var _regeneratorRuntime = require("C:\\Users\\nanma\\Documents\\GitHub\\star\\node_modules\\@babel\\runtime/regenerator");

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('react-three-fiber'), require('three'), require('drei'), require('three/examples/jsm/controls/TrackballControls'), require('@material-ui/core/Fab'), require('@material-ui/icons/GetAppRounded')) : typeof define === 'function' && define.amd ? define(['exports', 'react', 'react-three-fiber', 'three', 'drei', 'three/examples/jsm/controls/TrackballControls', '@material-ui/core/Fab', '@material-ui/icons/GetAppRounded'], factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global['react-vzome'] = {}, global.React, global.reactThreeFiber, global.THREE, global.drei, global.TrackballControls, global.Fab, global.GetAppRoundedIcon));
})(this, function (exports, React, reactThreeFiber, THREE, drei, TrackballControls, Fab, GetAppRoundedIcon) {
  'use strict';

  function _interopDefaultLegacy(e) {
    return e && typeof e === 'object' && 'default' in e ? e : {
      'default': e
    };
  }

  var React__default =
  /*#__PURE__*/
  _interopDefaultLegacy(React);

  var Fab__default =
  /*#__PURE__*/
  _interopDefaultLegacy(Fab);

  var GetAppRoundedIcon__default =
  /*#__PURE__*/
  _interopDefaultLegacy(GetAppRoundedIcon);

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg);
      var value = info.value;
    } catch (error) {
      reject(error);
      return;
    }

    if (info.done) {
      resolve(value);
    } else {
      Promise.resolve(value).then(_next, _throw);
    }
  }

  function _asyncToGenerator(fn) {
    return function () {
      var self = this,
          args = arguments;
      return new Promise(function (resolve, reject) {
        var gen = fn.apply(self, args);

        function _next(value) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
        }

        function _throw(err) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
        }

        _next(undefined);
      });
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct;
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }

    return _construct.apply(null, arguments);
  }

  function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  }

  function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;

    _wrapNativeSuper = function _wrapNativeSuper(Class) {
      if (Class === null || !_isNativeFunction(Class)) return Class;

      if (typeof Class !== "function") {
        throw new TypeError("Super expression must either be null or a function");
      }

      if (typeof _cache !== "undefined") {
        if (_cache.has(Class)) return _cache.get(Class);

        _cache.set(Class, Wrapper);
      }

      function Wrapper() {
        return _construct(Class, arguments, _getPrototypeOf(this).constructor);
      }

      Wrapper.prototype = Object.create(Class.prototype, {
        constructor: {
          value: Wrapper,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      return _setPrototypeOf(Wrapper, Class);
    };

    return _wrapNativeSuper(Class);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _superPropBase(object, property) {
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
      object = _getPrototypeOf(object);
      if (object === null) break;
    }

    return object;
  }

  function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
      _get = Reflect.get;
    } else {
      _get = function _get(target, property, receiver) {
        var base = _superPropBase(target, property);

        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);

        if (desc.get) {
          return desc.get.call(receiver);
        }

        return desc.value;
      };
    }

    return _get(target, property, receiver || target);
  }

  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
  }

  function _iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function _createForOfIteratorHelper(o, allowArrayLike) {
    var it;

    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
      if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;

        var F = function F() {};

        return {
          s: F,
          n: function n() {
            if (i >= o.length) return {
              done: true
            };
            return {
              done: false,
              value: o[i++]
            };
          },
          e: function e(_e6) {
            throw _e6;
          },
          f: F
        };
      }

      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    var normalCompletion = true,
        didErr = false,
        err;
    return {
      s: function s() {
        it = o[Symbol.iterator]();
      },
      n: function n() {
        var step = it.next();
        normalCompletion = step.done;
        return step;
      },
      e: function e(_e7) {
        didErr = true;
        err = _e7;
      },
      f: function f() {
        try {
          if (!normalCompletion && it.return != null) it.return();
        } finally {
          if (didErr) throw err;
        }
      }
    };
  }

  reactThreeFiber.extend({
    TrackballControls: TrackballControls.TrackballControls
  });

  var Controls = function Controls(props) {
    var _useThree = reactThreeFiber.useThree(),
        gl = _useThree.gl,
        camera = _useThree.camera;

    var controls = React.useRef();
    reactThreeFiber.useFrame(function () {
      return controls.current.update();
    });
    return (
      /*#__PURE__*/
      React__default['default'].createElement("trackballControls", _extends({
        ref: controls,
        args: [camera, gl.domElement]
      }, props))
    );
  }; // Found this trick for getting the DL.target into the scene here:
  //   https://spectrum.chat/react-three-fiber/general/how-to-set-spotlight-target~823340ea-433e-426a-a0dc-b9a333fc3f94


  var DirLight = function DirLight(_ref) {
    var direction = _ref.direction,
        color = _ref.color;
    var position = direction.map(function (x) {
      return -x;
    });
    var light = React.useMemo(function () {
      return new THREE.DirectionalLight();
    }, []);
    return (
      /*#__PURE__*/
      React__default['default'].createElement(React__default['default'].Fragment, null,
      /*#__PURE__*/
      React__default['default'].createElement("primitive", {
        object: light,
        position: position,
        color: color
      }),
      /*#__PURE__*/
      React__default['default'].createElement("primitive", {
        object: light.target,
        position: [0, 0, 0]
      }))
    );
  };

  var Lighting = function Lighting(_ref2) {
    var backgroundColor = _ref2.backgroundColor,
        ambientColor = _ref2.ambientColor,
        directionalLights = _ref2.directionalLights;
    var color = React.useMemo(function () {
      return new THREE.Color(backgroundColor);
    }, [backgroundColor]);
    reactThreeFiber.useFrame(function (_ref3) {
      var scene = _ref3.scene;
      scene.background = color;
    });
    return (
      /*#__PURE__*/
      React__default['default'].createElement(React__default['default'].Fragment, null,
      /*#__PURE__*/
      React__default['default'].createElement("ambientLight", {
        color: ambientColor
      }), directionalLights.map(function (config) {
        return (
          /*#__PURE__*/
          React__default['default'].createElement(DirLight, config)
        );
      }))
    );
  };

  var aspectRatio = window.innerWidth / window.innerHeight; // TODO: this is totally static!

  var convertFOV = function convertFOV(fovX) {
    return fovX / aspectRatio * 180 / Math.PI;
  }; // converting radians to degrees


  var defaultLighting = {
    backgroundColor: '#BBDAED',
    ambientColor: '#292929',
    directionalLights: [// These are the vZome defaults, for consistency
    {
      direction: [1, -1, -1],
      color: '#EBEBE4'
    }, {
      direction: [-1, 0, 0],
      color: '#E4E4EB'
    }, {
      direction: [0, 0, -1],
      color: '#1E1E1E'
    }]
  };
  var defaultInitialCamera = {
    fov: convertFOV(0.75),
    // 0.44 in vZome
    position: [0, 0, 75],
    lookAt: [0, 0, 0],
    up: [0, 1, 0],
    far: 217.46,
    near: 0.271
  }; // Thanks to Paul Henschel for this, to fix the camera.lookAt by adjusting the Controls target
  //   https://github.com/react-spring/react-three-fiber/discussions/609

  var DesignCanvas = function DesignCanvas(_ref4) {
    var lighting = _ref4.lighting,
        camera = _ref4.camera,
        children = _ref4.children,
        _ref4$handleBackgroun = _ref4.handleBackgroundClick,
        handleBackgroundClick = _ref4$handleBackgroun === void 0 ? function () {} : _ref4$handleBackgroun;

    var _ref5 = camera || defaultInitialCamera,
        fov = _ref5.fov,
        position = _ref5.position,
        up = _ref5.up,
        lookAt = _ref5.lookAt;

    return (
      /*#__PURE__*/
      React__default['default'].createElement(reactThreeFiber.Canvas, {
        gl: {
          antialias: true,
          alpha: false
        },
        onPointerMissed: handleBackgroundClick
      },
      /*#__PURE__*/
      React__default['default'].createElement(drei.PerspectiveCamera, _extends({
        makeDefault: true
      }, {
        fov: fov,
        position: position,
        up: up
      }),
      /*#__PURE__*/
      React__default['default'].createElement(Lighting, lighting || defaultLighting)),
      /*#__PURE__*/
      React__default['default'].createElement(Controls, {
        staticMoving: "true",
        rotateSpeed: 6,
        zoomSpeed: 3,
        panSpeed: 1,
        target: lookAt
      }), children)
    );
  };

  function BuildPlane(_ref) {
    var config = _ref.config,
        startGridHover = _ref.startGridHover,
        stopGridHover = _ref.stopGridHover;
    var position = config.position,
        quaternion = config.quaternion,
        grid = config.grid,
        color = config.color,
        size = config.size,
        field = config.field;

    var _useResource = reactThreeFiber.useResource(),
        _useResource2 = _slicedToArray(_useResource, 2),
        materialRef = _useResource2[0],
        material = _useResource2[1];

    var _useResource3 = reactThreeFiber.useResource(),
        _useResource4 = _slicedToArray(_useResource3, 2),
        planeMaterialRef = _useResource4[0],
        planeMaterial = _useResource4[1];

    var rsize = field.embed(size);
    var dotSize = rsize / 24;
    var discSize = rsize * 4;

    var makeAbsolute = function makeAbsolute(gridPt) {
      var vector3d = field.quatTransform(quaternion, [].concat(_toConsumableArray(gridPt), [field.zero]));
      return field.vectoradd(position, vector3d);
    };

    var handleHoverIn = function handleHoverIn(e, gridPt) {
      e.stopPropagation();
      startGridHover(makeAbsolute(gridPt));
    };

    var handleHoverOut = function handleHoverOut(e, gridPt) {
      e.stopPropagation();
      stopGridHover(makeAbsolute(gridPt));
    };

    var handleClick = function handleClick(e, gridPt) {
      e.stopPropagation();
      console.log("handle grid click: " + JSON.stringify(gridPt));
    };

    var wlast = function wlast(q) {
      var _q = _slicedToArray(q, 4),
          w = _q[0],
          x = _q[1],
          y = _q[2],
          z = _q[3];

      return [x, y, z, w];
    };
    /*
      Ideas:
        - when building struts, render the colored rays
        - always render the dots in colors
         - always render the hinge cylinder
        - hover on the hinge should show the two control handles:
           - a ball plus arc for the hinge angle around the center
           - a small torus for the plane angle around the hinge
    */


    return (
      /*#__PURE__*/
      React__default['default'].createElement("group", {
        position: field.embedv(position),
        quaternion: field.embedv(wlast(quaternion))
      },
      /*#__PURE__*/
      React__default['default'].createElement("meshLambertMaterial", {
        ref: planeMaterialRef,
        transparent: true,
        opacity: 0.5,
        color: color
      }),
      /*#__PURE__*/
      React__default['default'].createElement("mesh", {
        rotation: [Math.PI / 2, 0, 0],
        material: planeMaterial
      },
      /*#__PURE__*/
      React__default['default'].createElement("cylinderBufferGeometry", {
        attach: "geometry",
        args: [discSize, discSize, 0.05, 60]
      })),
      /*#__PURE__*/
      React__default['default'].createElement("mesh", {
        material: planeMaterial
      },
      /*#__PURE__*/
      React__default['default'].createElement("torusBufferGeometry", {
        attach: "geometry",
        args: [discSize, 0.5, 15, 60]
      })),
      /*#__PURE__*/
      React__default['default'].createElement("meshLambertMaterial", {
        ref: materialRef,
        color: "black",
        side: THREE.DoubleSide
      }), grid.map(function (gv) {
        var _field$embedv = field.embedv(gv),
            _field$embedv2 = _slicedToArray(_field$embedv, 3),
            x = _field$embedv2[0],
            y = _field$embedv2[1],
            z = _field$embedv2[2];

        return (
          /*#__PURE__*/
          React__default['default'].createElement("mesh", {
            position: [x, y, z],
            key: JSON.stringify(gv),
            material: material,
            onPointerOver: function onPointerOver(e) {
              return handleHoverIn(e, gv);
            },
            onPointerOut: function onPointerOut(e) {
              return handleHoverOut(e, gv);
            },
            onClick: function onClick(e) {
              return handleClick(e, gv);
            }
          },
          /*#__PURE__*/
          React__default['default'].createElement("icosahedronBufferGeometry", {
            attach: "geometry",
            args: [dotSize]
          }))
        );
      }))
    );
  }

  var computeNormal = function computeNormal(vertices, face) {
    var v0 = vertices[face.vertices[0]];
    var v1 = vertices[face.vertices[1]];
    var v2 = vertices[face.vertices[2]];
    var e1 = new THREE.Vector3().subVectors(v1, v0);
    var e2 = new THREE.Vector3().subVectors(v2, v0);
    return new THREE.Vector3().crossVectors(e1, e2);
  };

  var createGeometry = function createGeometry(_ref) {
    var vertices = _ref.vertices,
        faces = _ref.faces;
    var geometry = new THREE.Geometry();
    geometry.vertices = vertices.map(function (v) {
      return new THREE.Vector3(v.x, v.y, v.z);
    });
    geometry.faces = faces.map(function (f) {
      return new THREE.Face3(f.vertices[0], f.vertices[1], f.vertices[2], computeNormal(vertices, f));
    });
    geometry.computeBoundingSphere();
    return geometry;
  };

  var Instance = function Instance(_ref2) {
    var id = _ref2.id,
        vectors = _ref2.vectors,
        position = _ref2.position,
        rotation = _ref2.rotation,
        geometry = _ref2.geometry,
        color = _ref2.color,
        selected = _ref2.selected,
        _ref2$highlightBall = _ref2.highlightBall,
        highlightBall = _ref2$highlightBall === void 0 ? function () {} : _ref2$highlightBall,
        onClick = _ref2.onClick,
        onHover = _ref2.onHover;

    var handleHoverIn = function handleHoverIn(e) {
      e.stopPropagation();
      onHover && onHover(vectors, true);
    };

    var handleHoverOut = function handleHoverOut(e) {
      e.stopPropagation();
      onHover && onHover(vectors, false);
    };

    var handleClick = function handleClick(e) {
      if (onClick) {
        // may be undefined when the model is not editable, or when the object is not clickable in the current mode
        e.stopPropagation();
        onClick && onClick(id, vectors, selected);
      }
    };

    var emissive = selected ? "#bbbbbb" : highlightBall(id) ? "#884444" : "black"; // TODO: cache materials

    return (
      /*#__PURE__*/
      React__default['default'].createElement("group", {
        position: position,
        quaternion: rotation
      },
      /*#__PURE__*/
      React__default['default'].createElement("mesh", {
        geometry: geometry,
        onPointerOver: handleHoverIn,
        onPointerOut: handleHoverOut,
        onClick: handleClick
      },
      /*#__PURE__*/
      React__default['default'].createElement("meshLambertMaterial", {
        attach: "material",
        color: color,
        emissive: emissive
      })))
    );
  };

  var InstancedShape = function InstancedShape(_ref3) {
    var instances = _ref3.instances,
        shape = _ref3.shape,
        onClick = _ref3.onClick,
        onHover = _ref3.onHover,
        highlightBall = _ref3.highlightBall;
    var geometry = React.useMemo(function () {
      return createGeometry(shape);
    }, [shape]);
    return (
      /*#__PURE__*/
      React__default['default'].createElement(React__default['default'].Fragment, null, instances.map(function (instance) {
        return (
          /*#__PURE__*/
          React__default['default'].createElement(Instance, _extends({
            key: instance.id
          }, instance, {
            geometry: geometry,
            highlightBall: highlightBall,
            onClick: onClick,
            onHover: onHover
          }))
        );
      }))
    );
  };

  var SortedGeometry = function SortedGeometry(_ref4) {
    var sortedInstances = _ref4.sortedInstances,
        highlightBall = _ref4.highlightBall,
        handleClick = _ref4.handleClick,
        onHover = _ref4.onHover;
    return (
      /*#__PURE__*/
      React__default['default'].createElement(React__default['default'].Fragment, null, sortedInstances.map(function (_ref5) {
        var shape = _ref5.shape,
            instances = _ref5.instances;
        return (
          /*#__PURE__*/
          React__default['default'].createElement(InstancedShape, {
            key: shape.id,
            shape: shape,
            instances: instances,
            highlightBall: highlightBall,
            onClick: handleClick,
            onHover: onHover
          })
        );
      }))
    );
  };

  var ShapedGeometry = function ShapedGeometry(_ref6) {
    var shapes = _ref6.shapes,
        instances = _ref6.instances,
        highlightBall = _ref6.highlightBall,
        handleClick = _ref6.handleClick,
        onHover = _ref6.onHover;

    var filterInstances = function filterInstances(shape, instances) {
      return instances.filter(function (instance) {
        return instance.shapeId === shape.id;
      });
    };

    var sortByShape = function sortByShape() {
      return Object.values(shapes).map(function (shape) {
        return {
          shape: shape,
          instances: filterInstances(shape, instances)
        };
      });
    };

    var sortedInstances = React.useMemo(sortByShape, [shapes, instances]); // When !preRendered, instances will change every render

    return (
      /*#__PURE__*/
      React__default['default'].createElement(SortedGeometry, {
        sortedInstances: sortedInstances,
        highlightBall: highlightBall,
        handleClick: handleClick,
        onHover: onHover
      })
    );
  };

  var shapeInstance = function shapeInstance(instance, selected, shapedInstances, resolve) {
    // TODO: handle undefined result from resolve
    var shapedInstance = shapedInstances[instance.id];

    if (shapedInstance && instance.color === shapedInstance.color) {
      return _objectSpread2(_objectSpread2({}, shapedInstance), {}, {
        selected: selected
      });
    }

    shapedInstance = resolve(instance); // everything except selected state will go into shapedInstances

    shapedInstance = _objectSpread2(_objectSpread2({}, shapedInstance), {}, {
      vectors: instance.vectors
    });
    shapedInstances[instance.id] = shapedInstance;
    return _objectSpread2(_objectSpread2({}, shapedInstance), {}, {
      selected: selected
    });
  };

  var MeshGeometry = function MeshGeometry(_ref7) {
    var shown = _ref7.shown,
        selected = _ref7.selected,
        resolver = _ref7.resolver,
        highlightBall = _ref7.highlightBall,
        handleClick = _ref7.handleClick,
        onHover = _ref7.onHover; // resolver won't be available until the JSweet init has dispatched ORBITS_INITIALIZED

    var shapes = React.useMemo(function () {
      return {};
    }, [resolver]);
    var shapedInstances = React.useMemo(function () {
      return {};
    }, []);

    if (resolver) {
      var resolve = resolver(shapes);
      var instances = [];
      shown.forEach(function (instance) {
        return instances.push(shapeInstance(instance, false, shapedInstances, resolve));
      });
      selected.forEach(function (instance) {
        return instances.push(shapeInstance(instance, true, shapedInstances, resolve));
      });
      return (
        /*#__PURE__*/
        React__default['default'].createElement(ShapedGeometry, {
          shapes: shapes,
          instances: instances,
          highlightBall: highlightBall,
          handleClick: handleClick,
          onHover: onHover
        })
      );
    } else return null;
  };

  var canonicalizedId = function canonicalizedId(vectors) {
    var strings = vectors.map(function (n) {
      return JSON.stringify(n);
    });
    var min = strings[0];
    var minIndex = 0;

    for (var i = 1; i < strings.length; i++) {
      if (strings[i].localeCompare(min) < 0) {
        minIndex = i;
        min = strings[i];
      }
    } // Since % does not actually perform a consistent sawtooth modulus function for negative numbers,
    //  we add strings.length to force a positive number.


    var get = function get(i) {
      return strings[(strings.length + minIndex + i) % strings.length];
    }; // We have the minimum (get(0)), now figure out which way to go


    var incr = get(1).localeCompare(get(-1)) < 0 ? 1 : -1;
    var sorted = "";

    for (var j = 0; j < strings.length; j++) {
      var next = get(j * incr);
      sorted += next;
    }

    return sorted;
  };

  var createInstance = function createInstance(vectors) {
    var id = canonicalizedId(vectors); // We cannot rearrange vectors, as that would break strut semantics for some legacy commands

    return {
      id: id,
      vectors: vectors
    };
  };

  var Adapter =
  /*#__PURE__*/
  function () {
    function Adapter(shown, selected, hidden) {
      var groups = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

      _classCallCheck(this, Adapter);

      this.shown = shown;
      this.hidden = hidden;
      this.selected = selected;
      this.groups = groups;
    } // Selection methods


    _createClass(Adapter, [{
      key: "clone",
      value: function clone() {
        return new Adapter(new Map(this.shown), new Map(this.selected), new Map(this.hidden), _toConsumableArray(this.groups));
      }
    }, {
      key: "selectAll",
      value: function selectAll() {
        var temp = this.selected;
        this.selected = this.shown;
        this.shown = temp;
      }
    }, {
      key: "clearSelection",
      value: function clearSelection() {
        var temp = this.shown;
        this.shown = this.selected;
        this.selected = temp;
      }
    }, {
      key: "debugBottleneck",
      value: function debugBottleneck(id) {}
    }, {
      key: "select",
      value: function select(vectors) {
        var _createInstance = createInstance(vectors),
            id = _createInstance.id;

        if (this.selected.has(id)) return; // idempotent

        var instance = this.shown.get(id);

        if (!instance) {
          throw new Error("No shown instance to select at ".concat(id));
        }

        this.shown.delete(id);
        this.selected.set(id, instance);
        this.debugBottleneck(id);
      }
    }, {
      key: "unselect",
      value: function unselect(vectors) {
        var _createInstance2 = createInstance(vectors),
            id = _createInstance2.id;

        var instance = this.selected.get(id);
        this.selected.delete(id);
        this.shown.set(id, instance);
        this.debugBottleneck(id);
      }
    }, {
      key: "selectionSize",
      value: function selectionSize() {
        return this.selected.size;
      }
    }, {
      key: "selectedIterator",
      value: function selectedIterator() {
        return Array.from(this.selected.values()).map(function (instance) {
          return instance.vectors;
        }).values();
      }
    }, {
      key: "createGroup",
      value: function createGroup() {
        if (this.selectionIsGroup()) return;
        var group = new Set(this.selected.keys());
        this.groups.push(group);
      }
    }, {
      key: "disbandGroup",
      value: function disbandGroup() {
        var _this = this;

        this.groups = this.groups.filter(function (group) {
          return group.size !== _this.selected.size || Array.from(group).some(function (id) {
            return !_this.selected.has(id);
          });
        });
      }
    }, {
      key: "createLegacyGroup",
      value: function createLegacyGroup() {
        throw new Error("createLegacyGroup is not yet implemented");
      }
    }, {
      key: "disbandLegacyGroup",
      value: function disbandLegacyGroup() {
        throw new Error("disbandLegacyGroup is not yet implemented");
      }
    }, {
      key: "selectWithGrouping",
      value: function selectWithGrouping(vectors) {
        var _this2 = this;

        var _createInstance3 = createInstance(vectors),
            id = _createInstance3.id;

        if (this.selected.has(id)) return;
        var group = this.getLargestGroup(vectors);

        if (group) {
          group.forEach(function (id) {
            var instance = _this2.shown.get(id) || _this2.selected.get(id);

            _this2.shown.delete(id);

            _this2.selected.set(id, instance);

            _this2.debugBottleneck(id);
          });
        } else {
          var instance = this.shown.get(id);

          if (!instance) {
            throw new Error("No shown instance to select at ".concat(id));
          }

          this.shown.delete(id);
          this.selected.set(id, instance);
          this.debugBottleneck(id);
        }
      }
    }, {
      key: "unselectWithGrouping",
      value: function unselectWithGrouping(vectors) {
        var _this3 = this;

        var _createInstance4 = createInstance(vectors),
            id = _createInstance4.id;

        if (!this.selected.has(id)) return;
        var group = this.getLargestGroup(vectors);

        if (group) {
          group.forEach(function (id) {
            var instance = _this3.shown.get(id) || _this3.selected.get(id);

            _this3.selected.delete(id);

            _this3.shown.set(id, instance);

            _this3.debugBottleneck(id);
          });
        } else {
          var instance = this.selected.get(id);
          this.selected.delete(id);
          this.shown.set(id, instance);
          this.debugBottleneck(id);
        }
      }
    }, {
      key: "selectionIsGroup",
      value: function selectionIsGroup() {
        return !!this.getSelectionGroup();
      }
    }, {
      key: "getSelectionGroup",
      value: function getSelectionGroup() {
        var _this4 = this;

        var selectionSize = this.selected.size;
        if (selectionSize === 0) return false;
        return this.groups.find(function (group) {
          return group.size === selectionSize && Array.from(group).every(function (id) {
            return _this4.selected.has(id);
          });
        });
      } // RealizedModel calls

    }, {
      key: "getLargestGroup",
      value: function getLargestGroup(vectors) {
        var _this5 = this;

        var _createInstance5 = createInstance(vectors),
            id = _createInstance5.id;

        var matchingGroups = this.groups.filter(function (group) {
          return group.has(id);
        });
        if (matchingGroups.length === 0) return null;
        var largestGroup;
        var largestSize = 0;
        matchingGroups.map(function (group) {
          if (group.size > largestSize) {
            largestGroup = group;
            largestSize = group.size;
          }
        });
        return largestGroup && Array.from(largestGroup).map(function (id) {
          var instance = _this5.selected.get(id) || _this5.shown.get(id);

          return instance.vectors;
        });
      }
    }, {
      key: "delete",
      value: function _delete(vectors) {
        var _createInstance6 = createInstance(vectors),
            id = _createInstance6.id;

        this.debugBottleneck(id);
        this.shown.delete(id);
        this.selected.delete(id);
        this.hidden.delete(id);
        this.groups.forEach(function (group) {
          return group.delete(id);
        });
      }
    }, {
      key: "manifestationRendered",
      value: function manifestationRendered(vectors) {
        var _createInstance7 = createInstance(vectors),
            id = _createInstance7.id;

        return this.shown.has(id) || this.selected.has(id);
      }
    }, {
      key: "manifestationHidden",
      value: function manifestationHidden(vectors) {
        var _createInstance8 = createInstance(vectors),
            id = _createInstance8.id;

        return this.hidden.has(id);
      }
    }, {
      key: "manifestationSelected",
      value: function manifestationSelected(vectors) {
        var _createInstance9 = createInstance(vectors),
            id = _createInstance9.id;

        return this.selected.has(id);
      }
    }, {
      key: "manifestationHasColor",
      value: function manifestationHasColor(vectors) {
        var _createInstance10 = createInstance(vectors),
            id = _createInstance10.id;

        var existing = this.shown.get(id) || this.selected.get(id);
        return existing && !!existing.color;
      }
    }, {
      key: "manifestationColor",
      value: function manifestationColor(vectors) {
        var _createInstance11 = createInstance(vectors),
            id = _createInstance11.id;

        var existing = this.shown.get(id) || this.selected.get(id);
        return existing.color;
      }
    }, {
      key: "setManifestationColor",
      value: function setManifestationColor(vectors, color) {
        var instance = createInstance(vectors);
        instance.color = color;

        if (this.shown.has(instance.id)) {
          this.shown.set(instance.id, instance);
        } else if (this.selected.has(instance.id)) {
          this.selected.set(instance.id, instance);
        }
      }
    }, {
      key: "findOrCreateManifestation",
      value: function findOrCreateManifestation(vectors) {
        var created = createInstance(vectors);
        var id = created.id;
        var existing = this.shown.get(id) || this.hidden.get(id) || this.selected.get(id);
        if (existing) return existing.vectors; // TODO avoid creating zero-length struts, to match Java semantics of RMI.findConstruction

        return vectors;
      }
    }, {
      key: "showManifestation",
      value: function showManifestation(vectors) {
        var instance = createInstance(vectors);
        if (this.shown.has(instance.id) || this.selected.has(instance.id)) return; // idempotent

        this.hidden.delete(instance.id);
        this.shown.set(instance.id, instance);
        this.debugBottleneck(instance.id);
      }
    }, {
      key: "hideManifestation",
      value: function hideManifestation(vectors) {
        var instance = createInstance(vectors);
        instance = this.shown.get(instance.id) || this.selected.get(instance.id) || this.hidden.get(instance.id) || instance;
        this.selected.delete(instance.id) || this.shown.delete(instance.id);
        this.hidden.set(instance.id, instance);
        this.debugBottleneck(instance.id);
      }
    }, {
      key: "allIterator",
      value: function allIterator() {
        var shownArray = Array.from(this.shown.values());
        var selectedArray = Array.from(this.selected.values());
        var hiddenArray = Array.from(this.hidden.values());
        var all = [].concat(_toConsumableArray(shownArray), _toConsumableArray(selectedArray), _toConsumableArray(hiddenArray));
        return all.map(function (instance) {
          return instance.vectors;
        }).values();
      }
    }]);

    return Adapter;
  }(); // Most of this code is from Jacob Rus: https://observablehq.com/@jrus/zome-arithmetic


  var PHI = 0.5 * (Math.sqrt(5) + 1);

  function grsign(a) {
    var _a = _slicedToArray(a, 3),
        _a$ = _a[0],
        a0 = _a$ === void 0 ? 0 : _a$,
        _a$2 = _a[1],
        a1 = _a$2 === void 0 ? 0 : _a$2,
        _a$3 = _a[2],
        ad = _a$3 === void 0 ? 1 : _a$3,
        _float = a0 + PHI * a1;

    return ((ad > 0) - (ad < 0)) * ((_float > 0) - (_float < 0));
  }

  function gcd(a, b) {
    a = Math.abs(a);
    b = Math.abs(b);

    while (b !== 0) {
      var _ref = [b, a % b];
      a = _ref[0];
      b = _ref[1];
    }

    return a;
  }

  function simplify3(v0, v1, v2) {
    if ((v0 | 0) !== v0 || (v1 | 0) !== v1 || (v2 | 0) !== v2) throw new TypeError('simplify3 operates only on integers.');
    var s0 = (v0 > 0) - (v0 < 0),
        s1 = (v1 > 0) - (v1 < 0),
        s2 = (v2 > 0) - (v2 < 0); // signs

    v0 *= s0;
    v1 *= s1;
    v2 *= s2;
    s0 *= s2;
    s1 *= s2;
    var g = gcd(gcd(v0, v1), v2);
    return [s0 * v0 / g, s1 * v1 / g, v2 / g];
  }

  function reciprocal(a) {
    var _a2 = _slicedToArray(a, 3),
        _a2$ = _a2[0],
        a0 = _a2$ === void 0 ? 0 : _a2$,
        _a2$2 = _a2[1],
        a1 = _a2$2 === void 0 ? 0 : _a2$2,
        _a2$3 = _a2[2],
        ad = _a2$3 === void 0 ? 1 : _a2$3;

    return simplify3((a0 + a1) * ad, 0 - a1 * ad, a0 * a0 + a0 * a1 - a1 * a1);
  } // from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/random


  function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min); //The maximum is exclusive and the minimum is inclusive
  }

  function times(a, b) {
    var _a3 = _slicedToArray(a, 3),
        _a3$ = _a3[0],
        a0 = _a3$ === void 0 ? 0 : _a3$,
        _a3$2 = _a3[1],
        a1 = _a3$2 === void 0 ? 0 : _a3$2,
        _a3$3 = _a3[2],
        ad = _a3$3 === void 0 ? 1 : _a3$3,
        _b = _slicedToArray(b, 3),
        _b$ = _b[0],
        b0 = _b$ === void 0 ? 0 : _b$,
        _b$2 = _b[1],
        b1 = _b$2 === void 0 ? 0 : _b$2,
        _b$3 = _b[2],
        bd = _b$3 === void 0 ? 1 : _b$3;

    return simplify3(a0 * b0 + a1 * b1, a0 * b1 + a1 * b0 + a1 * b1, ad * bd);
  }

  function plus(a, b) {
    var _a4 = _slicedToArray(a, 3),
        _a4$ = _a4[0],
        a0 = _a4$ === void 0 ? 0 : _a4$,
        _a4$2 = _a4[1],
        a1 = _a4$2 === void 0 ? 0 : _a4$2,
        _a4$3 = _a4[2],
        ad = _a4$3 === void 0 ? 1 : _a4$3,
        _b2 = _slicedToArray(b, 3),
        _b2$ = _b2[0],
        b0 = _b2$ === void 0 ? 0 : _b2$,
        _b2$2 = _b2[1],
        b1 = _b2$2 === void 0 ? 0 : _b2$2,
        _b2$3 = _b2[2],
        bd = _b2$3 === void 0 ? 1 : _b2$3;

    return simplify3(a0 * bd + b0 * ad, a1 * bd + b1 * ad, ad * bd);
  }

  function minus(a, b) {
    var _a5 = _slicedToArray(a, 3),
        _a5$ = _a5[0],
        a0 = _a5$ === void 0 ? 0 : _a5$,
        _a5$2 = _a5[1],
        a1 = _a5$2 === void 0 ? 0 : _a5$2,
        _a5$3 = _a5[2],
        ad = _a5$3 === void 0 ? 1 : _a5$3,
        _b3 = _slicedToArray(b, 3),
        _b3$ = _b3[0],
        b0 = _b3$ === void 0 ? 0 : _b3$,
        _b3$2 = _b3[1],
        b1 = _b3$2 === void 0 ? 0 : _b3$2,
        _b3$3 = _b3[2],
        bd = _b3$3 === void 0 ? 1 : _b3$3;

    return simplify3(a0 * bd - b0 * ad, a1 * bd - b1 * ad, ad * bd);
  }

  function scalarmul(s, v) {
    return _toConsumableArray(v.values()).map(function () {
      var vi = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [0];
      return times(s, vi);
    });
  }

  function negate(a) {
    var _a6 = _slicedToArray(a, 3),
        _a6$ = _a6[0],
        a0 = _a6$ === void 0 ? 0 : _a6$,
        _a6$2 = _a6[1],
        a1 = _a6$2 === void 0 ? 0 : _a6$2,
        _a6$3 = _a6[2],
        ad = _a6$3 === void 0 ? 1 : _a6$3;

    return [0 - a0, 0 - a1, ad];
  }

  function vectoradd(u, v) {
    return _toConsumableArray(u.values()).map(function () {
      var ui = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [0];
      var i = arguments.length > 1 ? arguments[1] : undefined;
      return plus(ui, v[i] || [0]);
    });
  }

  function embed(a) {
    var _a7 = _slicedToArray(a, 3),
        _a7$ = _a7[0],
        a0 = _a7$ === void 0 ? 0 : _a7$,
        _a7$2 = _a7[1],
        a1 = _a7$2 === void 0 ? 0 : _a7$2,
        _a7$3 = _a7[2],
        ad = _a7$3 === void 0 ? 1 : _a7$3;

    return (a0 + PHI * a1) / ad;
  }

  function createRationalFromPairs(pairs) {
    var _pairs = _slicedToArray(pairs, 4),
        _pairs$ = _pairs[0],
        a0 = _pairs$ === void 0 ? 0 : _pairs$,
        _pairs$2 = _pairs[1],
        d0 = _pairs$2 === void 0 ? 1 : _pairs$2,
        _pairs$3 = _pairs[2],
        a1 = _pairs$3 === void 0 ? 0 : _pairs$3,
        _pairs$4 = _pairs[3],
        d1 = _pairs$4 === void 0 ? 1 : _pairs$4;

    return simplify3(a0 * d1, a1 * d0, d0 * d1);
  }

  function quatmul(u, v) {
    var x = times,
        a = plus,
        s = minus,
        _u = _slicedToArray(u, 4),
        _u$ = _u[0],
        u0 = _u$ === void 0 ? [0] : _u$,
        _u$2 = _u[1],
        u1 = _u$2 === void 0 ? [0] : _u$2,
        _u$3 = _u[2],
        u2 = _u$3 === void 0 ? [0] : _u$3,
        _u$4 = _u[3],
        u3 = _u$4 === void 0 ? [0] : _u$4,
        _v = _slicedToArray(v, 4),
        _v$ = _v[0],
        v0 = _v$ === void 0 ? [0] : _v$,
        _v$2 = _v[1],
        v1 = _v$2 === void 0 ? [0] : _v$2,
        _v$3 = _v[2],
        v2 = _v$3 === void 0 ? [0] : _v$3,
        _v$4 = _v[3],
        v3 = _v$4 === void 0 ? [0] : _v$4;

    return [s(x(u0, v0), a(a(x(u1, v1), x(u2, v2)), x(u3, v3))), a(a(x(u0, v1), x(u1, v0)), s(x(u2, v3), x(u3, v2))), a(a(x(u0, v2), x(u2, v0)), s(x(u3, v1), x(u1, v3))), a(a(x(u0, v3), x(u3, v0)), s(x(u1, v2), x(u2, v1)))];
  } // Everything here uses a W-first representation of quaternions.
  //   These quaternions must be transformed to W-last when using with three.js.


  function quatconj(_ref2) {
    var _ref3 = _slicedToArray(_ref2, 4),
        _ref3$ = _ref3[0],
        u0 = _ref3$ === void 0 ? [0] : _ref3$,
        _ref3$2 = _ref3[1],
        u1 = _ref3$2 === void 0 ? [0] : _ref3$2,
        _ref3$3 = _ref3[2],
        u2 = _ref3$3 === void 0 ? [0] : _ref3$3,
        _ref3$4 = _ref3[3],
        u3 = _ref3$4 === void 0 ? [0] : _ref3$4;

    return [u0, negate(u1), negate(u2), negate(u3)];
  }

  function quatTransform(Q, v) {
    return quatmul(Q, quatmul([[0]].concat(v), quatconj(Q))).slice(1);
  }

  function quatnormalize(q) {
    return scalarmul([q.map(grsign).reduce(function (a, b) {
      return a || b;
    }) || 1], q);
  }

  var one = [[1], [0], [0], [0]],
      h = [1, 0, 2],
      blue = [one, [[0], [1], [0], [0]], [[0], [0], [0], [1]], [[0], [0], [1], [0]]],
      yellow = [one, [h, h, h, h], [[-1, 0, 2], h, h, h]],
      red = [one, [[0, 1, 2], h, [-1, 1, 2]]];

  for (var i = 2; i < 5; i++) {
    red[i] = quatmul(red[i - 1], red[1]);
  }

  var vZomeIcosahedralQuaternions = [];
  var b, r, y;

  for (var _i = 0, _blue = blue; _i < _blue.length; _i++) {
    b = _blue[_i];

    var _iterator = _createForOfIteratorHelper(red),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        r = _step.value;

        var _iterator2 = _createForOfIteratorHelper(yellow),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            y = _step2.value;
            vZomeIcosahedralQuaternions.push(quatnormalize(quatmul(b, quatmul(y, r))));
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  } // All of this code for goldenSeries, etc. came from https://observablehq.com/@vorth/finding-golden-numbers


  var replacement = function replacement(item) {
    return item === "1" ? ["φ"] : ["1", "φ"];
  };

  var symbolSequence = function symbolSequence(depth) {
    function recurrence(arr) {
      return arr.reduce(function (acc, item) {
        return [].concat(_toConsumableArray(acc), _toConsumableArray(replacement(item)));
      }, []);
    }

    var seq = ["1"];

    for (var i = 0; i < depth; i++) {
      seq = recurrence(seq);
    }

    return seq;
  };

  var goldenSequence = function goldenSequence(depth) {
    return symbolSequence(depth).map(function (symbol) {
      return symbol === "1" ? [1, 0, 1] : [0, 1, 1];
    });
  };

  var goldenSeries = function goldenSeries(depth) {
    return goldenSequence(depth).reduce(function (r, a) {
      if (r.length > 0) a = plus(a, r[r.length - 1]);
      r.push(a);
      return r;
    }, []);
  };

  var origin = function origin(dimensions) {
    var result = [];

    for (var index = 0; index < dimensions; index++) {
      result.push([0, 0, 1]);
    }

    return result;
  };

  var goldenField = {
    name: 'golden',
    order: 2,
    zero: [0, 0, 1],
    one: [1, 0, 1],
    goldenRatio: [0, 1, 1],
    quaternions: vZomeIcosahedralQuaternions,
    goldenSeries: goldenSeries,
    origin: origin,
    plus: plus,
    minus: minus,
    times: times,
    scalarmul: scalarmul,
    vectoradd: vectoradd,
    embed: embed,
    reciprocal: reciprocal,
    negate: negate,
    createRationalFromPairs: createRationalFromPairs,
    quatTransform: quatTransform,
    embedv: function embedv(v) {
      return v.map(embed);
    },
    createRational: function createRational(n, d) {
      return simplify3(n, 0, d);
    },
    randomVector: function randomVector() {
      var x = [getRandomInt(-12, 12), 0, 1];
      var y = [getRandomInt(-12, 12), 0, 1];
      var z = [getRandomInt(-12, 12), 0, 1];
      return [x, y, z];
    }
  }; // Most of this code is from Jacob Rus: https://observablehq.com/@jrus/zome-arithmetic

  var SQRT2 = Math.sqrt(2);

  function gcd$1(a, b) {
    a = Math.abs(a);
    b = Math.abs(b);

    while (b !== 0) {
      var _ref = [b, a % b];
      a = _ref[0];
      b = _ref[1];
    }

    return a;
  }

  function simplify3$1(v0, v1, v2) {
    if ((v0 | 0) !== v0 || (v1 | 0) !== v1 || (v2 | 0) !== v2) throw new TypeError('simplify3 operates only on integers.');
    var s0 = (v0 > 0) - (v0 < 0),
        s1 = (v1 > 0) - (v1 < 0),
        s2 = (v2 > 0) - (v2 < 0); // signs

    v0 *= s0;
    v1 *= s1;
    v2 *= s2;
    s0 *= s2;
    s1 *= s2;
    var g = gcd$1(gcd$1(v0, v1), v2);
    return [s0 * v0 / g, s1 * v1 / g, v2 / g];
  }

  function reciprocal$1(x) {
    var _x = _slicedToArray(x, 3),
        _x$ = _x[0],
        a = _x$ === void 0 ? 0 : _x$,
        _x$2 = _x[1],
        b = _x$2 === void 0 ? 0 : _x$2,
        _x$3 = _x[2],
        c = _x$3 === void 0 ? 1 : _x$3;

    return simplify3$1(a * c, 0 - b * c, a * a - 2 * b * b);
  }

  function times$1(a, b) {
    var _a = _slicedToArray(a, 3),
        _a$ = _a[0],
        a0 = _a$ === void 0 ? 0 : _a$,
        _a$2 = _a[1],
        a1 = _a$2 === void 0 ? 0 : _a$2,
        _a$3 = _a[2],
        ad = _a$3 === void 0 ? 1 : _a$3,
        _b = _slicedToArray(b, 3),
        _b$ = _b[0],
        b0 = _b$ === void 0 ? 0 : _b$,
        _b$2 = _b[1],
        b1 = _b$2 === void 0 ? 0 : _b$2,
        _b$3 = _b[2],
        bd = _b$3 === void 0 ? 1 : _b$3;

    return simplify3$1(a0 * b0 + 2 * a1 * b1, a0 * b1 + a1 * b0, ad * bd);
  }

  function plus$1(a, b) {
    var _a2 = _slicedToArray(a, 3),
        _a2$ = _a2[0],
        a0 = _a2$ === void 0 ? 0 : _a2$,
        _a2$2 = _a2[1],
        a1 = _a2$2 === void 0 ? 0 : _a2$2,
        _a2$3 = _a2[2],
        ad = _a2$3 === void 0 ? 1 : _a2$3,
        _b2 = _slicedToArray(b, 3),
        _b2$ = _b2[0],
        b0 = _b2$ === void 0 ? 0 : _b2$,
        _b2$2 = _b2[1],
        b1 = _b2$2 === void 0 ? 0 : _b2$2,
        _b2$3 = _b2[2],
        bd = _b2$3 === void 0 ? 1 : _b2$3;

    return simplify3$1(a0 * bd + b0 * ad, a1 * bd + b1 * ad, ad * bd);
  }

  function minus$1(a, b) {
    var _a3 = _slicedToArray(a, 3),
        _a3$ = _a3[0],
        a0 = _a3$ === void 0 ? 0 : _a3$,
        _a3$2 = _a3[1],
        a1 = _a3$2 === void 0 ? 0 : _a3$2,
        _a3$3 = _a3[2],
        ad = _a3$3 === void 0 ? 1 : _a3$3,
        _b3 = _slicedToArray(b, 3),
        _b3$ = _b3[0],
        b0 = _b3$ === void 0 ? 0 : _b3$,
        _b3$2 = _b3[1],
        b1 = _b3$2 === void 0 ? 0 : _b3$2,
        _b3$3 = _b3[2],
        bd = _b3$3 === void 0 ? 1 : _b3$3;

    return simplify3$1(a0 * bd - b0 * ad, a1 * bd - b1 * ad, ad * bd);
  }

  function scalarmul$1(s, v) {
    return _toConsumableArray(v.values()).map(function () {
      var vi = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [0];
      return times$1(s, vi);
    });
  }

  function negate$1(a) {
    var _a4 = _slicedToArray(a, 3),
        _a4$ = _a4[0],
        a0 = _a4$ === void 0 ? 0 : _a4$,
        _a4$2 = _a4[1],
        a1 = _a4$2 === void 0 ? 0 : _a4$2,
        _a4$3 = _a4[2],
        ad = _a4$3 === void 0 ? 1 : _a4$3;

    return [0 - a0, 0 - a1, ad];
  }

  function vectoradd$1(u, v) {
    return _toConsumableArray(u.values()).map(function () {
      var ui = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [0];
      var i = arguments.length > 1 ? arguments[1] : undefined;
      return plus$1(ui, v[i] || [0]);
    });
  }

  function embed$1(a) {
    var _a5 = _slicedToArray(a, 3),
        _a5$ = _a5[0],
        a0 = _a5$ === void 0 ? 0 : _a5$,
        _a5$2 = _a5[1],
        a1 = _a5$2 === void 0 ? 0 : _a5$2,
        _a5$3 = _a5[2],
        ad = _a5$3 === void 0 ? 1 : _a5$3;

    return (a0 + SQRT2 * a1) / ad;
  }

  function createRationalFromPairs$1(pairs) {
    var _pairs = _slicedToArray(pairs, 4),
        _pairs$ = _pairs[0],
        a0 = _pairs$ === void 0 ? 0 : _pairs$,
        _pairs$2 = _pairs[1],
        d0 = _pairs$2 === void 0 ? 1 : _pairs$2,
        _pairs$3 = _pairs[2],
        a1 = _pairs$3 === void 0 ? 0 : _pairs$3,
        _pairs$4 = _pairs[3],
        d1 = _pairs$4 === void 0 ? 1 : _pairs$4;

    return simplify3$1(a0 * d1, a1 * d0, d0 * d1);
  }

  function quatmul$1(u, v) {
    var x = times$1,
        a = plus$1,
        s = minus$1,
        _u = _slicedToArray(u, 4),
        _u$ = _u[0],
        u0 = _u$ === void 0 ? [0] : _u$,
        _u$2 = _u[1],
        u1 = _u$2 === void 0 ? [0] : _u$2,
        _u$3 = _u[2],
        u2 = _u$3 === void 0 ? [0] : _u$3,
        _u$4 = _u[3],
        u3 = _u$4 === void 0 ? [0] : _u$4,
        _v = _slicedToArray(v, 4),
        _v$ = _v[0],
        v0 = _v$ === void 0 ? [0] : _v$,
        _v$2 = _v[1],
        v1 = _v$2 === void 0 ? [0] : _v$2,
        _v$3 = _v[2],
        v2 = _v$3 === void 0 ? [0] : _v$3,
        _v$4 = _v[3],
        v3 = _v$4 === void 0 ? [0] : _v$4;

    return [s(x(u0, v0), a(a(x(u1, v1), x(u2, v2)), x(u3, v3))), a(a(x(u0, v1), x(u1, v0)), s(x(u2, v3), x(u3, v2))), a(a(x(u0, v2), x(u2, v0)), s(x(u3, v1), x(u1, v3))), a(a(x(u0, v3), x(u3, v0)), s(x(u1, v2), x(u2, v1)))];
  } // Everything here uses a W-first representation of quaternions.
  //   These quaternions must be transformed to W-last when using with three.js.


  function quatconj$1(_ref2) {
    var _ref3 = _slicedToArray(_ref2, 4),
        _ref3$ = _ref3[0],
        u0 = _ref3$ === void 0 ? [0] : _ref3$,
        _ref3$2 = _ref3[1],
        u1 = _ref3$2 === void 0 ? [0] : _ref3$2,
        _ref3$3 = _ref3[2],
        u2 = _ref3$3 === void 0 ? [0] : _ref3$3,
        _ref3$4 = _ref3[3],
        u3 = _ref3$4 === void 0 ? [0] : _ref3$4;

    return [u0, negate$1(u1), negate$1(u2), negate$1(u3)];
  }

  function quatTransform$1(Q, v) {
    return quatmul$1(Q, quatmul$1([[0]].concat(v), quatconj$1(Q))).slice(1);
  }

  var origin$1 = function origin(dimensions) {
    var result = [];

    for (var index = 0; index < dimensions; index++) {
      result.push([0, 0, 1]);
    }

    return result;
  };

  var field = {
    name: 'rootTwo',
    order: 2,
    zero: [0, 0, 1],
    one: [1, 0, 1],
    sqrt2: [0, 1, 1],
    origin: origin$1,
    plus: plus$1,
    minus: minus$1,
    times: times$1,
    scalarmul: scalarmul$1,
    vectoradd: vectoradd$1,
    embed: embed$1,
    reciprocal: reciprocal$1,
    negate: negate$1,
    createRationalFromPairs: createRationalFromPairs$1,
    quatTransform: quatTransform$1,
    embedv: function embedv(v) {
      return v.map(embed$1);
    },
    createRational: function createRational(n, d) {
      return simplify3$1(n, 0, d);
    }
  };

  var JavaDomNodeList =
  /*#__PURE__*/
  function () {
    function JavaDomNodeList(nodeList) {
      _classCallCheck(this, JavaDomNodeList);

      this.nativeNodeList = nodeList;
      this.__interfaces = ["org.w3c.dom.NodeList"];
    }

    _createClass(JavaDomNodeList, [{
      key: "getLength",
      value: function getLength() {
        return this.nativeNodeList.length;
      }
    }, {
      key: "item",
      value: function item(i) {
        var node = this.nativeNodeList.item(i);
        if (node.nodeType === 1) return new JavaDomElement(node);else return node;
      }
    }]);

    return JavaDomNodeList;
  }();

  var JavaDomElement =
  /*#__PURE__*/
  function () {
    function JavaDomElement(element) {
      _classCallCheck(this, JavaDomElement);

      this.nativeElement = element;
      this.__interfaces = ["org.w3c.dom.Element"];
    }

    _createClass(JavaDomElement, [{
      key: "getAttribute",
      value: function getAttribute(name) {
        return this.nativeElement.getAttribute && this.nativeElement.getAttribute(name);
      }
    }, {
      key: "getLocalName",
      value: function getLocalName() {
        return this.nativeElement.localName;
      }
    }, {
      key: "getTextContent",
      value: function getTextContent() {
        return this.nativeElement.textContent;
      }
    }, {
      key: "getChildNodes",
      value: function getChildNodes() {
        return new JavaDomNodeList(this.nativeElement.childNodes);
      }
    }, {
      key: "getChildElement",
      value: function getChildElement(name) {
        var target = this.nativeElement.firstElementChild;

        while (target && name.toLowerCase() !== target.nodeName.toLowerCase()) {
          target = target.nextElementSibling;
        }

        return target && new JavaDomElement(target);
      }
    }, {
      key: "getElementsByTagName",
      value: function getElementsByTagName(name) {
        var target = this.nativeElement.firstElementChild;
        var results = [];

        while (target) {
          if (name.toLowerCase() === target.nodeName.toLowerCase()) {
            results.push(new JavaDomElement(target));
          }

          target = target.nextElementSibling;
        }

        return {
          getLength: function getLength() {
            return results.length;
          },
          item: function item(i) {
            return results[i];
          }
        };
      }
    }]);

    return JavaDomElement;
  }();

  var JsProperties =
  /*#__PURE__*/
  function () {
    function JsProperties(config) {
      _classCallCheck(this, JsProperties);

      this.config = config;
    }

    _createClass(JsProperties, [{
      key: "getProperty",
      value: function getProperty(key) {
        return this.config[key];
      }
    }, {
      key: "get",
      value: function get(key) {
        return this.config[key];
      }
    }]);

    return JsProperties;
  }();

  var connectorUrl = "data:null;base64,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";
  var blueUrl = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCmFjdHVhbApzY2FsZSAoMS8yLDApCgo5CigwLDApICAoMCw0KSAgKC0xLDIpICAoMiwtMykgCigwLDApICAoMCw0KSAgKC0xLDIpICAoLTIsMykgCigwLDApICAoMiwtMikgICgtMSwyKSAgKC0yLDMpIAooMCwwKSAgKDIsLTIpICAoLTEsMikgICgyLC0zKSAKKDAsMCkgICgwLDQpICAoMSwtMikgICgyLC0zKSAKKDAsMCkgICgyLC0yKSAgKDEsLTIpICAoMiwtMykgCigwLDApICAoMiwtMikgICgxLC0yKSAgKC0yLDMpIAooMCwwKSAgKDAsNCkgICgxLC0yKSAgKC0yLDMpIAooMCwwKSAgKDIsMikgICgwLDApICAoMCwwKSAKCgoKMAoKCgo0CjQgMCAxIDIgMwo0IDUgNiA3IDQKNCA1IDQgMCAzCjQgMSA3IDYgMgoKCgo1CiA0IDAgMSA4IDcKCgp0aXAgOAo=";
  var yellowUrl = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCgoxMwooMCwwKSAoLTEvMiwxKSAoMCwxKSAoMS8yLC0xLzIpCigwLDApICgtMS8yLDMvMikgKDEvMiwwKSAoMCwwKQooMCwwKSAoMS8yLDApICgxLC0xLzIpICgwLDApCigwLDApICgxLzIsLTEvMikgKDEvMiwxLzIpICgxLzIsLTEvMikKKDAsMCkgKDMvMiwtMSkgKDIsMCkgKDEvMiwtMS8yKQooMCwwKSAoLTEvMiwxKSAoMCwxKSAoLTEvMiwxLzIpCigwLDApICgxLzIsLTEvMikgKDEvMiwxLzIpICgtMS8yLDEvMikKKDAsMCkgKDEvMiwxLzIpICgzLzIsMS8yKSAoMS8yLC0xLzIpCigwLDApICgxLzIsMS8yKSAoMy8yLDEvMikgKC0xLzIsMS8yKQooMCwwKSAoMSwwKSAoMiwxKSAoMCwwKQooMCwwKSAoMS8yLDApICgxLDMvMikgKDAsMCkKKDAsMCkgKDMvMiwtMSkgKDIsMCkgKC0xLzIsMS8yKQooMCwwKSAoMy8yLC0zLzIpICgzLzIsMSkgKDAsMCkKCgoKMAoKCgoxMgo0IDAgMSAyIDMKNCA1IDAgMyA2CjMgMyAyIDcKMyAyIDYgOAozIDYgMyAxMAo0IDEwIDcgNCAxMgo0IDEgNSA2IDIKNCA3IDggMTEgNAozIDEwIDggNgo0IDggMTAgMTIgMTEKMyA4IDcgMgozIDcgMTAgMwoKCgo0CiA0IDkgMTEgMTIKCnRpcCA5Cm1pZGRsZSAxMCA4IDYgNyAyIDM=";
  var redUrl = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCgoyMQooMCwwKSAoLTEvMiwxLzIpICgzLzIsMSkgKC0yLDEpCigwLDApICgtMS8yLDEvMikgKDUvMiwxKSAoMCwtMykKKDAsMCkgKDEvMiwtMSkgKDMsMCkgKC0xLzIsLTUvMikKKDAsMCkgKDEvMiwtMS8yKSAoMS8yLDApICgtMSwxKQooMCwwKSAoMCwwKSAoLTEvMiwzLzIpICgtMS8yLDApCigwLDApICgwLDApICgxLzIsNS8yKSAoLTMvMiwwKQooMCwwKSAoMS8yLC0xLzIpICgzLzIsMSkgKC0yLDEpCigwLDApICgtMS8yLDEvMikgKDcvMiwyKSAoLTEsLTMpCigwLDApICgxLzIsLTEpICgxLDIpICgtMy8yLDEvMikKKDAsMCkgKC0xLzIsMSkgKDEsMikgKC0zLzIsMS8yKQooMCwwKSAoMCwwKSAoNy8yLC0xLzIpICgtMS8yLC0yKQooMCwwKSAoMS8yLC0xLzIpICg1LzIsMSkgKDAsLTMpCigwLDApICgwLDApICg5LzIsMS8yKSAoLTMvMiwtMikKKDAsMCkgKDEvMiwtMSkgKDAsMSkgKC0xLzIsMS8yKQooMCwwKSAoLTEvMiwxKSAoMCwxKSAoLTEvMiwxLzIpCigwLDApICgtMS8yLDEvMikgKDEvMiwwKSAoLTEsMSkKKDAsMCkgKDEvMiwtMSkgKDQsMSkgKC0zLzIsLTUvMikKKDAsMCkgKDEvMiwtMS8yKSAoNy8yLDIpICgtMSwtMykKKDAsMCkgKC0xLzIsMSkgKDQsMSkgKC0zLzIsLTUvMikKKDAsMCkgKDAsMCkgKDQsMikgKC0yLC0yKQooMCwwKSAoLTEvMiwxKSAoMywwKSAoLTEvMiwtNS8yKQoKCgowCgoKCjIwCjMgMCAxIDIKNCAzIDQgNSA2CjMgOCA5IDEwCjMgOSAxMSAxMAo0IDEzIDE0IDkgOAo0IDQgMTUgMCA1CjQgMiAxIDcgMTYKMyAwIDggMQo0IDE0IDMgNiA5CjMgOCAxMCAxCjMgOSA2IDExCjMgNSAwIDIKNCAxMSAyMCAxOCAxNwo0IDIwIDIgMTYgMTgKMyA2IDUgMjAKNCAxIDEwIDEyIDcKMyA2IDIwIDExCjQgMTUgMTMgOCAwCjQgMTAgMTEgMTcgMTIKMyA1IDIgMjAKCgoKNgogNyAxMiAxNyAxOCAxOSAxNgoKdGlwIDE5CgptaWRkbGUgOSAxMSAxMCAwIDggMSA1IDIgMjAgNg==";
  var greenUrl = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCnNjYWxlICgxLzIsMCkKCjE5CigwLDApICAoLTIsNykgICgwLDApICAoLTEsNSkgCigwLDApICAoMywwKSAgKC0yLDMpICAoMCw0KSAKKDAsMCkgICgtNCwxMCkgICgxLC0yKSAgKC00LDEwKSAKKDAsMCkgICgtNCwxMCkgICgtMSwyKSAgKC00LDEwKSAKKDAsMCkgICgtNiwxMykgICgwLDApICAoLTcsMTUpIAooMCwwKSAgKC0xLDIpICAoLTIsMykgICgyLC0yKSAKKDAsMCkgICgtMiw0KSAgKDEsLTIpICAoMCwxKSAKKDAsMCkgICg2LC04KSAgKDEsLTIpICAoNiwtOCkgCigwLDApICAoNCwtMikgICgtMSwyKSAgKDIsMSkgCigwLDApICAoMywwKSAgKDIsLTMpICAoMCw0KSAKKDAsMCkgICg0LC0yKSAgKDEsLTIpICAoMiwxKSAKKDAsMCkgICgyLDEpICAoMCwwKSAgKC0xLDYpIAooMCwwKSAgKDQsLTUpICAoMCwwKSAgKDMsLTMpIAooMCwwKSAgKC0xLDIpICAoMiwtMykgICgyLC0yKSAKKDAsMCkgICg4LC0xMSkgICgwLDApICAoOSwtMTMpIAooMCwwKSAgKDYsLTgpICAoLTEsMikgICg2LC04KSAKKDAsMCkgICgtMiw0KSAgKC0xLDIpICAoMCwxKSAKKDAsMCkgICgwLDEpICAoMCwwKSAgKDMsLTQpIAooMCwwKSAgKDIsMikgICgwLDApICAoMiwyKSAKCgoKMAoKCgoxOAozIDAgMSAyCjMgNSA2IDcKMyAzIDggOQo0IDQgMiAxMCAxMQo0IDEyIDcgMiA0CjMgMTMgNSAxMgo0IDcgMTQgMCAyCjQgMTQgMTUgMyAwCjQgMTUgMTIgNCAzCjMgMSAxMCAyCjMgOSAwIDMKMyA5IDEgMAozIDE2IDEzIDE1CjMgMTMgMTIgMTUKNCA2IDE3IDE0IDcKNCAzIDQgMTEgOAozIDUgNyAxMgo0IDE3IDE2IDE1IDE0CgoKCjEwCiAwIDMgNCAxIDkgMTEgMiAxMCAxOCA4Cgp0aXAgMTgK";
  var snubDiagonalUrl = "data:null;base64,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";
  var blackUrl = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCgoxNwooMCwwKSAoLTEvMiwtMSkgKDAsLTEpICgtMS8yLDEvMikKKDAsMCkgKC0xLzIsLTIpICgtMSwwKSAoMS8yLC0zLzIpCigwLDApICgtMSwtMSkgKC0zLzIsMS8yKSAoLTEvMiwwKQooMCwwKSAoLTEsMCkgKC0xLzIsLTEvMikgKC0zLzIsMikKKDAsMCkgKC0yLDApICgtMS8yLC0zLzIpICgtMy8yLDEpCigwLDApICgtMSwtMSkgKC0xLzIsLTEvMikgKDEvMiwtMikKKDAsMCkgKC0zLzIsLTEpICgwLC0yKSAoLTEvMiwtMS8yKQooMCwwKSAoLTEsLTIpICgtMS8yLC0zLzIpICgtMS8yLDApCigwLDApICgtMS8yLDApICgwLDApICgxLzIsLTMvMikKKDAsMCkgKC0xLDApICgxLzIsLTMvMikgKC0xLzIsMCkKKDAsMCkgKDAsLTEpICgtMS8yLDEvMikgKDEvMiwtMSkKKDAsMCkgKC0zLzIsMCkgKC0xLDApICgtMS8yLC0xLzIpCigwLDApICgtMy8yLC0xKSAoLTEsLTEpICgtMy8yLDMvMikKKDAsMCkgKC0zLzIsMSkgKDAsLTEpICgtMy8yLDMvMikKKDAsMCkgKC0yLC0xKSAoLTEsLTEpICgtMSwwKQooMCwwKSAoLTEsMSkgKC0xLzIsMS8yKSAoLTEvMiwwKQooMCwwKSAoLTEvMiwwKSAoLTEsMSkgKC0xLzIsMS8yKQoKCgowCgoKCjEyCjQgMCAxIDIgMwo0IDUgNiA3IDEKNCA4IDkgMCAxMAo0IDExIDIgMTIgNAo0IDEzIDExIDUgOQo0IDQgNiA1IDExCjQgMyAyIDExIDEzCjQgMTUgMTMgOSA4CjQgMyAxMyAxNSAxNgo0IDE2IDEwIDAgMwo0IDkgNSAxIDAKNCAxIDcgMTIgMgoKCgo5CiA0IDYgMSAxNCAyIDcgNSAxMSAxMgoKdGlwIDE0Cg==";
  var maroonUrl = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCnNjYWxlICgxLzIsMCkKCjE3CigwLDApICAoLTEsMikgICgtMiwzKSAgKDIsLTIpIAooMCwwKSAgKC0xLDIpICAoMiwtMykgICgyLC0yKSAKKDAsMCkgICgtMiw0KSAgKDIsLTMpICAoMSwxKSAKKDAsMCkgICgtMiw0KSAgKC0yLDMpICAoMSwxKSAKKDAsMCkgICgwLDEpICAoMCwwKSAgKDMsMikgCigwLDApICAoMCwxKSAgKDIsLTMpICAoMiwxKSAKKDAsMCkgICgwLDApICAoMiwtMykgICgxLDEpIAooMCwwKSAgKDIsLTMpICAoMiwtMykgICgyLDEpIAooMCwwKSAgKDEsLTEpICAoLTIsMykgICgxLDQpIAooMCwwKSAgKDIsLTMpICAoLTIsMykgICgyLDEpIAooMCwwKSAgKDAsMSkgICgtMiwzKSAgKDIsMSkgCigwLDApICAoLTEsMykgICgtMiwzKSAgKDEsNCkgCigwLDApICAoMSwtMSkgICgyLC0zKSAgKDEsNCkgCigwLDApICAoMCwwKSAgKC0yLDMpICAoMSwxKSAKKDAsMCkgICgxLC0yKSAgKC0yLDMpICAoMiwtMikgCigwLDApICAoLTEsMykgICgyLC0zKSAgKDEsNCkgCigwLDApICAoMSwtMikgICgyLC0zKSAgKDIsLTIpIAoKCgowCgoKCjEyCjQgMCAxIDIgMwo0IDUgMiA2IDcKNCA4IDkgMTAgMTEKNCAzIDIgNSAxMAo0IDAgMyAxMyAxNAo0IDcgMTIgMTUgNQo0IDkgNyA2IDEzCjQgMTMgNiAxNiAxNAo0IDIgMSAxNiA2CjQgMyAxMCA5IDEzCjQgMTAgNSAxNSAxMQo0IDggMTIgNyA5CgoKCjkKIDQgMTIgOCAxMSAxMCA5IDcgMTUgNQoKdGlwIDQK";
  var snubPentagonUrl = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgc251YkRvZGVjCgpzY2FsZSAoMCwwLDAsMCwwLDEvMikKCjE1CigwLDAsMCwwLDAsMCkgICgyLC0yLDAsMCwwLDApICAoLTQsNiwwLDAsNywtMTEpICAoMiwtNCwwLDAsLTMsNikgCigwLDAsMCwwLDAsMCkgICgwLDAsMCwwLDEsMCkgICgwLDAsMCwwLDAsMCkgICgwLDAsMCwwLDEsLTMpIAooMCwwLDAsMCwwLDApICAoMiwtMiwwLDAsMCwwKSAgKC00LDYsMCwwLDksLTEzKSAgKDIsLTQsMCwwLC0zLDYpIAooMCwwLDAsMCwwLDApICAoNCwyLDAsMCwwLC0yKSAgKC0yLDAsMCwwLDMsMSkgICgtMiwtMiwwLDAsMyw2KSAKKDAsMCwwLDAsMCwwKSAgKDQsMiwwLDAsLTEsMCkgICgtMiwwLDAsMCw0LDApICAoLTIsLTIsMCwwLDMsNykgCigwLDAsMCwwLDAsMCkgICg0LDIsMCwwLDAsLTIpICAoLTIsMCwwLDAsNSwtMSkgICgtMiwtMiwwLDAsMyw2KSAKKDAsMCwwLDAsMCwwKSAgKDIsNCwwLDAsMCwwKSAgKDIsLTYsMCwwLC01LDEzKSAgKC00LDIsMCwwLDcsLTIpIAooMCwwLDAsMCwwLDApICAoMiw0LDAsMCwwLDApICAoMiwtNiwwLDAsLTUsMTMpICAoLTQsMiwwLDAsOSwtNikgCigwLDAsMCwwLDAsMCkgICg0LDIsMCwwLDAsMCkgICgtMiwwLDAsMCw0LDApICAoLTIsLTIsMCwwLDQsNCkgCigwLDAsMCwwLDAsMCkgICgyLDQsMCwwLDAsMCkgICgyLC02LDAsMCwtMywxMSkgICgtNCwyLDAsMCw3LC0yKSAKKDAsMCwwLDAsMCwwKSAgKDIsNCwwLDAsMCwwKSAgKDIsLTYsMCwwLC0zLDExKSAgKC00LDIsMCwwLDksLTYpIAooMCwwLDAsMCwwLDApICAoMiwtMiwwLDAsMCwwKSAgKC00LDYsMCwwLDksLTEzKSAgKDIsLTQsMCwwLC01LDEwKSAKKDAsMCwwLDAsMCwwKSAgKDIsLTIsMCwwLDAsMCkgICgtNCw2LDAsMCw3LC0xMSkgICgyLC00LDAsMCwtNSwxMCkgCigwLDAsMCwwLDAsMCkgICgwLDAsMCwwLDAsMikgICgwLDAsMCwwLC0xLDEpICAoMCwwLDAsMCwxLC0yKSAKKDAsMCwwLDAsMCwwKSAgKDAsMCwwLDAsMCwyKSAgKDAsMCwwLDAsMSwtMSkgICgwLDAsMCwwLDEsLTIpIAoKCgowCgoKCjE2CjMgMCAxIDIKMyA2IDcgMwozIDkgNiA0CjQgOSAxMCAyIDExCjMgMCAxMiAxMwozIDAgMTMgMQozIDkgNSAxMAo0IDAgMiAxMCA3CjQgNyAxMCA1IDMKNCA3IDYgMTIgMAozIDEgMTQgMgo0IDExIDE0IDEzIDEyCjMgMTQgMTEgMgo0IDYgOSAxMSAxMgozIDkgNCA1CjMgNiAzIDQKCgoKOAogMyA0IDUgNyA4IDEwIDYgOQoKdGlwIDgK";
  var spruceUrl = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCiBzY2FsZSAgKDAsMS8yKSAKCjE1CigwLDApICAoLTIsMCkgICgtMiwxKSAgKDksMykgCigwLDApICAoMSwtMykgICgtMSwwKSAgKDgsMikgCigwLDApICAoLTIsMikgICgtMiwzKSAgKDEsMykgCigwLDApICAoMCwwKSAgKC0yLDMpICAoMSwzKSAKKDAsMCkgICgxLC0xKSAgKDEsLTIpICAoMCwyKSAKKDAsMCkgICgtMSwxKSAgKDEsLTIpICAoMCwyKSAKKDAsMCkgICgtMSwtMSkgICgtMSwwKSAgKDgsMikgCigwLDApICAoMSwtMykgICgxLC00KSAgKDgsMikgCigwLDApICAoMCwwKSAgKDEsLTMpICAoMSwwKSAKKDAsMCkgICgwLDApICAoMCwtMSkgICgxLDMpIAooMCwwKSAgKDAsLTIpICAoLTIsMSkgICg5LDMpIAooMCwwKSAgKC0xLC0xKSAgKC0yLDIpICAoOCw1KSAKKDAsMCkgICgtMSwtMSkgICgxLC00KSAgKDgsMikgCigwLDApICAoLTIsMikgICgwLC0xKSAgKDEsMykgCigwLDApICAoLTEsLTEpICAoLTEsLTEpICAoOSw1KSAKCgoKMAoKCgoxNgo0IDIgMyA0IDUKMyA4IDQgOQozIDEwIDEgMTEKNCA2IDEgMyAyCjQgMTMgOSA3IDEyCjMgNyAxIDEwCjMgMTIgMCA2CjMgNSAxMyAyCjMgOSA0IDMKMyA4IDkgMTMKMyAwIDExIDYKNCAxMyAxMiA2IDIKNCAxMiA3IDEwIDAKNCA5IDMgMSA3CjMgMTEgMSA2CjMgOCAxMyA1CgoKCjgKIDAgMSA2IDcgMTIgMTEgMTQgMTAKCnRpcCAxNAo=";
  var roseUrl = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCiBzY2FsZSAgKDEvMiwwKQoKMTcKKDAsMCkgICgxLC00KSAgKDEsMCkgICgxLC00KSAKKDAsMCkgICgtMSwtMSkgICgyLC0yKSAgKC0yLDEpIAooMCwwKSAgKC0yLDApICAoMywtMykgICgtMywyKSAKKDAsMCkgICgwLC0zKSAgKDIsLTEpICAoMCwtMykgCigwLDApICAoLTMsMykgICgwLDEpICAoLTMsNCkgCigwLDApICAoLTEsMCkgICgtMSwzKSAgKDAsLTEpIAooMCwwKSAgKC0xLC0xKSAgKDAsMikgICgyLC01KSAKKDAsMCkgICgtMywyKSAgKDEsMCkgICgtMSwwKSAKKDAsMCkgICgtMiwyKSAgKC0xLDIpICAoLTIsMykgCigwLDApICAoLTEsMCkgICgxLC0xKSAgKC00LDUpIAooMCwwKSAgKDAsLTEpICAoMCwwKSAgKC0zLDQpIAooMCwwKSAgKC0yLDApICAoMSwxKSAgKDEsLTQpIAooMCwwKSAgKDAsLTEpICAoLTIsNCkgICgxLC0yKSAKKDAsMCkgICgyLC00KSAgKC0xLDIpICAoMCwtMSkgCigwLDApICAoMSwtMykgICgwLDEpICAoLTEsMCkgCigwLDApICAoLTQsMykgICgyLC0xKSAgKC0yLDEpIAooMCwwKSAgKC0yLC0xKSAgKDEsMSkgICgtMiwwKSAKCgoKMAoKCgoxMgo0IDAgMSAyIDMKNCA0IDUgNiA3CjQgOCA0IDkgMTAKNCAxMSA2IDAgMwo0IDUgMTIgMTMgMTQKNCA4IDEyIDUgNAo0IDExIDE1IDcgNgo0IDYgNSAxNCAwCjQgNCA3IDEgOQo0IDcgMTUgMiAxCjQgMSAwIDE0IDkKNCA5IDE0IDEzIDEwCgoKCjkKIDMgMiAxNiAxNSAxIDExIDAgNiA3Cgp0aXAgMTYK";
  var purpleUrl = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCnNjYWxlICgxLzIsMCkKCjE5CigwLDApICAoMiw0KSAgKDMsLTIpICAoLTIsMykgCigwLDApICAoMSw2KSAgKDIsLTEpICAoMCwwKSAKKDAsMCkgICg0LDApICAoNSwtNikgICgyLC0zKSAKKDAsMCkgICg0LDApICAoNSwtNikgICgtMiwzKSAKKDAsMCkgICg0LDApICAoMywtMikgICgyLC0zKSAKKDAsMCkgICg0LDEpICAoNCwtNCkgICgxLC0yKSAKKDAsMCkgICgwLDIpICAoLTEsMikgICgyLC0zKSAKKDAsMCkgICgwLDIpICAoLTMsNikgICgyLC0zKSAKKDAsMCkgICgwLDEpICAoLTIsNCkgICgtMSwyKSAKKDAsMCkgICgyLDQpICAoMywtMikgICgyLC0zKSAKKDAsMCkgICgyLC0yKSAgKC0xLDIpICAoLTIsMykgCigwLDApICAoMCwyKSAgKC0xLDIpICAoLTIsMykgCigwLDApICAoMiwtMikgICgtMSwyKSAgKDIsLTMpIAooMCwwKSAgKDQsMSkgICg0LC00KSAgKC0xLDIpIAooMCwwKSAgKDQsMCkgICgzLC0yKSAgKC0yLDMpIAooMCwwKSAgKDAsMikgICgtMyw2KSAgKC0yLDMpIAooMCwwKSAgKDMsLTQpICAoMCwxKSAgKDAsMCkgCigwLDApICAoMCwxKSAgKC0yLDQpICAoMSwtMikgCigwLDApICAoNCwyKSAgKDIsMCkgICgwLDApIAoKCgowCgoKCjIwCjMgMSAyIDMKMyA2IDcgOAozIDMgNSAxCjQgMTAgMTEgNiAxMgozIDIgMSAxMwo0IDkgMCAxNCA0CjQgMTQgMyAxMSAxNQo0IDYgMiA0IDcKMyAxNCAwIDUKMyAyIDEzIDQKMyA0IDEzIDkKMyAxNiA4IDcKMyAxNyAxNSAxMQozIDggMTIgNgozIDE1IDE2IDcKNCAxNSA3IDQgMTQKNCAxMSAzIDIgNgozIDE1IDE3IDE2CjMgMTEgMTAgMTcKMyAxNCA1IDMKCgoKMTAKIDAgMiA0IDUgOSAxMyAxIDE0IDMgMTgKCnRpcCAxOAo=";
  var brownUrl = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCnNjYWxlICgxLzIsMCkKCjE3CigwLDApICAoLTMvMiwyKSAgKC01LzIsNy8yKSAgKDEsNy8yKSAKKDAsMCkgICgxLC01LzIpICAoLTMvMiwyKSAgKDMvMiwzLzIpIAooMCwwKSAgKC0zLzIsNS8yKSAgKDEsLTMvMikgICgzLzIsMCkgCigwLDApICAoLTMvMiw1LzIpICAoLTMsOS8yKSAgKDMvMiwwKSAKKDAsMCkgICgtMSwyKSAgKC0yLDMpICAoMiwtMikgCigwLDApICAoLTEsMikgICgyLC0zKSAgKDIsLTIpIAooMCwwKSAgKDEsLTUvMikgICg1LzIsLTQpICAoMy8yLDMvMikgCigwLDApICAoMS8yLC0yKSAgKDMvMiwtNS8yKSAgKDEsNy8yKSAKKDAsMCkgICgtMSwzLzIpICAoNS8yLC00KSAgKDMvMiwzLzIpIAooMCwwKSAgKDEsLTIpICAoMiwtMykgICgyLC0yKSAKKDAsMCkgICgxLC0yKSAgKC0yLDMpICAoMiwtMikgCigwLDApICAoMS8yLC0zLzIpICAoLTMsOS8yKSAgKDMvMiwwKSAKKDAsMCkgICgxLzIsLTMvMikgICgxLC0zLzIpICAoMy8yLDApIAooMCwwKSAgKC0zLzIsMikgICgzLzIsLTUvMikgICgxLDcvMikgCigwLDApICAoLTEsMy8yKSAgKC0zLzIsMikgICgzLzIsMy8yKSAKKDAsMCkgICgxLzIsLTIpICAoLTUvMiw3LzIpICAoMSw3LzIpIAooMCwwKSAgKC0xLzIsMCkgICgtMS8yLDEvMikgICgzLDMvMikgCgoKCjAKCgoKMTIKNCAyIDMgNCA1CjQgOSAxMCAxMSAxMgo0IDMgMTEgMTAgNAo0IDcgMTMgOCA2CjQgMTQgMSAxMSAzCjQgMCAxNSAxIDE0CjQgMTIgMiA1IDkKNCAxMyAwIDE0IDgKNCA2IDEgMTUgNwo0IDggMTQgMyAyCjQgNiA4IDIgMTIKNCAxMiAxMSAxIDYKCgoKOQogMCAxIDYgNyA4IDE0IDEzIDE2IDE1Cgp0aXAgMTYK";
  var sandUrl = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCnNjYWxlICgxLzIsMCkKCjE3CigwLDApICAoMCwxKSAgKC0yLDQpICAoMSw0KSAKKDAsMCkgICgyLC0zKSAgKDIsLTIpICAoMSw0KSAKKDAsMCkgICgwLDApICAoLTEsMikgICgyLDEpIAooMCwwKSAgKDAsMCkgICgzLC00KSAgKDIsMSkgCigwLDApICAoMywtNSkgICgxLC0xKSAgKDEsMSkgCigwLDApICAoMywtNSkgICgtMyw1KSAgKDEsMSkgCigwLDApICAoMiwtMykgICgtMiw0KSAgKDEsNCkgCigwLDApICAoMSwtMikgICgyLC0zKSAgKDIsLTIpIAooMCwwKSAgKDEsLTIpICAoLTIsMykgICgyLC0yKSAKKDAsMCkgICgxLC0xKSAgKDEsLTEpICAoMSwxKSAKKDAsMCkgICgtMSwyKSAgKDIsLTMpICAoMiwtMikgCigwLDApICAoMCwxKSAgKDIsLTIpICAoMSw0KSAKKDAsMCkgICgtMiw0KSAgKC0xLDIpICAoMiwxKSAKKDAsMCkgICgtMiw0KSAgKDMsLTQpICAoMiwxKSAKKDAsMCkgICgxLC0xKSAgKC0zLDUpICAoMSwxKSAKKDAsMCkgICgtMSwyKSAgKC0yLDMpICAoMiwtMikgCigwLDApICAoMSwtMSkgICgwLDEpICAoMywyKSAKCgoKMAoKCgoxMgo0IDIgMyA0IDUKNCA2IDEgMyAyCjQgNSA0IDcgOAo0IDQgOSAxMCA3CjQgMTEgMTMgMyAxCjQgMiA1IDE0IDEyCjQgNCAzIDEzIDkKNCAxNCA1IDggMTUKNCAxMiAxMyAxMSAwCjQgNiAyIDEyIDAKNCAxNCA5IDEzIDEyCjQgMTUgMTAgOSAxNAoKCgo5CiAwIDEgMiA2IDExIDEyIDE2IDMgMTMKCnRpcCAxNgo=";
  var coralUrl = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCiBzY2FsZSAgKDAsMS8yKSAKCjE1CigwLDApICAoLTMsMCkgICgyLDQpICAoLTUsMSkgCigwLDApICAoLTIsLTIpICAoMSw1KSAgKC0zLC0yKSAKKDAsMCkgICgtMiwtMikgICgyLDUpICAoLTMsLTMpIAooMCwwKSAgKC0xLDApICAoMSwwKSAgKDEsLTQpIAooMCwwKSAgKC0yLDIpICAoMSwtMSkgICgtMSwwKSAKKDAsMCkgICgtMSwwKSAgKDIsLTIpICAoLTEsMSkgCigwLDApICAoMCwtMikgICgyLC0xKSAgKDEsLTMpIAooMCwwKSAgKC0xLC00KSAgKDIsNCkgICgtMywtMSkgCigwLDApICAoLTIsLTMpICAoMywzKSAgKC0yLC00KSAKKDAsMCkgICgtMSwtNCkgICgzLDQpICAoLTMsLTIpIAooMCwwKSAgKC0yLC0yKSAgKDMsMykgICgtNSwyKSAKKDAsMCkgICgtMiwyKSAgKDIsLTEpICAoLTEsLTEpIAooMCwwKSAgKC0xLDEpICAoMSwwKSAgKC0yLDIpIAooMCwwKSAgKC0xLDApICAoMywtMikgICgtMSwwKSAKKDAsMCkgICgtMywtMikgICg0LDMpICAoLTQsLTIpIAoKCgowCgoKCjE2CjMgMSAyIDAKNCAzIDQgNSA2CjMgOCA3IDkKMyA3IDEwIDkKMyAxIDggMgozIDExIDQgMwo0IDAgMiA5IDEwCjQgMTEgMyAxIDAKMyAxMiAxMSAxMwo0IDcgMSAzIDYKMyAxMyA2IDUKNCAwIDEwIDEzIDExCjQgMTAgNyA2IDEzCjMgMTIgMTMgNQozIDggMSA3CjMgMTEgMTIgNAoKCgo4CiAwIDEgNyA4IDEwIDkgMTQgMgoKdGlwIDE0Cg==";
  var navyUrl = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCiBzY2FsZSAgKDEvMiwwKSAKCjE5CigwLDApICAoLTEsLTEpICAoLTEsMCkgICg0LDIpIAooMCwwKSAgKDIsLTQpICAoLTUsOCkgICgxLDEpIAooMCwwKSAgKDEsLTIpICAoMiwtMykgICgyLC0yKSAKKDAsMCkgICgyLC00KSAgKC0xLDIpICAoMCwxKSAKKDAsMCkgICgtMSwwKSAgKC0xLDApICAoMSw2KSAKKDAsMCkgICgtMiwxKSAgKDEsLTMpICAoMiw0KSAKKDAsMCkgICgtNiwxNS8yKSAgKDcvMiwtNykgICgzLzIsNy8yKSAKKDAsMCkgICgtMywzKSAgKDIsLTQpICAoLTMsMTEpIAooMCwwKSAgKC0yLDEpICAoLTMsMykgICgyLDQpIAooMCwwKSAgKC0zLDMpICAoMCwtMikgICg0LDEpIAooMCwwKSAgKC0zLDMpICAoNCwtOCkgICgzLDEpIAooMCwwKSAgKDUsLTE3LzIpICAoLTkvMiw3KSAgKDUvMiwtMy8yKSAKKDAsMCkgICgwLC0zLzIpICAoNS8yLC01KSAgKC0zLzIsMTcvMikgCigwLDApICAoMiwtNCkgICgtMyw0KSAgKDcsLTkpIAooMCwwKSAgKC0xLDEvMikgICgtNy8yLDUpICAoMTEvMiwtMTMvMikgCigwLDApICAoMCwtMSkgICgwLDApICAoMywtNCkgCigwLDApICAoLTMsMykgICgtMiwyKSAgKDQsMSkgCigwLDApICAoMSwtMikgICgtMiwzKSAgKDIsLTIpIAooMCwwKSAgKDIsLTQpICAoMSwtMikgICgwLDEpIAoKCgowCgoKCjIwCjMgMSAyIDMKMyA2IDUgNwozIDkgOCAxMAozIDEwIDggNgozIDggNSA2CjQgMTEgMSA3IDEyCjQgMTMgMTAgNiAxNAo0IDE1IDE0IDEgMwozIDEyIDcgMTYKMyAxMyAxNyAxMQozIDE2IDcgNQozIDIgMSAxMQozIDExIDE3IDIKMyAxMyAxOCAxNwozIDE4IDE0IDE1CjQgNyAxIDE0IDYKMyAxMyAxNCAxOAo0IDEwIDEyIDQgOQozIDQgMTIgMTYKNCAxMCAxMyAxMSAxMgoKCgoxMAogMCA0IDUgOCAxMCA3IDE2IDkgNiAxMgoKdGlwIDAK";
  var snubTriangleUrl = "data:null;base64,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";
  var sulfurUrl = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCnNjYWxlICgxLzIsMCkKCjE3CigwLDApICAoNCwtNSkgICgtMiwzKSAgKC02LDE1KSAKKDAsMCkgICgtNSw5KSAgKC0yLDMpICAoOSwtMTIpIAooMCwwKSAgKC01LDkpICAoMiwtMykgICg5LC0xMikgCigwLDApICAoNCwtNSkgICgyLC0zKSAgKC02LDE1KSAKKDAsMCkgICgtMyw1KSAgKC0yLDMpICAoOSwtMTIpIAooMCwwKSAgKC0zLDUpICAoMiwtMykgICg5LC0xMikgCigwLDApICAoMSwtMikgICgyLC0zKSAgKDIsLTIpIAooMCwwKSAgKDEsLTIpICAoLTIsMykgICgyLC0yKSAKKDAsMCkgICgwLDIpICAoMiwtMykgICgxLDUpIAooMCwwKSAgKDAsMikgICgtMiwzKSAgKDEsNSkgCigwLDApICAoMiwtMikgICgyLC0zKSAgKDEsNSkgCigwLDApICAoLTEsMikgICgtMiwzKSAgKDIsLTIpIAooMCwwKSAgKC0xLDIpICAoMiwtMykgICgyLC0yKSAKKDAsMCkgICg2LC05KSAgKDIsLTMpICAoLTYsMTUpIAooMCwwKSAgKDIsLTIpICAoLTIsMykgICgxLDUpIAooMCwwKSAgKDYsLTkpICAoLTIsMykgICgtNiwxNSkgCigwLDApICAoMSwwKSAgKDAsMCkgICgzLDMpIAoKCgowCgoKCjEyCjQgMCAxIDIgMwo0IDQgNSA2IDcKNCAwIDMgOCA5CjQgMTEgMSA0IDcKNCAxMSAxMiAyIDEKNCAxMyAzIDIgNQo0IDE0IDEwIDEzIDE1CjQgMTQgMTUgMCA5CjQgMTUgMTMgNSA0CjQgMTMgMTAgOCAzCjQgMiAxMiA2IDUKNCAxIDAgMTUgNAoKCgo5CiAxMCAzIDE2IDkgMCAxMyA4IDE1IDE0Cgp0aXAgMTYK";
  var cinnamonUrl = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCnNjYWxlICgxLzIsMCkKCjE3CigwLDApICAoMTMsLTIxKSAgKDcsLTEwKSAgKDYsLTQpIAooMCwwKSAgKDIsLTMpICAoMywtMykgICgyLDQpIAooMCwwKSAgKDAsMSkgICgzLC0zKSAgKDIsNCkgCigwLDApICAoMTEsLTE3KSAgKDcsLTEwKSAgKDYsLTQpIAooMCwwKSAgKDExLC0xNykgICgzLC00KSAgKDYsLTQpIAooMCwwKSAgKDAsMSkgICgtMSwzKSAgKDIsNCkgCigwLDApICAoMSwtMikgICgtMiwzKSAgKDIsLTIpIAooMCwwKSAgKC0xLDIpICAoLTIsMykgICgyLC0yKSAKKDAsMCkgICgtMTIsMjApICAoLTYsMTApICAoLTIsNikgCigwLDApICAoLTEwLDE2KSAgKC02LDEwKSAgKC0yLDYpIAooMCwwKSAgKC0xMiwyMCkgICgtMiw0KSAgKC0yLDYpIAooMCwwKSAgKDEsLTEpICAoMSwwKSAgKDQsMikgCigwLDApICAoMTMsLTIxKSAgKDMsLTQpICAoNiwtNCkgCigwLDApICAoLTEwLDE2KSAgKC0yLDQpICAoLTIsNikgCigwLDApICAoLTEsMikgICgyLC0zKSAgKDIsLTIpIAooMCwwKSAgKDEsLTIpICAoMiwtMykgICgyLC0yKSAKKDAsMCkgICgyLC0zKSAgKC0xLDMpICAoMiw0KSAKCgoKMAoKCgoxMgo0IDAgMSAyIDMKNCA2IDcgOCA5CjQgNCAzIDIgNQo0IDQgOCAxMCAzCjQgMTMgMTAgMTQgMTUKNCA5IDggNCAxMgo0IDEyIDQgNSAxNgo0IDAgMyAxMCAxMwo0IDEyIDAgMTMgOQo0IDcgMTQgMTAgOAo0IDEyIDE2IDEgMAo0IDkgMTMgMTUgNgoKCgo5CiA0IDEgNSAzIDIgMTEgMTIgMTYgMAoKdGlwIDExCg==";
  var turquoiseUrl = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCiBzY2FsZSAgKDAsMS8yKSAKCjE3CigwLDApICAoLTUsMSkgICg1LC03KSAgKC03LDUpIAooMCwwKSAgKC00LC0xKSAgKDYsLTgpICAoLTcsNikgCigwLDApICAoLTEsLTIpICAoLTMsNikgICgxLC00KSAKKDAsMCkgICgtMiwwKSAgKC00LDcpICAoMSwtNSkgCigwLDApICAoLTEsMCkgICgyLC0yKSAgKC0xLDEpIAooMCwwKSAgKC0yLDIpICAoMSwtMSkgICgtMSwwKSAKKDAsMCkgICgtMSwtMikgICgtNSw4KSAgKDMsLTgpIAooMCwwKSAgKC0xLDApICAoMCwwKSAgKDEsLTMpIAooMCwwKSAgKDAsLTIpICAoMSwtMSkgICgxLC0yKSAKKDAsMCkgICgwLC00KSAgKC00LDcpICAoMywtNykgCigwLDApICAoLTMsLTMpICAoNSwtNykgICgtNSwzKSAKKDAsMCkgICgtNCwtMykgICgtMSwyKSAgKC0zLC0zKSAKKDAsMCkgICgtNCwtMSkgICg0LC02KSAgKC01LDIpIAooMCwwKSAgKC0zLC01KSAgKDAsMSkgICgtMywtMikgCigwLDApICAoLTUsLTMpICAoMSwwKSAgKC00LC0yKSAKKDAsMCkgICgtNSwtMSkgICgwLDEpICAoLTUsMCkgCigwLDApICAoLTQsLTMpICAoMSwwKSAgKC01LDEpIAoKCgowCgoKCjEyCjQgMCAxIDIgMwo0IDIgNCA1IDMKNCA2IDcgOCA5CjQgMTEgMTIgMTAgMTMKNCA5IDEwIDEyIDYKNCA5IDggNCAyCjQgMTUgMTYgMSAwCjQgMiAxIDEwIDkKNCAwIDEyIDExIDE1CjQgMyA1IDcgNgo0IDEzIDEwIDEgMTYKNCAwIDMgNiAxMgoKCgo5CiAxMCAxIDAgMTQgMTIgMTMgMTYgMTUgMTEKCnRpcCAxNAo=";
  var oliveUrl = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCnNjYWxlICgxLzIsMCkKCjE5CigwLDApICAoMSwtMykgICgtMSwwKSAgKC0yLDQpIAooMCwwKSAgKDAsLTIpICAoMSwtMykgICgtMSwyKSAKKDAsMCkgICgwLC0zKSAgKDEsLTQpICAoMSwtMSkgCigwLDApICAoMSwtNCkgICgtMSwtMSkgICgwLDEpIAooMCwwKSAgKC0yLDIpICAoLTMsMykgICgtMSwyKSAKKDAsMCkgICgwLC0xKSAgKDIsLTQpICAoMSwtMikgCigwLDApICAoLTMsNCkgICgwLC0xKSAgKDAsMCkgCigwLDApICAoLTMsMikgICgtMSwtMSkgICgyLC0zKSAKKDAsMCkgICgtMywzKSAgKC0xLDApICAoMCwwKSAKKDAsMCkgICgtMiwxKSAgKC0zLDIpICAoMSwtMSkgCigwLDApICAoMCwtMSkgICgyLC00KSAgKC0xLDIpIAooMCwwKSAgKC0yLDIpICAoMSwtMikgICgyLC0zKSAKKDAsMCkgICgtMiwyKSAgKDEsLTIpICAoLTIsMykgCigwLDApICAoLTIsMCkgICgtNCwzKSAgKDEsLTEpIAooMCwwKSAgKC0yLDApICAoLTQsMykgICgtMSwzKSAKKDAsMCkgICgwLC0zKSAgKC0zLDEpICAoLTIsNCkgCigwLDApICAoMCwtMykgICgtMywxKSAgKDIsLTIpIAooMCwwKSAgKDEsLTUpICAoLTIsMCkgICgwLDEpIAooMCwwKSAgKC0yLC0xKSAgKC0yLC0xKSAgKDAsMSkgCgoKCjAKCgoKMjAKNCAwIDEgMiAzCjMgNCA1IDYKNCA3IDggNCA5CjMgMCAxMCAxMQozIDEgMTIgOAo0IDAgMyA5IDQKMyAyIDE0IDMKMyA3IDkgMTUKMyAzIDE0IDE2CjQgMTcgMiA3IDEzCjQgNyAyIDEgOAozIDggMTIgNQozIDQgOCA1CjQgMTAgMCA0IDYKMyA3IDE1IDEzCjMgMSAxMSAxMgozIDIgMTcgMTQKMyAwIDExIDEKMyAzIDE2IDkKMyA5IDE2IDE1CgoKCjEwCiAxMyAxNCAzIDkgMiAxOCAxNiAxNyA3IDE1Cgp0aXAgMTgK";
  var appleUrl = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCiBzY2FsZSAgKDAsMS8yKSAKCjE3CigwLDApICAoLTIsMy8yKSAgKDMvMiwtMSkgICgtOS8yLC0zLzIpIAooMCwwKSAgKDAsLTEvMikgICgzLzIsLTEpICAoLTkvMiwtMy8yKSAKKDAsMCkgICgxLC0zLzIpICAoMy8yLC0yKSAgKC0zLzIsLTMvMikgCigwLDApICAoLTEsMS8yKSAgKDMvMiwtMikgICgtMy8yLC0zLzIpIAooMCwwKSAgKC0yLDEpICAoMiwtMSkgICgtNiwtMSkgCigwLDApICAoLTEsMS8yKSAgKC0xLzIsMikgICgtMy8yLC0zLzIpIAooMCwwKSAgKDEsLTMvMikgICgtMS8yLDIpICAoLTMvMiwtMy8yKSAKKDAsMCkgICgwLC0xLzIpICAoLTEvMiwzKSAgKC05LzIsLTMvMikgCigwLDApICAoLTIsMy8yKSAgKC0xLzIsMykgICgtOS8yLC0zLzIpIAooMCwwKSAgKDAsLTEpICAoMCwzKSAgKC02LC0xKSAKKDAsMCkgICgwLC0xKSAgKDIsLTEpICAoLTYsLTEpIAooMCwwKSAgKC0xLDEpICAoLTEsMikgICgwLC0yKSAKKDAsMCkgICgxLC0xKSAgKC0xLDIpICAoMCwtMikgCigwLDApICAoLTEsMCkgICgxLDEpICAoLTYsLTMpIAooMCwwKSAgKC0yLDEpICAoMCwzKSAgKC02LC0xKSAKKDAsMCkgICgxLC0xKSAgKDEsLTIpICAoMCwtMikgCigwLDApICAoLTEsMSkgICgxLC0yKSAgKDAsLTIpIAoKCgowCgoKCjEyCjQgMCAxIDIgMwo0IDUgNiA3IDgKNCA0IDEwIDEgMAo0IDExIDEyIDYgNQo0IDMgNSA4IDAKNCA2IDIgMSA3CjQgNyAxIDEwIDkKNCA4IDcgOSAxNAo0IDE1IDIgNiAxMgo0IDE2IDExIDUgMwo0IDAgOCAxNCA0CjQgMyAyIDE1IDE2CgoKCjkKIDQgOSAxMCAxIDEzIDAgNyAxNCA4Cgp0aXAgMTMK";
  var lavenderUrl = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCiBzY2FsZSAgKDEvMiwwKSAKCjE1CigwLDApICAoMCwtMikgICgtNCwxMCkgICgtNCw0KSAKKDAsMCkgICgyLC01KSAgKC0zLDgpICAoLTUsNSkgCigwLDApICAoLTMsNCkgICg3LC0xMCkgICgtMSwwKSAKKDAsMCkgICgtNSw3KSAgKDYsLTgpICAoMCwtMSkgCigwLDApICAoMiwtNSkgICgtNSwxMikgICgtMSwtMSkgCigwLDApICAoNCwtOCkgICgtNCwxMCkgICgtMiwwKSAKKDAsMCkgICgtMSwwKSAgKDQsLTIpICAoLTMsMSkgCigwLDApICAoLTMsMykgICgzLDApICAoLTIsMCkgCigwLDApICAoLTMsNCkgICg1LC02KSAgKDMsLTYpIAooMCwwKSAgKC0xLDEpICAoNiwtOCkgICgyLC01KSAKKDAsMCkgICgyLC00KSAgKC0xLDIpICAoMCwtMSkgCigwLDApICAoMCwtMSkgICgtMiw0KSAgKDEsLTIpIAooMCwwKSAgKDEsLTIpICAoMCwxKSAgKDIsLTQpIAooMCwwKSAgKC0yLDEpICAoMiwxKSAgKC00LDMpIAooMCwwKSAgKC0xLC0xKSAgKDIsMikgICgtMiwtMSkgCgoKCjAKCgoKMTYKNCAwIDEgMiAzCjQgNCA1IDYgNwo0IDQgMCAzIDgKMyAyIDkgMTAKMyA4IDMgMTEKMyA4IDExIDEyCjMgOSAxMiAxMAozIDAgNCA3CjMgOSA4IDEyCjMgNSAxIDYKNCA4IDkgNSA0CjQgMyAyIDEwIDExCjMgMSAwIDEzCjMgMSAxMyA2CjMgMCA3IDEzCjQgNSA5IDIgMQoKCgo4CiA1IDEgNCAwIDcgMTQgNiAxMwoKdGlwIDE0Cg==";
  var orangeUrl = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCgoxNQooMCwwKSAoLTEvMiwxKSAoMCwxKSAoLTEvMiwxLzIpCigwLDApICgtMS8yLDEpICgwLDEpICgxLzIsLTEvMikKKDAsMCkgKC0xLzIsMy8yKSAoMS8yLDApICgwLDApCigwLDApICgxLzIsMCkgKDEsMCkgKC0xLzIsMS8yKQooMCwwKSAoMS8yLDApICgxLDApICgxLzIsLTEvMikKKDAsMCkgKC0xLzIsMikgKDEsMCkgKC0xLzIsMS8yKQooMCwwKSAoLTEvMiwyKSAoMSwwKSAoMS8yLC0xLzIpCigwLDApICg1LzIsLTEpICgyLDIpICgtMS8yLDEvMikKKDAsMCkgKDUvMiwtMSkgKDIsMikgKDEvMiwtMS8yKQooMCwwKSAoMy8yLDEpICgyLDIpICgtMS8yLDEvMikKKDAsMCkgKDMvMiwxKSAoMiwyKSAoMS8yLC0xLzIpCigwLDApICg1LzIsLTEvMikgKDUvMiwyKSAoMCwwKQooMCwwKSAoNS8yLDApICgzLDEpICgtMS8yLDEvMikKKDAsMCkgKDUvMiwwKSAoMywxKSAoMS8yLC0xLzIpCigwLDApICgyLDEpICgzLDIpICgwLDApCgoKCjAKCgoKMTYKMyAgMCAzIDUgCjMgIDEgMCAyIAozICAxIDIgNiAKMyAgNSAyIDAgCjMgIDYgNCAxIAozICA5IDcgMTIgCjMgIDExIDEyIDcgCjMgIDEzIDggMTAgCjMgIDEzIDExIDggCjMgIDEzIDEyIDExIAo0ICAxIDQgMyAwIAo0ICA1IDMgNyA5IAo0ICAxMCA4IDQgNiAKNCAgMTIgMTMgMTAgOSAKNSAgMyA0IDggMTEgNyAKNSAgNiAyIDUgOSAxMCAKCgoKOAo3IDggOSAxMCAxMSAxMiAxMyAxNCAKCgp0aXAgMTQKCg=="; // These imports work because we are using @rollup/plugin-url.

  var shapes = {
    connector: connectorUrl,
    blue: blueUrl,
    yellow: yellowUrl,
    red: redUrl,
    green: greenUrl,
    snubDiagonal: snubDiagonalUrl,
    black: blackUrl,
    maroon: maroonUrl,
    snubPentagon: snubPentagonUrl,
    spruce: spruceUrl,
    rose: roseUrl,
    purple: purpleUrl,
    brown: brownUrl,
    sand: sandUrl,
    coral: coralUrl,
    navy: navyUrl,
    snubTriangle: snubTriangleUrl,
    sulfur: sulfurUrl,
    cinnamon: cinnamonUrl,
    turquoise: turquoiseUrl,
    olive: oliveUrl,
    apple: appleUrl,
    lavender: lavenderUrl,
    orange: orangeUrl
  };
  var connectorUrl$1 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCiBzY2FsZSAgKDEvMiwwKSAKCjIxCigwLDApICAoLTEsMikgICgxLC0yKSAgKDEsLTIpIAooMCwwKSAgKDEsLTEpICAoMCwwKSAgKC0yLDMpIAooMCwwKSAgKDEsLTEpICAoMCwwKSAgKDIsLTMpIAooMCwwKSAgKC0xLDIpICAoMSwtMikgICgtMSwyKSAKKDAsMCkgICgyLC0zKSAgKC0xLDEpICAoMCwwKSAKKDAsMCkgICgwLDApICAoMiwtMykgICgxLC0xKSAKKDAsMCkgICgwLDApICAoLTIsMykgICgxLC0xKSAKKDAsMCkgICgtMSwyKSAgKC0xLDIpICAoLTEsMikgCigwLDApICAoMSwtMikgICgxLC0yKSAgKC0xLDIpIAooMCwwKSAgKDEsLTIpICAoLTEsMikgICgtMSwyKSAKKDAsMCkgICgtMSwxKSAgKDAsMCkgICgyLC0zKSAKKDAsMCkgICgwLDApICAoLTIsMykgICgtMSwxKSAKKDAsMCkgICgwLDApICAoMiwtMykgICgtMSwxKSAKKDAsMCkgICgtMSwyKSAgKC0xLDIpICAoMSwtMikgCigwLDApICAoMSwtMikgICgxLC0yKSAgKDEsLTIpIAooMCwwKSAgKC0yLDMpICAoLTEsMSkgICgwLDApIAooMCwwKSAgKC0xLDEpICAoMCwwKSAgKC0yLDMpIAooMCwwKSAgKDIsLTMpICAoMSwtMSkgICgwLDApIAooMCwwKSAgKDEsLTIpICAoLTEsMikgICgxLC0yKSAKKDAsMCkgICgwLDApICAoMCwwKSAgKDAsMCkgCigwLDApICAoLTIsMykgICgxLC0xKSAgKDAsMCkgCgoKCjEKMTkgMTcKCgoKMTIKNSAwIDEgMiAzIDQKNSA1IDYgMyAyIDcKNSA4IDYgNSA5IDEwCjUgMTEgMTIgMTMgMSAwCjUgMTQgMTEgMCA0IDE1CjUgMTYgMTQgMTUgOCAxMAo1IDEgMTMgMTcgNyAyCjUgMTggMTIgMTEgMTQgMTYKNSA1IDcgMTcgMjAgOQo1IDIwIDE3IDEzIDEyIDE4CjUgMjAgMTggMTYgMTAgOQo1IDggMTUgNCAzIDYKCgoKMAoKCg=="; // These imports work because we are using @rollup/plugin-url.

  var shapes$1 = {
    connector: connectorUrl$1
  };
  var connectorUrl$2 = "data:null;base64,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";
  var blueUrl$1 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCgoyNwooMCwwKSAgKC0xLzIsMS8yKSAgKDEvMiwtMSkgICg0LDEpIAooMCwwKSAgKC0xLzIsMS8yKSAgKC0xLzIsMSkgICg0LDEpIAooMCwwKSAgKC0xLzIsMS8yKSAgKC0xLzIsMSkgICgwLDEpIAooMCwwKSAgKC0xLzIsMS8yKSAgKDEvMiwtMSkgICgwLDEpIAooMCwwKSAgKDEvMiwtMSkgICgtMSwzLzIpICAoMSwtMSkgCigwLDApICAoLTEvMiwxKSAgKC0xLDMvMikgICgxLC0xKSAKKDAsMCkgICgtMS8yLDEpICAoLTEsMy8yKSAgKDAsMSkgCigwLDApICAoMS8yLC0xKSAgKC0xLDMvMikgICgwLDEpIAooMCwwKSAgKDEvMiwtMSkgICgtMSwzLzIpICAoNCwxKSAKKDAsMCkgICgxLzIsLTEpICAoMSwtMy8yKSAgKDQsMSkgCigwLDApICAoMS8yLC0xLzIpICAoLTEvMiwxKSAgKDQsMSkgCigwLDApICAoMS8yLC0xLzIpICAoLTEvMiwxKSAgKDAsMSkgCigwLDApICAoMCwwKSAgKDAsMCkgICgxLC0xKSAKKDAsMCkgICgxLzIsLTEpICAoMSwtMy8yKSAgKDEsLTEpIAooMCwwKSAgKDEvMiwtMS8yKSAgKDEvMiwtMSkgICg0LDEpIAooMCwwKSAgKDEvMiwtMS8yKSAgKDEvMiwtMSkgICgwLDEpIAooMCwwKSAgKDAsMCkgICgwLDApICAoMywzKSAKKDAsMCkgICgxLzIsLTEpICAoMSwtMy8yKSAgKDMsMykgCigwLDApICAoMS8yLC0xKSAgKC0xLDMvMikgICgzLDMpIAooMCwwKSAgKC0xLzIsMSkgICgxLC0zLzIpICAoMywzKSAKKDAsMCkgICgtMS8yLDEpICAoLTEsMy8yKSAgKDMsMykgCigwLDApICAoLTEvMiwxKSAgKC0xLDMvMikgICg0LDEpIAooMCwwKSAgKC0xLzIsMSkgICgxLC0zLzIpICAoNCwxKSAKKDAsMCkgICgxLzIsLTEpICAoMSwtMy8yKSAgKDAsMSkgCigwLDApICAoMCwwKSAgKDAsMCkgICg0LDIpIAooMCwwKSAgKC0xLzIsMSkgICgxLC0zLzIpICAoMSwtMSkgCigwLDApICAoLTEvMiwxKSAgKDEsLTMvMikgICgwLDEpIAoKCgowCgoKCjI4CjQgMCAxIDIgMwo0IDQgNSA2IDcKNCA4IDkgMSAwCjQgMSAxMCAxMSAyCjMgMTIgNSA0CjMgMTIgNCAxMwo0IDEwIDE0IDE1IDExCjMgMTYgMTcgMTgKNCAzIDE1IDE0IDAKNCAxOSAyMCAyMSAyMgo0IDcgMyAyIDIzCjMgMTYgMjAgMTkKMyAxMiAxMyAyNQo0IDE5IDIyIDkgMTcKNCAyNiAyMyAyIDExCjQgMjIgMTAgMSA5CjMgMTYgMTggMjAKNCAyNSAxMyAyMyAyNgo0IDI2IDExIDE1IDYKNCAyMiAyMSAxNCAxMAozIDE2IDE5IDE3CjMgMTIgMjUgNQo0IDE4IDE3IDkgOAo0IDE4IDggMjEgMjAKNCA4IDAgMTQgMjEKNCA0IDcgMjMgMTMKNCAyNSAyNiA2IDUKNCA3IDYgMTUgMwoKCgoxNAogMTAgMSAxNyAyMiAyNCA4IDE5IDE2IDE4IDAgMjEgOSAxNCAyMAoKdGlwIDI0Cg==";
  var yellowUrl$1 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCgoyNQooMCwwKSAoLTIvMyw0LzMpICgxLzIsMS82KSAoMS8yLC0xKQooMCwwKSAoLTEvMiwxKSAoMCwxKSAoLTEvMiwxLzIpCigwLDApICgtMS8yLDMvMikgKDEvMiwwKSAoMCwwKQooMCwwKSAoLTEvNiw1LzYpICgtMS8yLDUvMykgKDAsMCkKKDAsMCkgKC0xLzIsMikgKDIsMS8yKSAoMCwwKQooMCwwKSAoMS8yLDApICgxLDMvMikgKDAsMCkKKDAsMCkgKDEvMiwxLzIpICgzLzIsMS8yKSAoLTEvMiwxLzIpCigwLDApICgxLzIsLTEvMikgKDEvMiwxLzIpICgtMS8yLDEvMikKKDAsMCkgKDEvMiwtMS8yKSAoMS8yLDEvMikgKDEvMiwtMS8yKQooMCwwKSAoLTEvMiwxKSAoMCwxKSAoMS8yLC0xLzIpCigwLDApICgxLzIsMCkgKDEsLTEvMikgKDAsMCkKKDAsMCkgKDEvMiwxLzIpICgzLzIsMS8yKSAoMS8yLC0xLzIpCigwLDApICgzLzIsLTEpICgyLDApICgxLzIsLTEvMikKKDAsMCkgKDMvMiwtMy8yKSAoMy8yLDEpICgwLDApCigwLDApICg1LzMsLTQvMykgKDMvMiw1LzYpICgtMS8yLDEpCigwLDApICgzLzIsLTEpICgyLDApICgtMS8yLDEvMikKKDAsMCkgKDUvMywtNC8zKSAoMy8yLDUvNikgKDEvMiwtMSkKKDAsMCkgKDAsMy8yKSAoMSwyKSAoMS8yLC0xKQooMCwwKSAoNy82LC01LzYpICg1LzIsLTIvMykgKDAsMCkKKDAsMCkgKDEsMCkgKDIsMSkgKDAsMCkKKDAsMCkgKC0yLzMsNC8zKSAoMS8yLDEvNikgKC0xLzIsMSkKKDAsMCkgKDAsMy8yKSAoMSwyKSAoLTEvMiwxKQooMCwwKSAoMSwtMy8yKSAoMSwtMSkgKDEvMiwtMSkKKDAsMCkgKDEsLTMvMikgKDEsLTEpICgtMS8yLDEpCigwLDApICgzLzIsLTIpICgwLDEvMikgKDAsMCkKCgoKMAoKCgoyNgo0IDAgMSAyIDMKMyA1IDYgNwozIDcgOCA1CjQgOSAyIDEwIDgKNCAyIDEgNyAxMAo0IDUgMTEgMTIgMTMKNCAxNCAxMiAxNSAxNgo0IDE3IDE2IDE4IDQKMyAxMCA3IDYKMyAxMSA1IDgKNCAyMCA5IDEgMAo0IDYgNSAxMyAxNQozIDQgMjEgMTcKNCAxIDkgOCA3CjQgMyAyIDkgMjAKNCAxNiAxNSAxMyAxOAo0IDIwIDAgMjIgMjMKNCAzIDIwIDIzIDI0CjQgMTggMTMgMTIgMTQKMyA4IDEwIDExCjMgMjMgMjIgMjQKNCAyMSAxNCAxNiAxNwo0IDQgMTggMTQgMjEKNCAxMSA2IDE1IDEyCjMgNiAxMSAxMAo0IDAgMyAyNCAyMgoKCgoxMAogNCAxOSAxMiAxNCAxNSAxNyAyMSAxMyAxNiAxOAoKdGlwIDE5Cm1pZGRsZSAxMCA3IDYgOCAxMSA1Cg==";
  var redUrl$1 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCgo0MQooMCwwKSAoMCwwKSAoMy8yLC0yKSAoMCwtMS8yKQooMCwwKSAoMCwwKSAoOS8xMCwtNy8xMCkgKC0xMy8xMCw3LzUpCigwLDApICgtMS8yLDEpICgtMy81LDkvNSkgKC0zLzEwLC0xLzEwKQooMCwwKSAoLTEvMiwxKSAoMCwxLzIpICgxLC0yKQooMCwwKSAoLTEsMy8yKSAoMTgvNSwxNy8xMCkgKC02LzUsLTI5LzEwKQooMCwwKSAoMS8yLC0xKSAoNCwzLzIpICgtMywwKQooMCwwKSAoMS8yLC0xKSAoMjMvNSwxLzUpICgtMTcvMTAsLTE5LzEwKQooMCwwKSAoMCwwKSAoMzEvMTAsMjcvMTApICgtNy8xMCwtMTcvNSkKKDAsMCkgKDAsMCkgKDUvMiw0KSAoLTIsLTMvMikKKDAsMCkgKDEvMiwtMSkgKDQsMSkgKC0zLzIsLTUvMikKKDAsMCkgKC0xLzIsMS8yKSAoNS8yLDEpICgwLC0zKQooMCwwKSAoMCwwKSAoNy8yLC0xLzIpICgtMS8yLC0yKQooMCwwKSAoMCwwKSAoOS8yLDEvMikgKC0zLzIsLTIpCigwLDApICgtMS8yLDEvMikgKDcvMiwyKSAoLTEsLTMpCigwLDApICgtMS8yLDEpICg0LDMvMikgKC0zLDApCigwLDApICgtMS8yLDEpICgyMy81LDEvNSkgKC0xNy8xMCwtMTkvMTApCigwLDApICgxLC0zLzIpICgxOC81LDE3LzEwKSAoLTYvNSwtMjkvMTApCigwLDApICgxLC0zLzIpICgzLDMpICgtNS8yLC0xKQooMCwwKSAoMS8yLC0xLzIpICg3LzIsMikgKC0xLC0zKQooMCwwKSAoMSwtMy8yKSAoMi81LDMvMTApICgtNC81LDkvMTApCigwLDApICgxLC0zLzIpICgxLC0xKSAoMS8yLC0xKQooMCwwKSAoMCwwKSAoMS8yLDUvMikgKC0zLzIsMCkKKDAsMCkgKC0xLzIsMS8yKSAoMy8yLDEpICgtMiwxKQooMCwwKSAoMS8yLC0xKSAoMywwKSAoLTEvMiwtNS8yKQooMCwwKSAoMS8yLC0xKSAoMCwxKSAoLTEvMiwxLzIpCigwLDApICgtMS8yLDEpICgwLDEpICgtMS8yLDEvMikKKDAsMCkgKC0xLzIsMSkgKDEsMikgKC0zLzIsMS8yKQooMCwwKSAoMS8yLC0xKSAoMSwyKSAoLTMvMiwxLzIpCigwLDApICgxLzIsLTEvMikgKDUvMiwxKSAoMCwtMykKKDAsMCkgKC0xLzIsMSkgKDQsMSkgKC0zLzIsLTUvMikKKDAsMCkgKC0xLzIsMSkgKDMsMCkgKC0xLzIsLTUvMikKKDAsMCkgKDEvMiwtMS8yKSAoMy8yLDEpICgtMiwxKQooMCwwKSAoMS8yLC0xKSAoMCwxLzIpICgxLC0yKQooMCwwKSAoMS8yLC0xKSAoLTMvNSw5LzUpICgtMy8xMCwtMS8xMCkKKDAsMCkgKC0xLDMvMikgKDIvNSwzLzEwKSAoLTQvNSw5LzEwKQooMCwwKSAoLTEsMy8yKSAoMSwtMSkgKDEvMiwtMSkKKDAsMCkgKC0xLzIsMS8yKSAoMS8yLDApICgtMSwxKQooMCwwKSAoLTEsMy8yKSAoMywzKSAoLTUvMiwtMSkKKDAsMCkgKDAsMCkgKC0xLzIsMy8yKSAoLTEvMiwwKQooMCwwKSAoMS8yLC0xLzIpICgxLzIsMCkgKC0xLDEpCigwLDApICgwLDApICg0LDIpICgtMiwtMikKCgoKMAoKCgo0Mgo0IDAgMSAyIDMKNCA1IDYgNyA4CjQgMTAgMTEgMTIgMTMKNCAxNCAxNSAxNiAxNwo0IDggNyAxNSAxNAo0IDMgMiAxOSAyMAozIDIxIDIyIDIzCjQgMjMgMTAgMTMgOQo0IDI0IDI1IDI2IDI3CjQgNiAxMyAxMiA3CjMgMjcgMjYgMTEKMyAyNiAyOCAxMQo0IDE2IDI5IDkgNAozIDIyIDI3IDEwCjMgMjEgMjMgMzAKMyAzMSAyMSAzMAo0IDMyIDMzIDEgMAo0IDIwIDE5IDM0IDM1CjQgMjggMzAgMjkgMTgKNCAxNSAxOCAyOSAxNgo0IDM2IDI0IDI3IDIyCjQgMzAgMjMgOSAyOQo0IDQgOSAxMyA2CjQgMTcgMTYgNCAzNwo0IDM4IDM2IDIyIDIxCjMgMzEgMzAgMjgKNCA3IDEyIDE4IDE1CjMgMjcgMTEgMTAKNCAzNyA0IDYgNQo0IDM1IDM0IDMzIDMyCjQgMzMgMzYgMzggMQo0IDEgMzggMzkgMgo1IDIwIDM1IDMyIDAgMwo0IDE5IDI1IDI0IDM0CjUgMTcgMzcgNSA4IDE0CjQgMTEgMjggMTggMTIKNCAzNCAyNCAzNiAzMwozIDIyIDEwIDIzCjQgMiAzOSAyNSAxOQo0IDM5IDM4IDIxIDMxCjQgMjUgMzkgMzEgMjYKMyAyNiAzMSAyOAoKCgoxNgogNCA5IDEzIDE4IDE3IDggMTQgNSA3IDYgMjkgMTIgMTUgMzcgNDAgMTYKCnRpcCA0MAptaWRkbGUgMzEgMzAgMjggMjYgMTEgMjcgMTAgMjIgMjMgMjEK";
  var greenUrl$1 = "data:null;base64,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"; // These imports work because we are using @rollup/plugin-url.

  var shapes$2 = {
    connector: connectorUrl$2,
    blue: blueUrl$1,
    yellow: yellowUrl$1,
    red: redUrl$1,
    green: greenUrl$1
  };
  var connectorUrl$3 = "data:null;base64,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";
  var maroonUrl$1 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCiBzY2FsZSAgKDEsLTEpIAoKMTcKKDAsMCkgICgzMy8yLC0yNCkgICgzLzIsNSkgICgyMy8yLC0yMikgCigwLDApICAoNSwtNSkgICg3LC0zKSAgKC0zLDEpIAooMCwwKSAgKDMwLC00NSkgICgtMTgsMzcpICAoLTIsLTEpIAooMCwwKSAgKDI5LzIsLTIzKSAgKDMvMiwwKSAgKDI3LzIsLTIzKSAKKDAsMCkgICgzMS8yLC0yMikgICg1LzIsMykgICgyNS8yLC0yNCkgCigwLDApICAoMjcvMiwtMjEpICAoNS8yLC0yKSAgKDI5LzIsLTI1KSAKKDAsMCkgICgzLC0xKSAgKDcsLTMpICAoLTUsNSkgCigwLDApICAoLTI3LzIsMjMpICAoMy8yLDApICAoLTI5LzIsMjMpIAooMCwwKSAgKC0yOCw0NikgICgyMiwtMzQpICAoMCwwKSAKKDAsMCkgICgtMjkvMiwyNSkgICg1LzIsLTIpICAoLTI3LzIsMjEpIAooMCwwKSAgKDAsMCkgICgyMiwtMzQpICAoMjgsLTQ2KSAKKDAsMCkgICgyLDEpICAoLTE4LDM3KSAgKC0zMCw0NSkgCigwLDApICAoLTIzLzIsMjIpICAoMy8yLDUpICAoLTMzLzIsMjQpIAooMCwwKSAgKC0yNS8yLDI0KSAgKDUvMiwzKSAgKC0zMS8yLDIyKSAKKDAsMCkgICgyLDEpICAoNCwzKSAgKC0yLC0xKSAKKDAsMCkgICgtMyw2KSAgKC0zLDYpICAoMSwtMikgCigwLDApICAoLTEsMikgICgtMyw2KSAgKDMsLTYpIAoKCgowCgoKCjE2CjMgMCAxIDIKNCAzIDAgNCA1CjMgNyA4IDkKNCAxMCA4IDcgMwozIDExIDEyIDEzCjQgNCAxMyA5IDUKNCAzIDcgMTIgMAo0IDEyIDcgOSAxMwo0IDUgOSAxNSAxNgozIDExIDYgMTIKMyAwIDIgNAo0IDIgMTEgMTMgNAozIDEwIDMgNQozIDggMTUgOQozIDEwIDUgMTYKNCAwIDEyIDYgMQoKCgo5CiAwIDYgMTEgMTMgMTQgMiAxMiAxIDQKCnRpcCAxNAo=";
  var blueUrl$2 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCiBzY2FsZSAgKDEsLTEpIAoKOQooMCwwKSAgKC0xNiwzOCkgICgwLDApICAoLTI4LDQ2KSAKKDAsMCkgICgtMTYsMzgpICAoLTI4LDQ2KSAgKDAsMCkgCigwLDApICAoMjIsLTM0KSAgKC0yOCw0NikgICgwLDApIAooMCwwKSAgKDIyLC0zNCkgICgwLDApICAoLTI4LDQ2KSAKKDAsMCkgICgtMTYsMzgpICAoMCwwKSAgKDI4LC00NikgCigwLDApICAoLTE2LDM4KSAgKDI4LC00NikgICgwLDApIAooMCwwKSAgKDYsNCkgICgwLDApICAoMCwwKSAKKDAsMCkgICgyMiwtMzQpICAoMjgsLTQ2KSAgKDAsMCkgCigwLDApICAoMjIsLTM0KSAgKDAsMCkgICgyOCwtNDYpIAoKCgowCgoKCjQKNCAwIDEgMiAzCjQgNyA4IDQgNQo0IDQgOCAyIDEKNCA1IDAgMyA3CgoKCjUKIDQgNSA2IDAgMQoKdGlwIDYK";
  var yellowUrl$2 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCiBzY2FsZSAgKDEsLTEpIAoKMTMKKDAsMCkgICgtNy8zLDE3LzMpICAoLTEvMyw1LzMpICAoLTQvMywxMS8zKSAKKDAsMCkgICgtMyw2KSAgKC0xLDIpICAoLTMsNikgCigwLDApICAoLTMsNikgICgtMyw2KSAgKC0xLDIpIAooMCwwKSAgKDMsMikgICgzLDIpICAoMywyKSAKKDAsMCkgICgxMy8zLC01LzMpICAoMTAvMywxLzMpICAoMTYvMywtMTEvMykgCigwLDApICAoNCwwKSAgKDYsLTQpICAoNiwtNCkgCigwLDApICAoMTAvMywxLzMpICAoMTYvMywtMTEvMykgICgxMy8zLC01LzMpIAooMCwwKSAgKDYsLTQpICAoNCwwKSAgKDYsLTQpIAooMCwwKSAgKC0xLzMsNS8zKSAgKC00LzMsMTEvMykgICgtNy8zLDE3LzMpIAooMCwwKSAgKDE2LzMsLTExLzMpICAoMTMvMywtNS8zKSAgKDEwLzMsMS8zKSAKKDAsMCkgICg2LC00KSAgKDYsLTQpICAoNCwwKSAKKDAsMCkgICgtNC8zLDExLzMpICAoLTcvMywxNy8zKSAgKC0xLzMsNS8zKSAKKDAsMCkgICgtMSwyKSAgKC0zLDYpICAoLTMsNikgCgoKCjAKCgoKMTUKMyAwIDEgMgozIDQgNSA2CjMgMSAwIDgKMyA3IDQgOQo0IDggMCA2IDkKMyAxMCA2IDUKMyAxMSAyIDEyCjQgNiAwIDExIDQKMyAxMCA3IDkKMyAwIDIgMTEKMyAxIDggMTIKMyA4IDExIDEyCjMgNyA1IDQKMyAxMCA5IDYKNCA5IDQgMTEgOAoKCgo3CiAzIDcgNCA5IDEwIDYgNQoKdGlwIDMK";
  var purpleUrl$1 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCiBzY2FsZSAgKDEsLTEpIAoKMTcKKDAsMCkgICgtMjgsNDYpICAoMSwxKSAgKDE5LC0zNikgCigwLDApICAoMCwwKSAgKDQsLTUpICAoLTEsLTEpIAooMCwwKSAgKC00LDYpICAoMCwxKSAgKC0xLC0xKSAKKDAsMCkgICgyOCwtNDYpICAoMCwwKSAgKC0yMiwzNCkgCigwLDApICAoMCwwKSAgKC0yOCw0NikgICgtMjIsMzQpIAooMCwwKSAgKDAsMCkgICgxLDEpICAoLTMsLTIpIAooMCwwKSAgKDI4LC00NikgICgxLDEpICAoMTksLTM2KSAKKDAsMCkgICg0LC02KSAgKDEsMCkgICgtMiwtMSkgCigwLDApICAoNCwtNikgICgwLDEpICAoLTEsLTEpIAooMCwwKSAgKDAsMCkgICgtNCw3KSAgKC0xLC0xKSAKKDAsMCkgICgwLDApICAoLTMsNikgICgtMiwtMSkgCigwLDApICAoMCwwKSAgKDI5LC00NSkgICgxOSwtMzYpIAooMCwwKSAgKC00LDYpICAoMSwwKSAgKC0yLC0xKSAKKDAsMCkgICgtMjgsNDYpICAoMCwwKSAgKC0yMiwzNCkgCigwLDApICAoMCwwKSAgKDI4LC00NikgICgtMjIsMzQpIAooMCwwKSAgKDAsMCkgICgtMjcsNDcpICAoMTksLTM2KSAKKDAsMCkgICgwLDApICAoNSwtNikgICgtMiwtMSkgCgoKCjAKCgoKMTIKNCAxIDIgMyA0CjQgNyA4IDkgMTAKNCA2IDExIDEwIDEyCjQgOCAxIDQgMTMKNCAyIDkgMTQgMwo0IDcgMTAgMTEgMAo0IDggNyAxNiAxCjQgMTYgMTIgMiAxCjQgMTUgMTYgNyAwCjQgMTUgNiAxMiAxNgo0IDggMTMgMTQgOQo0IDIgMTIgMTAgOQoKCgo5CiAwIDUgNiAxMiAxMSAxNSAxNiAxMCA3Cgp0aXAgNQo=";
  var redUrl$2 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCiBzY2FsZSAgKDEsLTEpIAoKMTcKKDAsMCkgICgtMjcsMzUpICAoLTIzLDQyKSAgKDAsMCkgCigwLDApICAoLTIsLTUpICAoMiwyKSAgKDEsLTIpIAooMCwwKSAgKC0zLDIpICAoMSwwKSAgKDEsLTIpIAooMCwwKSAgKC0yOCw0MikgICgtMjQsNDApICAoMCwwKSAKKDAsMCkgICgtOCwzKSAgKDYsLTQpICAoLTEsMikgCigwLDApICAoLTIsLTUpICAoMiwyKSAgKC0xLDIpIAooMCwwKSAgKDIzLC00NSkgICgyNywtMzgpICAoMCwwKSAKKDAsMCkgICgxNywtMzcpICAoMzEsLTQ0KSAgKDAsMCkgCigwLDApICAoLTMsMikgICgxLDApICAoLTEsMikgCigwLDApICAoMjIsLTM4KSAgKDI2LC00MCkgICgwLDApIAooMCwwKSAgKC04LDMpICAoNiwtNCkgICgxLC0yKSAKKDAsMCkgICgzLC02KSAgKC0zLDYpICAoMSwtMikgCigwLDApICAoLTIyLDM0KSAgKC0yOCw0NikgICgwLDApIAooMCwwKSAgKC0zMyw0MykgICgtMTksMzYpICAoMCwwKSAKKDAsMCkgICgzLC02KSAgKC0zLDYpICAoLTEsMikgCigwLDApICAoMjgsLTQ2KSAgKDIyLC0zNCkgICgwLDApIAooMCwwKSAgKC01LC0zKSAgKDMsMikgICgwLDApIAoKCgowCgoKCjEyCjQgMCAxIDIgMwo0IDQgNSA2IDcKNCA4IDkgNiA1CjQgMyAyIDExIDEyCjQgMTMgMTAgMSAwCjQgNCAxMyAwIDUKNCAzIDggNSAwCjQgMSA2IDkgMgo0IDggMTQgMTUgOQo0IDEwIDcgNiAxCjQgMyAxMiAxNCA4CjQgMiA5IDE1IDExCgoKCjkKIDEwIDAgMTMgNiA3IDQgMTYgNSAxCgp0aXAgMTYK";
  var brownUrl$1 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCiBzY2FsZSAgKDEsLTEpIAoKMTcKKDAsMCkgICgtMyw0KSAgKDUsLTYpICAoLTEsMCkgCigwLDApICAoMCwwKSAgKDIyLC0zNCkgICgyOCwtNDYpIAooMCwwKSAgKDEsLTIpICAoLTMsNikgICgzLC02KSAKKDAsMCkgICgxLC01KSAgKDEsNCkgICgtMSwtMSkgCigwLDApICAoMSwtNSkgICgtMSw4KSAgKC0xLC0xKSAKKDAsMCkgICgtMiwtMSkgICgtMTgsMzYpICAoLTMwLDQ1KSAKKDAsMCkgICgtMyw0KSAgKDMsLTIpICAoLTEsMCkgCigwLDApICAoLTEsLTEpICAoMSw0KSAgKDEsLTUpIAooMCwwKSAgKC0xLDApICAoNSwtNikgICgtMyw0KSAKKDAsMCkgICgtMSwtMSkgICgtMSw4KSAgKDEsLTUpIAooMCwwKSAgKC0yLC0xKSAgKDQsMikgICgtMiwtMSkgCigwLDApICAoLTMwLDQ1KSAgKC0xOCwzNikgICgtMiwtMSkgCigwLDApICAoLTEsMCkgICgzLC0yKSAgKC0zLDQpIAooMCwwKSAgKC01LDUpICAoNywtNCkgICgtMywxKSAKKDAsMCkgICgtMywxKSAgKDcsLTQpICAoLTUsNSkgCigwLDApICAoMjgsLTQ2KSAgKDIyLC0zNCkgICgwLDApIAooMCwwKSAgKDMsLTYpICAoLTMsNikgICgxLC0yKSAKCgoKMAoKCgoxNgozIDAgMSAyCjMgMyA0IDUKMyAwIDYgMQo0IDcgMCA4IDMKNCA5IDYgMCA3CjMgMTEgOSA3CjQgNCAzIDggMTIKNCAzIDUgMTEgNwozIDUgNCAxNAo0IDEyIDE1IDEgNgozIDExIDEzIDkKMyAxNSAxMiA4CjMgMTYgMTUgOAo0IDkgMTMgMTQgNAo0IDQgMTIgNiA5CjQgOCAwIDIgMTYKCgoKOQogMTAgMTEgNyAxMyAzIDQgOSAxNCA1Cgp0aXAgMTAK";
  var greenUrl$2 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCiBzY2FsZSAgKDEsLTEpIAoKOQooMCwwKSAgKDIyLC0zNCkgICgwLDApICAoLTI4LDQ2KSAKKDAsMCkgICgtMyw2KSAgKC0xLDIpICAoLTMsNikgCigwLDApICAoOSwtMikgICgtMSwyKSAgKDksLTIpIAooMCwwKSAgKDM0LC00MikgICgwLDApICAoLTE2LDM4KSAKKDAsMCkgICg2LDQpICAoMCwwKSAgKDYsNCkgCigwLDApICAoOSwtMikgICgxLC0yKSAgKDksLTIpIAooMCwwKSAgKC0yOCw0NikgICgwLDApICAoMjIsLTM0KSAKKDAsMCkgICgtMyw2KSAgKDEsLTIpICAoLTMsNikgCigwLDApICAoLTE2LDM4KSAgKDAsMCkgICgzNCwtNDIpIAoKCgowCgoKCjQKNCAwIDEgMiAzCjQgNiA3IDUgOAo0IDMgNSA3IDAKNCA4IDIgMSA2CgoKCjUKIDQgNSAzIDggMgoKdGlwIDQK";
  var oliveUrl$1 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCiBzY2FsZSAgKDEsLTEpIAoKMTcKKDAsMCkgICgzLDApICAoMywwKSAgKC0yLDQpIAooMCwwKSAgKDI4LC00MCkgICgtMjIsNDApICAoLTMsNikgCigwLDApICAoMjUsLTM4KSAgKC0yNSw0MikgICg0LC02KSAKKDAsMCkgICgwLDIpICAoMCwyKSAgKDUsLTgpIAooMCwwKSAgKDAsMikgICgwLDIpICAoMywtNCkgCigwLDApICAoLTI1LDQyKSAgKDI1LC0zOCkgICg0LC02KSAKKDAsMCkgICgtMjgsNDYpICAoMjIsLTM0KSAgKDAsMCkgCigwLDApICAoLTMsNikgICgtMyw2KSAgKC0xLDIpIAooMCwwKSAgKC0yMiw0MCkgICgyOCwtNDApICAoLTMsNikgCigwLDApICAoMywwKSAgKDMsMCkgICgtNCw4KSAKKDAsMCkgICg2LC00KSAgKDYsLTQpICAoMCwyKSAKKDAsMCkgICgtMTksMzYpICAoMzEsLTQ0KSAgKDEsMCkgCigwLDApICAoMywyKSAgKDMsMikgICgxLDApIAooMCwwKSAgKDYsLTQpICAoNiwtNCkgICgyLC0yKSAKKDAsMCkgICgzMSwtNDQpICAoLTE5LDM2KSAgKDEsMCkgCigwLDApICAoLTMsNikgICgtMyw2KSAgKDEsLTIpIAooMCwwKSAgKDIyLC0zNCkgICgtMjgsNDYpICAoMCwwKSAKCgoKMAoKCgoxMgo0IDAgMSAyIDMKNCA0IDUgNiA3CjQgOCA5IDEwIDExCjQgOCAwIDMgNQo0IDEzIDE0IDEgMAo0IDggNSA0IDkKNCAxNSAzIDIgMTYKNCAxMSAxMyAwIDgKNCA5IDQgMiAxCjQgNiA1IDMgMTUKNCA5IDEgMTQgMTAKNCAxNiAyIDQgNwoKCgo5CiAxMiAxMCAxMSAxNCA5IDAgMSA4IDEzCgp0aXAgMTIK";
  var lavenderUrl$1 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCiBzY2FsZSAgKDEsLTEpIAoKMTgKKDAsMCkgICgxNywtMjcpICAoMSwxKSAgKC0xMSwxOSkgCigwLDApICAoLTExLDE5KSAgKDEsMSkgICgxNywtMjcpIAooMCwwKSAgKC0xMiwyMikgICg0LDIpICAoMTYsLTI0KSAKKDAsMCkgICgxNiwtMjQpICAoNCwyKSAgKC0xMiwyMikgCigwLDApICAoLTEsMikgICgtMyw2KSAgKC0zLDYpIAooMCwwKSAgKC0zLDYpICAoLTMsNikgICgtMSwyKSAKKDAsMCkgICgtMjgsNDYpICAoMjIsLTM0KSAgKDAsMCkgCigwLDApICAoLTE1LDI1KSAgKDEsMSkgICgxMywtMjEpIAooMCwwKSAgKC0xNiwyOCkgICg0LDIpICAoMTIsLTE4KSAKKDAsMCkgICgxLDEpICAoLTE3LDM3KSAgKDI5LC00NSkgCigwLDApICAoMTIsLTE4KSAgKDQsMikgICgtMTYsMjgpIAooMCwwKSAgKDQsLTUpICAoOCwtMykgICgyLC0xKSAKKDAsMCkgICgyLC0xKSAgKDgsLTMpICAoNCwtNSkgCigwLDApICAoMSwxKSAgKDUsMykgICgxLDEpIAooMCwwKSAgKDI5LC00NSkgICgtMTcsMzcpICAoMSwxKSAKKDAsMCkgICgwLDApICAoMjIsLTM0KSAgKC0yOCw0NikgCigwLDApICAoMTMsLTIxKSAgKDEsMSkgICgtMTUsMjUpIAooMCwwKSAgKDAsMCkgICgwLDApICAoMCwwKSAKCgoKMAoKCjEyCjQgMCAxIDIgMwo0IDQgNSAxIDAKNiAxIDYgNyA4IDkgMgo0IDExIDEyIDggMTAKNCAzIDIgOSAxNAo0IDE1IDE2IDcgNgozIDQgMCAxNQozIDE0IDExIDEwCjMgMTIgOSA4CjYgMTUgMCAzIDE0IDEwIDE2CjQgNyAxNiAxMCA4CjMgNSA2IDEKCgoKOQogMTAgMTMgMTEgOCAxMiAzIDkgMiAxNAoKdGlwIDEzCg=="; // These imports work because we are using @rollup/plugin-url.

  var shapes$3 = {
    connector: connectorUrl$3,
    maroon: maroonUrl$1,
    blue: blueUrl$2,
    yellow: yellowUrl$2,
    purple: purpleUrl$1,
    red: redUrl$2,
    brown: brownUrl$1,
    green: greenUrl$2,
    olive: oliveUrl$1,
    lavender: lavenderUrl$1
  };
  var connectorUrl$4 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCiBzY2FsZSAgKDEsLTEpIAoKNgooMCwwKSAgKDAsMCkgICgtNCw2KSAgKDAsMCkgCigwLDApICAoLTQsNikgICgwLDApICAoMCwwKSAKKDAsMCkgICgwLDApICAoMCwwKSAgKC00LDYpIAooMCwwKSAgKDQsLTYpICAoMCwwKSAgKDAsMCkgCigwLDApICAoMCwwKSAgKDQsLTYpICAoMCwwKSAKKDAsMCkgICgwLDApICAoMCwwKSAgKDQsLTYpIAoKCgowCgoKCjgKMyAwIDEgMgozIDMgMCAyCjMgNCAxIDUKMyAzIDQgNQozIDMgNSAwCjMgNSAxIDAKMyAyIDEgNAozIDMgMiA0CgoKCjAKCgo=";
  var blueUrl$3 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCiBzY2FsZSAgKDEsLTEpIAoKMTEKKDAsMCkgICgwLDEyKSAgKDAsMCkgICg0LC02KSAKKDAsMCkgICgwLDEyKSAgKDQsLTYpICAoMCwwKSAKKDAsMCkgICg2LC04KSAgKDQsLTYpICAoMCwwKSAKKDAsMCkgICg2LC04KSAgKDAsMCkgICg0LC02KSAKKDAsMCkgICgyLDEwKSAgKDAsMCkgICgwLDApIAooMCwwKSAgKDAsMTIpICAoMCwwKSAgKC00LDYpIAooMCwwKSAgKDAsMTIpICAoLTQsNikgICgwLDApIAooMCwwKSAgKDYsLTgpICAoLTQsNikgICgwLDApIAooMCwwKSAgKDQsLTYpICAoMCwwKSAgKDAsMCkgCigwLDApICAoNiwtOCkgICgwLDApICAoLTQsNikgCigwLDApICAoNiw0KSAgKDAsMCkgICgwLDApIAoKCgowCgoKCjEyCjQgMCAxIDIgMwozIDQgMSAwCjMgNyA4IDkKMyA3IDMgOAozIDMgMiA4CjQgNiAwIDMgNwo0IDUgNiA3IDkKMyA4IDIgOQozIDYgNCAwCjQgMSA1IDkgMgozIDUgMSA0CjMgNiA1IDQKCgoKNgogNCA1IDYgMCAxIDEwCgp0aXAgMTAK";
  var yellowUrl$3 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCgo5CigwLDApICAoLTEsLTEpICAoMSwxKSAgKC0xLC0xKSAKKDAsMCkgICgxLC0yKSAgKDksLTE0KSAgKC0xOSwzMCkgCigwLDApICAoMywtNSkgICgtMyw1KSAgKDMsLTUpIAooMCwwKSAgKC0xOSwzMCkgICgtMSwyKSAgKC05LDE0KSAKKDAsMCkgICg4LC0xNSkgICgyLC0xKSAgKDE4LC0zMSkgCigwLDApICAoLTIsMSkgICgtMTgsMzEpICAoOCwtMTUpIAooMCwwKSAgKC05LDE0KSAgKDE5LC0zMCkgICgxLC0yKSAKKDAsMCkgICgtNCw0KSAgKDQsLTQpICAoLTQsNCkgCigwLDApICAoMTgsLTMxKSAgKC04LDE1KSAgKC0yLDEpIAoKCgowCgoKCjkKMyAxIDIgMwo0IDQgNSAzIDYKMyAyIDEgNgozIDcgNSA0CjQgNSA4IDEgMwozIDIgNiAzCjQgNiAxIDggNAozIDcgNCA4CjMgNyA4IDUKCgoKNQogMCA4IDQgNSA3Cgp0aXAgMAo=";
  var greenUrl$3 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCiBzY2FsZSAgKDEsLTEpIAoKMTIKKDAsMCkgICg2LDQpICAoMCwwKSAgKDYsNCkgCigwLDApICAoNCw2KSAgKDAsMCkgICg4LDApIAooMCwwKSAgKDgsMCkgICgtNCw2KSAgKDgsMCkgCigwLDApICAoOCwxKSAgKDAsMCkgICg4LDEpIAooMCwwKSAgKDgsMCkgICgwLDApICAoOCwwKSAKKDAsMCkgICg4LDApICAoMCwwKSAgKDQsNikgCigwLDApICAoNCwtNSkgICgwLDApICAoMCwxKSAKKDAsMCkgICgwLDEpICAoLTQsNikgICgwLDEpIAooMCwwKSAgKDIsLTMpICAoMCwwKSAgKDIsLTMpIAooMCwwKSAgKDAsMSkgICg0LC02KSAgKDAsMSkgCigwLDApICAoOCwwKSAgKDQsLTYpICAoOCwwKSAKKDAsMCkgICgwLDEpICAoMCwwKSAgKDQsLTUpIAoKCgo2CjAgNAo0IDUKNCAyCjMgMAo0IDEwCjQgMQoKCgoxMgozIDAgMSAyCjMgMCAyIDUKNCA2IDUgMiA3CjMgNiA4IDkKNCAxMCA5IDExIDEKMyA4IDcgMTEKNCAyIDEgMTEgNwozIDAgMTAgMQozIDggNiA3CjMgOCAxMSA5CjQgNiA5IDEwIDUKMyAxMCAwIDUKCgoKNwogMyAyIDQgMSAxMCA1IDAKCnRpcCAzCg=="; // These imports work because we are using @rollup/plugin-url.

  var shapes$4 = {
    connector: connectorUrl$4,
    blue: blueUrl$3,
    yellow: yellowUrl$3,
    green: greenUrl$3
  };
  var connectorUrl$5 = "data:null;base64,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";
  var maroonUrl$2 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCiBzY2FsZSAgKDEsLTEpIAoKMTcKKDAsMCkgICgzMy8yLC0yNCkgICgzLzIsNSkgICgyMy8yLC0yMikgCigwLDApICAoNSwtNSkgICg3LC0zKSAgKC0zLDEpIAooMCwwKSAgKDMwLC00NSkgICgtMTgsMzcpICAoLTIsLTEpIAooMCwwKSAgKDI5LzIsLTIzKSAgKDMvMiwwKSAgKDI3LzIsLTIzKSAKKDAsMCkgICgzMS8yLC0yMikgICg1LzIsMykgICgyNS8yLC0yNCkgCigwLDApICAoMjcvMiwtMjEpICAoNS8yLC0yKSAgKDI5LzIsLTI1KSAKKDAsMCkgICgzLC0xKSAgKDcsLTMpICAoLTUsNSkgCigwLDApICAoLTI3LzIsMjMpICAoMy8yLDApICAoLTI5LzIsMjMpIAooMCwwKSAgKC0yOCw0NikgICgyMiwtMzQpICAoMCwwKSAKKDAsMCkgICgtMjkvMiwyNSkgICg1LzIsLTIpICAoLTI3LzIsMjEpIAooMCwwKSAgKDAsMCkgICgyMiwtMzQpICAoMjgsLTQ2KSAKKDAsMCkgICgyLDEpICAoLTE4LDM3KSAgKC0zMCw0NSkgCigwLDApICAoLTIzLzIsMjIpICAoMy8yLDUpICAoLTMzLzIsMjQpIAooMCwwKSAgKC0yNS8yLDI0KSAgKDUvMiwzKSAgKC0zMS8yLDIyKSAKKDAsMCkgICgyLDEpICAoNCwzKSAgKC0yLC0xKSAKKDAsMCkgICgtMyw2KSAgKC0zLDYpICAoMSwtMikgCigwLDApICAoLTEsMikgICgtMyw2KSAgKDMsLTYpIAoKCgowCgoKCjE2CjMgMCAxIDIKNCAzIDAgNCA1CjMgNyA4IDkKNCAxMCA4IDcgMwozIDExIDEyIDEzCjQgNCAxMyA5IDUKNCAzIDcgMTIgMAo0IDEyIDcgOSAxMwo0IDUgOSAxNSAxNgozIDExIDYgMTIKMyAwIDIgNAo0IDIgMTEgMTMgNAozIDEwIDMgNQozIDggMTUgOQozIDEwIDUgMTYKNCAwIDEyIDYgMQoKCgo5CiAwIDYgMTEgMTMgMTQgMiAxMiAxIDQKCnRpcCAxNAo=";
  var blueUrl$4 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCiBzY2FsZSAgKDEsLTEpIAoKOQooMCwwKSAgKC0xNiwzOCkgICgwLDApICAoLTI4LDQ2KSAKKDAsMCkgICgtMTYsMzgpICAoLTI4LDQ2KSAgKDAsMCkgCigwLDApICAoMjIsLTM0KSAgKC0yOCw0NikgICgwLDApIAooMCwwKSAgKDIyLC0zNCkgICgwLDApICAoLTI4LDQ2KSAKKDAsMCkgICgtMTYsMzgpICAoMCwwKSAgKDI4LC00NikgCigwLDApICAoLTE2LDM4KSAgKDI4LC00NikgICgwLDApIAooMCwwKSAgKDYsNCkgICgwLDApICAoMCwwKSAKKDAsMCkgICgyMiwtMzQpICAoMjgsLTQ2KSAgKDAsMCkgCigwLDApICAoMjIsLTM0KSAgKDAsMCkgICgyOCwtNDYpIAoKCgowCgoKCjQKNCAwIDEgMiAzCjQgNyA4IDQgNQo0IDQgOCAyIDEKNCA1IDAgMyA3CgoKCjUKIDQgNSA2IDAgMQoKdGlwIDYK";
  var yellowUrl$4 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCiBzY2FsZSAgKDEsLTEpIAoKMTMKKDAsMCkgICgtNy8zLDE3LzMpICAoLTEvMyw1LzMpICAoLTQvMywxMS8zKSAKKDAsMCkgICgtMyw2KSAgKC0xLDIpICAoLTMsNikgCigwLDApICAoLTMsNikgICgtMyw2KSAgKC0xLDIpIAooMCwwKSAgKDMsMikgICgzLDIpICAoMywyKSAKKDAsMCkgICgxMy8zLC01LzMpICAoMTAvMywxLzMpICAoMTYvMywtMTEvMykgCigwLDApICAoNCwwKSAgKDYsLTQpICAoNiwtNCkgCigwLDApICAoMTAvMywxLzMpICAoMTYvMywtMTEvMykgICgxMy8zLC01LzMpIAooMCwwKSAgKDYsLTQpICAoNCwwKSAgKDYsLTQpIAooMCwwKSAgKC0xLzMsNS8zKSAgKC00LzMsMTEvMykgICgtNy8zLDE3LzMpIAooMCwwKSAgKDE2LzMsLTExLzMpICAoMTMvMywtNS8zKSAgKDEwLzMsMS8zKSAKKDAsMCkgICg2LC00KSAgKDYsLTQpICAoNCwwKSAKKDAsMCkgICgtNC8zLDExLzMpICAoLTcvMywxNy8zKSAgKC0xLzMsNS8zKSAKKDAsMCkgICgtMSwyKSAgKC0zLDYpICAoLTMsNikgCgoKCjAKCgoKMTUKMyAwIDEgMgozIDQgNSA2CjMgMSAwIDgKMyA3IDQgOQo0IDggMCA2IDkKMyAxMCA2IDUKMyAxMSAyIDEyCjQgNiAwIDExIDQKMyAxMCA3IDkKMyAwIDIgMTEKMyAxIDggMTIKMyA4IDExIDEyCjMgNyA1IDQKMyAxMCA5IDYKNCA5IDQgMTEgOAoKCgo3CiAzIDcgNCA5IDEwIDYgNQoKdGlwIDMK";
  var purpleUrl$2 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCiBzY2FsZSAgKDEsLTEpIAoKMTcKKDAsMCkgICgtMjgsNDYpICAoMSwxKSAgKDE5LC0zNikgCigwLDApICAoMCwwKSAgKDQsLTUpICAoLTEsLTEpIAooMCwwKSAgKC00LDYpICAoMCwxKSAgKC0xLC0xKSAKKDAsMCkgICgyOCwtNDYpICAoMCwwKSAgKC0yMiwzNCkgCigwLDApICAoMCwwKSAgKC0yOCw0NikgICgtMjIsMzQpIAooMCwwKSAgKDAsMCkgICgxLDEpICAoLTMsLTIpIAooMCwwKSAgKDI4LC00NikgICgxLDEpICAoMTksLTM2KSAKKDAsMCkgICg0LC02KSAgKDEsMCkgICgtMiwtMSkgCigwLDApICAoNCwtNikgICgwLDEpICAoLTEsLTEpIAooMCwwKSAgKDAsMCkgICgtNCw3KSAgKC0xLC0xKSAKKDAsMCkgICgwLDApICAoLTMsNikgICgtMiwtMSkgCigwLDApICAoMCwwKSAgKDI5LC00NSkgICgxOSwtMzYpIAooMCwwKSAgKC00LDYpICAoMSwwKSAgKC0yLC0xKSAKKDAsMCkgICgtMjgsNDYpICAoMCwwKSAgKC0yMiwzNCkgCigwLDApICAoMCwwKSAgKDI4LC00NikgICgtMjIsMzQpIAooMCwwKSAgKDAsMCkgICgtMjcsNDcpICAoMTksLTM2KSAKKDAsMCkgICgwLDApICAoNSwtNikgICgtMiwtMSkgCgoKCjAKCgoKMTIKNCAxIDIgMyA0CjQgNyA4IDkgMTAKNCA2IDExIDEwIDEyCjQgOCAxIDQgMTMKNCAyIDkgMTQgMwo0IDcgMTAgMTEgMAo0IDggNyAxNiAxCjQgMTYgMTIgMiAxCjQgMTUgMTYgNyAwCjQgMTUgNiAxMiAxNgo0IDggMTMgMTQgOQo0IDIgMTIgMTAgOQoKCgo5CiAwIDUgNiAxMiAxMSAxNSAxNiAxMCA3Cgp0aXAgNQo=";
  var redUrl$3 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCiBzY2FsZSAgKDEsLTEpIAoKMTcKKDAsMCkgICgtMjcsMzUpICAoLTIzLDQyKSAgKDAsMCkgCigwLDApICAoLTIsLTUpICAoMiwyKSAgKDEsLTIpIAooMCwwKSAgKC0zLDIpICAoMSwwKSAgKDEsLTIpIAooMCwwKSAgKC0yOCw0MikgICgtMjQsNDApICAoMCwwKSAKKDAsMCkgICgtOCwzKSAgKDYsLTQpICAoLTEsMikgCigwLDApICAoLTIsLTUpICAoMiwyKSAgKC0xLDIpIAooMCwwKSAgKDIzLC00NSkgICgyNywtMzgpICAoMCwwKSAKKDAsMCkgICgxNywtMzcpICAoMzEsLTQ0KSAgKDAsMCkgCigwLDApICAoLTMsMikgICgxLDApICAoLTEsMikgCigwLDApICAoMjIsLTM4KSAgKDI2LC00MCkgICgwLDApIAooMCwwKSAgKC04LDMpICAoNiwtNCkgICgxLC0yKSAKKDAsMCkgICgzLC02KSAgKC0zLDYpICAoMSwtMikgCigwLDApICAoLTIyLDM0KSAgKC0yOCw0NikgICgwLDApIAooMCwwKSAgKC0zMyw0MykgICgtMTksMzYpICAoMCwwKSAKKDAsMCkgICgzLC02KSAgKC0zLDYpICAoLTEsMikgCigwLDApICAoMjgsLTQ2KSAgKDIyLC0zNCkgICgwLDApIAooMCwwKSAgKC01LC0zKSAgKDMsMikgICgwLDApIAoKCgowCgoKCjEyCjQgMCAxIDIgMwo0IDQgNSA2IDcKNCA4IDkgNiA1CjQgMyAyIDExIDEyCjQgMTMgMTAgMSAwCjQgNCAxMyAwIDUKNCAzIDggNSAwCjQgMSA2IDkgMgo0IDggMTQgMTUgOQo0IDEwIDcgNiAxCjQgMyAxMiAxNCA4CjQgMiA5IDE1IDExCgoKCjkKIDEwIDAgMTMgNiA3IDQgMTYgNSAxCgp0aXAgMTYK";
  var brownUrl$2 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCiBzY2FsZSAgKDEsLTEpIAoKMTcKKDAsMCkgICgtMyw0KSAgKDUsLTYpICAoLTEsMCkgCigwLDApICAoMCwwKSAgKDIyLC0zNCkgICgyOCwtNDYpIAooMCwwKSAgKDEsLTIpICAoLTMsNikgICgzLC02KSAKKDAsMCkgICgxLC01KSAgKDEsNCkgICgtMSwtMSkgCigwLDApICAoMSwtNSkgICgtMSw4KSAgKC0xLC0xKSAKKDAsMCkgICgtMiwtMSkgICgtMTgsMzYpICAoLTMwLDQ1KSAKKDAsMCkgICgtMyw0KSAgKDMsLTIpICAoLTEsMCkgCigwLDApICAoLTEsLTEpICAoMSw0KSAgKDEsLTUpIAooMCwwKSAgKC0xLDApICAoNSwtNikgICgtMyw0KSAKKDAsMCkgICgtMSwtMSkgICgtMSw4KSAgKDEsLTUpIAooMCwwKSAgKC0yLC0xKSAgKDQsMikgICgtMiwtMSkgCigwLDApICAoLTMwLDQ1KSAgKC0xOCwzNikgICgtMiwtMSkgCigwLDApICAoLTEsMCkgICgzLC0yKSAgKC0zLDQpIAooMCwwKSAgKC01LDUpICAoNywtNCkgICgtMywxKSAKKDAsMCkgICgtMywxKSAgKDcsLTQpICAoLTUsNSkgCigwLDApICAoMjgsLTQ2KSAgKDIyLC0zNCkgICgwLDApIAooMCwwKSAgKDMsLTYpICAoLTMsNikgICgxLC0yKSAKCgoKMAoKCgoxNgozIDAgMSAyCjMgMyA0IDUKMyAwIDYgMQo0IDcgMCA4IDMKNCA5IDYgMCA3CjMgMTEgOSA3CjQgNCAzIDggMTIKNCAzIDUgMTEgNwozIDUgNCAxNAo0IDEyIDE1IDEgNgozIDExIDEzIDkKMyAxNSAxMiA4CjMgMTYgMTUgOAo0IDkgMTMgMTQgNAo0IDQgMTIgNiA5CjQgOCAwIDIgMTYKCgoKOQogMTAgMTEgNyAxMyAzIDQgOSAxNCA1Cgp0aXAgMTAK";
  var greenUrl$4 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCiBzY2FsZSAgKDEsLTEpIAoKOQooMCwwKSAgKDIyLC0zNCkgICgwLDApICAoLTI4LDQ2KSAKKDAsMCkgICgtMyw2KSAgKC0xLDIpICAoLTMsNikgCigwLDApICAoOSwtMikgICgtMSwyKSAgKDksLTIpIAooMCwwKSAgKDM0LC00MikgICgwLDApICAoLTE2LDM4KSAKKDAsMCkgICg2LDQpICAoMCwwKSAgKDYsNCkgCigwLDApICAoOSwtMikgICgxLC0yKSAgKDksLTIpIAooMCwwKSAgKC0yOCw0NikgICgwLDApICAoMjIsLTM0KSAKKDAsMCkgICgtMyw2KSAgKDEsLTIpICAoLTMsNikgCigwLDApICAoLTE2LDM4KSAgKDAsMCkgICgzNCwtNDIpIAoKCgowCgoKCjQKNCAwIDEgMiAzCjQgNiA3IDUgOAo0IDMgNSA3IDAKNCA4IDIgMSA2CgoKCjUKIDQgNSAzIDggMgoKdGlwIDQK";
  var oliveUrl$2 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCiBzY2FsZSAgKDEsLTEpIAoKMTcKKDAsMCkgICgzLDApICAoMywwKSAgKC0yLDQpIAooMCwwKSAgKDI4LC00MCkgICgtMjIsNDApICAoLTMsNikgCigwLDApICAoMjUsLTM4KSAgKC0yNSw0MikgICg0LC02KSAKKDAsMCkgICgwLDIpICAoMCwyKSAgKDUsLTgpIAooMCwwKSAgKDAsMikgICgwLDIpICAoMywtNCkgCigwLDApICAoLTI1LDQyKSAgKDI1LC0zOCkgICg0LC02KSAKKDAsMCkgICgtMjgsNDYpICAoMjIsLTM0KSAgKDAsMCkgCigwLDApICAoLTMsNikgICgtMyw2KSAgKC0xLDIpIAooMCwwKSAgKC0yMiw0MCkgICgyOCwtNDApICAoLTMsNikgCigwLDApICAoMywwKSAgKDMsMCkgICgtNCw4KSAKKDAsMCkgICg2LC00KSAgKDYsLTQpICAoMCwyKSAKKDAsMCkgICgtMTksMzYpICAoMzEsLTQ0KSAgKDEsMCkgCigwLDApICAoMywyKSAgKDMsMikgICgxLDApIAooMCwwKSAgKDYsLTQpICAoNiwtNCkgICgyLC0yKSAKKDAsMCkgICgzMSwtNDQpICAoLTE5LDM2KSAgKDEsMCkgCigwLDApICAoLTMsNikgICgtMyw2KSAgKDEsLTIpIAooMCwwKSAgKDIyLC0zNCkgICgtMjgsNDYpICAoMCwwKSAKCgoKMAoKCgoxMgo0IDAgMSAyIDMKNCA0IDUgNiA3CjQgOCA5IDEwIDExCjQgOCAwIDMgNQo0IDEzIDE0IDEgMAo0IDggNSA0IDkKNCAxNSAzIDIgMTYKNCAxMSAxMyAwIDgKNCA5IDQgMiAxCjQgNiA1IDMgMTUKNCA5IDEgMTQgMTAKNCAxNiAyIDQgNwoKCgo5CiAxMiAxMCAxMSAxNCA5IDAgMSA4IDEzCgp0aXAgMTIK";
  var lavenderUrl$2 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCiBzY2FsZSAgKDEsLTEpIAoKMTgKKDAsMCkgICgxNywtMjcpICAoMSwxKSAgKC0xMSwxOSkgCigwLDApICAoLTExLDE5KSAgKDEsMSkgICgxNywtMjcpIAooMCwwKSAgKC0xMiwyMikgICg0LDIpICAoMTYsLTI0KSAKKDAsMCkgICgxNiwtMjQpICAoNCwyKSAgKC0xMiwyMikgCigwLDApICAoLTEsMikgICgtMyw2KSAgKC0zLDYpIAooMCwwKSAgKC0zLDYpICAoLTMsNikgICgtMSwyKSAKKDAsMCkgICgtMjgsNDYpICAoMjIsLTM0KSAgKDAsMCkgCigwLDApICAoLTE1LDI1KSAgKDEsMSkgICgxMywtMjEpIAooMCwwKSAgKC0xNiwyOCkgICg0LDIpICAoMTIsLTE4KSAKKDAsMCkgICgxLDEpICAoLTE3LDM3KSAgKDI5LC00NSkgCigwLDApICAoMTIsLTE4KSAgKDQsMikgICgtMTYsMjgpIAooMCwwKSAgKDQsLTUpICAoOCwtMykgICgyLC0xKSAKKDAsMCkgICgyLC0xKSAgKDgsLTMpICAoNCwtNSkgCigwLDApICAoMSwxKSAgKDUsMykgICgxLDEpIAooMCwwKSAgKDI5LC00NSkgICgtMTcsMzcpICAoMSwxKSAKKDAsMCkgICgwLDApICAoMjIsLTM0KSAgKC0yOCw0NikgCigwLDApICAoMTMsLTIxKSAgKDEsMSkgICgtMTUsMjUpIAooMCwwKSAgKDAsMCkgICgwLDApICAoMCwwKSAKCgoKMAoKCjEyCjQgMCAxIDIgMwo0IDQgNSAxIDAKNiAxIDYgNyA4IDkgMgo0IDExIDEyIDggMTAKNCAzIDIgOSAxNAo0IDE1IDE2IDcgNgozIDQgMCAxNQozIDE0IDExIDEwCjMgMTIgOSA4CjYgMTUgMCAzIDE0IDEwIDE2CjQgNyAxNiAxMCA4CjMgNSA2IDEKCgoKOQogMTAgMTMgMTEgOCAxMiAzIDkgMiAxNAoKdGlwIDEzCg=="; // These imports work because we are using @rollup/plugin-url.

  var shapes$5 = {
    connector: connectorUrl$5,
    maroon: maroonUrl$2,
    blue: blueUrl$4,
    yellow: yellowUrl$4,
    purple: purpleUrl$2,
    red: redUrl$3,
    brown: brownUrl$2,
    green: greenUrl$4,
    olive: oliveUrl$2,
    lavender: lavenderUrl$2
  };
  var connectorUrl$6 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCgoxMgooMCwwKSAoLTEvMiwxLzIpICgxLzIsLTEpICgwLDApCigwLDApICgtMS8yLDEvMikgKC0xLzIsMSkgKDAsMCkKKDAsMCkgKDEvMiwtMSkgKDAsMCkgKC0xLzIsMS8yKQooMCwwKSAoMS8yLC0xKSAoMCwwKSAoMS8yLC0xLzIpCigwLDApICgwLDApICgtMS8yLDEvMikgKDEvMiwtMSkKKDAsMCkgKDAsMCkgKC0xLzIsMS8yKSAoLTEvMiwxKQooMCwwKSAoMCwwKSAoMS8yLC0xLzIpICgxLzIsLTEpCigwLDApICgwLDApICgxLzIsLTEvMikgKC0xLzIsMSkKKDAsMCkgKC0xLzIsMSkgKDAsMCkgKC0xLzIsMS8yKQooMCwwKSAoLTEvMiwxKSAoMCwwKSAoMS8yLC0xLzIpCigwLDApICgxLzIsLTEvMikgKDEvMiwtMSkgKDAsMCkKKDAsMCkgKDEvMiwtMS8yKSAoLTEvMiwxKSAoMCwwKQoKCgowCgoKCjIwCjMgIDEgMCAzIAozICAxIDIgMCAKMyAgMyAwIDUgCjMgIDQgMCAyIAozICA1IDAgNCAKMyAgNiAyIDEgCjMgIDcgMSAzIAozICA3IDMgOSAKMyAgNyA2IDEgCjMgIDggMiA2IAozICA4IDQgMiAKMyAgOSAzIDUgCjMgIDEwIDQgOCAKMyAgMTAgNSA0IAozICAxMCA5IDUgCjMgIDExIDYgNyAKMyAgMTEgNyA5IAozICAxMSA4IDYgCjMgIDExIDkgMTAgCjMgIDExIDEwIDggCgoKCjAKCgo=";
  var blueUrl$5 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCiBzY2FsZSAgKDAsMS8yKSAKCjExCigwLDApICAoLTEsMykgICgxLDApICAoMCwwKSAKKDAsMCkgICgtMSwyKSAgKDAsMikgICgxLC0xKSAKKDAsMCkgICgxLDEpICAoMSw0KSAgKDAsMikgCigwLDApICAoMSwyKSAgKDIsMikgICgtMSwzKSAKKDAsMCkgICgzLC0yKSAgKDIsMikgICgxLDEpIAooMCwwKSAgKDMsLTEpICAoMywwKSAgKDAsMikgCigwLDApICAoMywtMSkgICgyLDMpICAoLTEsNCkgCigwLDApICAoLTEsMikgICgxLC0xKSAgKDIsLTMpIAooMCwwKSAgKDEsMCkgICgyLC0yKSAgKDEsLTEpIAooMCwwKSAgKDEsLTEpICAoMSwwKSAgKDIsLTIpIAooMCwwKSAgKDIsMSkgICgzLDIpICAoMSwxKSAKCgoKMAoKCgoxMgo0IDAgMSAyIDMKMyAyIDQgNgozIDcgOCA5CjQgOSA4IDUgNAo0IDEgOSA0IDIKMyAxIDcgOQozIDMgMiA2CjMgNyAxIDAKMyA0IDUgNgozIDUgMyA2CjQgOCAwIDMgNQozIDggNyAwCgoKCjYKIDQgNSA2IDEwIDIgMwoKdGlwIDEwCg==";
  var yellowUrl$5 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCiBzY2FsZSAgKDAsMS8yKSAKCjkKKDAsMCkgICgyLDEpICAoMiwxKSAgKDIsMSkgCigwLDApICAoMywtMSkgICgzLC0xKSAgKDMsLTEpIAooMCwwKSAgKDMvMiwxLzIpICAoMiwxLzIpICAoNS8yLC0xKSAKKDAsMCkgICg1LzIsLTEpICAoMy8yLDEvMikgICgyLDEvMikgCigwLDApICAoLTEvMiwzLzIpICAoMCwzLzIpICAoMS8yLDApIAooMCwwKSAgKDAsMy8yKSAgKDEvMiwwKSAgKC0xLzIsMy8yKSAKKDAsMCkgICgtMSwyKSAgKC0xLDIpICAoLTEsMikgCigwLDApICAoMiwxLzIpICAoNS8yLC0xKSAgKDMvMiwxLzIpIAooMCwwKSAgKDEvMiwwKSAgKC0xLzIsMy8yKSAgKDAsMy8yKSAKCgoKMAoKCgo5CjMgMSAyIDMKMyA0IDUgNgo0IDIgNyA1IDQKNCAzIDIgNCA4CjMgMSA3IDIKNCA3IDMgOCA1CjMgNSA4IDYKMyAxIDMgNwozIDggNCA2CgoKCjUKIDAgMSA3IDIgMwoKdGlwIDAK";
  var redUrl$4 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCiBzY2FsZSAgKDAsMS8yKSAKIAoxMwooMCwwKSAgKDEvMiwxKSAgKC0xLzIsMy8yKSAgKDAsMS8yKSAKKDAsMCkgICgxLzIsMikgICgxLzIsMS8yKSAgKDAsMS8yKSAKKDAsMCkgICgzLzIsMCkgICgzLzIsLTEvMikgICgwLDEvMikgCigwLDApICAoMy8yLC0xKSAgKDEvMiwxLzIpICAoMCwxLzIpIAooMCwwKSAgKDEsMCkgICgwLDEpICAoLTEsMSkgCigwLDApICAoMy8yLC0xLzIpICAoMCwxLzIpICAoMS8yLC0xKSAKKDAsMCkgICgxLC0xKSAgKC0xLDIpICAoMCwwKSAKKDAsMCkgICgxLDIpICAoMiwtMSkgICgwLDApIAooMCwwKSAgKDEvMiwzLzIpICAoMSwxLzIpICAoMS8yLC0xKSAKKDAsMCkgICgxLDEpICAoMSwwKSAgKC0xLDEpIAooMCwwKSAgKDIsMSkgICgxLDEpICAoMCwwKSAKKDAsMCkgICgxLzIsMS8yKSAgKDAsMy8yKSAgKDEvMiwtMSkgCigwLDApICAoMy8yLDEvMikgICgxLC0xLzIpICAoMS8yLC0xKSAKCgoKMAoKCgoxNQo0IDAgMSAyIDMKMyA0IDUgNgozIDcgOCAyCjMgNSAwIDYKMyA3IDkgOAo0IDMgMiA4IDExCjQgNCA5IDEyIDUKMyA3IDEyIDkKMyAxMSA0IDYKMyAwIDMgNgozIDcgMSAxMgozIDMgMTEgNgozIDcgMiAxCjQgMTEgOCA5IDQKNCA1IDEyIDEgMAoKCgo3CiAxIDkgOCAyIDEwIDcgMTIKCnRpcCAxMAo=";
  var greenUrl$5 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCiBzY2FsZSAgKDAsMS8yKSAKCjExCigwLDApICAoLTIsOCkgICgwLDApICAoLTIsOCkgCigwLDApICAoMiwxKSAgKDQsLTcpICAoLTIsNykgCigwLDApICAoMiwxKSAgKC00LDcpICAoLTIsNykgCigwLDApICAoLTIsNykgICgtNCw3KSAgKDIsMSkgCigwLDApICAoMCwxKSAgKDQsLTcpICAoNCwtNSkgCigwLDApICAoMCwxKSAgKC00LDcpICAoNCwtNSkgCigwLDApICAoNCwtNikgICgwLDApICAoNCwtNikgCigwLDApICAoNCwtNSkgICgtNCw3KSAgKDAsMSkgCigwLDApICAoNCwtNSkgICg0LC03KSAgKDAsMSkgCigwLDApICAoLTIsNykgICg0LC03KSAgKDIsMSkgCigwLDApICAoMiwyKSAgKDAsMCkgICgyLDIpIAoKCgowCgoKCjEyCjMgMSAyIDAKMyAyIDMgMAozIDQgNSA2CjMgNyA4IDYKNCAyIDEgOCA3CjQgNCA4IDEgOQozIDggNCA2CjMgMyA5IDAKNCAzIDIgNyA1CjMgNSA3IDYKMyA5IDEgMAo0IDUgNCA5IDMKCgoKNgogMCAxIDIgOSAzIDEwCgp0aXAgMTAK";
  var blackUrl$1 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCgoxMQooMCwwKSAoLTMsMSkgKDEvMiwtMy8yKSAoMS8yLC0xKQooMCwwKSAoMS8yLC0yKSAoMCwwKSAoLTMvMiw1LzIpCigwLDApICgxLzIsLTIpICgwLDApICgtMS8yLDEvMikKKDAsMCkgKC0zLDEpICgxLzIsLTMvMikgKDMvMiwtMykKKDAsMCkgKC01LDcvMikgKDEvMiwtMikgKDUvMiwtOS8yKQooMCwwKSAoMS8yLC0yKSAoLTEsMSkgKC0xLzIsMS8yKQooMCwwKSAoLTMsMSkgKC0xLzIsLTEvMikgKDMvMiwtMykKKDAsMCkgKC0zLDEpICgtMS8yLC0xLzIpICgxLzIsLTEpCigwLDApICgxLzIsLTIpICgtMSwxKSAoLTMvMiw1LzIpCigwLDApICg1LzIsLTkvMikgKC0xLDMvMikgKC01LzIsNCkKKDAsMCkgKC01LzIsLTEpICgtMS8yLC0xLzIpICgwLC0xLzIpCgoKCjAKCgoKMTIKNCAwIDEgMiAzCjMgMCAzIDQKNCAzIDIgNSA2CjMgNCA3IDAKNCA4IDEgMCA3CjMgNiA3IDQKMyAyIDEgOQozIDQgMyA2CjMgOSA1IDIKMyA4IDUgOQozIDkgMSA4CjQgNyA2IDUgOAoKCgo2CiAzIDcgMTAgNiAwIDQKCnRpcCAxMAo=";
  var maroonUrl$3 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCgoxMQooMCwwKSAgKC0zLzIsMCkgICgwLC01KSAgKC0zLzIsMS8yKSAKKDAsMCkgICgzLC01KSAgKC03LDExKSAgKDMsLTUpIAooMCwwKSAgKDEvMiwtMy8yKSAgKC03LzIsNSkgICgxLC0yKSAKKDAsMCkgICgzLzIsLTMpICAoLTMsNCkgICgzLzIsLTUvMikgCigwLDApICAoLTQsNCkgICg0LC0xMikgICgtNCw0KSAKKDAsMCkgICgtNS8yLDMvMikgICgtMS8yLC00KSAgKC0yLDEpIAooMCwwKSAgKC01LzQsMCkgICgtMy80LC0xNS80KSAgKC05LzIsMTkvNCkgCigwLDApICAoLTEvNCwtMy8yKSAgKC0xLzQsLTE5LzQpICAoLTQsMTcvNCkgCigwLDApICAoNy80LC0zKSAgKC0xNS80LDIxLzQpICAoLTMvMiw3LzQpIAooMCwwKSAgKDExLzQsLTkvMikgICgtMTMvNCwxNy80KSAgKC0xLDUvNCkgCigwLDApICAoLTEsLTEpICAoLTMsLTEpICAoLTEsLTEpIAoKCgowCgoKCjEyCjMgMSAyIDMKMyA0IDUgNgo0IDcgNiA4IDkKMyA0IDYgNwozIDEgOSA4CjMgNCA3IDAKMyAzIDkgMQozIDggMiAxCjQgMiA4IDYgNQo0IDAgNyA5IDMKMyAwIDUgNAo0IDMgMiA1IDAKCgoKNgogMCA1IDcgMTAgNiA0Cgp0aXAgMTAK";
  var spruceUrl$1 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCgoxMQooMCwwKSAoMTIsLTE5KSAoLTgsMTMpICgtOCwxMykKKDAsMCkgKDUsLTcpICgtNy8yLDExLzIpICgtNS8yLDQpCigwLDApICg1LC03KSAoLTcvMiwxMS8yKSAoLTcvMiw2KQooMCwwKSAoLTQsMTApICg5LzIsLTEzLzIpICg3LzIsLTUpCigwLDApICgtNCwxMCkgKDcvMiwtMTEvMikgKDcvMiwtNSkKKDAsMCkgKC00LDEwKSAoNy8yLC0xMS8yKSAoOS8yLC03KQooMCwwKSAoLTExLDIyKSAoOSwtMTQpICg5LC0xNCkKKDAsMCkgKDUsLTcpICgtNS8yLDkvMikgKC03LzIsNikKKDAsMCkgKDUsLTcpICgtNS8yLDkvMikgKC01LzIsNCkKKDAsMCkgKC00LDEwKSAoOS8yLC0xMy8yKSAoOS8yLC03KQooMCwwKSAoMSwzKSAoMSwtMSkgKDEsLTEpCgoKCjAKCgoKMTIKMyAwIDEgMgozIDQgNSA2CjMgNiAzIDQKMyAwIDcgOAo0IDIgNCAzIDcKMyA5IDMgNgozIDggMSAwCjMgNiA1IDkKNCA3IDMgOSA4CjQgMSA1IDQgMgo0IDggOSA1IDEKMyAwIDIgNwoKCgo2CiAzIDYgOSAxMCA0IDUKCnRpcCAxMAo=";
  var roseUrl$1 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCgoxMQooMCwwKSAoLTEsMykgKC0xLzIsMS8yKSAoMy8yLC0yKQooMCwwKSAoNCwtMikgKC0xLzIsMS8yKSAoLTUvMiw1KQooMCwwKSAoNCwtMikgKDEvMiwtMS8yKSAoLTUvMiw1KQooMCwwKSAoLTEsMykgKDEvMiwtMS8yKSAoMy8yLC0yKQooMCwwKSAoLTEsMykgKC0xLzIsMS8yKSAoNS8yLC00KQooMCwwKSAoNCwtMikgKC0xLzIsMS8yKSAoLTMvMiwzKQooMCwwKSAoLTQsNykgKDAsMCkgKDUsLTgpCigwLDApICgtMSwzKSAoMS8yLC0xLzIpICg1LzIsLTQpCigwLDApICg0LC0yKSAoMS8yLC0xLzIpICgtMy8yLDMpCigwLDApICg3LC02KSAoMCwwKSAoLTUsOSkKKDAsMCkgKDMsMSkgKDAsMCkgKDAsMSkKCgoKMAoKCgoxMgo0IDAgMSAyIDMKNCA0IDUgMSAwCjMgNiA3IDQKNCA3IDggNSA0CjMgOSA1IDgKMyA0IDAgNgozIDYgMCAzCjMgOSAyIDEKMyA4IDIgOQo0IDIgOCA3IDMKMyA2IDMgNwozIDEgNSA5CgoKCjYKIDggMTAgMSA5IDUgMgoKdGlwIDEwCg==";
  var purpleUrl$3 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCiBzY2FsZSAgKDAsMS8yKSAKCjExCigwLDApICAoLTMvMiwxKSAgKDMvMiwtNS8yKSAgKDAsMy8yKSAKKDAsMCkgICgtMS8yLDApICAoMy8yLC0zLzIpICAoMSwtMS8yKSAKKDAsMCkgICgtMS8yLDEvMikgICgxLC0zLzIpICAoLTMvMiwzKSAKKDAsMCkgICgtMS8yLC0xLzIpICAoLTEsMy8yKSAgKDEvMiwyKSAKKDAsMCkgICgtMS8yLDApICAoLTEvMiwxLzIpICAoLTEsNy8yKSAKKDAsMCkgICgxLzIsLTEpICAoLTEvMiwzLzIpICAoMCwzLzIpIAooMCwwKSAgKDEvMiwtMy8yKSAgKC0xLDUvMikgICgzLzIsMCkgCigwLDApICAoLTEvMiwtMSkgICgtMS8yLDMvMikgICgzLC0zLzIpIAooMCwwKSAgKC0zLzIsMS8yKSAgKDEsLTMvMikgICgzLzIsMCkgCigwLDApICAoLTEsLTEvMikgICgxLzIsMCkgICgzLzIsMy8yKSAKKDAsMCkgICgtMS8yLC0xLzIpICAoMSwtMS8yKSAgKDUvMiwtMikgCgoKCjAKCgoKMTIKMyAwIDEgMgo0IDMgNCA1IDYKMyA3IDggMwozIDUgMiAxCjMgMyA2IDcKNCAxIDEwIDYgNQo0IDEwIDEgMCA4CjMgNyA2IDEwCjMgNSA0IDIKNCA4IDAgNCAzCjMgMTAgOCA3CjMgNCAwIDIKCgoKNgogOSA3IDYgOCAxMCAzCgp0aXAgOQo=";
  var brownUrl$3 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCgoxMQooMCwwKSAoMCwzKSAoLTEvMiwzLzIpICgtNS8yLDQpCigwLDApICgzLzIsLTMvMikgKDMvMiwtMikgKDMsLTUpCigwLDApICgzLzIsLTMvMikgKDMvMiwtMikgKDIsLTMpCigwLDApICgwLDMpICgtMS8yLDMvMikgKC03LzIsNikKKDAsMCkgKDAsMykgKC0zLzIsNS8yKSAoLTcvMiw2KQooMCwwKSAoMy8yLDMvMikgKDAsMS8yKSAoLTEvMiwxKQooMCwwKSAoMy8yLC0zLzIpICgxLzIsLTEpICgyLC0zKQooMCwwKSAoLTMvMiw2KSAoLTUvMiw5LzIpICgtNywyMy8yKQooMCwwKSAoMywtOS8yKSAoNS8yLC00KSAoMTMvMiwtMjEvMikKKDAsMCkgKDMvMiwtMy8yKSAoMS8yLC0xKSAoMywtNSkKKDAsMCkgKDAsMykgKC0zLzIsNS8yKSAoLTUvMiw0KQoKCgowCgoKCjEyCjQgMCAxIDIgMwo0IDMgMiA2IDQKMyAwIDMgNwozIDggNiAyCjQgNCA2IDkgMTAKMyA4IDEgOQozIDcgMTAgMAozIDggOSA2CjMgNyAzIDQKMyAyIDEgOAo0IDEwIDkgMSAwCjMgNCAxMCA3CgoKCjYKIDQgNSAzIDAgMTAgNwoKdGlwIDUK";
  var sandUrl$1 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCgoxMQooMCwwKSAoMCwxKSAoOS8yLC0xNS8yKSAoLTUvMiw0KQooMCwwKSAoMiwwKSAoLTEzLzIsMjEvMikgKDkvMiwtNykKKDAsMCkgKDIsMCkgKC0xMy8yLDIxLzIpICg3LzIsLTUpCigwLDApICgwLDEpICg5LzIsLTE1LzIpICgtNy8yLDYpCigwLDApICgyLDEpICgtMSwyKSAoMSwtMSkKKDAsMCkgKDAsMSkgKDExLzIsLTE3LzIpICgtNy8yLDYpCigwLDApICgtMSwyKSAoMTMsLTIxKSAoLTgsMTMpCigwLDApICgyLDApICgtMTEvMiwxOS8yKSAoNy8yLC01KQooMCwwKSAoMiwwKSAoLTExLzIsMTkvMikgKDkvMiwtNykKKDAsMCkgKDAsMSkgKDExLzIsLTE3LzIpICgtNS8yLDQpCigwLDApICgzLC0xKSAoLTE0LDIzKSAoOSwtMTQpCgoKCjAKCgoKMTIKNCAwIDEgMiAzCjMgMyA1IDYKNCA1IDcgOCA5CjMgNiAwIDMKMyA2IDUgOQozIDcgMiAxMAozIDEwIDggNwozIDkgMCA2CjMgMTAgMiAxCjQgMyAyIDcgNQo0IDggMSAwIDkKMyAxIDggMTAKCgoKNgogNCA3IDEgMiA4IDEwCgp0aXAgNAo=";
  var coralUrl$1 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCgoxMQooMCwwKSAoMCw0KSAoNy8yLC0xMS8yKSAoMy8yLC0xKQooMCwwKSAoLTIsOCkgKDksLTE0KSAoNCwtNSkKKDAsMCkgKDAsNCkgKDkvMiwtMTMvMikgKDMvMiwtMSkKKDAsMCkgKDIsLTIpICgtNS8yLDkvMikgKC0xLzIsMSkKKDAsMCkgKDAsNCkgKDkvMiwtMTMvMikgKDUvMiwtMykKKDAsMCkgKDAsNCkgKDcvMiwtMTEvMikgKDUvMiwtMykKKDAsMCkgKDIsLTIpICgtNy8yLDExLzIpICgtMS8yLDEpCigwLDApICgyLC0yKSAoLTcvMiwxMS8yKSAoLTMvMiwzKQooMCwwKSAoMiwtMikgKC01LzIsOS8yKSAoLTMvMiwzKQooMCwwKSAoNCwtNikgKC04LDEzKSAoLTMsNSkKKDAsMCkgKDIsMikgKDEsLTEpICgxLDApCgoKCjAKCgoKMTIKMyAwIDEgMgo0IDMgNCA1IDYKMyA1IDEgMAo0IDcgMCAyIDgKMyAyIDEgNAozIDkgNiA3CjMgNyA4IDkKNCA4IDIgNCAzCjQgNiA1IDAgNwozIDMgNiA5CjMgNCAxIDUKMyA5IDggMwoKCgo2CiA1IDQgMTAgMSAyIDAKCnRpcCAxMAo=";
  var navyUrl$1 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCgoxMQooMCwwKSAoLTIsOCkgKDQsLTUpICgtNSw5KQooMCwwKSAoMCw0KSAoMy8yLC0zLzIpICgtMy8yLDMpCigwLDApICgwLDQpICg1LzIsLTUvMikgKC0zLzIsMykKKDAsMCkgKDAsNCkgKDUvMiwtNS8yKSAoLTUvMiw1KQooMCwwKSAoMCw0KSAoMy8yLC0zLzIpICgtNS8yLDUpCigwLDApICgyLC0yKSAoLTMvMiw1LzIpICgzLzIsLTIpCigwLDApICgyLC0yKSAoLTMvMiw1LzIpICg1LzIsLTQpCigwLDApICgyLC0yKSAoLTEvMiwzLzIpICg1LzIsLTQpCigwLDApICgyLC0yKSAoLTEvMiwzLzIpICgzLzIsLTIpCigwLDApICg0LC02KSAoLTMsNSkgKDUsLTgpCigwLDApICgyLDIpICgxLDApICgwLDEpCgoKCjAKCgoKMTIKMyAwIDEgMgo0IDUgNiAxIDQKNCA3IDIgMSA2CjQgOCAzIDIgNwozIDIgMyAwCjMgNCAxIDAKMyA5IDYgNQo0IDQgMyA4IDUKMyAwIDMgNAozIDcgNiA5CjMgOSA4IDcKMyA5IDUgOAoKCgo2CiAzIDQgMSAyIDAgMTAKCnRpcCAxMAo=";
  var sulfurUrl$1 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCgoxMQooMCwwKSAoLTMsNikgKDMvMiwtNS8yKSAoLTEvMiwxKQooMCwwKSAoLTMsNikgKDUvMiwtNy8yKSAoLTEvMiwxKQooMCwwKSAoLTksMTUpICg1LC04KSAoMCwwKQooMCwwKSAoLTMsNikgKDUvMiwtNy8yKSAoMS8yLC0xKQooMCwwKSAoMTUsLTIxKSAoLTEzLzIsMjMvMikgKDEvMiwtMSkKKDAsMCkgKDE1LC0yMSkgKC0xNS8yLDI1LzIpICgxLzIsLTEpCigwLDApICgtMyw2KSAoMy8yLC01LzIpICgxLzIsLTEpCigwLDApICgxNSwtMjEpICgtMTUvMiwyNS8yKSAoLTEvMiwxKQooMCwwKSAoMTUsLTIxKSAoLTEzLzIsMjMvMikgKC0xLzIsMSkKKDAsMCkgKDIxLC0zMCkgKC0xMCwxNykgKDAsMCkKKDAsMCkgKDMsMCkgKDAsMSkgKDAsMCkKCgoKMAoKCgoxMgozIDAgMSAyCjQgMyA0IDUgNgo0IDAgNyA4IDEKMyA1IDQgOQo0IDEgOCA0IDMKMyA4IDcgOQozIDIgNiAwCjMgMiAxIDMKMyA5IDcgNQozIDMgNiAyCjQgNiA1IDcgMAozIDkgNCA4CgoKCjYKIDUgNyA4IDEwIDkgNAoKdGlwIDEwCg==";
  var cinnamonUrl$1 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCgoxMQooMCwwKSAoLTIsOCkgKC0xNCwyMykgKC01LDkpCigwLDApICgwLDQpICgtMTMvMiwyMS8yKSAoLTUvMiw1KQooMCwwKSAoMCw0KSAoLTEzLzIsMjEvMikgKC0zLzIsMykKKDAsMCkgKDIsLTIpICgxMS8yLC0xNy8yKSAoNS8yLC00KQooMCwwKSAoMiwtMikgKDkvMiwtMTUvMikgKDUvMiwtNCkKKDAsMCkgKDQsLTYpICgxMywtMjEpICg1LC04KQooMCwwKSAoMiwtMikgKDkvMiwtMTUvMikgKDMvMiwtMikKKDAsMCkgKDAsNCkgKC0xMS8yLDE5LzIpICgtNS8yLDUpCigwLDApICgyLC0yKSAoMTEvMiwtMTcvMikgKDMvMiwtMikKKDAsMCkgKDAsNCkgKC0xMS8yLDE5LzIpICgtMy8yLDMpCigwLDApICgyLDIpICgtMSwyKSAoMCwxKQoKCgowCgoKCjEyCjMgMCAxIDIKMyAzIDQgNQozIDUgNCA2CjQgNiAxIDcgOAo0IDggNyA5IDMKMyA1IDggMwozIDYgOCA1CjMgMCAyIDkKMyAwIDcgMQo0IDMgOSAyIDQKNCA0IDIgMSA2CjMgOSA3IDAKCgoKNgogMSA3IDkgMTAgMiAwCgp0aXAgMTAK";
  var turquoiseUrl$1 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCgoxMQooMCwwKSAoMiwtMikgKDUvMiwtNy8yKSAoLTcvMiw2KQooMCwwKSAoMiwtMikgKDMvMiwtNS8yKSAoLTcvMiw2KQooMCwwKSAoMCw0KSAoLTUvMiw5LzIpICg3LzIsLTUpCigwLDApICgwLDQpICgtMy8yLDcvMikgKDcvMiwtNSkKKDAsMCkgKDIsMikgKDAsMSkgKDEsLTEpCigwLDApICgxLzE5LDQvMTkpICgtMy8zOCw3LzM4KSAoNy8zOCwtNS8xOSkKKDAsMCkgKDIsLTIpICg1LzIsLTcvMikgKC01LzIsNCkKKDAsMCkgKDAsNCkgKC01LzIsOS8yKSAoOS8yLC03KQooMCwwKSAoMiwtMikgKDMvMiwtNS8yKSAoLTUvMiw0KQooMCwwKSAoMCw0KSAoLTMvMiw3LzIpICg5LzIsLTcpCigwLDApICgzNy8xOSwzNC8xOSkgKDMvMzgsMzEvMzgpICgzMS8zOCwtMTQvMTkpCgoKCjAKCgoKMTIKNCAwIDEgMiAzCjMgNSAwIDYKNCA4IDcgMiAxCjQgNiA5IDcgOAo0IDYgMCAzIDkKMyAxMCAyIDcKMyA2IDggNQozIDcgOSAxMAozIDggMSA1CjMgMyAyIDEwCjMgNSAxIDAKMyAxMCA5IDMKCgoKNgogNCA3IDEwIDMgMiA5Cgp0aXAgNAo=";
  var oliveUrl$3 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCiBzY2FsZSAgKDAsMS8yKSAKCgoxMQooMCwwKSAgKDIsLTEpICAoMSwtMSkgICgyLDApIAooMCwwKSAgKDEsMCkgICgyLC0zKSAgKDAsMikgCigwLDApICAoMCwxKSAgKDIsLTIpICAoMSwwKSAKKDAsMCkgICgxLDApICAoMSwwKSAgKDMsLTIpIAooMCwwKSAgKDAsMSkgICgwLDApICAoLTEsNCkgCigwLDApICAoMSwwKSAgKC0xLDIpICAoMSwyKSAKKDAsMCkgICgyLC0xKSAgKC0xLDMpICAoNCwtMikgCigwLDApICAoMCwxKSAgKC0xLDMpICAoMiwwKSAKKDAsMCkgICgtMSwyKSAgKDAsMSkgICgwLDIpIAooMCwwKSAgKC0xLDIpICAoMiwtMykgICgtMiw0KSAKKDAsMCkgICgxLDEpICAoMSwwKSAgKDIsMikgCgoKCjAKCgoKMTIKNCAwIDEgMiAzCjQgNCAxIDAgNQozIDYgNSAwCjMgOCAyIDkKMyA2IDMgNwozIDIgMSA5CjQgNyAzIDIgOAozIDEgNCA5CjMgNCA4IDkKMyA2IDAgMwo0IDQgNSA3IDgKMyA1IDYgNwoKCgo2CiA3IDEwIDYgNSAwIDMKCnRpcCAxMAo=";
  var appleUrl$1 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCgoxMQooMCwwKSAoMTIsLTE1KSAoOSwtMTQpICgtNSw5KQooMCwwKSAoNiwtNikgKDkvMiwtMTMvMikgKC0zLzIsMykKKDAsMCkgKC0zLDYpICgtNy8yLDExLzIpICgzLzIsLTIpCigwLDApICg2LC02KSAoNy8yLC0xMS8yKSAoLTUvMiw1KQooMCwwKSAoNiwtNikgKDkvMiwtMTMvMikgKC01LzIsNSkKKDAsMCkgKC0zLDYpICgtNS8yLDkvMikgKDMvMiwtMikKKDAsMCkgKC0zLDYpICgtNy8yLDExLzIpICg1LzIsLTQpCigwLDApICgtOSwxNSkgKC04LDEzKSAoNSwtOCkKKDAsMCkgKC0zLDYpICgtNS8yLDkvMikgKDUvMiwtNCkKKDAsMCkgKDMsMCkgKDEsLTEpICgwLDEpCigwLDApICg2LC02KSAoNy8yLC0xMS8yKSAoLTMvMiwzKQoKCgowCgoKCjEyCjQgMiAzIDQgNQozIDYgMiA3CjQgNSA0IDEgOAozIDcgMiA1CjQgOCAxIDEwIDYKMyA3IDggNgozIDAgNCAzCjMgNSA4IDcKMyAwIDMgMTAKMyAwIDEwIDEKNCA2IDEwIDMgMgozIDEgNCAwCgoKCjYKIDAgMSA5IDQgMyAxMAoKdGlwIDkK";
  var lavenderUrl$3 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCgoxMQooMCwwKSAgKC04LDgpICAoMCw0KSAgKC00LDQpIAooMCwwKSAgKC00LDIpICAoMS8yLDUvMikgICgtMy8yLDApIAooMCwwKSAgKC05LzIsNS8yKSAgKDMvMiwxKSAgKC0yLDEpIAooMCwwKSAgKDYsLTEwKSAgKDIsLTMpICAoMywtNSkgCigwLDApICAoMy8yLC03LzIpICAoMy8yLC0yKSAgKDEsLTIpIAooMCwwKSAgKDIsLTQpICAoMS8yLC0xLzIpICAoMy8yLC0zKSAKKDAsMCkgICgtNCwyKSAgKDMvMiwzLzIpICAoLTUvMiwyKSAKKDAsMCkgICg1LzIsLTkvMikgICgxLzIsMCkgICgxLC0yKSAKKDAsMCkgICgtNy8yLDMvMikgICgxLzIsMykgICgtMiwxKSAKKDAsMCkgICgtMiwtMikgICgyLDEpICAoLTEsLTEpIAooMCwwKSAgKDIsLTQpICAoMy8yLC0zLzIpICAoMS8yLC0xKSAKCgoKMAoKCgoxMgozIDAgMSAyCjMgMyA0IDUKNCA3IDUgMSA4CjQgNSA0IDIgMQozIDMgNyAxMAozIDggMSAwCjQgOCA2IDEwIDcKMyAxMCA0IDMKNCA2IDIgNCAxMAozIDUgNyAzCjMgMCA2IDgKMyAwIDIgNgoKCgo2CiA2IDkgMiAwIDggMQoKdGlwIDkK";
  var orangeUrl$1 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgZ29sZGVuCiBzY2FsZSAgKDAsMS8yKSAKCjExCigwLDApICAoLTEvMiwyKSAgKDMvMiwxLzIpICAoMSwtMS8yKSAKKDAsMCkgICgxLC0xLzIpICAoNS8yLDApICAoLTEvMiwzLzIpIAooMCwwKSAgKC0xLDUvMikgICgxLzIsMSkgICgzLzIsLTMvMikgCigwLDApICAoLTEvMiwxKSAgKDEvMiw1LzIpICAoMCwxLzIpIAooMCwwKSAgKC0xLDMvMikgICgtMS8yLDMpICAoMS8yLC0xLzIpIAooMCwwKSAgKDMvMiwtMSkgICg1LzIsLTMvMikgICgwLDEvMikgCigwLDApICAoMSwtMS8yKSAgKDMvMiwtMSkgICgxLzIsLTEvMikgCigwLDApICAoMy8yLC0yKSAgKDMvMiwxLzIpICAoLTEsMy8yKSAKKDAsMCkgICgxLzIsMS8yKSAgKDIsMy8yKSAgKDEvMiwwKSAKKDAsMCkgICgtMS8yLDEpICAoLTEvMiwzLzIpICAoMSwtMy8yKSAKKDAsMCkgICgxLC0zLzIpICAoMS8yLDEpICAoLTEvMiwxLzIpIAoKCgowCgoKCjEyCjQgMiAwIDMgNAozIDEgMCA1CjQgMCAyIDYgNQozIDIgOSA2CjMgMTAgOSA0CjMgNCA5IDIKMyAzIDAgMQozIDUgNyAxCjMgMSA3IDMKNCA1IDYgMTAgNwozIDYgOSAxMAo0IDQgMyA3IDEwCgoKCjYKIDAgMSA3IDggMyA1Cgp0aXAgOAo="; // These imports work because we are using @rollup/plugin-url.

  var shapes$6 = {
    connector: connectorUrl$6,
    blue: blueUrl$5,
    yellow: yellowUrl$5,
    red: redUrl$4,
    green: greenUrl$5,
    black: blackUrl$1,
    maroon: maroonUrl$3,
    spruce: spruceUrl$1,
    rose: roseUrl$1,
    purple: purpleUrl$3,
    brown: brownUrl$3,
    sand: sandUrl$1,
    coral: coralUrl$1,
    navy: navyUrl$1,
    sulfur: sulfurUrl$1,
    cinnamon: cinnamonUrl$1,
    turquoise: turquoiseUrl$1,
    olive: oliveUrl$3,
    apple: appleUrl$1,
    lavender: lavenderUrl$3,
    orange: orangeUrl$1
  };
  var connectorUrl$7 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgcm9vdFR3bwogc2NhbGUgICgxLzIsMCkgCgoyNAooMCwwKSAgKDEvNCwwKSAgKDEvNCwwKSAgKC0zLzQsMCkgCigwLDApICAoMS80LDApICAoLTEvNCwwKSAgKC0zLzQsMCkgCigwLDApICAoLTEvNCwwKSAgKC0xLzQsMCkgICgtMy80LDApIAooMCwwKSAgKC0xLzQsMCkgICgxLzQsMCkgICgtMy80LDApIAooMCwwKSAgKC0xLzQsMCkgICgtMy80LDApICAoLTEvNCwwKSAKKDAsMCkgICgtMy80LDApICAoLTEvNCwwKSAgKC0xLzQsMCkgCigwLDApICAoMy80LDApICAoLTEvNCwwKSAgKC0xLzQsMCkgCigwLDApICAoMS80LDApICAoLTMvNCwwKSAgKC0xLzQsMCkgCigwLDApICAoMS80LDApICAoLTEvNCwwKSAgKDMvNCwwKSAKKDAsMCkgICgxLzQsMCkgICgxLzQsMCkgICgzLzQsMCkgCigwLDApICAoLTEvNCwwKSAgKDEvNCwwKSAgKDMvNCwwKSAKKDAsMCkgICgtMS80LDApICAoLTEvNCwwKSAgKDMvNCwwKSAKKDAsMCkgICgzLzQsMCkgICgxLzQsMCkgICgxLzQsMCkgCigwLDApICAoMS80LDApICAoMy80LDApICAoMS80LDApIAooMCwwKSAgKC0xLzQsMCkgICgtMy80LDApICAoMS80LDApIAooMCwwKSAgKC0zLzQsMCkgICgtMS80LDApICAoMS80LDApIAooMCwwKSAgKDEvNCwwKSAgKC0zLzQsMCkgICgxLzQsMCkgCigwLDApICAoLTMvNCwwKSAgKDEvNCwwKSAgKDEvNCwwKSAKKDAsMCkgICgtMS80LDApICAoMy80LDApICAoMS80LDApIAooMCwwKSAgKC0xLzQsMCkgICgzLzQsMCkgICgtMS80LDApIAooMCwwKSAgKC0zLzQsMCkgICgxLzQsMCkgICgtMS80LDApIAooMCwwKSAgKDEvNCwwKSAgKDMvNCwwKSAgKC0xLzQsMCkgCigwLDApICAoMy80LDApICAoLTEvNCwwKSAgKDEvNCwwKSAKKDAsMCkgICgzLzQsMCkgICgxLzQsMCkgICgtMS80LDApIAoKCgowCgoKCjI2CjQgMCAxIDIgMwozIDQgNSAyCjMgNiA3IDEKNCA4IDkgMTAgMTEKMyAxMiAxMyA5CjQgNSA0IDE0IDE1CjQgNyAxNiAxNCA0CjQgNCAyIDEgNwo0IDE3IDE4IDE5IDIwCjQgMTggMTAgOSAxMwo0IDEzIDIxIDE5IDE4CjQgMTEgMTQgMTYgOAozIDIyIDggMTYKNCAxNSAxNyAyMCA1CjMgMTggMTcgMTAKNCAyMiAxNiA3IDYKNCAxNSAxMSAxMCAxNwo0IDYgMSAwIDIzCjMgMTEgMTUgMTQKNCAyMyAyMSAxMyAxMgozIDMgMjAgMTkKNCAyMCAzIDIgNQozIDIzIDAgMjEKNCAzIDE5IDIxIDAKNCAxMiAyMiA2IDIzCjQgMTIgOSA4IDIyCgoKCjAKCgo=";
  var blueUrl$6 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgcm9vdFR3bwogc2NhbGUgICgxLzIsMCkgCgo5CigwLDApICAoMy80LDApICAoLTEvNCwwKSAgKC0xLzQsMCkgCigwLDApICAoMy80LDApICAoMS80LDApICAoLTEvNCwwKSAKKDAsMCkgICgtMy80LDgpICAoMS80LDApICAoLTEvNCwwKSAKKDAsMCkgICgtMy80LDgpICAoLTEvNCwwKSAgKC0xLzQsMCkgCigwLDApICAoMCw4KSAgKDAsMCkgICgwLDApIAooMCwwKSAgKC0zLzQsOCkgICgxLzQsMCkgICgxLzQsMCkgCigwLDApICAoLTMvNCw4KSAgKC0xLzQsMCkgICgxLzQsMCkgCigwLDApICAoMy80LDApICAoMS80LDApICAoMS80LDApIAooMCwwKSAgKDMvNCwwKSAgKC0xLzQsMCkgICgxLzQsMCkgCgoKCjAKCgoKNAo0IDAgMSAyIDMKNCA2IDUgNyA4CjQgOCAwIDMgNgo0IDIgMSA3IDUKCgoKNQogNCA1IDYgMiAzCgp0aXAgNAo=";
  var yellowUrl$6 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgcm9vdFR3bwogc2NhbGUgICgxLzIsMCkgCgoxMwooMCwwKSAgKDMsMS8yKSAgKDMsLTEvMikgICgzLDApIAooMCwwKSAgKDMsMCkgICgzLDEvMikgICgzLC0xLzIpIAooMCwwKSAgKDE1LzQsMCkgICgxNS80LDApICAoMTMvNCwwKSAKKDAsMCkgICgxLDApICAoMSwxLzIpICAoMSwtMS8yKSAKKDAsMCkgICgzLzQsMCkgICgxLzQsMCkgICgxLzQsMCkgCigwLDApICAoMS80LDApICAoMy80LDApICAoMS80LDApIAooMCwwKSAgKDMsLTEvMikgICgzLDApICAoMywxLzIpIAooMCwwKSAgKDQsMCkgICg0LDApICAoNCwwKSAKKDAsMCkgICgxLC0xLzIpICAoMSwwKSAgKDEsMS8yKSAKKDAsMCkgICgxLDEvMikgICgxLC0xLzIpICAoMSwwKSAKKDAsMCkgICgxNS80LDApICAoMTMvNCwwKSAgKDE1LzQsMCkgCigwLDApICAoMS80LDApICAoMS80LDApICAoMy80LDApIAooMCwwKSAgKDEzLzQsMCkgICgxNS80LDApICAoMTUvNCwwKSAKCgoKMAoKCgoxNQozIDAgMSAyCjMgMyA0IDUKNCAwIDYgOCA5CjMgOSA4IDExCjMgMiAxIDEyCjMgMyA5IDQKMyA5IDExIDQKMyAxMiAxIDYKMyAwIDEwIDYKNCAxIDAgOSAzCjMgOCAzIDUKMyA4IDUgMTEKMyAxMCAxMiA2CjMgMCAyIDEwCjQgNiAxIDMgOAoKCgo3CiAxIDIgMCA2IDcgMTAgMTIKCnRpcCA3Cg==";
  var brownUrl$4 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgcm9vdFR3bwogc2NhbGUgICgxLzIsMCkgCgoxNQooMCwwKSAgKDEvNCwwKSAgKDEvNCwwKSAgKDMvNCwwKSAKKDAsMCkgICgzLzQsMCkgICgxLzQsMCkgICgxLzQsMCkgCigwLDApICAoNS80LDApICAoMy80LDApICAoMiwwKSAKKDAsMCkgICgxMy80LDApICAoMTEvNCwwKSAgKDYsMCkgCigwLDApICAoMTMvNCwwKSAgKDE1LzQsMCkgICgzMS80LDApIAooMCwwKSAgKDExLzQsMCkgICgxMS80LDApICAoNiwwKSAKKDAsMCkgICgxNS80LDApICAoMTMvNCwwKSAgKDMxLzQsMCkgCigwLDApICAoMy80LDApICAoMy80LDApICAoMiwwKSAKKDAsMCkgICgzLzQsMCkgICg1LzQsMCkgICgyLDApIAooMCwwKSAgKDUvNCwwKSAgKDUvNCwwKSAgKDIsMCkgCigwLDApICAoMTMvNCwwKSAgKDEzLzQsMCkgICg2LDApIAooMCwwKSAgKDQsMCkgICg0LDApICAoOCwwKSAKKDAsMCkgICgxMS80LDApICAoMTMvNCwwKSAgKDYsMCkgCigwLDApICAoMS80LDApICAoMy80LDApICAoMS80LDApIAooMCwwKSAgKDE1LzQsMCkgICgxNS80LDApICAoMjkvNCwwKSAKCgoKMAoKCgoxOAozIDAgMSAyCjMgNCA1IDYKMyA3IDggMAo0IDMgMiA5IDEwCjQgMTIgMTAgOSA4CjQgNyAyIDMgNQo0IDUgMTIgOCA3CjMgOCA5IDEzCjMgNCAxNCAxMgozIDcgMCAyCjMgNCAxMiA1CjMgMCA4IDEzCjMgMTMgOSAxCjMgMTQgMTAgMTIKMyA1IDMgNgozIDYgMyAxNAozIDIgMSA5CjMgMTQgMyAxMAoKCgo4CiAzIDExIDEwIDE0IDEyIDYgNSA0Cgp0aXAgMTEK";
  var greenUrl$6 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgcm9vdFR3bwogc2NhbGUgICgxLzIsMCkgCgo5CigwLDApICAoLTMvNCw4KSAgKC0xLzQsMCkgICgtMS80LDgpIAooMCwwKSAgKDMvNCwwKSAgKDEvNCwwKSAgKDEvNCwwKSAKKDAsMCkgICgxLzQsMCkgICgxLzQsMCkgICgzLzQsMCkgCigwLDApICAoLTMvNCw4KSAgKDEvNCwwKSAgKC0xLzQsOCkgCigwLDApICAoLTEvNCw4KSAgKDEvNCwwKSAgKC0zLzQsOCkgCigwLDApICAoMCw4KSAgKDAsMCkgICgwLDgpIAooMCwwKSAgKDMvNCwwKSAgKC0xLzQsMCkgICgxLzQsMCkgCigwLDApICAoLTEvNCw4KSAgKC0xLzQsMCkgICgtMy80LDgpIAooMCwwKSAgKDEvNCwwKSAgKC0xLzQsMCkgICgzLzQsMCkgCgoKCjAKCgoKNAo0IDEgMiAzIDQKNCA2IDEgNCA3CjQgMCAzIDIgOAo0IDggNiA3IDAKCgoKNQogMCA1IDMgNyA0Cgp0aXAgNQo="; // These imports work because we are using @rollup/plugin-url.

  var shapes$7 = {
    connector: connectorUrl$7,
    blue: blueUrl$6,
    yellow: yellowUrl$6,
    brown: brownUrl$4,
    green: greenUrl$6
  };
  var connectorUrl$8 = "data:null;base64,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";
  var yellowUrl$7 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgcm9vdFR3bwogc2NhbGUgICgxLzIsMCkgCgoxMwooMCwwKSAgKDAsMykgICgwLDExLzQpICAoMCwxMy80KSAKKDAsMCkgICgwLDExLzQpICAoMCwxMy80KSAgKDAsMykgCigwLDApICAoMCwzLzQpICAoMCw1LzQpICAoMCwxKSAKKDAsMCkgICgwLDEpICAoMCwzLzQpICAoMCw1LzQpIAooMCwwKSAgKC0xLzQsNy8yKSAgKC0xLzQsNy8yKSAgKC0xLzQsNCkgCigwLDApICAoLTEvNCw3LzIpICAoLTEvNCw0KSAgKC0xLzQsNy8yKSAKKDAsMCkgICgxLzQsMCkgICgxLzQsMS8yKSAgKDEvNCwxLzIpIAooMCwwKSAgKDEvNCwxLzIpICAoMS80LDApICAoMS80LDEvMikgCigwLDApICAoLTEvNCw0KSAgKC0xLzQsNy8yKSAgKC0xLzQsNy8yKSAKKDAsMCkgICgwLDEzLzQpICAoMCwzKSAgKDAsMTEvNCkgCigwLDApICAoMCw1LzQpICAoMCwxKSAgKDAsMy80KSAKKDAsMCkgICgxLzQsMS8yKSAgKDEvNCwxLzIpICAoMS80LDApIAooMCwwKSAgKDAsNCkgICgwLDQpICAoMCw0KSAKCgoKMAoKCgoxNQo0IDAgMSAyIDMKMyA0IDUgMQozIDYgNyAzCjMgNCAwIDgKMyA4IDkgNQo0IDEwIDIgMSA5CjMgMyA3IDEwCjMgMCA5IDgKMyAyIDEwIDExCjMgMiA2IDMKNCA5IDAgMyAxMAozIDYgMiAxMQozIDAgNCAxCjMgMTEgMTAgNwozIDUgOSAxCgoKCjcKIDEgNSAwIDkgNCA4IDEyCgp0aXAgMTIK"; // These imports work because we are using @rollup/plugin-url.

  var shapes$8 = {
    connector: connectorUrl$8,
    yellow: yellowUrl$7
  };
  var connectorUrl$9 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgcm9vdFR3bwogc2NhbGUgICgxLzIsMCkgCgo2CigwLDApICAoMCwwKSAgKDEvMiwwKSAgKDAsMCkgCigwLDApICAoMCwwKSAgKDAsMCkgICgtMS8yLDApIAooMCwwKSAgKC0xLzIsMCkgICgwLDApICAoMCwwKSAKKDAsMCkgICgxLzIsMCkgICgwLDApICAoMCwwKSAKKDAsMCkgICgwLDApICAoLTEvMiwwKSAgKDAsMCkgCigwLDApICAoMCwwKSAgKDAsMCkgICgxLzIsMCkgCgoKCjAKCgoKOAozIDAgMSAyCjMgMyAxIDAKMyAxIDQgMgozIDMgMCA1CjMgNSAwIDIKMyAzIDQgMQozIDMgNSA0CjMgNCA1IDIKCgoKMAoKCg==";
  var blueUrl$7 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgcm9vdFR3bwogc2NhbGUgICgxLzIsMCkgCgoxMQooMCwwKSAgKDEvMiwwKSAgKDAsMCkgICgwLDApIAooMCwwKSAgKDMvMiwwKSAgKDAsMCkgICgtMS8yLDApIAooMCwwKSAgKDMvMiwwKSAgKC0xLzIsMCkgICgwLDApIAooMCwwKSAgKC0zLzIsOCkgICgwLDApICAoMS8yLDApIAooMCwwKSAgKC0zLzIsOCkgICgtMS8yLDApICAoMCwwKSAKKDAsMCkgICgzLzIsMCkgICgwLDApICAoMS8yLDApIAooMCwwKSAgKC0zLzIsOCkgICgwLDApICAoLTEvMiwwKSAKKDAsMCkgICgtMS8yLDgpICAoMCwwKSAgKDAsMCkgCigwLDApICAoLTMvMiw4KSAgKDEvMiwwKSAgKDAsMCkgCigwLDApICAoMy8yLDApICAoMS8yLDApICAoMCwwKSAKKDAsMCkgICgwLDgpICAoMCwwKSAgKDAsMCkgCgoKCjAKCgoKMTIKMyAwIDEgMgo0IDQgMyA1IDIKNCAzIDggOSA1CjQgOCA2IDEgOQozIDAgOSAxCjQgNCAyIDEgNgozIDMgNyA4CjMgMCAyIDUKMyA3IDMgNAozIDcgNCA2CjMgMCA1IDkKMyA3IDYgOAoKCgo2CiAzIDYgNyA4IDEwIDQKCnRpcCAxMAo=";
  var yellowUrl$8 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgcm9vdFR3bwogc2NhbGUgICgxLzIsMCkgCgo5CigwLDApICAoMCwxLzIpICAoMCwzLzIpICAoMCwxKSAKKDAsMCkgICgwLDMvMikgICgwLDEpICAoMCwxLzIpIAooMCwwKSAgKDAsMS80KSAgKDAsMS80KSAgKDAsMS80KSAKKDAsMCkgICgwLDcvMikgICgwLDMpICAoMCw1LzIpIAooMCwwKSAgKDAsMykgICgwLDUvMikgICgwLDcvMikgCigwLDApICAoMCwxKSAgKDAsMS8yKSAgKDAsMy8yKSAKKDAsMCkgICgwLDE1LzQpICAoMCwxNS80KSAgKDAsMTUvNCkgCigwLDApICAoMCw1LzIpICAoMCw3LzIpICAoMCwzKSAKKDAsMCkgICgwLDQpICAoMCw0KSAgKDAsNCkgCgoKCjAKCgoKOQozIDAgMSAyCjQgMyA0IDUgMQozIDYgNCAzCjMgNyA0IDYKMyAzIDcgNgo0IDcgMCA1IDQKMyA1IDAgMgo0IDAgNyAzIDEKMyAxIDUgMgoKCgo1CiA2IDcgOCA0IDMKCnRpcCA4Cg==";
  var brownUrl$5 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgcm9vdFR3bwogc2NhbGUgICgxLzIsMCkgCgoxMQooMCwwKSAgKDQsMCkgICg0LDApICAoOCwwKSAKKDAsMCkgICgyNy84LC0xLzIpICAoMzEvOCwtMS8yKSAgKDMxLzQsLTEpIAooMCwwKSAgKDM1LzgsLTEvMikgICgzMS84LC0xLzIpICAoMzEvNCwtMSkgCigwLDApICAoMzEvOCwtMS8yKSAgKDI3LzgsLTEvMikgICgzMS80LC0xKSAKKDAsMCkgICgxLzgsMS8yKSAgKC0zLzgsMS8yKSAgKDEvNCwxKSAKKDAsMCkgICg1LzgsMS8yKSAgKDEvOCwxLzIpICAoMS80LDEpIAooMCwwKSAgKC0zLzgsMS8yKSAgKDEvOCwxLzIpICAoMS80LDEpIAooMCwwKSAgKDMxLzgsLTEvMikgICgzNS84LC0xLzIpICAoMzEvNCwtMSkgCigwLDApICAoMS84LDEvMikgICg1LzgsMS8yKSAgKDEvNCwxKSAKKDAsMCkgICgzMS84LDApICAoMzEvOCwwKSAgKDMxLzQsMCkgCigwLDApICAoMS84LDApICAoMS84LDApICAoMS80LDApIAoKCgowCgoKCjEyCjQgMiAzIDQgNQo0IDYgMSA3IDgKMyAxIDMgOQozIDEwIDYgOAo0IDQgMyAxIDYKMyAyIDcgOQozIDkgMyAyCjQgOCA3IDIgNQozIDEwIDQgNgozIDEwIDggNQozIDkgNyAxCjMgMTAgNSA0CgoKCjYKIDAgMSA5IDMgMiA3Cgp0aXAgMAo=";
  var greenUrl$7 = "data:null;base64,dlpvbWUgVkVGIDYgZmllbGQgcm9vdFR3bwogc2NhbGUgICgxLzIsMCkgCgoxMQooMCwwKSAgKDE1LzQsMCkgICgwLDApICAoMTUvNCwwKSAKKDAsMCkgICg3LzIsLTEpICAoMCwwKSAgKDQsLTEpIAooMCwwKSAgKDQsLTEpICAoLTEvMiwwKSAgKDQsLTEpIAooMCwwKSAgKDAsMSkgICgtMS8yLDApICAoMCwxKSAKKDAsMCkgICgxLzIsMSkgICgwLDApICAoMCwxKSAKKDAsMCkgICg0LC0xKSAgKDAsMCkgICg3LzIsLTEpIAooMCwwKSAgKDAsMSkgICgxLzIsMCkgICgwLDEpIAooMCwwKSAgKDQsLTEpICAoMS8yLDApICAoNCwtMSkgCigwLDApICAoMCwxKSAgKDAsMCkgICgxLzIsMSkgCigwLDApICAoMS80LDApICAoMCwwKSAgKDEvNCwwKSAKKDAsMCkgICg0LDApICAoMCwwKSAgKDQsMCkgCgoKCjAKCgoKMTIKMyAwIDEgMgo0IDIgMyA0IDUKNCA1IDQgNiA3CjQgOCAzIDIgMQozIDQgOSA2CjMgMyA4IDkKMyAwIDIgNQozIDggNiA5CjMgMCA1IDcKMyAzIDkgNAozIDEgMCA3CjQgMSA3IDYgOAoKCgo2CiAyIDAgMTAgNSA3IDEKCnRpcCAxMAo="; // These imports work because we are using @rollup/plugin-url.

  var shapes$9 = {
    connector: connectorUrl$9,
    blue: blueUrl$7,
    yellow: yellowUrl$8,
    brown: brownUrl$5,
    green: greenUrl$7
  };
  var shapes$a = {
    'default': shapes,
    dodecs: shapes$1,
    lifelike: shapes$2,
    octahedral: shapes$3,
    octahedralFast: shapes$4,
    octahedralRealistic: shapes$5,
    tiny: shapes$6,
    rootTwo: shapes$7,
    rootTwoBig: shapes$8,
    rootTwoSmall: shapes$9
  };
  var binaryTetrahedralGroupUrl = "data:null;base64,dlpvbWUgVkVGIDQKCjI0CigwLDIpCSgwLDApCSgwLDApCSgwLDApCigwLDApCSgwLDIpCSgwLDApCSgwLDApCigwLDApCSgwLDApCSgwLDIpCSgwLDApCigwLDApCSgwLDApCSgwLDApCSgwLDIpCgooMCwxKQkoMCwxKQkoMCwxKQkoMCwxKQooMCwtMSkJKDAsLTEpCSgwLDEpCSgwLDEpCigwLC0xKQkoMCwxKQkoMCwtMSkJKDAsMSkKKDAsLTEpCSgwLDEpCSgwLDEpCSgwLC0xKQooMCwxKQkoMCwtMSkJKDAsLTEpCSgwLDEpCigwLDEpCSgwLC0xKQkoMCwxKQkoMCwtMSkKKDAsMSkJKDAsMSkJKDAsLTEpCSgwLC0xKQooMCwtMSkJKDAsLTEpCSgwLC0xKQkoMCwtMSkKCigwLC0yKQkoMCwwKQkoMCwwKQkoMCwwKQooMCwwKQkoMCwtMikJKDAsMCkJKDAsMCkKKDAsMCkJKDAsMCkJKDAsLTIpCSgwLDApCigwLDApCSgwLDApCSgwLDApCSgwLC0yKQoKKDAsLTEpCSgwLDEpCSgwLDEpCSgwLDEpCigwLDEpCSgwLC0xKQkoMCwxKQkoMCwxKQooMCwxKQkoMCwxKQkoMCwtMSkJKDAsMSkKKDAsMSkJKDAsMSkJKDAsMSkJKDAsLTEpCigwLC0xKQkoMCwtMSkJKDAsLTEpCSgwLDEpCigwLC0xKQkoMCwtMSkJKDAsMSkJKDAsLTEpCigwLC0xKQkoMCwxKQkoMCwtMSkJKDAsLTEpCigwLDEpCSgwLC0xKQkoMCwtMSkJKDAsLTEpCgoKCg==";
  var H4rootsRotationalSubgroupUrl = "data:null;base64,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";
  var H4rootsUrl = "data:null;base64,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"; // These imports work because we are using @rollup/plugin-url.

  var resources = {
    'binaryTetrahedralGroup': binaryTetrahedralGroupUrl,
    'H4roots-rotationalSubgroup': H4rootsRotationalSubgroupUrl,
    'H4roots': H4rootsUrl
  };

  var __extends = undefined && undefined.__extends || function () {
    var _extendStatics = function extendStatics(d, b) {
      _extendStatics = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (d, b) {
        d.__proto__ = b;
      } || function (d, b) {
        for (var p in b) {
          if (b.hasOwnProperty(p)) d[p] = b[p];
        }
      };

      return _extendStatics(d, b);
    };

    return function (d, b) {
      _extendStatics(d, b);

      function __() {
        this.constructor = d;
      }

      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  }();

  var __spreadArrays = undefined && undefined.__spreadArrays || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
      s += arguments[i].length;
    }

    for (var r = Array(s), k = 0, i = 0; i < il; i++) {
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
        r[k] = a[j];
      }
    }

    return r;
  };
  /* Generated from Java with JSweet 2.4.0-SNAPSHOT - http://www.jsweet.org */


  var javaemul;

  (function (javaemul) {
    (function (internal) {
      /**
      * Private implementation class for GWT. This API should not be
      * considered public or stable.
      * @class
      */
      var Coercions =
      /** @class */
      function () {
        function Coercions() {}
        /**
        * Coerce js int to 32 bits.
        * Trick related to JS and lack of integer rollover.
        * {@see com.google.gwt.lang.Cast#narrow_int}
        * @param {number} value
        * @return {number}
        */


        Coercions.ensureInt = function (value) {
          return value | 0;
        };

        return Coercions;
      }();

      internal.Coercions = Coercions;
      Coercions["__class"] = "javaemul.internal.Coercions";
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      var JreHelper =
      /** @class */
      function () {
        function JreHelper() {}

        JreHelper.LOG10E_$LI$ = function () {
          if (JreHelper.LOG10E == null) {
            JreHelper.LOG10E = Math.LOG10E;
          }

          return JreHelper.LOG10E;
        };

        return JreHelper;
      }();

      internal.JreHelper = JreHelper;
      JreHelper["__class"] = "javaemul.internal.JreHelper";
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      /**
      * Wraps native <code>boolean</code> as an object.
      * @param {boolean} value
      * @class
      */
      var BooleanHelper =
      /** @class */
      function () {
        function BooleanHelper() {}

        BooleanHelper.TYPE_$LI$ = function () {
          if (BooleanHelper.TYPE == null) {
            BooleanHelper.TYPE = Boolean;
          }

          return BooleanHelper.TYPE;
        };

        BooleanHelper.compare = function (x, y) {
          return x === y ? 0 : x ? 1 : -1;
        };

        BooleanHelper.hashCode = function (value) {
          return value ? 1231 : 1237;
        };

        BooleanHelper.logicalAnd = function (a, b) {
          return a && b;
        };

        BooleanHelper.logicalOr = function (a, b) {
          return a || b;
        };

        BooleanHelper.logicalXor = function (a, b) {
          return a !== b;
        };

        BooleanHelper.parseBoolean = function (s) {
          return (
            /* equalsIgnoreCase */
            function (o1, o2) {
              return o1.toUpperCase() === (o2 === null ? o2 : o2.toUpperCase());
            }("true", s)
          );
        };

        BooleanHelper.toString = function (x) {
          return (
            /* valueOf */
            new String(x).toString()
          );
        };

        BooleanHelper.valueOf$boolean = function (b) {
          return b ? BooleanHelper.TRUE : BooleanHelper.FALSE;
        };

        BooleanHelper.valueOf$java_lang_String = function (s) {
          return BooleanHelper.valueOf$boolean(BooleanHelper.parseBoolean(s));
        };

        BooleanHelper.valueOf = function (s) {
          if (typeof s === 'string' || s === null) {
            return javaemul.internal.BooleanHelper.valueOf$java_lang_String(s);
          } else if (typeof s === 'boolean' || s === null) {
            return javaemul.internal.BooleanHelper.valueOf$boolean(s);
          } else throw new Error('invalid overload');
        };

        BooleanHelper.prototype.booleanValue = function () {
          return BooleanHelper.unsafeCast(javaemul.internal.InternalPreconditions.checkNotNull(this));
        };
        /*private*/


        BooleanHelper.unsafeCast = function (value) {
          return value;
        };

        BooleanHelper.prototype.compareTo$javaemul_internal_BooleanHelper = function (b) {
          return BooleanHelper.compare(this.booleanValue(), b.booleanValue());
        };
        /**
        *
        * @param {javaemul.internal.BooleanHelper} b
        * @return {number}
        */


        BooleanHelper.prototype.compareTo = function (b) {
          if (b != null && b instanceof javaemul.internal.BooleanHelper || b === null) {
            return this.compareTo$javaemul_internal_BooleanHelper(b);
          } else throw new Error('invalid overload');
        };
        /**
        *
        * @param {*} o
        * @return {boolean}
        */


        BooleanHelper.prototype.equals = function (o) {
          return javaemul.internal.InternalPreconditions.checkNotNull(this) === o;
        };
        /**
        *
        * @return {number}
        */


        BooleanHelper.prototype.hashCode = function () {
          return BooleanHelper.hashCode(this.booleanValue());
        };
        /**
        *
        * @return {string}
        */


        BooleanHelper.prototype.toString = function () {
          return BooleanHelper.toString(this.booleanValue());
        };

        BooleanHelper.FALSE = false;
        BooleanHelper.TRUE = true;
        return BooleanHelper;
      }();

      internal.BooleanHelper = BooleanHelper;
      BooleanHelper["__class"] = "javaemul.internal.BooleanHelper";
      BooleanHelper["__interfaces"] = ["java.lang.Comparable", "java.io.Serializable"];
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      /**
      * Hashcode caching for strings.
      * @class
      */
      var StringHashCache =
      /** @class */
      function () {
        function StringHashCache() {}

        StringHashCache.back_$LI$ = function () {
          if (StringHashCache.back == null) {
            StringHashCache.back = StringHashCache.createNativeObject();
          }

          return StringHashCache.back;
        };

        StringHashCache.front_$LI$ = function () {
          if (StringHashCache.front == null) {
            StringHashCache.front = StringHashCache.createNativeObject();
          }

          return StringHashCache.front;
        };

        StringHashCache.getHashCode = function (str) {
          var key = ":" + str;
          var result = StringHashCache.getProperty(StringHashCache.front_$LI$(), key);

          if (!javaemul.internal.JsUtils.isUndefined(result)) {
            return StringHashCache.unsafeCastToInt(result);
          }

          result = StringHashCache.getProperty(StringHashCache.back_$LI$(), key);
          var hashCode = javaemul.internal.JsUtils.isUndefined(result) ? StringHashCache.compute(str) : StringHashCache.unsafeCastToInt(result);
          StringHashCache.increment();
          javaemul.internal.JsUtils.setIntProperty(StringHashCache.front_$LI$(), key, hashCode);
          return hashCode;
        };
        /*private*/


        StringHashCache.compute = function (str) {
          var hashCode = 0;
          var n = str.length;
          var nBatch = n - 4;
          var i = 0;

          while (i < nBatch) {
            {
              hashCode = function (c) {
                return c.charCodeAt == null ? c : c.charCodeAt(0);
              }(str.charAt(i + 3)) + 31 * (function (c) {
                return c.charCodeAt == null ? c : c.charCodeAt(0);
              }(str.charAt(i + 2)) + 31 * (function (c) {
                return c.charCodeAt == null ? c : c.charCodeAt(0);
              }(str.charAt(i + 1)) + 31 * (function (c) {
                return c.charCodeAt == null ? c : c.charCodeAt(0);
              }(str.charAt(i)) + 31 * hashCode)));

              hashCode = javaemul.internal.Coercions.ensureInt(hashCode);
              i += 4;
            }
          }

          while (i < n) {
            {
              hashCode = hashCode * 31 + function (c) {
                return c.charCodeAt == null ? c : c.charCodeAt(0);
              }(str.charAt(i++));
            }
          }

          hashCode = javaemul.internal.Coercions.ensureInt(hashCode);
          return hashCode;
        };
        /*private*/


        StringHashCache.increment = function () {
          if (StringHashCache.count === StringHashCache.MAX_CACHE) {
            StringHashCache.back = StringHashCache.front;
            StringHashCache.front = StringHashCache.createNativeObject();
            StringHashCache.count = 0;
          }

          ++StringHashCache.count;
        };
        /*private*/


        StringHashCache.getProperty = function (map, key) {
          return map[key];
        };
        /*private*/


        StringHashCache.createNativeObject = function () {
          return {};
        };
        /*private*/


        StringHashCache.unsafeCastToInt = function (o) {
          return o;
        };
        /**
        * Tracks the number of entries in front.
        */


        StringHashCache.count = 0;
        /**
        * Pulled this number out of thin air.
        */

        StringHashCache.MAX_CACHE = 256;
        return StringHashCache;
      }();

      internal.StringHashCache = StringHashCache;
      StringHashCache["__class"] = "javaemul.internal.StringHashCache";
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      (function (stream) {
        var ConsumingFunction =
        /** @class */
        function () {
          function ConsumingFunction(consumer) {
            if (this.consumer === undefined) {
              this.consumer = null;
            }

            this.consumer = consumer;
          }
          /**
          *
          * @param {*} t
          * @return {*}
          */


          ConsumingFunction.prototype.apply = function (t) {
            (function (target) {
              return typeof target === 'function' ? target(t) : target.accept(t);
            })(this.consumer);

            return t;
          };

          return ConsumingFunction;
        }();

        stream.ConsumingFunction = ConsumingFunction;
        ConsumingFunction["__class"] = "javaemul.internal.stream.ConsumingFunction";
        ConsumingFunction["__interfaces"] = ["java.util.function.Function"];
      })(internal.stream || (internal.stream = {}));
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      (function (stream) {
        var TerminalStreamRow =
        /** @class */
        function () {
          function TerminalStreamRow() {}

          TerminalStreamRow.prototype.chain = function (next) {
            if (next.constructor === javaemul.internal.stream.StreamRowEnd) {
              return;
            }

            throw new java.lang.IllegalStateException();
          };

          TerminalStreamRow.prototype.end = function () {};

          return TerminalStreamRow;
        }();

        stream.TerminalStreamRow = TerminalStreamRow;
        TerminalStreamRow["__class"] = "javaemul.internal.stream.TerminalStreamRow";
        TerminalStreamRow["__interfaces"] = ["javaemul.internal.stream.StreamRow"];
      })(internal.stream || (internal.stream = {}));
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      (function (stream) {
        var RunnableChain =
        /** @class */
        function () {
          function RunnableChain(run) {
            if (this.run === undefined) {
              this.run = null;
            }

            if (this.next === undefined) {
              this.next = null;
            }

            this.run = run;
          }

          RunnableChain.prototype.chain = function (next) {
            if (this.next == null) {
              this.next = next;
              return;
            }

            this.next.chain(next);
          };

          RunnableChain.prototype.runChain = function () {
            (function (target) {
              return target['run'] === undefined ? target : target['run'];
            })(this.run)();

            if (this.next == null) {
              return;
            }

            this.next.runChain();
          };

          return RunnableChain;
        }();

        stream.RunnableChain = RunnableChain;
        RunnableChain["__class"] = "javaemul.internal.stream.RunnableChain";
      })(internal.stream || (internal.stream = {}));
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      (function (stream) {
        var QuiteRunnable =
        /** @class */
        function () {
          function QuiteRunnable(loudRunnable) {
            if (this.loudRunnable === undefined) {
              this.loudRunnable = null;
            }

            this.loudRunnable = loudRunnable;
          }
          /**
          *
          */


          QuiteRunnable.prototype.run = function () {
            try {
              (function (target) {
                return target['run'] === undefined ? target : target['run'];
              })(this.loudRunnable)();
            } catch (e) {
              console.error(e.message, e);
            }
          };

          return QuiteRunnable;
        }();

        stream.QuiteRunnable = QuiteRunnable;
        QuiteRunnable["__class"] = "javaemul.internal.stream.QuiteRunnable";
        QuiteRunnable["__interfaces"] = ["java.lang.Runnable"];
      })(internal.stream || (internal.stream = {}));
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      (function (stream) {
        var ChooseSmallest =
        /** @class */
        function () {
          function ChooseSmallest(comparator) {
            if (this.comparator === undefined) {
              this.comparator = null;
            }

            this.comparator = comparator;
          }

          ChooseSmallest.prototype.apply = function (t1, t2) {
            if (function (target) {
              return target['compare'] === undefined ? target : target['compare'];
            }(this.comparator)(t1, t2) <= 0) {
              return t1;
            }

            return t2;
          };

          return ChooseSmallest;
        }();

        stream.ChooseSmallest = ChooseSmallest;
        ChooseSmallest["__class"] = "javaemul.internal.stream.ChooseSmallest";
        ChooseSmallest["__interfaces"] = ["java.util.function.BiFunction", "java.util.function.BinaryOperator"];
      })(internal.stream || (internal.stream = {}));
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      (function (stream) {
        var StreamHelper =
        /** @class */
        function () {
          function StreamHelper(data) {
            if (this.onCloseChain === undefined) {
              this.onCloseChain = null;
            }

            if (this.head === undefined) {
              this.head = null;
            }

            if (this.end === undefined) {
              this.end = null;
            }

            if (this.data === undefined) {
              this.data = null;
            }

            this.head = new javaemul.internal.stream.StreamRowMap(function (o) {
              return o;
            });
            this.end = new javaemul.internal.stream.StreamRowEnd(this.head);
            this.head.chain(this.end);
            this.data = data;
          }
          /*private*/


          StreamHelper.prototype.chain = function (streamRow) {
            this.end.chain(streamRow);
            return this;
          };
          /*private*/


          StreamHelper.prototype.play = function () {
            for (var index121 = this.data.iterator(); index121.hasNext();) {
              var item = index121.next();
              {
                if (!this.head.item(item)) {
                  break;
                }
              }
            }

            this.head.end();
          };
          /*private*/


          StreamHelper.prototype.foldRight = function (identity, accumulator) {
            var rowReduce = new javaemul.internal.stream.StreamRowReduce(identity, accumulator);
            this.chain(rowReduce);
            this.play();
            return rowReduce.getResult();
          };

          StreamHelper.prototype.filter = function (predicate) {
            return this.chain(new javaemul.internal.stream.StreamRowFilter(predicate));
          };

          StreamHelper.prototype.map = function (mapper) {
            return this.chain(new javaemul.internal.stream.StreamRowMap(mapper));
          };

          StreamHelper.prototype.mapToObj = function (mapper) {
            return this.chain(new javaemul.internal.stream.StreamRowMap(function (n) {
              return function (target) {
                return typeof target === 'function' ? target(n) : target.apply(n);
              }(mapper);
            }));
          };

          StreamHelper.prototype.flatMap = function (mapper) {
            return this.chain(new javaemul.internal.stream.StreamRowFlatMap(mapper));
          };

          StreamHelper.prototype.distinct = function () {
            return this.chain(new javaemul.internal.stream.StreamRowCollector(new java.util.LinkedHashSet()));
          };

          StreamHelper.prototype.sorted$ = function () {
            return this.sorted$java_util_Comparator(function (a, b) {
              return a.compareTo(b);
            });
          };

          StreamHelper.prototype.sorted$java_util_Comparator = function (comparator) {
            return this.chain(new javaemul.internal.stream.StreamRowSortingCollector(new java.util.ArrayList(), comparator));
          };

          StreamHelper.prototype.sorted = function (comparator) {
            if (typeof comparator === 'function' && comparator.length === 2 || comparator === null) {
              return this.sorted$java_util_Comparator(comparator);
            } else if (comparator === undefined) {
              return this.sorted$();
            } else throw new Error('invalid overload');
          };

          StreamHelper.prototype.peek = function (action) {
            var f = new javaemul.internal.stream.ConsumingFunction(action);
            return this.chain(new javaemul.internal.stream.StreamRowMap(function (arg0) {
              return f.apply(arg0);
            }));
          };

          StreamHelper.prototype.limit = function (maxSize) {
            var p = new javaemul.internal.stream.CountingPredicate(maxSize);
            return this.chain(new javaemul.internal.stream.StreamRowFilterFlop(function (arg0) {
              return p.test(arg0);
            }));
          };

          StreamHelper.prototype.skip = function (n) {
            var p = new javaemul.internal.stream.CountingPredicate(n);
            return this.chain(new javaemul.internal.stream.StreamRowFilter(function (p) {
              return function (v) {
                return !p.test(v);
              };
            }(p)));
          };

          StreamHelper.prototype.forEach = function (action) {
            this.peek(action);
            this.play();
          };

          StreamHelper.prototype.forEachOrdered = function (action) {
            this.forEach(action);
          };

          StreamHelper.prototype.toArray$ = function () {
            var result = new java.util.ArrayList();
            this.chain(new javaemul.internal.stream.StreamRowCollector(result));
            this.play();
            return result['toArray$']();
          };

          StreamHelper.prototype.toArray$java_util_function_IntFunction = function (generator) {
            var result = new java.util.ArrayList();
            this.chain(new javaemul.internal.stream.StreamRowCollector(result));
            this.play();
            return result['toArray$java_lang_Object_A'](function (target) {
              return typeof target === 'function' ? target(result.size()) : target.apply(result.size());
            }(generator));
          };

          StreamHelper.prototype.toArray = function (generator) {
            if (typeof generator === 'function' && generator.length === 1 || generator === null) {
              return this.toArray$java_util_function_IntFunction(generator);
            } else if (generator === undefined) {
              return this.toArray$();
            } else throw new Error('invalid overload');
          };

          StreamHelper.prototype.reduce$java_lang_Object$java_util_function_BinaryOperator = function (identity, accumulator) {
            return this.foldRight(java.util.Optional.of(identity), accumulator).get();
          };

          StreamHelper.prototype.reduce$java_util_function_BinaryOperator = function (accumulator) {
            return this.foldRight(java.util.Optional.empty(), accumulator);
          };

          StreamHelper.prototype.collect$java_util_stream_Collector = function (collector) {
            var container = function (target) {
              return typeof target === 'function' ? target() : target.get();
            }(collector.supplier());

            var accumulator = collector.accumulator();
            var f = new javaemul.internal.stream.ConsumingFunction(function (container, accumulator) {
              return function (item) {
                return function (target) {
                  return typeof target === 'function' ? target(container, item) : target.accept(container, item);
                }(accumulator);
              };
            }(container, accumulator));
            this.chain(new javaemul.internal.stream.StreamRowMap(function (arg0) {
              return f.apply(arg0);
            }));
            this.play();
            return container;
          };

          StreamHelper.prototype.min = function (comparator) {
            return this.foldRight(java.util.Optional.empty(), function (a, b) {
              return function (target) {
                return target['compare'] === undefined ? target : target['compare'];
              }(comparator)(a, b) <= 0 ? a : b;
            });
          };

          StreamHelper.prototype.max = function (comparator) {
            return this.foldRight(java.util.Optional.empty(), function (a, b) {
              return function (target) {
                return target['compare'] === undefined ? target : target['compare'];
              }(comparator)(a, b) >= 0 ? a : b;
            });
          };

          StreamHelper.prototype.count = function () {
            var counter = new javaemul.internal.stream.StreamRowCount();
            this.chain(counter);
            this.play();
            return counter.getCount();
          };

          StreamHelper.prototype.anyMatch = function (predicate) {
            var streamRow = new javaemul.internal.stream.StreamRowOnceFilter(predicate);
            this.chain(streamRow);
            this.play();
            return streamRow.getPredicateValue();
          };

          StreamHelper.prototype.allMatch = function (predicate) {
            var streamRow = new javaemul.internal.stream.StreamRowAllFilter(predicate);
            this.chain(streamRow);
            this.play();
            return streamRow.getPredicateValue();
          };

          StreamHelper.prototype.noneMatch = function (predicate) {
            return this.allMatch(function (v) {
              return !function (target) {
                return typeof target === 'function' ? target(v) : target.test(v);
              }(predicate);
            });
          };

          StreamHelper.prototype.findFirst = function () {
            var streamRow = new javaemul.internal.stream.StreamRowOnceFilter(function (o) {
              return true;
            });
            this.chain(streamRow);
            this.play();
            return streamRow.getFirstMatch();
          };

          StreamHelper.prototype.findAny = function () {
            return this.findFirst();
          };

          StreamHelper.prototype.iterator = function () {
            var result = new java.util.ArrayList();
            this.chain(new javaemul.internal.stream.StreamRowCollector(result));
            this.play();
            return result.iterator();
          };

          StreamHelper.prototype.isParallel = function () {
            return false;
          };

          StreamHelper.prototype.sequential = function () {
            return this;
          };

          StreamHelper.prototype.parallel = function () {
            return this;
          };

          StreamHelper.prototype.unordered = function () {
            return this;
          };

          StreamHelper.prototype.onClose = function (closeHandler) {
            var chainItem = new javaemul.internal.stream.RunnableChain(function () {
              return new javaemul.internal.stream.QuiteRunnable(closeHandler).run();
            });

            if (this.onCloseChain == null) {
              this.onCloseChain = chainItem;
            } else {
              this.onCloseChain.chain(chainItem);
            }

            return this;
          };

          StreamHelper.prototype.close = function () {
            if (this.onCloseChain == null) {
              return;
            }

            this.onCloseChain.runChain();
          };

          StreamHelper.prototype.mapToInt = function (mapper) {
            throw new java.lang.IllegalStateException();
          };

          StreamHelper.prototype.mapToLong = function (mapper) {
            throw new java.lang.IllegalStateException();
          };

          StreamHelper.prototype.mapToDouble = function (mapper) {
            throw new java.lang.IllegalStateException();
          };

          StreamHelper.prototype.flatMapToInt = function (mapper) {
            throw new java.lang.IllegalStateException();
          };

          StreamHelper.prototype.flatMapToLong = function (mapper) {
            throw new java.lang.IllegalStateException();
          };

          StreamHelper.prototype.flatMapToDouble = function (mapper) {
            throw new java.lang.IllegalStateException();
          };

          StreamHelper.prototype.spliterator = function () {
            throw new java.lang.IllegalStateException();
          };

          StreamHelper.prototype.reduce$java_lang_Object$java_util_function_BiFunction$java_util_function_BinaryOperator = function (identity, accumulator, combiner) {
            throw new java.lang.IllegalStateException();
          };

          StreamHelper.prototype.reduce = function (identity, accumulator, combiner) {
            if ((identity != null || identity === null) && (typeof accumulator === 'function' && accumulator.length === 2 || accumulator === null) && (typeof combiner === 'function' && combiner.length === 2 || combiner === null)) {
              return this.reduce$java_lang_Object$java_util_function_BiFunction$java_util_function_BinaryOperator(identity, accumulator, combiner);
            } else if ((identity != null || identity === null) && (typeof accumulator === 'function' && accumulator.length === 2 || accumulator === null) && combiner === undefined) {
              return this.reduce$java_lang_Object$java_util_function_BinaryOperator(identity, accumulator);
            } else if ((typeof identity === 'function' && identity.length === 2 || identity === null) && accumulator === undefined && combiner === undefined) {
              return this.reduce$java_util_function_BinaryOperator(identity);
            } else throw new Error('invalid overload');
          };

          StreamHelper.prototype.collect$java_util_function_Supplier$java_util_function_BiConsumer$java_util_function_BiConsumer = function (supplier, accumulator, combiner) {
            throw new java.lang.IllegalStateException();
          };

          StreamHelper.prototype.collect = function (supplier, accumulator, combiner) {
            if ((typeof supplier === 'function' && supplier.length === 0 || supplier === null) && (typeof accumulator === 'function' && accumulator.length === 2 || accumulator === null) && (typeof combiner === 'function' && combiner.length === 2 || combiner === null)) {
              return this.collect$java_util_function_Supplier$java_util_function_BiConsumer$java_util_function_BiConsumer(supplier, accumulator, combiner);
            } else if ((supplier != null && supplier.constructor != null && supplier.constructor["__interfaces"] != null && supplier.constructor["__interfaces"].indexOf("java.util.stream.Collector") >= 0 || supplier === null) && accumulator === undefined && combiner === undefined) {
              return this.collect$java_util_stream_Collector(supplier);
            } else throw new Error('invalid overload');
          };

          return StreamHelper;
        }();

        stream.StreamHelper = StreamHelper;
        StreamHelper["__class"] = "javaemul.internal.stream.StreamHelper";
        StreamHelper["__interfaces"] = ["java.util.stream.Stream"];
      })(internal.stream || (internal.stream = {}));
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      (function (stream) {
        var CountingPredicate =
        /** @class */
        function () {
          function CountingPredicate(n) {
            if (this.countDown === undefined) {
              this.countDown = 0;
            }

            this.countDown = n;
          }
          /**
          *
          * @param {*} t
          * @return {boolean}
          */


          CountingPredicate.prototype.test = function (t) {
            if (this.countDown <= 0) {
              return false;
            }

            --this.countDown;
            return true;
          };

          return CountingPredicate;
        }();

        stream.CountingPredicate = CountingPredicate;
        CountingPredicate["__class"] = "javaemul.internal.stream.CountingPredicate";
        CountingPredicate["__interfaces"] = ["java.util.function.Predicate"];
      })(internal.stream || (internal.stream = {}));
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      (function (stream) {
        var TransientStreamRow =
        /** @class */
        function () {
          function TransientStreamRow() {
            if (this.next === undefined) {
              this.next = null;
            }
          }

          TransientStreamRow.prototype.chain = function (next) {
            this.next = next;
          };

          return TransientStreamRow;
        }();

        stream.TransientStreamRow = TransientStreamRow;
        TransientStreamRow["__class"] = "javaemul.internal.stream.TransientStreamRow";
        TransientStreamRow["__interfaces"] = ["javaemul.internal.stream.StreamRow"];
      })(internal.stream || (internal.stream = {}));
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      (function (stream) {
        var VoidRunnable =
        /** @class */
        function () {
          function VoidRunnable() {}

          VoidRunnable.dryRun_$LI$ = function () {
            if (VoidRunnable.dryRun == null) {
              VoidRunnable.dryRun = new VoidRunnable();
            }

            return VoidRunnable.dryRun;
          };

          VoidRunnable.prototype.run = function () {};

          return VoidRunnable;
        }();

        stream.VoidRunnable = VoidRunnable;
        VoidRunnable["__class"] = "javaemul.internal.stream.VoidRunnable";
        VoidRunnable["__interfaces"] = ["java.lang.Runnable"];
      })(internal.stream || (internal.stream = {}));
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      /**
      * Provides an interface for simple JavaScript idioms that can not be expressed in Java.
      * @class
      */
      var JsUtils =
      /** @class */
      function () {
        function JsUtils() {}

        JsUtils.getInfinity = function () {
          return Infinity;
        };

        JsUtils.isUndefined = function (value) {
          return value == null;
        };

        JsUtils.unsafeCastToString = function (string) {
          return string;
        };

        JsUtils.setPropertySafe = function (map, key, value) {
          try {
            map[key] = value;
          } catch (e) {}
        };

        JsUtils.getIntProperty = function (map, key) {
          return map[key];
        };

        JsUtils.setIntProperty = function (map, key, value) {
          map[key] = value;
        };

        JsUtils.typeOf = function (o) {
          return _typeof(o);
        };

        return JsUtils;
      }();

      internal.JsUtils = JsUtils;
      JsUtils["__class"] = "javaemul.internal.JsUtils";
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      /**
      * A helper class for long comparison.
      * @class
      */
      var LongCompareHolder =
      /** @class */
      function () {
        function LongCompareHolder() {}

        LongCompareHolder.getLongComparator = function () {
          return function (l1, l2) {
            return l2 - l1;
          };
        };

        return LongCompareHolder;
      }();

      internal.LongCompareHolder = LongCompareHolder;
      LongCompareHolder["__class"] = "javaemul.internal.LongCompareHolder";
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      var ObjectHelper =
      /** @class */
      function () {
        function ObjectHelper() {}

        ObjectHelper.clone = function (obj) {
          var copy;
          if (null == obj || "object" != _typeof(obj)) return obj;

          if (obj instanceof Date) {
            copy = new Date();
            copy.setTime(obj.getTime());
            return copy;
          }

          if (obj instanceof Array) {
            copy = [];

            for (var i = 0, len = obj.length; i < len; i++) {
              copy[i] = javaemul.internal.ObjectHelper.clone(obj[i]);
            }

            return copy;
          }

          if (obj instanceof Object) {
            copy = {};

            for (var attr in obj) {
              if (obj.hasOwnProperty(attr)) copy[attr] = javaemul.internal.ObjectHelper.clone(obj[attr]);
            }

            return copy;
          }

          throw new Error("Unable to copy obj! Its type isn\'t supported.");
        };

        return ObjectHelper;
      }();

      internal.ObjectHelper = ObjectHelper;
      ObjectHelper["__class"] = "javaemul.internal.ObjectHelper";
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      /**
      * Wraps a native <code>char</code> as an object.
      *
      * TODO(jat): many of the classification methods implemented here are not
      * correct in that they only handle ASCII characters, and many other methods are
      * not currently implemented. I think the proper approach is to introduce * a
      * deferred binding parameter which substitutes an implementation using a
      * fully-correct Unicode character database, at the expense of additional data
      * being downloaded. That way developers that need the functionality can get it
      * without those who don't need it paying for it.
      *
      * <pre>
      * The following methods are still not implemented -- most would require Unicode
      * character db to be useful:
      * - digit / is* / to*(int codePoint)
      * - isDefined(char)
      * - isIdentifierIgnorable(char)
      * - isJavaIdentifierPart(char)
      * - isJavaIdentifierStart(char)
      * - isJavaLetter(char) -- deprecated, so probably not
      * - isJavaLetterOrDigit(char) -- deprecated, so probably not
      * - isISOControl(char)
      * - isMirrored(char)
      * - isSpaceChar(char)
      * - isTitleCase(char)
      * - isUnicodeIdentifierPart(char)
      * - isUnicodeIdentifierStart(char)
      * - getDirectionality(*)
      * - getNumericValue(*)
      * - getType(*)
      * - reverseBytes(char) -- any use for this at all in the browser?
      * - toTitleCase(*)
      * - all the category constants for classification
      *
      * The following do not properly handle characters outside of ASCII:
      * - digit(char c, int radix)
      * - isDigit(char c)
      * - isLetter(char c)
      * - isLetterOrDigit(char c)
      * - isLowerCase(char c)
      * - isUpperCase(char c)
      * </pre>
      * @param {string} value
      * @class
      */
      var CharacterHelper =
      /** @class */
      function () {
        function CharacterHelper(value) {
          if (this.value === undefined) {
            this.value = null;
          }

          this.value = value;
        }

        CharacterHelper.TYPE_$LI$ = function () {
          if (CharacterHelper.TYPE == null) {
            CharacterHelper.TYPE = String;
          }

          return CharacterHelper.TYPE;
        };

        CharacterHelper.charCount = function (codePoint) {
          return codePoint >= CharacterHelper.MIN_SUPPLEMENTARY_CODE_POINT ? 2 : 1;
        };

        CharacterHelper.codePointAt$char_A$int = function (a, index) {
          return CharacterHelper.codePointAt$java_lang_CharSequence$int$int(new String(a), index, a.length);
        };

        CharacterHelper.codePointAt$char_A$int$int = function (a, index, limit) {
          return CharacterHelper.codePointAt$java_lang_CharSequence$int$int(new String(a), index, limit);
        };

        CharacterHelper.codePointAt = function (a, index, limit) {
          if ((a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'string') || a === null) && (typeof index === 'number' || index === null) && (typeof limit === 'number' || limit === null)) {
            return javaemul.internal.CharacterHelper.codePointAt$char_A$int$int(a, index, limit);
          } else if ((a != null && (a.constructor != null && a.constructor["__interfaces"] != null && a.constructor["__interfaces"].indexOf("java.lang.CharSequence") >= 0 || typeof a === "string") || a === null) && (typeof index === 'number' || index === null) && (typeof limit === 'number' || limit === null)) {
            return javaemul.internal.CharacterHelper.codePointAt$java_lang_CharSequence$int$int(a, index, limit);
          } else if ((a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'string') || a === null) && (typeof index === 'number' || index === null) && limit === undefined) {
            return javaemul.internal.CharacterHelper.codePointAt$char_A$int(a, index);
          } else if ((a != null && (a.constructor != null && a.constructor["__interfaces"] != null && a.constructor["__interfaces"].indexOf("java.lang.CharSequence") >= 0 || typeof a === "string") || a === null) && (typeof index === 'number' || index === null) && limit === undefined) {
            return javaemul.internal.CharacterHelper.codePointAt$java_lang_CharSequence$int(a, index);
          } else throw new Error('invalid overload');
        };

        CharacterHelper.codePointAt$java_lang_CharSequence$int = function (seq, index) {
          return CharacterHelper.codePointAt$java_lang_CharSequence$int$int(seq, index, seq.length);
        };

        CharacterHelper.codePointBefore$char_A$int = function (a, index) {
          return CharacterHelper.codePointBefore$java_lang_CharSequence$int$int(new String(a), index, 0);
        };

        CharacterHelper.codePointBefore$char_A$int$int = function (a, index, start) {
          return CharacterHelper.codePointBefore$java_lang_CharSequence$int$int(new String(a), index, start);
        };

        CharacterHelper.codePointBefore = function (a, index, start) {
          if ((a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'string') || a === null) && (typeof index === 'number' || index === null) && (typeof start === 'number' || start === null)) {
            return javaemul.internal.CharacterHelper.codePointBefore$char_A$int$int(a, index, start);
          } else if ((a != null && (a.constructor != null && a.constructor["__interfaces"] != null && a.constructor["__interfaces"].indexOf("java.lang.CharSequence") >= 0 || typeof a === "string") || a === null) && (typeof index === 'number' || index === null) && (typeof start === 'number' || start === null)) {
            return javaemul.internal.CharacterHelper.codePointBefore$java_lang_CharSequence$int$int(a, index, start);
          } else if ((a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'string') || a === null) && (typeof index === 'number' || index === null) && start === undefined) {
            return javaemul.internal.CharacterHelper.codePointBefore$char_A$int(a, index);
          } else if ((a != null && (a.constructor != null && a.constructor["__interfaces"] != null && a.constructor["__interfaces"].indexOf("java.lang.CharSequence") >= 0 || typeof a === "string") || a === null) && (typeof index === 'number' || index === null) && start === undefined) {
            return javaemul.internal.CharacterHelper.codePointBefore$java_lang_CharSequence$int(a, index);
          } else throw new Error('invalid overload');
        };

        CharacterHelper.codePointBefore$java_lang_CharSequence$int = function (cs, index) {
          return CharacterHelper.codePointBefore$java_lang_CharSequence$int$int(cs, index, 0);
        };

        CharacterHelper.codePointCount$char_A$int$int = function (a, offset, count) {
          return CharacterHelper.codePointCount$java_lang_CharSequence$int$int(new String(a), offset, offset + count);
        };

        CharacterHelper.codePointCount = function (a, offset, count) {
          if ((a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'string') || a === null) && (typeof offset === 'number' || offset === null) && (typeof count === 'number' || count === null)) {
            return javaemul.internal.CharacterHelper.codePointCount$char_A$int$int(a, offset, count);
          } else if ((a != null && (a.constructor != null && a.constructor["__interfaces"] != null && a.constructor["__interfaces"].indexOf("java.lang.CharSequence") >= 0 || typeof a === "string") || a === null) && (typeof offset === 'number' || offset === null) && (typeof count === 'number' || count === null)) {
            return javaemul.internal.CharacterHelper.codePointCount$java_lang_CharSequence$int$int(a, offset, count);
          } else throw new Error('invalid overload');
        };

        CharacterHelper.codePointCount$java_lang_CharSequence$int$int = function (seq, beginIndex, endIndex) {
          var count = 0;

          for (var idx = beginIndex; idx < endIndex;) {
            {
              var ch = seq.charAt(idx++);

              if (CharacterHelper.isHighSurrogate(ch) && idx < endIndex && CharacterHelper.isLowSurrogate(seq.charAt(idx))) {
                ++idx;
              }

              ++count;
            }
          }

          return count;
        };

        CharacterHelper.compare = function (x, y) {
          return function (c) {
            return c.charCodeAt == null ? c : c.charCodeAt(0);
          }(x) - function (c) {
            return c.charCodeAt == null ? c : c.charCodeAt(0);
          }(y);
        };

        CharacterHelper.digit = function (c, radix) {
          if (radix < CharacterHelper.MIN_RADIX || radix > CharacterHelper.MAX_RADIX) {
            return -1;
          }

          if (function (c) {
            return c.charCodeAt == null ? c : c.charCodeAt(0);
          }(c) >= '0'.charCodeAt(0) && function (c) {
            return c.charCodeAt == null ? c : c.charCodeAt(0);
          }(c) < '0'.charCodeAt(0) + Math.min(radix, 10)) {
            return function (c) {
              return c.charCodeAt == null ? c : c.charCodeAt(0);
            }(c) - '0'.charCodeAt(0);
          }

          if (function (c) {
            return c.charCodeAt == null ? c : c.charCodeAt(0);
          }(c) >= 'a'.charCodeAt(0) && function (c) {
            return c.charCodeAt == null ? c : c.charCodeAt(0);
          }(c) < radix + 'a'.charCodeAt(0) - 10) {
            return function (c) {
              return c.charCodeAt == null ? c : c.charCodeAt(0);
            }(c) - 'a'.charCodeAt(0) + 10;
          }

          if (function (c) {
            return c.charCodeAt == null ? c : c.charCodeAt(0);
          }(c) >= 'A'.charCodeAt(0) && function (c) {
            return c.charCodeAt == null ? c : c.charCodeAt(0);
          }(c) < radix + 'A'.charCodeAt(0) - 10) {
            return function (c) {
              return c.charCodeAt == null ? c : c.charCodeAt(0);
            }(c) - 'A'.charCodeAt(0) + 10;
          }

          return -1;
        };

        CharacterHelper.getNumericValue = function (ch) {
          return ch.charCodeAt(0) | 0;
        };

        CharacterHelper.forDigit$int$int = function (digit, radix) {
          if (radix < CharacterHelper.MIN_RADIX || radix > CharacterHelper.MAX_RADIX) {
            return String.fromCharCode(0);
          }

          if (digit < 0 || digit >= radix) {
            return String.fromCharCode(0);
          }

          return CharacterHelper.forDigit$int(digit);
        };

        CharacterHelper.forDigit = function (digit, radix) {
          if ((typeof digit === 'number' || digit === null) && (typeof radix === 'number' || radix === null)) {
            return javaemul.internal.CharacterHelper.forDigit$int$int(digit, radix);
          } else if ((typeof digit === 'number' || digit === null) && radix === undefined) {
            return javaemul.internal.CharacterHelper.forDigit$int(digit);
          } else throw new Error('invalid overload');
        };
        /**
        * @skip
        *
        * public for shared implementation with Arrays.hashCode
        * @param {string} c
        * @return {number}
        */


        CharacterHelper.hashCode = function (c) {
          return c.charCodeAt(0);
        };

        CharacterHelper.isDigit = function (c) {
          var result =
          /* valueOf */
          new String(c).toString().match(CharacterHelper.digitRegex());
          return result != null && result.length > 0;
        };

        CharacterHelper.digitRegex = function () {
          return new RegExp("\\d");
        };

        CharacterHelper.isHighSurrogate = function (ch) {
          return function (c) {
            return c.charCodeAt == null ? c : c.charCodeAt(0);
          }(ch) >= function (c) {
            return c.charCodeAt == null ? c : c.charCodeAt(0);
          }(CharacterHelper.MIN_HIGH_SURROGATE) && function (c) {
            return c.charCodeAt == null ? c : c.charCodeAt(0);
          }(ch) <= function (c) {
            return c.charCodeAt == null ? c : c.charCodeAt(0);
          }(CharacterHelper.MAX_HIGH_SURROGATE);
        };

        CharacterHelper.isLetter = function (c) {
          return (
            /* valueOf */
            new String(c).toString().match(CharacterHelper.leterRegex()).length > 0
          );
        };

        CharacterHelper.leterRegex = function () {
          return new RegExp("[A-Z]", "i");
        };

        CharacterHelper.isLetterOrDigit = function (c) {
          var array =
          /* valueOf */
          new String(c).toString().match(CharacterHelper.leterOrDigitRegex());
          if (array != null) return (
            /* valueOf */
            new String(c).toString().match(CharacterHelper.leterOrDigitRegex()).length > 0
          );
          return false;
        };

        CharacterHelper.leterOrDigitRegex = function () {
          return new RegExp("[A-Z\\d]", "i");
        };

        CharacterHelper.isLowerCase = function (c) {
          return function (c) {
            return c.charCodeAt == null ? c : c.charCodeAt(0);
          }(CharacterHelper.toLowerCase$char(c)) == function (c) {
            return c.charCodeAt == null ? c : c.charCodeAt(0);
          }(c) && CharacterHelper.isLetter(c);
        };

        CharacterHelper.isLowSurrogate = function (ch) {
          return function (c) {
            return c.charCodeAt == null ? c : c.charCodeAt(0);
          }(ch) >= function (c) {
            return c.charCodeAt == null ? c : c.charCodeAt(0);
          }(CharacterHelper.MIN_LOW_SURROGATE) && function (c) {
            return c.charCodeAt == null ? c : c.charCodeAt(0);
          }(ch) <= function (c) {
            return c.charCodeAt == null ? c : c.charCodeAt(0);
          }(CharacterHelper.MAX_LOW_SURROGATE);
        };
        /**
        * Deprecated - see isWhitespace(char).
        * @param {string} c
        * @return {boolean}
        */


        CharacterHelper.isSpace = function (c) {
          switch (c.charCodeAt(0)) {
            case 32
            /* ' ' */
            :
              return true;

            case 10
            /* '\n' */
            :
              return true;

            case 9
            /* '\t' */
            :
              return true;

            case 12
            /* '\f' */
            :
              return true;

            case 13
            /* '\r' */
            :
              return true;

            default:
              return false;
          }
        };

        CharacterHelper.isWhitespace$char = function (ch) {
          return (
            /* valueOf */
            new String(ch).toString().match(CharacterHelper.whitespaceRegex()).length > 0
          );
        };

        CharacterHelper.isWhitespace = function (ch) {
          if (typeof ch === 'string' || ch === null) {
            return javaemul.internal.CharacterHelper.isWhitespace$char(ch);
          } else if (typeof ch === 'number' || ch === null) {
            return javaemul.internal.CharacterHelper.isWhitespace$int(ch);
          } else throw new Error('invalid overload');
        };

        CharacterHelper.isWhitespace$int = function (codePoint) {
          return String.fromCharCode(codePoint).match(CharacterHelper.whitespaceRegex()).length > 0;
        };

        CharacterHelper.whitespaceRegex = function () {
          return new RegExp("[\\t-\\r \\u1680\\u180E\\u2000-\\u2006\\u2008-\\u200A\\u2028\\u2029\\u205F\\u3000\\uFEFF]|[\\x1C-\\x1F]");
        };

        CharacterHelper.isSupplementaryCodePoint = function (codePoint) {
          return codePoint >= CharacterHelper.MIN_SUPPLEMENTARY_CODE_POINT && codePoint <= CharacterHelper.MAX_CODE_POINT;
        };

        CharacterHelper.isSurrogatePair = function (highSurrogate, lowSurrogate) {
          return CharacterHelper.isHighSurrogate(highSurrogate) && CharacterHelper.isLowSurrogate(lowSurrogate);
        };

        CharacterHelper.isUpperCase = function (c) {
          return function (c) {
            return c.charCodeAt == null ? c : c.charCodeAt(0);
          }(CharacterHelper.toUpperCase$char(c)) == function (c) {
            return c.charCodeAt == null ? c : c.charCodeAt(0);
          }(c) && CharacterHelper.isLetter(c);
        };

        CharacterHelper.isValidCodePoint = function (codePoint) {
          return codePoint >= CharacterHelper.MIN_CODE_POINT && codePoint <= CharacterHelper.MAX_CODE_POINT;
        };

        CharacterHelper.offsetByCodePoints$char_A$int$int$int$int = function (a, start, count, index, codePointOffset) {
          return CharacterHelper.offsetByCodePoints$java_lang_CharSequence$int$int(function (str, index, len) {
            return str.substring(index, index + len);
          }(a.join(''), start, count), index, codePointOffset);
        };

        CharacterHelper.offsetByCodePoints = function (a, start, count, index, codePointOffset) {
          if ((a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'string') || a === null) && (typeof start === 'number' || start === null) && (typeof count === 'number' || count === null) && (typeof index === 'number' || index === null) && (typeof codePointOffset === 'number' || codePointOffset === null)) {
            return javaemul.internal.CharacterHelper.offsetByCodePoints$char_A$int$int$int$int(a, start, count, index, codePointOffset);
          } else if ((a != null && (a.constructor != null && a.constructor["__interfaces"] != null && a.constructor["__interfaces"].indexOf("java.lang.CharSequence") >= 0 || typeof a === "string") || a === null) && (typeof start === 'number' || start === null) && (typeof count === 'number' || count === null) && index === undefined && codePointOffset === undefined) {
            return javaemul.internal.CharacterHelper.offsetByCodePoints$java_lang_CharSequence$int$int(a, start, count);
          } else throw new Error('invalid overload');
        };

        CharacterHelper.offsetByCodePoints$java_lang_CharSequence$int$int = function (seq, index, codePointOffset) {
          if (codePointOffset < 0) {
            while (codePointOffset < 0) {
              {
                --index;

                if (CharacterHelper.isLowSurrogate(seq.charAt(index)) && CharacterHelper.isHighSurrogate(seq.charAt(index - 1))) {
                  --index;
                }

                ++codePointOffset;
              }
            }
          } else {
            while (codePointOffset > 0) {
              {
                if (CharacterHelper.isHighSurrogate(seq.charAt(index)) && CharacterHelper.isLowSurrogate(seq.charAt(index + 1))) {
                  ++index;
                }

                ++index;
                --codePointOffset;
              }
            }
          }

          return index;
        };

        CharacterHelper.toChars$int = function (codePoint) {
          javaemul.internal.InternalPreconditions.checkCriticalArgument(codePoint >= 0 && codePoint <= CharacterHelper.MAX_CODE_POINT, "CodePoint %s not in range [%s, %s]",
          /* toString */
          '' + codePoint, "0",
          /* toString */
          '' + CharacterHelper.MAX_CODE_POINT);

          if (codePoint >= CharacterHelper.MIN_SUPPLEMENTARY_CODE_POINT) {
            return [CharacterHelper.getHighSurrogate(codePoint), CharacterHelper.getLowSurrogate(codePoint)];
          } else {
            return [String.fromCharCode(codePoint)];
          }
        };

        CharacterHelper.toChars$int$char_A$int = function (codePoint, dst, dstIndex) {
          javaemul.internal.InternalPreconditions.checkCriticalArgument(codePoint >= 0 && codePoint <= CharacterHelper.MAX_CODE_POINT, "CodePoint %s not in range [%s, %s]",
          /* toString */
          '' + codePoint, "0",
          /* toString */
          '' + CharacterHelper.MAX_CODE_POINT);

          if (codePoint >= CharacterHelper.MIN_SUPPLEMENTARY_CODE_POINT) {
            dst[dstIndex++] = CharacterHelper.getHighSurrogate(codePoint);
            dst[dstIndex] = CharacterHelper.getLowSurrogate(codePoint);
            return 2;
          } else {
            dst[dstIndex] = String.fromCharCode(codePoint);
            return 1;
          }
        };

        CharacterHelper.toChars = function (codePoint, dst, dstIndex) {
          if ((typeof codePoint === 'number' || codePoint === null) && (dst != null && dst instanceof Array && (dst.length == 0 || dst[0] == null || typeof dst[0] === 'string') || dst === null) && (typeof dstIndex === 'number' || dstIndex === null)) {
            return javaemul.internal.CharacterHelper.toChars$int$char_A$int(codePoint, dst, dstIndex);
          } else if ((typeof codePoint === 'number' || codePoint === null) && dst === undefined && dstIndex === undefined) {
            return javaemul.internal.CharacterHelper.toChars$int(codePoint);
          } else throw new Error('invalid overload');
        };

        CharacterHelper.toCodePoint = function (highSurrogate, lowSurrogate) {
          return CharacterHelper.MIN_SUPPLEMENTARY_CODE_POINT + ((function (c) {
            return c.charCodeAt == null ? c : c.charCodeAt(0);
          }(highSurrogate) & 1023) << 10) + (function (c) {
            return c.charCodeAt == null ? c : c.charCodeAt(0);
          }(lowSurrogate) & 1023);
        };

        CharacterHelper.toLowerCase$char = function (c) {
          return (
            /* valueOf */
            new String(c).toString().toLowerCase().charAt(0)
          );
        };

        CharacterHelper.toLowerCase = function (c) {
          if (typeof c === 'string' || c === null) {
            return javaemul.internal.CharacterHelper.toLowerCase$char(c);
          } else if (typeof c === 'number' || c === null) {
            return javaemul.internal.CharacterHelper.toLowerCase$int(c);
          } else throw new Error('invalid overload');
        };

        CharacterHelper.toLowerCase$int = function (c) {
          return (
            /* valueOf */
            new String(String.fromCharCode(c)).toString().toLowerCase().charAt(0).charCodeAt(0)
          );
        };

        CharacterHelper.toString = function (x) {
          return (
            /* valueOf */
            new String(x).toString()
          );
        };

        CharacterHelper.toUpperCase$char = function (c) {
          return (
            /* valueOf */
            new String(c).toString().toUpperCase().charAt(0)
          );
        };

        CharacterHelper.toUpperCase = function (c) {
          if (typeof c === 'string' || c === null) {
            return javaemul.internal.CharacterHelper.toUpperCase$char(c);
          } else if (typeof c === 'number' || c === null) {
            return javaemul.internal.CharacterHelper.toUpperCase$int(c);
          } else throw new Error('invalid overload');
        };

        CharacterHelper.toUpperCase$int = function (c) {
          return (
            /* valueOf */
            new String(String.fromCharCode(c)).toString().toUpperCase().charAt(0)
          );
        };

        CharacterHelper.valueOf = function (c) {
          if (function (c) {
            return c.charCodeAt == null ? c : c.charCodeAt(0);
          }(c) < 128) {
            var result = CharacterHelper.BoxedValues.boxedValues_$LI$()[c.charCodeAt(0)];

            if (function (c) {
              return c.charCodeAt == null ? c : c.charCodeAt(0);
            }(result) == null) {
              result = CharacterHelper.BoxedValues.boxedValues_$LI$()[c.charCodeAt(0)] = new String(c);
            }

            return result;
          }

          return new String(c);
        };

        CharacterHelper.codePointAt$java_lang_CharSequence$int$int = function (cs, index, limit) {
          var hiSurrogate = cs.charAt(index++);
          var loSurrogate;

          if (CharacterHelper.isHighSurrogate(hiSurrogate) && index < limit && CharacterHelper.isLowSurrogate(loSurrogate = cs.charAt(index))) {
            return CharacterHelper.toCodePoint(hiSurrogate, loSurrogate);
          }

          return hiSurrogate.charCodeAt(0);
        };

        CharacterHelper.codePointBefore$java_lang_CharSequence$int$int = function (cs, index, start) {
          var loSurrogate = cs.charAt(--index);
          var highSurrogate;

          if (CharacterHelper.isLowSurrogate(loSurrogate) && index > start && CharacterHelper.isHighSurrogate(highSurrogate = cs.charAt(index - 1))) {
            return CharacterHelper.toCodePoint(highSurrogate, loSurrogate);
          }

          return loSurrogate.charCodeAt(0);
        };

        CharacterHelper.forDigit$int = function (digit) {
          var overBaseTen = digit - 10;
          return String.fromCharCode(overBaseTen < 0 ? '0'.charCodeAt(0) + digit : 'a'.charCodeAt(0) + overBaseTen);
        };
        /**
        * Computes the high surrogate character of the UTF16 representation of a
        * non-BMP code point. See {@link getLowSurrogate}.
        *
        * @param {number} codePoint
        * requested codePoint, required to be >=
        * MIN_SUPPLEMENTARY_CODE_POINT
        * @return {string} high surrogate character
        */


        CharacterHelper.getHighSurrogate = function (codePoint) {
          return String.fromCharCode(function (c) {
            return c.charCodeAt == null ? c : c.charCodeAt(0);
          }(CharacterHelper.MIN_HIGH_SURROGATE) + (codePoint - CharacterHelper.MIN_SUPPLEMENTARY_CODE_POINT >> 10 & 1023));
        };
        /**
        * Computes the low surrogate character of the UTF16 representation of a non-BMP
        * code point. See {@link getHighSurrogate}.
        *
        * @param {number} codePoint
        * requested codePoint, required to be >=
        * MIN_SUPPLEMENTARY_CODE_POINT
        * @return {string} low surrogate character
        */


        CharacterHelper.getLowSurrogate = function (codePoint) {
          return String.fromCharCode(function (c) {
            return c.charCodeAt == null ? c : c.charCodeAt(0);
          }(CharacterHelper.MIN_LOW_SURROGATE) + (codePoint - CharacterHelper.MIN_SUPPLEMENTARY_CODE_POINT & 1023));
        };

        CharacterHelper.prototype.charValue = function () {
          return this.value;
        };

        CharacterHelper.prototype.compareTo$javaemul_internal_CharacterHelper = function (c) {
          return CharacterHelper.compare(this.value, c.value);
        };
        /**
        *
        * @param {javaemul.internal.CharacterHelper} c
        * @return {number}
        */


        CharacterHelper.prototype.compareTo = function (c) {
          if (c != null && c instanceof javaemul.internal.CharacterHelper || c === null) {
            return this.compareTo$javaemul_internal_CharacterHelper(c);
          } else throw new Error('invalid overload');
        };
        /**
        *
        * @param {*} o
        * @return {boolean}
        */


        CharacterHelper.prototype.equals = function (o) {
          return o != null && o instanceof javaemul.internal.CharacterHelper && function (c) {
            return c.charCodeAt == null ? c : c.charCodeAt(0);
          }(o.value) == function (c) {
            return c.charCodeAt == null ? c : c.charCodeAt(0);
          }(this.value);
        };
        /**
        *
        * @return {number}
        */


        CharacterHelper.prototype.hashCode = function () {
          return CharacterHelper.hashCode(this.value);
        };
        /**
        *
        * @return {string}
        */


        CharacterHelper.prototype.toString = function () {
          return (
            /* valueOf */
            new String(this.value).toString()
          );
        };

        CharacterHelper.MIN_RADIX = 2;
        CharacterHelper.MAX_RADIX = 36;
        CharacterHelper.MIN_VALUE = "\0";
        CharacterHelper.MAX_VALUE = "\uFFFF";
        CharacterHelper.MIN_SURROGATE = "\uD800";
        CharacterHelper.MAX_SURROGATE = "\uDFFF";
        CharacterHelper.MIN_LOW_SURROGATE = "\uDC00";
        CharacterHelper.MAX_LOW_SURROGATE = "\uDFFF";
        CharacterHelper.MIN_HIGH_SURROGATE = "\uD800";
        CharacterHelper.MAX_HIGH_SURROGATE = "\uDBFF";
        CharacterHelper.MIN_SUPPLEMENTARY_CODE_POINT = 65536;
        CharacterHelper.MIN_CODE_POINT = 0;
        CharacterHelper.MAX_CODE_POINT = 1114111;
        CharacterHelper.SIZE = 16;
        return CharacterHelper;
      }();

      internal.CharacterHelper = CharacterHelper;
      CharacterHelper["__class"] = "javaemul.internal.CharacterHelper";
      CharacterHelper["__interfaces"] = ["java.lang.Comparable", "java.io.Serializable"];

      (function (CharacterHelper) {
        /**
        * Use nested class to avoid clinit on outer.
        * @class
        */
        var BoxedValues =
        /** @class */
        function () {
          function BoxedValues() {}

          BoxedValues.boxedValues_$LI$ = function () {
            if (BoxedValues.boxedValues == null) {
              BoxedValues.boxedValues = function (s) {
                var a = [];

                while (s-- > 0) {
                  a.push(null);
                }

                return a;
              }(128);
            }

            return BoxedValues.boxedValues;
          };

          return BoxedValues;
        }();

        CharacterHelper.BoxedValues = BoxedValues;
        BoxedValues["__class"] = "javaemul.internal.CharacterHelper.BoxedValues";
      })(CharacterHelper = internal.CharacterHelper || (internal.CharacterHelper = {}));
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      /**
      * Simple Helper class to return Date.now.
      * @class
      */
      var DateUtil =
      /** @class */
      function () {
        function DateUtil() {}
        /**
        * Returns the numeric value corresponding to the current time - the number
        * of milliseconds elapsed since 1 January 1970 00:00:00 UTC.
        * @return {number}
        */


        DateUtil.now = function () {
          if (Date.now) {
            return Date.now();
          }

          return new Date().getTime();
        };

        return DateUtil;
      }();

      internal.DateUtil = DateUtil;
      DateUtil["__class"] = "javaemul.internal.DateUtil";
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      /**
      * Provides utilities to perform operations on Arrays.
      * @class
      */
      var ArrayHelper =
      /** @class */
      function () {
        function ArrayHelper() {}

        ArrayHelper.clone = function (array, fromIndex, toIndex) {
          var result = ArrayHelper.unsafeClone(array, fromIndex, toIndex);
          return javaemul.internal.ArrayStamper.stampJavaTypeInfo(result, array);
        };
        /**
        * Unlike clone, this method returns a copy of the array that is not type
        * marked. This is only safe for temp arrays as returned array will not do
        * any type checks.
        * @param {*} array
        * @param {number} fromIndex
        * @param {number} toIndex
        * @return {Array}
        */


        ArrayHelper.unsafeClone = function (array, fromIndex, toIndex) {
          return array.slice(fromIndex, toIndex);
        };

        ArrayHelper.createFrom = function (array, length) {
          var result = ArrayHelper.createNativeArray(length);
          return javaemul.internal.ArrayStamper.stampJavaTypeInfo(result, array);
        };
        /*private*/


        ArrayHelper.createNativeArray = function (length) {
          return new Array(length);
        };

        ArrayHelper.getLength = function (array) {
          return array.length | 0;
        };

        ArrayHelper.setLength = function (array, length) {
          array.length = length;
        };

        ArrayHelper.removeFrom = function (array, index, deleteCount) {
          array.splice(index, deleteCount);
        };

        ArrayHelper.insertTo$java_lang_Object$int$java_lang_Object = function (array, index, value) {
          array.splice(index, 0, value);
        };

        ArrayHelper.insertTo$java_lang_Object$int$java_lang_Object_A = function (array, index, values) {
          ArrayHelper.copy$java_lang_Object$int$java_lang_Object$int$int$boolean(values, 0, array, index, values.length, false);
        };

        ArrayHelper.insertTo = function (array, index, values) {
          if ((array != null || array === null) && (typeof index === 'number' || index === null) && (values != null && values instanceof Array && (values.length == 0 || values[0] == null || values[0] != null) || values === null)) {
            return javaemul.internal.ArrayHelper.insertTo$java_lang_Object$int$java_lang_Object_A(array, index, values);
          } else if ((array != null || array === null) && (typeof index === 'number' || index === null) && (values != null || values === null)) {
            return javaemul.internal.ArrayHelper.insertTo$java_lang_Object$int$java_lang_Object(array, index, values);
          } else throw new Error('invalid overload');
        };
        /**
        * This version of insertTo is specified only for arrays.
        * Same implementation (and arguments) as "public static void insertTo(Object array, int index, Object[] values)"
        * @param {*} array
        * @param {number} index
        * @param {Array} values
        */


        ArrayHelper.insertValuesToArray = function (array, index, values) {
          ArrayHelper.copy$java_lang_Object$int$java_lang_Object$int$int$boolean(values, 0, array, index, values.length, false);
        };

        ArrayHelper.copy$java_lang_Object$int$java_lang_Object$int$int = function (array, srcOfs, dest, destOfs, len) {
          ArrayHelper.copy$java_lang_Object$int$java_lang_Object$int$int$boolean(array, srcOfs, dest, destOfs, len, true);
        };

        ArrayHelper.copy$java_lang_Object$int$java_lang_Object$int$int$boolean = function (src, srcOfs, dest, destOfs, len, overwrite) {
          if (src === dest) {
            src = ArrayHelper.unsafeClone(src, srcOfs, srcOfs + len);
            srcOfs = 0;
          }

          for (var batchStart = srcOfs, end = srcOfs + len; batchStart < end;) {
            {
              var batchEnd = Math.min(batchStart + ArrayHelper.ARRAY_PROCESS_BATCH_SIZE, end);
              len = batchEnd - batchStart;
              ArrayHelper.applySplice(dest, destOfs, overwrite ? len : 0, ArrayHelper.unsafeClone(src, batchStart, batchEnd));
              batchStart = batchEnd;
              destOfs += len;
            }
          }
        };

        ArrayHelper.copy = function (src, srcOfs, dest, destOfs, len, overwrite) {
          if ((src != null || src === null) && (typeof srcOfs === 'number' || srcOfs === null) && (dest != null || dest === null) && (typeof destOfs === 'number' || destOfs === null) && (typeof len === 'number' || len === null) && (typeof overwrite === 'boolean' || overwrite === null)) {
            return javaemul.internal.ArrayHelper.copy$java_lang_Object$int$java_lang_Object$int$int$boolean(src, srcOfs, dest, destOfs, len, overwrite);
          } else if ((src != null || src === null) && (typeof srcOfs === 'number' || srcOfs === null) && (dest != null || dest === null) && (typeof destOfs === 'number' || destOfs === null) && (typeof len === 'number' || len === null) && overwrite === undefined) {
            return javaemul.internal.ArrayHelper.copy$java_lang_Object$int$java_lang_Object$int$int(src, srcOfs, dest, destOfs, len);
          } else throw new Error('invalid overload');
        };
        /*private*/


        ArrayHelper.applySplice = function (arrayObject, index, deleteCount, arrayToAdd) {
          Array.prototype.splice.apply(arrayObject, [index, deleteCount].concat(arrayToAdd));
        };

        ArrayHelper.ARRAY_PROCESS_BATCH_SIZE = 10000;
        return ArrayHelper;
      }();

      internal.ArrayHelper = ArrayHelper;
      ArrayHelper["__class"] = "javaemul.internal.ArrayHelper";
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      /**
      * Math utility methods and constants.
      * @class
      */
      var MathHelper =
      /** @class */
      function () {
        function MathHelper() {}

        MathHelper.EPSILON_$LI$ = function () {
          if (MathHelper.EPSILON == null) {
            MathHelper.EPSILON = MathHelper.pow(2, -52);
          }

          return MathHelper.EPSILON;
        };

        MathHelper.MAX_VALUE_$LI$ = function () {
          if (MathHelper.MAX_VALUE == null) {
            MathHelper.MAX_VALUE = (2 - MathHelper.EPSILON_$LI$()) * MathHelper.pow(2, 1023);
          }

          return MathHelper.MAX_VALUE;
        };

        MathHelper.MIN_VALUE_$LI$ = function () {
          if (MathHelper.MIN_VALUE == null) {
            MathHelper.MIN_VALUE = MathHelper.pow(2, -1022);
          }

          return MathHelper.MIN_VALUE;
        };

        MathHelper.nextDown = function (x) {
          return -MathHelper.nextUp(-x);
        };

        MathHelper.ulp = function (x) {
          return x < 0 ? MathHelper.nextUp(x) - x : x - -MathHelper.nextUp(-x);
        };

        MathHelper.nextUp = function (x) {
          if (x !== x) {
            return x;
          }

          if (x === (-1 / 0 | 0)) {
            return -MathHelper.MAX_VALUE_$LI$();
          }

          if (x === (+1 / 0 | 0)) {
            return +1 / 0 | 0;
          }

          if (x === +MathHelper.MAX_VALUE_$LI$()) {
            return +1 / 0 | 0;
          }

          var y = x * (x < 0 ? 1 - MathHelper.EPSILON_$LI$() / 2 : 1 + MathHelper.EPSILON_$LI$());

          if (y === x) {
            y = MathHelper.MIN_VALUE_$LI$() * MathHelper.EPSILON_$LI$() > 0 ? x + MathHelper.MIN_VALUE_$LI$() * MathHelper.EPSILON_$LI$() : x + MathHelper.MIN_VALUE_$LI$();
          }

          if (y === (+1 / 0 | 0)) {
            y = +MathHelper.MAX_VALUE_$LI$();
          }

          var b = x + (y - x) / 2;

          if (x < b && b < y) {
            y = b;
          }

          var c = (y + x) / 2;

          if (x < c && c < y) {
            y = c;
          }

          return y === 0 ? -0 : y;
        };

        MathHelper.PI_OVER_180_$LI$ = function () {
          if (MathHelper.PI_OVER_180 == null) {
            MathHelper.PI_OVER_180 = MathHelper.PI / 180.0;
          }

          return MathHelper.PI_OVER_180;
        };

        MathHelper.PI_UNDER_180_$LI$ = function () {
          if (MathHelper.PI_UNDER_180 == null) {
            MathHelper.PI_UNDER_180 = 180.0 / MathHelper.PI;
          }

          return MathHelper.PI_UNDER_180;
        };

        MathHelper.abs$double = function (x) {
          return x <= 0 ? 0.0 - x : x;
        };

        MathHelper.abs$float = function (x) {
          return MathHelper.abs$double(x);
        };

        MathHelper.abs$int = function (x) {
          return x < 0 ? -x : x;
        };

        MathHelper.abs = function (x) {
          if (typeof x === 'number' || x === null) {
            return javaemul.internal.MathHelper.abs$int(x);
          } else if (typeof x === 'number' || x === null) {
            return javaemul.internal.MathHelper.abs$long(x);
          } else if (typeof x === 'number' || x === null) {
            return javaemul.internal.MathHelper.abs$float(x);
          } else if (typeof x === 'number' || x === null) {
            return javaemul.internal.MathHelper.abs$double(x);
          } else throw new Error('invalid overload');
        };

        MathHelper.abs$long = function (x) {
          return x < 0 ? -x : x;
        };

        MathHelper.acos = function (x) {
          return Math.acos(x);
        };

        MathHelper.asin = function (x) {
          return Math.asin(x);
        };

        MathHelper.atan = function (x) {
          return Math.atan(x);
        };

        MathHelper.atan2 = function (y, x) {
          return Math.atan2(y, x);
        };

        MathHelper.cbrt = function (x) {
          return MathHelper.pow(x, 1.0 / 3.0);
        };

        MathHelper.ceil = function (x) {
          return Math.ceil(x);
        };

        MathHelper.copySign$double$double = function (magnitude, sign) {
          if (sign < 0) {
            return magnitude < 0 ? magnitude : -magnitude;
          } else {
            return magnitude > 0 ? magnitude : -magnitude;
          }
        };

        MathHelper.copySign$float$float = function (magnitude, sign) {
          return MathHelper.copySign$double$double(magnitude, sign);
        };

        MathHelper.copySign = function (magnitude, sign) {
          if ((typeof magnitude === 'number' || magnitude === null) && (typeof sign === 'number' || sign === null)) {
            return javaemul.internal.MathHelper.copySign$float$float(magnitude, sign);
          } else if ((typeof magnitude === 'number' || magnitude === null) && (typeof sign === 'number' || sign === null)) {
            return javaemul.internal.MathHelper.copySign$double$double(magnitude, sign);
          } else throw new Error('invalid overload');
        };

        MathHelper.cos = function (x) {
          return Math.cos(x);
        };

        MathHelper.cosh = function (x) {
          return (MathHelper.exp(x) + MathHelper.exp(-x)) / 2.0;
        };

        MathHelper.exp = function (x) {
          return Math.exp(x);
        };

        MathHelper.expm1 = function (d) {
          if (d === 0.0 ||
          /* isNaN */
          isNaN(d)) {
            return d;
          } else if (!function (value) {
            return Number.NEGATIVE_INFINITY === value || Number.POSITIVE_INFINITY === value;
          }(d)) {
            if (d < 0.0) {
              return -1.0;
            } else {
              return javaemul.internal.DoubleHelper.POSITIVE_INFINITY;
            }
          }

          return MathHelper.exp(d) + 1.0;
        };

        MathHelper.floor = function (x) {
          return Math.floor(x);
        };

        MathHelper.hypot = function (x, y) {
          return MathHelper.sqrt(x * x + y * y);
        };

        MathHelper.log = function (x) {
          return Math.log(x);
        };

        MathHelper.log10 = function (x) {
          return Math.log(x) * Math.LOG10E;
        };

        MathHelper.log1p = function (x) {
          return MathHelper.log(x + 1.0);
        };

        MathHelper.max$double$double = function (x, y) {
          return Math.max(x, y);
        };

        MathHelper.max$float$float = function (x, y) {
          return Math.max(x, y);
        };

        MathHelper.max$int$int = function (x, y) {
          return x > y ? x : y;
        };

        MathHelper.max = function (x, y) {
          if ((typeof x === 'number' || x === null) && (typeof y === 'number' || y === null)) {
            return javaemul.internal.MathHelper.max$int$int(x, y);
          } else if ((typeof x === 'number' || x === null) && (typeof y === 'number' || y === null)) {
            return javaemul.internal.MathHelper.max$long$long(x, y);
          } else if ((typeof x === 'number' || x === null) && (typeof y === 'number' || y === null)) {
            return javaemul.internal.MathHelper.max$float$float(x, y);
          } else if ((typeof x === 'number' || x === null) && (typeof y === 'number' || y === null)) {
            return javaemul.internal.MathHelper.max$double$double(x, y);
          } else throw new Error('invalid overload');
        };

        MathHelper.max$long$long = function (x, y) {
          return x > y ? x : y;
        };

        MathHelper.min$double$double = function (x, y) {
          return Math.min(x, y);
        };

        MathHelper.min$float$float = function (x, y) {
          return Math.min(x, y);
        };

        MathHelper.min$int$int = function (x, y) {
          return x < y ? x : y;
        };

        MathHelper.min = function (x, y) {
          if ((typeof x === 'number' || x === null) && (typeof y === 'number' || y === null)) {
            return javaemul.internal.MathHelper.min$int$int(x, y);
          } else if ((typeof x === 'number' || x === null) && (typeof y === 'number' || y === null)) {
            return javaemul.internal.MathHelper.min$long$long(x, y);
          } else if ((typeof x === 'number' || x === null) && (typeof y === 'number' || y === null)) {
            return javaemul.internal.MathHelper.min$float$float(x, y);
          } else if ((typeof x === 'number' || x === null) && (typeof y === 'number' || y === null)) {
            return javaemul.internal.MathHelper.min$double$double(x, y);
          } else throw new Error('invalid overload');
        };

        MathHelper.min$long$long = function (x, y) {
          return x < y ? x : y;
        };

        MathHelper.pow = function (x, exp) {
          return Math.pow(x, exp);
        };

        MathHelper.random = function () {
          return Math.random();
        };

        MathHelper.rint = function (d) {
          if (
          /* isNaN */
          isNaN(d)) {
            return d;
          } else if (
          /* isInfinite */
          function (value) {
            return Number.NEGATIVE_INFINITY === value || Number.POSITIVE_INFINITY === value;
          }(d)) {
            return d;
          } else if (d === 0.0) {
            return d;
          } else {
            return MathHelper.round$double(d);
          }
        };

        MathHelper.round$double = function (x) {
          return function (n) {
            return n < 0 ? Math.ceil(n) : Math.floor(n);
          }(Math.round(x));
        };

        MathHelper.round$float = function (x) {
          var roundedValue = Math.round(x);
          return MathHelper.unsafeCastToInt(roundedValue);
        };

        MathHelper.round = function (x) {
          if (typeof x === 'number' || x === null) {
            return javaemul.internal.MathHelper.round$float(x);
          } else if (typeof x === 'number' || x === null) {
            return javaemul.internal.MathHelper.round$double(x);
          } else throw new Error('invalid overload');
        };
        /*private*/


        MathHelper.unsafeCastToInt = function (d) {
          return d;
        };

        MathHelper.scalb$double$int = function (d, scaleFactor) {
          if (scaleFactor >= 31 || scaleFactor <= -31) {
            return d * MathHelper.pow(2, scaleFactor);
          } else if (scaleFactor > 0) {
            return d * (1 << scaleFactor);
          } else if (scaleFactor === 0) {
            return d;
          } else {
            return d * 1.0 / (1 << -scaleFactor);
          }
        };

        MathHelper.scalb$float$int = function (f, scaleFactor) {
          if (scaleFactor >= 31 || scaleFactor <= -31) {
            return f * MathHelper.pow(2, scaleFactor);
          } else if (scaleFactor > 0) {
            return f * (1 << scaleFactor);
          } else if (scaleFactor === 0) {
            return f;
          } else {
            return f * 1.0 / (1 << -scaleFactor);
          }
        };

        MathHelper.scalb = function (f, scaleFactor) {
          if ((typeof f === 'number' || f === null) && (typeof scaleFactor === 'number' || scaleFactor === null)) {
            return javaemul.internal.MathHelper.scalb$float$int(f, scaleFactor);
          } else if ((typeof f === 'number' || f === null) && (typeof scaleFactor === 'number' || scaleFactor === null)) {
            return javaemul.internal.MathHelper.scalb$double$int(f, scaleFactor);
          } else throw new Error('invalid overload');
        };

        MathHelper.signum$double = function (d) {
          if (d > 0.0) {
            return 1.0;
          } else if (d < 0.0) {
            return -1.0;
          } else {
            return 0.0;
          }
        };

        MathHelper.signum$float = function (f) {
          if (f > 0.0) {
            return 1.0;
          } else if (f < 0.0) {
            return -1.0;
          } else {
            return 0.0;
          }
        };

        MathHelper.signum = function (f) {
          if (typeof f === 'number' || f === null) {
            return javaemul.internal.MathHelper.signum$float(f);
          } else if (typeof f === 'number' || f === null) {
            return javaemul.internal.MathHelper.signum$double(f);
          } else throw new Error('invalid overload');
        };

        MathHelper.sin = function (x) {
          return Math.sin(x);
        };

        MathHelper.sinh = function (x) {
          return (MathHelper.exp(x) - MathHelper.exp(-x)) / 2.0;
        };

        MathHelper.sqrt = function (x) {
          return Math.sqrt(x);
        };

        MathHelper.tan = function (x) {
          return Math.tan(x);
        };

        MathHelper.tanh = function (x) {
          if (x === javaemul.internal.JsUtils.getInfinity()) {
            return 1.0;
          } else if (x === -javaemul.internal.JsUtils.getInfinity()) {
            return -1.0;
          }

          var e2x = MathHelper.exp(2.0 * x);
          return (e2x - 1) / (e2x + 1);
        };

        MathHelper.toDegrees = function (x) {
          return x * MathHelper.PI_UNDER_180_$LI$();
        };

        MathHelper.toRadians = function (x) {
          return x * MathHelper.PI_OVER_180_$LI$();
        };

        MathHelper.IEEEremainder = function (f1, f2) {
          var r = Math.abs(f1 % f2);

          if (
          /* isNaN */
          isNaN(r) || r === f2 || r <= Math.abs(f2) / 2.0) {
            return r;
          } else {
            return (
              /* signum */
              function (f) {
                if (f > 0) {
                  return 1;
                } else if (f < 0) {
                  return -1;
                } else {
                  return 0;
                }
              }(f1) * (r - f2)
            );
          }
        };

        MathHelper.E = 2.718281828459045;
        MathHelper.PI = 3.141592653589793;
        return MathHelper;
      }();

      internal.MathHelper = MathHelper;
      MathHelper["__class"] = "javaemul.internal.MathHelper";
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      /**
      * A utility to provide array stamping. Provided as a separate class to simplify
      * super-source.
      * @class
      */
      var ArrayStamper =
      /** @class */
      function () {
        function ArrayStamper() {}

        ArrayStamper.stampJavaTypeInfo = function (array, referenceType) {
          return array;
        };

        return ArrayStamper;
      }();

      internal.ArrayStamper = ArrayStamper;
      ArrayStamper["__class"] = "javaemul.internal.ArrayStamper";
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      /**
      * Contains logics for calculating hash codes in JavaScript.
      * @class
      */
      var HashCodes =
      /** @class */
      function () {
        function HashCodes() {}

        HashCodes.hashCodeForString = function (s) {
          return javaemul.internal.StringHashCache.getHashCode(s);
        };

        HashCodes.getIdentityHashCode = function (o) {
          if (o == null) {
            return 0;
          }

          return typeof o === 'string' ? HashCodes.hashCodeForString(javaemul.internal.JsUtils.unsafeCastToString(o)) : HashCodes.getObjectIdentityHashCode(o);
        };

        HashCodes.getObjectIdentityHashCode = function (o) {
          if (o[HashCodes.HASH_CODE_PROPERTY] != null) {
            return o[HashCodes.HASH_CODE_PROPERTY];
          } else {
            return o[HashCodes.HASH_CODE_PROPERTY] = HashCodes.getNextHashId();
          }
        };
        /**
        * Called from JSNI. Do not change this implementation without updating:
        * <ul>
        * <li>{@link com.google.gwt.user.client.rpc.impl.SerializerBase}</li>
        * </ul>
        * @return {number}
        * @private
        */

        /*private*/


        HashCodes.getNextHashId = function () {
          return ++HashCodes.sNextHashId;
        };

        HashCodes.sNextHashId = 0;
        HashCodes.HASH_CODE_PROPERTY = "$H";
        return HashCodes;
      }();

      internal.HashCodes = HashCodes;
      HashCodes["__class"] = "javaemul.internal.HashCodes";
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      /**
      * Abstract base class for numeric wrapper classes.
      * @class
      */
      var NumberHelper =
      /** @class */
      function () {
        function NumberHelper() {}
        /**
        * @skip
        *
        * This function will determine the radix that the string is expressed
        * in based on the parsing rules defined in the Javadocs for
        * Integer.decode() and invoke __parseAndValidateInt.
        * @param {string} s
        * @param {number} lowerBound
        * @param {number} upperBound
        * @return {number}
        */


        NumberHelper.__decodeAndValidateInt = function (s, lowerBound, upperBound) {
          var decode = NumberHelper.__decodeNumberString(s);

          return NumberHelper.__parseAndValidateInt(decode.payload, decode.radix, lowerBound, upperBound);
        };

        NumberHelper.__decodeNumberString = function (s) {
          var negative;

          if (
          /* startsWith */
          function (str, searchString, position) {
            if (position === void 0) {
              position = 0;
            }

            return str.substr(position, searchString.length) === searchString;
          }(s, "-")) {
            negative = true;
            s = s.substring(1);
          } else {
            negative = false;

            if (
            /* startsWith */
            function (str, searchString, position) {
              if (position === void 0) {
                position = 0;
              }

              return str.substr(position, searchString.length) === searchString;
            }(s, "+")) {
              s = s.substring(1);
            }
          }

          var radix;

          if (
          /* startsWith */
          function (str, searchString, position) {
            if (position === void 0) {
              position = 0;
            }

            return str.substr(position, searchString.length) === searchString;
          }(s, "0x") ||
          /* startsWith */
          function (str, searchString, position) {
            if (position === void 0) {
              position = 0;
            }

            return str.substr(position, searchString.length) === searchString;
          }(s, "0X")) {
            s = s.substring(2);
            radix = 16;
          } else if (
          /* startsWith */
          function (str, searchString, position) {
            if (position === void 0) {
              position = 0;
            }

            return str.substr(position, searchString.length) === searchString;
          }(s, "#")) {
            s = s.substring(1);
            radix = 16;
          } else if (
          /* startsWith */
          function (str, searchString, position) {
            if (position === void 0) {
              position = 0;
            }

            return str.substr(position, searchString.length) === searchString;
          }(s, "0")) {
            radix = 8;
          } else {
            radix = 10;
          }

          if (negative) {
            s = "-" + s;
          }

          return new NumberHelper.__Decode(radix, s);
        };
        /**
        * @skip
        *
        * This function contains common logic for parsing a String as a
        * floating- point number and validating the range.
        * @param {string} s
        * @return {number}
        */


        NumberHelper.__parseAndValidateDouble = function (s) {
          if (!NumberHelper.__isValidDouble(s)) {
            throw java.lang.NumberFormatException.forInputString(s);
          }

          return parseFloat(s);
        };
        /**
        * @skip
        *
        * This function contains common logic for parsing a String in a given
        * radix and validating the result.
        * @param {string} s
        * @param {number} radix
        * @param {number} lowerBound
        * @param {number} upperBound
        * @return {number}
        */


        NumberHelper.__parseAndValidateInt = function (s, radix, lowerBound, upperBound) {
          if (s == null) {
            throw java.lang.NumberFormatException.forNullInputString();
          }

          if (radix < javaemul.internal.CharacterHelper.MIN_RADIX || radix > javaemul.internal.CharacterHelper.MAX_RADIX) {
            throw java.lang.NumberFormatException.forRadix(radix);
          }

          var length = s.length;
          var startIndex = length > 0 && (function (c) {
            return c.charCodeAt == null ? c : c.charCodeAt(0);
          }(s.charAt(0)) == '-'.charCodeAt(0) || function (c) {
            return c.charCodeAt == null ? c : c.charCodeAt(0);
          }(s.charAt(0)) == '+'.charCodeAt(0)) ? 1 : 0;

          for (var i = startIndex; i < length; i++) {
            {
              if (javaemul.internal.CharacterHelper.digit(s.charAt(i), radix) === -1) {
                throw java.lang.NumberFormatException.forInputString(s);
              }
            }
          }

          var toReturn = parseInt(s, radix) | 0;
          var isTooLow = toReturn < lowerBound;

          if (javaemul.internal.DoubleHelper.isNaN(toReturn)) {
            throw java.lang.NumberFormatException.forInputString(s);
          } else if (isTooLow || toReturn > upperBound) {
            throw java.lang.NumberFormatException.forInputString(s);
          }

          return toReturn;
        };
        /**
        * @skip
        *
        * This function contains common logic for parsing a String in a given
        * radix and validating the result.
        * @param {string} s
        * @param {number} radix
        * @return {number}
        */


        NumberHelper.__parseAndValidateLong = function (s, radix) {
          if (s == null) {
            throw java.lang.NumberFormatException.forNullInputString();
          }

          if (radix < javaemul.internal.CharacterHelper.MIN_RADIX || radix > javaemul.internal.CharacterHelper.MAX_RADIX) {
            throw java.lang.NumberFormatException.forRadix(radix);
          }

          var orig = s;
          var length = s.length;
          var negative = false;

          if (length > 0) {
            var c = s.charAt(0);

            if (function (c) {
              return c.charCodeAt == null ? c : c.charCodeAt(0);
            }(c) == '-'.charCodeAt(0) || function (c) {
              return c.charCodeAt == null ? c : c.charCodeAt(0);
            }(c) == '+'.charCodeAt(0)) {
              s = s.substring(1);
              length--;

              negative = function (c) {
                return c.charCodeAt == null ? c : c.charCodeAt(0);
              }(c) == '-'.charCodeAt(0);
            }
          }

          if (length === 0) {
            throw java.lang.NumberFormatException.forInputString(orig);
          }

          while (s.length > 0 && function (c) {
            return c.charCodeAt == null ? c : c.charCodeAt(0);
          }(s.charAt(0)) == '0'.charCodeAt(0)) {
            {
              s = s.substring(1);
              length--;
            }
          }

          if (length > NumberHelper.__ParseLong.maxLengthForRadix_$LI$()[radix]) {
            throw java.lang.NumberFormatException.forInputString(orig);
          }

          for (var i = 0; i < length; i++) {
            {
              if (javaemul.internal.CharacterHelper.digit(s.charAt(i), radix) === -1) {
                throw java.lang.NumberFormatException.forInputString(orig);
              }
            }
          }

          var toReturn = 0;

          var maxDigits = NumberHelper.__ParseLong.maxDigitsForRadix_$LI$()[radix];

          var radixPower = NumberHelper.__ParseLong.maxDigitsRadixPower_$LI$()[radix];

          var minValue = -NumberHelper.__ParseLong.maxValueForRadix_$LI$()[radix];
          var firstTime = true;
          var head = length % maxDigits;

          if (head > 0) {
            toReturn = -(parseInt(s.substring(0, head), radix) | 0);
            s = s.substring(head);
            length -= head;
            firstTime = false;
          }

          while (length >= maxDigits) {
            {
              head = parseInt(s.substring(0, maxDigits), radix) | 0;
              s = s.substring(maxDigits);
              length -= maxDigits;

              if (!firstTime) {
                if (toReturn < minValue) {
                  throw java.lang.NumberFormatException.forInputString(orig);
                }

                toReturn *= radixPower;
              } else {
                firstTime = false;
              }

              toReturn -= head;
            }
          }

          if (toReturn > 0) {
            throw java.lang.NumberFormatException.forInputString(orig);
          }

          if (!negative) {
            toReturn = -toReturn;

            if (toReturn < 0) {
              throw java.lang.NumberFormatException.forInputString(orig);
            }
          }

          return toReturn;
        };
        /**
        * @skip
        *
        * @param {string} str
        * @return {boolean} {@code true} if the string matches the float format,
        * {@code false} otherwise
        * @private
        */


        NumberHelper.__isValidDouble = function (str) {
          if (NumberHelper.floatRegex == null) {
            NumberHelper.floatRegex = NumberHelper.createFloatRegex();
          }

          return NumberHelper.floatRegex.test(str);
        };

        NumberHelper.createFloatRegex = function () {
          return /^\s*[+-]?(NaN|Infinity|((\d+\.?\d*)|(\.\d+))([eE][+-]?\d+)?[dDfF]?)\s*$/;
        };

        NumberHelper.prototype.byteValue = function () {
          return this.intValue() | 0;
        };

        NumberHelper.prototype.shortValue = function () {
          return this.intValue() | 0;
        };
        /**
        * Stores a regular expression object to verify the format of float values.
        */


        NumberHelper.floatRegex = null;
        return NumberHelper;
      }();

      internal.NumberHelper = NumberHelper;
      NumberHelper["__class"] = "javaemul.internal.NumberHelper";
      NumberHelper["__interfaces"] = ["java.io.Serializable"];

      (function (NumberHelper) {
        var __Decode =
        /** @class */
        function () {
          function __Decode(radix, payload) {
            if (this.payload === undefined) {
              this.payload = null;
            }

            if (this.radix === undefined) {
              this.radix = 0;
            }

            this.radix = radix;
            this.payload = payload;
          }

          return __Decode;
        }();

        NumberHelper.__Decode = __Decode;
        __Decode["__class"] = "javaemul.internal.NumberHelper.__Decode";
        /**
        * Use nested class to avoid clinit on outer.
        * @class
        */

        var __ParseLong =
        /** @class */
        function () {
          function __ParseLong() {}

          __ParseLong.__static_initialize = function () {
            if (!__ParseLong.__static_initialized) {
              __ParseLong.__static_initialized = true;

              __ParseLong.__static_initializer_0();
            }
          };

          __ParseLong.maxDigitsForRadix_$LI$ = function () {
            __ParseLong.__static_initialize();

            if (__ParseLong.maxDigitsForRadix == null) {
              __ParseLong.maxDigitsForRadix = [-1, -1, 30, 19, 15, 13, 11, 11, 10, 9, 9, 8, 8, 8, 8, 7, 7, 7, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 5];
            }

            return __ParseLong.maxDigitsForRadix;
          };

          __ParseLong.maxDigitsRadixPower_$LI$ = function () {
            __ParseLong.__static_initialize();

            if (__ParseLong.maxDigitsRadixPower == null) {
              __ParseLong.maxDigitsRadixPower = function (s) {
                var a = [];

                while (s-- > 0) {
                  a.push(0);
                }

                return a;
              }(37);
            }

            return __ParseLong.maxDigitsRadixPower;
          };

          __ParseLong.maxLengthForRadix_$LI$ = function () {
            __ParseLong.__static_initialize();

            if (__ParseLong.maxLengthForRadix == null) {
              __ParseLong.maxLengthForRadix = [-1, -1, 63, 40, 32, 28, 25, 23, 21, 20, 19, 19, 18, 18, 17, 17, 16, 16, 16, 15, 15, 15, 15, 14, 14, 14, 14, 14, 14, 13, 13, 13, 13, 13, 13, 13, 13];
            }

            return __ParseLong.maxLengthForRadix;
          };

          __ParseLong.maxValueForRadix_$LI$ = function () {
            __ParseLong.__static_initialize();

            if (__ParseLong.maxValueForRadix == null) {
              __ParseLong.maxValueForRadix = function (s) {
                var a = [];

                while (s-- > 0) {
                  a.push(0);
                }

                return a;
              }(37);
            }

            return __ParseLong.maxValueForRadix;
          };

          __ParseLong.__static_initializer_0 = function () {
            for (var i = 2; i <= 36; i++) {
              {
                __ParseLong.maxDigitsRadixPower_$LI$()[i] = Math.pow(i, __ParseLong.maxDigitsForRadix_$LI$()[i]) | 0;

                __ParseLong.maxValueForRadix_$LI$()[i] = function (n) {
                  return n < 0 ? Math.ceil(n) : Math.floor(n);
                }(9223372036854775807 / __ParseLong.maxDigitsRadixPower_$LI$()[i]);
              }
            }
          };

          __ParseLong.__static_initialized = false;
          return __ParseLong;
        }();

        NumberHelper.__ParseLong = __ParseLong;
        __ParseLong["__class"] = "javaemul.internal.NumberHelper.__ParseLong";
      })(NumberHelper = internal.NumberHelper || (internal.NumberHelper = {}));
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  var java;

  (function (java) {
    (function (net) {
      var URL =
      /** @class */
      function () {
        function URL(protocol, host, port, file) {
          if ((typeof protocol === 'string' || protocol === null) && (typeof host === 'string' || host === null) && (typeof port === 'number' || port === null) && (typeof file === 'string' || file === null)) {
            var __args = arguments;
            {
              var spec = protocol + "//" + host + ":" + port + "/" + file;

              if (this.jsUrl === undefined) {
                this.jsUrl = null;
              }

              this.jsUrl = java.net.InternalJsURLFactory.newJsURL(spec);
            }

            if (this.jsUrl === undefined) {
              this.jsUrl = null;
            }
          } else if ((typeof protocol === 'string' || protocol === null) && (typeof host === 'string' || host === null) && (typeof port === 'string' || port === null) && file === undefined) {
            var __args = arguments;
            var file_1 = __args[2];
            {
              var spec = protocol + "//" + host + "/" + file_1;

              if (this.jsUrl === undefined) {
                this.jsUrl = null;
              }

              this.jsUrl = java.net.InternalJsURLFactory.newJsURL(spec);
            }

            if (this.jsUrl === undefined) {
              this.jsUrl = null;
            }
          } else if ((protocol != null && protocol instanceof java.net.URL || protocol === null) && (typeof host === 'string' || host === null) && port === undefined && file === undefined) {
            var __args = arguments;
            var url = __args[0];
            var string = __args[1];

            if (this.jsUrl === undefined) {
              this.jsUrl = null;
            }

            this.jsUrl = java.net.InternalJsURLFactory.newJsURL(string, url.jsUrl);
          } else if ((typeof protocol === 'string' || protocol === null) && host === undefined && port === undefined && file === undefined) {
            var __args = arguments;
            var spec = __args[0];

            if (this.jsUrl === undefined) {
              this.jsUrl = null;
            }

            this.jsUrl = java.net.InternalJsURLFactory.newJsURL(spec);
          } else throw new Error('invalid overload');
        }

        URL.prototype.openStream = function () {
          var request = this.makeConnection();

          switch (request.responseType) {
            case "arraybuffer":
              return new java.io.ByteArrayInputStream(new Int8Array(request.response));

            case "blob":
              var fileReaderSyncConstructor = self["FileReaderSync"];

              if (typeof fileReaderSyncConstructor === "function") {
                return new java.io.ByteArrayInputStream(fileReaderSyncConstructor["readAsArrayBuffer"](request.response));
              }

              return new java.io.ByteArrayInputStream(
              /* getBytes */
              URL.createObjectURL(request.response).split('').map(function (s) {
                return s.charCodeAt(0);
              }));

            default:
              return new java.io.ByteArrayInputStream(
              /* getBytes */
              request.response.toString().split('').map(function (s) {
                return s.charCodeAt(0);
              }));
          }
        };
        /*private*/


        URL.createObjectURL = function (obj) {
          return java.net.InternalJsURLFactory.jsURLCtor_$LI$()["createObjectURL"](obj);
        };
        /**
        *
        * @param {*} o
        * @return {boolean}
        */


        URL.prototype.equals = function (o) {
          if (this === o) return true;
          if (!(o != null && o instanceof java.net.URL)) return false;
          var url = o;
          return java.util.Objects.equals(this.jsUrl, url.jsUrl);
        };
        /**
        *
        * @return {number}
        */


        URL.prototype.hashCode = function () {
          return (
            /* hashCode */
            function (o) {
              if (o.hashCode) {
                return o.hashCode();
              } else {
                return o.toString().split('').reduce(function (prevHash, currVal) {
                  return (prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0;
                }, 0);
              }
            }(this.jsUrl)
          );
        };

        URL.prototype.getAuthority = function () {
          var username = this.jsUrl["username"];
          var password = this.jsUrl["password"];
          if (username == null && password == null) return "";
          if (username != null && password != null) return username + ":" + password;
          return username != null ? username : password;
        };

        URL.prototype.getContent = function () {
          return this.makeConnection().response;
        };

        URL.prototype.getDefaultPort = function () {
          switch (this.getProtocol().toLowerCase()) {
            case "http":
            case "ws":
              return 80;

            case "https":
            case "wss":
              return 443;

            case "ftp":
              return 21;

            case "sftp":
              return 22;

            case "gopher":
              return 70;

            case "file":
              return 0;
          }

          return -1;
        };

        URL.prototype.getFile = function () {
          var wholePath = this.getPath();
          var query = this.getQuery();
          return wholePath + (query.length > 0 ? "?" + query : "");
        };

        URL.prototype.getHost = function () {
          return this.jsUrl["hostname"];
        };

        URL.prototype.getPath = function () {
          return this.jsUrl["pathname"];
        };

        URL.prototype.getPort = function () {
          return this.jsUrl["port"];
        };

        URL.prototype.getProtocol = function () {
          return this.jsUrl["protocol"];
        };

        URL.prototype.getQuery = function () {
          return this.jsUrl["search"];
        };

        URL.prototype.getRef = function () {
          return this.jsUrl["hash"];
        };

        URL.prototype.getUserInfo = function () {
          return this.jsUrl["username"];
        };

        URL.prototype.sameFile = function (other) {
          return java.util.Objects.equals(this.getProtocol(), other.getProtocol()) && java.util.Objects.equals(this.getAuthority(), other.getAuthority()) && java.util.Objects.equals(this.getHost(), other.getHost()) && this.getPort() === other.getPort() && java.util.Objects.equals(this.getFile(), other.getFile());
        };

        URL.prototype.toExternalForm = function () {
          return this.jsUrl.toString();
        };
        /*private*/


        URL.prototype.makeConnection = function () {
          var request = new XMLHttpRequest();
          request.open("GET", this.jsUrl["href"], false);
          request.send();
          return request;
        };
        /**
        *
        * @return {string}
        */


        URL.prototype.toString = function () {
          return this.jsUrl["href"];
        };

        return URL;
      }();

      net.URL = URL;
      URL["__class"] = "java.net.URL";
      URL["__interfaces"] = ["java.io.Serializable"];
    })(java.net || (java.net = {}));
  })(java || (java = {}));

  (function (java) {
    (function (net) {
      var InternalJsURLFactory =
      /** @class */
      function () {
        function InternalJsURLFactory() {}

        InternalJsURLFactory.jsURLCtor_$LI$ = function () {
          if (InternalJsURLFactory.jsURLCtor == null) {
            InternalJsURLFactory.jsURLCtor = InternalJsURLFactory.getJsURLConstructor();
          }

          return InternalJsURLFactory.jsURLCtor;
        };
        /*private*/


        InternalJsURLFactory.getJsURLConstructor = function () {
          var URLConstructor;

          if (java.lang.System.ENVIRONMENT_IS_NODE_$LI$()) {
            URLConstructor = eval("global.URL || (global.URL = require(\"url\").URL)");
          } else if (java.lang.System.ENVIRONMENT_IS_SHELL_$LI$()) {
            java.net.InternalJsURLForShell;
            URLConstructor = eval("this.URL || (this.URL = internalJsURLForShellClass)");
          } else {
            URLConstructor = function () {
              return eval("URL");
            }.call(null);
          }

          return URLConstructor;
        };

        InternalJsURLFactory.newJsURL = function () {
          var objects = [];

          for (var _i = 0; _i < arguments.length; _i++) {
            objects[_i] = arguments[_i];
          }

          var ctor = InternalJsURLFactory.jsURLCtor_$LI$();
          return new (ctor.bind.apply(ctor, [null].concat(objects)))();
        };

        return InternalJsURLFactory;
      }();

      net.InternalJsURLFactory = InternalJsURLFactory;
      InternalJsURLFactory["__class"] = "java.net.InternalJsURLFactory";
    })(java.net || (java.net = {}));
  })(java || (java = {}));

  (function (java) {
    (function (net) {
      var InternalJsURLForShell =
      /** @class */
      function () {
        function InternalJsURLForShell(data, url) {
          if ((typeof data === 'string' || data === null) && (url != null && url instanceof Object || url === null)) {
            {
              var __args_3 = arguments;
              var data_1 = url["href"] + __args_3[0];

              if (this.href === undefined) {
                this.href = null;
              }

              if (this.protocol === undefined) {
                this.protocol = null;
              }

              if (this.username === undefined) {
                this.username = null;
              }

              if (this.password === undefined) {
                this.password = null;
              }

              if (this.hostname === undefined) {
                this.hostname = null;
              }

              if (this.port === undefined) {
                this.port = null;
              }

              if (this.pathname === undefined) {
                this.pathname = null;
              }

              if (this.search === undefined) {
                this.search = null;
              }

              if (this.hash === undefined) {
                this.hash = null;
              }

              this.href = data_1;
              var protocolEnd = data_1.indexOf("://");
              if (protocolEnd === -1) throw new Error("Wrong URL, no protocol");
              this.protocol = data_1.substring(0, protocolEnd);
              var userPassEnd = data_1.indexOf("@", protocolEnd + 3);
              var userEnd = userPassEnd === -1 ? -1 : data_1.indexOf(":", protocolEnd + 3);
              if (userEnd > userPassEnd) userEnd = -1;
              this.username = userPassEnd === -1 ? null : userEnd === -1 ? data_1.substring(protocolEnd + 3, userPassEnd) : data_1.substring(protocolEnd + 3, userEnd);
              this.password = userPassEnd === -1 || userEnd === -1 ? null : data_1.substring(userPassEnd + 1, userEnd);
              var hostStart = userPassEnd === -1 ? protocolEnd + 3 : userPassEnd + 1;
              var hostPortEnd = data_1.indexOf("/", hostStart);
              var portStart = data_1.indexOf(":", hostStart);
              this.hostname = portStart === -1 || portStart > hostPortEnd ? data_1.substring(hostStart, hostPortEnd) : data_1.substring(hostStart, portStart);
              this.port = portStart !== -1 && portStart < hostPortEnd ? javaemul.internal.IntegerHelper.parseInt(data_1.substring(portStart + 1, hostPortEnd)) : null;
              var searchStart = data_1.indexOf("?", hostPortEnd);
              var hashStart = data_1.indexOf("#", hostPortEnd);
              this.search = searchStart !== -1 ? hashStart === -1 ? data_1.substring(searchStart + 1) : data_1.substring(searchStart + 1, hashStart) : null;
              this.hash = hashStart !== -1 ? data_1.substring(hashStart + 1) : null;
              this.pathname = searchStart === -1 && hashStart === -1 ? data_1.substring(hostPortEnd + 1) : data_1.substring(hostPortEnd + 1, searchStart === -1 ? hashStart : searchStart);
            }

            if (this.href === undefined) {
              this.href = null;
            }

            if (this.protocol === undefined) {
              this.protocol = null;
            }

            if (this.username === undefined) {
              this.username = null;
            }

            if (this.password === undefined) {
              this.password = null;
            }

            if (this.hostname === undefined) {
              this.hostname = null;
            }

            if (this.port === undefined) {
              this.port = null;
            }

            if (this.pathname === undefined) {
              this.pathname = null;
            }

            if (this.search === undefined) {
              this.search = null;
            }

            if (this.hash === undefined) {
              this.hash = null;
            }
          } else if ((typeof data === 'string' || data === null) && url === undefined) {
            if (this.href === undefined) {
              this.href = null;
            }

            if (this.protocol === undefined) {
              this.protocol = null;
            }

            if (this.username === undefined) {
              this.username = null;
            }

            if (this.password === undefined) {
              this.password = null;
            }

            if (this.hostname === undefined) {
              this.hostname = null;
            }

            if (this.port === undefined) {
              this.port = null;
            }

            if (this.pathname === undefined) {
              this.pathname = null;
            }

            if (this.search === undefined) {
              this.search = null;
            }

            if (this.hash === undefined) {
              this.hash = null;
            }

            this.href = data;
            var protocolEnd = data.indexOf("://");
            if (protocolEnd === -1) throw new Error("Wrong URL, no protocol");
            this.protocol = data.substring(0, protocolEnd);
            var userPassEnd = data.indexOf("@", protocolEnd + 3);
            var userEnd = userPassEnd === -1 ? -1 : data.indexOf(":", protocolEnd + 3);
            if (userEnd > userPassEnd) userEnd = -1;
            this.username = userPassEnd === -1 ? null : userEnd === -1 ? data.substring(protocolEnd + 3, userPassEnd) : data.substring(protocolEnd + 3, userEnd);
            this.password = userPassEnd === -1 || userEnd === -1 ? null : data.substring(userPassEnd + 1, userEnd);
            var hostStart = userPassEnd === -1 ? protocolEnd + 3 : userPassEnd + 1;
            var hostPortEnd = data.indexOf("/", hostStart);
            var portStart = data.indexOf(":", hostStart);
            this.hostname = portStart === -1 || portStart > hostPortEnd ? data.substring(hostStart, hostPortEnd) : data.substring(hostStart, portStart);
            this.port = portStart !== -1 && portStart < hostPortEnd ? javaemul.internal.IntegerHelper.parseInt(data.substring(portStart + 1, hostPortEnd)) : null;
            var searchStart = data.indexOf("?", hostPortEnd);
            var hashStart = data.indexOf("#", hostPortEnd);
            this.search = searchStart !== -1 ? hashStart === -1 ? data.substring(searchStart + 1) : data.substring(searchStart + 1, hashStart) : null;
            this.hash = hashStart !== -1 ? data.substring(hashStart + 1) : null;
            this.pathname = searchStart === -1 && hashStart === -1 ? data.substring(hostPortEnd + 1) : data.substring(hostPortEnd + 1, searchStart === -1 ? hashStart : searchStart);
          } else throw new Error('invalid overload');
        }

        return InternalJsURLForShell;
      }();

      net.InternalJsURLForShell = InternalJsURLForShell;
      InternalJsURLForShell["__class"] = "java.net.InternalJsURLForShell";
    })(java.net || (java.net = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      var EventListenerProxy =
      /** @class */
      function () {
        function EventListenerProxy(listener) {
          if (this.listener === undefined) {
            this.listener = null;
          }

          this.listener = listener;
        }

        EventListenerProxy.prototype.getListener = function () {
          return this.listener;
        };

        return EventListenerProxy;
      }();

      util.EventListenerProxy = EventListenerProxy;
      EventListenerProxy["__class"] = "java.util.EventListenerProxy";
      EventListenerProxy["__interfaces"] = ["java.util.EventListener"];
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      (function (Map) {
        (function (Entry) {
          /**
          *
          * Returns a comparator that compares {@link Map.Entry} by value using the given
          * {@link Comparator}.
          *
          * <p>
          * The returned comparator is serializable if the specified comparator is also
          * serializable.
          *
          * @param <K>
          * the type of the map keys
          * @param <V>
          * the type of the map values
          * @param {*} cmp
          * the value {@link Comparator}
          * @return {*} a comparator that compares {@link Map.Entry} by the value.
          * @since 1.8
          */
          function comparingByValue(cmp) {
            java.util.Objects.requireNonNull(cmp);
            return function (c1, c2) {
              return function (target) {
                return target['compare'] === undefined ? target : target['compare'];
              }(cmp)(c1.getValue(), c2.getValue());
            };
          }

          Entry.comparingByValue = comparingByValue;
        })(Map.Entry || (Map.Entry = {}));
      })(util.Map || (util.Map = {}));
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * A factory to create JavaScript Map instances.
      * @class
      */
      var InternalJsMapFactory =
      /** @class */
      function () {
        function InternalJsMapFactory() {}

        InternalJsMapFactory.jsMapCtor_$LI$ = function () {
          if (InternalJsMapFactory.jsMapCtor == null) {
            InternalJsMapFactory.jsMapCtor = InternalJsMapFactory.getJsMapConstructor();
          }

          return InternalJsMapFactory.jsMapCtor;
        };
        /*private*/


        InternalJsMapFactory.getJsMapConstructor = function () {
          return function () {
            return eval("Map");
          }.call(null);
        };

        InternalJsMapFactory.newJsMap = function () {
          return new (InternalJsMapFactory.jsMapCtor_$LI$())();
        };

        return InternalJsMapFactory;
      }();

      util.InternalJsMapFactory = InternalJsMapFactory;
      InternalJsMapFactory["__class"] = "java.util.InternalJsMapFactory";
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * Incomplete and naive implementation of the BitSet utility (mainly for
      * compatibility/compilation purpose).
      *
      * @author Renaud Pawlak
      * @param {number} nbits
      * @class
      */
      var BitSet =
      /** @class */
      function () {
        function BitSet(nbits) {
          if (typeof nbits === 'number' || nbits === null) {
            this.bits = [];

            while (nbits > 0) {
              {
                this.bits.push(false);
                nbits--;
              }
            }
          } else if (nbits === undefined) {
            this.bits = [];
          } else throw new Error('invalid overload');
        }

        BitSet.valueOf = function (longs) {
          var bs = new BitSet();
          bs.bits = new Array(longs.length * 64);

          for (var n = 0; n < longs.length * 64; n++) {
            {
              bs.bits[n] = (longs[n / 64 | 0] & 1 << n % 64) !== 0;
            }
          }

          return bs;
        };

        BitSet.prototype.flip$int = function (bitIndex) {
          this.bits[bitIndex] = !this.bits[bitIndex];
        };

        BitSet.prototype.flip$int$int = function (fromIndex, toIndex) {
          for (var i = fromIndex; i <= toIndex; i++) {
            {
              this.flip$int(i);
            }
          }
        };

        BitSet.prototype.flip = function (fromIndex, toIndex) {
          if ((typeof fromIndex === 'number' || fromIndex === null) && (typeof toIndex === 'number' || toIndex === null)) {
            return this.flip$int$int(fromIndex, toIndex);
          } else if ((typeof fromIndex === 'number' || fromIndex === null) && toIndex === undefined) {
            return this.flip$int(fromIndex);
          } else throw new Error('invalid overload');
        };

        BitSet.prototype.set$int = function (bitIndex) {
          this.bits[bitIndex] = true;
        };

        BitSet.prototype.set$int$boolean = function (bitIndex, value) {
          if (value) {
            this.set$int(bitIndex);
          } else {
            this.clear$int(bitIndex);
          }
        };

        BitSet.prototype.set$int$int = function (fromIndex, toIndex) {
          for (var i = fromIndex; i <= toIndex; i++) {
            {
              this.set$int(i);
            }
          }
        };

        BitSet.prototype.set$int$int$boolean = function (fromIndex, toIndex, value) {
          if (value) {
            this.set$int$int(fromIndex, toIndex);
          } else {
            this.clear$int$int(fromIndex, toIndex);
          }
        };

        BitSet.prototype.set = function (fromIndex, toIndex, value) {
          if ((typeof fromIndex === 'number' || fromIndex === null) && (typeof toIndex === 'number' || toIndex === null) && (typeof value === 'boolean' || value === null)) {
            return this.set$int$int$boolean(fromIndex, toIndex, value);
          } else if ((typeof fromIndex === 'number' || fromIndex === null) && (typeof toIndex === 'boolean' || toIndex === null) && value === undefined) {
            return this.set$int$boolean(fromIndex, toIndex);
          } else if ((typeof fromIndex === 'number' || fromIndex === null) && (typeof toIndex === 'number' || toIndex === null) && value === undefined) {
            return this.set$int$int(fromIndex, toIndex);
          } else if ((typeof fromIndex === 'number' || fromIndex === null) && toIndex === undefined && value === undefined) {
            return this.set$int(fromIndex);
          } else throw new Error('invalid overload');
        };

        BitSet.prototype.clear$int = function (bitIndex) {
          this.bits[bitIndex] = false;
        };

        BitSet.prototype.clear$int$int = function (fromIndex, toIndex) {
          for (var i = fromIndex; i <= toIndex; i++) {
            {
              this.clear$int(i);
            }
          }
        };

        BitSet.prototype.clear = function (fromIndex, toIndex) {
          if ((typeof fromIndex === 'number' || fromIndex === null) && (typeof toIndex === 'number' || toIndex === null)) {
            return this.clear$int$int(fromIndex, toIndex);
          } else if ((typeof fromIndex === 'number' || fromIndex === null) && toIndex === undefined) {
            return this.clear$int(fromIndex);
          } else if (fromIndex === undefined && toIndex === undefined) {
            return this.clear$();
          } else throw new Error('invalid overload');
        };

        BitSet.prototype.clear$ = function () {
          this.bits = [];
        };

        BitSet.prototype.get$int = function (bitIndex) {
          return this.bits[bitIndex];
        };

        BitSet.prototype.get$int$int = function (fromIndex, toIndex) {
          var bs = new BitSet();

          for (var i = fromIndex; i <= toIndex; i++) {
            {
              bs.bits.push(this.bits[i]);
            }
          }

          return bs;
        };

        BitSet.prototype.get = function (fromIndex, toIndex) {
          if ((typeof fromIndex === 'number' || fromIndex === null) && (typeof toIndex === 'number' || toIndex === null)) {
            return this.get$int$int(fromIndex, toIndex);
          } else if ((typeof fromIndex === 'number' || fromIndex === null) && toIndex === undefined) {
            return this.get$int(fromIndex);
          } else throw new Error('invalid overload');
        };

        BitSet.prototype.length = function () {
          return this.bits.length;
        };

        BitSet.prototype.isEmpty = function () {
          return this.bits.length === 0;
        };

        BitSet.prototype.cardinality = function () {
          var sum = 0;

          for (var i = 0; i < this.bits.length; i++) {
            {
              sum += this.bits[i] ? 1 : 0;
            }
          }

          return sum;
        };

        BitSet.prototype.and = function (set) {
          for (var i = 0; i < this.bits.length; i++) {
            {
              this.bits[i] = this.bits[i] && set.get$int(i);
            }
          }
        };

        BitSet.prototype.or = function (set) {
          for (var i = 0; i < this.bits.length; i++) {
            {
              this.bits[i] = this.bits[i] || set.get$int(i);
            }
          }
        };

        BitSet.prototype.xor = function (set) {
          for (var i = 0; i < this.bits.length; i++) {
            {
              this.bits[i] = this.bits[i] && !set.get$int(i) || !this.bits[i] && set.get$int(i);
            }
          }
        };

        BitSet.prototype.andNot = function (set) {
          for (var i = 0; i < this.bits.length; i++) {
            {
              this.bits[i] = this.bits[i] && !set.get$int(i);
            }
          }
        };

        BitSet.prototype.size = function () {
          return this.bits.length;
        };

        BitSet.prototype.equals = function (obj) {
          if (!(obj != null && obj instanceof java.util.BitSet)) return false;
          if (this === obj) return true;
          var set = obj;

          if (set.bits.length !== this.bits.length) {
            return false;
          }

          for (var i = 0; i < set.bits.length; i++) {
            {
              if (!set.bits[i] == this.bits[i]) {
                return false;
              }
            }
          }

          return true;
        };

        BitSet.prototype.clone = function () {
          var bs = new BitSet();
          bs.bits = this.bits.slice(0, this.bits.length);
          return bs;
        };

        return BitSet;
      }();

      util.BitSet = BitSet;
      BitSet["__class"] = "java.util.BitSet";
      BitSet["__interfaces"] = ["java.lang.Cloneable", "java.io.Serializable"];
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * See <a
      * href="http://docs.oracle.com/javase/7/docs/api/java/util/Objects.html">the
      * official Java API doc</a> for details.
      * @class
      */
      var Objects =
      /** @class */
      function () {
        function Objects() {}

        Objects.compare = function (a, b, c) {
          return a === b ? 0 : function (target) {
            return target['compare'] === undefined ? target : target['compare'];
          }(c)(a, b);
        };

        Objects.deepEquals = function (a, b) {
          if (a === b) {
            return true;
          }

          if (a == null || b == null) {
            return false;
          }

          if (
          /* equals */
          function (o1, o2) {
            if (o1 && o1.equals) {
              return o1.equals(o2);
            } else {
              return o1 === o2;
            }
          }(a, b)) {
            return true;
          }

          var class1 = a.constructor;
          var class2 = b.constructor;

          if (!class1.isArray() || !function (o1, o2) {
            if (o1 && o1.equals) {
              return o1.equals(o2);
            } else {
              return o1 === o2;
            }
          }(class1, class2)) {
            return false;
          }

          if (a != null && a instanceof Array && (a.length == 0 || a[0] == null || a[0] != null)) {
            return java.util.Arrays.deepEquals(a, b);
          }

          if (a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'boolean')) {
            return java.util.Arrays.equals$boolean_A$boolean_A(a, b);
          }

          if (a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'number')) {
            return java.util.Arrays.equals$byte_A$byte_A(a, b);
          }

          if (a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'string')) {
            return java.util.Arrays.equals$char_A$char_A(a, b);
          }

          if (a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'number')) {
            return java.util.Arrays.equals$short_A$short_A(a, b);
          }

          if (a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'number')) {
            return java.util.Arrays.equals$int_A$int_A(a, b);
          }

          if (a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'number')) {
            return java.util.Arrays.equals$long_A$long_A(a, b);
          }

          if (a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'number')) {
            return java.util.Arrays.equals$float_A$float_A(a, b);
          }

          if (a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'number')) {
            return java.util.Arrays.equals$double_A$double_A(a, b);
          }

          return true;
        };

        Objects.equals = function (a, b) {
          return a === b || a != null &&
          /* equals */
          function (o1, o2) {
            if (o1 && o1.equals) {
              return o1.equals(o2);
            } else {
              return o1 === o2;
            }
          }(a, b);
        };

        Objects.hashCode = function (o) {
          return o != null ?
          /* hashCode */
          function (o) {
            if (o.hashCode) {
              return o.hashCode();
            } else {
              return o.toString().split('').reduce(function (prevHash, currVal) {
                return (prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0;
              }, 0);
            }
          }(o) : 0;
        };

        Objects.hash = function () {
          var values = [];

          for (var _i = 0; _i < arguments.length; _i++) {
            values[_i] = arguments[_i];
          }

          return java.util.Arrays.hashCode$java_lang_Object_A(values);
        };

        Objects.isNull = function (obj) {
          return obj == null;
        };

        Objects.nonNull = function (obj) {
          return obj != null;
        };

        Objects.requireNonNull$java_lang_Object = function (obj) {
          if (obj == null) {
            throw new java.lang.NullPointerException();
          }

          return obj;
        };

        Objects.requireNonNull$java_lang_Object$java_lang_String = function (obj, message) {
          if (obj == null) {
            throw new java.lang.NullPointerException(message);
          }

          return obj;
        };

        Objects.requireNonNull = function (obj, message) {
          if ((obj != null || obj === null) && (typeof message === 'string' || message === null)) {
            return java.util.Objects.requireNonNull$java_lang_Object$java_lang_String(obj, message);
          } else if ((obj != null || obj === null) && (typeof message === 'function' && message.length === 0 || message === null)) {
            return java.util.Objects.requireNonNull$java_lang_Object$java_util_function_Supplier(obj, message);
          } else if ((obj != null || obj === null) && message === undefined) {
            return java.util.Objects.requireNonNull$java_lang_Object(obj);
          } else throw new Error('invalid overload');
        };

        Objects.requireNonNull$java_lang_Object$java_util_function_Supplier = function (obj, messageSupplier) {
          if (obj == null) {
            throw new java.lang.NullPointerException(function (target) {
              return typeof target === 'function' ? target() : target.get();
            }(messageSupplier));
          }

          return obj;
        };

        Objects.toString$java_lang_Object = function (o) {
          return (
            /* valueOf */
            new String(o).toString()
          );
        };

        Objects.toString$java_lang_Object$java_lang_String = function (o, nullDefault) {
          return o != null ? o.toString() : nullDefault;
        };

        Objects.toString = function (o, nullDefault) {
          if ((o != null || o === null) && (typeof nullDefault === 'string' || nullDefault === null)) {
            return java.util.Objects.toString$java_lang_Object$java_lang_String(o, nullDefault);
          } else if ((o != null || o === null) && nullDefault === undefined) {
            return java.util.Objects.toString$java_lang_Object(o);
          } else throw new Error('invalid overload');
        };

        return Objects;
      }();

      util.Objects = Objects;
      Objects["__class"] = "java.util.Objects";
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * See <a href="https://docs.oracle.com/javase/8/docs/api/java/util/Optional.html">
      * the official Java API doc</a> for details.
      *
      * @param <T> type of the wrapped reference
      * @class
      */
      var Optional =
      /** @class */
      function () {
        function Optional(ref) {
          if (ref != null || ref === null) {
            if (this.ref === undefined) {
              this.ref = null;
            }

            this.ref = javaemul.internal.InternalPreconditions.checkCriticalNotNull(ref);
          } else if (ref === undefined) {
            if (this.ref === undefined) {
              this.ref = null;
            }

            this.ref = null;
          } else throw new Error('invalid overload');
        }

        Optional.empty = function () {
          return Optional.EMPTY_$LI$();
        };

        Optional.of = function (value) {
          return new Optional(value);
        };

        Optional.ofNullable = function (value) {
          return value == null ? Optional.empty() : Optional.of(value);
        };

        Optional.EMPTY_$LI$ = function () {
          if (Optional.EMPTY == null) {
            Optional.EMPTY = new Optional();
          }

          return Optional.EMPTY;
        };

        Optional.prototype.isPresent = function () {
          return this.ref != null;
        };

        Optional.prototype.get = function () {
          javaemul.internal.InternalPreconditions.checkCriticalElement(this.isPresent());
          return this.ref;
        };

        Optional.prototype.ifPresent = function (consumer) {
          var _this = this;

          if (this.isPresent()) {
            (function (target) {
              return typeof target === 'function' ? target(_this.ref) : target.accept(_this.ref);
            })(consumer);
          }
        };

        Optional.prototype.filter = function (predicate) {
          var _this = this;

          javaemul.internal.InternalPreconditions.checkCriticalNotNull(predicate);

          if (!this.isPresent() || function (target) {
            return typeof target === 'function' ? target(_this.ref) : target.test(_this.ref);
          }(predicate)) {
            return this;
          }

          return Optional.empty();
        };

        Optional.prototype.map = function (mapper) {
          var _this = this;

          javaemul.internal.InternalPreconditions.checkCriticalNotNull(mapper);

          if (this.isPresent()) {
            return Optional.ofNullable(function (target) {
              return typeof target === 'function' ? target(_this.ref) : target.apply(_this.ref);
            }(mapper));
          }

          return Optional.empty();
        };

        Optional.prototype.flatMap = function (mapper) {
          var _this = this;

          javaemul.internal.InternalPreconditions.checkCriticalNotNull(mapper);

          if (this.isPresent()) {
            return javaemul.internal.InternalPreconditions.checkCriticalNotNull(function (target) {
              return typeof target === 'function' ? target(_this.ref) : target.apply(_this.ref);
            }(mapper));
          }

          return Optional.empty();
        };

        Optional.prototype.orElse = function (other) {
          return this.isPresent() ? this.ref : other;
        };

        Optional.prototype.orElseGet = function (other) {
          return this.isPresent() ? this.ref : function (target) {
            return typeof target === 'function' ? target() : target.get();
          }(other);
        };

        Optional.prototype.orElseThrow = function (exceptionSupplier) {
          if (this.isPresent()) {
            return this.ref;
          }

          throw function (target) {
            return typeof target === 'function' ? target() : target.get();
          }(exceptionSupplier);
        };
        /**
        *
        * @param {*} obj
        * @return {boolean}
        */


        Optional.prototype.equals = function (obj) {
          if (obj === this) {
            return true;
          }

          if (!(obj != null && obj instanceof java.util.Optional)) {
            return false;
          }

          var other = obj;
          return java.util.Objects.equals(this.ref, other.ref);
        };
        /**
        *
        * @return {number}
        */


        Optional.prototype.hashCode = function () {
          return java.util.Objects.hashCode(this.ref);
        };
        /**
        *
        * @return {string}
        */


        Optional.prototype.toString = function () {
          return this.isPresent() ? "Optional.of(" +
          /* valueOf */
          new String(this.ref).toString() + ")" : "Optional.empty()";
        };

        return Optional;
      }();

      util.Optional = Optional;
      Optional["__class"] = "java.util.Optional";
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * See <a href="https://docs.oracle.com/javase/8/docs/api/java/util/OptionalDouble.html">
      * the official Java API doc</a> for details.
      * @class
      */
      var OptionalDouble =
      /** @class */
      function () {
        function OptionalDouble(value) {
          if (typeof value === 'number' || value === null) {
            if (this.ref === undefined) {
              this.ref = 0;
            }

            if (this.present === undefined) {
              this.present = false;
            }

            this.ref = value;
            this.present = true;
          } else if (value === undefined) {
            if (this.ref === undefined) {
              this.ref = 0;
            }

            if (this.present === undefined) {
              this.present = false;
            }

            this.ref = 0;
            this.present = false;
          } else throw new Error('invalid overload');
        }

        OptionalDouble.empty = function () {
          return OptionalDouble.EMPTY_$LI$();
        };

        OptionalDouble.of = function (value) {
          return new OptionalDouble(value);
        };

        OptionalDouble.EMPTY_$LI$ = function () {
          if (OptionalDouble.EMPTY == null) {
            OptionalDouble.EMPTY = new OptionalDouble();
          }

          return OptionalDouble.EMPTY;
        };

        OptionalDouble.prototype.isPresent = function () {
          return this.present;
        };

        OptionalDouble.prototype.getAsDouble = function () {
          javaemul.internal.InternalPreconditions.checkCriticalElement(this.present);
          return this.ref;
        };

        OptionalDouble.prototype.ifPresent = function (consumer) {
          var _this = this;

          if (this.present) {
            (function (target) {
              return typeof target === 'function' ? target(_this.ref) : target.accept(_this.ref);
            })(consumer);
          }
        };

        OptionalDouble.prototype.orElse = function (other) {
          return this.present ? this.ref : other;
        };

        OptionalDouble.prototype.orElseGet = function (other) {
          return this.present ? this.ref : function (target) {
            return typeof target === 'function' ? target() : target.getAsDouble();
          }(other);
        };

        OptionalDouble.prototype.orElseThrow = function (exceptionSupplier) {
          if (this.present) {
            return this.ref;
          }

          throw function (target) {
            return typeof target === 'function' ? target() : target.get();
          }(exceptionSupplier);
        };
        /**
        *
        * @param {*} obj
        * @return {boolean}
        */


        OptionalDouble.prototype.equals = function (obj) {
          if (obj === this) {
            return true;
          }

          if (!(obj != null && obj instanceof java.util.OptionalDouble)) {
            return false;
          }

          var other = obj;
          return this.present === other.present &&
          /* compare */
          this.ref - other.ref === 0;
        };
        /**
        *
        * @return {number}
        */


        OptionalDouble.prototype.hashCode = function () {
          return this.present ? javaemul.internal.DoubleHelper.hashCode(this.ref) : 0;
        };
        /**
        *
        * @return {string}
        */


        OptionalDouble.prototype.toString = function () {
          return this.present ? "OptionalDouble.of(" + (
          /* toString */
          '' + this.ref) + ")" : "OptionalDouble.empty()";
        };

        return OptionalDouble;
      }();

      util.OptionalDouble = OptionalDouble;
      OptionalDouble["__class"] = "java.util.OptionalDouble";
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * Construct an Observable with zero Observers.
      * @class
      */
      var Observable =
      /** @class */
      function () {
        function Observable() {
          this.changed = false;

          if (this.obs === undefined) {
            this.obs = null;
          }

          this.obs = new java.util.Vector();
        }
        /**
        * Adds an observer to the set of observers for this object, provided that
        * it is not the same as some observer already in the set. The order in
        * which notifications will be delivered to multiple observers is not
        * specified. See the class comment.
        *
        * @param {*} o
        * an observer to be added.
        * @throws NullPointerException
        * if the parameter o is null.
        */


        Observable.prototype.addObserver = function (o) {
          if (o == null) throw new java.lang.NullPointerException();

          if (!this.obs.contains(o)) {
            this.obs.addElement(o);
          }
        };
        /**
        * Deletes an observer from the set of observers of this object. Passing
        * <CODE>null</CODE> to this method will have no effect.
        *
        * @param {*} o
        * the observer to be deleted.
        */


        Observable.prototype.deleteObserver = function (o) {
          this.obs.removeElement(o);
        };

        Observable.prototype.notifyObservers$ = function () {
          this.notifyObservers$java_lang_Object(null);
        };

        Observable.prototype.notifyObservers$java_lang_Object = function (arg) {
          var arrLocal;
          if (!this.changed) return;
          arrLocal = this.obs.toArray$();
          this.clearChanged();

          for (var i = arrLocal.length - 1; i >= 0; i--) {
            arrLocal[i].update(this, arg);
          }
        };
        /**
        * If this object has changed, as indicated by the <code>hasChanged</code>
        * method, then notify all of its observers and then call the
        * <code>clearChanged</code> method to indicate that this object has no
        * longer changed.
        * <p>
        * Each observer has its <code>update</code> method called with two
        * arguments: this observable object and the <code>arg</code> argument.
        *
        * @param {*} arg
        * any object.
        * @see java.util.Observable#clearChanged()
        * @see java.util.Observable#hasChanged()
        * @see java.util.Observer#update(java.util.Observable, java.lang.Object)
        */


        Observable.prototype.notifyObservers = function (arg) {
          if (arg != null || arg === null) {
            return this.notifyObservers$java_lang_Object(arg);
          } else if (arg === undefined) {
            return this.notifyObservers$();
          } else throw new Error('invalid overload');
        };
        /**
        * Clears the observer list so that this object no longer has any observers.
        */


        Observable.prototype.deleteObservers = function () {
          this.obs.removeAllElements();
        };
        /**
        * Marks this <tt>Observable</tt> object as having been changed; the
        * <tt>hasChanged</tt> method will now return <tt>true</tt>.
        */


        Observable.prototype.setChanged = function () {
          this.changed = true;
        };
        /**
        * Indicates that this object has no longer changed, or that it has already
        * notified all of its observers of its most recent change, so that the
        * <tt>hasChanged</tt> method will now return <tt>false</tt>. This method is
        * called automatically by the <code>notifyObservers</code> methods.
        *
        * @see java.util.Observable#notifyObservers()
        * @see java.util.Observable#notifyObservers(java.lang.Object)
        */


        Observable.prototype.clearChanged = function () {
          this.changed = false;
        };
        /**
        * Tests if this object has changed.
        *
        * @return {boolean} <code>true</code> if and only if the <code>setChanged</code>
        * method has been called more recently than the
        * <code>clearChanged</code> method on this object;
        * <code>false</code> otherwise.
        * @see java.util.Observable#clearChanged()
        * @see java.util.Observable#setChanged()
        */


        Observable.prototype.hasChanged = function () {
          return this.changed;
        };
        /**
        * Returns the number of observers of this <tt>Observable</tt> object.
        *
        * @return {number} the number of observers of this object.
        */


        Observable.prototype.countObservers = function () {
          return this.obs.size();
        };

        return Observable;
      }();

      util.Observable = Observable;
      Observable["__class"] = "java.util.Observable";
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * A simple wrapper around JavaScriptObject to provide {@link java.util.Map}-like semantics for any
      * key type.
      * <p>
      * Implementation notes:
      * <p>
      * A key's hashCode is the index in backingMap which should contain that key. Since several keys may
      * have the same hash, each value in hashCodeMap is actually an array containing all entries whose
      * keys share the same hash.
      * @param {java.util.AbstractHashMap} host
      * @class
      */
      var InternalHashCodeMap =
      /** @class */
      function () {
        function InternalHashCodeMap(host) {
          this.backingMap = java.util.InternalJsMapFactory.newJsMap();

          if (this.host === undefined) {
            this.host = null;
          }

          if (this.__size === undefined) {
            this.__size = 0;
          }

          this.host = host;
        }
        /* Default method injected from java.lang.Iterable */


        InternalHashCodeMap.prototype.forEach = function (action) {
          javaemul.internal.InternalPreconditions.checkNotNull(action);

          var _loop_1 = function _loop_1(index122) {
            var t = index122.next();
            {
              (function (target) {
                return typeof target === 'function' ? target(t) : target.accept(t);
              })(action);
            }
          };

          for (var index122 = this.iterator(); index122.hasNext();) {
            _loop_1(index122);
          }
        };

        InternalHashCodeMap.prototype.put = function (key, value) {
          var hashCode = this.hash(key);
          var chain = this.getChainOrEmpty(hashCode);

          if (chain.length === 0) {
            this.backingMap.set(hashCode, chain);
          } else {
            var entry = this.findEntryInChain(key, chain);

            if (entry != null) {
              return entry.setValue(value);
            }
          }

          chain[chain.length] = new java.util.AbstractMap.SimpleEntry(key, value);
          this.__size++;
          java.util.ConcurrentModificationDetector.structureChanged(this.host);
          return null;
        };

        InternalHashCodeMap.prototype.remove = function (key) {
          var hashCode = this.hash(key);
          var chain = this.getChainOrEmpty(hashCode);

          for (var i = 0; i < chain.length; i++) {
            {
              var entry = chain[i];

              if (this.host._equals(key, entry.getKey())) {
                if (chain.length === 1) {
                  javaemul.internal.ArrayHelper.setLength(chain, 0);
                  this.backingMap["delete"](hashCode);
                } else {
                  javaemul.internal.ArrayHelper.removeFrom(chain, i, 1);
                }

                this.__size--;
                java.util.ConcurrentModificationDetector.structureChanged(this.host);
                return entry.getValue();
              }
            }
          }

          return null;
        };

        InternalHashCodeMap.prototype.getEntry = function (key) {
          return this.findEntryInChain(key, this.getChainOrEmpty(this.hash(key)));
        };
        /*private*/


        InternalHashCodeMap.prototype.findEntryInChain = function (key, chain) {
          for (var index123 = 0; index123 < chain.length; index123++) {
            var entry = chain[index123];
            {
              if (this.host._equals(key, entry.getKey())) {
                return entry;
              }
            }
          }

          return null;
        };

        InternalHashCodeMap.prototype.size = function () {
          return this.__size;
        };
        /**
        *
        * @return {*}
        */


        InternalHashCodeMap.prototype.iterator = function () {
          return new InternalHashCodeMap.InternalHashCodeMap$0(this);
        };
        /*private*/


        InternalHashCodeMap.prototype.getChainOrEmpty = function (hashCode) {
          var chain = this.unsafeCastToArray(this.backingMap.get(hashCode));
          return chain == null ? this.newEntryChain() : chain;
        };
        /*private*/


        InternalHashCodeMap.prototype.newEntryChain = function () {
          return [];
        };
        /*private*/


        InternalHashCodeMap.prototype.unsafeCastToArray = function (arr) {
          return arr;
        };
        /**
        * Returns hash code of the key as calculated by {@link AbstractHashMap#getHashCode(Object)} but
        * also handles null keys as well.
        * @param {*} key
        * @return {number}
        * @private
        */

        /*private*/


        InternalHashCodeMap.prototype.hash = function (key) {
          return key == null ? 0 : this.host.getHashCode(key);
        };

        return InternalHashCodeMap;
      }();

      util.InternalHashCodeMap = InternalHashCodeMap;
      InternalHashCodeMap["__class"] = "java.util.InternalHashCodeMap";
      InternalHashCodeMap["__interfaces"] = ["java.lang.Iterable"];

      (function (InternalHashCodeMap) {
        var InternalHashCodeMap$0 =
        /** @class */
        function () {
          function InternalHashCodeMap$0(__parent) {
            this.__parent = __parent;
            this.chains = this.__parent.backingMap.entries();
            this.itemIndex = 0;
            this.chain = this.__parent.newEntryChain();
            this.lastEntry = null;
          }
          /* Default method injected from java.util.Iterator */


          InternalHashCodeMap$0.prototype.forEachRemaining = function (consumer) {
            var _this = this;

            javaemul.internal.InternalPreconditions.checkNotNull(consumer);

            while (this.hasNext()) {
              {
                (function (target) {
                  return typeof target === 'function' ? target(_this.next()) : target.accept(_this.next());
                })(consumer);
              }
            }
          };
          /**
          *
          * @return {boolean}
          */


          InternalHashCodeMap$0.prototype.hasNext = function () {
            if (this.itemIndex < this.chain.length) {
              return true;
            }

            var current = this.chains.next();

            if (!current.done) {
              this.chain = this.__parent.unsafeCastToArray(current.value[1]);
              this.itemIndex = 0;
              return true;
            }

            return false;
          };
          /**
          *
          * @return {*}
          */


          InternalHashCodeMap$0.prototype.next = function () {
            this.lastEntry = this.chain[this.itemIndex++];
            return this.lastEntry;
          };
          /**
          *
          */


          InternalHashCodeMap$0.prototype.remove = function () {
            this.__parent.remove(this.lastEntry.getKey());

            if (this.itemIndex !== 0) {
              this.itemIndex--;
            }
          };

          return InternalHashCodeMap$0;
        }();

        InternalHashCodeMap.InternalHashCodeMap$0 = InternalHashCodeMap$0;
        InternalHashCodeMap$0["__interfaces"] = ["java.util.Iterator"];
      })(InternalHashCodeMap = util.InternalHashCodeMap || (util.InternalHashCodeMap = {}));
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      (function (stream) {
        (function (IntStream) {
          function range(startInclusive, endExclusive) {
            if (startInclusive >= endExclusive) {
              return java.util.Collections.emptyList().stream();
            } else {
              var result = new java.util.ArrayList();

              for (; startInclusive < endExclusive; ++startInclusive) {
                {
                  result.add(startInclusive);
                }
              }

              return result.stream();
            }
          }

          IntStream.range = range;
        })(stream.IntStream || (stream.IntStream = {}));
      })(util.stream || (util.stream = {}));
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      (function (stream) {
        (function (Collector) {
          (function (Characteristics) {
            /**
            * Indicates that this collector is <em>concurrent</em>, meaning that
            * the result container can support the accumulator function being
            * called concurrently with the same result container from multiple
            * threads.
            *
            * <p>If a {@code CONCURRENT} collector is not also {@code UNORDERED},
            * then it should only be evaluated concurrently if applied to an
            * unordered data source.
            */
            Characteristics[Characteristics["CONCURRENT"] = 0] = "CONCURRENT";
            /**
            * Indicates that the collection operation does not commit to preserving
            * the encounter order of input elements.  (This might be true if the
            * result container has no intrinsic order, such as a {@link Set}.)
            */

            Characteristics[Characteristics["UNORDERED"] = 1] = "UNORDERED";
            /**
            * Indicates that the finisher function is the identity function and
            * can be elided.  If set, it must be the case that an unchecked cast
            * from A to R will succeed.
            */

            Characteristics[Characteristics["IDENTITY_FINISH"] = 2] = "IDENTITY_FINISH";
          })(Collector.Characteristics || (Collector.Characteristics = {}));
        })(stream.Collector || (stream.Collector = {}));
      })(util.stream || (util.stream = {}));
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      (function (stream) {
        (function (Stream) {
          function of() {
            var values = [];

            for (var _i = 0; _i < arguments.length; _i++) {
              values[_i] = arguments[_i];
            }

            return java.util.Arrays.asList.apply(null, values).stream();
          }

          Stream.of = of;
        })(stream.Stream || (stream.Stream = {}));
      })(util.stream || (util.stream = {}));
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * See <a href="https://docs.oracle.com/javase/8/docs/api/java/util/OptionalInt.html">
      * the official Java API doc</a> for details.
      * @class
      */
      var OptionalInt =
      /** @class */
      function () {
        function OptionalInt(value) {
          if (typeof value === 'number' || value === null) {
            if (this.ref === undefined) {
              this.ref = 0;
            }

            if (this.present === undefined) {
              this.present = false;
            }

            this.ref = value;
            this.present = true;
          } else if (value === undefined) {
            if (this.ref === undefined) {
              this.ref = 0;
            }

            if (this.present === undefined) {
              this.present = false;
            }

            this.ref = 0;
            this.present = false;
          } else throw new Error('invalid overload');
        }

        OptionalInt.empty = function () {
          return OptionalInt.EMPTY_$LI$();
        };

        OptionalInt.of = function (value) {
          return new OptionalInt(value);
        };

        OptionalInt.EMPTY_$LI$ = function () {
          if (OptionalInt.EMPTY == null) {
            OptionalInt.EMPTY = new OptionalInt();
          }

          return OptionalInt.EMPTY;
        };

        OptionalInt.prototype.isPresent = function () {
          return this.present;
        };

        OptionalInt.prototype.getAsInt = function () {
          javaemul.internal.InternalPreconditions.checkCriticalElement(this.present);
          return this.ref;
        };

        OptionalInt.prototype.ifPresent = function (consumer) {
          var _this = this;

          if (this.present) {
            (function (target) {
              return typeof target === 'function' ? target(_this.ref) : target.accept(_this.ref);
            })(consumer);
          }
        };

        OptionalInt.prototype.orElse = function (other) {
          return this.present ? this.ref : other;
        };

        OptionalInt.prototype.orElseGet = function (other) {
          return this.present ? this.ref : function (target) {
            return typeof target === 'function' ? target() : target.getAsInt();
          }(other);
        };

        OptionalInt.prototype.orElseThrow = function (exceptionSupplier) {
          if (this.present) {
            return this.ref;
          }

          throw function (target) {
            return typeof target === 'function' ? target() : target.get();
          }(exceptionSupplier);
        };
        /**
        *
        * @param {*} obj
        * @return {boolean}
        */


        OptionalInt.prototype.equals = function (obj) {
          if (obj === this) {
            return true;
          }

          if (!(obj != null && obj instanceof java.util.OptionalInt)) {
            return false;
          }

          var other = obj;
          return this.present === other.present &&
          /* compare */
          this.ref - other.ref === 0;
        };
        /**
        *
        * @return {number}
        */


        OptionalInt.prototype.hashCode = function () {
          return this.present ? javaemul.internal.IntegerHelper.hashCode(this.ref) : 0;
        };
        /**
        *
        * @return {string}
        */


        OptionalInt.prototype.toString = function () {
          return this.present ? "OptionalInt.of(" + (
          /* toString */
          '' + this.ref) + ")" : "OptionalInt.empty()";
        };

        return OptionalInt;
      }();

      util.OptionalInt = OptionalInt;
      OptionalInt["__class"] = "java.util.OptionalInt";
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * See <a href="https://docs.oracle.com/javase/8/docs/api/java/util/OptionalLong.html">
      * the official Java API doc</a> for details.
      * @class
      */
      var OptionalLong =
      /** @class */
      function () {
        function OptionalLong(value) {
          if (typeof value === 'number' || value === null) {
            if (this.ref === undefined) {
              this.ref = 0;
            }

            if (this.present === undefined) {
              this.present = false;
            }

            this.ref = value;
            this.present = true;
          } else if (value === undefined) {
            if (this.ref === undefined) {
              this.ref = 0;
            }

            if (this.present === undefined) {
              this.present = false;
            }

            this.ref = 0;
            this.present = false;
          } else throw new Error('invalid overload');
        }

        OptionalLong.empty = function () {
          return OptionalLong.EMPTY_$LI$();
        };

        OptionalLong.of = function (value) {
          return new OptionalLong(value);
        };

        OptionalLong.EMPTY_$LI$ = function () {
          if (OptionalLong.EMPTY == null) {
            OptionalLong.EMPTY = new OptionalLong();
          }

          return OptionalLong.EMPTY;
        };

        OptionalLong.prototype.isPresent = function () {
          return this.present;
        };

        OptionalLong.prototype.getAsLong = function () {
          javaemul.internal.InternalPreconditions.checkCriticalElement(this.present);
          return this.ref;
        };

        OptionalLong.prototype.ifPresent = function (consumer) {
          var _this = this;

          if (this.present) {
            (function (target) {
              return typeof target === 'function' ? target(_this.ref) : target.accept(_this.ref);
            })(consumer);
          }
        };

        OptionalLong.prototype.orElse = function (other) {
          return this.present ? this.ref : other;
        };

        OptionalLong.prototype.orElseGet = function (other) {
          return this.present ? this.ref : function (target) {
            return typeof target === 'function' ? target() : target.getAsLong();
          }(other);
        };

        OptionalLong.prototype.orElseThrow = function (exceptionSupplier) {
          if (this.present) {
            return this.ref;
          }

          throw function (target) {
            return typeof target === 'function' ? target() : target.get();
          }(exceptionSupplier);
        };
        /**
        *
        * @param {*} obj
        * @return {boolean}
        */


        OptionalLong.prototype.equals = function (obj) {
          if (obj === this) {
            return true;
          }

          if (!(obj != null && obj instanceof java.util.OptionalLong)) {
            return false;
          }

          var other = obj;
          return this.present === other.present &&
          /* compare */
          this.ref - other.ref === 0;
        };
        /**
        *
        * @return {number}
        */


        OptionalLong.prototype.hashCode = function () {
          return this.present ? javaemul.internal.LongHelper.hashCode(this.ref) : 0;
        };
        /**
        *
        * @return {string}
        */


        OptionalLong.prototype.toString = function () {
          return this.present ? "OptionalLong.of(" + (
          /* toString */
          '' + this.ref) + ")" : "OptionalLong.empty()";
        };

        return OptionalLong;
      }();

      util.OptionalLong = OptionalLong;
      OptionalLong["__class"] = "java.util.OptionalLong";
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * Available as a superclass of event objects.
      * @param {*} source
      * @class
      */
      var EventObject =
      /** @class */
      function () {
        function EventObject(source) {
          if (this.source === undefined) {
            this.source = null;
          }

          this.source = source;
        }

        EventObject.prototype.getSource = function () {
          return this.source;
        };

        return EventObject;
      }();

      util.EventObject = EventObject;
      EventObject["__class"] = "java.util.EventObject";
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      (function (InternalJsMap) {})(util.InternalJsMap || (util.InternalJsMap = {}));
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * Constructs a string tokenizer for the specified string. All
      * characters in the <code>delim</code> argument are the delimiters
      * for separating tokens.
      * <p>
      * If the <code>returnDelims</code> flag is <code>true</code>, then
      * the delimiter characters are also returned as tokens. Each
      * delimiter is returned as a string of length one. If the flag is
      * <code>false</code>, the delimiter characters are skipped and only
      * serve as separators between tokens.
      * <p>
      * Note that if <tt>delim</tt> is <tt>null</tt>, this constructor does
      * not throw an exception. However, trying to invoke other methods on the
      * resulting <tt>StringTokenizer</tt> may result in a
      * <tt>NullPointerException</tt>.
      *
      * @param   {string} str            a string to be parsed.
      * @param   {string} delim          the delimiters.
      * @param   {boolean} returnDelims   flag indicating whether to return the delimiters
      * as tokens.
      * @exception NullPointerException if str is <CODE>null</CODE>
      * @class
      * @author  unascribed
      */
      var StringTokenizer =
      /** @class */
      function () {
        function StringTokenizer(str, delim, returnDelims) {
          if ((typeof str === 'string' || str === null) && (typeof delim === 'string' || delim === null) && (typeof returnDelims === 'boolean' || returnDelims === null)) {
            if (this.currentPosition === undefined) {
              this.currentPosition = 0;
            }

            if (this.newPosition === undefined) {
              this.newPosition = 0;
            }

            if (this.maxPosition === undefined) {
              this.maxPosition = 0;
            }

            if (this.str === undefined) {
              this.str = null;
            }

            if (this.delimiters === undefined) {
              this.delimiters = null;
            }

            if (this.retDelims === undefined) {
              this.retDelims = false;
            }

            if (this.delimsChanged === undefined) {
              this.delimsChanged = false;
            }

            if (this.maxDelimCodePoint === undefined) {
              this.maxDelimCodePoint = 0;
            }

            if (this.delimiterCodePoints === undefined) {
              this.delimiterCodePoints = null;
            }

            this.hasSurrogates = false;
            this.currentPosition = 0;
            this.newPosition = -1;
            this.delimsChanged = false;
            this.str = str;
            this.maxPosition = str.length;
            this.delimiters = delim;
            this.retDelims = returnDelims;
            this.setMaxDelimCodePoint();
          } else if ((typeof str === 'string' || str === null) && (typeof delim === 'string' || delim === null) && returnDelims === undefined) {
            {
              var returnDelims_1 = false;

              if (this.currentPosition === undefined) {
                this.currentPosition = 0;
              }

              if (this.newPosition === undefined) {
                this.newPosition = 0;
              }

              if (this.maxPosition === undefined) {
                this.maxPosition = 0;
              }

              if (this.str === undefined) {
                this.str = null;
              }

              if (this.delimiters === undefined) {
                this.delimiters = null;
              }

              if (this.retDelims === undefined) {
                this.retDelims = false;
              }

              if (this.delimsChanged === undefined) {
                this.delimsChanged = false;
              }

              if (this.maxDelimCodePoint === undefined) {
                this.maxDelimCodePoint = 0;
              }

              if (this.delimiterCodePoints === undefined) {
                this.delimiterCodePoints = null;
              }

              this.hasSurrogates = false;
              this.currentPosition = 0;
              this.newPosition = -1;
              this.delimsChanged = false;
              this.str = str;
              this.maxPosition = str.length;
              this.delimiters = delim;
              this.retDelims = returnDelims_1;
              this.setMaxDelimCodePoint();
            }

            if (this.currentPosition === undefined) {
              this.currentPosition = 0;
            }

            if (this.newPosition === undefined) {
              this.newPosition = 0;
            }

            if (this.maxPosition === undefined) {
              this.maxPosition = 0;
            }

            if (this.str === undefined) {
              this.str = null;
            }

            if (this.delimiters === undefined) {
              this.delimiters = null;
            }

            if (this.retDelims === undefined) {
              this.retDelims = false;
            }

            if (this.delimsChanged === undefined) {
              this.delimsChanged = false;
            }

            if (this.maxDelimCodePoint === undefined) {
              this.maxDelimCodePoint = 0;
            }

            if (this.delimiterCodePoints === undefined) {
              this.delimiterCodePoints = null;
            }

            this.hasSurrogates = false;
          } else if ((typeof str === 'string' || str === null) && delim === undefined && returnDelims === undefined) {
            {
              var delim_1 = " \t\n\r\f";
              var returnDelims_2 = false;

              if (this.currentPosition === undefined) {
                this.currentPosition = 0;
              }

              if (this.newPosition === undefined) {
                this.newPosition = 0;
              }

              if (this.maxPosition === undefined) {
                this.maxPosition = 0;
              }

              if (this.str === undefined) {
                this.str = null;
              }

              if (this.delimiters === undefined) {
                this.delimiters = null;
              }

              if (this.retDelims === undefined) {
                this.retDelims = false;
              }

              if (this.delimsChanged === undefined) {
                this.delimsChanged = false;
              }

              if (this.maxDelimCodePoint === undefined) {
                this.maxDelimCodePoint = 0;
              }

              if (this.delimiterCodePoints === undefined) {
                this.delimiterCodePoints = null;
              }

              this.hasSurrogates = false;
              this.currentPosition = 0;
              this.newPosition = -1;
              this.delimsChanged = false;
              this.str = str;
              this.maxPosition = str.length;
              this.delimiters = delim_1;
              this.retDelims = returnDelims_2;
              this.setMaxDelimCodePoint();
            }

            if (this.currentPosition === undefined) {
              this.currentPosition = 0;
            }

            if (this.newPosition === undefined) {
              this.newPosition = 0;
            }

            if (this.maxPosition === undefined) {
              this.maxPosition = 0;
            }

            if (this.str === undefined) {
              this.str = null;
            }

            if (this.delimiters === undefined) {
              this.delimiters = null;
            }

            if (this.retDelims === undefined) {
              this.retDelims = false;
            }

            if (this.delimsChanged === undefined) {
              this.delimsChanged = false;
            }

            if (this.maxDelimCodePoint === undefined) {
              this.maxDelimCodePoint = 0;
            }

            if (this.delimiterCodePoints === undefined) {
              this.delimiterCodePoints = null;
            }

            this.hasSurrogates = false;
          } else throw new Error('invalid overload');
        }
        /**
        * Set maxDelimCodePoint to the highest char in the delimiter set.
        * @private
        */

        /*private*/


        StringTokenizer.prototype.setMaxDelimCodePoint = function () {
          if (this.delimiters == null) {
            this.maxDelimCodePoint = 0;
            return;
          }

          var m = 0;
          var c;
          var count = 0;

          for (var i = 0; i < this.delimiters.length; i += javaemul.internal.CharacterHelper.charCount(c)) {
            {
              c = this.delimiters.charAt(i).charCodeAt(0);

              if (c >= function (c) {
                return c.charCodeAt == null ? c : c.charCodeAt(0);
              }(javaemul.internal.CharacterHelper.MIN_HIGH_SURROGATE) && c <= function (c) {
                return c.charCodeAt == null ? c : c.charCodeAt(0);
              }(javaemul.internal.CharacterHelper.MAX_LOW_SURROGATE)) {
                c =
                /* codePointAt */
                this.delimiters.charCodeAt(i);
                this.hasSurrogates = true;
              }

              if (m < c) m = c;
              count++;
            }
          }

          this.maxDelimCodePoint = m;

          if (this.hasSurrogates) {
            this.delimiterCodePoints = function (s) {
              var a = [];

              while (s-- > 0) {
                a.push(0);
              }

              return a;
            }(count);

            for (var i = 0, j = 0; i < count; i++, j += javaemul.internal.CharacterHelper.charCount(c)) {
              {
                c =
                /* codePointAt */
                this.delimiters.charCodeAt(j);
                this.delimiterCodePoints[i] = c;
              }
            }
          }
        };
        /**
        * Skips delimiters starting from the specified position. If retDelims
        * is false, returns the index of the first non-delimiter character at or
        * after startPos. If retDelims is true, startPos is returned.
        * @param {number} startPos
        * @return {number}
        * @private
        */

        /*private*/


        StringTokenizer.prototype.skipDelimiters = function (startPos) {
          if (this.delimiters == null) throw new java.lang.NullPointerException();
          var position = startPos;

          while (!this.retDelims && position < this.maxPosition) {
            {
              if (!this.hasSurrogates) {
                var c = this.str.charAt(position);
                if (function (c) {
                  return c.charCodeAt == null ? c : c.charCodeAt(0);
                }(c) > this.maxDelimCodePoint || this.delimiters.indexOf(c) < 0) break;
                position++;
              } else {
                var c = this.str.charCodeAt(position);

                if (c > this.maxDelimCodePoint || !this.isDelimiter(c)) {
                  break;
                }

                position += javaemul.internal.CharacterHelper.charCount(c);
              }
            }
          }

          return position;
        };
        /**
        * Skips ahead from startPos and returns the index of the next delimiter
        * character encountered, or maxPosition if no such delimiter is found.
        * @param {number} startPos
        * @return {number}
        * @private
        */

        /*private*/


        StringTokenizer.prototype.scanToken = function (startPos) {
          var position = startPos;

          while (position < this.maxPosition) {
            {
              if (!this.hasSurrogates) {
                var c = this.str.charAt(position);
                if (function (c) {
                  return c.charCodeAt == null ? c : c.charCodeAt(0);
                }(c) <= this.maxDelimCodePoint && this.delimiters.indexOf(c) >= 0) break;
                position++;
              } else {
                var c = this.str.charCodeAt(position);
                if (c <= this.maxDelimCodePoint && this.isDelimiter(c)) break;
                position += javaemul.internal.CharacterHelper.charCount(c);
              }
            }
          }

          if (this.retDelims && startPos === position) {
            if (!this.hasSurrogates) {
              var c = this.str.charAt(position);
              if (function (c) {
                return c.charCodeAt == null ? c : c.charCodeAt(0);
              }(c) <= this.maxDelimCodePoint && this.delimiters.indexOf(c) >= 0) position++;
            } else {
              var c = this.str.charCodeAt(position);
              if (c <= this.maxDelimCodePoint && this.isDelimiter(c)) position += javaemul.internal.CharacterHelper.charCount(c);
            }
          }

          return position;
        };
        /*private*/


        StringTokenizer.prototype.isDelimiter = function (codePoint) {
          for (var i = 0; i < this.delimiterCodePoints.length; i++) {
            {
              if (this.delimiterCodePoints[i] === codePoint) {
                return true;
              }
            }
          }

          return false;
        };
        /**
        * Tests if there are more tokens available from this tokenizer's string.
        * If this method returns <tt>true</tt>, then a subsequent call to
        * <tt>nextToken</tt> with no argument will successfully return a token.
        *
        * @return  {boolean} <code>true</code> if and only if there is at least one token
        * in the string after the current position; <code>false</code>
        * otherwise.
        */


        StringTokenizer.prototype.hasMoreTokens = function () {
          this.newPosition = this.skipDelimiters(this.currentPosition);
          return this.newPosition < this.maxPosition;
        };

        StringTokenizer.prototype.nextToken$ = function () {
          this.currentPosition = this.newPosition >= 0 && !this.delimsChanged ? this.newPosition : this.skipDelimiters(this.currentPosition);
          this.delimsChanged = false;
          this.newPosition = -1;
          if (this.currentPosition >= this.maxPosition) throw new java.util.NoSuchElementException();
          var start = this.currentPosition;
          this.currentPosition = this.scanToken(this.currentPosition);
          return this.str.substring(start, this.currentPosition);
        };

        StringTokenizer.prototype.nextToken$java_lang_String = function (delim) {
          this.delimiters = delim;
          this.delimsChanged = true;
          this.setMaxDelimCodePoint();
          return this.nextToken$();
        };
        /**
        * Returns the next token in this string tokenizer's string. First,
        * the set of characters considered to be delimiters by this
        * <tt>StringTokenizer</tt> object is changed to be the characters in
        * the string <tt>delim</tt>. Then the next token in the string
        * after the current position is returned. The current position is
        * advanced beyond the recognized token.  The new delimiter set
        * remains the default after this call.
        *
        * @param      {string} delim   the new delimiters.
        * @return     {string} the next token, after switching to the new delimiter set.
        * @exception  NoSuchElementException  if there are no more tokens in this
        * tokenizer's string.
        * @exception NullPointerException if delim is <CODE>null</CODE>
        */


        StringTokenizer.prototype.nextToken = function (delim) {
          if (typeof delim === 'string' || delim === null) {
            return this.nextToken$java_lang_String(delim);
          } else if (delim === undefined) {
            return this.nextToken$();
          } else throw new Error('invalid overload');
        };
        /**
        * Returns the same value as the <code>hasMoreTokens</code>
        * method. It exists so that this class can implement the
        * <code>Enumeration</code> interface.
        *
        * @return  {boolean} <code>true</code> if there are more tokens;
        * <code>false</code> otherwise.
        * @see     java.util.Enumeration
        * @see     java.util.StringTokenizer#hasMoreTokens()
        */


        StringTokenizer.prototype.hasMoreElements = function () {
          return this.hasMoreTokens();
        };
        /**
        * Returns the same value as the <code>nextToken</code> method,
        * except that its declared return value is <code>Object</code> rather than
        * <code>String</code>. It exists so that this class can implement the
        * <code>Enumeration</code> interface.
        *
        * @return     {*} the next token in the string.
        * @exception  NoSuchElementException  if there are no more tokens in this
        * tokenizer's string.
        * @see        java.util.Enumeration
        * @see        java.util.StringTokenizer#nextToken()
        */


        StringTokenizer.prototype.nextElement = function () {
          return this.nextToken$();
        };
        /**
        * Calculates the number of times that this tokenizer's
        * <code>nextToken</code> method can be called before it generates an
        * exception. The current position is not advanced.
        *
        * @return  {number} the number of tokens remaining in the string using the current
        * delimiter set.
        * @see     java.util.StringTokenizer#nextToken()
        */


        StringTokenizer.prototype.countTokens = function () {
          var count = 0;
          var currpos = this.currentPosition;

          while (currpos < this.maxPosition) {
            {
              currpos = this.skipDelimiters(currpos);
              if (currpos >= this.maxPosition) break;
              currpos = this.scanToken(currpos);
              count++;
            }
          }

          return count;
        };

        return StringTokenizer;
      }();

      util.StringTokenizer = StringTokenizer;
      StringTokenizer["__class"] = "java.util.StringTokenizer";
      StringTokenizer["__interfaces"] = ["java.util.Enumeration"];
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      (function (regex) {
        var Matcher =
        /** @class */
        function () {
          function Matcher(_pattern, text) {
            if (this._pattern === undefined) {
              this._pattern = null;
            }

            if (this.text === undefined) {
              this.text = null;
            }

            if (this.starts === undefined) {
              this.starts = null;
            }

            if (this.ends === undefined) {
              this.ends = null;
            }

            if (this.groups === undefined) {
              this.groups = null;
            }

            this.first = -1;
            this.last = 0;
            this.lastAppendPosition = 0;
            this._pattern = _pattern;
            this.text = text;
            this.reset$();
          }

          Matcher.prototype.hasGroups = function () {
            if (this.groups == null) throw new java.lang.IllegalStateException("No match available");
          };

          Matcher.prototype.searchWith = function (regExp) {
            var startLastIndex = regExp.lastIndex | 0;
            var exec = regExp.exec(this.text);
            this.groups = exec;

            if (this.groups == null) {
              this.reset$();
              return false;
            }

            this.starts = [];
            this.ends = [];
            var parenthesisStart = [];
            var parenthesisEnds = [];
            var nonCapturesToCaptures = new Matcher.NonCapturesToCaptures(parenthesisStart, parenthesisEnds);
            var regExpStringWithAllCaptures = regExp.source.replace(new RegExp("((?:\\\\.|\\[\\^?\\]\\]|\\[\\^?(?:[^\\\\\\]]|\\\\.|)+\\])+)|\\(((?:\\?\\:)?)|(\\))", "g"), function (nonCapturesToCaptures) {
              return function () {
                var args = [];

                for (var _i = 0; _i < arguments.length; _i++) {
                  args[_i] = arguments[_i];
                }

                return nonCapturesToCaptures.apply(args);
              };
            }(nonCapturesToCaptures));
            var regExpWithAllCaptures = new RegExp(regExpStringWithAllCaptures);
            var indexGetter = new Matcher.IndexGetter(regExp.source, parenthesisStart, parenthesisEnds, this.starts, this.ends, startLastIndex);
            this.text.substring(startLastIndex).replace(regExpWithAllCaptures, function (indexGetter) {
              return function () {
                var args = [];

                for (var _i = 0; _i < arguments.length; _i++) {
                  args[_i] = arguments[_i];
                }

                return indexGetter.apply(args);
              };
            }(indexGetter));
            return true;
          };

          Matcher.prototype.end$ = function () {
            return this.end$int(0);
          };

          Matcher.prototype.end$int = function (i) {
            this.hasGroups();
            return this.ends[i];
          };

          Matcher.prototype.end$java_lang_String = function (string) {
            return this.end$int(this._pattern.namedGroupsNames.get(string) + this.regionStart());
          };

          Matcher.prototype.end = function (string) {
            if (typeof string === 'string' || string === null) {
              return this.end$java_lang_String(string);
            } else if (typeof string === 'number' || string === null) {
              return this.end$int(string);
            } else if (string === undefined) {
              return this.end$();
            } else throw new Error('invalid overload');
          };

          Matcher.prototype.find$ = function () {
            return this.searchWith(this._pattern.regexp);
          };

          Matcher.prototype.find$int = function (start) {
            this._pattern.regexp.lastIndex = start;
            return this.find$();
          };

          Matcher.prototype.find = function (start) {
            if (typeof start === 'number' || start === null) {
              return this.find$int(start);
            } else if (start === undefined) {
              return this.find$();
            } else throw new Error('invalid overload');
          };

          Matcher.prototype.group$ = function () {
            return this.group$int(0);
          };

          Matcher.prototype.group$int = function (i) {
            this.hasGroups();
            return this.groups[i];
          };

          Matcher.prototype.group$java_lang_String = function (string) {
            return this.group$int(this._pattern.namedGroupsNames.get(string) + this.regionStart());
          };

          Matcher.prototype.group = function (string) {
            if (typeof string === 'string' || string === null) {
              return this.group$java_lang_String(string);
            } else if (typeof string === 'number' || string === null) {
              return this.group$int(string);
            } else if (string === undefined) {
              return this.group$();
            } else throw new Error('invalid overload');
          };
          /**
          *
          * @return {number}
          */


          Matcher.prototype.groupCount = function () {
            return this.groups.length - 1;
          };

          Matcher.prototype.hitEnd = function () {
            return this.end$() === this.text.length;
          };

          Matcher.prototype.lookingAt = function () {
            this.reset$();
            return this.searchWith(java.util.regex.Pattern.compile$java_lang_String("^(?:" + this._pattern.pattern() + ")").regexp);
          };

          Matcher.prototype.matches = function () {
            this.reset$();
            return this.searchWith(java.util.regex.Pattern.compile$java_lang_String("^(?:" + this._pattern.pattern() + ")$").regexp);
          };

          Matcher.prototype.pattern = function () {
            return this._pattern;
          };

          Matcher.prototype.regionEnd = function () {
            this.hasGroups();
            return this.groups.length;
          };

          Matcher.prototype.regionStart = function () {
            this.hasGroups();
            return 1;
          };

          Matcher.prototype.replaceAll = function (replacement) {
            this.reset$();
            this.text = this.text.replace(this._pattern.regexp, replacement);
            return this.text;
          };

          Matcher.prototype.replaceFirst = function (replacement) {
            this.reset$();
            var firstReplacer = new Matcher.FirstReplacer(replacement);
            this.text = this.text.replace(this._pattern.regexp, function (firstReplacer) {
              return function (args) {
                return firstReplacer.apply(args);
              };
            }(firstReplacer));
            return this.text;
          };

          Matcher.prototype.reset$ = function () {
            this._pattern.regexp.lastIndex = 0;
            this.groups = null;
            this.starts = null;
            this.ends = null;
            this.first = -1;
            this.last = 0;
            return this;
          };

          Matcher.prototype.reset$java_lang_CharSequence = function (input) {
            this.text = input.toString();
            return this.reset$();
          };

          Matcher.prototype.reset = function (input) {
            if (input != null && (input.constructor != null && input.constructor["__interfaces"] != null && input.constructor["__interfaces"].indexOf("java.lang.CharSequence") >= 0 || typeof input === "string") || input === null) {
              return this.reset$java_lang_CharSequence(input);
            } else if (input === undefined) {
              return this.reset$();
            } else throw new Error('invalid overload');
          };

          Matcher.prototype.start$ = function () {
            return this.start$int(0);
          };

          Matcher.prototype.start$int = function (i) {
            this.hasGroups();
            return this.starts[i];
          };

          Matcher.prototype.start$java_lang_String = function (string) {
            return this.start$int(this._pattern.namedGroupsNames.get(string) + this.regionStart());
          };

          Matcher.prototype.start = function (string) {
            if (typeof string === 'string' || string === null) {
              return this.start$java_lang_String(string);
            } else if (typeof string === 'number' || string === null) {
              return this.start$int(string);
            } else if (string === undefined) {
              return this.start$();
            } else throw new Error('invalid overload');
          };

          Matcher.prototype.toMatchResult = function () {
            return this;
          };

          Matcher.prototype.usePattern = function (newPattern) {
            this._pattern = newPattern;
            return this;
          };

          return Matcher;
        }();

        regex.Matcher = Matcher;
        Matcher["__class"] = "java.util.regex.Matcher";
        Matcher["__interfaces"] = ["java.util.regex.MatchResult"];

        (function (Matcher) {
          var IndexGetter =
          /** @class */
          function () {
            function IndexGetter(regexString, parenthesisStart, parenthesisEnd, starts, ends, startLastIndex) {
              if (this.regexString === undefined) {
                this.regexString = null;
              }

              if (this.parenthesisStart === undefined) {
                this.parenthesisStart = null;
              }

              if (this.parenthesisEnd === undefined) {
                this.parenthesisEnd = null;
              }

              if (this.starts === undefined) {
                this.starts = null;
              }

              if (this.ends === undefined) {
                this.ends = null;
              }

              if (this.startLastIndex === undefined) {
                this.startLastIndex = 0;
              }

              this.regexString = regexString;
              this.parenthesisStart = parenthesisStart;
              this.parenthesisEnd = parenthesisEnd;
              this.starts = starts;
              this.ends = ends;
              this.startLastIndex = startLastIndex;
            }
            /**
            *
            * @param {Array} args
            * @return {string}
            */


            IndexGetter.prototype.apply = function (args) {
              this.starts.push(args[args.length - 2]);
              this.ends.push(this.starts[0] + args[0].length);
              var lastIndices = new java.util.Stack();
              lastIndices.push(this.ends[0]);
              lastIndices.push(this.starts[0]);
              var countEndsFrom = 0;

              for (var i = 0; i < args.length - 3; ++i) {
                {
                  var pl = this.parenthesisStart[i];

                  while (this.parenthesisEnd[countEndsFrom] < pl) {
                    {
                      countEndsFrom += 1;
                      lastIndices.pop();
                    }
                  }

                  var start = lastIndices.pop();
                  var len = args[i + 1] != null ? args[i + 1].length : 0;
                  lastIndices.push(start + len);
                  lastIndices.push(start);

                  if (function (c) {
                    return c.charCodeAt == null ? c : c.charCodeAt(0);
                  }(this.regexString.charAt(pl + 1)) == '?'.charCodeAt(0)) {
                    continue;
                  }

                  if (len === 0) {
                    this.starts.push(-1);
                    this.ends.push(-1);
                  } else {
                    start += this.startLastIndex;
                    this.starts.push(start);
                    this.ends.push(start + len);
                  }
                }
              }

              this.starts[0] += this.startLastIndex;
              this.ends[0] += this.startLastIndex;
              return args[0];
            };

            return IndexGetter;
          }();

          Matcher.IndexGetter = IndexGetter;
          IndexGetter["__class"] = "java.util.regex.Matcher.IndexGetter";
          IndexGetter["__interfaces"] = ["java.util.function.Function"];

          var NonCapturesToCaptures =
          /** @class */
          function () {
            function NonCapturesToCaptures(start, ends) {
              if (this.start === undefined) {
                this.start = null;
              }

              if (this.ends === undefined) {
                this.ends = null;
              }

              this.start = start;
              this.ends = ends;
            }
            /**
            *
            * @param {Array} args
            * @return {string}
            */


            NonCapturesToCaptures.prototype.apply = function (args) {
              if (args[1] !== undefined) {
                return args[1];
              }

              if (args[2] !== undefined) {
                this.start.push(javaemul.internal.IntegerHelper.parseInt(args[args.length - 2]));
                return "(";
              }

              if (args[3] !== undefined) {
                this.ends.push(javaemul.internal.IntegerHelper.parseInt(args[args.length - 2]));
                return args[3];
              }

              throw new Error("NonCapturesToCaptures");
            };

            return NonCapturesToCaptures;
          }();

          Matcher.NonCapturesToCaptures = NonCapturesToCaptures;
          NonCapturesToCaptures["__class"] = "java.util.regex.Matcher.NonCapturesToCaptures";
          NonCapturesToCaptures["__interfaces"] = ["java.util.function.Function"];

          var FirstReplacer =
          /** @class */
          function () {
            function FirstReplacer(replacement) {
              if (this.replacement === undefined) {
                this.replacement = null;
              }

              this.first = true;
              this.replacement = replacement;
            }
            /**
            *
            * @param {Array} args
            * @return {string}
            */


            FirstReplacer.prototype.apply = function (args) {
              if (this.first) {
                this.first = false;
                return this.replacement;
              }

              return args[0];
            };

            return FirstReplacer;
          }();

          Matcher.FirstReplacer = FirstReplacer;
          FirstReplacer["__class"] = "java.util.regex.Matcher.FirstReplacer";
          FirstReplacer["__interfaces"] = ["java.util.function.Function"];
        })(Matcher = regex.Matcher || (regex.Matcher = {}));
      })(util.regex || (util.regex = {}));
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      (function (regex_1) {
        var Pattern =
        /** @class */
        function () {
          function Pattern(regexp, _flags, namedGroupsNames) {
            if (this.regexp === undefined) {
              this.regexp = null;
            }

            if (this._flags === undefined) {
              this._flags = 0;
            }

            if (this.namedGroupsNames === undefined) {
              this.namedGroupsNames = null;
            }

            this.regexp = regexp;
            this._flags = _flags;
            this.namedGroupsNames = namedGroupsNames;
          }

          Pattern.compile$java_lang_String = function (regexp) {
            return Pattern.compile$java_lang_String$int(regexp, 0);
          };

          Pattern.compile$java_lang_String$int = function (regexpString, flags) {
            var jsFlags = "g";

            if ((flags & Pattern.MULTILINE) > 0) {
              jsFlags += "m";
            }

            if ((flags & Pattern.CASE_INSENSITIVE) > 0) {
              jsFlags += "i";
            }

            if ((flags & Pattern.UNICODE_CHARACTER_CLASS) > 0) {
              jsFlags += "u";
            }

            if ((flags & Pattern.UNICODE_CASE) > 0) {
              jsFlags += "ui";
            }

            var namedGroupsNames = new java.util.HashMap();
            var groupNameRemover = new Pattern.GroupNameRemover(namedGroupsNames);
            regexpString = regexpString.replace(new RegExp("(?:\\\\\\\\)*(\\\\?)\\[\\^?\\]?|(?:\\\\\\\\)*(\\\\?)\\]|(?:\\\\\\\\)*(\\\\?)\\((?:(\\?\\:)|\\?<([^>]+)>)?", "g"), function (groupNameRemover) {
              return function () {
                var args = [];

                for (var _i = 0; _i < arguments.length; _i++) {
                  args[_i] = arguments[_i];
                }

                return groupNameRemover.apply(args);
              };
            }(groupNameRemover)).replace(new RegExp("(\\?\\:|(?:[*+?]|\\{[^\\}]+\\})*)((?:[^\\\\()|]|\\\\.|\\[\\^?\\]\\]|\\[\\^?(?:[^\\\\\\]]|\\\\.|)+\\])*)", "g"), function () {
              var args = [];

              for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
              }

              if (args[2] === undefined || args[2].length === 0) {
                return args[1];
              }

              var regexp = args[args.length - 1];
              var startIndexOfMatched = javaemul.internal.IntegerHelper.parseInt(args[args.length - 2]);
              var endIndexOfMatched = startIndexOfMatched + args[0].length;
              var hasOpenBracket = startIndexOfMatched > 0 && "(" === regexp.charAt(startIndexOfMatched - 1) || startIndexOfMatched > 2 && "(?:" === regexp.substr(startIndexOfMatched - 3, 3);
              var hasCloseBracket = regexp.length > endIndexOfMatched && ")" === regexp.charAt(endIndexOfMatched);

              if (hasOpenBracket && hasCloseBracket) {
                return args[1] + args[2];
              }

              return args[1] + "(?:" + args[2] + ")";
            });

            try {
              return new Pattern(new RegExp(regexpString, jsFlags), flags, namedGroupsNames);
            } catch (e) {
              throw new java.util.regex.PatternSyntaxException(e, regexpString);
            }
          };

          Pattern.compile = function (regexpString, flags) {
            if ((typeof regexpString === 'string' || regexpString === null) && (typeof flags === 'number' || flags === null)) {
              return java.util.regex.Pattern.compile$java_lang_String$int(regexpString, flags);
            } else if ((typeof regexpString === 'string' || regexpString === null) && flags === undefined) {
              return java.util.regex.Pattern.compile$java_lang_String(regexpString);
            } else throw new Error('invalid overload');
          };

          Pattern.prototype.flags = function () {
            return this._flags;
          };

          Pattern.prototype.matcher = function (sequence) {
            return new java.util.regex.Matcher(this, sequence.toString());
          };

          Pattern.matches = function (regex, input) {
            return Pattern.compile$java_lang_String(regex).matcher(input).matches();
          };

          Pattern.prototype.pattern = function () {
            return this.regexp.source;
          };

          Pattern.quote = function (s) {
            return JSON.stringify(s);
          };

          Pattern.prototype.split = function (input, limit) {
            if (limit === void 0) {
              limit = 0;
            }

            return input.toString().split(this.regexp, limit).toArray();
          };

          Pattern.prototype.splitAsStream = function (input) {
            return java.util.Arrays.stream(this.split(input));
          };
          /**
          *
          * @return {string}
          */


          Pattern.prototype.toString = function () {
            return this.pattern();
          };

          Pattern.CASE_INSENSITIVE = 2;
          Pattern.MULTILINE = 8;
          Pattern.UNICODE_CASE = 64;
          Pattern.UNICODE_CHARACTER_CLASS = 256;
          return Pattern;
        }();

        regex_1.Pattern = Pattern;
        Pattern["__class"] = "java.util.regex.Pattern";
        Pattern["__interfaces"] = ["java.io.Serializable"];

        (function (Pattern) {
          var GroupNameRemover =
          /** @class */
          function () {
            function GroupNameRemover(namedGroupsNames) {
              if (this.namedGroupsNames === undefined) {
                this.namedGroupsNames = null;
              }

              this.count = 0;
              this.inBrackets = false;
              this.namedGroupsNames = namedGroupsNames;
            }
            /**
            *
            * @param {Array} args
            * @return {string}
            */


            GroupNameRemover.prototype.apply = function (args) {
              if (this.inBrackets || args[2] !== undefined) {
                this.inBrackets = args[2] === undefined || args[2].length === 1;
                return args[0];
              }

              if (args[1] !== undefined) {
                this.inBrackets = args[1].length === 0;
                return args[0];
              }

              if (args[3] !== undefined && args[3].length !== 0) {
                return args[0];
              }

              if (args[4] === undefined) {
                this.count += 1;
              }

              if (args[5] !== undefined) {
                this.namedGroupsNames.put(args[5], this.count);
                args[0] = args[0].replace(new RegExp("\\?<[^>]+>"), "");
              }

              return args[0];
            };

            return GroupNameRemover;
          }();

          Pattern.GroupNameRemover = GroupNameRemover;
          GroupNameRemover["__class"] = "java.util.regex.Pattern.GroupNameRemover";
          GroupNameRemover["__interfaces"] = ["java.util.function.Function"];
        })(Pattern = regex_1.Pattern || (regex_1.Pattern = {}));
      })(util.regex || (util.regex = {}));
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * Skeletal implementation of the Collection interface. <a
      * href="http://java.sun.com/j2se/1.5.0/docs/api/java/util/AbstractCollection.html">[Sun
      * docs]</a>
      *
      * @param <E> the element type.
      * @class
      */
      var AbstractCollection =
      /** @class */
      function () {
        function AbstractCollection() {}
        /* Default method injected from java.util.Collection */


        AbstractCollection.prototype.stream = function () {
          return new javaemul.internal.stream.StreamHelper(this);
        };
        /* Default method injected from java.lang.Iterable */


        AbstractCollection.prototype.forEach = function (action) {
          javaemul.internal.InternalPreconditions.checkNotNull(action);

          var _loop_2 = function _loop_2(index124) {
            var t = index124.next();
            {
              (function (target) {
                return typeof target === 'function' ? target(t) : target.accept(t);
              })(action);
            }
          };

          for (var index124 = this.iterator(); index124.hasNext();) {
            _loop_2(index124);
          }
        };
        /* Default method injected from java.util.Collection */


        AbstractCollection.prototype.parallelStream = function () {
          return this.stream();
        };
        /* Default method injected from java.util.Collection */


        AbstractCollection.prototype.removeIf = function (filter) {
          javaemul.internal.InternalPreconditions.checkNotNull(filter);
          var removed = false;

          var _loop_3 = function _loop_3(it) {
            {
              if (function (target) {
                return typeof target === 'function' ? target(it.next()) : target.test(it.next());
              }(filter)) {
                it.remove();
                removed = true;
              }
            }
          };

          for (var it = this.iterator(); it.hasNext();) {
            _loop_3(it);
          }

          return removed;
        };
        /**
        *
        * @param {*} o
        * @return {boolean}
        */


        AbstractCollection.prototype.add = function (o) {
          throw new java.lang.UnsupportedOperationException("Add not supported on this collection");
        };
        /**
        *
        * @param {*} c
        * @return {boolean}
        */


        AbstractCollection.prototype.addAll = function (c) {
          javaemul.internal.InternalPreconditions.checkNotNull(c);
          var changed = false;

          for (var index125 = c.iterator(); index125.hasNext();) {
            var e = index125.next();
            {
              changed = this.add(e) || changed;
            }
          }

          return changed;
        };
        /**
        *
        */


        AbstractCollection.prototype.clear = function () {
          for (var iter = this.iterator(); iter.hasNext();) {
            {
              iter.next();
              iter.remove();
            }
          }
        };
        /**
        *
        * @param {*} o
        * @return {boolean}
        */


        AbstractCollection.prototype.contains = function (o) {
          return this.advanceToFind(o, false);
        };
        /**
        *
        * @param {*} c
        * @return {boolean}
        */


        AbstractCollection.prototype.containsAll = function (c) {
          javaemul.internal.InternalPreconditions.checkNotNull(c);

          for (var index126 = c.iterator(); index126.hasNext();) {
            var e = index126.next();
            {
              if (!this.contains(e)) {
                return false;
              }
            }
          }

          return true;
        };
        /**
        *
        * @return {boolean}
        */


        AbstractCollection.prototype.isEmpty = function () {
          return this.size() === 0;
        };
        /**
        *
        * @param {*} o
        * @return {boolean}
        */


        AbstractCollection.prototype.remove = function (o) {
          return this.advanceToFind(o, true);
        };
        /**
        *
        * @param {*} c
        * @return {boolean}
        */


        AbstractCollection.prototype.removeAll = function (c) {
          javaemul.internal.InternalPreconditions.checkNotNull(c);
          var changed = false;

          for (var iter = this.iterator(); iter.hasNext();) {
            {
              var o = iter.next();

              if (c.contains(o)) {
                iter.remove();
                changed = true;
              }
            }
          }

          return changed;
        };
        /**
        *
        * @param {*} c
        * @return {boolean}
        */


        AbstractCollection.prototype.retainAll = function (c) {
          javaemul.internal.InternalPreconditions.checkNotNull(c);
          var changed = false;

          for (var iter = this.iterator(); iter.hasNext();) {
            {
              var o = iter.next();

              if (!c.contains(o)) {
                iter.remove();
                changed = true;
              }
            }
          }

          return changed;
        };

        AbstractCollection.prototype.toArray$ = function () {
          return this.toArray$java_lang_Object_A(function (s) {
            var a = [];

            while (s-- > 0) {
              a.push(null);
            }

            return a;
          }(this.size()));
        };

        AbstractCollection.prototype.toArray$java_lang_Object_A = function (a) {
          var size = this.size();

          if (a.length < size) {
            a = javaemul.internal.ArrayHelper.createFrom(a, size);
          }

          var result = a;
          var it = this.iterator();

          for (var i = 0; i < size; ++i) {
            {
              result[i] = it.next();
            }
          }

          if (a.length > size) {
            a[size] = null;
          }

          return a;
        };
        /**
        *
        * @param {Array} a
        * @return {Array}
        */


        AbstractCollection.prototype.toArray = function (a) {
          if (a != null && a instanceof Array && (a.length == 0 || a[0] == null || a[0] != null) || a === null) {
            return this.toArray$java_lang_Object_A(a);
          } else if (a === undefined) {
            return this.toArray$();
          } else throw new Error('invalid overload');
        };
        /**
        *
        * @return {string}
        */


        AbstractCollection.prototype.toString = function () {
          var joiner = new java.util.StringJoiner(", ", "[", "]");

          for (var index127 = this.iterator(); index127.hasNext();) {
            var e = index127.next();
            {
              joiner.add(e === this ? "(this Collection)" :
              /* valueOf */
              new String(e).toString());
            }
          }

          return joiner.toString();
        };
        /*private*/


        AbstractCollection.prototype.advanceToFind = function (o, remove) {
          for (var iter = this.iterator(); iter.hasNext();) {
            {
              var e = iter.next();

              if (java.util.Objects.equals(o, e)) {
                if (remove) {
                  iter.remove();
                }

                return true;
              }
            }
          }

          return false;
        };

        return AbstractCollection;
      }();

      util.AbstractCollection = AbstractCollection;
      AbstractCollection["__class"] = "java.util.AbstractCollection";
      AbstractCollection["__interfaces"] = ["java.util.Collection", "java.lang.Iterable"];
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      var TimerTask =
      /** @class */
      function () {
        function TimerTask() {
          this.state = TimerTask.VIRGIN;

          if (this.nextExecutionTime === undefined) {
            this.nextExecutionTime = 0;
          }

          this.period = 0;

          if (this.handle === undefined) {
            this.handle = 0;
          }
        }

        TimerTask.prototype.cancel = function () {
          var success = this.state === TimerTask.SCHEDULED;
          this.state = TimerTask.CANCELLED;
          this.nextExecutionTime = 0;
          this.period = 0;
          return success;
        };

        TimerTask.prototype.scheduledExecutionTime = function () {
          return this.period < 0 ? this.nextExecutionTime + this.period : this.nextExecutionTime - this.period;
        };

        TimerTask.VIRGIN = 0;
        TimerTask.SCHEDULED = 1;
        TimerTask.EXECUTED = 2;
        TimerTask.CANCELLED = 3;
        return TimerTask;
      }();

      util.TimerTask = TimerTask;
      TimerTask["__class"] = "java.util.TimerTask";
      TimerTask["__interfaces"] = ["java.lang.Runnable"];
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * Construct a random generator with the given {@code seed} as the initial
      * state.
      *
      * @param {number} seed the seed that will determine the initial state of this random
      * number generator.
      * @see #setSeed
      * @class
      */
      var Random =
      /** @class */
      function () {
        function Random(seed) {
          if (typeof seed === 'number' || seed === null) {
            if (this.nextNextGaussian === undefined) {
              this.nextNextGaussian = 0;
            }

            if (this.seedhi === undefined) {
              this.seedhi = 0;
            }

            if (this.seedlo === undefined) {
              this.seedlo = 0;
            }

            this.haveNextNextGaussian = false;
            this.setSeed$long(seed);
          } else if (seed === undefined) {
            if (this.nextNextGaussian === undefined) {
              this.nextNextGaussian = 0;
            }

            if (this.seedhi === undefined) {
              this.seedhi = 0;
            }

            if (this.seedlo === undefined) {
              this.seedlo = 0;
            }

            this.haveNextNextGaussian = false;
            var seed_1 = Random.uniqueSeed++ + javaemul.internal.DateUtil.now();
            var hi = (Math.floor(seed_1 * Random.twoToTheMinus24) | 0) & 16777215;
            var lo = seed_1 - hi * Random.twoToThe24 | 0;
            this.setSeed$int$int(hi, lo);
          } else throw new Error('invalid overload');
        }

        Random.__static_initialize = function () {
          if (!Random.__static_initialized) {
            Random.__static_initialized = true;

            Random.__static_initializer_0();
          }
        };

        Random.twoToTheXMinus24_$LI$ = function () {
          Random.__static_initialize();

          if (Random.twoToTheXMinus24 == null) {
            Random.twoToTheXMinus24 = function (s) {
              var a = [];

              while (s-- > 0) {
                a.push(0);
              }

              return a;
            }(25);
          }

          return Random.twoToTheXMinus24;
        };

        Random.twoToTheXMinus48_$LI$ = function () {
          Random.__static_initialize();

          if (Random.twoToTheXMinus48 == null) {
            Random.twoToTheXMinus48 = function (s) {
              var a = [];

              while (s-- > 0) {
                a.push(0);
              }

              return a;
            }(33);
          }

          return Random.twoToTheXMinus48;
        };

        Random.__static_initializer_0 = function () {
          var twoToTheXMinus48Tmp = 1.52587890625E-5;

          for (var i = 32; i >= 0; i--) {
            {
              Random.twoToTheXMinus48_$LI$()[i] = twoToTheXMinus48Tmp;
              twoToTheXMinus48Tmp *= 0.5;
            }
          }

          var twoToTheXMinus24Tmp = 1.0;

          for (var i = 24; i >= 0; i--) {
            {
              Random.twoToTheXMinus24_$LI$()[i] = twoToTheXMinus24Tmp;
              twoToTheXMinus24Tmp *= 0.5;
            }
          }
        };
        /**
        * Returns the next pseudo-random, uniformly distributed {@code boolean} value
        * generated by this generator.
        *
        * @return {boolean} a pseudo-random, uniformly distributed boolean value.
        */


        Random.prototype.nextBoolean = function () {
          return this.nextInternal(1) !== 0;
        };
        /**
        * Modifies the {@code byte} array by a random sequence of {@code byte}s
        * generated by this random number generator.
        *
        * @param {Array} buf non-null array to contain the new random {@code byte}s.
        * @see #next
        */


        Random.prototype.nextBytes = function (buf) {
          javaemul.internal.InternalPreconditions.checkNotNull(buf);
          var rand = 0;
          var count = 0;
          var loop = 0;

          while (count < buf.length) {
            {
              if (loop === 0) {
                rand = this.nextInternal(32) | 0;
                loop = 3;
              } else {
                loop--;
              }

              buf[count++] = rand | 0;
              rand >>= 8;
            }
          }
        };
        /**
        * Generates a normally distributed random {@code double} number between 0.0
        * inclusively and 1.0 exclusively.
        *
        * @return {number} a random {@code double} in the range [0.0 - 1.0)
        * @see #nextFloat
        */


        Random.prototype.nextDouble = function () {
          return this.nextInternal(26) * Random.twoToTheMinus26 + this.nextInternal(27) * Random.twoToTheMinus53;
        };
        /**
        * Generates a normally distributed random {@code float} number between 0.0
        * inclusively and 1.0 exclusively.
        *
        * @return {number} float a random {@code float} number between [0.0 and 1.0)
        * @see #nextDouble
        */


        Random.prototype.nextFloat = function () {
          return this.nextInternal(24) * Random.twoToTheMinus24;
        };
        /**
        * Pseudo-randomly generates (approximately) a normally distributed {@code
        * double} value with mean 0.0 and a standard deviation value of {@code 1.0}
        * using the <i>polar method<i> of G. E. P. Box, M. E. Muller, and G.
        * Marsaglia, as described by Donald E. Knuth in <i>The Art of Computer
        * Programming, Volume 2: Seminumerical Algorithms</i>, section 3.4.1,
        * subsection C, algorithm P.
        *
        * @return {number} a random {@code double}
        * @see #nextDouble
        */


        Random.prototype.nextGaussian = function () {
          if (this.haveNextNextGaussian) {
            this.haveNextNextGaussian = false;
            return this.nextNextGaussian;
          }

          var v1;
          var v2;
          var s;

          do {
            {
              v1 = 2 * this.nextDouble() - 1;
              v2 = 2 * this.nextDouble() - 1;
              s = v1 * v1 + v2 * v2;
            }
          } while (s >= 1);

          var norm = s === 0 ? 0.0 : Math.sqrt(-2.0 * Math.log(s) / s);
          this.nextNextGaussian = v2 * norm;
          this.haveNextNextGaussian = true;
          return v1 * norm;
        };

        Random.prototype.nextInt$ = function () {
          return this.nextInternal(32) | 0;
        };

        Random.prototype.nextInt$int = function (n) {
          javaemul.internal.InternalPreconditions.checkCriticalArgument(n > 0, "Random nextInt parameter can only be positive: %s",
          /* toString */
          '' + n);

          if ((n & -n) === n) {
            return n * this.nextInternal(31) * Random.twoToTheMinus31 | 0;
          }

          var bits;
          var val;

          do {
            {
              bits = this.nextInternal(31);
              val = bits % n;
            }
          } while (bits - val + (n - 1) < 0);

          return val | 0;
        };
        /**
        * Returns a new pseudo-random {@code int} value which is uniformly
        * distributed between 0 (inclusively) and the value of {@code n}
        * (exclusively).
        *
        * @param {number} n the exclusive upper border of the range [0 - n).
        * @return {number} a random {@code int}.
        */


        Random.prototype.nextInt = function (n) {
          if (typeof n === 'number' || n === null) {
            return this.nextInt$int(n);
          } else if (n === undefined) {
            return this.nextInt$();
          } else throw new Error('invalid overload');
        };
        /**
        * Generates a uniformly distributed 64-bit integer value from the random
        * number sequence.
        *
        * @return {number} 64-bit random integer.
        * @see java.lang.Integer#MAX_VALUE
        * @see java.lang.Integer#MIN_VALUE
        * @see #next
        * @see #nextInt()
        * @see #nextInt(int)
        */


        Random.prototype.nextLong = function () {
          return (function (n) {
            return n < 0 ? Math.ceil(n) : Math.floor(n);
          }(this.nextInternal(32)) << 32) + function (n) {
            return n < 0 ? Math.ceil(n) : Math.floor(n);
          }(this.nextInternal(32));
        };

        Random.prototype.setSeed$long = function (seed) {
          this.setSeed$int$int(seed >> 24 & 16777215 | 0, seed & 16777215 | 0);
        };
        /**
        * Returns a pseudo-random uniformly distributed {@code int} value of the
        * number of bits specified by the argument {@code bits} as described by
        * Donald E. Knuth in <i>The Art of Computer Programming, Volume 2:
        * Seminumerical Algorithms</i>, section 3.2.1.
        *
        * @param {number} bits number of bits of the returned value.
        * @return {number} a pseudo-random generated int number.
        * @see #nextBytes
        * @see #nextDouble
        * @see #nextFloat
        * @see #nextInt()
        * @see #nextInt(int)
        * @see #nextGaussian
        * @see #nextLong
        */


        Random.prototype.next = function (bits) {
          return this.nextInternal(bits) | 0;
        };
        /*private*/


        Random.prototype.nextInternal = function (bits) {
          var hi = this.seedhi * Random.multiplierLo + this.seedlo * Random.multiplierHi;
          var lo = this.seedlo * Random.multiplierLo + 11;
          var carry = Math.floor(lo * Random.twoToTheMinus24);
          hi += carry;
          lo -= carry * Random.twoToThe24;
          hi %= Random.twoToThe24;
          this.seedhi = hi;
          this.seedlo = lo;

          if (bits <= 24) {
            return Math.floor(this.seedhi * Random.twoToTheXMinus24_$LI$()[bits]);
          } else {
            var h = this.seedhi * (1 << bits - 24);
            var l = Math.floor(this.seedlo * Random.twoToTheXMinus48_$LI$()[bits]);
            var dval = h + l;

            if (dval >= Random.twoToThe31) {
              dval -= Random.twoToThe32;
            }

            return dval;
          }
        };

        Random.prototype.setSeed$int$int = function (seedhi, seedlo) {
          this.seedhi = seedhi ^ 1502;
          this.seedlo = seedlo ^ 15525485;
          this.haveNextNextGaussian = false;
        };

        Random.prototype.setSeed = function (seedhi, seedlo) {
          if ((typeof seedhi === 'number' || seedhi === null) && (typeof seedlo === 'number' || seedlo === null)) {
            return this.setSeed$int$int(seedhi, seedlo);
          } else if ((typeof seedhi === 'number' || seedhi === null) && seedlo === undefined) {
            return this.setSeed$long(seedhi);
          } else throw new Error('invalid overload');
        };

        Random.__static_initialized = false;
        Random.multiplierHi = 1502;
        Random.multiplierLo = 15525485;
        Random.twoToThe24 = 1.6777216E7;
        Random.twoToThe31 = 2.147483648E9;
        Random.twoToThe32 = 4.294967296E9;
        Random.twoToTheMinus24 = 5.9604644775390625E-8;
        Random.twoToTheMinus26 = 1.4901161193847656E-8;
        Random.twoToTheMinus31 = 4.6566128730773926E-10;
        Random.twoToTheMinus53 = 1.1102230246251565E-16;
        /**
        * A value used to avoid two random number generators produced at the same
        * time having the same seed.
        */

        Random.uniqueSeed = 0;
        return Random;
      }();

      util.Random = Random;
      Random["__class"] = "java.util.Random";
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * A very simple emulation of Locale for shared-code patterns like
      * {@code String.toUpperCase(Locale.US)}.
      * <p>
      * Note: Any changes to this class should put into account the assumption that
      * was made in rest of the JRE emulation.
      * @class
      */
      var Locale =
      /** @class */
      function () {
        function Locale() {}

        Locale.ROOT_$LI$ = function () {
          if (Locale.ROOT == null) {
            Locale.ROOT = new Locale.RootLocale();
          }

          return Locale.ROOT;
        };

        Locale.ENGLISH_$LI$ = function () {
          if (Locale.ENGLISH == null) {
            Locale.ENGLISH = new Locale.EnglishLocale();
          }

          return Locale.ENGLISH;
        };

        Locale.US_$LI$ = function () {
          if (Locale.US == null) {
            Locale.US = new Locale.USLocale();
          }

          return Locale.US;
        };

        Locale.FRANCE_$LI$ = function () {
          if (Locale.FRANCE == null) {
            Locale.FRANCE = new Locale.FrenchLocale();
          }

          return Locale.FRANCE;
        };

        Locale.UK_$LI$ = function () {
          if (Locale.UK == null) {
            Locale.UK = new Locale.UKLocale();
          }

          return Locale.UK;
        };

        Locale.defaultLocale_$LI$ = function () {
          if (Locale.defaultLocale == null) {
            Locale.defaultLocale = new Locale.DefaultLocale();
          }

          return Locale.defaultLocale;
        };
        /**
        * Returns an instance that represents the browser's default locale (not
        * necessarily the one defined by 'gwt.locale').
        * @return {java.util.Locale}
        */


        Locale.getDefault = function () {
          return Locale.defaultLocale_$LI$();
        };

        return Locale;
      }();

      util.Locale = Locale;
      Locale["__class"] = "java.util.Locale";

      (function (Locale) {
        var RootLocale =
        /** @class */
        function (_super) {
          __extends(RootLocale, _super);

          function RootLocale() {
            return _super.call(this) || this;
          }
          /**
          *
          * @return {string}
          */


          RootLocale.prototype.toString = function () {
            return "";
          };

          return RootLocale;
        }(java.util.Locale);

        Locale.RootLocale = RootLocale;
        RootLocale["__class"] = "java.util.Locale.RootLocale";

        var EnglishLocale =
        /** @class */
        function (_super) {
          __extends(EnglishLocale, _super);

          function EnglishLocale() {
            return _super.call(this) || this;
          }
          /**
          *
          * @return {string}
          */


          EnglishLocale.prototype.toString = function () {
            return "en";
          };

          return EnglishLocale;
        }(java.util.Locale);

        Locale.EnglishLocale = EnglishLocale;
        EnglishLocale["__class"] = "java.util.Locale.EnglishLocale";

        var FrenchLocale =
        /** @class */
        function (_super) {
          __extends(FrenchLocale, _super);

          function FrenchLocale() {
            return _super.call(this) || this;
          }
          /**
          *
          * @return {string}
          */


          FrenchLocale.prototype.toString = function () {
            return "fr";
          };

          return FrenchLocale;
        }(java.util.Locale);

        Locale.FrenchLocale = FrenchLocale;
        FrenchLocale["__class"] = "java.util.Locale.FrenchLocale";

        var USLocale =
        /** @class */
        function (_super) {
          __extends(USLocale, _super);

          function USLocale() {
            return _super.call(this) || this;
          }
          /**
          *
          * @return {string}
          */


          USLocale.prototype.toString = function () {
            return "en_US";
          };

          return USLocale;
        }(java.util.Locale);

        Locale.USLocale = USLocale;
        USLocale["__class"] = "java.util.Locale.USLocale";

        var UKLocale =
        /** @class */
        function (_super) {
          __extends(UKLocale, _super);

          function UKLocale() {
            return _super.call(this) || this;
          }
          /**
          *
          * @return {string}
          */


          UKLocale.prototype.toString = function () {
            return "en-gb";
          };

          return UKLocale;
        }(java.util.Locale);

        Locale.UKLocale = UKLocale;
        UKLocale["__class"] = "java.util.Locale.UKLocale";

        var DefaultLocale =
        /** @class */
        function (_super) {
          __extends(DefaultLocale, _super);

          function DefaultLocale() {
            return _super.call(this) || this;
          }
          /**
          *
          * @return {string}
          */


          DefaultLocale.prototype.toString = function () {
            return "fr";
          };

          return DefaultLocale;
        }(java.util.Locale);

        Locale.DefaultLocale = DefaultLocale;
        DefaultLocale["__class"] = "java.util.Locale.DefaultLocale";
      })(Locale = util.Locale || (util.Locale = {}));
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      var Comparators =
      /** @class */
      function () {
        function Comparators() {}

        Comparators.NATURAL_$LI$ = function () {
          if (Comparators.NATURAL == null) {
            Comparators.NATURAL = function (a, b) {
              return new Comparators.NaturalComparator().compare(a, b);
            };
          }

          return Comparators.NATURAL;
        };
        /**
        * Returns the natural Comparator.
        * <p>
        * Example:
        *
        * <pre>Comparator&lt;String&gt; compareString = Comparators.natural()</pre>
        *
        * @return {*} the natural Comparator
        */


        Comparators.natural = function () {
          return Comparators.NATURAL_$LI$();
        };

        return Comparators;
      }();

      util.Comparators = Comparators;
      Comparators["__class"] = "java.util.Comparators";

      (function (Comparators) {
        var NaturalComparator =
        /** @class */
        function () {
          function NaturalComparator() {}
          /**
          *
          * @param {*} o1
          * @param {*} o2
          * @return {number}
          */


          NaturalComparator.prototype.compare = function (o1, o2) {
            javaemul.internal.InternalPreconditions.checkNotNull(o1);
            javaemul.internal.InternalPreconditions.checkNotNull(o2);

            if (o1["compareTo"] === undefined) {
              return (
                /* compareTo */
                o1.toString().localeCompare(o2.toString())
              );
            }

            return o1.compareTo(o2);
          };

          return NaturalComparator;
        }();

        Comparators.NaturalComparator = NaturalComparator;
        NaturalComparator["__class"] = "java.util.Comparators.NaturalComparator";
        NaturalComparator["__interfaces"] = ["java.util.Comparator"];
      })(Comparators = util.Comparators || (util.Comparators = {}));
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * Represents a date and time.
      * @param {number} year
      * @param {number} month
      * @param {number} date
      * @param {number} hrs
      * @param {number} min
      * @param {number} sec
      * @class
      */
      var Date =
      /** @class */
      function () {
        function Date(year, month, date, hrs, min, sec) {
          if ((typeof year === 'number' || year === null) && (typeof month === 'number' || month === null) && (typeof date === 'number' || date === null) && (typeof hrs === 'number' || hrs === null) && (typeof min === 'number' || min === null) && (typeof sec === 'number' || sec === null)) {
            var __args = arguments;

            if (this.jsdate === undefined) {
              this.jsdate = null;
            }

            this.jsdate = new (Date.jsdateClass())();
            this.jsdate["setFullYear"](this.jsdate, year + 1900, month, date);
            this.jsdate["setHours"](this.jsdate, hrs, min, sec, 0);
            this.fixDaylightSavings(hrs);
          } else if ((typeof year === 'number' || year === null) && (typeof month === 'number' || month === null) && (typeof date === 'number' || date === null) && (typeof hrs === 'number' || hrs === null) && (typeof min === 'number' || min === null) && sec === undefined) {
            var __args = arguments;
            {
              var sec_1 = 0;

              if (this.jsdate === undefined) {
                this.jsdate = null;
              }

              this.jsdate = new (Date.jsdateClass())();
              this.jsdate["setFullYear"](this.jsdate, year + 1900, month, date);
              this.jsdate["setHours"](this.jsdate, hrs, min, sec_1, 0);
              this.fixDaylightSavings(hrs);
            }

            if (this.jsdate === undefined) {
              this.jsdate = null;
            }
          } else if ((typeof year === 'number' || year === null) && (typeof month === 'number' || month === null) && (typeof date === 'number' || date === null) && hrs === undefined && min === undefined && sec === undefined) {
            var __args = arguments;
            {
              var hrs_1 = 0;
              var min_1 = 0;
              var sec_2 = 0;

              if (this.jsdate === undefined) {
                this.jsdate = null;
              }

              this.jsdate = new (Date.jsdateClass())();
              this.jsdate["setFullYear"](this.jsdate, year + 1900, month, date);
              this.jsdate["setHours"](this.jsdate, hrs_1, min_1, sec_2, 0);
              this.fixDaylightSavings(hrs_1);
            }

            if (this.jsdate === undefined) {
              this.jsdate = null;
            }
          } else if ((typeof year === 'string' || year === null) && month === undefined && date === undefined && hrs === undefined && min === undefined && sec === undefined) {
            var __args = arguments;
            __args[0];
            {
              var __args_8 = arguments;
              var date_2 = Date.parse(__args_8[0]);

              if (this.jsdate === undefined) {
                this.jsdate = null;
              }

              this.jsdate = new (Date.jsdateClass())(date_2);
            }

            if (this.jsdate === undefined) {
              this.jsdate = null;
            }
          } else if ((typeof year === 'number' || year === null) && month === undefined && date === undefined && hrs === undefined && min === undefined && sec === undefined) {
            var __args = arguments;
            var date_3 = __args[0];

            if (this.jsdate === undefined) {
              this.jsdate = null;
            }

            this.jsdate = new (Date.jsdateClass())(date_3);
          } else if (year === undefined && month === undefined && date === undefined && hrs === undefined && min === undefined && sec === undefined) {
            var __args = arguments;

            if (this.jsdate === undefined) {
              this.jsdate = null;
            }

            this.jsdate = new (Date.jsdateClass())();
          } else throw new Error('invalid overload');
        }

        Date.parse = function (s) {
          var parsed = Date.jsdateClass()["parse"](s);

          if (
          /* isNaN */
          isNaN(parsed)) {
            throw new java.lang.IllegalArgumentException();
          }

          return function (n) {
            return n < 0 ? Math.ceil(n) : Math.floor(n);
          }(parsed);
        };

        Date.UTC = function (year, month, date, hrs, min, sec) {
          return Date.jsdateClass()["UTC"](year + 1900, month, date, hrs, min, sec, 0);
        };
        /**
        * Ensure a number is displayed with two digits.
        *
        * @return {string} a two-character base 10 representation of the number
        * @param {number} number
        */


        Date.padTwo = function (number) {
          if (number < 10) {
            return "0" + number;
          } else {
            return (
              /* valueOf */
              new String(number).toString()
            );
          }
        };

        Date.jsdateClass = function () {
          return window["Date"];
        };

        Date.prototype.after = function (when) {
          return this.getTime() > when.getTime();
        };

        Date.prototype.before = function (when) {
          return this.getTime() < when.getTime();
        };

        Date.prototype.clone = function () {
          return new Date(this.getTime());
        };

        Date.prototype.compareTo$java_util_Date = function (other) {
          return (
            /* compare */
            this.getTime() - other.getTime()
          );
        };
        /**
        *
        * @param {java.util.Date} other
        * @return {number}
        */


        Date.prototype.compareTo = function (other) {
          if (other != null && other instanceof Date || other === null) {
            return this.compareTo$java_util_Date(other);
          } else throw new Error('invalid overload');
        };
        /**
        *
        * @param {*} obj
        * @return {boolean}
        */


        Date.prototype.equals = function (obj) {
          return obj != null && obj instanceof Date && this.getTime() === obj.getTime();
        };

        Date.prototype.getDate = function () {
          return this.jsdate["getDate"](this.jsdate);
        };

        Date.prototype.getDay = function () {
          return this.jsdate["getDay"](this.jsdate);
        };

        Date.prototype.getHours = function () {
          return this.jsdate["getHours"](this.jsdate);
        };

        Date.prototype.getMinutes = function () {
          return this.jsdate["getMinutes"](this.jsdate);
        };

        Date.prototype.getMonth = function () {
          return this.jsdate["getMonth"](this.jsdate);
        };

        Date.prototype.getSeconds = function () {
          return this.jsdate["getSeconds"](this.jsdate);
        };

        Date.prototype.getTime = function () {
          return this.jsdate["getTime"](this.jsdate);
        };

        Date.prototype.getTimezoneOffset = function () {
          return this.jsdate["getTimezoneOffset"](this.jsdate);
        };

        Date.prototype.getYear = function () {
          return this.jsdate["getFullYear"](this.jsdate) - 1900;
        };
        /**
        *
        * @return {number}
        */


        Date.prototype.hashCode = function () {
          var time = this.getTime();
          return time ^ time >>> 32 | 0;
        };

        Date.prototype.setDate = function (date) {
          var hours = this.getHours();
          this.jsdate["setDate"](this.jsdate, date);
          this.fixDaylightSavings(hours);
        };

        Date.prototype.setHours = function (hours) {
          this.jsdate["setHours"](this.jsdate, hours);
          this.fixDaylightSavings(hours);
        };

        Date.prototype.setMinutes = function (minutes) {
          var hours = this.getHours() + (minutes / 60 | 0);
          this.jsdate["setMinutes"](this.jsdate, minutes);
          this.fixDaylightSavings(hours);
        };

        Date.prototype.setMonth = function (month) {
          var hours = this.getHours();
          this.jsdate["setMonth"](this.jsdate, month);
          this.fixDaylightSavings(hours);
        };

        Date.prototype.setSeconds = function (seconds) {
          var hours = this.getHours() + (seconds / (60 * 60) | 0);
          this.jsdate["setSeconds"](this.jsdate, seconds);
          this.fixDaylightSavings(hours);
        };

        Date.prototype.setTime = function (time) {
          this.jsdate["setTime"](this.jsdate, time);
        };

        Date.prototype.setYear = function (year) {
          var hours = this.getHours();
          this.jsdate["setFullYear"](this.jsdate, year + 1900);
          this.fixDaylightSavings(hours);
        };

        Date.prototype.toGMTString = function () {
          return this.jsdate["getUTCDate"](this.jsdate) + " " + Date.StringData.MONTHS_$LI$()[this.jsdate["getUTCMonth"](this.jsdate)] + " " + this.jsdate["getUTCFullYear"](this.jsdate) + " " + Date.padTwo(this.jsdate["getUTCHours"](this.jsdate)) + ":" + Date.padTwo(this.jsdate["getUTCMinutes"](this.jsdate)) + ":" + Date.padTwo(this.jsdate["getUTCSeconds"](this.jsdate)) + " GMT";
        };

        Date.prototype.toLocaleString = function () {
          return this.jsdate.toLocaleString();
        };
        /**
        *
        * @return {string}
        */


        Date.prototype.toString = function () {
          var offset = -(this.getTimezoneOffset() | 0);
          var hourOffset = (offset >= 0 ? "+" : "") + (offset / 60 | 0);
          var minuteOffset = Date.padTwo(Math.abs(offset) % 60);
          return Date.StringData.DAYS_$LI$()[this.getDay() | 0] + " " + Date.StringData.MONTHS_$LI$()[this.getMonth() | 0] + " " + Date.padTwo(this.getDate() | 0) + " " + Date.padTwo(this.getHours() | 0) + ":" + Date.padTwo(this.getMinutes() | 0) + ":" + Date.padTwo(this.getSeconds() | 0) + " GMT" + hourOffset + minuteOffset + " " + this.jsdate["getFullYear"](this.jsdate);
        };
        /**
        * Detects if the requested time falls into a non-existent time range due to
        * local time advancing into daylight savings time or is ambiguous due to
        * going out of daylight savings. If so, adjust accordingly.
        * @param {number} requestedHours
        * @private
        */


        Date.prototype.fixDaylightSavings = function (requestedHours) {
          requestedHours %= 24;

          if (this.getHours() !== requestedHours) {
            var copy = new (Date.jsdateClass())(this.getTime());
            copy["setDate"](copy["getDate"](copy) + 1);
            var timeDiff = this.jsdate["getTimezoneOffset"](this.jsdate) - copy["getTimezoneOffset"](copy);

            if (timeDiff > 0) {
              var timeDiffHours = timeDiff / 60 | 0;
              var timeDiffMinutes = timeDiff % 60;
              var day = this.getDate() | 0;
              var badHours = this.getHours() | 0;

              if (badHours + timeDiffHours >= 24) {
                day++;
              }

              var newTime = new (Date.jsdateClass())(this.jsdate["getFullYear"](this.jsdate), this.getMonth(), day, requestedHours + timeDiffHours, this.getMinutes() + timeDiffMinutes, this.getSeconds(), this.jsdate["getMilliseconds"](this.jsdate));
              this.setTime(newTime["getMilliseconds"](newTime));
            }
          }

          var originalTimeInMillis = this.getTime();
          this.setTime(originalTimeInMillis + Date.ONE_HOUR_IN_MILLISECONDS);

          if (this.getHours() !== requestedHours) {
            this.setTime(originalTimeInMillis);
          }
        };

        Date.ONE_HOUR_IN_MILLISECONDS = 60 * 60 * 1000;
        return Date;
      }();

      util.Date = Date;
      Date["__class"] = "java.util.Date";
      Date["__interfaces"] = ["java.lang.Cloneable", "java.lang.Comparable", "java.io.Serializable"];

      (function (Date) {
        /**
        * Encapsulates static data to avoid Date itself having a static
        * initializer.
        * @class
        */
        var StringData =
        /** @class */
        function () {
          function StringData() {}

          StringData.DAYS_$LI$ = function () {
            if (StringData.DAYS == null) {
              StringData.DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
            }

            return StringData.DAYS;
          };

          StringData.MONTHS_$LI$ = function () {
            if (StringData.MONTHS == null) {
              StringData.MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            }

            return StringData.MONTHS;
          };

          return StringData;
        }();

        Date.StringData = StringData;
        StringData["__class"] = "java.util.Date.StringData";
      })(Date = util.Date || (util.Date = {}));
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      (function (logging) {
        /**
        * An emulation of the java.util.logging.Handler class. See
        * <a href="http://java.sun.com/j2se/1.4.2/docs/api/java/util/logging/Handler.html">
        * The Java API doc for details</a>
        * @class
        */
        var Handler =
        /** @class */
        function () {
          function Handler() {
            if (this.formatter === undefined) {
              this.formatter = null;
            }

            if (this.level === undefined) {
              this.level = null;
            }
          }

          Handler.prototype.getFormatter = function () {
            return this.formatter;
          };

          Handler.prototype.getLevel = function () {
            if (this.level != null) {
              return this.level;
            }

            return java.util.logging.Level.ALL_$LI$();
          };

          Handler.prototype.isLoggable = function (record) {
            return this.getLevel().intValue() <= record.getLevel().intValue();
          };

          Handler.prototype.setFormatter = function (newFormatter) {
            this.formatter = newFormatter;
          };

          Handler.prototype.setLevel = function (newLevel) {
            this.level = newLevel;
          };

          return Handler;
        }();

        logging.Handler = Handler;
        Handler["__class"] = "java.util.logging.Handler";
      })(util.logging || (util.logging = {}));
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      (function (logging) {
        /**
        * An emulation of the java.util.logging.LogRecord class. See
        * <a href="http://java.sun.com/j2se/1.4.2/docs/api/java/util/logging/LogRecord.html">
        * The Java API doc for details</a>
        * @param {java.util.logging.Level} level
        * @param {string} msg
        * @class
        */
        var LogRecord =
        /** @class */
        function () {
          function LogRecord(level, msg) {
            if ((level != null && level instanceof java.util.logging.Level || level === null) && (typeof msg === 'string' || msg === null)) {
              if (this.level === undefined) {
                this.level = null;
              }

              if (this.msg === undefined) {
                this.msg = null;
              }

              if (this.millis === undefined) {
                this.millis = 0;
              }

              this.loggerName = "";
              this.thrown = null;
              this.level = level;
              this.msg = msg;
              this.millis = java.lang.System.currentTimeMillis();
            } else if (level === undefined && msg === undefined) {
              if (this.level === undefined) {
                this.level = null;
              }

              if (this.msg === undefined) {
                this.msg = null;
              }

              if (this.millis === undefined) {
                this.millis = 0;
              }

              this.loggerName = "";
              this.thrown = null;
            } else throw new Error('invalid overload');
          }

          LogRecord.prototype.getLevel = function () {
            return this.level;
          };

          LogRecord.prototype.getLoggerName = function () {
            return this.loggerName;
          };

          LogRecord.prototype.getMessage = function () {
            return this.msg;
          };

          LogRecord.prototype.getMillis = function () {
            return this.millis;
          };

          LogRecord.prototype.getThrown = function () {
            return this.thrown;
          };

          LogRecord.prototype.setLevel = function (newLevel) {
            this.level = newLevel;
          };

          LogRecord.prototype.setLoggerName = function (newName) {
            this.loggerName = newName;
          };

          LogRecord.prototype.setMessage = function (newMessage) {
            this.msg = newMessage;
          };

          LogRecord.prototype.setMillis = function (newMillis) {
            this.millis = newMillis;
          };

          LogRecord.prototype.setThrown = function (newThrown) {
            this.thrown = newThrown;
          };

          return LogRecord;
        }();

        logging.LogRecord = LogRecord;
        LogRecord["__class"] = "java.util.logging.LogRecord";
        LogRecord["__interfaces"] = ["java.io.Serializable"];
      })(util.logging || (util.logging = {}));
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      (function (logging) {
        /**
        * An emulation of the java.util.logging.LogManager class. See
        * <a href="http://java.sun.com/j2se/1.4.2/docs/api/java/util/logging/LogManger.html">
        * The Java API doc for details</a>
        * @class
        */
        var LogManager =
        /** @class */
        function () {
          function LogManager() {
            this.loggerMap = new java.util.HashMap();
          }

          LogManager.getLogManager = function () {
            if (LogManager.singleton == null) {
              LogManager.singleton = new LogManager();
              var rootLogger = new java.util.logging.Logger("", null);
              rootLogger.setLevel(java.util.logging.Level.INFO_$LI$());
              LogManager.singleton.addLoggerImpl(rootLogger);
            }

            return LogManager.singleton;
          };

          LogManager.prototype.addLogger = function (logger) {
            if (this.getLogger(logger.getName()) != null) {
              return false;
            }

            this.addLoggerAndEnsureParents(logger);
            return true;
          };

          LogManager.prototype.getLogger = function (name) {
            return this.loggerMap.get(name);
          };

          LogManager.prototype.getLoggerNames = function () {
            return java.util.Collections.enumeration(this.loggerMap.keySet());
          };
          /**
          * Helper function to add a logger when we have already determined that it
          * does not exist.  When we add a logger, we recursively add all of it's
          * ancestors. Since loggers do not get removed, logger creation is cheap,
          * and there are not usually too many loggers in an ancestry chain,
          * this is a simple way to ensure that the parent/child relationships are
          * always correctly set up.
          * @param {java.util.logging.Logger} logger
          * @private
          */

          /*private*/


          LogManager.prototype.addLoggerAndEnsureParents = function (logger) {
            var name = logger.getName();
            var parentName = name.substring(0, Math.max(0, name.lastIndexOf('.')));
            logger.setParent(this.ensureLogger(parentName));
            this.addLoggerImpl(logger);
          };
          /*private*/


          LogManager.prototype.addLoggerImpl = function (logger) {
            if (java.lang.System.getProperty$java_lang_String$java_lang_String("gwt.logging.simpleConsoleHandler", "ENABLED") === "ENABLED") {
              if (
              /* isEmpty */
              logger.getName().length === 0) {
                logger.addHandler(new java.util.logging.SimpleConsoleLogHandler());
              }
            }

            this.loggerMap.put(logger.getName(), logger);
          };
          /**
          * Helper function to create a logger if it does not exist since the public
          * APIs for getLogger and addLogger make it difficult to use those functions
          * for this.
          * @param {string} name
          * @return {java.util.logging.Logger}
          */


          LogManager.prototype.ensureLogger = function (name) {
            var logger = this.getLogger(name);

            if (logger == null) {
              var newLogger = new java.util.logging.Logger(name, null);
              this.addLoggerAndEnsureParents(newLogger);
              return newLogger;
            }

            return logger;
          };

          LogManager.singleton = null;
          return LogManager;
        }();

        logging.LogManager = LogManager;
        LogManager["__class"] = "java.util.logging.LogManager";
      })(util.logging || (util.logging = {}));
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      (function (logging) {
        /**
        * An emulation of the java.util.logging.Formatter class. See
        * <a href="http://java.sun.com/j2se/1.4.2/docs/api/java/util/logging/Formatter.html">
        * The Java API doc for details</a>
        * @class
        */
        var Formatter =
        /** @class */
        function () {
          function Formatter() {}

          Formatter.prototype.formatMessage = function (record) {
            return this.format(record);
          };

          return Formatter;
        }();

        logging.Formatter = Formatter;
        Formatter["__class"] = "java.util.logging.Formatter";
      })(util.logging || (util.logging = {}));
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      (function (logging) {
        /**
        * An emulation of the java.util.logging.Level class. See
        * <a href="http://java.sun.com/j2se/1.4.2/docs/api/java/util/logging/Level.html">
        * The Java API doc for details</a>
        * @class
        */
        var Level =
        /** @class */
        function () {
          function Level() {}

          Level.ALL_$LI$ = function () {
            if (Level.ALL == null) {
              Level.ALL = new Level.LevelAll();
            }

            return Level.ALL;
          };

          Level.CONFIG_$LI$ = function () {
            if (Level.CONFIG == null) {
              Level.CONFIG = new Level.LevelConfig();
            }

            return Level.CONFIG;
          };

          Level.FINE_$LI$ = function () {
            if (Level.FINE == null) {
              Level.FINE = new Level.LevelFine();
            }

            return Level.FINE;
          };

          Level.FINER_$LI$ = function () {
            if (Level.FINER == null) {
              Level.FINER = new Level.LevelFiner();
            }

            return Level.FINER;
          };

          Level.FINEST_$LI$ = function () {
            if (Level.FINEST == null) {
              Level.FINEST = new Level.LevelFinest();
            }

            return Level.FINEST;
          };

          Level.INFO_$LI$ = function () {
            if (Level.INFO == null) {
              Level.INFO = new Level.LevelInfo();
            }

            return Level.INFO;
          };

          Level.OFF_$LI$ = function () {
            if (Level.OFF == null) {
              Level.OFF = new Level.LevelOff();
            }

            return Level.OFF;
          };

          Level.SEVERE_$LI$ = function () {
            if (Level.SEVERE == null) {
              Level.SEVERE = new Level.LevelSevere();
            }

            return Level.SEVERE;
          };

          Level.WARNING_$LI$ = function () {
            if (Level.WARNING == null) {
              Level.WARNING = new Level.LevelWarning();
            }

            return Level.WARNING;
          };

          Level.parse = function (name) {
            java.util.logging.Logger.assertLoggingValues();
            var loggingDisabled = java.lang.System.getProperty$java_lang_String$java_lang_String("gwt.logging.enabled", "FALSE") === "FALSE";

            if (loggingDisabled) {
              return null;
            }

            var value = name.toUpperCase();

            switch (value) {
              case "ALL":
                return Level.ALL_$LI$();

              case "CONFIG":
                return Level.CONFIG_$LI$();

              case "FINE":
                return Level.FINE_$LI$();

              case "FINER":
                return Level.FINER_$LI$();

              case "FINEST":
                return Level.FINEST_$LI$();

              case "INFO":
                return Level.INFO_$LI$();

              case "OFF":
                return Level.OFF_$LI$();

              case "SEVERE":
                return Level.SEVERE_$LI$();

              case "WARNING":
                return Level.WARNING_$LI$();

              default:
                throw new java.lang.IllegalArgumentException("Invalid level \"" + name + "\"");
            }
          };

          Level.prototype.getName = function () {
            return "DUMMY";
          };

          Level.prototype.intValue = function () {
            return -1;
          };
          /**
          *
          * @return {string}
          */


          Level.prototype.toString = function () {
            return this.getName();
          };

          return Level;
        }();

        logging.Level = Level;
        Level["__class"] = "java.util.logging.Level";
        Level["__interfaces"] = ["java.io.Serializable"];

        (function (Level) {
          var LevelAll =
          /** @class */
          function (_super) {
            __extends(LevelAll, _super);

            function LevelAll() {
              return _super.call(this) || this;
            }
            /**
            *
            * @return {string}
            */


            LevelAll.prototype.getName = function () {
              return "ALL";
            };
            /**
            *
            * @return {number}
            */


            LevelAll.prototype.intValue = function () {
              return javaemul.internal.IntegerHelper.MIN_VALUE;
            };

            return LevelAll;
          }(java.util.logging.Level);

          Level.LevelAll = LevelAll;
          LevelAll["__class"] = "java.util.logging.Level.LevelAll";
          LevelAll["__interfaces"] = ["java.io.Serializable"];

          var LevelConfig =
          /** @class */
          function (_super) {
            __extends(LevelConfig, _super);

            function LevelConfig() {
              return _super.call(this) || this;
            }
            /**
            *
            * @return {string}
            */


            LevelConfig.prototype.getName = function () {
              return "CONFIG";
            };
            /**
            *
            * @return {number}
            */


            LevelConfig.prototype.intValue = function () {
              return 700;
            };

            return LevelConfig;
          }(java.util.logging.Level);

          Level.LevelConfig = LevelConfig;
          LevelConfig["__class"] = "java.util.logging.Level.LevelConfig";
          LevelConfig["__interfaces"] = ["java.io.Serializable"];

          var LevelFine =
          /** @class */
          function (_super) {
            __extends(LevelFine, _super);

            function LevelFine() {
              return _super.call(this) || this;
            }
            /**
            *
            * @return {string}
            */


            LevelFine.prototype.getName = function () {
              return "FINE";
            };
            /**
            *
            * @return {number}
            */


            LevelFine.prototype.intValue = function () {
              return 500;
            };

            return LevelFine;
          }(java.util.logging.Level);

          Level.LevelFine = LevelFine;
          LevelFine["__class"] = "java.util.logging.Level.LevelFine";
          LevelFine["__interfaces"] = ["java.io.Serializable"];

          var LevelFiner =
          /** @class */
          function (_super) {
            __extends(LevelFiner, _super);

            function LevelFiner() {
              return _super.call(this) || this;
            }
            /**
            *
            * @return {string}
            */


            LevelFiner.prototype.getName = function () {
              return "FINER";
            };
            /**
            *
            * @return {number}
            */


            LevelFiner.prototype.intValue = function () {
              return 400;
            };

            return LevelFiner;
          }(java.util.logging.Level);

          Level.LevelFiner = LevelFiner;
          LevelFiner["__class"] = "java.util.logging.Level.LevelFiner";
          LevelFiner["__interfaces"] = ["java.io.Serializable"];

          var LevelFinest =
          /** @class */
          function (_super) {
            __extends(LevelFinest, _super);

            function LevelFinest() {
              return _super.call(this) || this;
            }
            /**
            *
            * @return {string}
            */


            LevelFinest.prototype.getName = function () {
              return "FINEST";
            };
            /**
            *
            * @return {number}
            */


            LevelFinest.prototype.intValue = function () {
              return 300;
            };

            return LevelFinest;
          }(java.util.logging.Level);

          Level.LevelFinest = LevelFinest;
          LevelFinest["__class"] = "java.util.logging.Level.LevelFinest";
          LevelFinest["__interfaces"] = ["java.io.Serializable"];

          var LevelInfo =
          /** @class */
          function (_super) {
            __extends(LevelInfo, _super);

            function LevelInfo() {
              return _super.call(this) || this;
            }
            /**
            *
            * @return {string}
            */


            LevelInfo.prototype.getName = function () {
              return "INFO";
            };
            /**
            *
            * @return {number}
            */


            LevelInfo.prototype.intValue = function () {
              return 800;
            };

            return LevelInfo;
          }(java.util.logging.Level);

          Level.LevelInfo = LevelInfo;
          LevelInfo["__class"] = "java.util.logging.Level.LevelInfo";
          LevelInfo["__interfaces"] = ["java.io.Serializable"];

          var LevelOff =
          /** @class */
          function (_super) {
            __extends(LevelOff, _super);

            function LevelOff() {
              return _super.call(this) || this;
            }
            /**
            *
            * @return {string}
            */


            LevelOff.prototype.getName = function () {
              return "OFF";
            };
            /**
            *
            * @return {number}
            */


            LevelOff.prototype.intValue = function () {
              return javaemul.internal.IntegerHelper.MAX_VALUE;
            };

            return LevelOff;
          }(java.util.logging.Level);

          Level.LevelOff = LevelOff;
          LevelOff["__class"] = "java.util.logging.Level.LevelOff";
          LevelOff["__interfaces"] = ["java.io.Serializable"];

          var LevelSevere =
          /** @class */
          function (_super) {
            __extends(LevelSevere, _super);

            function LevelSevere() {
              return _super.call(this) || this;
            }
            /**
            *
            * @return {string}
            */


            LevelSevere.prototype.getName = function () {
              return "SEVERE";
            };
            /**
            *
            * @return {number}
            */


            LevelSevere.prototype.intValue = function () {
              return 1000;
            };

            return LevelSevere;
          }(java.util.logging.Level);

          Level.LevelSevere = LevelSevere;
          LevelSevere["__class"] = "java.util.logging.Level.LevelSevere";
          LevelSevere["__interfaces"] = ["java.io.Serializable"];

          var LevelWarning =
          /** @class */
          function (_super) {
            __extends(LevelWarning, _super);

            function LevelWarning() {
              return _super.call(this) || this;
            }
            /**
            *
            * @return {string}
            */


            LevelWarning.prototype.getName = function () {
              return "WARNING";
            };
            /**
            *
            * @return {number}
            */


            LevelWarning.prototype.intValue = function () {
              return 900;
            };

            return LevelWarning;
          }(java.util.logging.Level);

          Level.LevelWarning = LevelWarning;
          LevelWarning["__class"] = "java.util.logging.Level.LevelWarning";
          LevelWarning["__interfaces"] = ["java.io.Serializable"];
        })(Level = logging.Level || (logging.Level = {}));
      })(util.logging || (util.logging = {}));
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * See <a href="https://docs.oracle.com/javase/8/docs/api/java/util/StringJoiner.html">
      * the official Java API doc</a> for details.
      * @param {*} delimiter
      * @param {*} prefix
      * @param {*} suffix
      * @class
      */
      var StringJoiner =
      /** @class */
      function () {
        function StringJoiner(delimiter, prefix, suffix) {
          if ((delimiter != null && (delimiter.constructor != null && delimiter.constructor["__interfaces"] != null && delimiter.constructor["__interfaces"].indexOf("java.lang.CharSequence") >= 0 || typeof delimiter === "string") || delimiter === null) && (prefix != null && (prefix.constructor != null && prefix.constructor["__interfaces"] != null && prefix.constructor["__interfaces"].indexOf("java.lang.CharSequence") >= 0 || typeof prefix === "string") || prefix === null) && (suffix != null && (suffix.constructor != null && suffix.constructor["__interfaces"] != null && suffix.constructor["__interfaces"].indexOf("java.lang.CharSequence") >= 0 || typeof suffix === "string") || suffix === null)) {
            if (this.delimiter === undefined) {
              this.delimiter = null;
            }

            if (this.prefix === undefined) {
              this.prefix = null;
            }

            if (this.suffix === undefined) {
              this.suffix = null;
            }

            if (this.builder === undefined) {
              this.builder = null;
            }

            if (this.emptyValue === undefined) {
              this.emptyValue = null;
            }

            javaemul.internal.InternalPreconditions.checkNotNull(delimiter, "delimiter");
            javaemul.internal.InternalPreconditions.checkNotNull(prefix, "prefix");
            javaemul.internal.InternalPreconditions.checkNotNull(suffix, "suffix");
            this.delimiter = delimiter.toString();
            this.prefix = prefix.toString();
            this.suffix = suffix.toString();
            this.emptyValue = this.prefix + this.suffix;
          } else if ((delimiter != null && (delimiter.constructor != null && delimiter.constructor["__interfaces"] != null && delimiter.constructor["__interfaces"].indexOf("java.lang.CharSequence") >= 0 || typeof delimiter === "string") || delimiter === null) && prefix === undefined && suffix === undefined) {
            {
              var prefix_1 = "";
              var suffix_1 = "";

              if (this.delimiter === undefined) {
                this.delimiter = null;
              }

              if (this.prefix === undefined) {
                this.prefix = null;
              }

              if (this.suffix === undefined) {
                this.suffix = null;
              }

              if (this.builder === undefined) {
                this.builder = null;
              }

              if (this.emptyValue === undefined) {
                this.emptyValue = null;
              }

              javaemul.internal.InternalPreconditions.checkNotNull(delimiter, "delimiter");
              javaemul.internal.InternalPreconditions.checkNotNull(prefix_1, "prefix");
              javaemul.internal.InternalPreconditions.checkNotNull(suffix_1, "suffix");
              this.delimiter = delimiter.toString();
              this.prefix = prefix_1.toString();
              this.suffix = suffix_1.toString();
              this.emptyValue = this.prefix + this.suffix;
            }

            if (this.delimiter === undefined) {
              this.delimiter = null;
            }

            if (this.prefix === undefined) {
              this.prefix = null;
            }

            if (this.suffix === undefined) {
              this.suffix = null;
            }

            if (this.builder === undefined) {
              this.builder = null;
            }

            if (this.emptyValue === undefined) {
              this.emptyValue = null;
            }
          } else throw new Error('invalid overload');
        }

        StringJoiner.prototype.add = function (newElement) {
          this.initBuilderOrAddDelimiter();
          this.builder.append$java_lang_CharSequence(newElement);
          return this;
        };

        StringJoiner.prototype.length = function () {
          if (this.builder == null) {
            return this.emptyValue.length;
          }

          return this.builder.length() + this.suffix.length;
        };

        StringJoiner.prototype.merge = function (other) {
          if (other.builder != null) {
            var otherLength = other.builder.length();
            this.initBuilderOrAddDelimiter();
            this.builder.append$java_lang_CharSequence$int$int(other.builder, other.prefix.length, otherLength);
          }

          return this;
        };

        StringJoiner.prototype.setEmptyValue = function (emptyValue) {
          javaemul.internal.InternalPreconditions.checkNotNull(emptyValue);
          this.emptyValue = emptyValue.toString();
          return this;
        };
        /**
        *
        * @return {string}
        */


        StringJoiner.prototype.toString = function () {
          if (this.builder == null) {
            return this.emptyValue;
          } else if (
          /* isEmpty */
          this.suffix.length === 0) {
            return this.builder.toString();
          } else {
            return this.builder.toString() + this.suffix;
          }
        };
        /*private*/


        StringJoiner.prototype.initBuilderOrAddDelimiter = function () {
          if (this.builder == null) {
            this.builder = new java.lang.StringBuilder(this.prefix);
          } else {
            this.builder.append$java_lang_String(this.delimiter);
          }
        };

        return StringJoiner;
      }();

      util.StringJoiner = StringJoiner;
      StringJoiner["__class"] = "java.util.StringJoiner";
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * Basic {@link Map.Entry} implementation that implements hashCode, equals, and
      * toString.
      * @class
      */
      var AbstractMapEntry =
      /** @class */
      function () {
        function AbstractMapEntry() {}
        /**
        *
        * @param {*} other
        * @return {boolean}
        */


        AbstractMapEntry.prototype.equals = function (other) {
          if (!(other != null && other.constructor != null && other.constructor["__interfaces"] != null && other.constructor["__interfaces"].indexOf("java.util.Map.Entry") >= 0)) {
            return false;
          }

          var entry = other;
          return java.util.Objects.equals(this.getKey(), entry.getKey()) && java.util.Objects.equals(this.getValue(), entry.getValue());
        };
        /**
        * Calculate the hash code using Sun's specified algorithm.
        * @return {number}
        */


        AbstractMapEntry.prototype.hashCode = function () {
          return java.util.Objects.hashCode(this.getKey()) ^ java.util.Objects.hashCode(this.getValue());
        };
        /**
        *
        * @return {string}
        */


        AbstractMapEntry.prototype.toString = function () {
          return this.getKey() + "=" + this.getValue();
        };

        return AbstractMapEntry;
      }();

      util.AbstractMapEntry = AbstractMapEntry;
      AbstractMapEntry["__class"] = "java.util.AbstractMapEntry";
      AbstractMapEntry["__interfaces"] = ["java.util.Map.Entry"];
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (security) {
      /**
      * Message Digest Service Provider Interface - <a
      * href="http://java.sun.com/j2se/1.4.2/docs/api/java/security/MessageDigestSpi.html">[Sun's
      * docs]</a>.
      * @class
      */
      var MessageDigestSpi =
      /** @class */
      function () {
        function MessageDigestSpi() {}

        MessageDigestSpi.prototype.engineDigest$ = function () {
          throw new Error('cannot invoke abstract overloaded method... check your argument(s) type(s)');
        };

        MessageDigestSpi.prototype.engineDigest$byte_A$int$int = function (buf, offset, len) {
          var digest = this.engineDigest$();

          if (buf.length < digest.length + offset) {
            throw new java.security.DigestException("Insufficient buffer space for digest");
          }

          if (len < digest.length) {
            throw new java.security.DigestException("Length not large enough to hold digest");
          }

          java.lang.System.arraycopy(digest, 0, buf, offset, digest.length);
          return digest.length;
        };

        MessageDigestSpi.prototype.engineDigest = function (buf, offset, len) {
          if ((buf != null && buf instanceof Array && (buf.length == 0 || buf[0] == null || typeof buf[0] === 'number') || buf === null) && (typeof offset === 'number' || offset === null) && (typeof len === 'number' || len === null)) {
            return this.engineDigest$byte_A$int$int(buf, offset, len);
          } else if (buf === undefined && offset === undefined && len === undefined) {
            return this.engineDigest$();
          } else throw new Error('invalid overload');
        };

        MessageDigestSpi.prototype.engineGetDigestLength = function () {
          return 0;
        };

        MessageDigestSpi.prototype.engineUpdate$byte = function (input) {
          throw new Error('cannot invoke abstract overloaded method... check your argument(s) type(s)');
        };

        MessageDigestSpi.prototype.engineUpdate$byte_A$int$int = function (input, offset, len) {
          throw new Error('cannot invoke abstract overloaded method... check your argument(s) type(s)');
        };

        MessageDigestSpi.prototype.engineUpdate = function (input, offset, len) {
          if ((input != null && input instanceof Array && (input.length == 0 || input[0] == null || typeof input[0] === 'number') || input === null) && (typeof offset === 'number' || offset === null) && (typeof len === 'number' || len === null)) {
            return this.engineUpdate$byte_A$int$int(input, offset, len);
          } else if ((typeof input === 'number' || input === null) && offset === undefined && len === undefined) {
            return this.engineUpdate$byte(input);
          } else throw new Error('invalid overload');
        };

        return MessageDigestSpi;
      }();

      security.MessageDigestSpi = MessageDigestSpi;
      MessageDigestSpi["__class"] = "java.security.MessageDigestSpi";
    })(java.security || (java.security = {}));
  })(java || (java = {}));

  (function (java) {
    (function (io) {
      /**
      * Provides a series of utilities to be reused between IO classes.
      *
      * TODO(chehayeb): move these checks to InternalPreconditions.
      * @class
      */
      var IOUtils =
      /** @class */
      function () {
        function IOUtils() {}

        IOUtils.checkOffsetAndCount$byte_A$int$int = function (buffer, byteOffset, byteCount) {
          javaemul.internal.InternalPreconditions.checkNotNull(buffer);
          IOUtils.checkOffsetAndCount$int$int$int(buffer.length, byteOffset, byteCount);
        };
        /**
        * Validates the offset and the byte count for the given array of bytes.
        *
        * @param {Array} buffer Array of bytes to be checked.
        * @param {number} byteOffset Starting offset in the array.
        * @param {number} byteCount Total number of bytes to be accessed.
        * @throws NullPointerException if the given reference to the buffer is null.
        * @throws IndexOutOfBoundsException if {@code byteOffset} is negative, {@code byteCount} is
        * negative or their sum exceeds the buffer length.
        */


        IOUtils.checkOffsetAndCount = function (buffer, byteOffset, byteCount) {
          if ((buffer != null && buffer instanceof Array && (buffer.length == 0 || buffer[0] == null || typeof buffer[0] === 'number') || buffer === null) && (typeof byteOffset === 'number' || byteOffset === null) && (typeof byteCount === 'number' || byteCount === null)) {
            return java.io.IOUtils.checkOffsetAndCount$byte_A$int$int(buffer, byteOffset, byteCount);
          } else if ((buffer != null && buffer instanceof Array && (buffer.length == 0 || buffer[0] == null || typeof buffer[0] === 'string') || buffer === null) && (typeof byteOffset === 'number' || byteOffset === null) && (typeof byteCount === 'number' || byteCount === null)) {
            return java.io.IOUtils.checkOffsetAndCount$char_A$int$int(buffer, byteOffset, byteCount);
          } else if ((typeof buffer === 'number' || buffer === null) && (typeof byteOffset === 'number' || byteOffset === null) && (typeof byteCount === 'number' || byteCount === null)) {
            return java.io.IOUtils.checkOffsetAndCount$int$int$int(buffer, byteOffset, byteCount);
          } else throw new Error('invalid overload');
        };

        IOUtils.checkOffsetAndCount$char_A$int$int = function (buffer, charOffset, charCount) {
          javaemul.internal.InternalPreconditions.checkNotNull(buffer);
          IOUtils.checkOffsetAndCount$int$int$int(buffer.length, charOffset, charCount);
        };
        /*private*/


        IOUtils.checkOffsetAndCount$int$int$int = function (length, offset, count) {
          if (offset < 0 || count < 0 || offset + count > length) {
            throw new java.lang.IndexOutOfBoundsException();
          }
        };

        return IOUtils;
      }();

      io.IOUtils = IOUtils;
      IOUtils["__class"] = "java.io.IOUtils";
    })(java.io || (java.io = {}));
  })(java || (java = {}));

  (function (java) {
    (function (io) {
      /**
      * JSweet implementation.
      * @class
      */
      var Writer =
      /** @class */
      function () {
        function Writer(lock) {
          if (lock != null || lock === null) {
            if (this.writeBuffer === undefined) {
              this.writeBuffer = null;
            }

            if (this.lock === undefined) {
              this.lock = null;
            }

            if (lock == null) {
              throw new java.lang.NullPointerException();
            }

            this.lock = lock;
          } else if (lock === undefined) {
            if (this.writeBuffer === undefined) {
              this.writeBuffer = null;
            }

            if (this.lock === undefined) {
              this.lock = null;
            }

            this.lock = this;
          } else throw new Error('invalid overload');
        }

        Writer.prototype.write$int = function (c) {
          {
            if (this.writeBuffer == null) {
              this.writeBuffer = function (s) {
                var a = [];

                while (s-- > 0) {
                  a.push(null);
                }

                return a;
              }(Writer.WRITE_BUFFER_SIZE);
            }

            this.writeBuffer[0] = String.fromCharCode(c);
            this.write$char_A$int$int(this.writeBuffer, 0, 1);
          }
        };

        Writer.prototype.write$char_A = function (cbuf) {
          this.write$char_A$int$int(cbuf, 0, cbuf.length);
        };

        Writer.prototype.write$char_A$int$int = function (cbuf, off, len) {
          throw new Error('cannot invoke abstract overloaded method... check your argument(s) type(s)');
        };

        Writer.prototype.write$java_lang_String = function (str) {
          this.write$java_lang_String$int$int(str, 0, str.length);
        };

        Writer.prototype.write$java_lang_String$int$int = function (str, off, len) {
          {
            var cbuf = void 0;

            if (len <= Writer.WRITE_BUFFER_SIZE) {
              if (this.writeBuffer == null) {
                this.writeBuffer = function (s) {
                  var a = [];

                  while (s-- > 0) {
                    a.push(null);
                  }

                  return a;
                }(Writer.WRITE_BUFFER_SIZE);
              }

              cbuf = this.writeBuffer;
            } else {
              cbuf = function (s) {
                var a = [];

                while (s-- > 0) {
                  a.push(null);
                }

                return a;
              }(len);
            }
            /* getChars */


            (function (a, s, e, d, l) {
              d.splice.apply(d, [l, e - s].concat(a.substring(s, e).split('')));
            })(str, off, off + len, cbuf, 0);

            this.write$char_A$int$int(cbuf, 0, len);
          }
        };

        Writer.prototype.write = function (str, off, len) {
          if ((typeof str === 'string' || str === null) && (typeof off === 'number' || off === null) && (typeof len === 'number' || len === null)) {
            return this.write$java_lang_String$int$int(str, off, len);
          } else if ((str != null && str instanceof Array && (str.length == 0 || str[0] == null || typeof str[0] === 'string') || str === null) && (typeof off === 'number' || off === null) && (typeof len === 'number' || len === null)) {
            return this.write$char_A$int$int(str, off, len);
          } else if ((str != null && str instanceof Array && (str.length == 0 || str[0] == null || typeof str[0] === 'string') || str === null) && off === undefined && len === undefined) {
            return this.write$char_A(str);
          } else if ((typeof str === 'string' || str === null) && off === undefined && len === undefined) {
            return this.write$java_lang_String(str);
          } else if ((typeof str === 'number' || str === null) && off === undefined && len === undefined) {
            return this.write$int(str);
          } else throw new Error('invalid overload');
        };

        Writer.prototype.append$java_lang_CharSequence = function (csq) {
          if (csq == null) this.write$java_lang_String("null");else this.write$java_lang_String(csq.toString());
          return this;
        };

        Writer.prototype.append$java_lang_CharSequence$int$int = function (csq, start, end) {
          var cs = csq == null ? "null" : csq;
          this.write$java_lang_String(
          /* subSequence */
          cs.substring(start, end).toString());
          return this;
        };

        Writer.prototype.append = function (csq, start, end) {
          if ((csq != null && (csq.constructor != null && csq.constructor["__interfaces"] != null && csq.constructor["__interfaces"].indexOf("java.lang.CharSequence") >= 0 || typeof csq === "string") || csq === null) && (typeof start === 'number' || start === null) && (typeof end === 'number' || end === null)) {
            return this.append$java_lang_CharSequence$int$int(csq, start, end);
          } else if ((csq != null && (csq.constructor != null && csq.constructor["__interfaces"] != null && csq.constructor["__interfaces"].indexOf("java.lang.CharSequence") >= 0 || typeof csq === "string") || csq === null) && start === undefined && end === undefined) {
            return this.append$java_lang_CharSequence(csq);
          } else if ((typeof csq === 'string' || csq === null) && start === undefined && end === undefined) {
            return this.append$char(csq);
          } else throw new Error('invalid overload');
        };

        Writer.prototype.append$char = function (c) {
          this.write$int(c.charCodeAt(0));
          return this;
        };

        Writer.WRITE_BUFFER_SIZE = 1024;
        return Writer;
      }();

      io.Writer = Writer;
      Writer["__class"] = "java.io.Writer";
      Writer["__interfaces"] = ["java.lang.Appendable", "java.io.Closeable", "java.lang.AutoCloseable", "java.io.Flushable"];
    })(java.io || (java.io = {}));
  })(java || (java = {}));

  (function (java) {
    (function (io) {
      /**
      * This constructor does nothing. It is provided for signature
      * compatibility.
      * @class
      * @extends *
      */
      var InputStream =
      /** @class */
      function () {
        function InputStream() {}
        /**
        * Returns an estimated number of bytes that can be read or skipped without blocking for more
        * input.
        *
        * <p>Note that this method provides such a weak guarantee that it is not very useful in
        * practice.
        *
        * <p>Firstly, the guarantee is "without blocking for more input" rather than "without
        * blocking": a read may still block waiting for I/O to complete&nbsp;&mdash; the guarantee is
        * merely that it won't have to wait indefinitely for data to be written. The result of this
        * method should not be used as a license to do I/O on a thread that shouldn't be blocked.
        *
        * <p>Secondly, the result is a
        * conservative estimate and may be significantly smaller than the actual number of bytes
        * available. In particular, an implementation that always returns 0 would be correct.
        * In general, callers should only use this method if they'd be satisfied with
        * treating the result as a boolean yes or no answer to the question "is there definitely
        * data ready?".
        *
        * <p>Thirdly, the fact that a given number of bytes is "available" does not guarantee that a
        * read or skip will actually read or skip that many bytes: they may read or skip fewer.
        *
        * <p>It is particularly important to realize that you <i>must not</i> use this method to
        * size a container and assume that you can read the entirety of the stream without needing
        * to resize the container. Such callers should probably write everything they read to a
        * {@link ByteArrayOutputStream} and convert that to a byte array. Alternatively, if you're
        * reading from a file, {@link File#length} returns the current length of the file (though
        * assuming the file's length can't change may be incorrect, reading a file is inherently
        * racy).
        *
        * <p>The default implementation of this method in {@code InputStream} always returns 0.
        * Subclasses should override this method if they are able to indicate the number of bytes
        * available.
        *
        * @return {number} the estimated number of bytes available
        * @throws IOException if this stream is closed or an error occurs
        */


        InputStream.prototype.available = function () {
          return 0;
        };
        /**
        * Closes this stream. Concrete implementations of this class should free
        * any resources during close. This implementation does nothing.
        *
        * @throws IOException
        * if an error occurs while closing this stream.
        */


        InputStream.prototype.close = function () {};
        /**
        * Sets a mark position in this InputStream. The parameter {@code readlimit}
        * indicates how many bytes can be read before the mark is invalidated.
        * Sending {@code reset()} will reposition the stream back to the marked
        * position provided {@code readLimit} has not been surpassed.
        * <p>
        * This default implementation does nothing and concrete subclasses must
        * provide their own implementation.
        *
        * @param {number} readlimit
        * the number of bytes that can be read from this stream before
        * the mark is invalidated.
        * @see #markSupported()
        * @see #reset()
        */


        InputStream.prototype.mark = function (readlimit) {};
        /**
        * Indicates whether this stream supports the {@code mark()} and
        * {@code reset()} methods. The default implementation returns {@code false}.
        *
        * @return {boolean} always {@code false}.
        * @see #mark(int)
        * @see #reset()
        */


        InputStream.prototype.markSupported = function () {
          return false;
        };

        InputStream.prototype.read$ = function () {
          throw new Error('cannot invoke abstract overloaded method... check your argument(s) type(s)');
        };

        InputStream.prototype.read$byte_A = function (buffer) {
          javaemul.internal.InternalPreconditions.checkNotNull(buffer);
          return this.read$byte_A$int$int(buffer, 0, buffer.length);
        };

        InputStream.prototype.read$byte_A$int$int = function (buffer, byteOffset, byteCount) {
          java.io.IOUtils.checkOffsetAndCount$byte_A$int$int(buffer, byteOffset, byteCount);

          for (var i = 0; i < byteCount; ++i) {
            {
              var c = void 0;

              try {
                if ((c = this.read$()) === -1) {
                  return i === 0 ? -1 : i;
                }
              } catch (e) {
                if (i !== 0) {
                  return i;
                }

                throw e;
              }

              buffer[byteOffset + i] = c | 0;
            }
          }

          return byteCount;
        };
        /**
        * Reads up to {@code byteCount} bytes from this stream and stores them in
        * the byte array {@code buffer} starting at {@code byteOffset}.
        * Returns the number of bytes actually read or -1 if the end of the stream
        * has been reached.
        *
        * @throws IndexOutOfBoundsException
        * if {@code byteOffset < 0 || byteCount < 0 || byteOffset + byteCount > buffer.length}.
        * @throws IOException
        * if the stream is closed or another IOException occurs.
        * @param {Array} buffer
        * @param {number} byteOffset
        * @param {number} byteCount
        * @return {number}
        */


        InputStream.prototype.read = function (buffer, byteOffset, byteCount) {
          if ((buffer != null && buffer instanceof Array && (buffer.length == 0 || buffer[0] == null || typeof buffer[0] === 'number') || buffer === null) && (typeof byteOffset === 'number' || byteOffset === null) && (typeof byteCount === 'number' || byteCount === null)) {
            return this.read$byte_A$int$int(buffer, byteOffset, byteCount);
          } else if ((buffer != null && buffer instanceof Array && (buffer.length == 0 || buffer[0] == null || typeof buffer[0] === 'number') || buffer === null) && byteOffset === undefined && byteCount === undefined) {
            return this.read$byte_A(buffer);
          } else if (buffer === undefined && byteOffset === undefined && byteCount === undefined) {
            return this.read$();
          } else throw new Error('invalid overload');
        };
        /**
        * Resets this stream to the last marked location. Throws an
        * {@code IOException} if the number of bytes read since the mark has been
        * set is greater than the limit provided to {@code mark}, or if no mark
        * has been set.
        * <p>
        * This implementation always throws an {@code IOException} and concrete
        * subclasses should provide the proper implementation.
        *
        * @throws IOException
        * if this stream is closed or another IOException occurs.
        */


        InputStream.prototype.reset = function () {
          throw new java.io.IOException();
        };
        /**
        * Skips at most {@code byteCount} bytes in this stream. The number of actual
        * bytes skipped may be anywhere between 0 and {@code byteCount}. If
        * {@code byteCount} is negative, this method does nothing and returns 0, but
        * some subclasses may throw.
        *
        * <p>Note the "at most" in the description of this method: this method may
        * choose to skip fewer bytes than requested. Callers should <i>always</i>
        * check the return value.
        *
        * <p>This default implementation reads bytes into a temporary buffer. Concrete
        * subclasses should provide their own implementation.
        *
        * @return {number} the number of bytes actually skipped.
        * @throws IOException if this stream is closed or another IOException
        * occurs.
        * @param {number} byteCount
        */


        InputStream.prototype.skip = function (byteCount) {
          if (byteCount <= 0) {
            return 0;
          }

          var bSize = Math.min(InputStream.MAX_SKIP_BUFFER_SIZE, byteCount) | 0;

          var b = function (s) {
            var a = [];

            while (s-- > 0) {
              a.push(0);
            }

            return a;
          }(bSize);

          var skipped = 0;

          while (skipped < byteCount) {
            {
              var toRead = Math.min(byteCount - skipped, b.length) | 0;
              var readCount = this.read$byte_A$int$int(b, 0, toRead);

              if (readCount === -1) {
                break;
              }

              skipped += readCount;

              if (readCount < toRead) {
                break;
              }
            }
          }

          return skipped;
        };
        /**
        * Size of the temporary buffer used when skipping bytes with {@link skip(long)}.
        */


        InputStream.MAX_SKIP_BUFFER_SIZE = 4096;
        return InputStream;
      }();

      io.InputStream = InputStream;
      InputStream["__class"] = "java.io.InputStream";
      InputStream["__interfaces"] = ["java.io.Closeable", "java.lang.AutoCloseable"];
    })(java.io || (java.io = {}));
  })(java || (java = {}));

  (function (java) {
    (function (io) {
      /**
      * JSweet implementation.
      * @class
      */
      var Reader =
      /** @class */
      function () {
        function Reader(lock) {
          if (lock != null || lock === null) {
            if (this.lock === undefined) {
              this.lock = null;
            }

            this.skipBuffer = null;

            if (lock == null) {
              throw new java.lang.NullPointerException();
            }

            this.lock = lock;
          } else if (lock === undefined) {
            if (this.lock === undefined) {
              this.lock = null;
            }

            this.skipBuffer = null;
            this.lock = this;
          } else throw new Error('invalid overload');
        }

        Reader.prototype.read$ = function () {
          var cb = [null];
          if (this.read$char_A$int$int(cb, 0, 1) === -1) return -1;else return cb[0].charCodeAt(0);
        };

        Reader.prototype.read$char_A = function (cbuf) {
          return this.read$char_A$int$int(cbuf, 0, cbuf.length);
        };

        Reader.prototype.read$char_A$int$int = function (cbuf, off, len) {
          throw new Error('cannot invoke abstract overloaded method... check your argument(s) type(s)');
        };

        Reader.prototype.read = function (cbuf, off, len) {
          if ((cbuf != null && cbuf instanceof Array && (cbuf.length == 0 || cbuf[0] == null || typeof cbuf[0] === 'string') || cbuf === null) && (typeof off === 'number' || off === null) && (typeof len === 'number' || len === null)) {
            return this.read$char_A$int$int(cbuf, off, len);
          } else if ((cbuf != null && cbuf instanceof Array && (cbuf.length == 0 || cbuf[0] == null || typeof cbuf[0] === 'string') || cbuf === null) && off === undefined && len === undefined) {
            return this.read$char_A(cbuf);
          } else if (cbuf === undefined && off === undefined && len === undefined) {
            return this.read$();
          } else throw new Error('invalid overload');
        };

        Reader.prototype.skip = function (n) {
          if (n < 0) throw new java.lang.IllegalArgumentException("skip value is negative");
          var nn = Math.min(n, Reader.maxSkipBufferSize) | 0;
          if (this.skipBuffer == null || this.skipBuffer.length < nn) this.skipBuffer = function (s) {
            var a = [];

            while (s-- > 0) {
              a.push(null);
            }

            return a;
          }(nn);
          var r = n;

          while (r > 0) {
            {
              var nc = this.read$char_A$int$int(this.skipBuffer, 0, Math.min(r, nn) | 0);
              if (nc === -1) break;
              r -= nc;
            }
          }

          return n - r;
        };

        Reader.prototype.ready = function () {
          return false;
        };

        Reader.prototype.markSupported = function () {
          return false;
        };

        Reader.prototype.mark = function (readAheadLimit) {
          throw new java.io.IOException("mark() not supported");
        };

        Reader.prototype.reset = function () {
          throw new java.io.IOException("reset() not supported");
        };
        /**
        * Maximum skip-buffer size
        */


        Reader.maxSkipBufferSize = 8192;
        return Reader;
      }();

      io.Reader = Reader;
      Reader["__class"] = "java.io.Reader";
      Reader["__interfaces"] = ["java.io.Closeable", "java.lang.AutoCloseable"];
    })(java.io || (java.io = {}));
  })(java || (java = {}));

  (function (java) {
    (function (io) {
      /**
      * Default constructor.
      * @class
      */
      var OutputStream =
      /** @class */
      function () {
        function OutputStream() {}
        /**
        * Closes this stream. Implementations of this method should free any
        * resources used by the stream. This implementation does nothing.
        *
        * @throws IOException
        * if an error occurs while closing this stream.
        */


        OutputStream.prototype.close = function () {};
        /**
        * Flushes this stream. Implementations of this method should ensure that
        * any buffered data is written out. This implementation does nothing.
        *
        * @throws IOException
        * if an error occurs while flushing this stream.
        */


        OutputStream.prototype.flush = function () {};

        OutputStream.prototype.write$byte_A = function (buffer) {
          javaemul.internal.InternalPreconditions.checkNotNull(buffer);
          this.write$byte_A$int$int(buffer, 0, buffer.length);
        };

        OutputStream.prototype.write$byte_A$int$int = function (buffer, offset, count) {
          java.io.IOUtils.checkOffsetAndCount$byte_A$int$int(buffer, offset, count);

          for (var i = offset; i < offset + count; i++) {
            {
              this.write$int(buffer[i]);
            }
          }
        };
        /**
        * Writes {@code count} bytes from the byte array {@code buffer} starting at
        * position {@code offset} to this stream.
        *
        * @param {Array} buffer
        * the buffer to be written.
        * @param {number} offset
        * the start position in {@code buffer} from where to get bytes.
        * @param {number} count
        * the number of bytes from {@code buffer} to write to this
        * stream.
        * @throws IOException
        * if an error occurs while writing to this stream.
        * @throws IndexOutOfBoundsException
        * if {@code offset < 0} or {@code count < 0}, or if
        * {@code offset + count} is bigger than the length of
        * {@code buffer}.
        */


        OutputStream.prototype.write = function (buffer, offset, count) {
          if ((buffer != null && buffer instanceof Array && (buffer.length == 0 || buffer[0] == null || typeof buffer[0] === 'number') || buffer === null) && (typeof offset === 'number' || offset === null) && (typeof count === 'number' || count === null)) {
            return this.write$byte_A$int$int(buffer, offset, count);
          } else if ((buffer != null && buffer instanceof Array && (buffer.length == 0 || buffer[0] == null || typeof buffer[0] === 'number') || buffer === null) && offset === undefined && count === undefined) {
            return this.write$byte_A(buffer);
          } else if ((typeof buffer === 'number' || buffer === null) && offset === undefined && count === undefined) {
            return this.write$int(buffer);
          } else throw new Error('invalid overload');
        };

        OutputStream.prototype.write$int = function (oneByte) {
          throw new Error('cannot invoke abstract overloaded method... check your argument(s) type(s)');
        };

        return OutputStream;
      }();

      io.OutputStream = OutputStream;
      OutputStream["__class"] = "java.io.OutputStream";
      OutputStream["__interfaces"] = ["java.io.Closeable", "java.lang.AutoCloseable", "java.io.Flushable"];
    })(java.io || (java.io = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      (function (ref) {
        /**
        * This implements the reference API in a minimal way. In JavaScript, there is
        * no control over the reference and the GC. So this implementation's only
        * purpose is for compilation.
        * @class
        */
        var Reference =
        /** @class */
        function () {
          function Reference(referent) {
            if (this.referent === undefined) {
              this.referent = null;
            }

            this.referent = referent;
          }

          Reference.prototype.get = function () {
            return this.referent;
          };

          Reference.prototype.clear = function () {
            this.referent = null;
          };

          return Reference;
        }();

        ref.Reference = Reference;
        Reference["__class"] = "java.lang.ref.Reference";
      })(lang.ref || (lang.ref = {}));
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      /**
      * Represents an error caused by an assertion failure.
      * @param {string} message
      * @param {java.lang.Throwable} cause
      * @class
      * @extends java.lang.Error
      */
      var AssertionError =
      /** @class */
      function (_super) {
        __extends(AssertionError, _super);

        function AssertionError(message, cause) {
          var _this = this;

          if ((typeof message === 'string' || message === null) && (cause != null && cause instanceof Error || cause === null)) {
            _this = _super.call(this, message) || this;
            _this.message = message;
          } else if ((typeof message === 'string' || message === null) && cause === undefined) {
            _this = _super.call(this, message) || this;
            _this.message = message;
          } else if ((typeof message === 'boolean' || message === null) && cause === undefined) {
            {
              var __args_10 = arguments;
              var message_1 = new String(__args_10[0]).toString();
              _this = _super.call(this, message_1) || this;
              _this.message = message_1;
            }
          } else if ((typeof message === 'string' || message === null) && cause === undefined) {
            {
              var __args_11 = arguments;
              var message_2 = new String(__args_11[0]).toString();
              _this = _super.call(this, message_2) || this;
              _this.message = message_2;
            }
          } else if ((typeof message === 'number' || message === null) && cause === undefined) {
            {
              var __args_12 = arguments;
              var message_3 = new String(__args_12[0]).toString();
              _this = _super.call(this, message_3) || this;
              _this.message = message_3;
            }
          } else if ((typeof message === 'number' || message === null) && cause === undefined) {
            {
              var __args_13 = arguments;
              var message_4 = new String(__args_13[0]).toString();
              _this = _super.call(this, message_4) || this;
              _this.message = message_4;
            }
          } else if ((typeof message === 'number' || message === null) && cause === undefined) {
            {
              var __args_14 = arguments;
              var message_5 = new String(__args_14[0]).toString();
              _this = _super.call(this, message_5) || this;
              _this.message = message_5;
            }
          } else if ((typeof message === 'number' || message === null) && cause === undefined) {
            {
              var __args_15 = arguments;
              var message_6 = new String(__args_15[0]).toString();
              _this = _super.call(this, message_6) || this;
              _this.message = message_6;
            }
          } else if ((message != null || message === null) && cause === undefined) {
            _this = _super.call(this,
            /* valueOf */
            new String(message).toString()) || this;
            _this.message =
            /* valueOf */
            new String(message).toString();
          } else if (message === undefined && cause === undefined) {
            _this = _super.call(this) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        return AssertionError;
      }(Error);

      lang.AssertionError = AssertionError;
      AssertionError["__class"] = "java.lang.AssertionError";
      AssertionError["__interfaces"] = ["java.io.Serializable"];
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      /**
      * Included for hosted mode source compatibility. Partially implemented
      *
      * @skip
      * @param {string} className
      * @param {string} methodName
      * @param {string} fileName
      * @param {number} lineNumber
      * @class
      */
      var StackTraceElement =
      /** @class */
      function () {
        function StackTraceElement(className, methodName, fileName, lineNumber) {
          if ((typeof className === 'string' || className === null) && (typeof methodName === 'string' || methodName === null) && (typeof fileName === 'string' || fileName === null) && (typeof lineNumber === 'number' || lineNumber === null)) {
            if (this.className === undefined) {
              this.className = null;
            }

            if (this.fileName === undefined) {
              this.fileName = null;
            }

            if (this.lineNumber === undefined) {
              this.lineNumber = 0;
            }

            if (this.methodName === undefined) {
              this.methodName = null;
            }

            this.className = className;
            this.methodName = methodName;
            this.fileName = fileName;
            this.lineNumber = lineNumber;
          } else if (className === undefined && methodName === undefined && fileName === undefined && lineNumber === undefined) {
            if (this.className === undefined) {
              this.className = null;
            }

            if (this.fileName === undefined) {
              this.fileName = null;
            }

            if (this.lineNumber === undefined) {
              this.lineNumber = 0;
            }

            if (this.methodName === undefined) {
              this.methodName = null;
            }
          } else throw new Error('invalid overload');
        }

        StackTraceElement.prototype.getClassName = function () {
          return this.className;
        };

        StackTraceElement.prototype.getFileName = function () {
          return this.fileName;
        };

        StackTraceElement.prototype.getLineNumber = function () {
          return this.lineNumber;
        };

        StackTraceElement.prototype.getMethodName = function () {
          return this.methodName;
        };
        /**
        *
        * @param {*} other
        * @return {boolean}
        */


        StackTraceElement.prototype.equals = function (other) {
          if (other != null && other instanceof java.lang.StackTraceElement) {
            var st = other;
            return this.lineNumber === st.lineNumber && java.util.Objects.equals(this.methodName, st.methodName) && java.util.Objects.equals(this.className, st.className) && java.util.Objects.equals(this.fileName, st.fileName);
          }

          return false;
        };
        /**
        *
        * @return {number}
        */


        StackTraceElement.prototype.hashCode = function () {
          return java.util.Objects.hash(this.lineNumber, this.className, this.methodName, this.fileName);
        };
        /**
        *
        * @return {string}
        */


        StackTraceElement.prototype.toString = function () {
          return this.className + "." + this.methodName + "(" + (this.fileName != null ? this.fileName : "Unknown Source") + (this.lineNumber >= 0 ? ":" + this.lineNumber : "") + ")";
        };

        return StackTraceElement;
      }();

      lang.StackTraceElement = StackTraceElement;
      StackTraceElement["__class"] = "java.lang.StackTraceElement";
      StackTraceElement["__interfaces"] = ["java.io.Serializable"];
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      /**
      * Constructs a {@code VirtualMachineError} with the specified
      * detail message and cause.  <p>Note that the detail message
      * associated with {@code cause} is <i>not</i> automatically
      * incorporated in this error's detail message.
      *
      * @param  {string} message the detail message (which is saved for later retrieval
      * by the {@link #getMessage()} method).
      * @param  {java.lang.Throwable} cause the cause (which is saved for later retrieval by the
      * {@link #getCause()} method).  (A {@code null} value is
      * permitted, and indicates that the cause is nonexistent or
      * unknown.)
      * @since  1.8
      * @class
      * @extends java.lang.Error
      * @author  Frank Yellin
      */
      var VirtualMachineError =
      /** @class */
      function (_super) {
        __extends(VirtualMachineError, _super);

        function VirtualMachineError(message, cause) {
          var _this = this;

          if ((typeof message === 'string' || message === null) && (cause != null && cause instanceof Error || cause === null)) {
            var __args = arguments;
            _this = _super.call(this, message) || this;
            _this.message = message;
          } else if ((typeof message === 'string' || message === null) && cause === undefined) {
            var __args = arguments;
            _this = _super.call(this, message) || this;
            _this.message = message;
          } else if ((message != null && message instanceof Error || message === null) && cause === undefined) {
            var __args = arguments;
            var cause_1 = __args[0];
            _this = _super.call(this, cause_1) || this;
            _this.message = cause_1;
          } else if (message === undefined && cause === undefined) {
            var __args = arguments;
            _this = _super.call(this) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        VirtualMachineError.serialVersionUID = 4161983926571568670;
        return VirtualMachineError;
      }(Error);

      lang.VirtualMachineError = VirtualMachineError;
      VirtualMachineError["__class"] = "java.lang.VirtualMachineError";
      VirtualMachineError["__interfaces"] = ["java.io.Serializable"];
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      /**
      * See <a
      * href="http://java.sun.com/j2se/1.5.0/docs/api/java/lang/Exception.html">the
      * official Java API doc</a> for details.
      * @param {string} message
      * @param {java.lang.Throwable} cause
      * @class
      * @extends java.lang.Throwable
      */
      var Exception =
      /** @class */
      function (_super) {
        __extends(Exception, _super);

        function Exception(message, cause, enableSuppression, writableStackTrace) {
          var _this = this;

          if ((typeof message === 'string' || message === null) && (cause != null && cause instanceof Error || cause === null) && (typeof enableSuppression === 'boolean' || enableSuppression === null) && (typeof writableStackTrace === 'boolean' || writableStackTrace === null)) {
            var __args = arguments;
            _this = _super.call(this, message) || this;
            _this.message = message;
          } else if ((typeof message === 'string' || message === null) && (cause != null && cause instanceof Error || cause === null) && enableSuppression === undefined && writableStackTrace === undefined) {
            var __args = arguments;
            _this = _super.call(this, message) || this;
            _this.message = message;
          } else if ((typeof message === 'string' || message === null) && cause === undefined && enableSuppression === undefined && writableStackTrace === undefined) {
            var __args = arguments;
            _this = _super.call(this, message) || this;
            _this.message = message;
          } else if ((message != null && message instanceof Error || message === null) && cause === undefined && enableSuppression === undefined && writableStackTrace === undefined) {
            var __args = arguments;
            var cause_2 = __args[0];
            _this = _super.call(this, cause_2) || this;
            _this.message = cause_2;
          } else if (message === undefined && cause === undefined && enableSuppression === undefined && writableStackTrace === undefined) {
            var __args = arguments;
            _this = _super.call(this) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        return Exception;
      }(Error);

      lang.Exception = Exception;
      Exception["__class"] = "java.lang.Exception";
      Exception["__interfaces"] = ["java.io.Serializable"];
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      /**
      * For JRE compatibility.
      * @class
      */
      var Void =
      /** @class */
      function () {
        function Void() {}

        return Void;
      }();

      lang.Void = Void;
      Void["__class"] = "java.lang.Void";
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      var IllegalAccessError =
      /** @class */
      function (_super) {
        __extends(IllegalAccessError, _super);

        function IllegalAccessError(message, cause) {
          var _this = this;

          if ((typeof message === 'string' || message === null) && (cause != null && cause instanceof Error || cause === null)) {
            var __args = arguments;
            _this = _super.call(this, message) || this;
            _this.message = message;
          } else if ((typeof message === 'string' || message === null) && cause === undefined) {
            var __args = arguments;
            _this = _super.call(this, message) || this;
            _this.message = message;
          } else if ((message != null && message instanceof Error || message === null) && cause === undefined) {
            var __args = arguments;
            var cause_3 = __args[0];
            _this = _super.call(this, cause_3) || this;
            _this.message = cause_3;
          } else if (message === undefined && cause === undefined) {
            var __args = arguments;
            _this = _super.call(this) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        return IllegalAccessError;
      }(Error);

      lang.IllegalAccessError = IllegalAccessError;
      IllegalAccessError["__class"] = "java.lang.IllegalAccessError";
      IllegalAccessError["__interfaces"] = ["java.io.Serializable"];
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      (function (reflect) {
        var Array =
        /** @class */
        function () {
          function Array() {}

          Array.newInstance = function (componentType, length) {
            var array = [];
            array.length = length;
            return array;
          };

          return Array;
        }();

        reflect.Array = Array;
        Array["__class"] = "java.lang.reflect.Array";
      })(lang.reflect || (lang.reflect = {}));
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      var NoSuchMethodError =
      /** @class */
      function (_super) {
        __extends(NoSuchMethodError, _super);

        function NoSuchMethodError(message, cause) {
          var _this = this;

          if ((typeof message === 'string' || message === null) && (cause != null && cause instanceof Error || cause === null)) {
            var __args = arguments;
            _this = _super.call(this, message) || this;
            _this.message = message;
          } else if ((typeof message === 'string' || message === null) && cause === undefined) {
            var __args = arguments;
            _this = _super.call(this, message) || this;
            _this.message = message;
          } else if ((message != null && message instanceof Error || message === null) && cause === undefined) {
            var __args = arguments;
            var cause_4 = __args[0];
            _this = _super.call(this, cause_4) || this;
            _this.message = cause_4;
          } else if (message === undefined && cause === undefined) {
            var __args = arguments;
            _this = _super.call(this) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        return NoSuchMethodError;
      }(Error);

      lang.NoSuchMethodError = NoSuchMethodError;
      NoSuchMethodError["__class"] = "java.lang.NoSuchMethodError";
      NoSuchMethodError["__interfaces"] = ["java.io.Serializable"];
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      (function (annotation) {
        (function (ElementType) {
          ElementType[ElementType["ANNOTATION_TYPE"] = 0] = "ANNOTATION_TYPE";
          ElementType[ElementType["CONSTRUCTOR"] = 1] = "CONSTRUCTOR";
          ElementType[ElementType["FIELD"] = 2] = "FIELD";
          ElementType[ElementType["LOCAL_VARIABLE"] = 3] = "LOCAL_VARIABLE";
          ElementType[ElementType["METHOD"] = 4] = "METHOD";
          ElementType[ElementType["PACKAGE"] = 5] = "PACKAGE";
          ElementType[ElementType["PARAMETER"] = 6] = "PARAMETER";
          ElementType[ElementType["TYPE"] = 7] = "TYPE";
        })(annotation.ElementType || (annotation.ElementType = {}));
      })(lang.annotation || (lang.annotation = {}));
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      (function (annotation) {
        (function (RetentionPolicy) {
          RetentionPolicy[RetentionPolicy["CLASS"] = 0] = "CLASS";
          RetentionPolicy[RetentionPolicy["RUNTIME"] = 1] = "RUNTIME";
          RetentionPolicy[RetentionPolicy["SOURCE"] = 2] = "SOURCE";
        })(annotation.RetentionPolicy || (annotation.RetentionPolicy = {}));
      })(lang.annotation || (lang.annotation = {}));
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      (function (annotation) {
        /**
        * Indicates the annotation parser determined the annotation was malformed when
        * reading from the class file <a
        * href="http://java.sun.com/j2se/1.5.0/docs/api/java/lang/annotation/AnnotationFormatError.html">[Sun
        * docs]</a>.
        * @class
        * @extends java.lang.Error
        */
        var AnnotationFormatError =
        /** @class */
        function (_super) {
          __extends(AnnotationFormatError, _super);

          function AnnotationFormatError() {
            var _this = _super.call(this) || this;

            Object.setPrototypeOf(_this, AnnotationFormatError.prototype);
            return _this;
          }

          return AnnotationFormatError;
        }(Error);

        annotation.AnnotationFormatError = AnnotationFormatError;
        AnnotationFormatError["__class"] = "java.lang.annotation.AnnotationFormatError";
        AnnotationFormatError["__interfaces"] = ["java.io.Serializable"];
      })(lang.annotation || (lang.annotation = {}));
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      /**
      * Generally unsupported. This class is provided so that the GWT compiler can
      * choke down class literal references.
      * <p>
      * NOTE: The code in this class is very sensitive and should keep its
      * dependencies upon other classes to a minimum.
      *
      * @param <T>
      * the type of the object
      * @class
      */
      var Class =
      /** @class */
      function () {
        function Class() {
          if (this.enumValueOfFunc === undefined) {
            this.enumValueOfFunc = null;
          }

          if (this.modifiers === undefined) {
            this.modifiers = 0;
          }

          if (this.componentType === undefined) {
            this.componentType = null;
          }

          if (this.enumConstantsFunc === undefined) {
            this.enumConstantsFunc = null;
          }

          if (this.enumSuperclass === undefined) {
            this.enumSuperclass = null;
          }

          if (this.superclass === undefined) {
            this.superclass = null;
          }

          if (this.simpleName === undefined) {
            this.simpleName = null;
          }

          if (this.typeName === undefined) {
            this.typeName = null;
          }

          if (this.canonicalName === undefined) {
            this.canonicalName = null;
          }

          if (this.packageName === undefined) {
            this.packageName = null;
          }

          if (this.compoundName === undefined) {
            this.compoundName = null;
          }

          if (this.typeId === undefined) {
            this.typeId = null;
          }

          if (this.arrayLiterals === undefined) {
            this.arrayLiterals = null;
          }

          this.sequentialId = Class.nextSequentialId++;
          this.typeName = null;
          this.simpleName = null;
          this.packageName = null;
          this.compoundName = null;
          this.canonicalName = null;
          this.typeId = null;
          this.arrayLiterals = null;
        }

        Class.constructors_$LI$ = function () {
          if (Class.constructors == null) {
            Class.constructors = new Array();
          }

          return Class.constructors;
        };

        Class.classes_$LI$ = function () {
          if (Class.classes == null) {
            Class.classes = new Array();
          }

          return Class.classes;
        };

        Class.getConstructorForClass = function (clazz) {
          var index = Class.classes_$LI$().indexOf(clazz) | 0;
          return index === -1 ? null : Class.constructors_$LI$()[index];
        };

        Class.getClassForConstructor = function (constructor) {
          var index = Class.constructors_$LI$().indexOf(constructor) | 0;
          return index === -1 ? null : Class.classes_$LI$()[index];
        };

        Class.mapConstructorToClass = function (constructor, clazz) {
          Class.constructors_$LI$().push(constructor);
          Class.classes_$LI$().push(clazz);
        };
        /**
        * Create a Class object for an array.
        * <p>
        *
        * Arrays are not registered in the prototype table and get the class
        * literal explicitly at construction.
        * <p>
        * @param {java.lang.Class} leafClass
        * @param {number} dimensions
        * @return {java.lang.Class}
        * @private
        */

        /*private*/


        Class.getClassLiteralForArray = function (leafClass, dimensions) {
          var arrayLiterals = leafClass.arrayLiterals = leafClass.arrayLiterals == null ? [] : leafClass.arrayLiterals;
          return arrayLiterals[dimensions] != null ? arrayLiterals[dimensions] : arrayLiterals[dimensions] = leafClass.createClassLiteralForArray(dimensions);
        };
        /*private*/


        Class.prototype.createClassLiteralForArray = function (dimensions) {
          var clazz = new java.lang.Class();
          clazz.modifiers = Class.ARRAY;
          clazz.superclass = Object;

          if (dimensions > 1) {
            clazz.componentType = Class.getClassLiteralForArray(this, dimensions - 1);
          } else {
            clazz.componentType = this;
          }

          return clazz;
        };
        /**
        * Create a Class object for a class.
        *
        * @skip
        * @param {string} packageName
        * @param {string} compoundClassName
        * @param {string} typeId
        * @param {java.lang.Class} superclass
        * @return {java.lang.Class}
        */


        Class.createForClass = function (packageName, compoundClassName, typeId, superclass) {
          var clazz = Class.createClassObject(packageName, compoundClassName, typeId);
          clazz.superclass = superclass;
          return clazz;
        };
        /**
        * Create a Class object for an enum.
        *
        * @skip
        * @param {string} packageName
        * @param {string} compoundClassName
        * @param {string} typeId
        * @param {java.lang.Class} superclass
        * @param {Function} enumConstantsFunc
        * @param {Function} enumValueOfFunc
        * @return {java.lang.Class}
        */


        Class.createForEnum = function (packageName, compoundClassName, typeId, superclass, enumConstantsFunc, enumValueOfFunc) {
          var clazz = Class.createClassObject(packageName, compoundClassName, typeId);
          clazz.modifiers = enumConstantsFunc != null ? Class.ENUM : 0;
          clazz.superclass = clazz.enumSuperclass = superclass;
          clazz.enumConstantsFunc = enumConstantsFunc;
          clazz.enumValueOfFunc = enumValueOfFunc;
          return clazz;
        };
        /**
        * Create a Class object for an interface.
        *
        * @skip
        * @param {string} packageName
        * @param {string} compoundClassName
        * @return {java.lang.Class}
        */


        Class.createForInterface = function (packageName, compoundClassName) {
          var clazz = Class.createClassObject(packageName, compoundClassName, null);
          clazz.modifiers = Class.INTERFACE;
          return clazz;
        };
        /**
        * Create a Class object for a primitive.
        *
        * @skip
        * @param {string} className
        * @param {string} primitiveTypeId
        * @return {java.lang.Class}
        */


        Class.createForPrimitive = function (className, primitiveTypeId) {
          var clazz = Class.createClassObject("", className, primitiveTypeId);
          clazz.modifiers = Class.PRIMITIVE;
          return clazz;
        };
        /**
        * Used by {@link WebModePayloadSink} to create uninitialized instances.
        * @param {java.lang.Class} clazz
        * @return {*}
        */


        Class.getPrototypeForClass = function (clazz) {
          if (clazz.isPrimitive()) {
            return null;
          }

          return Class.getConstructorForClass(clazz).prototype;
        };
        /**
        * Creates the class object for a type and initiliazes its fields.
        * @param {string} packageName
        * @param {string} compoundClassName
        * @param {string} typeId
        * @return {java.lang.Class}
        * @private
        */

        /*private*/


        Class.createClassObject = function (packageName, compoundClassName, typeId) {
          var clazz = new java.lang.Class();
          clazz.packageName = packageName;
          clazz.compoundName = compoundClassName;
          return clazz;
        };
        /**
        * Initiliazes {@code clazz} names from metadata.
        * <p>
        * Written in JSNI to minimize dependencies (on String.+).
        * @param {java.lang.Class} clazz
        * @private
        */

        /*private*/


        Class.initializeNames = function (clazz) {
          if (clazz.isArray()) {
            var componentType = clazz.componentType;

            if (componentType.isPrimitive()) {
              clazz.typeName = "[" + componentType.typeId;
            } else if (!componentType.isArray()) {
              clazz.typeName = "[L" +
              /* getName */
              function (c) {
                return typeof c === 'string' ? c : c["__class"] ? c["__class"] : c["name"];
              }(componentType) + ";";
            } else {
              clazz.typeName = "[" +
              /* getName */
              function (c) {
                return typeof c === 'string' ? c : c["__class"] ? c["__class"] : c["name"];
              }(componentType);
            }

            clazz.canonicalName = componentType.getCanonicalName() + "[]";

            clazz.simpleName =
            /* getSimpleName */
            function (c) {
              return typeof c === 'string' ? c.substring(c.lastIndexOf('.') + 1) : c["__class"] ? c["__class"].substring(c["__class"].lastIndexOf('.') + 1) : c["name"].substring(c["name"].lastIndexOf('.') + 1);
            }(componentType) + "[]";

            return;
          }

          var packageName = clazz.packageName;
          var compoundName = clazz.compoundName.split("/");
          clazz.typeName = [packageName, compoundName.join("$")].join(".");
          clazz.canonicalName = [packageName, compoundName.join(".")].join(".");
          clazz.simpleName = compoundName[compoundName.length - 1];
        };
        /**
        * Sets the class object for primitives.
        * <p>
        * Written in JSNI to minimize dependencies (on (String)+).
        * @param {java.lang.Class} clazz
        * @param {Object} primitiveTypeId
        */


        Class.synthesizePrimitiveNamesFromTypeId = function (clazz, primitiveTypeId) {
          clazz.typeName = "Class$" + primitiveTypeId;
          clazz.canonicalName = clazz.typeName;
          clazz.simpleName = clazz.typeName;
        };

        Class.prototype.desiredAssertionStatus = function () {
          return false;
        };
        /*private*/


        Class.prototype.ensureNamesAreInitialized = function () {
          if (this.typeName != null) {
            return;
          }

          Class.initializeNames(this);
        };

        Class.prototype.getCanonicalName = function () {
          this.ensureNamesAreInitialized();
          return this.canonicalName;
        };

        Class.prototype.getComponentType = function () {
          return this.componentType;
        };

        Class.prototype.getEnumConstants = function () {
          return this.enumConstantsFunc && this.enumConstantsFunc();
        };

        Class.prototype.getName = function () {
          this.ensureNamesAreInitialized();
          return this.typeName;
        };

        Class.prototype.getSimpleName = function () {
          this.ensureNamesAreInitialized();
          return this.simpleName;
        };

        Class.prototype.getSuperclass = function () {
          return this.superclass;
        };

        Class.prototype.isArray = function () {
          return (this.modifiers & Class.ARRAY) !== 0;
        };

        Class.prototype.isEnum = function () {
          return (this.modifiers & Class.ENUM) !== 0;
        };

        Class.prototype.isInterface = function () {
          return (this.modifiers & Class.INTERFACE) !== 0;
        };

        Class.prototype.isPrimitive = function () {
          return (this.modifiers & Class.PRIMITIVE) !== 0;
        };
        /**
        *
        * @return {string}
        */


        Class.prototype.toString = function () {
          return (this.isInterface() ? "interface " : this.isPrimitive() ? "" : "class ") +
          /* getName */
          function (c) {
            return typeof c === 'string' ? c : c["__class"] ? c["__class"] : c["name"];
          }(this);
        };
        /**
        * Used by Enum to allow getSuperclass() to be pruned.
        * @return {java.lang.Class}
        */


        Class.prototype.getEnumSuperclass = function () {
          return this.enumSuperclass;
        };

        Class.PRIMITIVE = 1;
        Class.INTERFACE = 2;
        Class.ARRAY = 4;
        Class.ENUM = 8;
        Class.nextSequentialId = 1;
        return Class;
      }();

      lang.Class = Class;
      Class["__class"] = "java.lang.Class";
      Class["__interfaces"] = ["java.lang.reflect.Type"];
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      var ThreadLocal =
      /** @class */
      function () {
        function ThreadLocal() {
          if (this.value === undefined) {
            this.value = null;
          }
        }

        ThreadLocal.prototype.initialValue = function () {
          return null;
        };

        ThreadLocal.prototype.get = function () {
          return this.value;
        };

        ThreadLocal.prototype.set = function (value) {
          this.value = value;
        };

        ThreadLocal.prototype.remove = function () {};

        ThreadLocal.prototype.childValue = function (parentValue) {
          throw new java.lang.UnsupportedOperationException();
        };

        return ThreadLocal;
      }();

      lang.ThreadLocal = ThreadLocal;
      ThreadLocal["__class"] = "java.lang.ThreadLocal";
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      /**
      * A base class to share implementation between {@link StringBuffer} and {@link StringBuilder}.
      * <p>
      * Most methods will give expected performance results. Exception is {@link #setCharAt(int, char)},
      * which is O(n), and thus should not be used many times on the same <code>StringBuffer</code>.
      * @param {string} string
      * @class
      */
      var AbstractStringBuilder =
      /** @class */
      function () {
        function AbstractStringBuilder(string) {
          if (this.string === undefined) {
            this.string = null;
          }

          this.string = string;
        }

        AbstractStringBuilder.prototype.length = function () {
          return this.string.length;
        };

        AbstractStringBuilder.prototype.setLength = function (newLength) {
          var oldLength = this.length();

          if (newLength < oldLength) {
            this.string = this.string.substring(0, newLength);
          } else if (newLength > oldLength) {
            this.string +=
            /* valueOf */
            new String(function (s) {
              var a = [];

              while (s-- > 0) {
                a.push(null);
              }

              return a;
            }(newLength - oldLength)).toString();
          }
        };

        AbstractStringBuilder.prototype.capacity = function () {
          return javaemul.internal.IntegerHelper.MAX_VALUE;
        };

        AbstractStringBuilder.prototype.ensureCapacity = function (ignoredCapacity) {};

        AbstractStringBuilder.prototype.trimToSize = function () {};

        AbstractStringBuilder.prototype.charAt = function (index) {
          return this.string.charAt(index);
        };

        AbstractStringBuilder.prototype.getChars = function (srcStart, srcEnd, dst, dstStart) {
          javaemul.internal.InternalPreconditions.checkStringBounds(srcStart, srcEnd, this.length());
          javaemul.internal.InternalPreconditions.checkStringBounds(dstStart, dstStart + (srcEnd - srcStart), dst.length);

          while (srcStart < srcEnd) {
            {
              dst[dstStart++] = this.string.charAt(srcStart++);
            }
          }
        };
        /**
        * Warning! This method is <b>much</b> slower than the JRE implementation. If you need to do
        * character level manipulation, you are strongly advised to use a char[] directly.
        * @param {number} index
        * @param {string} x
        */


        AbstractStringBuilder.prototype.setCharAt = function (index, x) {
          this.replace0(index, index + 1,
          /* valueOf */
          new String(x).toString());
        };

        AbstractStringBuilder.prototype.subSequence = function (start, end) {
          return this.string.substring(start, end);
        };

        AbstractStringBuilder.prototype.substring$int = function (begin) {
          return this.string.substring(begin);
        };

        AbstractStringBuilder.prototype.substring$int$int = function (begin, end) {
          return this.string.substring(begin, end);
        };

        AbstractStringBuilder.prototype.substring = function (begin, end) {
          if ((typeof begin === 'number' || begin === null) && (typeof end === 'number' || end === null)) {
            return this.substring$int$int(begin, end);
          } else if ((typeof begin === 'number' || begin === null) && end === undefined) {
            return this.substring$int(begin);
          } else throw new Error('invalid overload');
        };

        AbstractStringBuilder.prototype.indexOf$java_lang_String = function (x) {
          return this.string.indexOf(x);
        };

        AbstractStringBuilder.prototype.indexOf$java_lang_String$int = function (x, start) {
          return this.string.indexOf(x, start);
        };

        AbstractStringBuilder.prototype.indexOf = function (x, start) {
          if ((typeof x === 'string' || x === null) && (typeof start === 'number' || start === null)) {
            return this.indexOf$java_lang_String$int(x, start);
          } else if ((typeof x === 'string' || x === null) && start === undefined) {
            return this.indexOf$java_lang_String(x);
          } else throw new Error('invalid overload');
        };

        AbstractStringBuilder.prototype.lastIndexOf$java_lang_String = function (s) {
          return this.string.lastIndexOf(s);
        };

        AbstractStringBuilder.prototype.lastIndexOf$java_lang_String$int = function (s, start) {
          return this.string.lastIndexOf(s, start);
        };

        AbstractStringBuilder.prototype.lastIndexOf = function (s, start) {
          if ((typeof s === 'string' || s === null) && (typeof start === 'number' || start === null)) {
            return this.lastIndexOf$java_lang_String$int(s, start);
          } else if ((typeof s === 'string' || s === null) && start === undefined) {
            return this.lastIndexOf$java_lang_String(s);
          } else throw new Error('invalid overload');
        };
        /**
        *
        * @return {string}
        */


        AbstractStringBuilder.prototype.toString = function () {
          return this.string;
        };

        AbstractStringBuilder.prototype.append0 = function (x, start, end) {
          if (x == null) {
            x = "null";
          }

          this.string +=
          /* subSequence */
          x.substring(start, end);
        };

        AbstractStringBuilder.prototype.appendCodePoint0 = function (x) {
          this.string +=
          /* valueOf */
          new String(
          /* toChars */
          String.fromCharCode(x)).toString();
        };

        AbstractStringBuilder.prototype.replace0 = function (start, end, toInsert) {
          this.string = this.string.substring(0, start) + toInsert + this.string.substring(end);
        };

        AbstractStringBuilder.prototype.reverse0 = function () {
          var length = this.string.length;

          if (length <= 1) {
            return;
          }

          var buffer = function (s) {
            var a = [];

            while (s-- > 0) {
              a.push(null);
            }

            return a;
          }(length);

          buffer[0] = this.string.charAt(length - 1);

          for (var i = 1; i < length; i++) {
            {
              buffer[i] = this.string.charAt(length - 1 - i);

              if (javaemul.internal.CharacterHelper.isSurrogatePair(buffer[i], buffer[i - 1])) {
                AbstractStringBuilder.swap(buffer, i - 1, i);
              }
            }
          }

          this.string = new String(buffer);
        };
        /*private*/


        AbstractStringBuilder.swap = function (buffer, f, s) {
          var tmp = buffer[f];
          buffer[f] = buffer[s];
          buffer[s] = tmp;
        };

        return AbstractStringBuilder;
      }();

      lang.AbstractStringBuilder = AbstractStringBuilder;
      AbstractStringBuilder["__class"] = "java.lang.AbstractStringBuilder";
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      /**
      * The first-class representation of an enumeration.
      *
      * @param <E>
      * @class
      */
      var Enum =
      /** @class */
      function () {
        function Enum(name, ordinal) {
          if (this.__name === undefined) {
            this.__name = null;
          }

          if (this.__ordinal === undefined) {
            this.__ordinal = 0;
          }

          this.__name = name;
          this.__ordinal = ordinal;
        }

        Enum.valueOf$java_lang_Class$java_lang_String = function (enumType, name) {
          var enumValueOfFunc = javaemul.internal.InternalPreconditions.checkNotNull(enumType).enumValueOfFunc;
          javaemul.internal.InternalPreconditions.checkCriticalArgument(enumValueOfFunc != null, "EnumValueOfFunc is null at enum class: %s, enum value name: %s",
          /* getName */
          function (c) {
            return typeof c === 'string' ? c : c["__class"] ? c["__class"] : c["name"];
          }(enumType), name);
          javaemul.internal.InternalPreconditions.checkNotNull(name);
          return Enum.invokeValueOf(enumValueOfFunc, name);
        };

        Enum.valueOf = function (enumType, name) {
          if ((enumType != null && (enumType["__class"] != null || function (t) {
            try {
              new t();
              return true;
            } catch (_a) {
              return false;
            }
          }(enumType)) || enumType === null) && (typeof name === 'string' || name === null)) {
            return java.lang.Enum.valueOf$java_lang_Class$java_lang_String(enumType, name);
          } else if ((enumType != null && enumType instanceof Object || enumType === null) && (typeof name === 'string' || name === null)) {
            return java.lang.Enum.valueOf$def_js_Object$java_lang_String(enumType, name);
          } else throw new Error('invalid overload');
        };

        Enum.createValueOfMap = function (enumConstants) {
          var result = new Object();

          for (var index128 = 0; index128 < enumConstants.length; index128++) {
            var value = enumConstants[index128];
            {
              Enum.put0(result, ":" + value.name(), value);
            }
          }

          return result;
        };

        Enum.valueOf$def_js_Object$java_lang_String = function (map, name) {
          javaemul.internal.InternalPreconditions.checkNotNull(name);
          var result = java.lang.Enum.get0(map, ":" + name);
          javaemul.internal.InternalPreconditions.checkCriticalArgument(result != null, "Enum constant undefined: %s", name);
          return result;
        };
        /*private*/


        Enum.get0 = function (map, name) {
          return map[name];
        };
        /*private*/


        Enum.invokeValueOf = function (enumValueOfFunc, name) {
          return enumValueOfFunc(name);
        };
        /*private*/


        Enum.put0 = function (map, name, value) {
          map[name] = value;
        };

        Enum.prototype.compareTo$java_lang_Enum = function (other) {
          return this.__ordinal - other.__ordinal;
        };
        /**
        *
        * @param {java.lang.Enum} other
        * @return {number}
        */


        Enum.prototype.compareTo = function (other) {
          if (other != null || other === null) {
            return this.compareTo$java_lang_Enum(other);
          } else throw new Error('invalid overload');
        };

        Enum.prototype.getDeclaringClass = function () {
          return null;
        };

        Enum.prototype.name = function () {
          return this.__name != null ? this.__name : "" + this.__ordinal;
        };

        Enum.prototype.ordinal = function () {
          return this.__ordinal;
        };
        /**
        *
        * @return {string}
        */


        Enum.prototype.toString = function () {
          return this.name();
        };

        return Enum;
      }();

      lang.Enum = Enum;
      Enum["__class"] = "java.lang.Enum";
      Enum["__interfaces"] = ["java.lang.Comparable", "java.io.Serializable"];
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (beans) {
      /**
      * General-purpose beans control methods. GWT only supports a limited subset of these methods. Only
      * the documented methods are available.
      * @class
      */
      var Beans =
      /** @class */
      function () {
        function Beans() {}
        /**
        * @return {boolean} <code>true</code> if we are running in the design time mode.
        */


        Beans.isDesignTime = function () {
          return false;
        };

        return Beans;
      }();

      beans.Beans = Beans;
      Beans["__class"] = "java.beans.Beans";
    })(java.beans || (java.beans = {}));
  })(java || (java = {}));

  (function (java) {
    (function (beans) {
      var PropertyDescriptor =
      /** @class */
      function () {
        function PropertyDescriptor() {}

        PropertyDescriptor.prototype.getPropertyType = function () {
          return null;
        };

        return PropertyDescriptor;
      }();

      beans.PropertyDescriptor = PropertyDescriptor;
      PropertyDescriptor["__class"] = "java.beans.PropertyDescriptor";
    })(java.beans || (java.beans = {}));
  })(java || (java = {}));

  (function (java) {
    (function (nio) {
      (function (file) {
        var Paths =
        /** @class */
        function () {
          function Paths() {}

          Paths.get = function () {
            var paths = [];

            for (var _i = 0; _i < arguments.length; _i++) {
              paths[_i] = arguments[_i];
            }

            return new java.nio.file.Path(paths.join(java.nio.file.Path.PATH_SEPARATOR_$LI$()));
          };

          return Paths;
        }();

        file.Paths = Paths;
        Paths["__class"] = "java.nio.file.Paths";
      })(nio.file || (nio.file = {}));
    })(java.nio || (java.nio = {}));
  })(java || (java = {}));

  (function (java) {
    (function (nio) {
      var ByteOrder =
      /** @class */
      function () {
        function ByteOrder() {}

        ByteOrder.BIG_ENDIAN_$LI$ = function () {
          if (ByteOrder.BIG_ENDIAN == null) {
            ByteOrder.BIG_ENDIAN = new ByteOrder();
          }

          return ByteOrder.BIG_ENDIAN;
        };

        ByteOrder.LITTLE_ENDIAN_$LI$ = function () {
          if (ByteOrder.LITTLE_ENDIAN == null) {
            ByteOrder.LITTLE_ENDIAN = new ByteOrder();
          }

          return ByteOrder.LITTLE_ENDIAN;
        };
        /**
        *
        * @return {string}
        */


        ByteOrder.prototype.toString = function () {
          return this === ByteOrder.BIG_ENDIAN_$LI$() ? "BIG_ENDIAN" : "LITTLE_ENDIAN";
        };

        ByteOrder.nativeOrder = function () {
          if (ByteOrder.NativeInstanceHolder.INSTANCE == null) {
            ByteOrder.NativeInstanceHolder.INSTANCE = ByteOrder.NativeInstanceHolder.nativeOrderTester();
          }

          return ByteOrder.NativeInstanceHolder.INSTANCE;
        };

        return ByteOrder;
      }();

      nio.ByteOrder = ByteOrder;
      ByteOrder["__class"] = "java.nio.ByteOrder";

      (function (ByteOrder) {
        var NativeInstanceHolder =
        /** @class */
        function () {
          function NativeInstanceHolder() {}

          NativeInstanceHolder.nativeOrderTester = function () {
            var arrayBuffer = new ArrayBuffer(2);
            var uint8Array = new Uint8Array(arrayBuffer);
            var uint16array = new Uint16Array(arrayBuffer);
            uint8Array.set(Uint8Array.from([170, 187]), 0);
            if (uint16array[0] === 48042) return java.nio.ByteOrder.LITTLE_ENDIAN_$LI$();
            if (uint16array[0] === 43707) return java.nio.ByteOrder.BIG_ENDIAN_$LI$();
            throw new Error("Something crazy just happened in native order test");
          };

          NativeInstanceHolder.INSTANCE = null;
          return NativeInstanceHolder;
        }();

        ByteOrder.NativeInstanceHolder = NativeInstanceHolder;
        NativeInstanceHolder["__class"] = "java.nio.ByteOrder.NativeInstanceHolder";
      })(ByteOrder = nio.ByteOrder || (nio.ByteOrder = {}));
    })(java.nio || (java.nio = {}));
  })(java || (java = {}));

  (function (java) {
    (function (nio) {
      var Buffer =
      /** @class */
      function () {
        function Buffer(capacity, readOnly) {
          if (this._capacity === undefined) {
            this._capacity = 0;
          }

          if (this.readOnly === undefined) {
            this.readOnly = false;
          }

          if (this._position === undefined) {
            this._position = 0;
          }

          if (this._limit === undefined) {
            this._limit = 0;
          }

          if (this._mark === undefined) {
            this._mark = 0;
          }

          this._capacity = capacity;
          this.readOnly = readOnly;
          this._position = 0;
          this._limit = capacity;
          this._mark = -1;
        }

        Buffer.prototype.arrayOffset = function () {
          return 0;
        };

        Buffer.prototype.capacity = function () {
          return this._capacity;
        };

        Buffer.prototype.clear = function () {
          this._limit = this._capacity;
          this._position = 0;
          this._mark = -1;
          return this;
        };

        Buffer.prototype.flip = function () {
          this._limit = this._position;
          this._position = 0;
          this._mark = -1;
          return this;
        };

        Buffer.prototype.hasArray = function () {
          return this.array() != null;
        };

        Buffer.prototype.hasRemaining = function () {
          return this._position < this._limit;
        };

        Buffer.prototype.isDirect = function () {
          return false;
        };

        Buffer.prototype.isReadOnly = function () {
          return this.readOnly;
        };

        Buffer.prototype.limit$ = function () {
          return this._limit;
        };

        Buffer.prototype.limit$int = function (newLimit) {
          if (newLimit > this._capacity) throw new java.lang.IllegalArgumentException("limit is bigger than capacity");
          this._limit = newLimit;
          this._position = Math.min(this._position, this._limit);
          if (this._mark > this._limit) this._mark = -1;
          return this;
        };

        Buffer.prototype.limit = function (newLimit) {
          if (typeof newLimit === 'number' || newLimit === null) {
            return this.limit$int(newLimit);
          } else if (newLimit === undefined) {
            return this.limit$();
          } else throw new Error('invalid overload');
        };

        Buffer.prototype.mark = function () {
          this._mark = this._position;
          return this;
        };

        Buffer.prototype.position$ = function () {
          return this._position;
        };

        Buffer.prototype.position$int = function (newPosition) {
          if (newPosition > this._limit) throw new java.lang.IllegalArgumentException("position is bigger than limit");
          this._position = newPosition;
          if (this._mark > this._position) this._mark = -1;
          return this;
        };

        Buffer.prototype.position = function (newPosition) {
          if (typeof newPosition === 'number' || newPosition === null) {
            return this.position$int(newPosition);
          } else if (newPosition === undefined) {
            return this.position$();
          } else throw new Error('invalid overload');
        };

        Buffer.prototype.remaining = function () {
          return this._limit - this._position;
        };

        Buffer.prototype.reset = function () {
          if (this._mark === -1) throw new java.nio.InvalidMarkException();
          this._position = this._mark;
          return this;
        };

        Buffer.prototype.rewind = function () {
          this._position = 0;
          this._mark = -1;
          return this;
        };

        return Buffer;
      }();

      nio.Buffer = Buffer;
      Buffer["__class"] = "java.nio.Buffer";
    })(java.nio || (java.nio = {}));
  })(java || (java = {}));

  (function (java) {
    (function (nio) {
      (function (charset) {
        /**
        * A minimal emulation of {@link Charset}.
        * @class
        */
        var Charset =
        /** @class */
        function () {
          function Charset(name, aliasesIgnored) {
            if (this.__name === undefined) {
              this.__name = null;
            }

            this.__name = name;
          }

          Charset.availableCharsets = function () {
            if (Charset.AvailableCharsets.CHARSETS == null) {
              var map = new java.util.TreeMap();
              map.put(javaemul.internal.EmulatedCharset.ISO_8859_1_$LI$().name(), javaemul.internal.EmulatedCharset.ISO_8859_1_$LI$());
              map.put(javaemul.internal.EmulatedCharset.ISO_LATIN_1_$LI$().name(), javaemul.internal.EmulatedCharset.ISO_LATIN_1_$LI$());
              map.put(javaemul.internal.EmulatedCharset.UTF_8_$LI$().name(), javaemul.internal.EmulatedCharset.UTF_8_$LI$());
              Charset.AvailableCharsets.CHARSETS = java.util.Collections.unmodifiableSortedMap(map);
            }

            return Charset.AvailableCharsets.CHARSETS;
          };

          Charset.forName = function (charsetName) {
            javaemul.internal.InternalPreconditions.checkArgument(charsetName != null, "Null charset name");
            charsetName = charsetName.toUpperCase();

            if (javaemul.internal.EmulatedCharset.ISO_8859_1_$LI$().name() === charsetName) {
              return javaemul.internal.EmulatedCharset.ISO_8859_1_$LI$();
            } else if (javaemul.internal.EmulatedCharset.ISO_LATIN_1_$LI$().name() === charsetName) {
              return javaemul.internal.EmulatedCharset.ISO_LATIN_1_$LI$();
            } else if (javaemul.internal.EmulatedCharset.UTF_8_$LI$().name() === charsetName) {
              return javaemul.internal.EmulatedCharset.UTF_8_$LI$();
            }

            if (!Charset.createLegalCharsetNameRegex().test(charsetName)) {
              throw new java.nio.charset.IllegalCharsetNameException(charsetName);
            } else {
              throw new java.nio.charset.UnsupportedCharsetException(charsetName);
            }
          };

          Charset.createLegalCharsetNameRegex = function () {
            return new RegExp("^[A-Za-z0-9][\\w-:\\.\\+]*$");
          };

          Charset.prototype.name = function () {
            return this.__name;
          };

          Charset.prototype.compareTo$java_nio_charset_Charset = function (that) {
            return (
              /* compareToIgnoreCase */
              this.__name.toUpperCase().localeCompare(that.__name.toUpperCase())
            );
          };
          /**
          *
          * @param {java.nio.charset.Charset} that
          * @return {number}
          */


          Charset.prototype.compareTo = function (that) {
            if (that != null && that instanceof java.nio.charset.Charset || that === null) {
              return this.compareTo$java_nio_charset_Charset(that);
            } else throw new Error('invalid overload');
          };
          /**
          *
          * @return {number}
          */


          Charset.prototype.hashCode = function () {
            return (
              /* hashCode */
              function (o) {
                if (o.hashCode) {
                  return o.hashCode();
                } else {
                  return o.toString().split('').reduce(function (prevHash, currVal) {
                    return (prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0;
                  }, 0);
                }
              }(this.__name)
            );
          };
          /**
          *
          * @param {*} o
          * @return {boolean}
          */


          Charset.prototype.equals = function (o) {
            if (o === this) {
              return true;
            }

            if (!(o != null && o instanceof java.nio.charset.Charset)) {
              return false;
            }

            var that = o;
            return this.__name === that.__name;
          };
          /**
          *
          * @return {string}
          */


          Charset.prototype.toString = function () {
            return this.__name;
          };

          return Charset;
        }();

        charset.Charset = Charset;
        Charset["__class"] = "java.nio.charset.Charset";
        Charset["__interfaces"] = ["java.lang.Comparable"];

        (function (Charset) {
          var AvailableCharsets =
          /** @class */
          function () {
            function AvailableCharsets() {}

            AvailableCharsets.CHARSETS = null;
            return AvailableCharsets;
          }();

          Charset.AvailableCharsets = AvailableCharsets;
          AvailableCharsets["__class"] = "java.nio.charset.Charset.AvailableCharsets";
        })(Charset = charset.Charset || (charset.Charset = {}));
      })(nio.charset || (nio.charset = {}));
    })(java.nio || (java.nio = {}));
  })(java || (java = {}));

  (function (java) {
    (function (text) {
      /**
      * A basic implementation for Java collators.
      *
      * @author Renaud Pawlak
      * @class
      */
      var Collator =
      /** @class */
      function () {
        function Collator() {}

        Collator.getInstance = function () {
          if (Collator.collator == null) {
            Collator.collator = new Collator();
          }

          return Collator.collator;
        };
        /**
        *
        * @param {*} a
        * @param {*} b
        * @return {number}
        */


        Collator.prototype.compare = function (a, b) {
          return a.localeCompare(b);
        };

        Collator.collator = null;
        return Collator;
      }();

      text.Collator = Collator;
      Collator["__class"] = "java.text.Collator";
      Collator["__interfaces"] = ["java.util.Comparator"];
    })(java.text || (java.text = {}));
  })(java || (java = {}));

  (function (java) {
    (function (text) {
      var Normalizer =
      /** @class */
      function () {
        function Normalizer() {}

        Normalizer.normalize = function (src, form) {
          return src.toString().normalize(
          /* Enum.name */
          java.text.Normalizer.Form[form]).toString();
        };

        return Normalizer;
      }();

      text.Normalizer = Normalizer;
      Normalizer["__class"] = "java.text.Normalizer";

      (function (Normalizer) {
        (function (Form) {
          /**
          * Canonical decomposition.
          */
          Form[Form["NFD"] = 0] = "NFD";
          /**
          * Canonical decomposition, followed by canonical composition.
          */

          Form[Form["NFC"] = 1] = "NFC";
          /**
          * Compatibility decomposition.
          */

          Form[Form["NFKD"] = 2] = "NFKD";
          /**
          * Compatibility decomposition, followed by canonical composition.
          */

          Form[Form["NFKC"] = 3] = "NFKC";
        })(Normalizer.Form || (Normalizer.Form = {}));
      })(Normalizer = text.Normalizer || (text.Normalizer = {}));
    })(java.text || (java.text = {}));
  })(java || (java = {}));

  (function (java) {
    (function (text) {
      /**
      * Create a new ParsePosition with the given initial index.
      *
      * @param {number} index initial index
      * @class
      * @author      Mark Davis
      */
      var ParsePosition =
      /** @class */
      function () {
        function ParsePosition(index) {
          this.index = 0;
          this.errorIndex = -1;
          this.index = index;
        }
        /**
        * Retrieve the current parse position.  On input to a parse method, this
        * is the index of the character at which parsing will begin; on output, it
        * is the index of the character following the last character parsed.
        *
        * @return {number} the current parse position
        */


        ParsePosition.prototype.getIndex = function () {
          return this.index;
        };
        /**
        * Set the current parse position.
        *
        * @param {number} index the current parse position
        */


        ParsePosition.prototype.setIndex = function (index) {
          this.index = index;
        };
        /**
        * Set the index at which a parse error occurred.  Formatters
        * should set this before returning an error code from their
        * parseObject method.  The default value is -1 if this is not set.
        *
        * @param {number} ei the index at which an error occurred
        * @since 1.2
        */


        ParsePosition.prototype.setErrorIndex = function (ei) {
          this.errorIndex = ei;
        };
        /**
        * Retrieve the index at which an error occurred, or -1 if the
        * error index has not been set.
        *
        * @return {number} the index at which an error occurred
        * @since 1.2
        */


        ParsePosition.prototype.getErrorIndex = function () {
          return this.errorIndex;
        };
        /**
        * Overrides equals
        * @param {*} obj
        * @return {boolean}
        */


        ParsePosition.prototype.equals = function (obj) {
          if (obj == null) return false;
          if (!(obj != null && obj instanceof java.text.ParsePosition)) return false;
          var other = obj;
          return this.index === other.index && this.errorIndex === other.errorIndex;
        };
        /**
        * Returns a hash code for this ParsePosition.
        * @return {number} a hash code value for this object
        */


        ParsePosition.prototype.hashCode = function () {
          return this.errorIndex << 16 | this.index;
        };
        /**
        * Return a string representation of this ParsePosition.
        * @return  {string} a string representation of this object
        */


        ParsePosition.prototype.toString = function () {
          return (
            /* getName */
            function (c) {
              return typeof c === 'string' ? c : c["__class"] ? c["__class"] : c["name"];
            }(this.constructor) + "[index=" + this.index + ",errorIndex=" + this.errorIndex + ']'
          );
        };

        return ParsePosition;
      }();

      text.ParsePosition = ParsePosition;
      ParsePosition["__class"] = "java.text.ParsePosition";
    })(java.text || (java.text = {}));
  })(java || (java = {}));

  (function (javaemul) {
    (function (internal) {
      (function (stream) {
        /**
        * @author Władysław Kargul
        * @param {*} previous
        * @class
        * @extends javaemul.internal.stream.TerminalStreamRow
        */
        var StreamRowEnd =
        /** @class */
        function (_super) {
          __extends(StreamRowEnd, _super);

          function StreamRowEnd(previous) {
            var _this = _super.call(this) || this;

            if (_this.previous === undefined) {
              _this.previous = null;
            }

            _this.previous = previous;
            return _this;
          }

          StreamRowEnd.prototype.chain = function (next) {
            if (this.previous != null) {
              this.previous.chain(next);
            }

            this.previous = next;
            next.chain(this);
          };

          StreamRowEnd.prototype.item = function (a) {
            return true;
          };

          return StreamRowEnd;
        }(javaemul.internal.stream.TerminalStreamRow);

        stream.StreamRowEnd = StreamRowEnd;
        StreamRowEnd["__class"] = "javaemul.internal.stream.StreamRowEnd";
        StreamRowEnd["__interfaces"] = ["javaemul.internal.stream.StreamRow"];
      })(internal.stream || (internal.stream = {}));
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      (function (stream) {
        var StreamRowAllFilter =
        /** @class */
        function (_super) {
          __extends(StreamRowAllFilter, _super);

          function StreamRowAllFilter(predicate) {
            var _this = _super.call(this) || this;

            if (_this.predicate === undefined) {
              _this.predicate = null;
            }

            if (_this.predicateValue === undefined) {
              _this.predicateValue = false;
            }

            if (_this.attempts === undefined) {
              _this.attempts = 0;
            }

            _this.predicate = predicate;
            return _this;
          }

          StreamRowAllFilter.prototype.getPredicateValue = function () {
            return this.attempts === 0 || this.predicateValue;
          };

          StreamRowAllFilter.prototype.item = function (a) {
            ++this.attempts;

            this.predicateValue = function (target) {
              return typeof target === 'function' ? target(a) : target.test(a);
            }(this.predicate) && this.predicateValue;

            return this.predicateValue;
          };

          return StreamRowAllFilter;
        }(javaemul.internal.stream.TerminalStreamRow);

        stream.StreamRowAllFilter = StreamRowAllFilter;
        StreamRowAllFilter["__class"] = "javaemul.internal.stream.StreamRowAllFilter";
        StreamRowAllFilter["__interfaces"] = ["javaemul.internal.stream.StreamRow"];
      })(internal.stream || (internal.stream = {}));
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      (function (stream) {
        var StreamRowOnceFilter =
        /** @class */
        function (_super) {
          __extends(StreamRowOnceFilter, _super);

          function StreamRowOnceFilter(predicate) {
            var _this = _super.call(this) || this;

            if (_this.predicate === undefined) {
              _this.predicate = null;
            }

            if (_this.predicateValue === undefined) {
              _this.predicateValue = false;
            }

            _this.firstMatch = java.util.Optional.empty();
            _this.predicate = predicate;
            return _this;
          }

          StreamRowOnceFilter.prototype.getFirstMatch = function () {
            return this.firstMatch;
          };

          StreamRowOnceFilter.prototype.getPredicateValue = function () {
            return this.predicateValue;
          };

          StreamRowOnceFilter.prototype.item = function (a) {
            this.predicateValue = function (target) {
              return typeof target === 'function' ? target(a) : target.test(a);
            }(this.predicate);

            if (this.predicateValue) {
              this.firstMatch = java.util.Optional.of(a);
            }

            return !this.predicateValue;
          };

          return StreamRowOnceFilter;
        }(javaemul.internal.stream.TerminalStreamRow);

        stream.StreamRowOnceFilter = StreamRowOnceFilter;
        StreamRowOnceFilter["__class"] = "javaemul.internal.stream.StreamRowOnceFilter";
        StreamRowOnceFilter["__interfaces"] = ["javaemul.internal.stream.StreamRow"];
      })(internal.stream || (internal.stream = {}));
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      (function (stream) {
        var StreamRowReduce =
        /** @class */
        function (_super) {
          __extends(StreamRowReduce, _super);

          function StreamRowReduce(result, operator) {
            var _this = _super.call(this) || this;

            if (_this.result === undefined) {
              _this.result = null;
            }

            if (_this.operator === undefined) {
              _this.operator = null;
            }

            _this.result = result;
            _this.operator = operator;
            return _this;
          }

          StreamRowReduce.prototype.getResult = function () {
            return this.result;
          };

          StreamRowReduce.prototype.item = function (a) {
            var _this = this;

            this.result = java.util.Optional.of(this.result.map(function (v) {
              return function (target) {
                return typeof target === 'function' ? target(v, a) : target.apply(v, a);
              }(_this.operator);
            }).orElse(a));
            return true;
          };

          return StreamRowReduce;
        }(javaemul.internal.stream.TerminalStreamRow);

        stream.StreamRowReduce = StreamRowReduce;
        StreamRowReduce["__class"] = "javaemul.internal.stream.StreamRowReduce";
        StreamRowReduce["__interfaces"] = ["javaemul.internal.stream.StreamRow"];
      })(internal.stream || (internal.stream = {}));
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      (function (stream) {
        var StreamRowCount =
        /** @class */
        function (_super) {
          __extends(StreamRowCount, _super);

          function StreamRowCount() {
            var _this = _super.call(this) || this;

            if (_this.count === undefined) {
              _this.count = 0;
            }

            return _this;
          }

          StreamRowCount.prototype.getCount = function () {
            return this.count;
          };

          StreamRowCount.prototype.item = function (a) {
            ++this.count;
            return true;
          };

          return StreamRowCount;
        }(javaemul.internal.stream.TerminalStreamRow);

        stream.StreamRowCount = StreamRowCount;
        StreamRowCount["__class"] = "javaemul.internal.stream.StreamRowCount";
        StreamRowCount["__interfaces"] = ["javaemul.internal.stream.StreamRow"];
      })(internal.stream || (internal.stream = {}));
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      (function (stream) {
        var StreamRowCollector =
        /** @class */
        function (_super) {
          __extends(StreamRowCollector, _super);

          function StreamRowCollector(collection) {
            var _this = _super.call(this) || this;

            if (_this.collection === undefined) {
              _this.collection = null;
            }

            _this.collection = collection;
            return _this;
          }

          StreamRowCollector.prototype.item = function (a) {
            this.collection.add(a);
            return true;
          };

          StreamRowCollector.prototype.end = function () {
            for (var index129 = this.collection.iterator(); index129.hasNext();) {
              var item = index129.next();
              {
                if (!this.next.item(item)) {
                  break;
                }
              }
            }

            this.next.end();
          };

          return StreamRowCollector;
        }(javaemul.internal.stream.TransientStreamRow);

        stream.StreamRowCollector = StreamRowCollector;
        StreamRowCollector["__class"] = "javaemul.internal.stream.StreamRowCollector";
        StreamRowCollector["__interfaces"] = ["javaemul.internal.stream.StreamRow"];
      })(internal.stream || (internal.stream = {}));
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      (function (stream) {
        var StreamRowMap =
        /** @class */
        function (_super) {
          __extends(StreamRowMap, _super);

          function StreamRowMap(map) {
            var _this = _super.call(this) || this;

            if (_this.map === undefined) {
              _this.map = null;
            }

            _this.map = map;
            return _this;
          }

          StreamRowMap.prototype.item = function (a) {
            return this.next.item(function (target) {
              return typeof target === 'function' ? target(a) : target.apply(a);
            }(this.map));
          };

          StreamRowMap.prototype.end = function () {
            this.next.end();
          };

          return StreamRowMap;
        }(javaemul.internal.stream.TransientStreamRow);

        stream.StreamRowMap = StreamRowMap;
        StreamRowMap["__class"] = "javaemul.internal.stream.StreamRowMap";
        StreamRowMap["__interfaces"] = ["javaemul.internal.stream.StreamRow"];
      })(internal.stream || (internal.stream = {}));
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      (function (stream) {
        var StreamRowFilter =
        /** @class */
        function (_super) {
          __extends(StreamRowFilter, _super);

          function StreamRowFilter(predicate) {
            var _this = _super.call(this) || this;

            if (_this.predicate === undefined) {
              _this.predicate = null;
            }

            _this.predicate = predicate;
            return _this;
          }

          StreamRowFilter.prototype.item = function (a) {
            if (function (target) {
              return typeof target === 'function' ? target(a) : target.test(a);
            }(this.predicate)) {
              return this.next.item(a);
            }

            return true;
          };

          StreamRowFilter.prototype.end = function () {
            this.next.end();
          };

          return StreamRowFilter;
        }(javaemul.internal.stream.TransientStreamRow);

        stream.StreamRowFilter = StreamRowFilter;
        StreamRowFilter["__class"] = "javaemul.internal.stream.StreamRowFilter";
        StreamRowFilter["__interfaces"] = ["javaemul.internal.stream.StreamRow"];
      })(internal.stream || (internal.stream = {}));
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      (function (stream) {
        var StreamRowFilterFlop =
        /** @class */
        function (_super) {
          __extends(StreamRowFilterFlop, _super);

          function StreamRowFilterFlop(predicate) {
            var _this = _super.call(this) || this;

            if (_this.predicate === undefined) {
              _this.predicate = null;
            }

            _this.predicate = predicate;
            return _this;
          }

          StreamRowFilterFlop.prototype.item = function (a) {
            var test = function (target) {
              return typeof target === 'function' ? target(a) : target.test(a);
            }(this.predicate);

            if (test) {
              return this.next.item(a);
            }

            return false;
          };

          StreamRowFilterFlop.prototype.end = function () {
            this.next.end();
          };

          return StreamRowFilterFlop;
        }(javaemul.internal.stream.TransientStreamRow);

        stream.StreamRowFilterFlop = StreamRowFilterFlop;
        StreamRowFilterFlop["__class"] = "javaemul.internal.stream.StreamRowFilterFlop";
        StreamRowFilterFlop["__interfaces"] = ["javaemul.internal.stream.StreamRow"];
      })(internal.stream || (internal.stream = {}));
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      (function (stream) {
        var StreamRowFlatMap =
        /** @class */
        function (_super) {
          __extends(StreamRowFlatMap, _super);

          function StreamRowFlatMap(flatMap) {
            var _this = _super.call(this) || this;

            if (_this.flatMap === undefined) {
              _this.flatMap = null;
            }

            _this.flatMap = flatMap;
            return _this;
          }

          StreamRowFlatMap.prototype.item = function (a) {
            var _this = this;

            var subStream = function (target) {
              return typeof target === 'function' ? target(a) : target.apply(a);
            }(this.flatMap);

            try {
              try {
                subStream.forEach(function (o) {
                  if (!_this.next.item(o)) {
                    throw new javaemul.internal.stream.StopException();
                  }
                });
              } catch (e) {
                return false;
              }

              ;
            } finally {
              subStream.close();
            }

            return true;
          };

          StreamRowFlatMap.prototype.end = function () {
            this.next.end();
          };

          return StreamRowFlatMap;
        }(javaemul.internal.stream.TransientStreamRow);

        stream.StreamRowFlatMap = StreamRowFlatMap;
        StreamRowFlatMap["__class"] = "javaemul.internal.stream.StreamRowFlatMap";
        StreamRowFlatMap["__interfaces"] = ["javaemul.internal.stream.StreamRow"];
      })(internal.stream || (internal.stream = {}));
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      /**
      * Wraps a primitive <code>double</code> as an object.
      * @param {number} value
      * @class
      * @extends javaemul.internal.NumberHelper
      */
      var DoubleHelper =
      /** @class */
      function (_super) {
        __extends(DoubleHelper, _super);

        function DoubleHelper(s) {
          var _this = this;

          if (typeof s === 'string' || s === null) {
            var __args = arguments;
            _this = _super.call(this) || this;
          } else if (typeof s === 'number' || s === null) {
            var __args = arguments;
            __args[0];
            _this = _super.call(this) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        DoubleHelper.compare = function (x, y) {
          if (x < y) {
            return -1;
          }

          if (x > y) {
            return 1;
          }

          if (x === y) {
            return 0;
          }

          if (DoubleHelper.isNaN(x)) {
            if (DoubleHelper.isNaN(y)) {
              return 0;
            } else {
              return 1;
            }
          } else {
            return -1;
          }
        };

        DoubleHelper.doubleToLongBits = function (value) {
          if (DoubleHelper.isNaN(value)) {
            return 9221120237041090560;
          }

          var negative = false;

          if (value === 0.0) {
            if (1.0 / value === DoubleHelper.NEGATIVE_INFINITY) {
              return -9223372036854775808;
            } else {
              return 0;
            }
          }

          if (value < 0.0) {
            negative = true;
            value = -value;
          }

          if (DoubleHelper.isInfinite(value)) {
            if (negative) {
              return -4503599627370496;
            } else {
              return 9218868437227405312;
            }
          }

          var exp = 0;

          if (value < 1.0) {
            var bit = 512;

            for (var i = 0; i < 10; i++, bit >>= 1) {
              {
                if (value < DoubleHelper.PowersTable.invPowers_$LI$()[i] && exp - bit >= -1023) {
                  value *= DoubleHelper.PowersTable.powers_$LI$()[i];
                  exp -= bit;
                }
              }
            }

            if (value < 1.0 && exp - 1 >= -1023) {
              value *= 2.0;
              exp--;
            }
          } else if (value >= 2.0) {
            var bit = 512;

            for (var i = 0; i < 10; i++, bit >>= 1) {
              {
                if (value >= DoubleHelper.PowersTable.powers_$LI$()[i]) {
                  value *= DoubleHelper.PowersTable.invPowers_$LI$()[i];
                  exp += bit;
                }
              }
            }
          }

          if (exp > -1023) {
            value -= 1.0;
          } else {
            value *= 0.5;
          }

          var ihi = function (n) {
            return n < 0 ? Math.ceil(n) : Math.floor(n);
          }(value * DoubleHelper.POWER_20);

          value -= ihi * DoubleHelper.POWER_MINUS_20;

          var ilo = function (n) {
            return n < 0 ? Math.ceil(n) : Math.floor(n);
          }(value * DoubleHelper.POWER_52);

          ihi |= exp + 1023 << 20;

          if (negative) {
            ihi |= 2147483648;
          }

          return ihi << 32 | ilo;
        };
        /**
        * @skip Here for shared implementation with Arrays.hashCode
        * @param {number} d
        * @return {number}
        */


        DoubleHelper.hashCode = function (d) {
          return d | 0;
        };

        DoubleHelper.isInfinite = function (x) {
          return x === javaemul.internal.JsUtils.getInfinity() || x === -javaemul.internal.JsUtils.getInfinity();
        };

        DoubleHelper.isNaN = function (x) {
          return isNaN(x);
        };

        DoubleHelper.longBitsToDouble = function (bits) {
          var ihi = function (n) {
            return n < 0 ? Math.ceil(n) : Math.floor(n);
          }(bits >> 32);

          var ilo = function (n) {
            return n < 0 ? Math.ceil(n) : Math.floor(n);
          }(bits & 4294967295);

          if (ihi < 0) {
            ihi += 4294967296;
          }

          if (ilo < 0) {
            ilo += 4294967296;
          }

          var negative = (ihi & -2147483648) !== 0;
          var exp = ihi >> 20 & 2047 | 0;
          ihi &= 1048575;

          if (exp === 0) {
            var d_1 = ihi * DoubleHelper.POWER_MINUS_20 + ilo * DoubleHelper.POWER_MINUS_52;
            d_1 *= DoubleHelper.POWER_MINUS_1022;
            return negative ? d_1 === 0.0 ? -0.0 : -d_1 : d_1;
          } else if (exp === 2047) {
            if (ihi === 0 && ilo === 0) {
              return negative ? DoubleHelper.NEGATIVE_INFINITY : DoubleHelper.POSITIVE_INFINITY;
            } else {
              return DoubleHelper.NaN;
            }
          }

          exp -= 1023;
          var d = 1.0 + ihi * DoubleHelper.POWER_MINUS_20 + ilo * DoubleHelper.POWER_MINUS_52;

          if (exp > 0) {
            var bit = 512;

            for (var i = 0; i < 10; i++, bit >>= 1) {
              {
                if (exp >= bit) {
                  d *= DoubleHelper.PowersTable.powers_$LI$()[i];
                  exp -= bit;
                }
              }
            }
          } else if (exp < 0) {
            while (exp < 0) {
              {
                var bit = 512;

                for (var i = 0; i < 10; i++, bit >>= 1) {
                  {
                    if (exp <= -bit) {
                      d *= DoubleHelper.PowersTable.invPowers_$LI$()[i];
                      exp += bit;
                    }
                  }
                }
              }
            }
          }

          return negative ? -d : d;
        };

        DoubleHelper.parseDouble = function (s) {
          return internal.NumberHelper.__parseAndValidateDouble(s);
        };

        DoubleHelper.toString = function (b) {
          return (
            /* valueOf */
            new String(b).toString()
          );
        };

        DoubleHelper.valueOf$double = function (d) {
          return new Number(d);
        };

        DoubleHelper.valueOf$java_lang_String = function (s) {
          return new Number(s);
        };

        DoubleHelper.valueOf = function (s) {
          if (typeof s === 'string' || s === null) {
            return javaemul.internal.DoubleHelper.valueOf$java_lang_String(s);
          } else if (typeof s === 'number' || s === null) {
            return javaemul.internal.DoubleHelper.valueOf$double(s);
          } else throw new Error('invalid overload');
        };
        /**
        *
        * @return {number}
        */


        DoubleHelper.prototype.byteValue = function () {
          return this.doubleValue() | 0;
        };

        DoubleHelper.prototype.compareTo$javaemul_internal_DoubleHelper = function (b) {
          return DoubleHelper.compare(this.doubleValue(), b.doubleValue());
        };
        /**
        *
        * @param {javaemul.internal.DoubleHelper} b
        * @return {number}
        */


        DoubleHelper.prototype.compareTo = function (b) {
          if (b != null && b instanceof javaemul.internal.DoubleHelper || b === null) {
            return this.compareTo$javaemul_internal_DoubleHelper(b);
          } else throw new Error('invalid overload');
        };
        /**
        *
        * @return {number}
        */


        DoubleHelper.prototype.doubleValue = function () {
          return DoubleHelper.unsafeCast(javaemul.internal.InternalPreconditions.checkNotNull(this));
        };

        DoubleHelper.unsafeCast = function (instance) {
          return instance;
        };
        /**
        *
        * @param {*} o
        * @return {boolean}
        */


        DoubleHelper.prototype.equals = function (o) {
          return javaemul.internal.InternalPreconditions.checkNotNull(this) === o;
        };
        /**
        *
        * @return {number}
        */


        DoubleHelper.prototype.floatValue = function () {
          return this.doubleValue();
        };
        /**
        * Performance caution: using Double objects as map keys is not recommended.
        * Using double values as keys is generally a bad idea due to difficulty
        * determining exact equality. In addition, there is no efficient JavaScript
        * equivalent of <code>doubleToIntBits</code>. As a result, this method
        * computes a hash code by truncating the whole number portion of the
        * double, which may lead to poor performance for certain value sets if
        * Doubles are used as keys in a {@link java.util.HashMap}.
        * @return {number}
        */


        DoubleHelper.prototype.hashCode = function () {
          return DoubleHelper.hashCode(this.doubleValue());
        };
        /**
        *
        * @return {number}
        */


        DoubleHelper.prototype.intValue = function () {
          return this.doubleValue() | 0;
        };

        DoubleHelper.prototype.isInfinite = function () {
          return DoubleHelper.isInfinite(this.doubleValue());
        };

        DoubleHelper.prototype.isNaN = function () {
          return DoubleHelper.isNaN(this.doubleValue());
        };
        /**
        *
        * @return {number}
        */


        DoubleHelper.prototype.longValue = function () {
          return function (n) {
            return n < 0 ? Math.ceil(n) : Math.floor(n);
          }(this.doubleValue());
        };
        /**
        *
        * @return {number}
        */


        DoubleHelper.prototype.shortValue = function () {
          return this.doubleValue() | 0;
        };
        /**
        *
        * @return {string}
        */


        DoubleHelper.prototype.toString = function () {
          return DoubleHelper.toString(this.doubleValue());
        };

        DoubleHelper.MAX_VALUE = 1.7976931348623157E308;
        DoubleHelper.MIN_VALUE = 4.9E-324;
        DoubleHelper.MIN_NORMAL = 2.2250738585072014E-308;
        DoubleHelper.MAX_EXPONENT = 1023;
        DoubleHelper.MIN_EXPONENT = -1022;
        DoubleHelper.NaN = 0.0 / 0.0;
        DoubleHelper.NEGATIVE_INFINITY = -1.0 / 0.0;
        DoubleHelper.POSITIVE_INFINITY = 1.0 / 0.0;
        DoubleHelper.SIZE = 64;
        DoubleHelper.POWER_512 = 1.3407807929942597E154;
        DoubleHelper.POWER_MINUS_512 = 7.458340731200207E-155;
        DoubleHelper.POWER_256 = 1.157920892373162E77;
        DoubleHelper.POWER_MINUS_256 = 8.636168555094445E-78;
        DoubleHelper.POWER_128 = 3.4028236692093846E38;
        DoubleHelper.POWER_MINUS_128 = 2.9387358770557188E-39;
        DoubleHelper.POWER_64 = 1.8446744073709552E19;
        DoubleHelper.POWER_MINUS_64 = 5.421010862427522E-20;
        DoubleHelper.POWER_52 = 4.503599627370496E15;
        DoubleHelper.POWER_MINUS_52 = 2.220446049250313E-16;
        DoubleHelper.POWER_32 = 4.294967296E9;
        DoubleHelper.POWER_MINUS_32 = 2.3283064365386963E-10;
        DoubleHelper.POWER_31 = 2.147483648E9;
        DoubleHelper.POWER_20 = 1048576.0;
        DoubleHelper.POWER_MINUS_20 = 9.5367431640625E-7;
        DoubleHelper.POWER_16 = 65536.0;
        DoubleHelper.POWER_MINUS_16 = 1.52587890625E-5;
        DoubleHelper.POWER_8 = 256.0;
        DoubleHelper.POWER_MINUS_8 = 0.00390625;
        DoubleHelper.POWER_4 = 16.0;
        DoubleHelper.POWER_MINUS_4 = 0.0625;
        DoubleHelper.POWER_2 = 4.0;
        DoubleHelper.POWER_MINUS_2 = 0.25;
        DoubleHelper.POWER_1 = 2.0;
        DoubleHelper.POWER_MINUS_1 = 0.5;
        DoubleHelper.POWER_MINUS_1022 = 2.2250738585072014E-308;
        return DoubleHelper;
      }(javaemul.internal.NumberHelper);

      internal.DoubleHelper = DoubleHelper;
      DoubleHelper["__class"] = "javaemul.internal.DoubleHelper";
      DoubleHelper["__interfaces"] = ["java.lang.Comparable", "java.io.Serializable"];

      (function (DoubleHelper) {
        var PowersTable =
        /** @class */
        function () {
          function PowersTable() {}

          PowersTable.powers_$LI$ = function () {
            if (PowersTable.powers == null) {
              PowersTable.powers = [javaemul.internal.DoubleHelper.POWER_512, javaemul.internal.DoubleHelper.POWER_256, javaemul.internal.DoubleHelper.POWER_128, javaemul.internal.DoubleHelper.POWER_64, javaemul.internal.DoubleHelper.POWER_32, javaemul.internal.DoubleHelper.POWER_16, javaemul.internal.DoubleHelper.POWER_8, javaemul.internal.DoubleHelper.POWER_4, javaemul.internal.DoubleHelper.POWER_2, javaemul.internal.DoubleHelper.POWER_1];
            }

            return PowersTable.powers;
          };

          PowersTable.invPowers_$LI$ = function () {
            if (PowersTable.invPowers == null) {
              PowersTable.invPowers = [javaemul.internal.DoubleHelper.POWER_MINUS_512, javaemul.internal.DoubleHelper.POWER_MINUS_256, javaemul.internal.DoubleHelper.POWER_MINUS_128, javaemul.internal.DoubleHelper.POWER_MINUS_64, javaemul.internal.DoubleHelper.POWER_MINUS_32, javaemul.internal.DoubleHelper.POWER_MINUS_16, javaemul.internal.DoubleHelper.POWER_MINUS_8, javaemul.internal.DoubleHelper.POWER_MINUS_4, javaemul.internal.DoubleHelper.POWER_MINUS_2, javaemul.internal.DoubleHelper.POWER_MINUS_1];
            }

            return PowersTable.invPowers;
          };

          return PowersTable;
        }();

        DoubleHelper.PowersTable = PowersTable;
        PowersTable["__class"] = "javaemul.internal.DoubleHelper.PowersTable";
      })(DoubleHelper = internal.DoubleHelper || (internal.DoubleHelper = {}));
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      /**
      * Wraps a primitive <code>short</code> as an object.
      * @param {number} value
      * @class
      * @extends javaemul.internal.NumberHelper
      */
      var ShortHelper =
      /** @class */
      function (_super) {
        __extends(ShortHelper, _super);

        function ShortHelper(s) {
          var _this = this;

          if (typeof s === 'string' || s === null) {
            var __args = arguments;
            _this = _super.call(this) || this;

            if (_this.value === undefined) {
              _this.value = 0;
            }

            _this.value = ShortHelper.parseShort(s);
          } else if (typeof s === 'number' || s === null) {
            var __args = arguments;
            var value = __args[0];
            _this = _super.call(this) || this;

            if (_this.value === undefined) {
              _this.value = 0;
            }

            _this.value = value;
          } else throw new Error('invalid overload');

          return _this;
        }

        ShortHelper.MIN_VALUE_$LI$ = function () {
          if (ShortHelper.MIN_VALUE == null) {
            ShortHelper.MIN_VALUE = 32768 | 0;
          }

          return ShortHelper.MIN_VALUE;
        };

        ShortHelper.MAX_VALUE_$LI$ = function () {
          if (ShortHelper.MAX_VALUE == null) {
            ShortHelper.MAX_VALUE = 32767 | 0;
          }

          return ShortHelper.MAX_VALUE;
        };

        ShortHelper.TYPE_$LI$ = function () {
          if (ShortHelper.TYPE == null) {
            ShortHelper.TYPE = Number;
          }

          return ShortHelper.TYPE;
        };

        ShortHelper.compare = function (x, y) {
          return x - y;
        };

        ShortHelper.decode = function (s) {
          return ShortHelper.valueOf$short(internal.NumberHelper.__decodeAndValidateInt(s, ShortHelper.MIN_VALUE_$LI$(), ShortHelper.MAX_VALUE_$LI$()) | 0);
        };
        /**
        * @skip Here for shared implementation with Arrays.hashCode
        * @param {number} s
        * @return {number}
        */


        ShortHelper.hashCode = function (s) {
          return s;
        };

        ShortHelper.parseShort = function (s, radix) {
          if (radix === void 0) {
            radix = 10;
          }

          return internal.NumberHelper.__parseAndValidateInt(s, radix, ShortHelper.MIN_VALUE_$LI$(), ShortHelper.MAX_VALUE_$LI$()) | 0;
        };

        ShortHelper.reverseBytes = function (s) {
          return (s & 255) << 8 | (s & 65280) >> 8 | 0;
        };

        ShortHelper.toString = function (b) {
          return (
            /* valueOf */
            new String(b).toString()
          );
        };

        ShortHelper.valueOf$short = function (s) {
          if (s > -129 && s < 128) {
            var rebase = s + 128;
            var result = ShortHelper.BoxedValues.boxedValues_$LI$()[rebase];

            if (result == null) {
              result = ShortHelper.BoxedValues.boxedValues_$LI$()[rebase] = new Number(s);
            }

            return result;
          }

          return new Number(s);
        };

        ShortHelper.valueOf$java_lang_String = function (s) {
          return ShortHelper.valueOf$java_lang_String$int(s, 10);
        };

        ShortHelper.valueOf$java_lang_String$int = function (s, radix) {
          return ShortHelper.valueOf$short(ShortHelper.parseShort(s, radix));
        };

        ShortHelper.valueOf = function (s, radix) {
          if ((typeof s === 'string' || s === null) && (typeof radix === 'number' || radix === null)) {
            return javaemul.internal.ShortHelper.valueOf$java_lang_String$int(s, radix);
          } else if ((typeof s === 'string' || s === null) && radix === undefined) {
            return javaemul.internal.ShortHelper.valueOf$java_lang_String(s);
          } else if ((typeof s === 'number' || s === null) && radix === undefined) {
            return javaemul.internal.ShortHelper.valueOf$short(s);
          } else throw new Error('invalid overload');
        };
        /**
        *
        * @return {number}
        */


        ShortHelper.prototype.byteValue = function () {
          return this.value | 0;
        };

        ShortHelper.prototype.compareTo$javaemul_internal_ShortHelper = function (b) {
          return ShortHelper.compare(this.value, b.value);
        };
        /**
        *
        * @param {javaemul.internal.ShortHelper} b
        * @return {number}
        */


        ShortHelper.prototype.compareTo = function (b) {
          if (b != null && b instanceof javaemul.internal.ShortHelper || b === null) {
            return this.compareTo$javaemul_internal_ShortHelper(b);
          } else throw new Error('invalid overload');
        };
        /**
        *
        * @return {number}
        */


        ShortHelper.prototype.doubleValue = function () {
          return this.value;
        };
        /**
        *
        * @param {*} o
        * @return {boolean}
        */


        ShortHelper.prototype.equals = function (o) {
          return o != null && o instanceof javaemul.internal.ShortHelper && o.value === this.value;
        };
        /**
        *
        * @return {number}
        */


        ShortHelper.prototype.floatValue = function () {
          return this.value;
        };
        /**
        *
        * @return {number}
        */


        ShortHelper.prototype.hashCode = function () {
          return ShortHelper.hashCode(this.value);
        };
        /**
        *
        * @return {number}
        */


        ShortHelper.prototype.intValue = function () {
          return this.value;
        };
        /**
        *
        * @return {number}
        */


        ShortHelper.prototype.longValue = function () {
          return this.value;
        };
        /**
        *
        * @return {number}
        */


        ShortHelper.prototype.shortValue = function () {
          return this.value;
        };
        /**
        *
        * @return {string}
        */


        ShortHelper.prototype.toString = function () {
          return ShortHelper.toString(this.value);
        };

        ShortHelper.SIZE = 16;
        return ShortHelper;
      }(javaemul.internal.NumberHelper);

      internal.ShortHelper = ShortHelper;
      ShortHelper["__class"] = "javaemul.internal.ShortHelper";
      ShortHelper["__interfaces"] = ["java.lang.Comparable", "java.io.Serializable"];

      (function (ShortHelper) {
        /**
        * Use nested class to avoid clinit on outer.
        * @class
        */
        var BoxedValues =
        /** @class */
        function () {
          function BoxedValues() {}

          BoxedValues.boxedValues_$LI$ = function () {
            if (BoxedValues.boxedValues == null) {
              BoxedValues.boxedValues = function (s) {
                var a = [];

                while (s-- > 0) {
                  a.push(null);
                }

                return a;
              }(256);
            }

            return BoxedValues.boxedValues;
          };

          return BoxedValues;
        }();

        ShortHelper.BoxedValues = BoxedValues;
        BoxedValues["__class"] = "javaemul.internal.ShortHelper.BoxedValues";
      })(ShortHelper = internal.ShortHelper || (internal.ShortHelper = {}));
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      /**
      * Wraps native <code>byte</code> as an object.
      * @param {number} value
      * @class
      * @extends javaemul.internal.NumberHelper
      */
      var ByteHelper =
      /** @class */
      function (_super) {
        __extends(ByteHelper, _super);

        function ByteHelper(s) {
          var _this = this;

          if (typeof s === 'string' || s === null) {
            var __args = arguments;
            _this = _super.call(this) || this;

            if (_this.value === undefined) {
              _this.value = 0;
            }

            _this.value = ByteHelper.parseByte(s);
          } else if (typeof s === 'number' || s === null) {
            var __args = arguments;
            var value = __args[0];
            _this = _super.call(this) || this;

            if (_this.value === undefined) {
              _this.value = 0;
            }

            _this.value = value;
          } else throw new Error('invalid overload');

          return _this;
        }

        ByteHelper.MIN_VALUE_$LI$ = function () {
          if (ByteHelper.MIN_VALUE == null) {
            ByteHelper.MIN_VALUE = 128 | 0;
          }

          return ByteHelper.MIN_VALUE;
        };

        ByteHelper.MAX_VALUE_$LI$ = function () {
          if (ByteHelper.MAX_VALUE == null) {
            ByteHelper.MAX_VALUE = 127 | 0;
          }

          return ByteHelper.MAX_VALUE;
        };

        ByteHelper.TYPE_$LI$ = function () {
          if (ByteHelper.TYPE == null) {
            ByteHelper.TYPE = Number;
          }

          return ByteHelper.TYPE;
        };

        ByteHelper.compare = function (x, y) {
          return x - y;
        };

        ByteHelper.decode = function (s) {
          return ByteHelper.valueOf$byte(internal.NumberHelper.__decodeAndValidateInt(s, ByteHelper.MIN_VALUE_$LI$(), ByteHelper.MAX_VALUE_$LI$()) | 0);
        };
        /**
        * @skip
        *
        * Here for shared implementation with Arrays.hashCode
        * @param {number} b
        * @return {number}
        */


        ByteHelper.hashCode = function (b) {
          return b;
        };

        ByteHelper.parseByte = function (s, radix) {
          if (radix === void 0) {
            radix = 10;
          }

          return internal.NumberHelper.__parseAndValidateInt(s, radix, ByteHelper.MIN_VALUE_$LI$(), ByteHelper.MAX_VALUE_$LI$()) | 0;
        };

        ByteHelper.toString = function (b) {
          return (
            /* valueOf */
            new String(b).toString()
          );
        };

        ByteHelper.valueOf$byte = function (b) {
          var rebase = b + 128;
          var result = ByteHelper.BoxedValues.boxedValues_$LI$()[rebase];

          if (result == null) {
            result = ByteHelper.BoxedValues.boxedValues_$LI$()[rebase] = new Number(b);
          }

          return result;
        };

        ByteHelper.valueOf$java_lang_String = function (s) {
          return ByteHelper.valueOf$java_lang_String$int(s, 10);
        };

        ByteHelper.valueOf$java_lang_String$int = function (s, radix) {
          return javaemul.internal.ByteHelper.valueOf(ByteHelper.parseByte(s, radix));
        };

        ByteHelper.valueOf = function (s, radix) {
          if ((typeof s === 'string' || s === null) && (typeof radix === 'number' || radix === null)) {
            return javaemul.internal.ByteHelper.valueOf$java_lang_String$int(s, radix);
          } else if ((typeof s === 'string' || s === null) && radix === undefined) {
            return javaemul.internal.ByteHelper.valueOf$java_lang_String(s);
          } else if ((typeof s === 'number' || s === null) && radix === undefined) {
            return javaemul.internal.ByteHelper.valueOf$byte(s);
          } else throw new Error('invalid overload');
        };
        /**
        *
        * @return {number}
        */


        ByteHelper.prototype.byteValue = function () {
          return this.value;
        };

        ByteHelper.prototype.compareTo$javaemul_internal_ByteHelper = function (b) {
          return ByteHelper.compare(this.value, b.value);
        };
        /**
        *
        * @param {javaemul.internal.ByteHelper} b
        * @return {number}
        */


        ByteHelper.prototype.compareTo = function (b) {
          if (b != null && b instanceof javaemul.internal.ByteHelper || b === null) {
            return this.compareTo$javaemul_internal_ByteHelper(b);
          } else throw new Error('invalid overload');
        };
        /**
        *
        * @return {number}
        */


        ByteHelper.prototype.doubleValue = function () {
          return this.value;
        };
        /**
        *
        * @param {*} o
        * @return {boolean}
        */


        ByteHelper.prototype.equals = function (o) {
          return o != null && o instanceof javaemul.internal.ByteHelper && o.value === this.value;
        };
        /**
        *
        * @return {number}
        */


        ByteHelper.prototype.floatValue = function () {
          return this.value;
        };
        /**
        *
        * @return {number}
        */


        ByteHelper.prototype.hashCode = function () {
          return ByteHelper.hashCode(this.value);
        };
        /**
        *
        * @return {number}
        */


        ByteHelper.prototype.intValue = function () {
          return this.value;
        };
        /**
        *
        * @return {number}
        */


        ByteHelper.prototype.longValue = function () {
          return this.value;
        };
        /**
        *
        * @return {number}
        */


        ByteHelper.prototype.shortValue = function () {
          return this.value;
        };
        /**
        *
        * @return {string}
        */


        ByteHelper.prototype.toString = function () {
          return ByteHelper.toString(this.value);
        };

        ByteHelper.SIZE = 8;
        return ByteHelper;
      }(javaemul.internal.NumberHelper);

      internal.ByteHelper = ByteHelper;
      ByteHelper["__class"] = "javaemul.internal.ByteHelper";
      ByteHelper["__interfaces"] = ["java.lang.Comparable", "java.io.Serializable"];

      (function (ByteHelper) {
        /**
        * Use nested class to avoid clinit on outer.
        * @class
        */
        var BoxedValues =
        /** @class */
        function () {
          function BoxedValues() {}

          BoxedValues.boxedValues_$LI$ = function () {
            if (BoxedValues.boxedValues == null) {
              BoxedValues.boxedValues = function (s) {
                var a = [];

                while (s-- > 0) {
                  a.push(null);
                }

                return a;
              }(256);
            }

            return BoxedValues.boxedValues;
          };

          return BoxedValues;
        }();

        ByteHelper.BoxedValues = BoxedValues;
        BoxedValues["__class"] = "javaemul.internal.ByteHelper.BoxedValues";
      })(ByteHelper = internal.ByteHelper || (internal.ByteHelper = {}));
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      /**
      * Wraps a primitive <code>float</code> as an object.
      * @param {number} value
      * @class
      * @extends javaemul.internal.NumberHelper
      */
      var FloatHelper =
      /** @class */
      function (_super) {
        __extends(FloatHelper, _super);

        function FloatHelper(s) {
          var _this = this;

          if (typeof s === 'string' || s === null) {
            var __args = arguments;
            _this = _super.call(this) || this;

            if (_this.value === undefined) {
              _this.value = 0;
            }

            _this.value = FloatHelper.parseFloat(s);
          } else if (typeof s === 'number' || s === null) {
            var __args = arguments;
            var value = __args[0];
            _this = _super.call(this) || this;

            if (_this.value === undefined) {
              _this.value = 0;
            }

            _this.value = value;
          } else if (typeof s === 'number' || s === null) {
            var __args = arguments;
            var value = __args[0];
            _this = _super.call(this) || this;

            if (_this.value === undefined) {
              _this.value = 0;
            }

            _this.value = value;
          } else throw new Error('invalid overload');

          return _this;
        }

        FloatHelper.compare = function (x, y) {
          return javaemul.internal.DoubleHelper.compare(x, y);
        };

        FloatHelper.floatToIntBits = function (value) {
          if (FloatHelper.isNaN(value)) {
            return 2143289344;
          }

          if (value === 0.0) {
            if (1.0 / value === FloatHelper.NEGATIVE_INFINITY) {
              return -2147483648;
            } else {
              return 0;
            }
          }

          var negative = false;

          if (value < 0.0) {
            negative = true;
            value = -value;
          }

          if (FloatHelper.isInfinite(value)) {
            if (negative) {
              return -8388608;
            } else {
              return 2139095040;
            }
          }

          var l = javaemul.internal.DoubleHelper.doubleToLongBits(value);
          var exp = (l >> 52 & 2047) - 1023 | 0;
          var mantissa = (l & 4503599627370495) >> 29 | 0;

          if (exp <= -127) {
            mantissa = (8388608 | mantissa) >> -127 - exp + 1;
            exp = -127;
          }

          var bits = negative ? FloatHelper.POWER_31_INT : 0;
          bits |= exp + 127 << 23;
          bits |= mantissa;
          return bits | 0;
        };
        /**
        * @skip Here for shared implementation with Arrays.hashCode.
        * @param {number} f
        * @return {number} hash value of float (currently just truncated to int)
        */


        FloatHelper.hashCode = function (f) {
          return f | 0;
        };

        FloatHelper.intBitsToFloat = function (bits) {
          var negative = (bits & -2147483648) !== 0;
          var exp = bits >> 23 & 255;
          bits &= 8388607;

          if (exp === 0) {
            if (bits === 0) {
              return negative ? -0.0 : 0.0;
            }
          } else if (exp === 255) {
            if (bits === 0) {
              return negative ? FloatHelper.NEGATIVE_INFINITY : FloatHelper.POSITIVE_INFINITY;
            } else {
              return FloatHelper.NaN;
            }
          }

          if (exp === 0) {
            exp = 1;

            while ((bits & 8388608) === 0) {
              {
                bits <<= 1;
                exp--;
              }
            }

            bits &= 8388607;
          }

          var bits64 = negative ? -9223372036854775808 : 0;

          bits64 |= function (n) {
            return n < 0 ? Math.ceil(n) : Math.floor(n);
          }(exp + 896) << 52;

          bits64 |= function (n) {
            return n < 0 ? Math.ceil(n) : Math.floor(n);
          }(bits) << 29;

          return javaemul.internal.DoubleHelper.longBitsToDouble(bits64);
        };

        FloatHelper.isInfinite = function (x) {
          return javaemul.internal.DoubleHelper.isInfinite(x);
        };

        FloatHelper.isNaN = function (x) {
          return javaemul.internal.DoubleHelper.isNaN(x);
        };

        FloatHelper.parseFloat = function (s) {
          var doubleValue = internal.NumberHelper.__parseAndValidateDouble(s);

          if (doubleValue > FloatHelper.MAX_VALUE) {
            return FloatHelper.POSITIVE_INFINITY;
          } else if (doubleValue < -FloatHelper.MAX_VALUE) {
            return FloatHelper.NEGATIVE_INFINITY;
          }

          return doubleValue;
        };

        FloatHelper.toString = function (b) {
          return (
            /* valueOf */
            new String(b).toString()
          );
        };

        FloatHelper.valueOf$float = function (f) {
          return new Number(f);
        };

        FloatHelper.valueOf$java_lang_String = function (s) {
          return new Number(s);
        };

        FloatHelper.valueOf = function (s) {
          if (typeof s === 'string' || s === null) {
            return javaemul.internal.FloatHelper.valueOf$java_lang_String(s);
          } else if (typeof s === 'number' || s === null) {
            return javaemul.internal.FloatHelper.valueOf$float(s);
          } else throw new Error('invalid overload');
        };
        /**
        *
        * @return {number}
        */


        FloatHelper.prototype.byteValue = function () {
          return this.value | 0;
        };

        FloatHelper.prototype.compareTo$javaemul_internal_FloatHelper = function (b) {
          return FloatHelper.compare(this.value, b.value);
        };
        /**
        *
        * @param {javaemul.internal.FloatHelper} b
        * @return {number}
        */


        FloatHelper.prototype.compareTo = function (b) {
          if (b != null && b instanceof javaemul.internal.FloatHelper || b === null) {
            return this.compareTo$javaemul_internal_FloatHelper(b);
          } else throw new Error('invalid overload');
        };
        /**
        *
        * @return {number}
        */


        FloatHelper.prototype.doubleValue = function () {
          return this.value;
        };
        /**
        *
        * @param {*} o
        * @return {boolean}
        */


        FloatHelper.prototype.equals = function (o) {
          return o != null && o instanceof javaemul.internal.FloatHelper && o.value === this.value;
        };
        /**
        *
        * @return {number}
        */


        FloatHelper.prototype.floatValue = function () {
          return this.value;
        };
        /**
        * Performance caution: using Float objects as map keys is not recommended.
        * Using floating point values as keys is generally a bad idea due to
        * difficulty determining exact equality. In addition, there is no efficient
        * JavaScript equivalent of <code>floatToIntBits</code>. As a result, this
        * method computes a hash code by truncating the whole number portion of the
        * float, which may lead to poor performance for certain value sets if
        * Floats are used as keys in a {@link java.util.HashMap}.
        * @return {number}
        */


        FloatHelper.prototype.hashCode = function () {
          return FloatHelper.hashCode(this.value);
        };
        /**
        *
        * @return {number}
        */


        FloatHelper.prototype.intValue = function () {
          return this.value | 0;
        };

        FloatHelper.prototype.isInfinite = function () {
          return FloatHelper.isInfinite(this.value);
        };

        FloatHelper.prototype.isNaN = function () {
          return FloatHelper.isNaN(this.value);
        };
        /**
        *
        * @return {number}
        */


        FloatHelper.prototype.longValue = function () {
          return function (n) {
            return n < 0 ? Math.ceil(n) : Math.floor(n);
          }(this.value);
        };
        /**
        *
        * @return {number}
        */


        FloatHelper.prototype.shortValue = function () {
          return this.value | 0;
        };
        /**
        *
        * @return {string}
        */


        FloatHelper.prototype.toString = function () {
          return FloatHelper.toString(this.value);
        };

        FloatHelper.MAX_VALUE = 3.4028235E38;
        FloatHelper.MIN_VALUE = 1.4E-45;
        FloatHelper.MAX_EXPONENT = 127;
        FloatHelper.MIN_EXPONENT = -126;
        FloatHelper.MIN_NORMAL = 1.17549435E-38;
        FloatHelper.NaN = 0.0 / 0.0;
        FloatHelper.NEGATIVE_INFINITY = -1.0 / 0.0;
        FloatHelper.POSITIVE_INFINITY = 1.0 / 0.0;
        FloatHelper.SIZE = 32;
        FloatHelper.POWER_31_INT = 2147483648;
        return FloatHelper;
      }(javaemul.internal.NumberHelper);

      internal.FloatHelper = FloatHelper;
      FloatHelper["__class"] = "javaemul.internal.FloatHelper";
      FloatHelper["__interfaces"] = ["java.lang.Comparable", "java.io.Serializable"];
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      /**
      * Wraps a primitive <code>int</code> as an object.
      * @param {number} value
      * @class
      * @extends javaemul.internal.NumberHelper
      */
      var IntegerHelper =
      /** @class */
      function (_super) {
        __extends(IntegerHelper, _super);

        function IntegerHelper(s) {
          var _this = this;

          if (typeof s === 'string' || s === null) {
            var __args = arguments;
            _this = _super.call(this) || this;

            if (_this.value === undefined) {
              _this.value = 0;
            }

            _this.value = IntegerHelper.parseInt(s);
          } else if (typeof s === 'number' || s === null) {
            var __args = arguments;
            var value = __args[0];
            _this = _super.call(this) || this;

            if (_this.value === undefined) {
              _this.value = 0;
            }

            _this.value = value;
          } else throw new Error('invalid overload');

          return _this;
        }

        IntegerHelper.bitCount = function (x) {
          x -= x >> 1 & 1431655765;
          x = (x >> 2 & 858993459) + (x & 858993459);
          x = (x >> 4) + x & 252645135;
          x += x >> 8;
          x += x >> 16;
          return x & 63;
        };

        IntegerHelper.compare = function (x, y) {
          if (x < y) {
            return -1;
          } else if (x > y) {
            return 1;
          } else {
            return 0;
          }
        };

        IntegerHelper.decode = function (s) {
          return IntegerHelper.valueOf$int(internal.NumberHelper.__decodeAndValidateInt(s, IntegerHelper.MIN_VALUE, IntegerHelper.MAX_VALUE));
        };
        /**
        * @skip
        *
        * Here for shared implementation with Arrays.hashCode
        * @param {number} i
        * @return {number}
        */


        IntegerHelper.hashCode = function (i) {
          return i;
        };

        IntegerHelper.highestOneBit = function (i) {
          if (i < 0) {
            return IntegerHelper.MIN_VALUE;
          } else if (i === 0) {
            return 0;
          } else {
            var rtn = void 0;

            for (rtn = 1073741824; (rtn & i) === 0; rtn >>= 1) {}

            return rtn;
          }
        };

        IntegerHelper.lowestOneBit = function (i) {
          return i & -i;
        };

        IntegerHelper.numberOfLeadingZeros = function (i) {
          if (i < 0) {
            return 0;
          } else if (i === 0) {
            return IntegerHelper.SIZE;
          } else {
            var y = void 0;
            var m = void 0;
            var n = void 0;
            y = -(i >> 16);
            m = y >> 16 & 16;
            n = 16 - m;
            i = i >> m;
            y = i - 256;
            m = y >> 16 & 8;
            n += m;
            i <<= m;
            y = i - 4096;
            m = y >> 16 & 4;
            n += m;
            i <<= m;
            y = i - 16384;
            m = y >> 16 & 2;
            n += m;
            i <<= m;
            y = i >> 14;
            m = y & ~(y >> 1);
            return n + 2 - m;
          }
        };

        IntegerHelper.numberOfTrailingZeros = function (i) {
          if (i === 0) {
            return IntegerHelper.SIZE;
          } else {
            var rtn = 0;

            for (var r = 1; (r & i) === 0; r <<= 1) {
              {
                rtn++;
              }
            }

            return rtn;
          }
        };

        IntegerHelper.parseInt = function (s, radix) {
          if (radix === void 0) {
            radix = 10;
          }

          return internal.NumberHelper.__parseAndValidateInt(s, radix, IntegerHelper.MIN_VALUE, IntegerHelper.MAX_VALUE);
        };

        IntegerHelper.reverse = function (i) {
          var nibbles = IntegerHelper.ReverseNibbles.reverseNibbles_$LI$();
          return nibbles[i >>> 28] | nibbles[i >> 24 & 15] << 4 | nibbles[i >> 20 & 15] << 8 | nibbles[i >> 16 & 15] << 12 | nibbles[i >> 12 & 15] << 16 | nibbles[i >> 8 & 15] << 20 | nibbles[i >> 4 & 15] << 24 | nibbles[i & 15] << 28;
        };

        IntegerHelper.reverseBytes = function (i) {
          return (i & 255) << 24 | (i & 65280) << 8 | (i & 16711680) >> 8 | (i & -16777216) >>> 24;
        };

        IntegerHelper.rotateLeft = function (i, distance) {
          while (distance-- > 0) {
            {
              i = i << 1 | (i < 0 ? 1 : 0);
            }
          }

          return i;
        };

        IntegerHelper.rotateRight = function (i, distance) {
          var ui = i & IntegerHelper.MAX_VALUE;
          var carry = i < 0 ? 1073741824 : 0;

          while (distance-- > 0) {
            {
              var nextcarry = ui & 1;
              ui = carry | ui >> 1;
              carry = nextcarry === 0 ? 0 : 1073741824;
            }
          }

          if (carry !== 0) {
            ui = ui | IntegerHelper.MIN_VALUE;
          }

          return ui;
        };

        IntegerHelper.signum = function (i) {
          if (i === 0) {
            return 0;
          } else if (i < 0) {
            return -1;
          } else {
            return 1;
          }
        };

        IntegerHelper.toBinaryString = function (value) {
          return IntegerHelper.toUnsignedRadixString(value, 2);
        };

        IntegerHelper.toHexString = function (value) {
          return IntegerHelper.toUnsignedRadixString(value, 16);
        };

        IntegerHelper.toOctalString = function (value) {
          return IntegerHelper.toUnsignedRadixString(value, 8);
        };

        IntegerHelper.toString$int = function (value) {
          return (
            /* valueOf */
            new String(value).toString()
          );
        };

        IntegerHelper.toString$int$int = function (value, radix) {
          if (radix === 10 || radix < javaemul.internal.CharacterHelper.MIN_RADIX || radix > javaemul.internal.CharacterHelper.MAX_RADIX) {
            return (
              /* valueOf */
              new String(value).toString()
            );
          }

          return IntegerHelper.toRadixString(value, radix);
        };

        IntegerHelper.toString = function (value, radix) {
          if ((typeof value === 'number' || value === null) && (typeof radix === 'number' || radix === null)) {
            return javaemul.internal.IntegerHelper.toString$int$int(value, radix);
          } else if ((typeof value === 'number' || value === null) && radix === undefined) {
            return javaemul.internal.IntegerHelper.toString$int(value);
          } else throw new Error('invalid overload');
        };

        IntegerHelper.valueOf$int = function (i) {
          if (i > -129 && i < 128) {
            var rebase = i + 128;
            var result = IntegerHelper.BoxedValues.boxedValues_$LI$()[rebase];

            if (result == null) {
              result = IntegerHelper.BoxedValues.boxedValues_$LI$()[rebase] = new Number(i);
            }

            return result;
          }

          return new Number(i);
        };

        IntegerHelper.valueOf$java_lang_String = function (s) {
          return IntegerHelper.valueOf$java_lang_String$int(s, 10);
        };

        IntegerHelper.valueOf$java_lang_String$int = function (s, radix) {
          return IntegerHelper.valueOf$int(IntegerHelper.parseInt(s, radix));
        };

        IntegerHelper.valueOf = function (s, radix) {
          if ((typeof s === 'string' || s === null) && (typeof radix === 'number' || radix === null)) {
            return javaemul.internal.IntegerHelper.valueOf$java_lang_String$int(s, radix);
          } else if ((typeof s === 'string' || s === null) && radix === undefined) {
            return javaemul.internal.IntegerHelper.valueOf$java_lang_String(s);
          } else if ((typeof s === 'number' || s === null) && radix === undefined) {
            return javaemul.internal.IntegerHelper.valueOf$int(s);
          } else throw new Error('invalid overload');
        };

        IntegerHelper.toRadixString = function (value, radix) {
          return value.toString(radix);
        };

        IntegerHelper.toUnsignedRadixString = function (value, radix) {
          return (value >>> 0).toString(radix);
        };
        /**
        *
        * @return {number}
        */


        IntegerHelper.prototype.byteValue = function () {
          return this.value | 0;
        };

        IntegerHelper.prototype.compareTo$javaemul_internal_IntegerHelper = function (b) {
          return IntegerHelper.compare(this.value, b.value);
        };
        /**
        *
        * @param {javaemul.internal.IntegerHelper} b
        * @return {number}
        */


        IntegerHelper.prototype.compareTo = function (b) {
          if (b != null && b instanceof javaemul.internal.IntegerHelper || b === null) {
            return this.compareTo$javaemul_internal_IntegerHelper(b);
          } else throw new Error('invalid overload');
        };
        /**
        *
        * @return {number}
        */


        IntegerHelper.prototype.doubleValue = function () {
          return this.value;
        };
        /**
        *
        * @param {*} o
        * @return {boolean}
        */


        IntegerHelper.prototype.equals = function (o) {
          return o != null && o instanceof javaemul.internal.IntegerHelper && o.value === this.value;
        };
        /**
        *
        * @return {number}
        */


        IntegerHelper.prototype.floatValue = function () {
          return this.value;
        };
        /**
        *
        * @return {number}
        */


        IntegerHelper.prototype.hashCode = function () {
          return IntegerHelper.hashCode(this.value);
        };
        /**
        *
        * @return {number}
        */


        IntegerHelper.prototype.intValue = function () {
          return this.value;
        };
        /**
        *
        * @return {number}
        */


        IntegerHelper.prototype.longValue = function () {
          return this.value;
        };
        /**
        *
        * @return {number}
        */


        IntegerHelper.prototype.shortValue = function () {
          return this.value | 0;
        };
        /**
        *
        * @return {string}
        */


        IntegerHelper.prototype.toString = function () {
          return IntegerHelper.toString$int(this.value);
        };

        IntegerHelper.getInteger = function (nm) {
          return IntegerHelper.decode(java.lang.System.getProperty$java_lang_String(nm));
        };

        IntegerHelper.MAX_VALUE = 2147483647;
        IntegerHelper.MIN_VALUE = -2147483648;
        IntegerHelper.SIZE = 32;
        return IntegerHelper;
      }(javaemul.internal.NumberHelper);

      internal.IntegerHelper = IntegerHelper;
      IntegerHelper["__class"] = "javaemul.internal.IntegerHelper";
      IntegerHelper["__interfaces"] = ["java.lang.Comparable", "java.io.Serializable"];

      (function (IntegerHelper) {
        /**
        * Use nested class to avoid clinit on outer.
        * @class
        */
        var BoxedValues =
        /** @class */
        function () {
          function BoxedValues() {}

          BoxedValues.boxedValues_$LI$ = function () {
            if (BoxedValues.boxedValues == null) {
              BoxedValues.boxedValues = function (s) {
                var a = [];

                while (s-- > 0) {
                  a.push(null);
                }

                return a;
              }(256);
            }

            return BoxedValues.boxedValues;
          };

          return BoxedValues;
        }();

        IntegerHelper.BoxedValues = BoxedValues;
        BoxedValues["__class"] = "javaemul.internal.IntegerHelper.BoxedValues";
        /**
        * Use nested class to avoid clinit on outer.
        * @class
        */

        var ReverseNibbles =
        /** @class */
        function () {
          function ReverseNibbles() {}

          ReverseNibbles.reverseNibbles_$LI$ = function () {
            if (ReverseNibbles.reverseNibbles == null) {
              ReverseNibbles.reverseNibbles = [0, 8, 4, 12, 2, 10, 6, 14, 1, 9, 5, 13, 3, 11, 7, 15];
            }

            return ReverseNibbles.reverseNibbles;
          };

          return ReverseNibbles;
        }();

        IntegerHelper.ReverseNibbles = ReverseNibbles;
        ReverseNibbles["__class"] = "javaemul.internal.IntegerHelper.ReverseNibbles";
      })(IntegerHelper = internal.IntegerHelper || (internal.IntegerHelper = {}));
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      /**
      * Wraps a primitive <code>long</code> as an object.
      * @param {number} value
      * @class
      * @extends javaemul.internal.NumberHelper
      */
      var LongHelper =
      /** @class */
      function (_super) {
        __extends(LongHelper, _super);

        function LongHelper(s) {
          var _this = this;

          if (typeof s === 'string' || s === null) {
            var __args = arguments;
            _this = _super.call(this) || this;

            if (_this.value === undefined) {
              _this.value = 0;
            }

            _this.value = LongHelper.parseLong(s);
          } else if (typeof s === 'number' || s === null) {
            var __args = arguments;
            var value = __args[0];
            _this = _super.call(this) || this;

            if (_this.value === undefined) {
              _this.value = 0;
            }

            _this.value = value;
          } else throw new Error('invalid overload');

          return _this;
        }

        LongHelper.bitCount = function (i) {
          var high = i >> 32 | 0;
          var low = i | 0;
          return javaemul.internal.IntegerHelper.bitCount(high) + javaemul.internal.IntegerHelper.bitCount(low);
        };

        LongHelper.compare = function (x, y) {
          if (x < y) {
            return -1;
          } else if (x > y) {
            return 1;
          } else {
            return 0;
          }
        };

        LongHelper.decode = function (s) {
          var decode = internal.NumberHelper.__decodeNumberString(s);

          return LongHelper.valueOf$java_lang_String$int(decode.payload, decode.radix);
        };
        /**
        * @skip Here for shared implementation with Arrays.hashCode
        * @param {number} l
        * @return {number}
        */


        LongHelper.hashCode = function (l) {
          return l | 0;
        };

        LongHelper.highestOneBit = function (i) {
          var high = i >> 32 | 0;

          if (high !== 0) {
            return function (n) {
              return n < 0 ? Math.ceil(n) : Math.floor(n);
            }(javaemul.internal.IntegerHelper.highestOneBit(high)) << 32;
          } else {
            return javaemul.internal.IntegerHelper.highestOneBit(i | 0) & 4294967295;
          }
        };

        LongHelper.lowestOneBit = function (i) {
          return i & -i;
        };

        LongHelper.numberOfLeadingZeros = function (i) {
          var high = i >> 32 | 0;

          if (high !== 0) {
            return javaemul.internal.IntegerHelper.numberOfLeadingZeros(high);
          } else {
            return javaemul.internal.IntegerHelper.numberOfLeadingZeros(i | 0) + 32;
          }
        };

        LongHelper.numberOfTrailingZeros = function (i) {
          var low = i | 0;

          if (low !== 0) {
            return javaemul.internal.IntegerHelper.numberOfTrailingZeros(low);
          } else {
            return javaemul.internal.IntegerHelper.numberOfTrailingZeros(i >> 32 | 0) + 32;
          }
        };

        LongHelper.parseLong = function (s, radix) {
          if (radix === void 0) {
            radix = 10;
          }

          return internal.NumberHelper.__parseAndValidateLong(s, radix);
        };

        LongHelper.reverse = function (i) {
          var high = i >>> 32 | 0;
          var low = i | 0;
          return function (n) {
            return n < 0 ? Math.ceil(n) : Math.floor(n);
          }(javaemul.internal.IntegerHelper.reverse(low)) << 32 | javaemul.internal.IntegerHelper.reverse(high) & 4294967295;
        };

        LongHelper.reverseBytes = function (i) {
          var high = i >>> 32 | 0;
          var low = i | 0;
          return function (n) {
            return n < 0 ? Math.ceil(n) : Math.floor(n);
          }(javaemul.internal.IntegerHelper.reverseBytes(low)) << 32 | javaemul.internal.IntegerHelper.reverseBytes(high) & 4294967295;
        };

        LongHelper.rotateLeft = function (i, distance) {
          while (distance-- > 0) {
            {
              i = i << 1 | (i < 0 ? 1 : 0);
            }
          }

          return i;
        };

        LongHelper.rotateRight = function (i, distance) {
          var ui = i & LongHelper.MAX_VALUE;
          var carry = i < 0 ? 4611686018427387904 : 0;

          while (distance-- > 0) {
            {
              var nextcarry = ui & 1;
              ui = carry | ui >> 1;
              carry = nextcarry === 0 ? 0 : 4611686018427387904;
            }
          }

          if (carry !== 0) {
            ui = ui | LongHelper.MIN_VALUE;
          }

          return ui;
        };

        LongHelper.signum = function (i) {
          if (i === 0) {
            return 0;
          } else if (i < 0) {
            return -1;
          } else {
            return 1;
          }
        };

        LongHelper.toBinaryString = function (value) {
          return LongHelper.toPowerOfTwoUnsignedString(value, 1);
        };

        LongHelper.toHexString = function (value) {
          return LongHelper.toPowerOfTwoUnsignedString(value, 4);
        };

        LongHelper.toOctalString = function (value) {
          return LongHelper.toPowerOfTwoUnsignedString(value, 3);
        };

        LongHelper.toString$long = function (value) {
          return (
            /* valueOf */
            new String(value).toString()
          );
        };

        LongHelper.toString$long$int = function (value, intRadix) {
          if (intRadix === 10 || intRadix < javaemul.internal.CharacterHelper.MIN_RADIX || intRadix > javaemul.internal.CharacterHelper.MAX_RADIX) {
            return (
              /* valueOf */
              new String(value).toString()
            );
          }

          var intValue = value | 0;

          if (intValue === value) {
            return javaemul.internal.IntegerHelper.toString$int$int(intValue, intRadix);
          }

          var negative = value < 0;

          if (!negative) {
            value = -value;
          }

          var bufLen = intRadix < 8 ? 65 : 23;

          var buf = function (s) {
            var a = [];

            while (s-- > 0) {
              a.push(null);
            }

            return a;
          }(bufLen);

          var cursor = bufLen;
          var radix = intRadix;

          do {
            {
              var q = function (n) {
                return n < 0 ? Math.ceil(n) : Math.floor(n);
              }(value / radix);

              buf[--cursor] = javaemul.internal.CharacterHelper.forDigit$int(radix * q - value | 0);
              value = q;
            }
          } while (value !== 0);

          if (negative) {
            buf[--cursor] = '-';
          }

          return (
            /* valueOf */
            function (str, index, len) {
              return str.join('').substring(index, index + len);
            }(buf, cursor, bufLen - cursor)
          );
        };

        LongHelper.toString = function (value, intRadix) {
          if ((typeof value === 'number' || value === null) && (typeof intRadix === 'number' || intRadix === null)) {
            return javaemul.internal.LongHelper.toString$long$int(value, intRadix);
          } else if ((typeof value === 'number' || value === null) && intRadix === undefined) {
            return javaemul.internal.LongHelper.toString$long(value);
          } else throw new Error('invalid overload');
        };

        LongHelper.valueOf$long = function (i) {
          if (i > -129 && i < 128) {
            var rebase = (i | 0) + 128;
            var result = LongHelper.BoxedValues.boxedValues_$LI$()[rebase];

            if (result == null) {
              result = LongHelper.BoxedValues.boxedValues_$LI$()[rebase] = new Number(i);
            }

            return result;
          }

          return new Number(i);
        };

        LongHelper.valueOf$java_lang_String = function (s) {
          return LongHelper.valueOf$java_lang_String$int(s, 10);
        };

        LongHelper.valueOf$java_lang_String$int = function (s, radix) {
          return LongHelper.valueOf$long(LongHelper.parseLong(s, radix));
        };

        LongHelper.valueOf = function (s, radix) {
          if ((typeof s === 'string' || s === null) && (typeof radix === 'number' || radix === null)) {
            return javaemul.internal.LongHelper.valueOf$java_lang_String$int(s, radix);
          } else if ((typeof s === 'string' || s === null) && radix === undefined) {
            return javaemul.internal.LongHelper.valueOf$java_lang_String(s);
          } else if ((typeof s === 'number' || s === null) && radix === undefined) {
            return javaemul.internal.LongHelper.valueOf$long(s);
          } else throw new Error('invalid overload');
        };

        LongHelper.toPowerOfTwoUnsignedString = function (value, shift) {
          var radix = 1 << shift;

          if (javaemul.internal.IntegerHelper.MIN_VALUE <= value && value <= javaemul.internal.IntegerHelper.MAX_VALUE) {
            return javaemul.internal.IntegerHelper.toString$int$int(value | 0, radix);
          }

          var mask = radix - 1;
          var bufSize = (64 / shift | 0) + 1;

          var buf = function (s) {
            var a = [];

            while (s-- > 0) {
              a.push(null);
            }

            return a;
          }(bufSize);

          var pos = bufSize;

          do {
            {
              buf[--pos] = javaemul.internal.CharacterHelper.forDigit$int((value | 0) & mask);
              value >>>= shift;
            }
          } while (value !== 0);

          return (
            /* valueOf */
            function (str, index, len) {
              return str.join('').substring(index, index + len);
            }(buf, pos, bufSize - pos)
          );
        };
        /**
        *
        * @return {number}
        */


        LongHelper.prototype.byteValue = function () {
          return this.value | 0;
        };

        LongHelper.prototype.compareTo$javaemul_internal_LongHelper = function (b) {
          return LongHelper.compare(this.value, b.value);
        };
        /**
        *
        * @param {javaemul.internal.LongHelper} b
        * @return {number}
        */


        LongHelper.prototype.compareTo = function (b) {
          if (b != null && b instanceof javaemul.internal.LongHelper || b === null) {
            return this.compareTo$javaemul_internal_LongHelper(b);
          } else throw new Error('invalid overload');
        };
        /**
        *
        * @return {number}
        */


        LongHelper.prototype.doubleValue = function () {
          return this.value;
        };
        /**
        *
        * @param {*} o
        * @return {boolean}
        */


        LongHelper.prototype.equals = function (o) {
          return o != null && o instanceof javaemul.internal.LongHelper && o.value === this.value;
        };
        /**
        *
        * @return {number}
        */


        LongHelper.prototype.floatValue = function () {
          return this.value;
        };
        /**
        *
        * @return {number}
        */


        LongHelper.prototype.hashCode = function () {
          return LongHelper.hashCode(this.value);
        };
        /**
        *
        * @return {number}
        */


        LongHelper.prototype.intValue = function () {
          return this.value | 0;
        };
        /**
        *
        * @return {number}
        */


        LongHelper.prototype.longValue = function () {
          return this.value;
        };
        /**
        *
        * @return {number}
        */


        LongHelper.prototype.shortValue = function () {
          return this.value | 0;
        };
        /**
        *
        * @return {string}
        */


        LongHelper.prototype.toString = function () {
          return LongHelper.toString$long(this.value);
        };

        LongHelper.MAX_VALUE = 9223372036854775807;
        LongHelper.MIN_VALUE = -9223372036854775808;
        LongHelper.SIZE = 64;
        return LongHelper;
      }(javaemul.internal.NumberHelper);

      internal.LongHelper = LongHelper;
      LongHelper["__class"] = "javaemul.internal.LongHelper";
      LongHelper["__interfaces"] = ["java.lang.Comparable", "java.io.Serializable"];

      (function (LongHelper) {
        /**
        * Use nested class to avoid clinit on outer.
        * @class
        */
        var BoxedValues =
        /** @class */
        function () {
          function BoxedValues() {}

          BoxedValues.boxedValues_$LI$ = function () {
            if (BoxedValues.boxedValues == null) {
              BoxedValues.boxedValues = function (s) {
                var a = [];

                while (s-- > 0) {
                  a.push(null);
                }

                return a;
              }(256);
            }

            return BoxedValues.boxedValues;
          };

          return BoxedValues;
        }();

        LongHelper.BoxedValues = BoxedValues;
        BoxedValues["__class"] = "javaemul.internal.LongHelper.BoxedValues";
      })(LongHelper = internal.LongHelper || (internal.LongHelper = {}));
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (java) {
    (function (util) {
      var Scanner =
      /** @class */
      function () {
        function Scanner(string) {
          if (typeof string === 'string' || string === null) {
            var __args = arguments;
            {
              var reader = new java.io.StringReader(string);

              if (this.reader === undefined) {
                this.reader = null;
              }

              if (this.matcher === undefined) {
                this.matcher = null;
              }

              if (this.nextDelimiterWithPattern === undefined) {
                this.nextDelimiterWithPattern = null;
              }

              this.currentDelimiter = Scanner.whiteSpacePattern_$LI$();

              this.buf = function (s) {
                var a = [];

                while (s-- > 0) {
                  a.push(null);
                }

                return a;
              }(1024);

              this.bufferFilledLength = 0;
              this.currentPosition = 0;
              this.nextTokenStart = 0;
              this.nextDelimiterStart = -1;
              this.nextDelimiterEnd = -1;
              this.defaultRadix = 10;
              this.closed = false;
              this.reader = reader;
            }

            if (this.reader === undefined) {
              this.reader = null;
            }

            if (this.matcher === undefined) {
              this.matcher = null;
            }

            if (this.nextDelimiterWithPattern === undefined) {
              this.nextDelimiterWithPattern = null;
            }

            this.currentDelimiter = Scanner.whiteSpacePattern_$LI$();

            this.buf = function (s) {
              var a = [];

              while (s-- > 0) {
                a.push(null);
              }

              return a;
            }(1024);

            this.bufferFilledLength = 0;
            this.currentPosition = 0;
            this.nextTokenStart = 0;
            this.nextDelimiterStart = -1;
            this.nextDelimiterEnd = -1;
            this.defaultRadix = 10;
            this.closed = false;
          } else if (string != null && string instanceof java.io.InputStream || string === null) {
            var __args = arguments;
            var inputStream = __args[0];
            {
              var reader = new java.io.InputStreamReader(inputStream);

              if (this.reader === undefined) {
                this.reader = null;
              }

              if (this.matcher === undefined) {
                this.matcher = null;
              }

              if (this.nextDelimiterWithPattern === undefined) {
                this.nextDelimiterWithPattern = null;
              }

              this.currentDelimiter = Scanner.whiteSpacePattern_$LI$();

              this.buf = function (s) {
                var a = [];

                while (s-- > 0) {
                  a.push(null);
                }

                return a;
              }(1024);

              this.bufferFilledLength = 0;
              this.currentPosition = 0;
              this.nextTokenStart = 0;
              this.nextDelimiterStart = -1;
              this.nextDelimiterEnd = -1;
              this.defaultRadix = 10;
              this.closed = false;
              this.reader = reader;
            }

            if (this.reader === undefined) {
              this.reader = null;
            }

            if (this.matcher === undefined) {
              this.matcher = null;
            }

            if (this.nextDelimiterWithPattern === undefined) {
              this.nextDelimiterWithPattern = null;
            }

            this.currentDelimiter = Scanner.whiteSpacePattern_$LI$();

            this.buf = function (s) {
              var a = [];

              while (s-- > 0) {
                a.push(null);
              }

              return a;
            }(1024);

            this.bufferFilledLength = 0;
            this.currentPosition = 0;
            this.nextTokenStart = 0;
            this.nextDelimiterStart = -1;
            this.nextDelimiterEnd = -1;
            this.defaultRadix = 10;
            this.closed = false;
          } else if (string != null && string instanceof java.io.Reader || string === null) {
            var __args = arguments;
            var reader = __args[0];

            if (this.reader === undefined) {
              this.reader = null;
            }

            if (this.matcher === undefined) {
              this.matcher = null;
            }

            if (this.nextDelimiterWithPattern === undefined) {
              this.nextDelimiterWithPattern = null;
            }

            this.currentDelimiter = Scanner.whiteSpacePattern_$LI$();

            this.buf = function (s) {
              var a = [];

              while (s-- > 0) {
                a.push(null);
              }

              return a;
            }(1024);

            this.bufferFilledLength = 0;
            this.currentPosition = 0;
            this.nextTokenStart = 0;
            this.nextDelimiterStart = -1;
            this.nextDelimiterEnd = -1;
            this.defaultRadix = 10;
            this.closed = false;
            this.reader = reader;
          } else throw new Error('invalid overload');
        }
        /* Default method injected from java.util.Iterator */


        Scanner.prototype.forEachRemaining = function (consumer) {
          var _this = this;

          javaemul.internal.InternalPreconditions.checkNotNull(consumer);

          while (this.hasNext()) {
            {
              (function (target) {
                return typeof target === 'function' ? target(_this.next()) : target.accept(_this.next());
              })(consumer);
            }
          }
        };
        /* Default method injected from java.util.Iterator */


        Scanner.prototype.remove = function () {
          throw new java.lang.UnsupportedOperationException();
        };

        Scanner.numeral_$LI$ = function () {
          if (Scanner.numeral == null) {
            Scanner.numeral = Scanner.digit + "+";
          }

          return Scanner.numeral;
        };

        Scanner.decimalNumeral_$LI$ = function () {
          if (Scanner.decimalNumeral == null) {
            Scanner.decimalNumeral = "(?:" + Scanner.numeral_$LI$() + "|" + Scanner.numeral_$LI$() + Scanner.decimalSeparator + Scanner.digit + "*|" + Scanner.decimalSeparator + Scanner.digit + "+)";
          }

          return Scanner.decimalNumeral;
        };

        Scanner.exponent_$LI$ = function () {
          if (Scanner.exponent == null) {
            Scanner.exponent = "(?:[eE][+-]?" + Scanner.digit + "+)";
          }

          return Scanner.exponent;
        };

        Scanner.decimal_$LI$ = function () {
          if (Scanner.decimal == null) {
            Scanner.decimal = "(?:[-+]?" + Scanner.decimalNumeral_$LI$() + Scanner.exponent_$LI$() + "?)";
          }

          return Scanner.decimal;
        };

        Scanner.signedNonNumber_$LI$ = function () {
          if (Scanner.signedNonNumber == null) {
            Scanner.signedNonNumber = "(?:[-+]?" + Scanner.nonNumber + ")";
          }

          return Scanner.signedNonNumber;
        };

        Scanner.booleanPattern_$LI$ = function () {
          if (Scanner.booleanPattern == null) {
            Scanner.booleanPattern = java.util.regex.Pattern.compile("true|TRUE|True|1|false|FALSE|False|0");
          }

          return Scanner.booleanPattern;
        };

        Scanner.integerPattern_$LI$ = function () {
          if (Scanner.integerPattern == null) {
            Scanner.integerPattern = java.util.regex.Pattern.compile("[-+]?" + Scanner.numeral_$LI$());
          }

          return Scanner.integerPattern;
        };

        Scanner.floatPattern_$LI$ = function () {
          if (Scanner.floatPattern == null) {
            Scanner.floatPattern = java.util.regex.Pattern.compile(Scanner.decimal_$LI$() + "|" + Scanner.hexFloat + "|" + Scanner.signedNonNumber_$LI$());
          }

          return Scanner.floatPattern;
        };

        Scanner.endLinePattern_$LI$ = function () {
          if (Scanner.endLinePattern == null) {
            Scanner.endLinePattern = java.util.regex.Pattern.compile("[\\n\\r]+");
          }

          return Scanner.endLinePattern;
        };

        Scanner.whiteSpacePattern_$LI$ = function () {
          if (Scanner.whiteSpacePattern == null) {
            Scanner.whiteSpacePattern = java.util.regex.Pattern.compile("\\s+");
          }

          return Scanner.whiteSpacePattern;
        };
        /**
        *
        */


        Scanner.prototype.close = function () {
          this.closed = true;
          this.reader.close();
        };

        Scanner.prototype.delimiter = function () {
          return this.currentDelimiter;
        };

        Scanner.prototype.useDelimiter$java_lang_String = function (currentDelimiter) {
          return this.useDelimiter$java_util_regex_Pattern(java.util.regex.Pattern.compile$java_lang_String(currentDelimiter));
        };

        Scanner.prototype.useDelimiter = function (currentDelimiter) {
          if (typeof currentDelimiter === 'string' || currentDelimiter === null) {
            return this.useDelimiter$java_lang_String(currentDelimiter);
          } else if (currentDelimiter != null && currentDelimiter instanceof java.util.regex.Pattern || currentDelimiter === null) {
            return this.useDelimiter$java_util_regex_Pattern(currentDelimiter);
          } else throw new Error('invalid overload');
        };

        Scanner.prototype.useDelimiter$java_util_regex_Pattern = function (currentDelimiter) {
          this.currentDelimiter = currentDelimiter;
          return this;
        };

        Scanner.prototype.hasNext$ = function () {
          if (this.closed && this.currentPosition === this.bufferFilledLength) return false;

          if (this.nextDelimiterStart === -1 || this.nextDelimiterWithPattern !== this.currentDelimiter) {
            this.searchNextTo$java_util_regex_Pattern(this.currentDelimiter);
            this.nextDelimiterWithPattern = this.currentDelimiter;
          }

          return this.currentPosition !== this.bufferFilledLength;
        };
        /*private*/


        Scanner.prototype.searchNextTo$java_util_regex_Pattern = function (pattern) {
          this.searchNextTo$java_util_regex_Pattern$boolean(pattern, false);
        };

        Scanner.prototype.searchNextTo$java_util_regex_Pattern$boolean = function (pattern, canBeEmpty) {
          try {
            this.nextTokenStart = 0;

            while (!this.closed || this.bufferFilledLength !== this.currentPosition + this.nextTokenStart) {
              {
                this.matcher = pattern.matcher(function (str, index, len) {
                  return str.substring(index, index + len);
                }(this.buf.join(''), this.currentPosition + this.nextTokenStart, this.bufferFilledLength - this.currentPosition - this.nextTokenStart));

                if (this.matcher.find$()) {
                  if (this.matcher.start$() > 0 || canBeEmpty) {
                    this.nextDelimiterStart = this.currentPosition + this.nextTokenStart + this.matcher.start$();
                    this.nextDelimiterEnd = this.currentPosition + this.nextTokenStart + this.matcher.end$();
                    return;
                  }

                  this.nextTokenStart += this.matcher.end$();
                  if (this.currentPosition + this.nextTokenStart < this.bufferFilledLength) continue;
                }

                if (this.buf.length === this.bufferFilledLength) {
                  if (this.currentPosition < (this.buf.length / 2 | 0)) {
                    var chars = function (s) {
                      var a = [];

                      while (s-- > 0) {
                        a.push(null);
                      }

                      return a;
                    }(this.buf.length * 2);

                    java.lang.System.arraycopy(this.buf, this.currentPosition, chars, 0, this.bufferFilledLength - this.currentPosition);
                    this.buf = chars;
                  } else {
                    java.lang.System.arraycopy(this.buf, this.currentPosition, this.buf, 0, this.bufferFilledLength - this.currentPosition);
                  }

                  this.bufferFilledLength -= this.currentPosition;
                  this.currentPosition = 0;
                  this.nextDelimiterStart = this.nextDelimiterEnd = -1;
                }

                if (this.closed) break;
                var read = this.reader.read$char_A$int$int(this.buf, this.bufferFilledLength, this.buf.length - this.bufferFilledLength);

                if (read <= 0) {
                  try {
                    this.close();
                  } catch (ignored) {}

                  ;
                } else {
                  this.bufferFilledLength += read;
                }
              }
            }

            ;
          } catch (ignored) {
            try {
              this.close();
            } catch (ignored2) {}
          }

          this.nextDelimiterStart = this.nextDelimiterEnd = this.bufferFilledLength;
        };

        Scanner.prototype.searchNextTo = function (pattern, canBeEmpty) {
          if ((pattern != null && pattern instanceof java.util.regex.Pattern || pattern === null) && (typeof canBeEmpty === 'boolean' || canBeEmpty === null)) {
            return this.searchNextTo$java_util_regex_Pattern$boolean(pattern, canBeEmpty);
          } else if ((pattern != null && pattern instanceof java.util.regex.Pattern || pattern === null) && canBeEmpty === undefined) {
            return this.searchNextTo$java_util_regex_Pattern(pattern);
          } else throw new Error('invalid overload');
        };
        /**
        *
        * @return {string}
        */


        Scanner.prototype.next = function () {
          if (!this.hasNext$()) throw new java.util.NoSuchElementException("No more token");

          var result = function (str, index, len) {
            return str.substring(index, index + len);
          }(this.buf.join(''), this.currentPosition + this.nextTokenStart, this.nextDelimiterStart - this.currentPosition - this.nextTokenStart);

          this.currentPosition = this.nextDelimiterStart;
          this.nextDelimiterStart = this.nextDelimiterEnd = -1;
          return result;
        };

        Scanner.prototype.hasNext$java_util_regex_Pattern = function (pattern) {
          return this.hasNext$() && pattern.matcher(function (str, index, len) {
            return str.substring(index, index + len);
          }(this.buf.join(''), this.currentPosition + this.nextTokenStart, this.nextDelimiterStart - this.currentPosition - this.nextTokenStart)).matches();
        };

        Scanner.prototype.hasNext = function (pattern) {
          if (pattern != null && pattern instanceof java.util.regex.Pattern || pattern === null) {
            return this.hasNext$java_util_regex_Pattern(pattern);
          } else if (typeof pattern === 'string' || pattern === null) {
            return this.hasNext$java_lang_String(pattern);
          } else if (pattern === undefined) {
            return this.hasNext$();
          } else throw new Error('invalid overload');
        };

        Scanner.prototype.hasNext$java_lang_String = function (pattern) {
          return this.hasNext$() && java.util.regex.Pattern.matches(pattern, function (str, index, len) {
            return str.substring(index, index + len);
          }(this.buf.join(''), this.currentPosition + this.nextTokenStart, this.nextDelimiterStart - this.currentPosition - this.nextTokenStart));
        };

        Scanner.prototype.radix = function () {
          return this.defaultRadix;
        };

        Scanner.prototype.hasNextBoolean = function () {
          return this.hasNext$java_util_regex_Pattern(Scanner.booleanPattern_$LI$());
        };

        Scanner.prototype.nextBoolean = function () {
          if (!this.hasNextBoolean()) throw new java.util.InputMismatchException("Next token is not a boolean");
          var firstChar = this.next().charAt(0);
          return function (c) {
            return c.charCodeAt == null ? c : c.charCodeAt(0);
          }(firstChar) == 't'.charCodeAt(0) || function (c) {
            return c.charCodeAt == null ? c : c.charCodeAt(0);
          }(firstChar) == 'T'.charCodeAt(0) || function (c) {
            return c.charCodeAt == null ? c : c.charCodeAt(0);
          }(firstChar) == '1'.charCodeAt(0);
        };

        Scanner.prototype.hasNextByte = function () {
          return this.hasNext$java_util_regex_Pattern(Scanner.integerPattern_$LI$());
        };

        Scanner.prototype.nextByte = function () {
          if (!this.hasNextByte()) throw new java.util.InputMismatchException("Next token is not a byte");
          return javaemul.internal.ByteHelper.parseByte(this.next());
        };

        Scanner.prototype.hasNextDouble = function () {
          return this.hasNext$java_util_regex_Pattern(Scanner.floatPattern_$LI$());
        };

        Scanner.prototype.nextDouble = function () {
          if (!this.hasNextDouble()) throw new java.util.InputMismatchException("Next token is not a double");
          return javaemul.internal.DoubleHelper.parseDouble(this.next());
        };

        Scanner.prototype.hasNextFloat = function () {
          return this.hasNext$java_util_regex_Pattern(Scanner.floatPattern_$LI$());
        };

        Scanner.prototype.nextFloat = function () {
          if (!this.hasNextFloat()) throw new java.util.InputMismatchException("Next token is not a float");
          return javaemul.internal.FloatHelper.parseFloat(this.next());
        };

        Scanner.prototype.hasNextInt = function () {
          return this.hasNext$java_util_regex_Pattern(Scanner.integerPattern_$LI$());
        };

        Scanner.prototype.nextInt = function () {
          if (!this.hasNextInt()) throw new java.util.InputMismatchException("Next token is not a int");
          return javaemul.internal.IntegerHelper.parseInt(this.next());
        };

        Scanner.prototype.hasNextLine = function () {
          if (this.closed && this.currentPosition === this.bufferFilledLength) return false;

          if (this.nextDelimiterStart === -1 || this.nextDelimiterWithPattern !== Scanner.endLinePattern_$LI$()) {
            this.searchNextTo$java_util_regex_Pattern$boolean(Scanner.endLinePattern_$LI$(), true);
            this.nextDelimiterWithPattern = Scanner.endLinePattern_$LI$();
          }

          return this.currentPosition !== this.bufferFilledLength;
        };

        Scanner.prototype.nextLine = function () {
          if (!this.hasNextLine()) throw new java.util.InputMismatchException("No new line");

          var result = function (str, index, len) {
            return str.substring(index, index + len);
          }(this.buf.join(''), this.currentPosition, this.nextDelimiterStart - this.currentPosition);

          this.currentPosition = this.nextDelimiterEnd;
          this.nextDelimiterStart = this.nextDelimiterEnd = -1;
          return result;
        };

        Scanner.prototype.hasNextLong = function () {
          return this.hasNext$java_util_regex_Pattern(Scanner.integerPattern_$LI$());
        };

        Scanner.prototype.nextLong = function () {
          if (!this.hasNextLong()) throw new java.util.InputMismatchException("Next token is not a long");
          return javaemul.internal.LongHelper.parseLong(this.next());
        };

        Scanner.prototype.hasNextShort = function () {
          return this.hasNext$java_util_regex_Pattern(Scanner.integerPattern_$LI$());
        };

        Scanner.prototype.nextShort = function () {
          if (!this.hasNextShort()) throw new java.util.InputMismatchException("Next token is not a short");
          return javaemul.internal.ShortHelper.parseShort(this.next());
        };

        Scanner.prototype.reset = function () {
          return this.useDelimiter$java_util_regex_Pattern(Scanner.whiteSpacePattern_$LI$());
        };

        Scanner.prototype.skip$java_lang_String = function (pattern) {
          return this.skip$java_util_regex_Pattern(java.util.regex.Pattern.compile$java_lang_String(pattern));
        };

        Scanner.prototype.skip = function (pattern) {
          if (typeof pattern === 'string' || pattern === null) {
            return this.skip$java_lang_String(pattern);
          } else if (pattern != null && pattern instanceof java.util.regex.Pattern || pattern === null) {
            return this.skip$java_util_regex_Pattern(pattern);
          } else throw new Error('invalid overload');
        };

        Scanner.prototype.skip$java_util_regex_Pattern = function (pattern) {
          if (this.closed && this.currentPosition === this.bufferFilledLength) throw new java.util.NoSuchElementException("No more token");
          this.searchNextTo$java_util_regex_Pattern$boolean(pattern, true);

          if (this.nextDelimiterStart !== this.currentPosition) {
            throw new java.util.NoSuchElementException("The specified pattern was not found");
          }

          this.currentPosition = this.nextDelimiterEnd;
          this.nextDelimiterStart = this.nextDelimiterEnd = -1;
          return this;
        };

        Scanner.prototype.findInLine$java_lang_String = function (pattern) {
          return this.findInLine$java_util_regex_Pattern(java.util.regex.Pattern.compile$java_lang_String(pattern));
        };

        Scanner.prototype.findInLine = function (pattern) {
          if (typeof pattern === 'string' || pattern === null) {
            return this.findInLine$java_lang_String(pattern);
          } else if (pattern != null && pattern instanceof java.util.regex.Pattern || pattern === null) {
            return this.findInLine$java_util_regex_Pattern(pattern);
          } else throw new Error('invalid overload');
        };

        Scanner.prototype.findInLine$java_util_regex_Pattern = function (pattern) {
          if (!this.hasNextLine()) {
            return null;
          }

          this.matcher = pattern.matcher(function (str, index, len) {
            return str.substring(index, index + len);
          }(this.buf.join(''), this.currentPosition, this.nextDelimiterStart - this.currentPosition));

          if (this.matcher.find$()) {
            this.nextLine();
            return this.matcher.group$();
          } else {
            this.nextDelimiterStart = this.nextDelimiterEnd = -1;
            return null;
          }
        };

        Scanner.prototype.match = function () {
          if (this.matcher == null) throw new java.lang.IllegalStateException("No match result is available");
          return this.matcher;
        };

        Scanner.digit = "[\\d]";
        Scanner.decimalSeparator = "[.,]";
        Scanner.hexFloat = "(?:[-+]?0[xX][0-9a-fA-F]*\\.[0-9a-fA-F]+(?:[pP][-+]?[0-9]+)?)";
        Scanner.nonNumber = "(?:NaN|Infinity)";
        return Scanner;
      }();

      util.Scanner = Scanner;
      Scanner["__class"] = "java.util.Scanner";
      Scanner["__interfaces"] = ["java.util.Iterator", "java.io.Closeable", "java.lang.AutoCloseable"];
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * Skeletal implementation of the Set interface. <a
      * href="http://java.sun.com/j2se/1.5.0/docs/api/java/util/AbstractSet.html">[Sun
      * docs]</a>
      *
      * @param <E> the element type.
      * @class
      * @extends java.util.AbstractCollection
      */
      var AbstractSet =
      /** @class */
      function (_super) {
        __extends(AbstractSet, _super);

        function AbstractSet() {
          return _super.call(this) || this;
        }
        /* Default method injected from java.util.Collection */


        AbstractSet.prototype.stream = function () {
          return new javaemul.internal.stream.StreamHelper(this);
        };
        /* Default method injected from java.lang.Iterable */


        AbstractSet.prototype.forEach = function (action) {
          javaemul.internal.InternalPreconditions.checkNotNull(action);

          var _loop_4 = function _loop_4(index130) {
            var t = index130.next();
            {
              (function (target) {
                return typeof target === 'function' ? target(t) : target.accept(t);
              })(action);
            }
          };

          for (var index130 = this.iterator(); index130.hasNext();) {
            _loop_4(index130);
          }
        };
        /* Default method injected from java.util.Collection */


        AbstractSet.prototype.parallelStream = function () {
          return this.stream();
        };
        /* Default method injected from java.util.Collection */


        AbstractSet.prototype.removeIf = function (filter) {
          javaemul.internal.InternalPreconditions.checkNotNull(filter);
          var removed = false;

          var _loop_5 = function _loop_5(it) {
            {
              if (function (target) {
                return typeof target === 'function' ? target(it.next()) : target.test(it.next());
              }(filter)) {
                it.remove();
                removed = true;
              }
            }
          };

          for (var it = this.iterator(); it.hasNext();) {
            _loop_5(it);
          }

          return removed;
        };
        /**
        *
        * @param {*} o
        * @return {boolean}
        */


        AbstractSet.prototype.equals = function (o) {
          if (o === this) {
            return true;
          }

          if (!(o != null && o.constructor != null && o.constructor["__interfaces"] != null && o.constructor["__interfaces"].indexOf("java.util.Set") >= 0)) {
            return false;
          }

          var other = o;

          if (other.size() !== this.size()) {
            return false;
          }

          return this.containsAll(other);
        };
        /**
        *
        * @return {number}
        */


        AbstractSet.prototype.hashCode = function () {
          return java.util.Collections.hashCode$java_lang_Iterable(this);
        };
        /**
        *
        * @param {*} c
        * @return {boolean}
        */


        AbstractSet.prototype.removeAll = function (c) {
          javaemul.internal.InternalPreconditions.checkNotNull(c);
          var size = this.size();

          if (size < c.size()) {
            for (var iter = this.iterator(); iter.hasNext();) {
              {
                var o = iter.next();

                if (c.contains(o)) {
                  iter.remove();
                }
              }
            }
          } else {
            for (var index131 = c.iterator(); index131.hasNext();) {
              var o1 = index131.next();
              {
                this.remove(o1);
              }
            }
          }

          return size !== this.size();
        };

        return AbstractSet;
      }(java.util.AbstractCollection);

      util.AbstractSet = AbstractSet;
      AbstractSet["__class"] = "java.util.AbstractSet";
      AbstractSet["__interfaces"] = ["java.util.Collection", "java.util.Set", "java.lang.Iterable"];
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * Skeletal implementation of the List interface. <a
      * href="http://java.sun.com/j2se/1.5.0/docs/api/java/util/AbstractList.html">[Sun
      * docs]</a>
      *
      * @param <E> the element type.
      * @extends java.util.AbstractCollection
      * @class
      */
      var AbstractList =
      /** @class */
      function (_super) {
        __extends(AbstractList, _super);

        function AbstractList() {
          var _this = _super.call(this) || this;

          if (_this.modCount === undefined) {
            _this.modCount = 0;
          }

          return _this;
        }
        /* Default method injected from java.util.Collection */


        AbstractList.prototype.stream = function () {
          return new javaemul.internal.stream.StreamHelper(this);
        };
        /* Default method injected from java.lang.Iterable */


        AbstractList.prototype.forEach = function (action) {
          javaemul.internal.InternalPreconditions.checkNotNull(action);

          var _loop_6 = function _loop_6(index132) {
            var t = index132.next();
            {
              (function (target) {
                return typeof target === 'function' ? target(t) : target.accept(t);
              })(action);
            }
          };

          for (var index132 = this.iterator(); index132.hasNext();) {
            _loop_6(index132);
          }
        };
        /* Default method injected from java.util.Collection */


        AbstractList.prototype.parallelStream = function () {
          return this.stream();
        };
        /* Default method injected from java.util.List */


        AbstractList.prototype.sort = function (c) {
          var a = this.toArray();
          java.util.Arrays.sort(a, c);
          var i = this.listIterator();

          for (var index133 = 0; index133 < a.length; index133++) {
            var e = a[index133];
            {
              i.next();
              i.set(e);
            }
          }
        };
        /* Default method injected from java.util.Collection */


        AbstractList.prototype.removeIf = function (filter) {
          javaemul.internal.InternalPreconditions.checkNotNull(filter);
          var removed = false;

          var _loop_7 = function _loop_7(it) {
            {
              if (function (target) {
                return typeof target === 'function' ? target(it.next()) : target.test(it.next());
              }(filter)) {
                it.remove();
                removed = true;
              }
            }
          };

          for (var it = this.iterator(); it.hasNext();) {
            _loop_7(it);
          }

          return removed;
        };

        AbstractList.prototype.add$java_lang_Object = function (obj) {
          this.add(this.size(), obj);
          return true;
        };

        AbstractList.prototype.add$int$java_lang_Object = function (index, element) {
          throw new java.lang.UnsupportedOperationException("Add not supported on this list");
        };
        /**
        *
        * @param {number} index
        * @param {*} element
        */


        AbstractList.prototype.add = function (index, element) {
          if ((typeof index === 'number' || index === null) && (element != null || element === null)) {
            return this.add$int$java_lang_Object(index, element);
          } else if ((index != null || index === null) && element === undefined) {
            return this.add$java_lang_Object(index);
          } else throw new Error('invalid overload');
        };

        AbstractList.prototype.addAll$int$java_util_Collection = function (index, c) {
          javaemul.internal.InternalPreconditions.checkNotNull(c);
          var changed = false;

          for (var index134 = c.iterator(); index134.hasNext();) {
            var e = index134.next();
            {
              this.add(index++, e);
              changed = true;
            }
          }

          return changed;
        };
        /**
        *
        * @param {number} index
        * @param {*} c
        * @return {boolean}
        */


        AbstractList.prototype.addAll = function (index, c) {
          if ((typeof index === 'number' || index === null) && (c != null && c.constructor != null && c.constructor["__interfaces"] != null && c.constructor["__interfaces"].indexOf("java.util.Collection") >= 0 || c === null)) {
            return this.addAll$int$java_util_Collection(index, c);
          } else if ((index != null && index.constructor != null && index.constructor["__interfaces"] != null && index.constructor["__interfaces"].indexOf("java.util.Collection") >= 0 || index === null) && c === undefined) {
            return _super.prototype.addAll.call(this, index);
          } else throw new Error('invalid overload');
        };
        /**
        *
        */


        AbstractList.prototype.clear = function () {
          this.removeRange(0, this.size());
        };
        /**
        *
        * @param {*} o
        * @return {boolean}
        */


        AbstractList.prototype.equals = function (o) {
          if (o === this) {
            return true;
          }

          if (!(o != null && o.constructor != null && o.constructor["__interfaces"] != null && o.constructor["__interfaces"].indexOf("java.util.List") >= 0)) {
            return false;
          }

          var other = o;

          if (this.size() !== other.size()) {
            return false;
          }

          var iterOther = other.iterator();

          for (var index135 = this.iterator(); index135.hasNext();) {
            var elem = index135.next();
            {
              var elemOther = iterOther.next();

              if (!java.util.Objects.equals(elem, elemOther)) {
                return false;
              }
            }
          }

          return true;
        };
        /**
        *
        * @return {number}
        */


        AbstractList.prototype.hashCode = function () {
          return java.util.Collections.hashCode$java_lang_Iterable(this);
        };
        /**
        *
        * @param {*} toFind
        * @return {number}
        */


        AbstractList.prototype.indexOf = function (toFind) {
          for (var i = 0, n = this.size(); i < n; ++i) {
            {
              if (java.util.Objects.equals(toFind, this.get(i))) {
                return i;
              }
            }
          }

          return -1;
        };
        /**
        *
        * @return {*}
        */


        AbstractList.prototype.iterator = function () {
          return new AbstractList.IteratorImpl(this);
        };
        /**
        *
        * @param {*} toFind
        * @return {number}
        */


        AbstractList.prototype.lastIndexOf = function (toFind) {
          for (var i = this.size() - 1; i > -1; --i) {
            {
              if (java.util.Objects.equals(toFind, this.get(i))) {
                return i;
              }
            }
          }

          return -1;
        };

        AbstractList.prototype.listIterator$ = function () {
          return this.listIterator$int(0);
        };

        AbstractList.prototype.listIterator$int = function (from) {
          return new AbstractList.ListIteratorImpl(this, from);
        };
        /**
        *
        * @param {number} from
        * @return {*}
        */


        AbstractList.prototype.listIterator = function (from) {
          if (typeof from === 'number' || from === null) {
            return this.listIterator$int(from);
          } else if (from === undefined) {
            return this.listIterator$();
          } else throw new Error('invalid overload');
        };

        AbstractList.prototype.remove$int = function (index) {
          throw new java.lang.UnsupportedOperationException("Remove not supported on this list");
        };
        /**
        *
        * @param {number} index
        * @return {*}
        */


        AbstractList.prototype.remove = function (index) {
          if (typeof index === 'number' || index === null) {
            return this.remove$int(index);
          } else if (index != null || index === null) {
            return _super.prototype.remove.call(this, index);
          } else throw new Error('invalid overload');
        };
        /**
        *
        * @param {number} index
        * @param {*} o
        * @return {*}
        */


        AbstractList.prototype.set = function (index, o) {
          throw new java.lang.UnsupportedOperationException("Set not supported on this list");
        };
        /**
        *
        * @param {number} fromIndex
        * @param {number} toIndex
        * @return {*}
        */


        AbstractList.prototype.subList = function (fromIndex, toIndex) {
          return new AbstractList.SubList(this, fromIndex, toIndex);
        };

        AbstractList.prototype.removeRange = function (fromIndex, endIndex) {
          var iter = this.listIterator$int(fromIndex);

          for (var i = fromIndex; i < endIndex; ++i) {
            {
              iter.next();
              iter.remove();
            }
          }
        };

        return AbstractList;
      }(java.util.AbstractCollection);

      util.AbstractList = AbstractList;
      AbstractList["__class"] = "java.util.AbstractList";
      AbstractList["__interfaces"] = ["java.util.List", "java.util.Collection", "java.lang.Iterable"];

      (function (AbstractList) {
        var IteratorImpl =
        /** @class */
        function () {
          function IteratorImpl(__parent) {
            this.__parent = __parent;

            if (this.i === undefined) {
              this.i = 0;
            }

            if (this.last === undefined) {
              this.last = 0;
            }

            this.i = 0;
            this.last = -1;
          }
          /* Default method injected from java.util.Iterator */


          IteratorImpl.prototype.forEachRemaining = function (consumer) {
            var _this = this;

            javaemul.internal.InternalPreconditions.checkNotNull(consumer);

            while (this.hasNext()) {
              {
                (function (target) {
                  return typeof target === 'function' ? target(_this.next()) : target.accept(_this.next());
                })(consumer);
              }
            }
          };
          /**
          *
          * @return {boolean}
          */


          IteratorImpl.prototype.hasNext = function () {
            return this.i < this.__parent.size();
          };
          /**
          *
          * @return {*}
          */


          IteratorImpl.prototype.next = function () {
            javaemul.internal.InternalPreconditions.checkElement(this.hasNext());
            return this.__parent.get(this.last = this.i++);
          };
          /**
          *
          */


          IteratorImpl.prototype.remove = function () {
            javaemul.internal.InternalPreconditions.checkState(this.last !== -1);

            this.__parent.remove$int(this.last);

            this.i = this.last;
            this.last = -1;
          };

          return IteratorImpl;
        }();

        AbstractList.IteratorImpl = IteratorImpl;
        IteratorImpl["__class"] = "java.util.AbstractList.IteratorImpl";
        IteratorImpl["__interfaces"] = ["java.util.Iterator"];

        var SubList =
        /** @class */
        function (_super) {
          __extends(SubList, _super);

          function SubList(wrapped, fromIndex, toIndex) {
            var _this = _super.call(this) || this;

            if (_this.wrapped === undefined) {
              _this.wrapped = null;
            }

            if (_this.fromIndex === undefined) {
              _this.fromIndex = 0;
            }

            if (_this.__size === undefined) {
              _this.__size = 0;
            }

            javaemul.internal.InternalPreconditions.checkCriticalPositionIndexes(fromIndex, toIndex, wrapped.size());
            _this.wrapped = wrapped;
            _this.fromIndex = fromIndex;
            _this.__size = toIndex - fromIndex;
            return _this;
          }

          SubList.prototype.add$int$java_lang_Object = function (index, element) {
            javaemul.internal.InternalPreconditions.checkPositionIndex(index, this.__size);
            this.wrapped.add(this.fromIndex + index, element);
            this.__size++;
          };
          /**
          *
          * @param {number} index
          * @param {*} element
          */


          SubList.prototype.add = function (index, element) {
            if ((typeof index === 'number' || index === null) && (element != null || element === null)) {
              return this.add$int$java_lang_Object(index, element);
            } else if ((index != null || index === null) && element === undefined) {
              return this.add$java_lang_Object(index);
            } else throw new Error('invalid overload');
          };
          /**
          *
          * @param {number} index
          * @return {*}
          */


          SubList.prototype.get = function (index) {
            javaemul.internal.InternalPreconditions.checkElementIndex(index, this.__size);
            return this.wrapped.get(this.fromIndex + index);
          };

          SubList.prototype.remove$int = function (index) {
            javaemul.internal.InternalPreconditions.checkElementIndex(index, this.__size);
            var result = this.wrapped['remove$int'](this.fromIndex + index);
            this.__size--;
            return result;
          };
          /**
          *
          * @param {number} index
          * @return {*}
          */


          SubList.prototype.remove = function (index) {
            if (typeof index === 'number' || index === null) {
              return this.remove$int(index);
            } else if (index != null || index === null) {
              return _super.prototype.remove.call(this, index);
            } else throw new Error('invalid overload');
          };
          /**
          *
          * @param {number} index
          * @param {*} element
          * @return {*}
          */


          SubList.prototype.set = function (index, element) {
            javaemul.internal.InternalPreconditions.checkElementIndex(index, this.__size);
            return this.wrapped.set(this.fromIndex + index, element);
          };
          /**
          *
          * @return {number}
          */


          SubList.prototype.size = function () {
            return this.__size;
          };

          return SubList;
        }(java.util.AbstractList);

        AbstractList.SubList = SubList;
        SubList["__class"] = "java.util.AbstractList.SubList";
        SubList["__interfaces"] = ["java.util.List", "java.util.Collection", "java.lang.Iterable"];
        /**
        * Implementation of <code>ListIterator</code> for abstract lists.
        * @extends java.util.AbstractList.IteratorImpl
        * @class
        */

        var ListIteratorImpl =
        /** @class */
        function (_super) {
          __extends(ListIteratorImpl, _super);

          function ListIteratorImpl(__parent, start) {
            var _this = this;

            if (typeof start === 'number' || start === null) {
              Array.prototype.slice.call(arguments, [1]);
              _this = _super.call(this, __parent) || this;
              javaemul.internal.InternalPreconditions.checkPositionIndex(start, __parent.size());
              _this.i = start;
            } else if (start === undefined) {
              Array.prototype.slice.call(arguments, [1]);
              _this = _super.call(this, __parent) || this;
            } else throw new Error('invalid overload');

            return _this;
          }
          /* Default method injected from java.util.Iterator */


          ListIteratorImpl.prototype.forEachRemaining = function (consumer) {
            var _this = this;

            javaemul.internal.InternalPreconditions.checkNotNull(consumer);

            while (this.hasNext()) {
              {
                (function (target) {
                  return typeof target === 'function' ? target(_this.next()) : target.accept(_this.next());
                })(consumer);
              }
            }
          };
          /**
          *
          * @param {*} o
          */


          ListIteratorImpl.prototype.add = function (o) {
            this.__parent.add(this.i, o);

            this.i++;
            this.last = -1;
          };
          /**
          *
          * @return {boolean}
          */


          ListIteratorImpl.prototype.hasPrevious = function () {
            return this.i > 0;
          };
          /**
          *
          * @return {number}
          */


          ListIteratorImpl.prototype.nextIndex = function () {
            return this.i;
          };
          /**
          *
          * @return {*}
          */


          ListIteratorImpl.prototype.previous = function () {
            javaemul.internal.InternalPreconditions.checkElement(this.hasPrevious());
            return this.__parent.get(this.last = --this.i);
          };
          /**
          *
          * @return {number}
          */


          ListIteratorImpl.prototype.previousIndex = function () {
            return this.i - 1;
          };
          /**
          *
          * @param {*} o
          */


          ListIteratorImpl.prototype.set = function (o) {
            javaemul.internal.InternalPreconditions.checkState(this.last !== -1);

            this.__parent.set(this.last, o);
          };

          return ListIteratorImpl;
        }(AbstractList.IteratorImpl);

        AbstractList.ListIteratorImpl = ListIteratorImpl;
        ListIteratorImpl["__class"] = "java.util.AbstractList.ListIteratorImpl";
        ListIteratorImpl["__interfaces"] = ["java.util.Iterator", "java.util.ListIterator"];
      })(AbstractList = util.AbstractList || (util.AbstractList = {}));
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * Skeletal implementation of the Queue interface. <a
      * href="http://java.sun.com/j2se/1.5.0/docs/api/java/util/AbstractQueue.html">[Sun
      * docs]</a>
      *
      * @param <E> element type.
      * @extends java.util.AbstractCollection
      * @class
      */
      var AbstractQueue =
      /** @class */
      function (_super) {
        __extends(AbstractQueue, _super);

        function AbstractQueue() {
          return _super.call(this) || this;
        }
        /* Default method injected from java.util.Collection */


        AbstractQueue.prototype.stream = function () {
          return new javaemul.internal.stream.StreamHelper(this);
        };
        /* Default method injected from java.lang.Iterable */


        AbstractQueue.prototype.forEach = function (action) {
          javaemul.internal.InternalPreconditions.checkNotNull(action);

          var _loop_8 = function _loop_8(index136) {
            var t = index136.next();
            {
              (function (target) {
                return typeof target === 'function' ? target(t) : target.accept(t);
              })(action);
            }
          };

          for (var index136 = this.iterator(); index136.hasNext();) {
            _loop_8(index136);
          }
        };
        /* Default method injected from java.util.Collection */


        AbstractQueue.prototype.parallelStream = function () {
          return this.stream();
        };
        /* Default method injected from java.util.Collection */


        AbstractQueue.prototype.removeIf = function (filter) {
          javaemul.internal.InternalPreconditions.checkNotNull(filter);
          var removed = false;

          var _loop_9 = function _loop_9(it) {
            {
              if (function (target) {
                return typeof target === 'function' ? target(it.next()) : target.test(it.next());
              }(filter)) {
                it.remove();
                removed = true;
              }
            }
          };

          for (var it = this.iterator(); it.hasNext();) {
            _loop_9(it);
          }

          return removed;
        };
        /**
        *
        * @param {*} o
        * @return {boolean}
        */


        AbstractQueue.prototype.add = function (o) {
          javaemul.internal.InternalPreconditions.checkState(this.offer(o), "Unable to add element to queue");
          return true;
        };
        /**
        *
        * @param {*} c
        * @return {boolean}
        */


        AbstractQueue.prototype.addAll = function (c) {
          javaemul.internal.InternalPreconditions.checkNotNull(c);
          javaemul.internal.InternalPreconditions.checkArgument(c !== this, "Can\'t add a queue to itself");
          return _super.prototype.addAll.call(this, c);
        };
        /**
        *
        */


        AbstractQueue.prototype.clear = function () {
          while (this.poll() != null) {}
        };
        /**
        *
        * @return {*}
        */


        AbstractQueue.prototype.element = function () {
          var e = this.peek();
          javaemul.internal.InternalPreconditions.checkElement(e != null, "Queue is empty");
          return e;
        };
        /**
        *
        * @param {*} o
        * @return {boolean}
        */


        AbstractQueue.prototype.remove = function (o) {
          if (o != null || o === null) {
            return _super.prototype.remove.call(this, o);
          } else if (o === undefined) {
            return this.remove$();
          } else throw new Error('invalid overload');
        };

        AbstractQueue.prototype.remove$ = function () {
          var e = this.poll();
          javaemul.internal.InternalPreconditions.checkElement(e != null, "Queue is empty");
          return e;
        };

        return AbstractQueue;
      }(java.util.AbstractCollection);

      util.AbstractQueue = AbstractQueue;
      AbstractQueue["__class"] = "java.util.AbstractQueue";
      AbstractQueue["__interfaces"] = ["java.util.Collection", "java.util.Queue", "java.lang.Iterable"];
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * A {@link Deque} based on circular buffer that is implemented with an array and head/tail
      * pointers. Array deques have no capacity restrictions; they grow as necessary to support usage.
      * Null elements are prohibited. This class is likely to be faster than {@link Stack}
      * when used as a stack, and faster than {@link LinkedList} when used as a queue.
      * <a href="https://docs.oracle.com/javase/8/docs/api/java/util/ArrayDeque.html">ArrayDeque</a>
      *
      * @param <E> the element type.
      * @param {*} c
      * @class
      * @extends java.util.AbstractCollection
      */
      var ArrayDeque =
      /** @class */
      function (_super) {
        __extends(ArrayDeque, _super);

        function ArrayDeque(c) {
          var _this = this;

          if (c != null && c.constructor != null && c.constructor["__interfaces"] != null && c.constructor["__interfaces"].indexOf("java.util.Collection") >= 0 || c === null) {
            var __args = arguments;
            {
              var numElements = c.size();
              _this = _super.call(this) || this;

              if (_this.head === undefined) {
                _this.head = 0;
              }

              if (_this.tail === undefined) {
                _this.tail = 0;
              }

              _this.array = function (s) {
                var a = [];

                while (s-- > 0) {
                  a.push(null);
                }

                return a;
              }(ArrayDeque.MIN_INITIAL_CAPACITY);

              javaemul.internal.ArrayHelper.setLength(_this.array, ArrayDeque.nextArrayLength(numElements));
            }

            if (_this.head === undefined) {
              _this.head = 0;
            }

            if (_this.tail === undefined) {
              _this.tail = 0;
            }

            _this.array = function (s) {
              var a = [];

              while (s-- > 0) {
                a.push(null);
              }

              return a;
            }(ArrayDeque.MIN_INITIAL_CAPACITY);

            (function () {
              _this.addAll(c);
            })();
          } else if (typeof c === 'number' || c === null) {
            var __args = arguments;
            var numElements = __args[0];
            _this = _super.call(this) || this;

            if (_this.head === undefined) {
              _this.head = 0;
            }

            if (_this.tail === undefined) {
              _this.tail = 0;
            }

            _this.array = function (s) {
              var a = [];

              while (s-- > 0) {
                a.push(null);
              }

              return a;
            }(ArrayDeque.MIN_INITIAL_CAPACITY);

            javaemul.internal.ArrayHelper.setLength(_this.array, ArrayDeque.nextArrayLength(numElements));
          } else if (c === undefined) {
            var __args = arguments;
            _this = _super.call(this) || this;

            if (_this.head === undefined) {
              _this.head = 0;
            }

            if (_this.tail === undefined) {
              _this.tail = 0;
            }

            _this.array = function (s) {
              var a = [];

              while (s-- > 0) {
                a.push(null);
              }

              return a;
            }(ArrayDeque.MIN_INITIAL_CAPACITY);
          } else throw new Error('invalid overload');

          return _this;
        }
        /* Default method injected from java.util.Collection */


        ArrayDeque.prototype.stream = function () {
          return new javaemul.internal.stream.StreamHelper(this);
        };
        /* Default method injected from java.lang.Iterable */


        ArrayDeque.prototype.forEach = function (action) {
          javaemul.internal.InternalPreconditions.checkNotNull(action);

          var _loop_10 = function _loop_10(index137) {
            var t = index137.next();
            {
              (function (target) {
                return typeof target === 'function' ? target(t) : target.accept(t);
              })(action);
            }
          };

          for (var index137 = this.iterator(); index137.hasNext();) {
            _loop_10(index137);
          }
        };
        /* Default method injected from java.util.Collection */


        ArrayDeque.prototype.parallelStream = function () {
          return this.stream();
        };
        /* Default method injected from java.util.Collection */


        ArrayDeque.prototype.removeIf = function (filter) {
          javaemul.internal.InternalPreconditions.checkNotNull(filter);
          var removed = false;

          var _loop_11 = function _loop_11(it) {
            {
              if (function (target) {
                return typeof target === 'function' ? target(it.next()) : target.test(it.next());
              }(filter)) {
                it.remove();
                removed = true;
              }
            }
          };

          for (var it = this.iterator(); it.hasNext();) {
            _loop_11(it);
          }

          return removed;
        };

        ArrayDeque.checkConcurrentModification = function (expression) {
          if (!expression) {
            throw new java.util.ConcurrentModificationException();
          }
        };
        /**
        * Returns best power-of-two array length to hold the given number of elements.
        *
        * @param {number} numElements the number of elements to hold
        * @return {number}
        * @private
        */


        ArrayDeque.nextArrayLength = function (numElements) {
          return ArrayDeque.nextPowerOfTwo(Math.max(ArrayDeque.MIN_INITIAL_CAPACITY, numElements));
        };
        /**
        * Returns a number that is greater than {@code num} and is a power of two.
        * If passed {@code num} is not positive integer or next power of two overflows then
        * returned value is non-positive.
        * E.g., if num == 32, returns 64. if num == 31, returns 32.
        *
        * @param {number} num positive integer.
        * @return {number}
        * @private
        */


        ArrayDeque.nextPowerOfTwo = function (num) {
          return javaemul.internal.IntegerHelper.highestOneBit(num) << 1;
        };
        /**
        *
        * @param {*} e
        * @return {boolean}
        */


        ArrayDeque.prototype.add = function (e) {
          this.addLast(e);
          return true;
        };
        /**
        *
        * @param {*} e
        */


        ArrayDeque.prototype.addFirst = function (e) {
          javaemul.internal.InternalPreconditions.checkCriticalNotNull(e);
          this.head = this.head - 1 & this.array.length - 1;
          this.array[this.head] = e;
          this.ensureCapacity();
        };
        /**
        *
        * @param {*} e
        */


        ArrayDeque.prototype.addLast = function (e) {
          javaemul.internal.InternalPreconditions.checkCriticalNotNull(e);
          this.array[this.tail] = e;
          this.tail = this.tail + 1 & this.array.length - 1;
          this.ensureCapacity();
        };
        /**
        *
        */


        ArrayDeque.prototype.clear = function () {
          if (this.head === this.tail) {
            return;
          }

          this.array = function (s) {
            var a = [];

            while (s-- > 0) {
              a.push(null);
            }

            return a;
          }(ArrayDeque.MIN_INITIAL_CAPACITY);

          this.head = 0;
          this.tail = 0;
        };

        ArrayDeque.prototype.clone = function () {
          return new ArrayDeque(this);
        };

        ArrayDeque.prototype.contains$java_lang_Object = function (o) {
          return this.contains$java_util_Iterator$java_lang_Object(this.iterator(), o);
        };
        /**
        *
        * @return {*}
        */


        ArrayDeque.prototype.descendingIterator = function () {
          return new ArrayDeque.DescendingIteratorImpl(this);
        };
        /**
        *
        * @return {*}
        */


        ArrayDeque.prototype.element = function () {
          return this.getFirst();
        };
        /**
        *
        * @return {*}
        */


        ArrayDeque.prototype.getFirst = function () {
          var e = this.peekFirstElement();
          javaemul.internal.InternalPreconditions.checkElement(e != null);
          return e;
        };
        /**
        *
        * @return {*}
        */


        ArrayDeque.prototype.getLast = function () {
          var e = this.peekLastElement();
          javaemul.internal.InternalPreconditions.checkElement(e != null);
          return e;
        };
        /**
        *
        * @return {boolean}
        */


        ArrayDeque.prototype.isEmpty = function () {
          return this.head === this.tail;
        };
        /**
        *
        * @return {*}
        */


        ArrayDeque.prototype.iterator = function () {
          return new ArrayDeque.IteratorImpl(this);
        };
        /**
        *
        * @param {*} e
        * @return {boolean}
        */


        ArrayDeque.prototype.offer = function (e) {
          return this.offerLast(e);
        };
        /**
        *
        * @param {*} e
        * @return {boolean}
        */


        ArrayDeque.prototype.offerFirst = function (e) {
          this.addFirst(e);
          return true;
        };
        /**
        *
        * @param {*} e
        * @return {boolean}
        */


        ArrayDeque.prototype.offerLast = function (e) {
          this.addLast(e);
          return true;
        };
        /**
        *
        * @return {*}
        */


        ArrayDeque.prototype.peek = function () {
          return this.peekFirst();
        };
        /**
        *
        * @return {*}
        */


        ArrayDeque.prototype.peekFirst = function () {
          return this.peekFirstElement();
        };
        /**
        *
        * @return {*}
        */


        ArrayDeque.prototype.peekLast = function () {
          return this.peekLastElement();
        };
        /**
        *
        * @return {*}
        */


        ArrayDeque.prototype.poll = function () {
          return this.pollFirst();
        };
        /**
        *
        * @return {*}
        */


        ArrayDeque.prototype.pollFirst = function () {
          var e = this.peekFirstElement();

          if (e == null) {
            return null;
          }

          this.array[this.head] = null;
          this.head = this.head + 1 & this.array.length - 1;
          return e;
        };
        /**
        *
        * @return {*}
        */


        ArrayDeque.prototype.pollLast = function () {
          var e = this.peekLastElement();

          if (e == null) {
            return null;
          }

          this.tail = this.tail - 1 & this.array.length - 1;
          this.array[this.tail] = null;
          return e;
        };
        /**
        *
        * @return {*}
        */


        ArrayDeque.prototype.pop = function () {
          return this.removeFirst();
        };
        /**
        *
        * @param {*} e
        */


        ArrayDeque.prototype.push = function (e) {
          this.addFirst(e);
        };

        ArrayDeque.prototype.remove$ = function () {
          return this.removeFirst();
        };

        ArrayDeque.prototype.remove$java_lang_Object = function (o) {
          return this.removeFirstOccurrence(o);
        };
        /**
        *
        * @return {*}
        */


        ArrayDeque.prototype.removeFirst = function () {
          var e = this.pollFirst();
          javaemul.internal.InternalPreconditions.checkElement(e != null);
          return e;
        };
        /**
        *
        * @param {*} o
        * @return {boolean}
        */


        ArrayDeque.prototype.removeFirstOccurrence = function (o) {
          return this.remove$java_util_Iterator$java_lang_Object(this.iterator(), o);
        };
        /**
        *
        * @return {*}
        */


        ArrayDeque.prototype.removeLast = function () {
          var e = this.pollLast();
          javaemul.internal.InternalPreconditions.checkElement(e != null);
          return e;
        };
        /**
        *
        * @param {*} o
        * @return {boolean}
        */


        ArrayDeque.prototype.removeLastOccurrence = function (o) {
          return this.remove$java_util_Iterator$java_lang_Object(this.descendingIterator(), o);
        };
        /**
        *
        * @return {number}
        */


        ArrayDeque.prototype.size = function () {
          return this.tail - this.head & this.array.length - 1;
        };

        ArrayDeque.prototype.toArray$java_lang_Object_A = function (out) {
          var size = this.size();

          if (out.length < size) {
            out = javaemul.internal.ArrayHelper.createFrom(out, size);
          }

          this.copyElements(out, size);

          if (out.length > size) {
            out[size] = null;
          }

          return out;
        };
        /**
        *
        * @param {Array} out
        * @return {Array}
        */


        ArrayDeque.prototype.toArray = function (out) {
          if (out != null && out instanceof Array && (out.length == 0 || out[0] == null || out[0] != null) || out === null) {
            return this.toArray$java_lang_Object_A(out);
          } else if (out === undefined) {
            return this.toArray$();
          } else throw new Error('invalid overload');
        };

        ArrayDeque.prototype.contains$java_util_Iterator$java_lang_Object = function (it, o) {
          if (o == null) {
            return false;
          }

          while (it.hasNext()) {
            {
              if (
              /* equals */
              function (o1, o2) {
                if (o1 && o1.equals) {
                  return o1.equals(o2);
                } else {
                  return o1 === o2;
                }
              }(o, it.next())) {
                return true;
              }
            }
          }

          return false;
        };

        ArrayDeque.prototype.contains = function (it, o) {
          if ((it != null && it.constructor != null && it.constructor["__interfaces"] != null && it.constructor["__interfaces"].indexOf("java.util.Iterator") >= 0 || it === null) && (o != null || o === null)) {
            return this.contains$java_util_Iterator$java_lang_Object(it, o);
          } else if ((it != null || it === null) && o === undefined) {
            return this.contains$java_lang_Object(it);
          } else throw new Error('invalid overload');
        };

        ArrayDeque.prototype.remove$java_util_Iterator$java_lang_Object = function (it, o) {
          if (this.contains$java_util_Iterator$java_lang_Object(it, o)) {
            it.remove();
            return true;
          }

          return false;
        };

        ArrayDeque.prototype.remove = function (it, o) {
          if ((it != null && it.constructor != null && it.constructor["__interfaces"] != null && it.constructor["__interfaces"].indexOf("java.util.Iterator") >= 0 || it === null) && (o != null || o === null)) {
            return this.remove$java_util_Iterator$java_lang_Object(it, o);
          } else if ((it != null || it === null) && o === undefined) {
            return this.remove$java_lang_Object(it);
          } else if (it === undefined && o === undefined) {
            return this.remove$();
          } else throw new Error('invalid overload');
        };

        ArrayDeque.prototype.peekFirstElement = function () {
          return this.array[this.head];
        };

        ArrayDeque.prototype.peekLastElement = function () {
          return this.array[this.tail - 1 & this.array.length - 1];
        };
        /**
        * Copies {@code count} ArrayDeque's elements to {@code dest} array.
        * The method is safe to use when ArrayDeque's array has been rolled over,
        * i.e. {@code head == tail}.
        * It is assumed that {@code count < size()}.
        * @param {Array} dest
        * @param {number} count
        * @private
        */


        ArrayDeque.prototype.copyElements = function (dest, count) {
          var mask = this.array.length - 1;

          for (var i = this.head, dstIdx = 0; dstIdx < count; i = i + 1 & mask, ++dstIdx) {
            {
              dest[dstIdx] = this.array[i];
            }
          }
        };
        /**
        * Increase the capacity of this deque when full, i.e.,
        * when head and tail have wrapped around to become equal.
        * @private
        */


        ArrayDeque.prototype.ensureCapacity = function () {
          if (this.head !== this.tail) {
            return;
          }

          var numElements = this.array.length;
          var newLength = ArrayDeque.nextArrayLength(numElements);

          if (this.head !== 0) {
            var newArray = javaemul.internal.ArrayHelper.createFrom(this.array, newLength);
            this.copyElements(newArray, numElements);
            this.array = newArray;
            this.head = 0;
          } else {
            javaemul.internal.ArrayHelper.setLength(this.array, newLength);
          }

          this.tail = numElements;
        };
        /**
        * Removes the element at the specified position in the elements array,
        * adjusting head and tail as necessary. This results in motion of
        * elements backwards or forwards in the array.
        *
        * @return {number} -1 if elements moved backwards (left-shifted); 1 if forwards (right-shifted).
        * @param {number} i
        * @private
        */


        ArrayDeque.prototype.removeAtIndex = function (i) {
          var mask = this.array.length - 1;
          var headDistance = i - this.head & mask;
          var tailDistance = this.tail - i & mask;
          var size = this.tail - this.head & mask;
          ArrayDeque.checkConcurrentModification(headDistance < size);

          if (headDistance >= tailDistance) {
            this.shiftLeftAtIndex(i);
            return -1;
          } else {
            this.shiftRightAtIndex(i);
            return 1;
          }
        };

        ArrayDeque.prototype.shiftLeftAtIndex = function (i) {
          var mask = this.array.length - 1;
          this.tail = this.tail - 1 & mask;

          while (i !== this.tail) {
            {
              var nextOffset = i + 1 & mask;
              this.array[i] = this.array[nextOffset];
              i = nextOffset;
            }
          }

          this.array[this.tail] = null;
        };

        ArrayDeque.prototype.shiftRightAtIndex = function (i) {
          var mask = this.array.length - 1;

          while (i !== this.head) {
            {
              var prevOffset = i - 1 & mask;
              this.array[i] = this.array[prevOffset];
              i = prevOffset;
            }
          }

          this.array[this.head] = null;
          this.head = this.head + 1 & mask;
        };
        /**
        * The minimum capacity that we'll use for a newly created deque.
        * Must be a power of 2.
        */


        ArrayDeque.MIN_INITIAL_CAPACITY = 8;
        return ArrayDeque;
      }(java.util.AbstractCollection);

      util.ArrayDeque = ArrayDeque;
      ArrayDeque["__class"] = "java.util.ArrayDeque";
      ArrayDeque["__interfaces"] = ["java.lang.Cloneable", "java.util.Collection", "java.util.Queue", "java.util.Deque", "java.lang.Iterable"];

      (function (ArrayDeque) {
        var IteratorImpl =
        /** @class */
        function () {
          function IteratorImpl(__parent) {
            this.__parent = __parent;
            this.currentIndex = this.__parent.head;
            this.fence = this.__parent.tail;
            this.lastIndex = -1;
          }
          /* Default method injected from java.util.Iterator */


          IteratorImpl.prototype.forEachRemaining = function (consumer) {
            var _this = this;

            javaemul.internal.InternalPreconditions.checkNotNull(consumer);

            while (this.hasNext()) {
              {
                (function (target) {
                  return typeof target === 'function' ? target(_this.next()) : target.accept(_this.next());
                })(consumer);
              }
            }
          };
          /**
          *
          * @return {boolean}
          */


          IteratorImpl.prototype.hasNext = function () {
            return this.currentIndex !== this.fence;
          };
          /**
          *
          * @return {*}
          */


          IteratorImpl.prototype.next = function () {
            javaemul.internal.InternalPreconditions.checkCriticalElement(this.hasNext());
            var e = this.__parent.array[this.currentIndex];
            ArrayDeque.checkConcurrentModification(this.fence === this.__parent.tail && e != null);
            this.lastIndex = this.currentIndex;
            this.currentIndex = this.currentIndex + 1 & this.__parent.array.length - 1;
            return e;
          };
          /**
          *
          */


          IteratorImpl.prototype.remove = function () {
            javaemul.internal.InternalPreconditions.checkState(this.lastIndex >= 0);

            if (this.__parent.removeAtIndex(this.lastIndex) < 0) {
              this.currentIndex = this.currentIndex - 1 & this.__parent.array.length - 1;
              this.fence = this.__parent.tail;
            }

            this.lastIndex = -1;
          };

          return IteratorImpl;
        }();

        ArrayDeque.IteratorImpl = IteratorImpl;
        IteratorImpl["__class"] = "java.util.ArrayDeque.IteratorImpl";
        IteratorImpl["__interfaces"] = ["java.util.Iterator"];

        var DescendingIteratorImpl =
        /** @class */
        function () {
          function DescendingIteratorImpl(__parent) {
            this.__parent = __parent;
            this.currentIndex = this.__parent.tail;
            this.fence = this.__parent.head;
            this.lastIndex = -1;
          }
          /* Default method injected from java.util.Iterator */


          DescendingIteratorImpl.prototype.forEachRemaining = function (consumer) {
            var _this = this;

            javaemul.internal.InternalPreconditions.checkNotNull(consumer);

            while (this.hasNext()) {
              {
                (function (target) {
                  return typeof target === 'function' ? target(_this.next()) : target.accept(_this.next());
                })(consumer);
              }
            }
          };
          /**
          *
          * @return {boolean}
          */


          DescendingIteratorImpl.prototype.hasNext = function () {
            return this.currentIndex !== this.fence;
          };
          /**
          *
          * @return {*}
          */


          DescendingIteratorImpl.prototype.next = function () {
            javaemul.internal.InternalPreconditions.checkCriticalElement(this.hasNext());
            this.currentIndex = this.currentIndex - 1 & this.__parent.array.length - 1;
            var e = this.__parent.array[this.currentIndex];
            ArrayDeque.checkConcurrentModification(this.fence === this.__parent.head && e != null);
            this.lastIndex = this.currentIndex;
            return e;
          };
          /**
          *
          */


          DescendingIteratorImpl.prototype.remove = function () {
            javaemul.internal.InternalPreconditions.checkState(this.lastIndex >= 0);

            if (this.__parent.removeAtIndex(this.lastIndex) > 0) {
              this.currentIndex = this.currentIndex + 1 & this.__parent.array.length - 1;
              this.fence = this.__parent.head;
            }

            this.lastIndex = -1;
          };

          return DescendingIteratorImpl;
        }();

        ArrayDeque.DescendingIteratorImpl = DescendingIteratorImpl;
        DescendingIteratorImpl["__class"] = "java.util.ArrayDeque.DescendingIteratorImpl";
        DescendingIteratorImpl["__interfaces"] = ["java.util.Iterator"];
      })(ArrayDeque = util.ArrayDeque || (util.ArrayDeque = {}));
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      var Timer =
      /** @class */
      function () {
        function Timer(name, daemon) {
          if ((typeof name === 'string' || name === null) && (typeof daemon === 'boolean' || daemon === null)) {
            var __args = arguments;

            if (this.name === undefined) {
              this.name = null;
            }

            this.timeouts = new Array();
            this.intervals = new Array();
            this.name = name;
          } else if ((typeof name === 'string' || name === null) && daemon === undefined) {
            var __args = arguments;
            {
              if (this.name === undefined) {
                this.name = null;
              }

              this.timeouts = new Array();
              this.intervals = new Array();
              this.name = name;
            }

            if (this.name === undefined) {
              this.name = null;
            }

            this.timeouts = new Array();
            this.intervals = new Array();
          } else if ((typeof name === 'boolean' || name === null) && daemon === undefined) {
            var __args = arguments;
            __args[0];
            {
              {
                var name_1 = "Timer-" + ++Timer.nextSerialNumber;

                if (this.name === undefined) {
                  this.name = null;
                }

                this.timeouts = new Array();
                this.intervals = new Array();
                this.name = name_1;
              }

              if (this.name === undefined) {
                this.name = null;
              }

              this.timeouts = new Array();
              this.intervals = new Array();
            }

            if (this.name === undefined) {
              this.name = null;
            }

            this.timeouts = new Array();
            this.intervals = new Array();
          } else if (name === undefined && daemon === undefined) {
            var __args = arguments;
            {
              var name_2 = "Timer-" + ++Timer.nextSerialNumber;

              if (this.name === undefined) {
                this.name = null;
              }

              this.timeouts = new Array();
              this.intervals = new Array();
              this.name = name_2;
            }

            if (this.name === undefined) {
              this.name = null;
            }

            this.timeouts = new Array();
            this.intervals = new Array();
          } else throw new Error('invalid overload');
        }

        Timer.prototype.schedule$java_util_TimerTask$long = function (task, delay) {
          if (delay < 0) {
            throw new java.lang.IllegalArgumentException("Negative delay.");
          } else {
            this.schedule$java_util_TimerTask$java_util_Date(task, new util.Date(java.lang.System.currentTimeMillis() + delay));
          }
        };

        Timer.prototype.schedule$java_util_TimerTask$java_util_Date = function (task, time) {
          var _this = this;

          task.nextExecutionTime = time.getTime();
          task.handle = window.setTimeout(function () {
            if (task.state !== java.util.TimerTask.CANCELLED) {
              task.run();
              task.state = java.util.TimerTask.EXECUTED;
            }

            _this.timeouts.splice(_this.timeouts.indexOf(task), 1);
          }, time.getTime() - java.lang.System.currentTimeMillis()) | 0;
          this.timeouts.push(task);
          task.state = java.util.TimerTask.SCHEDULED;
        };

        Timer.prototype.schedule$java_util_TimerTask$long$long = function (task, delay, period) {
          if (delay < 0) {
            throw new java.lang.IllegalArgumentException("Negative delay.");
          } else {
            this.schedule$java_util_TimerTask$java_util_Date$long(task, new util.Date(java.lang.System.currentTimeMillis() + delay), period);
          }
        };

        Timer.prototype.schedule$java_util_TimerTask$java_util_Date$long = function (task, time, period) {
          var _this = this;

          if (period <= 0) {
            throw new java.lang.IllegalArgumentException("Non-positive period.");
          } else {
            task.period = period;
            task.nextExecutionTime = time.getTime();
            task.handle = window.setTimeout(function () {
              if (task.state !== java.util.TimerTask.CANCELLED) {
                task.run();

                _this.schedule$java_util_TimerTask$long$long(task, period, period);
              } else {
                _this.timeouts.splice(_this.timeouts.indexOf(task), 1);
              }
            }, time.getTime() - java.lang.System.currentTimeMillis()) | 0;
            this.timeouts.push(task);
            task.state = java.util.TimerTask.SCHEDULED;
          }
        };

        Timer.prototype.schedule = function (task, time, period) {
          if ((task != null && task instanceof java.util.TimerTask || task === null) && (time != null && time instanceof util.Date || time === null) && (typeof period === 'number' || period === null)) {
            return this.schedule$java_util_TimerTask$java_util_Date$long(task, time, period);
          } else if ((task != null && task instanceof java.util.TimerTask || task === null) && (typeof time === 'number' || time === null) && (typeof period === 'number' || period === null)) {
            return this.schedule$java_util_TimerTask$long$long(task, time, period);
          } else if ((task != null && task instanceof java.util.TimerTask || task === null) && (time != null && time instanceof util.Date || time === null) && period === undefined) {
            return this.schedule$java_util_TimerTask$java_util_Date(task, time);
          } else if ((task != null && task instanceof java.util.TimerTask || task === null) && (typeof time === 'number' || time === null) && period === undefined) {
            return this.schedule$java_util_TimerTask$long(task, time);
          } else throw new Error('invalid overload');
        };

        Timer.prototype.scheduleAtFixedRate$java_util_TimerTask$long$long = function (task, delay, period) {
          if (delay < 0) {
            throw new java.lang.IllegalArgumentException("Negative delay.");
          } else {
            this.scheduleAtFixedRate$java_util_TimerTask$java_util_Date$long(task, new util.Date(java.lang.System.currentTimeMillis() + delay), period);
          }
        };

        Timer.prototype.scheduleAtFixedRate$java_util_TimerTask$java_util_Date$long = function (task, time, period) {
          if (period <= 0) {
            throw new java.lang.IllegalArgumentException("Non-positive period.");
          } else {
            task.period = period;
            task.nextExecutionTime = time.getTime();
            var start = new Timer.Timer$0(this, task);
            this.schedule$java_util_TimerTask$java_util_Date(start, time);
            task.handle = start.handle;
          }
        };

        Timer.prototype.scheduleAtFixedRate = function (task, time, period) {
          if ((task != null && task instanceof java.util.TimerTask || task === null) && (time != null && time instanceof util.Date || time === null) && (typeof period === 'number' || period === null)) {
            return this.scheduleAtFixedRate$java_util_TimerTask$java_util_Date$long(task, time, period);
          } else if ((task != null && task instanceof java.util.TimerTask || task === null) && (typeof time === 'number' || time === null) && (typeof period === 'number' || period === null)) {
            return this.scheduleAtFixedRate$java_util_TimerTask$long$long(task, time, period);
          } else throw new Error('invalid overload');
        };

        Timer.prototype.cancel = function () {
          for (var index138 = 0; index138 < this.timeouts.length; index138++) {
            var task = this.timeouts[index138];
            {
              clearTimeout(task.handle);
            }
          }

          for (var index139 = 0; index139 < this.intervals.length; index139++) {
            var task = this.intervals[index139];
            {
              clearInterval(task.handle);
            }
          }

          this.intervals = new Array();
          this.timeouts = new Array();
        };

        Timer.prototype.purge = function () {
          var newTimeouts = this.timeouts.filter(function (timerTask) {
            return timerTask.handle !== java.util.TimerTask.EXECUTED && timerTask.handle !== java.util.TimerTask.CANCELLED;
          });
          var newIntervals = this.intervals.filter(function (timerTask) {
            return timerTask.handle !== java.util.TimerTask.EXECUTED && timerTask.handle !== java.util.TimerTask.CANCELLED;
          });
          var purged = this.timeouts.length - newTimeouts.length + this.intervals.length - newIntervals.length;
          this.timeouts = newTimeouts;
          this.intervals = newIntervals;
          return purged;
        };

        Timer.nextSerialNumber = 0;
        return Timer;
      }();

      util.Timer = Timer;
      Timer["__class"] = "java.util.Timer";

      (function (Timer) {
        var Timer$0 =
        /** @class */
        function (_super) {
          __extends(Timer$0, _super);

          function Timer$0(__parent, task) {
            var _this = _super.call(this) || this;

            _this.task = task;
            _this.__parent = __parent;
            return _this;
          }
          /**
          *
          */


          Timer$0.prototype.run = function () {
            var _this = this;

            if (this.task.state !== java.util.TimerTask.CANCELLED) {
              this.task.nextExecutionTime = java.lang.System.currentTimeMillis() + this.task.period;
              this.task.handle = window.setInterval(function () {
                if (_this.task.state !== java.util.TimerTask.CANCELLED) {
                  _this.task.nextExecutionTime = java.lang.System.currentTimeMillis() + _this.task.period;

                  _this.task.run();
                } else {
                  clearInterval(_this.task.handle);

                  _this.__parent.intervals.splice(_this.__parent.intervals.indexOf(_this.task), 1);
                }
              }, this.task.period) | 0;

              this.__parent.intervals.push(this.task);

              this.task.run();
            }
          };

          return Timer$0;
        }(java.util.TimerTask);

        Timer.Timer$0 = Timer$0;
        Timer$0["__interfaces"] = ["java.lang.Runnable"];
      })(Timer = util.Timer || (util.Timer = {}));
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (javaemul) {
    (function (internal) {
      /**
      * Intrinsic string class.
      * @class
      */
      var StringHelper =
      /** @class */
      function () {
        function StringHelper() {}

        StringHelper.CASE_INSENSITIVE_ORDER_$LI$ = function () {
          if (StringHelper.CASE_INSENSITIVE_ORDER == null) {
            StringHelper.CASE_INSENSITIVE_ORDER = function (a, b) {
              return (
                /* compareToIgnoreCase */
                a.toUpperCase().localeCompare(b.toUpperCase())
              );
            };
          }

          return StringHelper.CASE_INSENSITIVE_ORDER;
        };

        StringHelper.copyValueOf$char_A = function (v) {
          return StringHelper.valueOf$char_A(v);
        };

        StringHelper.copyValueOf$char_A$int$int = function (v, offset, count) {
          return StringHelper.valueOf$char_A$int$int(v, offset, count);
        };

        StringHelper.copyValueOf = function (v, offset, count) {
          if ((v != null && v instanceof Array && (v.length == 0 || v[0] == null || typeof v[0] === 'string') || v === null) && (typeof offset === 'number' || offset === null) && (typeof count === 'number' || count === null)) {
            return javaemul.internal.StringHelper.copyValueOf$char_A$int$int(v, offset, count);
          } else if ((v != null && v instanceof Array && (v.length == 0 || v[0] == null || typeof v[0] === 'string') || v === null) && offset === undefined && count === undefined) {
            return javaemul.internal.StringHelper.copyValueOf$char_A(v);
          } else throw new Error('invalid overload');
        };

        StringHelper.valueOf$boolean = function (x) {
          return "" + x;
        };

        StringHelper.valueOf$char = function (x) {
          return "" + x;
        };

        StringHelper.valueOf$char_A$int$int = function (x, offset, count) {
          var end = offset + count;
          javaemul.internal.InternalPreconditions.checkStringBounds(offset, end, x.length);
          var batchSize = javaemul.internal.ArrayHelper.ARRAY_PROCESS_BATCH_SIZE;
          var s = "";

          for (var batchStart = offset; batchStart < end;) {
            {
              var batchEnd = Math.min(batchStart + batchSize, end);
              s += javaemul.internal.ArrayHelper.unsafeClone(x, batchStart, batchEnd).join("");
              batchStart = batchEnd;
            }
          }

          return s;
        };

        StringHelper.valueOf = function (x, offset, count) {
          if ((x != null && x instanceof Array && (x.length == 0 || x[0] == null || typeof x[0] === 'string') || x === null) && (typeof offset === 'number' || offset === null) && (typeof count === 'number' || count === null)) {
            return javaemul.internal.StringHelper.valueOf$char_A$int$int(x, offset, count);
          } else if ((x != null && x instanceof Array && (x.length == 0 || x[0] == null || typeof x[0] === 'string') || x === null) && offset === undefined && count === undefined) {
            return javaemul.internal.StringHelper.valueOf$char_A(x);
          } else if ((typeof x === 'boolean' || x === null) && offset === undefined && count === undefined) {
            return javaemul.internal.StringHelper.valueOf$boolean(x);
          } else if ((typeof x === 'string' || x === null) && offset === undefined && count === undefined) {
            return javaemul.internal.StringHelper.valueOf$char(x);
          } else if ((typeof x === 'number' || x === null) && offset === undefined && count === undefined) {
            return javaemul.internal.StringHelper.valueOf$int(x);
          } else if ((typeof x === 'number' || x === null) && offset === undefined && count === undefined) {
            return javaemul.internal.StringHelper.valueOf$long(x);
          } else if ((typeof x === 'number' || x === null) && offset === undefined && count === undefined) {
            return javaemul.internal.StringHelper.valueOf$float(x);
          } else if ((typeof x === 'number' || x === null) && offset === undefined && count === undefined) {
            return javaemul.internal.StringHelper.valueOf$double(x);
          } else if ((x != null || x === null) && offset === undefined && count === undefined) {
            return javaemul.internal.StringHelper.valueOf$java_lang_Object(x);
          } else throw new Error('invalid overload');
        };
        /*private*/


        StringHelper.fromCharCode = function (array) {
          return String.fromCharCode(array | 0);
        };

        StringHelper.valueOf$char_A = function (x) {
          return StringHelper.valueOf$char_A$int$int(x, 0, x.length);
        };

        StringHelper.valueOf$double = function (x) {
          return "" + x;
        };

        StringHelper.valueOf$float = function (x) {
          return "" + x;
        };

        StringHelper.valueOf$int = function (x) {
          return "" + x;
        };

        StringHelper.valueOf$long = function (x) {
          return "" + x;
        };

        StringHelper.valueOf$java_lang_Object = function (x) {
          return x == null ? "null" : x.toString();
        };
        /**
        * This method converts Java-escaped dollar signs "\$" into
        * JavaScript-escaped dollar signs "$$", and removes all other lone
        * backslashes, which serve as escapes in Java but are passed through
        * literally in JavaScript.
        *
        * @skip
        * @param {string} replaceStr
        * @return {string}
        * @private
        */

        /*private*/


        StringHelper.translateReplaceString = function (replaceStr) {
          var pos = 0;

          while (0 <= (pos = replaceStr.indexOf("\\", pos))) {
            {
              if (function (c) {
                return c.charCodeAt == null ? c : c.charCodeAt(0);
              }(replaceStr.charAt(pos + 1)) == '$'.charCodeAt(0)) {
                replaceStr = replaceStr.substring(0, pos) + "$" + replaceStr.substring(++pos);
              } else {
                replaceStr = replaceStr.substring(0, pos) + replaceStr.substring(++pos);
              }
            }
          }

          return replaceStr;
        };
        /*private*/


        StringHelper.compareTo = function (thisStr, otherStr) {
          if (thisStr == otherStr) {
            return 0;
          }

          return thisStr < otherStr ? -1 : 1;
        };
        /*private*/


        StringHelper.getCharset = function (charsetName) {
          try {
            return java.nio.charset.Charset.forName(charsetName);
          } catch (e) {
            throw new java.io.UnsupportedEncodingException(charsetName);
          }
        };

        StringHelper.fromCodePoint = function (codePoint) {
          if (codePoint >= javaemul.internal.CharacterHelper.MIN_SUPPLEMENTARY_CODE_POINT) {
            var hiSurrogate = javaemul.internal.CharacterHelper.getHighSurrogate(codePoint);
            var loSurrogate = javaemul.internal.CharacterHelper.getLowSurrogate(codePoint);
            return (
              /* valueOf */
              new String(hiSurrogate).toString() +
              /* valueOf */
              new String(loSurrogate).toString()
            );
          } else {
            return (
              /* valueOf */
              new String(String.fromCharCode(codePoint)).toString()
            );
          }
        };

        StringHelper.format = function (formatString) {
          var args = [];

          for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
          }

          return "";
        };

        StringHelper.join = function (delimiter) {
          var elements = [];

          for (var _i = 1; _i < arguments.length; _i++) {
            elements[_i - 1] = arguments[_i];
          }

          java.util.Objects.requireNonNull(delimiter);
          java.util.Objects.requireNonNull(elements);
          var joiner = new java.util.StringJoiner(delimiter);

          for (var index140 = 0; index140 < elements.length; index140++) {
            var cs = elements[index140];
            {
              joiner.add(cs);
            }
          }

          return joiner.toString();
        };

        return StringHelper;
      }();

      internal.StringHelper = StringHelper;
      StringHelper["__class"] = "javaemul.internal.StringHelper";
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (java) {
    (function (sql) {
      /**
      * An implementation of java.sql.Timestame. Derived from
      * http://java.sun.com/j2se/1.5.0/docs/api/java/sql/Timestamp.html. This is
      * basically just regular Date decorated with a nanoseconds field.
      * @param {number} year
      * @param {number} month
      * @param {number} date
      * @param {number} hour
      * @param {number} minute
      * @param {number} second
      * @param {number} nano
      * @class
      * @extends java.util.Date
      */
      var Timestamp =
      /** @class */
      function (_super) {
        __extends(Timestamp, _super);

        function Timestamp(year, month, date, hour, minute, second, nano) {
          var _this = this;

          if ((typeof year === 'number' || year === null) && (typeof month === 'number' || month === null) && (typeof date === 'number' || date === null) && (typeof hour === 'number' || hour === null) && (typeof minute === 'number' || minute === null) && (typeof second === 'number' || second === null) && (typeof nano === 'number' || nano === null)) {
            var __args = arguments;
            _this = _super.call(this, year, month, date, hour, minute, second) || this;

            if (_this.nanos === undefined) {
              _this.nanos = 0;
            }

            _this.setNanos(nano);
          } else if ((typeof year === 'number' || year === null) && month === undefined && date === undefined && hour === undefined && minute === undefined && second === undefined && nano === undefined) {
            var __args = arguments;
            var time = __args[0];
            _this = _super.call(this, time) || this;

            if (_this.nanos === undefined) {
              _this.nanos = 0;
            }

            _this.nanos = (time % 1000 | 0) * 1000000;
          } else throw new Error('invalid overload');

          return _this;
        }

        Timestamp.valueOf = function (s) {
          var components = s.split(" ");

          if (components.length !== 2) {
            throw new java.lang.IllegalArgumentException("Invalid escape format: " + s);
          }

          var timeComponents = components[1].split("\\.");
          var hasNanos = true;
          var nanos = 0;

          if (timeComponents.length === 1) {
            hasNanos = false;
          } else if (timeComponents.length !== 2) {
            throw new java.lang.IllegalArgumentException("Invalid escape format: " + s);
          }

          var d = java.sql.Date.valueOf(components[0]);
          var t = java.sql.Time.valueOf(timeComponents[0]);

          if (hasNanos) {
            var nanosString = timeComponents[1];
            var len = nanosString.length;

            if (len > 9) {
              throw new java.lang.IllegalArgumentException("Invalid escape format: " + s);
            }

            if (len < 9) {
              nanosString += "00000000".substring(len - 1);
            }

            try {
              nanos = javaemul.internal.IntegerHelper.valueOf(nanosString);
            } catch (e) {
              throw new java.lang.IllegalArgumentException("Invalid escape format: " + s);
            }
          }

          return new Timestamp(d.getYear(), d.getMonth(), d.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), nanos);
        };
        /*private*/


        Timestamp.padNine = function (value) {
          var toReturn = new java.lang.StringBuilder("000000000");
          var asString = new String(value).toString();
          toReturn = toReturn.replace(9 - asString.length, 9, asString);
          return toReturn.toString();
        };

        Timestamp.prototype.after$java_sql_Timestamp = function (ts) {
          return this.getTime() > ts.getTime() || this.getTime() === ts.getTime() && this.getNanos() > ts.getNanos();
        };

        Timestamp.prototype.after = function (ts) {
          if (ts != null && ts instanceof java.sql.Timestamp || ts === null) {
            return this.after$java_sql_Timestamp(ts);
          } else if (ts != null && ts instanceof sql.Date || ts === null) {
            return _super.prototype.after.call(this, ts);
          } else throw new Error('invalid overload');
        };

        Timestamp.prototype.before$java_sql_Timestamp = function (ts) {
          return this.getTime() < ts.getTime() || this.getTime() === ts.getTime() && this.getNanos() < ts.getNanos();
        };

        Timestamp.prototype.before = function (ts) {
          if (ts != null && ts instanceof java.sql.Timestamp || ts === null) {
            return this.before$java_sql_Timestamp(ts);
          } else if (ts != null && ts instanceof sql.Date || ts === null) {
            return _super.prototype.before.call(this, ts);
          } else throw new Error('invalid overload');
        };

        Timestamp.prototype.compareTo$java_util_Date = function (o) {
          if (o != null && o instanceof java.sql.Timestamp) {
            return this.compareTo$java_sql_Timestamp(o);
          } else {
            return this.compareTo$java_sql_Timestamp(new Timestamp(o.getTime()));
          }
        };

        Timestamp.prototype.compareTo$java_sql_Timestamp = function (o) {
          var cmp = this.getTime() - o.getTime();
          return cmp === 0 ?
          /* compare */
          this.getNanos() - o.getNanos() : cmp;
        };

        Timestamp.prototype.compareTo = function (o) {
          if (o != null && o instanceof java.sql.Timestamp || o === null) {
            return this.compareTo$java_sql_Timestamp(o);
          } else if (o != null && o instanceof sql.Date || o === null) {
            return this.compareTo$java_util_Date(o);
          } else throw new Error('invalid overload');
        };

        Timestamp.prototype.equals$java_lang_Object = function (ts) {
          return ts != null && ts instanceof java.sql.Timestamp && this.equals$java_sql_Timestamp(ts);
        };

        Timestamp.prototype.equals$java_sql_Timestamp = function (ts) {
          return ts != null && this.getTime() === ts.getTime() && this.getNanos() === ts.getNanos();
        };

        Timestamp.prototype.equals = function (ts) {
          if (ts != null && ts instanceof java.sql.Timestamp || ts === null) {
            return this.equals$java_sql_Timestamp(ts);
          } else if (ts != null || ts === null) {
            return this.equals$java_lang_Object(ts);
          } else throw new Error('invalid overload');
        };

        Timestamp.prototype.getNanos = function () {
          return this.nanos;
        };
        /**
        *
        * @return {number}
        */


        Timestamp.prototype.getTime = function () {
          return _super.prototype.getTime.call(this);
        };
        /**
        *
        * @return {number}
        */


        Timestamp.prototype.hashCode = function () {
          return (
            /* hashCode */
            function (o) {
              if (o.hashCode) {
                return o.hashCode();
              } else {
                return o.toString().split('').reduce(function (prevHash, currVal) {
                  return (prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0;
                }, 0);
              }
            }(this)
          );
        };

        Timestamp.prototype.setNanos = function (n) {
          if (n < 0 || n > 999999999) {
            throw new java.lang.IllegalArgumentException("nanos out of range " + n);
          }

          this.nanos = n;

          _super.prototype.setTime.call(this, function (n) {
            return n < 0 ? Math.ceil(n) : Math.floor(n);
          }(this.getTime() / 1000) * 1000 + (this.nanos / 1000000 | 0));
        };
        /**
        *
        * @param {number} time
        */


        Timestamp.prototype.setTime = function (time) {
          _super.prototype.setTime.call(this, time);

          this.nanos = (time % 1000 | 0) * 1000000;
        };

        return Timestamp;
      }(java.util.Date);

      sql.Timestamp = Timestamp;
      Timestamp["__class"] = "java.sql.Timestamp";
      Timestamp["__interfaces"] = ["java.lang.Cloneable", "java.lang.Comparable", "java.io.Serializable"];
    })(java.sql || (java.sql = {}));
  })(java || (java = {}));

  (function (java) {
    (function (sql) {
      /**
      * An implementation of java.sql.Time. Derived from
      * http://java.sun.com/j2se/1.5.0/docs/api/java/sql/Time.html
      * @param {number} hour
      * @param {number} minute
      * @param {number} second
      * @class
      * @extends java.util.Date
      */
      var Time =
      /** @class */
      function (_super) {
        __extends(Time, _super);

        function Time(hour, minute, second) {
          var _this = this;

          if ((typeof hour === 'number' || hour === null) && (typeof minute === 'number' || minute === null) && (typeof second === 'number' || second === null)) {
            var __args = arguments;
            _this = _super.call(this, 70, 0, 1, hour, minute, second) || this;
          } else if ((typeof hour === 'number' || hour === null) && minute === undefined && second === undefined) {
            var __args = arguments;
            var time = __args[0];
            _this = _super.call(this, time) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        Time.valueOf = function (s) {
          var split = s.split(":");

          if (split.length !== 3) {
            throw new java.lang.IllegalArgumentException("Invalid escape format: " + s);
          }

          try {
            var hh = javaemul.internal.IntegerHelper.parseInt(split[0]);
            var mm = javaemul.internal.IntegerHelper.parseInt(split[1]);
            var ss = javaemul.internal.IntegerHelper.parseInt(split[2]);
            return new Time(hh, mm, ss);
          } catch (e) {
            throw new java.lang.IllegalArgumentException("Invalid escape format: " + s);
          }
        };
        /**
        *
        * @return {number}
        */


        Time.prototype.getDate = function () {
          throw new java.lang.IllegalArgumentException();
        };
        /**
        *
        * @return {number}
        */


        Time.prototype.getDay = function () {
          throw new java.lang.IllegalArgumentException();
        };
        /**
        *
        * @return {number}
        */


        Time.prototype.getMonth = function () {
          throw new java.lang.IllegalArgumentException();
        };
        /**
        *
        * @return {number}
        */


        Time.prototype.getYear = function () {
          throw new java.lang.IllegalArgumentException();
        };
        /**
        *
        * @param {number} i
        */


        Time.prototype.setDate = function (i) {
          throw new java.lang.IllegalArgumentException();
        };
        /**
        *
        * @param {number} i
        */


        Time.prototype.setMonth = function (i) {
          throw new java.lang.IllegalArgumentException();
        };
        /**
        *
        * @param {number} i
        */


        Time.prototype.setYear = function (i) {
          throw new java.lang.IllegalArgumentException();
        };

        return Time;
      }(java.util.Date);

      sql.Time = Time;
      Time["__class"] = "java.sql.Time";
      Time["__interfaces"] = ["java.lang.Cloneable", "java.lang.Comparable", "java.io.Serializable"];
    })(java.sql || (java.sql = {}));
  })(java || (java = {}));

  (function (java) {
    (function (sql) {
      /**
      * An implementation of java.sql.Date. Derived from
      * http://java.sun.com/j2se/1.5.0/docs/api/java/sql/Date.html
      * @param {number} year
      * @param {number} month
      * @param {number} day
      * @class
      * @extends java.util.Date
      */
      var Date =
      /** @class */
      function (_super) {
        __extends(Date, _super);

        function Date(year, month, day) {
          var _this = this;

          if ((typeof year === 'number' || year === null) && (typeof month === 'number' || month === null) && (typeof day === 'number' || day === null)) {
            var __args = arguments;
            _this = _super.call(this, year, month, day) || this;
          } else if ((typeof year === 'number' || year === null) && month === undefined && day === undefined) {
            var __args = arguments;
            var date = __args[0];
            _this = _super.call(this, date) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        Date.valueOf = function (s) {
          var split = s.split("-");

          if (split.length !== 3) {
            throw new java.lang.IllegalArgumentException("Invalid escape format: " + s);
          }

          try {
            var y = javaemul.internal.IntegerHelper.parseInt(split[0]) - 1900;
            var m = javaemul.internal.IntegerHelper.parseInt(split[1]) - 1;
            var d = javaemul.internal.IntegerHelper.parseInt(split[2]);
            return new Date(y, m, d);
          } catch (e) {
            throw new java.lang.IllegalArgumentException("Invalid escape format: " + s);
          }
        };
        /**
        *
        * @return {number}
        */


        Date.prototype.getHours = function () {
          throw new java.lang.IllegalArgumentException();
        };
        /**
        *
        * @return {number}
        */


        Date.prototype.getMinutes = function () {
          throw new java.lang.IllegalArgumentException();
        };
        /**
        *
        * @return {number}
        */


        Date.prototype.getSeconds = function () {
          throw new java.lang.IllegalArgumentException();
        };
        /**
        *
        * @param {number} i
        */


        Date.prototype.setHours = function (i) {
          throw new java.lang.IllegalArgumentException();
        };
        /**
        *
        * @param {number} i
        */


        Date.prototype.setMinutes = function (i) {
          throw new java.lang.IllegalArgumentException();
        };
        /**
        *
        * @param {number} i
        */


        Date.prototype.setSeconds = function (i) {
          throw new java.lang.IllegalArgumentException();
        };

        return Date;
      }(java.util.Date);

      sql.Date = Date;
      Date["__class"] = "java.sql.Date";
      Date["__interfaces"] = ["java.lang.Cloneable", "java.lang.Comparable", "java.io.Serializable"];
    })(java.sql || (java.sql = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      (function (logging) {
        /**
        * A simple console logger used in super dev mode.
        * @extends java.util.logging.Handler
        * @class
        */
        var SimpleConsoleLogHandler =
        /** @class */
        function (_super) {
          __extends(SimpleConsoleLogHandler, _super);

          function SimpleConsoleLogHandler() {
            return _super !== null && _super.apply(this, arguments) || this;
          }
          /**
          *
          * @param {java.util.logging.LogRecord} record
          */


          SimpleConsoleLogHandler.prototype.publish = function (record) {
            if (!this.isLoggable(record)) {
              return;
            }

            var level = this.toConsoleLogLevel(record.getLevel());
            console.log(level, record.getMessage());

            if (record.getThrown() != null) {
              console.log(level, record.getThrown());
            }
          };
          /*private*/


          SimpleConsoleLogHandler.prototype.toConsoleLogLevel = function (level) {
            var val = level.intValue();

            if (val >= java.util.logging.Level.SEVERE_$LI$().intValue()) {
              return "error";
            } else if (val >= java.util.logging.Level.WARNING_$LI$().intValue()) {
              return "warn";
            } else if (val >= java.util.logging.Level.INFO_$LI$().intValue()) {
              return "info";
            } else {
              return "log";
            }
          };
          /**
          *
          */


          SimpleConsoleLogHandler.prototype.close = function () {};
          /**
          *
          */


          SimpleConsoleLogHandler.prototype.flush = function () {};

          return SimpleConsoleLogHandler;
        }(java.util.logging.Handler);

        logging.SimpleConsoleLogHandler = SimpleConsoleLogHandler;
        SimpleConsoleLogHandler["__class"] = "java.util.logging.SimpleConsoleLogHandler";
      })(util.logging || (util.logging = {}));
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * A simple wrapper around JavaScript Map for key type is string.
      * @param {java.util.AbstractHashMap} host
      * @class
      */
      var InternalStringMap =
      /** @class */
      function () {
        function InternalStringMap(host) {
          this.backingMap = java.util.InternalJsMapFactory.newJsMap();

          if (this.host === undefined) {
            this.host = null;
          }

          if (this.size === undefined) {
            this.size = 0;
          }

          if (this.valueMod === undefined) {
            this.valueMod = 0;
          }

          this.host = host;
        }
        /* Default method injected from java.lang.Iterable */


        InternalStringMap.prototype.forEach = function (action) {
          javaemul.internal.InternalPreconditions.checkNotNull(action);

          var _loop_12 = function _loop_12(index141) {
            var t = index141.next();
            {
              (function (target) {
                return typeof target === 'function' ? target(t) : target.accept(t);
              })(action);
            }
          };

          for (var index141 = this.iterator(); index141.hasNext();) {
            _loop_12(index141);
          }
        };

        InternalStringMap.prototype.contains = function (key) {
          return !javaemul.internal.JsUtils.isUndefined(this.backingMap.get(key));
        };

        InternalStringMap.prototype.get = function (key) {
          return this.backingMap.get(key);
        };

        InternalStringMap.prototype.put = function (key, value) {
          var oldValue = this.backingMap.get(key);
          this.backingMap.set(key, InternalStringMap.toNullIfUndefined(value));

          if (javaemul.internal.JsUtils.isUndefined(oldValue)) {
            this.size++;
            java.util.ConcurrentModificationDetector.structureChanged(this.host);
          } else {
            this.valueMod++;
          }

          return oldValue;
        };

        InternalStringMap.prototype.remove = function (key) {
          var value = this.backingMap.get(key);

          if (!javaemul.internal.JsUtils.isUndefined(value)) {
            this.backingMap["delete"](key);
            this.size--;
            java.util.ConcurrentModificationDetector.structureChanged(this.host);
          } else {
            this.valueMod++;
          }

          return value;
        };

        InternalStringMap.prototype.getSize = function () {
          return this.size;
        };
        /**
        *
        * @return {*}
        */


        InternalStringMap.prototype.iterator = function () {
          return new InternalStringMap.InternalStringMap$0(this);
        };
        /*private*/


        InternalStringMap.prototype.newMapEntry = function (entry, lastValueMod) {
          return new InternalStringMap.InternalStringMap$1(this, entry, lastValueMod);
        };
        /*private*/


        InternalStringMap.toNullIfUndefined = function (value) {
          return javaemul.internal.JsUtils.isUndefined(value) ? null : value;
        };

        return InternalStringMap;
      }();

      util.InternalStringMap = InternalStringMap;
      InternalStringMap["__class"] = "java.util.InternalStringMap";
      InternalStringMap["__interfaces"] = ["java.lang.Iterable"];

      (function (InternalStringMap) {
        var InternalStringMap$0 =
        /** @class */
        function () {
          function InternalStringMap$0(__parent) {
            this.__parent = __parent;
            this.entries = this.__parent.backingMap.entries();
            this.current = this.entries.next();

            if (this.last === undefined) {
              this.last = null;
            }
          }
          /* Default method injected from java.util.Iterator */


          InternalStringMap$0.prototype.forEachRemaining = function (consumer) {
            var _this = this;

            javaemul.internal.InternalPreconditions.checkNotNull(consumer);

            while (this.hasNext()) {
              {
                (function (target) {
                  return typeof target === 'function' ? target(_this.next()) : target.accept(_this.next());
                })(consumer);
              }
            }
          };
          /**
          *
          * @return {boolean}
          */


          InternalStringMap$0.prototype.hasNext = function () {
            return !this.current.done;
          };
          /**
          *
          * @return {*}
          */


          InternalStringMap$0.prototype.next = function () {
            this.last = this.current;
            this.current = this.entries.next();
            return this.__parent.newMapEntry(this.last, this.__parent.valueMod);
          };
          /**
          *
          */


          InternalStringMap$0.prototype.remove = function () {
            this.__parent.remove(this.last.value[0]);
          };

          return InternalStringMap$0;
        }();

        InternalStringMap.InternalStringMap$0 = InternalStringMap$0;
        InternalStringMap$0["__interfaces"] = ["java.util.Iterator"];

        var InternalStringMap$1 =
        /** @class */
        function (_super) {
          __extends(InternalStringMap$1, _super);

          function InternalStringMap$1(__parent, entry, lastValueMod) {
            var _this = _super.call(this) || this;

            _this.entry = entry;
            _this.lastValueMod = lastValueMod;
            _this.__parent = __parent;
            return _this;
          }
          /**
          *
          * @return {*}
          */


          InternalStringMap$1.prototype.getKey = function () {
            return this.entry.value[0];
          };
          /**
          *
          * @return {*}
          */


          InternalStringMap$1.prototype.getValue = function () {
            if (this.__parent.valueMod !== this.lastValueMod) {
              return this.__parent.get(this.entry.value[0]);
            }

            return this.entry.value[1];
          };
          /**
          *
          * @param {*} object
          * @return {*}
          */


          InternalStringMap$1.prototype.setValue = function (object) {
            return this.__parent.put(this.entry.value[0], object);
          };

          return InternalStringMap$1;
        }(java.util.AbstractMapEntry);

        InternalStringMap.InternalStringMap$1 = InternalStringMap$1;
        InternalStringMap$1["__interfaces"] = ["java.util.Map.Entry"];
      })(InternalStringMap = util.InternalStringMap || (util.InternalStringMap = {}));
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (security) {
      /**
      * Message Digest algorithm - <a href=
      * "http://java.sun.com/j2se/1.4.2/docs/api/java/security/MessageDigest.html"
      * >[Sun's docs]</a>.
      * @extends java.security.MessageDigestSpi
      * @class
      */
      var MessageDigest =
      /** @class */
      function (_super) {
        __extends(MessageDigest, _super);

        function MessageDigest(algorithm) {
          var _this = _super.call(this) || this;

          if (_this.algorithm === undefined) {
            _this.algorithm = null;
          }

          _this.algorithm = algorithm;
          return _this;
        }

        MessageDigest.getInstance = function (algorithm) {
          if ("MD5" === algorithm) {
            return new MessageDigest.Md5Digest();
          }

          throw new java.security.NoSuchAlgorithmException(algorithm + " not supported");
        };

        MessageDigest.isEqual = function (digestA, digestB) {
          var n = digestA.length;

          if (n !== digestB.length) {
            return false;
          }

          for (var i = 0; i < n; ++i) {
            {
              if (digestA[i] !== digestB[i]) {
                return false;
              }
            }
          }

          return true;
        };

        MessageDigest.prototype.digest$ = function () {
          return this.engineDigest$();
        };

        MessageDigest.prototype.digest$byte_A = function (input) {
          this.update$byte_A(input);
          return this.digest$();
        };

        MessageDigest.prototype.digest$byte_A$int$int = function (buf, offset, len) {
          return this.engineDigest$byte_A$int$int(buf, offset, len);
        };

        MessageDigest.prototype.digest = function (buf, offset, len) {
          if ((buf != null && buf instanceof Array && (buf.length == 0 || buf[0] == null || typeof buf[0] === 'number') || buf === null) && (typeof offset === 'number' || offset === null) && (typeof len === 'number' || len === null)) {
            return this.digest$byte_A$int$int(buf, offset, len);
          } else if ((buf != null && buf instanceof Array && (buf.length == 0 || buf[0] == null || typeof buf[0] === 'number') || buf === null) && offset === undefined && len === undefined) {
            return this.digest$byte_A(buf);
          } else if (buf === undefined && offset === undefined && len === undefined) {
            return this.digest$();
          } else throw new Error('invalid overload');
        };

        MessageDigest.prototype.getAlgorithm = function () {
          return this.algorithm;
        };

        MessageDigest.prototype.getDigestLength = function () {
          return this.engineGetDigestLength();
        };

        MessageDigest.prototype.reset = function () {
          this.engineReset();
        };

        MessageDigest.prototype.update$byte = function (input) {
          this.engineUpdate$byte(input);
        };

        MessageDigest.prototype.update$byte_A = function (input) {
          this.engineUpdate$byte_A$int$int(input, 0, input.length);
        };

        MessageDigest.prototype.update$byte_A$int$int = function (input, offset, len) {
          this.engineUpdate$byte_A$int$int(input, offset, len);
        };

        MessageDigest.prototype.update = function (input, offset, len) {
          if ((input != null && input instanceof Array && (input.length == 0 || input[0] == null || typeof input[0] === 'number') || input === null) && (typeof offset === 'number' || offset === null) && (typeof len === 'number' || len === null)) {
            return this.update$byte_A$int$int(input, offset, len);
          } else if ((input != null && input instanceof Array && (input.length == 0 || input[0] == null || typeof input[0] === 'number') || input === null) && offset === undefined && len === undefined) {
            return this.update$byte_A(input);
          } else if ((typeof input === 'number' || input === null) && offset === undefined && len === undefined) {
            return this.update$byte(input);
          } else throw new Error('invalid overload');
        };

        return MessageDigest;
      }(java.security.MessageDigestSpi);

      security.MessageDigest = MessageDigest;
      MessageDigest["__class"] = "java.security.MessageDigest";

      (function (MessageDigest) {
        var Md5Digest =
        /** @class */
        function (_super) {
          __extends(Md5Digest, _super);

          function Md5Digest() {
            var _this = _super.call(this, "MD5") || this;

            if (_this.buffer === undefined) {
              _this.buffer = null;
            }

            if (_this.counter === undefined) {
              _this.counter = 0;
            }

            _this.oneByte = [0];

            if (_this.remainder === undefined) {
              _this.remainder = 0;
            }

            if (_this.state === undefined) {
              _this.state = null;
            }

            if (_this.x === undefined) {
              _this.x = null;
            }

            _this.engineReset();

            return _this;
          }

          Md5Digest.padding_$LI$ = function () {
            if (Md5Digest.padding == null) {
              Md5Digest.padding = [128 | 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
            }

            return Md5Digest.padding;
          };
          /**
          * Converts a long to a 8-byte array using low order first.
          *
          * @param {number} n A long.
          * @return {Array} A byte[].
          */


          Md5Digest.toBytes = function (n) {
            var b = [0, 0, 0, 0, 0, 0, 0, 0];
            b[0] = n | 0;
            n >>>= 8;
            b[1] = n | 0;
            n >>>= 8;
            b[2] = n | 0;
            n >>>= 8;
            b[3] = n | 0;
            n >>>= 8;
            b[4] = n | 0;
            n >>>= 8;
            b[5] = n | 0;
            n >>>= 8;
            b[6] = n | 0;
            n >>>= 8;
            b[7] = n | 0;
            return b;
          };
          /**
          * Converts a 64-byte array into a 16-int array.
          *
          * @param {Array} in A byte[].
          * @param {Array} out An int[].
          * @private
          */


          Md5Digest.byte2int = function (__in, out) {
            for (var inpos = 0, outpos = 0; outpos < 16; outpos++) {
              {
                out[outpos] = __in[inpos++] & 255 | (__in[inpos++] & 255) << 8 | (__in[inpos++] & 255) << 16 | (__in[inpos++] & 255) << 24;
              }
            }
          };

          Md5Digest.f = function (x, y, z) {
            return z ^ x & (y ^ z);
          };

          Md5Digest.ff = function (a, b, c, d, x, s, ac) {
            a += x + ac + Md5Digest.f(b, c, d);
            a = a << s | a >>> -s;
            return a + b;
          };

          Md5Digest.g = function (x, y, z) {
            return y ^ z & (x ^ y);
          };

          Md5Digest.gg = function (a, b, c, d, x, s, ac) {
            a += x + ac + Md5Digest.g(b, c, d);
            a = a << s | a >>> -s;
            return a + b;
          };

          Md5Digest.h = function (x, y, z) {
            return x ^ y ^ z;
          };

          Md5Digest.hh = function (a, b, c, d, x, s, ac) {
            a += x + ac + Md5Digest.h(b, c, d);
            a = a << s | a >>> -s;
            return a + b;
          };

          Md5Digest.i = function (x, y, z) {
            return y ^ (x | ~z);
          };

          Md5Digest.ii = function (a, b, c, d, x, s, ac) {
            a += x + ac + Md5Digest.i(b, c, d);
            a = a << s | a >>> -s;
            return a + b;
          };
          /**
          * Converts a 4-int array into a 16-byte array.
          *
          * @param {Array} in An int[].
          * @param {Array} out A byte[].
          * @private
          */


          Md5Digest.int2byte = function (__in, out) {
            for (var inpos = 0, outpos = 0; inpos < 4; inpos++) {
              {
                out[outpos++] = __in[inpos] & 255 | 0;
                out[outpos++] = __in[inpos] >>> 8 & 255 | 0;
                out[outpos++] = __in[inpos] >>> 16 & 255 | 0;
                out[outpos++] = __in[inpos] >>> 24 & 255 | 0;
              }
            }
          };

          Md5Digest.prototype.engineDigest = function (buf, offset, len) {
            if ((buf != null && buf instanceof Array && (buf.length == 0 || buf[0] == null || typeof buf[0] === 'number') || buf === null) && (typeof offset === 'number' || offset === null) && (typeof len === 'number' || len === null)) {
              return _super.prototype.engineDigest.call(this, buf, offset, len);
            } else if (buf === undefined && offset === undefined && len === undefined) {
              return this.engineDigest$();
            } else throw new Error('invalid overload');
          };

          Md5Digest.prototype.engineDigest$ = function () {
            var bits = Md5Digest.toBytes(this.counter << 3);

            var digest = function (s) {
              var a = [];

              while (s-- > 0) {
                a.push(0);
              }

              return a;
            }(16);

            if (this.remainder > 8) {
              this.engineUpdate$byte_A$int$int(Md5Digest.padding_$LI$(), 0, this.remainder - 8);
            } else {
              this.engineUpdate$byte_A$int$int(Md5Digest.padding_$LI$(), 0, 64 + (this.remainder - 8));
            }

            this.engineUpdate$byte_A$int$int(bits, 0, 8);
            Md5Digest.int2byte(this.state, digest);
            this.reset();
            return digest;
          };
          /**
          *
          * @return {number}
          */


          Md5Digest.prototype.engineGetDigestLength = function () {
            return 16;
          };
          /**
          *
          */


          Md5Digest.prototype.engineReset = function () {
            this.buffer = function (s) {
              var a = [];

              while (s-- > 0) {
                a.push(0);
              }

              return a;
            }(64);

            this.state = [0, 0, 0, 0];

            this.x = function (s) {
              var a = [];

              while (s-- > 0) {
                a.push(0);
              }

              return a;
            }(16);

            this.state[0] = 1732584193;
            this.state[1] = -271733879;
            this.state[2] = -1732584194;
            this.state[3] = 271733878;
            this.counter = 0;
            this.remainder = 64;
          };

          Md5Digest.prototype.engineUpdate$byte = function (input) {
            this.oneByte[0] = input;
            this.engineUpdate$byte_A$int$int(this.oneByte, 0, 1);
          };

          Md5Digest.prototype.engineUpdate$byte_A$int$int = function (input, offset, len) {
            while (true) {
              {
                if (len >= this.remainder) {
                  java.lang.System.arraycopy(input, offset, this.buffer, this.counter & 63 | 0, this.remainder);
                  this.transform(this.buffer);
                  this.counter += this.remainder;
                  offset += this.remainder;
                  len -= this.remainder;
                  this.remainder = 64;
                } else {
                  java.lang.System.arraycopy(input, offset, this.buffer, this.counter & 63 | 0, len);
                  this.counter += len;
                  this.remainder -= len;
                  break;
                }
              }
            }
          };
          /**
          *
          * @param {Array} input
          * @param {number} offset
          * @param {number} len
          */


          Md5Digest.prototype.engineUpdate = function (input, offset, len) {
            if ((input != null && input instanceof Array && (input.length == 0 || input[0] == null || typeof input[0] === 'number') || input === null) && (typeof offset === 'number' || offset === null) && (typeof len === 'number' || len === null)) {
              return this.engineUpdate$byte_A$int$int(input, offset, len);
            } else if ((typeof input === 'number' || input === null) && offset === undefined && len === undefined) {
              return this.engineUpdate$byte(input);
            } else throw new Error('invalid overload');
          };

          Md5Digest.prototype.transform = function (buffer) {
            var a;
            var b;
            var c;
            var d;
            Md5Digest.byte2int(buffer, this.x);
            a = this.state[0];
            b = this.state[1];
            c = this.state[2];
            d = this.state[3];
            a = Md5Digest.ff(a, b, c, d, this.x[0], 7, -680876936);
            d = Md5Digest.ff(d, a, b, c, this.x[1], 12, -389564586);
            c = Md5Digest.ff(c, d, a, b, this.x[2], 17, 606105819);
            b = Md5Digest.ff(b, c, d, a, this.x[3], 22, -1044525330);
            a = Md5Digest.ff(a, b, c, d, this.x[4], 7, -176418897);
            d = Md5Digest.ff(d, a, b, c, this.x[5], 12, 1200080426);
            c = Md5Digest.ff(c, d, a, b, this.x[6], 17, -1473231341);
            b = Md5Digest.ff(b, c, d, a, this.x[7], 22, -45705983);
            a = Md5Digest.ff(a, b, c, d, this.x[8], 7, 1770035416);
            d = Md5Digest.ff(d, a, b, c, this.x[9], 12, -1958414417);
            c = Md5Digest.ff(c, d, a, b, this.x[10], 17, -42063);
            b = Md5Digest.ff(b, c, d, a, this.x[11], 22, -1990404162);
            a = Md5Digest.ff(a, b, c, d, this.x[12], 7, 1804603682);
            d = Md5Digest.ff(d, a, b, c, this.x[13], 12, -40341101);
            c = Md5Digest.ff(c, d, a, b, this.x[14], 17, -1502002290);
            b = Md5Digest.ff(b, c, d, a, this.x[15], 22, 1236535329);
            a = Md5Digest.gg(a, b, c, d, this.x[1], 5, -165796510);
            d = Md5Digest.gg(d, a, b, c, this.x[6], 9, -1069501632);
            c = Md5Digest.gg(c, d, a, b, this.x[11], 14, 643717713);
            b = Md5Digest.gg(b, c, d, a, this.x[0], 20, -373897302);
            a = Md5Digest.gg(a, b, c, d, this.x[5], 5, -701558691);
            d = Md5Digest.gg(d, a, b, c, this.x[10], 9, 38016083);
            c = Md5Digest.gg(c, d, a, b, this.x[15], 14, -660478335);
            b = Md5Digest.gg(b, c, d, a, this.x[4], 20, -405537848);
            a = Md5Digest.gg(a, b, c, d, this.x[9], 5, 568446438);
            d = Md5Digest.gg(d, a, b, c, this.x[14], 9, -1019803690);
            c = Md5Digest.gg(c, d, a, b, this.x[3], 14, -187363961);
            b = Md5Digest.gg(b, c, d, a, this.x[8], 20, 1163531501);
            a = Md5Digest.gg(a, b, c, d, this.x[13], 5, -1444681467);
            d = Md5Digest.gg(d, a, b, c, this.x[2], 9, -51403784);
            c = Md5Digest.gg(c, d, a, b, this.x[7], 14, 1735328473);
            b = Md5Digest.gg(b, c, d, a, this.x[12], 20, -1926607734);
            a = Md5Digest.hh(a, b, c, d, this.x[5], 4, -378558);
            d = Md5Digest.hh(d, a, b, c, this.x[8], 11, -2022574463);
            c = Md5Digest.hh(c, d, a, b, this.x[11], 16, 1839030562);
            b = Md5Digest.hh(b, c, d, a, this.x[14], 23, -35309556);
            a = Md5Digest.hh(a, b, c, d, this.x[1], 4, -1530992060);
            d = Md5Digest.hh(d, a, b, c, this.x[4], 11, 1272893353);
            c = Md5Digest.hh(c, d, a, b, this.x[7], 16, -155497632);
            b = Md5Digest.hh(b, c, d, a, this.x[10], 23, -1094730640);
            a = Md5Digest.hh(a, b, c, d, this.x[13], 4, 681279174);
            d = Md5Digest.hh(d, a, b, c, this.x[0], 11, -358537222);
            c = Md5Digest.hh(c, d, a, b, this.x[3], 16, -722521979);
            b = Md5Digest.hh(b, c, d, a, this.x[6], 23, 76029189);
            a = Md5Digest.hh(a, b, c, d, this.x[9], 4, -640364487);
            d = Md5Digest.hh(d, a, b, c, this.x[12], 11, -421815835);
            c = Md5Digest.hh(c, d, a, b, this.x[15], 16, 530742520);
            b = Md5Digest.hh(b, c, d, a, this.x[2], 23, -995338651);
            a = Md5Digest.ii(a, b, c, d, this.x[0], 6, -198630844);
            d = Md5Digest.ii(d, a, b, c, this.x[7], 10, 1126891415);
            c = Md5Digest.ii(c, d, a, b, this.x[14], 15, -1416354905);
            b = Md5Digest.ii(b, c, d, a, this.x[5], 21, -57434055);
            a = Md5Digest.ii(a, b, c, d, this.x[12], 6, 1700485571);
            d = Md5Digest.ii(d, a, b, c, this.x[3], 10, -1894986606);
            c = Md5Digest.ii(c, d, a, b, this.x[10], 15, -1051523);
            b = Md5Digest.ii(b, c, d, a, this.x[1], 21, -2054922799);
            a = Md5Digest.ii(a, b, c, d, this.x[8], 6, 1873313359);
            d = Md5Digest.ii(d, a, b, c, this.x[15], 10, -30611744);
            c = Md5Digest.ii(c, d, a, b, this.x[6], 15, -1560198380);
            b = Md5Digest.ii(b, c, d, a, this.x[13], 21, 1309151649);
            a = Md5Digest.ii(a, b, c, d, this.x[4], 6, -145523070);
            d = Md5Digest.ii(d, a, b, c, this.x[11], 10, -1120210379);
            c = Md5Digest.ii(c, d, a, b, this.x[2], 15, 718787259);
            b = Md5Digest.ii(b, c, d, a, this.x[9], 21, -343485551);
            this.state[0] = javaemul.internal.Coercions.ensureInt(this.state[0] + a);
            this.state[1] = javaemul.internal.Coercions.ensureInt(this.state[1] + b);
            this.state[2] = javaemul.internal.Coercions.ensureInt(this.state[2] + c);
            this.state[3] = javaemul.internal.Coercions.ensureInt(this.state[3] + d);
          };

          return Md5Digest;
        }(java.security.MessageDigest);

        MessageDigest.Md5Digest = Md5Digest;
        Md5Digest["__class"] = "java.security.MessageDigest.Md5Digest";
      })(MessageDigest = security.MessageDigest || (security.MessageDigest = {}));
    })(java.security || (java.security = {}));
  })(java || (java = {}));

  (function (java) {
    (function (io) {
      /**
      * JSweet implementation (partial).
      *
      * TODO: actual support of charsets.
      * @param {java.io.OutputStream} out
      * @param {string} charsetName
      * @class
      * @extends java.io.Writer
      */
      var OutputStreamWriter =
      /** @class */
      function (_super) {
        __extends(OutputStreamWriter, _super);

        function OutputStreamWriter(out, charsetName) {
          var _this = this;

          if ((out != null && out instanceof java.io.OutputStream || out === null) && (typeof charsetName === 'string' || charsetName === null)) {
            var __args = arguments;
            _this = _super.call(this, out) || this;

            if (_this.out === undefined) {
              _this.out = null;
            }

            if (charsetName == null) throw new java.lang.NullPointerException("charsetName");
            _this.out = out;
          } else if ((out != null && out instanceof java.io.OutputStream || out === null) && (charsetName != null && charsetName instanceof java.nio.charset.Charset || charsetName === null)) {
            var __args = arguments;
            var cs = __args[1];
            _this = _super.call(this, out) || this;

            if (_this.out === undefined) {
              _this.out = null;
            }

            if (cs == null) throw new java.lang.NullPointerException("charset");
            _this.out = out;
          } else if ((out != null && out instanceof java.io.OutputStream || out === null) && charsetName === undefined) {
            var __args = arguments;
            _this = _super.call(this, out) || this;

            if (_this.out === undefined) {
              _this.out = null;
            }

            _this.out = out;
          } else throw new Error('invalid overload');

          return _this;
        }

        OutputStreamWriter.prototype.flushBuffer = function () {
          this.out.flush();
        };

        OutputStreamWriter.prototype.write$int = function (c) {
          this.out.write$int(c);
        };

        OutputStreamWriter.prototype.write$char_A$int$int = function (cbuf, off, len) {
          var buf = function (s) {
            var a = [];

            while (s-- > 0) {
              a.push(0);
            }

            return a;
          }(len);

          for (var i = 0; i < len; ++i) {
            buf[i] = cbuf[i + off].charCodeAt(0) | 0;
          }

          this.out.write$byte_A$int$int(buf, 0, len);
        };

        OutputStreamWriter.prototype.write = function (cbuf, off, len) {
          if ((cbuf != null && cbuf instanceof Array && (cbuf.length == 0 || cbuf[0] == null || typeof cbuf[0] === 'string') || cbuf === null) && (typeof off === 'number' || off === null) && (typeof len === 'number' || len === null)) {
            return this.write$char_A$int$int(cbuf, off, len);
          } else if ((typeof cbuf === 'string' || cbuf === null) && (typeof off === 'number' || off === null) && (typeof len === 'number' || len === null)) {
            return this.write$java_lang_String$int$int(cbuf, off, len);
          } else if ((cbuf != null && cbuf instanceof Array && (cbuf.length == 0 || cbuf[0] == null || typeof cbuf[0] === 'string') || cbuf === null) && off === undefined && len === undefined) {
            return this.write$char_A(cbuf);
          } else if ((typeof cbuf === 'string' || cbuf === null) && off === undefined && len === undefined) {
            return this.write$java_lang_String(cbuf);
          } else if ((typeof cbuf === 'number' || cbuf === null) && off === undefined && len === undefined) {
            return this.write$int(cbuf);
          } else throw new Error('invalid overload');
        };

        OutputStreamWriter.prototype.write$java_lang_String$int$int = function (str, off, len) {
          this.out.write$byte_A$int$int(
          /* getBytes */
          str.split('').map(function (s) {
            return s.charCodeAt(0);
          }), off, len);
        };

        OutputStreamWriter.prototype.flush = function () {
          this.out.flush();
        };

        OutputStreamWriter.prototype.close = function () {
          this.out.close();
        };

        return OutputStreamWriter;
      }(java.io.Writer);

      io.OutputStreamWriter = OutputStreamWriter;
      OutputStreamWriter["__class"] = "java.io.OutputStreamWriter";
      OutputStreamWriter["__interfaces"] = ["java.lang.Appendable", "java.io.Closeable", "java.lang.AutoCloseable", "java.io.Flushable"];
    })(java.io || (java.io = {}));
  })(java || (java = {}));

  (function (java) {
    (function (io) {
      /**
      * Wraps an existing {@link InputStream} and performs some transformation on
      * the input data while it is being read. Transformations can be anything from a
      * simple byte-wise filtering input data to an on-the-fly compression or
      * decompression of the underlying stream. Input streams that wrap another input
      * stream and provide some additional functionality on top of it usually inherit
      * from this class.
      *
      * @see FilterOutputStream
      * @extends java.io.InputStream
      * @class
      */
      var FilterInputStream =
      /** @class */
      function (_super) {
        __extends(FilterInputStream, _super);

        function FilterInputStream(__in) {
          var _this = _super.call(this) || this;

          if (_this["in"] === undefined) {
            _this["in"] = null;
          }

          _this["in"] = __in;
          return _this;
        }
        /**
        *
        * @return {number}
        */


        FilterInputStream.prototype.available = function () {
          return this["in"].available();
        };
        /**
        * Closes this stream. This implementation closes the filtered stream.
        *
        * @throws IOException
        * if an error occurs while closing this stream.
        */


        FilterInputStream.prototype.close = function () {
          this["in"].close();
        };
        /**
        * Sets a mark position in this stream. The parameter {@code readlimit}
        * indicates how many bytes can be read before the mark is invalidated.
        * Sending {@code reset()} will reposition this stream back to the marked
        * position, provided that {@code readlimit} has not been surpassed.
        * <p>
        * This implementation sets a mark in the filtered stream.
        *
        * @param {number} readlimit
        * the number of bytes that can be read from this stream before
        * the mark is invalidated.
        * @see #markSupported()
        * @see #reset()
        */


        FilterInputStream.prototype.mark = function (readlimit) {
          this["in"].mark(readlimit);
        };
        /**
        * Indicates whether this stream supports {@code mark()} and {@code reset()}.
        * This implementation returns whether or not the filtered stream supports
        * marking.
        *
        * @return {boolean} {@code true} if {@code mark()} and {@code reset()} are supported,
        * {@code false} otherwise.
        * @see #mark(int)
        * @see #reset()
        * @see #skip(long)
        */


        FilterInputStream.prototype.markSupported = function () {
          return this["in"].markSupported();
        };

        FilterInputStream.prototype.read = function (buffer, byteOffset, byteCount) {
          if ((buffer != null && buffer instanceof Array && (buffer.length == 0 || buffer[0] == null || typeof buffer[0] === 'number') || buffer === null) && (typeof byteOffset === 'number' || byteOffset === null) && (typeof byteCount === 'number' || byteCount === null)) {
            return _super.prototype.read.call(this, buffer, byteOffset, byteCount);
          } else if ((buffer != null && buffer instanceof Array && (buffer.length == 0 || buffer[0] == null || typeof buffer[0] === 'number') || buffer === null) && byteOffset === undefined && byteCount === undefined) {
            return this.read$byte_A(buffer);
          } else if (buffer === undefined && byteOffset === undefined && byteCount === undefined) {
            return this.read$();
          } else throw new Error('invalid overload');
        };

        FilterInputStream.prototype.read$ = function () {
          return this["in"].read$();
        };
        /**
        * Resets this stream to the last marked location. This implementation
        * resets the target stream.
        *
        * @throws IOException
        * if this stream is already closed, no mark has been set or the
        * mark is no longer valid because more than {@code readlimit}
        * bytes have been read since setting the mark.
        * @see #mark(int)
        * @see #markSupported()
        */


        FilterInputStream.prototype.reset = function () {
          this["in"].reset();
        };
        /**
        * Skips {@code byteCount} bytes in this stream. Subsequent
        * calls to {@code read} will not return these bytes unless {@code reset} is
        * used. This implementation skips {@code byteCount} bytes in the
        * filtered stream.
        *
        * @return {number} the number of bytes actually skipped.
        * @throws IOException
        * if this stream is closed or another IOException occurs.
        * @see #mark(int)
        * @see #reset()
        * @param {number} byteCount
        */


        FilterInputStream.prototype.skip = function (byteCount) {
          return this["in"].skip(byteCount);
        };

        return FilterInputStream;
      }(java.io.InputStream);

      io.FilterInputStream = FilterInputStream;
      FilterInputStream["__class"] = "java.io.FilterInputStream";
      FilterInputStream["__interfaces"] = ["java.io.Closeable", "java.lang.AutoCloseable"];
    })(java.io || (java.io = {}));
  })(java || (java = {}));

  (function (java) {
    (function (io) {
      /**
      * Constructs a new {@code ByteArrayInputStream} on the byte array
      * {@code buf} with the initial position set to {@code offset} and the
      * number of bytes available set to {@code offset} + {@code length}.
      *
      * @param {Array} buf
      * the byte array to stream over.
      * @param {number} offset
      * the initial position in {@code buf} to start streaming from.
      * @param {number} length
      * the number of bytes available for streaming.
      * @class
      * @extends java.io.InputStream
      */
      var ByteArrayInputStream =
      /** @class */
      function (_super) {
        __extends(ByteArrayInputStream, _super);

        function ByteArrayInputStream(buf, offset, length) {
          var _this = this;

          if ((buf != null && buf instanceof Array && (buf.length == 0 || buf[0] == null || typeof buf[0] === 'number') || buf === null) && (typeof offset === 'number' || offset === null) && (typeof length === 'number' || length === null)) {
            _this = _super.call(this) || this;

            if (_this.buf === undefined) {
              _this.buf = null;
            }

            if (_this.pos === undefined) {
              _this.pos = 0;
            }

            if (_this._mark === undefined) {
              _this._mark = 0;
            }

            if (_this.count === undefined) {
              _this.count = 0;
            }

            if (length === -1) {
              length = buf.length;
            }

            _this.buf = buf;
            _this.pos = offset;
            _this._mark = offset;
            _this.count = offset + length > buf.length ? buf.length : offset + length;
          } else if ((buf != null && buf instanceof Array && (buf.length == 0 || buf[0] == null || typeof buf[0] === 'number') || buf === null) && offset === undefined && length === undefined) {
            {
              var offset_1 = 0;
              var length_1 = -1;
              _this = _super.call(this) || this;

              if (_this.buf === undefined) {
                _this.buf = null;
              }

              if (_this.pos === undefined) {
                _this.pos = 0;
              }

              if (_this._mark === undefined) {
                _this._mark = 0;
              }

              if (_this.count === undefined) {
                _this.count = 0;
              }

              if (length_1 === -1) {
                length_1 = buf.length;
              }

              _this.buf = buf;
              _this.pos = offset_1;
              _this._mark = offset_1;
              _this.count = offset_1 + length_1 > buf.length ? buf.length : offset_1 + length_1;
            }

            if (_this.buf === undefined) {
              _this.buf = null;
            }

            if (_this.pos === undefined) {
              _this.pos = 0;
            }

            if (_this._mark === undefined) {
              _this._mark = 0;
            }

            if (_this.count === undefined) {
              _this.count = 0;
            }
          } else throw new Error('invalid overload');

          return _this;
        }
        /**
        * Returns the number of remaining bytes.
        *
        * @return {number} {@code count - pos}
        */


        ByteArrayInputStream.prototype.available = function () {
          return this.count - this.pos;
        };
        /**
        * Closes this stream and frees resources associated with this stream.
        *
        * @throws IOException
        * if an I/O error occurs while closing this stream.
        */


        ByteArrayInputStream.prototype.close = function () {};
        /**
        * Sets a mark position in this ByteArrayInputStream. The parameter
        * {@code readlimit} is ignored. Sending {@code reset()} will reposition the
        * stream back to the marked position.
        *
        * @param {number} readlimit
        * ignored.
        * @see #markSupported()
        * @see #reset()
        */


        ByteArrayInputStream.prototype.mark = function (readlimit) {
          this._mark = this.pos;
        };
        /**
        * Indicates whether this stream supports the {@code mark()} and
        * {@code reset()} methods. Returns {@code true} since this class supports
        * these methods.
        *
        * @return {boolean} always {@code true}.
        * @see #mark(int)
        * @see #reset()
        */


        ByteArrayInputStream.prototype.markSupported = function () {
          return true;
        };

        ByteArrayInputStream.prototype.read$ = function () {
          return this.read$byte_A$int$int(null, 0, 0);
        };

        ByteArrayInputStream.prototype.read$byte_A$int$int = function (buffer, byteOffset, byteCount) {
          if (buffer == null) {
            return this.pos < this.count ? this.buf[this.pos++] & 255 : -1;
          }

          java.io.IOUtils.checkOffsetAndCount$byte_A$int$int(buffer, byteOffset, byteCount);

          if (this.pos >= this.count) {
            return -1;
          }

          if (byteCount === 0) {
            return 0;
          }

          var copylen = this.count - this.pos < byteCount ? this.count - this.pos : byteCount;
          java.lang.System.arraycopy(this.buf, this.pos, buffer, byteOffset, copylen);
          this.pos += copylen;
          return copylen;
        };
        /**
        *
        * @param {Array} buffer
        * @param {number} byteOffset
        * @param {number} byteCount
        * @return {number}
        */


        ByteArrayInputStream.prototype.read = function (buffer, byteOffset, byteCount) {
          if ((buffer != null && buffer instanceof Array && (buffer.length == 0 || buffer[0] == null || typeof buffer[0] === 'number') || buffer === null) && (typeof byteOffset === 'number' || byteOffset === null) && (typeof byteCount === 'number' || byteCount === null)) {
            return this.read$byte_A$int$int(buffer, byteOffset, byteCount);
          } else if ((buffer != null && buffer instanceof Array && (buffer.length == 0 || buffer[0] == null || typeof buffer[0] === 'number') || buffer === null) && byteOffset === undefined && byteCount === undefined) {
            return this.read$byte_A(buffer);
          } else if (buffer === undefined && byteOffset === undefined && byteCount === undefined) {
            return this.read$();
          } else throw new Error('invalid overload');
        };
        /**
        * Resets this stream to the last marked location. This implementation
        * resets the position to either the marked position, the start position
        * supplied in the constructor or 0 if neither has been provided.
        *
        * @see #mark(int)
        */


        ByteArrayInputStream.prototype.reset = function () {
          this.pos = this._mark;
        };
        /**
        * Skips {@code byteCount} bytes in this InputStream. Subsequent calls to
        * {@code read} will not return these bytes unless {@code reset} is used.
        * This implementation skips {@code byteCount} number of bytes in the target
        * stream. It does nothing and returns 0 if {@code byteCount} is negative.
        *
        * @return {number} the number of bytes actually skipped.
        * @param {number} byteCount
        */


        ByteArrayInputStream.prototype.skip = function (byteCount) {
          if (byteCount <= 0) {
            return 0;
          }

          var temp = this.pos;
          this.pos = this.count - this.pos < byteCount ? this.count : this.pos + byteCount | 0;
          return this.pos - temp;
        };

        return ByteArrayInputStream;
      }(java.io.InputStream);

      io.ByteArrayInputStream = ByteArrayInputStream;
      ByteArrayInputStream["__class"] = "java.io.ByteArrayInputStream";
      ByteArrayInputStream["__interfaces"] = ["java.io.Closeable", "java.lang.AutoCloseable"];
    })(java.io || (java.io = {}));
  })(java || (java = {}));

  (function (java) {
    (function (io) {
      /**
      * JSweet implementation.
      * @param {java.io.Reader} in
      * @param {number} sz
      * @class
      * @extends java.io.Reader
      */
      var BufferedReader =
      /** @class */
      function (_super) {
        __extends(BufferedReader, _super);

        function BufferedReader(__in, sz) {
          var _this = this;

          if ((__in != null && __in instanceof java.io.Reader || __in === null) && (typeof sz === 'number' || sz === null)) {
            _this = _super.call(this, __in) || this;

            if (_this["in"] === undefined) {
              _this["in"] = null;
            }

            if (_this.cb === undefined) {
              _this.cb = null;
            }

            if (_this.nChars === undefined) {
              _this.nChars = 0;
            }

            if (_this.nextChar === undefined) {
              _this.nextChar = 0;
            }

            if (_this.markedChar === undefined) {
              _this.markedChar = 0;
            }

            if (_this.readAheadLimit === undefined) {
              _this.readAheadLimit = 0;
            }

            if (_this.skipLF === undefined) {
              _this.skipLF = false;
            }

            if (_this.markedSkipLF === undefined) {
              _this.markedSkipLF = false;
            }

            _this.markedChar = BufferedReader.UNMARKED;
            _this.readAheadLimit = 0;
            _this.skipLF = false;
            _this.markedSkipLF = false;
            if (sz <= 0) throw new java.lang.IllegalArgumentException("Buffer size <= 0");
            _this["in"] = __in;

            _this.cb = function (s) {
              var a = [];

              while (s-- > 0) {
                a.push(null);
              }

              return a;
            }(sz);

            _this.nextChar = _this.nChars = 0;
          } else if ((__in != null && __in instanceof java.io.Reader || __in === null) && sz === undefined) {
            {
              var sz_1 = BufferedReader.defaultCharBufferSize;
              _this = _super.call(this, __in) || this;

              if (_this["in"] === undefined) {
                _this["in"] = null;
              }

              if (_this.cb === undefined) {
                _this.cb = null;
              }

              if (_this.nChars === undefined) {
                _this.nChars = 0;
              }

              if (_this.nextChar === undefined) {
                _this.nextChar = 0;
              }

              if (_this.markedChar === undefined) {
                _this.markedChar = 0;
              }

              if (_this.readAheadLimit === undefined) {
                _this.readAheadLimit = 0;
              }

              if (_this.skipLF === undefined) {
                _this.skipLF = false;
              }

              if (_this.markedSkipLF === undefined) {
                _this.markedSkipLF = false;
              }

              _this.markedChar = BufferedReader.UNMARKED;
              _this.readAheadLimit = 0;
              _this.skipLF = false;
              _this.markedSkipLF = false;
              if (sz_1 <= 0) throw new java.lang.IllegalArgumentException("Buffer size <= 0");
              _this["in"] = __in;

              _this.cb = function (s) {
                var a = [];

                while (s-- > 0) {
                  a.push(null);
                }

                return a;
              }(sz_1);

              _this.nextChar = _this.nChars = 0;
            }

            if (_this["in"] === undefined) {
              _this["in"] = null;
            }

            if (_this.cb === undefined) {
              _this.cb = null;
            }

            if (_this.nChars === undefined) {
              _this.nChars = 0;
            }

            if (_this.nextChar === undefined) {
              _this.nextChar = 0;
            }

            if (_this.markedChar === undefined) {
              _this.markedChar = 0;
            }

            if (_this.readAheadLimit === undefined) {
              _this.readAheadLimit = 0;
            }

            if (_this.skipLF === undefined) {
              _this.skipLF = false;
            }

            if (_this.markedSkipLF === undefined) {
              _this.markedSkipLF = false;
            }
          } else throw new Error('invalid overload');

          return _this;
        }
        /*private*/


        BufferedReader.prototype.ensureOpen = function () {
          if (this["in"] == null) throw new java.io.IOException("Stream closed");
        };
        /*private*/


        BufferedReader.prototype.fill = function () {
          var dst;

          if (this.markedChar <= BufferedReader.UNMARKED) {
            dst = 0;
          } else {
            var delta = this.nextChar - this.markedChar;

            if (delta >= this.readAheadLimit) {
              this.markedChar = BufferedReader.INVALIDATED;
              this.readAheadLimit = 0;
              dst = 0;
            } else {
              if (this.readAheadLimit <= this.cb.length) {
                java.lang.System.arraycopy(this.cb, this.markedChar, this.cb, 0, delta);
                this.markedChar = 0;
                dst = delta;
              } else {
                var ncb = function (s) {
                  var a = [];

                  while (s-- > 0) {
                    a.push(null);
                  }

                  return a;
                }(this.readAheadLimit);

                java.lang.System.arraycopy(this.cb, this.markedChar, ncb, 0, delta);
                this.cb = ncb;
                this.markedChar = 0;
                dst = delta;
              }

              this.nextChar = this.nChars = delta;
            }
          }

          var n;

          do {
            {
              n = this["in"].read$char_A$int$int(this.cb, dst, this.cb.length - dst);
            }
          } while (n === 0);

          if (n > 0) {
            this.nChars = dst + n;
            this.nextChar = dst;
          }
        };

        BufferedReader.prototype.read$ = function () {
          {
            this.ensureOpen();

            for (;;) {
              {
                if (this.nextChar >= this.nChars) {
                  this.fill();
                  if (this.nextChar >= this.nChars) return -1;
                }

                if (this.skipLF) {
                  this.skipLF = false;

                  if (function (c) {
                    return c.charCodeAt == null ? c : c.charCodeAt(0);
                  }(this.cb[this.nextChar]) == '\n'.charCodeAt(0)) {
                    this.nextChar++;
                    continue;
                  }
                }

                return this.cb[this.nextChar++].charCodeAt(0);
              }
            }
          }
        };
        /*private*/


        BufferedReader.prototype.read1 = function (cbuf, off, len) {
          if (this.nextChar >= this.nChars) {
            if (len >= this.cb.length && this.markedChar <= BufferedReader.UNMARKED && !this.skipLF) {
              return this["in"].read$char_A$int$int(cbuf, off, len);
            }

            this.fill();
          }

          if (this.nextChar >= this.nChars) return -1;

          if (this.skipLF) {
            this.skipLF = false;

            if (function (c) {
              return c.charCodeAt == null ? c : c.charCodeAt(0);
            }(this.cb[this.nextChar]) == '\n'.charCodeAt(0)) {
              this.nextChar++;
              if (this.nextChar >= this.nChars) this.fill();
              if (this.nextChar >= this.nChars) return -1;
            }
          }

          var n = Math.min(len, this.nChars - this.nextChar);
          java.lang.System.arraycopy(this.cb, this.nextChar, cbuf, off, n);
          this.nextChar += n;
          return n;
        };

        BufferedReader.prototype.read$char_A$int$int = function (cbuf, off, len) {
          {
            this.ensureOpen();

            if (off < 0 || off > cbuf.length || len < 0 || off + len > cbuf.length || off + len < 0) {
              throw new java.lang.IndexOutOfBoundsException();
            } else if (len === 0) {
              return 0;
            }

            var n = this.read1(cbuf, off, len);
            if (n <= 0) return n;

            while (n < len && this["in"].ready()) {
              {
                var n1 = this.read1(cbuf, off + n, len - n);
                if (n1 <= 0) break;
                n += n1;
              }
            }

            return n;
          }
        };

        BufferedReader.prototype.read = function (cbuf, off, len) {
          if ((cbuf != null && cbuf instanceof Array && (cbuf.length == 0 || cbuf[0] == null || typeof cbuf[0] === 'string') || cbuf === null) && (typeof off === 'number' || off === null) && (typeof len === 'number' || len === null)) {
            return this.read$char_A$int$int(cbuf, off, len);
          } else if ((cbuf != null && cbuf instanceof Array && (cbuf.length == 0 || cbuf[0] == null || typeof cbuf[0] === 'string') || cbuf === null) && off === undefined && len === undefined) {
            return this.read$char_A(cbuf);
          } else if (cbuf === undefined && off === undefined && len === undefined) {
            return this.read$();
          } else throw new Error('invalid overload');
        };

        BufferedReader.prototype.readLine$boolean = function (ignoreLF) {
          var s = null;
          var startChar;
          {
            this.ensureOpen();
            var omitLF = ignoreLF || this.skipLF;

            for (;;) {
              {
                if (this.nextChar >= this.nChars) this.fill();

                if (this.nextChar >= this.nChars) {
                  if (s != null && s.length() > 0) return s.toString();else return null;
                }

                var eol = false;
                var c = String.fromCharCode(0);
                var i = void 0;
                if (omitLF && function (c) {
                  return c.charCodeAt == null ? c : c.charCodeAt(0);
                }(this.cb[this.nextChar]) == '\n'.charCodeAt(0)) this.nextChar++;
                this.skipLF = false;
                omitLF = false;

                charLoop: for (i = this.nextChar; i < this.nChars; i++) {
                  {
                    c = this.cb[i];

                    if (function (c) {
                      return c.charCodeAt == null ? c : c.charCodeAt(0);
                    }(c) == '\n'.charCodeAt(0) || function (c) {
                      return c.charCodeAt == null ? c : c.charCodeAt(0);
                    }(c) == '\r'.charCodeAt(0)) {
                      eol = true;
                      break charLoop;
                    }
                  }
                }

                startChar = this.nextChar;
                this.nextChar = i;

                if (eol) {
                  var str = void 0;

                  if (s == null) {
                    str = function (str, index, len) {
                      return str.substring(index, index + len);
                    }(this.cb.join(''), startChar, i - startChar);
                  } else {
                    s.append$char_A$int$int(this.cb, startChar, i - startChar);
                    str = s.toString();
                  }

                  this.nextChar++;

                  if (function (c) {
                    return c.charCodeAt == null ? c : c.charCodeAt(0);
                  }(c) == '\r'.charCodeAt(0)) {
                    this.skipLF = true;
                  }

                  return str;
                }

                if (s == null) s = new java.lang.StringBuffer(BufferedReader.defaultExpectedLineLength);
                s.append$char_A$int$int(this.cb, startChar, i - startChar);
              }
            }
          }
        };

        BufferedReader.prototype.readLine = function (ignoreLF) {
          if (typeof ignoreLF === 'boolean' || ignoreLF === null) {
            return this.readLine$boolean(ignoreLF);
          } else if (ignoreLF === undefined) {
            return this.readLine$();
          } else throw new Error('invalid overload');
        };

        BufferedReader.prototype.readLine$ = function () {
          return this.readLine$boolean(false);
        };

        BufferedReader.prototype.skip = function (n) {
          if (n < 0) {
            throw new java.lang.IllegalArgumentException("skip value is negative");
          }

          {
            this.ensureOpen();
            var r = n;

            while (r > 0) {
              {
                if (this.nextChar >= this.nChars) this.fill();
                if (this.nextChar >= this.nChars) break;

                if (this.skipLF) {
                  this.skipLF = false;

                  if (function (c) {
                    return c.charCodeAt == null ? c : c.charCodeAt(0);
                  }(this.cb[this.nextChar]) == '\n'.charCodeAt(0)) {
                    this.nextChar++;
                  }
                }

                var d = this.nChars - this.nextChar;

                if (r <= d) {
                  this.nextChar += r;
                  r = 0;
                  break;
                } else {
                  r -= d;
                  this.nextChar = this.nChars;
                }
              }
            }

            return n - r;
          }
        };

        BufferedReader.prototype.ready = function () {
          this.ensureOpen();

          if (this.skipLF) {
            if (this.nextChar >= this.nChars && this["in"].ready()) {
              this.fill();
            }

            if (this.nextChar < this.nChars) {
              if (function (c) {
                return c.charCodeAt == null ? c : c.charCodeAt(0);
              }(this.cb[this.nextChar]) == '\n'.charCodeAt(0)) this.nextChar++;
              this.skipLF = false;
            }
          }

          return this.nextChar < this.nChars || this["in"].ready();
        };

        BufferedReader.prototype.markSupported = function () {
          return true;
        };

        BufferedReader.prototype.mark = function (readAheadLimit) {
          if (readAheadLimit < 0) {
            throw new java.lang.IllegalArgumentException("Read-ahead limit < 0");
          }

          this.ensureOpen();
          this.readAheadLimit = readAheadLimit;
          this.markedChar = this.nextChar;
          this.markedSkipLF = this.skipLF;
        };

        BufferedReader.prototype.reset = function () {
          this.ensureOpen();
          if (this.markedChar < 0) throw new java.io.IOException(this.markedChar === BufferedReader.INVALIDATED ? "Mark invalid" : "Stream not marked");
          this.nextChar = this.markedChar;
          this.skipLF = this.markedSkipLF;
        };

        BufferedReader.prototype.close = function () {
          if (this["in"] == null) return;

          try {
            this["in"].close();
          } finally {
            this["in"] = null;
            this.cb = null;
          }
        };

        BufferedReader.INVALIDATED = -2;
        BufferedReader.UNMARKED = -1;
        BufferedReader.defaultCharBufferSize = 8192;
        BufferedReader.defaultExpectedLineLength = 80;
        return BufferedReader;
      }(java.io.Reader);

      io.BufferedReader = BufferedReader;
      BufferedReader["__class"] = "java.io.BufferedReader";
      BufferedReader["__interfaces"] = ["java.io.Closeable", "java.lang.AutoCloseable"];
    })(java.io || (java.io = {}));
  })(java || (java = {}));

  (function (java) {
    (function (io) {
      /**
      * JSweet implementation.
      * @param {java.io.InputStream} in
      * @param {string} charsetName
      * @class
      * @extends java.io.Reader
      */
      var InputStreamReader =
      /** @class */
      function (_super) {
        __extends(InputStreamReader, _super);

        function InputStreamReader(__in, charsetName) {
          var _this = this;

          if ((__in != null && __in instanceof java.io.InputStream || __in === null) && (typeof charsetName === 'string' || charsetName === null)) {
            var __args = arguments;
            _this = _super.call(this, __in) || this;

            if (_this["in"] === undefined) {
              _this["in"] = null;
            }

            _this["in"] = __in;
          } else if ((__in != null && __in instanceof java.io.InputStream || __in === null) && (charsetName != null && charsetName instanceof java.nio.charset.Charset || charsetName === null)) {
            var __args = arguments;
            var cs = __args[1];
            _this = _super.call(this, __in) || this;

            if (_this["in"] === undefined) {
              _this["in"] = null;
            }

            _this["in"] = __in;
            if (cs == null) throw new java.lang.NullPointerException("charset");
          } else if ((__in != null && __in instanceof java.io.InputStream || __in === null) && charsetName === undefined) {
            var __args = arguments;
            _this = _super.call(this, __in) || this;

            if (_this["in"] === undefined) {
              _this["in"] = null;
            }

            _this["in"] = __in;
          } else throw new Error('invalid overload');

          return _this;
        }

        InputStreamReader.prototype.read$char_A$int$int = function (cbuf, offset, length) {
          var buf = function (s) {
            var a = [];

            while (s-- > 0) {
              a.push(0);
            }

            return a;
          }(length - offset);

          var success = this["in"].read$byte_A$int$int(buf, 0, length);

          if (success > 0) {
            for (var i = 0; i < success; ++i) {
              {
                cbuf[i + offset] = String.fromCharCode(buf[i]).charAt(0);
              }
            }
          }

          return success;
        };

        InputStreamReader.prototype.read = function (cbuf, offset, length) {
          if ((cbuf != null && cbuf instanceof Array && (cbuf.length == 0 || cbuf[0] == null || typeof cbuf[0] === 'string') || cbuf === null) && (typeof offset === 'number' || offset === null) && (typeof length === 'number' || length === null)) {
            return this.read$char_A$int$int(cbuf, offset, length);
          } else if ((cbuf != null && cbuf instanceof Array && (cbuf.length == 0 || cbuf[0] == null || typeof cbuf[0] === 'string') || cbuf === null) && offset === undefined && length === undefined) {
            return this.read$char_A(cbuf);
          } else if (cbuf === undefined && offset === undefined && length === undefined) {
            return this.read$();
          } else throw new Error('invalid overload');
        };

        InputStreamReader.prototype.ready = function () {
          return this["in"].available() > 0;
        };

        InputStreamReader.prototype.close = function () {
          this["in"].close();
        };

        return InputStreamReader;
      }(java.io.Reader);

      io.InputStreamReader = InputStreamReader;
      InputStreamReader["__class"] = "java.io.InputStreamReader";
      InputStreamReader["__interfaces"] = ["java.io.Closeable", "java.lang.AutoCloseable"];
    })(java.io || (java.io = {}));
  })(java || (java = {}));

  (function (java) {
    (function (io) {
      var StringReader =
      /** @class */
      function (_super) {
        __extends(StringReader, _super);

        function StringReader(start) {
          var _this = _super.call(this) || this;

          if (_this.charArray === undefined) {
            _this.charArray = null;
          }

          if (_this.where === undefined) {
            _this.where = 0;
          }

          _this.marked = -1;

          if (_this.markedLen === undefined) {
            _this.markedLen = 0;
          }

          _this.charArray =
          /* toCharArray */
          start.split('');
          return _this;
        }

        StringReader.prototype.read$char_A$int$int = function (cbuf, off, len) {
          if (off < 0 || off > cbuf.length || len < 0 || off + len > cbuf.length || off + len < 0) {
            throw new java.lang.IndexOutOfBoundsException();
          } else if (len === 0) {
            return 0;
          }

          if (this.where === this.charArray.length) return -1;
          var size = Math.min(this.charArray.length - this.where, len);
          java.lang.System.arraycopy(this.charArray, this.where, cbuf, off, size);
          this.where += size;
          return size;
        };
        /**
        *
        * @param {Array} cbuf
        * @param {number} off
        * @param {number} len
        * @return {number}
        */


        StringReader.prototype.read = function (cbuf, off, len) {
          if ((cbuf != null && cbuf instanceof Array && (cbuf.length == 0 || cbuf[0] == null || typeof cbuf[0] === 'string') || cbuf === null) && (typeof off === 'number' || off === null) && (typeof len === 'number' || len === null)) {
            return this.read$char_A$int$int(cbuf, off, len);
          } else if ((cbuf != null && cbuf instanceof Array && (cbuf.length == 0 || cbuf[0] == null || typeof cbuf[0] === 'string') || cbuf === null) && off === undefined && len === undefined) {
            return this.read$char_A(cbuf);
          } else if (cbuf === undefined && off === undefined && len === undefined) {
            return this.read$();
          } else throw new Error('invalid overload');
        };
        /**
        *
        */


        StringReader.prototype.close = function () {
          this.where = this.charArray.length;
        };
        /**
        *
        * @return {boolean}
        */


        StringReader.prototype.ready = function () {
          return this.where < this.charArray.length;
        };
        /**
        *
        * @return {boolean}
        */


        StringReader.prototype.markSupported = function () {
          return true;
        };
        /**
        *
        * @param {number} readAheadLimit
        */


        StringReader.prototype.mark = function (readAheadLimit) {
          this.marked = this.where;
          this.markedLen = readAheadLimit;
        };
        /**
        *
        */


        StringReader.prototype.reset = function () {
          if (this.marked === -1 || this.where > this.marked + this.markedLen) {
            throw new java.io.IOException("The stream not been marked or mark has been invalidated");
          }

          this.where = this.marked;
        };

        return StringReader;
      }(java.io.Reader);

      io.StringReader = StringReader;
      StringReader["__class"] = "java.io.StringReader";
      StringReader["__interfaces"] = ["java.io.Closeable", "java.lang.AutoCloseable"];
    })(java.io || (java.io = {}));
  })(java || (java = {}));

  (function (java) {
    (function (io) {
      /**
      * Constructs a new {@code FilterOutputStream} with {@code out} as its
      * target stream.
      *
      * @param {java.io.OutputStream} out
      * the target stream that this stream writes to.
      * @class
      * @extends java.io.OutputStream
      */
      var FilterOutputStream =
      /** @class */
      function (_super) {
        __extends(FilterOutputStream, _super);

        function FilterOutputStream(out) {
          var _this = _super.call(this) || this;

          if (_this.out === undefined) {
            _this.out = null;
          }

          _this.out = out;
          return _this;
        }
        /**
        * Closes this stream. This implementation closes the target stream.
        *
        * @throws IOException
        * if an error occurs attempting to close this stream.
        */


        FilterOutputStream.prototype.close = function () {
          var thrown = null;

          try {
            this.flush();
          } catch (e) {
            thrown = e;
          }

          try {
            this.out.close();
          } catch (e) {
            if (thrown == null) {
              thrown = e;
            }
          }

          if (thrown != null) {
            throw new java.io.IOException(thrown);
          }
        };
        /**
        * Ensures that all pending data is sent out to the target stream. This
        * implementation flushes the target stream.
        *
        * @throws IOException
        * if an error occurs attempting to flush this stream.
        */


        FilterOutputStream.prototype.flush = function () {
          this.out.flush();
        };

        FilterOutputStream.prototype.write = function (buffer, offset, count) {
          if ((buffer != null && buffer instanceof Array && (buffer.length == 0 || buffer[0] == null || typeof buffer[0] === 'number') || buffer === null) && (typeof offset === 'number' || offset === null) && (typeof count === 'number' || count === null)) {
            _super.prototype.write.call(this, buffer, offset, count);
          } else if ((buffer != null && buffer instanceof Array && (buffer.length == 0 || buffer[0] == null || typeof buffer[0] === 'number') || buffer === null) && offset === undefined && count === undefined) {
            return this.write$byte_A(buffer);
          } else if ((typeof buffer === 'number' || buffer === null) && offset === undefined && count === undefined) {
            return this.write$int(buffer);
          } else throw new Error('invalid overload');
        };

        FilterOutputStream.prototype.write$int = function (oneByte) {
          this.out.write$int(oneByte);
        };

        return FilterOutputStream;
      }(java.io.OutputStream);

      io.FilterOutputStream = FilterOutputStream;
      FilterOutputStream["__class"] = "java.io.FilterOutputStream";
      FilterOutputStream["__interfaces"] = ["java.io.Closeable", "java.lang.AutoCloseable", "java.io.Flushable"];
    })(java.io || (java.io = {}));
  })(java || (java = {}));

  (function (java) {
    (function (io) {
      /**
      * Constructs a new {@code ByteArrayOutputStream} with a default size of
      * {@code size} bytes. If more than {@code size} bytes are written to this
      * instance, the underlying byte array will expand.
      *
      * @param {number} size
      * initial size for the underlying byte array, must be
      * non-negative.
      * @throws IllegalArgumentException
      * if {@code size} < 0.
      * @class
      * @extends java.io.OutputStream
      */
      var ByteArrayOutputStream =
      /** @class */
      function (_super) {
        __extends(ByteArrayOutputStream, _super);

        function ByteArrayOutputStream(size) {
          var _this = this;

          if (typeof size === 'number' || size === null) {
            _this = _super.call(this) || this;

            if (_this.buf === undefined) {
              _this.buf = null;
            }

            if (_this.count === undefined) {
              _this.count = 0;
            }

            if (size >= 0) {
              _this.buf = function (s) {
                var a = [];

                while (s-- > 0) {
                  a.push(0);
                }

                return a;
              }(size);
            } else {
              throw new java.lang.IllegalArgumentException("size < 0");
            }
          } else if (size === undefined) {
            _this = _super.call(this) || this;

            if (_this.buf === undefined) {
              _this.buf = null;
            }

            if (_this.count === undefined) {
              _this.count = 0;
            }

            _this.buf = function (s) {
              var a = [];

              while (s-- > 0) {
                a.push(0);
              }

              return a;
            }(32);
          } else throw new Error('invalid overload');

          return _this;
        }
        /**
        * Closes this stream. This releases system resources used for this stream.
        *
        * @throws IOException
        * if an error occurs while attempting to close this stream.
        */


        ByteArrayOutputStream.prototype.close = function () {
          _super.prototype.close.call(this);
        };
        /*private*/


        ByteArrayOutputStream.prototype.expand = function (i) {
          if (this.count + i <= this.buf.length) {
            return;
          }

          var newbuf = function (s) {
            var a = [];

            while (s-- > 0) {
              a.push(0);
            }

            return a;
          }((this.count + i) * 2);

          java.lang.System.arraycopy(this.buf, 0, newbuf, 0, this.count);
          this.buf = newbuf;
        };
        /**
        * Resets this stream to the beginning of the underlying byte array. All
        * subsequent writes will overwrite any bytes previously stored in this
        * stream.
        */


        ByteArrayOutputStream.prototype.reset = function () {
          this.count = 0;
        };
        /**
        * Returns the total number of bytes written to this stream so far.
        *
        * @return {number} the number of bytes written to this stream.
        */


        ByteArrayOutputStream.prototype.size = function () {
          return this.count;
        };
        /**
        * Returns the contents of this ByteArrayOutputStream as a byte array. Any
        * changes made to the receiver after returning will not be reflected in the
        * byte array returned to the caller.
        *
        * @return {Array} this stream's current contents as a byte array.
        */


        ByteArrayOutputStream.prototype.toByteArray = function () {
          var newArray = function (s) {
            var a = [];

            while (s-- > 0) {
              a.push(0);
            }

            return a;
          }(this.count);

          java.lang.System.arraycopy(this.buf, 0, newArray, 0, this.count);
          return newArray;
        };

        ByteArrayOutputStream.prototype.toString$ = function () {
          return function (str, index, len) {
            return str.substring(index, index + len);
          }(this.buf.map(function (s) {
            return String.fromCharCode(s);
          }).join(''), 0, this.count);
        };

        ByteArrayOutputStream.prototype.toString$int = function (hibyte) {
          var newBuf = function (s) {
            var a = [];

            while (s-- > 0) {
              a.push(null);
            }

            return a;
          }(this.size());

          for (var i = 0; i < newBuf.length; i++) {
            {
              newBuf[i] = String.fromCharCode((hibyte & 255) << 8 | this.buf[i] & 255);
            }
          }

          return new String(newBuf);
        };

        ByteArrayOutputStream.prototype.toString$java_lang_String = function (charsetName) {
          return function (str, index, len) {
            return str.substring(index, index + len);
          }(this.buf.map(function (s) {
            return String.fromCharCode(s);
          }).join(''), 0, this.count);
        };
        /**
        * Returns the contents of this ByteArrayOutputStream as a string converted
        * according to the encoding declared in {@code charsetName}.
        *
        * @param {string} charsetName
        * a string representing the encoding to use when translating
        * this stream to a string.
        * @return {string} this stream's current contents as an encoded string.
        * @throws UnsupportedEncodingException
        * if the provided encoding is not supported.
        */


        ByteArrayOutputStream.prototype.toString = function (charsetName) {
          if (typeof charsetName === 'string' || charsetName === null) {
            return this.toString$java_lang_String(charsetName);
          } else if (typeof charsetName === 'number' || charsetName === null) {
            return this.toString$int(charsetName);
          } else if (charsetName === undefined) {
            return this.toString$();
          } else throw new Error('invalid overload');
        };

        ByteArrayOutputStream.prototype.write$byte_A$int$int = function (buffer, offset, len) {
          java.io.IOUtils.checkOffsetAndCount$byte_A$int$int(buffer, offset, len);

          if (len === 0) {
            return;
          }

          this.expand(len);
          java.lang.System.arraycopy(buffer, offset, this.buf, this.count, len);
          this.count += len;
        };
        /**
        * Writes {@code count} bytes from the byte array {@code buffer} starting at
        * offset {@code index} to this stream.
        *
        * @param {Array} buffer
        * the buffer to be written.
        * @param {number} offset
        * the initial position in {@code buffer} to retrieve bytes.
        * @param {number} len
        * the number of bytes of {@code buffer} to write.
        * @throws NullPointerException
        * if {@code buffer} is {@code null}.
        * @throws IndexOutOfBoundsException
        * if {@code offset < 0} or {@code len < 0}, or if
        * {@code offset + len} is greater than the length of
        * {@code buffer}.
        */


        ByteArrayOutputStream.prototype.write = function (buffer, offset, len) {
          if ((buffer != null && buffer instanceof Array && (buffer.length == 0 || buffer[0] == null || typeof buffer[0] === 'number') || buffer === null) && (typeof offset === 'number' || offset === null) && (typeof len === 'number' || len === null)) {
            return this.write$byte_A$int$int(buffer, offset, len);
          } else if ((buffer != null && buffer instanceof Array && (buffer.length == 0 || buffer[0] == null || typeof buffer[0] === 'number') || buffer === null) && offset === undefined && len === undefined) {
            return this.write$byte_A(buffer);
          } else if ((typeof buffer === 'number' || buffer === null) && offset === undefined && len === undefined) {
            return this.write$int(buffer);
          } else throw new Error('invalid overload');
        };

        ByteArrayOutputStream.prototype.write$int = function (oneByte) {
          if (this.count === this.buf.length) {
            this.expand(1);
          }

          this.buf[this.count++] = oneByte | 0;
        };
        /**
        * Takes the contents of this stream and writes it to the output stream
        * {@code out}.
        *
        * @param {java.io.OutputStream} out
        * an OutputStream on which to write the contents of this stream.
        * @throws IOException
        * if an error occurs while writing to {@code out}.
        */


        ByteArrayOutputStream.prototype.writeTo = function (out) {
          out.write$byte_A$int$int(this.buf, 0, this.count);
        };

        return ByteArrayOutputStream;
      }(java.io.OutputStream);

      io.ByteArrayOutputStream = ByteArrayOutputStream;
      ByteArrayOutputStream["__class"] = "java.io.ByteArrayOutputStream";
      ByteArrayOutputStream["__interfaces"] = ["java.io.Closeable", "java.lang.AutoCloseable", "java.io.Flushable"];
    })(java.io || (java.io = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      (function (ref) {
        /**
        * This implements the reference API in a minimal way. In JavaScript, there is
        * no control over the reference and the GC. So this implementation's only
        * purpose is for compilation.
        * @param {*} referent
        * @class
        * @extends java.lang.ref.Reference
        */
        var WeakReference =
        /** @class */
        function (_super) {
          __extends(WeakReference, _super);

          function WeakReference(referent) {
            return _super.call(this, referent) || this;
          }

          return WeakReference;
        }(java.lang.ref.Reference);

        ref.WeakReference = WeakReference;
        WeakReference["__class"] = "java.lang.ref.WeakReference";
      })(lang.ref || (lang.ref = {}));
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      /**
      * Constructs an {@code InternalError} with the specified detail
      * message and cause.  <p>Note that the detail message associated
      * with {@code cause} is <i>not</i> automatically incorporated in
      * this error's detail message.
      *
      * @param  {string} message the detail message (which is saved for later retrieval
      * by the {@link #getMessage()} method).
      * @param  {java.lang.Throwable} cause the cause (which is saved for later retrieval by the
      * {@link #getCause()} method).  (A {@code null} value is
      * permitted, and indicates that the cause is nonexistent or
      * unknown.)
      * @since  1.8
      * @class
      * @extends java.lang.VirtualMachineError
      * @author  unascribed
      */
      var InternalError =
      /** @class */
      function (_super) {
        __extends(InternalError, _super);

        function InternalError(message, cause) {
          var _this = this;

          if ((typeof message === 'string' || message === null) && (cause != null && cause instanceof Error || cause === null)) {
            var __args = arguments;
            _this = _super.call(this, message, cause) || this;
          } else if ((typeof message === 'string' || message === null) && cause === undefined) {
            var __args = arguments;
            _this = _super.call(this, message) || this;
          } else if ((message != null && message instanceof Error || message === null) && cause === undefined) {
            var __args = arguments;
            var cause_5 = __args[0];
            _this = _super.call(this, cause_5) || this;
          } else if (message === undefined && cause === undefined) {
            var __args = arguments;
            _this = _super.call(this) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        InternalError.__java_lang_InternalError_serialVersionUID = -9062593416125562365;
        return InternalError;
      }(java.lang.VirtualMachineError);

      lang.InternalError = InternalError;
      InternalError["__class"] = "java.lang.InternalError";
      InternalError["__interfaces"] = ["java.io.Serializable"];
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * Thrown when the subject of an observer cannot support additional observers.
      *
      * @param {string} message
      * @class
      * @extends java.lang.Exception
      */
      var TooManyListenersException =
      /** @class */
      function (_super) {
        __extends(TooManyListenersException, _super);

        function TooManyListenersException(message) {
          var _this = this;

          if (typeof message === 'string' || message === null) {
            _this = _super.call(this, message) || this;
            _this.message = message;
          } else if (message === undefined) {
            _this = _super.call(this) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        return TooManyListenersException;
      }(Error);

      util.TooManyListenersException = TooManyListenersException;
      TooManyListenersException["__class"] = "java.util.TooManyListenersException";
      TooManyListenersException["__interfaces"] = ["java.io.Serializable"];
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (security) {
      /**
      * A generic security exception type - <a
      * href="http://java.sun.com/j2se/1.4.2/docs/api/java/security/GeneralSecurityException.html">[Sun's
      * docs]</a>.
      * @param {string} msg
      * @class
      * @extends java.lang.Exception
      */
      var GeneralSecurityException =
      /** @class */
      function (_super) {
        __extends(GeneralSecurityException, _super);

        function GeneralSecurityException(msg) {
          var _this = this;

          if (typeof msg === 'string' || msg === null) {
            _this = _super.call(this, msg) || this;
            _this.message = msg;
          } else if (msg === undefined) {
            _this = _super.call(this) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        return GeneralSecurityException;
      }(Error);

      security.GeneralSecurityException = GeneralSecurityException;
      GeneralSecurityException["__class"] = "java.security.GeneralSecurityException";
      GeneralSecurityException["__interfaces"] = ["java.io.Serializable"];
    })(java.security || (java.security = {}));
  })(java || (java = {}));

  (function (java) {
    (function (io) {
      /**
      * See <a
      * href="http://java.sun.com/javase/6/docs/api/java/io/IOException.html">the
      * official Java API doc</a> for details.
      * @param {string} message
      * @param {java.lang.Throwable} throwable
      * @class
      * @extends java.lang.Exception
      */
      var IOException =
      /** @class */
      function (_super) {
        __extends(IOException, _super);

        function IOException(message, throwable) {
          var _this = this;

          if ((typeof message === 'string' || message === null) && (throwable != null && throwable instanceof Error || throwable === null)) {
            var __args = arguments;
            _this = _super.call(this, message) || this;
            _this.message = message;
          } else if ((typeof message === 'string' || message === null) && throwable === undefined) {
            var __args = arguments;
            _this = _super.call(this, message) || this;
            _this.message = message;
          } else if ((message != null && message instanceof Error || message === null) && throwable === undefined) {
            var __args = arguments;
            var throwable_1 = __args[0];
            _this = _super.call(this, throwable_1) || this;
            _this.message = throwable_1;
          } else if (message === undefined && throwable === undefined) {
            var __args = arguments;
            _this = _super.call(this) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        return IOException;
      }(Error);

      io.IOException = IOException;
      IOException["__class"] = "java.io.IOException";
      IOException["__interfaces"] = ["java.io.Serializable"];
    })(java.io || (java.io = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      /**
      * See <a
      * href="http://java.sun.com/j2se/1.5.0/docs/api/java/lang/RuntimeException.html">the
      * official Java API doc</a> for details.
      * @param {string} message
      * @param {java.lang.Throwable} cause
      * @class
      * @extends java.lang.Exception
      */
      var RuntimeException =
      /** @class */
      function (_super) {
        __extends(RuntimeException, _super);

        function RuntimeException(message, cause, enableSuppression, writableStackTrace) {
          var _this = this;

          if ((typeof message === 'string' || message === null) && (cause != null && cause instanceof Error || cause === null) && (typeof enableSuppression === 'boolean' || enableSuppression === null) && (typeof writableStackTrace === 'boolean' || writableStackTrace === null)) {
            var __args = arguments;
            _this = _super.call(this, message) || this;
            _this.message = message;
          } else if ((typeof message === 'string' || message === null) && (cause != null && cause instanceof Error || cause === null) && enableSuppression === undefined && writableStackTrace === undefined) {
            var __args = arguments;
            _this = _super.call(this, message) || this;
            _this.message = message;
          } else if ((typeof message === 'string' || message === null) && cause === undefined && enableSuppression === undefined && writableStackTrace === undefined) {
            var __args = arguments;
            _this = _super.call(this, message) || this;
            _this.message = message;
          } else if ((message != null && message instanceof Error || message === null) && cause === undefined && enableSuppression === undefined && writableStackTrace === undefined) {
            var __args = arguments;
            var cause_6 = __args[0];
            _this = _super.call(this, cause_6) || this;
            _this.message = cause_6;
          } else if (message === undefined && cause === undefined && enableSuppression === undefined && writableStackTrace === undefined) {
            var __args = arguments;
            _this = _super.call(this) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        return RuntimeException;
      }(Error);

      lang.RuntimeException = RuntimeException;
      RuntimeException["__class"] = "java.lang.RuntimeException";
      RuntimeException["__interfaces"] = ["java.io.Serializable"];
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      /**
      * See <a
      * href="http://java.sun.com/j2se/1.5.0/docs/api/java/lang/CloneNotSupportedException.html">
      * the official Java API doc</a> for details.
      * @param {string} msg
      * @class
      * @extends java.lang.Exception
      */
      var CloneNotSupportedException =
      /** @class */
      function (_super) {
        __extends(CloneNotSupportedException, _super);

        function CloneNotSupportedException(msg) {
          var _this = this;

          if (typeof msg === 'string' || msg === null) {
            _this = _super.call(this, msg) || this;
            _this.message = msg;
          } else if (msg === undefined) {
            _this = _super.call(this) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        return CloneNotSupportedException;
      }(Error);

      lang.CloneNotSupportedException = CloneNotSupportedException;
      CloneNotSupportedException["__class"] = "java.lang.CloneNotSupportedException";
      CloneNotSupportedException["__interfaces"] = ["java.io.Serializable"];
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      /**
      * Constructs an <code>InterruptedException</code> with the
      * specified detail message.
      *
      * @param   {string} s   the detail message.
      * @class
      * @extends java.lang.Exception
      */
      var InterruptedException =
      /** @class */
      function (_super) {
        __extends(InterruptedException, _super);

        function InterruptedException(s) {
          var _this = this;

          if (typeof s === 'string' || s === null) {
            _this = _super.call(this, s) || this;
            _this.message = s;
          } else if (s === undefined) {
            _this = _super.call(this) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        return InterruptedException;
      }(Error);

      lang.InterruptedException = InterruptedException;
      InterruptedException["__class"] = "java.lang.InterruptedException";
      InterruptedException["__interfaces"] = ["java.io.Serializable"];
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      var ReflectiveOperationException =
      /** @class */
      function (_super) {
        __extends(ReflectiveOperationException, _super);

        function ReflectiveOperationException(s) {
          var _this = this;

          if (typeof s === 'string' || s === null) {
            _this = _super.call(this, s) || this;
            _this.message = s;
          } else if (s === undefined) {
            _this = _super.call(this) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        return ReflectiveOperationException;
      }(Error);

      lang.ReflectiveOperationException = ReflectiveOperationException;
      ReflectiveOperationException["__class"] = "java.lang.ReflectiveOperationException";
      ReflectiveOperationException["__interfaces"] = ["java.io.Serializable"];
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      /**
      * See <a href="http://java.sun.com/j2se/1.5.0/docs/api/java/lang/NoSuchMethodException.html">the
      * official Java API doc</a> for details.
      *
      * This exception is never thrown by GWT or GWT's libraries, as GWT does not support reflection. It
      * is provided in GWT only for compatibility with user code that explicitly throws or catches it for
      * non-reflection purposes.
      * @param {string} message
      * @class
      * @extends java.lang.Exception
      */
      var NoSuchMethodException =
      /** @class */
      function (_super) {
        __extends(NoSuchMethodException, _super);

        function NoSuchMethodException(message) {
          var _this = this;

          if (typeof message === 'string' || message === null) {
            _this = _super.call(this, message) || this;
            _this.message = message;
          } else if (message === undefined) {
            _this = _super.call(this) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        return NoSuchMethodException;
      }(Error);

      lang.NoSuchMethodException = NoSuchMethodException;
      NoSuchMethodException["__class"] = "java.lang.NoSuchMethodException";
      NoSuchMethodException["__interfaces"] = ["java.io.Serializable"];
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (text) {
      /**
      * Emulation of {@code java.text.ParseException}.
      * @param {string} s
      * @param {number} errorOffset
      * @class
      * @extends java.lang.Exception
      */
      var ParseException =
      /** @class */
      function (_super) {
        __extends(ParseException, _super);

        function ParseException(s, errorOffset) {
          var _this = _super.call(this, s) || this;

          _this.message = s;
          Object.setPrototypeOf(_this, ParseException.prototype);

          if (_this.errorOffset === undefined) {
            _this.errorOffset = 0;
          }

          _this.errorOffset = errorOffset;
          return _this;
        }

        ParseException.prototype.getErrorOffset = function () {
          return this.errorOffset;
        };

        return ParseException;
      }(Error);

      text.ParseException = ParseException;
      ParseException["__class"] = "java.text.ParseException";
      ParseException["__interfaces"] = ["java.io.Serializable"];
    })(java.text || (java.text = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      var InheritableThreadLocal =
      /** @class */
      function (_super) {
        __extends(InheritableThreadLocal, _super);

        function InheritableThreadLocal() {
          return _super !== null && _super.apply(this, arguments) || this;
        }

        InheritableThreadLocal.prototype.childValue = function (parentValue) {
          return parentValue;
        };

        return InheritableThreadLocal;
      }(java.lang.ThreadLocal);

      lang.InheritableThreadLocal = InheritableThreadLocal;
      InheritableThreadLocal["__class"] = "java.lang.InheritableThreadLocal";
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      /**
      * A fast way to create strings using multiple appends.
      *
      * This class is an exact clone of {@link StringBuffer} except for the name. Any
      * change made to one should be mirrored in the other.
      * @param {*} s
      * @class
      * @extends java.lang.AbstractStringBuilder
      */
      var StringBuilder =
      /** @class */
      function (_super) {
        __extends(StringBuilder, _super);

        function StringBuilder(s) {
          var _this = this;

          if (typeof s === 'string' || s === null) {
            var __args = arguments;
            _this = _super.call(this, s) || this;
          } else if (s != null && (s.constructor != null && s.constructor["__interfaces"] != null && s.constructor["__interfaces"].indexOf("java.lang.CharSequence") >= 0 || typeof s === "string") || s === null) {
            var __args = arguments;
            _this = _super.call(this,
            /* valueOf */
            new String(s).toString()) || this;
          } else if (typeof s === 'number' || s === null) {
            var __args = arguments;
            __args[0];
            _this = _super.call(this, "") || this;
          } else if (s === undefined) {
            var __args = arguments;
            _this = _super.call(this, "") || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        StringBuilder.prototype.append$boolean = function (x) {
          this.string += x;
          return this;
        };

        StringBuilder.prototype.append$char = function (x) {
          this.string +=
          /* valueOf */
          new String(x).toString();
          return this;
        };

        StringBuilder.prototype.append$char_A = function (x) {
          this.string +=
          /* valueOf */
          new String(x).toString();
          return this;
        };

        StringBuilder.prototype.append$char_A$int$int = function (x, start, len) {
          this.string +=
          /* valueOf */
          function (str, index, len) {
            return str.join('').substring(index, index + len);
          }(x, start, len);

          return this;
        };

        StringBuilder.prototype.append = function (x, start, len) {
          if ((x != null && x instanceof Array && (x.length == 0 || x[0] == null || typeof x[0] === 'string') || x === null) && (typeof start === 'number' || start === null) && (typeof len === 'number' || len === null)) {
            return this.append$char_A$int$int(x, start, len);
          } else if ((x != null && (x.constructor != null && x.constructor["__interfaces"] != null && x.constructor["__interfaces"].indexOf("java.lang.CharSequence") >= 0 || typeof x === "string") || x === null) && (typeof start === 'number' || start === null) && (typeof len === 'number' || len === null)) {
            return this.append$java_lang_CharSequence$int$int(x, start, len);
          } else if ((x != null && x instanceof Array && (x.length == 0 || x[0] == null || typeof x[0] === 'string') || x === null) && start === undefined && len === undefined) {
            return this.append$char_A(x);
          } else if ((typeof x === 'string' || x === null) && start === undefined && len === undefined) {
            return this.append$java_lang_String(x);
          } else if ((x != null && x instanceof java.lang.StringBuffer || x === null) && start === undefined && len === undefined) {
            return this.append$java_lang_StringBuffer(x);
          } else if ((x != null && (x.constructor != null && x.constructor["__interfaces"] != null && x.constructor["__interfaces"].indexOf("java.lang.CharSequence") >= 0 || typeof x === "string") || x === null) && start === undefined && len === undefined) {
            return this.append$java_lang_CharSequence(x);
          } else if ((typeof x === 'boolean' || x === null) && start === undefined && len === undefined) {
            return this.append$boolean(x);
          } else if ((typeof x === 'string' || x === null) && start === undefined && len === undefined) {
            return this.append$char(x);
          } else if ((typeof x === 'number' || x === null) && start === undefined && len === undefined) {
            return this.append$int(x);
          } else if ((typeof x === 'number' || x === null) && start === undefined && len === undefined) {
            return this.append$long(x);
          } else if ((typeof x === 'number' || x === null) && start === undefined && len === undefined) {
            return this.append$float(x);
          } else if ((typeof x === 'number' || x === null) && start === undefined && len === undefined) {
            return this.append$double(x);
          } else if ((x != null || x === null) && start === undefined && len === undefined) {
            return this.append$java_lang_Object(x);
          } else throw new Error('invalid overload');
        };

        StringBuilder.prototype.append$java_lang_CharSequence = function (x) {
          this.string += x;
          return this;
        };

        StringBuilder.prototype.append$java_lang_CharSequence$int$int = function (x, start, end) {
          this.append0(x, start, end);
          return this;
        };

        StringBuilder.prototype.append$double = function (x) {
          this.string += x;
          return this;
        };

        StringBuilder.prototype.append$float = function (x) {
          this.string += x;
          return this;
        };

        StringBuilder.prototype.append$int = function (x) {
          this.string += x;
          return this;
        };

        StringBuilder.prototype.append$long = function (x) {
          this.string += x;
          return this;
        };

        StringBuilder.prototype.append$java_lang_Object = function (x) {
          this.string += x;
          return this;
        };

        StringBuilder.prototype.append$java_lang_String = function (x) {
          this.string += x;
          return this;
        };

        StringBuilder.prototype.append$java_lang_StringBuffer = function (x) {
          this.string += x;
          return this;
        };

        StringBuilder.prototype.appendCodePoint = function (x) {
          this.appendCodePoint0(x);
          return this;
        };

        StringBuilder.prototype["delete"] = function (start, end) {
          this.replace0(start, end, "");
          return this;
        };

        StringBuilder.prototype.deleteCharAt = function (start) {
          this.replace0(start, start + 1, "");
          return this;
        };

        StringBuilder.prototype.insert$int$boolean = function (index, x) {
          return this.insert$int$java_lang_String(index,
          /* valueOf */
          new String(x).toString());
        };

        StringBuilder.prototype.insert$int$char = function (index, x) {
          this.replace0(index, index,
          /* valueOf */
          new String(x).toString());
          return this;
        };

        StringBuilder.prototype.insert$int$char_A = function (index, x) {
          return this.insert$int$java_lang_String(index,
          /* valueOf */
          new String(x).toString());
        };

        StringBuilder.prototype.insert$int$char_A$int$int = function (index, x, offset, len) {
          return this.insert$int$java_lang_String(index,
          /* valueOf */
          function (str, index, len) {
            return str.join('').substring(index, index + len);
          }(x, offset, len));
        };

        StringBuilder.prototype.insert = function (index, x, offset, len) {
          if ((typeof index === 'number' || index === null) && (x != null && x instanceof Array && (x.length == 0 || x[0] == null || typeof x[0] === 'string') || x === null) && (typeof offset === 'number' || offset === null) && (typeof len === 'number' || len === null)) {
            return this.insert$int$char_A$int$int(index, x, offset, len);
          } else if ((typeof index === 'number' || index === null) && (x != null && (x.constructor != null && x.constructor["__interfaces"] != null && x.constructor["__interfaces"].indexOf("java.lang.CharSequence") >= 0 || typeof x === "string") || x === null) && (typeof offset === 'number' || offset === null) && (typeof len === 'number' || len === null)) {
            return this.insert$int$java_lang_CharSequence$int$int(index, x, offset, len);
          } else if ((typeof index === 'number' || index === null) && (x != null && x instanceof Array && (x.length == 0 || x[0] == null || typeof x[0] === 'string') || x === null) && offset === undefined && len === undefined) {
            return this.insert$int$char_A(index, x);
          } else if ((typeof index === 'number' || index === null) && (typeof x === 'string' || x === null) && offset === undefined && len === undefined) {
            return this.insert$int$java_lang_String(index, x);
          } else if ((typeof index === 'number' || index === null) && (x != null && (x.constructor != null && x.constructor["__interfaces"] != null && x.constructor["__interfaces"].indexOf("java.lang.CharSequence") >= 0 || typeof x === "string") || x === null) && offset === undefined && len === undefined) {
            return this.insert$int$java_lang_CharSequence(index, x);
          } else if ((typeof index === 'number' || index === null) && (typeof x === 'boolean' || x === null) && offset === undefined && len === undefined) {
            return this.insert$int$boolean(index, x);
          } else if ((typeof index === 'number' || index === null) && (typeof x === 'string' || x === null) && offset === undefined && len === undefined) {
            return this.insert$int$char(index, x);
          } else if ((typeof index === 'number' || index === null) && (typeof x === 'number' || x === null) && offset === undefined && len === undefined) {
            return this.insert$int$int(index, x);
          } else if ((typeof index === 'number' || index === null) && (typeof x === 'number' || x === null) && offset === undefined && len === undefined) {
            return this.insert$int$long(index, x);
          } else if ((typeof index === 'number' || index === null) && (typeof x === 'number' || x === null) && offset === undefined && len === undefined) {
            return this.insert$int$float(index, x);
          } else if ((typeof index === 'number' || index === null) && (typeof x === 'number' || x === null) && offset === undefined && len === undefined) {
            return this.insert$int$double(index, x);
          } else if ((typeof index === 'number' || index === null) && (x != null || x === null) && offset === undefined && len === undefined) {
            return this.insert$int$java_lang_Object(index, x);
          } else throw new Error('invalid overload');
        };

        StringBuilder.prototype.insert$int$java_lang_CharSequence = function (index, chars) {
          return this.insert$int$java_lang_String(index, chars.toString());
        };

        StringBuilder.prototype.insert$int$java_lang_CharSequence$int$int = function (index, chars, start, end) {
          return this.insert$int$java_lang_String(index,
          /* subSequence */
          chars.substring(start, end).toString());
        };

        StringBuilder.prototype.insert$int$double = function (index, x) {
          return this.insert$int$java_lang_String(index,
          /* valueOf */
          new String(x).toString());
        };

        StringBuilder.prototype.insert$int$float = function (index, x) {
          return this.insert$int$java_lang_String(index,
          /* valueOf */
          new String(x).toString());
        };

        StringBuilder.prototype.insert$int$int = function (index, x) {
          return this.insert$int$java_lang_String(index,
          /* valueOf */
          new String(x).toString());
        };

        StringBuilder.prototype.insert$int$long = function (index, x) {
          return this.insert$int$java_lang_String(index,
          /* valueOf */
          new String(x).toString());
        };

        StringBuilder.prototype.insert$int$java_lang_Object = function (index, x) {
          return this.insert$int$java_lang_String(index,
          /* valueOf */
          new String(x).toString());
        };

        StringBuilder.prototype.insert$int$java_lang_String = function (index, x) {
          this.replace0(index, index, x);
          return this;
        };

        StringBuilder.prototype.replace = function (start, end, toInsert) {
          this.replace0(start, end, toInsert);
          return this;
        };

        StringBuilder.prototype.reverse = function () {
          this.reverse0();
          return this;
        };

        return StringBuilder;
      }(java.lang.AbstractStringBuilder);

      lang.StringBuilder = StringBuilder;
      StringBuilder["__class"] = "java.lang.StringBuilder";
      StringBuilder["__interfaces"] = ["java.lang.CharSequence", "java.lang.Appendable"];
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      /**
      * A fast way to create strings using multiple appends.
      *
      * This class is an exact clone of {@link StringBuilder} except for the name.
      * Any change made to one should be mirrored in the other.
      * @param {*} s
      * @class
      * @extends java.lang.AbstractStringBuilder
      */
      var StringBuffer =
      /** @class */
      function (_super) {
        __extends(StringBuffer, _super);

        function StringBuffer(s) {
          var _this = this;

          if (typeof s === 'string' || s === null) {
            var __args = arguments;
            _this = _super.call(this, s) || this;
          } else if (s != null && (s.constructor != null && s.constructor["__interfaces"] != null && s.constructor["__interfaces"].indexOf("java.lang.CharSequence") >= 0 || typeof s === "string") || s === null) {
            var __args = arguments;
            _this = _super.call(this,
            /* valueOf */
            new String(s).toString()) || this;
          } else if (typeof s === 'number' || s === null) {
            var __args = arguments;
            __args[0];
            _this = _super.call(this, "") || this;
          } else if (s === undefined) {
            var __args = arguments;
            _this = _super.call(this, "") || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        StringBuffer.prototype.append$boolean = function (x) {
          this.string += x;
          return this;
        };

        StringBuffer.prototype.append$char = function (x) {
          this.string += x;
          return this;
        };

        StringBuffer.prototype.append$char_A = function (x) {
          this.string +=
          /* valueOf */
          new String(x).toString();
          return this;
        };

        StringBuffer.prototype.append$char_A$int$int = function (x, start, len) {
          this.string +=
          /* valueOf */
          function (str, index, len) {
            return str.join('').substring(index, index + len);
          }(x, start, len);

          return this;
        };

        StringBuffer.prototype.append = function (x, start, len) {
          if ((x != null && x instanceof Array && (x.length == 0 || x[0] == null || typeof x[0] === 'string') || x === null) && (typeof start === 'number' || start === null) && (typeof len === 'number' || len === null)) {
            return this.append$char_A$int$int(x, start, len);
          } else if ((x != null && (x.constructor != null && x.constructor["__interfaces"] != null && x.constructor["__interfaces"].indexOf("java.lang.CharSequence") >= 0 || typeof x === "string") || x === null) && (typeof start === 'number' || start === null) && (typeof len === 'number' || len === null)) {
            return this.append$java_lang_CharSequence$int$int(x, start, len);
          } else if ((x != null && x instanceof Array && (x.length == 0 || x[0] == null || typeof x[0] === 'string') || x === null) && start === undefined && len === undefined) {
            return this.append$char_A(x);
          } else if ((typeof x === 'string' || x === null) && start === undefined && len === undefined) {
            return this.append$java_lang_String(x);
          } else if ((x != null && x instanceof java.lang.StringBuffer || x === null) && start === undefined && len === undefined) {
            return this.append$java_lang_StringBuffer(x);
          } else if ((x != null && (x.constructor != null && x.constructor["__interfaces"] != null && x.constructor["__interfaces"].indexOf("java.lang.CharSequence") >= 0 || typeof x === "string") || x === null) && start === undefined && len === undefined) {
            return this.append$java_lang_CharSequence(x);
          } else if ((typeof x === 'boolean' || x === null) && start === undefined && len === undefined) {
            return this.append$boolean(x);
          } else if ((typeof x === 'string' || x === null) && start === undefined && len === undefined) {
            return this.append$char(x);
          } else if ((typeof x === 'number' || x === null) && start === undefined && len === undefined) {
            return this.append$int(x);
          } else if ((typeof x === 'number' || x === null) && start === undefined && len === undefined) {
            return this.append$long(x);
          } else if ((typeof x === 'number' || x === null) && start === undefined && len === undefined) {
            return this.append$float(x);
          } else if ((typeof x === 'number' || x === null) && start === undefined && len === undefined) {
            return this.append$double(x);
          } else if ((x != null || x === null) && start === undefined && len === undefined) {
            return this.append$java_lang_Object(x);
          } else throw new Error('invalid overload');
        };

        StringBuffer.prototype.append$java_lang_CharSequence = function (x) {
          this.string += x;
          return this;
        };

        StringBuffer.prototype.append$java_lang_CharSequence$int$int = function (x, start, end) {
          this.append0(x, start, end);
          return this;
        };

        StringBuffer.prototype.append$double = function (x) {
          this.string += x;
          return this;
        };

        StringBuffer.prototype.append$float = function (x) {
          this.string += x;
          return this;
        };

        StringBuffer.prototype.append$int = function (x) {
          this.string += x;
          return this;
        };

        StringBuffer.prototype.append$long = function (x) {
          this.string += x;
          return this;
        };

        StringBuffer.prototype.append$java_lang_Object = function (x) {
          this.string += x;
          return this;
        };

        StringBuffer.prototype.append$java_lang_String = function (x) {
          this.string += x;
          return this;
        };

        StringBuffer.prototype.append$java_lang_StringBuffer = function (x) {
          this.string += x;
          return this;
        };

        StringBuffer.prototype.appendCodePoint = function (x) {
          this.appendCodePoint0(x);
          return this;
        };

        StringBuffer.prototype["delete"] = function (start, end) {
          this.replace0(start, end, "");
          return this;
        };

        StringBuffer.prototype.deleteCharAt = function (start) {
          this.replace0(start, start + 1, "");
          return this;
        };

        StringBuffer.prototype.insert$int$boolean = function (index, x) {
          return this.insert$int$java_lang_String(index,
          /* valueOf */
          new String(x).toString());
        };

        StringBuffer.prototype.insert$int$char = function (index, x) {
          return this.insert$int$java_lang_String(index,
          /* valueOf */
          new String(x).toString());
        };

        StringBuffer.prototype.insert$int$char_A = function (index, x) {
          return this.insert$int$java_lang_String(index,
          /* valueOf */
          new String(x).toString());
        };

        StringBuffer.prototype.insert$int$char_A$int$int = function (index, x, offset, len) {
          return this.insert$int$java_lang_String(index,
          /* valueOf */
          function (str, index, len) {
            return str.join('').substring(index, index + len);
          }(x, offset, len));
        };

        StringBuffer.prototype.insert = function (index, x, offset, len) {
          if ((typeof index === 'number' || index === null) && (x != null && x instanceof Array && (x.length == 0 || x[0] == null || typeof x[0] === 'string') || x === null) && (typeof offset === 'number' || offset === null) && (typeof len === 'number' || len === null)) {
            return this.insert$int$char_A$int$int(index, x, offset, len);
          } else if ((typeof index === 'number' || index === null) && (x != null && (x.constructor != null && x.constructor["__interfaces"] != null && x.constructor["__interfaces"].indexOf("java.lang.CharSequence") >= 0 || typeof x === "string") || x === null) && (typeof offset === 'number' || offset === null) && (typeof len === 'number' || len === null)) {
            return this.insert$int$java_lang_CharSequence$int$int(index, x, offset, len);
          } else if ((typeof index === 'number' || index === null) && (x != null && x instanceof Array && (x.length == 0 || x[0] == null || typeof x[0] === 'string') || x === null) && offset === undefined && len === undefined) {
            return this.insert$int$char_A(index, x);
          } else if ((typeof index === 'number' || index === null) && (typeof x === 'string' || x === null) && offset === undefined && len === undefined) {
            return this.insert$int$java_lang_String(index, x);
          } else if ((typeof index === 'number' || index === null) && (x != null && (x.constructor != null && x.constructor["__interfaces"] != null && x.constructor["__interfaces"].indexOf("java.lang.CharSequence") >= 0 || typeof x === "string") || x === null) && offset === undefined && len === undefined) {
            return this.insert$int$java_lang_CharSequence(index, x);
          } else if ((typeof index === 'number' || index === null) && (typeof x === 'boolean' || x === null) && offset === undefined && len === undefined) {
            return this.insert$int$boolean(index, x);
          } else if ((typeof index === 'number' || index === null) && (typeof x === 'string' || x === null) && offset === undefined && len === undefined) {
            return this.insert$int$char(index, x);
          } else if ((typeof index === 'number' || index === null) && (typeof x === 'number' || x === null) && offset === undefined && len === undefined) {
            return this.insert$int$int(index, x);
          } else if ((typeof index === 'number' || index === null) && (typeof x === 'number' || x === null) && offset === undefined && len === undefined) {
            return this.insert$int$long(index, x);
          } else if ((typeof index === 'number' || index === null) && (typeof x === 'number' || x === null) && offset === undefined && len === undefined) {
            return this.insert$int$float(index, x);
          } else if ((typeof index === 'number' || index === null) && (typeof x === 'number' || x === null) && offset === undefined && len === undefined) {
            return this.insert$int$double(index, x);
          } else if ((typeof index === 'number' || index === null) && (x != null || x === null) && offset === undefined && len === undefined) {
            return this.insert$int$java_lang_Object(index, x);
          } else throw new Error('invalid overload');
        };

        StringBuffer.prototype.insert$int$java_lang_CharSequence = function (index, chars) {
          return this.insert$int$java_lang_String(index, chars.toString());
        };

        StringBuffer.prototype.insert$int$java_lang_CharSequence$int$int = function (index, chars, start, end) {
          return this.insert$int$java_lang_String(index,
          /* subSequence */
          chars.substring(start, end).toString());
        };

        StringBuffer.prototype.insert$int$double = function (index, x) {
          return this.insert$int$java_lang_String(index,
          /* valueOf */
          new String(x).toString());
        };

        StringBuffer.prototype.insert$int$float = function (index, x) {
          return this.insert$int$java_lang_String(index,
          /* valueOf */
          new String(x).toString());
        };

        StringBuffer.prototype.insert$int$int = function (index, x) {
          return this.insert$int$java_lang_String(index,
          /* valueOf */
          new String(x).toString());
        };

        StringBuffer.prototype.insert$int$long = function (index, x) {
          return this.insert$int$java_lang_String(index,
          /* valueOf */
          new String(x).toString());
        };

        StringBuffer.prototype.insert$int$java_lang_Object = function (index, x) {
          return this.insert$int$java_lang_String(index,
          /* valueOf */
          new String(x).toString());
        };

        StringBuffer.prototype.insert$int$java_lang_String = function (index, x) {
          this.replace0(index, index, x);
          return this;
        };

        StringBuffer.prototype.replace = function (start, end, toInsert) {
          this.replace0(start, end, toInsert);
          return this;
        };

        StringBuffer.prototype.reverse = function () {
          this.reverse0();
          return this;
        };

        return StringBuffer;
      }(java.lang.AbstractStringBuilder);

      lang.StringBuffer = StringBuffer;
      StringBuffer["__class"] = "java.lang.StringBuffer";
      StringBuffer["__interfaces"] = ["java.lang.CharSequence", "java.lang.Appendable"];
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (nio) {
      var ByteBuffer =
      /** @class */
      function (_super) {
        __extends(ByteBuffer, _super);

        function ByteBuffer(_buffer, readOnly) {
          var _this = _super.call(this, _buffer.byteLength | 0, readOnly) || this;

          if (_this._buffer === undefined) {
            _this._buffer = null;
          }

          if (_this._array === undefined) {
            _this._array = null;
          }

          if (_this._data === undefined) {
            _this._data = null;
          }

          _this._order = java.nio.ByteOrder.BIG_ENDIAN_$LI$();
          _this._buffer = _buffer;
          _this._array = new Int8Array(_buffer);
          _this._data = new DataView(_buffer);
          return _this;
        }

        ByteBuffer.allocate = function (capacity) {
          return new ByteBuffer(new ArrayBuffer(capacity), false);
        };
        /**
        *
        * @return {Array}
        */


        ByteBuffer.prototype.array = function () {
          return this._array;
        };

        ByteBuffer.prototype.asReadOnlyBuffer = function () {
          var byteBuffer = new ByteBuffer(this._buffer, true);
          byteBuffer.limit$int(this.limit$());
          byteBuffer.position$int(this.position$());
          byteBuffer._mark = this._mark;
          return byteBuffer;
        };

        ByteBuffer.prototype.compact = function () {
          if (this.isReadOnly()) throw new java.nio.ReadOnlyBufferException();
          var current = this.position$();

          for (var i = current; i < this.limit$(); ++i) {
            {
              this.put$int$byte(i - current, this.get$int(i));
            }
          }

          this.position$int(this.limit$() - this.position$());
          this.limit$int(this.capacity());
          this._mark = -1;
          return this;
        };

        ByteBuffer.prototype.compareTo$java_nio_ByteBuffer = function (byteBuffer) {
          return (
            /* compareTo */
            this._array.toString().localeCompare(byteBuffer.toString())
          );
        };
        /**
        *
        * @param {java.nio.ByteBuffer} byteBuffer
        * @return {number}
        */


        ByteBuffer.prototype.compareTo = function (byteBuffer) {
          if (byteBuffer != null && byteBuffer instanceof java.nio.ByteBuffer || byteBuffer === null) {
            return this.compareTo$java_nio_ByteBuffer(byteBuffer);
          } else throw new Error('invalid overload');
        };

        ByteBuffer.prototype.duplicate = function () {
          var byteBuffer = new ByteBuffer(this._buffer, this.isReadOnly());
          byteBuffer.limit$int(this.limit$());
          byteBuffer.position$int(this.position$());
          byteBuffer._mark = this._mark;
          return byteBuffer;
        };
        /**
        *
        * @param {*} o
        * @return {boolean}
        */


        ByteBuffer.prototype.equals = function (o) {
          return this === o || o != null && o instanceof java.nio.ByteBuffer && java.util.Objects.equals(this._array, o._array);
        };

        ByteBuffer.prototype.get$ = function () {
          if (this.position$() === this.limit$()) throw new java.nio.BufferUnderflowException();

          var b = this._array[this.position$()];

          this.position$int(this.position$() + 1);
          return b;
        };

        ByteBuffer.prototype.get$byte_A = function (dest) {
          return this.get$byte_A$int$int(dest, 0, dest.length);
        };

        ByteBuffer.prototype.get$byte_A$int$int = function (dest, offset, length) {
          if (this.remaining() < length) throw new java.nio.BufferUnderflowException();

          for (var i = offset; i < offset + length; i++) {
            dest[i] = this.get$();
          }

          return this;
        };

        ByteBuffer.prototype.get = function (dest, offset, length) {
          if ((dest != null && dest instanceof Array && (dest.length == 0 || dest[0] == null || typeof dest[0] === 'number') || dest === null) && (typeof offset === 'number' || offset === null) && (typeof length === 'number' || length === null)) {
            return this.get$byte_A$int$int(dest, offset, length);
          } else if ((dest != null && dest instanceof Array && (dest.length == 0 || dest[0] == null || typeof dest[0] === 'number') || dest === null) && offset === undefined && length === undefined) {
            return this.get$byte_A(dest);
          } else if ((typeof dest === 'number' || dest === null) && offset === undefined && length === undefined) {
            return this.get$int(dest);
          } else if (dest === undefined && offset === undefined && length === undefined) {
            return this.get$();
          } else throw new Error('invalid overload');
        };

        ByteBuffer.prototype.get$int = function (from) {
          if (from < 0 || from > this.limit$()) throw new java.lang.IndexOutOfBoundsException();
          return this._array[from];
        };

        ByteBuffer.prototype.getChar$ = function () {
          if (this.remaining() < 2) throw new java.nio.BufferUnderflowException();
          var res = String.fromCharCode(this._data.getInt16(this.position$(), this._order === java.nio.ByteOrder.LITTLE_ENDIAN_$LI$()) | 0).charAt(0);
          this.position$int(this.position$() + 2);
          return res;
        };

        ByteBuffer.prototype.getChar$int = function (from) {
          if (from < 0 || from > this.limit$() - 1) throw new java.lang.IndexOutOfBoundsException();
          return String.fromCharCode(this._data.getInt16(from, this._order === java.nio.ByteOrder.LITTLE_ENDIAN_$LI$()) | 0).charAt(0);
        };

        ByteBuffer.prototype.getChar = function (from) {
          if (typeof from === 'number' || from === null) {
            return this.getChar$int(from);
          } else if (from === undefined) {
            return this.getChar$();
          } else throw new Error('invalid overload');
        };

        ByteBuffer.prototype.getDouble$ = function () {
          if (this.remaining() < 8) throw new java.nio.BufferUnderflowException();

          var res = this._data.getFloat64(this.position$(), this._order === java.nio.ByteOrder.LITTLE_ENDIAN_$LI$());

          this.position$int(this.position$() + 8);
          return res;
        };

        ByteBuffer.prototype.getDouble$int = function (from) {
          if (from < 0 || from > this.limit$() - 7) throw new java.lang.IndexOutOfBoundsException();
          return this._data.getFloat64(from, this._order === java.nio.ByteOrder.LITTLE_ENDIAN_$LI$());
        };

        ByteBuffer.prototype.getDouble = function (from) {
          if (typeof from === 'number' || from === null) {
            return this.getDouble$int(from);
          } else if (from === undefined) {
            return this.getDouble$();
          } else throw new Error('invalid overload');
        };

        ByteBuffer.prototype.getFloat$ = function () {
          if (this.remaining() < 4) throw new java.nio.BufferUnderflowException();

          var res = this._data.getFloat32(this.position$(), this._order === java.nio.ByteOrder.LITTLE_ENDIAN_$LI$());

          this.position$int(this.position$() + 4);
          return res;
        };

        ByteBuffer.prototype.getFloat$int = function (from) {
          if (from < 0 || from > this.limit$() - 3) throw new java.lang.IndexOutOfBoundsException();
          return this._data.getFloat32(from, this._order === java.nio.ByteOrder.LITTLE_ENDIAN_$LI$());
        };

        ByteBuffer.prototype.getFloat = function (from) {
          if (typeof from === 'number' || from === null) {
            return this.getFloat$int(from);
          } else if (from === undefined) {
            return this.getFloat$();
          } else throw new Error('invalid overload');
        };

        ByteBuffer.prototype.getInt$ = function () {
          if (this.remaining() < 4) throw new java.nio.BufferUnderflowException();

          var res = this._data.getInt32(this.position$(), this._order === java.nio.ByteOrder.LITTLE_ENDIAN_$LI$());

          this.position$int(this.position$() + 4);
          return res;
        };

        ByteBuffer.prototype.getInt$int = function (from) {
          if (from < 0 || from > this.limit$() - 3) throw new java.lang.IndexOutOfBoundsException();
          return this._data.getInt32(from, this._order === java.nio.ByteOrder.LITTLE_ENDIAN_$LI$());
        };

        ByteBuffer.prototype.getInt = function (from) {
          if (typeof from === 'number' || from === null) {
            return this.getInt$int(from);
          } else if (from === undefined) {
            return this.getInt$();
          } else throw new Error('invalid overload');
        };

        ByteBuffer.prototype.getLong$ = function () {
          if (this.remaining() < 8) throw new java.nio.BufferUnderflowException();

          var res1 = this._data.getInt32(this.position$(), this._order === java.nio.ByteOrder.LITTLE_ENDIAN_$LI$());

          var res2 = this._data.getInt32(this.position$() + 4, this._order === java.nio.ByteOrder.LITTLE_ENDIAN_$LI$());

          if (this._order === java.nio.ByteOrder.LITTLE_ENDIAN_$LI$()) {
            var tmp = res1;
            res1 = res2;
            res2 = tmp;
          }

          this.position$int(this.position$() + 8);
          return res1 * 4294967296 + res2;
        };

        ByteBuffer.prototype.getLong$int = function (from) {
          if (from < 0 || from > this.limit$() - 7) throw new java.lang.IndexOutOfBoundsException();

          var res1 = this._data.getInt32(from, this._order === java.nio.ByteOrder.LITTLE_ENDIAN_$LI$());

          var res2 = this._data.getInt32(from + 4, this._order === java.nio.ByteOrder.LITTLE_ENDIAN_$LI$());

          if (this._order === java.nio.ByteOrder.LITTLE_ENDIAN_$LI$()) {
            var tmp = res1;
            res1 = res2;
            res2 = tmp;
          }

          return res1 * 4294967296 + res2;
        };

        ByteBuffer.prototype.getLong = function (from) {
          if (typeof from === 'number' || from === null) {
            return this.getLong$int(from);
          } else if (from === undefined) {
            return this.getLong$();
          } else throw new Error('invalid overload');
        };

        ByteBuffer.prototype.getShort$ = function () {
          if (this.remaining() < 2) throw new java.nio.BufferUnderflowException();

          var res = this._data.getInt16(this.position$(), this._order === java.nio.ByteOrder.LITTLE_ENDIAN_$LI$());

          this.position$int(this.position$() + 2);
          return res;
        };

        ByteBuffer.prototype.getShort$int = function (from) {
          if (from < 0 || from > this.limit$() - 1) throw new java.lang.IndexOutOfBoundsException();
          return this._data.getInt16(from, this._order === java.nio.ByteOrder.LITTLE_ENDIAN_$LI$());
        };

        ByteBuffer.prototype.getShort = function (from) {
          if (typeof from === 'number' || from === null) {
            return this.getShort$int(from);
          } else if (from === undefined) {
            return this.getShort$();
          } else throw new Error('invalid overload');
        };

        ByteBuffer.prototype.order$ = function () {
          return this._order;
        };

        ByteBuffer.prototype.order$java_nio_ByteOrder = function (newOrder) {
          this._order = newOrder;
          return this;
        };

        ByteBuffer.prototype.order = function (newOrder) {
          if (newOrder != null && newOrder instanceof java.nio.ByteOrder || newOrder === null) {
            return this.order$java_nio_ByteOrder(newOrder);
          } else if (newOrder === undefined) {
            return this.order$();
          } else throw new Error('invalid overload');
        };

        ByteBuffer.prototype.put$byte = function (b) {
          if (this.isReadOnly()) throw new java.nio.ReadOnlyBufferException();
          if (this.position$() === this.limit$()) throw new java.nio.BufferOverflowException();
          this._array[this.position$()] = b;
          this.position$int(this.position$() + 1);
          return this;
        };

        ByteBuffer.prototype.put$byte_A = function (src) {
          return this.put$byte_A$int$int(src, 0, src.length);
        };

        ByteBuffer.prototype.put$byte_A$int$int = function (src, offset, length) {
          if (this.isReadOnly()) throw new java.nio.ReadOnlyBufferException();
          if (this.remaining() < length) throw new java.nio.BufferOverflowException();

          for (var i = offset; i < offset + length; i++) {
            this.put$byte(src[i]);
          }

          return this;
        };

        ByteBuffer.prototype.put = function (src, offset, length) {
          if ((src != null && src instanceof Array && (src.length == 0 || src[0] == null || typeof src[0] === 'number') || src === null) && (typeof offset === 'number' || offset === null) && (typeof length === 'number' || length === null)) {
            return this.put$byte_A$int$int(src, offset, length);
          } else if ((typeof src === 'number' || src === null) && (typeof offset === 'number' || offset === null) && length === undefined) {
            return this.put$int$byte(src, offset);
          } else if ((src != null && src instanceof Array && (src.length == 0 || src[0] == null || typeof src[0] === 'number') || src === null) && offset === undefined && length === undefined) {
            return this.put$byte_A(src);
          } else if ((typeof src === 'number' || src === null) && offset === undefined && length === undefined) {
            return this.put$byte(src);
          } else throw new Error('invalid overload');
        };

        ByteBuffer.prototype.put$int$byte = function (to, b) {
          if (this.isReadOnly()) throw new java.nio.ReadOnlyBufferException();
          if (to < 0 || to > this.limit$()) throw new java.lang.IndexOutOfBoundsException();
          this._array[to] = b;
          return this;
        };

        ByteBuffer.prototype.putChar$char = function (value) {
          if (this.isReadOnly()) throw new java.nio.ReadOnlyBufferException();
          if (this.remaining() < 2) throw new java.nio.BufferOverflowException();

          this._data.setInt16(this.position$(), value.charCodeAt(0), this._order === java.nio.ByteOrder.LITTLE_ENDIAN_$LI$());

          this.position$int(this.position$() + 2);
          return this;
        };

        ByteBuffer.prototype.putChar$int$char = function (to, value) {
          if (this.isReadOnly()) throw new java.nio.ReadOnlyBufferException();
          if (to < 0 || to > this.limit$() - 1) throw new java.lang.IndexOutOfBoundsException();

          this._data.setInt16(to, value.charCodeAt(0), this._order === java.nio.ByteOrder.LITTLE_ENDIAN_$LI$());

          return this;
        };

        ByteBuffer.prototype.putChar = function (to, value) {
          if ((typeof to === 'number' || to === null) && (typeof value === 'string' || value === null)) {
            return this.putChar$int$char(to, value);
          } else if ((typeof to === 'string' || to === null) && value === undefined) {
            return this.putChar$char(to);
          } else throw new Error('invalid overload');
        };

        ByteBuffer.prototype.putDouble$double = function (value) {
          if (this.isReadOnly()) throw new java.nio.ReadOnlyBufferException();
          if (this.remaining() < 8) throw new java.nio.BufferOverflowException();

          this._data.setFloat64(this.position$(), value, this._order === java.nio.ByteOrder.LITTLE_ENDIAN_$LI$());

          this.position$int(this.position$() + 8);
          return this;
        };

        ByteBuffer.prototype.putDouble$int$double = function (to, value) {
          if (this.isReadOnly()) throw new java.nio.ReadOnlyBufferException();
          if (to < 0 || to > this.limit$() - 7) throw new java.lang.IndexOutOfBoundsException();

          this._data.setFloat64(to, value, this._order === java.nio.ByteOrder.LITTLE_ENDIAN_$LI$());

          return this;
        };

        ByteBuffer.prototype.putDouble = function (to, value) {
          if ((typeof to === 'number' || to === null) && (typeof value === 'number' || value === null)) {
            return this.putDouble$int$double(to, value);
          } else if ((typeof to === 'number' || to === null) && value === undefined) {
            return this.putDouble$double(to);
          } else throw new Error('invalid overload');
        };

        ByteBuffer.prototype.putFloat$float = function (value) {
          if (this.isReadOnly()) throw new java.nio.ReadOnlyBufferException();
          if (this.remaining() < 4) throw new java.nio.BufferOverflowException();

          this._data.setFloat32(this.position$(), value, this._order === java.nio.ByteOrder.LITTLE_ENDIAN_$LI$());

          this.position$int(this.position$() + 4);
          return this;
        };

        ByteBuffer.prototype.putFloat$int$float = function (to, value) {
          if (this.isReadOnly()) throw new java.nio.ReadOnlyBufferException();
          if (to < 0 || to > this.limit$() - 3) throw new java.lang.IndexOutOfBoundsException();

          this._data.setFloat32(to, value, this._order === java.nio.ByteOrder.LITTLE_ENDIAN_$LI$());

          return this;
        };

        ByteBuffer.prototype.putFloat = function (to, value) {
          if ((typeof to === 'number' || to === null) && (typeof value === 'number' || value === null)) {
            return this.putFloat$int$float(to, value);
          } else if ((typeof to === 'number' || to === null) && value === undefined) {
            return this.putFloat$float(to);
          } else throw new Error('invalid overload');
        };

        ByteBuffer.prototype.putInt$int = function (value) {
          if (this.isReadOnly()) throw new java.nio.ReadOnlyBufferException();
          if (this.remaining() < 4) throw new java.nio.BufferOverflowException();

          this._data.setInt32(this.position$(), value, this._order === java.nio.ByteOrder.LITTLE_ENDIAN_$LI$());

          this.position$int(this.position$() + 4);
          return this;
        };

        ByteBuffer.prototype.putInt$int$int = function (to, value) {
          if (this.isReadOnly()) throw new java.nio.ReadOnlyBufferException();
          if (to < 0 || to > this.limit$() - 3) throw new java.lang.IndexOutOfBoundsException();

          this._data.setInt32(to, value, this._order === java.nio.ByteOrder.LITTLE_ENDIAN_$LI$());

          return this;
        };

        ByteBuffer.prototype.putInt = function (to, value) {
          if ((typeof to === 'number' || to === null) && (typeof value === 'number' || value === null)) {
            return this.putInt$int$int(to, value);
          } else if ((typeof to === 'number' || to === null) && value === undefined) {
            return this.putInt$int(to);
          } else throw new Error('invalid overload');
        };

        ByteBuffer.prototype.putLong$long = function (value) {
          if (this.isReadOnly()) throw new java.nio.ReadOnlyBufferException();
          if (this.remaining() < 8) throw new java.nio.BufferOverflowException();

          var big = function (n) {
            return n < 0 ? Math.ceil(n) : Math.floor(n);
          }(value / 4294967296) | 0;

          var small = value % 4294967296 | 0;

          if (this._order === java.nio.ByteOrder.LITTLE_ENDIAN_$LI$()) {
            var tmp = big;
            big = small;
            small = tmp;
          }

          this._data.setInt32(this.position$(), big, this._order === java.nio.ByteOrder.LITTLE_ENDIAN_$LI$());

          this._data.setInt32(this.position$() + 4, small, this._order === java.nio.ByteOrder.LITTLE_ENDIAN_$LI$());

          this.position$int(this.position$() + 8);
          return this;
        };

        ByteBuffer.prototype.putLong$int$long = function (to, value) {
          if (this.isReadOnly()) throw new java.nio.ReadOnlyBufferException();
          if (to < 0 || to > this.limit$() - 7) throw new java.lang.IndexOutOfBoundsException();

          var big = function (n) {
            return n < 0 ? Math.ceil(n) : Math.floor(n);
          }(value / 4294967296) | 0;

          var small = value % 4294967296 | 0;

          if (this._order === java.nio.ByteOrder.LITTLE_ENDIAN_$LI$()) {
            var tmp = big;
            big = small;
            small = tmp;
          }

          this._data.setInt32(to, big, this._order === java.nio.ByteOrder.LITTLE_ENDIAN_$LI$());

          this._data.setInt32(to + 4, small, this._order === java.nio.ByteOrder.LITTLE_ENDIAN_$LI$());

          return this;
        };

        ByteBuffer.prototype.putLong = function (to, value) {
          if ((typeof to === 'number' || to === null) && (typeof value === 'number' || value === null)) {
            return this.putLong$int$long(to, value);
          } else if ((typeof to === 'number' || to === null) && value === undefined) {
            return this.putLong$long(to);
          } else throw new Error('invalid overload');
        };

        ByteBuffer.prototype.putShort$short = function (value) {
          if (this.isReadOnly()) throw new java.nio.ReadOnlyBufferException();
          if (this.remaining() < 2) throw new java.nio.BufferOverflowException();

          this._data.setInt16(this.position$(), value, this._order === java.nio.ByteOrder.LITTLE_ENDIAN_$LI$());

          this.position$int(this.position$() + 2);
          return this;
        };

        ByteBuffer.prototype.putShort$int$short = function (to, value) {
          if (this.isReadOnly()) throw new java.nio.ReadOnlyBufferException();
          if (to < 0 || to > this.limit$() - 1) throw new java.lang.IndexOutOfBoundsException();

          this._data.setInt16(to, value, this._order === java.nio.ByteOrder.LITTLE_ENDIAN_$LI$());

          return this;
        };

        ByteBuffer.prototype.putShort = function (to, value) {
          if ((typeof to === 'number' || to === null) && (typeof value === 'number' || value === null)) {
            return this.putShort$int$short(to, value);
          } else if ((typeof to === 'number' || to === null) && value === undefined) {
            return this.putShort$short(to);
          } else throw new Error('invalid overload');
        };

        ByteBuffer.prototype.slice = function () {
          return new ByteBuffer(this._buffer, this.isReadOnly());
        };
        /**
        *
        * @return {number}
        */


        ByteBuffer.prototype.hashCode = function () {
          return java.util.Objects.hash(this._array);
        };

        ByteBuffer.wrap$byte_A = function (array) {
          return ByteBuffer.wrap$byte_A$int$int(array, 0, array.length);
        };

        ByteBuffer.wrap$byte_A$int$int = function (array, offset, length) {
          var buffer = new ArrayBuffer(length);
          var bytes = new Int8Array(buffer);
          bytes.set(Int8Array.from(array.slice(offset, offset + length)));
          return new ByteBuffer(buffer, true);
        };

        ByteBuffer.wrap = function (array, offset, length) {
          if ((array != null && array instanceof Array && (array.length == 0 || array[0] == null || typeof array[0] === 'number') || array === null) && (typeof offset === 'number' || offset === null) && (typeof length === 'number' || length === null)) {
            return java.nio.ByteBuffer.wrap$byte_A$int$int(array, offset, length);
          } else if ((array != null && array instanceof ArrayBuffer || array === null) && (typeof offset === 'number' || offset === null) && (typeof length === 'number' || length === null)) {
            return java.nio.ByteBuffer.wrap$def_js_ArrayBuffer$int$double(array, offset, length);
          } else if ((array != null && array instanceof Array && (array.length == 0 || array[0] == null || typeof array[0] === 'number') || array === null) && offset === undefined && length === undefined) {
            return java.nio.ByteBuffer.wrap$byte_A(array);
          } else if ((array != null && array instanceof ArrayBuffer || array === null) && offset === undefined && length === undefined) {
            return java.nio.ByteBuffer.wrap$def_js_ArrayBuffer(array);
          } else throw new Error('invalid overload');
        };

        ByteBuffer.wrap$def_js_ArrayBuffer = function (array) {
          return ByteBuffer.wrap$def_js_ArrayBuffer$int$double(array, 0, array.byteLength);
        };
        /*private*/


        ByteBuffer.wrap$def_js_ArrayBuffer$int$double = function (array, offset, length) {
          return new ByteBuffer(array.slice(offset, offset + length), false);
        };

        return ByteBuffer;
      }(java.nio.Buffer);

      nio.ByteBuffer = ByteBuffer;
      ByteBuffer["__class"] = "java.nio.ByteBuffer";
      ByteBuffer["__interfaces"] = ["java.lang.Comparable"];
    })(java.nio || (java.nio = {}));
  })(java || (java = {}));

  (function (javaemul) {
    (function (internal) {
      /**
      * Provides Charset implementations.
      * @param {string} name
      * @class
      * @extends java.nio.charset.Charset
      */
      var EmulatedCharset =
      /** @class */
      function (_super) {
        __extends(EmulatedCharset, _super);

        function EmulatedCharset(name) {
          return _super.call(this, name, null) || this;
        }

        EmulatedCharset.UTF_8_$LI$ = function () {
          if (EmulatedCharset.UTF_8 == null) {
            EmulatedCharset.UTF_8 = new EmulatedCharset.UtfCharset("UTF-8");
          }

          return EmulatedCharset.UTF_8;
        };

        EmulatedCharset.ISO_LATIN_1_$LI$ = function () {
          if (EmulatedCharset.ISO_LATIN_1 == null) {
            EmulatedCharset.ISO_LATIN_1 = new EmulatedCharset.LatinCharset("ISO-LATIN-1");
          }

          return EmulatedCharset.ISO_LATIN_1;
        };

        EmulatedCharset.ISO_8859_1_$LI$ = function () {
          if (EmulatedCharset.ISO_8859_1 == null) {
            EmulatedCharset.ISO_8859_1 = new EmulatedCharset.LatinCharset("ISO-8859-1");
          }

          return EmulatedCharset.ISO_8859_1;
        };

        return EmulatedCharset;
      }(java.nio.charset.Charset);

      internal.EmulatedCharset = EmulatedCharset;
      EmulatedCharset["__class"] = "javaemul.internal.EmulatedCharset";
      EmulatedCharset["__interfaces"] = ["java.lang.Comparable"];

      (function (EmulatedCharset) {
        var LatinCharset =
        /** @class */
        function (_super) {
          __extends(LatinCharset, _super);

          function LatinCharset(name) {
            return _super.call(this, name) || this;
          }
          /**
          *
          * @param {string} str
          * @return {Array}
          */


          LatinCharset.prototype.getBytes = function (str) {
            var n = str.length;

            var bytes = function (s) {
              var a = [];

              while (s-- > 0) {
                a.push(0);
              }

              return a;
            }(n);

            for (var i = 0; i < n; ++i) {
              {
                bytes[i] = function (c) {
                  return c.charCodeAt == null ? c : c.charCodeAt(0);
                }(str.charAt(i)) & 255 | 0;
              }
            }

            return bytes;
          };
          /**
          *
          * @param {Array} bytes
          * @param {number} ofs
          * @param {number} len
          * @return {Array}
          */


          LatinCharset.prototype.decodeString = function (bytes, ofs, len) {
            var chars = function (s) {
              var a = [];

              while (s-- > 0) {
                a.push(null);
              }

              return a;
            }(len);

            for (var i = 0; i < len; ++i) {
              {
                chars[i] = String.fromCharCode(bytes[ofs + i] & 255);
              }
            }

            return chars;
          };

          return LatinCharset;
        }(javaemul.internal.EmulatedCharset);

        EmulatedCharset.LatinCharset = LatinCharset;
        LatinCharset["__class"] = "javaemul.internal.EmulatedCharset.LatinCharset";
        LatinCharset["__interfaces"] = ["java.lang.Comparable"];

        var UtfCharset =
        /** @class */
        function (_super) {
          __extends(UtfCharset, _super);

          function UtfCharset(name) {
            return _super.call(this, name) || this;
          }
          /**
          *
          * @param {Array} bytes
          * @param {number} ofs
          * @param {number} len
          * @return {Array}
          */


          UtfCharset.prototype.decodeString = function (bytes, ofs, len) {
            var charCount = 0;

            for (var i = 0; i < len;) {
              {
                ++charCount;
                var ch = bytes[ofs + i];

                if ((ch & 192) === 128) {
                  throw new java.lang.IllegalArgumentException("Invalid UTF8 sequence");
                } else if ((ch & 128) === 0) {
                  ++i;
                } else if ((ch & 224) === 192) {
                  i += 2;
                } else if ((ch & 240) === 224) {
                  i += 3;
                } else if ((ch & 248) === 240) {
                  i += 4;
                } else {
                  throw new java.lang.IllegalArgumentException("Invalid UTF8 sequence");
                }

                if (i > len) {
                  throw new java.lang.IndexOutOfBoundsException("Invalid UTF8 sequence");
                }
              }
            }

            var chars = function (s) {
              var a = [];

              while (s-- > 0) {
                a.push(null);
              }

              return a;
            }(charCount);

            var outIdx = 0;
            var count = 0;

            for (var i = 0; i < len;) {
              {
                var ch = bytes[ofs + i++];

                if ((ch & 128) === 0) {
                  count = 1;
                  ch &= 127;
                } else if ((ch & 224) === 192) {
                  count = 2;
                  ch &= 31;
                } else if ((ch & 240) === 224) {
                  count = 3;
                  ch &= 15;
                } else if ((ch & 248) === 240) {
                  count = 4;
                  ch &= 7;
                } else if ((ch & 252) === 248) {
                  count = 5;
                  ch &= 3;
                }

                while (--count > 0) {
                  {
                    var b = bytes[ofs + i++];

                    if ((b & 192) !== 128) {
                      throw new java.lang.IllegalArgumentException("Invalid UTF8 sequence at " + (ofs + i - 1) + ", byte=" + javaemul.internal.IntegerHelper.toHexString(b));
                    }

                    ch = ch << 6 | b & 63;
                  }
                }

                outIdx += javaemul.internal.CharacterHelper.toChars$int$char_A$int(ch, chars, outIdx);
              }
            }

            return chars;
          };
          /**
          *
          * @param {string} str
          * @return {Array}
          */


          UtfCharset.prototype.getBytes = function (str) {
            var n = str.length;
            var byteCount = 0;

            for (var i = 0; i < n;) {
              {
                var ch = str.charCodeAt(i);
                i += javaemul.internal.CharacterHelper.charCount(ch);

                if (ch < 1 << 7) {
                  byteCount++;
                } else if (ch < 1 << 11) {
                  byteCount += 2;
                } else if (ch < 1 << 16) {
                  byteCount += 3;
                } else if (ch < 1 << 21) {
                  byteCount += 4;
                } else if (ch < 1 << 26) {
                  byteCount += 5;
                }
              }
            }

            var bytes = function (s) {
              var a = [];

              while (s-- > 0) {
                a.push(0);
              }

              return a;
            }(byteCount);

            var out = 0;

            for (var i = 0; i < n;) {
              {
                var ch = str.charCodeAt(i);
                i += javaemul.internal.CharacterHelper.charCount(ch);
                out += this.encodeUtf8(bytes, out, ch);
              }
            }

            return bytes;
          };
          /**
          * Encode a single character in UTF8.
          *
          * @param {Array} bytes byte array to store character in
          * @param {number} ofs offset into byte array to store first byte
          * @param {number} codePoint character to encode
          * @return {number} number of bytes consumed by encoding the character
          * @throws IllegalArgumentException if codepoint >= 2^26
          * @private
          */


          UtfCharset.prototype.encodeUtf8 = function (bytes, ofs, codePoint) {
            if (codePoint < 1 << 7) {
              bytes[ofs] = codePoint & 127 | 0;
              return 1;
            } else if (codePoint < 1 << 11) {
              bytes[ofs++] = codePoint >> 6 & 31 | 192 | 0;
              bytes[ofs] = codePoint & 63 | 128 | 0;
              return 2;
            } else if (codePoint < 1 << 16) {
              bytes[ofs++] = codePoint >> 12 & 15 | 224 | 0;
              bytes[ofs++] = codePoint >> 6 & 63 | 128 | 0;
              bytes[ofs] = codePoint & 63 | 128 | 0;
              return 3;
            } else if (codePoint < 1 << 21) {
              bytes[ofs++] = codePoint >> 18 & 7 | 240 | 0;
              bytes[ofs++] = codePoint >> 12 & 63 | 128 | 0;
              bytes[ofs++] = codePoint >> 6 & 63 | 128 | 0;
              bytes[ofs] = codePoint & 63 | 128 | 0;
              return 4;
            } else if (codePoint < 1 << 26) {
              bytes[ofs++] = codePoint >> 24 & 3 | 248 | 0;
              bytes[ofs++] = codePoint >> 18 & 63 | 128 | 0;
              bytes[ofs++] = codePoint >> 12 & 63 | 128 | 0;
              bytes[ofs++] = codePoint >> 6 & 63 | 128 | 0;
              bytes[ofs] = codePoint & 63 | 128 | 0;
              return 5;
            }

            throw new java.lang.IllegalArgumentException("Character out of range: " + codePoint);
          };

          return UtfCharset;
        }(javaemul.internal.EmulatedCharset);

        EmulatedCharset.UtfCharset = UtfCharset;
        UtfCharset["__class"] = "javaemul.internal.EmulatedCharset.UtfCharset";
        UtfCharset["__interfaces"] = ["java.lang.Comparable"];
      })(EmulatedCharset = internal.EmulatedCharset || (internal.EmulatedCharset = {}));
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (javaemul) {
    (function (internal) {
      (function (stream) {
        var StreamRowSortingCollector =
        /** @class */
        function (_super) {
          __extends(StreamRowSortingCollector, _super);

          function StreamRowSortingCollector(collection, comparator) {
            var _this = _super.call(this, collection) || this;

            if (_this.comparator === undefined) {
              _this.comparator = null;
            }

            _this.comparator = comparator;
            return _this;
          }
          /**
          *
          */


          StreamRowSortingCollector.prototype.end = function () {
            java.util.Collections.sort$java_util_List$java_util_Comparator(this.collection, this.comparator);

            _super.prototype.end.call(this);
          };

          return StreamRowSortingCollector;
        }(javaemul.internal.stream.StreamRowCollector);

        stream.StreamRowSortingCollector = StreamRowSortingCollector;
        StreamRowSortingCollector["__class"] = "javaemul.internal.stream.StreamRowSortingCollector";
        StreamRowSortingCollector["__interfaces"] = ["javaemul.internal.stream.StreamRow"];
      })(internal.stream || (internal.stream = {}));
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (java) {
    (function (util) {
      /**
      * Skeletal implementation of the Map interface.
      * <a href="http://java.sun.com/j2se/1.5.0/docs/api/java/util/AbstractMap.html">
      * [Sun docs]</a>
      *
      * @param <K>
      * the key type.
      * @param <V>
      * the value type.
      * @class
      */
      var AbstractMap =
      /** @class */
      function () {
        function AbstractMap() {}
        /* Default method injected from java.util.Map */


        AbstractMap.prototype.putIfAbsent = function (key, value) {
          var v = this.get(key);

          if (v == null) {
            v = this.put(key, value);
          }

          return v;
        };
        /* Default method injected from java.util.Map */


        AbstractMap.prototype.computeIfAbsent = function (key, mappingFunction) {
          var result;

          if ((result = this.get(key)) == null) {
            result = function (target) {
              return typeof target === 'function' ? target(key) : target.apply(key);
            }(mappingFunction);

            if (result != null) this.put(key, result);
          }

          return result;
        };
        /* Default method injected from java.util.Map */


        AbstractMap.prototype.merge = function (key, value, map) {
          var old = this.get(key);
          var next = old == null ? value : function (target) {
            return typeof target === 'function' ? target(old, value) : target.apply(old, value);
          }(map);

          if (next == null) {
            this.remove(key);
          } else {
            this.put(key, next);
          }

          return next;
        };
        /* Default method injected from java.util.Map */


        AbstractMap.prototype.getOrDefault = function (key, defaultValue) {
          var v;
          return (v = this.get(key)) != null || this.containsKey(key) ? v : defaultValue;
        };
        /* Default method injected from java.util.Map */


        AbstractMap.prototype.replaceAll = function (__function) {
          java.util.Objects.requireNonNull(__function);

          var _loop_13 = function _loop_13(index142) {
            var entry = index142.next();
            {
              var k_1;
              var v_1;

              try {
                k_1 = entry.getKey();
                v_1 = entry.getValue();
              } catch (ise) {
                throw new java.lang.RuntimeException(ise);
              }

              v_1 = function (target) {
                return typeof target === 'function' ? target(k_1, v_1) : target.apply(k_1, v_1);
              }(__function);

              try {
                entry.setValue(v_1);
              } catch (ise) {
                throw new java.lang.RuntimeException(ise);
              }
            }
          };

          for (var index142 = this.entrySet().iterator(); index142.hasNext();) {
            _loop_13(index142);
          }
        };
        /**
        *
        */


        AbstractMap.prototype.clear = function () {
          this.entrySet().clear();
        };
        /**
        *
        * @param {*} key
        * @return {boolean}
        */


        AbstractMap.prototype.containsKey = function (key) {
          return this.implFindEntry(key, false) != null;
        };
        /**
        *
        * @param {*} value
        * @return {boolean}
        */


        AbstractMap.prototype.containsValue = function (value) {
          for (var index143 = this.entrySet().iterator(); index143.hasNext();) {
            var entry = index143.next();
            {
              var v = entry.getValue();

              if (java.util.Objects.equals(value, v)) {
                return true;
              }
            }
          }

          return false;
        };

        AbstractMap.prototype.containsEntry = function (entry) {
          var key = entry.getKey();
          var value = entry.getValue();
          var ourValue = this.get(key);

          if (!java.util.Objects.equals(value, ourValue)) {
            return false;
          }

          if (ourValue == null && !this.containsKey(key)) {
            return false;
          }

          return true;
        };
        /**
        *
        * @param {*} obj
        * @return {boolean}
        */


        AbstractMap.prototype.equals = function (obj) {
          if (obj === this) {
            return true;
          }

          if (!(obj != null && obj.constructor != null && obj.constructor["__interfaces"] != null && obj.constructor["__interfaces"].indexOf("java.util.Map") >= 0)) {
            return false;
          }

          var otherMap = obj;

          if (this.size() !== otherMap.size()) {
            return false;
          }

          for (var index144 = otherMap.entrySet().iterator(); index144.hasNext();) {
            var entry = index144.next();
            {
              if (!this.containsEntry(entry)) {
                return false;
              }
            }
          }

          return true;
        };
        /**
        *
        * @param {*} key
        * @return {*}
        */


        AbstractMap.prototype.get = function (key) {
          return AbstractMap.getEntryValueOrNull(this.implFindEntry(key, false));
        };
        /**
        *
        * @return {number}
        */


        AbstractMap.prototype.hashCode = function () {
          return java.util.Collections.hashCode$java_lang_Iterable(this.entrySet());
        };
        /**
        *
        * @return {boolean}
        */


        AbstractMap.prototype.isEmpty = function () {
          return this.size() === 0;
        };
        /**
        *
        * @return {*}
        */


        AbstractMap.prototype.keySet = function () {
          return new AbstractMap.AbstractMap$0(this);
        };
        /**
        *
        * @param {*} key
        * @param {*} value
        * @return {*}
        */


        AbstractMap.prototype.put = function (key, value) {
          throw new java.lang.UnsupportedOperationException("Put not supported on this map");
        };
        /**
        *
        * @param {*} map
        */


        AbstractMap.prototype.putAll = function (map) {
          javaemul.internal.InternalPreconditions.checkNotNull(map);

          for (var index145 = map.entrySet().iterator(); index145.hasNext();) {
            var e = index145.next();
            {
              this.put(e.getKey(), e.getValue());
            }
          }
        };
        /**
        *
        * @param {*} key
        * @return {*}
        */


        AbstractMap.prototype.remove = function (key) {
          return AbstractMap.getEntryValueOrNull(this.implFindEntry(key, true));
        };
        /**
        *
        * @return {number}
        */


        AbstractMap.prototype.size = function () {
          return this.entrySet().size();
        };

        AbstractMap.prototype.toString$ = function () {
          var joiner = new java.util.StringJoiner(", ", "{", "}");

          for (var index146 = this.entrySet().iterator(); index146.hasNext();) {
            var entry = index146.next();
            {
              joiner.add(this.toString$java_util_Map_Entry(entry));
            }
          }

          return joiner.toString();
        };

        AbstractMap.prototype.toString$java_util_Map_Entry = function (entry) {
          return this.toString$java_lang_Object(entry.getKey()) + "=" + this.toString$java_lang_Object(entry.getValue());
        };

        AbstractMap.prototype.toString = function (entry) {
          if (entry != null && entry.constructor != null && entry.constructor["__interfaces"] != null && entry.constructor["__interfaces"].indexOf("java.util.Map.Entry") >= 0 || entry === null) {
            return this.toString$java_util_Map_Entry(entry);
          } else if (entry != null || entry === null) {
            return this.toString$java_lang_Object(entry);
          } else if (entry === undefined) {
            return this.toString$();
          } else throw new Error('invalid overload');
        };

        AbstractMap.prototype.toString$java_lang_Object = function (o) {
          return o === this ? "(this Map)" :
          /* valueOf */
          new String(o).toString();
        };
        /**
        *
        * @return {*}
        */


        AbstractMap.prototype.values = function () {
          return new AbstractMap.AbstractMap$1(this);
        };

        AbstractMap.getEntryKeyOrNull = function (entry) {
          return entry == null ? null : entry.getKey();
        };

        AbstractMap.getEntryValueOrNull = function (entry) {
          return entry == null ? null : entry.getValue();
        };

        AbstractMap.prototype.implFindEntry = function (key, remove) {
          for (var iter = this.entrySet().iterator(); iter.hasNext();) {
            {
              var entry = iter.next();
              var k = entry.getKey();

              if (java.util.Objects.equals(key, k)) {
                if (remove) {
                  entry = new AbstractMap.SimpleEntry(entry.getKey(), entry.getValue());
                  iter.remove();
                }

                return entry;
              }
            }
          }

          return null;
        };

        return AbstractMap;
      }();

      util.AbstractMap = AbstractMap;
      AbstractMap["__class"] = "java.util.AbstractMap";
      AbstractMap["__interfaces"] = ["java.util.Map"];

      (function (AbstractMap) {
        /**
        * Basic {@link Map.Entry} implementation used by {@link SimpleEntry} and
        * {@link SimpleImmutableEntry}.
        * @class
        */
        var AbstractEntry =
        /** @class */
        function () {
          function AbstractEntry(key, value) {
            if (this.key === undefined) {
              this.key = null;
            }

            if (this.value === undefined) {
              this.value = null;
            }

            this.key = key;
            this.value = value;
          }
          /**
          *
          * @return {*}
          */


          AbstractEntry.prototype.getKey = function () {
            return this.key;
          };
          /**
          *
          * @return {*}
          */


          AbstractEntry.prototype.getValue = function () {
            return this.value;
          };
          /**
          *
          * @param {*} value
          * @return {*}
          */


          AbstractEntry.prototype.setValue = function (value) {
            var oldValue = this.value;
            this.value = value;
            return oldValue;
          };
          /**
          *
          * @param {*} other
          * @return {boolean}
          */


          AbstractEntry.prototype.equals = function (other) {
            if (!(other != null && other.constructor != null && other.constructor["__interfaces"] != null && other.constructor["__interfaces"].indexOf("java.util.Map.Entry") >= 0)) {
              return false;
            }

            var entry = other;
            return java.util.Objects.equals(this.key, entry.getKey()) && java.util.Objects.equals(this.value, entry.getValue());
          };
          /**
          * Calculate the hash code using Sun's specified algorithm.
          * @return {number}
          */


          AbstractEntry.prototype.hashCode = function () {
            return java.util.Objects.hashCode(this.key) ^ java.util.Objects.hashCode(this.value);
          };
          /**
          *
          * @return {string}
          */


          AbstractEntry.prototype.toString = function () {
            return this.key + "=" + this.value;
          };

          return AbstractEntry;
        }();

        AbstractMap.AbstractEntry = AbstractEntry;
        AbstractEntry["__class"] = "java.util.AbstractMap.AbstractEntry";
        AbstractEntry["__interfaces"] = ["java.util.Map.Entry"];
        /**
        * A mutable {@link Map.Entry} shared by several {@link Map}
        * implementations.
        * @param {*} key
        * @param {*} value
        * @class
        * @extends java.util.AbstractMap.AbstractEntry
        */

        var SimpleEntry =
        /** @class */
        function (_super) {
          __extends(SimpleEntry, _super);

          function SimpleEntry(key, value) {
            var _this = this;

            if ((key != null || key === null) && (value != null || value === null)) {
              var __args = arguments;
              _this = _super.call(this, key, value) || this;
            } else if ((key != null && key.constructor != null && key.constructor["__interfaces"] != null && key.constructor["__interfaces"].indexOf("java.util.Map.Entry") >= 0 || key === null) && value === undefined) {
              var __args = arguments;
              var entry = __args[0];
              _this = _super.call(this, entry.getKey(), entry.getValue()) || this;
            } else throw new Error('invalid overload');

            return _this;
          }

          return SimpleEntry;
        }(AbstractMap.AbstractEntry);

        AbstractMap.SimpleEntry = SimpleEntry;
        SimpleEntry["__class"] = "java.util.AbstractMap.SimpleEntry";
        SimpleEntry["__interfaces"] = ["java.util.Map.Entry"];
        /**
        * An immutable {@link Map.Entry} shared by several {@link Map}
        * implementations.
        * @param {*} key
        * @param {*} value
        * @class
        * @extends java.util.AbstractMap.AbstractEntry
        */

        var SimpleImmutableEntry =
        /** @class */
        function (_super) {
          __extends(SimpleImmutableEntry, _super);

          function SimpleImmutableEntry(key, value) {
            var _this = this;

            if ((key != null || key === null) && (value != null || value === null)) {
              var __args = arguments;
              _this = _super.call(this, key, value) || this;
            } else if ((key != null && key.constructor != null && key.constructor["__interfaces"] != null && key.constructor["__interfaces"].indexOf("java.util.Map.Entry") >= 0 || key === null) && value === undefined) {
              var __args = arguments;
              var entry = __args[0];
              _this = _super.call(this, entry.getKey(), entry.getValue()) || this;
            } else throw new Error('invalid overload');

            return _this;
          }
          /**
          *
          * @param {*} value
          * @return {*}
          */


          SimpleImmutableEntry.prototype.setValue = function (value) {
            throw new java.lang.UnsupportedOperationException();
          };

          return SimpleImmutableEntry;
        }(AbstractMap.AbstractEntry);

        AbstractMap.SimpleImmutableEntry = SimpleImmutableEntry;
        SimpleImmutableEntry["__class"] = "java.util.AbstractMap.SimpleImmutableEntry";
        SimpleImmutableEntry["__interfaces"] = ["java.util.Map.Entry"];

        var AbstractMap$0 =
        /** @class */
        function (_super) {
          __extends(AbstractMap$0, _super);

          function AbstractMap$0(__parent) {
            var _this = _super.call(this) || this;

            _this.__parent = __parent;
            return _this;
          }
          /**
          *
          */


          AbstractMap$0.prototype.clear = function () {
            this.clear();
          };
          /**
          *
          * @param {*} key
          * @return {boolean}
          */


          AbstractMap$0.prototype.contains = function (key) {
            return this.__parent.containsKey(key);
          };
          /**
          *
          * @return {*}
          */


          AbstractMap$0.prototype.iterator = function () {
            var outerIter = this.__parent.entrySet().iterator();

            return new AbstractMap$0.AbstractMap$0$0(this, outerIter);
          };
          /**
          *
          * @param {*} key
          * @return {boolean}
          */


          AbstractMap$0.prototype.remove = function (key) {
            if (this.__parent.containsKey(key)) {
              this.remove(key);
              return true;
            }

            return false;
          };
          /**
          *
          * @return {number}
          */


          AbstractMap$0.prototype.size = function () {
            return this.size();
          };

          return AbstractMap$0;
        }(java.util.AbstractSet);

        AbstractMap.AbstractMap$0 = AbstractMap$0;
        AbstractMap$0["__interfaces"] = ["java.util.Collection", "java.util.Set", "java.lang.Iterable"];

        (function (AbstractMap$0) {
          var AbstractMap$0$0 =
          /** @class */
          function () {
            function AbstractMap$0$0(__parent, outerIter) {
              this.outerIter = outerIter;
              this.__parent = __parent;
            }
            /* Default method injected from java.util.Iterator */


            AbstractMap$0$0.prototype.forEachRemaining = function (consumer) {
              var _this = this;

              javaemul.internal.InternalPreconditions.checkNotNull(consumer);

              while (this.hasNext()) {
                {
                  (function (target) {
                    return typeof target === 'function' ? target(_this.next()) : target.accept(_this.next());
                  })(consumer);
                }
              }
            };
            /**
            *
            * @return {boolean}
            */


            AbstractMap$0$0.prototype.hasNext = function () {
              return this.outerIter.hasNext();
            };
            /**
            *
            * @return {*}
            */


            AbstractMap$0$0.prototype.next = function () {
              var entry = this.outerIter.next();
              return entry.getKey();
            };
            /**
            *
            */


            AbstractMap$0$0.prototype.remove = function () {
              this.outerIter.remove();
            };

            return AbstractMap$0$0;
          }();

          AbstractMap$0.AbstractMap$0$0 = AbstractMap$0$0;
          AbstractMap$0$0["__interfaces"] = ["java.util.Iterator"];
        })(AbstractMap$0 = AbstractMap.AbstractMap$0 || (AbstractMap.AbstractMap$0 = {}));

        var AbstractMap$1 =
        /** @class */
        function (_super) {
          __extends(AbstractMap$1, _super);

          function AbstractMap$1(__parent) {
            var _this = _super.call(this) || this;

            _this.__parent = __parent;
            return _this;
          }
          /**
          *
          */


          AbstractMap$1.prototype.clear = function () {
            this.clear();
          };
          /**
          *
          * @param {*} value
          * @return {boolean}
          */


          AbstractMap$1.prototype.contains = function (value) {
            return this.__parent.containsValue(value);
          };
          /**
          *
          * @return {*}
          */


          AbstractMap$1.prototype.iterator = function () {
            var outerIter = this.__parent.entrySet().iterator();

            return new AbstractMap$1.AbstractMap$1$0(this, outerIter);
          };
          /**
          *
          * @return {number}
          */


          AbstractMap$1.prototype.size = function () {
            return this.size();
          };

          return AbstractMap$1;
        }(java.util.AbstractCollection);

        AbstractMap.AbstractMap$1 = AbstractMap$1;
        AbstractMap$1["__interfaces"] = ["java.util.Collection", "java.lang.Iterable"];

        (function (AbstractMap$1) {
          var AbstractMap$1$0 =
          /** @class */
          function () {
            function AbstractMap$1$0(__parent, outerIter) {
              this.outerIter = outerIter;
              this.__parent = __parent;
            }
            /* Default method injected from java.util.Iterator */


            AbstractMap$1$0.prototype.forEachRemaining = function (consumer) {
              var _this = this;

              javaemul.internal.InternalPreconditions.checkNotNull(consumer);

              while (this.hasNext()) {
                {
                  (function (target) {
                    return typeof target === 'function' ? target(_this.next()) : target.accept(_this.next());
                  })(consumer);
                }
              }
            };
            /**
            *
            * @return {boolean}
            */


            AbstractMap$1$0.prototype.hasNext = function () {
              return this.outerIter.hasNext();
            };
            /**
            *
            * @return {*}
            */


            AbstractMap$1$0.prototype.next = function () {
              var entry = this.outerIter.next();
              return entry.getValue();
            };
            /**
            *
            */


            AbstractMap$1$0.prototype.remove = function () {
              this.outerIter.remove();
            };

            return AbstractMap$1$0;
          }();

          AbstractMap$1.AbstractMap$1$0 = AbstractMap$1$0;
          AbstractMap$1$0["__interfaces"] = ["java.util.Iterator"];
        })(AbstractMap$1 = AbstractMap.AbstractMap$1 || (AbstractMap.AbstractMap$1 = {}));
      })(AbstractMap = util.AbstractMap || (util.AbstractMap = {}));
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * Implements a set in terms of a hash table. <a
      * href="http://java.sun.com/j2se/1.5.0/docs/api/java/util/HashSet.html">[Sun
      * docs]</a>
      *
      * @param <E> element type.
      * @param {number} initialCapacity
      * @param {number} loadFactor
      * @class
      * @extends java.util.AbstractSet
      */
      var HashSet =
      /** @class */
      function (_super) {
        __extends(HashSet, _super);

        function HashSet(initialCapacity, loadFactor) {
          var _this = this;

          if ((typeof initialCapacity === 'number' || initialCapacity === null) && (typeof loadFactor === 'number' || loadFactor === null)) {
            var __args = arguments;
            _this = _super.call(this) || this;

            if (_this.map === undefined) {
              _this.map = null;
            }

            if (_this.exposeElement === undefined) {
              _this.exposeElement = null;
            }

            _this.map = new java.util.HashMap(initialCapacity, loadFactor);
          } else if ((initialCapacity != null && initialCapacity.constructor != null && initialCapacity.constructor["__interfaces"] != null && initialCapacity.constructor["__interfaces"].indexOf("java.util.Collection") >= 0 || initialCapacity === null) && loadFactor === undefined) {
            var __args = arguments;
            var c = __args[0];
            _this = _super.call(this) || this;

            if (_this.map === undefined) {
              _this.map = null;
            }

            if (_this.exposeElement === undefined) {
              _this.exposeElement = null;
            }

            _this.map = new java.util.HashMap(c.size());

            _this.addAll(c);
          } else if ((initialCapacity != null && initialCapacity instanceof java.util.HashMap || initialCapacity === null) && loadFactor === undefined) {
            var __args = arguments;
            var map = __args[0];
            _this = _super.call(this) || this;

            if (_this.map === undefined) {
              _this.map = null;
            }

            if (_this.exposeElement === undefined) {
              _this.exposeElement = null;
            }

            _this.map = map;
          } else if ((typeof initialCapacity === 'number' || initialCapacity === null) && loadFactor === undefined) {
            var __args = arguments;
            _this = _super.call(this) || this;

            if (_this.map === undefined) {
              _this.map = null;
            }

            if (_this.exposeElement === undefined) {
              _this.exposeElement = null;
            }

            _this.map = new java.util.HashMap(initialCapacity);
          } else if (initialCapacity === undefined && loadFactor === undefined) {
            var __args = arguments;
            _this = _super.call(this) || this;

            if (_this.map === undefined) {
              _this.map = null;
            }

            if (_this.exposeElement === undefined) {
              _this.exposeElement = null;
            }

            _this.map = new java.util.HashMap();
          } else throw new Error('invalid overload');

          return _this;
        }
        /* Default method injected from java.util.Collection */


        HashSet.prototype.stream = function () {
          return new javaemul.internal.stream.StreamHelper(this);
        };
        /* Default method injected from java.lang.Iterable */


        HashSet.prototype.forEach = function (action) {
          javaemul.internal.InternalPreconditions.checkNotNull(action);

          var _loop_14 = function _loop_14(index147) {
            var t = index147.next();
            {
              (function (target) {
                return typeof target === 'function' ? target(t) : target.accept(t);
              })(action);
            }
          };

          for (var index147 = this.iterator(); index147.hasNext();) {
            _loop_14(index147);
          }
        };
        /* Default method injected from java.util.Collection */


        HashSet.prototype.parallelStream = function () {
          return this.stream();
        };
        /* Default method injected from java.util.Collection */


        HashSet.prototype.removeIf = function (filter) {
          javaemul.internal.InternalPreconditions.checkNotNull(filter);
          var removed = false;

          var _loop_15 = function _loop_15(it) {
            {
              if (function (target) {
                return typeof target === 'function' ? target(it.next()) : target.test(it.next());
              }(filter)) {
                it.remove();
                removed = true;
              }
            }
          };

          for (var it = this.iterator(); it.hasNext();) {
            _loop_15(it);
          }

          return removed;
        };
        /**
        *
        * @param {*} o
        * @return {boolean}
        */


        HashSet.prototype.add = function (o) {
          var old = this.map.put(o, this);
          return old == null;
        };
        /**
        *
        */


        HashSet.prototype.clear = function () {
          this.map.clear();
        };

        HashSet.prototype.clone = function () {
          return new HashSet(this);
        };
        /**
        *
        * @param {*} o
        * @return {boolean}
        */


        HashSet.prototype.contains = function (o) {
          return this.map.containsKey(o);
        };
        /**
        *
        * @return {boolean}
        */


        HashSet.prototype.isEmpty = function () {
          return this.map.isEmpty();
        };
        /**
        *
        * @return {*}
        */


        HashSet.prototype.iterator = function () {
          return this.map.keySet().iterator();
        };
        /**
        *
        * @param {*} o
        * @return {boolean}
        */


        HashSet.prototype.remove = function (o) {
          return this.map.remove(o) != null;
        };
        /**
        *
        * @return {number}
        */


        HashSet.prototype.size = function () {
          return this.map.size();
        };
        /**
        *
        * @return {string}
        */


        HashSet.prototype.toString = function () {
          return this.map.keySet().toString();
        };

        return HashSet;
      }(java.util.AbstractSet);

      util.HashSet = HashSet;
      HashSet["__class"] = "java.util.HashSet";
      HashSet["__interfaces"] = ["java.lang.Cloneable", "java.util.Collection", "java.util.Set", "java.lang.Iterable", "java.io.Serializable"];
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * A {@link java.util.Set} of {@link Enum}s. <a
      * href="http://java.sun.com/j2se/1.5.0/docs/api/java/util/EnumSet.html">[Sun
      * docs]</a>
      *
      * @param <E> enumeration type
      * @extends java.util.AbstractSet
      * @class
      */
      var EnumSet =
      /** @class */
      function (_super) {
        __extends(EnumSet, _super);

        function EnumSet() {
          return _super.call(this) || this;
        }

        EnumSet.allOf = function (elementType) {
          var all = elementType.getEnumConstants();
          var set = javaemul.internal.ArrayHelper.clone(all, 0, all.length);
          return new EnumSet.EnumSetImpl(all, set, all.length);
        };

        EnumSet.complementOf = function (other) {
          var s = other;
          var all = s.all;
          var oldSet = s.set;
          var newSet = javaemul.internal.ArrayHelper.createFrom(oldSet, oldSet.length);

          for (var i = 0, c = oldSet.length; i < c; ++i) {
            {
              if (oldSet[i] == null) {
                newSet[i] = all[i];
              }
            }
          }

          return new EnumSet.EnumSetImpl(all, newSet, all.length - s.__size);
        };

        EnumSet.copyOf$java_util_Collection = function (c) {
          if (c != null && c instanceof java.util.EnumSet) {
            return EnumSet.copyOf$java_util_Collection(c);
          }

          javaemul.internal.InternalPreconditions.checkArgument(!c.isEmpty(), "Collection is empty");
          var iterator = c.iterator();
          var first = iterator.next();
          var set = EnumSet.of(first);

          while (iterator.hasNext()) {
            {
              var e = iterator.next();
              set.add(e);
            }
          }

          return set;
        };

        EnumSet.copyOf$java_util_EnumSet = function (s) {
          return (
            /* clone */
            function (o) {
              if (o.clone != undefined) {
                return o.clone();
              } else {
                var clone = Object.create(o);

                for (var p in o) {
                  if (o.hasOwnProperty(p)) clone[p] = o[p];
                }

                return clone;
              }
            }(s)
          );
        };

        EnumSet.copyOf = function (s) {
          if (s != null && s instanceof java.util.EnumSet || s === null) {
            return java.util.EnumSet.copyOf$java_util_EnumSet(s);
          } else if (s != null && s.constructor != null && s.constructor["__interfaces"] != null && s.constructor["__interfaces"].indexOf("java.util.Collection") >= 0 || s === null) {
            return java.util.EnumSet.copyOf$java_util_Collection(s);
          } else throw new Error('invalid overload');
        };

        EnumSet.noneOf = function (elementType) {
          var all = elementType.getEnumConstants();
          return new EnumSet.EnumSetImpl(all, javaemul.internal.ArrayHelper.createFrom(all, all.length), 0);
        };

        EnumSet.ofOne = function (first) {
          var set = EnumSet.noneOf(first.getDeclaringClass());
          set.add(first);
          return set;
        };

        EnumSet.of = function (first) {
          var _a;

          var rest = [];

          for (var _i = 1; _i < arguments.length; _i++) {
            rest[_i - 1] = arguments[_i];
          }

          var set = EnumSet.ofOne(first);

          (_a = java.util.Collections).addAll.apply(_a, __spreadArrays([set], rest));

          return set;
        };

        EnumSet.range = function (from, to) {
          javaemul.internal.InternalPreconditions.checkArgument(from.compareTo(to) <= 0, "%s > %s", from, to);
          var all = from.getDeclaringClass().getEnumConstants();
          var set = javaemul.internal.ArrayHelper.createFrom(all, all.length);
          var start = from.ordinal();
          var end = to.ordinal() + 1;

          for (var i = start; i < end; ++i) {
            {
              set[i] = all[i];
            }
          }

          return new EnumSet.EnumSetImpl(all, set, end - start);
        };

        return EnumSet;
      }(java.util.AbstractSet);

      util.EnumSet = EnumSet;
      EnumSet["__class"] = "java.util.EnumSet";
      EnumSet["__interfaces"] = ["java.util.Collection", "java.util.Set", "java.lang.Iterable"];

      (function (EnumSet) {
        /**
        * Constructs a set taking ownership of the specified set. The size must
        * accurately reflect the number of non-null items in set.
        * @param {Array} all
        * @param {Array} set
        * @param {number} size
        * @class
        * @extends java.util.EnumSet
        */
        var EnumSetImpl =
        /** @class */
        function (_super) {
          __extends(EnumSetImpl, _super);

          function EnumSetImpl(all, set, size) {
            var _this = _super.call(this) || this;

            if (_this.all === undefined) {
              _this.all = null;
            }

            if (_this.set === undefined) {
              _this.set = null;
            }

            if (_this.__size === undefined) {
              _this.__size = 0;
            }

            _this.all = all;
            _this.set = set;
            _this.__size = size;
            return _this;
          }

          EnumSetImpl.prototype.add$java_lang_Enum = function (e) {
            javaemul.internal.InternalPreconditions.checkNotNull(e);
            var ordinal = e.ordinal();

            if (this.set[ordinal] == null) {
              this.set[ordinal] = e;
              ++this.__size;
              return true;
            }

            return false;
          };
          /**
          *
          * @param {java.lang.Enum} e
          * @return {boolean}
          */


          EnumSetImpl.prototype.add = function (e) {
            if (e != null || e === null) {
              return this.add$java_lang_Enum(e);
            } else if (e != null || e === null) {
              return _super.prototype.add.call(this, e);
            } else throw new Error('invalid overload');
          };
          /**
          *
          * @return {java.util.EnumSet}
          */


          EnumSetImpl.prototype.clone = function () {
            var clonedSet = javaemul.internal.ArrayHelper.clone(this.set, 0, this.set.length);
            return new EnumSet.EnumSetImpl(this.all, clonedSet, this.__size);
          };
          /**
          *
          * @param {*} o
          * @return {boolean}
          */


          EnumSetImpl.prototype.contains = function (o) {
            return o != null && o instanceof java.lang.Enum && this.containsEnum(o);
          };

          EnumSetImpl.prototype.containsEnum = function (e) {
            return e != null && this.set[e.ordinal()] === e;
          };
          /**
          *
          * @return {*}
          */


          EnumSetImpl.prototype.iterator = function () {
            return new EnumSetImpl.IteratorImpl(this);
          };
          /**
          *
          * @param {*} o
          * @return {boolean}
          */


          EnumSetImpl.prototype.remove = function (o) {
            return o != null && o instanceof java.lang.Enum && this.removeEnum(o);
          };

          EnumSetImpl.prototype.removeEnum = function (e) {
            if (e != null && this.set[e.ordinal()] === e) {
              this.set[e.ordinal()] = null;
              --this.__size;
              return true;
            }

            return false;
          };
          /**
          *
          * @return {number}
          */


          EnumSetImpl.prototype.size = function () {
            return this.__size;
          };
          /**
          *
          * @return {number}
          */


          EnumSetImpl.prototype.capacity = function () {
            return this.all.length;
          };

          return EnumSetImpl;
        }(java.util.EnumSet);

        EnumSet.EnumSetImpl = EnumSetImpl;
        EnumSetImpl["__class"] = "java.util.EnumSet.EnumSetImpl";
        EnumSetImpl["__interfaces"] = ["java.util.Collection", "java.util.Set", "java.lang.Iterable"];

        (function (EnumSetImpl) {
          var IteratorImpl =
          /** @class */
          function () {
            function IteratorImpl(__parent) {
              this.__parent = __parent;
              this.i = -1;
              this.last = -1;
              this.findNext();
            }
            /* Default method injected from java.util.Iterator */


            IteratorImpl.prototype.forEachRemaining = function (consumer) {
              var _this = this;

              javaemul.internal.InternalPreconditions.checkNotNull(consumer);

              while (this.hasNext()) {
                {
                  (function (target) {
                    return typeof target === 'function' ? target(_this.next()) : target.accept(_this.next());
                  })(consumer);
                }
              }
            };
            /**
            *
            * @return {boolean}
            */


            IteratorImpl.prototype.hasNext = function () {
              return this.i < this.__parent.capacity();
            };
            /**
            *
            * @return {java.lang.Enum}
            */


            IteratorImpl.prototype.next = function () {
              javaemul.internal.InternalPreconditions.checkElement(this.hasNext());
              this.last = this.i;
              this.findNext();
              return this.__parent.set[this.last];
            };
            /**
            *
            */


            IteratorImpl.prototype.remove = function () {
              javaemul.internal.InternalPreconditions.checkState(this.last !== -1);
              this.__parent.set[this.last] = null;
              --this.__parent.__size;
              this.last = -1;
            };

            IteratorImpl.prototype.findNext = function () {
              ++this.i;

              for (var c = this.__parent.capacity(); this.i < c; ++this.i) {
                {
                  if (this.__parent.set[this.i] != null) {
                    return;
                  }
                }
              }
            };

            return IteratorImpl;
          }();

          EnumSetImpl.IteratorImpl = IteratorImpl;
          IteratorImpl["__class"] = "java.util.EnumSet.EnumSetImpl.IteratorImpl";
          IteratorImpl["__interfaces"] = ["java.util.Iterator"];
        })(EnumSetImpl = EnumSet.EnumSetImpl || (EnumSet.EnumSetImpl = {}));
      })(EnumSet = util.EnumSet || (util.EnumSet = {}));
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * Implements a set using a TreeMap. <a
      * href="http://java.sun.com/j2se/1.5.0/docs/api/java/util/TreeSet.html">[Sun
      * docs]</a>
      *
      * @param <E> element type.
      * @param {*} c
      * @class
      * @extends java.util.AbstractSet
      */
      var TreeSet =
      /** @class */
      function (_super) {
        __extends(TreeSet, _super);

        function TreeSet(c) {
          var _this = this;

          if (c != null && c.constructor != null && c.constructor["__interfaces"] != null && c.constructor["__interfaces"].indexOf("java.util.Collection") >= 0 || c === null) {
            var __args = arguments;
            {
              _this = _super.call(this) || this;

              if (_this.map === undefined) {
                _this.map = null;
              }

              _this.map = new java.util.TreeMap();
            }

            if (_this.map === undefined) {
              _this.map = null;
            }

            (function () {
              _this.addAll(c);
            })();
          } else if (typeof c === 'function' && c.length === 2 || c === null) {
            var __args = arguments;
            _this = _super.call(this) || this;

            if (_this.map === undefined) {
              _this.map = null;
            }

            _this.map = new java.util.TreeMap(c);
          } else if (c != null && c.constructor != null && c.constructor["__interfaces"] != null && c.constructor["__interfaces"].indexOf("java.util.SortedSet") >= 0 || c === null) {
            var __args = arguments;
            var s_1 = __args[0];
            {
              var c_1 = javaemul.internal.InternalPreconditions.checkNotNull(s_1).comparator();
              _this = _super.call(this) || this;

              if (_this.map === undefined) {
                _this.map = null;
              }

              _this.map = new java.util.TreeMap(c_1);
            }

            if (_this.map === undefined) {
              _this.map = null;
            }

            (function () {
              _this.addAll(s_1);
            })();
          } else if (c != null && c.constructor != null && c.constructor["__interfaces"] != null && c.constructor["__interfaces"].indexOf("java.util.NavigableMap") >= 0 || c === null) {
            var __args = arguments;
            var map = __args[0];
            _this = _super.call(this) || this;

            if (_this.map === undefined) {
              _this.map = null;
            }

            _this.map = map;
          } else if (c === undefined) {
            var __args = arguments;
            _this = _super.call(this) || this;

            if (_this.map === undefined) {
              _this.map = null;
            }

            _this.map = new java.util.TreeMap();
          } else throw new Error('invalid overload');

          return _this;
        }
        /* Default method injected from java.util.Collection */


        TreeSet.prototype.stream = function () {
          return new javaemul.internal.stream.StreamHelper(this);
        };
        /* Default method injected from java.lang.Iterable */


        TreeSet.prototype.forEach = function (action) {
          javaemul.internal.InternalPreconditions.checkNotNull(action);

          var _loop_16 = function _loop_16(index148) {
            var t = index148.next();
            {
              (function (target) {
                return typeof target === 'function' ? target(t) : target.accept(t);
              })(action);
            }
          };

          for (var index148 = this.iterator(); index148.hasNext();) {
            _loop_16(index148);
          }
        };
        /* Default method injected from java.util.Collection */


        TreeSet.prototype.parallelStream = function () {
          return this.stream();
        };
        /* Default method injected from java.util.Collection */


        TreeSet.prototype.removeIf = function (filter) {
          javaemul.internal.InternalPreconditions.checkNotNull(filter);
          var removed = false;

          var _loop_17 = function _loop_17(it) {
            {
              if (function (target) {
                return typeof target === 'function' ? target(it.next()) : target.test(it.next());
              }(filter)) {
                it.remove();
                removed = true;
              }
            }
          };

          for (var it = this.iterator(); it.hasNext();) {
            _loop_17(it);
          }

          return removed;
        };
        /**
        *
        * @param {*} o
        * @return {boolean}
        */


        TreeSet.prototype.add = function (o) {
          return this.map.put(o, javaemul.internal.BooleanHelper.FALSE) == null;
        };
        /**
        *
        * @param {*} e
        * @return {*}
        */


        TreeSet.prototype.ceiling = function (e) {
          return this.map.ceilingKey(e);
        };
        /**
        *
        */


        TreeSet.prototype.clear = function () {
          this.map.clear();
        };
        /**
        *
        * @return {*}
        */


        TreeSet.prototype.comparator = function () {
          return this.map.comparator();
        };
        /**
        *
        * @param {*} o
        * @return {boolean}
        */


        TreeSet.prototype.contains = function (o) {
          return this.map.containsKey(o);
        };
        /**
        *
        * @return {*}
        */


        TreeSet.prototype.descendingIterator = function () {
          return this.descendingSet().iterator();
        };
        /**
        *
        * @return {*}
        */


        TreeSet.prototype.descendingSet = function () {
          return new TreeSet(this.map.descendingMap());
        };
        /**
        *
        * @return {*}
        */


        TreeSet.prototype.first = function () {
          return this.map.firstKey();
        };
        /**
        *
        * @param {*} e
        * @return {*}
        */


        TreeSet.prototype.floor = function (e) {
          return this.map.floorKey(e);
        };

        TreeSet.prototype.headSet$java_lang_Object = function (toElement) {
          return this.headSet(toElement, false);
        };

        TreeSet.prototype.headSet$java_lang_Object$boolean = function (toElement, inclusive) {
          return new TreeSet(this.map.headMap(toElement, inclusive));
        };
        /**
        *
        * @param {*} toElement
        * @param {boolean} inclusive
        * @return {*}
        */


        TreeSet.prototype.headSet = function (toElement, inclusive) {
          if ((toElement != null || toElement === null) && (typeof inclusive === 'boolean' || inclusive === null)) {
            return this.headSet$java_lang_Object$boolean(toElement, inclusive);
          } else if ((toElement != null || toElement === null) && inclusive === undefined) {
            return this.headSet$java_lang_Object(toElement);
          } else throw new Error('invalid overload');
        };
        /**
        *
        * @param {*} e
        * @return {*}
        */


        TreeSet.prototype.higher = function (e) {
          return this.map.higherKey(e);
        };
        /**
        *
        * @return {*}
        */


        TreeSet.prototype.iterator = function () {
          return this.map.keySet().iterator();
        };
        /**
        *
        * @return {*}
        */


        TreeSet.prototype.last = function () {
          return this.map.lastKey();
        };
        /**
        *
        * @param {*} e
        * @return {*}
        */


        TreeSet.prototype.lower = function (e) {
          return this.map.lowerKey(e);
        };
        /**
        *
        * @return {*}
        */


        TreeSet.prototype.pollFirst = function () {
          return java.util.AbstractMap.getEntryKeyOrNull(this.map.pollFirstEntry());
        };
        /**
        *
        * @return {*}
        */


        TreeSet.prototype.pollLast = function () {
          return java.util.AbstractMap.getEntryKeyOrNull(this.map.pollLastEntry());
        };
        /**
        *
        * @param {*} o
        * @return {boolean}
        */


        TreeSet.prototype.remove = function (o) {
          return this.map.remove(o) != null;
        };
        /**
        *
        * @return {number}
        */


        TreeSet.prototype.size = function () {
          return this.map.size();
        };

        TreeSet.prototype.subSet$java_lang_Object$boolean$java_lang_Object$boolean = function (fromElement, fromInclusive, toElement, toInclusive) {
          return new TreeSet(this.map.subMap(fromElement, fromInclusive, toElement, toInclusive));
        };
        /**
        *
        * @param {*} fromElement
        * @param {boolean} fromInclusive
        * @param {*} toElement
        * @param {boolean} toInclusive
        * @return {*}
        */


        TreeSet.prototype.subSet = function (fromElement, fromInclusive, toElement, toInclusive) {
          if ((fromElement != null || fromElement === null) && (typeof fromInclusive === 'boolean' || fromInclusive === null) && (toElement != null || toElement === null) && (typeof toInclusive === 'boolean' || toInclusive === null)) {
            return this.subSet$java_lang_Object$boolean$java_lang_Object$boolean(fromElement, fromInclusive, toElement, toInclusive);
          } else if ((fromElement != null || fromElement === null) && (fromInclusive != null || fromInclusive === null) && toElement === undefined && toInclusive === undefined) {
            return this.subSet$java_lang_Object$java_lang_Object(fromElement, fromInclusive);
          } else throw new Error('invalid overload');
        };

        TreeSet.prototype.subSet$java_lang_Object$java_lang_Object = function (fromElement, toElement) {
          return this.subSet(fromElement, true, toElement, false);
        };

        TreeSet.prototype.tailSet$java_lang_Object = function (fromElement) {
          return this.tailSet(fromElement, true);
        };

        TreeSet.prototype.tailSet$java_lang_Object$boolean = function (fromElement, inclusive) {
          return new TreeSet(this.map.tailMap(fromElement, inclusive));
        };
        /**
        *
        * @param {*} fromElement
        * @param {boolean} inclusive
        * @return {*}
        */


        TreeSet.prototype.tailSet = function (fromElement, inclusive) {
          if ((fromElement != null || fromElement === null) && (typeof inclusive === 'boolean' || inclusive === null)) {
            return this.tailSet$java_lang_Object$boolean(fromElement, inclusive);
          } else if ((fromElement != null || fromElement === null) && inclusive === undefined) {
            return this.tailSet$java_lang_Object(fromElement);
          } else throw new Error('invalid overload');
        };

        return TreeSet;
      }(java.util.AbstractSet);

      util.TreeSet = TreeSet;
      TreeSet["__class"] = "java.util.TreeSet";
      TreeSet["__interfaces"] = ["java.util.SortedSet", "java.util.Collection", "java.util.Set", "java.util.NavigableSet", "java.lang.Iterable", "java.io.Serializable"];
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * Capacity increment is ignored.
      * @param {number} initialCapacity
      * @param {number} ignoredCapacityIncrement
      * @class
      * @extends java.util.AbstractList
      */
      var Vector =
      /** @class */
      function (_super) {
        __extends(Vector, _super);

        function Vector(initialCapacity, ignoredCapacityIncrement) {
          var _this = this;

          if ((typeof initialCapacity === 'number' || initialCapacity === null) && (typeof ignoredCapacityIncrement === 'number' || ignoredCapacityIncrement === null)) {
            var __args = arguments;
            {
              _this = _super.call(this) || this;

              if (_this.arrayList === undefined) {
                _this.arrayList = null;
              }

              if (_this.exposeElement === undefined) {
                _this.exposeElement = null;
              }

              _this.arrayList = new java.util.ArrayList(initialCapacity);
            }

            if (_this.arrayList === undefined) {
              _this.arrayList = null;
            }

            if (_this.exposeElement === undefined) {
              _this.exposeElement = null;
            }
          } else if ((initialCapacity != null && initialCapacity.constructor != null && initialCapacity.constructor["__interfaces"] != null && initialCapacity.constructor["__interfaces"].indexOf("java.util.Collection") >= 0 || initialCapacity === null) && ignoredCapacityIncrement === undefined) {
            var __args = arguments;
            var c = __args[0];
            _this = _super.call(this) || this;

            if (_this.arrayList === undefined) {
              _this.arrayList = null;
            }

            if (_this.exposeElement === undefined) {
              _this.exposeElement = null;
            }

            _this.arrayList = new java.util.ArrayList();

            _this.addAll$java_util_Collection(c);
          } else if ((typeof initialCapacity === 'number' || initialCapacity === null) && ignoredCapacityIncrement === undefined) {
            var __args = arguments;
            _this = _super.call(this) || this;

            if (_this.arrayList === undefined) {
              _this.arrayList = null;
            }

            if (_this.exposeElement === undefined) {
              _this.exposeElement = null;
            }

            _this.arrayList = new java.util.ArrayList(initialCapacity);
          } else if (initialCapacity === undefined && ignoredCapacityIncrement === undefined) {
            var __args = arguments;
            _this = _super.call(this) || this;

            if (_this.arrayList === undefined) {
              _this.arrayList = null;
            }

            if (_this.exposeElement === undefined) {
              _this.exposeElement = null;
            }

            _this.arrayList = new java.util.ArrayList();
          } else throw new Error('invalid overload');

          return _this;
        }
        /* Default method injected from java.util.Collection */


        Vector.prototype.stream = function () {
          return new javaemul.internal.stream.StreamHelper(this);
        };
        /* Default method injected from java.lang.Iterable */


        Vector.prototype.forEach = function (action) {
          javaemul.internal.InternalPreconditions.checkNotNull(action);

          var _loop_18 = function _loop_18(index149) {
            var t = index149.next();
            {
              (function (target) {
                return typeof target === 'function' ? target(t) : target.accept(t);
              })(action);
            }
          };

          for (var index149 = this.iterator(); index149.hasNext();) {
            _loop_18(index149);
          }
        };
        /* Default method injected from java.util.Collection */


        Vector.prototype.parallelStream = function () {
          return this.stream();
        };
        /* Default method injected from java.util.List */


        Vector.prototype.sort = function (c) {
          var a = this.toArray();
          java.util.Arrays.sort(a, c);
          var i = this.listIterator();

          for (var index150 = 0; index150 < a.length; index150++) {
            var e = a[index150];
            {
              i.next();
              i.set(e);
            }
          }
        };
        /* Default method injected from java.util.Collection */


        Vector.prototype.removeIf = function (filter) {
          javaemul.internal.InternalPreconditions.checkNotNull(filter);
          var removed = false;

          var _loop_19 = function _loop_19(it) {
            {
              if (function (target) {
                return typeof target === 'function' ? target(it.next()) : target.test(it.next());
              }(filter)) {
                it.remove();
                removed = true;
              }
            }
          };

          for (var it = this.iterator(); it.hasNext();) {
            _loop_19(it);
          }

          return removed;
        };

        Vector.prototype.add$java_lang_Object = function (o) {
          return this.arrayList.add(o);
        };

        Vector.prototype.add$int$java_lang_Object = function (index, o) {
          Vector.checkArrayElementIndex(index, this.size() + 1);
          this.arrayList.add(index, o);
        };
        /**
        *
        * @param {number} index
        * @param {*} o
        */


        Vector.prototype.add = function (index, o) {
          if ((typeof index === 'number' || index === null) && (o != null || o === null)) {
            return this.add$int$java_lang_Object(index, o);
          } else if ((index != null || index === null) && o === undefined) {
            return this.add$java_lang_Object(index);
          } else throw new Error('invalid overload');
        };

        Vector.prototype.addAll$java_util_Collection = function (c) {
          return this.arrayList.addAll$java_util_Collection(c);
        };

        Vector.prototype.addAll$int$java_util_Collection = function (index, c) {
          return this.arrayList.addAll$int$java_util_Collection(index, c);
        };
        /**
        *
        * @param {number} index
        * @param {*} c
        * @return {boolean}
        */


        Vector.prototype.addAll = function (index, c) {
          if ((typeof index === 'number' || index === null) && (c != null && c.constructor != null && c.constructor["__interfaces"] != null && c.constructor["__interfaces"].indexOf("java.util.Collection") >= 0 || c === null)) {
            return this.addAll$int$java_util_Collection(index, c);
          } else if ((index != null && index.constructor != null && index.constructor["__interfaces"] != null && index.constructor["__interfaces"].indexOf("java.util.Collection") >= 0 || index === null) && c === undefined) {
            return this.addAll$java_util_Collection(index);
          } else throw new Error('invalid overload');
        };

        Vector.prototype.addElement = function (o) {
          this.add(o);
        };

        Vector.prototype.capacity = function () {
          return this.arrayList.size();
        };
        /**
        *
        */


        Vector.prototype.clear = function () {
          this.arrayList.clear();
        };

        Vector.prototype.clone = function () {
          return new Vector(this);
        };
        /**
        *
        * @param {*} elem
        * @return {boolean}
        */


        Vector.prototype.contains = function (elem) {
          return this.arrayList.contains(elem);
        };
        /**
        *
        * @param {*} c
        * @return {boolean}
        */


        Vector.prototype.containsAll = function (c) {
          return this.arrayList.containsAll(c);
        };

        Vector.prototype.copyInto = function (objs) {
          var i = -1;
          var n = this.size();

          while (++i < n) {
            {
              objs[i] = this.get(i);
            }
          }
        };

        Vector.prototype.elementAt = function (index) {
          return this.get(index);
        };

        Vector.prototype.elements = function () {
          return java.util.Collections.enumeration(this.arrayList);
        };

        Vector.prototype.ensureCapacity = function (capacity) {
          this.arrayList.ensureCapacity(capacity);
        };

        Vector.prototype.firstElement = function () {
          javaemul.internal.InternalPreconditions.checkElement(!this.isEmpty());
          return this.get(0);
        };
        /**
        *
        * @param {number} index
        * @return {*}
        */


        Vector.prototype.get = function (index) {
          Vector.checkArrayElementIndex(index, this.size());
          return this.arrayList.get(index);
        };

        Vector.prototype.indexOf$java_lang_Object = function (elem) {
          return this.arrayList.indexOf$java_lang_Object(elem);
        };

        Vector.prototype.indexOf$java_lang_Object$int = function (elem, index) {
          Vector.checkArrayIndexOutOfBounds(index >= 0, index);
          return this.arrayList.indexOf$java_lang_Object$int(elem, index);
        };

        Vector.prototype.indexOf = function (elem, index) {
          if ((elem != null || elem === null) && (typeof index === 'number' || index === null)) {
            return this.indexOf$java_lang_Object$int(elem, index);
          } else if ((elem != null || elem === null) && index === undefined) {
            return this.indexOf$java_lang_Object(elem);
          } else throw new Error('invalid overload');
        };

        Vector.prototype.insertElementAt = function (o, index) {
          this.add(index, o);
        };
        /**
        *
        * @return {boolean}
        */


        Vector.prototype.isEmpty = function () {
          return this.arrayList.size() === 0;
        };
        /**
        *
        * @return {*}
        */


        Vector.prototype.iterator = function () {
          return this.arrayList.iterator();
        };

        Vector.prototype.lastElement = function () {
          javaemul.internal.InternalPreconditions.checkElement(!this.isEmpty());
          return this.get(this.size() - 1);
        };

        Vector.prototype.lastIndexOf$java_lang_Object = function (o) {
          return this.arrayList.lastIndexOf$java_lang_Object(o);
        };

        Vector.prototype.lastIndexOf$java_lang_Object$int = function (o, index) {
          Vector.checkArrayIndexOutOfBounds(index < this.size(), index);
          return this.arrayList.lastIndexOf$java_lang_Object$int(o, index);
        };

        Vector.prototype.lastIndexOf = function (o, index) {
          if ((o != null || o === null) && (typeof index === 'number' || index === null)) {
            return this.lastIndexOf$java_lang_Object$int(o, index);
          } else if ((o != null || o === null) && index === undefined) {
            return this.lastIndexOf$java_lang_Object(o);
          } else throw new Error('invalid overload');
        };

        Vector.prototype.remove$int = function (index) {
          Vector.checkArrayElementIndex(index, this.size());
          return this.arrayList.remove$int(index);
        };
        /**
        *
        * @param {number} index
        * @return {*}
        */


        Vector.prototype.remove = function (index) {
          if (typeof index === 'number' || index === null) {
            return this.remove$int(index);
          } else if (index != null || index === null) {
            return _super.prototype.remove.call(this, index);
          } else throw new Error('invalid overload');
        };
        /**
        *
        * @param {*} c
        * @return {boolean}
        */


        Vector.prototype.removeAll = function (c) {
          return this.arrayList.removeAll(c);
        };

        Vector.prototype.removeAllElements = function () {
          this.clear();
        };

        Vector.prototype.removeElement = function (o) {
          return this.remove(o);
        };

        Vector.prototype.removeElementAt = function (index) {
          this.remove$int(index);
        };
        /**
        *
        * @param {number} index
        * @param {*} elem
        * @return {*}
        */


        Vector.prototype.set = function (index, elem) {
          Vector.checkArrayElementIndex(index, this.size());
          return this.arrayList.set(index, elem);
        };

        Vector.prototype.setElementAt = function (o, index) {
          this.set(index, o);
        };

        Vector.prototype.setSize = function (size) {
          Vector.checkArrayIndexOutOfBounds(size >= 0, size);
          this.arrayList.setSize(size);
        };
        /**
        *
        * @return {number}
        */


        Vector.prototype.size = function () {
          return this.arrayList.size();
        };
        /**
        *
        * @param {number} fromIndex
        * @param {number} toIndex
        * @return {*}
        */


        Vector.prototype.subList = function (fromIndex, toIndex) {
          return this.arrayList.subList(fromIndex, toIndex);
        };

        Vector.prototype.toArray$ = function () {
          return this.arrayList.toArray$();
        };

        Vector.prototype.toArray$java_lang_Object_A = function (a) {
          return this.arrayList.toArray$java_lang_Object_A(a);
        };
        /**
        *
        * @param {Array} a
        * @return {Array}
        */


        Vector.prototype.toArray = function (a) {
          if (a != null && a instanceof Array && (a.length == 0 || a[0] == null || a[0] != null) || a === null) {
            return this.toArray$java_lang_Object_A(a);
          } else if (a === undefined) {
            return this.toArray$();
          } else throw new Error('invalid overload');
        };
        /**
        *
        * @return {string}
        */


        Vector.prototype.toString = function () {
          return this.arrayList.toString();
        };

        Vector.prototype.trimToSize = function () {
          this.arrayList.trimToSize();
        };
        /**
        *
        * @param {number} fromIndex
        * @param {number} endIndex
        */


        Vector.prototype.removeRange = function (fromIndex, endIndex) {
          this.arrayList.removeRange(fromIndex, endIndex);
        };
        /*private*/


        Vector.checkArrayElementIndex = function (index, size) {
          if (index < 0 || index >= size) {
            throw new java.lang.ArrayIndexOutOfBoundsException();
          }
        };
        /*private*/


        Vector.checkArrayIndexOutOfBounds = function (expression, index) {
          if (!expression) {
            throw new java.lang.ArrayIndexOutOfBoundsException(
            /* valueOf */
            new String(index).toString());
          }
        };

        return Vector;
      }(java.util.AbstractList);

      util.Vector = Vector;
      Vector["__class"] = "java.util.Vector";
      Vector["__interfaces"] = ["java.util.RandomAccess", "java.util.List", "java.lang.Cloneable", "java.util.Collection", "java.lang.Iterable", "java.io.Serializable"];
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * Skeletal implementation of the List interface. <a
      * href="http://java.sun.com/j2se/1.5.0/docs/api/java/util/AbstractSequentialList.html">[Sun
      * docs]</a>
      *
      * @param <E> element type.
      * @extends java.util.AbstractList
      * @class
      */
      var AbstractSequentialList =
      /** @class */
      function (_super) {
        __extends(AbstractSequentialList, _super);

        function AbstractSequentialList() {
          return _super.call(this) || this;
        }

        AbstractSequentialList.prototype.add$int$java_lang_Object = function (index, element) {
          var iter = this.listIterator$int(index);
          iter.add(element);
        };
        /**
        *
        * @param {number} index
        * @param {*} element
        */


        AbstractSequentialList.prototype.add = function (index, element) {
          if ((typeof index === 'number' || index === null) && (element != null || element === null)) {
            return this.add$int$java_lang_Object(index, element);
          } else if ((index != null || index === null) && element === undefined) {
            return this.add$java_lang_Object(index);
          } else throw new Error('invalid overload');
        };

        AbstractSequentialList.prototype.addAll$int$java_util_Collection = function (index, c) {
          javaemul.internal.InternalPreconditions.checkNotNull(c);
          var modified = false;
          var iter = this.listIterator$int(index);

          for (var index151 = c.iterator(); index151.hasNext();) {
            var e = index151.next();
            {
              iter.add(e);
              modified = true;
            }
          }

          return modified;
        };
        /**
        *
        * @param {number} index
        * @param {*} c
        * @return {boolean}
        */


        AbstractSequentialList.prototype.addAll = function (index, c) {
          if ((typeof index === 'number' || index === null) && (c != null && c.constructor != null && c.constructor["__interfaces"] != null && c.constructor["__interfaces"].indexOf("java.util.Collection") >= 0 || c === null)) {
            return this.addAll$int$java_util_Collection(index, c);
          } else if ((index != null && index.constructor != null && index.constructor["__interfaces"] != null && index.constructor["__interfaces"].indexOf("java.util.Collection") >= 0 || index === null) && c === undefined) {
            return _super.prototype.addAll.call(this, index);
          } else throw new Error('invalid overload');
        };
        /**
        *
        * @param {number} index
        * @return {*}
        */


        AbstractSequentialList.prototype.get = function (index) {
          var iter = this.listIterator$int(index);

          try {
            return iter.next();
          } catch (e) {
            throw new java.lang.IndexOutOfBoundsException("Can\'t get element " + index);
          }
        };
        /**
        *
        * @return {*}
        */


        AbstractSequentialList.prototype.iterator = function () {
          return this.listIterator$();
        };

        AbstractSequentialList.prototype.listIterator$int = function (index) {
          throw new Error('cannot invoke abstract overloaded method... check your argument(s) type(s)');
        };
        /**
        *
        * @param {number} index
        * @return {*}
        */


        AbstractSequentialList.prototype.listIterator = function (index) {
          if (typeof index === 'number' || index === null) {
            return this.listIterator$int(index);
          } else if (index === undefined) {
            return this.listIterator$();
          } else throw new Error('invalid overload');
        };

        AbstractSequentialList.prototype.remove$int = function (index) {
          var iter = this.listIterator$int(index);

          try {
            var old = iter.next();
            iter.remove();
            return old;
          } catch (e) {
            throw new java.lang.IndexOutOfBoundsException("Can\'t remove element " + index);
          }
        };
        /**
        *
        * @param {number} index
        * @return {*}
        */


        AbstractSequentialList.prototype.remove = function (index) {
          if (typeof index === 'number' || index === null) {
            return this.remove$int(index);
          } else if (index != null || index === null) {
            return _super.prototype.remove.call(this, index);
          } else throw new Error('invalid overload');
        };
        /**
        *
        * @param {number} index
        * @param {*} element
        * @return {*}
        */


        AbstractSequentialList.prototype.set = function (index, element) {
          var iter = this.listIterator$int(index);

          try {
            var old = iter.next();
            iter.set(element);
            return old;
          } catch (e) {
            throw new java.lang.IndexOutOfBoundsException("Can\'t set element " + index);
          }
        };

        return AbstractSequentialList;
      }(java.util.AbstractList);

      util.AbstractSequentialList = AbstractSequentialList;
      AbstractSequentialList["__class"] = "java.util.AbstractSequentialList";
      AbstractSequentialList["__interfaces"] = ["java.util.List", "java.util.Collection", "java.lang.Iterable"];
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * Resizeable array implementation of the List interface. <a
      * href="http://java.sun.com/j2se/1.5.0/docs/api/java/util/ArrayList.html">[Sun
      * docs]</a>
      *
      * <p>
      * This implementation differs from JDK 1.5 <code>ArrayList</code> in terms of
      * capacity management. There is no speed advantage to pre-allocating array
      * sizes in JavaScript, so this implementation does not include any of the
      * capacity and "growth increment" concepts in the standard ArrayList class.
      * Although <code>ArrayList(int)</code> accepts a value for the initial
      * capacity of the array, this constructor simply delegates to
      * <code>ArrayList()</code>. It is only present for compatibility with JDK
      * 1.5's API.
      * </p>
      *
      * @param <E> the element type.
      * @param {*} c
      * @class
      * @extends java.util.AbstractList
      */
      var ArrayList =
      /** @class */
      function (_super) {
        __extends(ArrayList, _super);

        function ArrayList(c) {
          var _this = this;

          if (c != null && c.constructor != null && c.constructor["__interfaces"] != null && c.constructor["__interfaces"].indexOf("java.util.Collection") >= 0 || c === null) {
            var __args = arguments;
            _this = _super.call(this) || this;

            if (_this.array === undefined) {
              _this.array = null;
            }

            if (_this.exposeElement === undefined) {
              _this.exposeElement = null;
            }

            _this.array = [];
            javaemul.internal.ArrayHelper.insertValuesToArray(_this.array, 0, c['toArray$']());
          } else if (typeof c === 'number' || c === null) {
            var __args = arguments;
            var initialCapacity = __args[0];
            _this = _super.call(this) || this;

            if (_this.array === undefined) {
              _this.array = null;
            }

            if (_this.exposeElement === undefined) {
              _this.exposeElement = null;
            }

            javaemul.internal.InternalPreconditions.checkArgument(initialCapacity >= 0, "Initial capacity must not be negative");
            _this.array = [];
          } else if (c === undefined) {
            var __args = arguments;
            _this = _super.call(this) || this;

            if (_this.array === undefined) {
              _this.array = null;
            }

            if (_this.exposeElement === undefined) {
              _this.exposeElement = null;
            }

            _this.array = [];
          } else throw new Error('invalid overload');

          return _this;
        }
        /* Default method injected from java.util.Collection */


        ArrayList.prototype.stream = function () {
          return new javaemul.internal.stream.StreamHelper(this);
        };
        /* Default method injected from java.lang.Iterable */


        ArrayList.prototype.forEach = function (action) {
          javaemul.internal.InternalPreconditions.checkNotNull(action);

          var _loop_20 = function _loop_20(index152) {
            var t = index152.next();
            {
              (function (target) {
                return typeof target === 'function' ? target(t) : target.accept(t);
              })(action);
            }
          };

          for (var index152 = this.iterator(); index152.hasNext();) {
            _loop_20(index152);
          }
        };
        /* Default method injected from java.util.Collection */


        ArrayList.prototype.parallelStream = function () {
          return this.stream();
        };
        /* Default method injected from java.util.List */


        ArrayList.prototype.sort = function (c) {
          var a = this.toArray();
          java.util.Arrays.sort(a, c);
          var i = this.listIterator();

          for (var index153 = 0; index153 < a.length; index153++) {
            var e = a[index153];
            {
              i.next();
              i.set(e);
            }
          }
        };
        /* Default method injected from java.util.Collection */


        ArrayList.prototype.removeIf = function (filter) {
          javaemul.internal.InternalPreconditions.checkNotNull(filter);
          var removed = false;

          var _loop_21 = function _loop_21(it) {
            {
              if (function (target) {
                return typeof target === 'function' ? target(it.next()) : target.test(it.next());
              }(filter)) {
                it.remove();
                removed = true;
              }
            }
          };

          for (var it = this.iterator(); it.hasNext();) {
            _loop_21(it);
          }

          return removed;
        };

        ArrayList.prototype.add$java_lang_Object = function (o) {
          this.array[this.array.length] = o;
          return true;
        };

        ArrayList.prototype.add$int$java_lang_Object = function (index, o) {
          javaemul.internal.InternalPreconditions.checkPositionIndex(index, this.array.length);
          javaemul.internal.ArrayHelper.insertTo$java_lang_Object$int$java_lang_Object(this.array, index, o);
        };
        /**
        *
        * @param {number} index
        * @param {*} o
        */


        ArrayList.prototype.add = function (index, o) {
          if ((typeof index === 'number' || index === null) && (o != null || o === null)) {
            return this.add$int$java_lang_Object(index, o);
          } else if ((index != null || index === null) && o === undefined) {
            return this.add$java_lang_Object(index);
          } else throw new Error('invalid overload');
        };

        ArrayList.prototype.addAll$java_util_Collection = function (c) {
          var cArray = c['toArray$']();
          var len = cArray.length;

          if (len === 0) {
            return false;
          }

          javaemul.internal.ArrayHelper.insertValuesToArray(this.array, this.array.length, cArray);
          return true;
        };

        ArrayList.prototype.addAll$int$java_util_Collection = function (index, c) {
          javaemul.internal.InternalPreconditions.checkPositionIndex(index, this.array.length);
          var cArray = c['toArray$']();
          var len = cArray.length;

          if (len === 0) {
            return false;
          }

          javaemul.internal.ArrayHelper.insertValuesToArray(this.array, index, cArray);
          return true;
        };
        /**
        *
        * @param {number} index
        * @param {*} c
        * @return {boolean}
        */


        ArrayList.prototype.addAll = function (index, c) {
          if ((typeof index === 'number' || index === null) && (c != null && c.constructor != null && c.constructor["__interfaces"] != null && c.constructor["__interfaces"].indexOf("java.util.Collection") >= 0 || c === null)) {
            return this.addAll$int$java_util_Collection(index, c);
          } else if ((index != null && index.constructor != null && index.constructor["__interfaces"] != null && index.constructor["__interfaces"].indexOf("java.util.Collection") >= 0 || index === null) && c === undefined) {
            return this.addAll$java_util_Collection(index);
          } else throw new Error('invalid overload');
        };
        /**
        *
        */


        ArrayList.prototype.clear = function () {
          this.array = [];
        };

        ArrayList.prototype.clone = function () {
          return new ArrayList(this);
        };
        /**
        *
        * @param {*} o
        * @return {boolean}
        */


        ArrayList.prototype.contains = function (o) {
          return this.indexOf$java_lang_Object(o) !== -1;
        };

        ArrayList.prototype.ensureCapacity = function (ignored) {};
        /**
        *
        * @param {number} index
        * @return {*}
        */


        ArrayList.prototype.get = function (index) {
          javaemul.internal.InternalPreconditions.checkElementIndex(index, this.array.length);
          return this.array[index];
        };

        ArrayList.prototype.indexOf$java_lang_Object = function (o) {
          return this.indexOf$java_lang_Object$int(o, 0);
        };
        /**
        *
        * @return {*}
        */


        ArrayList.prototype.iterator = function () {
          return new ArrayList.ArrayList$0(this);
        };
        /**
        *
        * @return {boolean}
        */


        ArrayList.prototype.isEmpty = function () {
          return this.array.length === 0;
        };

        ArrayList.prototype.lastIndexOf$java_lang_Object = function (o) {
          return this.lastIndexOf$java_lang_Object$int(o, this.size() - 1);
        };

        ArrayList.prototype.remove$int = function (index) {
          var previous = this.get(index);
          javaemul.internal.ArrayHelper.removeFrom(this.array, index, 1);
          return previous;
        };
        /**
        *
        * @param {number} index
        * @return {*}
        */


        ArrayList.prototype.remove = function (index) {
          if (typeof index === 'number' || index === null) {
            return this.remove$int(index);
          } else if (index != null || index === null) {
            return this.remove$java_lang_Object(index);
          } else throw new Error('invalid overload');
        };

        ArrayList.prototype.remove$java_lang_Object = function (o) {
          var i = this.indexOf$java_lang_Object(o);

          if (i === -1) {
            return false;
          }

          this.remove$int(i);
          return true;
        };
        /**
        *
        * @param {number} index
        * @param {*} o
        * @return {*}
        */


        ArrayList.prototype.set = function (index, o) {
          var previous = this.get(index);
          this.array[index] = o;
          return previous;
        };
        /**
        *
        * @return {number}
        */


        ArrayList.prototype.size = function () {
          return this.array.length;
        };

        ArrayList.prototype.toArray$ = function () {
          return javaemul.internal.ArrayHelper.clone(this.array, 0, this.array.length);
        };

        ArrayList.prototype.toArray$java_lang_Object_A = function (out) {
          var size = this.array.length;

          if (out.length < size) {
            out = javaemul.internal.ArrayHelper.createFrom(out, size);
          }

          for (var i = 0; i < size; ++i) {
            {
              out[i] = this.array[i];
            }
          }

          if (out.length > size) {
            out[size] = null;
          }

          return out;
        };
        /**
        *
        * @param {Array} out
        * @return {Array}
        */


        ArrayList.prototype.toArray = function (out) {
          if (out != null && out instanceof Array && (out.length == 0 || out[0] == null || out[0] != null) || out === null) {
            return this.toArray$java_lang_Object_A(out);
          } else if (out === undefined) {
            return this.toArray$();
          } else throw new Error('invalid overload');
        };

        ArrayList.prototype.trimToSize = function () {};
        /**
        *
        * @param {number} fromIndex
        * @param {number} endIndex
        */


        ArrayList.prototype.removeRange = function (fromIndex, endIndex) {
          javaemul.internal.InternalPreconditions.checkPositionIndexes(fromIndex, endIndex, this.array.length);
          var count = endIndex - fromIndex;
          javaemul.internal.ArrayHelper.removeFrom(this.array, fromIndex, count);
        };

        ArrayList.prototype.indexOf$java_lang_Object$int = function (o, index) {
          for (; index < this.array.length; ++index) {
            {
              if (java.util.Objects.equals(o, this.array[index])) {
                return index;
              }
            }
          }

          return -1;
        };
        /**
        * Used by Vector.
        * @param {*} o
        * @param {number} index
        * @return {number}
        */


        ArrayList.prototype.indexOf = function (o, index) {
          if ((o != null || o === null) && (typeof index === 'number' || index === null)) {
            return this.indexOf$java_lang_Object$int(o, index);
          } else if ((o != null || o === null) && index === undefined) {
            return this.indexOf$java_lang_Object(o);
          } else throw new Error('invalid overload');
        };

        ArrayList.prototype.lastIndexOf$java_lang_Object$int = function (o, index) {
          for (; index >= 0; --index) {
            {
              if (java.util.Objects.equals(o, this.array[index])) {
                return index;
              }
            }
          }

          return -1;
        };
        /**
        * Used by Vector.
        * @param {*} o
        * @param {number} index
        * @return {number}
        */


        ArrayList.prototype.lastIndexOf = function (o, index) {
          if ((o != null || o === null) && (typeof index === 'number' || index === null)) {
            return this.lastIndexOf$java_lang_Object$int(o, index);
          } else if ((o != null || o === null) && index === undefined) {
            return this.lastIndexOf$java_lang_Object(o);
          } else throw new Error('invalid overload');
        };

        ArrayList.prototype.setSize = function (newSize) {
          javaemul.internal.ArrayHelper.setLength(this.array, newSize);
        };

        return ArrayList;
      }(java.util.AbstractList);

      util.ArrayList = ArrayList;
      ArrayList["__class"] = "java.util.ArrayList";
      ArrayList["__interfaces"] = ["java.util.RandomAccess", "java.util.List", "java.lang.Cloneable", "java.util.Collection", "java.lang.Iterable", "java.io.Serializable"];

      (function (ArrayList) {
        var ArrayList$0 =
        /** @class */
        function () {
          function ArrayList$0(__parent) {
            this.__parent = __parent;
            this.i = 0;
            this.last = -1;
          }
          /* Default method injected from java.util.Iterator */


          ArrayList$0.prototype.forEachRemaining = function (consumer) {
            var _this = this;

            javaemul.internal.InternalPreconditions.checkNotNull(consumer);

            while (this.hasNext()) {
              {
                (function (target) {
                  return typeof target === 'function' ? target(_this.next()) : target.accept(_this.next());
                })(consumer);
              }
            }
          };
          /**
          *
          * @return {boolean}
          */


          ArrayList$0.prototype.hasNext = function () {
            return this.i < this.__parent.array.length;
          };
          /**
          *
          * @return {*}
          */


          ArrayList$0.prototype.next = function () {
            javaemul.internal.InternalPreconditions.checkElement(this.hasNext());
            this.last = this.i++;
            return this.__parent.array[this.last];
          };
          /**
          *
          */


          ArrayList$0.prototype.remove = function () {
            javaemul.internal.InternalPreconditions.checkState(this.last !== -1);

            this.__parent.remove$int(this.i = this.last);

            this.last = -1;
          };

          return ArrayList$0;
        }();

        ArrayList.ArrayList$0 = ArrayList$0;
        ArrayList$0["__interfaces"] = ["java.util.Iterator"];
      })(ArrayList = util.ArrayList || (util.ArrayList = {}));
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * Utility methods related to native arrays. <a
      * href="http://java.sun.com/j2se/1.5.0/docs/api/java/util/Arrays.html">[Sun
      * docs]</a>
      * @class
      */
      var Arrays =
      /** @class */
      function () {
        function Arrays() {}

        Arrays.asList = function () {
          var array = [];

          for (var _i = 0; _i < arguments.length; _i++) {
            array[_i] = arguments[_i];
          }

          if (array.length === 1 && Array.isArray(array[0])) {
            array = array[0];
          }

          return new Arrays.ArrayList(array);
        };

        Arrays.stream = function () {
          var array = [];

          for (var _i = 0; _i < arguments.length; _i++) {
            array[_i] = arguments[_i];
          }

          return Arrays.asList.apply(this, array).stream();
        };

        Arrays.binarySearch$byte_A$byte = function (sortedArray, key) {
          var low = 0;
          var high = sortedArray.length - 1;

          while (low <= high) {
            {
              var mid = low + (high - low >> 1);
              var midVal = sortedArray[mid];

              if (midVal < key) {
                low = mid + 1;
              } else if (midVal > key) {
                high = mid - 1;
              } else {
                return mid;
              }
            }
          }

          return -low - 1;
        };

        Arrays.binarySearch$char_A$char = function (a, key) {
          var low = 0;
          var high = a.length - 1;

          while (low <= high) {
            {
              var mid = low + (high - low >> 1);
              var midVal = a[mid];

              if (function (c) {
                return c.charCodeAt == null ? c : c.charCodeAt(0);
              }(midVal) < function (c) {
                return c.charCodeAt == null ? c : c.charCodeAt(0);
              }(key)) {
                low = mid + 1;
              } else if (function (c) {
                return c.charCodeAt == null ? c : c.charCodeAt(0);
              }(midVal) > function (c) {
                return c.charCodeAt == null ? c : c.charCodeAt(0);
              }(key)) {
                high = mid - 1;
              } else {
                return mid;
              }
            }
          }

          return -low - 1;
        };

        Arrays.binarySearch$double_A$double = function (sortedArray, key) {
          var low = 0;
          var high = sortedArray.length - 1;

          while (low <= high) {
            {
              var mid = low + (high - low >> 1);
              var midVal = sortedArray[mid];

              if (midVal < key) {
                low = mid + 1;
              } else if (midVal > key) {
                high = mid - 1;
              } else {
                return mid;
              }
            }
          }

          return -low - 1;
        };

        Arrays.binarySearch$float_A$float = function (sortedArray, key) {
          var low = 0;
          var high = sortedArray.length - 1;

          while (low <= high) {
            {
              var mid = low + (high - low >> 1);
              var midVal = sortedArray[mid];

              if (midVal < key) {
                low = mid + 1;
              } else if (midVal > key) {
                high = mid - 1;
              } else {
                return mid;
              }
            }
          }

          return -low - 1;
        };

        Arrays.binarySearch$int_A$int = function (sortedArray, key) {
          var low = 0;
          var high = sortedArray.length - 1;

          while (low <= high) {
            {
              var mid = low + (high - low >> 1);
              var midVal = sortedArray[mid];

              if (midVal < key) {
                low = mid + 1;
              } else if (midVal > key) {
                high = mid - 1;
              } else {
                return mid;
              }
            }
          }

          return -low - 1;
        };

        Arrays.binarySearch$long_A$long = function (sortedArray, key) {
          var low = 0;
          var high = sortedArray.length - 1;

          while (low <= high) {
            {
              var mid = low + (high - low >> 1);
              var midVal = sortedArray[mid];

              if (midVal < key) {
                low = mid + 1;
              } else if (midVal > key) {
                high = mid - 1;
              } else {
                return mid;
              }
            }
          }

          return -low - 1;
        };

        Arrays.binarySearch$java_lang_Object_A$java_lang_Object = function (sortedArray, key) {
          return Arrays.binarySearch(sortedArray, key, java.util.Comparators.natural());
        };

        Arrays.binarySearch$short_A$short = function (sortedArray, key) {
          var low = 0;
          var high = sortedArray.length - 1;

          while (low <= high) {
            {
              var mid = low + (high - low >> 1);
              var midVal = sortedArray[mid];

              if (midVal < key) {
                low = mid + 1;
              } else if (midVal > key) {
                high = mid - 1;
              } else {
                return mid;
              }
            }
          }

          return -low - 1;
        };

        Arrays.binarySearch$java_lang_Object_A$java_lang_Object$java_util_Comparator = function (sortedArray, key, comparator) {
          if (comparator == null) {
            comparator = java.util.Comparators.natural();
          }

          var low = 0;
          var high = sortedArray.length - 1;

          while (low <= high) {
            {
              var mid = low + (high - low >> 1);
              var midVal = sortedArray[mid];

              var compareResult = function (target) {
                return target['compare'] === undefined ? target : target['compare'];
              }(comparator)(midVal, key);

              if (compareResult < 0) {
                low = mid + 1;
              } else if (compareResult > 0) {
                high = mid - 1;
              } else {
                return mid;
              }
            }
          }

          return -low - 1;
        };
        /**
        * Perform a binary search on a sorted object array, using a user-specified
        * comparison function.
        *
        * @param {Array} sortedArray object array to search
        * @param {*} key value to search for
        * @param {*} comparator comparision function, <code>null</code> indicates
        * <i>natural ordering</i> should be used.
        * @return {number} the index of an element with a matching value, or a negative number
        * which is the index of the next larger value (or just past the end
        * of the array if the searched value is larger than all elements in
        * the array) minus 1 (to ensure error returns are negative)
        * @throws ClassCastException if <code>key</code> and
        * <code>sortedArray</code>'s elements cannot be compared by
        * <code>comparator</code>.
        */


        Arrays.binarySearch = function (sortedArray, key, comparator) {
          if ((sortedArray != null && sortedArray instanceof Array && (sortedArray.length == 0 || sortedArray[0] == null || sortedArray[0] != null) || sortedArray === null) && (key != null || key === null) && (typeof comparator === 'function' && comparator.length === 2 || comparator === null)) {
            return java.util.Arrays.binarySearch$java_lang_Object_A$java_lang_Object$java_util_Comparator(sortedArray, key, comparator);
          } else if ((sortedArray != null && sortedArray instanceof Array && (sortedArray.length == 0 || sortedArray[0] == null || typeof sortedArray[0] === 'number') || sortedArray === null) && (typeof key === 'number' || key === null) && comparator === undefined) {
            return java.util.Arrays.binarySearch$byte_A$byte(sortedArray, key);
          } else if ((sortedArray != null && sortedArray instanceof Array && (sortedArray.length == 0 || sortedArray[0] == null || typeof sortedArray[0] === 'string') || sortedArray === null) && (typeof key === 'string' || key === null) && comparator === undefined) {
            return java.util.Arrays.binarySearch$char_A$char(sortedArray, key);
          } else if ((sortedArray != null && sortedArray instanceof Array && (sortedArray.length == 0 || sortedArray[0] == null || typeof sortedArray[0] === 'number') || sortedArray === null) && (typeof key === 'number' || key === null) && comparator === undefined) {
            return java.util.Arrays.binarySearch$short_A$short(sortedArray, key);
          } else if ((sortedArray != null && sortedArray instanceof Array && (sortedArray.length == 0 || sortedArray[0] == null || typeof sortedArray[0] === 'number') || sortedArray === null) && (typeof key === 'number' || key === null) && comparator === undefined) {
            return java.util.Arrays.binarySearch$int_A$int(sortedArray, key);
          } else if ((sortedArray != null && sortedArray instanceof Array && (sortedArray.length == 0 || sortedArray[0] == null || typeof sortedArray[0] === 'number') || sortedArray === null) && (typeof key === 'number' || key === null) && comparator === undefined) {
            return java.util.Arrays.binarySearch$long_A$long(sortedArray, key);
          } else if ((sortedArray != null && sortedArray instanceof Array && (sortedArray.length == 0 || sortedArray[0] == null || typeof sortedArray[0] === 'number') || sortedArray === null) && (typeof key === 'number' || key === null) && comparator === undefined) {
            return java.util.Arrays.binarySearch$float_A$float(sortedArray, key);
          } else if ((sortedArray != null && sortedArray instanceof Array && (sortedArray.length == 0 || sortedArray[0] == null || typeof sortedArray[0] === 'number') || sortedArray === null) && (typeof key === 'number' || key === null) && comparator === undefined) {
            return java.util.Arrays.binarySearch$double_A$double(sortedArray, key);
          } else if ((sortedArray != null && sortedArray instanceof Array && (sortedArray.length == 0 || sortedArray[0] == null || sortedArray[0] != null) || sortedArray === null) && (key != null || key === null) && comparator === undefined) {
            return java.util.Arrays.binarySearch$java_lang_Object_A$java_lang_Object(sortedArray, key);
          } else throw new Error('invalid overload');
        };

        Arrays.copyOf$boolean_A$int = function (original, newLength) {
          javaemul.internal.InternalPreconditions.checkArraySize(newLength);
          return Arrays.copyOfRange$boolean_A$int$int(original, 0, newLength);
        };

        Arrays.copyOf = function (original, newLength) {
          if ((original != null && original instanceof Array && (original.length == 0 || original[0] == null || typeof original[0] === 'boolean') || original === null) && (typeof newLength === 'number' || newLength === null)) {
            return java.util.Arrays.copyOf$boolean_A$int(original, newLength);
          } else if ((original != null && original instanceof Array && (original.length == 0 || original[0] == null || typeof original[0] === 'number') || original === null) && (typeof newLength === 'number' || newLength === null)) {
            return java.util.Arrays.copyOf$byte_A$int(original, newLength);
          } else if ((original != null && original instanceof Array && (original.length == 0 || original[0] == null || typeof original[0] === 'string') || original === null) && (typeof newLength === 'number' || newLength === null)) {
            return java.util.Arrays.copyOf$char_A$int(original, newLength);
          } else if ((original != null && original instanceof Array && (original.length == 0 || original[0] == null || typeof original[0] === 'number') || original === null) && (typeof newLength === 'number' || newLength === null)) {
            return java.util.Arrays.copyOf$double_A$int(original, newLength);
          } else if ((original != null && original instanceof Array && (original.length == 0 || original[0] == null || typeof original[0] === 'number') || original === null) && (typeof newLength === 'number' || newLength === null)) {
            return java.util.Arrays.copyOf$float_A$int(original, newLength);
          } else if ((original != null && original instanceof Array && (original.length == 0 || original[0] == null || typeof original[0] === 'number') || original === null) && (typeof newLength === 'number' || newLength === null)) {
            return java.util.Arrays.copyOf$int_A$int(original, newLength);
          } else if ((original != null && original instanceof Array && (original.length == 0 || original[0] == null || typeof original[0] === 'number') || original === null) && (typeof newLength === 'number' || newLength === null)) {
            return java.util.Arrays.copyOf$long_A$int(original, newLength);
          } else if ((original != null && original instanceof Array && (original.length == 0 || original[0] == null || typeof original[0] === 'number') || original === null) && (typeof newLength === 'number' || newLength === null)) {
            return java.util.Arrays.copyOf$short_A$int(original, newLength);
          } else if ((original != null && original instanceof Array && (original.length == 0 || original[0] == null || original[0] != null) || original === null) && (typeof newLength === 'number' || newLength === null)) {
            return java.util.Arrays.copyOf$java_lang_Object_A$int(original, newLength);
          } else throw new Error('invalid overload');
        };

        Arrays.copyOf$byte_A$int = function (original, newLength) {
          javaemul.internal.InternalPreconditions.checkArraySize(newLength);
          return Arrays.copyOfRange$byte_A$int$int(original, 0, newLength);
        };

        Arrays.copyOf$char_A$int = function (original, newLength) {
          javaemul.internal.InternalPreconditions.checkArraySize(newLength);
          return Arrays.copyOfRange$char_A$int$int(original, 0, newLength);
        };

        Arrays.copyOf$double_A$int = function (original, newLength) {
          javaemul.internal.InternalPreconditions.checkArraySize(newLength);
          return Arrays.copyOfRange$double_A$int$int(original, 0, newLength);
        };

        Arrays.copyOf$float_A$int = function (original, newLength) {
          javaemul.internal.InternalPreconditions.checkArraySize(newLength);
          return Arrays.copyOfRange$float_A$int$int(original, 0, newLength);
        };

        Arrays.copyOf$int_A$int = function (original, newLength) {
          javaemul.internal.InternalPreconditions.checkArraySize(newLength);
          return Arrays.copyOfRange$int_A$int$int(original, 0, newLength);
        };

        Arrays.copyOf$long_A$int = function (original, newLength) {
          javaemul.internal.InternalPreconditions.checkArraySize(newLength);
          return Arrays.copyOfRange$long_A$int$int(original, 0, newLength);
        };

        Arrays.copyOf$short_A$int = function (original, newLength) {
          javaemul.internal.InternalPreconditions.checkArraySize(newLength);
          return Arrays.copyOfRange$short_A$int$int(original, 0, newLength);
        };

        Arrays.copyOf$java_lang_Object_A$int = function (original, newLength) {
          javaemul.internal.InternalPreconditions.checkArraySize(newLength);
          javaemul.internal.InternalPreconditions.checkNotNull(original, "original");
          var clone = javaemul.internal.ArrayHelper.clone(original, 0, newLength);
          javaemul.internal.ArrayHelper.setLength(clone, newLength);
          return clone;
        };

        Arrays.copyOfRange$boolean_A$int$int = function (original, from, to) {
          var len = Arrays.getCopyLength(original, from, to);

          var copy = function (s) {
            var a = [];

            while (s-- > 0) {
              a.push(false);
            }

            return a;
          }(to - from);

          javaemul.internal.ArrayHelper.copy$java_lang_Object$int$java_lang_Object$int$int(original, from, copy, 0, len);
          return copy;
        };

        Arrays.copyOfRange = function (original, from, to) {
          if ((original != null && original instanceof Array && (original.length == 0 || original[0] == null || typeof original[0] === 'boolean') || original === null) && (typeof from === 'number' || from === null) && (typeof to === 'number' || to === null)) {
            return java.util.Arrays.copyOfRange$boolean_A$int$int(original, from, to);
          } else if ((original != null && original instanceof Array && (original.length == 0 || original[0] == null || typeof original[0] === 'number') || original === null) && (typeof from === 'number' || from === null) && (typeof to === 'number' || to === null)) {
            return java.util.Arrays.copyOfRange$byte_A$int$int(original, from, to);
          } else if ((original != null && original instanceof Array && (original.length == 0 || original[0] == null || typeof original[0] === 'string') || original === null) && (typeof from === 'number' || from === null) && (typeof to === 'number' || to === null)) {
            return java.util.Arrays.copyOfRange$char_A$int$int(original, from, to);
          } else if ((original != null && original instanceof Array && (original.length == 0 || original[0] == null || typeof original[0] === 'number') || original === null) && (typeof from === 'number' || from === null) && (typeof to === 'number' || to === null)) {
            return java.util.Arrays.copyOfRange$double_A$int$int(original, from, to);
          } else if ((original != null && original instanceof Array && (original.length == 0 || original[0] == null || typeof original[0] === 'number') || original === null) && (typeof from === 'number' || from === null) && (typeof to === 'number' || to === null)) {
            return java.util.Arrays.copyOfRange$float_A$int$int(original, from, to);
          } else if ((original != null && original instanceof Array && (original.length == 0 || original[0] == null || typeof original[0] === 'number') || original === null) && (typeof from === 'number' || from === null) && (typeof to === 'number' || to === null)) {
            return java.util.Arrays.copyOfRange$int_A$int$int(original, from, to);
          } else if ((original != null && original instanceof Array && (original.length == 0 || original[0] == null || typeof original[0] === 'number') || original === null) && (typeof from === 'number' || from === null) && (typeof to === 'number' || to === null)) {
            return java.util.Arrays.copyOfRange$long_A$int$int(original, from, to);
          } else if ((original != null && original instanceof Array && (original.length == 0 || original[0] == null || typeof original[0] === 'number') || original === null) && (typeof from === 'number' || from === null) && (typeof to === 'number' || to === null)) {
            return java.util.Arrays.copyOfRange$short_A$int$int(original, from, to);
          } else if ((original != null && original instanceof Array && (original.length == 0 || original[0] == null || original[0] != null) || original === null) && (typeof from === 'number' || from === null) && (typeof to === 'number' || to === null)) {
            return java.util.Arrays.copyOfRange$java_lang_Object_A$int$int(original, from, to);
          } else throw new Error('invalid overload');
        };

        Arrays.copyOfRange$byte_A$int$int = function (original, from, to) {
          var len = Arrays.getCopyLength(original, from, to);

          var copy = function (s) {
            var a = [];

            while (s-- > 0) {
              a.push(0);
            }

            return a;
          }(to - from);

          javaemul.internal.ArrayHelper.copy$java_lang_Object$int$java_lang_Object$int$int(original, from, copy, 0, len);
          return copy;
        };

        Arrays.copyOfRange$char_A$int$int = function (original, from, to) {
          var len = Arrays.getCopyLength(original, from, to);

          var copy = function (s) {
            var a = [];

            while (s-- > 0) {
              a.push(null);
            }

            return a;
          }(to - from);

          javaemul.internal.ArrayHelper.copy$java_lang_Object$int$java_lang_Object$int$int(original, from, copy, 0, len);
          return copy;
        };

        Arrays.copyOfRange$double_A$int$int = function (original, from, to) {
          var len = Arrays.getCopyLength(original, from, to);

          var copy = function (s) {
            var a = [];

            while (s-- > 0) {
              a.push(0);
            }

            return a;
          }(to - from);

          javaemul.internal.ArrayHelper.copy$java_lang_Object$int$java_lang_Object$int$int(original, from, copy, 0, len);
          return copy;
        };

        Arrays.copyOfRange$float_A$int$int = function (original, from, to) {
          var len = Arrays.getCopyLength(original, from, to);

          var copy = function (s) {
            var a = [];

            while (s-- > 0) {
              a.push(0);
            }

            return a;
          }(to - from);

          javaemul.internal.ArrayHelper.copy$java_lang_Object$int$java_lang_Object$int$int(original, from, copy, 0, len);
          return copy;
        };

        Arrays.copyOfRange$int_A$int$int = function (original, from, to) {
          var len = Arrays.getCopyLength(original, from, to);

          var copy = function (s) {
            var a = [];

            while (s-- > 0) {
              a.push(0);
            }

            return a;
          }(to - from);

          javaemul.internal.ArrayHelper.copy$java_lang_Object$int$java_lang_Object$int$int(original, from, copy, 0, len);
          return copy;
        };

        Arrays.copyOfRange$long_A$int$int = function (original, from, to) {
          var len = Arrays.getCopyLength(original, from, to);

          var copy = function (s) {
            var a = [];

            while (s-- > 0) {
              a.push(0);
            }

            return a;
          }(to - from);

          javaemul.internal.ArrayHelper.copy$java_lang_Object$int$java_lang_Object$int$int(original, from, copy, 0, len);
          return copy;
        };

        Arrays.copyOfRange$short_A$int$int = function (original, from, to) {
          var len = Arrays.getCopyLength(original, from, to);

          var copy = function (s) {
            var a = [];

            while (s-- > 0) {
              a.push(0);
            }

            return a;
          }(to - from);

          javaemul.internal.ArrayHelper.copy$java_lang_Object$int$java_lang_Object$int$int(original, from, copy, 0, len);
          return copy;
        };

        Arrays.copyOfRange$java_lang_Object_A$int$int = function (original, from, to) {
          var len = Arrays.getCopyLength(original, from, to);
          var copy = javaemul.internal.ArrayHelper.createFrom(original, to - from);
          javaemul.internal.ArrayHelper.copy$java_lang_Object$int$java_lang_Object$int$int(original, from, copy, 0, len);
          return copy;
        };

        Arrays.deepEquals = function (a1, a2) {
          if (a1 === a2) {
            return true;
          }

          if (a1 == null || a2 == null) {
            return false;
          }

          if (a1.length !== a2.length) {
            return false;
          }

          for (var i = 0, n = a1.length; i < n; ++i) {
            {
              if (!java.util.Objects.deepEquals(a1[i], a2[i])) {
                return false;
              }
            }
          }

          return true;
        };

        Arrays.deepHashCode = function (a) {
          if (a == null) {
            return 0;
          }

          var hashCode = 1;

          for (var index154 = 0; index154 < a.length; index154++) {
            var obj = a[index154];
            {
              var hash = void 0;

              if (obj != null && obj instanceof Array && (obj.length == 0 || obj[0] == null || obj[0] != null)) {
                hash = Arrays.deepHashCode(obj);
              } else if (obj != null && obj instanceof Array && (obj.length == 0 || obj[0] == null || typeof obj[0] === 'boolean')) {
                hash = Arrays.hashCode$boolean_A(obj);
              } else if (obj != null && obj instanceof Array && (obj.length == 0 || obj[0] == null || typeof obj[0] === 'number')) {
                hash = Arrays.hashCode$byte_A(obj);
              } else if (obj != null && obj instanceof Array && (obj.length == 0 || obj[0] == null || typeof obj[0] === 'string')) {
                hash = Arrays.hashCode$char_A(obj);
              } else if (obj != null && obj instanceof Array && (obj.length == 0 || obj[0] == null || typeof obj[0] === 'number')) {
                hash = Arrays.hashCode$short_A(obj);
              } else if (obj != null && obj instanceof Array && (obj.length == 0 || obj[0] == null || typeof obj[0] === 'number')) {
                hash = Arrays.hashCode$int_A(obj);
              } else if (obj != null && obj instanceof Array && (obj.length == 0 || obj[0] == null || typeof obj[0] === 'number')) {
                hash = Arrays.hashCode$long_A(obj);
              } else if (obj != null && obj instanceof Array && (obj.length == 0 || obj[0] == null || typeof obj[0] === 'number')) {
                hash = Arrays.hashCode$float_A(obj);
              } else if (obj != null && obj instanceof Array && (obj.length == 0 || obj[0] == null || typeof obj[0] === 'number')) {
                hash = Arrays.hashCode$double_A(obj);
              } else {
                hash = java.util.Objects.hashCode(obj);
              }

              hashCode = 31 * hashCode + hash;
              hashCode = javaemul.internal.Coercions.ensureInt(hashCode);
            }
          }

          return hashCode;
        };

        Arrays.deepToString$java_lang_Object_A = function (a) {
          return Arrays.deepToString$java_lang_Object_A$java_util_Set(a, new java.util.HashSet());
        };

        Arrays.equals$boolean_A$boolean_A = function (array1, array2) {
          if (array1 === array2) {
            return true;
          }

          if (array1 == null || array2 == null) {
            return false;
          }

          if (array1.length !== array2.length) {
            return false;
          }

          for (var i = 0; i < array1.length; ++i) {
            {
              if (array1[i] !== array2[i]) {
                return false;
              }
            }
          }

          return true;
        };

        Arrays.equals = function (array1, array2) {
          if ((array1 != null && array1 instanceof Array && (array1.length == 0 || array1[0] == null || typeof array1[0] === 'boolean') || array1 === null) && (array2 != null && array2 instanceof Array && (array2.length == 0 || array2[0] == null || typeof array2[0] === 'boolean') || array2 === null)) {
            return java.util.Arrays.equals$boolean_A$boolean_A(array1, array2);
          } else if ((array1 != null && array1 instanceof Array && (array1.length == 0 || array1[0] == null || typeof array1[0] === 'number') || array1 === null) && (array2 != null && array2 instanceof Array && (array2.length == 0 || array2[0] == null || typeof array2[0] === 'number') || array2 === null)) {
            return java.util.Arrays.equals$byte_A$byte_A(array1, array2);
          } else if ((array1 != null && array1 instanceof Array && (array1.length == 0 || array1[0] == null || typeof array1[0] === 'string') || array1 === null) && (array2 != null && array2 instanceof Array && (array2.length == 0 || array2[0] == null || typeof array2[0] === 'string') || array2 === null)) {
            return java.util.Arrays.equals$char_A$char_A(array1, array2);
          } else if ((array1 != null && array1 instanceof Array && (array1.length == 0 || array1[0] == null || typeof array1[0] === 'number') || array1 === null) && (array2 != null && array2 instanceof Array && (array2.length == 0 || array2[0] == null || typeof array2[0] === 'number') || array2 === null)) {
            return java.util.Arrays.equals$double_A$double_A(array1, array2);
          } else if ((array1 != null && array1 instanceof Array && (array1.length == 0 || array1[0] == null || typeof array1[0] === 'number') || array1 === null) && (array2 != null && array2 instanceof Array && (array2.length == 0 || array2[0] == null || typeof array2[0] === 'number') || array2 === null)) {
            return java.util.Arrays.equals$float_A$float_A(array1, array2);
          } else if ((array1 != null && array1 instanceof Array && (array1.length == 0 || array1[0] == null || typeof array1[0] === 'number') || array1 === null) && (array2 != null && array2 instanceof Array && (array2.length == 0 || array2[0] == null || typeof array2[0] === 'number') || array2 === null)) {
            return java.util.Arrays.equals$int_A$int_A(array1, array2);
          } else if ((array1 != null && array1 instanceof Array && (array1.length == 0 || array1[0] == null || typeof array1[0] === 'number') || array1 === null) && (array2 != null && array2 instanceof Array && (array2.length == 0 || array2[0] == null || typeof array2[0] === 'number') || array2 === null)) {
            return java.util.Arrays.equals$long_A$long_A(array1, array2);
          } else if ((array1 != null && array1 instanceof Array && (array1.length == 0 || array1[0] == null || array1[0] != null) || array1 === null) && (array2 != null && array2 instanceof Array && (array2.length == 0 || array2[0] == null || array2[0] != null) || array2 === null)) {
            return java.util.Arrays.equals$java_lang_Object_A$java_lang_Object_A(array1, array2);
          } else if ((array1 != null && array1 instanceof Array && (array1.length == 0 || array1[0] == null || typeof array1[0] === 'number') || array1 === null) && (array2 != null && array2 instanceof Array && (array2.length == 0 || array2[0] == null || typeof array2[0] === 'number') || array2 === null)) {
            return java.util.Arrays.equals$short_A$short_A(array1, array2);
          } else throw new Error('invalid overload');
        };

        Arrays.equals$byte_A$byte_A = function (array1, array2) {
          if (array1 === array2) {
            return true;
          }

          if (array1 == null || array2 == null) {
            return false;
          }

          if (array1.length !== array2.length) {
            return false;
          }

          for (var i = 0; i < array1.length; ++i) {
            {
              if (array1[i] !== array2[i]) {
                return false;
              }
            }
          }

          return true;
        };

        Arrays.equals$char_A$char_A = function (array1, array2) {
          if (array1 === array2) {
            return true;
          }

          if (array1 == null || array2 == null) {
            return false;
          }

          if (array1.length !== array2.length) {
            return false;
          }

          for (var i = 0; i < array1.length; ++i) {
            {
              if (function (c) {
                return c.charCodeAt == null ? c : c.charCodeAt(0);
              }(array1[i]) != function (c) {
                return c.charCodeAt == null ? c : c.charCodeAt(0);
              }(array2[i])) {
                return false;
              }
            }
          }

          return true;
        };

        Arrays.equals$double_A$double_A = function (array1, array2) {
          if (array1 === array2) {
            return true;
          }

          if (array1 == null || array2 == null) {
            return false;
          }

          if (array1.length !== array2.length) {
            return false;
          }

          for (var i = 0; i < array1.length; ++i) {
            {
              if (array1[i] !== array2[i]) {
                return false;
              }
            }
          }

          return true;
        };

        Arrays.equals$float_A$float_A = function (array1, array2) {
          if (array1 === array2) {
            return true;
          }

          if (array1 == null || array2 == null) {
            return false;
          }

          if (array1.length !== array2.length) {
            return false;
          }

          for (var i = 0; i < array1.length; ++i) {
            {
              if (array1[i] !== array2[i]) {
                return false;
              }
            }
          }

          return true;
        };

        Arrays.equals$int_A$int_A = function (array1, array2) {
          if (array1 === array2) {
            return true;
          }

          if (array1 == null || array2 == null) {
            return false;
          }

          if (array1.length !== array2.length) {
            return false;
          }

          for (var i = 0; i < array1.length; ++i) {
            {
              if (array1[i] !== array2[i]) {
                return false;
              }
            }
          }

          return true;
        };

        Arrays.equals$long_A$long_A = function (array1, array2) {
          if (array1 === array2) {
            return true;
          }

          if (array1 == null || array2 == null) {
            return false;
          }

          if (array1.length !== array2.length) {
            return false;
          }

          for (var i = 0; i < array1.length; ++i) {
            {
              if (array1[i] !== array2[i]) {
                return false;
              }
            }
          }

          return true;
        };

        Arrays.equals$java_lang_Object_A$java_lang_Object_A = function (array1, array2) {
          if (array1 === array2) {
            return true;
          }

          if (array1 == null || array2 == null) {
            return false;
          }

          if (array1.length !== array2.length) {
            return false;
          }

          for (var i = 0; i < array1.length; ++i) {
            {
              var val1 = array1[i];
              var val2 = array2[i];

              if (!java.util.Objects.equals(val1, val2)) {
                return false;
              }
            }
          }

          return true;
        };

        Arrays.equals$short_A$short_A = function (array1, array2) {
          if (array1 === array2) {
            return true;
          }

          if (array1 == null || array2 == null) {
            return false;
          }

          if (array1.length !== array2.length) {
            return false;
          }

          for (var i = 0; i < array1.length; ++i) {
            {
              if (array1[i] !== array2[i]) {
                return false;
              }
            }
          }

          return true;
        };

        Arrays.fill$boolean_A$boolean = function (a, val) {
          Arrays.fill$boolean_A$int$int$boolean(a, 0, a.length, val);
        };

        Arrays.fill$boolean_A$int$int$boolean = function (a, fromIndex, toIndex, val) {
          for (var i = fromIndex; i < toIndex; ++i) {
            {
              a[i] = val;
            }
          }
        };

        Arrays.fill = function (a, fromIndex, toIndex, val) {
          if ((a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'boolean') || a === null) && (typeof fromIndex === 'number' || fromIndex === null) && (typeof toIndex === 'number' || toIndex === null) && (typeof val === 'boolean' || val === null)) {
            return java.util.Arrays.fill$boolean_A$int$int$boolean(a, fromIndex, toIndex, val);
          } else if ((a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'number') || a === null) && (typeof fromIndex === 'number' || fromIndex === null) && (typeof toIndex === 'number' || toIndex === null) && (typeof val === 'number' || val === null)) {
            return java.util.Arrays.fill$byte_A$int$int$byte(a, fromIndex, toIndex, val);
          } else if ((a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'string') || a === null) && (typeof fromIndex === 'number' || fromIndex === null) && (typeof toIndex === 'number' || toIndex === null) && (typeof val === 'string' || val === null)) {
            return java.util.Arrays.fill$char_A$int$int$char(a, fromIndex, toIndex, val);
          } else if ((a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'number') || a === null) && (typeof fromIndex === 'number' || fromIndex === null) && (typeof toIndex === 'number' || toIndex === null) && (typeof val === 'number' || val === null)) {
            return java.util.Arrays.fill$short_A$int$int$short(a, fromIndex, toIndex, val);
          } else if ((a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'number') || a === null) && (typeof fromIndex === 'number' || fromIndex === null) && (typeof toIndex === 'number' || toIndex === null) && (typeof val === 'number' || val === null)) {
            return java.util.Arrays.fill$int_A$int$int$int(a, fromIndex, toIndex, val);
          } else if ((a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'number') || a === null) && (typeof fromIndex === 'number' || fromIndex === null) && (typeof toIndex === 'number' || toIndex === null) && (typeof val === 'number' || val === null)) {
            return java.util.Arrays.fill$long_A$int$int$long(a, fromIndex, toIndex, val);
          } else if ((a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'number') || a === null) && (typeof fromIndex === 'number' || fromIndex === null) && (typeof toIndex === 'number' || toIndex === null) && (typeof val === 'number' || val === null)) {
            return java.util.Arrays.fill$float_A$int$int$float(a, fromIndex, toIndex, val);
          } else if ((a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'number') || a === null) && (typeof fromIndex === 'number' || fromIndex === null) && (typeof toIndex === 'number' || toIndex === null) && (typeof val === 'number' || val === null)) {
            return java.util.Arrays.fill$double_A$int$int$double(a, fromIndex, toIndex, val);
          } else if ((a != null && a instanceof Array && (a.length == 0 || a[0] == null || a[0] != null) || a === null) && (typeof fromIndex === 'number' || fromIndex === null) && (typeof toIndex === 'number' || toIndex === null) && (val != null || val === null)) {
            return java.util.Arrays.fill$java_lang_Object_A$int$int$java_lang_Object(a, fromIndex, toIndex, val);
          } else if ((a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'boolean') || a === null) && (typeof fromIndex === 'boolean' || fromIndex === null) && toIndex === undefined && val === undefined) {
            return java.util.Arrays.fill$boolean_A$boolean(a, fromIndex);
          } else if ((a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'number') || a === null) && (typeof fromIndex === 'number' || fromIndex === null) && toIndex === undefined && val === undefined) {
            return java.util.Arrays.fill$byte_A$byte(a, fromIndex);
          } else if ((a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'string') || a === null) && (typeof fromIndex === 'string' || fromIndex === null) && toIndex === undefined && val === undefined) {
            return java.util.Arrays.fill$char_A$char(a, fromIndex);
          } else if ((a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'number') || a === null) && (typeof fromIndex === 'number' || fromIndex === null) && toIndex === undefined && val === undefined) {
            return java.util.Arrays.fill$short_A$short(a, fromIndex);
          } else if ((a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'number') || a === null) && (typeof fromIndex === 'number' || fromIndex === null) && toIndex === undefined && val === undefined) {
            return java.util.Arrays.fill$int_A$int(a, fromIndex);
          } else if ((a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'number') || a === null) && (typeof fromIndex === 'number' || fromIndex === null) && toIndex === undefined && val === undefined) {
            return java.util.Arrays.fill$long_A$long(a, fromIndex);
          } else if ((a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'number') || a === null) && (typeof fromIndex === 'number' || fromIndex === null) && toIndex === undefined && val === undefined) {
            return java.util.Arrays.fill$float_A$float(a, fromIndex);
          } else if ((a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'number') || a === null) && (typeof fromIndex === 'number' || fromIndex === null) && toIndex === undefined && val === undefined) {
            return java.util.Arrays.fill$double_A$double(a, fromIndex);
          } else if ((a != null && a instanceof Array && (a.length == 0 || a[0] == null || a[0] != null) || a === null) && (fromIndex != null || fromIndex === null) && toIndex === undefined && val === undefined) {
            return java.util.Arrays.fill$java_lang_Object_A$java_lang_Object(a, fromIndex);
          } else throw new Error('invalid overload');
        };

        Arrays.fill$byte_A$byte = function (a, val) {
          Arrays.fill$byte_A$int$int$byte(a, 0, a.length, val);
        };

        Arrays.fill$byte_A$int$int$byte = function (a, fromIndex, toIndex, val) {
          for (var i = fromIndex; i < toIndex; ++i) {
            {
              a[i] = val;
            }
          }
        };

        Arrays.fill$char_A$char = function (a, val) {
          Arrays.fill$char_A$int$int$char(a, 0, a.length, val);
        };

        Arrays.fill$char_A$int$int$char = function (a, fromIndex, toIndex, val) {
          for (var i = fromIndex; i < toIndex; ++i) {
            {
              a[i] = val;
            }
          }
        };

        Arrays.fill$double_A$double = function (a, val) {
          Arrays.fill$double_A$int$int$double(a, 0, a.length, val);
        };

        Arrays.fill$double_A$int$int$double = function (a, fromIndex, toIndex, val) {
          for (var i = fromIndex; i < toIndex; ++i) {
            {
              a[i] = val;
            }
          }
        };

        Arrays.fill$float_A$float = function (a, val) {
          Arrays.fill$float_A$int$int$float(a, 0, a.length, val);
        };

        Arrays.fill$float_A$int$int$float = function (a, fromIndex, toIndex, val) {
          for (var i = fromIndex; i < toIndex; ++i) {
            {
              a[i] = val;
            }
          }
        };

        Arrays.fill$int_A$int = function (a, val) {
          Arrays.fill$int_A$int$int$int(a, 0, a.length, val);
        };

        Arrays.fill$int_A$int$int$int = function (a, fromIndex, toIndex, val) {
          for (var i = fromIndex; i < toIndex; ++i) {
            {
              a[i] = val;
            }
          }
        };

        Arrays.fill$long_A$int$int$long = function (a, fromIndex, toIndex, val) {
          for (var i = fromIndex; i < toIndex; ++i) {
            {
              a[i] = val;
            }
          }
        };

        Arrays.fill$long_A$long = function (a, val) {
          Arrays.fill$long_A$int$int$long(a, 0, a.length, val);
        };

        Arrays.fill$java_lang_Object_A$int$int$java_lang_Object = function (a, fromIndex, toIndex, val) {
          for (var i = fromIndex; i < toIndex; ++i) {
            {
              a[i] = val;
            }
          }
        };

        Arrays.fill$java_lang_Object_A$java_lang_Object = function (a, val) {
          Arrays.fill$java_lang_Object_A$int$int$java_lang_Object(a, 0, a.length, val);
        };

        Arrays.fill$short_A$int$int$short = function (a, fromIndex, toIndex, val) {
          for (var i = fromIndex; i < toIndex; ++i) {
            {
              a[i] = val;
            }
          }
        };

        Arrays.fill$short_A$short = function (a, val) {
          Arrays.fill$short_A$int$int$short(a, 0, a.length, val);
        };

        Arrays.hashCode$boolean_A = function (a) {
          if (a == null) {
            return 0;
          }

          var hashCode = 1;

          for (var index155 = 0; index155 < a.length; index155++) {
            var e = a[index155];
            {
              hashCode = 31 * hashCode + javaemul.internal.BooleanHelper.hashCode(e);
              hashCode = javaemul.internal.Coercions.ensureInt(hashCode);
            }
          }

          return hashCode;
        };

        Arrays.hashCode = function (a) {
          if (a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'boolean') || a === null) {
            return java.util.Arrays.hashCode$boolean_A(a);
          } else if (a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'number') || a === null) {
            return java.util.Arrays.hashCode$byte_A(a);
          } else if (a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'string') || a === null) {
            return java.util.Arrays.hashCode$char_A(a);
          } else if (a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'number') || a === null) {
            return java.util.Arrays.hashCode$double_A(a);
          } else if (a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'number') || a === null) {
            return java.util.Arrays.hashCode$float_A(a);
          } else if (a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'number') || a === null) {
            return java.util.Arrays.hashCode$int_A(a);
          } else if (a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'number') || a === null) {
            return java.util.Arrays.hashCode$long_A(a);
          } else if (a != null && a instanceof Array && (a.length == 0 || a[0] == null || a[0] != null) || a === null) {
            return java.util.Arrays.hashCode$java_lang_Object_A(a);
          } else if (a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'number') || a === null) {
            return java.util.Arrays.hashCode$short_A(a);
          } else throw new Error('invalid overload');
        };

        Arrays.hashCode$byte_A = function (a) {
          if (a == null) {
            return 0;
          }

          var hashCode = 1;

          for (var index156 = 0; index156 < a.length; index156++) {
            var e = a[index156];
            {
              hashCode = 31 * hashCode + javaemul.internal.ByteHelper.hashCode(e);
              hashCode = javaemul.internal.Coercions.ensureInt(hashCode);
            }
          }

          return hashCode;
        };

        Arrays.hashCode$char_A = function (a) {
          if (a == null) {
            return 0;
          }

          var hashCode = 1;

          for (var index157 = 0; index157 < a.length; index157++) {
            var e = a[index157];
            {
              hashCode = 31 * hashCode + javaemul.internal.CharacterHelper.hashCode(e);
              hashCode = javaemul.internal.Coercions.ensureInt(hashCode);
            }
          }

          return hashCode;
        };

        Arrays.hashCode$double_A = function (a) {
          if (a == null) {
            return 0;
          }

          var hashCode = 1;

          for (var index158 = 0; index158 < a.length; index158++) {
            var e = a[index158];
            {
              hashCode = 31 * hashCode + javaemul.internal.DoubleHelper.hashCode(e);
              hashCode = javaemul.internal.Coercions.ensureInt(hashCode);
            }
          }

          return hashCode;
        };

        Arrays.hashCode$float_A = function (a) {
          if (a == null) {
            return 0;
          }

          var hashCode = 1;

          for (var index159 = 0; index159 < a.length; index159++) {
            var e = a[index159];
            {
              hashCode = 31 * hashCode + javaemul.internal.FloatHelper.hashCode(e);
              hashCode = javaemul.internal.Coercions.ensureInt(hashCode);
            }
          }

          return hashCode;
        };

        Arrays.hashCode$int_A = function (a) {
          if (a == null) {
            return 0;
          }

          var hashCode = 1;

          for (var index160 = 0; index160 < a.length; index160++) {
            var e = a[index160];
            {
              hashCode = 31 * hashCode + javaemul.internal.IntegerHelper.hashCode(e);
              hashCode = javaemul.internal.Coercions.ensureInt(hashCode);
            }
          }

          return hashCode;
        };

        Arrays.hashCode$long_A = function (a) {
          if (a == null) {
            return 0;
          }

          var hashCode = 1;

          for (var index161 = 0; index161 < a.length; index161++) {
            var e = a[index161];
            {
              hashCode = 31 * hashCode + javaemul.internal.LongHelper.hashCode(e);
              hashCode = javaemul.internal.Coercions.ensureInt(hashCode);
            }
          }

          return hashCode;
        };

        Arrays.hashCode$java_lang_Object_A = function (a) {
          if (a == null) {
            return 0;
          }

          var hashCode = 1;

          for (var index162 = 0; index162 < a.length; index162++) {
            var e = a[index162];
            {
              hashCode = 31 * hashCode + java.util.Objects.hashCode(e);
              hashCode = javaemul.internal.Coercions.ensureInt(hashCode);
            }
          }

          return hashCode;
        };

        Arrays.hashCode$short_A = function (a) {
          if (a == null) {
            return 0;
          }

          var hashCode = 1;

          for (var index163 = 0; index163 < a.length; index163++) {
            var e = a[index163];
            {
              hashCode = 31 * hashCode + javaemul.internal.ShortHelper.hashCode(e);
              hashCode = javaemul.internal.Coercions.ensureInt(hashCode);
            }
          }

          return hashCode;
        };

        Arrays.sort$byte_A = function (array) {
          Arrays.nativeNumberSort$java_lang_Object(array);
        };

        Arrays.sort$byte_A$int$int = function (array, fromIndex, toIndex) {
          javaemul.internal.InternalPreconditions.checkPositionIndexes(fromIndex, toIndex, array.length);
          Arrays.nativeNumberSort$java_lang_Object$int$int(array, fromIndex, toIndex);
        };

        Arrays.sort$char_A = function (array) {
          Arrays.nativeNumberSort$java_lang_Object(array);
        };

        Arrays.sort$char_A$int$int = function (array, fromIndex, toIndex) {
          javaemul.internal.InternalPreconditions.checkPositionIndexes(fromIndex, toIndex, array.length);
          Arrays.nativeNumberSort$java_lang_Object$int$int(array, fromIndex, toIndex);
        };

        Arrays.sort$double_A = function (array) {
          Arrays.nativeNumberSort$java_lang_Object(array);
        };

        Arrays.sort$double_A$int$int = function (array, fromIndex, toIndex) {
          javaemul.internal.InternalPreconditions.checkPositionIndexes(fromIndex, toIndex, array.length);
          Arrays.nativeNumberSort$java_lang_Object$int$int(array, fromIndex, toIndex);
        };

        Arrays.sort$float_A = function (array) {
          Arrays.nativeNumberSort$java_lang_Object(array);
        };

        Arrays.sort$float_A$int$int = function (array, fromIndex, toIndex) {
          javaemul.internal.InternalPreconditions.checkPositionIndexes(fromIndex, toIndex, array.length);
          Arrays.nativeNumberSort$java_lang_Object$int$int(array, fromIndex, toIndex);
        };

        Arrays.sort$int_A = function (array) {
          Arrays.nativeNumberSort$java_lang_Object(array);
        };

        Arrays.sort$int_A$int$int = function (array, fromIndex, toIndex) {
          javaemul.internal.InternalPreconditions.checkPositionIndexes(fromIndex, toIndex, array.length);
          Arrays.nativeNumberSort$java_lang_Object$int$int(array, fromIndex, toIndex);
        };

        Arrays.sort$long_A = function (array) {
          Arrays.nativeLongSort$java_lang_Object$java_lang_Object(array, javaemul.internal.LongCompareHolder.getLongComparator());
        };

        Arrays.sort$long_A$int$int = function (array, fromIndex, toIndex) {
          javaemul.internal.InternalPreconditions.checkPositionIndexes(fromIndex, toIndex, array.length);
          Arrays.nativeLongSort$java_lang_Object$int$int(array, fromIndex, toIndex);
        };

        Arrays.sort$java_lang_Object_A = function (array) {
          Arrays.mergeSort$java_lang_Object_A$int$int$java_util_Comparator(array, 0, array.length, java.util.Comparators.natural());
        };

        Arrays.sort$java_lang_Object_A$int$int = function (x, fromIndex, toIndex) {
          Arrays.mergeSort$java_lang_Object_A$int$int$java_util_Comparator(x, fromIndex, toIndex, java.util.Comparators.natural());
        };

        Arrays.sort$short_A = function (array) {
          Arrays.nativeNumberSort$java_lang_Object(array);
        };

        Arrays.sort$short_A$int$int = function (array, fromIndex, toIndex) {
          javaemul.internal.InternalPreconditions.checkPositionIndexes(fromIndex, toIndex, array.length);
          Arrays.nativeNumberSort$java_lang_Object$int$int(array, fromIndex, toIndex);
        };

        Arrays.sort$java_lang_Object_A$java_util_Comparator = function (x, c) {
          Arrays.mergeSort$java_lang_Object_A$int$int$java_util_Comparator(x, 0, x.length, c);
        };

        Arrays.sort$java_lang_Object_A$int$int$java_util_Comparator = function (x, fromIndex, toIndex, c) {
          javaemul.internal.InternalPreconditions.checkPositionIndexes(fromIndex, toIndex, x.length);
          Arrays.mergeSort$java_lang_Object_A$int$int$java_util_Comparator(x, fromIndex, toIndex, c);
        };

        Arrays.sort = function (x, fromIndex, toIndex, c) {
          if ((x != null && x instanceof Array && (x.length == 0 || x[0] == null || x[0] != null) || x === null) && (typeof fromIndex === 'number' || fromIndex === null) && (typeof toIndex === 'number' || toIndex === null) && (typeof c === 'function' && c.length === 2 || c === null)) {
            return java.util.Arrays.sort$java_lang_Object_A$int$int$java_util_Comparator(x, fromIndex, toIndex, c);
          } else if ((x != null && x instanceof Array && (x.length == 0 || x[0] == null || typeof x[0] === 'number') || x === null) && (typeof fromIndex === 'number' || fromIndex === null) && (typeof toIndex === 'number' || toIndex === null) && c === undefined) {
            return java.util.Arrays.sort$byte_A$int$int(x, fromIndex, toIndex);
          } else if ((x != null && x instanceof Array && (x.length == 0 || x[0] == null || typeof x[0] === 'string') || x === null) && (typeof fromIndex === 'number' || fromIndex === null) && (typeof toIndex === 'number' || toIndex === null) && c === undefined) {
            return java.util.Arrays.sort$char_A$int$int(x, fromIndex, toIndex);
          } else if ((x != null && x instanceof Array && (x.length == 0 || x[0] == null || typeof x[0] === 'number') || x === null) && (typeof fromIndex === 'number' || fromIndex === null) && (typeof toIndex === 'number' || toIndex === null) && c === undefined) {
            return java.util.Arrays.sort$double_A$int$int(x, fromIndex, toIndex);
          } else if ((x != null && x instanceof Array && (x.length == 0 || x[0] == null || typeof x[0] === 'number') || x === null) && (typeof fromIndex === 'number' || fromIndex === null) && (typeof toIndex === 'number' || toIndex === null) && c === undefined) {
            return java.util.Arrays.sort$float_A$int$int(x, fromIndex, toIndex);
          } else if ((x != null && x instanceof Array && (x.length == 0 || x[0] == null || typeof x[0] === 'number') || x === null) && (typeof fromIndex === 'number' || fromIndex === null) && (typeof toIndex === 'number' || toIndex === null) && c === undefined) {
            return java.util.Arrays.sort$int_A$int$int(x, fromIndex, toIndex);
          } else if ((x != null && x instanceof Array && (x.length == 0 || x[0] == null || typeof x[0] === 'number') || x === null) && (typeof fromIndex === 'number' || fromIndex === null) && (typeof toIndex === 'number' || toIndex === null) && c === undefined) {
            return java.util.Arrays.sort$long_A$int$int(x, fromIndex, toIndex);
          } else if ((x != null && x instanceof Array && (x.length == 0 || x[0] == null || x[0] != null) || x === null) && (typeof fromIndex === 'number' || fromIndex === null) && (typeof toIndex === 'number' || toIndex === null) && c === undefined) {
            return java.util.Arrays.sort$java_lang_Object_A$int$int(x, fromIndex, toIndex);
          } else if ((x != null && x instanceof Array && (x.length == 0 || x[0] == null || typeof x[0] === 'number') || x === null) && (typeof fromIndex === 'number' || fromIndex === null) && (typeof toIndex === 'number' || toIndex === null) && c === undefined) {
            return java.util.Arrays.sort$short_A$int$int(x, fromIndex, toIndex);
          } else if ((x != null && x instanceof Array && (x.length == 0 || x[0] == null || x[0] != null) || x === null) && (typeof fromIndex === 'function' && fromIndex.length === 2 || fromIndex === null) && toIndex === undefined && c === undefined) {
            return java.util.Arrays.sort$java_lang_Object_A$java_util_Comparator(x, fromIndex);
          } else if ((x != null && x instanceof Array && (x.length == 0 || x[0] == null || typeof x[0] === 'number') || x === null) && fromIndex === undefined && toIndex === undefined && c === undefined) {
            return java.util.Arrays.sort$byte_A(x);
          } else if ((x != null && x instanceof Array && (x.length == 0 || x[0] == null || typeof x[0] === 'string') || x === null) && fromIndex === undefined && toIndex === undefined && c === undefined) {
            return java.util.Arrays.sort$char_A(x);
          } else if ((x != null && x instanceof Array && (x.length == 0 || x[0] == null || typeof x[0] === 'number') || x === null) && fromIndex === undefined && toIndex === undefined && c === undefined) {
            return java.util.Arrays.sort$double_A(x);
          } else if ((x != null && x instanceof Array && (x.length == 0 || x[0] == null || typeof x[0] === 'number') || x === null) && fromIndex === undefined && toIndex === undefined && c === undefined) {
            return java.util.Arrays.sort$float_A(x);
          } else if ((x != null && x instanceof Array && (x.length == 0 || x[0] == null || typeof x[0] === 'number') || x === null) && fromIndex === undefined && toIndex === undefined && c === undefined) {
            return java.util.Arrays.sort$int_A(x);
          } else if ((x != null && x instanceof Array && (x.length == 0 || x[0] == null || typeof x[0] === 'number') || x === null) && fromIndex === undefined && toIndex === undefined && c === undefined) {
            return java.util.Arrays.sort$long_A(x);
          } else if ((x != null && x instanceof Array && (x.length == 0 || x[0] == null || x[0] != null) || x === null) && fromIndex === undefined && toIndex === undefined && c === undefined) {
            return java.util.Arrays.sort$java_lang_Object_A(x);
          } else if ((x != null && x instanceof Array && (x.length == 0 || x[0] == null || typeof x[0] === 'number') || x === null) && fromIndex === undefined && toIndex === undefined && c === undefined) {
            return java.util.Arrays.sort$short_A(x);
          } else throw new Error('invalid overload');
        };

        Arrays.toString$boolean_A = function (a) {
          if (a == null) {
            return "null";
          }

          var joiner = new java.util.StringJoiner(", ", "[", "]");

          for (var index164 = 0; index164 < a.length; index164++) {
            var element = a[index164];
            {
              joiner.add(
              /* valueOf */
              new String(element).toString());
            }
          }

          return joiner.toString();
        };

        Arrays.toString = function (a) {
          if (a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'boolean') || a === null) {
            return java.util.Arrays.toString$boolean_A(a);
          } else if (a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'number') || a === null) {
            return java.util.Arrays.toString$byte_A(a);
          } else if (a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'string') || a === null) {
            return java.util.Arrays.toString$char_A(a);
          } else if (a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'number') || a === null) {
            return java.util.Arrays.toString$double_A(a);
          } else if (a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'number') || a === null) {
            return java.util.Arrays.toString$float_A(a);
          } else if (a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'number') || a === null) {
            return java.util.Arrays.toString$int_A(a);
          } else if (a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'number') || a === null) {
            return java.util.Arrays.toString$long_A(a);
          } else if (a != null && a instanceof Array && (a.length == 0 || a[0] == null || a[0] != null) || a === null) {
            return java.util.Arrays.toString$java_lang_Object_A(a);
          } else if (a != null && a instanceof Array && (a.length == 0 || a[0] == null || typeof a[0] === 'number') || a === null) {
            return java.util.Arrays.toString$short_A(a);
          } else throw new Error('invalid overload');
        };

        Arrays.toString$byte_A = function (a) {
          if (a == null) {
            return "null";
          }

          var joiner = new java.util.StringJoiner(", ", "[", "]");

          for (var index165 = 0; index165 < a.length; index165++) {
            var element = a[index165];
            {
              joiner.add(
              /* valueOf */
              new String(element).toString());
            }
          }

          return joiner.toString();
        };

        Arrays.toString$char_A = function (a) {
          if (a == null) {
            return "null";
          }

          var joiner = new java.util.StringJoiner(", ", "[", "]");

          for (var index166 = 0; index166 < a.length; index166++) {
            var element = a[index166];
            {
              joiner.add(
              /* valueOf */
              new String(element).toString());
            }
          }

          return joiner.toString();
        };

        Arrays.toString$double_A = function (a) {
          if (a == null) {
            return "null";
          }

          var joiner = new java.util.StringJoiner(", ", "[", "]");

          for (var index167 = 0; index167 < a.length; index167++) {
            var element = a[index167];
            {
              joiner.add(
              /* valueOf */
              new String(element).toString());
            }
          }

          return joiner.toString();
        };

        Arrays.toString$float_A = function (a) {
          if (a == null) {
            return "null";
          }

          var joiner = new java.util.StringJoiner(", ", "[", "]");

          for (var index168 = 0; index168 < a.length; index168++) {
            var element = a[index168];
            {
              joiner.add(
              /* valueOf */
              new String(element).toString());
            }
          }

          return joiner.toString();
        };

        Arrays.toString$int_A = function (a) {
          if (a == null) {
            return "null";
          }

          var joiner = new java.util.StringJoiner(", ", "[", "]");

          for (var index169 = 0; index169 < a.length; index169++) {
            var element = a[index169];
            {
              joiner.add(
              /* valueOf */
              new String(element).toString());
            }
          }

          return joiner.toString();
        };

        Arrays.toString$long_A = function (a) {
          if (a == null) {
            return "null";
          }

          var joiner = new java.util.StringJoiner(", ", "[", "]");

          for (var index170 = 0; index170 < a.length; index170++) {
            var element = a[index170];
            {
              joiner.add(
              /* valueOf */
              new String(element).toString());
            }
          }

          return joiner.toString();
        };

        Arrays.toString$java_lang_Object_A = function (x) {
          if (x == null) {
            return "null";
          }

          return Arrays.asList.apply(null, x).toString();
        };

        Arrays.toString$short_A = function (a) {
          if (a == null) {
            return "null";
          }

          var joiner = new java.util.StringJoiner(", ", "[", "]");

          for (var index171 = 0; index171 < a.length; index171++) {
            var element = a[index171];
            {
              joiner.add(
              /* valueOf */
              new String(element).toString());
            }
          }

          return joiner.toString();
        };

        Arrays.deepToString$java_lang_Object_A$java_util_Set = function (a, arraysIveSeen) {
          if (a == null) {
            return "null";
          }

          if (!arraysIveSeen.add(a)) {
            return "[...]";
          }

          var joiner = new java.util.StringJoiner(", ", "[", "]");

          for (var index172 = 0; index172 < a.length; index172++) {
            var obj = a[index172];
            {
              if (obj != null && obj.constructor.isArray()) {
                if (obj != null && obj instanceof Array && (obj.length == 0 || obj[0] == null || obj[0] != null)) {
                  if (arraysIveSeen.contains(obj)) {
                    joiner.add("[...]");
                  } else {
                    var objArray = obj;
                    var tempSet = new java.util.HashSet(arraysIveSeen);
                    joiner.add(Arrays.deepToString$java_lang_Object_A$java_util_Set(objArray, tempSet));
                  }
                } else if (obj != null && obj instanceof Array && (obj.length == 0 || obj[0] == null || typeof obj[0] === 'boolean')) {
                  joiner.add(Arrays.toString$boolean_A(obj));
                } else if (obj != null && obj instanceof Array && (obj.length == 0 || obj[0] == null || typeof obj[0] === 'number')) {
                  joiner.add(Arrays.toString$byte_A(obj));
                } else if (obj != null && obj instanceof Array && (obj.length == 0 || obj[0] == null || typeof obj[0] === 'string')) {
                  joiner.add(Arrays.toString$char_A(obj));
                } else if (obj != null && obj instanceof Array && (obj.length == 0 || obj[0] == null || typeof obj[0] === 'number')) {
                  joiner.add(Arrays.toString$short_A(obj));
                } else if (obj != null && obj instanceof Array && (obj.length == 0 || obj[0] == null || typeof obj[0] === 'number')) {
                  joiner.add(Arrays.toString$int_A(obj));
                } else if (obj != null && obj instanceof Array && (obj.length == 0 || obj[0] == null || typeof obj[0] === 'number')) {
                  joiner.add(Arrays.toString$long_A(obj));
                } else if (obj != null && obj instanceof Array && (obj.length == 0 || obj[0] == null || typeof obj[0] === 'number')) {
                  joiner.add(Arrays.toString$float_A(obj));
                } else if (obj != null && obj instanceof Array && (obj.length == 0 || obj[0] == null || typeof obj[0] === 'number')) {
                  joiner.add(Arrays.toString$double_A(obj));
                } else ;
              } else {
                joiner.add(
                /* valueOf */
                new String(obj).toString());
              }
            }
          }

          return joiner.toString();
        };
        /**
        * Recursive helper function for {@link Arrays#deepToString(Object[])}.
        * @param {Array} a
        * @param {*} arraysIveSeen
        * @return {string}
        * @private
        */


        Arrays.deepToString = function (a, arraysIveSeen) {
          if ((a != null && a instanceof Array && (a.length == 0 || a[0] == null || a[0] != null) || a === null) && (arraysIveSeen != null && arraysIveSeen.constructor != null && arraysIveSeen.constructor["__interfaces"] != null && arraysIveSeen.constructor["__interfaces"].indexOf("java.util.Set") >= 0 || arraysIveSeen === null)) {
            return java.util.Arrays.deepToString$java_lang_Object_A$java_util_Set(a, arraysIveSeen);
          } else if ((a != null && a instanceof Array && (a.length == 0 || a[0] == null || a[0] != null) || a === null) && arraysIveSeen === undefined) {
            return java.util.Arrays.deepToString$java_lang_Object_A(a);
          } else throw new Error('invalid overload');
        };

        Arrays.getCopyLength = function (array, from, to) {
          javaemul.internal.InternalPreconditions.checkArgument(from <= to, "%s > %s", from, to);
          var len = javaemul.internal.ArrayHelper.getLength(array);
          to = Math.min(to, len);
          javaemul.internal.InternalPreconditions.checkCriticalPositionIndexes(from, to, len);
          return to - from;
        };
        /**
        * Sort a small subsection of an array by insertion sort.
        *
        * @param {Array} array array to sort
        * @param {number} low lower bound of range to sort
        * @param {number} high upper bound of range to sort
        * @param {*} comp comparator to use
        * @private
        */


        Arrays.insertionSort = function (array, low, high, comp) {
          for (var i = low + 1; i < high; ++i) {
            {
              for (var j = i; j > low && function (target) {
                return target['compare'] === undefined ? target : target['compare'];
              }(comp)(array[j - 1], array[j]) > 0; --j) {
                {
                  var t = array[j];
                  array[j] = array[j - 1];
                  array[j - 1] = t;
                }
              }
            }
          }
        };
        /**
        * Merge the two sorted subarrays (srcLow,srcMid] and (srcMid,srcHigh] into
        * dest.
        *
        * @param {Array} src source array for merge
        * @param {number} srcLow lower bound of bottom sorted half
        * @param {number} srcMid upper bound of bottom sorted half & lower bound of top sorted
        * half
        * @param {number} srcHigh upper bound of top sorted half
        * @param {Array} dest destination array for merge
        * @param {number} destLow lower bound of destination
        * @param {number} destHigh upper bound of destination
        * @param {*} comp comparator to use
        * @private
        */


        Arrays.merge = function (src, srcLow, srcMid, srcHigh, dest, destLow, destHigh, comp) {
          var topIdx = srcMid;

          while (destLow < destHigh) {
            {
              if (topIdx >= srcHigh || srcLow < srcMid && function (target) {
                return target['compare'] === undefined ? target : target['compare'];
              }(comp)(src[srcLow], src[topIdx]) <= 0) {
                dest[destLow++] = src[srcLow++];
              } else {
                dest[destLow++] = src[topIdx++];
              }
            }
          }
        };

        Arrays.mergeSort$java_lang_Object_A$int$int$java_util_Comparator = function (x, fromIndex, toIndex, comp) {
          if (comp == null) {
            comp = java.util.Comparators.natural();
          }

          var temp = Arrays.copyOfRange$java_lang_Object_A$int$int(x, fromIndex, toIndex);
          Arrays.mergeSort$java_lang_Object_A$java_lang_Object_A$int$int$int$java_util_Comparator(temp, x, fromIndex, toIndex, -fromIndex, comp);
        };

        Arrays.mergeSort$java_lang_Object_A$java_lang_Object_A$int$int$int$java_util_Comparator = function (temp, array, low, high, ofs, comp) {
          var length = high - low;

          if (length < 7) {
            Arrays.insertionSort(array, low, high, comp);
            return;
          }

          var tempLow = low + ofs;
          var tempHigh = high + ofs;
          var tempMid = tempLow + (tempHigh - tempLow >> 1);
          Arrays.mergeSort$java_lang_Object_A$java_lang_Object_A$int$int$int$java_util_Comparator(array, temp, tempLow, tempMid, -ofs, comp);
          Arrays.mergeSort$java_lang_Object_A$java_lang_Object_A$int$int$int$java_util_Comparator(array, temp, tempMid, tempHigh, -ofs, comp);

          if (function (target) {
            return target['compare'] === undefined ? target : target['compare'];
          }(comp)(temp[tempMid - 1], temp[tempMid]) <= 0) {
            while (low < high) {
              {
                array[low++] = temp[tempLow++];
              }
            }

            return;
          }

          Arrays.merge(temp, tempLow, tempMid, tempHigh, array, low, high, comp);
        };
        /**
        * Recursive helper function for
        * {@link Arrays#mergeSort(Object[], int, int, Comparator)}.
        *
        * @param {Array} temp temporary space, as large as the range of elements being
        * sorted. On entry, temp should contain a copy of the sort range
        * from array.
        * @param {Array} array array to sort
        * @param {number} low lower bound of range to sort
        * @param {number} high upper bound of range to sort
        * @param {number} ofs offset to convert an array index into a temp index
        * @param {*} comp comparison function
        * @private
        */


        Arrays.mergeSort = function (temp, array, low, high, ofs, comp) {
          if ((temp != null && temp instanceof Array && (temp.length == 0 || temp[0] == null || temp[0] != null) || temp === null) && (array != null && array instanceof Array && (array.length == 0 || array[0] == null || array[0] != null) || array === null) && (typeof low === 'number' || low === null) && (typeof high === 'number' || high === null) && (typeof ofs === 'number' || ofs === null) && (typeof comp === 'function' && comp.length === 2 || comp === null)) {
            return java.util.Arrays.mergeSort$java_lang_Object_A$java_lang_Object_A$int$int$int$java_util_Comparator(temp, array, low, high, ofs, comp);
          } else if ((temp != null && temp instanceof Array && (temp.length == 0 || temp[0] == null || temp[0] != null) || temp === null) && (typeof array === 'number' || array === null) && (typeof low === 'number' || low === null) && (typeof high === 'function' && high.length === 2 || high === null) && ofs === undefined && comp === undefined) {
            return java.util.Arrays.mergeSort$java_lang_Object_A$int$int$java_util_Comparator(temp, array, low, high);
          } else throw new Error('invalid overload');
        };

        Arrays.nativeLongSort$java_lang_Object$java_lang_Object = function (array, compareFunction) {
          array.sort(compareFunction);
        };

        Arrays.nativeLongSort$java_lang_Object$int$int = function (array, fromIndex, toIndex) {
          var temp = javaemul.internal.ArrayHelper.unsafeClone(array, fromIndex, toIndex);
          Arrays.nativeLongSort$java_lang_Object$java_lang_Object(temp, javaemul.internal.LongCompareHolder.getLongComparator());
          javaemul.internal.ArrayHelper.copy$java_lang_Object$int$java_lang_Object$int$int(temp, 0, array, fromIndex, toIndex - fromIndex);
        };
        /**
        * Sort a subset of an array of number primitives.
        * @param {*} array
        * @param {number} fromIndex
        * @param {number} toIndex
        * @private
        */


        Arrays.nativeLongSort = function (array, fromIndex, toIndex) {
          if ((array != null || array === null) && (typeof fromIndex === 'number' || fromIndex === null) && (typeof toIndex === 'number' || toIndex === null)) {
            return java.util.Arrays.nativeLongSort$java_lang_Object$int$int(array, fromIndex, toIndex);
          } else if ((array != null || array === null) && (fromIndex != null || fromIndex === null) && toIndex === undefined) {
            return java.util.Arrays.nativeLongSort$java_lang_Object$java_lang_Object(array, fromIndex);
          } else throw new Error('invalid overload');
        };

        Arrays.nativeNumberSort$java_lang_Object = function (array) {
          array.sort(function (a, b) {
            return a - b;
          });
        };

        Arrays.nativeNumberSort$java_lang_Object$int$int = function (array, fromIndex, toIndex) {
          var temp = javaemul.internal.ArrayHelper.unsafeClone(array, fromIndex, toIndex);
          Arrays.nativeNumberSort$java_lang_Object(temp);
          javaemul.internal.ArrayHelper.copy$java_lang_Object$int$java_lang_Object$int$int(temp, 0, array, fromIndex, toIndex - fromIndex);
        };
        /**
        * Sort a subset of an array of number primitives.
        * @param {*} array
        * @param {number} fromIndex
        * @param {number} toIndex
        * @private
        */


        Arrays.nativeNumberSort = function (array, fromIndex, toIndex) {
          if ((array != null || array === null) && (typeof fromIndex === 'number' || fromIndex === null) && (typeof toIndex === 'number' || toIndex === null)) {
            return java.util.Arrays.nativeNumberSort$java_lang_Object$int$int(array, fromIndex, toIndex);
          } else if ((array != null || array === null) && fromIndex === undefined && toIndex === undefined) {
            return java.util.Arrays.nativeNumberSort$java_lang_Object(array);
          } else throw new Error('invalid overload');
        };

        return Arrays;
      }();

      util.Arrays = Arrays;
      Arrays["__class"] = "java.util.Arrays";

      (function (Arrays) {
        var ArrayList =
        /** @class */
        function (_super) {
          __extends(ArrayList, _super);

          function ArrayList(array) {
            var _this = _super.call(this) || this;

            if (_this.array === undefined) {
              _this.array = null;
            }

            _this.array = array;
            return _this;
          }
          /**
          *
          * @param {*} o
          * @return {boolean}
          */


          ArrayList.prototype.contains = function (o) {
            return this.indexOf(o) !== -1;
          };
          /**
          *
          * @param {number} index
          * @return {*}
          */


          ArrayList.prototype.get = function (index) {
            javaemul.internal.InternalPreconditions.checkElementIndex(index, this.size());
            return this.array[index];
          };
          /**
          *
          * @param {number} index
          * @param {*} value
          * @return {*}
          */


          ArrayList.prototype.set = function (index, value) {
            var was = this.get(index);
            this.array[index] = value;
            return was;
          };
          /**
          *
          * @return {number}
          */


          ArrayList.prototype.size = function () {
            return this.array.length;
          };

          ArrayList.prototype.toArray$ = function () {
            return this.toArray$java_lang_Object_A(function (s) {
              var a = [];

              while (s-- > 0) {
                a.push(null);
              }

              return a;
            }(this.array.length));
          };

          ArrayList.prototype.toArray$java_lang_Object_A = function (out) {
            var size = this.size();

            if (out.length < size) {
              out = javaemul.internal.ArrayHelper.createFrom(out, size);
            }

            for (var i = 0; i < size; ++i) {
              {
                out[i] = this.array[i];
              }
            }

            if (out.length > size) {
              out[size] = null;
            }

            return out;
          };
          /**
          *
          * @param {Array} out
          * @return {Array}
          */


          ArrayList.prototype.toArray = function (out) {
            if (out != null && out instanceof Array && (out.length == 0 || out[0] == null || out[0] != null) || out === null) {
              return this.toArray$java_lang_Object_A(out);
            } else if (out === undefined) {
              return this.toArray$();
            } else throw new Error('invalid overload');
          };

          return ArrayList;
        }(java.util.AbstractList);

        Arrays.ArrayList = ArrayList;
        ArrayList["__class"] = "java.util.Arrays.ArrayList";
        ArrayList["__interfaces"] = ["java.util.RandomAccess", "java.util.List", "java.util.Collection", "java.lang.Iterable", "java.io.Serializable"];
      })(Arrays = util.Arrays || (util.Arrays = {}));
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * An unbounded priority queue based on a priority heap. <a
      * href="http://java.sun.com/j2se/1.5.0/docs/api/java/util/PriorityQueue.html">[Sun
      * docs]</a>
      *
      * @param <E> element type.
      * @param {number} initialCapacity
      * @param {*} cmp
      * @class
      * @extends java.util.AbstractQueue
      */
      var PriorityQueue =
      /** @class */
      function (_super) {
        __extends(PriorityQueue, _super);

        function PriorityQueue(initialCapacity, cmp) {
          var _this = this;

          if ((typeof initialCapacity === 'number' || initialCapacity === null) && (typeof cmp === 'function' && cmp.length === 2 || cmp === null)) {
            var __args = arguments;
            _this = _super.call(this) || this;

            if (_this.cmp === undefined) {
              _this.cmp = null;
            }

            if (_this.heap === undefined) {
              _this.heap = null;
            }

            _this.heap = new java.util.ArrayList(initialCapacity);

            if (cmp == null) {
              cmp = java.util.Comparators.natural();
            }

            _this.cmp = cmp;
          } else if ((typeof initialCapacity === 'function' && initialCapacity.length === 2 || initialCapacity === null) && cmp === undefined) {
            var __args = arguments;
            var cp = __args[0];
            {
              var initialCapacity_1 = PriorityQueue.INITIAL_CAPACITY;
              var cmp_1 = cp;
              _this = _super.call(this) || this;

              if (_this.cmp === undefined) {
                _this.cmp = null;
              }

              if (_this.heap === undefined) {
                _this.heap = null;
              }

              _this.heap = new java.util.ArrayList(initialCapacity_1);

              if (cmp_1 == null) {
                cmp_1 = java.util.Comparators.natural();
              }

              _this.cmp = cmp_1;
            }

            if (_this.cmp === undefined) {
              _this.cmp = null;
            }

            if (_this.heap === undefined) {
              _this.heap = null;
            }
          } else if ((initialCapacity != null && initialCapacity instanceof java.util.PriorityQueue || initialCapacity === null) && cmp === undefined) {
            var __args = arguments;
            var c_2 = __args[0];
            {
              var initialCapacity_2 = c_2.size();
              var cmp_2 = c_2.comparator();
              _this = _super.call(this) || this;

              if (_this.cmp === undefined) {
                _this.cmp = null;
              }

              if (_this.heap === undefined) {
                _this.heap = null;
              }

              _this.heap = new java.util.ArrayList(initialCapacity_2);

              if (cmp_2 == null) {
                cmp_2 = java.util.Comparators.natural();
              }

              _this.cmp = cmp_2;
            }

            if (_this.cmp === undefined) {
              _this.cmp = null;
            }

            if (_this.heap === undefined) {
              _this.heap = null;
            }

            (function () {
              _this.addAll(c_2);
            })();
          } else if ((initialCapacity != null && initialCapacity.constructor != null && initialCapacity.constructor["__interfaces"] != null && initialCapacity.constructor["__interfaces"].indexOf("java.util.SortedSet") >= 0 || initialCapacity === null) && cmp === undefined) {
            var __args = arguments;
            var c_3 = __args[0];
            {
              var initialCapacity_3 = c_3.size();
              var cmp_3 = c_3.comparator();
              _this = _super.call(this) || this;

              if (_this.cmp === undefined) {
                _this.cmp = null;
              }

              if (_this.heap === undefined) {
                _this.heap = null;
              }

              _this.heap = new java.util.ArrayList(initialCapacity_3);

              if (cmp_3 == null) {
                cmp_3 = java.util.Comparators.natural();
              }

              _this.cmp = cmp_3;
            }

            if (_this.cmp === undefined) {
              _this.cmp = null;
            }

            if (_this.heap === undefined) {
              _this.heap = null;
            }

            (function () {
              _this.addAll(c_3);
            })();
          } else if ((initialCapacity != null && initialCapacity.constructor != null && initialCapacity.constructor["__interfaces"] != null && initialCapacity.constructor["__interfaces"].indexOf("java.util.Collection") >= 0 || initialCapacity === null) && cmp === undefined) {
            var __args = arguments;
            var c_4 = __args[0];
            {
              var initialCapacity_4 = c_4.size();
              {
                var cmp_4 = null;
                _this = _super.call(this) || this;

                if (_this.cmp === undefined) {
                  _this.cmp = null;
                }

                if (_this.heap === undefined) {
                  _this.heap = null;
                }

                _this.heap = new java.util.ArrayList(initialCapacity_4);

                if (cmp_4 == null) {
                  cmp_4 = java.util.Comparators.natural();
                }

                _this.cmp = cmp_4;
              }

              if (_this.cmp === undefined) {
                _this.cmp = null;
              }

              if (_this.heap === undefined) {
                _this.heap = null;
              }
            }

            if (_this.cmp === undefined) {
              _this.cmp = null;
            }

            if (_this.heap === undefined) {
              _this.heap = null;
            }

            (function () {
              _this.addAll(c_4);
            })();
          } else if ((typeof initialCapacity === 'number' || initialCapacity === null) && cmp === undefined) {
            var __args = arguments;
            {
              var cmp_5 = null;
              _this = _super.call(this) || this;

              if (_this.cmp === undefined) {
                _this.cmp = null;
              }

              if (_this.heap === undefined) {
                _this.heap = null;
              }

              _this.heap = new java.util.ArrayList(initialCapacity);

              if (cmp_5 == null) {
                cmp_5 = java.util.Comparators.natural();
              }

              _this.cmp = cmp_5;
            }

            if (_this.cmp === undefined) {
              _this.cmp = null;
            }

            if (_this.heap === undefined) {
              _this.heap = null;
            }
          } else if (initialCapacity === undefined && cmp === undefined) {
            var __args = arguments;
            {
              var initialCapacity_5 = PriorityQueue.INITIAL_CAPACITY;
              {
                var cmp_6 = null;
                _this = _super.call(this) || this;

                if (_this.cmp === undefined) {
                  _this.cmp = null;
                }

                if (_this.heap === undefined) {
                  _this.heap = null;
                }

                _this.heap = new java.util.ArrayList(initialCapacity_5);

                if (cmp_6 == null) {
                  cmp_6 = java.util.Comparators.natural();
                }

                _this.cmp = cmp_6;
              }

              if (_this.cmp === undefined) {
                _this.cmp = null;
              }

              if (_this.heap === undefined) {
                _this.heap = null;
              }
            }

            if (_this.cmp === undefined) {
              _this.cmp = null;
            }

            if (_this.heap === undefined) {
              _this.heap = null;
            }
          } else throw new Error('invalid overload');

          return _this;
        }
        /*private*/


        PriorityQueue.getLeftChild = function (node) {
          return 2 * node + 1;
        };
        /*private*/


        PriorityQueue.getParent = function (node) {
          return (node - 1) / 2 | 0;
        };
        /*private*/


        PriorityQueue.getRightChild = function (node) {
          return 2 * node + 2;
        };
        /*private*/


        PriorityQueue.isLeaf = function (node, size) {
          return node * 2 + 1 >= size;
        };
        /**
        *
        * @param {*} c
        * @return {boolean}
        */


        PriorityQueue.prototype.addAll = function (c) {
          if (this.heap.addAll$java_util_Collection(c)) {
            this.makeHeap(0);
            return true;
          }

          return false;
        };
        /**
        *
        */


        PriorityQueue.prototype.clear = function () {
          this.heap.clear();
        };

        PriorityQueue.prototype.comparator = function () {
          return this.cmp === java.util.Comparators.natural() ? null : this.cmp;
        };
        /**
        *
        * @param {*} o
        * @return {boolean}
        */


        PriorityQueue.prototype.contains = function (o) {
          return this.heap.contains(o);
        };
        /**
        *
        * @param {*} c
        * @return {boolean}
        */


        PriorityQueue.prototype.containsAll = function (c) {
          return this.heap.containsAll(c);
        };
        /**
        *
        * @return {boolean}
        */


        PriorityQueue.prototype.isEmpty = function () {
          return this.heap.isEmpty();
        };
        /**
        *
        * @return {*}
        */


        PriorityQueue.prototype.iterator = function () {
          return java.util.Collections.unmodifiableList(this.heap).iterator();
        };
        /**
        *
        * @param {*} e
        * @return {boolean}
        */


        PriorityQueue.prototype.offer = function (e) {
          var node = this.heap.size();
          this.heap.add(e);

          while (node > 0) {
            {
              var childNode = node;
              node = PriorityQueue.getParent(node);

              if (function (target) {
                return target['compare'] === undefined ? target : target['compare'];
              }(this.cmp)(this.heap.get(node), e) <= 0) {
                this.heap.set(childNode, e);
                return true;
              }

              this.heap.set(childNode, this.heap.get(node));
            }
          }

          this.heap.set(node, e);
          return true;
        };
        /**
        *
        * @return {*}
        */


        PriorityQueue.prototype.peek = function () {
          if (this.heap.size() === 0) {
            return null;
          }

          return this.heap.get(0);
        };
        /**
        *
        * @return {*}
        */


        PriorityQueue.prototype.poll = function () {
          if (this.heap.size() === 0) {
            return null;
          }

          var value = this.heap.get(0);
          this.removeAtIndex(0);
          return value;
        };

        PriorityQueue.prototype.remove$java_lang_Object = function (o) {
          var index = this.heap.indexOf$java_lang_Object(o);

          if (index < 0) {
            return false;
          }

          this.removeAtIndex(index);
          return true;
        };
        /**
        *
        * @param {*} o
        * @return {boolean}
        */


        PriorityQueue.prototype.remove = function (o) {
          if (o != null || o === null) {
            return this.remove$java_lang_Object(o);
          } else if (o === undefined) {
            return this.remove$();
          } else throw new Error('invalid overload');
        };
        /**
        *
        * @param {*} c
        * @return {boolean}
        */


        PriorityQueue.prototype.removeAll = function (c) {
          if (this.heap.removeAll(c)) {
            this.makeHeap(0);
            return true;
          }

          return false;
        };
        /**
        *
        * @param {*} c
        * @return {boolean}
        */


        PriorityQueue.prototype.retainAll = function (c) {
          if (this.heap.retainAll(c)) {
            this.makeHeap(0);
            return true;
          }

          return false;
        };
        /**
        *
        * @return {number}
        */


        PriorityQueue.prototype.size = function () {
          return this.heap.size();
        };

        PriorityQueue.prototype.toArray$ = function () {
          return this.heap.toArray$();
        };

        PriorityQueue.prototype.toArray$java_lang_Object_A = function (a) {
          return this.heap.toArray$java_lang_Object_A(a);
        };
        /**
        *
        * @param {Array} a
        * @return {Array}
        */


        PriorityQueue.prototype.toArray = function (a) {
          if (a != null && a instanceof Array && (a.length == 0 || a[0] == null || a[0] != null) || a === null) {
            return this.toArray$java_lang_Object_A(a);
          } else if (a === undefined) {
            return this.toArray$();
          } else throw new Error('invalid overload');
        };
        /**
        *
        * @return {string}
        */


        PriorityQueue.prototype.toString = function () {
          return this.heap.toString();
        };
        /**
        * Make the subtree rooted at <code>node</code> a valid heap. O(n) time
        *
        * @param {number} node
        */


        PriorityQueue.prototype.makeHeap = function (node) {
          if (this.isLeaf(node)) {
            return;
          }

          this.makeHeap(PriorityQueue.getLeftChild(node));
          var rightChild = PriorityQueue.getRightChild(node);

          if (rightChild < this.heap.size()) {
            this.makeHeap(rightChild);
          }

          this.mergeHeaps(node);
        };
        /**
        * Merge two subheaps into a single heap. O(log n) time
        *
        * PRECONDITION: both children of <code>node</code> are heaps
        *
        * @param {number} node the parent of the two subtrees to merge
        */


        PriorityQueue.prototype.mergeHeaps = function (node) {
          var heapSize = this.heap.size();
          var value = this.heap.get(node);

          while (!PriorityQueue.isLeaf(node, heapSize)) {
            {
              var smallestChild = this.getSmallestChild(node, heapSize);

              if (function (target) {
                return target['compare'] === undefined ? target : target['compare'];
              }(this.cmp)(value, this.heap.get(smallestChild)) < 0) {
                break;
              }

              this.heap.set(node, this.heap.get(smallestChild));
              node = smallestChild;
            }
          }

          this.heap.set(node, value);
        };
        /*private*/


        PriorityQueue.prototype.getSmallestChild = function (node, heapSize) {
          var smallestChild;
          var leftChild = PriorityQueue.getLeftChild(node);
          var rightChild = leftChild + 1;
          smallestChild = leftChild;

          if (rightChild < heapSize && function (target) {
            return target['compare'] === undefined ? target : target['compare'];
          }(this.cmp)(this.heap.get(rightChild), this.heap.get(leftChild)) < 0) {
            smallestChild = rightChild;
          }

          return smallestChild;
        };
        /*private*/


        PriorityQueue.prototype.isLeaf = function (node) {
          return PriorityQueue.isLeaf(node, this.heap.size());
        };
        /*private*/


        PriorityQueue.prototype.removeAtIndex = function (index) {
          var lastValue = this.heap.remove$int(this.heap.size() - 1);

          if (index < this.heap.size()) {
            this.heap.set(index, lastValue);
            this.mergeHeaps(index);
          }
        };

        PriorityQueue.INITIAL_CAPACITY = 11;
        return PriorityQueue;
      }(java.util.AbstractQueue);

      util.PriorityQueue = PriorityQueue;
      PriorityQueue["__class"] = "java.util.PriorityQueue";
      PriorityQueue["__interfaces"] = ["java.util.Collection", "java.util.Queue", "java.lang.Iterable"];
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (io) {
      /**
      * @skip
      * @param {java.io.OutputStream} out
      * @class
      * @extends java.io.FilterOutputStream
      */
      var PrintStream =
      /** @class */
      function (_super) {
        __extends(PrintStream, _super);

        function PrintStream(out) {
          return _super.call(this, out) || this;
        }

        PrintStream.prototype.print$java_lang_String = function (s) {
          try {
            this.write$byte_A(
            /* getBytes */
            s.split('').map(function (s) {
              return s.charCodeAt(0);
            }));
          } catch (e) {
            console.error(e.message, e);
          }
        };

        PrintStream.prototype.print = function (s) {
          if (typeof s === 'string' || s === null) {
            return this.print$java_lang_String(s);
          } else if (s != null && s instanceof Array && (s.length == 0 || s[0] == null || typeof s[0] === 'string') || s === null) {
            return this.print$char_A(s);
          } else if (typeof s === 'boolean' || s === null) {
            return this.print$boolean(s);
          } else if (typeof s === 'string' || s === null) {
            return this.print$char(s);
          } else if (typeof s === 'number' || s === null) {
            return this.print$int(s);
          } else if (typeof s === 'number' || s === null) {
            return this.print$long(s);
          } else if (typeof s === 'number' || s === null) {
            return this.print$float(s);
          } else if (typeof s === 'number' || s === null) {
            return this.print$double(s);
          } else if (s != null || s === null) {
            return this.print$java_lang_Object(s);
          } else throw new Error('invalid overload');
        };

        PrintStream.prototype.println$java_lang_String = function (s) {
          this.print$java_lang_String(s + java.lang.System.lineSeparator());
        };

        PrintStream.prototype.println = function (s) {
          if (typeof s === 'string' || s === null) {
            return this.println$java_lang_String(s);
          } else if (s != null && s instanceof Array && (s.length == 0 || s[0] == null || typeof s[0] === 'string') || s === null) {
            return this.println$char_A(s);
          } else if (typeof s === 'boolean' || s === null) {
            return this.println$boolean(s);
          } else if (typeof s === 'string' || s === null) {
            return this.println$char(s);
          } else if (typeof s === 'number' || s === null) {
            return this.println$int(s);
          } else if (typeof s === 'number' || s === null) {
            return this.println$long(s);
          } else if (typeof s === 'number' || s === null) {
            return this.println$float(s);
          } else if (typeof s === 'number' || s === null) {
            return this.println$double(s);
          } else if (s != null || s === null) {
            return this.println$java_lang_Object(s);
          } else if (s === undefined) {
            return this.println$();
          } else throw new Error('invalid overload');
        };

        PrintStream.prototype.print$boolean = function (x) {
          this.print$java_lang_String(
          /* valueOf */
          new String(x).toString());
        };

        PrintStream.prototype.print$char = function (x) {
          this.print$java_lang_String(
          /* valueOf */
          new String(x).toString());
        };

        PrintStream.prototype.print$char_A = function (x) {
          this.println$java_lang_String(
          /* valueOf */
          new String(x).toString());
        };

        PrintStream.prototype.print$double = function (x) {
          this.print$java_lang_String(
          /* valueOf */
          new String(x).toString());
        };

        PrintStream.prototype.print$float = function (x) {
          this.print$java_lang_String(
          /* valueOf */
          new String(x).toString());
        };

        PrintStream.prototype.print$int = function (x) {
          this.print$java_lang_String(
          /* valueOf */
          new String(x).toString());
        };

        PrintStream.prototype.print$long = function (x) {
          this.print$java_lang_String(
          /* valueOf */
          new String(x).toString());
        };

        PrintStream.prototype.print$java_lang_Object = function (x) {
          this.print$java_lang_String(
          /* valueOf */
          new String(x).toString());
        };

        PrintStream.prototype.println$ = function () {
          this.println$java_lang_String("");
        };

        PrintStream.prototype.println$boolean = function (x) {
          this.println$java_lang_String(
          /* valueOf */
          new String(x).toString());
        };

        PrintStream.prototype.println$char = function (x) {
          this.println$java_lang_String(
          /* valueOf */
          new String(x).toString());
        };

        PrintStream.prototype.println$char_A = function (x) {
          this.println$java_lang_String(
          /* valueOf */
          new String(x).toString());
        };

        PrintStream.prototype.println$double = function (x) {
          this.println$java_lang_String(
          /* valueOf */
          new String(x).toString());
        };

        PrintStream.prototype.println$float = function (x) {
          this.println$java_lang_String(
          /* valueOf */
          new String(x).toString());
        };

        PrintStream.prototype.println$int = function (x) {
          this.println$java_lang_String(
          /* valueOf */
          new String(x).toString());
        };

        PrintStream.prototype.println$long = function (x) {
          this.println$java_lang_String(
          /* valueOf */
          new String(x).toString());
        };

        PrintStream.prototype.println$java_lang_Object = function (x) {
          this.println$java_lang_String(
          /* valueOf */
          new String(x).toString());
        };

        return PrintStream;
      }(java.io.FilterOutputStream);

      io.PrintStream = PrintStream;
      PrintStream["__class"] = "java.io.PrintStream";
      PrintStream["__interfaces"] = ["java.io.Closeable", "java.lang.AutoCloseable", "java.io.Flushable"];
    })(java.io || (java.io = {}));
  })(java || (java = {}));

  (function (java) {
    (function (security) {
      /**
      * A generic security exception type - <a
      * href="http://java.sun.com/j2se/1.4.2/docs/api/java/security/DigestException.html">[Sun's
      * docs]</a>.
      * @param {string} msg
      * @class
      * @extends java.security.GeneralSecurityException
      */
      var DigestException =
      /** @class */
      function (_super) {
        __extends(DigestException, _super);

        function DigestException(msg) {
          var _this = this;

          if (typeof msg === 'string' || msg === null) {
            _this = _super.call(this, msg) || this;
          } else if (msg === undefined) {
            _this = _super.call(this) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        return DigestException;
      }(java.security.GeneralSecurityException);

      security.DigestException = DigestException;
      DigestException["__class"] = "java.security.DigestException";
      DigestException["__interfaces"] = ["java.io.Serializable"];
    })(java.security || (java.security = {}));
  })(java || (java = {}));

  (function (java) {
    (function (security) {
      /**
      * A generic security exception type - <a
      * href="http://java.sun.com/j2se/1.4.2/docs/api/java/security/NoSuchAlgorithmException.html">[Sun's
      * docs]</a>.
      * @param {string} msg
      * @class
      * @extends java.security.GeneralSecurityException
      */
      var NoSuchAlgorithmException =
      /** @class */
      function (_super) {
        __extends(NoSuchAlgorithmException, _super);

        function NoSuchAlgorithmException(msg) {
          var _this = this;

          if (typeof msg === 'string' || msg === null) {
            _this = _super.call(this, msg) || this;
          } else if (msg === undefined) {
            _this = _super.call(this) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        return NoSuchAlgorithmException;
      }(java.security.GeneralSecurityException);

      security.NoSuchAlgorithmException = NoSuchAlgorithmException;
      NoSuchAlgorithmException["__class"] = "java.security.NoSuchAlgorithmException";
      NoSuchAlgorithmException["__interfaces"] = ["java.io.Serializable"];
    })(java.security || (java.security = {}));
  })(java || (java = {}));

  (function (java) {
    (function (io) {
      /**
      * A character encoding is not supported - <a
      * href="http://java.sun.com/javase/6/docs/api/java/io/UnsupportedEncodingException.html">[Sun's
      * docs]</a>.
      * @param {string} msg
      * @class
      * @extends java.io.IOException
      */
      var UnsupportedEncodingException =
      /** @class */
      function (_super) {
        __extends(UnsupportedEncodingException, _super);

        function UnsupportedEncodingException(msg) {
          var _this = this;

          if (typeof msg === 'string' || msg === null) {
            _this = _super.call(this, msg) || this;
          } else if (msg === undefined) {
            _this = _super.call(this) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        return UnsupportedEncodingException;
      }(java.io.IOException);

      io.UnsupportedEncodingException = UnsupportedEncodingException;
      UnsupportedEncodingException["__class"] = "java.io.UnsupportedEncodingException";
      UnsupportedEncodingException["__interfaces"] = ["java.io.Serializable"];
    })(java.io || (java.io = {}));
  })(java || (java = {}));

  (function (javaemul) {
    (function (internal) {
      (function (stream) {
        var StopException =
        /** @class */
        function (_super) {
          __extends(StopException, _super);

          function StopException() {
            var _this = _super.call(this) || this;

            Object.setPrototypeOf(_this, StopException.prototype);
            return _this;
          }

          return StopException;
        }(java.lang.RuntimeException);

        stream.StopException = StopException;
        StopException["__class"] = "javaemul.internal.stream.StopException";
        StopException["__interfaces"] = ["java.io.Serializable"];
      })(internal.stream || (internal.stream = {}));
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (java) {
    (function (util) {
      /**
      * See <a
      * href="http://java.sun.com/j2se/1.5.0/docs/api/java/util/MissingResourceException.html">the
      * official Java API doc</a> for details.
      * @param {string} s
      * @param {string} className
      * @param {string} key
      * @class
      * @extends java.lang.RuntimeException
      */
      var MissingResourceException =
      /** @class */
      function (_super) {
        __extends(MissingResourceException, _super);

        function MissingResourceException(s, className, key) {
          var _this = _super.call(this, s) || this;

          Object.setPrototypeOf(_this, MissingResourceException.prototype);

          if (_this.className === undefined) {
            _this.className = null;
          }

          if (_this.key === undefined) {
            _this.key = null;
          }

          _this.key = key;
          _this.className = className;
          return _this;
        }

        MissingResourceException.prototype.getClassName = function () {
          return this.className;
        };

        MissingResourceException.prototype.getKey = function () {
          return this.key;
        };

        return MissingResourceException;
      }(java.lang.RuntimeException);

      util.MissingResourceException = MissingResourceException;
      MissingResourceException["__class"] = "java.util.MissingResourceException";
      MissingResourceException["__interfaces"] = ["java.io.Serializable"];
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * See <a
      * href="http://java.sun.com/j2se/1.5.0/docs/api/java/util/ConcurrentModificationException.html">the
      * official Java API doc</a> for details.
      * @param {string} message
      * @class
      * @extends java.lang.RuntimeException
      */
      var ConcurrentModificationException =
      /** @class */
      function (_super) {
        __extends(ConcurrentModificationException, _super);

        function ConcurrentModificationException(message) {
          var _this = this;

          if (typeof message === 'string' || message === null) {
            _this = _super.call(this, message) || this;
          } else if (message === undefined) {
            _this = _super.call(this) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        return ConcurrentModificationException;
      }(java.lang.RuntimeException);

      util.ConcurrentModificationException = ConcurrentModificationException;
      ConcurrentModificationException["__class"] = "java.util.ConcurrentModificationException";
      ConcurrentModificationException["__interfaces"] = ["java.io.Serializable"];
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * See <a
      * href="http://java.sun.com/j2se/1.5.0/docs/api/java/util/NoSuchElementException.html">the
      * official Java API doc</a> for details.
      * @param {string} s
      * @class
      * @extends java.lang.RuntimeException
      */
      var NoSuchElementException =
      /** @class */
      function (_super) {
        __extends(NoSuchElementException, _super);

        function NoSuchElementException(s) {
          var _this = this;

          if (typeof s === 'string' || s === null) {
            _this = _super.call(this, s) || this;
          } else if (s === undefined) {
            _this = _super.call(this) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        return NoSuchElementException;
      }(java.lang.RuntimeException);

      util.NoSuchElementException = NoSuchElementException;
      NoSuchElementException["__class"] = "java.util.NoSuchElementException";
      NoSuchElementException["__interfaces"] = ["java.io.Serializable"];
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * See <a
      * href="http://java.sun.com/j2se/1.5.0/docs/api/java/util/EmptyStackException.html">the
      * official Java API doc</a> for details.
      * @class
      * @extends java.lang.RuntimeException
      */
      var EmptyStackException =
      /** @class */
      function (_super) {
        __extends(EmptyStackException, _super);

        function EmptyStackException() {
          var _this = _super.call(this) || this;

          Object.setPrototypeOf(_this, EmptyStackException.prototype);
          return _this;
        }

        return EmptyStackException;
      }(java.lang.RuntimeException);

      util.EmptyStackException = EmptyStackException;
      EmptyStackException["__class"] = "java.util.EmptyStackException";
      EmptyStackException["__interfaces"] = ["java.io.Serializable"];
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (io) {
      /**
      * See <a
      * href="https://docs.oracle.com/javase/8/docs/api/java/io/UncheckedIOException.html">the
      * official Java API doc</a> for details.
      * @param {string} message
      * @param {java.io.IOException} cause
      * @class
      * @extends java.lang.RuntimeException
      */
      var UncheckedIOException =
      /** @class */
      function (_super) {
        __extends(UncheckedIOException, _super);

        function UncheckedIOException(message, cause) {
          var _this = this;

          if ((typeof message === 'string' || message === null) && (cause != null && cause instanceof java.io.IOException || cause === null)) {
            var __args = arguments;
            _this = _super.call(this, message, javaemul.internal.InternalPreconditions.checkNotNull(cause)) || this;
          } else if ((message != null && message instanceof java.io.IOException || message === null) && cause === undefined) {
            var __args = arguments;
            var cause_7 = __args[0];
            _this = _super.call(this, javaemul.internal.InternalPreconditions.checkNotNull(cause_7)) || this;
          } else throw new Error('invalid overload');

          return _this;
        }
        /**
        *
        * @return {java.io.IOException}
        */


        UncheckedIOException.prototype.getCause = function () {
          return null;
        };

        return UncheckedIOException;
      }(java.lang.RuntimeException);

      io.UncheckedIOException = UncheckedIOException;
      UncheckedIOException["__class"] = "java.io.UncheckedIOException";
      UncheckedIOException["__interfaces"] = ["java.io.Serializable"];
    })(java.io || (java.io = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      /**
      * Indicates that an objet was in an invalid state during an attempted
      * operation.
      * @param {string} message
      * @param {java.lang.Throwable} cause
      * @class
      * @extends java.lang.RuntimeException
      */
      var IllegalStateException =
      /** @class */
      function (_super) {
        __extends(IllegalStateException, _super);

        function IllegalStateException(message, cause) {
          var _this = this;

          if ((typeof message === 'string' || message === null) && (cause != null && cause instanceof Error || cause === null)) {
            var __args = arguments;
            _this = _super.call(this, message, cause) || this;
          } else if ((typeof message === 'string' || message === null) && cause === undefined) {
            var __args = arguments;
            var s = __args[0];
            _this = _super.call(this, s) || this;
          } else if ((message != null && message instanceof Error || message === null) && cause === undefined) {
            var __args = arguments;
            var cause_8 = __args[0];
            _this = _super.call(this, cause_8) || this;
          } else if (message === undefined && cause === undefined) {
            var __args = arguments;
            _this = _super.call(this) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        return IllegalStateException;
      }(java.lang.RuntimeException);

      lang.IllegalStateException = IllegalStateException;
      IllegalStateException["__class"] = "java.lang.IllegalStateException";
      IllegalStateException["__interfaces"] = ["java.io.Serializable"];
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      /**
      * See <a
      * href="http://java.sun.com/j2se/1.5.0/docs/api/java/lang/NullPointerException.html">the
      * official Java API doc</a> for details.
      * @param {string} message
      * @class
      * @extends java.lang.RuntimeException
      */
      var NullPointerException =
      /** @class */
      function (_super) {
        __extends(NullPointerException, _super);

        function NullPointerException(message) {
          var _this = this;

          if (typeof message === 'string' || message === null) {
            _this = _super.call(this, message) || this;
          } else if (message === undefined) {
            _this = _super.call(this) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        NullPointerException.prototype.createError = function (msg) {
          return new TypeError(msg);
        };

        return NullPointerException;
      }(java.lang.RuntimeException);

      lang.NullPointerException = NullPointerException;
      NullPointerException["__class"] = "java.lang.NullPointerException";
      NullPointerException["__interfaces"] = ["java.io.Serializable"];
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      var IllegalAccessException =
      /** @class */
      function (_super) {
        __extends(IllegalAccessException, _super);

        function IllegalAccessException(message, cause) {
          var _this = this;

          if ((typeof message === 'string' || message === null) && (cause != null && cause instanceof Error || cause === null)) {
            var __args = arguments;
            _this = _super.call(this, message, cause) || this;
          } else if ((typeof message === 'string' || message === null) && cause === undefined) {
            var __args = arguments;
            var s = __args[0];
            _this = _super.call(this, s) || this;
          } else if ((message != null && message instanceof Error || message === null) && cause === undefined) {
            var __args = arguments;
            var cause_9 = __args[0];
            _this = _super.call(this, cause_9) || this;
          } else if (message === undefined && cause === undefined) {
            var __args = arguments;
            _this = _super.call(this) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        return IllegalAccessException;
      }(java.lang.RuntimeException);

      lang.IllegalAccessException = IllegalAccessException;
      IllegalAccessException["__class"] = "java.lang.IllegalAccessException";
      IllegalAccessException["__interfaces"] = ["java.io.Serializable"];
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      /**
      * See <a
      * href="http://java.sun.com/j2se/1.5.0/docs/api/java/lang/IllegalArgumentException.html">the
      * official Java API doc</a> for details.
      * @param {string} message
      * @param {java.lang.Throwable} cause
      * @class
      * @extends java.lang.RuntimeException
      */
      var IllegalArgumentException =
      /** @class */
      function (_super) {
        __extends(IllegalArgumentException, _super);

        function IllegalArgumentException(message, cause) {
          var _this = this;

          if ((typeof message === 'string' || message === null) && (cause != null && cause instanceof Error || cause === null)) {
            var __args = arguments;
            _this = _super.call(this, message, cause) || this;
          } else if ((typeof message === 'string' || message === null) && cause === undefined) {
            var __args = arguments;
            _this = _super.call(this, message) || this;
          } else if ((message != null && message instanceof Error || message === null) && cause === undefined) {
            var __args = arguments;
            var cause_10 = __args[0];
            _this = _super.call(this, cause_10) || this;
          } else if (message === undefined && cause === undefined) {
            var __args = arguments;
            _this = _super.call(this) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        return IllegalArgumentException;
      }(java.lang.RuntimeException);

      lang.IllegalArgumentException = IllegalArgumentException;
      IllegalArgumentException["__class"] = "java.lang.IllegalArgumentException";
      IllegalArgumentException["__interfaces"] = ["java.io.Serializable"];
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      (function (annotation) {
        /**
        * Indicates an attempt to access an element of an annotation that has changed
        * since it was compiled or serialized <a
        * href="http://java.sun.com/j2se/1.5.0/docs/api/java/lang/annotation/AnnotationTypeMismatchException.html">[Sun
        * docs]</a>.
        * @class
        * @extends java.lang.RuntimeException
        */
        var AnnotationTypeMismatchException =
        /** @class */
        function (_super) {
          __extends(AnnotationTypeMismatchException, _super);

          function AnnotationTypeMismatchException() {
            var _this = _super.call(this) || this;

            Object.setPrototypeOf(_this, AnnotationTypeMismatchException.prototype);
            return _this;
          }

          return AnnotationTypeMismatchException;
        }(java.lang.RuntimeException);

        annotation.AnnotationTypeMismatchException = AnnotationTypeMismatchException;
        AnnotationTypeMismatchException["__class"] = "java.lang.annotation.AnnotationTypeMismatchException";
        AnnotationTypeMismatchException["__interfaces"] = ["java.io.Serializable"];
      })(lang.annotation || (lang.annotation = {}));
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      (function (annotation) {
        /**
        * Indicates an attempt to access an element of an annotation that was added
        * since it was compiled or serialized <a
        * href="http://java.sun.com/j2se/1.5.0/docs/api/java/lang/annotation/IncompleteAnnotationException.html">[Sun
        * docs]</a>.
        * @param {java.lang.Class} annotationType
        * @param {string} elementName
        * @class
        * @extends java.lang.RuntimeException
        */
        var IncompleteAnnotationException =
        /** @class */
        function (_super) {
          __extends(IncompleteAnnotationException, _super);

          function IncompleteAnnotationException(annotationType, elementName) {
            var _this = _super.call(this, "Incomplete annotation: trying to access " + elementName + " on " + annotationType) || this;

            Object.setPrototypeOf(_this, IncompleteAnnotationException.prototype);

            if (_this.__annotationType === undefined) {
              _this.__annotationType = null;
            }

            if (_this.__elementName === undefined) {
              _this.__elementName = null;
            }

            _this.__annotationType = annotationType;
            _this.__elementName = elementName;
            return _this;
          }

          IncompleteAnnotationException.prototype.annotationType = function () {
            return this.__annotationType;
          };

          IncompleteAnnotationException.prototype.elementName = function () {
            return this.__elementName;
          };

          return IncompleteAnnotationException;
        }(java.lang.RuntimeException);

        annotation.IncompleteAnnotationException = IncompleteAnnotationException;
        IncompleteAnnotationException["__class"] = "java.lang.annotation.IncompleteAnnotationException";
        IncompleteAnnotationException["__interfaces"] = ["java.io.Serializable"];
      })(lang.annotation || (lang.annotation = {}));
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      /**
      * Indicates failure to cast one type into another.
      * @param {string} message
      * @class
      * @extends java.lang.RuntimeException
      */
      var ClassCastException =
      /** @class */
      function (_super) {
        __extends(ClassCastException, _super);

        function ClassCastException(message) {
          var _this = this;

          if (typeof message === 'string' || message === null) {
            _this = _super.call(this, message) || this;
          } else if (message === undefined) {
            _this = _super.call(this) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        return ClassCastException;
      }(java.lang.RuntimeException);

      lang.ClassCastException = ClassCastException;
      ClassCastException["__class"] = "java.lang.ClassCastException";
      ClassCastException["__interfaces"] = ["java.io.Serializable"];
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      /**
      * See <a
      * href="http://java.sun.com/j2se/1.5.0/docs/api/java/lang/NegativeArraySizeException.html">the
      * official Java API doc</a> for details.
      * @param {string} message
      * @class
      * @extends java.lang.RuntimeException
      */
      var NegativeArraySizeException =
      /** @class */
      function (_super) {
        __extends(NegativeArraySizeException, _super);

        function NegativeArraySizeException(message) {
          var _this = this;

          if (typeof message === 'string' || message === null) {
            _this = _super.call(this, message) || this;
          } else if (message === undefined) {
            _this = _super.call(this) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        return NegativeArraySizeException;
      }(java.lang.RuntimeException);

      lang.NegativeArraySizeException = NegativeArraySizeException;
      NegativeArraySizeException["__class"] = "java.lang.NegativeArraySizeException";
      NegativeArraySizeException["__interfaces"] = ["java.io.Serializable"];
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      /**
      * See <a
      * href="http://java.sun.com/j2se/1.5.0/docs/api/java/lang/ArrayStoreException.html">the
      * official Java API doc</a> for details.
      * @param {string} message
      * @class
      * @extends java.lang.RuntimeException
      */
      var ArrayStoreException =
      /** @class */
      function (_super) {
        __extends(ArrayStoreException, _super);

        function ArrayStoreException(message) {
          var _this = this;

          if (typeof message === 'string' || message === null) {
            _this = _super.call(this, message) || this;
          } else if (message === undefined) {
            _this = _super.call(this) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        return ArrayStoreException;
      }(java.lang.RuntimeException);

      lang.ArrayStoreException = ArrayStoreException;
      ArrayStoreException["__class"] = "java.lang.ArrayStoreException";
      ArrayStoreException["__interfaces"] = ["java.io.Serializable"];
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      /**
      * NOTE: in GWT this is only thrown for division by zero on longs and
      * BigInteger/BigDecimal.
      * <p>
      * See <a
      * href="http://java.sun.com/j2se/1.5.0/docs/api/java/lang/ArithmeticException.html">the
      * official Java API doc</a> for details.
      * @param {string} explanation
      * @class
      * @extends java.lang.RuntimeException
      */
      var ArithmeticException =
      /** @class */
      function (_super) {
        __extends(ArithmeticException, _super);

        function ArithmeticException(explanation) {
          var _this = this;

          if (typeof explanation === 'string' || explanation === null) {
            _this = _super.call(this, explanation) || this;
          } else if (explanation === undefined) {
            _this = _super.call(this) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        return ArithmeticException;
      }(java.lang.RuntimeException);

      lang.ArithmeticException = ArithmeticException;
      ArithmeticException["__class"] = "java.lang.ArithmeticException";
      ArithmeticException["__interfaces"] = ["java.io.Serializable"];
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      /**
      * See <a
      * href="http://java.sun.com/j2se/1.5.0/docs/api/java/lang/UnsupportedOperationException.html">the
      * official Java API doc</a> for details.
      * @param {string} message
      * @param {java.lang.Throwable} cause
      * @class
      * @extends java.lang.RuntimeException
      */
      var UnsupportedOperationException =
      /** @class */
      function (_super) {
        __extends(UnsupportedOperationException, _super);

        function UnsupportedOperationException(message, cause) {
          var _this = this;

          if ((typeof message === 'string' || message === null) && (cause != null && cause instanceof Error || cause === null)) {
            var __args = arguments;
            _this = _super.call(this, message, cause) || this;
          } else if ((typeof message === 'string' || message === null) && cause === undefined) {
            var __args = arguments;
            _this = _super.call(this, message) || this;
          } else if ((message != null && message instanceof Error || message === null) && cause === undefined) {
            var __args = arguments;
            var cause_11 = __args[0];
            _this = _super.call(this, cause_11) || this;
          } else if (message === undefined && cause === undefined) {
            var __args = arguments;
            _this = _super.call(this) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        return UnsupportedOperationException;
      }(java.lang.RuntimeException);

      lang.UnsupportedOperationException = UnsupportedOperationException;
      UnsupportedOperationException["__class"] = "java.lang.UnsupportedOperationException";
      UnsupportedOperationException["__interfaces"] = ["java.io.Serializable"];
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      /**
      * See <a
      * href="http://java.sun.com/j2se/1.5.0/docs/api/java/lang/IndexOutOfBoundsException.html">the
      * official Java API doc</a> for details.
      * @param {string} message
      * @class
      * @extends java.lang.RuntimeException
      */
      var IndexOutOfBoundsException =
      /** @class */
      function (_super) {
        __extends(IndexOutOfBoundsException, _super);

        function IndexOutOfBoundsException(message) {
          var _this = this;

          if (typeof message === 'string' || message === null) {
            _this = _super.call(this, message) || this;
          } else if (message === undefined) {
            _this = _super.call(this) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        return IndexOutOfBoundsException;
      }(java.lang.RuntimeException);

      lang.IndexOutOfBoundsException = IndexOutOfBoundsException;
      IndexOutOfBoundsException["__class"] = "java.lang.IndexOutOfBoundsException";
      IndexOutOfBoundsException["__interfaces"] = ["java.io.Serializable"];
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (nio) {
      var BufferUnderflowException =
      /** @class */
      function (_super) {
        __extends(BufferUnderflowException, _super);

        function BufferUnderflowException() {
          var _this = _super.call(this) || this;

          Object.setPrototypeOf(_this, BufferUnderflowException.prototype);
          return _this;
        }

        return BufferUnderflowException;
      }(java.lang.RuntimeException);

      nio.BufferUnderflowException = BufferUnderflowException;
      BufferUnderflowException["__class"] = "java.nio.BufferUnderflowException";
      BufferUnderflowException["__interfaces"] = ["java.io.Serializable"];
    })(java.nio || (java.nio = {}));
  })(java || (java = {}));

  (function (java) {
    (function (nio) {
      var BufferOverflowException =
      /** @class */
      function (_super) {
        __extends(BufferOverflowException, _super);

        function BufferOverflowException() {
          var _this = _super.call(this) || this;

          Object.setPrototypeOf(_this, BufferOverflowException.prototype);
          return _this;
        }

        return BufferOverflowException;
      }(java.lang.RuntimeException);

      nio.BufferOverflowException = BufferOverflowException;
      BufferOverflowException["__class"] = "java.nio.BufferOverflowException";
      BufferOverflowException["__interfaces"] = ["java.io.Serializable"];
    })(java.nio || (java.nio = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      var InstantiationException =
      /** @class */
      function (_super) {
        __extends(InstantiationException, _super);

        function InstantiationException(s) {
          var _this = this;

          if (typeof s === 'string' || s === null) {
            _this = _super.call(this, s) || this;
          } else if (s === undefined) {
            _this = _super.call(this) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        return InstantiationException;
      }(java.lang.ReflectiveOperationException);

      lang.InstantiationException = InstantiationException;
      InstantiationException["__class"] = "java.lang.InstantiationException";
      InstantiationException["__interfaces"] = ["java.io.Serializable"];
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (nio) {
      (function (charset) {
        /**
        * Constant definitions for the standard Charsets.
        * @class
        */
        var StandardCharsets =
        /** @class */
        function () {
          function StandardCharsets() {}

          StandardCharsets.ISO_8859_1_$LI$ = function () {
            if (StandardCharsets.ISO_8859_1 == null) {
              StandardCharsets.ISO_8859_1 = javaemul.internal.EmulatedCharset.ISO_8859_1_$LI$();
            }

            return StandardCharsets.ISO_8859_1;
          };

          StandardCharsets.UTF_8_$LI$ = function () {
            if (StandardCharsets.UTF_8 == null) {
              StandardCharsets.UTF_8 = javaemul.internal.EmulatedCharset.UTF_8_$LI$();
            }

            return StandardCharsets.UTF_8;
          };

          return StandardCharsets;
        }();

        charset.StandardCharsets = StandardCharsets;
        StandardCharsets["__class"] = "java.nio.charset.StandardCharsets";
      })(nio.charset || (nio.charset = {}));
    })(java.nio || (java.nio = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * Implementation of Map interface based on a hash table.
      * <a href="http://java.sun.com/j2se/1.5.0/docs/api/java/util/HashMap.html">[Sun
      * docs]</a>
      *
      * @param <K>
      * key type
      * @param <V>
      * value type
      * @param {number} ignored
      * @param {number} alsoIgnored
      * @class
      * @extends java.util.AbstractMap
      */
      var AbstractHashMap =
      /** @class */
      function (_super) {
        __extends(AbstractHashMap, _super);

        function AbstractHashMap(ignored, alsoIgnored) {
          var _this = this;

          if ((typeof ignored === 'number' || ignored === null) && (typeof alsoIgnored === 'number' || alsoIgnored === null)) {
            var __args = arguments;
            _this = _super.call(this) || this;

            if (_this.hashCodeMap === undefined) {
              _this.hashCodeMap = null;
            }

            if (_this.stringMap === undefined) {
              _this.stringMap = null;
            }

            javaemul.internal.InternalPreconditions.checkArgument(ignored >= 0, "Negative initial capacity");
            javaemul.internal.InternalPreconditions.checkArgument(alsoIgnored >= 0, "Non-positive load factor");

            _this.reset();
          } else if ((ignored != null && ignored.constructor != null && ignored.constructor["__interfaces"] != null && ignored.constructor["__interfaces"].indexOf("java.util.Map") >= 0 || ignored === null) && alsoIgnored === undefined) {
            var __args = arguments;
            var toBeCopied = __args[0];
            _this = _super.call(this) || this;

            if (_this.hashCodeMap === undefined) {
              _this.hashCodeMap = null;
            }

            if (_this.stringMap === undefined) {
              _this.stringMap = null;
            }

            _this.reset();

            _this.putAll(toBeCopied);
          } else if ((typeof ignored === 'number' || ignored === null) && alsoIgnored === undefined) {
            var __args = arguments;
            {
              var alsoIgnored_1 = 0;
              _this = _super.call(this) || this;

              if (_this.hashCodeMap === undefined) {
                _this.hashCodeMap = null;
              }

              if (_this.stringMap === undefined) {
                _this.stringMap = null;
              }

              javaemul.internal.InternalPreconditions.checkArgument(ignored >= 0, "Negative initial capacity");
              javaemul.internal.InternalPreconditions.checkArgument(alsoIgnored_1 >= 0, "Non-positive load factor");

              _this.reset();
            }

            if (_this.hashCodeMap === undefined) {
              _this.hashCodeMap = null;
            }

            if (_this.stringMap === undefined) {
              _this.stringMap = null;
            }
          } else if (ignored === undefined && alsoIgnored === undefined) {
            var __args = arguments;
            _this = _super.call(this) || this;

            if (_this.hashCodeMap === undefined) {
              _this.hashCodeMap = null;
            }

            if (_this.stringMap === undefined) {
              _this.stringMap = null;
            }

            _this.reset();
          } else throw new Error('invalid overload');

          return _this;
        }
        /**
        *
        */


        AbstractHashMap.prototype.clear = function () {
          this.reset();
        };

        AbstractHashMap.prototype.reset = function () {
          this.hashCodeMap = new java.util.InternalHashCodeMap(this);
          this.stringMap = new java.util.InternalStringMap(this);
          java.util.ConcurrentModificationDetector.structureChanged(this);
        };
        /**
        *
        * @param {*} key
        * @return {boolean}
        */


        AbstractHashMap.prototype.containsKey = function (key) {
          return typeof key === 'string' ? this.hasStringValue(javaemul.internal.JsUtils.unsafeCastToString(key)) : this.hasHashValue(key);
        };
        /**
        *
        * @param {*} value
        * @return {boolean}
        */


        AbstractHashMap.prototype.containsValue = function (value) {
          return this._containsValue(value, this.stringMap) || this._containsValue(value, this.hashCodeMap);
        };

        AbstractHashMap.prototype._containsValue = function (value, entries) {
          for (var index173 = entries.iterator(); index173.hasNext();) {
            var entry = index173.next();
            {
              if (this._equals(value, entry.getValue())) {
                return true;
              }
            }
          }

          return false;
        };
        /**
        *
        * @return {*}
        */


        AbstractHashMap.prototype.entrySet = function () {
          return new AbstractHashMap.EntrySet(this);
        };
        /**
        *
        * @param {*} key
        * @return {*}
        */


        AbstractHashMap.prototype.get = function (key) {
          var v = typeof key === 'string' ? this.getStringValue(javaemul.internal.JsUtils.unsafeCastToString(key)) : this.getHashValue(key);
          return v === undefined ? null : v;
        };
        /**
        *
        * @param {*} key
        * @param {*} value
        * @return {*}
        */


        AbstractHashMap.prototype.put = function (key, value) {
          return typeof key === 'string' ? this.putStringValue(javaemul.internal.JsUtils.unsafeCastToString(key), value) : this.putHashValue(key, value);
        };
        /**
        *
        * @param {*} key
        * @return {*}
        */


        AbstractHashMap.prototype.remove = function (key) {
          return typeof key === 'string' ? this.removeStringValue(javaemul.internal.JsUtils.unsafeCastToString(key)) : this.removeHashValue(key);
        };
        /**
        *
        * @return {number}
        */


        AbstractHashMap.prototype.size = function () {
          return this.hashCodeMap.size() + this.stringMap.getSize();
        };
        /**
        * Returns the Map.Entry whose key is Object equal to <code>key</code>,
        * provided that <code>key</code>'s hash code is <code>hashCode</code>; or
        * <code>null</code> if no such Map.Entry exists at the specified hashCode.
        * @param {*} key
        * @return {*}
        * @private
        */


        AbstractHashMap.prototype.getHashValue = function (key) {
          return util.AbstractMap.getEntryValueOrNull(this.hashCodeMap.getEntry(key));
        };
        /**
        * Returns the value for the given key in the stringMap. Returns
        * <code>null</code> if the specified key does not exist.
        * @param {string} key
        * @return {*}
        * @private
        */


        AbstractHashMap.prototype.getStringValue = function (key) {
          return key == null ? this.getHashValue(null) : this.stringMap.get(key);
        };
        /**
        * Returns true if the a key exists in the hashCodeMap that is Object equal
        * to <code>key</code>, provided that <code>key</code>'s hash code is
        * <code>hashCode</code>.
        * @param {*} key
        * @return {boolean}
        * @private
        */


        AbstractHashMap.prototype.hasHashValue = function (key) {
          return this.hashCodeMap.getEntry(key) != null;
        };
        /**
        * Returns true if the given key exists in the stringMap.
        * @param {string} key
        * @return {boolean}
        * @private
        */


        AbstractHashMap.prototype.hasStringValue = function (key) {
          return key == null ? this.hasHashValue(null) : this.stringMap.contains(key);
        };
        /**
        * Sets the specified key to the specified value in the hashCodeMap. Returns
        * the value previously at that key. Returns <code>null</code> if the
        * specified key did not exist.
        * @param {*} key
        * @param {*} value
        * @return {*}
        * @private
        */


        AbstractHashMap.prototype.putHashValue = function (key, value) {
          return this.hashCodeMap.put(key, value);
        };
        /**
        * Sets the specified key to the specified value in the stringMap. Returns
        * the value previously at that key. Returns <code>null</code> if the
        * specified key did not exist.
        * @param {string} key
        * @param {*} value
        * @return {*}
        * @private
        */


        AbstractHashMap.prototype.putStringValue = function (key, value) {
          return key == null ? this.putHashValue(null, value) : this.stringMap.put(key, value);
        };
        /**
        * Removes the pair whose key is Object equal to <code>key</code> from
        * <code>hashCodeMap</code>, provided that <code>key</code>'s hash code is
        * <code>hashCode</code>. Returns the value that was associated with the
        * removed key, or null if no such key existed.
        * @param {*} key
        * @return {*}
        * @private
        */


        AbstractHashMap.prototype.removeHashValue = function (key) {
          return this.hashCodeMap.remove(key);
        };
        /**
        * Removes the specified key from the stringMap and returns the value that
        * was previously there. Returns <code>null</code> if the specified key does
        * not exist.
        * @param {string} key
        * @return {*}
        * @private
        */


        AbstractHashMap.prototype.removeStringValue = function (key) {
          return key == null ? this.removeHashValue(null) : this.stringMap.remove(key);
        };

        return AbstractHashMap;
      }(java.util.AbstractMap);

      util.AbstractHashMap = AbstractHashMap;
      AbstractHashMap["__class"] = "java.util.AbstractHashMap";
      AbstractHashMap["__interfaces"] = ["java.util.Map"];

      (function (AbstractHashMap) {
        var EntrySet =
        /** @class */
        function (_super) {
          __extends(EntrySet, _super);

          function EntrySet(__parent) {
            var _this = _super.call(this) || this;

            _this.__parent = __parent;
            return _this;
          }
          /**
          *
          */


          EntrySet.prototype.clear = function () {
            this.clear();
          };
          /**
          *
          * @param {*} o
          * @return {boolean}
          */


          EntrySet.prototype.contains = function (o) {
            if (o != null && o.constructor != null && o.constructor["__interfaces"] != null && o.constructor["__interfaces"].indexOf("java.util.Map.Entry") >= 0) {
              return this.__parent.containsEntry(o);
            }

            return false;
          };
          /**
          *
          * @return {*}
          */


          EntrySet.prototype.iterator = function () {
            return new AbstractHashMap.EntrySetIterator(this.__parent);
          };
          /**
          *
          * @param {*} entry
          * @return {boolean}
          */


          EntrySet.prototype.remove = function (entry) {
            if (this.contains(entry)) {
              var key = entry.getKey();
              this.remove(key);
              return true;
            }

            return false;
          };
          /**
          *
          * @return {number}
          */


          EntrySet.prototype.size = function () {
            return this.size();
          };

          return EntrySet;
        }(java.util.AbstractSet);

        AbstractHashMap.EntrySet = EntrySet;
        EntrySet["__class"] = "java.util.AbstractHashMap.EntrySet";
        EntrySet["__interfaces"] = ["java.util.Collection", "java.util.Set", "java.lang.Iterable"];
        /**
        * Iterator for <code>EntrySet</code>.
        * @class
        */

        var EntrySetIterator =
        /** @class */
        function () {
          function EntrySetIterator(__parent) {
            this.__parent = __parent;

            if (this.stringMapEntries === undefined) {
              this.stringMapEntries = null;
            }

            if (this.current === undefined) {
              this.current = null;
            }

            if (this.last === undefined) {
              this.last = null;
            }

            if (this.__hasNext === undefined) {
              this.__hasNext = false;
            }

            this.stringMapEntries = __parent.stringMap.iterator();
            this.current = this.stringMapEntries;
            this.__hasNext = this.computeHasNext();
            java.util.ConcurrentModificationDetector.recordLastKnownStructure(__parent, this);
          }
          /* Default method injected from java.util.Iterator */


          EntrySetIterator.prototype.forEachRemaining = function (consumer) {
            var _this = this;

            javaemul.internal.InternalPreconditions.checkNotNull(consumer);

            while (this.hasNext()) {
              {
                (function (target) {
                  return typeof target === 'function' ? target(_this.next()) : target.accept(_this.next());
                })(consumer);
              }
            }
          };
          /**
          *
          * @return {boolean}
          */


          EntrySetIterator.prototype.hasNext = function () {
            return this.__hasNext;
          };

          EntrySetIterator.prototype.computeHasNext = function () {
            if (this.current.hasNext()) {
              return true;
            }

            if (this.current !== this.stringMapEntries) {
              return false;
            }

            this.current = this.__parent.hashCodeMap.iterator();
            return this.current.hasNext();
          };
          /**
          *
          * @return {*}
          */


          EntrySetIterator.prototype.next = function () {
            java.util.ConcurrentModificationDetector.checkStructuralChange(this.__parent, this);
            javaemul.internal.InternalPreconditions.checkElement(this.hasNext());
            this.last = this.current;
            var rv = this.current.next();
            this.__hasNext = this.computeHasNext();
            return rv;
          };
          /**
          *
          */


          EntrySetIterator.prototype.remove = function () {
            javaemul.internal.InternalPreconditions.checkState(this.last != null);
            java.util.ConcurrentModificationDetector.checkStructuralChange(this.__parent, this);
            this.last.remove();
            this.last = null;
            this.__hasNext = this.computeHasNext();
            java.util.ConcurrentModificationDetector.recordLastKnownStructure(this.__parent, this);
          };

          return EntrySetIterator;
        }();

        AbstractHashMap.EntrySetIterator = EntrySetIterator;
        EntrySetIterator["__class"] = "java.util.AbstractHashMap.EntrySetIterator";
        EntrySetIterator["__interfaces"] = ["java.util.Iterator"];
      })(AbstractHashMap = util.AbstractHashMap || (util.AbstractHashMap = {}));
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * A {@link java.util.Map} of {@link Enum}s. <a
      * href="http://java.sun.com/j2se/1.5.0/docs/api/java/util/EnumMap.html">[Sun
      * docs]</a>
      *
      * @param <K> key type
      * @param <V> value type
      * @param {java.lang.Class} type
      * @class
      * @extends java.util.AbstractMap
      */
      var EnumMap =
      /** @class */
      function (_super) {
        __extends(EnumMap, _super);

        function EnumMap(type) {
          var _this = this;

          if (type != null && (type["__class"] != null || function (t) {
            try {
              new t();
              return true;
            } catch (_a) {
              return false;
            }
          }(type)) || type === null) {
            var __args = arguments;
            _this = _super.call(this) || this;

            if (_this.__keySet === undefined) {
              _this.__keySet = null;
            }

            if (_this.__values === undefined) {
              _this.__values = null;
            }

            _this.init$java_lang_Class(type);
          } else if (type != null && type instanceof java.util.EnumMap || type === null) {
            var __args = arguments;
            var m = __args[0];
            _this = _super.call(this) || this;

            if (_this.__keySet === undefined) {
              _this.__keySet = null;
            }

            if (_this.__values === undefined) {
              _this.__values = null;
            }

            _this.init$java_util_EnumMap(m);
          } else if (type != null && type.constructor != null && type.constructor["__interfaces"] != null && type.constructor["__interfaces"].indexOf("java.util.Map") >= 0 || type === null) {
            var __args = arguments;
            var m = __args[0];
            _this = _super.call(this) || this;

            if (_this.__keySet === undefined) {
              _this.__keySet = null;
            }

            if (_this.__values === undefined) {
              _this.__values = null;
            }

            if (m != null && m instanceof java.util.EnumMap) {
              _this.init$java_util_EnumMap(m);
            } else {
              javaemul.internal.InternalPreconditions.checkArgument(!m.isEmpty(), "Specified map is empty");

              _this.init$java_lang_Class(m.keySet().iterator().next().getDeclaringClass());

              _this.putAll(m);
            }
          } else throw new Error('invalid overload');

          return _this;
        }
        /**
        *
        */


        EnumMap.prototype.clear = function () {
          this.__keySet.clear();

          this.__values = function (s) {
            var a = [];

            while (s-- > 0) {
              a.push(null);
            }

            return a;
          }(this.__values.length);
        };

        EnumMap.prototype.clone = function () {
          return new EnumMap(this);
        };
        /**
        *
        * @param {*} key
        * @return {boolean}
        */


        EnumMap.prototype.containsKey = function (key) {
          return this.__keySet.contains(key);
        };
        /**
        *
        * @param {*} value
        * @return {boolean}
        */


        EnumMap.prototype.containsValue = function (value) {
          for (var index174 = this.__keySet.iterator(); index174.hasNext();) {
            var key = index174.next();
            {
              if (java.util.Objects.equals(value, this.__values[key.ordinal()])) {
                return true;
              }
            }
          }

          return false;
        };
        /**
        *
        * @return {*}
        */


        EnumMap.prototype.entrySet = function () {
          return new EnumMap.EntrySet(this);
        };
        /**
        *
        * @param {*} k
        * @return {*}
        */


        EnumMap.prototype.get = function (k) {
          return this.__keySet.contains(k) ? this.__values[this.asOrdinal(k)] : null;
        };

        EnumMap.prototype.put$java_lang_Enum$java_lang_Object = function (key, value) {
          this.__keySet.add(key);

          return this.set(key.ordinal(), value);
        };
        /**
        *
        * @param {java.lang.Enum} key
        * @param {*} value
        * @return {*}
        */


        EnumMap.prototype.put = function (key, value) {
          if ((key != null || key === null) && (value != null || value === null)) {
            return this.put$java_lang_Enum$java_lang_Object(key, value);
          } else if ((key != null || key === null) && (value != null || value === null)) {
            return _super.prototype.put.call(this, key, value);
          } else throw new Error('invalid overload');
        };
        /**
        *
        * @param {*} key
        * @return {*}
        */


        EnumMap.prototype.remove = function (key) {
          return this.__keySet.remove(key) ? this.set(this.asOrdinal(key), null) : null;
        };
        /**
        *
        * @return {number}
        */


        EnumMap.prototype.size = function () {
          return this.__keySet.size();
        };
        /**
        * Returns <code>key</code> as <code>K</code>. Only runtime checks that
        * key is an Enum, not that it's the particular Enum K. Should only be called
        * when you are sure <code>key</code> is of type <code>K</code>.
        * @param {*} key
        * @return {java.lang.Enum}
        * @private
        */


        EnumMap.prototype.asKey = function (key) {
          return key;
        };

        EnumMap.prototype.asOrdinal = function (key) {
          return this.asKey(key).ordinal();
        };

        EnumMap.prototype.init$java_lang_Class = function (type) {
          this.__keySet = java.util.EnumSet.noneOf(type);

          this.__values = function (s) {
            var a = [];

            while (s-- > 0) {
              a.push(null);
            }

            return a;
          }(this.__keySet.capacity());
        };

        EnumMap.prototype.init = function (type) {
          if (type != null && (type["__class"] != null || function (t) {
            try {
              new t();
              return true;
            } catch (_a) {
              return false;
            }
          }(type)) || type === null) {
            return this.init$java_lang_Class(type);
          } else if (type != null && type instanceof java.util.EnumMap || type === null) {
            return this.init$java_util_EnumMap(type);
          } else throw new Error('invalid overload');
        };

        EnumMap.prototype.init$java_util_EnumMap = function (m) {
          this.__keySet =
          /* clone */
          function (o) {
            if (o.clone != undefined) {
              return o.clone();
            } else {
              var clone = Object.create(o);

              for (var p in o) {
                if (o.hasOwnProperty(p)) clone[p] = o[p];
              }

              return clone;
            }
          }(m.__keySet);

          this.__values = javaemul.internal.ArrayHelper.clone(m.__values, 0, m.__values.length);
        };

        EnumMap.prototype.set = function (ordinal, value) {
          var was = this.__values[ordinal];
          this.__values[ordinal] = value;
          return was;
        };

        return EnumMap;
      }(java.util.AbstractMap);

      util.EnumMap = EnumMap;
      EnumMap["__class"] = "java.util.EnumMap";
      EnumMap["__interfaces"] = ["java.util.Map"];

      (function (EnumMap) {
        var EntrySet =
        /** @class */
        function (_super) {
          __extends(EntrySet, _super);

          function EntrySet(__parent) {
            var _this = _super.call(this) || this;

            _this.__parent = __parent;
            return _this;
          }
          /**
          *
          */


          EntrySet.prototype.clear = function () {
            this.clear();
          };
          /**
          *
          * @param {*} o
          * @return {boolean}
          */


          EntrySet.prototype.contains = function (o) {
            if (o != null && o.constructor != null && o.constructor["__interfaces"] != null && o.constructor["__interfaces"].indexOf("java.util.Map.Entry") >= 0) {
              return this.__parent.containsEntry(o);
            }

            return false;
          };
          /**
          *
          * @return {*}
          */


          EntrySet.prototype.iterator = function () {
            return new EnumMap.EntrySetIterator(this.__parent);
          };
          /**
          *
          * @param {*} entry
          * @return {boolean}
          */


          EntrySet.prototype.remove = function (entry) {
            if (this.contains(entry)) {
              var key = entry.getKey();
              this.remove(key);
              return true;
            }

            return false;
          };
          /**
          *
          * @return {number}
          */


          EntrySet.prototype.size = function () {
            return this.size();
          };

          return EntrySet;
        }(java.util.AbstractSet);

        EnumMap.EntrySet = EntrySet;
        EntrySet["__class"] = "java.util.EnumMap.EntrySet";
        EntrySet["__interfaces"] = ["java.util.Collection", "java.util.Set", "java.lang.Iterable"];

        var EntrySetIterator =
        /** @class */
        function () {
          function EntrySetIterator(__parent) {
            this.__parent = __parent;
            this.it = this.__parent.__keySet.iterator();

            if (this.key === undefined) {
              this.key = null;
            }
          }
          /* Default method injected from java.util.Iterator */


          EntrySetIterator.prototype.forEachRemaining = function (consumer) {
            var _this = this;

            javaemul.internal.InternalPreconditions.checkNotNull(consumer);

            while (this.hasNext()) {
              {
                (function (target) {
                  return typeof target === 'function' ? target(_this.next()) : target.accept(_this.next());
                })(consumer);
              }
            }
          };
          /**
          *
          * @return {boolean}
          */


          EntrySetIterator.prototype.hasNext = function () {
            return this.it.hasNext();
          };
          /**
          *
          * @return {*}
          */


          EntrySetIterator.prototype.next = function () {
            this.key = this.it.next();
            return new EnumMap.MapEntry(this.__parent, this.key);
          };
          /**
          *
          */


          EntrySetIterator.prototype.remove = function () {
            javaemul.internal.InternalPreconditions.checkState(this.key != null);

            this.__parent.remove(this.key);

            this.key = null;
          };

          return EntrySetIterator;
        }();

        EnumMap.EntrySetIterator = EntrySetIterator;
        EntrySetIterator["__class"] = "java.util.EnumMap.EntrySetIterator";
        EntrySetIterator["__interfaces"] = ["java.util.Iterator"];

        var MapEntry =
        /** @class */
        function (_super) {
          __extends(MapEntry, _super);

          function MapEntry(__parent, key) {
            var _this = _super.call(this) || this;

            _this.__parent = __parent;

            if (_this.key === undefined) {
              _this.key = null;
            }

            _this.key = key;
            return _this;
          }
          /**
          *
          * @return {java.lang.Enum}
          */


          MapEntry.prototype.getKey = function () {
            return this.key;
          };
          /**
          *
          * @return {*}
          */


          MapEntry.prototype.getValue = function () {
            return this.__parent.__values[this.key.ordinal()];
          };
          /**
          *
          * @param {*} value
          * @return {*}
          */


          MapEntry.prototype.setValue = function (value) {
            return this.__parent.set(this.key.ordinal(), value);
          };

          return MapEntry;
        }(java.util.AbstractMapEntry);

        EnumMap.MapEntry = MapEntry;
        MapEntry["__class"] = "java.util.EnumMap.MapEntry";
        MapEntry["__interfaces"] = ["java.util.Map.Entry"];
      })(EnumMap = util.EnumMap || (util.EnumMap = {}));
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * Skeletal implementation of a NavigableMap.
      * @extends java.util.AbstractMap
      * @class
      */
      var AbstractNavigableMap =
      /** @class */
      function (_super) {
        __extends(AbstractNavigableMap, _super);

        function AbstractNavigableMap() {
          return _super.call(this) || this;
        }
        /* Default method injected from java.util.Map */


        AbstractNavigableMap.prototype.putIfAbsent = function (key, value) {
          var v = this.get(key);

          if (v == null) {
            v = this.put(key, value);
          }

          return v;
        };
        /* Default method injected from java.util.Map */


        AbstractNavigableMap.prototype.computeIfAbsent = function (key, mappingFunction) {
          var result;

          if ((result = this.get(key)) == null) {
            result = function (target) {
              return typeof target === 'function' ? target(key) : target.apply(key);
            }(mappingFunction);

            if (result != null) this.put(key, result);
          }

          return result;
        };
        /* Default method injected from java.util.Map */


        AbstractNavigableMap.prototype.merge = function (key, value, map) {
          var old = this.get(key);
          var next = old == null ? value : function (target) {
            return typeof target === 'function' ? target(old, value) : target.apply(old, value);
          }(map);

          if (next == null) {
            this.remove(key);
          } else {
            this.put(key, next);
          }

          return next;
        };
        /* Default method injected from java.util.Map */


        AbstractNavigableMap.prototype.getOrDefault = function (key, defaultValue) {
          var v;
          return (v = this.get(key)) != null || this.containsKey(key) ? v : defaultValue;
        };
        /* Default method injected from java.util.Map */


        AbstractNavigableMap.prototype.replaceAll = function (__function) {
          java.util.Objects.requireNonNull(__function);

          var _loop_22 = function _loop_22(index175) {
            var entry = index175.next();
            {
              var k_2;
              var v_2;

              try {
                k_2 = entry.getKey();
                v_2 = entry.getValue();
              } catch (ise) {
                throw new java.lang.RuntimeException(ise);
              }

              v_2 = function (target) {
                return typeof target === 'function' ? target(k_2, v_2) : target.apply(k_2, v_2);
              }(__function);

              try {
                entry.setValue(v_2);
              } catch (ise) {
                throw new java.lang.RuntimeException(ise);
              }
            }
          };

          for (var index175 = this.entrySet().iterator(); index175.hasNext();) {
            _loop_22(index175);
          }
        };

        AbstractNavigableMap.copyOf = function (entry) {
          return entry == null ? null : new util.AbstractMap.SimpleImmutableEntry(entry);
        };

        AbstractNavigableMap.getKeyOrNSE = function (entry) {
          if (entry == null) {
            throw new java.util.NoSuchElementException();
          }

          return entry.getKey();
        };
        /**
        *
        * @param {*} key
        * @return {*}
        */


        AbstractNavigableMap.prototype.ceilingEntry = function (key) {
          return AbstractNavigableMap.copyOf(this.getCeilingEntry(key));
        };
        /**
        *
        * @param {*} key
        * @return {*}
        */


        AbstractNavigableMap.prototype.ceilingKey = function (key) {
          return util.AbstractMap.getEntryKeyOrNull(this.getCeilingEntry(key));
        };
        /**
        *
        * @param {*} k
        * @return {boolean}
        */


        AbstractNavigableMap.prototype.containsKey = function (k) {
          var key = k;
          return this.getEntry(key) != null;
        };
        /**
        *
        * @return {*}
        */


        AbstractNavigableMap.prototype.descendingKeySet = function () {
          return this.descendingMap().navigableKeySet();
        };
        /**
        *
        * @return {*}
        */


        AbstractNavigableMap.prototype.descendingMap = function () {
          return new AbstractNavigableMap.DescendingMap(this);
        };
        /**
        *
        * @return {*}
        */


        AbstractNavigableMap.prototype.entrySet = function () {
          return new AbstractNavigableMap.EntrySet(this);
        };
        /**
        *
        * @return {*}
        */


        AbstractNavigableMap.prototype.firstEntry = function () {
          return AbstractNavigableMap.copyOf(this.getFirstEntry());
        };
        /**
        *
        * @return {*}
        */


        AbstractNavigableMap.prototype.firstKey = function () {
          return AbstractNavigableMap.getKeyOrNSE(this.getFirstEntry());
        };
        /**
        *
        * @param {*} key
        * @return {*}
        */


        AbstractNavigableMap.prototype.floorEntry = function (key) {
          return AbstractNavigableMap.copyOf(this.getFloorEntry(key));
        };
        /**
        *
        * @param {*} key
        * @return {*}
        */


        AbstractNavigableMap.prototype.floorKey = function (key) {
          return util.AbstractMap.getEntryKeyOrNull(this.getFloorEntry(key));
        };
        /**
        *
        * @param {*} k
        * @return {*}
        */


        AbstractNavigableMap.prototype.get = function (k) {
          var key = k;
          return util.AbstractMap.getEntryValueOrNull(this.getEntry(key));
        };

        AbstractNavigableMap.prototype.headMap = function (toKey, inclusive) {
          if ((toKey != null || toKey === null) && inclusive === undefined) {
            return this.headMap$java_lang_Object(toKey);
          } else throw new Error('invalid overload');
        };

        AbstractNavigableMap.prototype.headMap$java_lang_Object = function (toKey) {
          return this.headMap(toKey, false);
        };
        /**
        *
        * @param {*} key
        * @return {*}
        */


        AbstractNavigableMap.prototype.higherEntry = function (key) {
          return AbstractNavigableMap.copyOf(this.getHigherEntry(key));
        };
        /**
        *
        * @param {*} key
        * @return {*}
        */


        AbstractNavigableMap.prototype.higherKey = function (key) {
          return util.AbstractMap.getEntryKeyOrNull(this.getHigherEntry(key));
        };
        /**
        *
        * @return {*}
        */


        AbstractNavigableMap.prototype.keySet = function () {
          return this.navigableKeySet();
        };
        /**
        *
        * @return {*}
        */


        AbstractNavigableMap.prototype.lastEntry = function () {
          return AbstractNavigableMap.copyOf(this.getLastEntry());
        };
        /**
        *
        * @return {*}
        */


        AbstractNavigableMap.prototype.lastKey = function () {
          return AbstractNavigableMap.getKeyOrNSE(this.getLastEntry());
        };
        /**
        *
        * @param {*} key
        * @return {*}
        */


        AbstractNavigableMap.prototype.lowerEntry = function (key) {
          return AbstractNavigableMap.copyOf(this.getLowerEntry(key));
        };
        /**
        *
        * @param {*} key
        * @return {*}
        */


        AbstractNavigableMap.prototype.lowerKey = function (key) {
          return util.AbstractMap.getEntryKeyOrNull(this.getLowerEntry(key));
        };
        /**
        *
        * @return {*}
        */


        AbstractNavigableMap.prototype.navigableKeySet = function () {
          return new AbstractNavigableMap.NavigableKeySet(this);
        };
        /**
        *
        * @return {*}
        */


        AbstractNavigableMap.prototype.pollFirstEntry = function () {
          return this.pollEntry(this.getFirstEntry());
        };
        /**
        *
        * @return {*}
        */


        AbstractNavigableMap.prototype.pollLastEntry = function () {
          return this.pollEntry(this.getLastEntry());
        };

        AbstractNavigableMap.prototype.subMap = function (fromKey, fromInclusive, toKey, toInclusive) {
          if ((fromKey != null || fromKey === null) && (fromInclusive != null || fromInclusive === null) && toKey === undefined && toInclusive === undefined) {
            return this.subMap$java_lang_Object$java_lang_Object(fromKey, fromInclusive);
          } else throw new Error('invalid overload');
        };

        AbstractNavigableMap.prototype.subMap$java_lang_Object$java_lang_Object = function (fromKey, toKey) {
          return this.subMap(fromKey, true, toKey, false);
        };

        AbstractNavigableMap.prototype.tailMap = function (fromKey, inclusive) {
          if ((fromKey != null || fromKey === null) && inclusive === undefined) {
            return this.tailMap$java_lang_Object(fromKey);
          } else throw new Error('invalid overload');
        };

        AbstractNavigableMap.prototype.tailMap$java_lang_Object = function (fromKey) {
          return this.tailMap(fromKey, true);
        };
        /**
        *
        * @param {*} entry
        * @return {boolean}
        */


        AbstractNavigableMap.prototype.containsEntry = function (entry) {
          var key = entry.getKey();
          var lookupEntry = this.getEntry(key);
          return lookupEntry != null && java.util.Objects.equals(lookupEntry.getValue(), entry.getValue());
        };

        AbstractNavigableMap.prototype.pollEntry = function (entry) {
          if (entry != null) {
            this.removeEntry(entry);
          }

          return AbstractNavigableMap.copyOf(entry);
        };

        return AbstractNavigableMap;
      }(java.util.AbstractMap);

      util.AbstractNavigableMap = AbstractNavigableMap;
      AbstractNavigableMap["__class"] = "java.util.AbstractNavigableMap";
      AbstractNavigableMap["__interfaces"] = ["java.util.Map", "java.util.NavigableMap", "java.util.SortedMap"];

      (function (AbstractNavigableMap) {
        var DescendingMap =
        /** @class */
        function (_super) {
          __extends(DescendingMap, _super);

          function DescendingMap(__parent) {
            var _this = _super.call(this) || this;

            _this.__parent = __parent;
            return _this;
          }
          /**
          *
          */


          DescendingMap.prototype.clear = function () {
            this.ascendingMap().clear();
          };
          /**
          *
          * @return {*}
          */


          DescendingMap.prototype.comparator = function () {
            return java.util.Collections.reverseOrder$java_util_Comparator(this.ascendingMap().comparator());
          };
          /**
          *
          * @return {*}
          */


          DescendingMap.prototype.descendingMap = function () {
            return this.ascendingMap();
          };

          DescendingMap.prototype.headMap$java_lang_Object$boolean = function (toKey, inclusive) {
            return this.ascendingMap().tailMap(toKey, inclusive).descendingMap();
          };
          /**
          *
          * @param {*} toKey
          * @param {boolean} inclusive
          * @return {*}
          */


          DescendingMap.prototype.headMap = function (toKey, inclusive) {
            if ((toKey != null || toKey === null) && (typeof inclusive === 'boolean' || inclusive === null)) {
              return this.headMap$java_lang_Object$boolean(toKey, inclusive);
            } else if ((toKey != null || toKey === null) && inclusive === undefined) {
              return this.headMap$java_lang_Object(toKey);
            } else throw new Error('invalid overload');
          };
          /**
          *
          * @param {*} key
          * @param {*} value
          * @return {*}
          */


          DescendingMap.prototype.put = function (key, value) {
            return this.ascendingMap().put(key, value);
          };
          /**
          *
          * @param {*} key
          * @return {*}
          */


          DescendingMap.prototype.remove = function (key) {
            return this.ascendingMap().remove(key);
          };
          /**
          *
          * @return {number}
          */


          DescendingMap.prototype.size = function () {
            return this.ascendingMap().size();
          };

          DescendingMap.prototype.subMap$java_lang_Object$boolean$java_lang_Object$boolean = function (fromKey, fromInclusive, toKey, toInclusive) {
            return this.ascendingMap().subMap(toKey, toInclusive, fromKey, fromInclusive).descendingMap();
          };
          /**
          *
          * @param {*} fromKey
          * @param {boolean} fromInclusive
          * @param {*} toKey
          * @param {boolean} toInclusive
          * @return {*}
          */


          DescendingMap.prototype.subMap = function (fromKey, fromInclusive, toKey, toInclusive) {
            if ((fromKey != null || fromKey === null) && (typeof fromInclusive === 'boolean' || fromInclusive === null) && (toKey != null || toKey === null) && (typeof toInclusive === 'boolean' || toInclusive === null)) {
              return this.subMap$java_lang_Object$boolean$java_lang_Object$boolean(fromKey, fromInclusive, toKey, toInclusive);
            } else if ((fromKey != null || fromKey === null) && (fromInclusive != null || fromInclusive === null) && toKey === undefined && toInclusive === undefined) {
              return this.subMap$java_lang_Object$java_lang_Object(fromKey, fromInclusive);
            } else throw new Error('invalid overload');
          };

          DescendingMap.prototype.tailMap$java_lang_Object$boolean = function (fromKey, inclusive) {
            return this.ascendingMap().headMap(fromKey, inclusive).descendingMap();
          };
          /**
          *
          * @param {*} fromKey
          * @param {boolean} inclusive
          * @return {*}
          */


          DescendingMap.prototype.tailMap = function (fromKey, inclusive) {
            if ((fromKey != null || fromKey === null) && (typeof inclusive === 'boolean' || inclusive === null)) {
              return this.tailMap$java_lang_Object$boolean(fromKey, inclusive);
            } else if ((fromKey != null || fromKey === null) && inclusive === undefined) {
              return this.tailMap$java_lang_Object(fromKey);
            } else throw new Error('invalid overload');
          };

          DescendingMap.prototype.ascendingMap = function () {
            return this.__parent;
          };
          /**
          *
          * @return {*}
          */


          DescendingMap.prototype.descendingEntryIterator = function () {
            return this.ascendingMap().entryIterator();
          };
          /**
          *
          * @return {*}
          */


          DescendingMap.prototype.entryIterator = function () {
            return this.ascendingMap().descendingEntryIterator();
          };
          /**
          *
          * @param {*} key
          * @return {*}
          */


          DescendingMap.prototype.getEntry = function (key) {
            return this.ascendingMap().getEntry(key);
          };
          /**
          *
          * @return {*}
          */


          DescendingMap.prototype.getFirstEntry = function () {
            return this.ascendingMap().getLastEntry();
          };
          /**
          *
          * @return {*}
          */


          DescendingMap.prototype.getLastEntry = function () {
            return this.ascendingMap().getFirstEntry();
          };
          /**
          *
          * @param {*} key
          * @return {*}
          */


          DescendingMap.prototype.getCeilingEntry = function (key) {
            return this.ascendingMap().getFloorEntry(key);
          };
          /**
          *
          * @param {*} key
          * @return {*}
          */


          DescendingMap.prototype.getFloorEntry = function (key) {
            return this.ascendingMap().getCeilingEntry(key);
          };
          /**
          *
          * @param {*} key
          * @return {*}
          */


          DescendingMap.prototype.getHigherEntry = function (key) {
            return this.ascendingMap().getLowerEntry(key);
          };
          /**
          *
          * @param {*} key
          * @return {*}
          */


          DescendingMap.prototype.getLowerEntry = function (key) {
            return this.ascendingMap().getHigherEntry(key);
          };
          /**
          *
          * @param {*} entry
          * @return {boolean}
          */


          DescendingMap.prototype.removeEntry = function (entry) {
            return this.ascendingMap().removeEntry(entry);
          };

          return DescendingMap;
        }(java.util.AbstractNavigableMap);

        AbstractNavigableMap.DescendingMap = DescendingMap;
        DescendingMap["__class"] = "java.util.AbstractNavigableMap.DescendingMap";
        DescendingMap["__interfaces"] = ["java.util.Map", "java.util.NavigableMap", "java.util.SortedMap"];

        var EntrySet =
        /** @class */
        function (_super) {
          __extends(EntrySet, _super);

          function EntrySet(__parent) {
            var _this = _super.call(this) || this;

            _this.__parent = __parent;
            return _this;
          }
          /**
          *
          * @param {*} o
          * @return {boolean}
          */


          EntrySet.prototype.contains = function (o) {
            return o != null && o.constructor != null && o.constructor["__interfaces"] != null && o.constructor["__interfaces"].indexOf("java.util.Map.Entry") >= 0 && this.__parent.containsEntry(o);
          };
          /**
          *
          * @return {*}
          */


          EntrySet.prototype.iterator = function () {
            return this.__parent.entryIterator();
          };
          /**
          *
          * @param {*} o
          * @return {boolean}
          */


          EntrySet.prototype.remove = function (o) {
            if (o != null && o.constructor != null && o.constructor["__interfaces"] != null && o.constructor["__interfaces"].indexOf("java.util.Map.Entry") >= 0) {
              var entry = o;
              return this.__parent.removeEntry(entry);
            }

            return false;
          };
          /**
          *
          * @return {number}
          */


          EntrySet.prototype.size = function () {
            return this.size();
          };

          return EntrySet;
        }(java.util.AbstractSet);

        AbstractNavigableMap.EntrySet = EntrySet;
        EntrySet["__class"] = "java.util.AbstractNavigableMap.EntrySet";
        EntrySet["__interfaces"] = ["java.util.Collection", "java.util.Set", "java.lang.Iterable"];

        var NavigableKeySet =
        /** @class */
        function (_super) {
          __extends(NavigableKeySet, _super);

          function NavigableKeySet(map) {
            var _this = _super.call(this) || this;

            if (_this.map === undefined) {
              _this.map = null;
            }

            _this.map = map;
            return _this;
          }
          /* Default method injected from java.util.Collection */


          NavigableKeySet.prototype.stream = function () {
            return new javaemul.internal.stream.StreamHelper(this);
          };
          /* Default method injected from java.lang.Iterable */


          NavigableKeySet.prototype.forEach = function (action) {
            javaemul.internal.InternalPreconditions.checkNotNull(action);

            var _loop_23 = function _loop_23(index176) {
              var t = index176.next();
              {
                (function (target) {
                  return typeof target === 'function' ? target(t) : target.accept(t);
                })(action);
              }
            };

            for (var index176 = this.iterator(); index176.hasNext();) {
              _loop_23(index176);
            }
          };
          /* Default method injected from java.util.Collection */


          NavigableKeySet.prototype.parallelStream = function () {
            return this.stream();
          };
          /* Default method injected from java.util.Collection */


          NavigableKeySet.prototype.removeIf = function (filter) {
            javaemul.internal.InternalPreconditions.checkNotNull(filter);
            var removed = false;

            var _loop_24 = function _loop_24(it) {
              {
                if (function (target) {
                  return typeof target === 'function' ? target(it.next()) : target.test(it.next());
                }(filter)) {
                  it.remove();
                  removed = true;
                }
              }
            };

            for (var it = this.iterator(); it.hasNext();) {
              _loop_24(it);
            }

            return removed;
          };
          /**
          *
          * @param {*} k
          * @return {*}
          */


          NavigableKeySet.prototype.ceiling = function (k) {
            return this.map.ceilingKey(k);
          };
          /**
          *
          */


          NavigableKeySet.prototype.clear = function () {
            this.map.clear();
          };
          /**
          *
          * @return {*}
          */


          NavigableKeySet.prototype.comparator = function () {
            return this.map.comparator();
          };
          /**
          *
          * @param {*} o
          * @return {boolean}
          */


          NavigableKeySet.prototype.contains = function (o) {
            return this.map.containsKey(o);
          };
          /**
          *
          * @return {*}
          */


          NavigableKeySet.prototype.descendingIterator = function () {
            return this.descendingSet().iterator();
          };
          /**
          *
          * @return {*}
          */


          NavigableKeySet.prototype.descendingSet = function () {
            return this.map.descendingMap().navigableKeySet();
          };
          /**
          *
          * @return {*}
          */


          NavigableKeySet.prototype.first = function () {
            return this.map.firstKey();
          };
          /**
          *
          * @param {*} k
          * @return {*}
          */


          NavigableKeySet.prototype.floor = function (k) {
            return this.map.floorKey(k);
          };

          NavigableKeySet.prototype.headSet$java_lang_Object = function (toElement) {
            return this.headSet(toElement, false);
          };

          NavigableKeySet.prototype.headSet$java_lang_Object$boolean = function (toElement, inclusive) {
            return this.map.headMap(toElement, inclusive).navigableKeySet();
          };
          /**
          *
          * @param {*} toElement
          * @param {boolean} inclusive
          * @return {*}
          */


          NavigableKeySet.prototype.headSet = function (toElement, inclusive) {
            if ((toElement != null || toElement === null) && (typeof inclusive === 'boolean' || inclusive === null)) {
              return this.headSet$java_lang_Object$boolean(toElement, inclusive);
            } else if ((toElement != null || toElement === null) && inclusive === undefined) {
              return this.headSet$java_lang_Object(toElement);
            } else throw new Error('invalid overload');
          };
          /**
          *
          * @param {*} k
          * @return {*}
          */


          NavigableKeySet.prototype.higher = function (k) {
            return this.map.higherKey(k);
          };
          /**
          *
          * @return {*}
          */


          NavigableKeySet.prototype.iterator = function () {
            var entryIterator = this.map.entrySet().iterator();
            return new NavigableKeySet.NavigableKeySet$0(this, entryIterator);
          };
          /**
          *
          * @return {*}
          */


          NavigableKeySet.prototype.last = function () {
            return this.map.lastKey();
          };
          /**
          *
          * @param {*} k
          * @return {*}
          */


          NavigableKeySet.prototype.lower = function (k) {
            return this.map.lowerKey(k);
          };
          /**
          *
          * @return {*}
          */


          NavigableKeySet.prototype.pollFirst = function () {
            return util.AbstractMap.getEntryKeyOrNull(this.map.pollFirstEntry());
          };
          /**
          *
          * @return {*}
          */


          NavigableKeySet.prototype.pollLast = function () {
            return util.AbstractMap.getEntryKeyOrNull(this.map.pollLastEntry());
          };
          /**
          *
          * @param {*} o
          * @return {boolean}
          */


          NavigableKeySet.prototype.remove = function (o) {
            if (this.map.containsKey(o)) {
              this.map.remove(o);
              return true;
            }

            return false;
          };
          /**
          *
          * @return {number}
          */


          NavigableKeySet.prototype.size = function () {
            return this.map.size();
          };

          NavigableKeySet.prototype.subSet$java_lang_Object$boolean$java_lang_Object$boolean = function (fromElement, fromInclusive, toElement, toInclusive) {
            return this.map.subMap(fromElement, fromInclusive, toElement, toInclusive).navigableKeySet();
          };
          /**
          *
          * @param {*} fromElement
          * @param {boolean} fromInclusive
          * @param {*} toElement
          * @param {boolean} toInclusive
          * @return {*}
          */


          NavigableKeySet.prototype.subSet = function (fromElement, fromInclusive, toElement, toInclusive) {
            if ((fromElement != null || fromElement === null) && (typeof fromInclusive === 'boolean' || fromInclusive === null) && (toElement != null || toElement === null) && (typeof toInclusive === 'boolean' || toInclusive === null)) {
              return this.subSet$java_lang_Object$boolean$java_lang_Object$boolean(fromElement, fromInclusive, toElement, toInclusive);
            } else if ((fromElement != null || fromElement === null) && (fromInclusive != null || fromInclusive === null) && toElement === undefined && toInclusive === undefined) {
              return this.subSet$java_lang_Object$java_lang_Object(fromElement, fromInclusive);
            } else throw new Error('invalid overload');
          };

          NavigableKeySet.prototype.subSet$java_lang_Object$java_lang_Object = function (fromElement, toElement) {
            return this.subSet(fromElement, true, toElement, false);
          };

          NavigableKeySet.prototype.tailSet$java_lang_Object = function (fromElement) {
            return this.tailSet(fromElement, true);
          };

          NavigableKeySet.prototype.tailSet$java_lang_Object$boolean = function (fromElement, inclusive) {
            return this.map.tailMap(fromElement, inclusive).navigableKeySet();
          };
          /**
          *
          * @param {*} fromElement
          * @param {boolean} inclusive
          * @return {*}
          */


          NavigableKeySet.prototype.tailSet = function (fromElement, inclusive) {
            if ((fromElement != null || fromElement === null) && (typeof inclusive === 'boolean' || inclusive === null)) {
              return this.tailSet$java_lang_Object$boolean(fromElement, inclusive);
            } else if ((fromElement != null || fromElement === null) && inclusive === undefined) {
              return this.tailSet$java_lang_Object(fromElement);
            } else throw new Error('invalid overload');
          };

          return NavigableKeySet;
        }(java.util.AbstractSet);

        AbstractNavigableMap.NavigableKeySet = NavigableKeySet;
        NavigableKeySet["__class"] = "java.util.AbstractNavigableMap.NavigableKeySet";
        NavigableKeySet["__interfaces"] = ["java.util.SortedSet", "java.util.Collection", "java.util.Set", "java.util.NavigableSet", "java.lang.Iterable"];

        (function (NavigableKeySet) {
          var NavigableKeySet$0 =
          /** @class */
          function () {
            function NavigableKeySet$0(__parent, entryIterator) {
              this.entryIterator = entryIterator;
              this.__parent = __parent;
            }
            /* Default method injected from java.util.Iterator */


            NavigableKeySet$0.prototype.forEachRemaining = function (consumer) {
              var _this = this;

              javaemul.internal.InternalPreconditions.checkNotNull(consumer);

              while (this.hasNext()) {
                {
                  (function (target) {
                    return typeof target === 'function' ? target(_this.next()) : target.accept(_this.next());
                  })(consumer);
                }
              }
            };
            /**
            *
            * @return {boolean}
            */


            NavigableKeySet$0.prototype.hasNext = function () {
              return this.entryIterator.hasNext();
            };
            /**
            *
            * @return {*}
            */


            NavigableKeySet$0.prototype.next = function () {
              var entry = this.entryIterator.next();
              return entry.getKey();
            };
            /**
            *
            */


            NavigableKeySet$0.prototype.remove = function () {
              this.entryIterator.remove();
            };

            return NavigableKeySet$0;
          }();

          NavigableKeySet.NavigableKeySet$0 = NavigableKeySet$0;
          NavigableKeySet$0["__interfaces"] = ["java.util.Iterator"];
        })(NavigableKeySet = AbstractNavigableMap.NavigableKeySet || (AbstractNavigableMap.NavigableKeySet = {}));
      })(AbstractNavigableMap = util.AbstractNavigableMap || (util.AbstractNavigableMap = {}));
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * Utility methods that operate on collections. <a href=
      * "http://java.sun.com/j2se/1.5.0/docs/api/java/util/Collections.html">[Sun
      * docs]</a>
      * @class
      */
      var Collections =
      /** @class */
      function () {
        function Collections() {}

        Collections.EMPTY_LIST_$LI$ = function () {
          if (Collections.EMPTY_LIST == null) {
            Collections.EMPTY_LIST = new Collections.EmptyList();
          }

          return Collections.EMPTY_LIST;
        };

        Collections.EMPTY_MAP_$LI$ = function () {
          if (Collections.EMPTY_MAP == null) {
            Collections.EMPTY_MAP = new Collections.EmptyMap();
          }

          return Collections.EMPTY_MAP;
        };

        Collections.EMPTY_SET_$LI$ = function () {
          if (Collections.EMPTY_SET == null) {
            Collections.EMPTY_SET = new Collections.EmptySet();
          }

          return Collections.EMPTY_SET;
        };

        Collections.addAll = function (c) {
          var a = [];

          for (var _i = 1; _i < arguments.length; _i++) {
            a[_i - 1] = arguments[_i];
          }

          var result = false;

          for (var index177 = 0; index177 < a.length; index177++) {
            var e = a[index177];
            {
              result = c.add(e) || result;
            }
          }

          return result;
        };

        Collections.asLifoQueue = function (deque) {
          return new Collections.LifoQueue(deque);
        };

        Collections.binarySearch$java_util_List$java_lang_Object = function (sortedList, key) {
          return Collections.binarySearch(sortedList, key, null);
        };

        Collections.binarySearch$java_util_List$java_lang_Object$java_util_Comparator = function (sortedList, key, comparator) {
          if (comparator == null) {
            comparator = java.util.Comparators.natural();
          }

          var low = 0;
          var high = sortedList.size() - 1;

          while (low <= high) {
            {
              var mid = low + (high - low >> 1);
              var midVal = sortedList.get(mid);

              var compareResult = function (target) {
                return target['compare'] === undefined ? target : target['compare'];
              }(comparator)(midVal, key);

              if (compareResult < 0) {
                low = mid + 1;
              } else if (compareResult > 0) {
                high = mid - 1;
              } else {
                return mid;
              }
            }
          }

          return -low - 1;
        };
        /**
        * Perform a binary search on a sorted List, using a user-specified comparison
        * function.
        *
        * <p>
        * Note: The GWT implementation differs from the JDK implementation in that it
        * does not do an iterator-based binary search for Lists that do not implement
        * RandomAccess.
        * </p>
        *
        * @param {*} sortedList
        * List to search
        * @param {*} key
        * value to search for
        * @param {*} comparator
        * comparision function, <code>null</code> indicates <i>natural
        * ordering</i> should be used.
        * @return {number} the index of an element with a matching value, or a negative number
        * which is the index of the next larger value (or just past the end of
        * the array if the searched value is larger than all elements in the
        * array) minus 1 (to ensure error returns are negative)
        * @throws ClassCastException
        * if <code>key</code> and <code>sortedList</code>'s elements cannot
        * be compared by <code>comparator</code>.
        */


        Collections.binarySearch = function (sortedList, key, comparator) {
          if ((sortedList != null && sortedList.constructor != null && sortedList.constructor["__interfaces"] != null && sortedList.constructor["__interfaces"].indexOf("java.util.List") >= 0 || sortedList === null) && (key != null || key === null) && (typeof comparator === 'function' && comparator.length === 2 || comparator === null)) {
            return java.util.Collections.binarySearch$java_util_List$java_lang_Object$java_util_Comparator(sortedList, key, comparator);
          } else if ((sortedList != null && sortedList.constructor != null && sortedList.constructor["__interfaces"] != null && sortedList.constructor["__interfaces"].indexOf("java.util.List") >= 0 || sortedList === null) && (key != null || key === null) && comparator === undefined) {
            return java.util.Collections.binarySearch$java_util_List$java_lang_Object(sortedList, key);
          } else throw new Error('invalid overload');
        };

        Collections.copy = function (dest, src) {
          if (src.size() > dest.size()) {
            throw new java.lang.IndexOutOfBoundsException("src does not fit in dest");
          }

          var destIt = dest['listIterator$']();

          for (var index178 = src.iterator(); index178.hasNext();) {
            var e = index178.next();
            {
              destIt.next();
              destIt.set(e);
            }
          }
        };

        Collections.disjoint = function (c1, c2) {
          var iterating = c1;
          var testing = c2;

          if (c1 != null && c1.constructor != null && c1.constructor["__interfaces"] != null && c1.constructor["__interfaces"].indexOf("java.util.Set") >= 0 && !(c2 != null && c2.constructor != null && c2.constructor["__interfaces"] != null && c2.constructor["__interfaces"].indexOf("java.util.Set") >= 0)) {
            iterating = c2;
            testing = c1;
          }

          for (var index179 = iterating.iterator(); index179.hasNext();) {
            var o = index179.next();
            {
              if (testing.contains(o)) {
                return false;
              }
            }
          }

          return true;
        };

        Collections.emptyIterator = function () {
          return Collections.EmptyListIterator.INSTANCE_$LI$();
        };

        Collections.emptyList = function () {
          return Collections.EMPTY_LIST_$LI$();
        };

        Collections.emptyListIterator = function () {
          return Collections.EmptyListIterator.INSTANCE_$LI$();
        };

        Collections.emptyMap = function () {
          return Collections.EMPTY_MAP_$LI$();
        };

        Collections.emptySet = function () {
          return Collections.EMPTY_SET_$LI$();
        };

        Collections.enumeration = function (c) {
          var it = c.iterator();
          return new Collections.Collections$0(it);
        };

        Collections.fill = function (list, obj) {
          for (var it = list['listIterator$'](); it.hasNext();) {
            {
              it.next();
              it.set(obj);
            }
          }
        };

        Collections.frequency = function (c, o) {
          var count = 0;

          for (var index180 = c.iterator(); index180.hasNext();) {
            var e = index180.next();
            {
              if (java.util.Objects.equals(o, e)) {
                ++count;
              }
            }
          }

          return count;
        };

        Collections.list = function (e) {
          var arrayList = new java.util.ArrayList();

          while (e.hasMoreElements()) {
            {
              arrayList.add(e.nextElement());
            }
          }

          return arrayList;
        };

        Collections.max$java_util_Collection = function (coll) {
          return Collections.max$java_util_Collection$java_util_Comparator(coll, null);
        };

        Collections.max$java_util_Collection$java_util_Comparator = function (coll, comp) {
          if (comp == null) {
            comp = java.util.Comparators.natural();
          }

          var it = coll.iterator();
          var max = it.next();

          while (it.hasNext()) {
            {
              var t = it.next();

              if (function (target) {
                return target['compare'] === undefined ? target : target['compare'];
              }(comp)(t, max) > 0) {
                max = t;
              }
            }
          }

          return max;
        };

        Collections.max = function (coll, comp) {
          if ((coll != null && coll.constructor != null && coll.constructor["__interfaces"] != null && coll.constructor["__interfaces"].indexOf("java.util.Collection") >= 0 || coll === null) && (typeof comp === 'function' && comp.length === 2 || comp === null)) {
            return java.util.Collections.max$java_util_Collection$java_util_Comparator(coll, comp);
          } else if ((coll != null && coll.constructor != null && coll.constructor["__interfaces"] != null && coll.constructor["__interfaces"].indexOf("java.util.Collection") >= 0 || coll === null) && comp === undefined) {
            return java.util.Collections.max$java_util_Collection(coll);
          } else throw new Error('invalid overload');
        };

        Collections.min = function (coll, comp) {
          if (comp === void 0) {
            comp = null;
          }

          return Collections.max$java_util_Collection$java_util_Comparator(coll, Collections.reverseOrder$java_util_Comparator(comp));
        };

        Collections.newSetFromMap = function (map) {
          javaemul.internal.InternalPreconditions.checkArgument(map.isEmpty(), "map is not empty");
          return new Collections.SetFromMap(map);
        };

        Collections.nCopies = function (n, o) {
          var list = new java.util.ArrayList();

          for (var i = 0; i < n; ++i) {
            {
              list.add(o);
            }
          }

          return Collections.unmodifiableList(list);
        };

        Collections.replaceAll = function (list, oldVal, newVal) {
          var modified = false;

          for (var it = list['listIterator$'](); it.hasNext();) {
            {
              var t = it.next();

              if (java.util.Objects.equals(t, oldVal)) {
                it.set(newVal);
                modified = true;
              }
            }
          }

          return modified;
        };

        Collections.reverse = function (l) {
          if (l != null && l.constructor != null && l.constructor["__interfaces"] != null && l.constructor["__interfaces"].indexOf("java.util.RandomAccess") >= 0) {
            for (var iFront = 0, iBack = l.size() - 1; iFront < iBack; ++iFront, --iBack) {
              {
                Collections.swap(l, iFront, iBack);
              }
            }
          } else {
            var head = l['listIterator$']();
            var tail = l['listIterator$int'](l.size());

            while (head.nextIndex() < tail.previousIndex()) {
              {
                var headElem = head.next();
                var tailElem = tail.previous();
                head.set(tailElem);
                tail.set(headElem);
              }
            }
          }
        };

        Collections.reverseOrder$ = function () {
          return Collections.ReverseComparator.INSTANCE_$LI$();
        };

        Collections.reverseOrder$java_util_Comparator = function (cmp) {
          if (cmp == null) {
            return Collections.reverseOrder$();
          }

          return function (t1, t2) {
            return function (target) {
              return target['compare'] === undefined ? target : target['compare'];
            }(cmp)(t2, t1);
          };
        };

        Collections.reverseOrder = function (cmp) {
          if (typeof cmp === 'function' && cmp.length === 2 || cmp === null) {
            return java.util.Collections.reverseOrder$java_util_Comparator(cmp);
          } else if (cmp === undefined) {
            return java.util.Collections.reverseOrder$();
          } else throw new Error('invalid overload');
        };
        /**
        * Rotates the elements in {@code list} by the distance {@code dist}
        * <p>
        * e.g. for a given list with elements [1, 2, 3, 4, 5, 6, 7, 8, 9, 0], calling
        * rotate(list, 3) or rotate(list, -7) would modify the list to look like this:
        * [8, 9, 0, 1, 2, 3, 4, 5, 6, 7]
        *
        * @param {*} lst
        * the list whose elements are to be rotated.
        * @param {number} dist
        * is the distance the list is rotated. This can be any valid
        * integer. Negative values rotate the list backwards.
        */


        Collections.rotate = function (lst, dist) {
          javaemul.internal.InternalPreconditions.checkNotNull(lst);
          var size = lst.size();

          if (size === 0) {
            return;
          }

          var normdist = dist % size;

          if (normdist === 0) {
            return;
          }

          if (normdist < 0) {
            normdist += size;
          }

          if (lst != null && lst.constructor != null && lst.constructor["__interfaces"] != null && lst.constructor["__interfaces"].indexOf("java.util.RandomAccess") >= 0) {
            var list = lst;
            var temp = list.get(0);
            var index = 0;
            var beginIndex = 0;

            for (var i = 0; i < size; i++) {
              {
                index = (index + normdist) % size;
                temp = list.set(index, temp);

                if (index === beginIndex) {
                  index = ++beginIndex;
                  temp = list.get(beginIndex);
                }
              }
            }
          } else {
            var divideIndex = size - normdist;
            var sublist1 = lst.subList(0, divideIndex);
            var sublist2 = lst.subList(divideIndex, size);
            Collections.reverse(sublist1);
            Collections.reverse(sublist2);
            Collections.reverse(lst);
          }
        };

        Collections.shuffle = function (list, rnd) {
          if (rnd === void 0) {
            rnd = Collections.RandomHolder.rnd_$LI$();
          }

          if (list != null && list.constructor != null && list.constructor["__interfaces"] != null && list.constructor["__interfaces"].indexOf("java.util.RandomAccess") >= 0) {
            for (var i = list.size() - 1; i >= 1; i--) {
              {
                Collections.swapImpl$java_util_List$int$int(list, i, rnd.nextInt$int(i + 1));
              }
            }
          } else {
            var arr = list['toArray$']();

            for (var i = arr.length - 1; i >= 1; i--) {
              {
                Collections.swapImpl$java_lang_Object_A$int$int(arr, i, rnd.nextInt$int(i + 1));
              }
            }

            var it = list['listIterator$']();

            for (var index181 = 0; index181 < arr.length; index181++) {
              var e = arr[index181];
              {
                it.next();
                it.set(e);
              }
            }
          }
        };

        Collections.singleton = function (o) {
          var set = new java.util.HashSet(1);
          set.add(o);
          return Collections.unmodifiableSet(set);
        };

        Collections.singletonList = function (o) {
          return new Collections.SingletonList(o);
        };

        Collections.singletonMap = function (key, value) {
          var map = new java.util.HashMap(1);
          map.put(key, value);
          return Collections.unmodifiableMap(map);
        };

        Collections.sort$java_util_List = function (target) {
          Collections.sort$java_util_List$java_util_Comparator(target, null);
        };

        Collections.sort$java_util_List$java_util_Comparator = function (target, c) {
          var x = target['toArray$']();
          java.util.Arrays.sort$java_lang_Object_A$java_util_Comparator(x, c);
          Collections.replaceContents(target, x);
        };

        Collections.sort = function (target, c) {
          if ((target != null && target.constructor != null && target.constructor["__interfaces"] != null && target.constructor["__interfaces"].indexOf("java.util.List") >= 0 || target === null) && (typeof c === 'function' && c.length === 2 || c === null)) {
            return java.util.Collections.sort$java_util_List$java_util_Comparator(target, c);
          } else if ((target != null && target.constructor != null && target.constructor["__interfaces"] != null && target.constructor["__interfaces"].indexOf("java.util.List") >= 0 || target === null) && c === undefined) {
            return java.util.Collections.sort$java_util_List(target);
          } else throw new Error('invalid overload');
        };

        Collections.swap = function (list, i, j) {
          Collections.swapImpl$java_util_List$int$int(list, i, j);
        };

        Collections.unmodifiableCollection = function (coll) {
          return new Collections.UnmodifiableCollection(coll);
        };

        Collections.unmodifiableList = function (list) {
          return list != null && list.constructor != null && list.constructor["__interfaces"] != null && list.constructor["__interfaces"].indexOf("java.util.RandomAccess") >= 0 ? new Collections.UnmodifiableRandomAccessList(list) : new Collections.UnmodifiableList(list);
        };

        Collections.unmodifiableMap = function (map) {
          return new Collections.UnmodifiableMap(map);
        };

        Collections.unmodifiableSet = function (set) {
          return new Collections.UnmodifiableSet(set);
        };

        Collections.unmodifiableSortedMap = function (map) {
          return new Collections.UnmodifiableSortedMap(map);
        };

        Collections.unmodifiableSortedSet = function (set) {
          return new Collections.UnmodifiableSortedSet(set);
        };

        Collections.hashCode$java_lang_Iterable = function (collection) {
          var hashCode = 0;

          for (var index182 = collection.iterator(); index182.hasNext();) {
            var e = index182.next();
            {
              hashCode = hashCode + java.util.Objects.hashCode(e);
              hashCode = javaemul.internal.Coercions.ensureInt(hashCode);
            }
          }

          return hashCode;
        };

        Collections.hashCode$java_util_List = function (list) {
          var hashCode = 1;

          for (var index183 = list.iterator(); index183.hasNext();) {
            var e = index183.next();
            {
              hashCode = 31 * hashCode + java.util.Objects.hashCode(e);
              hashCode = javaemul.internal.Coercions.ensureInt(hashCode);
            }
          }

          return hashCode;
        };
        /**
        * Computes hash code preserving collection order (e.g. ArrayList).
        * @param {*} list
        * @return {number}
        */


        Collections.hashCode = function (list) {
          if (list != null && list.constructor != null && list.constructor["__interfaces"] != null && list.constructor["__interfaces"].indexOf("java.util.List") >= 0 || list === null) {
            return java.util.Collections.hashCode$java_util_List(list);
          } else if (list != null && list.constructor != null && list.constructor["__interfaces"] != null && list.constructor["__interfaces"].indexOf("java.lang.Iterable") >= 0 || list === null) {
            return java.util.Collections.hashCode$java_lang_Iterable(list);
          } else throw new Error('invalid overload');
        };
        /**
        * Replace contents of a list from an array.
        *
        * @param <T>
        * element type
        * @param {*} target
        * list to replace contents from an array
        * @param {Array} x
        * an Object array which can contain only T instances
        * @private
        */


        Collections.replaceContents = function (target, x) {
          var size = target.size();

          for (var i = 0; i < size; i++) {
            {
              target.set(i, x[i]);
            }
          }
        };

        Collections.swapImpl$java_util_List$int$int = function (list, i, j) {
          var t = list.get(i);
          list.set(i, list.get(j));
          list.set(j, t);
        };

        Collections.swapImpl = function (list, i, j) {
          if ((list != null && list.constructor != null && list.constructor["__interfaces"] != null && list.constructor["__interfaces"].indexOf("java.util.List") >= 0 || list === null) && (typeof i === 'number' || i === null) && (typeof j === 'number' || j === null)) {
            return java.util.Collections.swapImpl$java_util_List$int$int(list, i, j);
          } else if ((list != null && list instanceof Array && (list.length == 0 || list[0] == null || list[0] != null) || list === null) && (typeof i === 'number' || i === null) && (typeof j === 'number' || j === null)) {
            return java.util.Collections.swapImpl$java_lang_Object_A$int$int(list, i, j);
          } else throw new Error('invalid overload');
        };

        Collections.swapImpl$java_lang_Object_A$int$int = function (a, i, j) {
          var obj = a[i];
          a[i] = a[j];
          a[j] = obj;
        };

        Collections.synchronizedList = function (list) {
          return new java.util.ArrayList(list);
        };

        Collections.synchronizedSet = function (s) {
          return new java.util.HashSet(s);
        };

        return Collections;
      }();

      util.Collections = Collections;
      Collections["__class"] = "java.util.Collections";

      (function (Collections) {
        var LifoQueue =
        /** @class */
        function (_super) {
          __extends(LifoQueue, _super);

          function LifoQueue(deque) {
            var _this = _super.call(this) || this;

            if (_this.deque === undefined) {
              _this.deque = null;
            }

            _this.deque = deque;
            return _this;
          }
          /**
          *
          * @return {*}
          */


          LifoQueue.prototype.iterator = function () {
            return this.deque.iterator();
          };
          /**
          *
          * @param {*} e
          * @return {boolean}
          */


          LifoQueue.prototype.offer = function (e) {
            return this.deque.offerFirst(e);
          };
          /**
          *
          * @return {*}
          */


          LifoQueue.prototype.peek = function () {
            return this.deque.peekFirst();
          };
          /**
          *
          * @return {*}
          */


          LifoQueue.prototype.poll = function () {
            return this.deque.pollFirst();
          };
          /**
          *
          * @return {number}
          */


          LifoQueue.prototype.size = function () {
            return this.deque.size();
          };

          return LifoQueue;
        }(java.util.AbstractQueue);

        Collections.LifoQueue = LifoQueue;
        LifoQueue["__class"] = "java.util.Collections.LifoQueue";
        LifoQueue["__interfaces"] = ["java.util.Collection", "java.util.Queue", "java.lang.Iterable", "java.io.Serializable"];

        var EmptyList =
        /** @class */
        function (_super) {
          __extends(EmptyList, _super);

          function EmptyList() {
            return _super.call(this) || this;
          }
          /**
          *
          * @param {*} object
          * @return {boolean}
          */


          EmptyList.prototype.contains = function (object) {
            return false;
          };
          /**
          *
          * @param {number} location
          * @return {*}
          */


          EmptyList.prototype.get = function (location) {
            javaemul.internal.InternalPreconditions.checkElementIndex(location, 0);
            return null;
          };
          /**
          *
          * @return {*}
          */


          EmptyList.prototype.iterator = function () {
            return Collections.emptyIterator();
          };
          /**
          *
          * @param {number} from
          * @return {*}
          */


          EmptyList.prototype.listIterator = function (from) {
            if (typeof from === 'number' || from === null) {
              return _super.prototype.listIterator.call(this, from);
            } else if (from === undefined) {
              return this.listIterator$();
            } else throw new Error('invalid overload');
          };

          EmptyList.prototype.listIterator$ = function () {
            return Collections.emptyListIterator();
          };
          /**
          *
          * @return {number}
          */


          EmptyList.prototype.size = function () {
            return 0;
          };

          return EmptyList;
        }(java.util.AbstractList);

        Collections.EmptyList = EmptyList;
        EmptyList["__class"] = "java.util.Collections.EmptyList";
        EmptyList["__interfaces"] = ["java.util.RandomAccess", "java.util.List", "java.util.Collection", "java.lang.Iterable", "java.io.Serializable"];

        var EmptyListIterator =
        /** @class */
        function () {
          function EmptyListIterator() {}
          /* Default method injected from java.util.Iterator */


          EmptyListIterator.prototype.forEachRemaining = function (consumer) {
            var _this = this;

            javaemul.internal.InternalPreconditions.checkNotNull(consumer);

            while (this.hasNext()) {
              {
                (function (target) {
                  return typeof target === 'function' ? target(_this.next()) : target.accept(_this.next());
                })(consumer);
              }
            }
          };

          EmptyListIterator.INSTANCE_$LI$ = function () {
            if (EmptyListIterator.INSTANCE == null) {
              EmptyListIterator.INSTANCE = new Collections.EmptyListIterator();
            }

            return EmptyListIterator.INSTANCE;
          };
          /**
          *
          * @param {*} o
          */


          EmptyListIterator.prototype.add = function (o) {
            throw new java.lang.UnsupportedOperationException();
          };
          /**
          *
          * @return {boolean}
          */


          EmptyListIterator.prototype.hasNext = function () {
            return false;
          };
          /**
          *
          * @return {boolean}
          */


          EmptyListIterator.prototype.hasPrevious = function () {
            return false;
          };
          /**
          *
          * @return {*}
          */


          EmptyListIterator.prototype.next = function () {
            throw new java.util.NoSuchElementException();
          };
          /**
          *
          * @return {number}
          */


          EmptyListIterator.prototype.nextIndex = function () {
            return 0;
          };
          /**
          *
          * @return {*}
          */


          EmptyListIterator.prototype.previous = function () {
            throw new java.util.NoSuchElementException();
          };
          /**
          *
          * @return {number}
          */


          EmptyListIterator.prototype.previousIndex = function () {
            return -1;
          };
          /**
          *
          */


          EmptyListIterator.prototype.remove = function () {
            throw new java.lang.IllegalStateException();
          };
          /**
          *
          * @param {*} o
          */


          EmptyListIterator.prototype.set = function (o) {
            throw new java.lang.IllegalStateException();
          };

          return EmptyListIterator;
        }();

        Collections.EmptyListIterator = EmptyListIterator;
        EmptyListIterator["__class"] = "java.util.Collections.EmptyListIterator";
        EmptyListIterator["__interfaces"] = ["java.util.Iterator", "java.util.ListIterator"];

        var EmptySet =
        /** @class */
        function (_super) {
          __extends(EmptySet, _super);

          function EmptySet() {
            return _super.call(this) || this;
          }
          /**
          *
          * @param {*} object
          * @return {boolean}
          */


          EmptySet.prototype.contains = function (object) {
            return false;
          };
          /**
          *
          * @return {*}
          */


          EmptySet.prototype.iterator = function () {
            return Collections.emptyIterator();
          };
          /**
          *
          * @return {number}
          */


          EmptySet.prototype.size = function () {
            return 0;
          };

          return EmptySet;
        }(java.util.AbstractSet);

        Collections.EmptySet = EmptySet;
        EmptySet["__class"] = "java.util.Collections.EmptySet";
        EmptySet["__interfaces"] = ["java.util.Collection", "java.util.Set", "java.lang.Iterable", "java.io.Serializable"];

        var EmptyMap =
        /** @class */
        function (_super) {
          __extends(EmptyMap, _super);

          function EmptyMap() {
            return _super.call(this) || this;
          }
          /**
          *
          * @param {*} key
          * @return {boolean}
          */


          EmptyMap.prototype.containsKey = function (key) {
            return false;
          };
          /**
          *
          * @param {*} value
          * @return {boolean}
          */


          EmptyMap.prototype.containsValue = function (value) {
            return false;
          };
          /**
          *
          * @return {*}
          */


          EmptyMap.prototype.entrySet = function () {
            return java.util.Collections.EMPTY_SET_$LI$();
          };
          /**
          *
          * @param {*} key
          * @return {*}
          */


          EmptyMap.prototype.get = function (key) {
            return null;
          };
          /**
          *
          * @return {*}
          */


          EmptyMap.prototype.keySet = function () {
            return java.util.Collections.EMPTY_SET_$LI$();
          };
          /**
          *
          * @return {number}
          */


          EmptyMap.prototype.size = function () {
            return 0;
          };
          /**
          *
          * @return {*}
          */


          EmptyMap.prototype.values = function () {
            return java.util.Collections.EMPTY_LIST_$LI$();
          };

          return EmptyMap;
        }(java.util.AbstractMap);

        Collections.EmptyMap = EmptyMap;
        EmptyMap["__class"] = "java.util.Collections.EmptyMap";
        EmptyMap["__interfaces"] = ["java.util.Map", "java.io.Serializable"];

        var ReverseComparator =
        /** @class */
        function () {
          function ReverseComparator() {}

          ReverseComparator.INSTANCE_$LI$ = function () {
            if (ReverseComparator.INSTANCE == null) {
              ReverseComparator.INSTANCE = new Collections.ReverseComparator();
            }

            return ReverseComparator.INSTANCE;
          };

          ReverseComparator.prototype.compare$java_lang_Comparable$java_lang_Comparable = function (o1, o2) {
            return o2.compareTo(o1);
          };
          /**
          *
          * @param {*} o1
          * @param {*} o2
          * @return {number}
          */


          ReverseComparator.prototype.compare = function (o1, o2) {
            if ((o1 != null && o1.constructor != null && o1.constructor["__interfaces"] != null && o1.constructor["__interfaces"].indexOf("java.lang.Comparable") >= 0 || o1 === null) && (o2 != null && o2.constructor != null && o2.constructor["__interfaces"] != null && o2.constructor["__interfaces"].indexOf("java.lang.Comparable") >= 0 || o2 === null)) {
              return this.compare$java_lang_Comparable$java_lang_Comparable(o1, o2);
            } else throw new Error('invalid overload');
          };

          return ReverseComparator;
        }();

        Collections.ReverseComparator = ReverseComparator;
        ReverseComparator["__class"] = "java.util.Collections.ReverseComparator";
        ReverseComparator["__interfaces"] = ["java.util.Comparator"];

        var SetFromMap =
        /** @class */
        function (_super) {
          __extends(SetFromMap, _super);

          function SetFromMap(map) {
            var _this = _super.call(this) || this;

            if (_this.backingMap === undefined) {
              _this.backingMap = null;
            }

            if (_this.__keySet === undefined) {
              _this.__keySet = null;
            }

            _this.backingMap = map;
            return _this;
          }
          /**
          *
          * @param {*} e
          * @return {boolean}
          */


          SetFromMap.prototype.add = function (e) {
            return this.backingMap.put(e, javaemul.internal.BooleanHelper.TRUE) == null;
          };
          /**
          *
          */


          SetFromMap.prototype.clear = function () {
            this.backingMap.clear();
          };
          /**
          *
          * @param {*} o
          * @return {boolean}
          */


          SetFromMap.prototype.contains = function (o) {
            return this.backingMap.containsKey(o);
          };
          /**
          *
          * @param {*} o
          * @return {boolean}
          */


          SetFromMap.prototype.equals = function (o) {
            return o === this ||
            /* equals */
            function (o1, o2) {
              if (o1 && o1.equals) {
                return o1.equals(o2);
              } else {
                return o1 === o2;
              }
            }(this.keySet(), o);
          };
          /**
          *
          * @return {number}
          */


          SetFromMap.prototype.hashCode = function () {
            return (
              /* hashCode */
              function (o) {
                if (o.hashCode) {
                  return o.hashCode();
                } else {
                  return o.toString().split('').reduce(function (prevHash, currVal) {
                    return (prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0;
                  }, 0);
                }
              }(this.keySet())
            );
          };
          /**
          *
          * @return {*}
          */


          SetFromMap.prototype.iterator = function () {
            return this.keySet().iterator();
          };
          /**
          *
          * @param {*} o
          * @return {boolean}
          */


          SetFromMap.prototype.remove = function (o) {
            return this.backingMap.remove(o) != null;
          };
          /**
          *
          * @return {number}
          */


          SetFromMap.prototype.size = function () {
            return this.keySet().size();
          };
          /**
          *
          * @return {string}
          */


          SetFromMap.prototype.toString = function () {
            return this.keySet().toString();
          };
          /**
          * Lazy initialize keySet to avoid NPE after deserialization.
          * @return {*}
          * @private
          */


          SetFromMap.prototype.keySet = function () {
            if (this.__keySet == null) {
              this.__keySet = this.backingMap.keySet();
            }

            return this.__keySet;
          };

          return SetFromMap;
        }(java.util.AbstractSet);

        Collections.SetFromMap = SetFromMap;
        SetFromMap["__class"] = "java.util.Collections.SetFromMap";
        SetFromMap["__interfaces"] = ["java.util.Collection", "java.util.Set", "java.lang.Iterable", "java.io.Serializable"];

        var SingletonList =
        /** @class */
        function (_super) {
          __extends(SingletonList, _super);

          function SingletonList(element) {
            var _this = _super.call(this) || this;

            if (_this.element === undefined) {
              _this.element = null;
            }

            _this.element = element;
            return _this;
          }
          /**
          *
          * @param {*} item
          * @return {boolean}
          */


          SingletonList.prototype.contains = function (item) {
            return java.util.Objects.equals(this.element, item);
          };
          /**
          *
          * @param {number} index
          * @return {*}
          */


          SingletonList.prototype.get = function (index) {
            javaemul.internal.InternalPreconditions.checkElementIndex(index, 1);
            return this.element;
          };
          /**
          *
          * @return {number}
          */


          SingletonList.prototype.size = function () {
            return 1;
          };

          return SingletonList;
        }(java.util.AbstractList);

        Collections.SingletonList = SingletonList;
        SingletonList["__class"] = "java.util.Collections.SingletonList";
        SingletonList["__interfaces"] = ["java.util.List", "java.util.Collection", "java.lang.Iterable", "java.io.Serializable"];

        var UnmodifiableCollection =
        /** @class */
        function () {
          function UnmodifiableCollection(coll) {
            if (this.coll === undefined) {
              this.coll = null;
            }

            this.coll = coll;
          }
          /* Default method injected from java.util.Collection */


          UnmodifiableCollection.prototype.stream = function () {
            return new javaemul.internal.stream.StreamHelper(this);
          };
          /* Default method injected from java.lang.Iterable */


          UnmodifiableCollection.prototype.forEach = function (action) {
            javaemul.internal.InternalPreconditions.checkNotNull(action);

            var _loop_25 = function _loop_25(index184) {
              var t = index184.next();
              {
                (function (target) {
                  return typeof target === 'function' ? target(t) : target.accept(t);
                })(action);
              }
            };

            for (var index184 = this.iterator(); index184.hasNext();) {
              _loop_25(index184);
            }
          };
          /* Default method injected from java.util.Collection */


          UnmodifiableCollection.prototype.parallelStream = function () {
            return this.stream();
          };
          /* Default method injected from java.util.Collection */


          UnmodifiableCollection.prototype.removeIf = function (filter) {
            javaemul.internal.InternalPreconditions.checkNotNull(filter);
            var removed = false;

            var _loop_26 = function _loop_26(it) {
              {
                if (function (target) {
                  return typeof target === 'function' ? target(it.next()) : target.test(it.next());
                }(filter)) {
                  it.remove();
                  removed = true;
                }
              }
            };

            for (var it = this.iterator(); it.hasNext();) {
              _loop_26(it);
            }

            return removed;
          };
          /**
          *
          * @param {*} o
          * @return {boolean}
          */


          UnmodifiableCollection.prototype.add = function (o) {
            throw new java.lang.UnsupportedOperationException();
          };
          /**
          *
          * @param {*} c
          * @return {boolean}
          */


          UnmodifiableCollection.prototype.addAll = function (c) {
            throw new java.lang.UnsupportedOperationException();
          };
          /**
          *
          */


          UnmodifiableCollection.prototype.clear = function () {
            throw new java.lang.UnsupportedOperationException();
          };
          /**
          *
          * @param {*} o
          * @return {boolean}
          */


          UnmodifiableCollection.prototype.contains = function (o) {
            return this.coll.contains(o);
          };
          /**
          *
          * @param {*} c
          * @return {boolean}
          */


          UnmodifiableCollection.prototype.containsAll = function (c) {
            return this.coll.containsAll(c);
          };
          /**
          *
          * @return {boolean}
          */


          UnmodifiableCollection.prototype.isEmpty = function () {
            return this.coll.isEmpty();
          };
          /**
          *
          * @return {*}
          */


          UnmodifiableCollection.prototype.iterator = function () {
            return new Collections.UnmodifiableCollectionIterator(this.coll.iterator());
          };
          /**
          *
          * @param {*} o
          * @return {boolean}
          */


          UnmodifiableCollection.prototype.remove = function (o) {
            throw new java.lang.UnsupportedOperationException();
          };
          /**
          *
          * @param {*} c
          * @return {boolean}
          */


          UnmodifiableCollection.prototype.removeAll = function (c) {
            throw new java.lang.UnsupportedOperationException();
          };
          /**
          *
          * @param {*} c
          * @return {boolean}
          */


          UnmodifiableCollection.prototype.retainAll = function (c) {
            throw new java.lang.UnsupportedOperationException();
          };
          /**
          *
          * @return {number}
          */


          UnmodifiableCollection.prototype.size = function () {
            return this.coll.size();
          };

          UnmodifiableCollection.prototype.toArray$ = function () {
            return this.coll['toArray$']();
          };

          UnmodifiableCollection.prototype.toArray$java_lang_Object_A = function (a) {
            return this.coll['toArray$java_lang_Object_A'](a);
          };
          /**
          *
          * @param {Array} a
          * @return {Array}
          */


          UnmodifiableCollection.prototype.toArray = function (a) {
            if (a != null && a instanceof Array && (a.length == 0 || a[0] == null || a[0] != null) || a === null) {
              return this.toArray$java_lang_Object_A(a);
            } else if (a === undefined) {
              return this.toArray$();
            } else throw new Error('invalid overload');
          };
          /**
          *
          * @return {string}
          */


          UnmodifiableCollection.prototype.toString = function () {
            return this.coll.toString();
          };

          return UnmodifiableCollection;
        }();

        Collections.UnmodifiableCollection = UnmodifiableCollection;
        UnmodifiableCollection["__class"] = "java.util.Collections.UnmodifiableCollection";
        UnmodifiableCollection["__interfaces"] = ["java.util.Collection", "java.lang.Iterable"];

        var UnmodifiableCollectionIterator =
        /** @class */
        function () {
          function UnmodifiableCollectionIterator(it) {
            if (this.it === undefined) {
              this.it = null;
            }

            this.it = it;
          }
          /* Default method injected from java.util.Iterator */


          UnmodifiableCollectionIterator.prototype.forEachRemaining = function (consumer) {
            var _this = this;

            javaemul.internal.InternalPreconditions.checkNotNull(consumer);

            while (this.hasNext()) {
              {
                (function (target) {
                  return typeof target === 'function' ? target(_this.next()) : target.accept(_this.next());
                })(consumer);
              }
            }
          };
          /**
          *
          * @return {boolean}
          */


          UnmodifiableCollectionIterator.prototype.hasNext = function () {
            return this.it.hasNext();
          };
          /**
          *
          * @return {*}
          */


          UnmodifiableCollectionIterator.prototype.next = function () {
            return this.it.next();
          };
          /**
          *
          */


          UnmodifiableCollectionIterator.prototype.remove = function () {
            throw new java.lang.UnsupportedOperationException();
          };

          return UnmodifiableCollectionIterator;
        }();

        Collections.UnmodifiableCollectionIterator = UnmodifiableCollectionIterator;
        UnmodifiableCollectionIterator["__class"] = "java.util.Collections.UnmodifiableCollectionIterator";
        UnmodifiableCollectionIterator["__interfaces"] = ["java.util.Iterator"];

        var RandomHolder =
        /** @class */
        function () {
          function RandomHolder() {}

          RandomHolder.rnd_$LI$ = function () {
            if (RandomHolder.rnd == null) {
              RandomHolder.rnd = new java.util.Random();
            }

            return RandomHolder.rnd;
          };

          return RandomHolder;
        }();

        Collections.RandomHolder = RandomHolder;
        RandomHolder["__class"] = "java.util.Collections.RandomHolder";

        var UnmodifiableList =
        /** @class */
        function (_super) {
          __extends(UnmodifiableList, _super);

          function UnmodifiableList(list) {
            var _this = _super.call(this, list) || this;

            if (_this.list === undefined) {
              _this.list = null;
            }

            _this.list = list;
            return _this;
          }
          /* Default method injected from java.util.Collection */


          UnmodifiableList.prototype.stream = function () {
            return new javaemul.internal.stream.StreamHelper(this);
          };
          /* Default method injected from java.lang.Iterable */


          UnmodifiableList.prototype.forEach = function (action) {
            javaemul.internal.InternalPreconditions.checkNotNull(action);

            var _loop_27 = function _loop_27(index185) {
              var t = index185.next();
              {
                (function (target) {
                  return typeof target === 'function' ? target(t) : target.accept(t);
                })(action);
              }
            };

            for (var index185 = this.iterator(); index185.hasNext();) {
              _loop_27(index185);
            }
          };
          /* Default method injected from java.util.Collection */


          UnmodifiableList.prototype.parallelStream = function () {
            return this.stream();
          };
          /* Default method injected from java.util.List */


          UnmodifiableList.prototype.sort = function (c) {
            var a = this.toArray();
            java.util.Arrays.sort(a, c);
            var i = this.listIterator();

            for (var index186 = 0; index186 < a.length; index186++) {
              var e = a[index186];
              {
                i.next();
                i.set(e);
              }
            }
          };
          /* Default method injected from java.util.Collection */


          UnmodifiableList.prototype.removeIf = function (filter) {
            javaemul.internal.InternalPreconditions.checkNotNull(filter);
            var removed = false;

            var _loop_28 = function _loop_28(it) {
              {
                if (function (target) {
                  return typeof target === 'function' ? target(it.next()) : target.test(it.next());
                }(filter)) {
                  it.remove();
                  removed = true;
                }
              }
            };

            for (var it = this.iterator(); it.hasNext();) {
              _loop_28(it);
            }

            return removed;
          };

          UnmodifiableList.prototype.add$int$java_lang_Object = function (index, element) {
            throw new java.lang.UnsupportedOperationException();
          };
          /**
          *
          * @param {number} index
          * @param {*} element
          */


          UnmodifiableList.prototype.add = function (index, element) {
            if ((typeof index === 'number' || index === null) && (element != null || element === null)) {
              return this.add$int$java_lang_Object(index, element);
            } else if ((index != null || index === null) && element === undefined) {
              _super.prototype.add.call(this, index);
            } else throw new Error('invalid overload');
          };

          UnmodifiableList.prototype.addAll$int$java_util_Collection = function (index, c) {
            throw new java.lang.UnsupportedOperationException();
          };
          /**
          *
          * @param {number} index
          * @param {*} c
          * @return {boolean}
          */


          UnmodifiableList.prototype.addAll = function (index, c) {
            if ((typeof index === 'number' || index === null) && (c != null && c.constructor != null && c.constructor["__interfaces"] != null && c.constructor["__interfaces"].indexOf("java.util.Collection") >= 0 || c === null)) {
              return this.addAll$int$java_util_Collection(index, c);
            } else if ((index != null && index.constructor != null && index.constructor["__interfaces"] != null && index.constructor["__interfaces"].indexOf("java.util.Collection") >= 0 || index === null) && c === undefined) {
              return _super.prototype.addAll.call(this, index);
            } else throw new Error('invalid overload');
          };
          /**
          *
          * @param {*} o
          * @return {boolean}
          */


          UnmodifiableList.prototype.equals = function (o) {
            return (
              /* equals */
              function (o1, o2) {
                if (o1 && o1.equals) {
                  return o1.equals(o2);
                } else {
                  return o1 === o2;
                }
              }(this.list, o)
            );
          };
          /**
          *
          * @param {number} index
          * @return {*}
          */


          UnmodifiableList.prototype.get = function (index) {
            return this.list.get(index);
          };
          /**
          *
          * @return {number}
          */


          UnmodifiableList.prototype.hashCode = function () {
            return (
              /* hashCode */
              function (o) {
                if (o.hashCode) {
                  return o.hashCode();
                } else {
                  return o.toString().split('').reduce(function (prevHash, currVal) {
                    return (prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0;
                  }, 0);
                }
              }(this.list)
            );
          };
          /**
          *
          * @param {*} o
          * @return {number}
          */


          UnmodifiableList.prototype.indexOf = function (o) {
            return this.list.indexOf(o);
          };
          /**
          *
          * @return {boolean}
          */


          UnmodifiableList.prototype.isEmpty = function () {
            return this.list.isEmpty();
          };
          /**
          *
          * @param {*} o
          * @return {number}
          */


          UnmodifiableList.prototype.lastIndexOf = function (o) {
            return this.list.lastIndexOf(o);
          };

          UnmodifiableList.prototype.listIterator$ = function () {
            return this.listIterator$int(0);
          };

          UnmodifiableList.prototype.listIterator$int = function (from) {
            return new Collections.UnmodifiableListIterator(this.list['listIterator$int'](from));
          };
          /**
          *
          * @param {number} from
          * @return {*}
          */


          UnmodifiableList.prototype.listIterator = function (from) {
            if (typeof from === 'number' || from === null) {
              return this.listIterator$int(from);
            } else if (from === undefined) {
              return this.listIterator$();
            } else throw new Error('invalid overload');
          };

          UnmodifiableList.prototype.remove$int = function (index) {
            throw new java.lang.UnsupportedOperationException();
          };
          /**
          *
          * @param {number} index
          * @return {*}
          */


          UnmodifiableList.prototype.remove = function (index) {
            if (typeof index === 'number' || index === null) {
              return this.remove$int(index);
            } else if (index != null || index === null) {
              return _super.prototype.remove.call(this, index);
            } else throw new Error('invalid overload');
          };
          /**
          *
          * @param {number} index
          * @param {*} element
          * @return {*}
          */


          UnmodifiableList.prototype.set = function (index, element) {
            throw new java.lang.UnsupportedOperationException();
          };
          /**
          *
          * @param {number} fromIndex
          * @param {number} toIndex
          * @return {*}
          */


          UnmodifiableList.prototype.subList = function (fromIndex, toIndex) {
            return new Collections.UnmodifiableList(this.list.subList(fromIndex, toIndex));
          };

          return UnmodifiableList;
        }(Collections.UnmodifiableCollection);

        Collections.UnmodifiableList = UnmodifiableList;
        UnmodifiableList["__class"] = "java.util.Collections.UnmodifiableList";
        UnmodifiableList["__interfaces"] = ["java.util.List", "java.util.Collection", "java.lang.Iterable"];

        var UnmodifiableSet =
        /** @class */
        function (_super) {
          __extends(UnmodifiableSet, _super);

          function UnmodifiableSet(set) {
            return _super.call(this, set) || this;
          }
          /* Default method injected from java.util.Collection */


          UnmodifiableSet.prototype.stream = function () {
            return new javaemul.internal.stream.StreamHelper(this);
          };
          /* Default method injected from java.lang.Iterable */


          UnmodifiableSet.prototype.forEach = function (action) {
            javaemul.internal.InternalPreconditions.checkNotNull(action);

            var _loop_29 = function _loop_29(index187) {
              var t = index187.next();
              {
                (function (target) {
                  return typeof target === 'function' ? target(t) : target.accept(t);
                })(action);
              }
            };

            for (var index187 = this.iterator(); index187.hasNext();) {
              _loop_29(index187);
            }
          };
          /* Default method injected from java.util.Collection */


          UnmodifiableSet.prototype.parallelStream = function () {
            return this.stream();
          };
          /* Default method injected from java.util.Collection */


          UnmodifiableSet.prototype.removeIf = function (filter) {
            javaemul.internal.InternalPreconditions.checkNotNull(filter);
            var removed = false;

            var _loop_30 = function _loop_30(it) {
              {
                if (function (target) {
                  return typeof target === 'function' ? target(it.next()) : target.test(it.next());
                }(filter)) {
                  it.remove();
                  removed = true;
                }
              }
            };

            for (var it = this.iterator(); it.hasNext();) {
              _loop_30(it);
            }

            return removed;
          };
          /**
          *
          * @param {*} o
          * @return {boolean}
          */


          UnmodifiableSet.prototype.equals = function (o) {
            return (
              /* equals */
              function (o1, o2) {
                if (o1 && o1.equals) {
                  return o1.equals(o2);
                } else {
                  return o1 === o2;
                }
              }(this.coll, o)
            );
          };
          /**
          *
          * @return {number}
          */


          UnmodifiableSet.prototype.hashCode = function () {
            return (
              /* hashCode */
              function (o) {
                if (o.hashCode) {
                  return o.hashCode();
                } else {
                  return o.toString().split('').reduce(function (prevHash, currVal) {
                    return (prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0;
                  }, 0);
                }
              }(this.coll)
            );
          };

          return UnmodifiableSet;
        }(Collections.UnmodifiableCollection);

        Collections.UnmodifiableSet = UnmodifiableSet;
        UnmodifiableSet["__class"] = "java.util.Collections.UnmodifiableSet";
        UnmodifiableSet["__interfaces"] = ["java.util.Collection", "java.util.Set", "java.lang.Iterable"];

        var UnmodifiableListIterator =
        /** @class */
        function (_super) {
          __extends(UnmodifiableListIterator, _super);

          function UnmodifiableListIterator(lit) {
            var _this = _super.call(this, lit) || this;

            if (_this.lit === undefined) {
              _this.lit = null;
            }

            _this.lit = lit;
            return _this;
          }
          /* Default method injected from java.util.Iterator */


          UnmodifiableListIterator.prototype.forEachRemaining = function (consumer) {
            var _this = this;

            javaemul.internal.InternalPreconditions.checkNotNull(consumer);

            while (this.hasNext()) {
              {
                (function (target) {
                  return typeof target === 'function' ? target(_this.next()) : target.accept(_this.next());
                })(consumer);
              }
            }
          };
          /**
          *
          * @param {*} o
          */


          UnmodifiableListIterator.prototype.add = function (o) {
            throw new java.lang.UnsupportedOperationException();
          };
          /**
          *
          * @return {boolean}
          */


          UnmodifiableListIterator.prototype.hasPrevious = function () {
            return this.lit.hasPrevious();
          };
          /**
          *
          * @return {number}
          */


          UnmodifiableListIterator.prototype.nextIndex = function () {
            return this.lit.nextIndex();
          };
          /**
          *
          * @return {*}
          */


          UnmodifiableListIterator.prototype.previous = function () {
            return this.lit.previous();
          };
          /**
          *
          * @return {number}
          */


          UnmodifiableListIterator.prototype.previousIndex = function () {
            return this.lit.previousIndex();
          };
          /**
          *
          * @param {*} o
          */


          UnmodifiableListIterator.prototype.set = function (o) {
            throw new java.lang.UnsupportedOperationException();
          };

          return UnmodifiableListIterator;
        }(Collections.UnmodifiableCollectionIterator);

        Collections.UnmodifiableListIterator = UnmodifiableListIterator;
        UnmodifiableListIterator["__class"] = "java.util.Collections.UnmodifiableListIterator";
        UnmodifiableListIterator["__interfaces"] = ["java.util.Iterator", "java.util.ListIterator"];

        var UnmodifiableRandomAccessList =
        /** @class */
        function (_super) {
          __extends(UnmodifiableRandomAccessList, _super);

          function UnmodifiableRandomAccessList(list) {
            return _super.call(this, list) || this;
          }

          return UnmodifiableRandomAccessList;
        }(Collections.UnmodifiableList);

        Collections.UnmodifiableRandomAccessList = UnmodifiableRandomAccessList;
        UnmodifiableRandomAccessList["__class"] = "java.util.Collections.UnmodifiableRandomAccessList";
        UnmodifiableRandomAccessList["__interfaces"] = ["java.util.RandomAccess", "java.util.List", "java.util.Collection", "java.lang.Iterable"];

        var UnmodifiableMap =
        /** @class */
        function () {
          function UnmodifiableMap(map) {
            if (this.__entrySet === undefined) {
              this.__entrySet = null;
            }

            if (this.__keySet === undefined) {
              this.__keySet = null;
            }

            if (this.map === undefined) {
              this.map = null;
            }

            if (this.__values === undefined) {
              this.__values = null;
            }

            this.map = map;
          }
          /* Default method injected from java.util.Map */


          UnmodifiableMap.prototype.putIfAbsent = function (key, value) {
            var v = this.get(key);

            if (v == null) {
              v = this.put(key, value);
            }

            return v;
          };
          /* Default method injected from java.util.Map */


          UnmodifiableMap.prototype.computeIfAbsent = function (key, mappingFunction) {
            var result;

            if ((result = this.get(key)) == null) {
              result = function (target) {
                return typeof target === 'function' ? target(key) : target.apply(key);
              }(mappingFunction);

              if (result != null) this.put(key, result);
            }

            return result;
          };
          /* Default method injected from java.util.Map */


          UnmodifiableMap.prototype.merge = function (key, value, map) {
            var old = this.get(key);
            var next = old == null ? value : function (target) {
              return typeof target === 'function' ? target(old, value) : target.apply(old, value);
            }(map);

            if (next == null) {
              this.remove(key);
            } else {
              this.put(key, next);
            }

            return next;
          };
          /* Default method injected from java.util.Map */


          UnmodifiableMap.prototype.getOrDefault = function (key, defaultValue) {
            var v;
            return (v = this.get(key)) != null || this.containsKey(key) ? v : defaultValue;
          };
          /* Default method injected from java.util.Map */


          UnmodifiableMap.prototype.replaceAll = function (__function) {
            java.util.Objects.requireNonNull(__function);

            var _loop_31 = function _loop_31(index188) {
              var entry = index188.next();
              {
                var k_3;
                var v_3;

                try {
                  k_3 = entry.getKey();
                  v_3 = entry.getValue();
                } catch (ise) {
                  throw new java.lang.RuntimeException(ise);
                }

                v_3 = function (target) {
                  return typeof target === 'function' ? target(k_3, v_3) : target.apply(k_3, v_3);
                }(__function);

                try {
                  entry.setValue(v_3);
                } catch (ise) {
                  throw new java.lang.RuntimeException(ise);
                }
              }
            };

            for (var index188 = this.entrySet().iterator(); index188.hasNext();) {
              _loop_31(index188);
            }
          };
          /**
          *
          */


          UnmodifiableMap.prototype.clear = function () {
            throw new java.lang.UnsupportedOperationException();
          };
          /**
          *
          * @param {*} key
          * @return {boolean}
          */


          UnmodifiableMap.prototype.containsKey = function (key) {
            return this.map.containsKey(key);
          };
          /**
          *
          * @param {*} val
          * @return {boolean}
          */


          UnmodifiableMap.prototype.containsValue = function (val) {
            return this.map.containsValue(val);
          };
          /**
          *
          * @return {*}
          */


          UnmodifiableMap.prototype.entrySet = function () {
            if (this.__entrySet == null) {
              this.__entrySet = new UnmodifiableMap.UnmodifiableEntrySet(this.map.entrySet());
            }

            return this.__entrySet;
          };
          /**
          *
          * @param {*} o
          * @return {boolean}
          */


          UnmodifiableMap.prototype.equals = function (o) {
            return (
              /* equals */
              function (o1, o2) {
                if (o1 && o1.equals) {
                  return o1.equals(o2);
                } else {
                  return o1 === o2;
                }
              }(this.map, o)
            );
          };
          /**
          *
          * @param {*} key
          * @return {*}
          */


          UnmodifiableMap.prototype.get = function (key) {
            return this.map.get(key);
          };
          /**
          *
          * @return {number}
          */


          UnmodifiableMap.prototype.hashCode = function () {
            return (
              /* hashCode */
              function (o) {
                if (o.hashCode) {
                  return o.hashCode();
                } else {
                  return o.toString().split('').reduce(function (prevHash, currVal) {
                    return (prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0;
                  }, 0);
                }
              }(this.map)
            );
          };
          /**
          *
          * @return {boolean}
          */


          UnmodifiableMap.prototype.isEmpty = function () {
            return this.map.isEmpty();
          };
          /**
          *
          * @return {*}
          */


          UnmodifiableMap.prototype.keySet = function () {
            if (this.__keySet == null) {
              this.__keySet = new Collections.UnmodifiableSet(this.map.keySet());
            }

            return this.__keySet;
          };
          /**
          *
          * @param {*} key
          * @param {*} value
          * @return {*}
          */


          UnmodifiableMap.prototype.put = function (key, value) {
            throw new java.lang.UnsupportedOperationException();
          };
          /**
          *
          * @param {*} t
          */


          UnmodifiableMap.prototype.putAll = function (t) {
            throw new java.lang.UnsupportedOperationException();
          };
          /**
          *
          * @param {*} key
          * @return {*}
          */


          UnmodifiableMap.prototype.remove = function (key) {
            throw new java.lang.UnsupportedOperationException();
          };
          /**
          *
          * @return {number}
          */


          UnmodifiableMap.prototype.size = function () {
            return this.map.size();
          };
          /**
          *
          * @return {string}
          */


          UnmodifiableMap.prototype.toString = function () {
            return this.map.toString();
          };
          /**
          *
          * @return {*}
          */


          UnmodifiableMap.prototype.values = function () {
            if (this.__values == null) {
              this.__values = new Collections.UnmodifiableCollection(this.map.values());
            }

            return this.__values;
          };

          return UnmodifiableMap;
        }();

        Collections.UnmodifiableMap = UnmodifiableMap;
        UnmodifiableMap["__class"] = "java.util.Collections.UnmodifiableMap";
        UnmodifiableMap["__interfaces"] = ["java.util.Map"];

        (function (UnmodifiableMap) {
          var UnmodifiableEntrySet =
          /** @class */
          function (_super) {
            __extends(UnmodifiableEntrySet, _super);

            function UnmodifiableEntrySet(s) {
              return _super.call(this, s) || this;
            }
            /**
            *
            * @param {*} o
            * @return {boolean}
            */


            UnmodifiableEntrySet.prototype.contains = function (o) {
              return this.coll.contains(o);
            };
            /**
            *
            * @param {*} o
            * @return {boolean}
            */


            UnmodifiableEntrySet.prototype.containsAll = function (o) {
              return this.coll.containsAll(o);
            };
            /**
            *
            * @return {*}
            */


            UnmodifiableEntrySet.prototype.iterator = function () {
              var it = this.coll.iterator();
              return new UnmodifiableEntrySet.UnmodifiableEntrySet$0(this, it);
            };

            UnmodifiableEntrySet.prototype.toArray$ = function () {
              var array = _super.prototype.toArray$.call(this);

              this.wrap(array, array.length);
              return array;
            };

            UnmodifiableEntrySet.prototype.toArray$java_lang_Object_A = function (a) {
              var result = _super.prototype.toArray$java_lang_Object_A.call(this, a);

              this.wrap(result, this.coll.size());
              return result;
            };
            /**
            *
            * @param {Array} a
            * @return {Array}
            */


            UnmodifiableEntrySet.prototype.toArray = function (a) {
              if (a != null && a instanceof Array && (a.length == 0 || a[0] == null || a[0] != null) || a === null) {
                return this.toArray$java_lang_Object_A(a);
              } else if (a === undefined) {
                return this.toArray$();
              } else throw new Error('invalid overload');
            };
            /**
            * Wrap an array of Map.Entries as UnmodifiableEntries.
            *
            * @param {Array} array
            * array to wrap
            * @param {number} size
            * number of entries to wrap
            * @private
            */


            UnmodifiableEntrySet.prototype.wrap = function (array, size) {
              for (var i = 0; i < size; ++i) {
                {
                  array[i] = new UnmodifiableEntrySet.UnmodifiableEntry(array[i]);
                }
              }
            };

            return UnmodifiableEntrySet;
          }(Collections.UnmodifiableSet);

          UnmodifiableMap.UnmodifiableEntrySet = UnmodifiableEntrySet;
          UnmodifiableEntrySet["__class"] = "java.util.Collections.UnmodifiableMap.UnmodifiableEntrySet";
          UnmodifiableEntrySet["__interfaces"] = ["java.util.Collection", "java.util.Set", "java.lang.Iterable"];

          (function (UnmodifiableEntrySet) {
            var UnmodifiableEntry =
            /** @class */
            function () {
              function UnmodifiableEntry(entry) {
                if (this.entry === undefined) {
                  this.entry = null;
                }

                this.entry = entry;
              }
              /**
              *
              * @param {*} o
              * @return {boolean}
              */


              UnmodifiableEntry.prototype.equals = function (o) {
                return (
                  /* equals */
                  function (o1, o2) {
                    if (o1 && o1.equals) {
                      return o1.equals(o2);
                    } else {
                      return o1 === o2;
                    }
                  }(this.entry, o)
                );
              };
              /**
              *
              * @return {*}
              */


              UnmodifiableEntry.prototype.getKey = function () {
                return this.entry.getKey();
              };
              /**
              *
              * @return {*}
              */


              UnmodifiableEntry.prototype.getValue = function () {
                return this.entry.getValue();
              };
              /**
              *
              * @return {number}
              */


              UnmodifiableEntry.prototype.hashCode = function () {
                return (
                  /* hashCode */
                  function (o) {
                    if (o.hashCode) {
                      return o.hashCode();
                    } else {
                      return o.toString().split('').reduce(function (prevHash, currVal) {
                        return (prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0;
                      }, 0);
                    }
                  }(this.entry)
                );
              };
              /**
              *
              * @param {*} value
              * @return {*}
              */


              UnmodifiableEntry.prototype.setValue = function (value) {
                throw new java.lang.UnsupportedOperationException();
              };
              /**
              *
              * @return {string}
              */


              UnmodifiableEntry.prototype.toString = function () {
                return this.entry.toString();
              };

              return UnmodifiableEntry;
            }();

            UnmodifiableEntrySet.UnmodifiableEntry = UnmodifiableEntry;
            UnmodifiableEntry["__class"] = "java.util.Collections.UnmodifiableMap.UnmodifiableEntrySet.UnmodifiableEntry";
            UnmodifiableEntry["__interfaces"] = ["java.util.Map.Entry"];

            var UnmodifiableEntrySet$0 =
            /** @class */
            function () {
              function UnmodifiableEntrySet$0(__parent, it) {
                this.it = it;
                this.__parent = __parent;
              }
              /* Default method injected from java.util.Iterator */


              UnmodifiableEntrySet$0.prototype.forEachRemaining = function (consumer) {
                var _this = this;

                javaemul.internal.InternalPreconditions.checkNotNull(consumer);

                while (this.hasNext()) {
                  {
                    (function (target) {
                      return typeof target === 'function' ? target(_this.next()) : target.accept(_this.next());
                    })(consumer);
                  }
                }
              };
              /**
              *
              * @return {boolean}
              */


              UnmodifiableEntrySet$0.prototype.hasNext = function () {
                return this.it.hasNext();
              };
              /**
              *
              * @return {*}
              */


              UnmodifiableEntrySet$0.prototype.next = function () {
                return new UnmodifiableEntrySet.UnmodifiableEntry(this.it.next());
              };
              /**
              *
              */


              UnmodifiableEntrySet$0.prototype.remove = function () {
                throw new java.lang.UnsupportedOperationException();
              };

              return UnmodifiableEntrySet$0;
            }();

            UnmodifiableEntrySet.UnmodifiableEntrySet$0 = UnmodifiableEntrySet$0;
            UnmodifiableEntrySet$0["__interfaces"] = ["java.util.Iterator"];
          })(UnmodifiableEntrySet = UnmodifiableMap.UnmodifiableEntrySet || (UnmodifiableMap.UnmodifiableEntrySet = {}));
        })(UnmodifiableMap = Collections.UnmodifiableMap || (Collections.UnmodifiableMap = {}));

        var UnmodifiableSortedSet =
        /** @class */
        function (_super) {
          __extends(UnmodifiableSortedSet, _super);

          function UnmodifiableSortedSet(sortedSet) {
            var _this = _super.call(this, sortedSet) || this;

            if (_this.sortedSet === undefined) {
              _this.sortedSet = null;
            }

            _this.sortedSet = sortedSet;
            return _this;
          }
          /* Default method injected from java.util.Collection */


          UnmodifiableSortedSet.prototype.stream = function () {
            return new javaemul.internal.stream.StreamHelper(this);
          };
          /* Default method injected from java.lang.Iterable */


          UnmodifiableSortedSet.prototype.forEach = function (action) {
            javaemul.internal.InternalPreconditions.checkNotNull(action);

            var _loop_32 = function _loop_32(index189) {
              var t = index189.next();
              {
                (function (target) {
                  return typeof target === 'function' ? target(t) : target.accept(t);
                })(action);
              }
            };

            for (var index189 = this.iterator(); index189.hasNext();) {
              _loop_32(index189);
            }
          };
          /* Default method injected from java.util.Collection */


          UnmodifiableSortedSet.prototype.parallelStream = function () {
            return this.stream();
          };
          /* Default method injected from java.util.Collection */


          UnmodifiableSortedSet.prototype.removeIf = function (filter) {
            javaemul.internal.InternalPreconditions.checkNotNull(filter);
            var removed = false;

            var _loop_33 = function _loop_33(it) {
              {
                if (function (target) {
                  return typeof target === 'function' ? target(it.next()) : target.test(it.next());
                }(filter)) {
                  it.remove();
                  removed = true;
                }
              }
            };

            for (var it = this.iterator(); it.hasNext();) {
              _loop_33(it);
            }

            return removed;
          };
          /**
          *
          * @return {*}
          */


          UnmodifiableSortedSet.prototype.comparator = function () {
            return this.sortedSet.comparator();
          };
          /**
          *
          * @param {*} o
          * @return {boolean}
          */


          UnmodifiableSortedSet.prototype.equals = function (o) {
            return (
              /* equals */
              function (o1, o2) {
                if (o1 && o1.equals) {
                  return o1.equals(o2);
                } else {
                  return o1 === o2;
                }
              }(this.sortedSet, o)
            );
          };
          /**
          *
          * @return {*}
          */


          UnmodifiableSortedSet.prototype.first = function () {
            return this.sortedSet.first();
          };
          /**
          *
          * @return {number}
          */


          UnmodifiableSortedSet.prototype.hashCode = function () {
            return (
              /* hashCode */
              function (o) {
                if (o.hashCode) {
                  return o.hashCode();
                } else {
                  return o.toString().split('').reduce(function (prevHash, currVal) {
                    return (prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0;
                  }, 0);
                }
              }(this.sortedSet)
            );
          };
          /**
          *
          * @param {*} toElement
          * @return {*}
          */


          UnmodifiableSortedSet.prototype.headSet = function (toElement) {
            return new Collections.UnmodifiableSortedSet(this.sortedSet.headSet(toElement));
          };
          /**
          *
          * @return {*}
          */


          UnmodifiableSortedSet.prototype.last = function () {
            return this.sortedSet.last();
          };
          /**
          *
          * @param {*} fromElement
          * @param {*} toElement
          * @return {*}
          */


          UnmodifiableSortedSet.prototype.subSet = function (fromElement, toElement) {
            return new Collections.UnmodifiableSortedSet(this.sortedSet.subSet(fromElement, toElement));
          };
          /**
          *
          * @param {*} fromElement
          * @return {*}
          */


          UnmodifiableSortedSet.prototype.tailSet = function (fromElement) {
            return new Collections.UnmodifiableSortedSet(this.sortedSet.tailSet(fromElement));
          };

          return UnmodifiableSortedSet;
        }(Collections.UnmodifiableSet);

        Collections.UnmodifiableSortedSet = UnmodifiableSortedSet;
        UnmodifiableSortedSet["__class"] = "java.util.Collections.UnmodifiableSortedSet";
        UnmodifiableSortedSet["__interfaces"] = ["java.util.SortedSet", "java.util.Collection", "java.util.Set", "java.lang.Iterable"];

        var UnmodifiableSortedMap =
        /** @class */
        function (_super) {
          __extends(UnmodifiableSortedMap, _super);

          function UnmodifiableSortedMap(sortedMap) {
            var _this = _super.call(this, sortedMap) || this;

            if (_this.sortedMap === undefined) {
              _this.sortedMap = null;
            }

            _this.sortedMap = sortedMap;
            return _this;
          }
          /* Default method injected from java.util.Map */


          UnmodifiableSortedMap.prototype.putIfAbsent = function (key, value) {
            var v = this.get(key);

            if (v == null) {
              v = this.put(key, value);
            }

            return v;
          };
          /* Default method injected from java.util.Map */


          UnmodifiableSortedMap.prototype.computeIfAbsent = function (key, mappingFunction) {
            var result;

            if ((result = this.get(key)) == null) {
              result = function (target) {
                return typeof target === 'function' ? target(key) : target.apply(key);
              }(mappingFunction);

              if (result != null) this.put(key, result);
            }

            return result;
          };
          /* Default method injected from java.util.Map */


          UnmodifiableSortedMap.prototype.merge = function (key, value, map) {
            var old = this.get(key);
            var next = old == null ? value : function (target) {
              return typeof target === 'function' ? target(old, value) : target.apply(old, value);
            }(map);

            if (next == null) {
              this.remove(key);
            } else {
              this.put(key, next);
            }

            return next;
          };
          /* Default method injected from java.util.Map */


          UnmodifiableSortedMap.prototype.getOrDefault = function (key, defaultValue) {
            var v;
            return (v = this.get(key)) != null || this.containsKey(key) ? v : defaultValue;
          };
          /* Default method injected from java.util.Map */


          UnmodifiableSortedMap.prototype.replaceAll = function (__function) {
            java.util.Objects.requireNonNull(__function);

            var _loop_34 = function _loop_34(index190) {
              var entry = index190.next();
              {
                var k_4;
                var v_4;

                try {
                  k_4 = entry.getKey();
                  v_4 = entry.getValue();
                } catch (ise) {
                  throw new java.lang.RuntimeException(ise);
                }

                v_4 = function (target) {
                  return typeof target === 'function' ? target(k_4, v_4) : target.apply(k_4, v_4);
                }(__function);

                try {
                  entry.setValue(v_4);
                } catch (ise) {
                  throw new java.lang.RuntimeException(ise);
                }
              }
            };

            for (var index190 = this.entrySet().iterator(); index190.hasNext();) {
              _loop_34(index190);
            }
          };
          /**
          *
          * @return {*}
          */


          UnmodifiableSortedMap.prototype.comparator = function () {
            return this.sortedMap.comparator();
          };
          /**
          *
          * @param {*} o
          * @return {boolean}
          */


          UnmodifiableSortedMap.prototype.equals = function (o) {
            return (
              /* equals */
              function (o1, o2) {
                if (o1 && o1.equals) {
                  return o1.equals(o2);
                } else {
                  return o1 === o2;
                }
              }(this.sortedMap, o)
            );
          };
          /**
          *
          * @return {*}
          */


          UnmodifiableSortedMap.prototype.firstKey = function () {
            return this.sortedMap.firstKey();
          };
          /**
          *
          * @return {number}
          */


          UnmodifiableSortedMap.prototype.hashCode = function () {
            return (
              /* hashCode */
              function (o) {
                if (o.hashCode) {
                  return o.hashCode();
                } else {
                  return o.toString().split('').reduce(function (prevHash, currVal) {
                    return (prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0;
                  }, 0);
                }
              }(this.sortedMap)
            );
          };
          /**
          *
          * @param {*} toKey
          * @return {*}
          */


          UnmodifiableSortedMap.prototype.headMap = function (toKey) {
            return new Collections.UnmodifiableSortedMap(this.sortedMap.headMap(toKey));
          };
          /**
          *
          * @return {*}
          */


          UnmodifiableSortedMap.prototype.lastKey = function () {
            return this.sortedMap.lastKey();
          };
          /**
          *
          * @param {*} fromKey
          * @param {*} toKey
          * @return {*}
          */


          UnmodifiableSortedMap.prototype.subMap = function (fromKey, toKey) {
            return new Collections.UnmodifiableSortedMap(this.sortedMap.subMap(fromKey, toKey));
          };
          /**
          *
          * @param {*} fromKey
          * @return {*}
          */


          UnmodifiableSortedMap.prototype.tailMap = function (fromKey) {
            return new Collections.UnmodifiableSortedMap(this.sortedMap.tailMap(fromKey));
          };

          return UnmodifiableSortedMap;
        }(Collections.UnmodifiableMap);

        Collections.UnmodifiableSortedMap = UnmodifiableSortedMap;
        UnmodifiableSortedMap["__class"] = "java.util.Collections.UnmodifiableSortedMap";
        UnmodifiableSortedMap["__interfaces"] = ["java.util.Map", "java.util.SortedMap"];

        var Collections$0 =
        /** @class */
        function () {
          function Collections$0(it) {
            this.it = it;
          }
          /**
          *
          * @return {boolean}
          */


          Collections$0.prototype.hasMoreElements = function () {
            return this.it.hasNext();
          };
          /**
          *
          * @return {*}
          */


          Collections$0.prototype.nextElement = function () {
            return this.it.next();
          };

          return Collections$0;
        }();

        Collections.Collections$0 = Collections$0;
        Collections$0["__interfaces"] = ["java.util.Enumeration"];
      })(Collections = util.Collections || (util.Collections = {}));
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * Hash table and linked-list implementation of the Set interface with
      * predictable iteration order. <a
      * href="http://java.sun.com/j2se/1.5.0/docs/api/java/util/LinkedHashSet.html">[Sun
      * docs]</a>
      *
      * @param <E> element type.
      * @param {number} ignored
      * @param {number} alsoIgnored
      * @class
      * @extends java.util.HashSet
      */
      var LinkedHashSet =
      /** @class */
      function (_super) {
        __extends(LinkedHashSet, _super);

        function LinkedHashSet(ignored, alsoIgnored) {
          var _this = this;

          if ((typeof ignored === 'number' || ignored === null) && (typeof alsoIgnored === 'number' || alsoIgnored === null)) {
            var __args = arguments;
            _this = _super.call(this, new java.util.LinkedHashMap(ignored, alsoIgnored)) || this;
          } else if ((ignored != null && ignored.constructor != null && ignored.constructor["__interfaces"] != null && ignored.constructor["__interfaces"].indexOf("java.util.Collection") >= 0 || ignored === null) && alsoIgnored === undefined) {
            var __args = arguments;
            var c = __args[0];
            _this = _super.call(this, new java.util.LinkedHashMap()) || this;

            _this.addAll(c);
          } else if ((typeof ignored === 'number' || ignored === null) && alsoIgnored === undefined) {
            var __args = arguments;
            _this = _super.call(this, new java.util.LinkedHashMap(ignored)) || this;
          } else if (ignored === undefined && alsoIgnored === undefined) {
            var __args = arguments;
            _this = _super.call(this, new java.util.LinkedHashMap()) || this;
          } else throw new Error('invalid overload');

          return _this;
        }
        /* Default method injected from java.util.Collection */


        LinkedHashSet.prototype.stream = function () {
          return new javaemul.internal.stream.StreamHelper(this);
        };
        /* Default method injected from java.lang.Iterable */


        LinkedHashSet.prototype.forEach = function (action) {
          javaemul.internal.InternalPreconditions.checkNotNull(action);

          var _loop_35 = function _loop_35(index191) {
            var t = index191.next();
            {
              (function (target) {
                return typeof target === 'function' ? target(t) : target.accept(t);
              })(action);
            }
          };

          for (var index191 = this.iterator(); index191.hasNext();) {
            _loop_35(index191);
          }
        };
        /* Default method injected from java.util.Collection */


        LinkedHashSet.prototype.parallelStream = function () {
          return this.stream();
        };
        /* Default method injected from java.util.Collection */


        LinkedHashSet.prototype.removeIf = function (filter) {
          javaemul.internal.InternalPreconditions.checkNotNull(filter);
          var removed = false;

          var _loop_36 = function _loop_36(it) {
            {
              if (function (target) {
                return typeof target === 'function' ? target(it.next()) : target.test(it.next());
              }(filter)) {
                it.remove();
                removed = true;
              }
            }
          };

          for (var it = this.iterator(); it.hasNext();) {
            _loop_36(it);
          }

          return removed;
        };
        /**
        *
        * @return {*}
        */


        LinkedHashSet.prototype.clone = function () {
          return new LinkedHashSet(this);
        };

        return LinkedHashSet;
      }(java.util.HashSet);

      util.LinkedHashSet = LinkedHashSet;
      LinkedHashSet["__class"] = "java.util.LinkedHashSet";
      LinkedHashSet["__interfaces"] = ["java.lang.Cloneable", "java.util.Collection", "java.util.Set", "java.lang.Iterable", "java.io.Serializable"];
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * Maintains a last-in, first-out collection of objects. <a
      * href="http://java.sun.com/j2se/1.5.0/docs/api/java/util/Stack.html">[Sun
      * docs]</a>
      *
      * @param <E> element type.
      * @class
      * @extends java.util.Vector
      */
      var Stack =
      /** @class */
      function (_super) {
        __extends(Stack, _super);

        function Stack() {
          return _super.call(this) || this;
        }
        /**
        *
        * @return {*}
        */


        Stack.prototype.clone = function () {
          var s = new Stack();
          s.addAll$java_util_Collection(this);
          return s;
        };

        Stack.prototype.empty = function () {
          return this.isEmpty();
        };

        Stack.prototype.peek = function () {
          var sz = this.size();

          if (sz > 0) {
            return this.get(sz - 1);
          } else {
            throw new java.util.EmptyStackException();
          }
        };

        Stack.prototype.pop = function () {
          var sz = this.size();

          if (sz > 0) {
            return this.remove$int(sz - 1);
          } else {
            throw new java.util.EmptyStackException();
          }
        };

        Stack.prototype.push = function (o) {
          this.add(o);
          return o;
        };

        Stack.prototype.search = function (o) {
          var pos = this.lastIndexOf$java_lang_Object(o);

          if (pos >= 0) {
            return this.size() - pos;
          }

          return -1;
        };

        return Stack;
      }(java.util.Vector);

      util.Stack = Stack;
      Stack["__class"] = "java.util.Stack";
      Stack["__interfaces"] = ["java.util.RandomAccess", "java.util.List", "java.lang.Cloneable", "java.util.Collection", "java.lang.Iterable", "java.io.Serializable"];
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * Linked list implementation.
      * <a href="http://java.sun.com/j2se/1.5.0/docs/api/java/util/LinkedList.html">
      * [Sun docs]</a>
      *
      * @param <E>
      * element type.
      * @param {*} c
      * @class
      * @extends java.util.AbstractSequentialList
      */
      var LinkedList =
      /** @class */
      function (_super) {
        __extends(LinkedList, _super);

        function LinkedList(c) {
          var _this = this;

          if (c != null && c.constructor != null && c.constructor["__interfaces"] != null && c.constructor["__interfaces"].indexOf("java.util.Collection") >= 0 || c === null) {
            _this = _super.call(this) || this;

            if (_this.exposeElement === undefined) {
              _this.exposeElement = null;
            }

            if (_this.header === undefined) {
              _this.header = null;
            }

            if (_this.tail === undefined) {
              _this.tail = null;
            }

            if (_this.__size === undefined) {
              _this.__size = 0;
            }

            _this.header = new LinkedList.Node();
            _this.tail = new LinkedList.Node();

            _this.reset();

            _this.addAll(c);
          } else if (c === undefined) {
            _this = _super.call(this) || this;

            if (_this.exposeElement === undefined) {
              _this.exposeElement = null;
            }

            if (_this.header === undefined) {
              _this.header = null;
            }

            if (_this.tail === undefined) {
              _this.tail = null;
            }

            if (_this.__size === undefined) {
              _this.__size = 0;
            }

            _this.header = new LinkedList.Node();
            _this.tail = new LinkedList.Node();

            _this.reset();
          } else throw new Error('invalid overload');

          return _this;
        }
        /* Default method injected from java.util.Collection */


        LinkedList.prototype.stream = function () {
          return new javaemul.internal.stream.StreamHelper(this);
        };
        /* Default method injected from java.lang.Iterable */


        LinkedList.prototype.forEach = function (action) {
          javaemul.internal.InternalPreconditions.checkNotNull(action);

          var _loop_37 = function _loop_37(index192) {
            var t = index192.next();
            {
              (function (target) {
                return typeof target === 'function' ? target(t) : target.accept(t);
              })(action);
            }
          };

          for (var index192 = this.iterator(); index192.hasNext();) {
            _loop_37(index192);
          }
        };
        /* Default method injected from java.util.Collection */


        LinkedList.prototype.parallelStream = function () {
          return this.stream();
        };
        /* Default method injected from java.util.List */


        LinkedList.prototype.sort = function (c) {
          var a = this.toArray();
          java.util.Arrays.sort(a, c);
          var i = this.listIterator();

          for (var index193 = 0; index193 < a.length; index193++) {
            var e = a[index193];
            {
              i.next();
              i.set(e);
            }
          }
        };
        /* Default method injected from java.util.Collection */


        LinkedList.prototype.removeIf = function (filter) {
          javaemul.internal.InternalPreconditions.checkNotNull(filter);
          var removed = false;

          var _loop_38 = function _loop_38(it) {
            {
              if (function (target) {
                return typeof target === 'function' ? target(it.next()) : target.test(it.next());
              }(filter)) {
                it.remove();
                removed = true;
              }
            }
          };

          for (var it = this.iterator(); it.hasNext();) {
            _loop_38(it);
          }

          return removed;
        };
        /**
        *
        * @param {number} index
        * @param {*} element
        */


        LinkedList.prototype.add = function (index, element) {
          if ((typeof index === 'number' || index === null) && (element != null || element === null)) {
            _super.prototype.add.call(this, index, element);
          } else if ((index != null || index === null) && element === undefined) {
            return this.add$java_lang_Object(index);
          } else throw new Error('invalid overload');
        };

        LinkedList.prototype.add$java_lang_Object = function (o) {
          this.addLast(o);
          return true;
        };
        /**
        *
        * @param {*} o
        */


        LinkedList.prototype.addFirst = function (o) {
          this.addNode(o, this.header, this.header.next);
        };
        /**
        *
        * @param {*} o
        */


        LinkedList.prototype.addLast = function (o) {
          this.addNode(o, this.tail.prev, this.tail);
        };
        /**
        *
        */


        LinkedList.prototype.clear = function () {
          this.reset();
        };

        LinkedList.prototype.reset = function () {
          this.header.next = this.tail;
          this.tail.prev = this.header;
          this.header.prev = this.tail.next = null;
          this.__size = 0;
        };

        LinkedList.prototype.clone = function () {
          return new LinkedList(this);
        };
        /**
        *
        * @return {*}
        */


        LinkedList.prototype.descendingIterator = function () {
          return new LinkedList.DescendingIteratorImpl(this);
        };
        /**
        *
        * @return {*}
        */


        LinkedList.prototype.element = function () {
          return this.getFirst();
        };
        /**
        *
        * @return {*}
        */


        LinkedList.prototype.getFirst = function () {
          javaemul.internal.InternalPreconditions.checkElement(this.__size !== 0);
          return this.header.next.value;
        };
        /**
        *
        * @return {*}
        */


        LinkedList.prototype.getLast = function () {
          javaemul.internal.InternalPreconditions.checkElement(this.__size !== 0);
          return this.tail.prev.value;
        };

        LinkedList.prototype.listIterator$int = function (index) {
          javaemul.internal.InternalPreconditions.checkPositionIndex(index, this.__size);
          var node;

          if (index >= this.__size >> 1) {
            node = this.tail;

            for (var i = this.__size; i > index; --i) {
              {
                node = node.prev;
              }
            }
          } else {
            node = this.header.next;

            for (var i = 0; i < index; ++i) {
              {
                node = node.next;
              }
            }
          }

          return new LinkedList.ListIteratorImpl2(this, index, node);
        };
        /**
        *
        * @param {number} index
        * @return {*}
        */


        LinkedList.prototype.listIterator = function (index) {
          if (typeof index === 'number' || index === null) {
            return this.listIterator$int(index);
          } else if (index === undefined) {
            return this.listIterator$();
          } else throw new Error('invalid overload');
        };
        /**
        *
        * @param {*} o
        * @return {boolean}
        */


        LinkedList.prototype.offer = function (o) {
          return this.offerLast(o);
        };
        /**
        *
        * @param {*} e
        * @return {boolean}
        */


        LinkedList.prototype.offerFirst = function (e) {
          this.addFirst(e);
          return true;
        };
        /**
        *
        * @param {*} e
        * @return {boolean}
        */


        LinkedList.prototype.offerLast = function (e) {
          this.addLast(e);
          return true;
        };
        /**
        *
        * @return {*}
        */


        LinkedList.prototype.peek = function () {
          return this.peekFirst();
        };
        /**
        *
        * @return {*}
        */


        LinkedList.prototype.peekFirst = function () {
          return this.__size === 0 ? null : this.getFirst();
        };
        /**
        *
        * @return {*}
        */


        LinkedList.prototype.peekLast = function () {
          return this.__size === 0 ? null : this.getLast();
        };
        /**
        *
        * @return {*}
        */


        LinkedList.prototype.poll = function () {
          return this.pollFirst();
        };
        /**
        *
        * @return {*}
        */


        LinkedList.prototype.pollFirst = function () {
          return this.__size === 0 ? null : this.removeFirst();
        };
        /**
        *
        * @return {*}
        */


        LinkedList.prototype.pollLast = function () {
          return this.__size === 0 ? null : this.removeLast();
        };
        /**
        *
        * @return {*}
        */


        LinkedList.prototype.pop = function () {
          return this.removeFirst();
        };
        /**
        *
        * @param {*} e
        */


        LinkedList.prototype.push = function (e) {
          this.addFirst(e);
        };
        /**
        *
        * @param {number} index
        * @return {*}
        */


        LinkedList.prototype.remove = function (index) {
          if (typeof index === 'number' || index === null) {
            return _super.prototype.remove.call(this, index);
          } else if (index != null || index === null) {
            return _super.prototype.remove.call(this, index);
          } else if (index === undefined) {
            return this.remove$();
          } else throw new Error('invalid overload');
        };

        LinkedList.prototype.remove$ = function () {
          return this.removeFirst();
        };
        /**
        *
        * @return {*}
        */


        LinkedList.prototype.removeFirst = function () {
          javaemul.internal.InternalPreconditions.checkElement(this.__size !== 0);
          return this.removeNode(this.header.next);
        };
        /**
        *
        * @param {*} o
        * @return {boolean}
        */


        LinkedList.prototype.removeFirstOccurrence = function (o) {
          return this.remove(o);
        };
        /**
        *
        * @return {*}
        */


        LinkedList.prototype.removeLast = function () {
          javaemul.internal.InternalPreconditions.checkElement(this.__size !== 0);
          return this.removeNode(this.tail.prev);
        };
        /**
        *
        * @param {*} o
        * @return {boolean}
        */


        LinkedList.prototype.removeLastOccurrence = function (o) {
          for (var e = this.tail.prev; e !== this.header; e = e.prev) {
            {
              if (java.util.Objects.equals(e.value, o)) {
                this.removeNode(e);
                return true;
              }
            }
          }

          return false;
        };
        /**
        *
        * @return {number}
        */


        LinkedList.prototype.size = function () {
          return this.__size;
        };

        LinkedList.prototype.addNode = function (o, prev, next) {
          var node = new LinkedList.Node();
          node.value = o;
          node.prev = prev;
          node.next = next;
          next.prev = prev.next = node;
          ++this.__size;
        };

        LinkedList.prototype.removeNode = function (node) {
          var oldValue = node.value;
          node.next.prev = node.prev;
          node.prev.next = node.next;
          node.next = node.prev = null;
          node.value = null;
          --this.__size;
          return oldValue;
        };

        return LinkedList;
      }(java.util.AbstractSequentialList);

      util.LinkedList = LinkedList;
      LinkedList["__class"] = "java.util.LinkedList";
      LinkedList["__interfaces"] = ["java.lang.Cloneable", "java.util.List", "java.util.Collection", "java.util.Queue", "java.util.Deque", "java.lang.Iterable", "java.io.Serializable"];

      (function (LinkedList) {
        var DescendingIteratorImpl =
        /** @class */
        function () {
          function DescendingIteratorImpl(__parent) {
            this.__parent = __parent;
            this.itr = new LinkedList.ListIteratorImpl2(this.__parent, this.__parent.__size, this.__parent.tail);
          }
          /* Default method injected from java.util.Iterator */


          DescendingIteratorImpl.prototype.forEachRemaining = function (consumer) {
            var _this = this;

            javaemul.internal.InternalPreconditions.checkNotNull(consumer);

            while (this.hasNext()) {
              {
                (function (target) {
                  return typeof target === 'function' ? target(_this.next()) : target.accept(_this.next());
                })(consumer);
              }
            }
          };
          /**
          *
          * @return {boolean}
          */


          DescendingIteratorImpl.prototype.hasNext = function () {
            return this.itr.hasPrevious();
          };
          /**
          *
          * @return {*}
          */


          DescendingIteratorImpl.prototype.next = function () {
            return this.itr.previous();
          };
          /**
          *
          */


          DescendingIteratorImpl.prototype.remove = function () {
            this.itr.remove();
          };

          return DescendingIteratorImpl;
        }();

        LinkedList.DescendingIteratorImpl = DescendingIteratorImpl;
        DescendingIteratorImpl["__class"] = "java.util.LinkedList.DescendingIteratorImpl";
        DescendingIteratorImpl["__interfaces"] = ["java.util.Iterator"];
        /**
        * @param {number} index
        * from the beginning of the list (0 = first node)
        * @param {java.util.LinkedList.Node} startNode
        * the initial current node
        * @class
        */

        var ListIteratorImpl2 =
        /** @class */
        function () {
          function ListIteratorImpl2(__parent, index, startNode) {
            this.__parent = __parent;

            if (this.currentIndex === undefined) {
              this.currentIndex = 0;
            }

            if (this.currentNode === undefined) {
              this.currentNode = null;
            }

            this.lastNode = null;
            this.currentNode = startNode;
            this.currentIndex = index;
          }
          /* Default method injected from java.util.Iterator */


          ListIteratorImpl2.prototype.forEachRemaining = function (consumer) {
            var _this = this;

            javaemul.internal.InternalPreconditions.checkNotNull(consumer);

            while (this.hasNext()) {
              {
                (function (target) {
                  return typeof target === 'function' ? target(_this.next()) : target.accept(_this.next());
                })(consumer);
              }
            }
          };
          /**
          *
          * @param {*} o
          */


          ListIteratorImpl2.prototype.add = function (o) {
            this.__parent.addNode(o, this.currentNode.prev, this.currentNode);

            ++this.currentIndex;
            this.lastNode = null;
          };
          /**
          *
          * @return {boolean}
          */


          ListIteratorImpl2.prototype.hasNext = function () {
            return this.currentNode !== this.__parent.tail;
          };
          /**
          *
          * @return {boolean}
          */


          ListIteratorImpl2.prototype.hasPrevious = function () {
            return this.currentNode.prev !== this.__parent.header;
          };
          /**
          *
          * @return {*}
          */


          ListIteratorImpl2.prototype.next = function () {
            javaemul.internal.InternalPreconditions.checkElement(this.hasNext());
            this.lastNode = this.currentNode;
            this.currentNode = this.currentNode.next;
            ++this.currentIndex;
            return this.lastNode.value;
          };
          /**
          *
          * @return {number}
          */


          ListIteratorImpl2.prototype.nextIndex = function () {
            return this.currentIndex;
          };
          /**
          *
          * @return {*}
          */


          ListIteratorImpl2.prototype.previous = function () {
            javaemul.internal.InternalPreconditions.checkElement(this.hasPrevious());
            this.lastNode = this.currentNode = this.currentNode.prev;
            --this.currentIndex;
            return this.lastNode.value;
          };
          /**
          *
          * @return {number}
          */


          ListIteratorImpl2.prototype.previousIndex = function () {
            return this.currentIndex - 1;
          };
          /**
          *
          */


          ListIteratorImpl2.prototype.remove = function () {
            javaemul.internal.InternalPreconditions.checkState(this.lastNode != null);
            var nextNode = this.lastNode.next;

            this.__parent.removeNode(this.lastNode);

            if (this.currentNode === this.lastNode) {
              this.currentNode = nextNode;
            } else {
              --this.currentIndex;
            }

            this.lastNode = null;
          };
          /**
          *
          * @param {*} o
          */


          ListIteratorImpl2.prototype.set = function (o) {
            javaemul.internal.InternalPreconditions.checkState(this.lastNode != null);
            this.lastNode.value = o;
          };

          return ListIteratorImpl2;
        }();

        LinkedList.ListIteratorImpl2 = ListIteratorImpl2;
        ListIteratorImpl2["__class"] = "java.util.LinkedList.ListIteratorImpl2";
        ListIteratorImpl2["__interfaces"] = ["java.util.Iterator", "java.util.ListIterator"];
        /**
        * Internal class representing a doubly-linked list node.
        *
        * @param <E>
        * element type
        * @class
        */

        var Node =
        /** @class */
        function () {
          function Node() {
            if (this.next === undefined) {
              this.next = null;
            }

            if (this.prev === undefined) {
              this.prev = null;
            }

            if (this.value === undefined) {
              this.value = null;
            }
          }

          return Node;
        }();

        LinkedList.Node = Node;
        Node["__class"] = "java.util.LinkedList.Node";
      })(LinkedList = util.LinkedList || (util.LinkedList = {}));
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      var InputMismatchException =
      /** @class */
      function (_super) {
        __extends(InputMismatchException, _super);

        function InputMismatchException(message) {
          var _this = this;

          if (typeof message === 'string' || message === null) {
            _this = _super.call(this, message) || this;
          } else if (message === undefined) {
            _this = _super.call(this) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        return InputMismatchException;
      }(java.util.NoSuchElementException);

      util.InputMismatchException = InputMismatchException;
      InputMismatchException["__class"] = "java.util.InputMismatchException";
      InputMismatchException["__interfaces"] = ["java.io.Serializable"];
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (nio) {
      var InvalidMarkException =
      /** @class */
      function (_super) {
        __extends(InvalidMarkException, _super);

        function InvalidMarkException() {
          var _this = _super.call(this) || this;

          Object.setPrototypeOf(_this, InvalidMarkException.prototype);
          return _this;
        }

        return InvalidMarkException;
      }(java.lang.IllegalStateException);

      nio.InvalidMarkException = InvalidMarkException;
      InvalidMarkException["__class"] = "java.nio.InvalidMarkException";
      InvalidMarkException["__interfaces"] = ["java.io.Serializable"];
    })(java.nio || (java.nio = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      (function (regex) {
        var PatternSyntaxException =
        /** @class */
        function (_super) {
          __extends(PatternSyntaxException, _super);

          function PatternSyntaxException(desc, pattern, index) {
            var _this = this;

            if ((typeof desc === 'string' || desc === null) && (typeof pattern === 'string' || pattern === null) && (typeof index === 'number' || index === null)) {
              var __args = arguments;
              {
                var throwable = PatternSyntaxException.createSyntaxError(desc, index);
                _this = _super.call(this, throwable) || this;

                if (_this.pattern === undefined) {
                  _this.pattern = null;
                }

                _this.pattern = pattern;
              }

              if (_this.pattern === undefined) {
                _this.pattern = null;
              }
            } else if ((desc != null && desc instanceof Error || desc === null) && (typeof pattern === 'string' || pattern === null) && index === undefined) {
              var __args = arguments;
              var throwable = __args[0];
              _this = _super.call(this, throwable) || this;

              if (_this.pattern === undefined) {
                _this.pattern = null;
              }

              _this.pattern = pattern;
            } else throw new Error('invalid overload');

            return _this;
          }
          /*private*/


          PatternSyntaxException.createSyntaxError = function (desc, index) {
            var syntaxError = new SyntaxError(desc);
            syntaxError["columnNumber"] = index;
            return syntaxError;
          };

          PatternSyntaxException.prototype.getIndex = function () {
            return null["columnNumber"];
          };

          PatternSyntaxException.prototype.getDescription = function () {
            return this.message;
          };

          PatternSyntaxException.prototype.getPattern = function () {
            return this.pattern;
          };
          /**
          *
          * @return {string}
          */


          PatternSyntaxException.prototype.getMessage = function () {
            return this.getDescription() + " Pattern: " + this.pattern;
          };

          return PatternSyntaxException;
        }(java.lang.IllegalArgumentException);

        regex.PatternSyntaxException = PatternSyntaxException;
        PatternSyntaxException["__class"] = "java.util.regex.PatternSyntaxException";
        PatternSyntaxException["__interfaces"] = ["java.io.Serializable"];
      })(util.regex || (util.regex = {}));
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      /**
      * See <a
      * href="http://java.sun.com/j2se/1.5.0/docs/api/java/lang/NumberFormatException.html">the
      * official Java API doc</a> for details.
      * @param {string} message
      * @class
      * @extends java.lang.IllegalArgumentException
      */
      var NumberFormatException =
      /** @class */
      function (_super) {
        __extends(NumberFormatException, _super);

        function NumberFormatException(message) {
          var _this = this;

          if (typeof message === 'string' || message === null) {
            _this = _super.call(this, message) || this;
          } else if (message === undefined) {
            _this = _super.call(this) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        NumberFormatException.forInputString = function (s) {
          return new java.lang.NumberFormatException("For input string: \"" + s + "\"");
        };

        NumberFormatException.forNullInputString = function () {
          return new java.lang.NumberFormatException("null");
        };

        NumberFormatException.forRadix = function (radix) {
          return new java.lang.NumberFormatException("radix " + radix + " out of range");
        };

        return NumberFormatException;
      }(java.lang.IllegalArgumentException);

      lang.NumberFormatException = NumberFormatException;
      NumberFormatException["__class"] = "java.lang.NumberFormatException";
      NumberFormatException["__interfaces"] = ["java.io.Serializable"];
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (nio) {
      (function (charset) {
        /**
        * GWT emulation of {@link IllegalCharsetNameException}.
        * @param {string} charsetName
        * @class
        * @extends java.lang.IllegalArgumentException
        */
        var IllegalCharsetNameException =
        /** @class */
        function (_super) {
          __extends(IllegalCharsetNameException, _super);

          function IllegalCharsetNameException(charsetName) {
            var _this = _super.call(this,
            /* valueOf */
            new String(charsetName).toString()) || this;

            Object.setPrototypeOf(_this, IllegalCharsetNameException.prototype);

            if (_this.charsetName === undefined) {
              _this.charsetName = null;
            }

            _this.charsetName = charsetName;
            return _this;
          }

          IllegalCharsetNameException.prototype.getCharsetName = function () {
            return this.charsetName;
          };

          return IllegalCharsetNameException;
        }(java.lang.IllegalArgumentException);

        charset.IllegalCharsetNameException = IllegalCharsetNameException;
        IllegalCharsetNameException["__class"] = "java.nio.charset.IllegalCharsetNameException";
        IllegalCharsetNameException["__interfaces"] = ["java.io.Serializable"];
      })(nio.charset || (nio.charset = {}));
    })(java.nio || (java.nio = {}));
  })(java || (java = {}));

  (function (java) {
    (function (nio) {
      (function (charset) {
        /**
        * GWT emulation of {@link UnsupportedCharsetException}.
        * @param {string} charsetName
        * @class
        * @extends java.lang.IllegalArgumentException
        */
        var UnsupportedCharsetException =
        /** @class */
        function (_super) {
          __extends(UnsupportedCharsetException, _super);

          function UnsupportedCharsetException(charsetName) {
            var _this = _super.call(this,
            /* valueOf */
            new String(charsetName).toString()) || this;

            Object.setPrototypeOf(_this, UnsupportedCharsetException.prototype);

            if (_this.charsetName === undefined) {
              _this.charsetName = null;
            }

            _this.charsetName = charsetName;
            return _this;
          }

          UnsupportedCharsetException.prototype.getCharsetName = function () {
            return this.charsetName;
          };

          return UnsupportedCharsetException;
        }(java.lang.IllegalArgumentException);

        charset.UnsupportedCharsetException = UnsupportedCharsetException;
        UnsupportedCharsetException["__class"] = "java.nio.charset.UnsupportedCharsetException";
        UnsupportedCharsetException["__interfaces"] = ["java.io.Serializable"];
      })(nio.charset || (nio.charset = {}));
    })(java.nio || (java.nio = {}));
  })(java || (java = {}));

  (function (java) {
    (function (nio) {
      var ReadOnlyBufferException =
      /** @class */
      function (_super) {
        __extends(ReadOnlyBufferException, _super);

        function ReadOnlyBufferException() {
          var _this = _super.call(this) || this;

          Object.setPrototypeOf(_this, ReadOnlyBufferException.prototype);
          return _this;
        }

        return ReadOnlyBufferException;
      }(java.lang.UnsupportedOperationException);

      nio.ReadOnlyBufferException = ReadOnlyBufferException;
      ReadOnlyBufferException["__class"] = "java.nio.ReadOnlyBufferException";
      ReadOnlyBufferException["__interfaces"] = ["java.io.Serializable"];
    })(java.nio || (java.nio = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      /**
      * See <a
      * href="http://java.sun.com/j2se/1.5.0/docs/api/java/lang/StringIndexOfBoundsException.html">the
      * official Java API doc</a> for details.
      * @param {string} message
      * @class
      * @extends java.lang.IndexOutOfBoundsException
      */
      var StringIndexOutOfBoundsException =
      /** @class */
      function (_super) {
        __extends(StringIndexOutOfBoundsException, _super);

        function StringIndexOutOfBoundsException(message) {
          var _this = this;

          if (typeof message === 'string' || message === null) {
            var __args = arguments;
            _this = _super.call(this, message) || this;
          } else if (typeof message === 'number' || message === null) {
            var __args = arguments;
            var index = __args[0];
            _this = _super.call(this, "String index out of range: " + index) || this;
          } else if (message === undefined) {
            var __args = arguments;
            _this = _super.call(this) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        return StringIndexOutOfBoundsException;
      }(java.lang.IndexOutOfBoundsException);

      lang.StringIndexOutOfBoundsException = StringIndexOutOfBoundsException;
      StringIndexOutOfBoundsException["__class"] = "java.lang.StringIndexOutOfBoundsException";
      StringIndexOutOfBoundsException["__interfaces"] = ["java.io.Serializable"];
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      /**
      * NOTE: in GWT this will never be thrown for normal array accesses, only for
      * explicit throws.
      *
      * See <a
      * href="http://java.sun.com/j2se/1.5.0/docs/api/java/lang/ArrayIndexOutOfBoundsException.html">the
      * official Java API doc</a> for details.
      * @param {number} index
      * @class
      * @extends java.lang.IndexOutOfBoundsException
      */
      var ArrayIndexOutOfBoundsException =
      /** @class */
      function (_super) {
        __extends(ArrayIndexOutOfBoundsException, _super);

        function ArrayIndexOutOfBoundsException(msg) {
          var _this = this;

          if (typeof msg === 'string' || msg === null) {
            var __args = arguments;
            _this = _super.call(this, msg) || this;
          } else if (typeof msg === 'number' || msg === null) {
            var __args = arguments;
            var index = __args[0];
            _this = _super.call(this, "Array index " + index + " out of range") || this;
          } else if (msg === undefined) {
            var __args = arguments;
            _this = _super.call(this) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        return ArrayIndexOutOfBoundsException;
      }(java.lang.IndexOutOfBoundsException);

      lang.ArrayIndexOutOfBoundsException = ArrayIndexOutOfBoundsException;
      ArrayIndexOutOfBoundsException["__class"] = "java.lang.ArrayIndexOutOfBoundsException";
      ArrayIndexOutOfBoundsException["__interfaces"] = ["java.io.Serializable"];
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * Map using reference equality on keys. <a
      * href="http://java.sun.com/j2se/1.5.0/docs/api/java/util/IdentityHashMap.html">[Sun
      * docs]</a>
      *
      * @param <K> key type
      * @param <V> value type
      * @param {number} ignored
      * @class
      * @extends java.util.AbstractHashMap
      */
      var IdentityHashMap =
      /** @class */
      function (_super) {
        __extends(IdentityHashMap, _super);

        function IdentityHashMap(toBeCopied) {
          var _this = this;

          if (toBeCopied != null && toBeCopied.constructor != null && toBeCopied.constructor["__interfaces"] != null && toBeCopied.constructor["__interfaces"].indexOf("java.util.Map") >= 0 || toBeCopied === null) {
            var __args = arguments;
            _this = _super.call(this, toBeCopied) || this;

            if (_this.exposeKey === undefined) {
              _this.exposeKey = null;
            }

            if (_this.exposeValue === undefined) {
              _this.exposeValue = null;
            }
          } else if (typeof toBeCopied === 'number' || toBeCopied === null) {
            var __args = arguments;
            var ignored = __args[0];
            _this = _super.call(this, ignored) || this;

            if (_this.exposeKey === undefined) {
              _this.exposeKey = null;
            }

            if (_this.exposeValue === undefined) {
              _this.exposeValue = null;
            }
          } else if (toBeCopied === undefined) {
            var __args = arguments;
            _this = _super.call(this) || this;

            if (_this.exposeKey === undefined) {
              _this.exposeKey = null;
            }

            if (_this.exposeValue === undefined) {
              _this.exposeValue = null;
            }
          } else throw new Error('invalid overload');

          return _this;
        }
        /* Default method injected from java.util.Map */


        IdentityHashMap.prototype.putIfAbsent = function (key, value) {
          var v = this.get(key);

          if (v == null) {
            v = this.put(key, value);
          }

          return v;
        };
        /* Default method injected from java.util.Map */


        IdentityHashMap.prototype.computeIfAbsent = function (key, mappingFunction) {
          var result;

          if ((result = this.get(key)) == null) {
            result = function (target) {
              return typeof target === 'function' ? target(key) : target.apply(key);
            }(mappingFunction);

            if (result != null) this.put(key, result);
          }

          return result;
        };
        /* Default method injected from java.util.Map */


        IdentityHashMap.prototype.merge = function (key, value, map) {
          var old = this.get(key);
          var next = old == null ? value : function (target) {
            return typeof target === 'function' ? target(old, value) : target.apply(old, value);
          }(map);

          if (next == null) {
            this.remove(key);
          } else {
            this.put(key, next);
          }

          return next;
        };
        /* Default method injected from java.util.Map */


        IdentityHashMap.prototype.getOrDefault = function (key, defaultValue) {
          var v;
          return (v = this.get(key)) != null || this.containsKey(key) ? v : defaultValue;
        };
        /* Default method injected from java.util.Map */


        IdentityHashMap.prototype.replaceAll = function (__function) {
          java.util.Objects.requireNonNull(__function);

          var _loop_39 = function _loop_39(index194) {
            var entry = index194.next();
            {
              var k_5;
              var v_5;

              try {
                k_5 = entry.getKey();
                v_5 = entry.getValue();
              } catch (ise) {
                throw new java.lang.RuntimeException(ise);
              }

              v_5 = function (target) {
                return typeof target === 'function' ? target(k_5, v_5) : target.apply(k_5, v_5);
              }(__function);

              try {
                entry.setValue(v_5);
              } catch (ise) {
                throw new java.lang.RuntimeException(ise);
              }
            }
          };

          for (var index194 = this.entrySet().iterator(); index194.hasNext();) {
            _loop_39(index194);
          }
        };

        IdentityHashMap.prototype.clone = function () {
          return new IdentityHashMap(this);
        };
        /**
        *
        * @param {*} obj
        * @return {boolean}
        */


        IdentityHashMap.prototype.equals = function (obj) {
          if (obj === this) {
            return true;
          }

          if (!(obj != null && obj.constructor != null && obj.constructor["__interfaces"] != null && obj.constructor["__interfaces"].indexOf("java.util.Map") >= 0)) {
            return false;
          }

          var otherMap = obj;

          if (this.size() !== otherMap.size()) {
            return false;
          }

          for (var index195 = otherMap.entrySet().iterator(); index195.hasNext();) {
            var entry = index195.next();
            {
              var otherKey = entry.getKey();
              var otherValue = entry.getValue();

              if (!this.containsKey(otherKey)) {
                return false;
              }

              if (otherValue !== this.get(otherKey)) {
                return false;
              }
            }
          }

          return true;
        };
        /**
        *
        * @return {number}
        */


        IdentityHashMap.prototype.hashCode = function () {
          var hashCode = 0;

          for (var index196 = this.entrySet().iterator(); index196.hasNext();) {
            var entry = index196.next();
            {
              hashCode += java.lang.System.identityHashCode(entry.getKey());
              hashCode += java.lang.System.identityHashCode(entry.getValue());
            }
          }

          return hashCode;
        };
        /**
        *
        * @param {*} value1
        * @param {*} value2
        * @return {boolean}
        */


        IdentityHashMap.prototype._equals = function (value1, value2) {
          return value1 === value2;
        };
        /**
        *
        * @param {*} key
        * @return {number}
        */


        IdentityHashMap.prototype.getHashCode = function (key) {
          return javaemul.internal.HashCodes.getObjectIdentityHashCode(key);
        };

        return IdentityHashMap;
      }(java.util.AbstractHashMap);

      util.IdentityHashMap = IdentityHashMap;
      IdentityHashMap["__class"] = "java.util.IdentityHashMap";
      IdentityHashMap["__interfaces"] = ["java.lang.Cloneable", "java.util.Map", "java.io.Serializable"];
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * Implementation of Map interface based on a hash table. <a
      * href="http://java.sun.com/j2se/1.5.0/docs/api/java/util/HashMap.html">[Sun
      * docs]</a>
      *
      * @param <K> key type
      * @param <V> value type
      * @param {number} ignored
      * @param {number} alsoIgnored
      * @class
      * @extends java.util.AbstractHashMap
      */
      var HashMap =
      /** @class */
      function (_super) {
        __extends(HashMap, _super);

        function HashMap(ignored, alsoIgnored) {
          var _this = this;

          if ((typeof ignored === 'number' || ignored === null) && (typeof alsoIgnored === 'number' || alsoIgnored === null)) {
            var __args = arguments;
            _this = _super.call(this, ignored, alsoIgnored) || this;

            if (_this.exposeKey === undefined) {
              _this.exposeKey = null;
            }

            if (_this.exposeValue === undefined) {
              _this.exposeValue = null;
            }
          } else if ((ignored != null && ignored.constructor != null && ignored.constructor["__interfaces"] != null && ignored.constructor["__interfaces"].indexOf("java.util.Map") >= 0 || ignored === null) && alsoIgnored === undefined) {
            var __args = arguments;
            var toBeCopied = __args[0];
            _this = _super.call(this, toBeCopied) || this;

            if (_this.exposeKey === undefined) {
              _this.exposeKey = null;
            }

            if (_this.exposeValue === undefined) {
              _this.exposeValue = null;
            }
          } else if ((typeof ignored === 'number' || ignored === null) && alsoIgnored === undefined) {
            var __args = arguments;
            _this = _super.call(this, ignored) || this;

            if (_this.exposeKey === undefined) {
              _this.exposeKey = null;
            }

            if (_this.exposeValue === undefined) {
              _this.exposeValue = null;
            }
          } else if (ignored === undefined && alsoIgnored === undefined) {
            var __args = arguments;
            _this = _super.call(this) || this;

            if (_this.exposeKey === undefined) {
              _this.exposeKey = null;
            }

            if (_this.exposeValue === undefined) {
              _this.exposeValue = null;
            }
          } else throw new Error('invalid overload');

          return _this;
        }

        HashMap.prototype.clone = function () {
          return new HashMap(this);
        };
        /**
        *
        * @param {*} value1
        * @param {*} value2
        * @return {boolean}
        */


        HashMap.prototype._equals = function (value1, value2) {
          return java.util.Objects.equals(value1, value2);
        };
        /**
        *
        * @param {*} key
        * @return {number}
        */


        HashMap.prototype.getHashCode = function (key) {
          var hashCode = function (o) {
            if (o.hashCode) {
              return o.hashCode();
            } else {
              return o.toString().split('').reduce(function (prevHash, currVal) {
                return (prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0;
              }, 0);
            }
          }(key);

          return javaemul.internal.Coercions.ensureInt(hashCode);
        };

        return HashMap;
      }(java.util.AbstractHashMap);

      util.HashMap = HashMap;
      HashMap["__class"] = "java.util.HashMap";
      HashMap["__interfaces"] = ["java.lang.Cloneable", "java.util.Map", "java.io.Serializable"];
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * Implements a TreeMap using a red-black tree. This guarantees O(log n)
      * performance on lookups, inserts, and deletes while maintaining linear
      * in-order traversal time. Null keys and values are fully supported if the
      * comparator supports them (the default comparator does not).
      *
      * @param <K> key type
      * @param <V> value type
      * @param {*} c
      * @class
      * @extends java.util.AbstractNavigableMap
      */
      var TreeMap =
      /** @class */
      function (_super) {
        __extends(TreeMap, _super);

        function TreeMap(c) {
          var _this = this;

          if (typeof c === 'function' && c.length === 2 || c === null) {
            var __args = arguments;
            _this = _super.call(this) || this;

            if (_this.cmp === undefined) {
              _this.cmp = null;
            }

            if (_this.exposeKeyType === undefined) {
              _this.exposeKeyType = null;
            }

            if (_this.exposeValueType === undefined) {
              _this.exposeValueType = null;
            }

            if (_this.root === undefined) {
              _this.root = null;
            }

            if (_this.__size === undefined) {
              _this.__size = 0;
            }

            _this.root = null;

            if (c == null) {
              c = java.util.Comparators.natural();
            }

            _this.cmp = c;
          } else if (c != null && c.constructor != null && c.constructor["__interfaces"] != null && c.constructor["__interfaces"].indexOf("java.util.SortedMap") >= 0 || c === null) {
            var __args = arguments;
            var map_1 = __args[0];
            {
              var c_5 = javaemul.internal.InternalPreconditions.checkNotNull(map_1).comparator();
              _this = _super.call(this) || this;

              if (_this.cmp === undefined) {
                _this.cmp = null;
              }

              if (_this.exposeKeyType === undefined) {
                _this.exposeKeyType = null;
              }

              if (_this.exposeValueType === undefined) {
                _this.exposeValueType = null;
              }

              if (_this.root === undefined) {
                _this.root = null;
              }

              if (_this.__size === undefined) {
                _this.__size = 0;
              }

              _this.root = null;

              if (c_5 == null) {
                c_5 = java.util.Comparators.natural();
              }

              _this.cmp = c_5;
            }

            if (_this.cmp === undefined) {
              _this.cmp = null;
            }

            if (_this.exposeKeyType === undefined) {
              _this.exposeKeyType = null;
            }

            if (_this.exposeValueType === undefined) {
              _this.exposeValueType = null;
            }

            if (_this.root === undefined) {
              _this.root = null;
            }

            if (_this.__size === undefined) {
              _this.__size = 0;
            }

            (function () {
              _this.putAll(map_1);
            })();
          } else if (c != null && c.constructor != null && c.constructor["__interfaces"] != null && c.constructor["__interfaces"].indexOf("java.util.Map") >= 0 || c === null) {
            var __args = arguments;
            var map_2 = __args[0];
            {
              {
                var c_6 = null;
                _this = _super.call(this) || this;

                if (_this.cmp === undefined) {
                  _this.cmp = null;
                }

                if (_this.exposeKeyType === undefined) {
                  _this.exposeKeyType = null;
                }

                if (_this.exposeValueType === undefined) {
                  _this.exposeValueType = null;
                }

                if (_this.root === undefined) {
                  _this.root = null;
                }

                if (_this.__size === undefined) {
                  _this.__size = 0;
                }

                _this.root = null;

                if (c_6 == null) {
                  c_6 = java.util.Comparators.natural();
                }

                _this.cmp = c_6;
              }

              if (_this.cmp === undefined) {
                _this.cmp = null;
              }

              if (_this.exposeKeyType === undefined) {
                _this.exposeKeyType = null;
              }

              if (_this.exposeValueType === undefined) {
                _this.exposeValueType = null;
              }

              if (_this.root === undefined) {
                _this.root = null;
              }

              if (_this.__size === undefined) {
                _this.__size = 0;
              }
            }

            if (_this.cmp === undefined) {
              _this.cmp = null;
            }

            if (_this.exposeKeyType === undefined) {
              _this.exposeKeyType = null;
            }

            if (_this.exposeValueType === undefined) {
              _this.exposeValueType = null;
            }

            if (_this.root === undefined) {
              _this.root = null;
            }

            if (_this.__size === undefined) {
              _this.__size = 0;
            }

            (function () {
              _this.putAll(map_2);
            })();
          } else if (c === undefined) {
            var __args = arguments;
            {
              var c_7 = null;
              _this = _super.call(this) || this;

              if (_this.cmp === undefined) {
                _this.cmp = null;
              }

              if (_this.exposeKeyType === undefined) {
                _this.exposeKeyType = null;
              }

              if (_this.exposeValueType === undefined) {
                _this.exposeValueType = null;
              }

              if (_this.root === undefined) {
                _this.root = null;
              }

              if (_this.__size === undefined) {
                _this.__size = 0;
              }

              _this.root = null;

              if (c_7 == null) {
                c_7 = java.util.Comparators.natural();
              }

              _this.cmp = c_7;
            }

            if (_this.cmp === undefined) {
              _this.cmp = null;
            }

            if (_this.exposeKeyType === undefined) {
              _this.exposeKeyType = null;
            }

            if (_this.exposeValueType === undefined) {
              _this.exposeValueType = null;
            }

            if (_this.root === undefined) {
              _this.root = null;
            }

            if (_this.__size === undefined) {
              _this.__size = 0;
            }
          } else throw new Error('invalid overload');

          return _this;
        }

        TreeMap.SubMapType_All_$LI$ = function () {
          if (TreeMap.SubMapType_All == null) {
            TreeMap.SubMapType_All = new TreeMap.SubMapType();
          }

          return TreeMap.SubMapType_All;
        };

        TreeMap.SubMapType_Head_$LI$ = function () {
          if (TreeMap.SubMapType_Head == null) {
            TreeMap.SubMapType_Head = new TreeMap.SubMapTypeHead();
          }

          return TreeMap.SubMapType_Head;
        };

        TreeMap.SubMapType_Range_$LI$ = function () {
          if (TreeMap.SubMapType_Range == null) {
            TreeMap.SubMapType_Range = new TreeMap.SubMapTypeRange();
          }

          return TreeMap.SubMapType_Range;
        };

        TreeMap.SubMapType_Tail_$LI$ = function () {
          if (TreeMap.SubMapType_Tail == null) {
            TreeMap.SubMapType_Tail = new TreeMap.SubMapTypeTail();
          }

          return TreeMap.SubMapType_Tail;
        };

        TreeMap.otherChild = function (child) {
          return 1 - child;
        };
        /**
        *
        */


        TreeMap.prototype.clear = function () {
          this.root = null;
          this.__size = 0;
        };
        /**
        *
        * @return {*}
        */


        TreeMap.prototype.comparator = function () {
          if (this.cmp === java.util.Comparators.natural()) {
            return null;
          }

          return this.cmp;
        };
        /**
        *
        * @return {*}
        */


        TreeMap.prototype.entrySet = function () {
          return new TreeMap.__java_util_TreeMap_EntrySet(this);
        };

        TreeMap.prototype.headMap$java_lang_Object$boolean = function (toKey, inclusive) {
          return new TreeMap.SubMap(this, TreeMap.SubMapType_Head_$LI$(), null, false, toKey, inclusive);
        };
        /**
        *
        * @param {*} toKey
        * @param {boolean} inclusive
        * @return {*}
        */


        TreeMap.prototype.headMap = function (toKey, inclusive) {
          if ((toKey != null || toKey === null) && (typeof inclusive === 'boolean' || inclusive === null)) {
            return this.headMap$java_lang_Object$boolean(toKey, inclusive);
          } else if ((toKey != null || toKey === null) && inclusive === undefined) {
            return this.headMap$java_lang_Object(toKey);
          } else throw new Error('invalid overload');
        };
        /**
        *
        * @param {*} key
        * @param {*} value
        * @return {*}
        */


        TreeMap.prototype.put = function (key, value) {
          var node = new TreeMap.Node(key, value);
          var state = new TreeMap.State();
          this.root = this.insert(this.root, node, state);

          if (!state.found) {
            ++this.__size;
          }

          this.root.isRed = false;
          return state.value;
        };
        /**
        *
        * @param {*} k
        * @return {*}
        */


        TreeMap.prototype.remove = function (k) {
          var key = k;
          var state = new TreeMap.State();
          this.removeWithState(key, state);
          return state.value;
        };
        /**
        *
        * @return {number}
        */


        TreeMap.prototype.size = function () {
          return this.__size;
        };

        TreeMap.prototype.subMap$java_lang_Object$boolean$java_lang_Object$boolean = function (fromKey, fromInclusive, toKey, toInclusive) {
          return new TreeMap.SubMap(this, TreeMap.SubMapType_Range_$LI$(), fromKey, fromInclusive, toKey, toInclusive);
        };
        /**
        *
        * @param {*} fromKey
        * @param {boolean} fromInclusive
        * @param {*} toKey
        * @param {boolean} toInclusive
        * @return {*}
        */


        TreeMap.prototype.subMap = function (fromKey, fromInclusive, toKey, toInclusive) {
          if ((fromKey != null || fromKey === null) && (typeof fromInclusive === 'boolean' || fromInclusive === null) && (toKey != null || toKey === null) && (typeof toInclusive === 'boolean' || toInclusive === null)) {
            return this.subMap$java_lang_Object$boolean$java_lang_Object$boolean(fromKey, fromInclusive, toKey, toInclusive);
          } else if ((fromKey != null || fromKey === null) && (fromInclusive != null || fromInclusive === null) && toKey === undefined && toInclusive === undefined) {
            return this.subMap$java_lang_Object$java_lang_Object(fromKey, fromInclusive);
          } else throw new Error('invalid overload');
        };

        TreeMap.prototype.tailMap$java_lang_Object$boolean = function (fromKey, inclusive) {
          return new TreeMap.SubMap(this, TreeMap.SubMapType_Tail_$LI$(), fromKey, inclusive, null, false);
        };
        /**
        *
        * @param {*} fromKey
        * @param {boolean} inclusive
        * @return {*}
        */


        TreeMap.prototype.tailMap = function (fromKey, inclusive) {
          if ((fromKey != null || fromKey === null) && (typeof inclusive === 'boolean' || inclusive === null)) {
            return this.tailMap$java_lang_Object$boolean(fromKey, inclusive);
          } else if ((fromKey != null || fromKey === null) && inclusive === undefined) {
            return this.tailMap$java_lang_Object(fromKey);
          } else throw new Error('invalid overload');
        };
        /**
        * Returns the first node which compares greater than the given key.
        *
        * @param {*} key the key to search for
        * @return {java.util.TreeMap.Node} the next node, or null if there is none
        * @param {boolean} inclusive
        * @private
        */


        TreeMap.prototype.getNodeAfter = function (key, inclusive) {
          var foundNode = null;
          var node = this.root;

          while (node != null) {
            {
              var c = function (target) {
                return target['compare'] === undefined ? target : target['compare'];
              }(this.cmp)(key, node.getKey());

              if (inclusive && c === 0) {
                return node;
              }

              if (c >= 0) {
                node = node.child[TreeMap.RIGHT];
              } else {
                foundNode = node;
                node = node.child[TreeMap.LEFT];
              }
            }
          }

          return foundNode;
        };
        /**
        * Returns the last node which is strictly less than the given key.
        *
        * @param {*} key the key to search for
        * @return {java.util.TreeMap.Node} the previous node, or null if there is none
        * @param {boolean} inclusive
        * @private
        */


        TreeMap.prototype.getNodeBefore = function (key, inclusive) {
          var foundNode = null;
          var node = this.root;

          while (node != null) {
            {
              var c = function (target) {
                return target['compare'] === undefined ? target : target['compare'];
              }(this.cmp)(key, node.getKey());

              if (inclusive && c === 0) {
                return node;
              }

              if (c <= 0) {
                node = node.child[TreeMap.LEFT];
              } else {
                foundNode = node;
                node = node.child[TreeMap.RIGHT];
              }
            }
          }

          return foundNode;
        };

        TreeMap.prototype.assertCorrectness$ = function () {
          this.assertCorrectness$java_util_TreeMap_Node$boolean(this.root, true);
        };
        /**
        *
        * @return {*}
        */


        TreeMap.prototype.descendingEntryIterator = function () {
          return new TreeMap.DescendingEntryIterator(this);
        };
        /**
        *
        * @return {*}
        */


        TreeMap.prototype.entryIterator = function () {
          return new TreeMap.EntryIterator(this);
        };

        TreeMap.prototype.assertCorrectness$java_util_TreeMap_Node$boolean = function (tree, isRed) {
          if (tree == null) {
            return 0;
          }

          if (isRed && tree.isRed) {
            throw new java.lang.RuntimeException("Two red nodes adjacent");
          }

          var leftNode = tree.child[TreeMap.LEFT];

          if (leftNode != null && function (target) {
            return target['compare'] === undefined ? target : target['compare'];
          }(this.cmp)(leftNode.getKey(), tree.getKey()) > 0) {
            throw new java.lang.RuntimeException("Left child " + leftNode + " larger than " + tree);
          }

          var rightNode = tree.child[TreeMap.RIGHT];

          if (rightNode != null && function (target) {
            return target['compare'] === undefined ? target : target['compare'];
          }(this.cmp)(rightNode.getKey(), tree.getKey()) < 0) {
            throw new java.lang.RuntimeException("Right child " + rightNode + " smaller than " + tree);
          }

          var leftHeight = this.assertCorrectness$java_util_TreeMap_Node$boolean(leftNode, tree.isRed);
          var rightHeight = this.assertCorrectness$java_util_TreeMap_Node$boolean(rightNode, tree.isRed);

          if (leftHeight !== 0 && rightHeight !== 0 && leftHeight !== rightHeight) {
            throw new java.lang.RuntimeException("Black heights don\'t match");
          }

          return tree.isRed ? leftHeight : leftHeight + 1;
        };
        /**
        * Internal helper function for public {@link #assertCorrectness()}.
        *
        * @param {java.util.TreeMap.Node} tree the subtree to validate.
        * @param {boolean} isRed true if the parent of this node is red.
        * @return {number} the black height of this subtree.
        * @throws RuntimeException if this RB-tree is not valid.
        * @private
        */


        TreeMap.prototype.assertCorrectness = function (tree, isRed) {
          if ((tree != null && tree instanceof java.util.TreeMap.Node || tree === null) && (typeof isRed === 'boolean' || isRed === null)) {
            return this.assertCorrectness$java_util_TreeMap_Node$boolean(tree, isRed);
          } else if (tree === undefined && isRed === undefined) {
            return this.assertCorrectness$();
          } else throw new Error('invalid overload');
        };
        /**
        * Finds an entry given a key and returns the node.
        *
        * @param {*} key the search key
        * @return {*} the node matching the key or null
        */


        TreeMap.prototype.getEntry = function (key) {
          var tree = this.root;

          while (tree != null) {
            {
              var c = function (target) {
                return target['compare'] === undefined ? target : target['compare'];
              }(this.cmp)(key, tree.getKey());

              if (c === 0) {
                return tree;
              }

              var childNum = c < 0 ? TreeMap.LEFT : TreeMap.RIGHT;
              tree = tree.child[childNum];
            }
          }

          return null;
        };
        /**
        * Returns the left-most node of the tree, or null if empty.
        * @return {*}
        */


        TreeMap.prototype.getFirstEntry = function () {
          if (this.root == null) {
            return null;
          }

          var node = this.root;
          var nextNode;

          while ((nextNode = node.child[TreeMap.LEFT]) != null) {
            {
              node = nextNode;
            }
          }

          return node;
        };
        /**
        * Returns the right-most node of the tree, or null if empty.
        * @return {*}
        */


        TreeMap.prototype.getLastEntry = function () {
          if (this.root == null) {
            return null;
          }

          var node = this.root;
          var nextNode;

          while ((nextNode = node.child[TreeMap.RIGHT]) != null) {
            {
              node = nextNode;
            }
          }

          return node;
        };
        /**
        *
        * @param {*} key
        * @return {*}
        */


        TreeMap.prototype.getCeilingEntry = function (key) {
          return this.getNodeAfter(key, true);
        };
        /**
        *
        * @param {*} key
        * @return {*}
        */


        TreeMap.prototype.getFloorEntry = function (key) {
          return this.getNodeBefore(key, true);
        };
        /**
        *
        * @param {*} key
        * @return {*}
        */


        TreeMap.prototype.getHigherEntry = function (key) {
          return this.getNodeAfter(key, false);
        };
        /**
        *
        * @param {*} key
        * @return {*}
        */


        TreeMap.prototype.getLowerEntry = function (key) {
          return this.getNodeBefore(key, false);
        };
        /**
        *
        * @param {*} entry
        * @return {boolean}
        */


        TreeMap.prototype.removeEntry = function (entry) {
          var state = new TreeMap.State();
          state.matchValue = true;
          state.value = entry.getValue();
          return this.removeWithState(entry.getKey(), state);
        };

        TreeMap.prototype.inOrderAdd = function (list, type, current, fromKey, fromInclusive, toKey, toInclusive) {
          if (current == null) {
            return;
          }

          var leftNode = current.child[TreeMap.LEFT];

          if (leftNode != null) {
            this.inOrderAdd(list, type, leftNode, fromKey, fromInclusive, toKey, toInclusive);
          }

          if (this.inRange(type, current.getKey(), fromKey, fromInclusive, toKey, toInclusive)) {
            list.add(current);
          }

          var rightNode = current.child[TreeMap.RIGHT];

          if (rightNode != null) {
            this.inOrderAdd(list, type, rightNode, fromKey, fromInclusive, toKey, toInclusive);
          }
        };

        TreeMap.prototype.inRange = function (type, key, fromKey, fromInclusive, toKey, toInclusive) {
          if (type.fromKeyValid() && this.smaller(key, fromKey, !fromInclusive)) {
            return false;
          }

          if (type.toKeyValid() && this.larger(key, toKey, !toInclusive)) {
            return false;
          }

          return true;
        };
        /**
        * Insert a node into a subtree, collecting state about the insertion.
        *
        * If the same key already exists, the value of the node is overwritten with
        * the value from the new node instead.
        *
        * @param {java.util.TreeMap.Node} tree subtree to insert into
        * @param {java.util.TreeMap.Node} newNode new node to insert
        * @param {java.util.TreeMap.State} state result of the insertion: state.found true if the key already
        * existed in the tree state.value the old value if the key existed
        * @return {java.util.TreeMap.Node} the new subtree root
        * @private
        */


        TreeMap.prototype.insert = function (tree, newNode, state) {
          if (tree == null) {
            return newNode;
          } else {
            var c = function (target) {
              return target['compare'] === undefined ? target : target['compare'];
            }(this.cmp)(newNode.getKey(), tree.getKey());

            if (c === 0) {
              state.value = tree.setValue(newNode.getValue());
              state.found = true;
              return tree;
            }

            var childNum = c < 0 ? TreeMap.LEFT : TreeMap.RIGHT;
            tree.child[childNum] = this.insert(tree.child[childNum], newNode, state);

            if (this.isRed(tree.child[childNum])) {
              if (this.isRed(tree.child[TreeMap.otherChild(childNum)])) {
                tree.isRed = true;
                tree.child[TreeMap.LEFT].isRed = false;
                tree.child[TreeMap.RIGHT].isRed = false;
              } else {
                if (this.isRed(tree.child[childNum].child[childNum])) {
                  tree = this.rotateSingle(tree, TreeMap.otherChild(childNum));
                } else if (this.isRed(tree.child[childNum].child[TreeMap.otherChild(childNum)])) {
                  tree = this.rotateDouble(tree, TreeMap.otherChild(childNum));
                }
              }
            }
          }

          return tree;
        };
        /**
        * Returns true if <code>node</code> is red. Note that null pointers are
        * considered black.
        * @param {java.util.TreeMap.Node} node
        * @return {boolean}
        * @private
        */


        TreeMap.prototype.isRed = function (node) {
          return node != null && node.isRed;
        };
        /**
        * Returns true if <code>a</code> is greater than or equal to <code>b</code>.
        * @param {*} a
        * @param {*} b
        * @param {boolean} orEqual
        * @return {boolean}
        * @private
        */


        TreeMap.prototype.larger = function (a, b, orEqual) {
          var compare = function (target) {
            return target['compare'] === undefined ? target : target['compare'];
          }(this.cmp)(a, b);

          return compare > 0 || orEqual && compare === 0;
        };
        /**
        * Returns true if <code>a</code> is less than or equal to <code>b</code>.
        * @param {*} a
        * @param {*} b
        * @param {boolean} orEqual
        * @return {boolean}
        * @private
        */


        TreeMap.prototype.smaller = function (a, b, orEqual) {
          var compare = function (target) {
            return target['compare'] === undefined ? target : target['compare'];
          }(this.cmp)(a, b);

          return compare < 0 || orEqual && compare === 0;
        };
        /**
        * Remove a key from the tree, returning whether it was found and its value.
        *
        * @param {*} key key to remove
        * @param {java.util.TreeMap.State} state return state, not null
        * @return {boolean} true if the value was found
        * @private
        */


        TreeMap.prototype.removeWithState = function (key, state) {
          if (this.root == null) {
            return false;
          }

          var found = null;
          var parent = null;
          var head = new TreeMap.Node(null, null);
          var dir = TreeMap.RIGHT;
          head.child[TreeMap.RIGHT] = this.root;
          var node = head;

          while (node.child[dir] != null) {
            {
              var last = dir;
              var grandparent = parent;
              parent = node;
              node = node.child[dir];

              var c = function (target) {
                return target['compare'] === undefined ? target : target['compare'];
              }(this.cmp)(key, node.getKey());

              dir = c < 0 ? TreeMap.LEFT : TreeMap.RIGHT;

              if (c === 0 && (!state.matchValue || java.util.Objects.equals(node.getValue(), state.value))) {
                found = node;
              }

              if (!this.isRed(node) && !this.isRed(node.child[dir])) {
                if (this.isRed(node.child[TreeMap.otherChild(dir)])) {
                  parent = parent.child[last] = this.rotateSingle(node, dir);
                } else if (!this.isRed(node.child[TreeMap.otherChild(dir)])) {
                  var sibling = parent.child[TreeMap.otherChild(last)];

                  if (sibling != null) {
                    if (!this.isRed(sibling.child[TreeMap.otherChild(last)]) && !this.isRed(sibling.child[last])) {
                      parent.isRed = false;
                      sibling.isRed = true;
                      node.isRed = true;
                    } else {
                      var dir2 = grandparent.child[TreeMap.RIGHT] === parent ? TreeMap.RIGHT : TreeMap.LEFT;

                      if (this.isRed(sibling.child[last])) {
                        grandparent.child[dir2] = this.rotateDouble(parent, last);
                      } else if (this.isRed(sibling.child[TreeMap.otherChild(last)])) {
                        grandparent.child[dir2] = this.rotateSingle(parent, last);
                      }

                      node.isRed = grandparent.child[dir2].isRed = true;
                      grandparent.child[dir2].child[TreeMap.LEFT].isRed = false;
                      grandparent.child[dir2].child[TreeMap.RIGHT].isRed = false;
                    }
                  }
                }
              }
            }
          }

          if (found != null) {
            state.found = true;
            state.value = found.getValue();

            if (node !== found) {
              var newNode = new TreeMap.Node(node.getKey(), node.getValue());
              this.replaceNode(head, found, newNode);

              if (parent === found) {
                parent = newNode;
              }
            }

            parent.child[parent.child[TreeMap.RIGHT] === node ? TreeMap.RIGHT : TreeMap.LEFT] = node.child[node.child[TreeMap.LEFT] == null ? TreeMap.RIGHT : TreeMap.LEFT];
            this.__size--;
          }

          this.root = head.child[TreeMap.RIGHT];

          if (this.root != null) {
            this.root.isRed = false;
          }

          return state.found;
        };
        /**
        * replace 'node' with 'newNode' in the tree rooted at 'head'. Could have
        * avoided this traversal if each node maintained a parent pointer.
        * @param {java.util.TreeMap.Node} head
        * @param {java.util.TreeMap.Node} node
        * @param {java.util.TreeMap.Node} newNode
        * @private
        */


        TreeMap.prototype.replaceNode = function (head, node, newNode) {
          var parent = head;
          var direction = parent.getKey() == null || function (target) {
            return target['compare'] === undefined ? target : target['compare'];
          }(this.cmp)(node.getKey(), parent.getKey()) > 0 ? TreeMap.RIGHT : TreeMap.LEFT;

          while (parent.child[direction] !== node) {
            {
              parent = parent.child[direction];
              direction = function (target) {
                return target['compare'] === undefined ? target : target['compare'];
              }(this.cmp)(node.getKey(), parent.getKey()) > 0 ? TreeMap.RIGHT : TreeMap.LEFT;
            }
          }

          parent.child[direction] = newNode;
          newNode.isRed = node.isRed;
          newNode.child[TreeMap.LEFT] = node.child[TreeMap.LEFT];
          newNode.child[TreeMap.RIGHT] = node.child[TreeMap.RIGHT];
          node.child[TreeMap.LEFT] = null;
          node.child[TreeMap.RIGHT] = null;
        };
        /**
        * Perform a double rotation, first rotating the child which will become the
        * root in the opposite direction, then rotating the root in the specified
        * direction.
        *
        * <pre>
        * A                                               F
        * B   C    becomes (with rotateDirection=0)       A   C
        * D E F G                                         B E   G
        * D
        * </pre>
        *
        * @param {java.util.TreeMap.Node} tree root of the subtree to rotate
        * @param {number} rotateDirection the direction to rotate: 0=left, 1=right
        * @return {java.util.TreeMap.Node} the new root of the rotated subtree
        * @private
        */


        TreeMap.prototype.rotateDouble = function (tree, rotateDirection) {
          var otherChildDir = TreeMap.otherChild(rotateDirection);
          tree.child[otherChildDir] = this.rotateSingle(tree.child[otherChildDir], otherChildDir);
          return this.rotateSingle(tree, rotateDirection);
        };
        /**
        * Perform a single rotation, pushing the root of the subtree to the specified
        * direction.
        *
        * <pre>
        * A                                              B
        * B   C     becomes (with rotateDirection=1)     D   A
        * D E                                              E   C
        * </pre>
        *
        * @param {java.util.TreeMap.Node} tree the root of the subtree to rotate
        * @param {number} rotateDirection the direction to rotate: 0=left rotation, 1=right
        * @return {java.util.TreeMap.Node} the new root of the rotated subtree
        * @private
        */


        TreeMap.prototype.rotateSingle = function (tree, rotateDirection) {
          var otherChildDir = TreeMap.otherChild(rotateDirection);
          var save = tree.child[otherChildDir];
          tree.child[otherChildDir] = save.child[rotateDirection];
          save.child[rotateDirection] = tree;
          tree.isRed = true;
          save.isRed = false;
          return save;
        };

        TreeMap.LEFT = 0;
        TreeMap.RIGHT = 1;
        return TreeMap;
      }(java.util.AbstractNavigableMap);

      util.TreeMap = TreeMap;
      TreeMap["__class"] = "java.util.TreeMap";
      TreeMap["__interfaces"] = ["java.util.Map", "java.util.NavigableMap", "java.util.SortedMap", "java.io.Serializable"];

      (function (TreeMap) {
        /**
        * Create an iterator which may return only a restricted range.
        *
        * @param {*} fromKey the first key to return in the iterator.
        * @param {*} toKey the upper bound of keys to return.
        * @param {java.util.TreeMap.SubMapType} type
        * @param {boolean} fromInclusive
        * @param {boolean} toInclusive
        * @class
        */
        var DescendingEntryIterator =
        /** @class */
        function () {
          function DescendingEntryIterator(__parent, type, fromKey, fromInclusive, toKey, toInclusive) {
            if ((type != null && type instanceof java.util.TreeMap.SubMapType || type === null) && (fromKey != null || fromKey === null) && (typeof fromInclusive === 'boolean' || fromInclusive === null) && (toKey != null || toKey === null) && (typeof toInclusive === 'boolean' || toInclusive === null)) {
              Array.prototype.slice.call(arguments, [1]);

              if (this.iter === undefined) {
                this.iter = null;
              }

              if (this.last === undefined) {
                this.last = null;
              }

              var list = new java.util.ArrayList();

              __parent.inOrderAdd(list, type, __parent.root, fromKey, fromInclusive, toKey, toInclusive);

              this.iter = list['listIterator$int'](list.size());
            } else if (type === undefined && fromKey === undefined && fromInclusive === undefined && toKey === undefined && toInclusive === undefined) {
              Array.prototype.slice.call(arguments, [1]);
              {
                Array.prototype.slice.call(arguments, [1]);
                var type_1 = java.util.TreeMap.SubMapType_All_$LI$();
                var fromKey_1 = null;
                var fromInclusive_1 = false;
                var toKey_1 = null;
                var toInclusive_1 = false;

                if (this.iter === undefined) {
                  this.iter = null;
                }

                if (this.last === undefined) {
                  this.last = null;
                }

                var list = new java.util.ArrayList();

                __parent.inOrderAdd(list, type_1, __parent.root, fromKey_1, fromInclusive_1, toKey_1, toInclusive_1);

                this.iter = list['listIterator$int'](list.size());
              }

              if (this.iter === undefined) {
                this.iter = null;
              }

              if (this.last === undefined) {
                this.last = null;
              }
            } else throw new Error('invalid overload');
          }
          /* Default method injected from java.util.Iterator */


          DescendingEntryIterator.prototype.forEachRemaining = function (consumer) {
            var _this = this;

            javaemul.internal.InternalPreconditions.checkNotNull(consumer);

            while (this.hasNext()) {
              {
                (function (target) {
                  return typeof target === 'function' ? target(_this.next()) : target.accept(_this.next());
                })(consumer);
              }
            }
          };
          /**
          *
          * @return {boolean}
          */


          DescendingEntryIterator.prototype.hasNext = function () {
            return this.iter.hasPrevious();
          };
          /**
          *
          * @return {*}
          */


          DescendingEntryIterator.prototype.next = function () {
            return this.last = this.iter.previous();
          };
          /**
          *
          */


          DescendingEntryIterator.prototype.remove = function () {
            this.iter.remove();

            this.__parent.removeEntry(this.last);

            this.last = null;
          };

          return DescendingEntryIterator;
        }();

        TreeMap.DescendingEntryIterator = DescendingEntryIterator;
        DescendingEntryIterator["__class"] = "java.util.TreeMap.DescendingEntryIterator";
        DescendingEntryIterator["__interfaces"] = ["java.util.Iterator"];
        /**
        * Create an iterator which may return only a restricted range.
        *
        * @param {*} fromKey the first key to return in the iterator.
        * @param {*} toKey the upper bound of keys to return.
        * @param {java.util.TreeMap.SubMapType} type
        * @param {boolean} fromInclusive
        * @param {boolean} toInclusive
        * @class
        */

        var EntryIterator =
        /** @class */
        function () {
          function EntryIterator(__parent, type, fromKey, fromInclusive, toKey, toInclusive) {
            if ((type != null && type instanceof java.util.TreeMap.SubMapType || type === null) && (fromKey != null || fromKey === null) && (typeof fromInclusive === 'boolean' || fromInclusive === null) && (toKey != null || toKey === null) && (typeof toInclusive === 'boolean' || toInclusive === null)) {
              Array.prototype.slice.call(arguments, [1]);

              if (this.iter === undefined) {
                this.iter = null;
              }

              if (this.last === undefined) {
                this.last = null;
              }

              var list = new java.util.ArrayList();

              __parent.inOrderAdd(list, type, __parent.root, fromKey, fromInclusive, toKey, toInclusive);

              this.iter = list['listIterator$']();
            } else if (type === undefined && fromKey === undefined && fromInclusive === undefined && toKey === undefined && toInclusive === undefined) {
              Array.prototype.slice.call(arguments, [1]);
              {
                Array.prototype.slice.call(arguments, [1]);
                var type_2 = java.util.TreeMap.SubMapType_All_$LI$();
                var fromKey_2 = null;
                var fromInclusive_2 = false;
                var toKey_2 = null;
                var toInclusive_2 = false;

                if (this.iter === undefined) {
                  this.iter = null;
                }

                if (this.last === undefined) {
                  this.last = null;
                }

                var list = new java.util.ArrayList();

                __parent.inOrderAdd(list, type_2, __parent.root, fromKey_2, fromInclusive_2, toKey_2, toInclusive_2);

                this.iter = list['listIterator$']();
              }

              if (this.iter === undefined) {
                this.iter = null;
              }

              if (this.last === undefined) {
                this.last = null;
              }
            } else throw new Error('invalid overload');
          }
          /* Default method injected from java.util.Iterator */


          EntryIterator.prototype.forEachRemaining = function (consumer) {
            var _this = this;

            javaemul.internal.InternalPreconditions.checkNotNull(consumer);

            while (this.hasNext()) {
              {
                (function (target) {
                  return typeof target === 'function' ? target(_this.next()) : target.accept(_this.next());
                })(consumer);
              }
            }
          };
          /**
          *
          * @return {boolean}
          */


          EntryIterator.prototype.hasNext = function () {
            return this.iter.hasNext();
          };
          /**
          *
          * @return {*}
          */


          EntryIterator.prototype.next = function () {
            return this.last = this.iter.next();
          };
          /**
          *
          */


          EntryIterator.prototype.remove = function () {
            this.iter.remove();

            this.__parent.removeEntry(this.last);

            this.last = null;
          };

          return EntryIterator;
        }();

        TreeMap.EntryIterator = EntryIterator;
        EntryIterator["__class"] = "java.util.TreeMap.EntryIterator";
        EntryIterator["__interfaces"] = ["java.util.Iterator"];

        var __java_util_TreeMap_EntrySet =
        /** @class */
        function (_super) {
          __extends(__java_util_TreeMap_EntrySet, _super);

          function __java_util_TreeMap_EntrySet(__parent) {
            var _this = _super.call(this, __parent) || this;

            _this.__parent = __parent;
            return _this;
          }
          /**
          *
          */


          __java_util_TreeMap_EntrySet.prototype.clear = function () {
            this.clear();
          };

          return __java_util_TreeMap_EntrySet;
        }(java.util.AbstractNavigableMap.EntrySet);

        TreeMap.__java_util_TreeMap_EntrySet = __java_util_TreeMap_EntrySet;
        __java_util_TreeMap_EntrySet["__class"] = "java.util.TreeMap.EntrySet";
        __java_util_TreeMap_EntrySet["__interfaces"] = ["java.util.Collection", "java.util.Set", "java.lang.Iterable"];
        /**
        * Create a node of the specified color.
        *
        * @param {*} key
        * @param {*} value
        * @param {boolean} isRed true if this should be a red node, false for black
        * @class
        * @extends java.util.AbstractMap.SimpleEntry
        */

        var Node =
        /** @class */
        function (_super) {
          __extends(Node, _super);

          function Node(key, value, isRed) {
            var _this = this;

            if ((key != null || key === null) && (value != null || value === null) && (typeof isRed === 'boolean' || isRed === null)) {
              _this = _super.call(this, key, value) || this;

              if (_this.isRed === undefined) {
                _this.isRed = false;
              }

              _this.child = [null, null];
              _this.isRed = isRed;
            } else if ((key != null || key === null) && (value != null || value === null) && isRed === undefined) {
              {
                var isRed_1 = true;
                _this = _super.call(this, key, value) || this;

                if (_this.isRed === undefined) {
                  _this.isRed = false;
                }

                _this.child = [null, null];
                _this.isRed = isRed_1;
              }

              if (_this.isRed === undefined) {
                _this.isRed = false;
              }

              _this.child = [null, null];
            } else throw new Error('invalid overload');

            return _this;
          }

          return Node;
        }(util.AbstractMap.SimpleEntry);

        TreeMap.Node = Node;
        Node["__class"] = "java.util.TreeMap.Node";
        Node["__interfaces"] = ["java.util.Map.Entry"];
        /**
        * A state object which is passed down the tree for both insert and remove.
        * All uses make use of the done flag to indicate when no further rebalancing
        * of the tree is required. Remove methods use the found flag to indicate when
        * the desired key has been found. value is used both to return the value of a
        * removed node as well as to pass in a value which must match (used for
        * entrySet().remove(entry)), and the matchValue flag is used to request this
        * behavior.
        *
        * @param <V> value type
        * @class
        */

        var State =
        /** @class */
        function () {
          function State() {
            if (this.done === undefined) {
              this.done = false;
            }

            if (this.found === undefined) {
              this.found = false;
            }

            if (this.matchValue === undefined) {
              this.matchValue = false;
            }

            if (this.value === undefined) {
              this.value = null;
            }
          }
          /**
          *
          * @return {string}
          */


          State.prototype.toString = function () {
            return "State: mv=" + this.matchValue + " value=" + this.value + " done=" + this.done + " found=" + this.found;
          };

          return State;
        }();

        TreeMap.State = State;
        State["__class"] = "java.util.TreeMap.State";

        var SubMap =
        /** @class */
        function (_super) {
          __extends(SubMap, _super);

          function SubMap(__parent, type, fromKey, fromInclusive, toKey, toInclusive) {
            var _this = _super.call(this) || this;

            _this.__parent = __parent;

            if (_this.fromInclusive === undefined) {
              _this.fromInclusive = false;
            }

            if (_this.fromKey === undefined) {
              _this.fromKey = null;
            }

            if (_this.toInclusive === undefined) {
              _this.toInclusive = false;
            }

            if (_this.toKey === undefined) {
              _this.toKey = null;
            }

            if (_this.type === undefined) {
              _this.type = null;
            }

            if (type === java.util.TreeMap.SubMapType_Range_$LI$()) {
              if (function (target) {
                return target['compare'] === undefined ? target : target['compare'];
              }(__parent.cmp)(toKey, fromKey) < 0) {
                throw new java.lang.IllegalArgumentException("subMap: " + toKey + " less than " + fromKey);
              }
            }

            if (type === java.util.TreeMap.SubMapType_Head_$LI$()) {
              (function (target) {
                return target['compare'] === undefined ? target : target['compare'];
              })(__parent.cmp)(toKey, toKey);
            }

            if (type === java.util.TreeMap.SubMapType_Tail_$LI$()) {
              (function (target) {
                return target['compare'] === undefined ? target : target['compare'];
              })(__parent.cmp)(fromKey, fromKey);
            }

            if (type === java.util.TreeMap.SubMapType_All_$LI$()) ;
            _this.type = type;
            _this.fromKey = fromKey;
            _this.fromInclusive = fromInclusive;
            _this.toKey = toKey;
            _this.toInclusive = toInclusive;
            return _this;
          }
          /**
          *
          * @return {*}
          */


          SubMap.prototype.comparator = function () {
            return this.comparator();
          };
          /**
          *
          * @return {*}
          */


          SubMap.prototype.entrySet = function () {
            return new SubMap.SubMap$0(this);
          };

          SubMap.prototype.headMap$java_lang_Object$boolean = function (toKey, toInclusive) {
            if (this.type.toKeyValid() && function (target) {
              return target['compare'] === undefined ? target : target['compare'];
            }(this.__parent.cmp)(toKey, this.toKey) > 0) {
              throw new java.lang.IllegalArgumentException("subMap: " + toKey + " greater than " + this.toKey);
            }

            if (this.type.fromKeyValid()) {
              return this.subMap(this.fromKey, this.fromInclusive, toKey, toInclusive);
            } else {
              return this.headMap(toKey, toInclusive);
            }
          };
          /**
          *
          * @param {*} toKey
          * @param {boolean} toInclusive
          * @return {*}
          */


          SubMap.prototype.headMap = function (toKey, toInclusive) {
            if ((toKey != null || toKey === null) && (typeof toInclusive === 'boolean' || toInclusive === null)) {
              return this.headMap$java_lang_Object$boolean(toKey, toInclusive);
            } else if ((toKey != null || toKey === null) && toInclusive === undefined) {
              return this.headMap$java_lang_Object(toKey);
            } else throw new Error('invalid overload');
          };
          /**
          *
          * @return {boolean}
          */


          SubMap.prototype.isEmpty = function () {
            return this.getFirstEntry() == null;
          };
          /**
          *
          * @param {*} key
          * @param {*} value
          * @return {*}
          */


          SubMap.prototype.put = function (key, value) {
            if (!this.inRange(key)) {
              throw new java.lang.IllegalArgumentException(key + " outside the range " + this.fromKey + " to " + this.toKey);
            }

            return this.put(key, value);
          };
          /**
          *
          * @param {*} k
          * @return {*}
          */


          SubMap.prototype.remove = function (k) {
            var key = k;

            if (!this.inRange(key)) {
              return null;
            }

            return this.remove(key);
          };
          /**
          *
          * @return {number}
          */


          SubMap.prototype.size = function () {
            var count = 0;

            for (var it = this.entryIterator(); it.hasNext(); it.next()) {
              {
                count++;
              }
            }

            return count;
          };

          SubMap.prototype.subMap$java_lang_Object$boolean$java_lang_Object$boolean = function (newFromKey, newFromInclusive, newToKey, newToInclusive) {
            if (this.type.fromKeyValid() && function (target) {
              return target['compare'] === undefined ? target : target['compare'];
            }(this.__parent.cmp)(newFromKey, this.fromKey) < 0) {
              throw new java.lang.IllegalArgumentException("subMap: " + newFromKey + " less than " + this.fromKey);
            }

            if (this.type.toKeyValid() && function (target) {
              return target['compare'] === undefined ? target : target['compare'];
            }(this.__parent.cmp)(newToKey, this.toKey) > 0) {
              throw new java.lang.IllegalArgumentException("subMap: " + newToKey + " greater than " + this.toKey);
            }

            return this.subMap(newFromKey, newFromInclusive, newToKey, newToInclusive);
          };
          /**
          *
          * @param {*} newFromKey
          * @param {boolean} newFromInclusive
          * @param {*} newToKey
          * @param {boolean} newToInclusive
          * @return {*}
          */


          SubMap.prototype.subMap = function (newFromKey, newFromInclusive, newToKey, newToInclusive) {
            if ((newFromKey != null || newFromKey === null) && (typeof newFromInclusive === 'boolean' || newFromInclusive === null) && (newToKey != null || newToKey === null) && (typeof newToInclusive === 'boolean' || newToInclusive === null)) {
              return this.subMap$java_lang_Object$boolean$java_lang_Object$boolean(newFromKey, newFromInclusive, newToKey, newToInclusive);
            } else if ((newFromKey != null || newFromKey === null) && (newFromInclusive != null || newFromInclusive === null) && newToKey === undefined && newToInclusive === undefined) {
              return this.subMap$java_lang_Object$java_lang_Object(newFromKey, newFromInclusive);
            } else throw new Error('invalid overload');
          };

          SubMap.prototype.tailMap$java_lang_Object$boolean = function (fromKey, fromInclusive) {
            if (this.type.fromKeyValid() && function (target) {
              return target['compare'] === undefined ? target : target['compare'];
            }(this.__parent.cmp)(fromKey, this.fromKey) < 0) {
              throw new java.lang.IllegalArgumentException("subMap: " + fromKey + " less than " + this.fromKey);
            }

            if (this.type.toKeyValid()) {
              return this.subMap(fromKey, fromInclusive, this.toKey, this.toInclusive);
            } else {
              return this.tailMap(fromKey, fromInclusive);
            }
          };
          /**
          *
          * @param {*} fromKey
          * @param {boolean} fromInclusive
          * @return {*}
          */


          SubMap.prototype.tailMap = function (fromKey, fromInclusive) {
            if ((fromKey != null || fromKey === null) && (typeof fromInclusive === 'boolean' || fromInclusive === null)) {
              return this.tailMap$java_lang_Object$boolean(fromKey, fromInclusive);
            } else if ((fromKey != null || fromKey === null) && fromInclusive === undefined) {
              return this.tailMap$java_lang_Object(fromKey);
            } else throw new Error('invalid overload');
          };
          /**
          *
          * @return {*}
          */


          SubMap.prototype.descendingEntryIterator = function () {
            return new TreeMap.DescendingEntryIterator(this.__parent, this.type, this.fromKey, this.fromInclusive, this.toKey, this.toInclusive);
          };
          /**
          *
          * @return {*}
          */


          SubMap.prototype.entryIterator = function () {
            return new TreeMap.EntryIterator(this.__parent, this.type, this.fromKey, this.fromInclusive, this.toKey, this.toInclusive);
          };
          /**
          *
          * @param {*} key
          * @return {*}
          */


          SubMap.prototype.getEntry = function (key) {
            return this.guardInRange(this.getEntry(key));
          };
          /**
          *
          * @return {*}
          */


          SubMap.prototype.getFirstEntry = function () {
            var entry;

            if (this.type.fromKeyValid()) {
              if (this.fromInclusive) {
                entry = this.getCeilingEntry(this.fromKey);
              } else {
                entry = this.getHigherEntry(this.fromKey);
              }
            } else {
              entry = this.getFirstEntry();
            }

            return this.guardInRange(entry);
          };
          /**
          *
          * @return {*}
          */


          SubMap.prototype.getLastEntry = function () {
            var entry;

            if (this.type.toKeyValid()) {
              if (this.toInclusive) {
                entry = this.getFloorEntry(this.toKey);
              } else {
                entry = this.getLowerEntry(this.toKey);
              }
            } else {
              entry = this.getLastEntry();
            }

            return this.guardInRange(entry);
          };
          /**
          *
          * @param {*} key
          * @return {*}
          */


          SubMap.prototype.getCeilingEntry = function (key) {
            return this.guardInRange(this.getCeilingEntry(key));
          };
          /**
          *
          * @param {*} key
          * @return {*}
          */


          SubMap.prototype.getFloorEntry = function (key) {
            return this.guardInRange(this.getFloorEntry(key));
          };
          /**
          *
          * @param {*} key
          * @return {*}
          */


          SubMap.prototype.getHigherEntry = function (key) {
            return this.guardInRange(this.getHigherEntry(key));
          };
          /**
          *
          * @param {*} key
          * @return {*}
          */


          SubMap.prototype.getLowerEntry = function (key) {
            return this.guardInRange(this.getLowerEntry(key));
          };
          /**
          *
          * @param {*} entry
          * @return {boolean}
          */


          SubMap.prototype.removeEntry = function (entry) {
            return this.inRange(entry.getKey()) && this.removeEntry(entry);
          };

          SubMap.prototype.guardInRange = function (entry) {
            return entry != null && this.inRange(entry.getKey()) ? entry : null;
          };

          SubMap.prototype.inRange = function (key) {
            return this.__parent.inRange(this.type, key, this.fromKey, this.fromInclusive, this.toKey, this.toInclusive);
          };

          return SubMap;
        }(java.util.AbstractNavigableMap);

        TreeMap.SubMap = SubMap;
        SubMap["__class"] = "java.util.TreeMap.SubMap";
        SubMap["__interfaces"] = ["java.util.Map", "java.util.NavigableMap", "java.util.SortedMap"];

        (function (SubMap) {
          var SubMap$0 =
          /** @class */
          function (_super) {
            __extends(SubMap$0, _super);

            function SubMap$0(__parent) {
              var _this = _super.call(this, __parent) || this;

              _this.__parent = __parent;
              return _this;
            }
            /**
            *
            * @return {boolean}
            */


            SubMap$0.prototype.isEmpty = function () {
              return this.isEmpty();
            };

            return SubMap$0;
          }(TreeMap.SubMap.EntrySet);

          SubMap.SubMap$0 = SubMap$0;
          SubMap$0["__interfaces"] = ["java.util.Collection", "java.util.Set", "java.lang.Iterable"];
        })(SubMap = TreeMap.SubMap || (TreeMap.SubMap = {}));

        var SubMapType =
        /** @class */
        function () {
          function SubMapType() {}
          /**
          * Returns true if this submap type uses a from-key.
          * @return {boolean}
          */


          SubMapType.prototype.fromKeyValid = function () {
            return false;
          };
          /**
          * Returns true if this submap type uses a to-key.
          * @return {boolean}
          */


          SubMapType.prototype.toKeyValid = function () {
            return false;
          };

          return SubMapType;
        }();

        TreeMap.SubMapType = SubMapType;
        SubMapType["__class"] = "java.util.TreeMap.SubMapType";

        var SubMapTypeHead =
        /** @class */
        function (_super) {
          __extends(SubMapTypeHead, _super);

          function SubMapTypeHead() {
            return _super.call(this) || this;
          }
          /**
          *
          * @return {boolean}
          */


          SubMapTypeHead.prototype.toKeyValid = function () {
            return true;
          };

          return SubMapTypeHead;
        }(TreeMap.SubMapType);

        TreeMap.SubMapTypeHead = SubMapTypeHead;
        SubMapTypeHead["__class"] = "java.util.TreeMap.SubMapTypeHead";

        var SubMapTypeRange =
        /** @class */
        function (_super) {
          __extends(SubMapTypeRange, _super);

          function SubMapTypeRange() {
            return _super.call(this) || this;
          }
          /**
          *
          * @return {boolean}
          */


          SubMapTypeRange.prototype.fromKeyValid = function () {
            return true;
          };
          /**
          *
          * @return {boolean}
          */


          SubMapTypeRange.prototype.toKeyValid = function () {
            return true;
          };

          return SubMapTypeRange;
        }(TreeMap.SubMapType);

        TreeMap.SubMapTypeRange = SubMapTypeRange;
        SubMapTypeRange["__class"] = "java.util.TreeMap.SubMapTypeRange";

        var SubMapTypeTail =
        /** @class */
        function (_super) {
          __extends(SubMapTypeTail, _super);

          function SubMapTypeTail() {
            return _super.call(this) || this;
          }
          /**
          *
          * @return {boolean}
          */


          SubMapTypeTail.prototype.fromKeyValid = function () {
            return true;
          };

          return SubMapTypeTail;
        }(TreeMap.SubMapType);

        TreeMap.SubMapTypeTail = SubMapTypeTail;
        SubMapTypeTail["__class"] = "java.util.TreeMap.SubMapTypeTail";
      })(TreeMap = util.TreeMap || (util.TreeMap = {}));
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      (function (stream) {
        var Collectors =
        /** @class */
        function () {
          function Collectors() {}

          Collectors.throwingMerger = function () {
            return function (u, v) {
              throw new java.lang.IllegalStateException(javaemul.internal.StringHelper.format("Duplicate key %s", u));
            };
          };

          Collectors.CH_ID_$LI$ = function () {
            if (Collectors.CH_ID == null) {
              Collectors.CH_ID = java.util.Collections.unmodifiableSet(java.util.Collections.singleton(java.util.stream.Collector.Characteristics.IDENTITY_FINISH));
            }

            return Collectors.CH_ID;
          };

          Collectors.CH_NOID_$LI$ = function () {
            if (Collectors.CH_NOID == null) {
              Collectors.CH_NOID = java.util.Collections.emptySet();
            }

            return Collectors.CH_NOID;
          };

          Collectors.toList = function () {
            return new Collectors.CollectorImpl(function () {
              return new java.util.ArrayList();
            }, function (l, i) {
              return l.add(i);
            }, function (left, right) {
              left.addAll$java_util_Collection(right);
              return left;
            });
          };

          Collectors.toSet = function () {
            return new Collectors.CollectorImpl(function () {
              return new java.util.HashSet();
            }, function (s, i) {
              return s.add(i);
            }, function (left, right) {
              left.addAll(right);
              return left;
            });
          };

          Collectors.toMap$java_util_function_Function$java_util_function_Function = function (keyMapper, valueMapper) {
            return Collectors.toMap$java_util_function_Function$java_util_function_Function$java_util_function_BinaryOperator$java_util_function_Supplier(keyMapper, valueMapper, Collectors.throwingMerger(), function () {
              return new java.util.HashMap();
            });
          };

          Collectors.toMap$java_util_function_Function$java_util_function_Function$java_util_function_BinaryOperator = function (keyMapper, valueMapper, mergeFunction) {
            return Collectors.toMap$java_util_function_Function$java_util_function_Function$java_util_function_BinaryOperator$java_util_function_Supplier(keyMapper, valueMapper, mergeFunction, function () {
              return new java.util.HashMap();
            });
          };

          Collectors.toMap$java_util_function_Function$java_util_function_Function$java_util_function_BinaryOperator$java_util_function_Supplier = function (keyMapper, valueMapper, mergeFunction, mapSupplier) {
            var accumulator = function accumulator(map, element) {
              return map.merge(function (target) {
                return typeof target === 'function' ? target(element) : target.apply(element);
              }(keyMapper), function (target) {
                return typeof target === 'function' ? target(element) : target.apply(element);
              }(valueMapper), mergeFunction);
            };

            return new Collectors.CollectorImpl(mapSupplier, accumulator, Collectors.mapMerger(mergeFunction));
          };

          Collectors.toMap = function (keyMapper, valueMapper, mergeFunction, mapSupplier) {
            if ((typeof keyMapper === 'function' && keyMapper.length === 1 || keyMapper === null) && (typeof valueMapper === 'function' && valueMapper.length === 1 || valueMapper === null) && (typeof mergeFunction === 'function' && mergeFunction.length === 2 || mergeFunction === null) && (typeof mapSupplier === 'function' && mapSupplier.length === 0 || mapSupplier === null)) {
              return java.util.stream.Collectors.toMap$java_util_function_Function$java_util_function_Function$java_util_function_BinaryOperator$java_util_function_Supplier(keyMapper, valueMapper, mergeFunction, mapSupplier);
            } else if ((typeof keyMapper === 'function' && keyMapper.length === 1 || keyMapper === null) && (typeof valueMapper === 'function' && valueMapper.length === 1 || valueMapper === null) && (typeof mergeFunction === 'function' && mergeFunction.length === 2 || mergeFunction === null) && mapSupplier === undefined) {
              return java.util.stream.Collectors.toMap$java_util_function_Function$java_util_function_Function$java_util_function_BinaryOperator(keyMapper, valueMapper, mergeFunction);
            } else if ((typeof keyMapper === 'function' && keyMapper.length === 1 || keyMapper === null) && (typeof valueMapper === 'function' && valueMapper.length === 1 || valueMapper === null) && mergeFunction === undefined && mapSupplier === undefined) {
              return java.util.stream.Collectors.toMap$java_util_function_Function$java_util_function_Function(keyMapper, valueMapper);
            } else throw new Error('invalid overload');
          };

          Collectors.mapMerger = function (mergeFunction) {
            return function (m1, m2) {
              for (var index197 = m2.entrySet().iterator(); index197.hasNext();) {
                var e = index197.next();
                m1.merge(e.getKey(), e.getValue(), mergeFunction);
              }

              return m1;
            };
          };

          Collectors.joining$ = function () {
            return new Collectors.CollectorImpl(function () {
              return new java.lang.StringBuilder();
            }, function (instance$StringBuilder, x) {
              return instance$StringBuilder.append(x);
            }, function (r1, r2) {
              r1.append$java_lang_CharSequence(r2);
              return r1;
            });
          };

          Collectors.joining$java_lang_CharSequence = function (delimiter) {
            return Collectors.joining$java_lang_CharSequence$java_lang_CharSequence$java_lang_CharSequence(delimiter, "", "");
          };

          Collectors.joining$java_lang_CharSequence$java_lang_CharSequence$java_lang_CharSequence = function (delimiter, prefix, suffix) {
            return new Collectors.CollectorImpl(function () {
              return new java.util.StringJoiner(delimiter, prefix, suffix);
            }, function (instance$StringJoiner, newElement) {
              return instance$StringJoiner.add(newElement);
            }, function (instance$StringJoiner, other) {
              return instance$StringJoiner.merge(other);
            });
          };
          /**
          * Returns a {@code Collector} that concatenates the input elements, separated
          * by the specified delimiter, with the specified prefix and suffix, in
          * encounter order.
          *
          * @param {*} delimiter
          * the delimiter to be used between each element
          * @param {*} prefix
          * the sequence of characters to be used at the beginning of the
          * joined result
          * @param {*} suffix
          * the sequence of characters to be used at the end of the joined
          * result
          * @return {*} A {@code Collector} which concatenates CharSequence elements,
          * separated by the specified delimiter, in encounter order
          */


          Collectors.joining = function (delimiter, prefix, suffix) {
            if ((delimiter != null && (delimiter.constructor != null && delimiter.constructor["__interfaces"] != null && delimiter.constructor["__interfaces"].indexOf("java.lang.CharSequence") >= 0 || typeof delimiter === "string") || delimiter === null) && (prefix != null && (prefix.constructor != null && prefix.constructor["__interfaces"] != null && prefix.constructor["__interfaces"].indexOf("java.lang.CharSequence") >= 0 || typeof prefix === "string") || prefix === null) && (suffix != null && (suffix.constructor != null && suffix.constructor["__interfaces"] != null && suffix.constructor["__interfaces"].indexOf("java.lang.CharSequence") >= 0 || typeof suffix === "string") || suffix === null)) {
              return java.util.stream.Collectors.joining$java_lang_CharSequence$java_lang_CharSequence$java_lang_CharSequence(delimiter, prefix, suffix);
            } else if ((delimiter != null && (delimiter.constructor != null && delimiter.constructor["__interfaces"] != null && delimiter.constructor["__interfaces"].indexOf("java.lang.CharSequence") >= 0 || typeof delimiter === "string") || delimiter === null) && prefix === undefined && suffix === undefined) {
              return java.util.stream.Collectors.joining$java_lang_CharSequence(delimiter);
            } else if (delimiter === undefined && prefix === undefined && suffix === undefined) {
              return java.util.stream.Collectors.joining$();
            } else throw new Error('invalid overload');
          };

          Collectors.groupingBy$java_util_function_Function$java_util_stream_Collector = function (classifier, downstream) {
            return Collectors.groupingBy$java_util_function_Function$java_util_function_Supplier$java_util_stream_Collector(classifier, function () {
              return new java.util.HashMap();
            }, downstream);
          };

          Collectors.groupingBy$java_util_function_Function$java_util_function_Supplier$java_util_stream_Collector = function (classifier, mapFactory, downstream) {
            var downstreamSupplier = downstream.supplier();
            var downstreamAccumulator = downstream.accumulator();

            var accumulator = function (downstreamAccumulator) {
              return function (m, t) {
                var key = java.util.Objects.requireNonNull(function (target) {
                  return typeof target === 'function' ? target(t) : target.apply(t);
                }(classifier), "element cannot be mapped to a null key");
                var container = m.computeIfAbsent(key, function (k) {
                  return function (target) {
                    return typeof target === 'function' ? target() : target.get();
                  }(downstreamSupplier);
                });

                (function (target) {
                  return typeof target === 'function' ? target(container, t) : target.accept(container, t);
                })(downstreamAccumulator);
              };
            }(downstreamAccumulator);

            var merger = Collectors.mapMerger(downstream.combiner());
            var mangledFactory = mapFactory;

            if (downstream.characteristics().contains(java.util.stream.Collector.Characteristics.IDENTITY_FINISH)) {
              return new Collectors.CollectorImpl(mangledFactory, accumulator, merger, Collectors.CH_ID_$LI$());
            } else {
              var downstreamFinisher_1 = downstream.finisher();

              var finisher = function finisher(intermediate) {
                intermediate.replaceAll(function (k, v) {
                  return function (target) {
                    return typeof target === 'function' ? target(v) : target.apply(v);
                  }(downstreamFinisher_1);
                });
                var castResult = intermediate;
                return castResult;
              };

              return new Collectors.CollectorImpl(mangledFactory, accumulator, merger, finisher, Collectors.CH_NOID_$LI$());
            }
          };

          Collectors.groupingBy = function (classifier, mapFactory, downstream) {
            if ((typeof classifier === 'function' && classifier.length === 1 || classifier === null) && (typeof mapFactory === 'function' && mapFactory.length === 0 || mapFactory === null) && (downstream != null && downstream.constructor != null && downstream.constructor["__interfaces"] != null && downstream.constructor["__interfaces"].indexOf("java.util.stream.Collector") >= 0 || downstream === null)) {
              return java.util.stream.Collectors.groupingBy$java_util_function_Function$java_util_function_Supplier$java_util_stream_Collector(classifier, mapFactory, downstream);
            } else if ((typeof classifier === 'function' && classifier.length === 1 || classifier === null) && (mapFactory != null && mapFactory.constructor != null && mapFactory.constructor["__interfaces"] != null && mapFactory.constructor["__interfaces"].indexOf("java.util.stream.Collector") >= 0 || mapFactory === null) && downstream === undefined) {
              return java.util.stream.Collectors.groupingBy$java_util_function_Function$java_util_stream_Collector(classifier, mapFactory);
            } else throw new Error('invalid overload');
          };

          Collectors.mapping = function (mapper, downstream) {
            var downstreamAccumulator = downstream.accumulator();
            return new Collectors.CollectorImpl(downstream.supplier(), function (downstreamAccumulator) {
              return function (r, t) {
                return function (target) {
                  return typeof target === 'function' ? target(r, function (target) {
                    return typeof target === 'function' ? target(t) : target.apply(t);
                  }(mapper)) : target.accept(r, function (target) {
                    return typeof target === 'function' ? target(t) : target.apply(t);
                  }(mapper));
                }(downstreamAccumulator);
              };
            }(downstreamAccumulator), downstream.combiner(), downstream.finisher(), downstream.characteristics());
          };

          Collectors.reducing$java_lang_Object$java_util_function_BinaryOperator = function (identity, op) {
            return new Collectors.CollectorImpl(Collectors.boxSupplier(identity), function (a, t) {
              a[0] = function (target) {
                return typeof target === 'function' ? target(a[0], t) : target.apply(a[0], t);
              }(op);
            }, function (a, b) {
              a[0] = function (target) {
                return typeof target === 'function' ? target(a[0], b[0]) : target.apply(a[0], b[0]);
              }(op);

              return a;
            }, function (a) {
              return a[0];
            }, Collectors.CH_NOID_$LI$());
          };

          Collectors.reducing$java_lang_Object$java_util_function_Function$java_util_function_BinaryOperator = function (identity, mapper, op) {
            return new Collectors.CollectorImpl(Collectors.boxSupplier(identity), function (a, t) {
              a[0] = function (target) {
                return typeof target === 'function' ? target(a[0], function (target) {
                  return typeof target === 'function' ? target(t) : target.apply(t);
                }(mapper)) : target.apply(a[0], function (target) {
                  return typeof target === 'function' ? target(t) : target.apply(t);
                }(mapper));
              }(op);
            }, function (a, b) {
              a[0] = function (target) {
                return typeof target === 'function' ? target(a[0], b[0]) : target.apply(a[0], b[0]);
              }(op);

              return a;
            }, function (a) {
              return a[0];
            }, Collectors.CH_NOID_$LI$());
          };

          Collectors.reducing = function (identity, mapper, op) {
            if ((identity != null || identity === null) && (typeof mapper === 'function' && mapper.length === 1 || mapper === null) && (typeof op === 'function' && op.length === 2 || op === null)) {
              return java.util.stream.Collectors.reducing$java_lang_Object$java_util_function_Function$java_util_function_BinaryOperator(identity, mapper, op);
            } else if ((identity != null || identity === null) && (typeof mapper === 'function' && mapper.length === 2 || mapper === null) && op === undefined) {
              return java.util.stream.Collectors.reducing$java_lang_Object$java_util_function_BinaryOperator(identity, mapper);
            } else throw new Error('invalid overload');
          };

          Collectors.boxSupplier = function (identity) {
            return function () {
              return [identity];
            };
          };

          return Collectors;
        }();

        stream.Collectors = Collectors;
        Collectors["__class"] = "java.util.stream.Collectors";

        (function (Collectors) {
          var CollectorImpl =
          /** @class */
          function () {
            function CollectorImpl(supplier, accumulator, combiner, finisher, characteristics) {
              if ((typeof supplier === 'function' && supplier.length === 0 || supplier === null) && (typeof accumulator === 'function' && accumulator.length === 2 || accumulator === null) && (typeof combiner === 'function' && combiner.length === 2 || combiner === null) && (typeof finisher === 'function' && finisher.length === 1 || finisher === null) && (characteristics != null && characteristics.constructor != null && characteristics.constructor["__interfaces"] != null && characteristics.constructor["__interfaces"].indexOf("java.util.Set") >= 0 || characteristics === null)) {
                var __args = arguments;

                if (this.__supplier === undefined) {
                  this.__supplier = null;
                }

                if (this.__accumulator === undefined) {
                  this.__accumulator = null;
                }

                if (this.__combiner === undefined) {
                  this.__combiner = null;
                }

                if (this.__characteristics === undefined) {
                  this.__characteristics = null;
                }

                if (this.__finisher === undefined) {
                  this.__finisher = null;
                }

                this.__supplier = supplier;
                this.__accumulator = accumulator;
                this.__combiner = combiner;
                this.__finisher = finisher;
                this.__characteristics = characteristics;
              } else if ((typeof supplier === 'function' && supplier.length === 0 || supplier === null) && (typeof accumulator === 'function' && accumulator.length === 2 || accumulator === null) && (typeof combiner === 'function' && combiner.length === 2 || combiner === null) && (finisher != null && finisher.constructor != null && finisher.constructor["__interfaces"] != null && finisher.constructor["__interfaces"].indexOf("java.util.Set") >= 0 || finisher === null) && characteristics === undefined) {
                var __args = arguments;
                var characteristics_1 = __args[3];
                {
                  var finisher_1 = CollectorImpl.castingIdentity();

                  if (this.__supplier === undefined) {
                    this.__supplier = null;
                  }

                  if (this.__accumulator === undefined) {
                    this.__accumulator = null;
                  }

                  if (this.__combiner === undefined) {
                    this.__combiner = null;
                  }

                  if (this.__characteristics === undefined) {
                    this.__characteristics = null;
                  }

                  if (this.__finisher === undefined) {
                    this.__finisher = null;
                  }

                  this.__supplier = supplier;
                  this.__accumulator = accumulator;
                  this.__combiner = combiner;
                  this.__finisher = finisher_1;
                  this.__characteristics = characteristics_1;
                }

                if (this.__supplier === undefined) {
                  this.__supplier = null;
                }

                if (this.__accumulator === undefined) {
                  this.__accumulator = null;
                }

                if (this.__combiner === undefined) {
                  this.__combiner = null;
                }

                if (this.__characteristics === undefined) {
                  this.__characteristics = null;
                }

                if (this.__finisher === undefined) {
                  this.__finisher = null;
                }
              } else if ((typeof supplier === 'function' && supplier.length === 0 || supplier === null) && (typeof accumulator === 'function' && accumulator.length === 2 || accumulator === null) && (typeof combiner === 'function' && combiner.length === 2 || combiner === null) && finisher === undefined && characteristics === undefined) {
                var __args = arguments;
                {
                  var finisher_2 = CollectorImpl.castingIdentity();
                  var characteristics_2 = null;

                  if (this.__supplier === undefined) {
                    this.__supplier = null;
                  }

                  if (this.__accumulator === undefined) {
                    this.__accumulator = null;
                  }

                  if (this.__combiner === undefined) {
                    this.__combiner = null;
                  }

                  if (this.__characteristics === undefined) {
                    this.__characteristics = null;
                  }

                  if (this.__finisher === undefined) {
                    this.__finisher = null;
                  }

                  this.__supplier = supplier;
                  this.__accumulator = accumulator;
                  this.__combiner = combiner;
                  this.__finisher = finisher_2;
                  this.__characteristics = characteristics_2;
                }

                if (this.__supplier === undefined) {
                  this.__supplier = null;
                }

                if (this.__accumulator === undefined) {
                  this.__accumulator = null;
                }

                if (this.__combiner === undefined) {
                  this.__combiner = null;
                }

                if (this.__characteristics === undefined) {
                  this.__characteristics = null;
                }

                if (this.__finisher === undefined) {
                  this.__finisher = null;
                }
              } else throw new Error('invalid overload');
            }

            CollectorImpl.castingIdentity = function () {
              return function (i) {
                return i;
              };
            };
            /**
            *
            * @return {*}
            */


            CollectorImpl.prototype.accumulator = function () {
              return this.__accumulator;
            };
            /**
            *
            * @return {*}
            */


            CollectorImpl.prototype.supplier = function () {
              return this.__supplier;
            };
            /**
            *
            * @return {*}
            */


            CollectorImpl.prototype.combiner = function () {
              return this.__combiner;
            };
            /**
            *
            * @return {*}
            */


            CollectorImpl.prototype.finisher = function () {
              return this.__finisher;
            };
            /**
            *
            * @return {*}
            */


            CollectorImpl.prototype.characteristics = function () {
              return this.__characteristics;
            };

            return CollectorImpl;
          }();

          Collectors.CollectorImpl = CollectorImpl;
          CollectorImpl["__class"] = "java.util.stream.Collectors.CollectorImpl";
          CollectorImpl["__interfaces"] = ["java.util.stream.Collector"];
        })(Collectors = stream.Collectors || (stream.Collectors = {}));
      })(util.stream || (util.stream = {}));
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      /**
      * Hash table implementation of the Map interface with predictable iteration
      * order. <a href=
      * "http://java.sun.com/j2se/1.5.0/docs/api/java/util/LinkedHashMap.html">[Sun
      * docs]</a>
      *
      * @param <K>
      * key type.
      * @param <V>
      * value type.
      * @param {number} ignored
      * @param {number} alsoIgnored
      * @param {boolean} accessOrder
      * @class
      * @extends java.util.HashMap
      */
      var LinkedHashMap =
      /** @class */
      function (_super) {
        __extends(LinkedHashMap, _super);

        function LinkedHashMap(ignored, alsoIgnored, accessOrder) {
          var _this = this;

          if ((typeof ignored === 'number' || ignored === null) && (typeof alsoIgnored === 'number' || alsoIgnored === null) && (typeof accessOrder === 'boolean' || accessOrder === null)) {
            var __args = arguments;
            _this = _super.call(this, ignored, alsoIgnored) || this;

            if (_this.accessOrder === undefined) {
              _this.accessOrder = false;
            }

            if (_this.head === undefined) {
              _this.head = null;
            }

            if (_this.map === undefined) {
              _this.map = null;
            }

            _this.head = new LinkedHashMap.ChainEntry(_this);
            _this.map = new java.util.HashMap();
            _this.accessOrder = accessOrder;

            _this.resetChainEntries();
          } else if ((typeof ignored === 'number' || ignored === null) && (typeof alsoIgnored === 'number' || alsoIgnored === null) && accessOrder === undefined) {
            var __args = arguments;
            _this = _super.call(this, ignored, alsoIgnored) || this;

            if (_this.accessOrder === undefined) {
              _this.accessOrder = false;
            }

            if (_this.head === undefined) {
              _this.head = null;
            }

            if (_this.map === undefined) {
              _this.map = null;
            }

            _this.head = new LinkedHashMap.ChainEntry(_this);
            _this.map = new java.util.HashMap();

            _this.resetChainEntries();
          } else if ((ignored != null && ignored.constructor != null && ignored.constructor["__interfaces"] != null && ignored.constructor["__interfaces"].indexOf("java.util.Map") >= 0 || ignored === null) && alsoIgnored === undefined && accessOrder === undefined) {
            var __args = arguments;
            var toBeCopied = __args[0];
            _this = _super.call(this) || this;

            if (_this.accessOrder === undefined) {
              _this.accessOrder = false;
            }

            if (_this.head === undefined) {
              _this.head = null;
            }

            if (_this.map === undefined) {
              _this.map = null;
            }

            _this.head = new LinkedHashMap.ChainEntry(_this);
            _this.map = new java.util.HashMap();

            _this.resetChainEntries();

            _this.putAll(toBeCopied);
          } else if ((typeof ignored === 'number' || ignored === null) && alsoIgnored === undefined && accessOrder === undefined) {
            var __args = arguments;
            {
              var alsoIgnored_2 = 0;
              _this = _super.call(this, ignored, alsoIgnored_2) || this;

              if (_this.accessOrder === undefined) {
                _this.accessOrder = false;
              }

              if (_this.head === undefined) {
                _this.head = null;
              }

              if (_this.map === undefined) {
                _this.map = null;
              }

              _this.head = new LinkedHashMap.ChainEntry(_this);
              _this.map = new java.util.HashMap();

              _this.resetChainEntries();
            }

            if (_this.accessOrder === undefined) {
              _this.accessOrder = false;
            }

            if (_this.head === undefined) {
              _this.head = null;
            }

            if (_this.map === undefined) {
              _this.map = null;
            }
          } else if (ignored === undefined && alsoIgnored === undefined && accessOrder === undefined) {
            var __args = arguments;
            _this = _super.call(this) || this;

            if (_this.accessOrder === undefined) {
              _this.accessOrder = false;
            }

            if (_this.head === undefined) {
              _this.head = null;
            }

            if (_this.map === undefined) {
              _this.map = null;
            }

            _this.head = new LinkedHashMap.ChainEntry(_this);
            _this.map = new java.util.HashMap();

            _this.resetChainEntries();
          } else throw new Error('invalid overload');

          return _this;
        }
        /* Default method injected from java.util.Map */


        LinkedHashMap.prototype.putIfAbsent = function (key, value) {
          var v = this.get(key);

          if (v == null) {
            v = this.put(key, value);
          }

          return v;
        };
        /* Default method injected from java.util.Map */


        LinkedHashMap.prototype.computeIfAbsent = function (key, mappingFunction) {
          var result;

          if ((result = this.get(key)) == null) {
            result = function (target) {
              return typeof target === 'function' ? target(key) : target.apply(key);
            }(mappingFunction);

            if (result != null) this.put(key, result);
          }

          return result;
        };
        /* Default method injected from java.util.Map */


        LinkedHashMap.prototype.merge = function (key, value, map) {
          var old = this.get(key);
          var next = old == null ? value : function (target) {
            return typeof target === 'function' ? target(old, value) : target.apply(old, value);
          }(map);

          if (next == null) {
            this.remove(key);
          } else {
            this.put(key, next);
          }

          return next;
        };
        /* Default method injected from java.util.Map */


        LinkedHashMap.prototype.getOrDefault = function (key, defaultValue) {
          var v;
          return (v = this.get(key)) != null || this.containsKey(key) ? v : defaultValue;
        };
        /* Default method injected from java.util.Map */


        LinkedHashMap.prototype.replaceAll = function (__function) {
          java.util.Objects.requireNonNull(__function);

          var _loop_40 = function _loop_40(index198) {
            var entry = index198.next();
            {
              var k_6;
              var v_6;

              try {
                k_6 = entry.getKey();
                v_6 = entry.getValue();
              } catch (ise) {
                throw new java.lang.RuntimeException(ise);
              }

              v_6 = function (target) {
                return typeof target === 'function' ? target(k_6, v_6) : target.apply(k_6, v_6);
              }(__function);

              try {
                entry.setValue(v_6);
              } catch (ise) {
                throw new java.lang.RuntimeException(ise);
              }
            }
          };

          for (var index198 = this.entrySet().iterator(); index198.hasNext();) {
            _loop_40(index198);
          }
        };
        /**
        *
        */


        LinkedHashMap.prototype.clear = function () {
          this.map.clear();
          this.resetChainEntries();
        };

        LinkedHashMap.prototype.resetChainEntries = function () {
          this.head.prev = this.head;
          this.head.next = this.head;
        };
        /**
        *
        * @return {*}
        */


        LinkedHashMap.prototype.clone = function () {
          return new LinkedHashMap(this);
        };
        /**
        *
        * @param {*} key
        * @return {boolean}
        */


        LinkedHashMap.prototype.containsKey = function (key) {
          return this.map.containsKey(key);
        };
        /**
        *
        * @param {*} value
        * @return {boolean}
        */


        LinkedHashMap.prototype.containsValue = function (value) {
          var node = this.head.next;

          while (node !== this.head) {
            {
              if (java.util.Objects.equals(node.getValue(), value)) {
                return true;
              }

              node = node.next;
            }
          }

          return false;
        };
        /**
        *
        * @return {*}
        */


        LinkedHashMap.prototype.entrySet = function () {
          return new LinkedHashMap.__java_util_LinkedHashMap_EntrySet(this);
        };
        /**
        *
        * @param {*} key
        * @return {*}
        */


        LinkedHashMap.prototype.get = function (key) {
          var entry = this.map.get(key);

          if (entry != null) {
            this.recordAccess(entry);
            return entry.getValue();
          }

          return null;
        };
        /**
        *
        * @param {*} key
        * @param {*} value
        * @return {*}
        */


        LinkedHashMap.prototype.put = function (key, value) {
          var old = this.map.get(key);

          if (old == null) {
            var newEntry = new LinkedHashMap.ChainEntry(this, key, value);
            this.map.put(key, newEntry);
            newEntry.addToEnd();
            var eldest = this.head.next;

            if (this.removeEldestEntry(eldest)) {
              eldest.remove();
              this.map.remove(eldest.getKey());
            }

            return null;
          } else {
            var oldValue = old.setValue(value);
            this.recordAccess(old);
            return oldValue;
          }
        };
        /**
        *
        * @param {*} key
        * @return {*}
        */


        LinkedHashMap.prototype.remove = function (key) {
          var entry = this.map.remove(key);

          if (entry != null) {
            entry.remove();
            return entry.getValue();
          }

          return null;
        };
        /**
        *
        * @return {number}
        */


        LinkedHashMap.prototype.size = function () {
          return this.map.size();
        };

        LinkedHashMap.prototype.removeEldestEntry = function (eldest) {
          return false;
        };

        LinkedHashMap.prototype.recordAccess = function (entry) {
          if (this.accessOrder) {
            entry.remove();
            entry.addToEnd();
          }
        };

        return LinkedHashMap;
      }(java.util.HashMap);

      util.LinkedHashMap = LinkedHashMap;
      LinkedHashMap["__class"] = "java.util.LinkedHashMap";
      LinkedHashMap["__interfaces"] = ["java.lang.Cloneable", "java.util.Map", "java.io.Serializable"];

      (function (LinkedHashMap) {
        /**
        * The entry we use includes next/prev pointers for a doubly-linked circular
        * list with a head node. This reduces the special cases we have to deal
        * with in the list operations.
        *
        * Note that we duplicate the key from the underlying hash map so we can
        * find the eldest entry. The alternative would have been to modify HashMap
        * so more of the code was directly usable here, but this would have added
        * some overhead to HashMap, or to reimplement most of the HashMap code here
        * with small modifications. Paying a small storage cost only if you use
        * LinkedHashMap and minimizing code size seemed like a better tradeoff
        * @param {*} key
        * @param {*} value
        * @class
        * @extends java.util.AbstractMap.SimpleEntry
        */
        var ChainEntry =
        /** @class */
        function (_super) {
          __extends(ChainEntry, _super);

          function ChainEntry(__parent, key, value) {
            if (key === void 0) {
              key = null;
            }

            if (value === void 0) {
              value = null;
            }

            var _this = _super.call(this, key, value) || this;

            _this.__parent = __parent;

            if (_this.next === undefined) {
              _this.next = null;
            }

            if (_this.prev === undefined) {
              _this.prev = null;
            }

            return _this;
          }
          /**
          * Add this node to the end of the chain.
          */


          ChainEntry.prototype.addToEnd = function () {
            var tail = this.__parent.head.prev;
            this.prev = tail;
            this.next = this.__parent.head;
            tail.next = this.__parent.head.prev = this;
          };
          /**
          * Remove this node from any list it may be a part of.
          */


          ChainEntry.prototype.remove = function () {
            this.next.prev = this.prev;
            this.prev.next = this.next;
            this.next = this.prev = null;
          };

          return ChainEntry;
        }(util.AbstractMap.SimpleEntry);

        LinkedHashMap.ChainEntry = ChainEntry;
        ChainEntry["__class"] = "java.util.LinkedHashMap.ChainEntry";
        ChainEntry["__interfaces"] = ["java.util.Map.Entry"];

        var __java_util_LinkedHashMap_EntrySet =
        /** @class */
        function (_super) {
          __extends(__java_util_LinkedHashMap_EntrySet, _super);

          function __java_util_LinkedHashMap_EntrySet(__parent) {
            var _this = _super.call(this) || this;

            _this.__parent = __parent;
            return _this;
          }
          /**
          *
          */


          __java_util_LinkedHashMap_EntrySet.prototype.clear = function () {
            this.clear();
          };
          /**
          *
          * @param {*} o
          * @return {boolean}
          */


          __java_util_LinkedHashMap_EntrySet.prototype.contains = function (o) {
            if (o != null && o.constructor != null && o.constructor["__interfaces"] != null && o.constructor["__interfaces"].indexOf("java.util.Map.Entry") >= 0) {
              return this.__parent.containsEntry(o);
            }

            return false;
          };
          /**
          *
          * @return {*}
          */


          __java_util_LinkedHashMap_EntrySet.prototype.iterator = function () {
            return new __java_util_LinkedHashMap_EntrySet.EntryIterator(this);
          };
          /**
          *
          * @param {*} entry
          * @return {boolean}
          */


          __java_util_LinkedHashMap_EntrySet.prototype.remove = function (entry) {
            if (this.contains(entry)) {
              var key = entry.getKey();
              this.remove(key);
              return true;
            }

            return false;
          };
          /**
          *
          * @return {number}
          */


          __java_util_LinkedHashMap_EntrySet.prototype.size = function () {
            return this.size();
          };

          return __java_util_LinkedHashMap_EntrySet;
        }(java.util.AbstractSet);

        LinkedHashMap.__java_util_LinkedHashMap_EntrySet = __java_util_LinkedHashMap_EntrySet;
        __java_util_LinkedHashMap_EntrySet["__class"] = "java.util.LinkedHashMap.EntrySet";
        __java_util_LinkedHashMap_EntrySet["__interfaces"] = ["java.util.Collection", "java.util.Set", "java.lang.Iterable"];

        (function (__java_util_LinkedHashMap_EntrySet) {
          var EntryIterator =
          /** @class */
          function () {
            function EntryIterator(__parent) {
              this.__parent = __parent;

              if (this.last === undefined) {
                this.last = null;
              }

              if (this.__next === undefined) {
                this.__next = null;
              }

              this.__next = __parent.__parent.head.next;
              java.util.ConcurrentModificationDetector.recordLastKnownStructure(__parent.__parent.map, this);
            }
            /* Default method injected from java.util.Iterator */


            EntryIterator.prototype.forEachRemaining = function (consumer) {
              var _this = this;

              javaemul.internal.InternalPreconditions.checkNotNull(consumer);

              while (this.hasNext()) {
                {
                  (function (target) {
                    return typeof target === 'function' ? target(_this.next()) : target.accept(_this.next());
                  })(consumer);
                }
              }
            };
            /**
            *
            * @return {boolean}
            */


            EntryIterator.prototype.hasNext = function () {
              return this.__next !== this.__parent.__parent.head;
            };
            /**
            *
            * @return {*}
            */


            EntryIterator.prototype.next = function () {
              java.util.ConcurrentModificationDetector.checkStructuralChange(this.__parent.__parent.map, this);
              javaemul.internal.InternalPreconditions.checkCriticalElement(this.hasNext());
              this.last = this.__next;
              this.__next = this.__next.next;
              return this.last;
            };
            /**
            *
            */


            EntryIterator.prototype.remove = function () {
              javaemul.internal.InternalPreconditions.checkState(this.last != null);
              java.util.ConcurrentModificationDetector.checkStructuralChange(this.__parent.__parent.map, this);
              this.last.remove();

              this.__parent.__parent.map.remove(this.last.getKey());

              java.util.ConcurrentModificationDetector.recordLastKnownStructure(this.__parent.__parent.map, this);
              this.last = null;
            };

            return EntryIterator;
          }();

          __java_util_LinkedHashMap_EntrySet.EntryIterator = EntryIterator;
          EntryIterator["__class"] = "java.util.LinkedHashMap.EntrySet.EntryIterator";
          EntryIterator["__interfaces"] = ["java.util.Iterator"];
        })(__java_util_LinkedHashMap_EntrySet = LinkedHashMap.__java_util_LinkedHashMap_EntrySet || (LinkedHashMap.__java_util_LinkedHashMap_EntrySet = {}));
      })(LinkedHashMap = util.LinkedHashMap || (util.LinkedHashMap = {}));
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      var ConcurrentHashMap =
      /** @class */
      function (_super) {
        __extends(ConcurrentHashMap, _super);

        function ConcurrentHashMap() {
          return _super.call(this) || this;
        }

        return ConcurrentHashMap;
      }(java.util.HashMap);

      util.ConcurrentHashMap = ConcurrentHashMap;
      ConcurrentHashMap["__class"] = "java.util.ConcurrentHashMap";
      ConcurrentHashMap["__interfaces"] = ["java.lang.Cloneable", "java.util.Map", "java.io.Serializable"];
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      var Hashtable =
      /** @class */
      function (_super) {
        __extends(Hashtable, _super);

        function Hashtable(ignored, alsoIgnored) {
          var _this = this;

          if ((typeof ignored === 'number' || ignored === null) && (typeof alsoIgnored === 'number' || alsoIgnored === null)) {
            var __args = arguments;
            _this = _super.call(this, ignored, alsoIgnored) || this;
          } else if ((ignored != null && ignored.constructor != null && ignored.constructor["__interfaces"] != null && ignored.constructor["__interfaces"].indexOf("java.util.Map") >= 0 || ignored === null) && alsoIgnored === undefined) {
            var __args = arguments;
            var toBeCopied = __args[0];
            _this = _super.call(this, toBeCopied) || this;
          } else if ((typeof ignored === 'number' || ignored === null) && alsoIgnored === undefined) {
            var __args = arguments;
            _this = _super.call(this, ignored) || this;
          } else if (ignored === undefined && alsoIgnored === undefined) {
            var __args = arguments;
            _this = _super.call(this) || this;
          } else throw new Error('invalid overload');

          return _this;
        }

        Hashtable.prototype.keys = function () {
          var it = this.keySet().iterator();
          return new Hashtable.Hashtable$0(this, it);
        };

        Hashtable.prototype.elements = function () {
          var it = this.values().iterator();
          return new Hashtable.Hashtable$1(this, it);
        };

        Hashtable.serialVersionUID = 1;
        return Hashtable;
      }(java.util.HashMap);

      util.Hashtable = Hashtable;
      Hashtable["__class"] = "java.util.Hashtable";
      Hashtable["__interfaces"] = ["java.lang.Cloneable", "java.util.Map", "java.util.Dictionary", "java.io.Serializable"];

      (function (Hashtable) {
        var Hashtable$0 =
        /** @class */
        function () {
          function Hashtable$0(__parent, it) {
            this.it = it;
            this.__parent = __parent;
          }
          /**
          *
          * @return {boolean}
          */


          Hashtable$0.prototype.hasMoreElements = function () {
            return this.it.hasNext();
          };
          /**
          *
          * @return {*}
          */


          Hashtable$0.prototype.nextElement = function () {
            return this.it.next();
          };

          return Hashtable$0;
        }();

        Hashtable.Hashtable$0 = Hashtable$0;
        Hashtable$0["__interfaces"] = ["java.util.Enumeration"];

        var Hashtable$1 =
        /** @class */
        function () {
          function Hashtable$1(__parent, it) {
            this.it = it;
            this.__parent = __parent;
          }
          /**
          *
          * @return {boolean}
          */


          Hashtable$1.prototype.hasMoreElements = function () {
            return this.it.hasNext();
          };
          /**
          *
          * @return {*}
          */


          Hashtable$1.prototype.nextElement = function () {
            return this.it.next();
          };

          return Hashtable$1;
        }();

        Hashtable.Hashtable$1 = Hashtable$1;
        Hashtable$1["__interfaces"] = ["java.util.Enumeration"];
      })(Hashtable = util.Hashtable || (util.Hashtable = {}));
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (lang) {
      var System =
      /** @class */
      function () {
        function System() {}

        System.__static_initialize = function () {
          if (!System.__static_initialized) {
            System.__static_initialized = true;

            System.__static_initializer_0();
          }
        };

        System.ENVIRONMENT_IS_WEB_$LI$ = function () {
          System.__static_initialize();

          if (System.ENVIRONMENT_IS_WEB == null) {
            System.ENVIRONMENT_IS_WEB = java.util.Objects.equals(typeof window === "undefined" ? "undefined" : _typeof(window), "object");
          }

          return System.ENVIRONMENT_IS_WEB;
        };

        System.ENVIRONMENT_IS_WORKER_$LI$ = function () {
          System.__static_initialize();

          if (System.ENVIRONMENT_IS_WORKER == null) {
            System.ENVIRONMENT_IS_WORKER = java.util.Objects.equals(typeof importScripts === "undefined" ? "undefined" : _typeof(importScripts), "function");
          }

          return System.ENVIRONMENT_IS_WORKER;
        };

        System.ENVIRONMENT_IS_NODE_$LI$ = function () {
          System.__static_initialize();

          if (System.ENVIRONMENT_IS_NODE == null) {
            System.ENVIRONMENT_IS_NODE = !System.ENVIRONMENT_IS_WEB_$LI$() && !System.ENVIRONMENT_IS_WORKER_$LI$() && java.util.Objects.equals(eval("typeof process"), "object") && java.util.Objects.equals(eval("typeof require"), "function");
          }

          return System.ENVIRONMENT_IS_NODE;
        };

        System.ENVIRONMENT_IS_SHELL_$LI$ = function () {
          System.__static_initialize();

          if (System.ENVIRONMENT_IS_SHELL == null) {
            System.ENVIRONMENT_IS_SHELL = !System.ENVIRONMENT_IS_WEB_$LI$() && !System.ENVIRONMENT_IS_WORKER_$LI$() && !System.ENVIRONMENT_IS_NODE_$LI$();
          }

          return System.ENVIRONMENT_IS_SHELL;
        };

        System.propertyMap_$LI$ = function () {
          System.__static_initialize();

          return System.propertyMap;
        };

        System.err_$LI$ = function () {
          System.__static_initialize();

          return System.err;
        };

        System.out_$LI$ = function () {
          System.__static_initialize();

          return System.out;
        };

        System.in_$LI$ = function () {
          System.__static_initialize();

          return System["in"];
        };

        System.__static_initializer_0 = function () {
          System.propertyMap = new java.util.HashMap();
          System.propertyMap_$LI$().put("java.vendor", "JSweet");
          System.propertyMap_$LI$().put("java.vendor.url", "http://www.jsweet.org");
          System.propertyMap_$LI$().put("java.version", "jsweet");
          var tmpDir = "";
          var lineSeparator = "\n";
          var fileSeparator = "/";
          var userHome = "";
          var userName = "";
          var osArch = "";

          if (System.ENVIRONMENT_IS_WEB_$LI$() || System.ENVIRONMENT_IS_WORKER_$LI$()) {
            System.propertyMap_$LI$().put("os.name", System.ENVIRONMENT_IS_WEB_$LI$() ? "WEB" : "WEB-WORKER");
            System.propertyMap_$LI$().put("os.version", navigator.userAgent);
            var pathname = document.location.pathname;
            System.propertyMap_$LI$().put("user.dir", pathname.substring(0, pathname.lastIndexOf("/")));
          } else if (System.ENVIRONMENT_IS_NODE_$LI$()) {
            var os = eval("global.os || (global.os = require(\"os\"))");
            var path = eval("global.path || (global.path = require(\"path\"))");
            System.propertyMap_$LI$().put("os.name", "NODE");
            System.propertyMap_$LI$().put("os.version", eval("process.version"));
            System.propertyMap_$LI$().put("user.dir", eval("process.cwd()"));
            tmpDir = os["tmpdir"]();
            lineSeparator = os["EOL"];
            fileSeparator = path["sep"];
            userHome = os["homedir"]();
            userName = os["userInfo"]()["username"];
            osArch = os["arch"]();
          } else {
            console = new Object();
            console["info"] = print;
            console["error"] = java.util.Objects.equals(eval("typeof printErr"), "undefined") ? print : eval("printErr");
            System.propertyMap_$LI$().put("os.name", "SHELL");
            var runnerName = "UNKNOWN";
            var userDir = ".";

            if (java.util.Objects.equals(eval("typeof environment"), "object")) {
              runnerName = "RHINO";
              userDir = eval("environment[\"user.dir\"]");
              lineSeparator = eval("environment[\"line.separator\"]");
              fileSeparator = eval("environment[\"file.separator\"]");
              userHome = eval("environment[\"user.name\"]");
              userName = eval("environment[\"user.home\"]");
              osArch = eval("environment[\"os.arch\"]");
            } else if (java.util.Objects.equals(eval("typeof jscOptions"), "function")) {
              runnerName = "JSC";
            }

            System.propertyMap_$LI$().put("os.version", runnerName);
            System.propertyMap_$LI$().put("user.dir", userDir);
          }

          System.propertyMap_$LI$().put("java.io.tmpdir", tmpDir);
          System.propertyMap_$LI$().put("line.separator", lineSeparator);
          System.propertyMap_$LI$().put("file.separator", fileSeparator);
          System.propertyMap_$LI$().put("user.home", userHome);
          System.propertyMap_$LI$().put("user.name", userName);
          System.propertyMap_$LI$().put("os.arch", osArch);
          System.out = new java.io.PrintStream(new System.System$0());
          System.err = new java.io.PrintStream(new System.System$1());
          System["in"] = new System.System$2();
        };

        System.arraycopy = function (src, srcOfs, dest, destOfs, len) {
          javaemul.internal.InternalPreconditions.checkNotNull(src, "src");
          javaemul.internal.InternalPreconditions.checkNotNull(dest, "dest");
          var srclen = javaemul.internal.ArrayHelper.getLength(src);
          var destlen = javaemul.internal.ArrayHelper.getLength(dest);

          if (srcOfs < 0 || destOfs < 0 || len < 0 || srcOfs + len > srclen || destOfs + len > destlen) {
            throw new java.lang.IndexOutOfBoundsException();
          }

          if (len > 0) {
            javaemul.internal.ArrayHelper.copy$java_lang_Object$int$java_lang_Object$int$int(src, srcOfs, dest, destOfs, len);
          }
        };

        System.currentTimeMillis = function () {
          return function (n) {
            return n < 0 ? Math.ceil(n) : Math.floor(n);
          }(javaemul.internal.DateUtil.now());
        };

        System.gc = function () {
          (function () {
            var gcFun = eval("this.gc");

            if (java.util.Objects.equals(_typeof(gcFun), "function")) {
              gcFun();
            }
          }).apply(null);
        };

        System.getProperty$java_lang_String = function (key) {
          return System.propertyMap_$LI$() == null ? null : System.propertyMap_$LI$().get(key);
        };

        System.getProperty$java_lang_String$java_lang_String = function (key, def) {
          var prop = System.getProperty$java_lang_String(key);
          return prop == null ? def : prop;
        };

        System.getProperty = function (key, def) {
          if ((typeof key === 'string' || key === null) && (typeof def === 'string' || def === null)) {
            return java.lang.System.getProperty$java_lang_String$java_lang_String(key, def);
          } else if ((typeof key === 'string' || key === null) && def === undefined) {
            return java.lang.System.getProperty$java_lang_String(key);
          } else throw new Error('invalid overload');
        };

        System.identityHashCode = function (o) {
          return javaemul.internal.HashCodes.getIdentityHashCode(o);
        };

        System.setErr = function (err) {
          java.lang.System.err = err;
        };

        System.setOut = function (out) {
          java.lang.System.out = out;
        };

        System.lineSeparator = function () {
          return System.getProperty$java_lang_String("line.separator");
        };

        System.exit = function (status) {
          if (System.ENVIRONMENT_IS_NODE_$LI$()) {
            eval("process.exit(" + status + ")");
          } else if (System.ENVIRONMENT_IS_WEB_$LI$()) {
            window.close();
          } else if (System.ENVIRONMENT_IS_WORKER_$LI$()) {
            self.close();
          } else {
            if (java.util.Objects.equals(_typeof(eval("quit")), "function")) {
              eval("quit(" + status + ")");
            }

            if (java.util.Objects.equals(_typeof(eval("exit")), "function")) {
              eval("exit(" + status + ")");
            }
          }
        };

        System.__static_initialized = false;
        return System;
      }();

      lang.System = System;
      System["__class"] = "java.lang.System";

      (function (System) {
        var System$0 =
        /** @class */
        function (_super) {
          __extends(System$0, _super);

          function System$0() {
            var _this = _super.call(this) || this;

            _this.sep = java.lang.System.propertyMap_$LI$().get("line.separator");
            _this.toOut = "";
            return _this;
          }

          System$0.prototype.write = function (buffer, offset, count) {
            if ((buffer != null && buffer instanceof Array && (buffer.length == 0 || buffer[0] == null || typeof buffer[0] === 'number') || buffer === null) && (typeof offset === 'number' || offset === null) && (typeof count === 'number' || count === null)) {
              _super.prototype.write.call(this, buffer, offset, count);
            } else if ((buffer != null && buffer instanceof Array && (buffer.length == 0 || buffer[0] == null || typeof buffer[0] === 'number') || buffer === null) && offset === undefined && count === undefined) {
              return this.write$byte_A(buffer);
            } else if ((typeof buffer === 'number' || buffer === null) && offset === undefined && count === undefined) {
              return this.write$int(buffer);
            } else throw new Error('invalid overload');
          };

          System$0.prototype.write$int = function (i) {
            this.toOut += String.fromCharCode(i);

            if (
            /* endsWith */
            function (str, searchString) {
              var pos = str.length - searchString.length;
              var lastIndex = str.indexOf(searchString, pos);
              return lastIndex !== -1 && lastIndex === pos;
            }(this.toOut, this.sep)) {
              this.flush();
            }
          };
          /**
          *
          */


          System$0.prototype.flush = function () {
            _super.prototype.flush.call(this);

            if (!(this.toOut.length === 0)) {
              if (
              /* endsWith */
              function (str, searchString) {
                var pos = str.length - searchString.length;
                var lastIndex = str.indexOf(searchString, pos);
                return lastIndex !== -1 && lastIndex === pos;
              }(this.toOut, this.sep)) {
                this.toOut = this.toOut.substring(0, this.toOut.length - this.sep.length);
              }

              console.info(this.toOut);
              this.toOut = "";
            }
          };

          return System$0;
        }(java.io.OutputStream);

        System.System$0 = System$0;
        System$0["__interfaces"] = ["java.io.Closeable", "java.lang.AutoCloseable", "java.io.Flushable"];

        var System$1 =
        /** @class */
        function (_super) {
          __extends(System$1, _super);

          function System$1() {
            var _this = _super.call(this) || this;

            _this.sep = java.lang.System.propertyMap_$LI$().get("line.separator");
            _this.toOut = "";
            return _this;
          }

          System$1.prototype.write = function (buffer, offset, count) {
            if ((buffer != null && buffer instanceof Array && (buffer.length == 0 || buffer[0] == null || typeof buffer[0] === 'number') || buffer === null) && (typeof offset === 'number' || offset === null) && (typeof count === 'number' || count === null)) {
              _super.prototype.write.call(this, buffer, offset, count);
            } else if ((buffer != null && buffer instanceof Array && (buffer.length == 0 || buffer[0] == null || typeof buffer[0] === 'number') || buffer === null) && offset === undefined && count === undefined) {
              return this.write$byte_A(buffer);
            } else if ((typeof buffer === 'number' || buffer === null) && offset === undefined && count === undefined) {
              return this.write$int(buffer);
            } else throw new Error('invalid overload');
          };

          System$1.prototype.write$int = function (i) {
            this.toOut += String.fromCharCode(i);

            if (
            /* endsWith */
            function (str, searchString) {
              var pos = str.length - searchString.length;
              var lastIndex = str.indexOf(searchString, pos);
              return lastIndex !== -1 && lastIndex === pos;
            }(this.toOut, this.sep)) {
              this.flush();
            }
          };
          /**
          *
          */


          System$1.prototype.flush = function () {
            _super.prototype.flush.call(this);

            if (!(this.toOut.length === 0)) {
              if (
              /* endsWith */
              function (str, searchString) {
                var pos = str.length - searchString.length;
                var lastIndex = str.indexOf(searchString, pos);
                return lastIndex !== -1 && lastIndex === pos;
              }(this.toOut, this.sep)) {
                this.toOut = this.toOut.substring(0, this.toOut.length - this.sep.length);
              }

              console.error(this.toOut);
              this.toOut = "";
            }
          };

          return System$1;
        }(java.io.OutputStream);

        System.System$1 = System$1;
        System$1["__interfaces"] = ["java.io.Closeable", "java.lang.AutoCloseable", "java.io.Flushable"];

        var System$2 =
        /** @class */
        function (_super) {
          __extends(System$2, _super);

          function System$2() {
            var _this = _super.call(this) || this;

            if (_this.readData === undefined) {
              _this.readData = null;
            }

            _this.where = 0;
            _this.sep = java.lang.System.propertyMap_$LI$().get("line.separator");

            _this.readerFunction = function () {
              var result = null;

              if (java.lang.System.ENVIRONMENT_IS_NODE_$LI$()) {
                var fs = eval("global.fs || (global.fs = require(\"fs\"))");
                var BUFSIZE = 256;
                var buf = new (eval("Buffer"))(BUFSIZE);
                var fd = eval("process.stdin.fd");
                var usingDevice = false;

                try {
                  fd = fs["openSync"]("/dev/stdin", "r");
                  usingDevice = true;
                } catch (ignored) {}

                var bytesRead = 0;

                try {
                  bytesRead = fs["readSync"](fd, buf, 0, BUFSIZE, null);
                } catch (e) {
                  if (e.toString().indexOf("EOF") === -1) throw e;
                }

                if (usingDevice) fs["closeSync"](fd);
                if (bytesRead > 0) result = buf.slice(0, bytesRead).toString();
              } else if (java.lang.System.ENVIRONMENT_IS_WEB_$LI$() || java.lang.System.ENVIRONMENT_IS_WORKER_$LI$()) {
                if (java.util.Objects.equals(_typeof(window["prompt"]), "function")) {
                  result = window.prompt("Input: ");

                  if (result != null) {
                    result += _this.sep;
                  }
                }
              } else if (java.util.Objects.equals(_typeof(eval("readline")), "function")) {
                result = eval("readline()");

                if (result != null) {
                  result += _this.sep;
                }
              }

              return result;
            };

            return _this;
          }

          System$2.prototype.read = function (buffer, byteOffset, byteCount) {
            if ((buffer != null && buffer instanceof Array && (buffer.length == 0 || buffer[0] == null || typeof buffer[0] === 'number') || buffer === null) && (typeof byteOffset === 'number' || byteOffset === null) && (typeof byteCount === 'number' || byteCount === null)) {
              return _super.prototype.read.call(this, buffer, byteOffset, byteCount);
            } else if ((buffer != null && buffer instanceof Array && (buffer.length == 0 || buffer[0] == null || typeof buffer[0] === 'number') || buffer === null) && byteOffset === undefined && byteCount === undefined) {
              return this.read$byte_A(buffer);
            } else if (buffer === undefined && byteOffset === undefined && byteCount === undefined) {
              return this.read$();
            } else throw new Error('invalid overload');
          };

          System$2.prototype.read$ = function () {
            if (this.readData == null) {
              this.readData =
              /* toCharArray */
              function (target) {
                return typeof target === 'function' ? target() : target.get();
              }(this.readerFunction).split('');

              this.where = 0;
            } else {
              ++this.where;
            }

            if (this.where === this.readData.length) {
              this.readData = null;
              this.where = 0;
              return -1;
            }

            return this.readData[this.where].charCodeAt(0);
          };

          return System$2;
        }(java.io.InputStream);

        System.System$2 = System$2;
        System$2["__interfaces"] = ["java.io.Closeable", "java.lang.AutoCloseable"];
      })(System = lang.System || (lang.System = {}));
    })(java.lang || (java.lang = {}));
  })(java || (java = {}));

  (function (javaemul) {
    (function (internal) {
      /**
      * A utility class that provides utility functions to do precondition checks inside GWT-SDK.
      * @class
      */
      var InternalPreconditions =
      /** @class */
      function () {
        function InternalPreconditions() {}

        InternalPreconditions.CHECKED_MODE_$LI$ = function () {
          if (InternalPreconditions.CHECKED_MODE == null) {
            InternalPreconditions.CHECKED_MODE = java.lang.System.getProperty("jre.checkedMode", "ENABLED") === "ENABLED";
          }

          return InternalPreconditions.CHECKED_MODE;
        };

        InternalPreconditions.TYPE_CHECK_$LI$ = function () {
          if (InternalPreconditions.TYPE_CHECK == null) {
            InternalPreconditions.TYPE_CHECK = java.lang.System.getProperty("jre.checks.type", "ENABLED") === "ENABLED";
          }

          return InternalPreconditions.TYPE_CHECK;
        };

        InternalPreconditions.API_CHECK_$LI$ = function () {
          if (InternalPreconditions.API_CHECK == null) {
            InternalPreconditions.API_CHECK = java.lang.System.getProperty("jre.checks.api", "ENABLED") === "ENABLED";
          }

          return InternalPreconditions.API_CHECK;
        };

        InternalPreconditions.BOUND_CHECK_$LI$ = function () {
          if (InternalPreconditions.BOUND_CHECK == null) {
            InternalPreconditions.BOUND_CHECK = java.lang.System.getProperty("jre.checks.bounds", "ENABLED") === "ENABLED";
          }

          return InternalPreconditions.BOUND_CHECK;
        };

        InternalPreconditions.checkType = function (expression) {
          if (InternalPreconditions.TYPE_CHECK_$LI$()) {
            InternalPreconditions.checkCriticalType(expression);
          } else if (InternalPreconditions.CHECKED_MODE_$LI$()) {
            try {
              InternalPreconditions.checkCriticalType(expression);
            } catch (e) {
              throw new java.lang.AssertionError(e);
            }
          }
        };

        InternalPreconditions.checkCriticalType = function (expression) {
          if (!expression) {
            throw new java.lang.ClassCastException();
          }
        };

        InternalPreconditions.checkArrayType$boolean = function (expression) {
          if (InternalPreconditions.TYPE_CHECK_$LI$()) {
            InternalPreconditions.checkCriticalArrayType$boolean(expression);
          } else if (InternalPreconditions.CHECKED_MODE_$LI$()) {
            try {
              InternalPreconditions.checkCriticalArrayType$boolean(expression);
            } catch (e) {
              throw new java.lang.AssertionError(e);
            }
          }
        };

        InternalPreconditions.checkCriticalArrayType$boolean = function (expression) {
          if (!expression) {
            throw new java.lang.ArrayStoreException();
          }
        };

        InternalPreconditions.checkArrayType$boolean$java_lang_Object = function (expression, errorMessage) {
          if (InternalPreconditions.TYPE_CHECK_$LI$()) {
            InternalPreconditions.checkCriticalArrayType$boolean$java_lang_Object(expression, errorMessage);
          } else if (InternalPreconditions.CHECKED_MODE_$LI$()) {
            try {
              InternalPreconditions.checkCriticalArrayType$boolean$java_lang_Object(expression, errorMessage);
            } catch (e) {
              throw new java.lang.AssertionError(e);
            }
          }
        };
        /**
        * Ensures the truth of an expression that verifies array type.
        * @param {boolean} expression
        * @param {*} errorMessage
        */


        InternalPreconditions.checkArrayType = function (expression, errorMessage) {
          if ((typeof expression === 'boolean' || expression === null) && (errorMessage != null || errorMessage === null)) {
            return javaemul.internal.InternalPreconditions.checkArrayType$boolean$java_lang_Object(expression, errorMessage);
          } else if ((typeof expression === 'boolean' || expression === null) && errorMessage === undefined) {
            return javaemul.internal.InternalPreconditions.checkArrayType$boolean(expression);
          } else throw new Error('invalid overload');
        };

        InternalPreconditions.checkCriticalArrayType$boolean$java_lang_Object = function (expression, errorMessage) {
          if (!expression) {
            throw new java.lang.ArrayStoreException(
            /* valueOf */
            new String(errorMessage).toString());
          }
        };

        InternalPreconditions.checkCriticalArrayType = function (expression, errorMessage) {
          if ((typeof expression === 'boolean' || expression === null) && (errorMessage != null || errorMessage === null)) {
            return javaemul.internal.InternalPreconditions.checkCriticalArrayType$boolean$java_lang_Object(expression, errorMessage);
          } else if ((typeof expression === 'boolean' || expression === null) && errorMessage === undefined) {
            return javaemul.internal.InternalPreconditions.checkCriticalArrayType$boolean(expression);
          } else throw new Error('invalid overload');
        };

        InternalPreconditions.checkElement$boolean = function (expression) {
          if (InternalPreconditions.API_CHECK_$LI$()) {
            InternalPreconditions.checkCriticalElement$boolean(expression);
          } else if (InternalPreconditions.CHECKED_MODE_$LI$()) {
            try {
              InternalPreconditions.checkCriticalElement$boolean(expression);
            } catch (e) {
              throw new java.lang.AssertionError(e);
            }
          }
        };

        InternalPreconditions.checkCriticalElement$boolean = function (expression) {
          if (!expression) {
            throw new java.util.NoSuchElementException();
          }
        };

        InternalPreconditions.checkElement$boolean$java_lang_Object = function (expression, errorMessage) {
          if (InternalPreconditions.API_CHECK_$LI$()) {
            InternalPreconditions.checkCriticalElement$boolean$java_lang_Object(expression, errorMessage);
          } else if (InternalPreconditions.CHECKED_MODE_$LI$()) {
            try {
              InternalPreconditions.checkCriticalElement$boolean$java_lang_Object(expression, errorMessage);
            } catch (e) {
              throw new java.lang.AssertionError(e);
            }
          }
        };
        /**
        * Ensures the truth of an expression involving existence of an element.
        * @param {boolean} expression
        * @param {*} errorMessage
        */


        InternalPreconditions.checkElement = function (expression, errorMessage) {
          if ((typeof expression === 'boolean' || expression === null) && (errorMessage != null || errorMessage === null)) {
            return javaemul.internal.InternalPreconditions.checkElement$boolean$java_lang_Object(expression, errorMessage);
          } else if ((typeof expression === 'boolean' || expression === null) && errorMessage === undefined) {
            return javaemul.internal.InternalPreconditions.checkElement$boolean(expression);
          } else throw new Error('invalid overload');
        };

        InternalPreconditions.checkCriticalElement$boolean$java_lang_Object = function (expression, errorMessage) {
          if (!expression) {
            throw new java.util.NoSuchElementException(
            /* valueOf */
            new String(errorMessage).toString());
          }
        };
        /**
        * Ensures the truth of an expression involving existence of an element.
        * <p>
        * For cases where failing fast is pretty important and not failing early could cause bugs that
        * are much harder to debug.
        * @param {boolean} expression
        * @param {*} errorMessage
        */


        InternalPreconditions.checkCriticalElement = function (expression, errorMessage) {
          if ((typeof expression === 'boolean' || expression === null) && (errorMessage != null || errorMessage === null)) {
            return javaemul.internal.InternalPreconditions.checkCriticalElement$boolean$java_lang_Object(expression, errorMessage);
          } else if ((typeof expression === 'boolean' || expression === null) && errorMessage === undefined) {
            return javaemul.internal.InternalPreconditions.checkCriticalElement$boolean(expression);
          } else throw new Error('invalid overload');
        };

        InternalPreconditions.checkArgument$boolean = function (expression) {
          if (InternalPreconditions.API_CHECK_$LI$()) {
            InternalPreconditions.checkCriticalArgument$boolean(expression);
          } else if (InternalPreconditions.CHECKED_MODE_$LI$()) {
            try {
              InternalPreconditions.checkCriticalArgument$boolean(expression);
            } catch (e) {
              throw new java.lang.AssertionError(e);
            }
          }
        };

        InternalPreconditions.checkCriticalArgument$boolean = function (expression) {
          if (!expression) {
            throw new java.lang.IllegalArgumentException();
          }
        };

        InternalPreconditions.checkArgument$boolean$java_lang_Object = function (expression, errorMessage) {
          if (InternalPreconditions.API_CHECK_$LI$()) {
            InternalPreconditions.checkCriticalArgument$boolean$java_lang_Object(expression, errorMessage);
          } else if (InternalPreconditions.CHECKED_MODE_$LI$()) {
            try {
              InternalPreconditions.checkCriticalArgument$boolean$java_lang_Object(expression, errorMessage);
            } catch (e) {
              throw new java.lang.AssertionError(e);
            }
          }
        };

        InternalPreconditions.checkCriticalArgument$boolean$java_lang_Object = function (expression, errorMessage) {
          if (!expression) {
            throw new java.lang.IllegalArgumentException(
            /* valueOf */
            new String(errorMessage).toString());
          }
        };

        InternalPreconditions.checkArgument$boolean$java_lang_String$java_lang_Object_A = function (expression, errorMessageTemplate) {
          var errorMessageArgs = [];

          for (var _i = 2; _i < arguments.length; _i++) {
            errorMessageArgs[_i - 2] = arguments[_i];
          }

          if (InternalPreconditions.API_CHECK_$LI$()) {
            InternalPreconditions.checkCriticalArgument$boolean$java_lang_String$java_lang_Object_A.apply(this, [expression, errorMessageTemplate].concat(errorMessageArgs));
          } else if (InternalPreconditions.CHECKED_MODE_$LI$()) {
            try {
              InternalPreconditions.checkCriticalArgument$boolean$java_lang_String$java_lang_Object_A.apply(this, [expression, errorMessageTemplate].concat(errorMessageArgs));
            } catch (e) {
              throw new java.lang.AssertionError(e);
            }
          }
        };
        /**
        * Ensures the truth of an expression involving one or more parameters to the calling method.
        * @param {boolean} expression
        * @param {string} errorMessageTemplate
        * @param {Array} errorMessageArgs
        */


        InternalPreconditions.checkArgument = function (expression, errorMessageTemplate) {
          var _a;

          var errorMessageArgs = [];

          for (var _i = 2; _i < arguments.length; _i++) {
            errorMessageArgs[_i - 2] = arguments[_i];
          }

          if ((typeof expression === 'boolean' || expression === null) && (typeof errorMessageTemplate === 'string' || errorMessageTemplate === null) && (errorMessageArgs != null && errorMessageArgs instanceof Array && (errorMessageArgs.length == 0 || errorMessageArgs[0] == null || errorMessageArgs[0] != null) || errorMessageArgs === null)) {
            return (_a = javaemul.internal.InternalPreconditions).checkArgument$boolean$java_lang_String$java_lang_Object_A.apply(_a, __spreadArrays([expression, errorMessageTemplate], errorMessageArgs));
          } else if ((typeof expression === 'boolean' || expression === null) && (errorMessageTemplate != null || errorMessageTemplate === null) && errorMessageArgs === undefined || errorMessageArgs.length === 0) {
            return javaemul.internal.InternalPreconditions.checkArgument$boolean$java_lang_Object(expression, errorMessageTemplate);
          } else if ((typeof expression === 'boolean' || expression === null) && errorMessageTemplate === undefined && errorMessageArgs === undefined || errorMessageArgs.length === 0) {
            return javaemul.internal.InternalPreconditions.checkArgument$boolean(expression);
          } else throw new Error('invalid overload');
        };

        InternalPreconditions.checkCriticalArgument$boolean$java_lang_String$java_lang_Object_A = function (expression, errorMessageTemplate) {
          var errorMessageArgs = [];

          for (var _i = 2; _i < arguments.length; _i++) {
            errorMessageArgs[_i - 2] = arguments[_i];
          }

          if (!expression) {
            throw new java.lang.IllegalArgumentException(InternalPreconditions.format.apply(this, [errorMessageTemplate].concat(errorMessageArgs)));
          }
        };
        /**
        * Ensures the truth of an expression involving one or more parameters to the calling method.
        * <p>
        * For cases where failing fast is pretty important and not failing early could cause bugs that
        * are much harder to debug.
        * @param {boolean} expression
        * @param {string} errorMessageTemplate
        * @param {Array} errorMessageArgs
        */


        InternalPreconditions.checkCriticalArgument = function (expression, errorMessageTemplate) {
          var _a;

          var errorMessageArgs = [];

          for (var _i = 2; _i < arguments.length; _i++) {
            errorMessageArgs[_i - 2] = arguments[_i];
          }

          if ((typeof expression === 'boolean' || expression === null) && (typeof errorMessageTemplate === 'string' || errorMessageTemplate === null) && (errorMessageArgs != null && errorMessageArgs instanceof Array && (errorMessageArgs.length == 0 || errorMessageArgs[0] == null || errorMessageArgs[0] != null) || errorMessageArgs === null)) {
            return (_a = javaemul.internal.InternalPreconditions).checkCriticalArgument$boolean$java_lang_String$java_lang_Object_A.apply(_a, __spreadArrays([expression, errorMessageTemplate], errorMessageArgs));
          } else if ((typeof expression === 'boolean' || expression === null) && (errorMessageTemplate != null || errorMessageTemplate === null) && errorMessageArgs === undefined || errorMessageArgs.length === 0) {
            return javaemul.internal.InternalPreconditions.checkCriticalArgument$boolean$java_lang_Object(expression, errorMessageTemplate);
          } else if ((typeof expression === 'boolean' || expression === null) && errorMessageTemplate === undefined && errorMessageArgs === undefined || errorMessageArgs.length === 0) {
            return javaemul.internal.InternalPreconditions.checkCriticalArgument$boolean(expression);
          } else throw new Error('invalid overload');
        };

        InternalPreconditions.checkState$boolean = function (expression) {
          if (InternalPreconditions.API_CHECK_$LI$()) {
            InternalPreconditions.checkCritcalState(expression);
          } else if (InternalPreconditions.CHECKED_MODE_$LI$()) {
            try {
              InternalPreconditions.checkCritcalState(expression);
            } catch (e) {
              throw new java.lang.AssertionError(e);
            }
          }
        };
        /**
        * Ensures the truth of an expression involving the state of the calling instance, but not
        * involving any parameters to the calling method.
        * <p>
        * For cases where failing fast is pretty important and not failing early could cause bugs that
        * are much harder to debug.
        * @param {boolean} expression
        */


        InternalPreconditions.checkCritcalState = function (expression) {
          if (!expression) {
            throw new java.lang.IllegalStateException();
          }
        };

        InternalPreconditions.checkState$boolean$java_lang_Object = function (expression, errorMessage) {
          if (InternalPreconditions.API_CHECK_$LI$()) {
            InternalPreconditions.checkCriticalState(expression, errorMessage);
          } else if (InternalPreconditions.CHECKED_MODE_$LI$()) {
            try {
              InternalPreconditions.checkCriticalState(expression, errorMessage);
            } catch (e) {
              throw new java.lang.AssertionError(e);
            }
          }
        };
        /**
        * Ensures the truth of an expression involving the state of the calling instance, but not
        * involving any parameters to the calling method.
        * @param {boolean} expression
        * @param {*} errorMessage
        */


        InternalPreconditions.checkState = function (expression, errorMessage) {
          if ((typeof expression === 'boolean' || expression === null) && (errorMessage != null || errorMessage === null)) {
            return javaemul.internal.InternalPreconditions.checkState$boolean$java_lang_Object(expression, errorMessage);
          } else if ((typeof expression === 'boolean' || expression === null) && errorMessage === undefined) {
            return javaemul.internal.InternalPreconditions.checkState$boolean(expression);
          } else throw new Error('invalid overload');
        };
        /**
        * Ensures the truth of an expression involving the state of the calling instance, but not
        * involving any parameters to the calling method.
        * @param {boolean} expression
        * @param {*} errorMessage
        */


        InternalPreconditions.checkCriticalState = function (expression, errorMessage) {
          if (!expression) {
            throw new java.lang.IllegalStateException(
            /* valueOf */
            new String(errorMessage).toString());
          }
        };

        InternalPreconditions.checkNotNull$java_lang_Object = function (reference) {
          if (InternalPreconditions.API_CHECK_$LI$()) {
            InternalPreconditions.checkCriticalNotNull(reference);
          } else if (InternalPreconditions.CHECKED_MODE_$LI$()) {
            try {
              InternalPreconditions.checkCriticalNotNull(reference);
            } catch (e) {
              throw new java.lang.AssertionError(e);
            }
          }

          return reference;
        };

        InternalPreconditions.checkCriticalNotNull$java_lang_Object = function (reference) {
          if (reference == null) {
            throw new java.lang.NullPointerException();
          }

          return reference;
        };

        InternalPreconditions.checkNotNull$java_lang_Object$java_lang_Object = function (reference, errorMessage) {
          if (InternalPreconditions.API_CHECK_$LI$()) {
            InternalPreconditions.checkCriticalNotNull$java_lang_Object$java_lang_Object(reference, errorMessage);
          } else if (InternalPreconditions.CHECKED_MODE_$LI$()) {
            try {
              InternalPreconditions.checkCriticalNotNull$java_lang_Object$java_lang_Object(reference, errorMessage);
            } catch (e) {
              throw new java.lang.AssertionError(e);
            }
          }
        };
        /**
        * Ensures that an object reference passed as a parameter to the calling method is not null.
        * @param {*} reference
        * @param {*} errorMessage
        */


        InternalPreconditions.checkNotNull = function (reference, errorMessage) {
          if ((reference != null || reference === null) && (errorMessage != null || errorMessage === null)) {
            return javaemul.internal.InternalPreconditions.checkNotNull$java_lang_Object$java_lang_Object(reference, errorMessage);
          } else if ((reference != null || reference === null) && errorMessage === undefined) {
            return javaemul.internal.InternalPreconditions.checkNotNull$java_lang_Object(reference);
          } else throw new Error('invalid overload');
        };

        InternalPreconditions.checkCriticalNotNull$java_lang_Object$java_lang_Object = function (reference, errorMessage) {
          if (reference == null) {
            throw new java.lang.NullPointerException(
            /* valueOf */
            new String(errorMessage).toString());
          }
        };

        InternalPreconditions.checkCriticalNotNull = function (reference, errorMessage) {
          if ((reference != null || reference === null) && (errorMessage != null || errorMessage === null)) {
            return javaemul.internal.InternalPreconditions.checkCriticalNotNull$java_lang_Object$java_lang_Object(reference, errorMessage);
          } else if ((reference != null || reference === null) && errorMessage === undefined) {
            return javaemul.internal.InternalPreconditions.checkCriticalNotNull$java_lang_Object(reference);
          } else throw new Error('invalid overload');
        };
        /**
        * Ensures that {@code size} specifies a valid array size (i.e. non-negative).
        * @param {number} size
        */


        InternalPreconditions.checkArraySize = function (size) {
          if (InternalPreconditions.API_CHECK_$LI$()) {
            InternalPreconditions.checkCriticalArraySize(size);
          } else if (InternalPreconditions.CHECKED_MODE_$LI$()) {
            try {
              InternalPreconditions.checkCriticalArraySize(size);
            } catch (e) {
              throw new java.lang.AssertionError(e);
            }
          }
        };

        InternalPreconditions.checkCriticalArraySize = function (size) {
          if (size < 0) {
            throw new java.lang.NegativeArraySizeException("Negative array size: " + size);
          }
        };
        /**
        * Ensures that {@code index} specifies a valid <i>element</i> in an array, list or string of size
        * {@code size}. An element index may range from zero, inclusive, to {@code size}, exclusive.
        * @param {number} index
        * @param {number} size
        */


        InternalPreconditions.checkElementIndex = function (index, size) {
          if (InternalPreconditions.BOUND_CHECK_$LI$()) {
            InternalPreconditions.checkCriticalElementIndex(index, size);
          } else if (InternalPreconditions.CHECKED_MODE_$LI$()) {
            try {
              InternalPreconditions.checkCriticalElementIndex(index, size);
            } catch (e) {
              throw new java.lang.AssertionError(e);
            }
          }
        };

        InternalPreconditions.checkCriticalElementIndex = function (index, size) {
          if (index < 0 || index >= size) {
            throw new java.lang.IndexOutOfBoundsException("Index: " + index + ", Size: " + size);
          }
        };
        /**
        * Ensures that {@code index} specifies a valid <i>position</i> in an array, list or string of
        * size {@code size}. A position index may range from zero to {@code size}, inclusive.
        * @param {number} index
        * @param {number} size
        */


        InternalPreconditions.checkPositionIndex = function (index, size) {
          if (InternalPreconditions.BOUND_CHECK_$LI$()) {
            InternalPreconditions.checkCriticalPositionIndex(index, size);
          } else if (InternalPreconditions.CHECKED_MODE_$LI$()) {
            try {
              InternalPreconditions.checkCriticalPositionIndex(index, size);
            } catch (e) {
              throw new java.lang.AssertionError(e);
            }
          }
        };

        InternalPreconditions.checkCriticalPositionIndex = function (index, size) {
          if (index < 0 || index > size) {
            throw new java.lang.IndexOutOfBoundsException("Index: " + index + ", Size: " + size);
          }
        };
        /**
        * Ensures that {@code start} and {@code end} specify a valid <i>positions</i> in an array, list
        * or string of size {@code size}, and are in order. A position index may range from zero to
        * {@code size}, inclusive.
        * @param {number} start
        * @param {number} end
        * @param {number} size
        */


        InternalPreconditions.checkPositionIndexes = function (start, end, size) {
          if (InternalPreconditions.BOUND_CHECK_$LI$()) {
            InternalPreconditions.checkCriticalPositionIndexes(start, end, size);
          } else if (InternalPreconditions.CHECKED_MODE_$LI$()) {
            try {
              InternalPreconditions.checkCriticalPositionIndexes(start, end, size);
            } catch (e) {
              throw new java.lang.AssertionError(e);
            }
          }
        };
        /**
        * Ensures that {@code start} and {@code end} specify a valid <i>positions</i> in an array, list
        * or string of size {@code size}, and are in order. A position index may range from zero to
        * {@code size}, inclusive.
        * @param {number} start
        * @param {number} end
        * @param {number} size
        */


        InternalPreconditions.checkCriticalPositionIndexes = function (start, end, size) {
          if (start < 0) {
            throw new java.lang.IndexOutOfBoundsException("fromIndex: " + start + " < 0");
          }

          if (end > size) {
            throw new java.lang.IndexOutOfBoundsException("toIndex: " + end + " > size " + size);
          }

          if (start > end) {
            throw new java.lang.IllegalArgumentException("fromIndex: " + start + " > toIndex: " + end);
          }
        };
        /**
        * Checks that bounds are correct.
        *
        * @throw StringIndexOutOfBoundsException if the range is not legal
        * @param {number} start
        * @param {number} end
        * @param {number} size
        */


        InternalPreconditions.checkStringBounds = function (start, end, size) {
          if (start < 0) {
            throw new java.lang.StringIndexOutOfBoundsException("fromIndex: " + start + " < 0");
          }

          if (end > size) {
            throw new java.lang.StringIndexOutOfBoundsException("toIndex: " + end + " > size " + size);
          }

          if (end < start) {
            throw new java.lang.StringIndexOutOfBoundsException("fromIndex: " + start + " > toIndex: " + end);
          }
        };
        /**
        * Substitutes each {@code %s} in {@code template} with an argument. These are matched by
        * position: the first {@code %s} gets {@code args[0]}, etc.  If there are more arguments than
        * placeholders, the unmatched arguments will be appended to the end of the formatted message in
        * square braces.
        * @param {string} template
        * @param {Array} args
        * @return {string}
        * @private
        */

        /*private*/


        InternalPreconditions.format = function (template) {
          var args = [];

          for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
          }

          template =
          /* valueOf */
          new String(template).toString();
          var builder = new java.lang.StringBuilder(template.length + 16 * args.length);
          var templateStart = 0;
          var i = 0;

          while (i < args.length) {
            {
              var placeholderStart = template.indexOf("%s", templateStart);

              if (placeholderStart === -1) {
                break;
              }

              builder.append$java_lang_String(template.substring(templateStart, placeholderStart));
              builder.append$java_lang_Object(args[i++]);
              templateStart = placeholderStart + 2;
            }
          }

          builder.append$java_lang_String(template.substring(templateStart));

          if (i < args.length) {
            builder.append$java_lang_String(" [");
            builder.append$java_lang_Object(args[i++]);

            while (i < args.length) {
              {
                builder.append$java_lang_String(", ");
                builder.append$java_lang_Object(args[i++]);
              }
            }

            builder.append$char(']');
          }

          return builder.toString();
        };

        return InternalPreconditions;
      }();

      internal.InternalPreconditions = InternalPreconditions;
      InternalPreconditions["__class"] = "javaemul.internal.InternalPreconditions";
    })(javaemul.internal || (javaemul.internal = {}));
  })(javaemul || (javaemul = {}));

  (function (java) {
    (function (util) {
      /**
      * A helper to detect concurrent modifications to collections. This is implemented as a helper
      * utility so that we could remove the checks easily by a flag.
      * @class
      */
      var ConcurrentModificationDetector =
      /** @class */
      function () {
        function ConcurrentModificationDetector() {}

        ConcurrentModificationDetector.API_CHECK_$LI$ = function () {
          if (ConcurrentModificationDetector.API_CHECK == null) {
            ConcurrentModificationDetector.API_CHECK = java.lang.System.getProperty("jre.checks.api", "ENABLED") === "ENABLED";
          }

          return ConcurrentModificationDetector.API_CHECK;
        };

        ConcurrentModificationDetector.structureChanged = function (map) {
          if (!ConcurrentModificationDetector.API_CHECK_$LI$()) {
            return;
          }

          var modCount = javaemul.internal.JsUtils.getIntProperty(map, ConcurrentModificationDetector.MOD_COUNT_PROPERTY) | 0;
          javaemul.internal.JsUtils.setIntProperty(map, ConcurrentModificationDetector.MOD_COUNT_PROPERTY, modCount + 1);
        };

        ConcurrentModificationDetector.recordLastKnownStructure = function (host, iterator) {
          if (!ConcurrentModificationDetector.API_CHECK_$LI$()) {
            return;
          }

          var modCount = javaemul.internal.JsUtils.getIntProperty(host, ConcurrentModificationDetector.MOD_COUNT_PROPERTY);
          javaemul.internal.JsUtils.setIntProperty(iterator, ConcurrentModificationDetector.MOD_COUNT_PROPERTY, modCount);
        };

        ConcurrentModificationDetector.checkStructuralChange = function (host, iterator) {
          if (!ConcurrentModificationDetector.API_CHECK_$LI$()) {
            return;
          }

          if (javaemul.internal.JsUtils.getIntProperty(iterator, ConcurrentModificationDetector.MOD_COUNT_PROPERTY) !== javaemul.internal.JsUtils.getIntProperty(host, ConcurrentModificationDetector.MOD_COUNT_PROPERTY)) {
            throw new java.util.ConcurrentModificationException();
          }
        };

        ConcurrentModificationDetector.MOD_COUNT_PROPERTY = "_gwt_modCount";
        return ConcurrentModificationDetector;
      }();

      util.ConcurrentModificationDetector = ConcurrentModificationDetector;
      ConcurrentModificationDetector["__class"] = "java.util.ConcurrentModificationDetector";
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (util) {
      (function (logging) {
        /**
        * An emulation of the java.util.logging.Logger class. See
        * <a href="http://java.sun.com/j2se/1.4.2/docs/api/java/util/logging/Logger.html">
        * The Java API doc for details</a>
        * @class
        */
        var Logger =
        /** @class */
        function () {
          function Logger(name, resourceName) {
            if (this.handlers === undefined) {
              this.handlers = null;
            }

            this.level = null;

            if (this.name === undefined) {
              this.name = null;
            }

            if (this.parent === undefined) {
              this.parent = null;
            }

            if (this.useParentHandlers === undefined) {
              this.useParentHandlers = false;
            }

            if (Logger.LOGGING_FALSE_$LI$()) {
              return;
            }

            this.name = name;
            this.useParentHandlers = true;
            this.handlers = new java.util.ArrayList();
          }

          Logger.__static_initialize = function () {
            if (!Logger.__static_initialized) {
              Logger.__static_initialized = true;

              Logger.__static_initializer_0();
            }
          };

          Logger.LOGGING_ENABLED_$LI$ = function () {
            Logger.__static_initialize();

            if (Logger.LOGGING_ENABLED == null) {
              Logger.LOGGING_ENABLED = java.lang.System.getProperty("gwt.logging.enabled", "TRUE");
            }

            return Logger.LOGGING_ENABLED;
          };

          Logger.LOGGING_WARNING_$LI$ = function () {
            Logger.__static_initialize();

            if (Logger.LOGGING_WARNING == null) {
              Logger.LOGGING_WARNING = Logger.LOGGING_ENABLED_$LI$() === "WARNING";
            }

            return Logger.LOGGING_WARNING;
          };

          Logger.LOGGING_SEVERE_$LI$ = function () {
            Logger.__static_initialize();

            if (Logger.LOGGING_SEVERE == null) {
              Logger.LOGGING_SEVERE = Logger.LOGGING_ENABLED_$LI$() === "SEVERE";
            }

            return Logger.LOGGING_SEVERE;
          };

          Logger.LOGGING_FALSE_$LI$ = function () {
            Logger.__static_initialize();

            if (Logger.LOGGING_FALSE == null) {
              Logger.LOGGING_FALSE = Logger.LOGGING_ENABLED_$LI$() === "FALSE";
            }

            return Logger.LOGGING_FALSE;
          };

          Logger.__static_initializer_0 = function () {
            Logger.assertLoggingValues();
          };

          Logger.getGlobal = function () {
            return Logger.getLogger(Logger.GLOBAL_LOGGER_NAME);
          };

          Logger.getLogger = function (name) {
            if (Logger.LOGGING_FALSE_$LI$()) {
              return new Logger(name, null);
            }

            return java.util.logging.LogManager.getLogManager().ensureLogger(name);
          };

          Logger.assertLoggingValues = function () {
            if (Logger.LOGGING_ENABLED_$LI$() === "FALSE" || Logger.LOGGING_ENABLED_$LI$() === "TRUE" || Logger.LOGGING_ENABLED_$LI$() === "SEVERE" || Logger.LOGGING_ENABLED_$LI$() === "WARNING") {
              return;
            }

            throw new java.lang.RuntimeException("Undefined value for gwt.logging.enabled: \'" + Logger.LOGGING_ENABLED_$LI$() + "\'. Allowed values are TRUE, FALSE, SEVERE, WARNING");
          };

          Logger.prototype.addHandler = function (handler) {
            if (Logger.LOGGING_FALSE_$LI$()) {
              return;
            }

            this.handlers.add(handler);
          };

          Logger.prototype.config = function (msg) {
            if (Logger.LOGGING_FALSE_$LI$() || Logger.LOGGING_SEVERE_$LI$() || Logger.LOGGING_WARNING_$LI$()) {
              return;
            }

            this.log$java_util_logging_Level$java_lang_String(java.util.logging.Level.CONFIG_$LI$(), msg);
          };

          Logger.prototype.fine = function (msg) {
            if (Logger.LOGGING_FALSE_$LI$() || Logger.LOGGING_SEVERE_$LI$() || Logger.LOGGING_WARNING_$LI$()) {
              return;
            }

            this.log$java_util_logging_Level$java_lang_String(java.util.logging.Level.FINE_$LI$(), msg);
          };

          Logger.prototype.finer = function (msg) {
            if (Logger.LOGGING_FALSE_$LI$() || Logger.LOGGING_SEVERE_$LI$() || Logger.LOGGING_WARNING_$LI$()) {
              return;
            }

            this.log$java_util_logging_Level$java_lang_String(java.util.logging.Level.FINER_$LI$(), msg);
          };

          Logger.prototype.finest = function (msg) {
            if (Logger.LOGGING_FALSE_$LI$() || Logger.LOGGING_SEVERE_$LI$() || Logger.LOGGING_WARNING_$LI$()) {
              return;
            }

            this.log$java_util_logging_Level$java_lang_String(java.util.logging.Level.FINEST_$LI$(), msg);
          };

          Logger.prototype.info = function (msg) {
            if (Logger.LOGGING_FALSE_$LI$() || Logger.LOGGING_SEVERE_$LI$() || Logger.LOGGING_WARNING_$LI$()) {
              return;
            }

            this.log$java_util_logging_Level$java_lang_String(java.util.logging.Level.INFO_$LI$(), msg);
          };

          Logger.prototype.warning = function (msg) {
            if (Logger.LOGGING_FALSE_$LI$() || Logger.LOGGING_SEVERE_$LI$()) {
              return;
            }

            this.log$java_util_logging_Level$java_lang_String(java.util.logging.Level.WARNING_$LI$(), msg);
          };

          Logger.prototype.severe = function (msg) {
            if (Logger.LOGGING_FALSE_$LI$()) {
              return;
            }

            this.log$java_util_logging_Level$java_lang_String(java.util.logging.Level.SEVERE_$LI$(), msg);
          };

          Logger.prototype.getHandlers = function () {
            if (Logger.LOGGING_FALSE_$LI$()) {
              return [];
            }

            return this.handlers['toArray$java_lang_Object_A'](function (s) {
              var a = [];

              while (s-- > 0) {
                a.push(null);
              }

              return a;
            }(this.handlers.size()));
          };

          Logger.prototype.getLevel = function () {
            return Logger.LOGGING_FALSE_$LI$() ? null : this.level;
          };

          Logger.prototype.getName = function () {
            return Logger.LOGGING_FALSE_$LI$() ? null : this.name;
          };

          Logger.prototype.getParent = function () {
            return Logger.LOGGING_FALSE_$LI$() ? null : this.parent;
          };

          Logger.prototype.getUseParentHandlers = function () {
            return Logger.LOGGING_FALSE_$LI$() ? false : this.useParentHandlers;
          };

          Logger.prototype.isLoggable = function (messageLevel) {
            return Logger.LOGGING_FALSE_$LI$() ? false : this.getEffectiveLevel().intValue() <= messageLevel.intValue();
          };

          Logger.prototype.log$java_util_logging_Level$java_lang_String = function (level, msg) {
            this.log$java_util_logging_Level$java_lang_String$java_lang_Throwable(level, msg, null);
          };

          Logger.prototype.log$java_util_logging_Level$java_lang_String$java_lang_Throwable = function (level, msg, thrown) {
            if (Logger.LOGGING_FALSE_$LI$()) {
              return;
            }

            if (Logger.LOGGING_SEVERE_$LI$()) {
              if (level.intValue() >= 1000) {
                this.actuallyLog$java_util_logging_Level$java_lang_String$java_lang_Throwable(level, msg, thrown);
              }
            } else if (Logger.LOGGING_WARNING_$LI$()) {
              if (level.intValue() >= java.util.logging.Level.WARNING_$LI$().intValue()) {
                this.actuallyLog$java_util_logging_Level$java_lang_String$java_lang_Throwable(level, msg, thrown);
              }
            } else {
              this.actuallyLog$java_util_logging_Level$java_lang_String$java_lang_Throwable(level, msg, thrown);
            }
          };

          Logger.prototype.log = function (level, msg, thrown) {
            if ((level != null && level instanceof java.util.logging.Level || level === null) && (typeof msg === 'string' || msg === null) && (thrown != null && thrown instanceof Error || thrown === null)) {
              return this.log$java_util_logging_Level$java_lang_String$java_lang_Throwable(level, msg, thrown);
            } else if ((level != null && level instanceof java.util.logging.Level || level === null) && (typeof msg === 'string' || msg === null) && thrown === undefined) {
              return this.log$java_util_logging_Level$java_lang_String(level, msg);
            } else if ((level != null && level instanceof java.util.logging.LogRecord || level === null) && msg === undefined && thrown === undefined) {
              return this.log$java_util_logging_LogRecord(level);
            } else throw new Error('invalid overload');
          };

          Logger.prototype.log$java_util_logging_LogRecord = function (record) {
            if (Logger.LOGGING_FALSE_$LI$()) {
              return;
            }

            if (Logger.LOGGING_SEVERE_$LI$()) {
              if (record.getLevel().intValue() >= 1000) {
                this.actuallyLog$java_util_logging_LogRecord(record);
              }
            } else if (Logger.LOGGING_WARNING_$LI$()) {
              if (record.getLevel().intValue() >= java.util.logging.Level.WARNING_$LI$().intValue()) {
                this.actuallyLog$java_util_logging_LogRecord(record);
              }
            } else {
              this.actuallyLog$java_util_logging_LogRecord(record);
            }
          };

          Logger.prototype.removeHandler = function (handler) {
            if (Logger.LOGGING_FALSE_$LI$()) {
              return;
            }

            this.handlers['remove$java_lang_Object'](handler);
          };

          Logger.prototype.setLevel = function (newLevel) {
            if (Logger.LOGGING_FALSE_$LI$()) {
              return;
            }

            this.level = newLevel;
          };

          Logger.prototype.setParent = function (newParent) {
            if (Logger.LOGGING_FALSE_$LI$()) {
              return;
            }

            if (newParent != null) {
              this.parent = newParent;
            }
          };

          Logger.prototype.setUseParentHandlers = function (newUseParentHandlers) {
            if (Logger.LOGGING_FALSE_$LI$()) {
              return;
            }

            this.useParentHandlers = newUseParentHandlers;
          };
          /*private*/


          Logger.prototype.getEffectiveLevel = function () {
            if (this.level != null) {
              return this.level;
            }

            var logger = this.getParent();

            while (logger != null) {
              {
                var effectiveLevel = logger.getLevel();

                if (effectiveLevel != null) {
                  return effectiveLevel;
                }

                logger = logger.getParent();
              }
            }

            return java.util.logging.Level.INFO_$LI$();
          };

          Logger.prototype.actuallyLog$java_util_logging_Level$java_lang_String$java_lang_Throwable = function (level, msg, thrown) {
            if (this.isLoggable(level)) {
              var record = new java.util.logging.LogRecord(level, msg);
              record.setThrown(thrown);
              record.setLoggerName(this.getName());
              this.actuallyLog$java_util_logging_LogRecord(record);
            }
          };

          Logger.prototype.actuallyLog = function (level, msg, thrown) {
            if ((level != null && level instanceof java.util.logging.Level || level === null) && (typeof msg === 'string' || msg === null) && (thrown != null && thrown instanceof Error || thrown === null)) {
              return this.actuallyLog$java_util_logging_Level$java_lang_String$java_lang_Throwable(level, msg, thrown);
            } else if ((level != null && level instanceof java.util.logging.LogRecord || level === null) && msg === undefined && thrown === undefined) {
              return this.actuallyLog$java_util_logging_LogRecord(level);
            } else throw new Error('invalid overload');
          };
          /*private*/


          Logger.prototype.actuallyLog$java_util_logging_LogRecord = function (record) {
            if (this.isLoggable(record.getLevel())) {
              {
                var array200 = this.getHandlers();

                for (var index199 = 0; index199 < array200.length; index199++) {
                  var handler = array200[index199];
                  {
                    handler.publish(record);
                  }
                }
              }
              var logger = this.getUseParentHandlers() ? this.getParent() : null;

              while (logger != null) {
                {
                  {
                    var array202 = logger.getHandlers();

                    for (var index201 = 0; index201 < array202.length; index201++) {
                      var handler = array202[index201];
                      {
                        handler.publish(record);
                      }
                    }
                  }
                  logger = logger.getUseParentHandlers() ? logger.getParent() : null;
                }
              }
            }
          };

          Logger.__static_initialized = false;
          Logger.GLOBAL_LOGGER_NAME = "global";
          return Logger;
        }();

        logging.Logger = Logger;
        Logger["__class"] = "java.util.logging.Logger";
      })(util.logging || (util.logging = {}));
    })(java.util || (java.util = {}));
  })(java || (java = {}));

  (function (java) {
    (function (nio) {
      (function (file) {
        var Path =
        /** @class */
        function () {
          function Path(fullPath) {
            if (this.fullPath === undefined) {
              this.fullPath = null;
            }

            this.fullPath = fullPath;
          }
          /* Default method injected from java.lang.Iterable */


          Path.prototype.forEach = function (action) {
            javaemul.internal.InternalPreconditions.checkNotNull(action);

            var _loop_41 = function _loop_41(index203) {
              var t = index203.next();
              {
                (function (target) {
                  return typeof target === 'function' ? target(t) : target.accept(t);
                })(action);
              }
            };

            for (var index203 = this.iterator(); index203.hasNext();) {
              _loop_41(index203);
            }
          };

          Path.PATH_SEPARATOR_$LI$ = function () {
            if (Path.PATH_SEPARATOR == null) {
              Path.PATH_SEPARATOR = java.lang.System.getProperty("file.separator");
            }

            return Path.PATH_SEPARATOR;
          };

          Path.prototype.compareTo$java_nio_file_Path = function (path) {
            return (
              /* compareTo */
              this.toString().localeCompare(path.toString())
            );
          };
          /**
          *
          * @param {java.nio.file.Path} path
          * @return {number}
          */


          Path.prototype.compareTo = function (path) {
            if (path != null && path instanceof java.nio.file.Path || path === null) {
              return this.compareTo$java_nio_file_Path(path);
            } else throw new Error('invalid overload');
          };

          Path.prototype.isAbsolute = function () {
            return java.util.Objects.equals(Path.PATH_SEPARATOR_$LI$(), "/") ? this.fullPath.length > 0 && java.util.Objects.equals(this.fullPath.substring(0, 1), Path.PATH_SEPARATOR_$LI$()) : this.fullPath.length >= 3 && java.util.Objects.equals(this.fullPath.substring(1, 3), ":\\");
          };

          Path.prototype.getFileName = function () {
            return new Path(this.fullPath.substring(this.fullPath.lastIndexOf(Path.PATH_SEPARATOR_$LI$()) + Path.PATH_SEPARATOR_$LI$().length));
          };

          Path.prototype.getParent = function () {
            return new Path(this.fullPath.substring(0, this.fullPath.lastIndexOf(Path.PATH_SEPARATOR_$LI$())));
          };

          Path.prototype.resolve$java_nio_file_Path = function (other) {
            if (other.isAbsolute()) return other;
            return new Path(this.fullPath + "/" + other.fullPath);
          };

          Path.prototype.resolve = function (other) {
            if (other != null && other instanceof java.nio.file.Path || other === null) {
              return this.resolve$java_nio_file_Path(other);
            } else if (typeof other === 'string' || other === null) {
              return this.resolve$java_lang_String(other);
            } else throw new Error('invalid overload');
          };

          Path.prototype.resolve$java_lang_String = function (other) {
            return this.resolve$java_nio_file_Path(java.nio.file.Paths.get(other));
          };

          Path.prototype.toAbsolutePath = function () {
            return java.nio.file.Paths.get(java.lang.System.getProperty$java_lang_String("user.dir")).resolve$java_nio_file_Path(this);
          };
          /**
          *
          * @return {*}
          */


          Path.prototype.iterator = function () {
            var _this = this;

            return java.util.Arrays.asList(this.fullPath.split(Path.PATH_SEPARATOR_$LI$()).map(function (str, i, arr) {
              return _this.isAbsolute() && i === 0 ? new Path(str + Path.PATH_SEPARATOR_$LI$()) : new Path(str);
            })).iterator();
          };
          /**
          *
          * @return {string}
          */


          Path.prototype.toString = function () {
            return this.fullPath;
          };

          return Path;
        }();

        file.Path = Path;
        Path["__class"] = "java.nio.file.Path";
        Path["__interfaces"] = ["java.lang.Comparable", "java.lang.Iterable"];
      })(nio.file || (nio.file = {}));
    })(java.nio || (java.nio = {}));
  })(java || (java = {}));

  java.nio.file.Path.PATH_SEPARATOR_$LI$();
  java.util.logging.Logger.LOGGING_FALSE_$LI$();
  java.util.logging.Logger.LOGGING_SEVERE_$LI$();
  java.util.logging.Logger.LOGGING_WARNING_$LI$();
  java.util.logging.Logger.LOGGING_ENABLED_$LI$();

  java.util.logging.Logger.__static_initialize();

  java.util.ConcurrentModificationDetector.API_CHECK_$LI$();
  javaemul.internal.InternalPreconditions.BOUND_CHECK_$LI$();
  javaemul.internal.InternalPreconditions.API_CHECK_$LI$();
  javaemul.internal.InternalPreconditions.TYPE_CHECK_$LI$();
  javaemul.internal.InternalPreconditions.CHECKED_MODE_$LI$();
  java.lang.System.in_$LI$();
  java.lang.System.out_$LI$();
  java.lang.System.err_$LI$();
  java.lang.System.propertyMap_$LI$();
  java.lang.System.ENVIRONMENT_IS_SHELL_$LI$();
  java.lang.System.ENVIRONMENT_IS_NODE_$LI$();
  java.lang.System.ENVIRONMENT_IS_WORKER_$LI$();
  java.lang.System.ENVIRONMENT_IS_WEB_$LI$();

  java.lang.System.__static_initialize();

  java.util.stream.Collectors.CH_NOID_$LI$();
  java.util.stream.Collectors.CH_ID_$LI$();
  java.util.TreeMap.SubMapType_Tail_$LI$();
  java.util.TreeMap.SubMapType_Range_$LI$();
  java.util.TreeMap.SubMapType_Head_$LI$();
  java.util.TreeMap.SubMapType_All_$LI$();
  java.util.Collections.RandomHolder.rnd_$LI$();
  java.util.Collections.ReverseComparator.INSTANCE_$LI$();
  java.util.Collections.EmptyListIterator.INSTANCE_$LI$();
  java.util.Collections.EMPTY_SET_$LI$();
  java.util.Collections.EMPTY_MAP_$LI$();
  java.util.Collections.EMPTY_LIST_$LI$();
  java.nio.charset.StandardCharsets.UTF_8_$LI$();
  java.nio.charset.StandardCharsets.ISO_8859_1_$LI$();
  javaemul.internal.EmulatedCharset.ISO_8859_1_$LI$();
  javaemul.internal.EmulatedCharset.ISO_LATIN_1_$LI$();
  javaemul.internal.EmulatedCharset.UTF_8_$LI$();
  java.security.MessageDigest.Md5Digest.padding_$LI$();
  javaemul.internal.StringHelper.CASE_INSENSITIVE_ORDER_$LI$();
  java.util.Scanner.whiteSpacePattern_$LI$();
  java.util.Scanner.endLinePattern_$LI$();
  java.util.Scanner.floatPattern_$LI$();
  java.util.Scanner.integerPattern_$LI$();
  java.util.Scanner.booleanPattern_$LI$();
  java.util.Scanner.signedNonNumber_$LI$();
  java.util.Scanner.decimal_$LI$();
  java.util.Scanner.exponent_$LI$();
  java.util.Scanner.decimalNumeral_$LI$();
  java.util.Scanner.numeral_$LI$();
  javaemul.internal.LongHelper.BoxedValues.boxedValues_$LI$();
  javaemul.internal.IntegerHelper.ReverseNibbles.reverseNibbles_$LI$();
  javaemul.internal.IntegerHelper.BoxedValues.boxedValues_$LI$();
  javaemul.internal.ByteHelper.BoxedValues.boxedValues_$LI$();
  javaemul.internal.ByteHelper.TYPE_$LI$();
  javaemul.internal.ByteHelper.MAX_VALUE_$LI$();
  javaemul.internal.ByteHelper.MIN_VALUE_$LI$();
  javaemul.internal.ShortHelper.BoxedValues.boxedValues_$LI$();
  javaemul.internal.ShortHelper.TYPE_$LI$();
  javaemul.internal.ShortHelper.MAX_VALUE_$LI$();
  javaemul.internal.ShortHelper.MIN_VALUE_$LI$();
  javaemul.internal.DoubleHelper.PowersTable.invPowers_$LI$();
  javaemul.internal.DoubleHelper.PowersTable.powers_$LI$();
  java.nio.ByteOrder.LITTLE_ENDIAN_$LI$();
  java.nio.ByteOrder.BIG_ENDIAN_$LI$();
  java.lang.Class.classes_$LI$();
  java.lang.Class.constructors_$LI$();
  java.util.logging.Level.WARNING_$LI$();
  java.util.logging.Level.SEVERE_$LI$();
  java.util.logging.Level.OFF_$LI$();
  java.util.logging.Level.INFO_$LI$();
  java.util.logging.Level.FINEST_$LI$();
  java.util.logging.Level.FINER_$LI$();
  java.util.logging.Level.FINE_$LI$();
  java.util.logging.Level.CONFIG_$LI$();
  java.util.logging.Level.ALL_$LI$();
  java.util.Date.StringData.MONTHS_$LI$();
  java.util.Date.StringData.DAYS_$LI$();
  java.util.Comparators.NATURAL_$LI$();
  java.util.Locale.defaultLocale_$LI$();
  java.util.Locale.UK_$LI$();
  java.util.Locale.FRANCE_$LI$();
  java.util.Locale.US_$LI$();
  java.util.Locale.ENGLISH_$LI$();
  java.util.Locale.ROOT_$LI$();
  java.util.Random.twoToTheXMinus48_$LI$();
  java.util.Random.twoToTheXMinus24_$LI$();

  java.util.Random.__static_initialize();

  java.util.OptionalLong.EMPTY_$LI$();
  java.util.OptionalInt.EMPTY_$LI$();
  java.util.OptionalDouble.EMPTY_$LI$();
  java.util.Optional.EMPTY_$LI$();
  java.util.InternalJsMapFactory.jsMapCtor_$LI$();
  java.net.InternalJsURLFactory.jsURLCtor_$LI$();

  javaemul.internal.NumberHelper.__ParseLong.maxValueForRadix_$LI$();

  javaemul.internal.NumberHelper.__ParseLong.maxLengthForRadix_$LI$();

  javaemul.internal.NumberHelper.__ParseLong.maxDigitsRadixPower_$LI$();

  javaemul.internal.NumberHelper.__ParseLong.maxDigitsForRadix_$LI$();

  javaemul.internal.NumberHelper.__ParseLong.__static_initialize();

  javaemul.internal.MathHelper.PI_UNDER_180_$LI$();
  javaemul.internal.MathHelper.PI_OVER_180_$LI$();
  javaemul.internal.MathHelper.MIN_VALUE_$LI$();
  javaemul.internal.MathHelper.MAX_VALUE_$LI$();
  javaemul.internal.MathHelper.EPSILON_$LI$();
  javaemul.internal.CharacterHelper.BoxedValues.boxedValues_$LI$();
  javaemul.internal.CharacterHelper.TYPE_$LI$();
  javaemul.internal.stream.VoidRunnable.dryRun_$LI$();
  javaemul.internal.StringHashCache.front_$LI$();
  javaemul.internal.StringHashCache.back_$LI$();
  javaemul.internal.BooleanHelper.TYPE_$LI$();
  javaemul.internal.JreHelper.LOG10E_$LI$();
  /* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */

  var com;

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (kinds) {
          var AbstractSymmetryPerspective =
          /*#__PURE__*/
          function () {
            function AbstractSymmetryPerspective(symmetry) {
              _classCallCheck(this, AbstractSymmetryPerspective);

              if (this.symmetry === undefined) this.symmetry = null;
              this.geometries = new java.util.ArrayList();
              this.defaultShapes = null;
              this.symmetry = symmetry;
              this.symmetry.computeOrbitDots();
            }
            /**
            *
            * @return {*}
            */


            _createClass(AbstractSymmetryPerspective, [{
              key: "getSymmetry",
              value: function getSymmetry() {
                return this.symmetry;
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getName",
              value: function getName() {
                return this.getSymmetry().getName();
              }
            }, {
              key: "addShapes",
              value: function addShapes(shapes) {
                var old = this.getGeometry(shapes.getName());

                if (old != null) {
                  this.geometries.remove(old);
                }

                this.geometries.add(shapes);
              }
            }, {
              key: "clearShapes",
              value: function clearShapes() {
                this.geometries.clear();
                this.defaultShapes = null;
              }
              /**
              *
              * @return {*}
              */

            }, {
              key: "getGeometries",
              value: function getGeometries() {
                return this.geometries;
              }
              /*private*/

            }, {
              key: "getGeometry",
              value: function getGeometry(name) {
                for (var index569 = this.geometries.iterator(); index569.hasNext();) {
                  var shapes = index569.next();
                  {
                    if (
                    /* equals */
                    function (o1, o2) {
                      if (o1 && o1.equals) {
                        return o1.equals(o2);
                      } else {
                        return o1 === o2;
                      }
                    }(shapes.getName(), name)) {
                      return shapes;
                    }
                  }
                }

                return null;
              }
            }, {
              key: "setDefaultGeometry",
              value: function setDefaultGeometry(shapes) {
                this.defaultShapes = shapes;
                this.addShapes(shapes);
              }
              /**
              *
              * @return {*}
              */

            }, {
              key: "getDefaultGeometry",
              value: function getDefaultGeometry() {
                return this.defaultShapes;
              }
              /**
              *
              * @param {string} action
              * @return {*}
              */

            }, {
              key: "getLegacyCommand",
              value: function getLegacyCommand(action) {
                switch (action) {
                  case "octasymm":
                    {
                      var octaSymm = this.getSymmetry();

                      if (!(octaSymm != null && octaSymm instanceof com.vzome.core.math.symmetry.OctahedralSymmetry)) {
                        octaSymm = new com.vzome.core.math.symmetry.OctahedralSymmetry(octaSymm.getField());
                      }

                      return new com.vzome.core.commands.CommandSymmetry(octaSymm);
                    }

                  default:
                    return null;
                }
              }
              /**
              *
              * @param {com.vzome.core.math.symmetry.Direction} orbit
              * @return {boolean}
              */

            }, {
              key: "orbitIsStandard",
              value: function orbitIsStandard(orbit) {
                return orbit.isStandard();
              }
              /**
              *
              * @param {com.vzome.core.math.symmetry.Direction} orbit
              * @return {boolean}
              */

            }, {
              key: "orbitIsBuildDefault",
              value: function orbitIsBuildDefault(orbit) {
                var zone0 = orbit.getAxis$int$int(0, 0);
                return zone0.getRotationPermutation() != null;
              }
              /**
              *
              * @param {com.vzome.core.math.symmetry.Direction} orbit
              * @return {*}
              */

            }, {
              key: "getOrbitUnitLength",
              value: function getOrbitUnitLength(orbit) {
                return orbit.getUnitLength();
              }
            }]);

            return AbstractSymmetryPerspective;
          }();

          kinds.AbstractSymmetryPerspective = AbstractSymmetryPerspective;
          AbstractSymmetryPerspective["__class"] = "com.vzome.core.kinds.AbstractSymmetryPerspective";
          AbstractSymmetryPerspective["__interfaces"] = ["com.vzome.core.editor.FieldApplication.SymmetryPerspective"];
        })(core.kinds || (core.kinds = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (kinds) {
          var DefaultFieldApplication =
          /*#__PURE__*/
          function () {
            function DefaultFieldApplication(field) {
              _classCallCheck(this, DefaultFieldApplication);

              if (this.field === undefined) this.field = null;
              if (this.octahedralPerspective === undefined) this.octahedralPerspective = null;
              this.groups4d = new java.util.HashMap();
              this.pointsymm = new com.vzome.core.commands.CommandCentralSymmetry();
              this.mirrorsymm = new com.vzome.core.commands.CommandMirrorSymmetry();
              this.translate = new com.vzome.core.commands.CommandTranslate();
              this.centroid = new com.vzome.core.commands.CommandCentroid();
              this.hideball = new com.vzome.core.commands.CommandHide();
              this.hide = new com.vzome.core.commands.CommandHide();
              this.panel = new com.vzome.core.commands.CommandPolygon();
              this.midpoint = new com.vzome.core.commands.CommandMidpoint();
              this.field = field;
            }
            /**
            *
            * @return {string}
            */


            _createClass(DefaultFieldApplication, [{
              key: "getName",
              value: function getName() {
                return this.field.getName();
              }
              /**
              *
              * @return {*}
              */

            }, {
              key: "getField",
              value: function getField() {
                return this.field;
              }
              /**
              *
              * @return {*}
              */

            }, {
              key: "getDefaultSymmetryPerspective",
              value: function getDefaultSymmetryPerspective() {
                return this.getSymmetryPerspective("octahedral");
              }
              /**
              *
              * @return {*}
              */

            }, {
              key: "getSymmetryPerspectives",
              value: function getSymmetryPerspectives() {
                return java.util.Arrays.asList(this.getDefaultSymmetryPerspective());
              }
              /**
              *
              * @param {string} symmName
              * @return {*}
              */

            }, {
              key: "getSymmetryPerspective",
              value: function getSymmetryPerspective(symmName) {
                switch (symmName) {
                  case "octahedral":
                    if (this.octahedralPerspective == null) {
                      this.octahedralPerspective = new com.vzome.core.kinds.OctahedralSymmetryPerspective(this.field);
                    }

                    return this.octahedralPerspective;

                  default:
                    return null;
                }
              }
              /**
              *
              * @param {string} name
              * @return {com.vzome.core.math.symmetry.QuaternionicSymmetry}
              */

            }, {
              key: "getQuaternionSymmetry",
              value: function getQuaternionSymmetry(name) {
                return null;
              }
              /**
              *
              * @param {*} toolFactories
              * @param {com.vzome.core.editor.ToolsModel} tools
              */

            }, {
              key: "registerToolFactories",
              value: function registerToolFactories(toolFactories, tools) {
                toolFactories.put("SymmetryTool", new com.vzome.core.tools.OctahedralToolFactory(tools, null));
                toolFactories.put("RotationTool", new com.vzome.core.tools.RotationTool.__com_vzome_core_tools_RotationTool_Factory(tools, null));
                toolFactories.put("ScalingTool", new com.vzome.core.tools.ScalingTool.__com_vzome_core_tools_ScalingTool_Factory(tools, null));
                toolFactories.put("InversionTool", new com.vzome.core.tools.InversionTool.Factory(tools));
                toolFactories.put("MirrorTool", new com.vzome.core.tools.MirrorTool.Factory(tools));
                toolFactories.put("TranslationTool", new com.vzome.core.tools.TranslationTool.Factory(tools));
                toolFactories.put("ProjectionTool", new com.vzome.core.tools.ProjectionTool.Factory(tools));
                toolFactories.put("BookmarkTool", new com.vzome.core.tools.BookmarkTool.Factory(tools));
                toolFactories.put("LinearTransformTool", new com.vzome.core.tools.LinearMapTool.Factory(tools, null, false));
                toolFactories.put("LinearMapTool", new com.vzome.core.tools.LinearMapTool.Factory(tools, null, true));
                toolFactories.put("ModuleTool", new com.vzome.core.tools.ModuleTool.Factory(tools));
                toolFactories.put("PlaneSelectionTool", new com.vzome.core.tools.PlaneSelectionTool.Factory(tools));
              }
              /**
              *
              * @param {string} groupName
              * @param {number} index
              * @param {number} edgesToRender
              * @param {Array} edgeScales
              * @param {*} listener
              */

            }, {
              key: "constructPolytope",
              value: function constructPolytope(groupName, index, edgesToRender, edgeScales, listener) {
                var group = this.groups4d.get(groupName);

                if (group == null) {
                  switch (groupName) {
                    case "A4":
                      group = new com.vzome.core.math.symmetry.A4Group(this.field);
                      break;

                    case "D4":
                      group = new com.vzome.core.math.symmetry.D4Group(this.field);
                      break;

                    case "F4":
                      group = new com.vzome.core.math.symmetry.F4Group(this.field);
                      break;

                    default:
                      group = new com.vzome.core.math.symmetry.B4Group(this.field);
                      break;
                  }

                  this.groups4d.put(groupName, group);
                }

                com.vzome.core.math.symmetry.WythoffConstruction.constructPolytope(group, index, edgesToRender, edgeScales, group, listener);
              }
              /**
              *
              * @param {string} action
              * @return {*}
              */

            }, {
              key: "getLegacyCommand",
              value: function getLegacyCommand(action) {
                switch (action) {
                  case "pointsymm":
                    return this.pointsymm;

                  case "mirrorsymm":
                    return this.mirrorsymm;

                  case "translate":
                    return this.translate;

                  case "centroid":
                    return this.centroid;

                  case "hideball":
                    return this.hideball;

                  case "hide":
                    return this.hide;

                  case "panel":
                    return this.panel;

                  case "midpoint":
                    return this.midpoint;

                  case "octasymm":
                    return this.getDefaultSymmetryPerspective().getLegacyCommand(action);

                  default:
                    return null;
                }
              }
            }]);

            return DefaultFieldApplication;
          }();

          kinds.DefaultFieldApplication = DefaultFieldApplication;
          DefaultFieldApplication["__class"] = "com.vzome.core.kinds.DefaultFieldApplication";
          DefaultFieldApplication["__interfaces"] = ["com.vzome.core.math.symmetry.Symmetries4D", "com.vzome.core.editor.FieldApplication"];
        })(core.kinds || (core.kinds = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (render) {
          var Colors =
          /*#__PURE__*/
          function () {
            function Colors(props) {
              _classCallCheck(this, Colors);

              this.mColors = new java.util.TreeMap();
              this.mListeners = new java.util.ArrayList();
              if (this.properties === undefined) this.properties = null;
              this.mNextNewColor = 3221;
              this.STEP = 73;
              this.properties = props;
            }

            _createClass(Colors, [{
              key: "addColor",
              value: function addColor(name, color) {
                this.mColors.put(name, color);

                for (var index570 = this.mListeners.iterator(); index570.hasNext();) {
                  var next = index570.next();
                  {
                    next.colorAdded(name, color);
                  }
                }
              }
            }, {
              key: "setColor",
              value: function setColor(name, color) {
                this.mColors.put(name, color);

                for (var index571 = this.mListeners.iterator(); index571.hasNext();) {
                  var next = index571.next();
                  {
                    next.colorChanged(name, color);
                  }
                }
              }
            }, {
              key: "addListener",
              value: function addListener(changes) {
                this.mListeners.add(changes);
              }
            }, {
              key: "removeListener",
              value: function removeListener(changes) {
                this.mListeners.remove(changes);
              }
            }, {
              key: "getVectorPref",
              value: function getVectorPref(name) {
                var result = Colors.NO_VECTOR_$LI$();
                var pref = this.properties.getProperty(name);
                if (pref == null ||
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(pref, "")) return result;

                result =
                /* clone */
                function (o) {
                  if (o.clone != undefined) {
                    return o.clone();
                  } else {
                    var clone = Object.create(o);

                    for (var p in o) {
                      if (o.hasOwnProperty(p)) clone[p] = o[p];
                    }

                    return clone;
                  }
                }(result);

                var tokens = new java.util.StringTokenizer(pref, ", ");
                var i = 0;

                while (tokens.hasMoreTokens()) {
                  result[i++] = javaemul.internal.FloatHelper.parseFloat(tokens.nextToken());
                }

                return result;
              }
            }, {
              key: "getColorPref",
              value: function getColorPref(name) {
                var percents = this.getVectorPref("color.percent." + name);

                if (percents !== Colors.NO_VECTOR_$LI$()) {
                  return new com.vzome.core.construction.Color(Math.round(Math.fround(Math.fround(percents[0] * 255) / 100)), Math.round(Math.fround(Math.fround(percents[1] * 255) / 100)), Math.round(Math.fround(Math.fround(percents[2] * 255) / 100)));
                }

                var pref = this.properties.getProperty("color." + name);
                return Colors.parseColor(pref);
              }
            }, {
              key: "getColor",
              value: function getColor(name) {
                var color = this.mColors.get(name);

                if (color == null) {
                  if (
                  /* startsWith */
                  function (str, searchString) {
                    var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                    return str.substr(position, searchString.length) === searchString;
                  }(name, Colors.DIRECTION_$LI$())) {
                    var prefName = name.substring(Colors.DIRECTION_$LI$().length);
                    color = this.getColorPref(prefName);
                  } else if (
                  /* startsWith */
                  function (str, searchString) {
                    var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                    return str.substr(position, searchString.length) === searchString;
                  }(name, Colors.PLANE_$LI$())) {
                    var _prefName = name.substring(Colors.PLANE_$LI$().length);

                    color = this.getColorPref(_prefName);
                    color = color.getPastel();
                  } else if (
                  /* startsWith */
                  function (str, searchString) {
                    var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                    return str.substr(position, searchString.length) === searchString;
                  }(name, Colors.RGB_ORBIT) ||
                  /* startsWith */
                  function (str, searchString) {
                    var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                    return str.substr(position, searchString.length) === searchString;
                  }(name, Colors.RGB_CUSTOM)) {
                    var tokens = new java.util.StringTokenizer(name);
                    tokens.nextToken();
                    var r = javaemul.internal.IntegerHelper.parseInt(tokens.nextToken());
                    var g = javaemul.internal.IntegerHelper.parseInt(tokens.nextToken());
                    var b = javaemul.internal.IntegerHelper.parseInt(tokens.nextToken());
                    color = new com.vzome.core.construction.Color(r, g, b);
                  } else if (
                  /* equals */
                  function (o1, o2) {
                    if (o1 && o1.equals) {
                      return o1.equals(o2);
                    } else {
                      return o1 === o2;
                    }
                  }(name, Colors.CONNECTOR_$LI$())) color = this.getColorPref("white");else if (
                  /* equals */
                  function (o1, o2) {
                    if (o1 && o1.equals) {
                      return o1.equals(o2);
                    } else {
                      return o1 === o2;
                    }
                  }(name, Colors.HIGHLIGHT_$LI$())) color = this.getColorPref("highlight");else if (
                  /* equals */
                  function (o1, o2) {
                    if (o1 && o1.equals) {
                      return o1.equals(o2);
                    } else {
                      return o1 === o2;
                    }
                  }(name, Colors.HIGHLIGHT_MAC_$LI$())) color = this.getColorPref("highlight.mac");else if (
                  /* equals */
                  function (o1, o2) {
                    if (o1 && o1.equals) {
                      return o1.equals(o2);
                    } else {
                      return o1 === o2;
                    }
                  }(name, Colors.PANEL_$LI$())) color = this.getColorPref("panels");else if (
                  /* equals */
                  function (o1, o2) {
                    if (o1 && o1.equals) {
                      return o1.equals(o2);
                    } else {
                      return o1 === o2;
                    }
                  }(name, Colors.BACKGROUND_$LI$())) color = this.getColorPref("background");

                  if (color == null) {
                    this.mNextNewColor = (this.mNextNewColor + this.STEP) % 4096;
                    var i = this.mNextNewColor;

                    var _r = 135 + (i % 16 << 3);

                    i = i >> 4;

                    var _g = 135 + (i % 16 << 3);

                    i = i >> 4;

                    var _b = 135 + (i % 16 << 3);

                    i = i >> 4;
                    color = new com.vzome.core.construction.Color(_r, _g, _b);
                  }

                  this.addColor(name, color);
                }

                return color;
              }
              /**
              *
              * @return {*}
              */

            }, {
              key: "iterator",
              value: function iterator() {
                return this.mColors.keySet().iterator();
              }
              /**
              * @deprecated Consider using a JDK-5 for-loop if possible. Otherwise use {@link #iterator()} instead.
              * @return {*}
              */

            }, {
              key: "getColorNames",
              value: function getColorNames() {
                return this.iterator();
              }
            }, {
              key: "reset",
              value: function reset() {}
            }], [{
              key: "BACKGROUND_$LI$",
              value: function BACKGROUND_$LI$() {
                if (Colors.BACKGROUND == null) Colors.BACKGROUND = Colors.PREFIX + "background";
                return Colors.BACKGROUND;
              }
            }, {
              key: "PANEL_$LI$",
              value: function PANEL_$LI$() {
                if (Colors.PANEL == null) Colors.PANEL = Colors.PREFIX + "panel";
                return Colors.PANEL;
              }
            }, {
              key: "HIGHLIGHT_$LI$",
              value: function HIGHLIGHT_$LI$() {
                if (Colors.HIGHLIGHT == null) Colors.HIGHLIGHT = Colors.PREFIX + "highlight";
                return Colors.HIGHLIGHT;
              }
            }, {
              key: "HIGHLIGHT_MAC_$LI$",
              value: function HIGHLIGHT_MAC_$LI$() {
                if (Colors.HIGHLIGHT_MAC == null) Colors.HIGHLIGHT_MAC = Colors.HIGHLIGHT_$LI$() + ".mac";
                return Colors.HIGHLIGHT_MAC;
              }
            }, {
              key: "CONNECTOR_$LI$",
              value: function CONNECTOR_$LI$() {
                if (Colors.CONNECTOR == null) Colors.CONNECTOR = Colors.PREFIX + "connector";
                return Colors.CONNECTOR;
              }
            }, {
              key: "DIRECTION_$LI$",
              value: function DIRECTION_$LI$() {
                if (Colors.DIRECTION == null) Colors.DIRECTION = Colors.PREFIX + "direction.";
                return Colors.DIRECTION;
              }
            }, {
              key: "PLANE_$LI$",
              value: function PLANE_$LI$() {
                if (Colors.PLANE == null) Colors.PLANE = Colors.DIRECTION_$LI$() + "plane.";
                return Colors.PLANE;
              }
            }, {
              key: "NO_VECTOR_$LI$",
              value: function NO_VECTOR_$LI$() {
                if (Colors.NO_VECTOR == null) Colors.NO_VECTOR = [0.0, 0.0, 0.0];
                return Colors.NO_VECTOR;
              }
            }, {
              key: "parseColor",
              value: function parseColor(colorString) {
                if (colorString == null ||
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(colorString, "")) return com.vzome.core.construction.Color.WHITE_$LI$();
                var tokens = new java.util.StringTokenizer(colorString, ", ");
                var rgb = [0, 0, 0];
                var i = 0;

                while (tokens.hasMoreTokens()) {
                  rgb[i++] = javaemul.internal.IntegerHelper.parseInt(tokens.nextToken());
                }

                return new com.vzome.core.construction.Color(rgb[0], rgb[1], rgb[2]);
              }
            }, {
              key: "getColorName",
              value: function getColorName(color) {
                return Colors.RGB_ORBIT + " " + color.getRed() + " " + color.getGreen() + " " + color.getBlue();
              }
            }]);

            return Colors;
          }();

          Colors.RGB_CUSTOM = "rgb.custom";
          Colors.RGB_ORBIT = "rgb.orbit";
          Colors.PREFIX = "";
          render.Colors = Colors;
          Colors["__class"] = "com.vzome.core.render.Colors";
          Colors["__interfaces"] = ["java.lang.Iterable"];
        })(core.render || (core.render = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (render) {
          /**
          * @author Scott Vorthmann
          * @param {*} m
          * @param {*} orbitSource
          * @class
          */
          var RenderedManifestation =
          /*#__PURE__*/
          function () {
            function RenderedManifestation(m, orbitSource) {
              _classCallCheck(this, RenderedManifestation);

              if (this.mManifestation === undefined) this.mManifestation = null;
              if (this.mShape === undefined) this.mShape = null;
              this.color = null;
              if (this.mOrientation === undefined) this.mOrientation = null;
              this.mGlow = 0.0;
              this.mTransparency = 0.0;
              if (this.mGraphicsObject === undefined) this.mGraphicsObject = null;
              this.mPickable = true;
              this.isOffset = false;
              if (this.location === undefined) this.location = null;
              if (this.fixedLocation === undefined) this.fixedLocation = null;
              this.strutZone = -1;
              this.strutLength = null;
              this.strutOrbit = null;
              if (this.strutSense === undefined) this.strutSense = 0;
              this.guid = java.util.UUID.randomUUID();
              if (this.orbitSource === undefined) this.orbitSource = null;
              this.mManifestation = m;
              this.orbitSource = orbitSource;
              if (m != null) this.location = m.getLocation();
              this.fixedLocation = this.location;
              this.mOrientation = null;
            }

            _createClass(RenderedManifestation, [{
              key: "toString",

              /**
              *
              * @return {string}
              */
              value: function toString() {
                return this.mManifestation.toString();
              }
            }, {
              key: "getGuid",
              value: function getGuid() {
                return this.guid;
              }
            }, {
              key: "setGraphicsObject",
              value: function setGraphicsObject(go) {
                this.mGraphicsObject = go;
              }
            }, {
              key: "getGraphicsObject",
              value: function getGraphicsObject() {
                return this.mGraphicsObject;
              }
            }, {
              key: "setGlow",
              value: function setGlow(glow) {
                this.mGlow = glow;
              }
            }, {
              key: "getGlow",
              value: function getGlow() {
                return this.mGlow;
              }
            }, {
              key: "setTransparency",
              value: function setTransparency(trans) {
                this.mTransparency = trans;
              }
            }, {
              key: "getTransparency",
              value: function getTransparency() {
                return this.mTransparency;
              }
            }, {
              key: "getShapeId",
              value: function getShapeId() {
                return this.mShape.getGuid();
              }
            }, {
              key: "getShape",
              value: function getShape() {
                return this.mShape;
              }
            }, {
              key: "setPickable",
              value: function setPickable(value) {
                this.mPickable = value;
              }
            }, {
              key: "isPickable",
              value: function isPickable() {
                return this.mPickable;
              }
            }, {
              key: "getManifestation",
              value: function getManifestation() {
                return this.mManifestation;
              }
            }, {
              key: "getColor",
              value: function getColor() {
                return this.color;
              }
            }, {
              key: "getColorWeb",
              value: function getColorWeb() {
                return this.color.toWebString();
              }
            }, {
              key: "setColor",
              value: function setColor(color) {
                this.color = color;
              }
            }, {
              key: "setOrientation",
              value: function setOrientation(m) {
                this.mOrientation = m;
              }
            }, {
              key: "getOrientation",
              value: function getOrientation() {
                return this.mOrientation;
              }
            }, {
              key: "getLocation",
              value: function getLocation() {
                if (this.location != null) return this.getEmbedding().embedInR3(this.location);else return new com.vzome.core.math.RealVector(0.0, 0.0, 0.0);
              }
            }, {
              key: "getLocationAV",
              value: function getLocationAV() {
                return this.location;
              }
            }, {
              key: "getEmbedding",
              value: function getEmbedding() {
                return this.orbitSource.getSymmetry();
              }
              /**
              *
              * @return {number}
              */

            }, {
              key: "hashCode",
              value: function hashCode() {
                return (
                  /* hashCode */
                  function (o) {
                    if (o.hashCode) {
                      return o.hashCode();
                    } else {
                      return o.toString().split('').reduce(function (prevHash, currVal) {
                        return (prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0;
                      }, 0);
                    }
                  }(this.guid)
                );
              }
              /**
              *
              * @param {*} obj
              * @return {boolean}
              */

            }, {
              key: "equals",
              value: function equals(obj) {
                if (this === obj) {
                  return true;
                }

                if (obj == null) {
                  return false;
                }

                if (this.constructor !== obj.constructor) {
                  return false;
                }

                var other = obj;

                if (this.fixedLocation == null) {
                  if (other.fixedLocation != null) {
                    return false;
                  }
                } else if (!this.fixedLocation.equals(other.fixedLocation)) {
                  return false;
                }

                if (this.isOffset !== other.isOffset) {
                  return false;
                }

                if (this.mOrientation == null) {
                  if (other.mOrientation != null) {
                    return false;
                  }
                } else if (!this.mOrientation.equals(other.mOrientation)) {
                  return false;
                }

                if (this.mShape == null) {
                  if (other.mShape != null) {
                    return false;
                  }
                } else if (!this.mShape.equals(other.mShape)) {
                  return false;
                }

                if (this.strutSense !== other.strutSense) {
                  return false;
                }

                return true;
              }
            }, {
              key: "copy",
              value: function copy() {
                var copy = new RenderedManifestation(null, this.orbitSource);
                copy.location = this.location;
                copy.fixedLocation = this.fixedLocation;
                copy.color = this.color;
                copy.mGlow = this.mGlow;
                copy.mOrientation = this.mOrientation;
                copy.mShape = this.mShape;
                copy.mTransparency = this.mTransparency;
                copy.strutLength = this.strutLength;
                copy.strutZone = this.strutZone;
                return copy;
              }
            }, {
              key: "setStrut",
              value: function setStrut(orbit, zone, sense, length) {
                this.strutOrbit = orbit;
                this.strutZone = zone;
                this.strutSense = sense;
                this.strutLength = length;
              }
            }, {
              key: "getStrutZone",
              value: function getStrutZone() {
                return this.strutZone;
              }
            }, {
              key: "getStrutSense",
              value: function getStrutSense() {
                return this.strutSense;
              }
            }, {
              key: "getStrutLength",
              value: function getStrutLength() {
                return this.strutLength;
              }
            }, {
              key: "getStrutOrbit",
              value: function getStrutOrbit() {
                return this.strutOrbit;
              }
            }, {
              key: "offsetLocation",
              value: function offsetLocation() {
                if (this.mManifestation != null) {
                  var strut = this.mManifestation;
                  this.location = strut.getEnd();
                  this.isOffset = true;
                }
              }
            }, {
              key: "resetLocation",
              value: function resetLocation() {
                if (this.mManifestation != null) {
                  this.location = this.mManifestation.getLocation();
                  this.isOffset = false;
                }
              }
            }, {
              key: "getSymmetryShapes",
              value: function getSymmetryShapes() {
                return this.orbitSource.getName() + ":" + this.orbitSource.getShapes().getName();
              }
            }, {
              key: "resetAttributes",
              value: function resetAttributes(oneSidedPanels, colorPanels) {
                if (this.mManifestation != null && (this.mManifestation["__interfaces"] != null && this.mManifestation["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0 || this.mManifestation.constructor != null && this.mManifestation.constructor["__interfaces"] != null && this.mManifestation.constructor["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0)) {
                  this.resetPanelAttributes(oneSidedPanels, colorPanels);
                } else if (this.orbitSource.getShapes() == null) {
                  return;
                } else if (this.mManifestation != null && (this.mManifestation["__interfaces"] != null && this.mManifestation["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || this.mManifestation.constructor != null && this.mManifestation.constructor["__interfaces"] != null && this.mManifestation.constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0)) {
                  this.resetConnectorAttributes(this.mManifestation);
                } else if (this.mManifestation != null && (this.mManifestation["__interfaces"] != null && this.mManifestation["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || this.mManifestation.constructor != null && this.mManifestation.constructor["__interfaces"] != null && this.mManifestation.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0)) {
                  var strut = this.mManifestation;
                  this.resetStrutAttributes(strut);
                } else throw new java.lang.UnsupportedOperationException("only strut, ball, and panel shapes currently supported");
              }
              /*private*/

            }, {
              key: "resetPanelAttributes",
              value: function resetPanelAttributes(oneSidedPanels, colorPanels) {
                var panel = this.mManifestation;
                var shape = RenderedManifestation.makePanelPolyhedron(panel, oneSidedPanels);
                if (shape == null) return;
                var normal = panel['getNormal$']();
                if (normal.isOrigin()) return;
                this.mShape = shape;
                if (!colorPanels) return;
                this.setOrientation(this.orbitSource.getSymmetry().getField().identityMatrix(3));

                try {
                  var axis = this.orbitSource.getAxis(normal);

                  if (axis == null) {
                    this.setColor(com.vzome.core.construction.Color.WHITE_$LI$());
                    return;
                  }

                  panel.setZoneVector(axis.normal());
                  var orbit = axis.getDirection();
                  var color = this.mManifestation.getColor();

                  if (color == null) {
                    color = this.orbitSource.getColor(orbit);
                    if (color != null) color = color.getPastel();
                  }

                  this.setColor(color);
                } catch (e) {
                  if (RenderedManifestation.logger_$LI$().isLoggable(java.util.logging.Level.WARNING)) RenderedManifestation.logger_$LI$().warning("Unable to set color for panel, normal = " + normal.toString());
                }
              }
            }, {
              key: "resetStrutAttributes",
              value: function resetStrutAttributes(strut) {
                var shapes = this.orbitSource.getShapes();
                var offset = strut.getOffset();
                if (offset.isOrigin()) return;
                var axis = this.orbitSource.getAxis(offset);
                if (axis == null) return;
                strut.setZoneVector(axis.normal());
                var orbit = axis.getDirection();
                var len = axis.getLength(offset);
                var prototypeLengthShape = shapes.getStrutShape(orbit, len);
                this.mShape = prototypeLengthShape;
                var orn = axis.getOrientation();
                var orientation = shapes.getSymmetry().getMatrix(orn);
                var reflection = this.orbitSource.getSymmetry().getPrincipalReflection();

                if (reflection != null) {
                  if (RenderedManifestation.logger_$LI$().isLoggable(java.util.logging.Level.FINE)) {
                    RenderedManifestation.logger_$LI$().fine("rendering " + offset + " as " + axis);
                  }

                  if (axis.getSense() === com.vzome.core.math.symmetry.Axis.MINUS) {
                    if (RenderedManifestation.logger_$LI$().isLoggable(java.util.logging.Level.FINER)) {
                      RenderedManifestation.logger_$LI$().finer("mirroring orientation " + orn);
                    }

                    this.mShape = prototypeLengthShape.getEvilTwin(reflection);
                  }

                  if (!axis.isOutbound()) {
                    this.offsetLocation();
                  } else this.resetLocation();
                } else {
                  if (axis.getSense() === com.vzome.core.math.symmetry.Axis.MINUS) {
                    this.offsetLocation();
                  } else this.resetLocation();
                }

                this.setStrut(orbit, orn, axis.getSense(), len);
                this.setOrientation(orientation);
                var color = this.getManifestation().getColor();
                if (color == null) color = shapes.getColor(orbit);
                if (color == null) color = this.orbitSource.getColor(orbit);
                this.setColor(color);
              }
            }, {
              key: "resetConnectorAttributes",
              value: function resetConnectorAttributes(m) {
                var shapes = this.orbitSource.getShapes();
                this.mShape = shapes.getConnectorShape();
                var color = this.getManifestation().getColor();
                if (color == null) color = shapes.getColor(null);
                if (color == null) color = this.orbitSource.getColor(null);
                this.setColor(color);
                this.setOrientation(this.orbitSource.getSymmetry().getField().identityMatrix(3));
              }
              /*private*/

            }, {
              key: "setOrbitSource",
              value: function setOrbitSource(orbitSource) {
                this.orbitSource = orbitSource;
              }
            }, {
              key: "getOrbitSource",
              value: function getOrbitSource() {
                return this.orbitSource;
              }
            }], [{
              key: "logger_$LI$",
              value: function logger_$LI$() {
                if (RenderedManifestation.logger == null) RenderedManifestation.logger = java.util.logging.Logger.getLogger("com.vzome.core.render.RenderedManifestation");
                return RenderedManifestation.logger;
              }
            }, {
              key: "makePanelPolyhedron",
              value: function makePanelPolyhedron(panel, oneSided) {
                var poly = new com.vzome.core.math.Polyhedron(panel.getZoneVector().getField());
                poly.setPanel(true);
                var arity = 0;

                for (var index572 = panel.iterator(); index572.hasNext();) {
                  var gv = index572.next();
                  {
                    arity++;
                    poly.addVertex(gv);
                  }
                }

                if (poly.getVertexList().size() < arity) return null;
                var front = poly.newFace();
                var back = poly.newFace();

                for (var i = 0; i < arity; i++) {
                  {
                    var j = i;
                    front.add(j);
                    back.add(0, j);
                  }
                }

                poly.addFace(front);
                if (!oneSided) poly.addFace(back);
                return poly;
              }
            }]);

            return RenderedManifestation;
          }();

          render.RenderedManifestation = RenderedManifestation;
          RenderedManifestation["__class"] = "com.vzome.core.render.RenderedManifestation";
          RenderedManifestation["__interfaces"] = ["com.vzome.core.model.RenderedObject"];
        })(core.render || (core.render = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (viewing) {
          var AbstractShapes =
          /*#__PURE__*/
          function () {
            function AbstractShapes(pkgName, name, alias, symm) {
              _classCallCheck(this, AbstractShapes);

              this.strutShapesByLengthAndOrbit = new java.util.HashMap();
              this.strutGeometriesByOrbit = new java.util.HashMap();
              if (this.mPkgName === undefined) this.mPkgName = null;
              if (this.mName === undefined) this.mName = null;
              if (this.alias === undefined) this.alias = null;
              if (this.mSymmetry === undefined) this.mSymmetry = null;
              if (this.mConnectorGeometry === undefined) this.mConnectorGeometry = null;
              this.mPkgName = pkgName;
              this.mName = name;
              this.alias = alias;
              this.mConnectorGeometry = null;
              this.mSymmetry = symm;
            }
            /**
            *
            * @param {com.vzome.core.math.symmetry.Direction} dir
            * @return {com.vzome.core.construction.Color}
            */


            _createClass(AbstractShapes, [{
              key: "getColor",
              value: function getColor(dir) {
                return null;
              }
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "hasColors",
              value: function hasColors() {
                return false;
              }
            }, {
              key: "createStrutGeometry",
              value: function createStrutGeometry(dir) {
                return new com.vzome.core.parts.FastDefaultStrutGeometry(dir);
              }
              /*private*/

            }, {
              key: "getStrutGeometry",
              value: function getStrutGeometry(orbit) {
                var orbitStrutGeometry = this.strutGeometriesByOrbit.get(orbit);

                if (orbitStrutGeometry == null) {
                  orbitStrutGeometry = this.createStrutGeometry(orbit);
                  this.strutGeometriesByOrbit.put(orbit, orbitStrutGeometry);
                }

                return orbitStrutGeometry;
              }
            }, {
              key: "getStrutGeometries",
              value: function getStrutGeometries() {
                var _this = this;

                return java.util.Arrays.stream(this.mSymmetry.getDirectionNames()).collect(java.util.stream.Collectors.toMap(function (x) {
                  return x;
                }, function (name) {
                  return _this.getStrutGeometry(_this.mSymmetry.getDirection(name));
                }));
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getName",
              value: function getName() {
                return this.mName;
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getAlias",
              value: function getAlias() {
                return this.alias;
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getPackage",
              value: function getPackage() {
                return this.mPkgName;
              }
              /**
              *
              * @return {com.vzome.core.math.Polyhedron}
              */

            }, {
              key: "getConnectorShape",
              value: function getConnectorShape() {
                if (this.mConnectorGeometry == null) {
                  this.mConnectorGeometry = this.buildConnectorShape(this.mPkgName);
                  this.mConnectorGeometry.setName("ball");
                }

                return this.mConnectorGeometry;
              }
              /**
              *
              * @param {com.vzome.core.math.symmetry.Direction} orbit
              * @param {*} length
              * @return {com.vzome.core.math.Polyhedron}
              */

            }, {
              key: "getStrutShape",
              value: function getStrutShape(orbit, length) {
                var strutShapesByLength = this.strutShapesByLengthAndOrbit.get(orbit);

                if (strutShapesByLength == null) {
                  strutShapesByLength = new java.util.HashMap();
                  this.strutShapesByLengthAndOrbit.put(orbit, strutShapesByLength);
                }

                var lengthShape = strutShapesByLength.get(length);

                if (lengthShape == null) {
                  var orbitStrutGeometry = this.getStrutGeometry(orbit);
                  lengthShape = orbitStrutGeometry.getStrutPolyhedron(length);
                  strutShapesByLength.put(length, lengthShape);

                  if (lengthShape != null) {
                    lengthShape.setName(orbit.getName() + strutShapesByLength.size());
                    lengthShape.setOrbit(orbit);
                    lengthShape.setLength(orbit.getLengthInUnits(length));
                  }
                }

                return lengthShape;
              }
              /**
              *
              * @return {*}
              */

            }, {
              key: "getSymmetry",
              value: function getSymmetry() {
                return this.mSymmetry;
              }
            }]);

            return AbstractShapes;
          }();

          viewing.AbstractShapes = AbstractShapes;
          AbstractShapes["__class"] = "com.vzome.core.viewing.AbstractShapes";
          AbstractShapes["__interfaces"] = ["com.vzome.core.editor.api.Shapes"];
        })(core.viewing || (core.viewing = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (viewing) {
          var ExportedVEFStrutGeometry =
          /*#__PURE__*/
          function () {
            function ExportedVEFStrutGeometry(vertices, faces, prototype, fullScaleVertices, halfScaleVertices, field) {
              var _this2 = this;

              _classCallCheck(this, ExportedVEFStrutGeometry);

              if ((vertices != null && (vertices["__interfaces"] != null && vertices["__interfaces"].indexOf("java.util.List") >= 0 || vertices.constructor != null && vertices.constructor["__interfaces"] != null && vertices.constructor["__interfaces"].indexOf("java.util.List") >= 0) || vertices === null) && (faces != null && (faces["__interfaces"] != null && faces["__interfaces"].indexOf("java.util.List") >= 0 || faces.constructor != null && faces.constructor["__interfaces"] != null && faces.constructor["__interfaces"].indexOf("java.util.List") >= 0) || faces === null) && (prototype != null && prototype instanceof com.vzome.core.algebra.AlgebraicVector || prototype === null) && (fullScaleVertices != null && (fullScaleVertices["__interfaces"] != null && fullScaleVertices["__interfaces"].indexOf("java.util.Set") >= 0 || fullScaleVertices.constructor != null && fullScaleVertices.constructor["__interfaces"] != null && fullScaleVertices.constructor["__interfaces"].indexOf("java.util.Set") >= 0) || fullScaleVertices === null) && (halfScaleVertices != null && (halfScaleVertices["__interfaces"] != null && halfScaleVertices["__interfaces"].indexOf("java.util.Set") >= 0 || halfScaleVertices.constructor != null && halfScaleVertices.constructor["__interfaces"] != null && halfScaleVertices.constructor["__interfaces"].indexOf("java.util.Set") >= 0) || halfScaleVertices === null) && (field != null && (field["__interfaces"] != null && field["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicField") >= 0 || field.constructor != null && field.constructor["__interfaces"] != null && field.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicField") >= 0) || field === null)) {
                if (this.prototypeVertices === undefined) this.prototypeVertices = null;
                if (this.prototypeFaces === undefined) this.prototypeFaces = null;
                if (this.field === undefined) this.field = null;
                if (this.prototypeVector === undefined) this.prototypeVector = null;
                if (this.fullScaleVertices === undefined) this.fullScaleVertices = null;
                if (this.halfScaleVertices === undefined) this.halfScaleVertices = null;
                if (this.prototypeVertices === undefined) this.prototypeVertices = null;
                if (this.prototypeFaces === undefined) this.prototypeFaces = null;
                if (this.field === undefined) this.field = null;
                if (this.prototypeVector === undefined) this.prototypeVector = null;
                if (this.fullScaleVertices === undefined) this.fullScaleVertices = null;
                if (this.halfScaleVertices === undefined) this.halfScaleVertices = null;

                (function () {
                  _this2.prototypeVertices = vertices;
                  _this2.prototypeFaces = faces;
                  _this2.prototypeVector = prototype;
                  _this2.fullScaleVertices = fullScaleVertices;
                  _this2.halfScaleVertices = halfScaleVertices;
                  _this2.field = field;
                })();
              } else if ((vertices != null && (vertices["__interfaces"] != null && vertices["__interfaces"].indexOf("java.util.List") >= 0 || vertices.constructor != null && vertices.constructor["__interfaces"] != null && vertices.constructor["__interfaces"].indexOf("java.util.List") >= 0) || vertices === null) && (faces != null && (faces["__interfaces"] != null && faces["__interfaces"].indexOf("java.util.List") >= 0 || faces.constructor != null && faces.constructor["__interfaces"] != null && faces.constructor["__interfaces"].indexOf("java.util.List") >= 0) || faces === null) && (prototype != null && prototype instanceof com.vzome.core.algebra.AlgebraicVector || prototype === null) && (fullScaleVertices != null && (fullScaleVertices["__interfaces"] != null && fullScaleVertices["__interfaces"].indexOf("java.util.Set") >= 0 || fullScaleVertices.constructor != null && fullScaleVertices.constructor["__interfaces"] != null && fullScaleVertices.constructor["__interfaces"].indexOf("java.util.Set") >= 0) || fullScaleVertices === null) && (halfScaleVertices != null && (halfScaleVertices["__interfaces"] != null && halfScaleVertices["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicField") >= 0 || halfScaleVertices.constructor != null && halfScaleVertices.constructor["__interfaces"] != null && halfScaleVertices.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicField") >= 0) || halfScaleVertices === null) && field === undefined) {
                var _args = arguments;
                var _field = _args[4];
                {
                  var _halfScaleVertices = null;
                  if (this.prototypeVertices === undefined) this.prototypeVertices = null;
                  if (this.prototypeFaces === undefined) this.prototypeFaces = null;
                  if (this.field === undefined) this.field = null;
                  if (this.prototypeVector === undefined) this.prototypeVector = null;
                  if (this.fullScaleVertices === undefined) this.fullScaleVertices = null;
                  if (this.halfScaleVertices === undefined) this.halfScaleVertices = null;
                  if (this.prototypeVertices === undefined) this.prototypeVertices = null;
                  if (this.prototypeFaces === undefined) this.prototypeFaces = null;
                  if (this.field === undefined) this.field = null;
                  if (this.prototypeVector === undefined) this.prototypeVector = null;
                  if (this.fullScaleVertices === undefined) this.fullScaleVertices = null;
                  if (this.halfScaleVertices === undefined) this.halfScaleVertices = null;

                  (function () {
                    _this2.prototypeVertices = vertices;
                    _this2.prototypeFaces = faces;
                    _this2.prototypeVector = prototype;
                    _this2.fullScaleVertices = fullScaleVertices;
                    _this2.halfScaleVertices = _halfScaleVertices;
                    _this2.field = _field;
                  })();
                }
              } else throw new Error('invalid overload');
            }

            _createClass(ExportedVEFStrutGeometry, [{
              key: "getStrutPolyhedron",

              /**
              *
              * @param {*} length
              * @return {com.vzome.core.math.Polyhedron}
              */
              value: function getStrutPolyhedron(length) {
                var tipVertex = this.prototypeVector.scale(length);
                var midpoint = tipVertex.scale(this.field['createRational$long$long'](1, 2));

                if (
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(this.field.getName(), "snubDodec") && ExportedVEFStrutGeometry.LOGGER_$LI$().isLoggable(java.util.logging.Level.FINE)) {
                  ExportedVEFStrutGeometry.LOGGER_$LI$().fine("proto length = " + this.prototypeVector.toRealVector().length());
                  ExportedVEFStrutGeometry.LOGGER_$LI$().fine("strut length = " + length.evaluate());
                  ExportedVEFStrutGeometry.LOGGER_$LI$().fine("tip length = " + tipVertex.toRealVector().length());
                }

                var result = new com.vzome.core.math.Polyhedron(this.field);

                for (var i = 0; i < this.prototypeVertices.size(); i++) {
                  {
                    var vertex = this.prototypeVertices.get(i);

                    if (this.fullScaleVertices.contains(i)) {
                      vertex = vertex.plus(tipVertex);
                    } else if (this.halfScaleVertices != null && this.halfScaleVertices.contains(i)) {
                      vertex = vertex.plus(midpoint);
                    }

                    result.addVertex(vertex);
                  }
                }

                for (var index573 = this.prototypeFaces.iterator(); index573.hasNext();) {
                  var prototypeFace = index573.next();
                  {
                    var face = result.newFace();
                    face.addAll(prototypeFace);
                    result.addFace(face);
                  }
                }

                return result;
              }
            }], [{
              key: "LOGGER_$LI$",
              value: function LOGGER_$LI$() {
                if (ExportedVEFStrutGeometry.LOGGER == null) ExportedVEFStrutGeometry.LOGGER = java.util.logging.Logger.getLogger("com.vzome.core.viewing.ExportedVEFStrutGeometry");
                return ExportedVEFStrutGeometry.LOGGER;
              }
            }]);

            return ExportedVEFStrutGeometry;
          }();

          viewing.ExportedVEFStrutGeometry = ExportedVEFStrutGeometry;
          ExportedVEFStrutGeometry["__class"] = "com.vzome.core.viewing.ExportedVEFStrutGeometry";
          ExportedVEFStrutGeometry["__interfaces"] = ["com.vzome.core.parts.StrutGeometry"];
        })(core.viewing || (core.viewing = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (math) {
          /**
          * @author David Hall
          * @param {*} field
          * @class
          */
          var TetrahedralProjection =
          /*#__PURE__*/
          function () {
            function TetrahedralProjection(field) {
              _classCallCheck(this, TetrahedralProjection);

              if (this.field === undefined) this.field = null;
              if (this.basis === undefined) this.basis = null;
              this.field = field;
              var pos = field.one();
              var neg = pos.negate();
              this.basis = [null, null, null, null];
              this.basis[0] = new com.vzome.core.algebra.AlgebraicVector(pos, pos, pos);
              this.basis[1] = new com.vzome.core.algebra.AlgebraicVector(pos, neg, neg);
              this.basis[2] = new com.vzome.core.algebra.AlgebraicVector(neg, pos, neg);
              this.basis[3] = new com.vzome.core.algebra.AlgebraicVector(neg, neg, pos);
            }
            /**
            *
            * @param {com.vzome.core.algebra.AlgebraicVector} source
            * @param {boolean} wFirst
            * @return {com.vzome.core.algebra.AlgebraicVector}
            */


            _createClass(TetrahedralProjection, [{
              key: "projectImage",
              value: function projectImage(source, wFirst) {
                var result = this.field.origin(this.basis[0].dimension());
                var pos = wFirst ? 0 : this.basis.length - 1;

                for (var index574 = 0; index574 < this.basis.length; index574++) {
                  var unitVector = this.basis[index574];
                  {
                    var scalar = source.getComponent(pos);
                    result = result.plus(unitVector.scale(scalar));
                    pos = (pos + 1) % this.basis.length;
                  }
                }

                return result;
              }
              /**
              *
              * @param {*} element
              */

            }, {
              key: "getXmlAttributes",
              value: function getXmlAttributes(element) {}
              /**
              *
              * @param {*} xml
              */

            }, {
              key: "setXmlAttributes",
              value: function setXmlAttributes(xml) {}
              /**
              *
              * @return {string}
              */

            }, {
              key: "getProjectionName",
              value: function getProjectionName() {
                return "Tetrahedral";
              }
            }]);

            return TetrahedralProjection;
          }();

          math.TetrahedralProjection = TetrahedralProjection;
          TetrahedralProjection["__class"] = "com.vzome.core.math.TetrahedralProjection";
          TetrahedralProjection["__interfaces"] = ["com.vzome.core.math.Projection"];
        })(core.math || (core.math = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (math) {
          var Polyhedron =
          /*#__PURE__*/
          function () {
            function Polyhedron(field) {
              _classCallCheck(this, Polyhedron);

              this.numVertices = 0;
              this.m_vertices = new java.util.HashMap();
              this.m_vertexList = new java.util.ArrayList();
              this.m_faces = new java.util.HashSet();
              if (this.field === undefined) this.field = null;
              if (this.evilTwin === undefined) this.evilTwin = null;
              this.isEvil = false;
              this.__isPanel = false;
              this.guid = java.util.UUID.randomUUID();
              if (this.name === undefined) this.name = null;
              if (this.orbit === undefined) this.orbit = null;
              if (this.length === undefined) this.length = null;
              this.field = field;
            }

            _createClass(Polyhedron, [{
              key: "getEvilTwin",

              /**
              * Get the mirror twin of this Polyhedron.
              * The vertices are transformed by the given reflection.
              * The faces are oriented in reverse, so that when oriented with
              * a mirroring transformation, the face normals will still point
              * outward.
              * @return
              * @param {com.vzome.core.algebra.AlgebraicMatrix} reflection
              * @return {com.vzome.core.math.Polyhedron}
              */
              value: function getEvilTwin(reflection) {
                if (this.evilTwin == null) {
                  try {
                    this.evilTwin = function (o) {
                      if (o.clone != undefined) {
                        return o.clone();
                      } else {
                        var clone = Object.create(o);

                        for (var p in o) {
                          if (o.hasOwnProperty(p)) clone[p] = o[p];
                        }

                        return clone;
                      }
                    }(this);
                  } catch (e) {
                    console.error(e.message, e);
                  }

                  this.evilTwin.isEvil = true;
                  this.evilTwin.m_vertexList = new java.util.ArrayList();

                  for (var index575 = this.m_vertexList.iterator(); index575.hasNext();) {
                    var vertex = index575.next();
                    {
                      this.evilTwin.addVertex(reflection.timesColumn(vertex));
                    }
                  }

                  this.evilTwin.m_faces = new java.util.HashSet();

                  for (var index576 = this.m_faces.iterator(); index576.hasNext();) {
                    var face = index576.next();
                    {
                      var mirrorFace = function (o) {
                        if (o.clone != undefined) {
                          return o.clone();
                        } else {
                          var clone = Object.create(o);

                          for (var p in o) {
                            if (o.hasOwnProperty(p)) clone[p] = o[p];
                          }

                          return clone;
                        }
                      }(face);

                      java.util.Collections.reverse(mirrorFace);
                      this.evilTwin.addFace(mirrorFace);
                    }
                  }
                }

                return this.evilTwin;
              }
            }, {
              key: "getField",
              value: function getField() {
                return this.field;
              }
            }, {
              key: "setName",
              value: function setName(name) {
                this.name = name;
              }
            }, {
              key: "getName",
              value: function getName() {
                return this.name;
              }
            }, {
              key: "addVertex",
              value: function addVertex(location) {
                this.m_vertexList.add(location);
              }
              /**
              * Only used in ZomicPolyhedronModelInterpreter.
              * This used to be the implementation of addVertex, but all other callers
              * don't use the return value, and have already assigned their own indices,
              * so the collisions here are a bad idea.
              * @param halfLoc
              * @return
              * @param {com.vzome.core.algebra.AlgebraicVector} location
              * @return {number}
              */

            }, {
              key: "addIndexedVertex",
              value: function addIndexedVertex(location) {
                var vertexObj = this.m_vertices.get(location);

                if (vertexObj == null) {
                  this.m_vertexList.add(location);
                  this.m_vertices.put(location, vertexObj = this.numVertices++);
                }

                return vertexObj;
              }
            }, {
              key: "addFace",
              value: function addFace(face) {
                face.canonicallyOrder();

                if (!this.m_faces.contains(face)) {
                  this.m_faces.add(face);
                }
              }
            }, {
              key: "newFace",
              value: function newFace() {
                return new Polyhedron.Face(this);
              }
              /**
              *
              * @return {number}
              */

            }, {
              key: "hashCode",
              value: function hashCode() {
                var prime = 31;
                var result = 1;
                result = prime * result + (this.isEvil ? 1231 : 1237);
                result = prime * result + (this.length == null ? 0 :
                /* hashCode */
                function (o) {
                  if (o.hashCode) {
                    return o.hashCode();
                  } else {
                    return o.toString().split('').reduce(function (prevHash, currVal) {
                      return (prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0;
                    }, 0);
                  }
                }(this.length));
                result = prime * result + (this.m_faces == null ? 0 :
                /* hashCode */
                function (o) {
                  if (o.hashCode) {
                    return o.hashCode();
                  } else {
                    return o.toString().split('').reduce(function (prevHash, currVal) {
                      return (prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0;
                    }, 0);
                  }
                }(this.m_faces));
                result = prime * result + (this.m_vertexList == null ? 0 :
                /* hashCode */
                function (o) {
                  if (o.hashCode) {
                    return o.hashCode();
                  } else {
                    return o.toString().split('').reduce(function (prevHash, currVal) {
                      return (prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0;
                    }, 0);
                  }
                }(this.m_vertexList));
                result = prime * result + this.numVertices;
                result = prime * result + (this.orbit == null ? 0 :
                /* hashCode */
                function (o) {
                  if (o.hashCode) {
                    return o.hashCode();
                  } else {
                    return o.toString().split('').reduce(function (prevHash, currVal) {
                      return (prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0;
                    }, 0);
                  }
                }(this.orbit));
                return result;
              }
              /**
              *
              * @param {*} obj
              * @return {boolean}
              */

            }, {
              key: "equals",
              value: function equals(obj) {
                if (this === obj) {
                  return true;
                }

                if (obj == null) {
                  return false;
                }

                if (this.constructor !== obj.constructor) {
                  return false;
                }

                var other = obj;

                if (this.isEvil !== other.isEvil) {
                  return false;
                }

                if (this.length == null) {
                  if (other.length != null) {
                    return false;
                  }
                } else if (!function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(this.length, other.length)) {
                  return false;
                }

                if (this.m_faces == null) {
                  if (other.m_faces != null) {
                    return false;
                  }
                } else if (!function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(this.m_faces, other.m_faces)) {
                  return false;
                }

                if (this.m_vertexList == null) {
                  if (other.m_vertexList != null) {
                    return false;
                  }
                } else if (!function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(this.m_vertexList, other.m_vertexList)) {
                  return false;
                }

                if (this.numVertices !== other.numVertices) {
                  return false;
                }

                if (this.orbit == null) {
                  if (other.orbit != null) {
                    return false;
                  }
                } else if (!this.orbit.equals(other.orbit)) {
                  return false;
                }

                return true;
              }
            }, {
              key: "setOrbit",
              value: function setOrbit(orbit) {
                this.orbit = orbit;
              }
            }, {
              key: "setLength",
              value: function setLength(length) {
                this.length = length;
              }
            }, {
              key: "getOrbit",
              value: function getOrbit() {
                return this.orbit;
              }
            }, {
              key: "getLength",
              value: function getLength() {
                return this.length;
              }
            }, {
              key: "isPanel",
              value: function isPanel() {
                return this.__isPanel;
              }
            }, {
              key: "setPanel",
              value: function setPanel(isPanel) {
                this.__isPanel = isPanel;
              }
            }, {
              key: "getVertexList",
              value: function getVertexList() {
                return this.m_vertexList;
              }
            }, {
              key: "getFaceSet",
              value: function getFaceSet() {
                return this.m_faces;
              }
            }, {
              key: "getGuid",
              value: function getGuid() {
                return this.guid;
              }
            }, {
              key: "getTriangleFaces",
              value: function getTriangleFaces() {
                var result = new java.util.ArrayList();

                for (var index577 = this.m_faces.iterator(); index577.hasNext();) {
                  var face = index577.next();
                  {
                    result.addAll(face.getTriangles());
                  }
                }

                return result;
              }
            }, {
              key: "getTriangles",
              value: function getTriangles() {
                var index = 0;
                var result = new java.util.ArrayList();

                for (var index578 = this.m_faces.iterator(); index578.hasNext();) {
                  var face = index578.next();
                  {
                    for (var index579 = face.getTriangles().iterator(); index579.hasNext();) {
                      index579.next();
                      {
                        result.add(index++);
                        result.add(index++);
                        result.add(index++);
                      }
                    }
                  }
                }

                return result;
              }
            }, {
              key: "getTriangleVertices",
              value: function getTriangleVertices() {
                var result = new java.util.ArrayList();

                for (var index580 = this.m_faces.iterator(); index580.hasNext();) {
                  var face = index580.next();
                  {
                    for (var index581 = face.getTriangles().iterator(); index581.hasNext();) {
                      var triangle = index581.next();
                      {
                        for (var index582 = 0; index582 < triangle.vertices.length; index582++) {
                          var index = triangle.vertices[index582];
                          {
                            var vertex = this.m_vertexList.get(index);
                            result.add(vertex.toRealVector());
                          }
                        }
                      }
                    }
                  }
                }

                return result;
              }
            }], [{
              key: "logger_$LI$",
              value: function logger_$LI$() {
                if (Polyhedron.logger == null) Polyhedron.logger = java.util.logging.Logger.getLogger("com.vzome.core.math.Polyhedron");
                return Polyhedron.logger;
              }
            }]);

            return Polyhedron;
          }();

          math.Polyhedron = Polyhedron;
          Polyhedron["__class"] = "com.vzome.core.math.Polyhedron";
          Polyhedron["__interfaces"] = ["java.lang.Cloneable"];

          (function (Polyhedron) {
            var Face =
            /*#__PURE__*/
            function (_java$util$ArrayList) {
              _inherits(Face, _java$util$ArrayList);

              var _super = _createSuper(Face);

              function Face(__parent) {
                var _this3;

                _classCallCheck(this, Face);

                _this3 = _super.call(this);
                _this3.__parent = __parent;
                return _this3;
              }

              _createClass(Face, [{
                key: "getVertex",
                value: function getVertex(index) {
                  if (index >= this.size()) {
                    var msg = "index larger than Face size";
                    com.vzome.core.math.Polyhedron.logger_$LI$().severe(msg);
                    throw new java.lang.IllegalStateException(msg);
                  }

                  return this.get(index);
                }
              }, {
                key: "getTriangles",
                value: function getTriangles() {
                  var arity = this.size();
                  var result = new java.util.ArrayList();
                  var v0 = -1;
                  var v1 = -1;

                  for (var j = 0; j < arity; j++) {
                    {
                      var index = this.get(j);

                      if (v0 === -1) {
                        v0 = index;
                      } else if (v1 === -1) {
                        v1 = index;
                      } else {
                        var triangle = new com.vzome.core.math.Polyhedron.Face.Triangle(this, v0, v1, index);
                        result.add(triangle);
                        v1 = index;
                      }
                    }
                  }

                  return result;
                }
              }, {
                key: "getNormal",
                value: function getNormal(vertices) {
                  return com.vzome.core.algebra.AlgebraicVectors.getNormal$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector(vertices.get(this.getVertex(0)), vertices.get(this.getVertex(1)), vertices.get(this.getVertex(2)));
                }
              }, {
                key: "canonicallyOrder",
                value: function canonicallyOrder() {
                  var minIndex = -1;
                  var minVertex = javaemul.internal.IntegerHelper.MAX_VALUE;
                  var sz = this.size();

                  for (var i = 0; i < sz; i++) {
                    if (this.getVertex(i) <= minVertex) {
                      minVertex = this.getVertex(i);
                      minIndex = i;
                    }
                  }

                  var temp = function (s) {
                    var a = [];

                    while (s-- > 0) {
                      a.push(null);
                    }

                    return a;
                  }(sz);

                  for (var j = 0; j < sz; j++) {
                    {
                      temp[j] = this.get((j + minIndex) % sz);
                    }
                  }

                  for (var k = 0; k < sz; k++) {
                    this.set(k, temp[k]);
                  }
                }
                /**
                *
                * @return {number}
                */

              }, {
                key: "hashCode",
                value: function hashCode() {
                  var tot = 0;

                  for (var i = 0; i < this.size(); i++) {
                    tot += this.getVertex(i);
                  }

                  return tot;
                }
                /**
                *
                * @param {*} other
                * @return {boolean}
                */

              }, {
                key: "equals",
                value: function equals(other) {
                  if (other == null) return false;
                  if (other === this) return true;
                  if (!(other != null && other instanceof com.vzome.core.math.Polyhedron.Face)) return false;
                  var otherFace = other;
                  if (otherFace.size() !== this.size()) return false;

                  for (var i = 0; i < this.size(); i++) {
                    if (!function (o1, o2) {
                      if (o1 && o1.equals) {
                        return o1.equals(o2);
                      } else {
                        return o1 === o2;
                      }
                    }(this.get(i), otherFace.get(i))) return false;
                  }

                  return true;
                }
              }]);

              return Face;
            }(java.util.ArrayList);

            Polyhedron.Face = Face;
            Face["__class"] = "com.vzome.core.math.Polyhedron.Face";
            Face["__interfaces"] = ["java.util.RandomAccess", "java.lang.Cloneable", "java.util.List", "java.util.Collection", "java.lang.Iterable", "java.io.Serializable"];

            (function (Face) {
              var Triangle = function Triangle(__parent, v0, v1, v2) {
                _classCallCheck(this, Triangle);

                this.__parent = __parent;
                this.vertices = [0, 0, 0];
                this.vertices[0] = v0;
                this.vertices[1] = v1;
                this.vertices[2] = v2;
              };

              Face.Triangle = Triangle;
              Triangle["__class"] = "com.vzome.core.math.Polyhedron.Face.Triangle";
            })(Face = Polyhedron.Face || (Polyhedron.Face = {}));

            var Views = function Views() {
              _classCallCheck(this, Views);
            };

            Polyhedron.Views = Views;
            Views["__class"] = "com.vzome.core.math.Polyhedron.Views";
          })(Polyhedron = math.Polyhedron || (math.Polyhedron = {}));
        })(core.math || (core.math = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (math) {
          (function (convexhull) {
            /**
            * Constructs a vertex with the specified coordinates and index.
            * @param {com.vzome.core.algebra.AlgebraicVector} v
            * @param {number} idx
            * @class
            * @author John E. Lloyd, Fall 2004
            */
            var Vertex = function Vertex(v, idx) {
              _classCallCheck(this, Vertex);

              if (this.pnt === undefined) this.pnt = null;
              if (this.index === undefined) this.index = 0;
              if (this.prev === undefined) this.prev = null;
              if (this.next === undefined) this.next = null;
              if (this.face === undefined) this.face = null;
              this.pnt = v;
              this.index = idx;
            };

            convexhull.Vertex = Vertex;
            Vertex["__class"] = "com.vzome.core.math.convexhull.Vertex";
          })(math.convexhull || (math.convexhull = {}));
        })(core.math || (core.math = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (math) {
          (function (convexhull) {
            var GrahamScan2D =
            /*#__PURE__*/
            function () {
              function GrahamScan2D() {
                _classCallCheck(this, GrahamScan2D);
              }
              /**
              * Constructs the 2d convex hull of a coplanar set of 3d points.
              *
              * @param {*} points
              * a set of 3d input points
              * @return  {Array} an array of the vertices of the planar convex hull.
              * The points are ordered so that the normal of the resulting polygon points AWAY from the origin.
              * The points in the array are unique, so the last point is NOT the same as the first.
              * This means that polygon edges derived from this array must connect the last to the first.
              * @throws Failure
              * if the number of input points is less than three,
              * or if the points are collinear
              * or if the points are not coplanar.
              */


              _createClass(GrahamScan2D, null, [{
                key: "buildHull",
                value: function buildHull(points) {
                  if (points.size() < 3) {
                    GrahamScan2D.fail("At least three input points are required for a 2d convex hull.\n\n" + points.size() + " specified.");
                  }

                  var normal = com.vzome.core.algebra.AlgebraicVectors.getNormal$java_util_Collection(points);

                  if (normal.isOrigin()) {
                    GrahamScan2D.fail("Cannot generate a 2d convex hull from collinear points");
                  }

                  if (!com.vzome.core.algebra.AlgebraicVectors.areOrthogonalTo(normal, points)) {
                    GrahamScan2D.fail("Cannot generate a 2d convex hull from non-coplanar points");
                  }

                  var keySet = new java.util.ArrayList();
                  var xyTo3dMap = GrahamScan2D.map3dToXY(points, normal, keySet);
                  var stack2d = GrahamScan2D.getHull2d(keySet);

                  var vertices3d = function (s) {
                    var a = [];

                    while (s-- > 0) {
                      a.push(null);
                    }

                    return a;
                  }(stack2d.size());

                  var i = 0;

                  for (var index583 = stack2d.iterator(); index583.hasNext();) {
                    var point2d = index583.next();
                    {
                      var point3d = xyTo3dMap.get(point2d.toString(com.vzome.core.algebra.AlgebraicField.VEF_FORMAT));
                      vertices3d[i++] = point3d;
                    }
                  }

                  return vertices3d;
                }
                /*private*/

              }, {
                key: "map3dToXY",
                value: function map3dToXY(points3d, normal, keySet) {
                  var maxAxis = com.vzome.core.algebra.AlgebraicVectors.getMaxComponentIndex(normal);
                  var mapX = (maxAxis + 1) % 3;
                  var mapY = (maxAxis + 2) % 3;
                  var map = new java.util.HashMap();

                  for (var index584 = points3d.iterator(); index584.hasNext();) {
                    var point3d = index584.next();
                    {
                      var point2d = new com.vzome.core.algebra.AlgebraicVector(point3d.getComponent(mapX), point3d.getComponent(mapY));
                      keySet.add(point2d);
                      map.put(point2d.toString(com.vzome.core.algebra.AlgebraicField.VEF_FORMAT), point3d);
                    }
                  }

                  return map;
                }
                /*private*/

              }, {
                key: "getHull2d",
                value: function getHull2d(points2d) {
                  var sortedPoints2d = GrahamScan2D.getSortedPoints(points2d);
                  var stack2d = new java.util.ArrayDeque();
                  stack2d.push(sortedPoints2d.get(0));
                  stack2d.push(sortedPoints2d.get(1));

                  for (var i = 2; i < sortedPoints2d.size(); i++) {
                    {
                      var head = sortedPoints2d.get(i);
                      var middle = stack2d.pop();
                      var tail = stack2d.peek();
                      var turn = GrahamScan2D.getWindingDirection(tail, middle, head);

                      switch (turn) {
                        case 1:
                          stack2d.push(middle);
                          stack2d.push(head);
                          break;

                        case -1:
                          i--;
                          break;

                        case 0:
                          stack2d.push(head);
                          break;

                        default:
                          throw new java.lang.IllegalStateException("Illegal turn: " + turn);
                      }
                    }
                  }

                  return stack2d;
                }
                /**
                * @param {*} points2d set of 2d points to be sorted
                * @return {*} a list of points sorted:
                * 1) in increasing order of the angle they and the lowest point make with the x-axis.
                * 2) by increasing distance from the lowest point.
                * @private
                */

                /*private*/

              }, {
                key: "getSortedPoints",
                value: function getSortedPoints(points2d) {
                  var lowest = GrahamScan2D.getLowest2dPoint(points2d);
                  var list = new java.util.ArrayList(points2d);
                  java.util.Collections.sort(list, function (a, b) {
                    if (a.equals(b)) {
                      return 0;
                    }

                    if (a.equals(lowest)) {
                      return -1;
                    }

                    if (b.equals(lowest)) {
                      return 1;
                    }

                    var turn = GrahamScan2D.getWindingDirection(lowest, a, b);

                    if (turn !== 0) {
                      return -turn;
                    }

                    var lengthSqA = com.vzome.core.algebra.AlgebraicVectors.getMagnitudeSquared(a.minus(lowest));
                    var lengthSqB = com.vzome.core.algebra.AlgebraicVectors.getMagnitudeSquared(b.minus(lowest));
                    return lengthSqA.compareTo(lengthSqB);
                  });
                  return list;
                }
                /**
                * @param {*} points2d a collection of 2d points from which to determine the lowest point.
                * @return  {com.vzome.core.algebra.AlgebraicVector} the point with the lowest y coordinate.
                * In case more than one point has the same minimum y coordinate,
                * the one with the lowest x coordinate is returned.
                */

              }, {
                key: "getLowest2dPoint",
                value: function getLowest2dPoint(points2d) {
                  var lowest = null;

                  for (var index585 = points2d.iterator(); index585.hasNext();) {
                    var point2d = index585.next();
                    {
                      if (lowest == null) {
                        lowest = point2d;
                      } else {
                        var signum = point2d.getComponent(com.vzome.core.algebra.AlgebraicVector.Y)['minus$com_vzome_core_algebra_AlgebraicNumber'](lowest.getComponent(com.vzome.core.algebra.AlgebraicVector.Y)).signum();

                        switch (signum) {
                          case -1:
                            lowest = point2d;
                            break;

                          case 0:
                            if (point2d.getComponent(com.vzome.core.algebra.AlgebraicVector.X).lessThan(lowest.getComponent(com.vzome.core.algebra.AlgebraicVector.X))) {
                              lowest = point2d;
                            }

                            break;
                        }
                      }
                    }
                  }

                  return lowest;
                }
                /**
                *
                * @param {com.vzome.core.algebra.AlgebraicVector} a 2d coordinate
                * @param {com.vzome.core.algebra.AlgebraicVector} b 2d coordinate
                * @param {com.vzome.core.algebra.AlgebraicVector} c 2d coordinate
                * @return {number} -1, 0 or 1, depending on the orientation of vector ac with respect to vector ab:
                * 1: COUNTER_CLOCKWISE
                * c
                * /
                * /
                * a-----b
                * -1: CLOCKWISE
                * b
                * /
                * /
                * a-----c
                * 0: COLLINEAR
                * a-----b--c
                * @private
                */

                /*private*/

              }, {
                key: "getWindingDirection",
                value: function getWindingDirection(a, b, c) {
                  var ab = b.minus(a);
                  var ac = c.minus(a);
                  return new com.vzome.core.algebra.AlgebraicMatrix(ab, ac).determinant().signum();
                }
                /*private*/

              }, {
                key: "fail",
                value: function fail(msg) {
                  throw new com.vzome.core.commands.Command.Failure(msg);
                }
              }]);

              return GrahamScan2D;
            }();

            convexhull.GrahamScan2D = GrahamScan2D;
            GrahamScan2D["__class"] = "com.vzome.core.math.convexhull.GrahamScan2D";
          })(math.convexhull || (math.convexhull = {}));
        })(core.math || (core.math = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (math) {
          (function (convexhull) {
            /**
            * Basic triangular face used to form the hull.
            *
            * <p>
            * The information stored for each face consists of a planar normal, a planar
            * offset, and a doubly-linked list of three <a href=HalfEdge>HalfEdges</a>
            * which surround the face in a counter-clockwise direction.
            *
            * @author John E. Lloyd, Fall 2004
            * @class
            */
            var Face =
            /*#__PURE__*/
            function () {
              function Face() {
                _classCallCheck(this, Face);

                if (this.he0 === undefined) this.he0 = null;
                if (this.normal === undefined) this.normal = null;
                if (this.area === undefined) this.area = 0;
                if (this.centroid === undefined) this.centroid = null;
                if (this.planeOffset === undefined) this.planeOffset = null;
                if (this.index === undefined) this.index = 0;
                if (this.numVerts === undefined) this.numVerts = 0;
                if (this.next === undefined) this.next = null;
                this.mark = Face.VISIBLE;
                if (this.outside === undefined) this.outside = null;
                this.mark = Face.VISIBLE;
              }

              _createClass(Face, [{
                key: "computeCentroid",
                value: function computeCentroid() {
                  var vectors = new java.util.HashSet();
                  var he = this.he0;

                  do {
                    {
                      vectors.add(he.head().pnt);
                      he = he.next;
                    }
                  } while (he !== this.he0);

                  this.centroid = com.vzome.core.algebra.AlgebraicVectors.calculateCentroid(vectors);
                  return this.centroid;
                }
              }, {
                key: "computeNormal",
                value: function computeNormal() {
                  var he1 = this.he0.next;
                  var he2 = he1.next;
                  var p0 = this.he0.head().pnt;
                  var p2 = he1.head().pnt;
                  var d2 = p2.minus(p0);
                  this.normal = p0.getField().origin(3);
                  this.numVerts = 2;

                  while (he2 !== this.he0) {
                    {
                      var d1 = d2;
                      p2 = he2.head().pnt;
                      d2 = p2.minus(p0);
                      this.normal = this.normal.plus(d1.cross(d2));
                      he1 = he2;
                      he2 = he2.next;
                      this.numVerts++;
                    }
                  }

                  return this.normal;
                }
                /*private*/

              }, {
                key: "computeNormalAndCentroid$",
                value: function computeNormalAndCentroid$() {
                  this.normal = this.computeNormal();
                  this.centroid = this.computeCentroid();
                  this.planeOffset = this.normal.dot(this.centroid);
                  var numv = 0;
                  var he = this.he0;

                  do {
                    {
                      numv++;
                      he = he.next;
                    }
                  } while (he !== this.he0);

                  if (numv !== this.numVerts) {
                    this.fail("face " + this.getVertexString() + " numVerts=" + this.numVerts + " should be " + numv);
                  }
                }
              }, {
                key: "computeNormalAndCentroid$double",
                value: function computeNormalAndCentroid$double(minArea) {
                  this.normal = this.computeNormal();
                  this.centroid = this.computeCentroid();
                  this.planeOffset = this.normal.dot(this.centroid);
                }
              }, {
                key: "computeNormalAndCentroid",
                value: function computeNormalAndCentroid(minArea) {
                  if (typeof minArea === 'number' || minArea === null) {
                    return this.computeNormalAndCentroid$double(minArea);
                  } else if (minArea === undefined) {
                    return this.computeNormalAndCentroid$();
                  } else throw new Error('invalid overload');
                }
              }, {
                key: "getEdge",

                /**
                * Gets the i-th half-edge associated with the face.
                *
                * @param {number} i
                * the half-edge index, in the range 0-2.
                * @return {com.vzome.core.math.convexhull.HalfEdge} the half-edge
                */
                value: function getEdge(i) {
                  var he = this.he0;

                  while (i > 0) {
                    {
                      he = he.next;
                      i--;
                    }
                  }

                  while (i < 0) {
                    {
                      he = he.prev;
                      i++;
                    }
                  }

                  return he;
                }
              }, {
                key: "getFirstEdge",
                value: function getFirstEdge() {
                  return this.he0;
                }
                /**
                * Finds the half-edge within this face which has tail <code>vt</code> and head
                * <code>vh</code>.
                *
                * @param {com.vzome.core.math.convexhull.Vertex} vt
                * tail point
                * @param {com.vzome.core.math.convexhull.Vertex} vh
                * head point
                * @return {com.vzome.core.math.convexhull.HalfEdge} the half-edge, or null if none is found.
                */

              }, {
                key: "findEdge",
                value: function findEdge(vt, vh) {
                  var he = this.he0;

                  do {
                    {
                      if (he.head() === vh && he.tail() === vt) {
                        return he;
                      }

                      he = he.next;
                    }
                  } while (he !== this.he0);

                  return null;
                }
                /**
                * Computes the distance from a point p to the plane of this face.
                *
                * @param {com.vzome.core.algebra.AlgebraicVector} p
                * the point
                * @return {*} distance from the point to the plane
                */

              }, {
                key: "distanceToPlane",
                value: function distanceToPlane(p) {
                  return this.normal.dot(p)['minus$com_vzome_core_algebra_AlgebraicNumber'](this.planeOffset);
                }
                /**
                * Returns the normal of the plane associated with this face.
                *
                * @return {com.vzome.core.algebra.AlgebraicVector} the planar normal
                */

              }, {
                key: "getNormal",
                value: function getNormal() {
                  return this.normal;
                }
              }, {
                key: "getCentroid",
                value: function getCentroid() {
                  return this.centroid;
                }
              }, {
                key: "numVertices",
                value: function numVertices() {
                  return this.numVerts;
                }
              }, {
                key: "getVertexString",
                value: function getVertexString() {
                  var s = null;
                  var he = this.he0;

                  do {
                    {
                      if (s == null) {
                        s = "" + he.head().index;
                      } else {
                        s += " " + he.head().index;
                      }

                      he = he.next;
                    }
                  } while (he !== this.he0);

                  return s;
                }
              }, {
                key: "getVertexIndices",
                value: function getVertexIndices(idxs) {
                  var he = this.he0;
                  var i = 0;

                  do {
                    {
                      idxs[i++] = he.head().index;
                      he = he.next;
                    }
                  } while (he !== this.he0);
                }
                /*private*/

              }, {
                key: "connectHalfEdges",
                value: function connectHalfEdges(hedgePrev, hedge) {
                  var discardedFace = null;

                  if (hedgePrev.oppositeFace() === hedge.oppositeFace()) {
                    var oppFace = hedge.oppositeFace();
                    var hedgeOpp;

                    if (hedgePrev === this.he0) {
                      this.he0 = hedge;
                    }

                    if (oppFace.numVertices() === 3) {
                      hedgeOpp = hedge.getOpposite().prev.getOpposite();
                      oppFace.mark = Face.DELETED;
                      discardedFace = oppFace;
                    } else {
                      hedgeOpp = hedge.getOpposite().next;

                      if (oppFace.he0 === hedgeOpp.prev) {
                        oppFace.he0 = hedgeOpp;
                      }

                      hedgeOpp.prev = hedgeOpp.prev.prev;
                      hedgeOpp.prev.next = hedgeOpp;
                    }

                    hedge.prev = hedgePrev.prev;
                    hedge.prev.next = hedge;
                    hedge.opposite = hedgeOpp;
                    hedgeOpp.opposite = hedge;
                    oppFace.computeNormalAndCentroid$();
                  } else {
                    hedgePrev.next = hedge;
                    hedge.prev = hedgePrev;
                  }

                  return discardedFace;
                }
                /*private*/

              }, {
                key: "fail",
                value: function fail(msg) {
                  throw new com.vzome.core.commands.Command.Failure(msg);
                }
              }, {
                key: "checkConsistency",
                value: function checkConsistency() {
                  var hedge = this.he0;
                  var numv = 0;

                  if (this.numVerts < 3) {
                    this.fail("degenerate face: " + this.getVertexString());
                  }

                  do {
                    {
                      var hedgeOpp = hedge.getOpposite();

                      if (hedgeOpp == null) {
                        this.fail("face " + this.getVertexString() + ": unreflected half edge " + hedge.getVertexString());
                      } else if (hedgeOpp.getOpposite() !== hedge) {
                        this.fail("face " + this.getVertexString() + ": opposite half edge " + hedgeOpp.getVertexString() + " has opposite " + hedgeOpp.getOpposite().getVertexString());
                      }

                      if (hedgeOpp.head() !== hedge.tail() || hedge.head() !== hedgeOpp.tail()) {
                        this.fail("face " + this.getVertexString() + ": half edge " + hedge.getVertexString() + " reflected by " + hedgeOpp.getVertexString());
                      }

                      var oppFace = hedgeOpp.face;

                      if (oppFace == null) {
                        this.fail("face " + this.getVertexString() + ": no face on half edge " + hedgeOpp.getVertexString());
                      } else if (oppFace.mark === Face.DELETED) {
                        this.fail("face " + this.getVertexString() + ": opposite face " + oppFace.getVertexString() + " not on hull");
                      }

                      Math.abs(this.distanceToPlane(hedge.head().pnt).evaluate());
                      numv++;
                      hedge = hedge.next;
                    }
                  } while (hedge !== this.he0);

                  if (numv !== this.numVerts) {
                    this.fail("face " + this.getVertexString() + " numVerts=" + this.numVerts + " should be " + numv);
                  }
                }
              }, {
                key: "mergeAdjacentFace",
                value: function mergeAdjacentFace(hedgeAdj, discarded) {
                  var oppFace = hedgeAdj.oppositeFace();
                  var numDiscarded = 0;
                  discarded[numDiscarded++] = oppFace;
                  oppFace.mark = Face.DELETED;
                  var hedgeOpp = hedgeAdj.getOpposite();
                  var hedgeAdjPrev = hedgeAdj.prev;
                  var hedgeAdjNext = hedgeAdj.next;
                  var hedgeOppPrev = hedgeOpp.prev;
                  var hedgeOppNext = hedgeOpp.next;
                  var foo = 0;

                  while (hedgeAdjPrev.oppositeFace() === oppFace) {
                    {
                      hedgeAdjPrev = hedgeAdjPrev.prev;
                      hedgeOppNext = hedgeOppNext.next;

                      if (++foo > 1000) {
                        this.fail("Oops, it\'s hung.");
                      }
                    }
                  }

                  foo = 0;

                  while (hedgeAdjNext.oppositeFace() === oppFace) {
                    {
                      hedgeOppPrev = hedgeOppPrev.prev;
                      hedgeAdjNext = hedgeAdjNext.next;

                      if (++foo > 1000) {
                        this.fail("Oops, it\'s hung.");
                      }
                    }
                  }

                  var hedge;
                  foo = 0;

                  for (hedge = hedgeOppNext; hedge !== hedgeOppPrev.next; hedge = hedge.next) {
                    {
                      hedge.face = this;

                      if (++foo > 1000) {
                        this.fail("Oops, it\'s hung.");
                      }
                    }
                  }

                  if (hedgeAdj === this.he0) {
                    this.he0 = hedgeAdjNext;
                  }

                  var discardedFace;
                  discardedFace = this.connectHalfEdges(hedgeOppPrev, hedgeAdjNext);

                  if (discardedFace != null) {
                    discarded[numDiscarded++] = discardedFace;
                  }

                  discardedFace = this.connectHalfEdges(hedgeAdjPrev, hedgeOppNext);

                  if (discardedFace != null) {
                    discarded[numDiscarded++] = discardedFace;
                  }

                  this.computeNormalAndCentroid$();
                  this.checkConsistency();
                  return numDiscarded;
                }
              }, {
                key: "triangulate",
                value: function triangulate(newFaces) {
                  var minArea = 0;
                  var hedge;

                  if (this.numVertices() < 4) {
                    return;
                  }

                  var v0 = this.he0.head();
                  hedge = this.he0.next;
                  var oppPrev = hedge.opposite;
                  var face0 = null;

                  for (hedge = hedge.next; hedge !== this.he0.prev; hedge = hedge.next) {
                    {
                      var face = Face.createTriangle$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex$double(v0, hedge.prev.head(), hedge.head(), minArea);
                      face.he0.next.setOpposite(oppPrev);
                      face.he0.prev.setOpposite(hedge.opposite);
                      oppPrev = face.he0;
                      newFaces.add(face);

                      if (face0 == null) {
                        face0 = face;
                      }
                    }
                  }

                  hedge = new com.vzome.core.math.convexhull.HalfEdge(this.he0.prev.prev.head(), this);
                  hedge.setOpposite(oppPrev);
                  hedge.prev = this.he0;
                  hedge.prev.next = hedge;
                  hedge.next = this.he0.prev;
                  hedge.next.prev = hedge;
                  this.computeNormalAndCentroid$double(minArea);
                  this.checkConsistency();

                  for (var _face = face0; _face != null; _face = _face.next) {
                    {
                      _face.checkConsistency();
                    }
                  }
                }
              }], [{
                key: "createTriangle$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex",
                value: function createTriangle$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex(v0, v1, v2) {
                  return Face.createTriangle$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex$double(v0, v1, v2, 0);
                }
              }, {
                key: "createTriangle$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex$double",
                value: function createTriangle$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex$double(v0, v1, v2, minArea) {
                  var face = new Face();
                  var he0 = new com.vzome.core.math.convexhull.HalfEdge(v0, face);
                  var he1 = new com.vzome.core.math.convexhull.HalfEdge(v1, face);
                  var he2 = new com.vzome.core.math.convexhull.HalfEdge(v2, face);
                  he0.prev = he2;
                  he0.next = he1;
                  he1.prev = he0;
                  he1.next = he2;
                  he2.prev = he1;
                  he2.next = he0;
                  face.he0 = he0;
                  face.computeNormalAndCentroid$double(minArea);
                  return face;
                }
                /**
                * Constructs a triangule Face from vertices v0, v1, and v2.
                *
                * @param {com.vzome.core.math.convexhull.Vertex} v0
                * first vertex
                * @param {com.vzome.core.math.convexhull.Vertex} v1
                * second vertex
                * @param {com.vzome.core.math.convexhull.Vertex} v2
                * third vertex
                * @param {number} minArea
                * @return {com.vzome.core.math.convexhull.Face}
                */

              }, {
                key: "createTriangle",
                value: function createTriangle(v0, v1, v2, minArea) {
                  if ((v0 != null && v0 instanceof com.vzome.core.math.convexhull.Vertex || v0 === null) && (v1 != null && v1 instanceof com.vzome.core.math.convexhull.Vertex || v1 === null) && (v2 != null && v2 instanceof com.vzome.core.math.convexhull.Vertex || v2 === null) && (typeof minArea === 'number' || minArea === null)) {
                    return com.vzome.core.math.convexhull.Face.createTriangle$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex$double(v0, v1, v2, minArea);
                  } else if ((v0 != null && v0 instanceof com.vzome.core.math.convexhull.Vertex || v0 === null) && (v1 != null && v1 instanceof com.vzome.core.math.convexhull.Vertex || v1 === null) && (v2 != null && v2 instanceof com.vzome.core.math.convexhull.Vertex || v2 === null) && minArea === undefined) {
                    return com.vzome.core.math.convexhull.Face.createTriangle$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex(v0, v1, v2);
                  } else throw new Error('invalid overload');
                }
              }, {
                key: "create",
                value: function create(vtxArray, indices) {
                  var face = new Face();
                  var hePrev = null;

                  for (var i = 0; i < indices.length; i++) {
                    {
                      var he = new com.vzome.core.math.convexhull.HalfEdge(vtxArray[indices[i]], face);

                      if (hePrev != null) {
                        he.setPrev(hePrev);
                        hePrev.setNext(he);
                      } else {
                        face.he0 = he;
                      }

                      hePrev = he;
                    }
                  }

                  face.he0.setPrev(hePrev);
                  hePrev.setNext(face.he0);
                  face.computeNormalAndCentroid$();
                  return face;
                }
              }]);

              return Face;
            }();

            Face.VISIBLE = 1;
            Face.NON_CONVEX = 2;
            Face.DELETED = 3;
            convexhull.Face = Face;
            Face["__class"] = "com.vzome.core.math.convexhull.Face";
          })(math.convexhull || (math.convexhull = {}));
        })(core.math || (core.math = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (math) {
          (function (convexhull) {
            /**
            * Creates an empty convex hull object.
            * @class
            * @author John E. Lloyd, Fall 2004
            */
            var QuickHull3D =
            /*#__PURE__*/
            function () {
              function QuickHull3D() {
                _classCallCheck(this, QuickHull3D);

                this.findIndex = -1;
                this.debug = false;
                this.pointBuffer = [];
                this.vertexPointIndices = [];
                this.discardedFaces = [null, null, null];
                this.maxVtxs = [null, null, null];
                this.minVtxs = [null, null, null];
                this.faces = new java.util.Vector(16);
                this.newFaces = new java.util.LinkedList();
                this.unclaimed = new com.vzome.core.math.convexhull.VertexList();
                this.claimed = new com.vzome.core.math.convexhull.VertexList();
                if (this.numVertices === undefined) this.numVertices = 0;
                if (this.numFaces === undefined) this.numFaces = 0;
                if (this.numPoints === undefined) this.numPoints = 0;
              }
              /**
              * Returns true if debugging is enabled.
              *
              * @return {boolean} true is debugging is enabled
              * @see QuickHull3D#setDebug
              */


              _createClass(QuickHull3D, [{
                key: "getDebug",
                value: function getDebug() {
                  return this.debug;
                }
                /**
                * Enables the printing of debugging diagnostics.
                *
                * @param {boolean} enable
                * if true, enables debugging
                */

              }, {
                key: "setDebug",
                value: function setDebug(enable) {
                  this.debug = enable;
                }
                /*private*/

              }, {
                key: "addPointToFace",
                value: function addPointToFace(vtx, face) {
                  vtx.face = face;

                  if (face.outside == null) {
                    this.claimed.add(vtx);
                  } else {
                    this.claimed.insertBefore(vtx, face.outside);
                  }

                  face.outside = vtx;
                }
                /*private*/

              }, {
                key: "removePointFromFace",
                value: function removePointFromFace(vtx, face) {
                  if (vtx === face.outside) {
                    if (vtx.next != null && vtx.next.face === face) {
                      face.outside = vtx.next;
                    } else {
                      face.outside = null;
                    }
                  }

                  this.claimed.delete$com_vzome_core_math_convexhull_Vertex(vtx);
                }
                /*private*/

              }, {
                key: "removeAllPointsFromFace",
                value: function removeAllPointsFromFace(face) {
                  if (face.outside != null) {
                    var end = face.outside;

                    while (end.next != null && end.next.face === face) {
                      {
                        end = end.next;
                      }
                    }

                    this.claimed.delete$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex(face.outside, end);
                    end.next = null;
                    return face.outside;
                  } else {
                    return null;
                  }
                }
                /*private*/

              }, {
                key: "findHalfEdge",
                value: function findHalfEdge(tail, head) {
                  for (var index586 = this.faces.iterator(); index586.hasNext();) {
                    var face = index586.next();
                    {
                      var he = face.findEdge(tail, head);

                      if (he != null) {
                        return he;
                      }
                    }
                  }

                  return null;
                }
              }, {
                key: "setHull",
                value: function setHull(coords, nump, faceIndices, numf) {
                  this.initBuffers(nump);
                  this.setPoints(coords, nump);
                  this.computeMaxAndMin();

                  for (var i = 0; i < numf; i++) {
                    {
                      var face = com.vzome.core.math.convexhull.Face.create(this.pointBuffer, faceIndices[i]);
                      var he = face.he0;

                      do {
                        {
                          var heOpp = this.findHalfEdge(he.head(), he.tail());

                          if (heOpp != null) {
                            he.setOpposite(heOpp);
                          }

                          he = he.next;
                        }
                      } while (he !== face.he0);

                      this.faces.add(face);
                    }
                  }
                }
              }, {
                key: "build$java_util_Collection",
                value: function build$java_util_Collection(points) {
                  this.build$com_vzome_core_algebra_AlgebraicVector_A(points.toArray(function (s) {
                    var a = [];

                    while (s-- > 0) {
                      a.push(null);
                    }

                    return a;
                  }(points.size())));
                }
              }, {
                key: "build$com_vzome_core_algebra_AlgebraicVector_A",
                value: function build$com_vzome_core_algebra_AlgebraicVector_A(points) {
                  this.build$com_vzome_core_algebra_AlgebraicVector_A$int(points, points.length);
                }
              }, {
                key: "build$com_vzome_core_algebra_AlgebraicVector_A$int",
                value: function build$com_vzome_core_algebra_AlgebraicVector_A$int(points, nump) {
                  if (nump < 4) {
                    throw new com.vzome.core.commands.Command.Failure("At least four input points are required for a 3d convex hull.\n\n" + nump + " specified.");
                  }

                  if (points.length < nump) {
                    throw new com.vzome.core.commands.Command.Failure("Point array too small for specified number of points");
                  }

                  this.printPointSet(points, nump);
                  this.initBuffers(nump);
                  this.setPoints(points, nump);
                  this.buildHull();
                }
                /**
                * Constructs the convex hull of an array of points.
                *
                * @param {Array} points
                * input points
                * @param {number} nump
                * number of input points
                * @throws Failure
                * if the number of input points is less than four or greater than the
                * length of <code>points</code>, or the points are
                * coincident, collinear, or coplanar.
                */

              }, {
                key: "build",
                value: function build(points, nump) {
                  if ((points != null && points instanceof Array && (points.length == 0 || points[0] == null || points[0] != null && points[0] instanceof com.vzome.core.algebra.AlgebraicVector) || points === null) && (typeof nump === 'number' || nump === null)) {
                    return this.build$com_vzome_core_algebra_AlgebraicVector_A$int(points, nump);
                  } else if ((points != null && (points["__interfaces"] != null && points["__interfaces"].indexOf("java.util.Collection") >= 0 || points.constructor != null && points.constructor["__interfaces"] != null && points.constructor["__interfaces"].indexOf("java.util.Collection") >= 0) || points === null) && nump === undefined) {
                    return this.build$java_util_Collection(points);
                  } else if ((points != null && points instanceof Array && (points.length == 0 || points[0] == null || points[0] != null && points[0] instanceof com.vzome.core.algebra.AlgebraicVector) || points === null) && nump === undefined) {
                    return this.build$com_vzome_core_algebra_AlgebraicVector_A(points);
                  } else throw new Error('invalid overload');
                }
                /**
                * prints the initial set of points.
                *
                * @param {Array} points
                * input points
                * @param {number} nump
                * number of input points
                */

              }, {
                key: "printPointSet",
                value: function printPointSet(points, nump) {
                  if (this.debug) {
                    console.info("initial point set:");

                    for (var i = 0; i < nump; i++) {
                      {
                        console.info(i + ": " + points[i]);
                      }
                    }
                  }
                }
                /**
                * Triangulates any non-triangular hull faces. In some cases, due to precision
                * issues, the resulting triangles may be very thin or small, and hence appear
                * to be non-convex (this same limitation is present in <a href=http://www.qhull.org>qhull</a>).
                * @throws Failure
                */

              }, {
                key: "triangulate",
                value: function triangulate() {
                  this.newFaces.clear();

                  for (var index587 = this.faces.iterator(); index587.hasNext();) {
                    var face = index587.next();
                    {
                      if (face.mark === com.vzome.core.math.convexhull.Face.VISIBLE) {
                        face.triangulate(this.newFaces);
                      }
                    }
                  }

                  for (var index588 = this.newFaces.iterator(); index588.hasNext();) {
                    var _face2 = index588.next();

                    {
                      this.faces.add(_face2);
                    }
                  }
                }
              }, {
                key: "initBuffers",
                value: function initBuffers(nump) {
                  if (this.pointBuffer.length < nump) {
                    var newBuffer = function (s) {
                      var a = [];

                      while (s-- > 0) {
                        a.push(null);
                      }

                      return a;
                    }(nump);

                    this.vertexPointIndices = function (s) {
                      var a = [];

                      while (s-- > 0) {
                        a.push(0);
                      }

                      return a;
                    }(nump);

                    for (var i = 0; i < this.pointBuffer.length; i++) {
                      {
                        newBuffer[i] = this.pointBuffer[i];
                      }
                    }

                    for (var _i = this.pointBuffer.length; _i < nump; _i++) {
                      {
                        newBuffer[_i] = null;
                      }
                    }

                    this.pointBuffer = newBuffer;
                  }

                  this.faces.clear();
                  this.claimed.clear();
                  this.numFaces = 0;
                  this.numPoints = nump;
                }
              }, {
                key: "setPoints",
                value: function setPoints(pnts, nump) {
                  this.pointBuffer = function (s) {
                    var a = [];

                    while (s-- > 0) {
                      a.push(null);
                    }

                    return a;
                  }(nump);

                  for (var i = 0; i < nump; i++) {
                    {
                      this.pointBuffer[i] = new com.vzome.core.math.convexhull.Vertex(pnts[i], i);
                    }
                  }
                }
              }, {
                key: "computeMaxAndMin",
                value: function computeMaxAndMin() {
                  for (var i = 0; i < 3; i++) {
                    {
                      this.maxVtxs[i] = this.minVtxs[i] = this.pointBuffer[0];
                    }
                  }

                  var max = this.pointBuffer[0].pnt;
                  var maxx = max.getComponent(com.vzome.core.algebra.AlgebraicVector.X).evaluate();
                  var maxy = max.getComponent(com.vzome.core.algebra.AlgebraicVector.Y).evaluate();
                  var maxz = max.getComponent(com.vzome.core.algebra.AlgebraicVector.Z).evaluate();
                  var minx = maxx;
                  var miny = maxy;
                  var minz = maxz;

                  for (var _i2 = 1; _i2 < this.numPoints; _i2++) {
                    {
                      var pnt = this.pointBuffer[_i2].pnt;
                      var pntx = pnt.getComponent(com.vzome.core.algebra.AlgebraicVector.X).evaluate();
                      var pnty = pnt.getComponent(com.vzome.core.algebra.AlgebraicVector.Y).evaluate();
                      var pntz = pnt.getComponent(com.vzome.core.algebra.AlgebraicVector.Z).evaluate();

                      if (pntx > maxx) {
                        maxx = pntx;
                        this.maxVtxs[0] = this.pointBuffer[_i2];
                      } else if (pntx < minx) {
                        minx = pntx;
                        this.minVtxs[0] = this.pointBuffer[_i2];
                      }

                      if (pnty > maxy) {
                        maxy = pnty;
                        this.maxVtxs[1] = this.pointBuffer[_i2];
                      } else if (pnty < miny) {
                        miny = pnty;
                        this.minVtxs[1] = this.pointBuffer[_i2];
                      }

                      if (pntz > maxz) {
                        maxz = pntz;
                        this.maxVtxs[2] = this.pointBuffer[_i2];
                      } else if (pntz < minz) {
                        minz = pntz;
                        this.minVtxs[2] = this.pointBuffer[_i2];
                      }
                    }
                  }
                }
                /**
                * Creates the initial simplex from which the hull will be built.
                */

              }, {
                key: "createInitialSimplex",
                value: function createInitialSimplex() {
                  var max = 0;
                  var imax = 0;

                  for (var i = 0; i < 3; i++) {
                    {
                      var diff = this.maxVtxs[i].pnt.getComponent(i)['minus$com_vzome_core_algebra_AlgebraicNumber'](this.minVtxs[i].pnt.getComponent(i)).evaluate();

                      if (diff > max) {
                        max = diff;
                        imax = i;
                      }
                    }
                  }

                  if (max <= 0) {
                    throw new com.vzome.core.commands.Command.Failure("Input points are coincident");
                  }

                  var vtx = [null, null, null, null];
                  vtx[0] = this.maxVtxs[imax];
                  vtx[1] = this.minVtxs[imax];
                  var diff02;
                  var nrml = null;
                  var maxSqr = 0;
                  var u01 = vtx[1].pnt.minus(vtx[0].pnt);

                  for (var _i3 = 0; _i3 < this.numPoints; _i3++) {
                    {
                      diff02 = this.pointBuffer[_i3].pnt.minus(vtx[0].pnt);
                      var xprod = u01.cross(diff02);
                      var lenSqr = xprod.dot(xprod);

                      if (lenSqr.evaluate() > maxSqr && this.pointBuffer[_i3] !== vtx[0] && this.pointBuffer[_i3] !== vtx[1]) {
                        maxSqr = lenSqr.evaluate();
                        vtx[2] = this.pointBuffer[_i3];
                        nrml = xprod;
                      }
                    }
                  }

                  if (maxSqr === 0) {
                    throw new com.vzome.core.commands.Command.Failure("Input points are collinear");
                  }

                  var res = u01.scale(nrml.dot(u01));
                  nrml = nrml.minus(res);
                  var maxDist = 0.0;
                  var d0 = vtx[2].pnt.dot(nrml);

                  for (var _i4 = 0; _i4 < this.numPoints; _i4++) {
                    {
                      var dist = Math.abs(this.pointBuffer[_i4].pnt.dot(nrml)['minus$com_vzome_core_algebra_AlgebraicNumber'](d0).evaluate());

                      if (dist > maxDist && this.pointBuffer[_i4] !== vtx[0] && this.pointBuffer[_i4] !== vtx[1] && this.pointBuffer[_i4] !== vtx[2]) {
                        maxDist = dist;
                        vtx[3] = this.pointBuffer[_i4];
                      }
                    }
                  }

                  if (maxDist === 0.0) {
                    throw new com.vzome.core.commands.Command.Failure("Input points are coplanar");
                  }

                  if (this.debug) {
                    console.info("initial vertices:");
                    console.info(vtx[0].index + ": " + vtx[0].pnt);
                    console.info(vtx[1].index + ": " + vtx[1].pnt);
                    console.info(vtx[2].index + ": " + vtx[2].pnt);
                    console.info(vtx[3].index + ": " + vtx[3].pnt);
                  }

                  var tris = [null, null, null, null];

                  if (vtx[3].pnt.dot(nrml)['minus$com_vzome_core_algebra_AlgebraicNumber'](d0).evaluate() < 0) {
                    tris[0] = com.vzome.core.math.convexhull.Face.createTriangle$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex(vtx[0], vtx[1], vtx[2]);
                    tris[1] = com.vzome.core.math.convexhull.Face.createTriangle$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex(vtx[3], vtx[1], vtx[0]);
                    tris[2] = com.vzome.core.math.convexhull.Face.createTriangle$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex(vtx[3], vtx[2], vtx[1]);
                    tris[3] = com.vzome.core.math.convexhull.Face.createTriangle$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex(vtx[3], vtx[0], vtx[2]);

                    for (var _i5 = 0; _i5 < 3; _i5++) {
                      {
                        var k = (_i5 + 1) % 3;

                        tris[_i5 + 1].getEdge(1).setOpposite(tris[k + 1].getEdge(0));

                        tris[_i5 + 1].getEdge(2).setOpposite(tris[0].getEdge(k));
                      }
                    }
                  } else {
                    tris[0] = com.vzome.core.math.convexhull.Face.createTriangle$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex(vtx[0], vtx[2], vtx[1]);
                    tris[1] = com.vzome.core.math.convexhull.Face.createTriangle$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex(vtx[3], vtx[0], vtx[1]);
                    tris[2] = com.vzome.core.math.convexhull.Face.createTriangle$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex(vtx[3], vtx[1], vtx[2]);
                    tris[3] = com.vzome.core.math.convexhull.Face.createTriangle$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex(vtx[3], vtx[2], vtx[0]);

                    for (var _i6 = 0; _i6 < 3; _i6++) {
                      {
                        var _k = (_i6 + 1) % 3;

                        tris[_i6 + 1].getEdge(0).setOpposite(tris[_k + 1].getEdge(1));

                        tris[_i6 + 1].getEdge(2).setOpposite(tris[0].getEdge((3 - _i6) % 3));
                      }
                    }
                  }

                  for (var _i7 = 0; _i7 < 4; _i7++) {
                    {
                      this.faces.add(tris[_i7]);
                    }
                  }

                  for (var _i8 = 0; _i8 < this.numPoints; _i8++) {
                    {
                      var v = this.pointBuffer[_i8];

                      if (v === vtx[0] || v === vtx[1] || v === vtx[2] || v === vtx[3]) {
                        continue;
                      }

                      maxDist = 0.0;
                      var maxFace = null;

                      for (var _k2 = 0; _k2 < 4; _k2++) {
                        {
                          var _dist = tris[_k2].distanceToPlane(v.pnt).evaluate();

                          if (_dist > maxDist) {
                            maxFace = tris[_k2];
                            maxDist = _dist;
                          }
                        }
                      }

                      if (maxFace != null) {
                        this.addPointToFace(v, maxFace);
                      }
                    }
                  }
                }
                /**
                * Returns the number of vertices in this hull.
                *
                * @return {number} number of vertices
                */

              }, {
                key: "getNumVertices",
                value: function getNumVertices() {
                  return this.numVertices;
                }
              }, {
                key: "getVertices$",
                value: function getVertices$() {
                  var vtxs = function (s) {
                    var a = [];

                    while (s-- > 0) {
                      a.push(null);
                    }

                    return a;
                  }(this.numVertices);

                  for (var i = 0; i < this.numVertices; i++) {
                    {
                      vtxs[i] = this.pointBuffer[this.vertexPointIndices[i]].pnt;
                    }
                  }

                  return vtxs;
                }
              }, {
                key: "getVertices$com_vzome_core_algebra_AlgebraicNumber_A",
                value: function getVertices$com_vzome_core_algebra_AlgebraicNumber_A(coords) {
                  for (var i = 0; i < this.numVertices; i++) {
                    {
                      var pnt = this.pointBuffer[this.vertexPointIndices[i]].pnt;
                      coords[i * 3 + 0] = pnt.getComponent(com.vzome.core.algebra.AlgebraicVector.X);
                      coords[i * 3 + 1] = pnt.getComponent(com.vzome.core.algebra.AlgebraicVector.Y);
                      coords[i * 3 + 2] = pnt.getComponent(com.vzome.core.algebra.AlgebraicVector.Z);
                    }
                  }

                  return this.numVertices;
                }
                /**
                * Returns the coordinates of the vertex points of this hull.
                *
                * @param {Array} coords
                * returns the x, y, z coordinates of each vertex. This length of
                * this array must be at least three times the number of vertices.
                * @return {number} the number of vertices
                * @see QuickHull3D#getVertices()
                * @see QuickHull3D#getFaces()
                */

              }, {
                key: "getVertices",
                value: function getVertices(coords) {
                  if (coords != null && coords instanceof Array && (coords.length == 0 || coords[0] == null || coords[0] != null && (coords[0]["__interfaces"] != null && coords[0]["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0 || coords[0].constructor != null && coords[0].constructor["__interfaces"] != null && coords[0].constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0)) || coords === null) {
                    return this.getVertices$com_vzome_core_algebra_AlgebraicNumber_A(coords);
                  } else if (coords === undefined) {
                    return this.getVertices$();
                  } else throw new Error('invalid overload');
                }
                /**
                * Returns an array specifing the index of each hull vertex with respect to the
                * original input points.
                *
                * @return {Array} vertex indices with respect to the original points
                */

              }, {
                key: "getVertexPointIndices",
                value: function getVertexPointIndices() {
                  var indices = function (s) {
                    var a = [];

                    while (s-- > 0) {
                      a.push(0);
                    }

                    return a;
                  }(this.numVertices);

                  for (var i = 0; i < this.numVertices; i++) {
                    {
                      indices[i] = this.vertexPointIndices[i];
                    }
                  }

                  return indices;
                }
                /**
                * Returns the number of edges in this hull.
                *
                * @return {number} number of edges
                */

              }, {
                key: "getNumEdges",
                value: function getNumEdges() {
                  var count = 0;

                  for (var index589 = this.faces.iterator(); index589.hasNext();) {
                    var face = index589.next();
                    {
                      count += face.numVertices();
                    }
                  }

                  return count / 2 | 0;
                }
                /**
                * Returns the number of faces in this hull.
                *
                * @return {number} number of faces
                */

              }, {
                key: "getNumFaces",
                value: function getNumFaces() {
                  return this.faces.size();
                }
              }, {
                key: "getFaces$",
                value: function getFaces$() {
                  return this.getFaces$int(0);
                }
              }, {
                key: "getFaces$int",
                value: function getFaces$int(indexFlags) {
                  var allFaces = function (s) {
                    var a = [];

                    while (s-- > 0) {
                      a.push(null);
                    }

                    return a;
                  }(this.faces.size());

                  var k = 0;

                  for (var index590 = this.faces.iterator(); index590.hasNext();) {
                    var face = index590.next();
                    {
                      allFaces[k] = function (s) {
                        var a = [];

                        while (s-- > 0) {
                          a.push(0);
                        }

                        return a;
                      }(face.numVertices());

                      this.getFaceIndices(allFaces[k], face, indexFlags);
                      k++;
                    }
                  }

                  return allFaces;
                }
                /**
                * Returns the faces associated with this hull.
                *
                * <p>
                * Each face is represented by an integer array which gives the indices of the
                * vertices. By default, these indices are numbered with respect to the hull
                * vertices (as opposed to the input points), are zero-based, and are arranged
                * counter-clockwise. However, this can be changed by setting
                * {@link #POINT_RELATIVE}, {@link #INDEXED_FROM_ONE}, or {@link #CLOCKWISE} in the indexFlags
                * parameter.
                *
                * @param {number} indexFlags
                * specifies index characteristics (0 results in the default)
                * @return {Array} array of integer arrays, giving the vertex indices for each face.
                * @see QuickHull3D#getVertices()
                */

              }, {
                key: "getFaces",
                value: function getFaces(indexFlags) {
                  if (typeof indexFlags === 'number' || indexFlags === null) {
                    return this.getFaces$int(indexFlags);
                  } else if (indexFlags === undefined) {
                    return this.getFaces$();
                  } else throw new Error('invalid overload');
                }
              }, {
                key: "print$java_io_PrintStream",
                value: function print$java_io_PrintStream(ps) {
                  this.print$java_io_PrintStream$int(ps, 0);
                }
              }, {
                key: "print$java_io_PrintStream$int",
                value: function print$java_io_PrintStream$int(ps, indexFlags) {
                  if ((indexFlags & QuickHull3D.INDEXED_FROM_ZERO) === 0) {
                    indexFlags |= QuickHull3D.INDEXED_FROM_ONE;
                  }

                  for (var i = 0; i < this.numVertices; i++) {
                    {
                      var pnt = this.pointBuffer[this.vertexPointIndices[i]].pnt;
                      ps.println(pnt);
                    }
                  }

                  for (var index591 = this.faces.iterator(); index591.hasNext();) {
                    var face = index591.next();
                    {
                      var indices = function (s) {
                        var a = [];

                        while (s-- > 0) {
                          a.push(0);
                        }

                        return a;
                      }(face.numVertices());

                      this.getFaceIndices(indices, face, indexFlags);
                      ps.print("f");

                      for (var k = 0; k < indices.length; k++) {
                        {
                          ps.print(" " + indices[k]);
                        }
                      }

                      ps.println("");
                    }
                  }
                }
                /**
                * Prints the vertices and faces of this hull to the stream ps.
                *
                * <p>
                * This is done using the Alias Wavefront .obj file format, with the vertices
                * printed first (each preceding by the letter <code>v</code>), followed by the
                * vertex indices for each face (each preceded by the letter <code>f</code>).
                *
                * <p>
                * By default, the face indices are numbered with respect to the hull vertices
                * (as opposed to the input points), with a lowest index of 1, and are arranged
                * counter-clockwise. However, this can be changed by setting
                * {@link #POINT_RELATIVE}, {@link #INDEXED_FROM_ONE}, or {@link #CLOCKWISE} in the indexFlags
                * parameter.
                *
                * @param {java.io.PrintStream} ps
                * stream used for printing
                * @param {number} indexFlags
                * specifies index characteristics (0 results in the default).
                * @see QuickHull3D#getVertices()
                * @see QuickHull3D#getFaces()
                */

              }, {
                key: "print",
                value: function print(ps, indexFlags) {
                  if ((ps != null && ps instanceof java.io.PrintStream || ps === null) && (typeof indexFlags === 'number' || indexFlags === null)) {
                    return this.print$java_io_PrintStream$int(ps, indexFlags);
                  } else if ((ps != null && ps instanceof java.io.PrintStream || ps === null) && indexFlags === undefined) {
                    return this.print$java_io_PrintStream(ps);
                  } else throw new Error('invalid overload');
                }
                /*private*/

              }, {
                key: "getFaceIndices",
                value: function getFaceIndices(indices, face, flags) {
                  var ccw = (flags & QuickHull3D.CLOCKWISE) === 0;
                  var indexedFromOne = (flags & QuickHull3D.INDEXED_FROM_ONE) !== 0;
                  var pointRelative = (flags & QuickHull3D.POINT_RELATIVE) !== 0;
                  var hedge = face.he0;
                  var k = 0;

                  do {
                    {
                      var idx = hedge.head().index;

                      if (pointRelative) {
                        idx = this.vertexPointIndices[idx];
                      }

                      if (indexedFromOne) {
                        idx++;
                      }

                      indices[k++] = idx;
                      hedge = ccw ? hedge.next : hedge.prev;
                    }
                  } while (hedge !== face.he0);
                }
              }, {
                key: "resolveUnclaimedPoints",
                value: function resolveUnclaimedPoints(newFaces) {
                  var vtxNext = this.unclaimed.first();

                  for (var vtx = vtxNext; vtx != null; vtx = vtxNext) {
                    {
                      vtxNext = vtx.next;
                      var maxDist = 0;
                      var maxFace = null;

                      for (var index592 = newFaces.iterator(); index592.hasNext();) {
                        var newFace = index592.next();
                        {
                          if (newFace.mark === com.vzome.core.math.convexhull.Face.VISIBLE) {
                            var dist = newFace.distanceToPlane(vtx.pnt).evaluate();

                            if (dist > maxDist) {
                              maxDist = dist;
                              maxFace = newFace;
                            }

                            if (maxDist > 0) {
                              break;
                            }
                          }
                        }
                      }

                      if (maxFace != null) {
                        this.addPointToFace(vtx, maxFace);

                        if (this.debug && vtx.index === this.findIndex) {
                          console.info(this.findIndex + " CLAIMED BY " + maxFace.getVertexString());
                        }
                      } else {
                        if (this.debug && vtx.index === this.findIndex) {
                          console.info(this.findIndex + " DISCARDED");
                        }
                      }
                    }
                  }
                }
              }, {
                key: "deleteFacePoints",
                value: function deleteFacePoints(face, absorbingFace) {
                  var faceVtxs = this.removeAllPointsFromFace(face);

                  if (faceVtxs != null) {
                    if (absorbingFace == null) {
                      this.unclaimed.addAll(faceVtxs);
                    } else {
                      var vtxNext = faceVtxs;

                      for (var vtx = vtxNext; vtx != null; vtx = vtxNext) {
                        {
                          vtxNext = vtx.next;
                          var dist = absorbingFace.distanceToPlane(vtx.pnt).evaluate();

                          if (dist > 0) {
                            this.addPointToFace(vtx, absorbingFace);
                          } else {
                            this.unclaimed.add(vtx);
                          }
                        }
                      }
                    }
                  }
                }
              }, {
                key: "oppFaceDistance",
                value: function oppFaceDistance(he) {
                  return he.face.distanceToPlane(he.opposite.face.getCentroid());
                }
                /*private*/

              }, {
                key: "doAdjacentMerge",
                value: function doAdjacentMerge(face, mergeType) {
                  var hedge = face.he0;
                  var convex = true;

                  do {
                    {
                      var oppFace = hedge.oppositeFace();
                      var merge = false;
                      var tolerance = 0;

                      if (mergeType === QuickHull3D.NONCONVEX) {
                        if (this.oppFaceDistance(hedge).evaluate() > -tolerance || this.oppFaceDistance(hedge.opposite).evaluate() > -tolerance) {
                          merge = true;
                        }
                      } else {
                        if (face.area > oppFace.area) {
                          if (this.oppFaceDistance(hedge).evaluate() > -tolerance) {
                            merge = true;
                          } else if (this.oppFaceDistance(hedge.opposite).evaluate() > -tolerance) {
                            convex = false;
                          }
                        } else {
                          if (this.oppFaceDistance(hedge.opposite).evaluate() >= -tolerance) {
                            merge = true;
                          } else if (this.oppFaceDistance(hedge).evaluate() >= -tolerance) {
                            convex = false;
                          }
                        }
                      }

                      if (merge) {
                        if (this.debug) {
                          console.info("  merging " + face.getVertexString() + "  and  " + oppFace.getVertexString());
                        }

                        var numd = face.mergeAdjacentFace(hedge, this.discardedFaces);

                        for (var i = 0; i < numd; i++) {
                          {
                            this.deleteFacePoints(this.discardedFaces[i], face);
                          }
                        }

                        if (this.debug) {
                          console.info("  result: " + face.getVertexString());
                        }

                        return true;
                      }

                      hedge = hedge.next;
                    }
                  } while (hedge !== face.he0);

                  if (!convex) {
                    face.mark = com.vzome.core.math.convexhull.Face.NON_CONVEX;
                  }

                  return false;
                }
              }, {
                key: "calculateHorizon",
                value: function calculateHorizon(eyePnt, edge0, face, horizon) {
                  this.deleteFacePoints(face, null);
                  face.mark = com.vzome.core.math.convexhull.Face.DELETED;

                  if (this.debug) {
                    console.info("  visiting face " + face.getVertexString());
                  }

                  var edge;

                  if (edge0 == null) {
                    edge0 = face.getEdge(0);
                    edge = edge0;
                  } else {
                    edge = edge0.getNext();
                  }

                  var tolerance = 0;

                  do {
                    {
                      var oppFace = edge.oppositeFace();

                      if (oppFace.mark === com.vzome.core.math.convexhull.Face.VISIBLE) {
                        if (oppFace.distanceToPlane(eyePnt).evaluate() > tolerance) {
                          this.calculateHorizon(eyePnt, edge.getOpposite(), oppFace, horizon);
                        } else {
                          horizon.add(edge);

                          if (this.debug) {
                            console.info("  adding horizon edge " + edge.getVertexString());
                          }
                        }
                      }

                      edge = edge.getNext();
                    }
                  } while (edge !== edge0);
                }
                /*private*/

              }, {
                key: "addAdjoiningFace",
                value: function addAdjoiningFace(eyeVtx, he) {
                  var face = com.vzome.core.math.convexhull.Face.createTriangle$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex(eyeVtx, he.tail(), he.head());
                  this.faces.add(face);
                  face.getEdge(-1).setOpposite(he.getOpposite());
                  return face.getEdge(0);
                }
              }, {
                key: "addNewFaces",
                value: function addNewFaces(newFaces, eyeVtx, horizon) {
                  newFaces.clear();
                  var hedgeSidePrev = null;
                  var hedgeSideBegin = null;

                  for (var index593 = horizon.iterator(); index593.hasNext();) {
                    var horizonHe = index593.next();
                    {
                      var hedgeSide = this.addAdjoiningFace(eyeVtx, horizonHe);

                      if (this.debug) {
                        console.info("new face: " + hedgeSide.face.getVertexString());
                      }

                      if (hedgeSidePrev != null) {
                        hedgeSide.next.setOpposite(hedgeSidePrev);
                      } else {
                        hedgeSideBegin = hedgeSide;
                      }

                      newFaces.add(hedgeSide.getFace());
                      hedgeSidePrev = hedgeSide;
                    }
                  }

                  hedgeSideBegin.next.setOpposite(hedgeSidePrev);
                }
              }, {
                key: "nextPointToAdd",
                value: function nextPointToAdd() {
                  if (!this.claimed.isEmpty()) {
                    var eyeFace = this.claimed.first().face;
                    var eyeVtx = null;
                    var maxDist = 0;

                    for (var vtx = eyeFace.outside; vtx != null && vtx.face === eyeFace; vtx = vtx.next) {
                      {
                        var dist = eyeFace.distanceToPlane(vtx.pnt).evaluate();

                        if (dist > maxDist) {
                          maxDist = dist;
                          eyeVtx = vtx;
                        }
                      }
                    }

                    return eyeVtx;
                  } else {
                    return null;
                  }
                }
              }, {
                key: "addPointToHull",
                value: function addPointToHull(eyeVtx) {
                  var horizon = new java.util.Vector();
                  this.unclaimed.clear();

                  if (this.debug) {
                    console.info("Adding point: " + eyeVtx.index);
                    console.info(" which is " + eyeVtx.face.distanceToPlane(eyeVtx.pnt) + " above face " + eyeVtx.face.getVertexString());
                  }

                  this.removePointFromFace(eyeVtx, eyeVtx.face);
                  this.calculateHorizon(eyeVtx.pnt, null, eyeVtx.face, horizon);
                  this.newFaces.clear();
                  this.addNewFaces(this.newFaces, eyeVtx, horizon);

                  for (var index594 = this.newFaces.iterator(); index594.hasNext();) {
                    var face = index594.next();
                    {
                      if (face.mark === com.vzome.core.math.convexhull.Face.VISIBLE) {
                        while (this.doAdjacentMerge(face, QuickHull3D.NONCONVEX_WRT_LARGER_FACE)) {}
                      }
                    }
                  }

                  for (var index595 = this.newFaces.iterator(); index595.hasNext();) {
                    var _face3 = index595.next();

                    {
                      if (_face3.mark === com.vzome.core.math.convexhull.Face.NON_CONVEX) {
                        _face3.mark = com.vzome.core.math.convexhull.Face.VISIBLE;

                        while (this.doAdjacentMerge(_face3, QuickHull3D.NONCONVEX)) {}
                      }
                    }
                  }

                  this.resolveUnclaimedPoints(this.newFaces);
                }
              }, {
                key: "buildHull",
                value: function buildHull() {
                  var cnt = 0;
                  var eyeVtx;
                  this.computeMaxAndMin();
                  this.createInitialSimplex();

                  while ((eyeVtx = this.nextPointToAdd()) != null) {
                    {
                      this.addPointToHull(eyeVtx);
                      cnt++;

                      if (this.debug) {
                        console.info("iteration " + cnt + " done");
                      }
                    }
                  }

                  this.reindexFacesAndVertices();

                  if (this.debug) {
                    console.info("hull done");
                  }
                }
                /*private*/

              }, {
                key: "markFaceVertices",
                value: function markFaceVertices(face, mark) {
                  var he0 = face.getFirstEdge();
                  var he = he0;

                  do {
                    {
                      he.head().index = mark;
                      he = he.next;
                    }
                  } while (he !== he0);
                }
              }, {
                key: "reindexFacesAndVertices",
                value: function reindexFacesAndVertices() {
                  for (var i = 0; i < this.numPoints; i++) {
                    {
                      this.pointBuffer[i].index = -1;
                    }
                  }

                  this.numFaces = 0;

                  for (var it = this.faces.iterator(); it.hasNext();) {
                    {
                      var face = it.next();

                      if (face.mark !== com.vzome.core.math.convexhull.Face.VISIBLE) {
                        it.remove();
                      } else {
                        this.markFaceVertices(face, 0);
                        this.numFaces++;
                      }
                    }
                  }

                  this.numVertices = 0;

                  for (var _i9 = 0; _i9 < this.numPoints; _i9++) {
                    {
                      var vtx = this.pointBuffer[_i9];

                      if (vtx.index === 0) {
                        this.vertexPointIndices[this.numVertices] = _i9;
                        vtx.index = this.numVertices++;
                      }
                    }
                  }
                }
              }, {
                key: "checkFaceConvexity",
                value: function checkFaceConvexity(face, ps) {
                  var he = face.he0;

                  do {
                    {
                      face.checkConsistency();
                      var dist = this.oppFaceDistance(he);

                      if (!dist.isZero()) {
                        if (ps != null) {
                          ps.println("Edge " + he.getVertexString() + " non-convex by " + dist);
                        }

                        return false;
                      }

                      dist = this.oppFaceDistance(he.opposite);

                      if (!dist.isZero()) {
                        if (ps != null) {
                          ps.println("Opposite edge " + he.opposite.getVertexString() + " non-convex by " + dist);
                        }

                        return false;
                      }

                      if (he.next.oppositeFace() === he.oppositeFace()) {
                        if (ps != null) {
                          ps.println("Redundant vertex " + he.head().index + " in face " + face.getVertexString());
                        }

                        return false;
                      }

                      he = he.next;
                    }
                  } while (he !== face.he0);

                  return true;
                }
              }, {
                key: "checkFaces",
                value: function checkFaces(ps) {
                  var convex = true;

                  for (var index596 = this.faces.iterator(); index596.hasNext();) {
                    var face = index596.next();
                    {
                      if (face.mark === com.vzome.core.math.convexhull.Face.VISIBLE) {
                        if (!this.checkFaceConvexity(face, ps)) {
                          convex = false;
                        }
                      }
                    }
                  }

                  return convex;
                }
                /**
                * Checks the correctness of the hull. This is done by making sure that no faces
                * are non-convex and that no points are outside any face. These tests are
                * performed using the distance tolerance <i>tol</i>. Faces are considered
                * non-convex if any edge is non-convex, and an edge is non-convex if the
                * centroid of either adjoining face is more than <i>tol</i> above the plane of
                * the other face. Similarly, a point is considered outside a face if its
                * distance to that face's plane is more than 10 times <i>tol</i>.
                *
                * <p>
                * If the hull has been {@link #triangulate}, then this routine may
                * fail if some of the resulting triangles are very small or thin.
                *
                * @param {java.io.PrintStream} ps
                * print stream for diagnostic messages; may be set to
                * <code>null</code> if no messages are desired.
                * @return {boolean} true if the hull is valid
                * @throws Failure
                * @see QuickHull3D#check(PrintStream)
                */

              }, {
                key: "check",
                value: function check(ps) {
                  if (!this.checkFaces(ps)) {
                    return false;
                  }

                  for (var i = 0; i < this.numPoints; i++) {
                    {
                      var pnt = this.pointBuffer[i].pnt;

                      for (var index597 = this.faces.iterator(); index597.hasNext();) {
                        var face = index597.next();
                        {
                          if (face.mark === com.vzome.core.math.convexhull.Face.VISIBLE) {
                            var dist = face.distanceToPlane(pnt);

                            if (!dist.isZero()) {
                              if (ps != null) {
                                ps.println("Point " + i + " " + dist + " above face " + face.getVertexString());
                              }

                              return false;
                            }
                          }
                        }
                      }
                    }
                  }

                  return true;
                }
              }]);

              return QuickHull3D;
            }();
            /**
            * Specifies that (on output) vertex indices for a face should be listed in
            * clockwise order.
            */


            QuickHull3D.CLOCKWISE = 1;
            /**
            * Specifies that (on output) the vertex indices for a face should be numbered
            * starting from 1.
            */

            QuickHull3D.INDEXED_FROM_ONE = 2;
            /**
            * Specifies that (on output) the vertex indices for a face should be numbered
            * starting from 0.
            */

            QuickHull3D.INDEXED_FROM_ZERO = 4;
            /**
            * Specifies that (on output) the vertex indices for a face should be numbered
            * with respect to the original input points.
            */

            QuickHull3D.POINT_RELATIVE = 8;
            QuickHull3D.NONCONVEX_WRT_LARGER_FACE = 1;
            QuickHull3D.NONCONVEX = 2;
            convexhull.QuickHull3D = QuickHull3D;
            QuickHull3D["__class"] = "com.vzome.core.math.convexhull.QuickHull3D";
          })(math.convexhull || (math.convexhull = {}));
        })(core.math || (core.math = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (math) {
          (function (convexhull) {
            /**
            * Maintains a double-linked list of vertices for use by QuickHull3D
            * @class
            */
            var VertexList =
            /*#__PURE__*/
            function () {
              function VertexList() {
                _classCallCheck(this, VertexList);

                if (this.head === undefined) this.head = null;
                if (this.tail === undefined) this.tail = null;
              }
              /**
              * Clears this list.
              */


              _createClass(VertexList, [{
                key: "clear",
                value: function clear() {
                  this.head = this.tail = null;
                }
                /**
                * Adds a vertex to the end of this list.
                * @param {com.vzome.core.math.convexhull.Vertex} vtx
                */

              }, {
                key: "add",
                value: function add(vtx) {
                  if (this.head == null) {
                    this.head = vtx;
                  } else {
                    this.tail.next = vtx;
                  }

                  vtx.prev = this.tail;
                  vtx.next = null;
                  this.tail = vtx;
                }
                /**
                * Adds a chain of vertices to the end of this list.
                * @param {com.vzome.core.math.convexhull.Vertex} vtx
                */

              }, {
                key: "addAll",
                value: function addAll(vtx) {
                  if (this.head == null) {
                    this.head = vtx;
                  } else {
                    this.tail.next = vtx;
                  }

                  vtx.prev = this.tail;

                  while (vtx.next != null) {
                    {
                      vtx = vtx.next;
                    }
                  }

                  this.tail = vtx;
                }
              }, {
                key: "delete$com_vzome_core_math_convexhull_Vertex",
                value: function delete$com_vzome_core_math_convexhull_Vertex(vtx) {
                  if (vtx.prev == null) {
                    this.head = vtx.next;
                  } else {
                    vtx.prev.next = vtx.next;
                  }

                  if (vtx.next == null) {
                    this.tail = vtx.prev;
                  } else {
                    vtx.next.prev = vtx.prev;
                  }
                }
              }, {
                key: "delete$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex",
                value: function delete$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex(vtx1, vtx2) {
                  if (vtx1.prev == null) {
                    this.head = vtx2.next;
                  } else {
                    vtx1.prev.next = vtx2.next;
                  }

                  if (vtx2.next == null) {
                    this.tail = vtx1.prev;
                  } else {
                    vtx2.next.prev = vtx1.prev;
                  }
                }
                /**
                * Deletes a chain of vertices from this list.
                * @param {com.vzome.core.math.convexhull.Vertex} vtx1
                * @param {com.vzome.core.math.convexhull.Vertex} vtx2
                */

              }, {
                key: "delete",
                value: function _delete(vtx1, vtx2) {
                  if ((vtx1 != null && vtx1 instanceof com.vzome.core.math.convexhull.Vertex || vtx1 === null) && (vtx2 != null && vtx2 instanceof com.vzome.core.math.convexhull.Vertex || vtx2 === null)) {
                    return this.delete$com_vzome_core_math_convexhull_Vertex$com_vzome_core_math_convexhull_Vertex(vtx1, vtx2);
                  } else if ((vtx1 != null && vtx1 instanceof com.vzome.core.math.convexhull.Vertex || vtx1 === null) && vtx2 === undefined) {
                    return this.delete$com_vzome_core_math_convexhull_Vertex(vtx1);
                  } else throw new Error('invalid overload');
                }
                /**
                * Inserts a vertex into this list before another specificed vertex.
                * @param {com.vzome.core.math.convexhull.Vertex} vtx
                * @param {com.vzome.core.math.convexhull.Vertex} next
                */

              }, {
                key: "insertBefore",
                value: function insertBefore(vtx, next) {
                  vtx.prev = next.prev;

                  if (next.prev == null) {
                    this.head = vtx;
                  } else {
                    next.prev.next = vtx;
                  }

                  vtx.next = next;
                  next.prev = vtx;
                }
                /**
                * Returns the first element in this list.
                * @return {com.vzome.core.math.convexhull.Vertex}
                */

              }, {
                key: "first",
                value: function first() {
                  return this.head;
                }
                /**
                * Returns true if this list is empty.
                * @return {boolean}
                */

              }, {
                key: "isEmpty",
                value: function isEmpty() {
                  return this.head == null;
                }
              }]);

              return VertexList;
            }();

            convexhull.VertexList = VertexList;
            VertexList["__class"] = "com.vzome.core.math.convexhull.VertexList";
          })(math.convexhull || (math.convexhull = {}));
        })(core.math || (core.math = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (math) {
          (function (convexhull) {
            /**
            * Constructs a HalfEdge with head vertex <code>v</code> and left-hand
            * triangular face <code>f</code>.
            *
            * @param {com.vzome.core.math.convexhull.Vertex} v
            * head vertex
            * @param {com.vzome.core.math.convexhull.Face} f
            * left-hand triangular face
            * @class
            * @author John E. Lloyd, Fall 2004
            */
            var HalfEdge =
            /*#__PURE__*/
            function () {
              function HalfEdge(v, f) {
                var _this4 = this;

                _classCallCheck(this, HalfEdge);

                if ((v != null && v instanceof com.vzome.core.math.convexhull.Vertex || v === null) && (f != null && f instanceof com.vzome.core.math.convexhull.Face || f === null)) {
                  if (this.vertex === undefined) this.vertex = null;
                  if (this.face === undefined) this.face = null;
                  if (this.next === undefined) this.next = null;
                  if (this.prev === undefined) this.prev = null;
                  if (this.opposite === undefined) this.opposite = null;
                  if (this.vertex === undefined) this.vertex = null;
                  if (this.face === undefined) this.face = null;
                  if (this.next === undefined) this.next = null;
                  if (this.prev === undefined) this.prev = null;
                  if (this.opposite === undefined) this.opposite = null;

                  (function () {
                    _this4.vertex = v;
                    _this4.face = f;
                  })();
                } else if (v === undefined && f === undefined) {
                  if (this.vertex === undefined) this.vertex = null;
                  if (this.face === undefined) this.face = null;
                  if (this.next === undefined) this.next = null;
                  if (this.prev === undefined) this.prev = null;
                  if (this.opposite === undefined) this.opposite = null;
                  if (this.vertex === undefined) this.vertex = null;
                  if (this.face === undefined) this.face = null;
                  if (this.next === undefined) this.next = null;
                  if (this.prev === undefined) this.prev = null;
                  if (this.opposite === undefined) this.opposite = null;
                } else throw new Error('invalid overload');
              }
              /**
              * Sets the value of the next edge adjacent (counter-clockwise) to this one
              * within the triangle.
              *
              * @param {com.vzome.core.math.convexhull.HalfEdge} edge
              * next adjacent edge
              */


              _createClass(HalfEdge, [{
                key: "setNext",
                value: function setNext(edge) {
                  this.next = edge;
                }
                /**
                * Gets the value of the next edge adjacent (counter-clockwise) to this one
                * within the triangle.
                *
                * @return {com.vzome.core.math.convexhull.HalfEdge} next adjacent edge
                */

              }, {
                key: "getNext",
                value: function getNext() {
                  return this.next;
                }
                /**
                * Sets the value of the previous edge adjacent (clockwise) to this one within
                * the triangle.
                *
                * @param {com.vzome.core.math.convexhull.HalfEdge} edge
                * previous adjacent edge
                */

              }, {
                key: "setPrev",
                value: function setPrev(edge) {
                  this.prev = edge;
                }
                /**
                * Gets the value of the previous edge adjacent (clockwise) to this one within
                * the triangle.
                *
                * @return {com.vzome.core.math.convexhull.HalfEdge} previous adjacent edge
                */

              }, {
                key: "getPrev",
                value: function getPrev() {
                  return this.prev;
                }
                /**
                * Returns the triangular face located to the left of this half-edge.
                *
                * @return {com.vzome.core.math.convexhull.Face} left-hand triangular face
                */

              }, {
                key: "getFace",
                value: function getFace() {
                  return this.face;
                }
                /**
                * Returns the half-edge opposite to this half-edge.
                *
                * @return {com.vzome.core.math.convexhull.HalfEdge} opposite half-edge
                */

              }, {
                key: "getOpposite",
                value: function getOpposite() {
                  return this.opposite;
                }
                /**
                * Sets the half-edge opposite to this half-edge.
                *
                * @param {com.vzome.core.math.convexhull.HalfEdge} edge
                * opposite half-edge
                */

              }, {
                key: "setOpposite",
                value: function setOpposite(edge) {
                  this.opposite = edge;
                  edge.opposite = this;
                }
                /**
                * Returns the head vertex associated with this half-edge.
                *
                * @return {com.vzome.core.math.convexhull.Vertex} head vertex
                */

              }, {
                key: "head",
                value: function head() {
                  return this.vertex;
                }
                /**
                * Returns the tail vertex associated with this half-edge.
                *
                * @return {com.vzome.core.math.convexhull.Vertex} tail vertex
                */

              }, {
                key: "tail",
                value: function tail() {
                  return this.prev != null ? this.prev.vertex : null;
                }
                /**
                * Returns the opposite triangular face associated with this half-edge.
                *
                * @return {com.vzome.core.math.convexhull.Face} opposite triangular face
                */

              }, {
                key: "oppositeFace",
                value: function oppositeFace() {
                  return this.opposite == null ? null : this.opposite.face;
                }
                /**
                * Produces a string identifying this half-edge by the point index values of its
                * tail and head vertices.
                *
                * @return {string} identifying string
                */

              }, {
                key: "getVertexString",
                value: function getVertexString() {
                  if (this.tail() != null) {
                    return "" + this.tail().index + "-" + this.head().index;
                  } else {
                    return "?-" + this.head().index;
                  }
                }
                /**
                * Returns the length squared of this half-edge.
                *
                * @return {*} half-edge length squared
                */

              }, {
                key: "lengthSquared",
                value: function lengthSquared() {
                  if (this.tail() == null) {
                    return this.head().pnt.getField()['createRational$long'](-1);
                  }

                  var offset = this.head().pnt.minus(this.tail().pnt);
                  return offset.dot(offset);
                }
              }]);

              return HalfEdge;
            }();

            convexhull.HalfEdge = HalfEdge;
            HalfEdge["__class"] = "com.vzome.core.math.convexhull.HalfEdge";
          })(math.convexhull || (math.convexhull = {}));
        })(core.math || (core.math = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (math) {
          /**
          * @author Scott Vorthmann
          * @param {*} field
          * @class
          */
          var SixCubeProjection =
          /*#__PURE__*/
          function () {
            function SixCubeProjection(field) {
              _classCallCheck(this, SixCubeProjection);

              if (this.field === undefined) this.field = null;
              if (this.basis === undefined) this.basis = null;
              this.field = field;
              var zero = field.zero();
              var one = field.one();
              var nOne = one.negate();
              var phi = field['createPower$int'](1);
              this.basis = [null, null, null, null, null, null];
              this.basis[0] = new com.vzome.core.algebra.AlgebraicVector(phi, one, zero);
              this.basis[1] = new com.vzome.core.algebra.AlgebraicVector(phi, nOne, zero);
              this.basis[2] = new com.vzome.core.algebra.AlgebraicVector(zero, phi, one);
              this.basis[3] = new com.vzome.core.algebra.AlgebraicVector(zero, phi, nOne);
              this.basis[4] = new com.vzome.core.algebra.AlgebraicVector(one, zero, phi);
              this.basis[5] = new com.vzome.core.algebra.AlgebraicVector(nOne, zero, phi);
            }
            /**
            *
            * @param {com.vzome.core.algebra.AlgebraicVector} source
            * @param {boolean} wFirst
            * @return {com.vzome.core.algebra.AlgebraicVector}
            */


            _createClass(SixCubeProjection, [{
              key: "projectImage",
              value: function projectImage(source, wFirst) {
                var result = this.field.origin(this.basis[0].dimension());
                var pos = wFirst ? 0 : this.basis.length - 1;

                for (var index598 = 0; index598 < this.basis.length; index598++) {
                  var unitVector = this.basis[index598];
                  {
                    var scalar = source.getComponent(pos);
                    result = result.plus(unitVector.scale(scalar));
                    pos = (pos + 1) % this.basis.length;
                  }
                }

                return result;
              }
              /**
              *
              * @param {*} element
              */

            }, {
              key: "getXmlAttributes",
              value: function getXmlAttributes(element) {}
              /**
              *
              * @param {*} xml
              */

            }, {
              key: "setXmlAttributes",
              value: function setXmlAttributes(xml) {}
              /**
              *
              * @return {string}
              */

            }, {
              key: "getProjectionName",
              value: function getProjectionName() {
                return "SixCube";
              }
            }]);

            return SixCubeProjection;
          }();

          math.SixCubeProjection = SixCubeProjection;
          SixCubeProjection["__class"] = "com.vzome.core.math.SixCubeProjection";
          SixCubeProjection["__interfaces"] = ["com.vzome.core.math.Projection"];
        })(core.math || (core.math = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (math) {
          (function (symmetry) {
            var A4Group =
            /*#__PURE__*/
            function () {
              function A4Group(field) {
                _classCallCheck(this, A4Group);

                if (this.field === undefined) this.field = null;
                this.ROOTS = [null, null, null, null];
                this.WEIGHTS = [null, null, null, null];
                this.ROOTS_R4 = [null, null, null, null];
                if (this.ONE_FIFTH === undefined) this.ONE_FIFTH = null;
                if (this.TWO_FIFTHS === undefined) this.TWO_FIFTHS = null;
                if (this.THREE_FIFTHS === undefined) this.THREE_FIFTHS = null;
                if (this.FOUR_FIFTHS === undefined) this.FOUR_FIFTHS = null;
                this.field = field;
                this.ONE_FIFTH = field['createRational$long$long'](1, 5);
                this.TWO_FIFTHS = field['createRational$long$long'](2, 5);
                this.THREE_FIFTHS = field['createRational$long$long'](3, 5);
                this.FOUR_FIFTHS = field['createRational$long$long'](4, 5);
                var neg_one = field['createRational$long'](-1);
                this.ROOTS[0] = field.basisVector(5, 0);
                this.ROOTS[0].setComponent(1, neg_one);
                this.ROOTS[1] = field.basisVector(5, 1);
                this.ROOTS[1].setComponent(2, neg_one);
                this.ROOTS[2] = field.basisVector(5, 2);
                this.ROOTS[2].setComponent(3, neg_one);
                this.ROOTS[3] = field.basisVector(5, 3);
                this.ROOTS[3].setComponent(4, neg_one);
                this.WEIGHTS[0] = field.basisVector(5, 0);
                this.WEIGHTS[0].setComponent(0, this.FOUR_FIFTHS);
                this.WEIGHTS[0].setComponent(1, this.ONE_FIFTH.negate());
                this.WEIGHTS[0].setComponent(2, this.ONE_FIFTH.negate());
                this.WEIGHTS[0].setComponent(3, this.ONE_FIFTH.negate());
                this.WEIGHTS[0].setComponent(4, this.ONE_FIFTH.negate());
                this.WEIGHTS[1] = field.basisVector(5, 0);
                this.WEIGHTS[1].setComponent(0, this.THREE_FIFTHS);
                this.WEIGHTS[1].setComponent(1, this.THREE_FIFTHS);
                this.WEIGHTS[1].setComponent(2, this.TWO_FIFTHS.negate());
                this.WEIGHTS[1].setComponent(3, this.TWO_FIFTHS.negate());
                this.WEIGHTS[1].setComponent(4, this.TWO_FIFTHS.negate());
                this.WEIGHTS[2] = field.basisVector(5, 0);
                this.WEIGHTS[2].setComponent(0, this.TWO_FIFTHS);
                this.WEIGHTS[2].setComponent(1, this.TWO_FIFTHS);
                this.WEIGHTS[2].setComponent(2, this.TWO_FIFTHS);
                this.WEIGHTS[2].setComponent(3, this.THREE_FIFTHS.negate());
                this.WEIGHTS[2].setComponent(4, this.THREE_FIFTHS.negate());
                this.WEIGHTS[3] = field.basisVector(5, 0);
                this.WEIGHTS[3].setComponent(0, this.ONE_FIFTH);
                this.WEIGHTS[3].setComponent(1, this.ONE_FIFTH);
                this.WEIGHTS[3].setComponent(2, this.ONE_FIFTH);
                this.WEIGHTS[3].setComponent(3, this.ONE_FIFTH);
                this.WEIGHTS[3].setComponent(4, this.FOUR_FIFTHS.negate());
                var two = field['createRational$long'](2);
                var two_neg = field['createRational$long'](-2);
                this.ROOTS_R4[0] = field.basisVector(4, 1);
                this.ROOTS_R4[0].setComponent(1, two);
                this.ROOTS_R4[0].setComponent(2, two_neg);
                this.ROOTS_R4[1] = field.basisVector(4, 1);
                this.ROOTS_R4[1].setComponent(3, two_neg);
                this.ROOTS_R4[1].setComponent(1, two_neg);
                this.ROOTS_R4[2] = field.basisVector(4, 1);
                this.ROOTS_R4[2].setComponent(1, two);
                this.ROOTS_R4[2].setComponent(2, two);
                this.ROOTS_R4[3] = field.basisVector(4, 3);
                var root5 = field['createAlgebraicNumber$int$int$int$int'](-1, 2, 1, 0);
                this.ROOTS_R4[3].setComponent(1, neg_one);
                this.ROOTS_R4[3].setComponent(2, neg_one);
                this.ROOTS_R4[3].setComponent(0, root5);
              }

              _createClass(A4Group, [{
                key: "getOrder",

                /**
                *
                * @return {number}
                */
                value: function getOrder() {
                  return A4Group.S5_PERMS_$LI$().length;
                }
                /**
                *
                * @param {com.vzome.core.algebra.AlgebraicVector} model
                * @param {number} element
                * @return {com.vzome.core.algebra.AlgebraicVector}
                */

              }, {
                key: "groupAction",
                value: function groupAction(model, element) {
                  var result = this.field.origin(4);
                  var sum = this.field['createRational$long'](0);

                  for (var c = 0; c < 4; c++) {
                    {
                      var source = model.getComponent(A4Group.S5_PERMS_$LI$()[element][c]);
                      sum = sum['plus$com_vzome_core_algebra_AlgebraicNumber'](source);
                      var scaled = this.ROOTS_R4[c].scale(sum);
                      result = result.plus(scaled);
                    }
                  }

                  return result.scale(this.field['createPower$int'](-1));
                }
                /**
                *
                * @return {com.vzome.core.algebra.AlgebraicVector}
                */

              }, {
                key: "getOrigin",
                value: function getOrigin() {
                  return this.field.origin(5);
                }
                /**
                *
                * @param {number} i
                * @return {com.vzome.core.algebra.AlgebraicVector}
                */

              }, {
                key: "getWeight",
                value: function getWeight(i) {
                  return this.WEIGHTS[i];
                }
                /**
                *
                * @param {number} i
                * @return {com.vzome.core.algebra.AlgebraicVector}
                */

              }, {
                key: "getSimpleRoot",
                value: function getSimpleRoot(i) {
                  return this.ROOTS[i];
                }
                /**
                *
                * @return {*}
                */

              }, {
                key: "getField",
                value: function getField() {
                  return this.field;
                }
                /**
                *
                * @param {com.vzome.core.algebra.AlgebraicVector} model
                * @param {number} element
                * @return {com.vzome.core.algebra.AlgebraicVector}
                */

              }, {
                key: "chiralSubgroupAction",
                value: function chiralSubgroupAction(model, element) {
                  if (element >= 60) return null;
                  var result = this.field.origin(4);
                  var sum = this.field['createRational$long'](0);

                  for (var c = 0; c < 4; c++) {
                    {
                      var source = model.getComponent(A4Group.S5_PERMS_$LI$()[element][c]);
                      sum = sum['plus$com_vzome_core_algebra_AlgebraicNumber'](source);
                      var scaled = this.ROOTS_R4[c].scale(sum);
                      result = result.plus(scaled);
                    }
                  }

                  return result.scale(this.field['createPower$int'](-1));
                }
              }], [{
                key: "S5_PERMS_$LI$",
                value: function S5_PERMS_$LI$() {
                  if (A4Group.S5_PERMS == null) A4Group.S5_PERMS = [[0, 1, 2, 3, 4], [1, 2, 3, 4, 0], [2, 3, 4, 0, 1], [3, 4, 0, 1, 2], [4, 0, 1, 2, 3], [1, 2, 0, 3, 4], [2, 0, 3, 4, 1], [0, 3, 4, 1, 2], [3, 4, 1, 2, 0], [4, 1, 2, 0, 3], [0, 2, 3, 1, 4], [2, 3, 1, 4, 0], [3, 1, 4, 0, 2], [1, 4, 0, 2, 3], [4, 0, 2, 3, 1], [0, 1, 3, 4, 2], [1, 3, 4, 2, 0], [3, 4, 2, 0, 1], [4, 2, 0, 1, 3], [2, 0, 1, 3, 4], [3, 1, 2, 4, 0], [1, 2, 4, 0, 3], [2, 4, 0, 3, 1], [4, 0, 3, 1, 2], [0, 3, 1, 2, 4], [1, 4, 2, 3, 0], [4, 2, 3, 0, 1], [2, 3, 0, 1, 4], [3, 0, 1, 4, 2], [0, 1, 4, 2, 3], [1, 3, 2, 0, 4], [3, 2, 0, 4, 1], [2, 0, 4, 1, 3], [0, 4, 1, 3, 2], [4, 1, 3, 2, 0], [0, 2, 4, 3, 1], [2, 4, 3, 1, 0], [4, 3, 1, 0, 2], [3, 1, 0, 2, 4], [1, 0, 2, 4, 3], [2, 1, 3, 0, 4], [1, 3, 0, 4, 2], [3, 0, 4, 2, 1], [0, 4, 2, 1, 3], [4, 2, 1, 3, 0], [0, 3, 2, 4, 1], [3, 2, 4, 1, 0], [2, 4, 1, 0, 3], [4, 1, 0, 3, 2], [1, 0, 3, 2, 4], [2, 1, 4, 3, 0], [1, 4, 3, 0, 2], [4, 3, 0, 2, 1], [3, 0, 2, 1, 4], [0, 2, 1, 4, 3], [4, 3, 2, 1, 0], [3, 2, 1, 0, 4], [2, 1, 0, 4, 3], [1, 0, 4, 3, 2], [0, 4, 3, 2, 1], [0, 1, 3, 2, 4], [0, 2, 1, 3, 4], [0, 3, 2, 1, 4], [1, 0, 2, 3, 4], [1, 2, 3, 0, 4], [1, 3, 0, 2, 4], [2, 1, 0, 3, 4], [2, 0, 3, 1, 4], [2, 3, 1, 0, 4], [3, 1, 2, 0, 4], [3, 2, 0, 1, 4], [3, 0, 1, 2, 4], [0, 1, 2, 4, 3], [0, 2, 3, 4, 1], [0, 3, 1, 4, 2], [1, 0, 3, 4, 2], [1, 2, 0, 4, 3], [1, 3, 2, 4, 0], [2, 1, 3, 4, 0], [2, 0, 1, 4, 3], [2, 3, 0, 4, 1], [3, 1, 0, 4, 2], [3, 2, 1, 4, 0], [3, 0, 2, 4, 1], [0, 2, 4, 1, 3], [0, 3, 4, 2, 1], [1, 0, 4, 2, 3], [1, 2, 4, 3, 0], [1, 3, 4, 0, 2], [2, 1, 4, 0, 3], [2, 0, 4, 3, 1], [2, 3, 4, 1, 0], [3, 1, 4, 2, 0], [3, 2, 4, 0, 1], [3, 0, 4, 1, 2], [0, 4, 1, 2, 3], [0, 4, 2, 3, 1], [0, 4, 3, 1, 2], [1, 4, 0, 3, 2], [1, 4, 2, 0, 3], [1, 4, 3, 2, 0], [2, 4, 1, 3, 0], [2, 4, 0, 1, 3], [2, 4, 3, 0, 1], [3, 4, 1, 0, 2], [3, 4, 2, 1, 0], [3, 4, 0, 2, 1], [4, 0, 1, 3, 2], [4, 0, 2, 1, 3], [4, 0, 3, 2, 1], [4, 1, 0, 2, 3], [4, 1, 2, 3, 0], [4, 1, 3, 0, 2], [4, 2, 1, 0, 3], [4, 2, 0, 3, 1], [4, 2, 3, 1, 0], [4, 3, 1, 2, 0], [4, 3, 2, 0, 1], [0, 1, 4, 3, 2], [4, 3, 0, 1, 2]];
                  return A4Group.S5_PERMS;
                }
              }]);

              return A4Group;
            }();

            symmetry.A4Group = A4Group;
            A4Group["__class"] = "com.vzome.core.math.symmetry.A4Group";
            A4Group["__interfaces"] = ["com.vzome.core.math.symmetry.CoxeterGroup"];
          })(math.symmetry || (math.symmetry = {}));
        })(core.math || (core.math = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (math) {
          (function (symmetry) {
            var WythoffConstruction =
            /*#__PURE__*/
            function () {
              function WythoffConstruction() {
                _classCallCheck(this, WythoffConstruction);
              }

              _createClass(WythoffConstruction, null, [{
                key: "constructPolytope",
                value: function constructPolytope(group, index, edgesToRender, edgeScales, renderingGroup, listener) {
                  var neighbors = [null, null, null, null];
                  var origin = group.getOrigin();
                  var model = origin;
                  var bits = index;

                  for (var i = 0; i < 4; i++) {
                    {
                      if (bits % 2 === 1) model = model.plus(group.getWeight(i).scale(edgeScales[i]));
                      bits >>= 1;
                    }
                  }

                  bits = index;

                  for (var _i10 = 0; _i10 < 4; _i10++) {
                    {
                      if (bits % 2 === 1 && edgesToRender % 2 === 1) neighbors[_i10] = model.minus(group.getSimpleRoot(_i10).scale(edgeScales[_i10]));else neighbors[_i10] = origin;
                      bits >>= 1;
                      edgesToRender >>= 1;
                    }
                  }

                  var order = renderingGroup.getOrder();

                  for (var _i12 = 0; _i12 < order; _i12++) {
                    {
                      var _vector = renderingGroup.groupAction(model, _i12);

                      var p = listener.addVertex(_vector);

                      for (var _e = 0; _e < 4; _e++) {
                        {
                          if (neighbors[_e].equals(origin)) continue;
                          var other = renderingGroup.groupAction(neighbors[_e], _i12);

                          if (!other.equals(_vector)) {
                            var _p = listener.addVertex(other);

                            listener.addEdge(p, _p);
                          }
                        }
                      }
                    }
                  }
                }
              }]);

              return WythoffConstruction;
            }();

            symmetry.WythoffConstruction = WythoffConstruction;
            WythoffConstruction["__class"] = "com.vzome.core.math.symmetry.WythoffConstruction";

            (function (WythoffConstruction) {
              var VefPrinter =
              /*#__PURE__*/
              function () {
                function VefPrinter(field2) {
                  _classCallCheck(this, VefPrinter);

                  this.vefVertices = new java.lang.StringBuffer();
                  this.vefEdges = new java.lang.StringBuffer();
                  this.numEdges = 0;
                  this.numVertices = 0;
                  if (this.field === undefined) this.field = null;
                  this.field = field2;
                }
                /**
                *
                * @param {*} p1
                * @param {*} p2
                * @return {*}
                */


                _createClass(VefPrinter, [{
                  key: "addEdge",
                  value: function addEdge(p1, p2) {
                    this.vefEdges.append(p1 + "\t" + p2 + "\n");
                    ++this.numEdges;
                    return null;
                  }
                  /**
                  *
                  * @param {Array} vertices
                  * @return {*}
                  */

                }, {
                  key: "addFace",
                  value: function addFace(vertices) {
                    return null;
                  }
                  /**
                  *
                  * @param {com.vzome.core.algebra.AlgebraicVector} gv
                  * @return {*}
                  */

                }, {
                  key: "addVertex",
                  value: function addVertex(gv) {
                    gv.getVectorExpression$java_lang_StringBuffer$int(this.vefVertices, com.vzome.core.algebra.AlgebraicField.VEF_FORMAT);
                    this.vefVertices.append("\n");
                    return this.numVertices++;
                  }
                }, {
                  key: "print",
                  value: function print(out) {
                    out.println$java_lang_Object("vZome VEF 5");
                    out.println$java_lang_Object(this.numVertices);
                    out.println$java_lang_Object(this.vefVertices.toString());
                    out.println$java_lang_Object(this.numEdges);
                    out.println$java_lang_Object(this.vefEdges.toString());
                    out.close();
                  }
                }]);

                return VefPrinter;
              }();

              WythoffConstruction.VefPrinter = VefPrinter;
              VefPrinter["__class"] = "com.vzome.core.math.symmetry.WythoffConstruction.VefPrinter";
              VefPrinter["__interfaces"] = ["com.vzome.core.math.symmetry.WythoffConstruction.Listener"];
            })(WythoffConstruction = symmetry.WythoffConstruction || (symmetry.WythoffConstruction = {}));
          })(math.symmetry || (math.symmetry = {}));
        })(core.math || (core.math = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (math) {
          (function (symmetry) {
            var D4Group =
            /*#__PURE__*/
            function () {
              function D4Group(field) {
                _classCallCheck(this, D4Group);

                if (this.field === undefined) this.field = null;
                this.ROOTS = [null, null, null, null];
                this.WEIGHTS = [null, null, null, null];
                this.field = field;
                var neg_one = field['createRational$long'](-1);
                this.ROOTS[0] = field.basisVector(4, com.vzome.core.algebra.AlgebraicVector.X4);
                this.ROOTS[0].setComponent(com.vzome.core.algebra.AlgebraicVector.Y4, neg_one);
                this.ROOTS[1] = field.basisVector(4, com.vzome.core.algebra.AlgebraicVector.Y4);
                this.ROOTS[1].setComponent(com.vzome.core.algebra.AlgebraicVector.Z4, neg_one);
                this.ROOTS[2] = field.basisVector(4, com.vzome.core.algebra.AlgebraicVector.Z4);
                this.ROOTS[2].setComponent(com.vzome.core.algebra.AlgebraicVector.W4, neg_one);
                this.ROOTS[3] = field.basisVector(4, com.vzome.core.algebra.AlgebraicVector.Z4);
                this.ROOTS[3].setComponent(com.vzome.core.algebra.AlgebraicVector.W4, field['createPower$int'](0));
                var y = field.basisVector(4, com.vzome.core.algebra.AlgebraicVector.Y4);
                var half = field['createRational$long$long'](1, 2);
                var neg_half = field['createRational$long$long'](-1, 2);
                this.WEIGHTS[0] = field.basisVector(4, com.vzome.core.algebra.AlgebraicVector.X4);
                this.WEIGHTS[1] = this.WEIGHTS[0].plus(y);
                this.WEIGHTS[2] = field.basisVector(4, com.vzome.core.algebra.AlgebraicVector.X4);
                this.WEIGHTS[2].setComponent(com.vzome.core.algebra.AlgebraicVector.X4, half);
                this.WEIGHTS[2].setComponent(com.vzome.core.algebra.AlgebraicVector.Y4, half);
                this.WEIGHTS[2].setComponent(com.vzome.core.algebra.AlgebraicVector.Z4, half);
                this.WEIGHTS[2].setComponent(com.vzome.core.algebra.AlgebraicVector.W4, neg_half);
                this.WEIGHTS[3] = field.basisVector(4, com.vzome.core.algebra.AlgebraicVector.X4);
                this.WEIGHTS[3].setComponent(com.vzome.core.algebra.AlgebraicVector.X4, half);
                this.WEIGHTS[3].setComponent(com.vzome.core.algebra.AlgebraicVector.Y4, half);
                this.WEIGHTS[3].setComponent(com.vzome.core.algebra.AlgebraicVector.Z4, half);
                this.WEIGHTS[3].setComponent(com.vzome.core.algebra.AlgebraicVector.W4, half);
              }

              _createClass(D4Group, [{
                key: "getOrder",

                /**
                *
                * @return {number}
                */
                value: function getOrder() {
                  return 24 * 8;
                }
                /**
                *
                * @param {com.vzome.core.algebra.AlgebraicVector} model
                * @param {number} element
                * @return {com.vzome.core.algebra.AlgebraicVector}
                */

              }, {
                key: "groupAction",
                value: function groupAction(model, element) {
                  var result = this.field.basisVector(4, com.vzome.core.algebra.AlgebraicVector.X4);
                  var perm = element / 8 | 0;
                  var signs = element % 8;
                  var even = true;

                  for (var c = 0; c < 4; c++) {
                    {
                      var source = model.getComponent((D4Group.D4_PERMS_$LI$()[perm][c] + 1) % 4);

                      if (c === 3 && !even) {
                        source = source.negate();
                      } else if (signs % 2 !== 0) {
                        even = !even;
                        source = source.negate();
                      }

                      result.setComponent((c + 1) % 4, source);
                      signs = signs >> 1;
                    }
                  }

                  return result;
                }
                /**
                *
                * @return {com.vzome.core.algebra.AlgebraicVector}
                */

              }, {
                key: "getOrigin",
                value: function getOrigin() {
                  return this.field.origin(4);
                }
                /**
                *
                * @param {number} i
                * @return {com.vzome.core.algebra.AlgebraicVector}
                */

              }, {
                key: "getWeight",
                value: function getWeight(i) {
                  return this.WEIGHTS[i];
                }
                /**
                *
                * @param {number} i
                * @return {com.vzome.core.algebra.AlgebraicVector}
                */

              }, {
                key: "getSimpleRoot",
                value: function getSimpleRoot(i) {
                  return this.ROOTS[i];
                }
                /**
                *
                * @return {*}
                */

              }, {
                key: "getField",
                value: function getField() {
                  return this.field;
                }
                /**
                *
                * @param {com.vzome.core.algebra.AlgebraicVector} model
                * @param {number} element
                * @return {com.vzome.core.algebra.AlgebraicVector}
                */

              }, {
                key: "chiralSubgroupAction",
                value: function chiralSubgroupAction(model, element) {
                  var result = this.field.basisVector(4, com.vzome.core.algebra.AlgebraicVector.X4);
                  var perm = element / 8 | 0;
                  if (perm >= 12) return null;
                  var signs = element % 8;
                  var even = true;

                  for (var c = 0; c < 4; c++) {
                    {
                      var source = model.getComponent((D4Group.D4_PERMS_$LI$()[perm][c] + 1) % 4);

                      if (c === 3 && !even) {
                        source = source.negate();
                      } else if (signs % 2 !== 0) {
                        even = !even;
                        source = source.negate();
                      }

                      result.setComponent((c + 1) % 4, source);
                      signs = signs >> 1;
                    }
                  }

                  return result;
                }
              }], [{
                key: "D4_PERMS_$LI$",
                value: function D4_PERMS_$LI$() {
                  if (D4Group.D4_PERMS == null) D4Group.D4_PERMS = [[0, 1, 2, 3], [2, 3, 0, 1], [1, 0, 3, 2], [3, 2, 1, 0], [2, 1, 3, 0], [3, 0, 2, 1], [1, 2, 0, 3], [0, 3, 1, 2], [0, 2, 3, 1], [3, 1, 0, 2], [2, 0, 1, 3], [1, 3, 2, 0], [1, 0, 2, 3], [2, 3, 1, 0], [0, 1, 3, 2], [3, 2, 0, 1], [0, 2, 1, 3], [1, 3, 0, 2], [2, 0, 3, 1], [3, 1, 2, 0], [2, 1, 0, 3], [0, 3, 2, 1], [1, 2, 3, 0], [3, 0, 1, 2]];
                  return D4Group.D4_PERMS;
                }
              }]);

              return D4Group;
            }();

            symmetry.D4Group = D4Group;
            D4Group["__class"] = "com.vzome.core.math.symmetry.D4Group";
            D4Group["__interfaces"] = ["com.vzome.core.math.symmetry.CoxeterGroup"];
          })(math.symmetry || (math.symmetry = {}));
        })(core.math || (core.math = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (math) {
          (function (symmetry) {
            var Permutation =
            /*#__PURE__*/
            function () {
              function Permutation(group, map) {
                _classCallCheck(this, Permutation);

                if (this.m_map === undefined) this.m_map = null;
                this.m_order = 1;
                if (this.mSymmetryGroup === undefined) this.mSymmetryGroup = null;
                this.mSymmetryGroup = group;

                if (map == null) {
                  var numUnits = group.getChiralOrder();

                  map = function (s) {
                    var a = [];

                    while (s-- > 0) {
                      a.push(0);
                    }

                    return a;
                  }(numUnits);

                  for (var _unit = 0; _unit < numUnits; _unit++) {
                    map[_unit] = _unit;
                  }
                }

                this.m_map = map;
                var unit = 0;

                for (var i = 0; i < 20; i++) {
                  {
                    unit = this.m_map[unit];

                    if (unit === 0) {
                      this.m_order = i + 1;
                      break;
                    }
                  }
                }
              }

              _createClass(Permutation, [{
                key: "getJsonValue",
                value: function getJsonValue() {
                  return this.m_map;
                }
                /**
                *
                * @return {string}
                */

              }, {
                key: "toString",
                value: function toString() {
                  return "permutation #" + this.mapIndex(0);
                }
              }, {
                key: "getOrder",
                value: function getOrder() {
                  return this.m_order;
                }
                /**
                * Composition, where p1.compose( p2 ) .permute(axis)  == p1.permute( p2.permute( axis ) )
                * @param {com.vzome.core.math.symmetry.Permutation} other
                * @return {com.vzome.core.math.symmetry.Permutation}
                */

              }, {
                key: "compose",
                value: function compose(other) {
                  return this.mSymmetryGroup.getPermutation(this.m_map[other.m_map[0]]);
                }
              }, {
                key: "inverse",
                value: function inverse() {
                  for (var i = 0; i < this.m_map.length; i++) {
                    if (this.mapIndex(i) === 0) return this.mSymmetryGroup.getPermutation(i);
                  }

                  return null;
                }
              }, {
                key: "power",
                value: function power(_power) {
                  if (_power === 0) return this.mSymmetryGroup.getPermutation(0);
                  var base = this;

                  if (_power < 0) {
                    base = this.inverse();
                    _power *= -1;
                  }

                  if (_power === 1) return base;
                  return base.compose(base.power(_power - 1));
                }
              }, {
                key: "mapIndex",
                value: function mapIndex(i) {
                  if (i < 0 || i >= this.m_map.length) return com.vzome.core.math.symmetry.Symmetry.NO_ROTATION;
                  return this.m_map[i];
                }
              }, {
                key: "permute",
                value: function permute(axis, sense) {
                  var orn = axis.getOrientation();
                  orn = this.mapIndex(orn);
                  return axis.getDirection().getAxis$int$int((sense + axis.getSense()) % 2, orn);
                }
              }]);

              return Permutation;
            }();

            symmetry.Permutation = Permutation;
            Permutation["__class"] = "com.vzome.core.math.symmetry.Permutation";
          })(math.symmetry || (math.symmetry = {}));
        })(core.math || (core.math = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (math) {
          (function (symmetry_1) {
            var OrbitDotLocator =
            /*#__PURE__*/
            function () {
              function OrbitDotLocator(symmetry, worldTriangle) {
                _classCallCheck(this, OrbitDotLocator);

                if (this.worldTrianglePoint === undefined) this.worldTrianglePoint = null;
                if (this.worldTriangleNormal === undefined) this.worldTriangleNormal = null;
                if (this.dotTransform === undefined) this.dotTransform = null;
                if (this.orbitProbe === undefined) this.orbitProbe = null;
                if (this.symmetry === undefined) this.symmetry = null;
                if (this.debugger === undefined) this.debugger = null;
                if (this.field === undefined) this.field = null;
                if (this.vefDebugOutput === undefined) this.vefDebugOutput = null;
                this.symmetry = symmetry;
                this.field = symmetry.getField();
                var oldMatrix = new com.vzome.core.algebra.AlgebraicMatrix(worldTriangle);
                var X = this.field.basisVector(3, com.vzome.core.algebra.AlgebraicVector.X);
                var Y = this.field.basisVector(3, com.vzome.core.algebra.AlgebraicVector.Y);
                var Z = this.field.basisVector(3, com.vzome.core.algebra.AlgebraicVector.Z);
                var viewTriangle = [Z, X.plus(Z), Y.plus(Z)];
                var newMatrix = new com.vzome.core.algebra.AlgebraicMatrix(viewTriangle);
                this.dotTransform = newMatrix.times(oldMatrix.inverse());
                var blueVertex = worldTriangle[0];
                var redVertex = worldTriangle[1];
                var yellowVertex = worldTriangle[2];
                this.orbitProbe = redVertex.plus(yellowVertex.plus(blueVertex)).toRealVector();
                this.worldTrianglePoint = blueVertex;
                this.worldTriangleNormal = com.vzome.core.algebra.AlgebraicVectors.getNormal$java_util_Collection(java.util.Arrays.asList(worldTriangle));

                if (this.debugger != null) {
                  this.debugger.exportSegment(this.field.origin(3), redVertex);
                  this.debugger.exportPoint(redVertex);
                  this.debugger.exportSegment(this.field.origin(3), yellowVertex);
                  this.debugger.exportPoint(yellowVertex);
                  this.debugger.exportSegment(this.field.origin(3), blueVertex);
                  this.debugger.exportPoint(blueVertex);
                  this.debugger.exportPolygon(java.util.Arrays.asList(worldTriangle));
                  this.debugger.exportPolygon(java.util.Arrays.asList(viewTriangle));
                  this.debugger.exportSegment(blueVertex, this.worldTriangleNormal);
                }
              }

              _createClass(OrbitDotLocator, [{
                key: "enableDebugger",
                value: function enableDebugger() {
                  this.vefDebugOutput = new java.io.StringWriter();
                  this.debugger = new com.vzome.core.algebra.VefVectorExporter(this.vefDebugOutput, this.field);
                }
              }, {
                key: "locateOrbitDot",
                value: function locateOrbitDot(orbit) {
                  var dotZone = this.symmetry['getAxis$com_vzome_core_math_RealVector$java_util_Set'](this.orbitProbe, java.util.Collections.singleton(orbit)).normal();
                  var lineStart = this.field.origin(3);
                  var worldDot = com.vzome.core.algebra.AlgebraicVectors.getLinePlaneIntersection(lineStart, dotZone, this.worldTrianglePoint, this.worldTriangleNormal);
                  var viewDot = this.dotTransform.timesColumn(worldDot);
                  var dotX = viewDot.getComponent(com.vzome.core.algebra.AlgebraicVector.X).evaluate();
                  var dotY = viewDot.getComponent(com.vzome.core.algebra.AlgebraicVector.Y).evaluate();
                  orbit.setDotLocation(dotX, dotY);

                  if (this.debugger != null) {
                    this.debugger.exportSegment(this.field.origin(3), dotZone);
                    this.debugger.exportPoint(worldDot);
                    this.debugger.exportPoint(viewDot);
                  }
                }
              }, {
                key: "getDebuggerOutput",
                value: function getDebuggerOutput() {
                  this.debugger.finishExport();
                  this.debugger = null;
                  return this.vefDebugOutput.toString();
                }
              }]);

              return OrbitDotLocator;
            }();

            symmetry_1.OrbitDotLocator = OrbitDotLocator;
            OrbitDotLocator["__class"] = "com.vzome.core.math.symmetry.OrbitDotLocator";
          })(math.symmetry || (math.symmetry = {}));
        })(core.math || (core.math = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (math) {
          (function (symmetry) {
            /**
            * Should be called Zone, an infinite family of parallel lines, one member of an orbit (Direction)
            * of a Symmetry group.
            * @class
            */
            var Axis =
            /*#__PURE__*/
            function () {
              function Axis(dir, index, sense, rotation, rotPerm, normal, outbound) {
                var _this5 = this;

                _classCallCheck(this, Axis);

                if ((dir != null && dir instanceof com.vzome.core.math.symmetry.Direction || dir === null) && (typeof index === 'number' || index === null) && (typeof sense === 'number' || sense === null) && (typeof rotation === 'number' || rotation === null) && (rotPerm != null && rotPerm instanceof com.vzome.core.math.symmetry.Permutation || rotPerm === null) && (normal != null && normal instanceof com.vzome.core.algebra.AlgebraicVector || normal === null) && (typeof outbound === 'boolean' || outbound === null)) {
                  if (this.mDirection === undefined) this.mDirection = null;
                  if (this.orientation === undefined) this.orientation = 0;
                  if (this.mSense === undefined) this.mSense = 0;
                  if (this.mRotationPerm === undefined) this.mRotationPerm = null;
                  if (this.mRotation === undefined) this.mRotation = 0;
                  if (this.__normal === undefined) this.__normal = null;
                  this.outbound = true;
                  if (this.mDirection === undefined) this.mDirection = null;
                  if (this.orientation === undefined) this.orientation = 0;
                  if (this.mSense === undefined) this.mSense = 0;
                  this.outbound = true;
                  if (this.mRotationPerm === undefined) this.mRotationPerm = null;
                  if (this.mRotation === undefined) this.mRotation = 0;
                  if (this.__normal === undefined) this.__normal = null;

                  (function () {
                    _this5.mDirection = dir;
                    _this5.mRotation = rotation;
                    _this5.mRotationPerm = rotPerm;
                    _this5.orientation = index;
                    _this5.__normal = normal;
                    _this5.mSense = sense;
                    _this5.outbound = outbound;
                  })();
                } else if ((dir != null && dir instanceof com.vzome.core.math.symmetry.Direction || dir === null) && (typeof index === 'number' || index === null) && (typeof sense === 'number' || sense === null) && (typeof rotation === 'number' || rotation === null) && (rotPerm != null && rotPerm instanceof com.vzome.core.math.symmetry.Permutation || rotPerm === null) && (normal != null && normal instanceof com.vzome.core.algebra.AlgebraicVector || normal === null) && outbound === undefined) {
                  {
                    var _outbound = true;
                    if (this.mDirection === undefined) this.mDirection = null;
                    if (this.orientation === undefined) this.orientation = 0;
                    if (this.mSense === undefined) this.mSense = 0;
                    if (this.mRotationPerm === undefined) this.mRotationPerm = null;
                    if (this.mRotation === undefined) this.mRotation = 0;
                    if (this.__normal === undefined) this.__normal = null;
                    this.outbound = true;
                    if (this.mDirection === undefined) this.mDirection = null;
                    if (this.orientation === undefined) this.orientation = 0;
                    if (this.mSense === undefined) this.mSense = 0;
                    this.outbound = true;
                    if (this.mRotationPerm === undefined) this.mRotationPerm = null;
                    if (this.mRotation === undefined) this.mRotation = 0;
                    if (this.__normal === undefined) this.__normal = null;

                    (function () {
                      _this5.mDirection = dir;
                      _this5.mRotation = rotation;
                      _this5.mRotationPerm = rotPerm;
                      _this5.orientation = index;
                      _this5.__normal = normal;
                      _this5.mSense = sense;
                      _this5.outbound = _outbound;
                    })();
                  }
                } else throw new Error('invalid overload');
              }
              /**
              * Return the normal vector for this axis.
              * Note that this vector may not have length=1.0, but it will have length
              * equal to one "unit" for this axis.
              * @return {com.vzome.core.algebra.AlgebraicVector} AlgebraicVector
              */


              _createClass(Axis, [{
                key: "normal",
                value: function normal() {
                  return this.__normal;
                }
              }, {
                key: "isOutbound",
                value: function isOutbound() {
                  return this.outbound;
                }
              }, {
                key: "getLength",
                value: function getLength(vector) {
                  return vector.getLength(this.__normal);
                }
                /**
                *
                * @return {number}
                */

              }, {
                key: "hashCode",
                value: function hashCode() {
                  var prime = 31;
                  var result = 1;
                  result = prime * result + (this.mDirection == null ? 0 :
                  /* hashCode */
                  function (o) {
                    if (o.hashCode) {
                      return o.hashCode();
                    } else {
                      return o.toString().split('').reduce(function (prevHash, currVal) {
                        return (prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0;
                      }, 0);
                    }
                  }(this.mDirection));
                  result = prime * result + this.mSense;
                  result = prime * result + (this.__normal == null ? 0 :
                  /* hashCode */
                  function (o) {
                    if (o.hashCode) {
                      return o.hashCode();
                    } else {
                      return o.toString().split('').reduce(function (prevHash, currVal) {
                        return (prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0;
                      }, 0);
                    }
                  }(this.__normal));
                  return result;
                }
                /**
                *
                * @param {*} obj
                * @return {boolean}
                */

              }, {
                key: "equals",
                value: function equals(obj) {
                  if (this === obj) return true;
                  if (obj == null) return false;
                  if (this.constructor !== obj.constructor) return false;
                  var other = obj;

                  if (this.mDirection == null) {
                    if (other.mDirection != null) return false;
                  } else if (!this.mDirection.equals(other.mDirection)) return false;

                  if (this.mSense !== other.mSense) return false;

                  if (this.__normal == null) {
                    if (other.__normal != null) return false;
                  } else if (!this.__normal.equals(other.__normal)) return false;

                  return true;
                }
                /**
                *
                * @return {string}
                */

              }, {
                key: "toString",
                value: function toString() {
                  return this.mDirection.toString() + " " + (this.mSense === com.vzome.core.math.symmetry.Symmetry.PLUS ? "+" : "-") + this.orientation + (this.outbound ? "" : "i");
                }
              }, {
                key: "getOrbit",
                value: function getOrbit() {
                  return this.mDirection;
                }
              }, {
                key: "getDirection",
                value: function getDirection() {
                  return this.mDirection;
                }
              }, {
                key: "getOrientation",
                value: function getOrientation() {
                  return this.orientation;
                }
              }, {
                key: "getRotation",
                value: function getRotation() {
                  return this.mRotation;
                }
              }, {
                key: "getCorrectRotation",
                value: function getCorrectRotation() {
                  return this.mRotationPerm == null ? com.vzome.core.math.symmetry.Symmetry.NO_ROTATION : this.mRotationPerm.mapIndex(0);
                }
              }, {
                key: "getRotationPermutation",
                value: function getRotationPermutation() {
                  return this.mRotationPerm;
                }
              }, {
                key: "getSense",
                value: function getSense() {
                  return this.mSense;
                }
                /**
                * @param plus
                * @param {number} orientation2
                * @param {boolean} outbound
                * @param {number} sense
                */

              }, {
                key: "rename",
                value: function rename(sense, orientation2, outbound) {
                  this.mSense = sense;
                  this.orientation = orientation2;
                  this.outbound = outbound;
                }
              }, {
                key: "getXML",
                value: function getXML(elem) {
                  com.vzome.xml.DomUtils.addAttribute(elem, "symm", this.mDirection.getSymmetry().getName());
                  com.vzome.xml.DomUtils.addAttribute(elem, "dir", this.mDirection.getName());
                  com.vzome.xml.DomUtils.addAttribute(elem, "index",
                  /* toString */
                  '' + this.orientation);
                  if (this.mSense !== com.vzome.core.math.symmetry.Symmetry.PLUS) com.vzome.xml.DomUtils.addAttribute(elem, "sense", "minus");
                }
              }]);

              return Axis;
            }();

            Axis.PLUS = 0;
            Axis.MINUS = 1;
            symmetry.Axis = Axis;
            Axis["__class"] = "com.vzome.core.math.symmetry.Axis";
          })(math.symmetry || (math.symmetry = {}));
        })(core.math || (core.math = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (math) {
          (function (symmetry) {
            /**
            * @author Scott Vorthmann
            * @param {com.vzome.core.math.symmetry.Direction} dir
            * @param {string} name
            * @class
            */
            var DirectionNaming =
            /*#__PURE__*/
            function () {
              function DirectionNaming(dir, name) {
                _classCallCheck(this, DirectionNaming);

                if (this.mName === undefined) this.mName = null;
                if (this.mDirection === undefined) this.mDirection = null;
                this.mName = name;
                this.mDirection = dir;
              }

              _createClass(DirectionNaming, [{
                key: "getName$",
                value: function getName$() {
                  return this.mName;
                }
                /**
                * Default behavior.
                * @param {string} axisName
                * @return
                * @return {com.vzome.core.math.symmetry.Axis}
                */

              }, {
                key: "getAxis",
                value: function getAxis(axisName) {
                  return this.mDirection.getAxis$int$int(this.getSign(axisName), this.getInteger(axisName));
                }
              }, {
                key: "getSign",
                value: function getSign(axisName) {
                  if (
                  /* startsWith */
                  function (str, searchString) {
                    var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                    return str.substr(position, searchString.length) === searchString;
                  }(axisName, "-")) return com.vzome.core.math.symmetry.Symmetry.MINUS;
                  return com.vzome.core.math.symmetry.Symmetry.PLUS;
                }
              }, {
                key: "getInteger",
                value: function getInteger(axisName) {
                  if (
                  /* startsWith */
                  function (str, searchString) {
                    var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                    return str.substr(position, searchString.length) === searchString;
                  }(axisName, "-") ||
                  /* startsWith */
                  function (str, searchString) {
                    var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                    return str.substr(position, searchString.length) === searchString;
                  }(axisName, "+")) return javaemul.internal.IntegerHelper.parseInt(axisName.substring(1));
                  return javaemul.internal.IntegerHelper.parseInt(axisName);
                }
              }, {
                key: "getName$com_vzome_core_math_symmetry_Axis",
                value: function getName$com_vzome_core_math_symmetry_Axis(axis) {
                  var sign = DirectionNaming.SIGN_$LI$()[axis.getSense()];
                  return sign + axis.getOrientation();
                }
              }, {
                key: "getName",
                value: function getName(axis) {
                  if (axis != null && axis instanceof com.vzome.core.math.symmetry.Axis || axis === null) {
                    return this.getName$com_vzome_core_math_symmetry_Axis(axis);
                  } else if (axis === undefined) {
                    return this.getName$();
                  } else throw new Error('invalid overload');
                }
              }, {
                key: "getFullName",
                value: function getFullName(axis) {
                  return this.mName + " " + this.getName$com_vzome_core_math_symmetry_Axis(axis);
                }
              }, {
                key: "getDirection",
                value: function getDirection() {
                  return this.mDirection;
                }
              }], [{
                key: "SIGN_$LI$",
                value: function SIGN_$LI$() {
                  if (DirectionNaming.SIGN == null) DirectionNaming.SIGN = ["+", "-"];
                  return DirectionNaming.SIGN;
                }
              }]);

              return DirectionNaming;
            }();

            symmetry.DirectionNaming = DirectionNaming;
            DirectionNaming["__class"] = "com.vzome.core.math.symmetry.DirectionNaming";
          })(math.symmetry || (math.symmetry = {}));
        })(core.math || (core.math = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (math) {
          (function (symmetry) {
            /**
            * @author Scott Vorthmann
            * @class
            */
            var AbstractSymmetry =
            /*#__PURE__*/
            function () {
              function AbstractSymmetry(order, field, frameColor, principalReflection) {
                var _this6 = this;

                _classCallCheck(this, AbstractSymmetry);

                if ((typeof order === 'number' || order === null) && (field != null && (field["__interfaces"] != null && field["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicField") >= 0 || field.constructor != null && field.constructor["__interfaces"] != null && field.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicField") >= 0) || field === null) && (typeof frameColor === 'string' || frameColor === null) && (principalReflection != null && principalReflection instanceof com.vzome.core.algebra.AlgebraicMatrix || principalReflection === null)) {
                  if (this.mOrientations === undefined) this.mOrientations = null;
                  if (this.mMatrices === undefined) this.mMatrices = null;
                  if (this.mField === undefined) this.mField = null;
                  if (this.dotLocator === undefined) this.dotLocator = null;
                  this.mDirectionMap = new java.util.HashMap();
                  this.mDirectionList = new java.util.ArrayList();
                  this.orbitSet = new com.vzome.core.math.symmetry.OrbitSet(this);
                  this.principalReflection = null;
                  this.mDirectionMap = new java.util.HashMap();
                  this.mDirectionList = new java.util.ArrayList();
                  this.orbitSet = new com.vzome.core.math.symmetry.OrbitSet(this);
                  if (this.mOrientations === undefined) this.mOrientations = null;
                  if (this.mMatrices === undefined) this.mMatrices = null;
                  if (this.mField === undefined) this.mField = null;
                  this.principalReflection = null;
                  if (this.dotLocator === undefined) this.dotLocator = null;

                  (function () {
                    _this6.mField = field;
                    _this6.principalReflection = principalReflection;

                    _this6.mOrientations = function (s) {
                      var a = [];

                      while (s-- > 0) {
                        a.push(null);
                      }

                      return a;
                    }(order);

                    _this6.mMatrices = function (s) {
                      var a = [];

                      while (s-- > 0) {
                        a.push(null);
                      }

                      return a;
                    }(order);

                    _this6.createInitialPermutations();

                    var done = false;

                    while (!done) {
                      {
                        done = true;

                        for (var i = 1; i < order; i++) {
                          {
                            var p1 = _this6.mOrientations[i];

                            if (p1 == null) {
                              done = false;
                              continue;
                            }

                            done = true;

                            for (var j = 1; j < order; j++) {
                              {
                                var p2 = _this6.mOrientations[j];

                                if (p2 == null) {
                                  done = false;
                                  continue;
                                }

                                var result = p1.mapIndex(p2.mapIndex(0));
                                if (_this6.mOrientations[result] != null) continue;

                                var map = function (s) {
                                  var a = [];

                                  while (s-- > 0) {
                                    a.push(0);
                                  }

                                  return a;
                                }(order);

                                for (var k = 0; k < order; k++) {
                                  map[k] = p1.mapIndex(p2.mapIndex(k));
                                }

                                _this6.mOrientations[result] = new com.vzome.core.math.symmetry.Permutation(_this6, map);
                              }
                            }

                            if (done) break;
                          }
                        }
                      }
                    }

                    _this6.createFrameOrbit(frameColor);

                    _this6.createOtherOrbits();
                  })();
                } else if ((typeof order === 'number' || order === null) && (field != null && (field["__interfaces"] != null && field["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicField") >= 0 || field.constructor != null && field.constructor["__interfaces"] != null && field.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicField") >= 0) || field === null) && (typeof frameColor === 'string' || frameColor === null) && principalReflection === undefined) {
                  {
                    var _principalReflection = null;
                    if (this.mOrientations === undefined) this.mOrientations = null;
                    if (this.mMatrices === undefined) this.mMatrices = null;
                    if (this.mField === undefined) this.mField = null;
                    if (this.dotLocator === undefined) this.dotLocator = null;
                    this.mDirectionMap = new java.util.HashMap();
                    this.mDirectionList = new java.util.ArrayList();
                    this.orbitSet = new com.vzome.core.math.symmetry.OrbitSet(this);
                    this.principalReflection = null;
                    this.mDirectionMap = new java.util.HashMap();
                    this.mDirectionList = new java.util.ArrayList();
                    this.orbitSet = new com.vzome.core.math.symmetry.OrbitSet(this);
                    if (this.mOrientations === undefined) this.mOrientations = null;
                    if (this.mMatrices === undefined) this.mMatrices = null;
                    if (this.mField === undefined) this.mField = null;
                    this.principalReflection = null;
                    if (this.dotLocator === undefined) this.dotLocator = null;

                    (function () {
                      _this6.mField = field;
                      _this6.principalReflection = _principalReflection;

                      _this6.mOrientations = function (s) {
                        var a = [];

                        while (s-- > 0) {
                          a.push(null);
                        }

                        return a;
                      }(order);

                      _this6.mMatrices = function (s) {
                        var a = [];

                        while (s-- > 0) {
                          a.push(null);
                        }

                        return a;
                      }(order);

                      _this6.createInitialPermutations();

                      var done = false;

                      while (!done) {
                        {
                          done = true;

                          for (var i = 1; i < order; i++) {
                            {
                              var p1 = _this6.mOrientations[i];

                              if (p1 == null) {
                                done = false;
                                continue;
                              }

                              done = true;

                              for (var j = 1; j < order; j++) {
                                {
                                  var p2 = _this6.mOrientations[j];

                                  if (p2 == null) {
                                    done = false;
                                    continue;
                                  }

                                  var result = p1.mapIndex(p2.mapIndex(0));
                                  if (_this6.mOrientations[result] != null) continue;

                                  var map = function (s) {
                                    var a = [];

                                    while (s-- > 0) {
                                      a.push(0);
                                    }

                                    return a;
                                  }(order);

                                  for (var k = 0; k < order; k++) {
                                    map[k] = p1.mapIndex(p2.mapIndex(k));
                                  }

                                  _this6.mOrientations[result] = new com.vzome.core.math.symmetry.Permutation(_this6, map);
                                }
                              }

                              if (done) break;
                            }
                          }
                        }
                      }

                      _this6.createFrameOrbit(frameColor);

                      _this6.createOtherOrbits();
                    })();
                  }
                } else throw new Error('invalid overload');
              }
              /**
              *
              * @return {*}
              */


              _createClass(AbstractSymmetry, [{
                key: "getField",
                value: function getField() {
                  return this.mField;
                }
                /**
                *
                * @return {com.vzome.core.math.symmetry.Axis}
                */

              }, {
                key: "getPreferredAxis",
                value: function getPreferredAxis() {
                  return null;
                }
              }, {
                key: "createZoneOrbit$java_lang_String$int$int$int_A_A",
                value: function createZoneOrbit$java_lang_String$int$int$int_A_A(name, prototype, rotatedPrototype, norm) {
                  var aNorm = this.mField.createVector(norm);
                  return this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector$boolean(name, prototype, rotatedPrototype, aNorm, false);
                }
              }, {
                key: "createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector",
                value: function createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector(name, prototype, rotatedPrototype, norm) {
                  return this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector$boolean(name, prototype, rotatedPrototype, norm, false);
                }
              }, {
                key: "createZoneOrbit$java_lang_String$int$int$int_A_A$boolean",
                value: function createZoneOrbit$java_lang_String$int$int$int_A_A$boolean(name, prototype, rotatedPrototype, norm, standard) {
                  var aNorm = this.mField.createVector(norm);
                  return this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector$boolean$boolean(name, prototype, rotatedPrototype, aNorm, standard, false);
                }
              }, {
                key: "createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector$boolean",
                value: function createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector$boolean(name, prototype, rotatedPrototype, norm, standard) {
                  return this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector$boolean$boolean(name, prototype, rotatedPrototype, norm, standard, false);
                }
              }, {
                key: "createZoneOrbit$java_lang_String$int$int$int_A_A$boolean$boolean",
                value: function createZoneOrbit$java_lang_String$int$int$int_A_A$boolean$boolean(name, prototype, rotatedPrototype, norm, standard, halfSizes) {
                  var aNorm = this.mField.createVector(norm);
                  return this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector$boolean$boolean$com_vzome_core_algebra_AlgebraicNumber(name, prototype, rotatedPrototype, aNorm, standard, false, null);
                }
              }, {
                key: "createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector$boolean$boolean",
                value: function createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector$boolean$boolean(name, prototype, rotatedPrototype, norm, standard, halfSizes) {
                  return this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector$boolean$boolean$com_vzome_core_algebra_AlgebraicNumber(name, prototype, rotatedPrototype, norm, standard, false, this.mField.one());
                }
              }, {
                key: "createZoneOrbit$java_lang_String$int$int$int_A_A$boolean$boolean$com_vzome_core_algebra_AlgebraicNumber",
                value: function createZoneOrbit$java_lang_String$int$int$int_A_A$boolean$boolean$com_vzome_core_algebra_AlgebraicNumber(name, prototype, rotatedPrototype, norm, standard, halfSizes, unitLength) {
                  var aNorm = this.mField.createVector(norm);
                  return this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector$boolean$boolean$com_vzome_core_algebra_AlgebraicNumber(name, prototype, rotatedPrototype, aNorm, standard, halfSizes, unitLength);
                }
              }, {
                key: "createZoneOrbit",
                value: function createZoneOrbit(name, prototype, rotatedPrototype, norm, standard, halfSizes, unitLength) {
                  if ((typeof name === 'string' || name === null) && (typeof prototype === 'number' || prototype === null) && (typeof rotatedPrototype === 'number' || rotatedPrototype === null) && (norm != null && norm instanceof Array && (norm.length == 0 || norm[0] == null || norm[0] instanceof Array) || norm === null) && (typeof standard === 'boolean' || standard === null) && (typeof halfSizes === 'boolean' || halfSizes === null) && (unitLength != null && (unitLength["__interfaces"] != null && unitLength["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0 || unitLength.constructor != null && unitLength.constructor["__interfaces"] != null && unitLength.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0) || unitLength === null)) {
                    return this.createZoneOrbit$java_lang_String$int$int$int_A_A$boolean$boolean$com_vzome_core_algebra_AlgebraicNumber(name, prototype, rotatedPrototype, norm, standard, halfSizes, unitLength);
                  } else if ((typeof name === 'string' || name === null) && (typeof prototype === 'number' || prototype === null) && (typeof rotatedPrototype === 'number' || rotatedPrototype === null) && (norm != null && norm instanceof com.vzome.core.algebra.AlgebraicVector || norm === null) && (typeof standard === 'boolean' || standard === null) && (typeof halfSizes === 'boolean' || halfSizes === null) && (unitLength != null && (unitLength["__interfaces"] != null && unitLength["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0 || unitLength.constructor != null && unitLength.constructor["__interfaces"] != null && unitLength.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0) || unitLength === null)) {
                    return this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector$boolean$boolean$com_vzome_core_algebra_AlgebraicNumber(name, prototype, rotatedPrototype, norm, standard, halfSizes, unitLength);
                  } else if ((typeof name === 'string' || name === null) && (typeof prototype === 'number' || prototype === null) && (typeof rotatedPrototype === 'number' || rotatedPrototype === null) && (norm != null && norm instanceof Array && (norm.length == 0 || norm[0] == null || norm[0] instanceof Array) || norm === null) && (typeof standard === 'boolean' || standard === null) && (typeof halfSizes === 'boolean' || halfSizes === null) && unitLength === undefined) {
                    return this.createZoneOrbit$java_lang_String$int$int$int_A_A$boolean$boolean(name, prototype, rotatedPrototype, norm, standard, halfSizes);
                  } else if ((typeof name === 'string' || name === null) && (typeof prototype === 'number' || prototype === null) && (typeof rotatedPrototype === 'number' || rotatedPrototype === null) && (norm != null && norm instanceof com.vzome.core.algebra.AlgebraicVector || norm === null) && (typeof standard === 'boolean' || standard === null) && (typeof halfSizes === 'boolean' || halfSizes === null) && unitLength === undefined) {
                    return this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector$boolean$boolean(name, prototype, rotatedPrototype, norm, standard, halfSizes);
                  } else if ((typeof name === 'string' || name === null) && (typeof prototype === 'number' || prototype === null) && (typeof rotatedPrototype === 'number' || rotatedPrototype === null) && (norm != null && norm instanceof Array && (norm.length == 0 || norm[0] == null || norm[0] instanceof Array) || norm === null) && (typeof standard === 'boolean' || standard === null) && halfSizes === undefined && unitLength === undefined) {
                    return this.createZoneOrbit$java_lang_String$int$int$int_A_A$boolean(name, prototype, rotatedPrototype, norm, standard);
                  } else if ((typeof name === 'string' || name === null) && (typeof prototype === 'number' || prototype === null) && (typeof rotatedPrototype === 'number' || rotatedPrototype === null) && (norm != null && norm instanceof com.vzome.core.algebra.AlgebraicVector || norm === null) && (typeof standard === 'boolean' || standard === null) && halfSizes === undefined && unitLength === undefined) {
                    return this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector$boolean(name, prototype, rotatedPrototype, norm, standard);
                  } else if ((typeof name === 'string' || name === null) && (typeof prototype === 'number' || prototype === null) && (typeof rotatedPrototype === 'number' || rotatedPrototype === null) && (norm != null && norm instanceof Array && (norm.length == 0 || norm[0] == null || norm[0] instanceof Array) || norm === null) && standard === undefined && halfSizes === undefined && unitLength === undefined) {
                    return this.createZoneOrbit$java_lang_String$int$int$int_A_A(name, prototype, rotatedPrototype, norm);
                  } else if ((typeof name === 'string' || name === null) && (typeof prototype === 'number' || prototype === null) && (typeof rotatedPrototype === 'number' || rotatedPrototype === null) && (norm != null && norm instanceof com.vzome.core.algebra.AlgebraicVector || norm === null) && standard === undefined && halfSizes === undefined && unitLength === undefined) {
                    return this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector(name, prototype, rotatedPrototype, norm);
                  } else throw new Error('invalid overload');
                }
              }, {
                key: "createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector$boolean$boolean$com_vzome_core_algebra_AlgebraicNumber",
                value: function createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector$boolean$boolean$com_vzome_core_algebra_AlgebraicNumber(name, prototype, rotatedPrototype, norm, standard, halfSizes, unitLength) {
                  var existingDir = this.mDirectionMap.get(name);

                  if (existingDir != null) {
                    this.mDirectionMap.remove(name);
                    this.orbitSet.remove(existingDir);
                    this.mDirectionList.remove(existingDir);
                  }

                  var orbit = new com.vzome.core.math.symmetry.Direction(name, this, prototype, rotatedPrototype, norm, standard);
                  if (halfSizes) orbit.setHalfSizes(true);
                  orbit.setUnitLength(unitLength);
                  this.mDirectionMap.put(orbit.getName(), orbit);
                  this.mDirectionList.add(orbit);
                  this.orbitSet.add(orbit);
                  if (this.dotLocator != null) this.dotLocator.locateOrbitDot(orbit);
                  return orbit;
                }
                /**
                *
                * @param {string} name
                * @param {number} prototype
                * @param {number} rotatedPrototype
                * @param {com.vzome.core.algebra.AlgebraicVector} norm
                * @return {com.vzome.core.math.symmetry.Direction}
                */

              }, {
                key: "createNewZoneOrbit",
                value: function createNewZoneOrbit(name, prototype, rotatedPrototype, norm) {
                  var orbit = new com.vzome.core.math.symmetry.Direction(name, this, prototype, rotatedPrototype, norm, false).withCorrection();
                  if (this.dotLocator != null) this.dotLocator.locateOrbitDot(orbit);
                  return orbit;
                }
                /**
                *
                * @return {com.vzome.core.math.symmetry.OrbitSet}
                */

              }, {
                key: "getOrbitSet",
                value: function getOrbitSet() {
                  return this.orbitSet;
                }
                /**
                * @param unit
                * @param rot
                * @return
                * @param {number} from
                * @param {number} to
                * @return {number}
                */

              }, {
                key: "getMapping",
                value: function getMapping(from, to) {
                  if (to === com.vzome.core.math.symmetry.Symmetry.NO_ROTATION) return com.vzome.core.math.symmetry.Symmetry.NO_ROTATION;

                  for (var p = 0; p < this.mOrientations.length; p++) {
                    if (this.mOrientations[p].mapIndex(from) === to) return p;
                  }

                  return com.vzome.core.math.symmetry.Symmetry.NO_ROTATION;
                }
              }, {
                key: "mapAxis",
                value: function mapAxis(from, to) {
                  return this.mapAxes([from], [to]);
                }
              }, {
                key: "mapAxes",
                value: function mapAxes(from, to) {
                  if (from.length !== to.length) throw new AbstractSymmetry.MismatchedAxes("must map to equal number of axes");
                  if (from.length > 3) throw new AbstractSymmetry.MismatchedAxes("must map three or fewer axes");

                  for (var i = 0; i < from.length; i++) {
                    if (from[i].getDirection().equals(to[i].getDirection())) throw new AbstractSymmetry.MismatchedAxes("must map between same color axes");
                  }

                  var result = [null];
                  return result[0];
                }
                /**
                *
                * @return {*}
                */

              }, {
                key: "iterator",
                value: function iterator() {
                  return this.mDirectionList.iterator();
                }
                /**
                * @deprecated Consider using a JDK-5 for-loop if possible. Otherwise use {@link #iterator()} instead.
                * @return {*}
                */

              }, {
                key: "getDirections",
                value: function getDirections() {
                  return this.iterator();
                }
              }, {
                key: "getAxis$com_vzome_core_algebra_AlgebraicVector",
                value: function getAxis$com_vzome_core_algebra_AlgebraicVector(vector) {
                  return this.getAxis$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_math_symmetry_OrbitSet(vector, this.orbitSet);
                }
              }, {
                key: "getAxis$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_math_symmetry_OrbitSet",
                value: function getAxis$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_math_symmetry_OrbitSet(vector, orbits) {
                  if (vector.isOrigin()) {
                    return null;
                  }

                  var canonicalOrbit = this.getSpecialOrbit(symmetry.Symmetry.SpecialOrbit.BLACK);
                  if (canonicalOrbit == null) for (var index599 = orbits.iterator(); index599.hasNext();) {
                    var dir = index599.next();
                    {
                      var candidate = dir.getAxis$com_vzome_core_algebra_AlgebraicVector(vector);

                      if (candidate != null) {
                        return candidate;
                      }
                    }
                  } else {
                    var zone = canonicalOrbit.getAxis$com_vzome_core_math_RealVector(vector.toRealVector());
                    var orientation = zone.getOrientation();
                    var sense = zone.getSense();

                    for (var index600 = orbits.iterator(); index600.hasNext();) {
                      var orbit = index600.next();
                      {
                        var _candidate = orbit.getCanonicalAxis(sense, orientation);

                        if (com.vzome.core.algebra.AlgebraicVectors.areParallel(_candidate.normal(), vector)) {
                          return _candidate;
                        }
                      }
                    }
                  }
                  return null;
                }
                /**
                *
                * @param {com.vzome.core.algebra.AlgebraicVector} vector
                * @param {com.vzome.core.math.symmetry.OrbitSet} orbits
                * @return {com.vzome.core.math.symmetry.Axis}
                */

              }, {
                key: "getAxis",
                value: function getAxis(vector, orbits) {
                  if ((vector != null && vector instanceof com.vzome.core.algebra.AlgebraicVector || vector === null) && (orbits != null && orbits instanceof com.vzome.core.math.symmetry.OrbitSet || orbits === null)) {
                    return this.getAxis$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_math_symmetry_OrbitSet(vector, orbits);
                  } else if ((vector != null && vector instanceof com.vzome.core.math.RealVector || vector === null) && (orbits != null && (orbits["__interfaces"] != null && orbits["__interfaces"].indexOf("java.util.Set") >= 0 || orbits.constructor != null && orbits.constructor["__interfaces"] != null && orbits.constructor["__interfaces"].indexOf("java.util.Set") >= 0) || orbits === null)) {
                    return this.getAxis$com_vzome_core_math_RealVector$java_util_Set(vector, orbits);
                  } else if ((vector != null && vector instanceof com.vzome.core.algebra.AlgebraicVector || vector === null) && orbits === undefined) {
                    return this.getAxis$com_vzome_core_algebra_AlgebraicVector(vector);
                  } else throw new Error('invalid overload');
                }
              }, {
                key: "getAxis$com_vzome_core_math_RealVector$java_util_Set",
                value: function getAxis$com_vzome_core_math_RealVector$java_util_Set(vector, dirMask) {
                  if (com.vzome.core.math.RealVector.ORIGIN_$LI$().equals(vector)) {
                    return null;
                  }

                  var maxCosine = -1.0;
                  var closest = null;
                  var orientation = -1;
                  var sense = -1;
                  var chiralOrbit = this.getSpecialOrbit(symmetry.Symmetry.SpecialOrbit.BLACK);

                  if (chiralOrbit != null) {
                    var closestChiralAxis = chiralOrbit.getChiralAxis(vector);
                    orientation = closestChiralAxis.getOrientation();
                    sense = closestChiralAxis.getSense();
                  }

                  var dirs = dirMask == null ? this.orbitSet.iterator() : dirMask.iterator();

                  while (dirs.hasNext()) {
                    {
                      var dir = dirs.next();
                      var axis = orientation >= 0 ? dir.getCanonicalAxis(sense, orientation) : dir.getAxisBruteForce(vector);
                      var axisV = axis.normal().toRealVector();
                      var cosine = vector.dot(axisV) / (vector.length() * axisV.length());

                      if (cosine > maxCosine) {
                        maxCosine = cosine;
                        closest = axis;
                      }
                    }
                  }

                  return closest;
                }
                /**
                *
                * @return {number}
                */

              }, {
                key: "getChiralOrder",
                value: function getChiralOrder() {
                  return this.mOrientations.length;
                }
                /**
                *
                * @param {number} i
                * @return {com.vzome.core.math.symmetry.Permutation}
                */

              }, {
                key: "getPermutation",
                value: function getPermutation(i) {
                  if (i < 0 || i > this.mOrientations.length) return null;
                  return this.mOrientations[i];
                }
              }, {
                key: "getPermutations",
                value: function getPermutations() {
                  return this.mOrientations;
                }
                /**
                *
                * @param {number} i
                * @return {com.vzome.core.algebra.AlgebraicMatrix}
                */

              }, {
                key: "getMatrix",
                value: function getMatrix(i) {
                  return this.mMatrices[i];
                }
              }, {
                key: "getMatrices",
                value: function getMatrices() {
                  return this.mMatrices;
                }
                /**
                *
                * @param {number} orientation
                * @return {number}
                */

              }, {
                key: "inverse",
                value: function inverse(orientation) {
                  if (orientation < 0 || orientation > this.mOrientations.length) return com.vzome.core.math.symmetry.Symmetry.NO_ROTATION;
                  return this.mOrientations[orientation].inverse().mapIndex(0);
                }
                /**
                *
                * @param {string} color
                * @return {com.vzome.core.math.symmetry.Direction}
                */

              }, {
                key: "getDirection",
                value: function getDirection(color) {
                  return this.mDirectionMap.get(color);
                }
                /**
                *
                * @return {Array}
                */

              }, {
                key: "getDirectionNames",
                value: function getDirectionNames() {
                  var list = new java.util.ArrayList();

                  for (var index601 = this.mDirectionList.iterator(); index601.hasNext();) {
                    var dir = index601.next();
                    {
                      if (!dir.isAutomatic()) list.add(dir.getName());
                    }
                  }

                  return list.toArray([]);
                }
                /**
                *
                * @param {Array} perms
                * @return {Array}
                */

              }, {
                key: "closure",
                value: function closure(perms) {
                  var newPerms = new java.util.ArrayList();

                  var knownPerms = function (s) {
                    var a = [];

                    while (s-- > 0) {
                      a.push(null);
                    }

                    return a;
                  }(this.mOrientations.length);

                  var closureSize = 0;

                  for (var i = 0; i < perms.length; i++) {
                    {
                      var perm = this.mOrientations[perms[i]];
                      knownPerms[perms[i]] = perm;
                      newPerms.add(perm);
                      ++closureSize;
                    }
                  }

                  while (!newPerms.isEmpty()) {
                    {
                      var _perm = newPerms.remove(0);

                      for (var index602 = 0; index602 < knownPerms.length; index602++) {
                        var knownPerm = knownPerms[index602];
                        {
                          if (knownPerm != null) {
                            var composition = _perm.compose(knownPerm);

                            var _j = composition.mapIndex(0);

                            if (knownPerms[_j] == null) {
                              newPerms.add(composition);
                              knownPerms[_j] = composition;
                              ++closureSize;
                            }

                            composition = knownPerm.compose(_perm);
                            _j = composition.mapIndex(0);

                            if (knownPerms[_j] == null) {
                              newPerms.add(composition);
                              knownPerms[_j] = composition;
                              ++closureSize;
                            }
                          }
                        }
                      }
                    }
                  }

                  var result = function (s) {
                    var a = [];

                    while (s-- > 0) {
                      a.push(0);
                    }

                    return a;
                  }(closureSize);

                  var j = 0;

                  for (var _i13 = 0; _i13 < knownPerms.length; _i13++) {
                    {
                      if (knownPerms[_i13] != null) {
                        result[j++] = _i13;
                      }
                    }
                  }

                  return result;
                }
                /**
                *
                * @param {number} orientation
                * @return {Array}
                */

              }, {
                key: "getIncidentOrientations",
                value: function getIncidentOrientations(orientation) {
                  return null;
                }
                /**
                *
                * @param {com.vzome.core.algebra.AlgebraicVector} v
                * @return {com.vzome.core.math.RealVector}
                */

              }, {
                key: "embedInR3",
                value: function embedInR3(v) {
                  return v.toRealVector();
                }
                /**
                *
                * @return {boolean}
                */

              }, {
                key: "isTrivial",
                value: function isTrivial() {
                  return true;
                }
                /**
                *
                * @return {com.vzome.core.algebra.AlgebraicMatrix}
                */

              }, {
                key: "getPrincipalReflection",
                value: function getPrincipalReflection() {
                  return this.principalReflection;
                }
              }, {
                key: "getOrbitTriangle",
                value: function getOrbitTriangle() {
                  var blueVertex = this.getSpecialOrbit(symmetry.Symmetry.SpecialOrbit.BLUE).getPrototype();
                  var redVertex = this.getSpecialOrbit(symmetry.Symmetry.SpecialOrbit.RED).getPrototype();
                  var yellowVertex = this.getSpecialOrbit(symmetry.Symmetry.SpecialOrbit.YELLOW).getPrototype();
                  return [blueVertex, redVertex, yellowVertex];
                }
                /**
                *
                * @return {string}
                */

              }, {
                key: "computeOrbitDots",
                value: function computeOrbitDots() {
                  this.dotLocator = new com.vzome.core.math.symmetry.OrbitDotLocator(this, this.getOrbitTriangle());

                  for (var index603 = this.mDirectionList.iterator(); index603.hasNext();) {
                    var orbit = index603.next();
                    {
                      this.dotLocator.locateOrbitDot(orbit);
                    }
                  }

                  return null;
                }
                /**
                *
                * @return {boolean}
                */

              }, {
                key: "reverseOrbitTriangle",
                value: function reverseOrbitTriangle() {
                  return false;
                }
              }]);

              return AbstractSymmetry;
            }();

            symmetry.AbstractSymmetry = AbstractSymmetry;
            AbstractSymmetry["__class"] = "com.vzome.core.math.symmetry.AbstractSymmetry";
            AbstractSymmetry["__interfaces"] = ["com.vzome.core.math.symmetry.Symmetry", "java.lang.Iterable", "com.vzome.core.math.symmetry.Embedding"];

            (function (AbstractSymmetry) {
              var MismatchedAxes =
              /*#__PURE__*/
              function (_java$lang$RuntimeExc) {
                _inherits(MismatchedAxes, _java$lang$RuntimeExc);

                var _super2 = _createSuper(MismatchedAxes);

                function MismatchedAxes(message) {
                  var _this7;

                  _classCallCheck(this, MismatchedAxes);

                  _this7 = _super2.call(this, message);
                  Object.setPrototypeOf(_assertThisInitialized(_this7), MismatchedAxes.prototype);
                  return _this7;
                }

                return MismatchedAxes;
              }(java.lang.RuntimeException);

              MismatchedAxes.serialVersionUID = 2610579323321804987;
              AbstractSymmetry.MismatchedAxes = MismatchedAxes;
              MismatchedAxes["__class"] = "com.vzome.core.math.symmetry.AbstractSymmetry.MismatchedAxes";
              MismatchedAxes["__interfaces"] = ["java.io.Serializable"];
            })(AbstractSymmetry = symmetry.AbstractSymmetry || (symmetry.AbstractSymmetry = {}));
          })(math.symmetry || (math.symmetry = {}));
        })(core.math || (core.math = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (math) {
          (function (symmetry) {
            (function (Embedding) {
              var Trivial =
              /*#__PURE__*/
              function () {
                _createClass(Trivial, [{
                  key: "embedInR3",

                  /**
                  *
                  * @param {com.vzome.core.algebra.AlgebraicVector} v
                  * @return {com.vzome.core.math.RealVector}
                  */
                  value: function embedInR3(v) {
                    return v.toRealVector();
                  }
                  /**
                  *
                  * @return {boolean}
                  */

                }, {
                  key: "isTrivial",
                  value: function isTrivial() {
                    return true;
                  }
                }]);

                function Trivial() {
                  _classCallCheck(this, Trivial);
                }

                return Trivial;
              }();

              Embedding.Trivial = Trivial;
              Trivial["__class"] = "com.vzome.core.math.symmetry.Embedding.Trivial";
              Trivial["__interfaces"] = ["com.vzome.core.math.symmetry.Embedding"];
            })(symmetry.Embedding || (symmetry.Embedding = {}));
          })(math.symmetry || (math.symmetry = {}));
        })(core.math || (core.math = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (math) {
          (function (symmetry_2) {
            var OrbitSet =
            /*#__PURE__*/
            function (_java$util$TreeSet) {
              _inherits(OrbitSet, _java$util$TreeSet);

              var _super3 = _createSuper(OrbitSet);

              function OrbitSet(symmetry) {
                var _this8;

                _classCallCheck(this, OrbitSet);

                _this8 = _super3.call(this);
                if (_this8.symmetry === undefined) _this8.symmetry = null;
                _this8.symmetry = symmetry;
                return _this8;
              }

              _createClass(OrbitSet, [{
                key: "getSymmetry",
                value: function getSymmetry() {
                  return this.symmetry;
                }
              }, {
                key: "getAxis",
                value: function getAxis(vector) {
                  return this.symmetry['getAxis$com_vzome_core_math_RealVector$java_util_Set'](vector, this);
                }
              }, {
                key: "getDirection",
                value: function getDirection(name) {
                  for (var index604 = this.iterator(); index604.hasNext();) {
                    var dir = index604.next();
                    {
                      if (
                      /* equals */
                      function (o1, o2) {
                        if (o1 && o1.equals) {
                          return o1.equals(o2);
                        } else {
                          return o1 === o2;
                        }
                      }(dir.getName(), name)) return dir;
                    }
                  }

                  return null;
                }
              }]);

              return OrbitSet;
            }(java.util.TreeSet);

            symmetry_2.OrbitSet = OrbitSet;
            OrbitSet["__class"] = "com.vzome.core.math.symmetry.OrbitSet";
            OrbitSet["__interfaces"] = ["java.lang.Cloneable", "java.util.SortedSet", "java.util.Collection", "java.util.Set", "java.util.NavigableSet", "java.lang.Iterable", "java.io.Serializable"];

            (function (OrbitSet) {
              var OrbitComparator =
              /*#__PURE__*/
              function () {
                function OrbitComparator(__parent) {
                  _classCallCheck(this, OrbitComparator);

                  this.__parent = __parent;
                  this.names = this.__parent.getSymmetry().getDirectionNames();
                }
                /**
                *
                * @param {com.vzome.core.math.symmetry.Direction} dir1
                * @param {com.vzome.core.math.symmetry.Direction} dir2
                * @return {number}
                */


                _createClass(OrbitComparator, [{
                  key: "compare",
                  value: function compare(dir1, dir2) {
                    var name1 = dir1.getName();
                    var name2 = dir2.getName();
                    var i1 = -1;
                    var i2 = -1;

                    for (var i = 0; i < this.names.length; i++) {
                      {
                        if (
                        /* equals */
                        function (o1, o2) {
                          if (o1 && o1.equals) {
                            return o1.equals(o2);
                          } else {
                            return o1 === o2;
                          }
                        }(name1, this.names[i])) i1 = i;else if (
                        /* equals */
                        function (o1, o2) {
                          if (o1 && o1.equals) {
                            return o1.equals(o2);
                          } else {
                            return o1 === o2;
                          }
                        }(name2, this.names[i])) i2 = i;
                      }
                    }

                    return i2 - i1;
                  }
                }]);

                return OrbitComparator;
              }();

              OrbitSet.OrbitComparator = OrbitComparator;
              OrbitComparator["__class"] = "com.vzome.core.math.symmetry.OrbitSet.OrbitComparator";
              OrbitComparator["__interfaces"] = ["java.util.Comparator"];
            })(OrbitSet = symmetry_2.OrbitSet || (symmetry_2.OrbitSet = {}));
          })(math.symmetry || (math.symmetry = {}));
        })(core.math || (core.math = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (math) {
          (function (symmetry) {
            /**
            * @author Scott Vorthmann
            * @class
            */
            var NamingConvention =
            /*#__PURE__*/
            function () {
              function NamingConvention() {
                _classCallCheck(this, NamingConvention);

                this.mNamings = new java.util.HashMap();
              }

              _createClass(NamingConvention, [{
                key: "addDirectionNaming",
                value: function addDirectionNaming(naming) {
                  this.mNamings.put(naming.getName$(), naming);
                }
              }, {
                key: "getAxis",
                value: function getAxis(color, name) {
                  var naming = this.mNamings.get(color);
                  if (naming == null) return null;
                  return naming.getAxis(name);
                }
              }, {
                key: "getName",
                value: function getName(axis) {
                  for (var index605 = this.mNamings.values().iterator(); index605.hasNext();) {
                    var naming = index605.next();
                    {
                      if (naming.getDirection().equals(axis.getDirection())) return naming.getName$com_vzome_core_math_symmetry_Axis(axis);
                    }
                  }

                  return NamingConvention.UNKNOWN_AXIS;
                }
              }]);

              return NamingConvention;
            }();

            NamingConvention.UNKNOWN_AXIS = "UNKNOWN AXIS";
            symmetry.NamingConvention = NamingConvention;
            NamingConvention["__class"] = "com.vzome.core.math.symmetry.NamingConvention";
          })(math.symmetry || (math.symmetry = {}));
        })(core.math || (core.math = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (math) {
          (function (symmetry) {
            (function (Symmetry) {
              Symmetry.PLUS = com.vzome.core.math.symmetry.Axis.PLUS;
              Symmetry.MINUS = com.vzome.core.math.symmetry.Axis.MINUS;
              Symmetry.NO_ROTATION = -1;
              Symmetry.TETRAHEDRAL = "tetrahedral";
              Symmetry.PYRITOHEDRAL = "pyritohedral";
            })(symmetry.Symmetry || (symmetry.Symmetry = {}));

            (function (Symmetry) {
              (function (SpecialOrbit) {
                SpecialOrbit[SpecialOrbit["BLUE"] = 0] = "BLUE";
                SpecialOrbit[SpecialOrbit["RED"] = 1] = "RED";
                SpecialOrbit[SpecialOrbit["YELLOW"] = 2] = "YELLOW";
                SpecialOrbit[SpecialOrbit["BLACK"] = 3] = "BLACK";
              })(Symmetry.SpecialOrbit || (Symmetry.SpecialOrbit = {}));
            })(symmetry.Symmetry || (symmetry.Symmetry = {}));
          })(math.symmetry || (math.symmetry = {}));
        })(core.math || (core.math = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (math) {
          (function (symmetry) {
            /**
            * A single orbit in a Symmetry group.
            * Consists of a collection of zones (Axis), each of which is an infinite family of parallel lines.
            * There is a prototype zone (Axis) which has index==0; ideally, that zone should
            * have normal vector =~ (1,e,e), for 0 < e << 1, but this is not true, historically.
            *
            * The orbit is represented by a single "dot" on the fundamental region triangle, and typically
            * struts in the orbit are rendered with a shape and color unique from all other orbits.
            *
            * @author Scott Vorthmann
            * @param {string} name
            * @param {*} group
            * @param {number} prototype
            * @param {number} rotatedPrototype
            * @param {com.vzome.core.algebra.AlgebraicVector} vector
            * @param {boolean} isStd
            * @class
            */
            var Direction =
            /*#__PURE__*/
            function () {
              function Direction(name, group, prototype, rotatedPrototype, vector, isStd) {
                _classCallCheck(this, Direction);

                if (this.mName === undefined) this.mName = null;
                if (this.zoneNames === undefined) this.zoneNames = null;
                this.zoneVectors = new java.util.HashMap();
                if (this.mSymmetryGroup === undefined) this.mSymmetryGroup = null;
                if (this.mPrototype === undefined) this.mPrototype = null;
                if (this.mStandard === undefined) this.mStandard = false;
                if (this.mAutomatic === undefined) this.mAutomatic = false;
                if (this.__hasHalfSizes === undefined) this.__hasHalfSizes = false;
                this.scaleNames = ["shorter", "short", "medium", "long"];

                this.scales = function (s) {
                  var a = [];

                  while (s-- > 0) {
                    a.push(null);
                  }

                  return a;
                }(this.scaleNames.length);

                if (this.unitLength === undefined) this.unitLength = null;
                if (this.unitLengthReciprocal === undefined) this.unitLengthReciprocal = null;
                this.dotX = -999.0;
                this.dotY = -999.0;
                if (this.index === undefined) this.index = 0;
                this.canonicalize = 0;
                this.index = Direction.globalIndex++;
                this.mStandard = isStd;
                this.mName = name;
                this.mSymmetryGroup = group;

                for (var i = 0; i < this.scales.length; i++) {
                  {
                    this.scales[i] = this.mSymmetryGroup.getField()['createPower$int'](i - 1);
                  }
                }

                this.mPrototype = vector;
                var order = group.getChiralOrder();

                this.zoneNames = function (dims) {
                  var allocate = function allocate(dims) {
                    if (dims.length == 0) {
                      return null;
                    } else {
                      var array = [];

                      for (var _i14 = 0; _i14 < dims[0]; _i14++) {
                        array.push(allocate(dims.slice(1)));
                      }

                      return array;
                    }
                  };

                  return allocate(dims);
                }([2, 2, order]);

                for (var _i15 = 0; _i15 < order; _i15++) {
                  {
                    var transform = group.getMatrix(_i15);
                    if (transform == null) return;
                    var perm = group.getPermutation(_i15);
                    var j = perm.mapIndex(prototype);
                    var rotated = perm.mapIndex(rotatedPrototype);
                    var normal = transform.timesColumn(vector);
                    var rot = group.getMapping(j, rotated);
                    this.createAxis$int$int$com_vzome_core_algebra_AlgebraicVector(j, rot, normal);
                  }
                }
              }
              /**
              *
              * @return {number}
              */


              _createClass(Direction, [{
                key: "hashCode",
                value: function hashCode() {
                  var prime = 31;
                  var result = 1;
                  result = prime * result + this.index;
                  result = prime * result + (this.mPrototype == null ? 0 :
                  /* hashCode */
                  function (o) {
                    if (o.hashCode) {
                      return o.hashCode();
                    } else {
                      return o.toString().split('').reduce(function (prevHash, currVal) {
                        return (prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0;
                      }, 0);
                    }
                  }(this.mPrototype));
                  result = prime * result + (this.mSymmetryGroup == null ? 0 :
                  /* hashCode */
                  function (o) {
                    if (o.hashCode) {
                      return o.hashCode();
                    } else {
                      return o.toString().split('').reduce(function (prevHash, currVal) {
                        return (prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0;
                      }, 0);
                    }
                  }(this.mSymmetryGroup));
                  return result;
                }
                /**
                *
                * @param {*} obj
                * @return {boolean}
                */

              }, {
                key: "equals",
                value: function equals(obj) {
                  if (this === obj) {
                    return true;
                  }

                  if (obj == null) {
                    return false;
                  }

                  if (this.constructor !== obj.constructor) {
                    return false;
                  }

                  var other = obj;

                  if (this.index !== other.index) {
                    return false;
                  }

                  if (this.mPrototype == null) {
                    if (other.mPrototype != null) {
                      return false;
                    }
                  } else if (!this.mPrototype.equals(other.mPrototype)) {
                    return false;
                  }

                  if (this.mSymmetryGroup == null) {
                    if (other.mSymmetryGroup != null) {
                      return false;
                    }
                  } else if (!function (o1, o2) {
                    if (o1 && o1.equals) {
                      return o1.equals(o2);
                    } else {
                      return o1 === o2;
                    }
                  }(this.mSymmetryGroup, other.mSymmetryGroup)) {
                    return false;
                  }

                  return true;
                }
              }, {
                key: "setAutomatic",
                value: function setAutomatic(auto) {
                  this.mAutomatic = auto;
                }
              }, {
                key: "isAutomatic",
                value: function isAutomatic() {
                  return this.mAutomatic;
                }
              }, {
                key: "isStandard",
                value: function isStandard() {
                  return this.mStandard;
                }
                /**
                *
                * @return {string}
                */

              }, {
                key: "toString",
                value: function toString() {
                  return this.mSymmetryGroup.getName() + " " + this.mName;
                }
              }, {
                key: "getPrototype",
                value: function getPrototype() {
                  return this.mPrototype;
                }
                /**
                *
                * @return {*}
                */

              }, {
                key: "iterator",
                value: function iterator() {
                  return this.zoneVectors.values().iterator();
                }
                /**
                * @deprecated Consider using a JDK-5 for-loop if possible. Otherwise use {@link #iterator()} instead.
                * @return {*}
                */

              }, {
                key: "getAxes",
                value: function getAxes() {
                  return this.iterator();
                }
              }, {
                key: "getSymmetry",
                value: function getSymmetry() {
                  return this.mSymmetryGroup;
                }
              }, {
                key: "getName",
                value: function getName() {
                  return this.mName;
                }
              }, {
                key: "getAxis$com_vzome_core_algebra_AlgebraicVector",
                value: function getAxis$com_vzome_core_algebra_AlgebraicVector(vector) {
                  for (var index606 = this.zoneVectors.values().iterator(); index606.hasNext();) {
                    var axis = index606.next();
                    {
                      var normal = axis.normal();

                      if (com.vzome.core.algebra.AlgebraicVectors.areParallel(normal, vector)) {
                        var dotProd = normal.dot(vector);

                        if (dotProd.evaluate() > 0) {
                          return axis;
                        } else {
                          var principalReflection = this.mSymmetryGroup.getPrincipalReflection();

                          if (principalReflection == null) {
                            var opp = (axis.getSense() + 1) % 2;
                            return this.getAxis$int$int(opp, axis.getOrientation());
                          } else {
                            return this.getAxis$int$int$boolean(axis.getSense(), axis.getOrientation(), !axis.isOutbound());
                          }
                        }
                      }
                    }
                  }

                  return null;
                }
              }, {
                key: "getAxis$com_vzome_core_math_RealVector",
                value: function getAxis$com_vzome_core_math_RealVector(vector) {
                  return this.getSymmetry()['getAxis$com_vzome_core_math_RealVector$java_util_Set'](vector, java.util.Collections.singleton(this));
                }
              }, {
                key: "getChiralAxis",
                value: function getChiralAxis(vector) {
                  if (com.vzome.core.math.RealVector.ORIGIN_$LI$().equals(vector)) {
                    return null;
                  }

                  var vectorLength = vector.length();
                  var checked = new java.util.HashSet();
                  var closestOrientation = 0;
                  var closestSense = com.vzome.core.math.symmetry.Symmetry.PLUS;
                  var closestAxis = this.getCanonicalAxis(com.vzome.core.math.symmetry.Symmetry.PLUS, 0);
                  checked.add(closestAxis);
                  var axisV = closestAxis.normal().toRealVector();
                  var maxCosine = vector.dot(axisV) / (vectorLength * axisV.length());

                  if (maxCosine < 0) {
                    closestAxis = this.getCanonicalAxis(com.vzome.core.math.symmetry.Symmetry.MINUS, 0);
                    closestSense = com.vzome.core.math.symmetry.Symmetry.MINUS;
                    checked.add(closestAxis);
                    axisV = closestAxis.normal().toRealVector();
                    maxCosine = vector.dot(axisV) / (vectorLength * axisV.length());
                  }

                  var finished = false;

                  while (!finished) {
                    {
                      var incidentOrientations = this.getSymmetry().getIncidentOrientations(closestOrientation);

                      if (incidentOrientations == null) {
                        break;
                      }

                      var reverseSense = (closestSense + 1) % 2;

                      for (var index607 = 0; index607 < incidentOrientations.length; index607++) {
                        var i = incidentOrientations[index607];
                        {
                          var neighbor = this.getCanonicalAxis(reverseSense, i);
                          if (checked.contains(neighbor)) continue;
                          checked.add(neighbor);
                          axisV = neighbor.normal().toRealVector();
                          var cosine = vector.dot(axisV) / (vectorLength * axisV.length());

                          if (cosine > maxCosine) {
                            maxCosine = cosine;
                            closestAxis = neighbor;
                            closestOrientation = i;
                            closestSense = reverseSense;
                          }
                        }
                      }

                      if (reverseSense !== closestSense) {
                        return closestAxis;
                      }
                    }
                  }

                  return this.getAxisBruteForce(vector);
                }
              }, {
                key: "getAxisBruteForce",
                value: function getAxisBruteForce(vector) {
                  var closestAxis = null;
                  var maxCosine = -1.0;

                  for (var index608 = this.iterator(); index608.hasNext();) {
                    var axis = index608.next();
                    {
                      var axisV = axis.normal().toRealVector();
                      var cosine = vector.dot(axisV) / (vector.length() * axisV.length());

                      if (cosine > maxCosine) {
                        maxCosine = cosine;
                        closestAxis = axis;
                      }
                    }
                  }

                  return closestAxis;
                }
              }, {
                key: "getAxis$int$int",
                value: function getAxis$int$int(sense, index) {
                  return this.getAxis$int$int$boolean(sense, index, true);
                }
              }, {
                key: "getAxis$int$int$boolean",
                value: function getAxis$int$int$boolean(sense, index, outbound) {
                  return this.zoneNames[outbound ? 1 : 0][sense][index];
                }
              }, {
                key: "getAxis",
                value: function getAxis(sense, index, outbound) {
                  if ((typeof sense === 'number' || sense === null) && (typeof index === 'number' || index === null) && (typeof outbound === 'boolean' || outbound === null)) {
                    return this.getAxis$int$int$boolean(sense, index, outbound);
                  } else if ((typeof sense === 'number' || sense === null) && (typeof index === 'number' || index === null) && outbound === undefined) {
                    return this.getAxis$int$int(sense, index);
                  } else if ((sense != null && sense instanceof com.vzome.core.algebra.AlgebraicVector || sense === null) && index === undefined && outbound === undefined) {
                    return this.getAxis$com_vzome_core_algebra_AlgebraicVector(sense);
                  } else if ((sense != null && sense instanceof com.vzome.core.math.RealVector || sense === null) && index === undefined && outbound === undefined) {
                    return this.getAxis$com_vzome_core_math_RealVector(sense);
                  } else throw new Error('invalid overload');
                }
              }, {
                key: "withCorrection",
                value: function withCorrection() {
                  var treatedAs0 = this.getAxisBruteForce(com.vzome.core.math.RealVector.DIRECTION_0_$LI$());
                  this.canonicalize = treatedAs0.getOrientation();
                  if (treatedAs0.getSense() === com.vzome.core.math.symmetry.Symmetry.MINUS) this.canonicalize *= -1;
                  return this;
                }
                /**
                * Get the axis that protrudes from the canonical direction on the zome ball.
                * Many Directions (orbits) are created without regard to whether "axis 0" actually sticks out
                * of the ball in the fundamental domain with index 0.
                * @param {number} sense
                * @param {number} index
                * @return
                * @return {com.vzome.core.math.symmetry.Axis}
                */

              }, {
                key: "getCanonicalAxis",
                value: function getCanonicalAxis(sense, index) {
                  if (this.canonicalize !== 0) {
                    if (this.canonicalize < 0) sense = (sense + 1) % 2;
                    var target = this.mSymmetryGroup.getPermutation(index);
                    index = target.mapIndex(Math.abs(this.canonicalize));
                  }

                  return this.getAxis$int$int(sense, index);
                }
              }, {
                key: "createAxis$int$int$int_A_A",
                value: function createAxis$int$int$int_A_A(orientation, rotation, norm) {
                  var aNorm = this.mSymmetryGroup.getField().createVector(norm);
                  this.createAxis$int$int$com_vzome_core_algebra_AlgebraicVector(orientation, rotation, aNorm);
                }
              }, {
                key: "createAxis",
                value: function createAxis(orientation, rotation, norm) {
                  if ((typeof orientation === 'number' || orientation === null) && (typeof rotation === 'number' || rotation === null) && (norm != null && norm instanceof Array && (norm.length == 0 || norm[0] == null || norm[0] instanceof Array) || norm === null)) {
                    return this.createAxis$int$int$int_A_A(orientation, rotation, norm);
                  } else if ((typeof orientation === 'number' || orientation === null) && (typeof rotation === 'number' || rotation === null) && (norm != null && norm instanceof com.vzome.core.algebra.AlgebraicVector || norm === null)) {
                    return this.createAxis$int$int$com_vzome_core_algebra_AlgebraicVector(orientation, rotation, norm);
                  } else throw new Error('invalid overload');
                }
              }, {
                key: "createAxis$int$int$com_vzome_core_algebra_AlgebraicVector",
                value: function createAxis$int$int$com_vzome_core_algebra_AlgebraicVector(orientation, rotation, norm) {
                  var perm = this.mSymmetryGroup.getPermutation(rotation);
                  this.recordZone(this, orientation, com.vzome.core.math.symmetry.Symmetry.PLUS, rotation, perm, norm, true);
                  var inversion = this.mSymmetryGroup.getPrincipalReflection();

                  if (inversion == null) {
                    if (perm != null) perm = perm.inverse();
                    this.recordZone(this, orientation, com.vzome.core.math.symmetry.Symmetry.MINUS, rotation, perm, norm.negate(), true);
                  } else {
                    var reverseRotation = rotation;
                    var reversePerm = perm;

                    if (perm != null) {
                      reversePerm = perm.inverse();
                      reverseRotation = perm.mapIndex(0);
                    }

                    this.recordZone(this, orientation, com.vzome.core.math.symmetry.Symmetry.PLUS, reverseRotation, reversePerm, norm.negate(), false);
                    var reflectedNorm = inversion.timesColumn(norm);
                    this.recordZone(this, orientation, com.vzome.core.math.symmetry.Symmetry.MINUS, reverseRotation, reversePerm, reflectedNorm, true);
                    reflectedNorm = reflectedNorm.negate();
                    this.recordZone(this, orientation, com.vzome.core.math.symmetry.Symmetry.MINUS, rotation, perm, reflectedNorm, false);
                  }
                }
                /*private*/

              }, {
                key: "recordZone",
                value: function recordZone(dir, orientation, sense, rotation, rotPerm, normal, outbound) {
                  var zone = this.zoneVectors.get(normal.toString());

                  if (zone == null) {
                    zone = new com.vzome.core.math.symmetry.Axis(this, orientation, sense, rotation, rotPerm, normal, outbound);
                    this.zoneVectors.put(normal.toString(), zone);
                    if (Direction.logger_$LI$().isLoggable(java.util.logging.Level.FINER)) Direction.logger_$LI$().finer("creating zone " + zone.toString() + " " + normal.toString());
                  } else {
                    if (outbound && !zone.isOutbound()) {
                      var oldName = zone.toString();
                      zone.rename(sense, orientation, true);
                      if (Direction.logger_$LI$().isLoggable(java.util.logging.Level.FINER)) Direction.logger_$LI$().finer("zone " + oldName + " upgraded to " + zone.toString());
                    } else if (zone.isOutbound() && !outbound) {
                      if (Direction.logger_$LI$().isLoggable(java.util.logging.Level.FINEST)) Direction.logger_$LI$().finest("zone " + zone.toString() + " aliased as " + (sense === com.vzome.core.math.symmetry.Axis.MINUS ? "-" : "") + orientation + (outbound ? "" : "i"));
                    } else if (sense === com.vzome.core.math.symmetry.Axis.PLUS && zone.getSense() === com.vzome.core.math.symmetry.Axis.MINUS) {
                      var _oldName = zone.toString();

                      zone.rename(sense, orientation, outbound);
                      if (Direction.logger_$LI$().isLoggable(java.util.logging.Level.FINER)) Direction.logger_$LI$().finer("zone " + _oldName + " upgraded to " + zone.toString());
                    } else {
                      if (Direction.logger_$LI$().isLoggable(java.util.logging.Level.FINEST)) Direction.logger_$LI$().finest("zone " + zone.toString() + " aliased as " + (sense === com.vzome.core.math.symmetry.Axis.MINUS ? "-" : "") + orientation + (outbound ? "" : "i"));
                    }
                  }

                  this.zoneNames[outbound ? 1 : 0][sense][orientation] = zone;
                }
                /**
                *
                * @param {com.vzome.core.math.symmetry.Direction} other
                * @return {number}
                */

              }, {
                key: "compareTo",
                value: function compareTo(other) {
                  return this.index - other.index;
                }
              }, {
                key: "setHalfSizes",
                value: function setHalfSizes(value) {
                  this.__hasHalfSizes = value;
                }
              }, {
                key: "hasHalfSizes",
                value: function hasHalfSizes() {
                  return this.__hasHalfSizes;
                }
              }, {
                key: "setScaleNames",
                value: function setScaleNames(names) {
                  for (var i = 0; i < names.length; i++) {
                    {
                      this.scaleNames[i] = names[i];
                    }
                  }
                }
              }, {
                key: "getScaleName",
                value: function getScaleName(scale) {
                  if (scale < this.scaleNames.length && scale >= 0) return this.scaleNames[scale];else return "scale " + (scale - 1);
                }
              }, {
                key: "setUnitLength",
                value: function setUnitLength(unitLength) {
                  this.unitLength = unitLength;
                  this.unitLengthReciprocal = unitLength.reciprocal();
                }
              }, {
                key: "getUnitLength",
                value: function getUnitLength() {
                  if (this.unitLength == null) return this.mSymmetryGroup.getField()['createPower$int'](0);else return this.unitLength;
                }
              }, {
                key: "getLengthInUnits",
                value: function getLengthInUnits(rawLength) {
                  var field = this.mSymmetryGroup.getField();
                  var scaledLength = rawLength['times$com_vzome_core_algebra_AlgebraicNumber'](field['createPower$int'](-Direction.USER_SCALE));
                  if (this.unitLength == null) return scaledLength;else return scaledLength['times$com_vzome_core_algebra_AlgebraicNumber'](this.unitLengthReciprocal);
                }
              }, {
                key: "getLengthName",
                value: function getLengthName(length) {
                  for (var i = 0; i < this.scales.length; i++) {
                    {
                      if (
                      /* equals */
                      function (o1, o2) {
                        if (o1 && o1.equals) {
                          return o1.equals(o2);
                        } else {
                          return o1 === o2;
                        }
                      }(this.scales[i], length)) {
                        return this.scaleNames[i];
                      }
                    }
                  }

                  return "";
                }
              }, {
                key: "getLengthExpression",
                value: function getLengthExpression(buf, length) {
                  var bufLen = buf.length();
                  buf.append(this.getLengthName(length));

                  if (buf.length() === bufLen) {
                    buf.append(" ");
                  }

                  buf.append(":");
                  length.getNumberExpression(buf, com.vzome.core.algebra.AlgebraicField.EXPRESSION_FORMAT);
                }
              }, {
                key: "getDotX",
                value: function getDotX() {
                  return this.dotX;
                }
              }, {
                key: "getDotY",
                value: function getDotY() {
                  return this.dotY;
                }
              }, {
                key: "setDotLocation",
                value: function setDotLocation(x, y) {
                  this.dotX = x;
                  this.dotY = y;
                }
              }], [{
                key: "logger_$LI$",
                value: function logger_$LI$() {
                  if (Direction.logger == null) Direction.logger = java.util.logging.Logger.getLogger("com.vzome.core.math.symmetry.Orbit");
                  return Direction.logger;
                }
              }]);

              return Direction;
            }();

            Direction.globalIndex = 0;
            Direction.USER_SCALE = 3;
            symmetry.Direction = Direction;
            Direction["__class"] = "com.vzome.core.math.symmetry.Direction";
            Direction["__interfaces"] = ["java.lang.Comparable", "java.lang.Iterable"];
          })(math.symmetry || (math.symmetry = {}));
        })(core.math || (core.math = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (math) {
          (function (symmetry) {
            var B4Group =
            /*#__PURE__*/
            function () {
              function B4Group(field) {
                _classCallCheck(this, B4Group);

                if (this.field === undefined) this.field = null;
                this.ROOTS = [null, null, null, null];
                this.WEIGHTS = [null, null, null, null];
                this.field = field;
                var neg_one = field['createRational$long'](-1);
                this.ROOTS[0] = field.basisVector(4, com.vzome.core.algebra.AlgebraicVector.X4);
                this.ROOTS[0].setComponent(com.vzome.core.algebra.AlgebraicVector.Y4, neg_one);
                this.ROOTS[1] = field.basisVector(4, com.vzome.core.algebra.AlgebraicVector.Y4);
                this.ROOTS[1].setComponent(com.vzome.core.algebra.AlgebraicVector.Z4, neg_one);
                this.ROOTS[2] = field.basisVector(4, com.vzome.core.algebra.AlgebraicVector.Z4);
                this.ROOTS[2].setComponent(com.vzome.core.algebra.AlgebraicVector.W4, neg_one);
                this.ROOTS[3] = field.basisVector(4, com.vzome.core.algebra.AlgebraicVector.W4);
                var y = field.basisVector(4, com.vzome.core.algebra.AlgebraicVector.Y4);
                var z = field.basisVector(4, com.vzome.core.algebra.AlgebraicVector.Z4);
                this.WEIGHTS[0] = field.basisVector(4, com.vzome.core.algebra.AlgebraicVector.X4);
                this.WEIGHTS[1] = this.WEIGHTS[0].plus(y);
                this.WEIGHTS[2] = this.WEIGHTS[1].plus(z);
                this.WEIGHTS[3] = field.basisVector(4, com.vzome.core.algebra.AlgebraicVector.X4);
                var half = field['createRational$long$long'](1, 2);
                this.WEIGHTS[3].setComponent(com.vzome.core.algebra.AlgebraicVector.X4, half);
                this.WEIGHTS[3].setComponent(com.vzome.core.algebra.AlgebraicVector.Y4, half);
                this.WEIGHTS[3].setComponent(com.vzome.core.algebra.AlgebraicVector.Z4, half);
                this.WEIGHTS[3].setComponent(com.vzome.core.algebra.AlgebraicVector.W4, half);

                if (field.scale4dRoots()) {
                  var scale = field['createPower$int'](1);
                  this.ROOTS[3] = this.ROOTS[3].scale(scale);
                  this.WEIGHTS[3] = this.WEIGHTS[3].scale(scale);
                }
              }

              _createClass(B4Group, [{
                key: "getOrder",

                /**
                *
                * @return {number}
                */
                value: function getOrder() {
                  return 24 * 16;
                }
                /**
                *
                * @param {com.vzome.core.algebra.AlgebraicVector} model
                * @param {number} element
                * @return {com.vzome.core.algebra.AlgebraicVector}
                */

              }, {
                key: "groupAction",
                value: function groupAction(model, element) {
                  var result = this.field.basisVector(4, com.vzome.core.algebra.AlgebraicVector.X4);
                  var perm = element / 16 | 0;
                  var signs = element % 16;

                  for (var c = 0; c < 4; c++) {
                    {
                      var source = model.getComponent((B4Group.B4_PERMS_$LI$()[perm][c] + 1) % 4);
                      if (signs % 2 !== 0) source = source.negate();
                      result.setComponent((c + 1) % 4, source);
                      signs = signs >> 1;
                    }
                  }

                  return result;
                }
                /**
                *
                * @return {com.vzome.core.algebra.AlgebraicVector}
                */

              }, {
                key: "getOrigin",
                value: function getOrigin() {
                  return this.field.origin(4);
                }
                /**
                *
                * @param {number} i
                * @return {com.vzome.core.algebra.AlgebraicVector}
                */

              }, {
                key: "getWeight",
                value: function getWeight(i) {
                  return this.WEIGHTS[i];
                }
                /**
                *
                * @param {number} i
                * @return {com.vzome.core.algebra.AlgebraicVector}
                */

              }, {
                key: "getSimpleRoot",
                value: function getSimpleRoot(i) {
                  return this.ROOTS[i];
                }
                /**
                *
                * @return {*}
                */

              }, {
                key: "getField",
                value: function getField() {
                  return this.field;
                }
                /**
                *
                * @param {com.vzome.core.algebra.AlgebraicVector} model
                * @param {number} element
                * @return {com.vzome.core.algebra.AlgebraicVector}
                */

              }, {
                key: "chiralSubgroupAction",
                value: function chiralSubgroupAction(model, element) {
                  var result = this.field.basisVector(4, com.vzome.core.algebra.AlgebraicVector.X4);
                  var perm = element / 16 | 0;
                  var signs = element % 16;
                  var even = true;

                  for (var c = 0; c < 4; c++) {
                    {
                      var source = model.getComponent((B4Group.B4_PERMS_$LI$()[perm][c] + 1) % 4);

                      if (signs % 2 !== 0) {
                        even = !even;
                        source = source.negate();
                      }

                      result.setComponent((c + 1) % 4, source);
                      signs = signs >> 1;
                    }
                  }

                  return even ? result : null;
                }
              }], [{
                key: "B4_PERMS_$LI$",
                value: function B4_PERMS_$LI$() {
                  if (B4Group.B4_PERMS == null) B4Group.B4_PERMS = [[0, 1, 2, 3], [0, 1, 3, 2], [0, 2, 1, 3], [0, 2, 3, 1], [0, 3, 2, 1], [0, 3, 1, 2], [1, 0, 2, 3], [1, 0, 3, 2], [1, 2, 0, 3], [1, 2, 3, 0], [1, 3, 2, 0], [1, 3, 0, 2], [2, 1, 0, 3], [2, 1, 3, 0], [2, 0, 1, 3], [2, 0, 3, 1], [2, 3, 0, 1], [2, 3, 1, 0], [3, 1, 2, 0], [3, 1, 0, 2], [3, 2, 1, 0], [3, 2, 0, 1], [3, 0, 2, 1], [3, 0, 1, 2]];
                  return B4Group.B4_PERMS;
                }
              }]);

              return B4Group;
            }();

            symmetry.B4Group = B4Group;
            B4Group["__class"] = "com.vzome.core.math.symmetry.B4Group";
            B4Group["__interfaces"] = ["com.vzome.core.math.symmetry.CoxeterGroup"];
          })(math.symmetry || (math.symmetry = {}));
        })(core.math || (core.math = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (math) {
          (function (symmetry) {
            (function (Constants) {
              Constants.RED = 0;
              Constants.YELLOW = 1;
              Constants.BLUE = 2;
              Constants.GREEN = 3;
              Constants.ORANGE = 4;
              Constants.PURPLE = 5;
              Constants.BLACK = 6;
              Constants.NO_AXIS = 7;
              /**
              * Blue axes of basis.
              */

              Constants.X = 2;
              /**
              * Blue axes of basis.
              */

              Constants.Y = 5;
              /**
              * Blue axes of basis.
              */

              Constants.Z = 13;
              Constants.SHORT = 3;
              Constants.MEDIUM = 4;
              Constants.LONG = 5;
              Constants.JUST_RED = 1 << Constants.RED;
              Constants.JUST_YELLOW = 1 << Constants.YELLOW;
              Constants.JUST_BLUE = 1 << Constants.BLUE;
              Constants.JUST_GREEN = 1 << Constants.GREEN;
              Constants.JUST_ORANGE = 1 << Constants.ORANGE;
              Constants.JUST_PURPLE = 1 << Constants.PURPLE;
              Constants.JUST_BLACK = 1 << Constants.BLACK;
              Constants.ORIGINAL_STRUTS = Constants.JUST_RED | Constants.JUST_YELLOW | Constants.JUST_BLUE;
              Constants.ALL_STRUTS = Constants.ORIGINAL_STRUTS | Constants.JUST_GREEN | Constants.JUST_ORANGE | Constants.JUST_PURPLE | Constants.JUST_BLACK;
              Constants.RED_AXIS_YELLOW_NEIGHBORS = [[0, 1, 2, 3, 4], [1, 0, 5, -8, 6], [2, 1, 6, -9, 7], [3, 2, 7, -5, 8], [4, 3, 8, -6, 9], [0, 4, 9, -7, 5]];
              Constants.AXIS_SYMMETRY = [5, 3, 2, 1, 1, 1, 1];
            })(symmetry.Constants || (symmetry.Constants = {}));
          })(math.symmetry || (math.symmetry = {}));
        })(core.math || (core.math = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (math) {
          var VefParser =
          /*#__PURE__*/
          function () {
            function VefParser() {
              _classCallCheck(this, VefParser);

              this.mVersion = 0;
              this.dimension = 4;
              this.__isRational = false;
              if (this.field === undefined) this.field = null;
              if (this.parsedOffset === undefined) this.parsedOffset = null;
            }

            _createClass(VefParser, [{
              key: "endVertices",
              value: function endVertices() {}
            }, {
              key: "endEdges",
              value: function endEdges() {}
            }, {
              key: "endFaces",
              value: function endFaces() {}
            }, {
              key: "endBalls",
              value: function endBalls() {}
            }, {
              key: "getVersion",
              value: function getVersion() {
                return this.mVersion;
              }
            }, {
              key: "getField",
              value: function getField() {
                return this.field;
              }
            }, {
              key: "isRational",
              value: function isRational() {
                return this.__isRational;
              }
            }, {
              key: "wFirst",
              value: function wFirst() {
                return this.mVersion >= VefParser.VERSION_W_FIRST;
              }
            }, {
              key: "parseVEF",
              value: function parseVEF(vefData, field) {
                this.field = field;
                var tokens = new java.util.StringTokenizer(vefData);
                var token = null;

                try {
                  token = tokens.nextToken();
                } catch (e1) {
                  throw new java.lang.IllegalStateException("VEF format error: no tokens in file data: \"" + vefData + "\"");
                }

                this.mVersion = 0;
                this.__isRational = false;

                if (
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(token, "vZome")) {
                  try {
                    token = tokens.nextToken();
                  } catch (e1) {
                    throw new java.lang.IllegalStateException("VEF format error: no tokens after \"vZome\"");
                  }

                  if (!function (o1, o2) {
                    if (o1 && o1.equals) {
                      return o1.equals(o2);
                    } else {
                      return o1 === o2;
                    }
                  }("VEF", token)) throw new java.lang.IllegalStateException("VEF format error: token after \"vZome\" (\"" + token + "\" should be \"VEF\"");

                  try {
                    token = tokens.nextToken();
                  } catch (e1) {
                    throw new java.lang.IllegalStateException("VEF format error: no tokens after \"VEF\"");
                  }

                  try {
                    this.mVersion = javaemul.internal.IntegerHelper.parseInt(token);
                  } catch (e) {
                    throw new java.lang.RuntimeException("VEF format error: VEF version number (\"" + token + "\") must be an integer", e);
                  }

                  token = tokens.nextToken();
                }

                if (
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(token, "field")) {
                  try {
                    token = tokens.nextToken();
                  } catch (e1) {
                    throw new java.lang.IllegalStateException("VEF format error: no tokens after \"field\"");
                  }

                  if (
                  /* equals */
                  function (o1, o2) {
                    if (o1 && o1.equals) {
                      return o1.equals(o2);
                    } else {
                      return o1 === o2;
                    }
                  }(token, "rational")) {
                    this.__isRational = true;
                    token = field.getName();
                  }

                  if (!VefParser.fieldsAreCompatible(field, token)) {
                    throw new java.lang.IllegalStateException("VEF field mismatch error: VEF field name (\"" + token + "\") does not match current model field name (\"" + field.getName() + "\").");
                  }

                  token = tokens.nextToken();
                }

                if (
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(token, "actual")) {
                  try {
                    token = tokens.nextToken();
                  } catch (e1) {
                    throw new java.lang.IllegalStateException("VEF format error: no tokens after \"actual\"");
                  }
                }

                if (
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(token, "dimension")) {
                  try {
                    token = tokens.nextToken();
                  } catch (e1) {
                    throw new java.lang.IllegalStateException("VEF format error: no tokens after \"dimension\"");
                  }

                  try {
                    this.dimension = javaemul.internal.IntegerHelper.parseInt(token);
                  } catch (e) {
                    throw new java.lang.RuntimeException("VEF format error: dimension number (\"" + token + "\") must be an integer", e);
                  }

                  try {
                    token = tokens.nextToken();
                  } catch (e) {
                    throw new java.lang.IllegalStateException("VEF format error: no tokens after \"dimension\"");
                  }
                }

                var scaleVector = new com.vzome.core.algebra.AlgebraicVector(field, this.dimension);

                if (
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(token, "scale")) {
                  try {
                    token = tokens.nextToken();

                    if (
                    /* equals */
                    function (o1, o2) {
                      if (o1 && o1.equals) {
                        return o1.equals(o2);
                      } else {
                        return o1 === o2;
                      }
                    }(token, "vector")) {
                      try {
                        for (var tokNum = 0; tokNum < this.dimension; tokNum++) {
                          {
                            token = tokens.nextToken();
                            var coord = this.field.parseVefNumber(token, this.__isRational);
                            scaleVector.setComponent(tokNum, coord);
                          }
                          ;
                        }
                      } catch (e) {
                        throw new java.lang.IllegalStateException("VEF format error: scale vector requires " + this.dimension + " coordinates");
                      }

                      ;
                    } else {
                      var scale = this.field.parseVefNumber(token, this.__isRational);

                      for (var i = 0; i < this.dimension; i++) {
                        {
                          scaleVector.setComponent(i, scale);
                        }
                        ;
                      }
                    }

                    token = tokens.nextToken();
                  } catch (e) {
                    throw new java.lang.IllegalStateException("VEF format error: no tokens after \"scale\"");
                  }
                } else {
                  for (var _i16 = 0; _i16 < this.dimension; _i16++) {
                    {
                      scaleVector.setComponent(_i16, field.one());
                    }
                  }
                }

                this.parsedOffset = new com.vzome.core.algebra.AlgebraicVector(field, this.dimension);

                if (
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(token, "offset")) {
                  try {
                    for (var _tokNum = 0; _tokNum < this.dimension; _tokNum++) {
                      {
                        token = tokens.nextToken();

                        var _coord = this.field.parseVefNumber(token, this.__isRational);

                        this.parsedOffset.setComponent(_tokNum, _coord);
                      }
                      ;
                    }
                  } catch (e) {
                    throw new java.lang.IllegalStateException("VEF format error: offset vector requires " + this.dimension + " coordinates");
                  }

                  try {
                    token = tokens.nextToken();
                  } catch (e) {
                    throw new java.lang.IllegalStateException("VEF format error: no tokens after \"offset\"");
                  }
                }

                var numVertices;

                try {
                  numVertices = javaemul.internal.IntegerHelper.parseInt(token);
                } catch (e) {
                  throw new java.lang.RuntimeException("VEF format error: number of vertices (\"" + token + "\") must be an integer", e);
                }

                this.startVertices(numVertices);
                var hasOffset = !this.parsedOffset.isOrigin();

                for (var _i17 = 0; _i17 < numVertices; _i17++) {
                  {
                    var v = field.origin(this.dimension);

                    for (var _tokNum2 = 0; _tokNum2 < this.dimension; _tokNum2++) {
                      {
                        try {
                          token = tokens.nextToken();
                        } catch (e1) {
                          throw new java.lang.IllegalStateException("VEF format error: not enough vertices in list");
                        }

                        var _coord2 = this.field.parseVefNumber(token, this.__isRational)['times$com_vzome_core_algebra_AlgebraicNumber'](scaleVector.getComponent(_tokNum2));

                        v.setComponent(_tokNum2, _coord2);
                      }
                    }

                    if (hasOffset) {
                      v = v.plus(this.parsedOffset);
                    }

                    this.addVertex(_i17, v);
                  }
                }

                this.endVertices();

                if (tokens.hasMoreTokens()) {
                  token = tokens.nextToken();
                  var numEdges;

                  try {
                    numEdges = javaemul.internal.IntegerHelper.parseInt(token);
                  } catch (e) {
                    throw new java.lang.RuntimeException("VEF format error: number of edges (\"" + token + "\") must be an integer", e);
                  }

                  this.startEdges(numEdges);

                  for (var _i18 = 0; _i18 < numEdges; _i18++) {
                    {
                      try {
                        token = tokens.nextToken();
                      } catch (e1) {
                        throw new java.lang.IllegalStateException("VEF format error: not enough edges in list");
                      }

                      var v1 = javaemul.internal.IntegerHelper.parseInt(token);

                      try {
                        token = tokens.nextToken();
                      } catch (e1) {
                        throw new java.lang.IllegalStateException("VEF format error: 2nd vertex index of last edge is missing");
                      }

                      var v2 = javaemul.internal.IntegerHelper.parseInt(token);
                      this.addEdge(_i18, v1, v2);
                    }
                  }

                  this.endEdges();
                }

                if (tokens.hasMoreTokens()) {
                  token = tokens.nextToken();
                  var numFaces;

                  try {
                    numFaces = javaemul.internal.IntegerHelper.parseInt(token);
                  } catch (e) {
                    throw new java.lang.RuntimeException("VEF format error: number of faces (\"" + token + "\") must be an integer", e);
                  }

                  this.startFaces(numFaces);

                  for (var _i19 = 0; _i19 < numFaces; _i19++) {
                    {
                      try {
                        token = tokens.nextToken();
                      } catch (e1) {
                        throw new java.lang.IllegalStateException("VEF format error: not enough faces in list");
                      }

                      var _order = javaemul.internal.IntegerHelper.parseInt(token);

                      var verts = function (s) {
                        var a = [];

                        while (s-- > 0) {
                          a.push(0);
                        }

                        return a;
                      }(_order);

                      for (var j = 0; j < _order; j++) {
                        {
                          try {
                            token = tokens.nextToken();
                          } catch (e1) {
                            throw new java.lang.IllegalStateException("VEF format error: not enough vertices in last face");
                          }

                          verts[j] = javaemul.internal.IntegerHelper.parseInt(token);
                        }
                      }

                      this.addFace(_i19, verts);
                    }
                  }

                  this.endFaces();
                }

                if (tokens.hasMoreTokens()) {
                  token = tokens.nextToken();
                  var numBalls;

                  try {
                    numBalls = javaemul.internal.IntegerHelper.parseInt(token);
                  } catch (e) {
                    throw new java.lang.RuntimeException("VEF format error: number of balls (\"" + token + "\") must be an integer", e);
                  }

                  this.startBalls(numBalls);

                  for (var _i20 = 0; _i20 < numBalls; _i20++) {
                    {
                      try {
                        token = tokens.nextToken();
                      } catch (e1) {
                        throw new java.lang.IllegalStateException("VEF format error: not enough balls in list");
                      }

                      var _v = javaemul.internal.IntegerHelper.parseInt(token);

                      this.addBall(_i20, _v);
                    }
                  }

                  this.endBalls();
                }

                this.endFile(tokens);
              }
            }, {
              key: "endFile",
              value: function endFile(tokens) {}
            }], [{
              key: "fieldsAreCompatible",
              value: function fieldsAreCompatible(field, fieldName) {
                if (
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(fieldName, field.getName())) return true;
                return (
                  /* equals */
                  function (o1, o2) {
                    if (o1 && o1.equals) {
                      return o1.equals(o2);
                    } else {
                      return o1 === o2;
                    }
                  }(fieldName, "golden") && field.getGoldenRatio() != null
                );
              }
            }]);

            return VefParser;
          }();

          VefParser.VERSION_EXPLICIT_OFFSET = 10;
          VefParser.VERSION_EXPLICIT_DIMENSION = 9;
          VefParser.VERSION_SCALE_VECTOR = 8;
          VefParser.VERSION_RATIONAL_ACTUAL_SCALE = 7;
          VefParser.VERSION_EXPLICIT_BALLS = 6;
          VefParser.VERSION_ANY_FIELD = 5;
          VefParser.VERSION_W_FIRST = 4;
          math.VefParser = VefParser;
          VefParser["__class"] = "com.vzome.core.math.VefParser";
        })(core.math || (core.math = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (math) {
          /**
          * @param {*} field
          * @param {com.vzome.core.algebra.AlgebraicVector} leftQuat
          * @param {com.vzome.core.algebra.AlgebraicVector} rightQuat
          * @class
          */
          var QuaternionProjection =
          /*#__PURE__*/
          function () {
            function QuaternionProjection(field, leftQuat, rightQuat) {
              _classCallCheck(this, QuaternionProjection);

              this.quaternions = function (dims) {
                var allocate = function allocate(dims) {
                  if (dims.length == 0) {
                    return null;
                  } else {
                    var array = [];

                    for (var i = 0; i < dims[0]; i++) {
                      array.push(allocate(dims.slice(1)));
                    }

                    return array;
                  }
                };

                return allocate(dims);
              }([2, 2]);

              if (this.field === undefined) this.field = null;
              this.field = field;
              this.setQuaternion(leftQuat, QuaternionProjection.LEFT);
              this.setQuaternion(rightQuat, QuaternionProjection.RIGHT);
            }
            /**
            *
            * @param {com.vzome.core.algebra.AlgebraicVector} source
            * @param {boolean} wFirst
            * @return {com.vzome.core.algebra.AlgebraicVector}
            */


            _createClass(QuaternionProjection, [{
              key: "projectImage",
              value: function projectImage(source, wFirst) {
                var result = source;
                var leftQuat = this.getQuaternion(QuaternionProjection.LEFT, wFirst);
                var rightQuat = this.getQuaternion(QuaternionProjection.RIGHT, wFirst);

                if (rightQuat != null) {
                  if (leftQuat != null) {
                    result = leftQuat.rightMultiply(result);
                    console.info("left mult: " + result.toString());
                  }

                  result = rightQuat.leftMultiply(result);
                } else {
                  result = leftQuat.rightMultiply(result);
                }

                return this.field.projectTo3d(result, wFirst);
              }
              /*private*/

            }, {
              key: "setQuaternion",
              value: function setQuaternion(quatVector, hand) {
                this.quaternions[hand][QuaternionProjection.WFIRST] = quatVector == null ? null : new com.vzome.core.algebra.Quaternion(this.field, quatVector.inflateTo4d$boolean(true));
                this.quaternions[hand][QuaternionProjection.WLAST] = quatVector == null ? null : new com.vzome.core.algebra.Quaternion(this.field, quatVector.inflateTo4d$boolean(false));
              }
              /*private*/

            }, {
              key: "getQuaternion",
              value: function getQuaternion(hand, wFirst) {
                return this.quaternions[hand][wFirst ? QuaternionProjection.WFIRST : QuaternionProjection.WLAST];
              }
              /**
              *
              * @param {*} element
              */

            }, {
              key: "getXmlAttributes",
              value: function getXmlAttributes(element) {
                var leftQuat = this.getQuaternion(QuaternionProjection.LEFT, true);
                var rightQuat = this.getQuaternion(QuaternionProjection.RIGHT, true);

                if (leftQuat != null) {
                  com.vzome.xml.DomUtils.addAttribute(element, QuaternionProjection.LEFT_QUATERNION_ATTRIBUTENAME, leftQuat.getVector().toParsableString());
                }

                if (rightQuat != null) {
                  com.vzome.xml.DomUtils.addAttribute(element, QuaternionProjection.RIGHT_QUATERNION_ATTRIBUTENAME, rightQuat.getVector().toParsableString());
                }
              }
              /**
              *
              * @param {*} xml
              */

            }, {
              key: "setXmlAttributes",
              value: function setXmlAttributes(xml) {
                this.setQuaternion(this.parseRationalVector(xml, QuaternionProjection.LEFT_QUATERNION_ATTRIBUTENAME), QuaternionProjection.LEFT);
                this.setQuaternion(this.parseRationalVector(xml, QuaternionProjection.RIGHT_QUATERNION_ATTRIBUTENAME), QuaternionProjection.RIGHT);
              }
              /*private*/

            }, {
              key: "parseRationalVector",
              value: function parseRationalVector(xml, attrName) {
                var nums = xml.getAttribute(attrName);
                if (nums == null ||
                /* isEmpty */
                nums.length === 0) return null;
                var loc = this.field.parseVector(nums);
                return loc;
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getProjectionName",
              value: function getProjectionName() {
                return "Quaternion";
              }
            }]);

            return QuaternionProjection;
          }();

          QuaternionProjection.LEFT = 0;
          QuaternionProjection.RIGHT = 1;
          QuaternionProjection.WFIRST = 0;
          QuaternionProjection.WLAST = 1;
          QuaternionProjection.RIGHT_QUATERNION_ATTRIBUTENAME = "quaternion";
          QuaternionProjection.LEFT_QUATERNION_ATTRIBUTENAME = "leftQuaternion";
          math.QuaternionProjection = QuaternionProjection;
          QuaternionProjection["__class"] = "com.vzome.core.math.QuaternionProjection";
          QuaternionProjection["__interfaces"] = ["com.vzome.core.math.Projection"];
        })(core.math || (core.math = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (math) {
          (function (Projection) {
            var Default =
            /*#__PURE__*/
            function () {
              function Default(field) {
                _classCallCheck(this, Default);

                if (this.field === undefined) this.field = null;
                this.field = field;
              }
              /**
              *
              * @param {com.vzome.core.algebra.AlgebraicVector} source
              * @param {boolean} wFirst
              * @return {com.vzome.core.algebra.AlgebraicVector}
              */


              _createClass(Default, [{
                key: "projectImage",
                value: function projectImage(source, wFirst) {
                  return this.field.projectTo3d(source, wFirst);
                }
                /**
                *
                * @param {*} element
                */

              }, {
                key: "getXmlAttributes",
                value: function getXmlAttributes(element) {}
                /**
                *
                * @param {*} xml
                */

              }, {
                key: "setXmlAttributes",
                value: function setXmlAttributes(xml) {}
                /**
                *
                * @return {string}
                */

              }, {
                key: "getProjectionName",
                value: function getProjectionName() {
                  return "";
                }
              }]);

              return Default;
            }();

            Projection.Default = Default;
            Default["__class"] = "com.vzome.core.math.Projection.Default";
            Default["__interfaces"] = ["com.vzome.core.math.Projection"];
          })(math.Projection || (math.Projection = {}));
        })(core.math || (core.math = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (math) {
          var PerspectiveProjection =
          /*#__PURE__*/
          function () {
            function PerspectiveProjection(field, cameraDist) {
              _classCallCheck(this, PerspectiveProjection);

              if (this.field === undefined) this.field = null;
              if (this.cameraDist === undefined) this.cameraDist = null;
              if (this.minDenom === undefined) this.minDenom = null;
              if (this.minDenomValue === undefined) this.minDenomValue = 0;
              this.field = field;
              this.cameraDist = cameraDist;
            }
            /**
            *
            * @param {com.vzome.core.algebra.AlgebraicVector} source
            * @param {boolean} wFirst
            * @return {com.vzome.core.algebra.AlgebraicVector}
            */


            _createClass(PerspectiveProjection, [{
              key: "projectImage",
              value: function projectImage(source, wFirst) {
                var result = this.field.origin(4);
                var w = source.getComponent(0);
                var denom = this.cameraDist['minus$com_vzome_core_algebra_AlgebraicNumber'](w);

                if (this.minDenom == null) {
                  this.minDenom = this.field['createPower$int'](-5);
                  this.minDenomValue = this.minDenom.evaluate();
                }

                var denomValue = denom.evaluate();

                if (denomValue < this.minDenomValue) {
                  denom = this.minDenom;
                }

                var numerator = denom.reciprocal();
                result.setComponent(0, this.field['createPower$int'](0));
                result.setComponent(1, source.getComponent(1)['times$com_vzome_core_algebra_AlgebraicNumber'](numerator));
                result.setComponent(2, source.getComponent(2)['times$com_vzome_core_algebra_AlgebraicNumber'](numerator));
                result.setComponent(3, source.getComponent(3)['times$com_vzome_core_algebra_AlgebraicNumber'](numerator));
                return result;
              }
              /**
              *
              * @param {*} element
              */

            }, {
              key: "getXmlAttributes",
              value: function getXmlAttributes(element) {
                if (this.cameraDist != null) {
                  com.vzome.xml.DomUtils.addAttribute(element, "cameraDist", this.cameraDist.toString(com.vzome.core.algebra.AlgebraicField.ZOMIC_FORMAT));
                }
              }
              /**
              *
              * @param {*} xml
              */

            }, {
              key: "setXmlAttributes",
              value: function setXmlAttributes(xml) {
                var nums = xml.getAttribute("cameraDist");
                if (nums == null ||
                /* isEmpty */
                nums.length === 0) return;
                this.cameraDist = this.field.parseNumber(nums);
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getProjectionName",
              value: function getProjectionName() {
                return "Perspective";
              }
            }]);

            return PerspectiveProjection;
          }();

          math.PerspectiveProjection = PerspectiveProjection;
          PerspectiveProjection["__class"] = "com.vzome.core.math.PerspectiveProjection";
          PerspectiveProjection["__interfaces"] = ["com.vzome.core.math.Projection"];
        })(core.math || (core.math = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (math) {
          var Line =
          /*#__PURE__*/
          function () {
            function Line(origin, direction) {
              _classCallCheck(this, Line);

              if (this.origin === undefined) this.origin = null;
              if (this.direction === undefined) this.direction = null;
              this.direction = direction;
              this.origin = origin;
            }

            _createClass(Line, [{
              key: "getOrigin",
              value: function getOrigin() {
                return this.origin;
              }
            }, {
              key: "getDirection",
              value: function getDirection() {
                return this.direction;
              }
            }]);

            return Line;
          }();

          math.Line = Line;
          Line["__class"] = "com.vzome.core.math.Line";
        })(core.math || (core.math = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (model_1) {
          var ColoredMeshJson =
          /*#__PURE__*/
          function () {
            function ColoredMeshJson() {
              _classCallCheck(this, ColoredMeshJson);
            }

            _createClass(ColoredMeshJson, null, [{
              key: "generate",
              value: function generate(model, field, writer) {
                var vertices = new java.util.TreeSet();
                var balls = new java.util.ArrayList();
                var struts = new java.util.ArrayList();
                var panels = new java.util.ArrayList();
                var lastBall = null;
                var lastVertex = null;

                for (var index609 = model.iterator(); index609.hasNext();) {
                  var man = index609.next();
                  {
                    if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0)) {
                      lastBall = man.getLocation();
                      vertices.add(lastBall);
                    } else if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0)) {
                      lastVertex = man.getLocation();
                      vertices.add(lastVertex);
                      vertices.add(man.getEnd());
                    } else if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0)) {
                      for (var index610 = man.iterator(); index610.hasNext();) {
                        var vertex = index610.next();
                        {
                          lastVertex = vertex;
                          vertices.add(vertex);
                        }
                      }
                    }
                  }
                }

                var origin = lastBall != null ? lastBall : lastVertex;
                var sortedVertexList = new java.util.ArrayList(vertices);
                vertices = null;
                var mapper = new com.fasterxml.jackson.databind.ObjectMapper();

                for (var index611 = model.iterator(); index611.hasNext();) {
                  var _man = index611.next();

                  {
                    if (_man != null && (_man["__interfaces"] != null && _man["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || _man.constructor != null && _man.constructor["__interfaces"] != null && _man.constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0)) {
                      var ballJson = mapper.createObjectNode();
                      ballJson.set("vertex", mapper.valueToTree(sortedVertexList.indexOf(_man.getLocation())));
                      ballJson.set("color", mapper.valueToTree(_man.getColor().toWebString()));
                      balls.add(ballJson);
                    } else if (_man != null && (_man["__interfaces"] != null && _man["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || _man.constructor != null && _man.constructor["__interfaces"] != null && _man.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0)) {
                      var strutJson = mapper.createObjectNode();
                      var start = sortedVertexList.indexOf(_man.getLocation());
                      var end = sortedVertexList.indexOf(_man.getEnd());
                      var ends = mapper.valueToTree([start, end]);
                      strutJson.set("vertices", ends);
                      strutJson.set("color", mapper.valueToTree(_man.getColor().toWebString()));
                      struts.add(strutJson);
                    } else if (_man != null && (_man["__interfaces"] != null && _man["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0 || _man.constructor != null && _man.constructor["__interfaces"] != null && _man.constructor["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0)) {
                      var panelJson = mapper.createObjectNode();
                      var vertexStream = java.util.stream.StreamSupport.stream(_man.spliterator(), false);
                      var node = mapper.valueToTree(vertexStream.map(function (sortedVertexList) {
                        return function (v) {
                          return sortedVertexList.indexOf(v);
                        };
                      }(sortedVertexList)).collect(java.util.stream.Collectors.toList()));
                      panelJson.set("vertices", node);
                      panelJson.set("color", mapper.valueToTree(_man.getColor().toWebString()));
                      panels.add(panelJson);
                    }
                  }
                }

                var factory = new com.fasterxml.jackson.core.JsonFactory().disable(com.fasterxml.jackson.core.JsonGenerator.Feature.AUTO_CLOSE_TARGET);
                var generator = factory.createGenerator(writer);
                generator.useDefaultPrettyPrinter();
                generator.setCodec(mapper);
                generator.writeStartObject();
                generator.writeStringField("field", field.getName());
                generator.writeFieldName("vertices");
                generator.writeStartArray();
                var objectWriter = mapper.writerWithView("com.vzome.core.algebra.AlgebraicNumber.Views.TrailingDivisor");

                for (var index612 = sortedVertexList.iterator(); index612.hasNext();) {
                  var algebraicVector = index612.next();
                  {
                    algebraicVector = algebraicVector.minus(origin);
                    generator.writeObject(mapper.readTree(objectWriter.writeValueAsString(algebraicVector)));
                  }
                }

                generator.writeEndArray();
                generator.writeObjectField("balls", balls);
                generator.writeObjectField("struts", struts);
                generator.writeObjectField("panels", panels);
                generator.writeEndObject();
                generator.close();
              }
            }, {
              key: "parse",
              value: function parse(json, offset, projection, events, registry) {
                var mapper = new com.fasterxml.jackson.databind.ObjectMapper();
                var node = mapper.readTree(json);
                var fieldName = node.has("field") ? node.get("field").asText() : "golden";
                var field = registry.getField(fieldName);

                if (!node.has("vertices")) {
                  throw new java.io.IOException("There is no \'vertices\' list in the JSON");
                }

                if (!node.has("balls") && !node.has("struts") && !node.has("panels")) {
                  throw new java.io.IOException("There are no balls, struts, or panels in the JSON");
                }

                var vertices = new java.util.ArrayList();
                {
                  var verticesNode = node.get("vertices");

                  for (var index613 = verticesNode.iterator(); index613.hasNext();) {
                    var vectorNode = index613.next();
                    {
                      var dimension = vectorNode.size();

                      var nums = function (s) {
                        var a = [];

                        while (s-- > 0) {
                          a.push(null);
                        }

                        return a;
                      }(dimension);

                      var i = 0;

                      for (var index614 = vectorNode.iterator(); index614.hasNext();) {
                        var numberNode = index614.next();
                        {
                          nums[i++] = mapper.treeToValue(numberNode, [].constructor);
                        }
                      }

                      var vertex = field.createIntegerVectorFromTDs(nums);
                      if (vertex.dimension() > 3) vertex = projection.projectImage(vertex, false);
                      if (offset != null) vertex = offset.plus(vertex);
                      vertices.add(vertex);
                    }
                  }
                }
                var collection = node.get("balls");

                if (collection != null) {
                  try {
                    var indices = mapper.treeToValue(collection, [].constructor);
                    java.util.Arrays.stream(indices).forEach(function (vertices) {
                      return function (i) {
                        return events.constructionAdded(new com.vzome.core.construction.FreePoint(vertices.get(i)), null);
                      };
                    }(vertices));
                  } catch (e) {
                    for (var index615 = collection.iterator(); index615.hasNext();) {
                      var ballNode = index615.next();
                      {
                        var vertexNode = ballNode.get("vertex");

                        var _i21 = vertexNode.asInt();

                        var colorNode = ballNode.get("color");
                        var color = colorNode == null ? null : com.vzome.core.construction.Color.parseWebColor(colorNode.asText());
                        events.constructionAdded(new com.vzome.core.construction.FreePoint(vertices.get(_i21)), color);
                      }
                    }
                  }
                }

                collection = node.get("struts");

                if (collection != null) {
                  for (var index616 = collection.iterator(); index616.hasNext();) {
                    var strutNode = index616.next();
                    {
                      if (strutNode.has("start")) {
                        var start = mapper.treeToValue(strutNode.get("start"), Number);
                        var end = mapper.treeToValue(strutNode.get("end"), Number);
                        var p1 = new com.vzome.core.construction.FreePoint(vertices.get(start));
                        var p2 = new com.vzome.core.construction.FreePoint(vertices.get(end));
                        events.constructionAdded(new com.vzome.core.construction.SegmentJoiningPoints(p1, p2), null);
                      } else {
                        var _verticesNode = strutNode.get("vertices");

                        var ends = mapper.treeToValue(_verticesNode, [].constructor);

                        var _p2 = new com.vzome.core.construction.FreePoint(vertices.get(ends[0]));

                        var _p3 = new com.vzome.core.construction.FreePoint(vertices.get(ends[1]));

                        var _colorNode = strutNode.get("color");

                        var _color = _colorNode == null ? null : com.vzome.core.construction.Color.parseWebColor(_colorNode.asText());

                        events.constructionAdded(new com.vzome.core.construction.SegmentJoiningPoints(_p2, _p3), _color);
                      }
                    }
                  }
                }

                collection = node.get("panels");

                if (collection != null) {
                  for (var index617 = collection.iterator(); index617.hasNext();) {
                    var panelNode = index617.next();
                    {
                      var _verticesNode2 = panelNode.get("vertices");

                      var _indices = mapper.treeToValue(_verticesNode2, [].constructor);

                      var points = java.util.Arrays.stream(_indices).mapToObj(function (vertices) {
                        return function (i) {
                          return new com.vzome.core.construction.FreePoint(vertices.get(i));
                        };
                      }(vertices)).collect(java.util.stream.Collectors.toList());
                      var panel = new com.vzome.core.construction.PolygonFromVertices(points);

                      var _colorNode2 = panelNode.get("color");

                      var _color2 = _colorNode2 == null ? null : com.vzome.core.construction.Color.parseWebColor(_colorNode2.asText());

                      events.constructionAdded(panel, _color2);
                    }
                  }
                }
              }
            }]);

            return ColoredMeshJson;
          }();

          model_1.ColoredMeshJson = ColoredMeshJson;
          ColoredMeshJson["__class"] = "com.vzome.core.model.ColoredMeshJson";
        })(core.model || (core.model = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (model) {
          var Group =
          /*#__PURE__*/
          function (_java$util$ArrayList2) {
            _inherits(Group, _java$util$ArrayList2);

            var _super4 = _createSuper(Group);

            function Group() {
              var _this9;

              _classCallCheck(this, Group);

              _this9 = _super4.call(this);
              if (_this9.mContainer === undefined) _this9.mContainer = null;
              return _this9;
            }

            _createClass(Group, [{
              key: "getContainer",
              value: function getContainer() {
                return this.mContainer;
              }
              /**
              *
              * @param {com.vzome.core.model.Group} container
              */

            }, {
              key: "setContainer",
              value: function setContainer(container) {
                this.mContainer = container;
              }
            }]);

            return Group;
          }(java.util.ArrayList);

          model.Group = Group;
          Group["__class"] = "com.vzome.core.model.Group";
          Group["__interfaces"] = ["java.util.RandomAccess", "com.vzome.core.model.GroupElement", "java.util.List", "java.lang.Cloneable", "java.util.Collection", "java.lang.Iterable", "java.io.Serializable"];
        })(core.model || (core.model = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (model_2) {
          var SimpleMeshJson =
          /*#__PURE__*/
          function () {
            function SimpleMeshJson() {
              _classCallCheck(this, SimpleMeshJson);
            }

            _createClass(SimpleMeshJson, null, [{
              key: "generate",
              value: function generate(model, field, writer) {
                var vertices = new java.util.TreeSet();
                var vertexIndices = new java.util.ArrayList();
                var edgeNodes = new java.util.ArrayList();
                var faceNodes = new java.util.ArrayList();
                var lastBall = null;
                var lastVertex = null;

                for (var index618 = model.iterator(); index618.hasNext();) {
                  var man = index618.next();
                  {
                    if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0)) {
                      lastBall = man.getLocation();
                      vertices.add(lastBall);
                    } else if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0)) {
                      lastVertex = man.getLocation();
                      vertices.add(lastVertex);
                      vertices.add(man.getEnd());
                    } else if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0)) {
                      for (var index619 = man.iterator(); index619.hasNext();) {
                        var vertex = index619.next();
                        {
                          lastVertex = vertex;
                          vertices.add(vertex);
                        }
                      }
                    }
                  }
                }

                var origin = lastBall != null ? lastBall : lastVertex;
                var sortedVertexList = new java.util.ArrayList(vertices);
                vertices = null;
                var mapper = new com.fasterxml.jackson.databind.ObjectMapper();

                for (var index620 = model.iterator(); index620.hasNext();) {
                  var _man2 = index620.next();

                  {
                    if (_man2 != null && (_man2["__interfaces"] != null && _man2["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || _man2.constructor != null && _man2.constructor["__interfaces"] != null && _man2.constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0)) {
                      vertexIndices.add(sortedVertexList.indexOf(_man2.getLocation()));
                    } else if (_man2 != null && (_man2["__interfaces"] != null && _man2["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || _man2.constructor != null && _man2.constructor["__interfaces"] != null && _man2.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0)) {
                      var start = sortedVertexList.indexOf(_man2.getLocation());
                      var end = sortedVertexList.indexOf(_man2.getEnd());
                      var ends = mapper.valueToTree([start, end]);
                      edgeNodes.add(ends);
                    } else if (_man2 != null && (_man2["__interfaces"] != null && _man2["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0 || _man2.constructor != null && _man2.constructor["__interfaces"] != null && _man2.constructor["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0)) {
                      var vertexStream = java.util.stream.StreamSupport.stream(_man2.spliterator(), false);
                      var node = mapper.valueToTree(vertexStream.map(function (sortedVertexList) {
                        return function (v) {
                          return sortedVertexList.indexOf(v);
                        };
                      }(sortedVertexList)).collect(java.util.stream.Collectors.toList()));
                      faceNodes.add(node);
                    }
                  }
                }

                var factory = new com.fasterxml.jackson.core.JsonFactory().disable(com.fasterxml.jackson.core.JsonGenerator.Feature.AUTO_CLOSE_TARGET);
                var generator = factory.createGenerator(writer);
                generator.useDefaultPrettyPrinter();
                generator.setCodec(mapper);
                generator.writeStartObject();
                generator.writeStringField("field", field.getName());
                generator.writeFieldName("vertices");
                generator.writeStartArray();
                var objectWriter = mapper.writerWithView("com.vzome.core.algebra.AlgebraicNumber.Views.TrailingDivisor");

                for (var index621 = sortedVertexList.iterator(); index621.hasNext();) {
                  var algebraicVector = index621.next();
                  {
                    algebraicVector = algebraicVector.minus(origin);
                    generator.writeObject(mapper.readTree(objectWriter.writeValueAsString(algebraicVector)));
                  }
                }

                generator.writeEndArray();
                generator.writeObjectField("edges", edgeNodes);
                generator.writeObjectField("faces", faceNodes);
                generator.writeEndObject();
                generator.close();
              }
            }, {
              key: "parse",
              value: function parse(json, offset, projection, events, registry) {
                var mapper = new com.fasterxml.jackson.databind.ObjectMapper();
                var node = mapper.readTree(json);
                var fieldName = node.has("field") ? node.get("field").asText() : "golden";
                var field = registry.getField(fieldName);

                if (!node.has("vertices")) {
                  throw new java.io.IOException("There is no \'vertices\' list in the JSON");
                }

                if (!node.has("edges")) {
                  throw new java.io.IOException("There is no \'edges\' list in the JSON");
                }

                if (!node.has("faces")) {
                  throw new java.io.IOException("There is no \'faces\' list in the JSON");
                }

                var vertices = new java.util.ArrayList();
                {
                  var verticesNode = node.get("vertices");

                  for (var index622 = verticesNode.iterator(); index622.hasNext();) {
                    var vectorNode = index622.next();
                    {
                      var dimension = vectorNode.size();

                      var nums = function (s) {
                        var a = [];

                        while (s-- > 0) {
                          a.push(null);
                        }

                        return a;
                      }(dimension);

                      var i = 0;

                      for (var index623 = vectorNode.iterator(); index623.hasNext();) {
                        var numberNode = index623.next();
                        {
                          nums[i++] = mapper.treeToValue(numberNode, [].constructor);
                        }
                      }

                      var vertex = field.createIntegerVectorFromTDs(nums);
                      if (vertex.dimension() > 3) vertex = projection.projectImage(vertex, false);
                      if (offset != null) vertex = offset.plus(vertex);
                      vertices.add(vertex);
                    }
                  }
                }
                var collection = node.get("edges");

                for (var index624 = collection.iterator(); index624.hasNext();) {
                  var strutNode = index624.next();
                  {
                    var ends = mapper.treeToValue(strutNode, [].constructor);
                    var p1 = new com.vzome.core.construction.FreePoint(vertices.get(ends[0]));
                    var p2 = new com.vzome.core.construction.FreePoint(vertices.get(ends[1]));
                    events.constructionAdded(p1);
                    events.constructionAdded(p2);
                    events.constructionAdded(new com.vzome.core.construction.SegmentJoiningPoints(p1, p2));
                  }
                }

                collection = node.get("faces");

                for (var index625 = collection.iterator(); index625.hasNext();) {
                  var panelNode = index625.next();
                  {
                    var indices = mapper.treeToValue(panelNode, [].constructor);
                    var points = java.util.Arrays.stream(indices).mapToObj(function (vertices) {
                      return function (i) {
                        return new com.vzome.core.construction.FreePoint(vertices.get(i));
                      };
                    }(vertices)).collect(java.util.stream.Collectors.toList());
                    var panel = new com.vzome.core.construction.PolygonFromVertices(points);
                    events.constructionAdded(panel);
                  }
                }
              }
            }]);

            return SimpleMeshJson;
          }();

          model_2.SimpleMeshJson = SimpleMeshJson;
          SimpleMeshJson["__class"] = "com.vzome.core.model.SimpleMeshJson";
        })(core.model || (core.model = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (parts) {
          /**
          * @author Scott Vorthmann
          *
          * Since every field allows octahedral symmetry, we want the richest triangular
          * tiling of that symmetry, which means we want the fundamental triangles of
          * the reflection group, by definition.  Rather than rely on any symmetry orbits,
          * we can simply hard-code the vertices of a disdyakis dodecahedron, all
          * reflections and permutations of (8,0,0), (4,4,4), and (5,5,0).
          * (This is a simple approximation with integers.)
          * These vertices correspond to blue-like, yellow-like, and green-like axes,
          * in the usual Zome coloring.
          * @param {com.vzome.core.math.symmetry.Direction} dir
          * @class
          */
          var FastDefaultStrutGeometry =
          /*#__PURE__*/
          function () {
            function FastDefaultStrutGeometry(dir) {
              _classCallCheck(this, FastDefaultStrutGeometry);

              if (this.g2_vector === undefined) this.g2_vector = null;
              if (this.b2_vector === undefined) this.b2_vector = null;
              if (this.y2_vector === undefined) this.y2_vector = null;
              if (this.g2n_vector === undefined) this.g2n_vector = null;
              if (this.y2n_vector === undefined) this.y2n_vector = null;
              if (this.mAxis === undefined) this.mAxis = null;
              this.mAxis = dir.getAxis$int$int(com.vzome.core.math.symmetry.Symmetry.PLUS, 0);
              var v = this.mAxis.normal();
              var x = v.getComponent(com.vzome.core.algebra.AlgebraicVector.X).evaluate();
              var y = v.getComponent(com.vzome.core.algebra.AlgebraicVector.Y).evaluate();
              var z = v.getComponent(com.vzome.core.algebra.AlgebraicVector.Z).evaluate();
              var evenParity = true;
              var xNeg = x < 0.0;

              if (xNeg) {
                x = -x;
                evenParity = !evenParity;
              }

              var yNeg = y < 0.0;

              if (yNeg) {
                y = -y;
                evenParity = !evenParity;
              }

              var zNeg = z < 0.0;

              if (zNeg) {
                z = -z;
                evenParity = !evenParity;
              }

              var first;
              var second;
              var third;
              var firstNeg;
              var secondNeg;
              var thirdNeg;

              if (x >= y) {
                if (y >= z) {
                  first = com.vzome.core.algebra.AlgebraicVector.X;
                  firstNeg = xNeg;
                  second = com.vzome.core.algebra.AlgebraicVector.Y;
                  secondNeg = yNeg;
                  third = com.vzome.core.algebra.AlgebraicVector.Z;
                  thirdNeg = zNeg;
                } else if (x >= z) {
                  first = com.vzome.core.algebra.AlgebraicVector.X;
                  firstNeg = xNeg;
                  second = com.vzome.core.algebra.AlgebraicVector.Z;
                  secondNeg = zNeg;
                  third = com.vzome.core.algebra.AlgebraicVector.Y;
                  thirdNeg = yNeg;
                  evenParity = !evenParity;
                } else {
                  first = com.vzome.core.algebra.AlgebraicVector.Z;
                  firstNeg = zNeg;
                  second = com.vzome.core.algebra.AlgebraicVector.X;
                  secondNeg = xNeg;
                  third = com.vzome.core.algebra.AlgebraicVector.Y;
                  thirdNeg = yNeg;
                }
              } else {
                if (x >= z) {
                  first = com.vzome.core.algebra.AlgebraicVector.Y;
                  firstNeg = yNeg;
                  second = com.vzome.core.algebra.AlgebraicVector.X;
                  secondNeg = xNeg;
                  third = com.vzome.core.algebra.AlgebraicVector.Z;
                  thirdNeg = zNeg;
                  evenParity = !evenParity;
                } else if (y >= z) {
                  first = com.vzome.core.algebra.AlgebraicVector.Y;
                  firstNeg = yNeg;
                  second = com.vzome.core.algebra.AlgebraicVector.Z;
                  secondNeg = zNeg;
                  third = com.vzome.core.algebra.AlgebraicVector.X;
                  thirdNeg = xNeg;
                } else {
                  first = com.vzome.core.algebra.AlgebraicVector.Z;
                  firstNeg = zNeg;
                  second = com.vzome.core.algebra.AlgebraicVector.Y;
                  secondNeg = yNeg;
                  third = com.vzome.core.algebra.AlgebraicVector.X;
                  thirdNeg = xNeg;
                  evenParity = !evenParity;
                }
              }

              var field = v.getField();
              var eight = field['createRational$long$long'](8, 10);
              this.b2_vector = field.origin(3);
              this.b2_vector.setComponent(first, firstNeg ? eight.negate() : eight);
              var five = field['createRational$long$long'](5, 10);
              this.g2_vector = field.origin(3);
              this.g2_vector.setComponent(first, firstNeg ? five.negate() : five);
              this.g2_vector.setComponent(second, secondNeg ? five.negate() : five);
              var four = field['createRational$long$long'](4, 10);
              this.y2_vector = field.origin(3);
              this.y2_vector.setComponent(first, firstNeg ? four.negate() : four);
              this.y2_vector.setComponent(second, secondNeg ? four.negate() : four);
              this.y2_vector.setComponent(third, thirdNeg ? four.negate() : four);

              if (!evenParity) {
                var swap = this.y2_vector;
                this.y2_vector = this.g2_vector;
                this.g2_vector = swap;
              }

              var centroid = com.vzome.core.algebra.AlgebraicVectors.getCentroid([this.b2_vector, this.g2_vector, this.y2_vector]);
              var b2g2 = this.g2_vector.minus(this.b2_vector);
              var y2g2 = this.g2_vector.minus(this.y2_vector);
              var normal = com.vzome.core.algebra.AlgebraicVectors.getNormal$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector(b2g2, y2g2);
              var intersection = com.vzome.core.algebra.AlgebraicVectors.getLinePlaneIntersection(field.origin(3), v, this.g2_vector, normal);
              var g2_offset = this.g2_vector.minus(centroid);
              var y2_offset = this.y2_vector.minus(centroid);
              this.g2_vector = intersection.plus(g2_offset);
              this.y2_vector = intersection.plus(y2_offset);
              this.g2n_vector = intersection.minus(g2_offset);
              this.y2n_vector = intersection.minus(y2_offset);
            }
            /**
            *
            * @param {*} length
            * @return {com.vzome.core.math.Polyhedron}
            */


            _createClass(FastDefaultStrutGeometry, [{
              key: "getStrutPolyhedron",
              value: function getStrutPolyhedron(length) {
                var field = this.mAxis.getDirection().getSymmetry().getField();
                var poly = new com.vzome.core.math.Polyhedron(field);
                var strutVector = this.mAxis.normal().scale(length);
                var g1_vector = this.g2_vector.negate().plus(strutVector);
                var y1_vector = this.y2_vector.negate().plus(strutVector);
                var g1n_vector = this.g2n_vector.negate().plus(strutVector);
                var y1n_vector = this.y2n_vector.negate().plus(strutVector);
                poly.addVertex(y1_vector);
                var y1 = 0;
                poly.addVertex(g1_vector);
                var g1 = 1;
                poly.addVertex(this.y2_vector);
                var y2 = 2;
                poly.addVertex(this.g2_vector);
                var g2 = 3;
                poly.addVertex(y1n_vector);
                var y1n = 4;
                poly.addVertex(g1n_vector);
                var g1n = 5;
                poly.addVertex(this.y2n_vector);
                var y2n = 6;
                poly.addVertex(this.g2n_vector);
                var g2n = 7;
                var face = poly.newFace();
                face.add(g2);
                face.add(y2);
                face.add(y1n);
                face.add(g1n);
                poly.addFace(face);
                face = poly.newFace();
                face.add(g2);
                face.add(g1n);
                face.add(y1);
                face.add(y2n);
                poly.addFace(face);
                face = poly.newFace();
                face.add(g2n);
                face.add(y2n);
                face.add(y1);
                face.add(g1);
                poly.addFace(face);
                face = poly.newFace();
                face.add(g2n);
                face.add(g1);
                face.add(y1n);
                face.add(y2);
                poly.addFace(face);
                face = poly.newFace();
                face.add(y2);
                face.add(g2);
                face.add(y2n);
                face.add(g2n);
                poly.addFace(face);
                face = poly.newFace();
                face.add(g1);
                face.add(y1);
                face.add(g1n);
                face.add(y1n);
                poly.addFace(face);
                return poly;
              }
            }]);

            return FastDefaultStrutGeometry;
          }();

          parts.FastDefaultStrutGeometry = FastDefaultStrutGeometry;
          FastDefaultStrutGeometry["__class"] = "com.vzome.core.parts.FastDefaultStrutGeometry";
          FastDefaultStrutGeometry["__interfaces"] = ["com.vzome.core.parts.StrutGeometry"];
        })(core.parts || (core.parts = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          /**
          * @author Scott Vorthmann
          * @class
          */
          var Construction =
          /*#__PURE__*/
          function () {
            function Construction(field) {
              _classCallCheck(this, Construction);

              if (this.field === undefined) this.field = null;
              this.mImpossible = false;
              this.mIndex = -1;
              this.__failed = false;
              if (this.color === undefined) this.color = null;
              this.field = field;
            }

            _createClass(Construction, [{
              key: "getField",
              value: function getField() {
                return this.field;
              }
            }, {
              key: "setIndex",
              value: function setIndex(index) {
                this.mIndex = index;
              }
            }, {
              key: "getIndex",
              value: function getIndex() {
                return this.mIndex;
              }
            }, {
              key: "isImpossible",
              value: function isImpossible() {
                return this.mImpossible;
              }
            }, {
              key: "setImpossible",
              value: function setImpossible(value) {
                this.mImpossible = value;
              }
            }, {
              key: "setFailed",
              value: function setFailed() {
                this.__failed = true;
              }
            }, {
              key: "failed",
              value: function failed() {
                return this.__failed;
              }
            }, {
              key: "setColor",
              value: function setColor(color) {
                this.color = color;
              }
            }, {
              key: "getColor",
              value: function getColor() {
                return this.color;
              }
            }]);

            return Construction;
          }();

          construction.Construction = Construction;
          Construction["__class"] = "com.vzome.core.construction.Construction";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          /**
          * A selection in the model.
          * @class
          * @extends java.util.ArrayList
          */
          var ConstructionList =
          /*#__PURE__*/
          function (_java$util$ArrayList3) {
            _inherits(ConstructionList, _java$util$ArrayList3);

            var _super5 = _createSuper(ConstructionList);

            _createClass(ConstructionList, [{
              key: "addConstruction",
              value: function addConstruction(ball) {
                this.add(ball);
                return this;
              }
            }, {
              key: "removeConstruction",
              value: function removeConstruction(ball) {
                this.remove(ball);
                return this;
              }
            }, {
              key: "getConstructions",
              value: function getConstructions() {
                return this.toArray(function (s) {
                  var a = [];

                  while (s-- > 0) {
                    a.push(null);
                  }

                  return a;
                }(this.size()));
              }
            }]);

            function ConstructionList() {
              _classCallCheck(this, ConstructionList);

              return _super5.call(this);
            }

            return ConstructionList;
          }(java.util.ArrayList);

          construction.ConstructionList = ConstructionList;
          ConstructionList["__class"] = "com.vzome.core.construction.ConstructionList";
          ConstructionList["__interfaces"] = ["java.util.RandomAccess", "java.util.List", "java.lang.Cloneable", "java.util.Collection", "java.lang.Iterable", "java.io.Serializable"];
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          /**
          * @author Scott Vorthmann
          * @param {number} r
          * @param {number} g
          * @param {number} b
          * @param {number} a
          * @class
          */
          var Color =
          /*#__PURE__*/
          function () {
            function Color(r, g, b, a) {
              var _this10 = this;

              _classCallCheck(this, Color);

              if ((typeof r === 'number' || r === null) && (typeof g === 'number' || g === null) && (typeof b === 'number' || b === null) && (typeof a === 'number' || a === null)) {
                if (this.red === undefined) this.red = 0;
                if (this.green === undefined) this.green = 0;
                if (this.blue === undefined) this.blue = 0;
                if (this.alpha === undefined) this.alpha = 0;
                if (this.red === undefined) this.red = 0;
                if (this.green === undefined) this.green = 0;
                if (this.blue === undefined) this.blue = 0;
                if (this.alpha === undefined) this.alpha = 0;

                (function () {
                  _this10.red = r > 255 ? 255 : r < 0 ? 0 : r;
                  _this10.green = g > 255 ? 255 : g < 0 ? 0 : g;
                  _this10.blue = b > 255 ? 255 : b < 0 ? 0 : b;
                  _this10.alpha = a > 255 ? 255 : a < 0 ? 0 : a;
                })();
              } else if ((typeof r === 'number' || r === null) && (typeof g === 'number' || g === null) && (typeof b === 'number' || b === null) && a === undefined) {
                {
                  var _a = 255;
                  if (this.red === undefined) this.red = 0;
                  if (this.green === undefined) this.green = 0;
                  if (this.blue === undefined) this.blue = 0;
                  if (this.alpha === undefined) this.alpha = 0;
                  if (this.red === undefined) this.red = 0;
                  if (this.green === undefined) this.green = 0;
                  if (this.blue === undefined) this.blue = 0;
                  if (this.alpha === undefined) this.alpha = 0;

                  (function () {
                    _this10.red = r > 255 ? 255 : r < 0 ? 0 : r;
                    _this10.green = g > 255 ? 255 : g < 0 ? 0 : g;
                    _this10.blue = b > 255 ? 255 : b < 0 ? 0 : b;
                    _this10.alpha = _a > 255 ? 255 : _a < 0 ? 0 : _a;
                  })();
                }
              } else if ((typeof r === 'string' || r === null) && g === undefined && b === undefined && a === undefined) {
                var _args10 = arguments;
                var rgbaHex = _args10[0];
                if (this.red === undefined) this.red = 0;
                if (this.green === undefined) this.green = 0;
                if (this.blue === undefined) this.blue = 0;
                if (this.alpha === undefined) this.alpha = 0;
                if (this.red === undefined) this.red = 0;
                if (this.green === undefined) this.green = 0;
                if (this.blue === undefined) this.blue = 0;
                if (this.alpha === undefined) this.alpha = 0;

                (function () {
                  var rgba = javaemul.internal.IntegerHelper.parseUnsignedInt(rgbaHex, 16);
                  var r = rgba >> 24 & 255;
                  var g = rgba >> 16 & 255;
                  var b = rgba >> 8 & 255;
                  var a = rgba >> 0 & 255;
                  _this10.red = r > 255 ? 255 : r < 0 ? 0 : r;
                  _this10.green = g > 255 ? 255 : g < 0 ? 0 : g;
                  _this10.blue = b > 255 ? 255 : b < 0 ? 0 : b;
                  _this10.alpha = a > 255 ? 255 : a < 0 ? 0 : a;
                })();
              } else if ((typeof r === 'number' || r === null) && g === undefined && b === undefined && a === undefined) {
                var _args11 = arguments;
                var rgb = _args11[0];
                {
                  var _r2 = rgb >> 16 & 255;

                  var _g2 = rgb >> 8 & 255;

                  var _b2 = rgb & 255;

                  {
                    var _a2 = 255;
                    if (this.red === undefined) this.red = 0;
                    if (this.green === undefined) this.green = 0;
                    if (this.blue === undefined) this.blue = 0;
                    if (this.alpha === undefined) this.alpha = 0;
                    if (this.red === undefined) this.red = 0;
                    if (this.green === undefined) this.green = 0;
                    if (this.blue === undefined) this.blue = 0;
                    if (this.alpha === undefined) this.alpha = 0;

                    (function () {
                      _this10.red = _r2 > 255 ? 255 : _r2 < 0 ? 0 : _r2;
                      _this10.green = _g2 > 255 ? 255 : _g2 < 0 ? 0 : _g2;
                      _this10.blue = _b2 > 255 ? 255 : _b2 < 0 ? 0 : _b2;
                      _this10.alpha = _a2 > 255 ? 255 : _a2 < 0 ? 0 : _a2;
                    })();
                  }
                }
              } else throw new Error('invalid overload');
            }

            _createClass(Color, [{
              key: "getRGBColorComponents",
              value: function getRGBColorComponents(rgb) {
                var len = rgb.length;

                if (len < 3 || len > 4) {
                  throw new java.lang.IllegalArgumentException("Expected rgb.length to be 3 or 4. Found " + len + ".");
                }

                rgb[0] = Math.fround(this.red / 255.0);
                rgb[1] = Math.fround(this.green / 255.0);
                rgb[2] = Math.fround(this.blue / 255.0);

                if (len === 4) {
                  rgb[3] = Math.fround(this.alpha / 255.0);
                }

                return rgb;
              }
              /**
              *
              * @return {number}
              */

            }, {
              key: "hashCode",
              value: function hashCode() {
                return this.getRGBA();
              }
              /**
              *
              * @param {*} other
              * @return {boolean}
              */

            }, {
              key: "equals",
              value: function equals(other) {
                if (this === other) return true;
                if (other == null) return true;
                if (!(other != null && other instanceof com.vzome.core.construction.Color)) return false;
                var c = other;
                return this.red === c.red && this.green === c.green && this.blue === c.blue && this.alpha === c.alpha;
              }
            }, {
              key: "getPastel",
              value: function getPastel() {
                var r = this.red + ((255 - this.red) / 2 | 0);
                var g = this.green + ((255 - this.green) / 2 | 0);
                var b = this.blue + ((255 - this.blue) / 2 | 0);
                return new Color(r, g, b, this.alpha);
              }
              /**
              * @return
              * @return {number}
              */

            }, {
              key: "getRGBA",
              value: function getRGBA() {
                return this.red * 16777216 + this.green * 65536 + this.blue * 256 + this.alpha;
              }
            }, {
              key: "getRGB",
              value: function getRGB() {
                return this.red * 65536 + this.green * 256 + this.blue;
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "toString",
              value: function toString() {
                return this.red + "," + this.green + "," + this.blue + (this.alpha < 255 ? "," + this.alpha : "");
              }
            }, {
              key: "toWebString",
              value: function toWebString() {
                return javaemul.internal.StringHelper.format("#%02X%02X%02X", this.red, this.green, this.blue);
              }
            }, {
              key: "getRed",
              value: function getRed() {
                return this.red;
              }
            }, {
              key: "getGreen",
              value: function getGreen() {
                return this.green;
              }
            }, {
              key: "getBlue",
              value: function getBlue() {
                return this.blue;
              }
            }, {
              key: "getAlpha",
              value: function getAlpha() {
                return this.alpha;
              }
            }], [{
              key: "BLACK_$LI$",
              value: function BLACK_$LI$() {
                if (Color.BLACK == null) Color.BLACK = new Color(0, 0, 0);
                return Color.BLACK;
              }
            }, {
              key: "WHITE_$LI$",
              value: function WHITE_$LI$() {
                if (Color.WHITE == null) Color.WHITE = new Color(255, 255, 255);
                return Color.WHITE;
              }
            }, {
              key: "GREY_TRANSPARENT_$LI$",
              value: function GREY_TRANSPARENT_$LI$() {
                if (Color.GREY_TRANSPARENT == null) Color.GREY_TRANSPARENT = new Color(25, 25, 25, 50);
                return Color.GREY_TRANSPARENT;
              }
            }, {
              key: "parseColor",
              value: function parseColor(str) {
                var toks = new java.util.StringTokenizer(str, ",");
                var red = toks.nextToken();
                var green = toks.nextToken();
                var blue = toks.nextToken();
                return new Color(javaemul.internal.IntegerHelper.parseInt(red), javaemul.internal.IntegerHelper.parseInt(green), javaemul.internal.IntegerHelper.parseInt(blue));
              }
            }, {
              key: "parseWebColor",
              value: function parseWebColor(colorStr) {
                return new Color(
                /* intValue */
                javaemul.internal.IntegerHelper.valueOf(colorStr.substring(1, 3), 16) | 0,
                /* intValue */
                javaemul.internal.IntegerHelper.valueOf(colorStr.substring(3, 5), 16) | 0,
                /* intValue */
                javaemul.internal.IntegerHelper.valueOf(colorStr.substring(5, 7), 16) | 0);
              }
            }, {
              key: "getComplement",
              value: function getComplement(color) {
                return color == null ? null : new Color((128 + color.red) % 256, (128 + color.green) % 256, (128 + color.blue) % 256, color.alpha);
              }
            }, {
              key: "getInverted",
              value: function getInverted(color) {
                return color == null ? null : new Color(255 - color.red, 255 - color.green, 255 - color.blue, color.alpha);
              }
              /**
              * @param {com.vzome.core.construction.Color} color color to be modified.
              * @param {number} scale0to1 is adjusted internally to be between 0 and 1.
              * @return {com.vzome.core.construction.Color} The original color maximized then having each component
              * multiplied by the specified scale (between 0 and 1).
              * Multiplying by 0 returns BLACK.
              * Multiplying by 1 returns the maximized color.
              */

            }, {
              key: "getScaledTo",
              value: function getScaledTo(color, scale0to1) {
                if (color == null) {
                  return null;
                }

                var maxColor = Color.getMaximum(color);
                var scale = Math.min(Math.max(0.0, scale0to1), 1.0);
                if (scale === 0.0) return Color.BLACK_$LI$();
                if (scale === 1.0) return maxColor;
                var red = maxColor.getRed() * scale;
                var green = maxColor.getGreen() * scale;
                var blue = maxColor.getBlue() * scale;
                return new Color(
                /* intValue */
                red | 0,
                /* intValue */
                green | 0,
                /* intValue */
                blue | 0, color.getAlpha());
              }
              /**
              * @param {com.vzome.core.construction.Color} color
              * @return {com.vzome.core.construction.Color} A new color where each of the RGB components are proportional to the parameter
              * but scaled so that the component with the highest value becomes 0xFF.
              * Other components are scaled proportionally. The alpha component is unchanged.
              * If the color is null or BLACK (0,0,0) or if one or more elements are already at 0xFF
              * then the original value is returned unchanged.
              */

            }, {
              key: "getMaximum",
              value: function getMaximum(color) {
                if (color == null) {
                  return null;
                }

                var most = Math.max(Math.max(color.red, color.green), color.blue);
                return most === 0 || most === 255 ? color : new Color(255 * color.red / most | 0, 255 * color.green / most | 0, 255 * color.blue / most | 0, color.alpha);
              }
            }, {
              key: "getPastel",
              value: function getPastel(color) {
                return color == null ? null : color.getPastel();
              }
            }]);

            return Color;
          }();

          construction.Color = Color;
          Color["__class"] = "com.vzome.core.construction.Color";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (generic) {
          /**
          * @author David Hall
          * @class
          */
          var ArrayComparator =
          /*#__PURE__*/
          function () {
            function ArrayComparator() {
              _classCallCheck(this, ArrayComparator);
            }

            _createClass(ArrayComparator, [{
              key: "getContentFirstArrayComparator",
              value: function getContentFirstArrayComparator() {
                return new ArrayComparator.ContentFirstArrayComparator();
              }
            }, {
              key: "getLengthFirstArrayComparator",
              value: function getLengthFirstArrayComparator() {
                return new ArrayComparator.LengthFirstArrayComparator();
              }
            }]);

            return ArrayComparator;
          }();

          generic.ArrayComparator = ArrayComparator;
          ArrayComparator["__class"] = "com.vzome.core.generic.ArrayComparator";

          (function (ArrayComparator) {
            var ContentFirstArrayComparator =
            /*#__PURE__*/
            function () {
              _createClass(ContentFirstArrayComparator, [{
                key: "compare",

                /**
                *
                * @param {Array} array1
                * @param {Array} array2
                * @return {number}
                */
                value: function compare(array1, array2) {
                  var len1 = array1.length;
                  var len2 = array2.length;
                  var smaller = len1 < len2 ? len1 : len2;

                  for (var i = 0; i < smaller; i++) {
                    {
                      var element1 = array1[i];
                      var element2 = array2[i];
                      var comparison = element1.compareTo(element2);

                      if (comparison !== 0) {
                        return comparison;
                      }
                    }
                  }

                  return (
                    /* compareTo */
                    function (o1, o2) {
                      if (o1 && o1.compareTo) {
                        return o1.compareTo(o2);
                      } else {
                        return o1 < o2 ? -1 : o2 < o1 ? 1 : 0;
                      }
                    }(len1, len2)
                  );
                }
              }]);

              function ContentFirstArrayComparator() {
                _classCallCheck(this, ContentFirstArrayComparator);
              }

              return ContentFirstArrayComparator;
            }();

            ArrayComparator.ContentFirstArrayComparator = ContentFirstArrayComparator;
            ContentFirstArrayComparator["__class"] = "com.vzome.core.generic.ArrayComparator.ContentFirstArrayComparator";
            ContentFirstArrayComparator["__interfaces"] = ["java.util.Comparator"];

            var LengthFirstArrayComparator =
            /*#__PURE__*/
            function () {
              _createClass(LengthFirstArrayComparator, [{
                key: "compare",

                /**
                *
                * @param {Array} array1
                * @param {Array} array2
                * @return {number}
                */
                value: function compare(array1, array2) {
                  var len1 = array1.length;
                  var len2 = array2.length;

                  var comparison = function (o1, o2) {
                    if (o1 && o1.compareTo) {
                      return o1.compareTo(o2);
                    } else {
                      return o1 < o2 ? -1 : o2 < o1 ? 1 : 0;
                    }
                  }(len1, len2);

                  if (comparison !== 0) {
                    return comparison;
                  }

                  for (var i = 0; i < len1; i++) {
                    {
                      var element1 = array1[i];
                      var element2 = array2[i];
                      comparison = element1.compareTo(element2);

                      if (comparison !== 0) {
                        return comparison;
                      }
                    }
                  }

                  return comparison;
                }
              }]);

              function LengthFirstArrayComparator() {
                _classCallCheck(this, LengthFirstArrayComparator);
              }

              return LengthFirstArrayComparator;
            }();

            ArrayComparator.LengthFirstArrayComparator = LengthFirstArrayComparator;
            LengthFirstArrayComparator["__class"] = "com.vzome.core.generic.ArrayComparator.LengthFirstArrayComparator";
            LengthFirstArrayComparator["__interfaces"] = ["java.util.Comparator"];
          })(ArrayComparator = generic.ArrayComparator || (generic.ArrayComparator = {}));
        })(core.generic || (core.generic = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (generic) {
          /**
          * @author David Hall
          * Based on http://stackoverflow.com/questions/5474893/how-to-implement-this-filteringiterator
          * @class
          */
          var FilteredIterator =
          /*#__PURE__*/
          function () {
            function FilteredIterator(preTest, iterable, postTest) {
              _classCallCheck(this, FilteredIterator);

              if (this.wrappedIterator === undefined) this.wrappedIterator = null;
              if (this.__preFilter === undefined) this.__preFilter = null;
              if (this.__postFilter === undefined) this.__postFilter = null;
              this.nextElement = null;
              this.__hasNext = null;
              this.wrappedIterator = iterable.iterator();
              this.__preFilter = preTest;
              this.__postFilter = postTest;
            }
            /**
            * Elements must match this filter before conversion
            * @param {*} element
            * @return {boolean}
            */


            _createClass(FilteredIterator, [{
              key: "preFilter",
              value: function preFilter(element) {
                return this.__preFilter == null ? true : function (target) {
                  return typeof target === 'function' ? target(element) : target.test(element);
                }(this.__preFilter);
              }
              /**
              * Elements must match this filter after conversion
              * @param {*} element
              * @return {boolean}
              */

            }, {
              key: "postFilter",
              value: function postFilter(element) {
                return this.__postFilter == null ? true : function (target) {
                  return typeof target === 'function' ? target(element) : target.test(element);
                }(this.__postFilter);
              }
              /**
              *
              * @return {*}
              */

            }, {
              key: "iterator",
              value: function iterator() {
                return this;
              }
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "hasNext",
              value: function hasNext() {
                if (this.__hasNext == null) {
                  this.nextMatch();
                }

                return this.__hasNext;
              }
              /**
              *
              * @return {*}
              */

            }, {
              key: "next",
              value: function next() {
                if (this.__hasNext == null) {
                  this.nextMatch();
                }

                if (!this.__hasNext) {
                  throw new java.util.NoSuchElementException();
                }

                return this.nextMatch();
              }
            }, {
              key: "nextMatch",
              value: function nextMatch() {
                var lastMatch = this.nextElement;

                while (this.wrappedIterator.hasNext()) {
                  {
                    var next = this.wrappedIterator.next();

                    if (this.preFilter(next)) {
                      var converted = this.apply(next);

                      if (this.postFilter(converted)) {
                        this.nextElement = converted;
                        this.__hasNext = true;
                        return lastMatch;
                      }
                    }
                  }
                }

                this.__hasNext = false;
                return lastMatch;
              }
              /**
              *
              */

            }, {
              key: "remove",
              value: function remove() {
                this.wrappedIterator.remove();
              }
            }]);

            return FilteredIterator;
          }();

          generic.FilteredIterator = FilteredIterator;
          FilteredIterator["__class"] = "com.vzome.core.generic.FilteredIterator";
          FilteredIterator["__interfaces"] = ["java.util.Iterator", "java.lang.Iterable"];

          (function (FilteredIterator) {
            var Filters =
            /*#__PURE__*/
            function () {
              function Filters() {
                _classCallCheck(this, Filters);
              }
              /**
              * A static convenience function that may be passed as a preFilter parameter
              * @param <T>
              * @param {*} element
              * @return {boolean} {@code true} if element is not null
              */


              _createClass(Filters, null, [{
                key: "elementNotNull",
                value: function elementNotNull(element) {
                  return element != null;
                }
                /**
                * A static convenience function that may be passed as a postFilter parameter
                * @param <R>
                * @param {*} result
                * @return {boolean} {@code true} if result is not null
                */

              }, {
                key: "resultNotNull",
                value: function resultNotNull(result) {
                  return result != null;
                }
                /**
                * A static convenience function that may be used with another predicate
                * to be passed as a preFilter or postFilter parameter
                * @param <B>
                * @param {*} predicate The predicate to be negated.
                * @param {*} arg The parameter to be passed to the predicate.
                * @return {boolean} The opposite of what the predicate returns.
                */

              }, {
                key: "not",
                value: function not(predicate, arg) {
                  return function (target) {
                    return typeof target === 'function' ? target(arg) : target.test(arg);
                  }(function (target) {
                    return typeof target === 'function' ? target() : target.negate();
                  }(predicate));
                }
                /**
                * A static convenience function that may be used to combine two other predicates
                * to be passed as a preFilter or postFilter parameter
                * @param <B>
                * @param {*} check1 The 1st predicate to be evaluated.
                * @param {*} check2 The 2nd predicate to be evaluated.
                * @param {*} arg The parameter to be passed to the predicates.
                * @return {boolean} {@code true} only if both predicates are true.
                */

              }, {
                key: "and",
                value: function and(check1, check2, arg) {
                  return function (target) {
                    return typeof target === 'function' ? target(arg) : target.test(arg);
                  }(function (target) {
                    return typeof target === 'function' ? target(check2) : target.and(check2);
                  }(check1));
                }
                /**
                * A static convenience function that may be used to combine two other predicates
                * to be passed as a preFilter or postFilter parameter
                * @param <B>
                * @param {*} check1 The 1st predicate to be evaluated.
                * @param {*} check2 The 2nd predicate to be evaluated.
                * @param {*} arg The parameter to be passed to the predicates.
                * @return {boolean} {@code true} if either predicate is true.
                */

              }, {
                key: "or",
                value: function or(check1, check2, arg) {
                  return function (target) {
                    return typeof target === 'function' ? target(arg) : target.test(arg);
                  }(function (target) {
                    return typeof target === 'function' ? target(check2) : target.or(check2);
                  }(check1));
                }
              }]);

              return Filters;
            }();

            FilteredIterator.Filters = Filters;
            Filters["__class"] = "com.vzome.core.generic.FilteredIterator.Filters";
          })(FilteredIterator = generic.FilteredIterator || (generic.FilteredIterator = {}));
        })(core.generic || (core.generic = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (commands) {
          var XmlSaveFormat =
          /*#__PURE__*/
          function () {
            function XmlSaveFormat(version, capabilities) {
              _classCallCheck(this, XmlSaveFormat);

              if (this.mProject4d === undefined) this.mProject4d = false;
              if (this.mSelectionNotSaved === undefined) this.mSelectionNotSaved = false;
              if (this.mRationalVectors === undefined) this.mRationalVectors = false;
              if (this.mGroupingInSelection === undefined) this.mGroupingInSelection = false;
              if (this.mField === undefined) this.mField = null;
              if (this.mScale === undefined) this.mScale = 0;
              if (this.mMultiplier === undefined) this.mMultiplier = null;
              if (this.writerVersion === undefined) this.writerVersion = null;
              if (this.version === undefined) this.version = null;
              this.capabilities = new java.util.HashSet();
              if (this.properties === undefined) this.properties = null;
              this.version = version;
              this.capabilities.addAll(java.util.Arrays.asList(capabilities));
              this.mProject4d = this.capabilities.contains(XmlSaveFormat.PROJECT_4D);
              this.mSelectionNotSaved = this.capabilities.contains(XmlSaveFormat.SELECTION_NOT_SAVED);
              this.mRationalVectors = this.capabilities.contains(XmlSaveFormat.RATIONAL_VECTORS);
              this.mGroupingInSelection = this.capabilities.contains(XmlSaveFormat.GROUPING_IN_SELECTION);
              XmlSaveFormat.FORMATS_$LI$().put(version, this);
            }

            _createClass(XmlSaveFormat, [{
              key: "initialize",

              /**
              * Initialize.
              *
              * If you're tempted to add another parameter, see if you can make it a property instead.
              *
              * Shouldn't we just replace all the parameters with one Controller object?
              *
              * @param root
              * @param {*} field
              * @param symms
              * @param {number} scale
              * @param {string} writerVersion
              * @param {java.util.Properties} props
              */
              value: function initialize(field, scale, writerVersion, props) {
                this.properties = props;
                this.writerVersion = writerVersion;
                if (writerVersion == null ||
                /* isEmpty */
                writerVersion.length === 0) this.writerVersion = "before 2.1 Beta 7";
                this.mField = field;
                this.mScale = scale;
                if (scale === 0) this.mMultiplier = null;else this.mMultiplier = field['createPower$int'](scale);
              }
            }, {
              key: "getVersion",
              value: function getVersion() {
                return this.version;
              }
            }, {
              key: "isMigration",
              value: function isMigration() {
                return !this.multipleDesigns();
              }
            }, {
              key: "selectionsNotSaved",
              value: function selectionsNotSaved() {
                return this.mSelectionNotSaved;
              }
            }, {
              key: "rationalVectors",
              value: function rationalVectors() {
                return this.mRationalVectors;
              }
            }, {
              key: "actionHistory",
              value: function actionHistory() {
                return false;
              }
            }, {
              key: "commandEditsCompacted",
              value: function commandEditsCompacted() {
                return this.capabilities.contains(XmlSaveFormat.COMPACTED_COMMAND_EDITS);
              }
            }, {
              key: "multipleDesigns",
              value: function multipleDesigns() {
                return this.capabilities.contains(XmlSaveFormat.MULTIPLE_DESIGNS);
              }
            }, {
              key: "groupingDoneInSelection",
              value: function groupingDoneInSelection() {
                return this.mGroupingInSelection && !function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }("2.1.3", this.writerVersion);
              }
            }, {
              key: "groupingRecursive",
              value: function groupingRecursive() {
                return !this.groupingDoneInSelection() ||
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }("2.1.2", this.writerVersion);
              }
            }, {
              key: "interim210format",
              value: function interim210format() {
                return this.capabilities.contains(XmlSaveFormat.FORMAT_2_1_0);
              }
            }, {
              key: "parseAlgebraicVector",
              value: function parseAlgebraicVector(elem) {
                var val = elem.getAttribute("x");
                var x = val == null ||
                /* isEmpty */
                val.length === 0 ? this.mField.zero() : this.mField.parseLegacyNumber(val);
                val = elem.getAttribute("y");
                var y = val == null ||
                /* isEmpty */
                val.length === 0 ? this.mField.zero() : this.mField.parseLegacyNumber(val);
                val = elem.getAttribute("z");
                var z = val == null ||
                /* isEmpty */
                val.length === 0 ? this.mField.zero() : this.mField.parseLegacyNumber(val);
                val = elem.getAttribute("w");
                var threeD = val == null ||
                /* isEmpty */
                val.length === 0;
                var w = null;
                if (!threeD) w = this.mField.parseLegacyNumber(val);
                var value = threeD ? new com.vzome.core.algebra.AlgebraicVector(x, y, z) : new com.vzome.core.algebra.AlgebraicVector(w, x, y, z);

                if (this.mProject4d && !threeD) {
                  if (!w.isZero() && XmlSaveFormat.logger_$LI$().isLoggable(java.util.logging.Level.WARNING)) XmlSaveFormat.logger_$LI$().warning("stripping non-zero W component from " + value.toString());
                  value = this.mField.projectTo3d(value, true);
                }

                if (this.mMultiplier != null) value = value.scale(this.mMultiplier);
                return value;
              }
            }, {
              key: "parseAlgebraicObject",
              value: function parseAlgebraicObject(valName, val) {
                var value = XmlSaveFormat.NOT_AN_ATTRIBUTE_$LI$();
                if (
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(valName, "Null")) value = null;else if (
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(valName, "RationalVector")) {
                  var nums = val.getAttribute("nums");
                  if (nums == null ||
                  /* isEmpty */
                  nums.length === 0) return this.mField.origin(3);
                  var denoms = val.getAttribute("denoms");
                  var tokens = new java.util.StringTokenizer(nums);
                  var result = [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1];

                  for (var i = 0; i < this.mField.getOrder(); i++) {
                    {
                      var token = tokens.nextToken();
                      if (token == null) throw new java.lang.IllegalStateException("RationalVector nums too short for field " + this.mField.getName());
                      result[i * 2] = javaemul.internal.IntegerHelper.parseInt(token);
                    }
                  }

                  if (denoms != null && !(denoms.length === 0)) {
                    tokens = new java.util.StringTokenizer(denoms);

                    for (var _i22 = 0; _i22 < this.mField.getOrder(); _i22++) {
                      {
                        var _token = tokens.nextToken();

                        if (_token == null) throw new java.lang.IllegalStateException("RationalVector denoms too short for field " + this.mField.getName());
                        result[_i22 * 2 + 1] = javaemul.internal.IntegerHelper.parseInt(_token);
                      }
                    }
                  }

                  var oneThirdLen = result.length / 3 | 0;
                  var twoThirdLen = oneThirdLen * 2;

                  var result3d = function (dims) {
                    var allocate = function allocate(dims) {
                      if (dims.length == 0) {
                        return 0;
                      } else {
                        var array = [];

                        for (var _i23 = 0; _i23 < dims[0]; _i23++) {
                          array.push(allocate(dims.slice(1)));
                        }

                        return array;
                      }
                    };

                    return allocate(dims);
                  }([3, oneThirdLen]);

                  for (var _i24 = 0; _i24 < oneThirdLen; _i24++) {
                    {
                      result3d[0][_i24] = result[_i24];
                      result3d[1][_i24] = result[_i24 + oneThirdLen];
                      result3d[2][_i24] = result[_i24 + twoThirdLen];
                    }
                  }

                  value = this.mField.createVector(result3d);
                } else if (
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(valName, "GoldenVector")) value = this.parseAlgebraicVector(val);else if (
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(valName, "Boolean")) {
                  var gnum = val.getAttribute("value");
                  value = javaemul.internal.BooleanHelper.parseBoolean(gnum);
                } else if (
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(valName, "Integer")) {
                  var _gnum = val.getAttribute("value");

                  value = javaemul.internal.IntegerHelper.parseInt(_gnum);
                } else if (
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(valName, "GoldenNumber") ||
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(valName, "IntegralNumber")) {
                  var _gnum2 = val.getAttribute("value");

                  value = this.mField.parseLegacyNumber(_gnum2);
                  if (this.mMultiplier != null) value = value['times$com_vzome_core_algebra_AlgebraicNumber'](this.mMultiplier);
                } else if (
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(valName, "String")) value = val.getTextContent();
                return value;
              }
            }, {
              key: "parseConstruction$java_lang_String$org_w3c_dom_Element",
              value: function parseConstruction$java_lang_String$org_w3c_dom_Element(apName, attrOrParam) {
                return this.parseConstruction$java_lang_String$org_w3c_dom_Element$boolean(apName, attrOrParam, false);
              }
            }, {
              key: "parseConstruction$java_lang_String$org_w3c_dom_Element$boolean",
              value: function parseConstruction$java_lang_String$org_w3c_dom_Element$boolean(apName, attrOrParam, projectTo3d) {
                var c = null;

                if (
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(apName, "point")) {
                  var loc = this.parseAlgebraicVector(attrOrParam);
                  if (projectTo3d) loc = loc.projectTo3d(true);
                  c = new com.vzome.core.construction.FreePoint(loc);
                } else if (
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(apName, "segment")) {
                  var start = com.vzome.xml.DomUtils.getFirstChildElement$org_w3c_dom_Element$java_lang_String(attrOrParam, "start");
                  var end = com.vzome.xml.DomUtils.getFirstChildElement$org_w3c_dom_Element$java_lang_String(attrOrParam, "end");
                  var sloc = this.parseAlgebraicVector(start);
                  var eloc = this.parseAlgebraicVector(end);

                  if (projectTo3d) {
                    sloc = sloc.projectTo3d(true);
                    eloc = eloc.projectTo3d(true);
                  }

                  c = new com.vzome.core.construction.SegmentJoiningPoints(new com.vzome.core.construction.FreePoint(sloc), new com.vzome.core.construction.FreePoint(eloc));
                } else if (
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(apName, "polygon")) {
                  var kids = attrOrParam.getElementsByTagName("vertex");

                  var pts = function (s) {
                    var a = [];

                    while (s-- > 0) {
                      a.push(null);
                    }

                    return a;
                  }(kids.getLength());

                  for (var k = 0; k < kids.getLength(); k++) {
                    {
                      var _loc = this.parseAlgebraicVector(kids.item(k));

                      if (projectTo3d) _loc = _loc.projectTo3d(true);
                      pts[k] = new com.vzome.core.construction.FreePoint(_loc);
                    }
                  }

                  c = new com.vzome.core.construction.PolygonFromVertices(pts);
                }

                return c;
              }
              /**
              * this is for the old format (before rationalVectors)
              * @param {string} apName
              * @param {*} attrOrParam
              * @param {boolean} projectTo3d
              * @return {com.vzome.core.construction.Construction}
              */

            }, {
              key: "parseConstruction",
              value: function parseConstruction(apName, attrOrParam, projectTo3d) {
                if ((typeof apName === 'string' || apName === null) && (attrOrParam != null && (attrOrParam["__interfaces"] != null && attrOrParam["__interfaces"].indexOf("org.w3c.dom.Element") >= 0 || attrOrParam.constructor != null && attrOrParam.constructor["__interfaces"] != null && attrOrParam.constructor["__interfaces"].indexOf("org.w3c.dom.Element") >= 0) || attrOrParam === null) && (typeof projectTo3d === 'boolean' || projectTo3d === null)) {
                  return this.parseConstruction$java_lang_String$org_w3c_dom_Element$boolean(apName, attrOrParam, projectTo3d);
                } else if ((typeof apName === 'string' || apName === null) && (attrOrParam != null && (attrOrParam["__interfaces"] != null && attrOrParam["__interfaces"].indexOf("org.w3c.dom.Element") >= 0 || attrOrParam.constructor != null && attrOrParam.constructor["__interfaces"] != null && attrOrParam.constructor["__interfaces"].indexOf("org.w3c.dom.Element") >= 0) || attrOrParam === null) && projectTo3d === undefined) {
                  return this.parseConstruction$java_lang_String$org_w3c_dom_Element(apName, attrOrParam);
                } else throw new Error('invalid overload');
              }
            }, {
              key: "loadCommandAttributes$org_w3c_dom_Element",
              value: function loadCommandAttributes$org_w3c_dom_Element(editElem) {
                return this.loadCommandAttributes$org_w3c_dom_Element$boolean(editElem, false);
              }
            }, {
              key: "loadCommandAttributes$org_w3c_dom_Element$boolean",
              value: function loadCommandAttributes$org_w3c_dom_Element$boolean(editElem, projectTo3d) {
                var attrs = new com.vzome.core.commands.AttributeMap();
                var kids = editElem.getChildNodes();

                for (var j = 0; j < kids.getLength(); j++) {
                  {
                    var node = kids.item(j);
                    if (!(node != null && (node["__interfaces"] != null && node["__interfaces"].indexOf("org.w3c.dom.Element") >= 0 || node.constructor != null && node.constructor["__interfaces"] != null && node.constructor["__interfaces"].indexOf("org.w3c.dom.Element") >= 0))) continue;
                    var attrElem = node;
                    var elemName = attrElem.getLocalName();
                    var attrName = attrElem.getAttribute("attrName");

                    if (this.interim210format()) {
                      attrName = attrElem.getAttribute("name");
                      var elemKid = com.vzome.xml.DomUtils.getFirstChildElement$org_w3c_dom_Element(attrElem);

                      if (elemKid != null) {
                        attrElem = elemKid;
                        elemName = attrElem.getLocalName();
                      }
                    }

                    var value = this.parseAlgebraicObject(elemName, attrElem);
                    if (value === XmlSaveFormat.NOT_AN_ATTRIBUTE_$LI$()) if (this.rationalVectors()) {
                      if (
                      /* equals */
                      function (o1, o2) {
                        if (o1 && o1.equals) {
                          return o1.equals(o2);
                        } else {
                          return o1 === o2;
                        }
                      }(elemName, "point")) value = this.parsePoint$org_w3c_dom_Element$java_lang_String$boolean(attrElem, "at", projectTo3d);else if (
                      /* equals */
                      function (o1, o2) {
                        if (o1 && o1.equals) {
                          return o1.equals(o2);
                        } else {
                          return o1 === o2;
                        }
                      }(elemName, "segment")) value = this.parseSegment$org_w3c_dom_Element$java_lang_String$java_lang_String$boolean(attrElem, "start", "end", projectTo3d);else if (
                      /* equals */
                      function (o1, o2) {
                        if (o1 && o1.equals) {
                          return o1.equals(o2);
                        } else {
                          return o1 === o2;
                        }
                      }(elemName, "polygon")) value = this.parsePolygon$org_w3c_dom_Element$java_lang_String$boolean(attrElem, "vertex", projectTo3d);else throw new java.lang.IllegalStateException("unknown parameter construction: " + elemName);
                    } else value = this.parseConstruction$java_lang_String$org_w3c_dom_Element$boolean(elemName, attrElem, projectTo3d);
                    attrs.put(attrName, value);
                  }
                }

                return attrs;
              }
            }, {
              key: "loadCommandAttributes",
              value: function loadCommandAttributes(editElem, projectTo3d) {
                if ((editElem != null && (editElem["__interfaces"] != null && editElem["__interfaces"].indexOf("org.w3c.dom.Element") >= 0 || editElem.constructor != null && editElem.constructor["__interfaces"] != null && editElem.constructor["__interfaces"].indexOf("org.w3c.dom.Element") >= 0) || editElem === null) && (typeof projectTo3d === 'boolean' || projectTo3d === null)) {
                  return this.loadCommandAttributes$org_w3c_dom_Element$boolean(editElem, projectTo3d);
                } else if ((editElem != null && (editElem["__interfaces"] != null && editElem["__interfaces"].indexOf("org.w3c.dom.Element") >= 0 || editElem.constructor != null && editElem.constructor["__interfaces"] != null && editElem.constructor["__interfaces"].indexOf("org.w3c.dom.Element") >= 0) || editElem === null) && projectTo3d === undefined) {
                  return this.loadCommandAttributes$org_w3c_dom_Element(editElem);
                } else throw new Error('invalid overload');
              }
            }, {
              key: "getField",
              value: function getField() {
                return this.mField;
              }
            }, {
              key: "getScale",
              value: function getScale() {
                return this.mScale;
              }
            }, {
              key: "parseRationalVector",
              value: function parseRationalVector(xml, attrName) {
                var nums = xml.getAttribute(attrName);
                if (nums == null ||
                /* isEmpty */
                nums.length === 0) return null;
                var loc = this.mField.parseVector(nums);
                return loc;
              }
            }, {
              key: "parseRationalNumber",
              value: function parseRationalNumber(xml, attrName) {
                var nums = xml.getAttribute(attrName);
                if (nums == null ||
                /* isEmpty */
                nums.length === 0) return null;
                var loc = this.mField.parseNumber(nums);
                return loc;
              }
            }, {
              key: "parsePoint$org_w3c_dom_Element$java_lang_String",
              value: function parsePoint$org_w3c_dom_Element$java_lang_String(xml, attrName) {
                return this.parsePoint$org_w3c_dom_Element$java_lang_String$boolean(xml, attrName, false);
              }
            }, {
              key: "parsePoint$org_w3c_dom_Element$java_lang_String$boolean",
              value: function parsePoint$org_w3c_dom_Element$java_lang_String$boolean(xml, attrName, projectTo3d) {
                var nums = xml.getAttribute(attrName);
                if (nums == null ||
                /* isEmpty */
                nums.length === 0) return null;
                var loc = this.mField.parseVector(nums);
                if (projectTo3d) loc = loc.projectTo3d(true);
                return new com.vzome.core.construction.FreePoint(loc);
              }
            }, {
              key: "parsePoint",
              value: function parsePoint(xml, attrName, projectTo3d) {
                if ((xml != null && (xml["__interfaces"] != null && xml["__interfaces"].indexOf("org.w3c.dom.Element") >= 0 || xml.constructor != null && xml.constructor["__interfaces"] != null && xml.constructor["__interfaces"].indexOf("org.w3c.dom.Element") >= 0) || xml === null) && (typeof attrName === 'string' || attrName === null) && (typeof projectTo3d === 'boolean' || projectTo3d === null)) {
                  return this.parsePoint$org_w3c_dom_Element$java_lang_String$boolean(xml, attrName, projectTo3d);
                } else if ((xml != null && (xml["__interfaces"] != null && xml["__interfaces"].indexOf("org.w3c.dom.Element") >= 0 || xml.constructor != null && xml.constructor["__interfaces"] != null && xml.constructor["__interfaces"].indexOf("org.w3c.dom.Element") >= 0) || xml === null) && (typeof attrName === 'string' || attrName === null) && projectTo3d === undefined) {
                  return this.parsePoint$org_w3c_dom_Element$java_lang_String(xml, attrName);
                } else throw new Error('invalid overload');
              }
            }, {
              key: "parseSegment$org_w3c_dom_Element$java_lang_String$java_lang_String",
              value: function parseSegment$org_w3c_dom_Element$java_lang_String$java_lang_String(xml, startAttrName, endAttrName) {
                return this.parseSegment$org_w3c_dom_Element$java_lang_String$java_lang_String$boolean(xml, startAttrName, endAttrName, false);
              }
            }, {
              key: "parseSegment$org_w3c_dom_Element$java_lang_String$java_lang_String$boolean",
              value: function parseSegment$org_w3c_dom_Element$java_lang_String$java_lang_String$boolean(xml, startAttrName, endAttrName, projectTo3d) {
                var nums = xml.getAttribute(endAttrName);
                if (nums == null ||
                /* isEmpty */
                nums.length === 0) return null;
                var eloc = this.mField.parseVector(nums);
                nums = xml.getAttribute(startAttrName);
                var sloc = nums == null ||
                /* isEmpty */
                nums.length === 0 ? this.mField.origin(eloc.dimension()) : this.mField.parseVector(nums);

                if (projectTo3d) {
                  sloc = sloc.projectTo3d(true);
                  eloc = eloc.projectTo3d(true);
                }

                return new com.vzome.core.construction.SegmentJoiningPoints(new com.vzome.core.construction.FreePoint(sloc), new com.vzome.core.construction.FreePoint(eloc));
              }
            }, {
              key: "parseSegment",
              value: function parseSegment(xml, startAttrName, endAttrName, projectTo3d) {
                if ((xml != null && (xml["__interfaces"] != null && xml["__interfaces"].indexOf("org.w3c.dom.Element") >= 0 || xml.constructor != null && xml.constructor["__interfaces"] != null && xml.constructor["__interfaces"].indexOf("org.w3c.dom.Element") >= 0) || xml === null) && (typeof startAttrName === 'string' || startAttrName === null) && (typeof endAttrName === 'string' || endAttrName === null) && (typeof projectTo3d === 'boolean' || projectTo3d === null)) {
                  return this.parseSegment$org_w3c_dom_Element$java_lang_String$java_lang_String$boolean(xml, startAttrName, endAttrName, projectTo3d);
                } else if ((xml != null && (xml["__interfaces"] != null && xml["__interfaces"].indexOf("org.w3c.dom.Element") >= 0 || xml.constructor != null && xml.constructor["__interfaces"] != null && xml.constructor["__interfaces"].indexOf("org.w3c.dom.Element") >= 0) || xml === null) && (typeof startAttrName === 'string' || startAttrName === null) && (typeof endAttrName === 'string' || endAttrName === null) && projectTo3d === undefined) {
                  return this.parseSegment$org_w3c_dom_Element$java_lang_String$java_lang_String(xml, startAttrName, endAttrName);
                } else throw new Error('invalid overload');
              }
            }, {
              key: "parsePolygon$org_w3c_dom_Element$java_lang_String",
              value: function parsePolygon$org_w3c_dom_Element$java_lang_String(xml, vertexChildName) {
                return this.parsePolygon$org_w3c_dom_Element$java_lang_String$boolean(xml, vertexChildName, false);
              }
            }, {
              key: "parsePolygon$org_w3c_dom_Element$java_lang_String$boolean",
              value: function parsePolygon$org_w3c_dom_Element$java_lang_String$boolean(xml, vertexChildName, projectTo3d) {
                var kids = xml.getElementsByTagName(vertexChildName);

                var pts = function (s) {
                  var a = [];

                  while (s-- > 0) {
                    a.push(null);
                  }

                  return a;
                }(kids.getLength());

                for (var k = 0; k < kids.getLength(); k++) {
                  {
                    var nums = kids.item(k).getAttribute("at");
                    var loc = this.mField.parseVector(nums);
                    if (projectTo3d) loc = loc.projectTo3d(true);
                    pts[k] = new com.vzome.core.construction.FreePoint(loc);
                  }
                }

                return new com.vzome.core.construction.PolygonFromVertices(pts);
              }
            }, {
              key: "parsePolygon",
              value: function parsePolygon(xml, vertexChildName, projectTo3d) {
                if ((xml != null && (xml["__interfaces"] != null && xml["__interfaces"].indexOf("org.w3c.dom.Element") >= 0 || xml.constructor != null && xml.constructor["__interfaces"] != null && xml.constructor["__interfaces"].indexOf("org.w3c.dom.Element") >= 0) || xml === null) && (typeof vertexChildName === 'string' || vertexChildName === null) && (typeof projectTo3d === 'boolean' || projectTo3d === null)) {
                  return this.parsePolygon$org_w3c_dom_Element$java_lang_String$boolean(xml, vertexChildName, projectTo3d);
                } else if ((xml != null && (xml["__interfaces"] != null && xml["__interfaces"].indexOf("org.w3c.dom.Element") >= 0 || xml.constructor != null && xml.constructor["__interfaces"] != null && xml.constructor["__interfaces"].indexOf("org.w3c.dom.Element") >= 0) || xml === null) && (typeof vertexChildName === 'string' || vertexChildName === null) && projectTo3d === undefined) {
                  return this.parsePolygon$org_w3c_dom_Element$java_lang_String(xml, vertexChildName);
                } else throw new Error('invalid overload');
              }
            }, {
              key: "parsePolygonReversed",
              value: function parsePolygonReversed(xml, vertexChildName) {
                var kids = xml.getElementsByTagName(vertexChildName);

                var pts = function (s) {
                  var a = [];

                  while (s-- > 0) {
                    a.push(null);
                  }

                  return a;
                }(kids.getLength());

                var kmax = kids.getLength() - 1;

                for (var k = 0; k < kids.getLength(); k++) {
                  {
                    var nums = kids.item(k).getAttribute("at");
                    var loc = this.mField.parseVector(nums);
                    pts[kmax - k] = new com.vzome.core.construction.FreePoint(loc);
                  }
                }

                return new com.vzome.core.construction.PolygonFromVertices(pts);
              }
            }, {
              key: "parseNumber",
              value: function parseNumber(xml, attrName) {
                var nums = xml.getAttribute(attrName);
                if (nums == null ||
                /* isEmpty */
                nums.length === 0) return null;
                return this.mField.parseNumber(nums);
              }
            }, {
              key: "loadToRender",
              value: function loadToRender() {
                return !function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }("true", this.properties.getProperty("no.rendering"));
              }
            }, {
              key: "getToolVersion",
              value: function getToolVersion(element) {
                var fileEdition = element.getAttribute("edition");
                if (fileEdition == null ||
                /* isEmpty */
                fileEdition.length === 0) fileEdition = "vZome";
                return fileEdition + " " + this.writerVersion;
              }
            }], [{
              key: "FORMATS_$LI$",
              value: function FORMATS_$LI$() {
                if (XmlSaveFormat.FORMATS == null) XmlSaveFormat.FORMATS = new java.util.HashMap();
                return XmlSaveFormat.FORMATS;
              }
            }, {
              key: "logger_$LI$",
              value: function logger_$LI$() {
                if (XmlSaveFormat.logger == null) XmlSaveFormat.logger = java.util.logging.Logger.getLogger("com.vzome.core.commands.XmlSaveFormat");
                return XmlSaveFormat.logger;
              }
            }, {
              key: "NOT_AN_ATTRIBUTE_$LI$",
              value: function NOT_AN_ATTRIBUTE_$LI$() {
                if (XmlSaveFormat.NOT_AN_ATTRIBUTE == null) XmlSaveFormat.NOT_AN_ATTRIBUTE = new Object();
                return XmlSaveFormat.NOT_AN_ATTRIBUTE;
              }
            }, {
              key: "serializeNumber",
              value: function serializeNumber(xml, attrName, number) {
                com.vzome.xml.DomUtils.addAttribute(xml, attrName, number.toString(com.vzome.core.algebra.AlgebraicField.ZOMIC_FORMAT));
              }
            }, {
              key: "serializePoint",
              value: function serializePoint(xml, attrName, point) {
                com.vzome.xml.DomUtils.addAttribute(xml, attrName, point.getLocation().getVectorExpression$int(com.vzome.core.algebra.AlgebraicField.ZOMIC_FORMAT));
              }
            }, {
              key: "serializeSegment",
              value: function serializeSegment(xml, startAttrName, endAttrName, segment) {
                com.vzome.xml.DomUtils.addAttribute(xml, startAttrName, segment.getStart().getVectorExpression$int(com.vzome.core.algebra.AlgebraicField.ZOMIC_FORMAT));
                com.vzome.xml.DomUtils.addAttribute(xml, endAttrName, segment.getEnd().getVectorExpression$int(com.vzome.core.algebra.AlgebraicField.ZOMIC_FORMAT));
              }
            }, {
              key: "serializePolygon",
              value: function serializePolygon(xml, vertexChildName, polygon) {
                polygon.getXml$org_w3c_dom_Element$java_lang_String(xml, vertexChildName);
              }
            }, {
              key: "escapeNewlines",
              value: function escapeNewlines(input) {
                var buf = new java.lang.StringBuffer();
                var br = new java.io.BufferedReader(new java.io.StringReader(input));
                var line = null;

                try {
                  while ((line = br.readLine()) != null) {
                    {
                      var comment = line.indexOf("//");

                      if (comment >= 0) {
                        line = line.substring(0, comment);
                      }

                      buf.append(line + "\n");
                    }
                  }

                  ;
                } catch (e) {}

                return buf.toString();
              }
            }]);

            return XmlSaveFormat;
          }();

          XmlSaveFormat.CURRENT_FORMAT = "http://xml.vzome.com/vZome/4.0.0/";
          XmlSaveFormat.PROJECT_4D = "project-4D-to-3D";
          XmlSaveFormat.SELECTION_NOT_SAVED = "selection-not-saved";
          XmlSaveFormat.FORMAT_2_1_0 = "interim-210-format";
          XmlSaveFormat.GROUPING_IN_SELECTION = "grouping-in-selection";
          XmlSaveFormat.RATIONAL_VECTORS = "rational-vectors";
          XmlSaveFormat.COMPACTED_COMMAND_EDITS = "compacted-command-edits";
          XmlSaveFormat.MULTIPLE_DESIGNS = "multiple-designs";
          XmlSaveFormat.UNKNOWN_COMMAND = "unknown.command";
          commands.XmlSaveFormat = XmlSaveFormat;
          XmlSaveFormat["__class"] = "com.vzome.core.commands.XmlSaveFormat";
        })(core.commands || (core.commands = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (commands) {
          /**
          * @author David Hall
          * This class doesn't add anything to the TreeMap,
          * but there were so many places that were using Map<String, Object>,
          * that I decided to use this class to clarify which ones were using it
          * for managing attributes. It also avoids cluttering the code
          * with Map<String, Object> which is just needed for type safety,
          * but which does nothing for describing the intended use of the variables.
          *
          * Note that in XmlSaveFormat, AttributeMap replaces TreeMap<>,
          * but in other places (such as CommandEdit), it replaces HashMap<>.
          * XmlSaveFormat requires the Map<> to be ordered, but I assume
          * that other places can safely use any implementation of Map<>.
          * Therefore, I have used TreeMap<> rather than HashMap<> as the basis
          * for AttributeMap across the board.
          * @class
          * @extends java.util.TreeMap
          */
          var AttributeMap =
          /*#__PURE__*/
          function (_java$util$TreeMap) {
            _inherits(AttributeMap, _java$util$TreeMap);

            var _super6 = _createSuper(AttributeMap);

            function AttributeMap() {
              _classCallCheck(this, AttributeMap);

              return _super6.call(this);
            }

            return AttributeMap;
          }(java.util.TreeMap);

          AttributeMap.__com_vzome_core_commands_AttributeMap_serialVersionUID = 1;
          commands.AttributeMap = AttributeMap;
          AttributeMap["__class"] = "com.vzome.core.commands.AttributeMap";
          AttributeMap["__interfaces"] = ["java.lang.Cloneable", "java.util.Map", "java.util.NavigableMap", "java.util.SortedMap", "java.io.Serializable"];
        })(core.commands || (core.commands = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (commands) {
          var AbstractCommand =
          /*#__PURE__*/
          function () {
            _createClass(AbstractCommand, [{
              key: "setXml",

              /**
              * This default behavior deserializes in the old way, before XmlSaveFormat .COMPACTED_COMMAND_EDITS
              * @param attributes
              * @param {*} xml
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              * @return
              * @return {com.vzome.core.commands.AttributeMap}
              */
              value: function setXml(xml, format) {
                var attrs = format.loadCommandAttributes$org_w3c_dom_Element(xml);
                this.setFixedAttributes(attrs, format);
                return attrs;
              }
            }, {
              key: "setFixedAttributes",
              value: function setFixedAttributes(attributes, format) {
                attributes.put(com.vzome.core.commands.Command.FIELD_ATTR_NAME, format.getField());
              }
              /**
              * This default behavior serializes in the old way, before XmlSaveFormat .COMPACTED_COMMAND_EDITS
              * @param {com.vzome.core.commands.AttributeMap} attributes
              * @return
              * @param {*} result
              */

            }, {
              key: "getXml",
              value: function getXml(result, attributes) {
                if (attributes == null) return;

                for (var index626 = attributes.keySet().iterator(); index626.hasNext();) {
                  var key = index626.next();
                  {
                    if (
                    /* equals */
                    function (o1, o2) {
                      if (o1 && o1.equals) {
                        return o1.equals(o2);
                      } else {
                        return o1 === o2;
                      }
                    }(key, com.vzome.core.commands.Command.FIELD_ATTR_NAME)) continue;
                    if (
                    /* equals */
                    function (o1, o2) {
                      if (o1 && o1.equals) {
                        return o1.equals(o2);
                      } else {
                        return o1 === o2;
                      }
                    }(key, com.vzome.core.commands.CommandTransform.SYMMETRY_CENTER_ATTR_NAME)) continue;
                    if (
                    /* equals */
                    function (o1, o2) {
                      if (o1 && o1.equals) {
                        return o1.equals(o2);
                      } else {
                        return o1 === o2;
                      }
                    }(key, com.vzome.core.commands.CommandTransform.SYMMETRY_AXIS_ATTR_NAME)) continue;
                    if (
                    /* equals */
                    function (o1, o2) {
                      if (o1 && o1.equals) {
                        return o1.equals(o2);
                      } else {
                        return o1 === o2;
                      }
                    }(key, com.vzome.core.commands.CommandImportVEFData.FIELD_ATTR_NAME)) continue;
                    var value = attributes.get(key);
                    if (value != null && value instanceof com.vzome.core.math.symmetry.IcosahedralSymmetry) continue;
                    AbstractCommand.saveCommandAttribute(result, key, value);
                  }
                }
              }
            }, {
              key: "attributeIs3D",
              value: function attributeIs3D(attrName) {
                return true;
              }
            }, {
              key: "setQuaternion",
              value: function setQuaternion(offset) {}
            }, {
              key: "ordersSelection",
              value: function ordersSelection() {
                return false;
              }
            }], [{
              key: "saveCommandAttribute",
              value: function saveCommandAttribute(command, attrName, value) {
                var doc = command.getOwnerDocument();
                var valElem = null;

                if (value != null && value instanceof Array && (value.length == 0 || value[0] == null || typeof value[0] === 'number')) {
                  var v = value;
                  valElem = command.getOwnerDocument().createElement("RationalVector");
                  var allOnes = true;
                  var allZeros = true;

                  for (var i = 0; i < (v.length / 2 | 0); i++) {
                    {
                      allZeros = allZeros && v[2 * i] === 0;
                      allOnes = allOnes && v[2 * i + 1] === 1;
                    }
                  }

                  if (!allZeros) {
                    var numerators = new java.lang.StringBuffer();

                    for (var _i25 = 0; _i25 < (v.length / 2 | 0); _i25++) {
                      {
                        if (_i25 > 0) numerators.append(" ");
                        numerators.append(v[2 * _i25]);
                      }
                    }

                    com.vzome.xml.DomUtils.addAttribute(valElem, "nums", numerators.toString());

                    if (!allOnes) {
                      var denominators = new java.lang.StringBuffer();

                      for (var _i26 = 0; _i26 < (v.length / 2 | 0); _i26++) {
                        {
                          if (_i26 > 0) denominators.append(" ");
                          denominators.append(v[2 * _i26 + 1]);
                        }
                      }

                      com.vzome.xml.DomUtils.addAttribute(valElem, "denoms", denominators.toString());
                    }
                  }
                } else if (value != null && value instanceof com.vzome.core.math.symmetry.Axis) {
                  valElem = doc.createElement("Axis");
                  value.getXML(valElem);
                } else if (typeof value === 'boolean') {
                  valElem = doc.createElement("Boolean");
                  com.vzome.xml.DomUtils.addAttribute(valElem, "value", value.toString());
                } else if (typeof value === 'number') {
                  valElem = doc.createElement("Integer");
                  com.vzome.xml.DomUtils.addAttribute(valElem, "value", value.toString());
                } else if (value != null && value instanceof com.vzome.core.construction.Construction) {
                  valElem = value.getXml(command.getOwnerDocument());
                } else if (typeof value === 'string') {
                  valElem = doc.createElement("String");
                  var str = com.vzome.core.commands.XmlSaveFormat.escapeNewlines(value);
                  valElem.appendChild(doc.createTextNode(str));
                } else if (value != null && value instanceof com.vzome.core.math.symmetry.QuaternionicSymmetry) {
                  valElem = doc.createElement("QuaternionicSymmetry");
                  com.vzome.xml.DomUtils.addAttribute(valElem, "name", value.getName());
                } else if (value != null && (value["__interfaces"] != null && value["__interfaces"].indexOf("com.vzome.core.math.symmetry.Symmetry") >= 0 || value.constructor != null && value.constructor["__interfaces"] != null && value.constructor["__interfaces"].indexOf("com.vzome.core.math.symmetry.Symmetry") >= 0)) {
                  valElem = doc.createElement("Symmetry");
                  com.vzome.xml.DomUtils.addAttribute(valElem, "name", value.getName());
                } else if (value == null) {
                  valElem = doc.createElement("Null");
                } else {
                  throw new java.lang.IllegalStateException("unable to save " +
                  /* getName */
                  function (c) {
                    return c["__class"] ? c["__class"] : c["name"];
                  }(value.constructor));
                }

                com.vzome.xml.DomUtils.addAttribute(valElem, "attrName", attrName);
                command.appendChild(valElem);
              }
            }]);

            function AbstractCommand() {
              _classCallCheck(this, AbstractCommand);
            }

            return AbstractCommand;
          }();

          commands.AbstractCommand = AbstractCommand;
          AbstractCommand["__class"] = "com.vzome.core.commands.AbstractCommand";
          AbstractCommand["__interfaces"] = ["com.vzome.core.commands.Command"];
        })(core.commands || (core.commands = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (commands) {
          (function (Command) {
            Command.LOADING_FROM_FILE = "org.vorthmann.zome.editor.Command.LOADING_FROM_FILE";
            Command.FIELD_ATTR_NAME = "org.vorthmann.zome.commands.Command.ALGEBRAIC_FIELD";
            Command.GENERIC_PARAM_NAME = "org.vorthmann.zome.editor.Command.GENERIC_PARAM";
          })(commands.Command || (commands.Command = {}));

          (function (Command) {
            /**
            * @param {string} message
            * @param {java.lang.Throwable} cause
            * @class
            * @extends java.lang.Exception
            */
            var Failure =
            /*#__PURE__*/
            function (_Error) {
              _inherits(Failure, _Error);

              var _super7 = _createSuper(Failure);

              function Failure(message, cause) {
                var _this11;

                _classCallCheck(this, Failure);

                if ((typeof message === 'string' || message === null) && (cause != null && cause instanceof Error || cause === null)) {
                  _this11 = _super7.call(this, message);
                  _this11.message = message;
                  Object.setPrototypeOf(_assertThisInitialized(_this11), Failure.prototype);

                  (function () {
                    Failure.logger_$LI$().log(java.util.logging.Level.INFO, "command failure: " + message, cause);
                  })();
                } else if ((typeof message === 'string' || message === null) && cause === undefined) {
                  _this11 = _super7.call(this, message);
                  _this11.message = message;
                  Object.setPrototypeOf(_assertThisInitialized(_this11), Failure.prototype);

                  (function () {
                    if (Failure.logger_$LI$().isLoggable(java.util.logging.Level.FINE)) Failure.logger_$LI$().log(java.util.logging.Level.FINE, "command failure: " + message);
                  })();
                } else if ((message != null && message instanceof Error || message === null) && cause === undefined) {
                  var _args15 = arguments;
                  var _cause = _args15[0];
                  _this11 = _super7.call(this, _cause);
                  _this11.message = _cause;
                  Object.setPrototypeOf(_assertThisInitialized(_this11), Failure.prototype);

                  (function () {
                    Failure.logger_$LI$().log(java.util.logging.Level.INFO, "command failure", _cause);
                  })();
                } else if (message === undefined && cause === undefined) {
                  _this11 = _super7.call(this);
                  Object.setPrototypeOf(_assertThisInitialized(_this11), Failure.prototype);
                } else throw new Error('invalid overload');

                return _possibleConstructorReturn(_this11);
              }

              _createClass(Failure, null, [{
                key: "logger_$LI$",
                value: function logger_$LI$() {
                  if (Failure.logger == null) Failure.logger = java.util.logging.Logger.getLogger("org.vorthmann.zome.commands");
                  return Failure.logger;
                }
              }]);

              return Failure;
            }(
            /*#__PURE__*/
            _wrapNativeSuper(Error));

            Command.Failure = Failure;
            Failure["__class"] = "com.vzome.core.commands.Command.Failure";
            Failure["__interfaces"] = ["java.io.Serializable"];
          })(commands.Command || (commands.Command = {}));
        })(core.commands || (core.commands = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          /**
          * @author David Hall
          * @class
          */
          var ManifestationColorMappers =
          /*#__PURE__*/
          function () {
            function ManifestationColorMappers() {
              _classCallCheck(this, ManifestationColorMappers);
            }

            _createClass(ManifestationColorMappers, null, [{
              key: "__static_initialize",
              value: function __static_initialize() {
                if (!ManifestationColorMappers.__static_initialized) {
                  ManifestationColorMappers.__static_initialized = true;

                  ManifestationColorMappers.__static_initializer_0();
                }
              }
            }, {
              key: "colorMappers_$LI$",
              value: function colorMappers_$LI$() {
                ManifestationColorMappers.__static_initialize();

                if (ManifestationColorMappers.colorMappers == null) ManifestationColorMappers.colorMappers = new java.util.HashMap();
                return ManifestationColorMappers.colorMappers;
              }
            }, {
              key: "__static_initializer_0",
              value: function __static_initializer_0() {
                ManifestationColorMappers.RegisterMapper(new ManifestationColorMappers.RadialCentroidColorMap());
                ManifestationColorMappers.RegisterMapper(new ManifestationColorMappers.RadialStandardBasisColorMap());
                ManifestationColorMappers.RegisterMapper(new ManifestationColorMappers.CanonicalOrientationColorMap());
                ManifestationColorMappers.RegisterMapper(new ManifestationColorMappers.NormalPolarityColorMap());
                ManifestationColorMappers.RegisterMapper(new ManifestationColorMappers.CentroidByOctantAndDirectionColorMap());
                ManifestationColorMappers.RegisterMapper(new ManifestationColorMappers.CoordinatePlaneColorMap());
                ManifestationColorMappers.RegisterMapper(new ManifestationColorMappers.Identity());
                ManifestationColorMappers.RegisterMapper(new ManifestationColorMappers.ColorComplementor());
                ManifestationColorMappers.RegisterMapper(new ManifestationColorMappers.ColorInverter());
                ManifestationColorMappers.RegisterMapper(new ManifestationColorMappers.ColorMaximizer());
                ManifestationColorMappers.RegisterMapper(new ManifestationColorMappers.ColorSoftener());
              }
            }, {
              key: "RegisterMapper",
              value: function RegisterMapper(mapper) {
                if (mapper != null) {
                  ManifestationColorMappers.colorMappers_$LI$().put(mapper.getName(), mapper);
                  if (
                  /* equals */
                  function (o1, o2) {
                    if (o1 && o1.equals) {
                      return o1.equals(o2);
                    } else {
                      return o1 === o2;
                    }
                  }(mapper.getName(), "ColorComplementor")) ManifestationColorMappers.colorMappers_$LI$().put("ColorComplimentor", mapper);
                }
              }
            }, {
              key: "getColorMapper$java_lang_String",
              value: function getColorMapper$java_lang_String(mapperName) {
                var strTransparency = "TransparencyMapper@";

                if (
                /* startsWith */
                function (str, searchString) {
                  var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                  return str.substr(position, searchString.length) === searchString;
                }(mapperName, strTransparency)) {
                  var strAlpha = mapperName.substring(strTransparency.length);
                  var alpha = javaemul.internal.IntegerHelper.parseInt(strAlpha);
                  return new ManifestationColorMappers.TransparencyMapper(alpha);
                }

                switch (mapperName) {
                  case "TransparencyMapper":
                    return new ManifestationColorMappers.TransparencyMapper(255);

                  case "DarkenWithDistance":
                    return new ManifestationColorMappers.DarkenWithDistance();

                  case "DarkenNearOrigin":
                    return new ManifestationColorMappers.DarkenNearOrigin();

                  case "CopyLastSelectedColor":
                    return new ManifestationColorMappers.CopyLastSelectedColor();
                }

                return ManifestationColorMappers.colorMappers_$LI$().get(mapperName);
              }
            }, {
              key: "getColorMapper$java_lang_String$com_vzome_core_editor_api_OrbitSource",
              value: function getColorMapper$java_lang_String$com_vzome_core_editor_api_OrbitSource(mapperName, symmetry) {
                var colorMapper = function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(mapperName, "SystemColorMap") ? new ManifestationColorMappers.SystemColorMap(symmetry) :
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(mapperName, "SystemCentroidColorMap") ? new ManifestationColorMappers.SystemCentroidColorMap(symmetry) :
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(mapperName, "NearestSpecialOrbitColorMap") ? new ManifestationColorMappers.NearestSpecialOrbitColorMap(symmetry) :
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(mapperName, "CentroidNearestSpecialOrbitColorMap") ? new ManifestationColorMappers.CentroidNearestSpecialOrbitColorMap(symmetry) :
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(mapperName, "NearestPredefinedOrbitColorMap") ? new ManifestationColorMappers.NearestPredefinedOrbitColorMap(symmetry) :
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(mapperName, "CentroidNearestPredefinedOrbitColorMap") ? new ManifestationColorMappers.CentroidNearestPredefinedOrbitColorMap(symmetry) : ManifestationColorMappers.getColorMapper$java_lang_String(mapperName);

                if (colorMapper == null) {
                  colorMapper = new ManifestationColorMappers.Identity();
                }

                return colorMapper;
              }
            }, {
              key: "getColorMapper",
              value: function getColorMapper(mapperName, symmetry) {
                if ((typeof mapperName === 'string' || mapperName === null) && (symmetry != null && (symmetry["__interfaces"] != null && symmetry["__interfaces"].indexOf("com.vzome.core.editor.api.OrbitSource") >= 0 || symmetry.constructor != null && symmetry.constructor["__interfaces"] != null && symmetry.constructor["__interfaces"].indexOf("com.vzome.core.editor.api.OrbitSource") >= 0) || symmetry === null)) {
                  return com.vzome.core.edits.ManifestationColorMappers.getColorMapper$java_lang_String$com_vzome_core_editor_api_OrbitSource(mapperName, symmetry);
                } else if ((typeof mapperName === 'string' || mapperName === null) && symmetry === undefined) {
                  return com.vzome.core.edits.ManifestationColorMappers.getColorMapper$java_lang_String(mapperName);
                } else throw new Error('invalid overload');
              }
            }, {
              key: "mapPolarity",
              value: function mapPolarity(vector, alpha) {
                var polarity = vector.compareTo(vector.negate());
                var mid = 128;
                var diff = 64;
                var shade = polarity < 0 ? mid - diff : polarity > 0 ? mid + diff : mid;
                return new com.vzome.core.construction.Color(shade, shade, shade, alpha);
              }
              /**
              * @param {com.vzome.core.algebra.AlgebraicVector} vector could be midpoint, start, end, normal, or any basis for mapping to a color
              * @param {number} alpha the transparency component of the resulting color.
              * @return
              * @return {com.vzome.core.construction.Color}
              */

            }, {
              key: "mapRadially",
              value: function mapRadially(vector, alpha) {
                var midPoint = 127;
                var rgb = [midPoint, midPoint, midPoint];

                var parts = function (s) {
                  var a = [];

                  while (s-- > 0) {
                    a.push(0);
                  }

                  return a;
                }(rgb.length);

                var dimensions = Math.min(rgb.length, vector.dimension());
                var whole = 0.0;

                for (var i = 0; i < dimensions; i++) {
                  {
                    var component = vector.getComponent(i);
                    parts[i] = component.evaluate();
                    whole += Math.abs(parts[i]);
                  }
                }

                if (whole !== 0.0) {
                  for (var _i27 = 0; _i27 < parts.length; _i27++) {
                    {
                      var part = parts[_i27] / whole;
                      var contribution = part * midPoint;
                      rgb[_i27] =
                      /* intValue */
                      (contribution | 0) + midPoint;
                      rgb[_i27] = Math.min(255, rgb[_i27]);
                      rgb[_i27] = Math.max(0, rgb[_i27]);
                    }
                  }
                }

                return new com.vzome.core.construction.Color(rgb[0], rgb[1], rgb[2], alpha);
              }
              /**
              * @param {com.vzome.core.algebra.AlgebraicVector} vector could be midpoint, start, end, normal, or any basis for mapping to a color
              * @param {number} alpha the transparency component of the resulting color.
              * @param {number} neg the R, G or B level of vectors with a negative value in the corresponding X, Y, or Z dimension.
              * @param {number} zero the R, G or B level of vectors with a zero value in the corresponding X, Y, or Z dimension.
              * @param {number} pos the R, G or B level of vectors with a positive value in the corresponding X, Y, or Z dimension.
              * @return
              * @return {com.vzome.core.construction.Color}
              */

            }, {
              key: "mapToOctant",
              value: function mapToOctant(vector, alpha, neg, zero, pos) {
                var src = [neg, zero, pos];

                var rgb = function (s) {
                  var a = [];

                  while (s-- > 0) {
                    a.push(0);
                  }

                  return a;
                }(src.length);

                var dimensions = Math.min(rgb.length, vector.dimension());

                for (var i = 0; i < dimensions; i++) {
                  {
                    var component = vector.getComponent(i);

                    var dir = function (f) {
                      if (f > 0) {
                        return 1;
                      } else if (f < 0) {
                        return -1;
                      } else {
                        return 0;
                      }
                    }(component.evaluate());

                    var index = (dir | 0) + 1;
                    rgb[i] = src[index];
                  }
                }

                return new com.vzome.core.construction.Color(rgb[0], rgb[1], rgb[2], alpha);
              }
            }, {
              key: "mapToMagnitude",
              value: function mapToMagnitude(vector, offset, fullScaleSquared, initialColor) {
                if (vector == null || initialColor == null) {
                  return initialColor;
                }

                var magnitudeSquared = com.vzome.core.algebra.AlgebraicVectors.getMagnitudeSquared(vector).evaluate();
                var denominator = fullScaleSquared === 0.0 ? 1.0E-4 : fullScaleSquared;
                var scale = Math.abs(offset - magnitudeSquared) / denominator;
                return com.vzome.core.construction.Color.getScaledTo(initialColor, scale);
              }
            }]);

            return ManifestationColorMappers;
          }();

          ManifestationColorMappers.__static_initialized = false;
          edits.ManifestationColorMappers = ManifestationColorMappers;
          ManifestationColorMappers["__class"] = "com.vzome.core.edits.ManifestationColorMappers";

          (function (ManifestationColorMappers) {
            /**
            * Common abstract base class adds xml persistence
            * and late loading of criteria based on selection and/or model
            * @class
            */
            var ManifestationColorMapper =
            /*#__PURE__*/
            function () {
              _createClass(ManifestationColorMapper, [{
                key: "requiresOrderedSelection",

                /* Default method injected from com.vzome.core.edits.ColorMappers.ColorMapper */
                value: function requiresOrderedSelection() {
                  return false;
                }
              }]);

              function ManifestationColorMapper() {
                _classCallCheck(this, ManifestationColorMapper);
              }
              /**
              * Optional opportunity to initialize parameters that were not available at time of the constructor
              * but are determined based on the selection or model iterator
              * just before apply is called on each individual manifestation.
              * @param selection
              * @param model
              * @param {com.vzome.core.editor.api.Manifestations.ManifestationIterator} manifestations
              */


              _createClass(ManifestationColorMapper, [{
                key: "initialize",
                value: function initialize(manifestations) {}
              }, {
                key: "apply$com_vzome_core_model_Manifestation",
                value: function apply$com_vzome_core_model_Manifestation(man) {
                  return man == null || !man.isRendered() ? null : this.applyTo(man);
                }
                /**
                *
                * @param {*} man
                * @return {com.vzome.core.construction.Color}
                */

              }, {
                key: "apply",
                value: function apply(man) {
                  if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0) || man === null) {
                    return this.apply$com_vzome_core_model_Manifestation(man);
                  } else throw new Error('invalid overload');
                }
              }, {
                key: "applyTo",
                value: function applyTo(manifestation) {
                  var color = manifestation.getColor();

                  if (color == null) {
                    color = com.vzome.core.construction.Color.WHITE_$LI$();
                  }

                  return color;
                }
                /**
                * subclasses should call {@code result.setAttribute()} if they have any parameters to persist
                * @param {*} result
                */

              }, {
                key: "getXmlAttributes",
                value: function getXmlAttributes(result) {}
                /**
                * subclasses should call {@code xml.getAttribute()} to retrieve any persisted parameters
                * @param {*} xml
                */

              }, {
                key: "setXmlAttributes",
                value: function setXmlAttributes(xml) {}
              }]);

              return ManifestationColorMapper;
            }();

            ManifestationColorMappers.ManifestationColorMapper = ManifestationColorMapper;
            ManifestationColorMapper["__class"] = "com.vzome.core.edits.ManifestationColorMappers.ManifestationColorMapper";
            ManifestationColorMapper["__interfaces"] = ["com.vzome.core.edits.ColorMappers.ColorMapper", "java.util.function.Function"];
            /**
            * returns current color
            * @class
            * @extends com.vzome.core.edits.ManifestationColorMappers.ManifestationColorMapper
            */

            var Identity =
            /*#__PURE__*/
            function (_ManifestationColorMa) {
              _inherits(Identity, _ManifestationColorMa);

              var _super8 = _createSuper(Identity);

              _createClass(Identity, [{
                key: "getName",

                /**
                *
                * @return {string}
                */
                value: function getName() {
                  return "Identity";
                }
                /**
                *
                * @param {*} rendered
                * @return {com.vzome.core.construction.Color}
                */

              }, {
                key: "applyTo",
                value: function applyTo(rendered) {
                  return rendered.getColor();
                }
              }]);

              function Identity() {
                _classCallCheck(this, Identity);

                return _super8.call(this);
              }

              return Identity;
            }(ManifestationColorMappers.ManifestationColorMapper);

            ManifestationColorMappers.Identity = Identity;
            Identity["__class"] = "com.vzome.core.edits.ManifestationColorMappers.Identity";
            Identity["__interfaces"] = ["com.vzome.core.edits.ColorMappers.ColorMapper", "java.util.function.Function"];
            /**
            * returns complementary color
            * @class
            * @extends com.vzome.core.edits.ManifestationColorMappers.ManifestationColorMapper
            */

            var ColorComplementor =
            /*#__PURE__*/
            function (_ManifestationColorMa2) {
              _inherits(ColorComplementor, _ManifestationColorMa2);

              var _super9 = _createSuper(ColorComplementor);

              _createClass(ColorComplementor, [{
                key: "getName",

                /**
                *
                * @return {string}
                */
                value: function getName() {
                  return "ColorComplementor";
                }
                /**
                *
                * @param {*} rendered
                * @return {com.vzome.core.construction.Color}
                */

              }, {
                key: "applyTo",
                value: function applyTo(rendered) {
                  return com.vzome.core.construction.Color.getComplement(_get(_getPrototypeOf(ColorComplementor.prototype), "applyTo", this).call(this, rendered));
                }
              }]);

              function ColorComplementor() {
                _classCallCheck(this, ColorComplementor);

                return _super9.call(this);
              }

              return ColorComplementor;
            }(ManifestationColorMappers.ManifestationColorMapper);

            ManifestationColorMappers.ColorComplementor = ColorComplementor;
            ColorComplementor["__class"] = "com.vzome.core.edits.ManifestationColorMappers.ColorComplementor";
            ColorComplementor["__interfaces"] = ["com.vzome.core.edits.ColorMappers.ColorMapper", "java.util.function.Function"];
            /**
            * returns inverted color
            * @class
            * @extends com.vzome.core.edits.ManifestationColorMappers.ManifestationColorMapper
            */

            var ColorInverter =
            /*#__PURE__*/
            function (_ManifestationColorMa3) {
              _inherits(ColorInverter, _ManifestationColorMa3);

              var _super10 = _createSuper(ColorInverter);

              _createClass(ColorInverter, [{
                key: "getName",

                /**
                *
                * @return {string}
                */
                value: function getName() {
                  return "ColorInverter";
                }
                /**
                *
                * @param {*} rendered
                * @return {com.vzome.core.construction.Color}
                */

              }, {
                key: "applyTo",
                value: function applyTo(rendered) {
                  return com.vzome.core.construction.Color.getInverted(_get(_getPrototypeOf(ColorInverter.prototype), "applyTo", this).call(this, rendered));
                }
              }]);

              function ColorInverter() {
                _classCallCheck(this, ColorInverter);

                return _super10.call(this);
              }

              return ColorInverter;
            }(ManifestationColorMappers.ManifestationColorMapper);

            ManifestationColorMappers.ColorInverter = ColorInverter;
            ColorInverter["__class"] = "com.vzome.core.edits.ManifestationColorMappers.ColorInverter";
            ColorInverter["__interfaces"] = ["com.vzome.core.edits.ColorMappers.ColorMapper", "java.util.function.Function"];
            /**
            * returns maximized color
            * @class
            * @extends com.vzome.core.edits.ManifestationColorMappers.ManifestationColorMapper
            */

            var ColorMaximizer =
            /*#__PURE__*/
            function (_ManifestationColorMa4) {
              _inherits(ColorMaximizer, _ManifestationColorMa4);

              var _super11 = _createSuper(ColorMaximizer);

              _createClass(ColorMaximizer, [{
                key: "getName",

                /**
                *
                * @return {string}
                */
                value: function getName() {
                  return "ColorMaximizer";
                }
                /**
                *
                * @param {*} rendered
                * @return {com.vzome.core.construction.Color}
                */

              }, {
                key: "applyTo",
                value: function applyTo(rendered) {
                  return com.vzome.core.construction.Color.getMaximum(_get(_getPrototypeOf(ColorMaximizer.prototype), "applyTo", this).call(this, rendered));
                }
              }]);

              function ColorMaximizer() {
                _classCallCheck(this, ColorMaximizer);

                return _super11.call(this);
              }

              return ColorMaximizer;
            }(ManifestationColorMappers.ManifestationColorMapper);

            ManifestationColorMappers.ColorMaximizer = ColorMaximizer;
            ColorMaximizer["__class"] = "com.vzome.core.edits.ManifestationColorMappers.ColorMaximizer";
            ColorMaximizer["__interfaces"] = ["com.vzome.core.edits.ColorMappers.ColorMapper", "java.util.function.Function"];
            /**
            * returns pastel of current color
            * @class
            * @extends com.vzome.core.edits.ManifestationColorMappers.ManifestationColorMapper
            */

            var ColorSoftener =
            /*#__PURE__*/
            function (_ManifestationColorMa5) {
              _inherits(ColorSoftener, _ManifestationColorMa5);

              var _super12 = _createSuper(ColorSoftener);

              _createClass(ColorSoftener, [{
                key: "getName",

                /**
                *
                * @return {string}
                */
                value: function getName() {
                  return "ColorSoftener";
                }
                /**
                *
                * @param {*} rendered
                * @return {com.vzome.core.construction.Color}
                */

              }, {
                key: "applyTo",
                value: function applyTo(rendered) {
                  return com.vzome.core.construction.Color.getPastel(_get(_getPrototypeOf(ColorSoftener.prototype), "applyTo", this).call(this, rendered));
                }
              }]);

              function ColorSoftener() {
                _classCallCheck(this, ColorSoftener);

                return _super12.call(this);
              }

              return ColorSoftener;
            }(ManifestationColorMappers.ManifestationColorMapper);

            ManifestationColorMappers.ColorSoftener = ColorSoftener;
            ColorSoftener["__class"] = "com.vzome.core.edits.ManifestationColorMappers.ColorSoftener";
            ColorSoftener["__interfaces"] = ["com.vzome.core.edits.ColorMappers.ColorMapper", "java.util.function.Function"];

            var TransparencyMapper =
            /*#__PURE__*/
            function (_ManifestationColorMa6) {
              _inherits(TransparencyMapper, _ManifestationColorMa6);

              var _super13 = _createSuper(TransparencyMapper);

              function TransparencyMapper(alpha) {
                var _this12;

                _classCallCheck(this, TransparencyMapper);

                _this12 = _super13.call(this);
                if (_this12.alpha === undefined) _this12.alpha = 0;

                _this12.setAlpha(alpha);

                return _this12;
              }
              /**
              *
              * @return {string}
              */


              _createClass(TransparencyMapper, [{
                key: "getName",
                value: function getName() {
                  return "TransparencyMapper";
                }
              }, {
                key: "setAlpha",
                value: function setAlpha(value) {
                  this.alpha = Math.min(255, Math.max(1, value));
                }
                /**
                *
                * @param {*} xml
                */

              }, {
                key: "setXmlAttributes",
                value: function setXmlAttributes(xml) {
                  this.alpha = javaemul.internal.IntegerHelper.parseInt(xml.getAttribute(TransparencyMapper.ALPHA_ATTR_NAME));
                }
                /**
                *
                * @param {*} result
                */

              }, {
                key: "getXmlAttributes",
                value: function getXmlAttributes(result) {
                  result.setAttribute(TransparencyMapper.ALPHA_ATTR_NAME,
                  /* toString */
                  '' + this.alpha);
                }
                /**
                *
                * @param {*} rendered
                * @return {com.vzome.core.construction.Color}
                */

              }, {
                key: "applyTo",
                value: function applyTo(rendered) {
                  var color = _get(_getPrototypeOf(TransparencyMapper.prototype), "applyTo", this).call(this, rendered);

                  return new com.vzome.core.construction.Color(color.getRed(), color.getGreen(), color.getBlue(), this.alpha);
                }
              }]);

              return TransparencyMapper;
            }(ManifestationColorMappers.ManifestationColorMapper);

            TransparencyMapper.ALPHA_ATTR_NAME = "alpha";
            ManifestationColorMappers.TransparencyMapper = TransparencyMapper;
            TransparencyMapper["__class"] = "com.vzome.core.edits.ManifestationColorMappers.TransparencyMapper";
            TransparencyMapper["__interfaces"] = ["com.vzome.core.edits.ColorMappers.ColorMapper", "java.util.function.Function"];

            var CopyLastSelectedColor =
            /*#__PURE__*/
            function (_ManifestationColorMa7) {
              _inherits(CopyLastSelectedColor, _ManifestationColorMa7);

              var _super14 = _createSuper(CopyLastSelectedColor);

              function CopyLastSelectedColor() {
                var _this13;

                _classCallCheck(this, CopyLastSelectedColor);

                _this13 = _super14.call(this);
                if (_this13.color === undefined) _this13.color = null;
                return _this13;
              }
              /**
              *
              * @return {string}
              */


              _createClass(CopyLastSelectedColor, [{
                key: "getName",
                value: function getName() {
                  return "CopyLastSelectedColor";
                }
                /**
                *
                * @return {boolean}
                */

              }, {
                key: "requiresOrderedSelection",
                value: function requiresOrderedSelection() {
                  return true;
                }
                /**
                *
                * @param {com.vzome.core.editor.api.Manifestations.ManifestationIterator} selection
                */

              }, {
                key: "initialize",
                value: function initialize(selection) {
                  if (this.color == null) {
                    var last = null;

                    for (var index627 = selection.iterator(); index627.hasNext();) {
                      var man = index627.next();
                      {
                        if (man != null && man.isRendered()) {
                          last = man;
                        }
                      }
                    }

                    if (last != null) {
                      this.color = last.getColor();
                    }
                  }

                  if (this.color == null) {
                    throw new com.vzome.core.commands.Command.Failure("select a ball, strut or panel as the color to be copied.");
                  }
                }
                /**
                *
                * @param {*} xml
                */

              }, {
                key: "setXmlAttributes",
                value: function setXmlAttributes(xml) {
                  var red = xml.getAttribute("red");
                  var green = xml.getAttribute("green");
                  var blue = xml.getAttribute("blue");
                  var alphaStr = xml.getAttribute("alpha");
                  var alpha = alphaStr == null ||
                  /* isEmpty */
                  alphaStr.length === 0 ? 255 : javaemul.internal.IntegerHelper.parseInt(alphaStr);
                  this.color = new com.vzome.core.construction.Color(javaemul.internal.IntegerHelper.parseInt(red), javaemul.internal.IntegerHelper.parseInt(green), javaemul.internal.IntegerHelper.parseInt(blue), alpha);
                }
                /**
                *
                * @param {*} result
                */

              }, {
                key: "getXmlAttributes",
                value: function getXmlAttributes(result) {
                  result.setAttribute("red", "" + this.color.getRed());
                  result.setAttribute("green", "" + this.color.getGreen());
                  result.setAttribute("blue", "" + this.color.getBlue());
                  var alpha = this.color.getAlpha();
                  if (alpha < 255) result.setAttribute("alpha", "" + alpha);
                }
                /**
                *
                * @param {*} rendered
                * @return {com.vzome.core.construction.Color}
                */

              }, {
                key: "applyTo",
                value: function applyTo(rendered) {
                  return this.color;
                }
              }]);

              return CopyLastSelectedColor;
            }(ManifestationColorMappers.ManifestationColorMapper);

            ManifestationColorMappers.CopyLastSelectedColor = CopyLastSelectedColor;
            CopyLastSelectedColor["__class"] = "com.vzome.core.edits.ManifestationColorMappers.CopyLastSelectedColor";
            CopyLastSelectedColor["__interfaces"] = ["com.vzome.core.edits.ColorMappers.ColorMapper", "java.util.function.Function"];
            /**
            * Handles getting the centroid and calling overloaded methods to map the subClass specific AlgebraicVector
            * @extends com.vzome.core.edits.ManifestationColorMappers.ManifestationColorMapper
            * @class
            */

            var CentroidColorMapper =
            /*#__PURE__*/
            function (_ManifestationColorMa8) {
              _inherits(CentroidColorMapper, _ManifestationColorMa8);

              var _super15 = _createSuper(CentroidColorMapper);

              function CentroidColorMapper() {
                _classCallCheck(this, CentroidColorMapper);

                return _super15.call(this);
              }

              _createClass(CentroidColorMapper, [{
                key: "applyTo$com_vzome_core_model_Manifestation",
                value: function applyTo$com_vzome_core_model_Manifestation(rendered) {
                  var color = rendered.getColor();
                  var alpha = color == null ? 255 : color.getAlpha();
                  return this.applyTo$com_vzome_core_algebra_AlgebraicVector$int(rendered.getCentroid(), alpha);
                }
              }, {
                key: "applyTo$com_vzome_core_algebra_AlgebraicVector$int",
                value: function applyTo$com_vzome_core_algebra_AlgebraicVector$int(centroid, alpha) {
                  throw new Error('cannot invoke abstract overloaded method... check your argument(s) type(s)');
                }
              }, {
                key: "applyTo",
                value: function applyTo(centroid, alpha) {
                  if ((centroid != null && centroid instanceof com.vzome.core.algebra.AlgebraicVector || centroid === null) && (typeof alpha === 'number' || alpha === null)) {
                    return this.applyTo$com_vzome_core_algebra_AlgebraicVector$int(centroid, alpha);
                  } else if ((centroid != null && (centroid["__interfaces"] != null && centroid["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0 || centroid.constructor != null && centroid.constructor["__interfaces"] != null && centroid.constructor["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0) || centroid === null) && alpha === undefined) {
                    return this.applyTo$com_vzome_core_model_Manifestation(centroid);
                  } else throw new Error('invalid overload');
                }
              }]);

              return CentroidColorMapper;
            }(ManifestationColorMappers.ManifestationColorMapper);

            ManifestationColorMappers.CentroidColorMapper = CentroidColorMapper;
            CentroidColorMapper["__class"] = "com.vzome.core.edits.ManifestationColorMappers.CentroidColorMapper";
            CentroidColorMapper["__interfaces"] = ["com.vzome.core.edits.ColorMappers.ColorMapper", "java.util.function.Function"];
            /**
            * Scales the intensity of the current color of each Manifestation
            * based on the distance of its centroid from the origin.
            * A position ranging from the origin to the fullScale vector position
            * adjusts the intensity of the current color from darkest to lightest.
            * @class
            * @extends com.vzome.core.edits.ManifestationColorMappers.ManifestationColorMapper
            */

            var DarkenNearOrigin =
            /*#__PURE__*/
            function (_ManifestationColorMa9) {
              _inherits(DarkenNearOrigin, _ManifestationColorMa9);

              var _super16 = _createSuper(DarkenNearOrigin);

              function DarkenNearOrigin() {
                var _this14;

                _classCallCheck(this, DarkenNearOrigin);

                _this14 = _super16.call(this);
                _this14.offset = 0;
                _this14.fullScaleSquared = 0;
                _this14.FULLSCALESQUARED_ATTR_NAME = "fullScaleSquared";
                return _this14;
              }
              /**
              *
              * @return {string}
              */


              _createClass(DarkenNearOrigin, [{
                key: "getName",
                value: function getName() {
                  return "DarkenNearOrigin";
                }
                /**
                *
                * @param {com.vzome.core.editor.api.Manifestations.ManifestationIterator} manifestations
                */

              }, {
                key: "initialize",
                value: function initialize(manifestations) {
                  if (this.fullScaleSquared === 0) {
                    var fullScale = DarkenNearOrigin.getMostDistantPoint(manifestations);

                    if (fullScale == null) {
                      throw new com.vzome.core.commands.Command.Failure("unable to determine most distant point");
                    }

                    if (fullScale.isOrigin()) {
                      throw new com.vzome.core.commands.Command.Failure("select at least one point other than the origin");
                    }

                    this.fullScaleSquared = com.vzome.core.algebra.AlgebraicVectors.getMagnitudeSquared(fullScale).evaluate();
                  }
                }
              }, {
                key: "applyTo",

                /**
                *
                * @param {*} rendered
                * @return {com.vzome.core.construction.Color}
                */
                value: function applyTo(rendered) {
                  var centroid = rendered.getCentroid();

                  var initialColor = _get(_getPrototypeOf(DarkenNearOrigin.prototype), "applyTo", this).call(this, rendered);

                  return ManifestationColorMappers.mapToMagnitude(centroid, this.offset, this.fullScaleSquared, initialColor);
                }
                /**
                *
                * @param {*} result
                */

              }, {
                key: "getXmlAttributes",
                value: function getXmlAttributes(result) {
                  result.setAttribute(this.FULLSCALESQUARED_ATTR_NAME,
                  /* toString */
                  '' + this.fullScaleSquared);
                }
                /**
                *
                * @param {*} xml
                */

              }, {
                key: "setXmlAttributes",
                value: function setXmlAttributes(xml) {
                  var attr = xml.getAttribute(this.FULLSCALESQUARED_ATTR_NAME);
                  this.fullScaleSquared = javaemul.internal.DoubleHelper.parseDouble(attr);
                }
              }], [{
                key: "getMostDistantPoint",
                value: function getMostDistantPoint(manifestations) {
                  var centroids = new java.util.ArrayList();

                  for (var index628 = manifestations.iterator(); index628.hasNext();) {
                    var man = index628.next();
                    {
                      centroids.add(man.getCentroid());
                    }
                  }

                  if (centroids.isEmpty()) {
                    return null;
                  }

                  var mostDistant = com.vzome.core.algebra.AlgebraicVectors.getMostDistantFromOrigin(centroids);
                  return mostDistant.isEmpty() ? null : mostDistant.first();
                }
              }]);

              return DarkenNearOrigin;
            }(ManifestationColorMappers.ManifestationColorMapper);

            ManifestationColorMappers.DarkenNearOrigin = DarkenNearOrigin;
            DarkenNearOrigin["__class"] = "com.vzome.core.edits.ManifestationColorMappers.DarkenNearOrigin";
            DarkenNearOrigin["__interfaces"] = ["com.vzome.core.edits.ColorMappers.ColorMapper", "java.util.function.Function"];
            /**
            * Abstract base class which calls subclass specific abstract overloads for all known subtypes.
            * @class
            * @extends com.vzome.core.edits.ManifestationColorMappers.ManifestationColorMapper
            */

            var ManifestationSubclassColorMapper =
            /*#__PURE__*/
            function (_ManifestationColorMa10) {
              _inherits(ManifestationSubclassColorMapper, _ManifestationColorMa10);

              var _super17 = _createSuper(ManifestationSubclassColorMapper);

              _createClass(ManifestationSubclassColorMapper, [{
                key: "applyTo",

                /**
                *
                * @param {*} man
                * @return {com.vzome.core.construction.Color}
                */
                value: function applyTo(man) {
                  var color = man.getColor();
                  var alpha = color == null ? 255 : color.getAlpha();

                  if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0)) {
                    return this.applyToBall(man, alpha);
                  } else if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0)) {
                    return this.applyToStrut(man, alpha);
                  } else if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0)) {
                    return this.applyToPanel(man, alpha);
                  }

                  return null;
                }
              }]);

              function ManifestationSubclassColorMapper() {
                _classCallCheck(this, ManifestationSubclassColorMapper);

                return _super17.call(this);
              }

              return ManifestationSubclassColorMapper;
            }(ManifestationColorMappers.ManifestationColorMapper);

            ManifestationColorMappers.ManifestationSubclassColorMapper = ManifestationSubclassColorMapper;
            ManifestationSubclassColorMapper["__class"] = "com.vzome.core.edits.ManifestationColorMappers.ManifestationSubclassColorMapper";
            ManifestationSubclassColorMapper["__interfaces"] = ["com.vzome.core.edits.ColorMappers.ColorMapper", "java.util.function.Function"];
            /**
            * Maps vector XYZ components to RGB
            * such that each RGB component is weighted by the contribution
            * of the corresponding XYZ component
            * and offset by half of the color range so that a
            * + directions map between 0x7F and 0xFF color element
            * 0 direction maps to a midrange    0x7F color element
            * - directions map between 0x00 and 0x7F color element
            *
            * Polarity info IS retained by this mapping.
            * @class
            * @extends com.vzome.core.edits.ManifestationColorMappers.CentroidColorMapper
            */

            var RadialCentroidColorMap =
            /*#__PURE__*/
            function (_ManifestationColorMa11) {
              _inherits(RadialCentroidColorMap, _ManifestationColorMa11);

              var _super18 = _createSuper(RadialCentroidColorMap);

              _createClass(RadialCentroidColorMap, [{
                key: "getName",

                /**
                *
                * @return {string}
                */
                value: function getName() {
                  return "RadialCentroidColorMap";
                }
              }, {
                key: "applyTo$com_vzome_core_algebra_AlgebraicVector$int",
                value: function applyTo$com_vzome_core_algebra_AlgebraicVector$int(centroid, alpha) {
                  return ManifestationColorMappers.mapRadially(centroid, alpha);
                }
                /**
                *
                * @param {com.vzome.core.algebra.AlgebraicVector} centroid
                * @param {number} alpha
                * @return {com.vzome.core.construction.Color}
                */

              }, {
                key: "applyTo",
                value: function applyTo(centroid, alpha) {
                  if ((centroid != null && centroid instanceof com.vzome.core.algebra.AlgebraicVector || centroid === null) && (typeof alpha === 'number' || alpha === null)) {
                    return this.applyTo$com_vzome_core_algebra_AlgebraicVector$int(centroid, alpha);
                  } else if ((centroid != null && (centroid["__interfaces"] != null && centroid["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0 || centroid.constructor != null && centroid.constructor["__interfaces"] != null && centroid.constructor["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0) || centroid === null) && alpha === undefined) {
                    return this.applyTo$com_vzome_core_model_Manifestation(centroid);
                  } else throw new Error('invalid overload');
                }
              }]);

              function RadialCentroidColorMap() {
                _classCallCheck(this, RadialCentroidColorMap);

                return _super18.call(this);
              }

              return RadialCentroidColorMap;
            }(ManifestationColorMappers.CentroidColorMapper);

            ManifestationColorMappers.RadialCentroidColorMap = RadialCentroidColorMap;
            RadialCentroidColorMap["__class"] = "com.vzome.core.edits.ManifestationColorMappers.RadialCentroidColorMap";
            RadialCentroidColorMap["__interfaces"] = ["com.vzome.core.edits.ColorMappers.ColorMapper", "java.util.function.Function"];
            /**
            * Maps vector XYZ components to RGB by Octant
            *
            * Polarity info IS retained by this mapping.
            * @class
            * @extends com.vzome.core.edits.ManifestationColorMappers.CentroidColorMapper
            */

            var CentroidByOctantAndDirectionColorMap =
            /*#__PURE__*/
            function (_ManifestationColorMa12) {
              _inherits(CentroidByOctantAndDirectionColorMap, _ManifestationColorMa12);

              var _super19 = _createSuper(CentroidByOctantAndDirectionColorMap);

              _createClass(CentroidByOctantAndDirectionColorMap, [{
                key: "getName",

                /**
                *
                * @return {string}
                */
                value: function getName() {
                  return "CentroidByOctantAndDirectionColorMap";
                }
              }, {
                key: "applyTo$com_vzome_core_algebra_AlgebraicVector$int",
                value: function applyTo$com_vzome_core_algebra_AlgebraicVector$int(vector, alpha) {
                  return com.vzome.core.construction.Color.getMaximum(ManifestationColorMappers.mapToOctant(vector, alpha, 0, 127, 255));
                }
                /**
                *
                * @param {com.vzome.core.algebra.AlgebraicVector} vector
                * @param {number} alpha
                * @return {com.vzome.core.construction.Color}
                */

              }, {
                key: "applyTo",
                value: function applyTo(vector, alpha) {
                  if ((vector != null && vector instanceof com.vzome.core.algebra.AlgebraicVector || vector === null) && (typeof alpha === 'number' || alpha === null)) {
                    return this.applyTo$com_vzome_core_algebra_AlgebraicVector$int(vector, alpha);
                  } else if ((vector != null && (vector["__interfaces"] != null && vector["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0 || vector.constructor != null && vector.constructor["__interfaces"] != null && vector.constructor["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0) || vector === null) && alpha === undefined) {
                    return this.applyTo$com_vzome_core_model_Manifestation(vector);
                  } else throw new Error('invalid overload');
                }
              }]);

              function CentroidByOctantAndDirectionColorMap() {
                _classCallCheck(this, CentroidByOctantAndDirectionColorMap);

                return _super19.call(this);
              }

              return CentroidByOctantAndDirectionColorMap;
            }(ManifestationColorMappers.CentroidColorMapper);

            ManifestationColorMappers.CentroidByOctantAndDirectionColorMap = CentroidByOctantAndDirectionColorMap;
            CentroidByOctantAndDirectionColorMap["__class"] = "com.vzome.core.edits.ManifestationColorMappers.CentroidByOctantAndDirectionColorMap";
            CentroidByOctantAndDirectionColorMap["__interfaces"] = ["com.vzome.core.edits.ColorMappers.ColorMapper", "java.util.function.Function"];
            /**
            * Maps vector XYZ components to RGB
            * corresponding to the X, Y or Z coordinate plane.
            *
            * Polarity info IS NOT retained by this mapping.
            * @class
            * @extends com.vzome.core.edits.ManifestationColorMappers.CentroidColorMapper
            */

            var CoordinatePlaneColorMap =
            /*#__PURE__*/
            function (_ManifestationColorMa13) {
              _inherits(CoordinatePlaneColorMap, _ManifestationColorMa13);

              var _super20 = _createSuper(CoordinatePlaneColorMap);

              _createClass(CoordinatePlaneColorMap, [{
                key: "getName",

                /**
                *
                * @return {string}
                */
                value: function getName() {
                  return "CoordinatePlaneColorMap";
                }
              }, {
                key: "applyTo$com_vzome_core_algebra_AlgebraicVector$int",
                value: function applyTo$com_vzome_core_algebra_AlgebraicVector$int(vector, alpha) {
                  return com.vzome.core.construction.Color.getInverted(ManifestationColorMappers.mapToOctant(vector, alpha, 0, 255, 0));
                }
                /**
                *
                * @param {com.vzome.core.algebra.AlgebraicVector} vector
                * @param {number} alpha
                * @return {com.vzome.core.construction.Color}
                */

              }, {
                key: "applyTo",
                value: function applyTo(vector, alpha) {
                  if ((vector != null && vector instanceof com.vzome.core.algebra.AlgebraicVector || vector === null) && (typeof alpha === 'number' || alpha === null)) {
                    return this.applyTo$com_vzome_core_algebra_AlgebraicVector$int(vector, alpha);
                  } else if ((vector != null && (vector["__interfaces"] != null && vector["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0 || vector.constructor != null && vector.constructor["__interfaces"] != null && vector.constructor["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0) || vector === null) && alpha === undefined) {
                    return this.applyTo$com_vzome_core_model_Manifestation(vector);
                  } else throw new Error('invalid overload');
                }
              }]);

              function CoordinatePlaneColorMap() {
                _classCallCheck(this, CoordinatePlaneColorMap);

                return _super20.call(this);
              }

              return CoordinatePlaneColorMap;
            }(ManifestationColorMappers.CentroidColorMapper);

            ManifestationColorMappers.CoordinatePlaneColorMap = CoordinatePlaneColorMap;
            CoordinatePlaneColorMap["__class"] = "com.vzome.core.edits.ManifestationColorMappers.CoordinatePlaneColorMap";
            CoordinatePlaneColorMap["__interfaces"] = ["com.vzome.core.edits.ColorMappers.ColorMapper", "java.util.function.Function"];
            /**
            * Maps standard SymmetrySystem colors
            * to the Manifestation's Centroid instead of the normal vector
            * @extends com.vzome.core.edits.ManifestationColorMappers.CentroidColorMapper
            * @class
            */

            var SystemCentroidColorMap =
            /*#__PURE__*/
            function (_ManifestationColorMa14) {
              _inherits(SystemCentroidColorMap, _ManifestationColorMa14);

              var _super21 = _createSuper(SystemCentroidColorMap);

              function SystemCentroidColorMap(symmetry) {
                var _this15;

                _classCallCheck(this, SystemCentroidColorMap);

                _this15 = _super21.call(this);
                if (_this15.symmetrySystem === undefined) _this15.symmetrySystem = null;
                _this15.symmetrySystem = symmetry;
                return _this15;
              }
              /**
              *
              * @return {string}
              */


              _createClass(SystemCentroidColorMap, [{
                key: "getName",
                value: function getName() {
                  return "SystemCentroidColorMap";
                }
              }, {
                key: "applyTo$com_vzome_core_algebra_AlgebraicVector$int",
                value: function applyTo$com_vzome_core_algebra_AlgebraicVector$int(centroid, alpha) {
                  return this.symmetrySystem.getVectorColor(centroid);
                }
                /**
                *
                * @param {com.vzome.core.algebra.AlgebraicVector} centroid
                * @param {number} alpha
                * @return {com.vzome.core.construction.Color}
                */

              }, {
                key: "applyTo",
                value: function applyTo(centroid, alpha) {
                  if ((centroid != null && centroid instanceof com.vzome.core.algebra.AlgebraicVector || centroid === null) && (typeof alpha === 'number' || alpha === null)) {
                    return this.applyTo$com_vzome_core_algebra_AlgebraicVector$int(centroid, alpha);
                  } else if ((centroid != null && (centroid["__interfaces"] != null && centroid["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0 || centroid.constructor != null && centroid.constructor["__interfaces"] != null && centroid.constructor["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0) || centroid === null) && alpha === undefined) {
                    return this.applyTo$com_vzome_core_model_Manifestation(centroid);
                  } else throw new Error('invalid overload');
                }
                /**
                *
                * @param {*} element
                */

              }, {
                key: "getXmlAttributes",
                value: function getXmlAttributes(element) {
                  if (this.symmetrySystem != null) {
                    com.vzome.xml.DomUtils.addAttribute(element, "symmetry", this.symmetrySystem.getName());
                  }
                }
              }]);

              return SystemCentroidColorMap;
            }(ManifestationColorMappers.CentroidColorMapper);

            ManifestationColorMappers.SystemCentroidColorMap = SystemCentroidColorMap;
            SystemCentroidColorMap["__class"] = "com.vzome.core.edits.ManifestationColorMappers.SystemCentroidColorMap";
            SystemCentroidColorMap["__interfaces"] = ["com.vzome.core.edits.ColorMappers.ColorMapper", "java.util.function.Function"];
            /**
            * Same as {@code DarkenNearOrigin} except that
            * the color mapping is reversed from lightest to darkest
            * @class
            * @extends com.vzome.core.edits.ManifestationColorMappers.DarkenNearOrigin
            */

            var DarkenWithDistance =
            /*#__PURE__*/
            function (_ManifestationColorMa15) {
              _inherits(DarkenWithDistance, _ManifestationColorMa15);

              var _super22 = _createSuper(DarkenWithDistance);

              _createClass(DarkenWithDistance, [{
                key: "getName",

                /**
                *
                * @return {string}
                */
                value: function getName() {
                  return "DarkenWithDistance";
                }
                /**
                *
                * @param {com.vzome.core.editor.api.Manifestations.ManifestationIterator} manifestations
                */

              }, {
                key: "initialize",
                value: function initialize(manifestations) {
                  _get(_getPrototypeOf(DarkenWithDistance.prototype), "initialize", this).call(this, manifestations);

                  this.offset = this.fullScaleSquared;
                }
              }]);

              function DarkenWithDistance() {
                _classCallCheck(this, DarkenWithDistance);

                return _super22.call(this);
              }

              return DarkenWithDistance;
            }(ManifestationColorMappers.DarkenNearOrigin);

            ManifestationColorMappers.DarkenWithDistance = DarkenWithDistance;
            DarkenWithDistance["__class"] = "com.vzome.core.edits.ManifestationColorMappers.DarkenWithDistance";
            DarkenWithDistance["__interfaces"] = ["com.vzome.core.edits.ColorMappers.ColorMapper", "java.util.function.Function"];
            /**
            * Polarity info is retained by this mapping
            * so that inverted struts and panels will be mapped to inverted colors.
            * @class
            * @extends com.vzome.core.edits.ManifestationColorMappers.ManifestationSubclassColorMapper
            */

            var RadialStandardBasisColorMap =
            /*#__PURE__*/
            function (_ManifestationColorMa16) {
              _inherits(RadialStandardBasisColorMap, _ManifestationColorMa16);

              var _super23 = _createSuper(RadialStandardBasisColorMap);

              _createClass(RadialStandardBasisColorMap, [{
                key: "getName",

                /**
                *
                * @return {string}
                */
                value: function getName() {
                  return "RadialStandardBasisColorMap";
                }
                /**
                *
                * @param {*} ball
                * @param {number} alpha
                * @return {com.vzome.core.construction.Color}
                */

              }, {
                key: "applyToBall",
                value: function applyToBall(ball, alpha) {
                  return this.applyTo$com_vzome_core_algebra_AlgebraicVector$int(ball.getLocation(), alpha);
                }
                /**
                *
                * @param {*} strut
                * @param {number} alpha
                * @return {com.vzome.core.construction.Color}
                */

              }, {
                key: "applyToStrut",
                value: function applyToStrut(strut, alpha) {
                  return this.applyTo$com_vzome_core_algebra_AlgebraicVector$int(strut.getOffset(), alpha);
                }
                /**
                *
                * @param {*} panel
                * @param {number} alpha
                * @return {com.vzome.core.construction.Color}
                */

              }, {
                key: "applyToPanel",
                value: function applyToPanel(panel, alpha) {
                  return this.applyTo$com_vzome_core_algebra_AlgebraicVector$int(panel['getNormal$'](), alpha);
                }
              }, {
                key: "applyTo$com_vzome_core_algebra_AlgebraicVector$int",
                value: function applyTo$com_vzome_core_algebra_AlgebraicVector$int(vector, alpha) {
                  return ManifestationColorMappers.mapRadially(vector, alpha);
                }
              }, {
                key: "applyTo",
                value: function applyTo(vector, alpha) {
                  if ((vector != null && vector instanceof com.vzome.core.algebra.AlgebraicVector || vector === null) && (typeof alpha === 'number' || alpha === null)) {
                    return this.applyTo$com_vzome_core_algebra_AlgebraicVector$int(vector, alpha);
                  } else if ((vector != null && (vector["__interfaces"] != null && vector["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0 || vector.constructor != null && vector.constructor["__interfaces"] != null && vector.constructor["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0) || vector === null) && alpha === undefined) {
                    _get(_getPrototypeOf(RadialStandardBasisColorMap.prototype), "applyTo", this).call(this, vector);
                  } else throw new Error('invalid overload');
                }
              }]);

              function RadialStandardBasisColorMap() {
                _classCallCheck(this, RadialStandardBasisColorMap);

                return _super23.call(this);
              }

              return RadialStandardBasisColorMap;
            }(ManifestationColorMappers.ManifestationSubclassColorMapper);

            ManifestationColorMappers.RadialStandardBasisColorMap = RadialStandardBasisColorMap;
            RadialStandardBasisColorMap["__class"] = "com.vzome.core.edits.ManifestationColorMappers.RadialStandardBasisColorMap";
            RadialStandardBasisColorMap["__interfaces"] = ["com.vzome.core.edits.ColorMappers.ColorMapper", "java.util.function.Function"];
            /**
            * Gets standard color mapping from the OrbitSource
            * @extends com.vzome.core.edits.ManifestationColorMappers.ManifestationSubclassColorMapper
            * @class
            */

            var SystemColorMap =
            /*#__PURE__*/
            function (_ManifestationColorMa17) {
              _inherits(SystemColorMap, _ManifestationColorMa17);

              var _super24 = _createSuper(SystemColorMap);

              function SystemColorMap(symmetry) {
                var _this16;

                _classCallCheck(this, SystemColorMap);

                _this16 = _super24.call(this);
                if (_this16.symmetrySystem === undefined) _this16.symmetrySystem = null;
                _this16.symmetrySystem = symmetry;
                return _this16;
              }
              /**
              *
              * @return {string}
              */


              _createClass(SystemColorMap, [{
                key: "getName",
                value: function getName() {
                  return "SystemColorMap";
                }
                /**
                *
                * @param {*} ball
                * @param {number} alpha
                * @return {com.vzome.core.construction.Color}
                */

              }, {
                key: "applyToBall",
                value: function applyToBall(ball, alpha) {
                  return com.vzome.core.construction.Color.WHITE_$LI$();
                }
                /**
                *
                * @param {*} strut
                * @param {number} alpha
                * @return {com.vzome.core.construction.Color}
                */

              }, {
                key: "applyToStrut",
                value: function applyToStrut(strut, alpha) {
                  return this.applyTo$com_vzome_core_algebra_AlgebraicVector(strut.getOffset());
                }
                /**
                *
                * @param {*} panel
                * @param {number} alpha
                * @return {com.vzome.core.construction.Color}
                */

              }, {
                key: "applyToPanel",
                value: function applyToPanel(panel, alpha) {
                  return this.applyTo$com_vzome_core_algebra_AlgebraicVector(panel['getNormal$']()).getPastel();
                }
              }, {
                key: "applyTo$com_vzome_core_algebra_AlgebraicVector",
                value: function applyTo$com_vzome_core_algebra_AlgebraicVector(vector) {
                  return this.symmetrySystem.getVectorColor(vector);
                }
              }, {
                key: "applyTo",
                value: function applyTo(vector) {
                  if (vector != null && vector instanceof com.vzome.core.algebra.AlgebraicVector || vector === null) {
                    return this.applyTo$com_vzome_core_algebra_AlgebraicVector(vector);
                  } else if (vector != null && (vector["__interfaces"] != null && vector["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0 || vector.constructor != null && vector.constructor["__interfaces"] != null && vector.constructor["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0) || vector === null) {
                    _get(_getPrototypeOf(SystemColorMap.prototype), "applyTo", this).call(this, vector);
                  } else throw new Error('invalid overload');
                }
                /**
                *
                * @param {*} element
                */

              }, {
                key: "getXmlAttributes",
                value: function getXmlAttributes(element) {
                  if (this.symmetrySystem != null) {
                    com.vzome.xml.DomUtils.addAttribute(element, "symmetry", this.symmetrySystem.getName());
                  }
                }
              }]);

              return SystemColorMap;
            }(ManifestationColorMappers.ManifestationSubclassColorMapper);

            ManifestationColorMappers.SystemColorMap = SystemColorMap;
            SystemColorMap["__class"] = "com.vzome.core.edits.ManifestationColorMappers.SystemColorMap";
            SystemColorMap["__interfaces"] = ["com.vzome.core.edits.ColorMappers.ColorMapper", "java.util.function.Function"];
            /**
            * Polarity info is intentionally removed by this mapping for struts and panels, but not balls
            * so that parallel struts and the panels normal to them will be the same color.
            * @class
            * @extends com.vzome.core.edits.ManifestationColorMappers.RadialStandardBasisColorMap
            */

            var CanonicalOrientationColorMap =
            /*#__PURE__*/
            function (_ManifestationColorMa18) {
              _inherits(CanonicalOrientationColorMap, _ManifestationColorMa18);

              var _super25 = _createSuper(CanonicalOrientationColorMap);

              _createClass(CanonicalOrientationColorMap, [{
                key: "getName",

                /**
                *
                * @return {string}
                */
                value: function getName() {
                  return "CanonicalOrientationColorMap";
                }
                /**
                *
                * @param {*} ball
                * @param {number} alpha
                * @return {com.vzome.core.construction.Color}
                */

              }, {
                key: "applyToBall",
                value: function applyToBall(ball, alpha) {
                  return _get(_getPrototypeOf(CanonicalOrientationColorMap.prototype), "applyToBall", this).call(this, ball, alpha);
                }
              }, {
                key: "applyTo$com_vzome_core_algebra_AlgebraicVector$int",
                value: function applyTo$com_vzome_core_algebra_AlgebraicVector$int(vector, alpha) {
                  return _get(_getPrototypeOf(CanonicalOrientationColorMap.prototype), "applyTo$com_vzome_core_algebra_AlgebraicVector$int", this).call(this, com.vzome.core.algebra.AlgebraicVectors.getCanonicalOrientation(vector), alpha);
                }
                /**
                *
                * @param {com.vzome.core.algebra.AlgebraicVector} vector
                * @param {number} alpha
                * @return {com.vzome.core.construction.Color}
                */

              }, {
                key: "applyTo",
                value: function applyTo(vector, alpha) {
                  if ((vector != null && vector instanceof com.vzome.core.algebra.AlgebraicVector || vector === null) && (typeof alpha === 'number' || alpha === null)) {
                    return this.applyTo$com_vzome_core_algebra_AlgebraicVector$int(vector, alpha);
                  } else if ((vector != null && (vector["__interfaces"] != null && vector["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0 || vector.constructor != null && vector.constructor["__interfaces"] != null && vector.constructor["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0) || vector === null) && alpha === undefined) {
                    _get(_getPrototypeOf(CanonicalOrientationColorMap.prototype), "applyTo", this).call(this, vector);
                  } else throw new Error('invalid overload');
                }
              }]);

              function CanonicalOrientationColorMap() {
                _classCallCheck(this, CanonicalOrientationColorMap);

                return _super25.call(this);
              }

              return CanonicalOrientationColorMap;
            }(ManifestationColorMappers.RadialStandardBasisColorMap);

            ManifestationColorMappers.CanonicalOrientationColorMap = CanonicalOrientationColorMap;
            CanonicalOrientationColorMap["__class"] = "com.vzome.core.edits.ManifestationColorMappers.CanonicalOrientationColorMap";
            CanonicalOrientationColorMap["__interfaces"] = ["com.vzome.core.edits.ColorMappers.ColorMapper", "java.util.function.Function"];
            /**
            * Polarity info is the ONLY basis for this mapping
            * @class
            * @extends com.vzome.core.edits.ManifestationColorMappers.RadialStandardBasisColorMap
            */

            var NormalPolarityColorMap =
            /*#__PURE__*/
            function (_ManifestationColorMa19) {
              _inherits(NormalPolarityColorMap, _ManifestationColorMa19);

              var _super26 = _createSuper(NormalPolarityColorMap);

              _createClass(NormalPolarityColorMap, [{
                key: "getName",

                /**
                *
                * @return {string}
                */
                value: function getName() {
                  return "NormalPolarityColorMap";
                }
              }, {
                key: "applyTo$com_vzome_core_algebra_AlgebraicVector$int",
                value: function applyTo$com_vzome_core_algebra_AlgebraicVector$int(vector, alpha) {
                  return ManifestationColorMappers.mapPolarity(vector, alpha);
                }
                /**
                *
                * @param {com.vzome.core.algebra.AlgebraicVector} vector
                * @param {number} alpha
                * @return {com.vzome.core.construction.Color}
                */

              }, {
                key: "applyTo",
                value: function applyTo(vector, alpha) {
                  if ((vector != null && vector instanceof com.vzome.core.algebra.AlgebraicVector || vector === null) && (typeof alpha === 'number' || alpha === null)) {
                    return this.applyTo$com_vzome_core_algebra_AlgebraicVector$int(vector, alpha);
                  } else if ((vector != null && (vector["__interfaces"] != null && vector["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0 || vector.constructor != null && vector.constructor["__interfaces"] != null && vector.constructor["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0) || vector === null) && alpha === undefined) {
                    _get(_getPrototypeOf(NormalPolarityColorMap.prototype), "applyTo", this).call(this, vector);
                  } else throw new Error('invalid overload');
                }
              }]);

              function NormalPolarityColorMap() {
                _classCallCheck(this, NormalPolarityColorMap);

                return _super26.call(this);
              }

              return NormalPolarityColorMap;
            }(ManifestationColorMappers.RadialStandardBasisColorMap);

            ManifestationColorMappers.NormalPolarityColorMap = NormalPolarityColorMap;
            NormalPolarityColorMap["__class"] = "com.vzome.core.edits.ManifestationColorMappers.NormalPolarityColorMap";
            NormalPolarityColorMap["__interfaces"] = ["com.vzome.core.edits.ColorMappers.ColorMapper", "java.util.function.Function"];
            /**
            * Gets standard color of the nearest special orbit using the standard color basis
            * @extends com.vzome.core.edits.ManifestationColorMappers.SystemColorMap
            * @class
            */

            var NearestSpecialOrbitColorMap =
            /*#__PURE__*/
            function (_ManifestationColorMa20) {
              _inherits(NearestSpecialOrbitColorMap, _ManifestationColorMa20);

              var _super27 = _createSuper(NearestSpecialOrbitColorMap);

              function NearestSpecialOrbitColorMap(symm) {
                var _this17;

                _classCallCheck(this, NearestSpecialOrbitColorMap);

                _this17 = _super27.call(this, symm);
                _this17.specialOrbits = new java.util.LinkedHashSet();

                _this17.specialOrbits.add(symm.getSymmetry().getSpecialOrbit(com.vzome.core.math.symmetry.Symmetry.SpecialOrbit.BLUE));

                _this17.specialOrbits.add(symm.getSymmetry().getSpecialOrbit(com.vzome.core.math.symmetry.Symmetry.SpecialOrbit.YELLOW));

                _this17.specialOrbits.add(symm.getSymmetry().getSpecialOrbit(com.vzome.core.math.symmetry.Symmetry.SpecialOrbit.RED));

                return _this17;
              }
              /**
              *
              * @return {string}
              */


              _createClass(NearestSpecialOrbitColorMap, [{
                key: "getName",
                value: function getName() {
                  return "NearestSpecialOrbitColorMap";
                }
                /**
                *
                * @param {*} ball
                * @param {number} alpha
                * @return {com.vzome.core.construction.Color}
                */

              }, {
                key: "applyToBall",
                value: function applyToBall(ball, alpha) {
                  return this.applyTo$com_vzome_core_algebra_AlgebraicVector(ball.getLocation());
                }
                /**
                *
                * @param {*} strut
                * @param {number} alpha
                * @return {com.vzome.core.construction.Color}
                */

              }, {
                key: "applyToStrut",
                value: function applyToStrut(strut, alpha) {
                  return this.applyTo$com_vzome_core_algebra_AlgebraicVector(strut.getOffset());
                }
                /**
                *
                * @param {*} panel
                * @param {number} alpha
                * @return {com.vzome.core.construction.Color}
                */

              }, {
                key: "applyToPanel",
                value: function applyToPanel(panel, alpha) {
                  return this.applyTo$com_vzome_core_algebra_AlgebraicVector(panel['getNormal$']()).getPastel();
                }
              }, {
                key: "applyTo$com_vzome_core_algebra_AlgebraicVector",
                value: function applyTo$com_vzome_core_algebra_AlgebraicVector(vector) {
                  if (vector.isOrigin()) {
                    return com.vzome.core.construction.Color.WHITE_$LI$();
                  }

                  var nearestSpecialOrbit = this.symmetrySystem.getSymmetry()['getAxis$com_vzome_core_math_RealVector$java_util_Set'](vector.toRealVector(), this.specialOrbits);
                  var normal = nearestSpecialOrbit.normal();
                  return this.symmetrySystem.getVectorColor(normal);
                }
                /**
                *
                * @param {com.vzome.core.algebra.AlgebraicVector} vector
                * @return {com.vzome.core.construction.Color}
                */

              }, {
                key: "applyTo",
                value: function applyTo(vector) {
                  if (vector != null && vector instanceof com.vzome.core.algebra.AlgebraicVector || vector === null) {
                    return this.applyTo$com_vzome_core_algebra_AlgebraicVector(vector);
                  } else if (vector != null && (vector["__interfaces"] != null && vector["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0 || vector.constructor != null && vector.constructor["__interfaces"] != null && vector.constructor["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0) || vector === null) {
                    _get(_getPrototypeOf(NearestSpecialOrbitColorMap.prototype), "applyTo", this).call(this, vector);
                  } else throw new Error('invalid overload');
                }
              }]);

              return NearestSpecialOrbitColorMap;
            }(ManifestationColorMappers.SystemColorMap);

            ManifestationColorMappers.NearestSpecialOrbitColorMap = NearestSpecialOrbitColorMap;
            NearestSpecialOrbitColorMap["__class"] = "com.vzome.core.edits.ManifestationColorMappers.NearestSpecialOrbitColorMap";
            NearestSpecialOrbitColorMap["__interfaces"] = ["com.vzome.core.edits.ColorMappers.ColorMapper", "java.util.function.Function"];
            /**
            * Gets standard color of the nearest special orbit based on the Centroid
            * @extends com.vzome.core.edits.ManifestationColorMappers.NearestSpecialOrbitColorMap
            * @class
            */

            var CentroidNearestSpecialOrbitColorMap =
            /*#__PURE__*/
            function (_ManifestationColorMa21) {
              _inherits(CentroidNearestSpecialOrbitColorMap, _ManifestationColorMa21);

              var _super28 = _createSuper(CentroidNearestSpecialOrbitColorMap);

              _createClass(CentroidNearestSpecialOrbitColorMap, [{
                key: "getName",

                /**
                *
                * @return {string}
                */
                value: function getName() {
                  return "CentroidNearestSpecialOrbitColorMap";
                }
              }]);

              function CentroidNearestSpecialOrbitColorMap(symm) {
                _classCallCheck(this, CentroidNearestSpecialOrbitColorMap);

                return _super28.call(this, symm);
              }
              /**
              *
              * @param {*} ball
              * @param {number} alpha
              * @return {com.vzome.core.construction.Color}
              */


              _createClass(CentroidNearestSpecialOrbitColorMap, [{
                key: "applyToBall",
                value: function applyToBall(ball, alpha) {
                  return this.applyTo$com_vzome_core_algebra_AlgebraicVector(ball.getCentroid());
                }
                /**
                *
                * @param {*} strut
                * @param {number} alpha
                * @return {com.vzome.core.construction.Color}
                */

              }, {
                key: "applyToStrut",
                value: function applyToStrut(strut, alpha) {
                  return this.applyTo$com_vzome_core_algebra_AlgebraicVector(strut.getCentroid());
                }
                /**
                *
                * @param {*} panel
                * @param {number} alpha
                * @return {com.vzome.core.construction.Color}
                */

              }, {
                key: "applyToPanel",
                value: function applyToPanel(panel, alpha) {
                  return this.applyTo$com_vzome_core_algebra_AlgebraicVector(panel.getCentroid()).getPastel();
                }
              }]);

              return CentroidNearestSpecialOrbitColorMap;
            }(ManifestationColorMappers.NearestSpecialOrbitColorMap);

            ManifestationColorMappers.CentroidNearestSpecialOrbitColorMap = CentroidNearestSpecialOrbitColorMap;
            CentroidNearestSpecialOrbitColorMap["__class"] = "com.vzome.core.edits.ManifestationColorMappers.CentroidNearestSpecialOrbitColorMap";
            CentroidNearestSpecialOrbitColorMap["__interfaces"] = ["com.vzome.core.edits.ColorMappers.ColorMapper", "java.util.function.Function"];
            /**
            * Gets standard color of the nearest predefined orbit using the symmetry's standard color scheme
            * @extends com.vzome.core.edits.ManifestationColorMappers.NearestSpecialOrbitColorMap
            * @class
            */

            var NearestPredefinedOrbitColorMap =
            /*#__PURE__*/
            function (_ManifestationColorMa22) {
              _inherits(NearestPredefinedOrbitColorMap, _ManifestationColorMa22);

              var _super29 = _createSuper(NearestPredefinedOrbitColorMap);

              _createClass(NearestPredefinedOrbitColorMap, [{
                key: "getName",

                /**
                *
                * @return {string}
                */
                value: function getName() {
                  return "NearestPredefinedOrbitColorMap";
                }
              }]);

              function NearestPredefinedOrbitColorMap(symm) {
                var _this18;

                _classCallCheck(this, NearestPredefinedOrbitColorMap);

                _this18 = _super29.call(this, symm);
                _this18.specialOrbits = null;
                return _this18;
              }

              return NearestPredefinedOrbitColorMap;
            }(ManifestationColorMappers.NearestSpecialOrbitColorMap);

            ManifestationColorMappers.NearestPredefinedOrbitColorMap = NearestPredefinedOrbitColorMap;
            NearestPredefinedOrbitColorMap["__class"] = "com.vzome.core.edits.ManifestationColorMappers.NearestPredefinedOrbitColorMap";
            NearestPredefinedOrbitColorMap["__interfaces"] = ["com.vzome.core.edits.ColorMappers.ColorMapper", "java.util.function.Function"];
            /**
            * Gets standard color of the nearest predefined orbit based on the centroid of each manifestation
            * @extends com.vzome.core.edits.ManifestationColorMappers.CentroidNearestSpecialOrbitColorMap
            * @class
            */

            var CentroidNearestPredefinedOrbitColorMap =
            /*#__PURE__*/
            function (_ManifestationColorMa23) {
              _inherits(CentroidNearestPredefinedOrbitColorMap, _ManifestationColorMa23);

              var _super30 = _createSuper(CentroidNearestPredefinedOrbitColorMap);

              _createClass(CentroidNearestPredefinedOrbitColorMap, [{
                key: "getName",

                /**
                *
                * @return {string}
                */
                value: function getName() {
                  return "CentroidNearestPredefinedOrbitColorMap";
                }
              }]);

              function CentroidNearestPredefinedOrbitColorMap(symm) {
                var _this19;

                _classCallCheck(this, CentroidNearestPredefinedOrbitColorMap);

                _this19 = _super30.call(this, symm);
                _this19.specialOrbits = null;
                return _this19;
              }

              return CentroidNearestPredefinedOrbitColorMap;
            }(ManifestationColorMappers.CentroidNearestSpecialOrbitColorMap);

            ManifestationColorMappers.CentroidNearestPredefinedOrbitColorMap = CentroidNearestPredefinedOrbitColorMap;
            CentroidNearestPredefinedOrbitColorMap["__class"] = "com.vzome.core.edits.ManifestationColorMappers.CentroidNearestPredefinedOrbitColorMap";
            CentroidNearestPredefinedOrbitColorMap["__interfaces"] = ["com.vzome.core.edits.ColorMappers.ColorMapper", "java.util.function.Function"];
          })(ManifestationColorMappers = edits.ManifestationColorMappers || (edits.ManifestationColorMappers = {}));
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          /**
          * @author David Hall
          * @class
          */
          var ColorMappers = function ColorMappers() {
            _classCallCheck(this, ColorMappers);
          };

          edits.ColorMappers = ColorMappers;
          ColorMappers["__class"] = "com.vzome.core.edits.ColorMappers";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (editor_1) {
          var ToolsModel =
          /*#__PURE__*/
          function (_java$util$TreeMap2) {
            _inherits(ToolsModel, _java$util$TreeMap2);

            var _super31 = _createSuper(ToolsModel);

            function ToolsModel(context, originPoint) {
              var _this20;

              _classCallCheck(this, ToolsModel);

              _this20 = _super31.call(this);
              if (_this20.editor === undefined) _this20.editor = null;
              _this20.lastId = 0;
              _this20.pcs = new java.beans.PropertyChangeSupport(_assertThisInitialized(_this20));
              if (_this20.context === undefined) _this20.context = null;
              if (_this20.originPoint === undefined) _this20.originPoint = null;
              _this20.toolLabels = new java.util.HashMap();
              _this20.toolDeleteInputs = new java.util.HashMap();
              _this20.toolSelectInputs = new java.util.HashMap();
              _this20.hiddenTools = new java.util.HashSet();
              _this20.context = context;
              _this20.originPoint = originPoint;
              return _this20;
            }

            _createClass(ToolsModel, [{
              key: "reserveId",
              value: function reserveId() {
                return this.lastId++;
              }
              /**
              * Only called during load of a document, before any new tool creations with reserveId.
              * @param {number} id
              */

            }, {
              key: "setMaxId",
              value: function setMaxId(id) {
                if (id >= this.lastId) this.lastId = id + 1;
              }
              /**
              *
              * @param {string} key
              * @param {com.vzome.core.editor.Tool} tool
              * @return {com.vzome.core.editor.Tool}
              */

            }, {
              key: "put",
              value: function put(key, tool) {
                this.pcs.firePropertyChange("tool.instances", null, tool);
                return _get(_getPrototypeOf(ToolsModel.prototype), "put", this).call(this, key, tool);
              }
            }, {
              key: "createEdit",
              value: function createEdit(className) {
                switch (className) {
                  case "ToolApplied":
                    return new com.vzome.core.editor.ApplyTool(this, null, false, false, false, false, false);

                  case "ApplyTool":
                    return new com.vzome.core.editor.ApplyTool(this, null, false, false, false, false, true);

                  case "SelectToolParameters":
                    return new com.vzome.core.editor.SelectToolParameters(this, null);

                  default:
                    return null;
                }
              }
            }, {
              key: "applyTool",
              value: function applyTool(tool, selectInputs, deleteInputs, createOutputs, selectOutputs) {
                var edit = new com.vzome.core.editor.ApplyTool(this, tool, selectInputs, deleteInputs, createOutputs, selectOutputs, true);
                this.getContext().performAndRecord(edit);
              }
            }, {
              key: "selectToolParameters",
              value: function selectToolParameters(tool) {
                var edit = new com.vzome.core.editor.SelectToolParameters(this, tool);
                this.getContext().performAndRecord(edit);
              }
            }, {
              key: "addPropertyListener",
              value: function addPropertyListener(listener) {
                this.pcs.addPropertyChangeListener(listener);
              }
            }, {
              key: "removePropertyListener",
              value: function removePropertyListener(listener) {
                this.pcs.removePropertyChangeListener(listener);
              }
            }, {
              key: "setEditorModel",
              value: function setEditorModel(editor) {
                this.editor = editor;
              }
            }, {
              key: "getEditorModel",
              value: function getEditorModel() {
                return this.editor;
              }
              /**
              *
              * @param {string} id
              * @return {com.vzome.core.editor.Tool}
              */

            }, {
              key: "getPredefinedTool",
              value: function getPredefinedTool(id) {
                return this.get(id);
              }
            }, {
              key: "getContext",
              value: function getContext() {
                return this.context;
              }
            }, {
              key: "getOriginPoint",
              value: function getOriginPoint() {
                return this.originPoint;
              }
            }, {
              key: "getXml",
              value: function getXml(doc) {
                var result = doc.createElement("Tools");

                for (var index629 = this.values().iterator(); index629.hasNext();) {
                  var tool = index629.next();

                  if (!tool.isPredefined()) {
                    var toolElem = doc.createElement("Tool");
                    com.vzome.xml.DomUtils.addAttribute(toolElem, "id", tool.getId());
                    com.vzome.xml.DomUtils.addAttribute(toolElem, "label", tool.getLabel());
                    if (tool.isHidden()) com.vzome.xml.DomUtils.addAttribute(toolElem, "hidden", "true");
                    if (tool.isSelectInputs()) toolElem.setAttribute("selectInputs", "true");
                    if (tool.isDeleteInputs()) toolElem.setAttribute("deleteInputs", "true");
                    result.appendChild(toolElem);
                  }
                }

                return result;
              }
            }, {
              key: "loadFromXml",
              value: function loadFromXml(xml) {
                var nodes = xml.getChildNodes();

                for (var i = 0; i < nodes.getLength(); i++) {
                  {
                    var node = nodes.item(i);

                    if (node != null && (node["__interfaces"] != null && node["__interfaces"].indexOf("org.w3c.dom.Element") >= 0 || node.constructor != null && node.constructor["__interfaces"] != null && node.constructor["__interfaces"].indexOf("org.w3c.dom.Element") >= 0)) {
                      var toolElem = node;
                      var id = toolElem.getAttribute("id");
                      var label = toolElem.getAttribute("label");
                      this.toolLabels.put(id, label);
                      var value = toolElem.getAttribute("selectInputs");
                      if (value != null &&
                      /* equals */
                      function (o1, o2) {
                        if (o1 && o1.equals) {
                          return o1.equals(o2);
                        } else {
                          return o1 === o2;
                        }
                      }(value, "true")) this.toolSelectInputs.put(id, javaemul.internal.BooleanHelper.parseBoolean(value));
                      value = toolElem.getAttribute("deleteInputs");
                      if (value != null &&
                      /* equals */
                      function (o1, o2) {
                        if (o1 && o1.equals) {
                          return o1.equals(o2);
                        } else {
                          return o1 === o2;
                        }
                      }(value, "true")) this.toolDeleteInputs.put(id, javaemul.internal.BooleanHelper.parseBoolean(value));
                      var hiddenStr = toolElem.getAttribute("hidden");
                      if (hiddenStr != null &&
                      /* equals */
                      function (o1, o2) {
                        if (o1 && o1.equals) {
                          return o1.equals(o2);
                        } else {
                          return o1 === o2;
                        }
                      }(hiddenStr, "true")) this.hiddenTools.add(id);
                    }
                  }
                }
              }
            }, {
              key: "setConfiguration",
              value: function setConfiguration(tool) {
                var id = tool.getId();
                var label = this.toolLabels.get(id);
                if (label != null) tool.setLabel(label);

                if (this.toolDeleteInputs.containsKey(id) || this.toolSelectInputs.containsKey(id)) {
                  tool.setInputBehaviors(this.toolSelectInputs.containsKey(id), this.toolDeleteInputs.containsKey(id));
                }

                tool.setHidden(this.hiddenTools.contains(id));
              }
            }, {
              key: "hideTool",
              value: function hideTool(tool) {
                this.pcs.firePropertyChange("tool.instances", tool, null);
              }
            }]);

            return ToolsModel;
          }(java.util.TreeMap);

          editor_1.ToolsModel = ToolsModel;
          ToolsModel["__class"] = "com.vzome.core.editor.ToolsModel";
          ToolsModel["__interfaces"] = ["java.lang.Cloneable", "com.vzome.api.Tool.Source", "java.util.Map", "java.util.NavigableMap", "java.util.SortedMap", "java.io.Serializable"];
        })(core.editor || (core.editor = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (editor) {
          var Duplicator =
          /*#__PURE__*/
          function () {
            function Duplicator(edit, offset) {
              _classCallCheck(this, Duplicator);

              this.vertexData = new java.util.HashMap();
              if (this.edit === undefined) this.edit = null;
              if (this.offset === undefined) this.offset = null;
              this.edit = edit;
              this.offset = offset;
            }

            _createClass(Duplicator, [{
              key: "duplicateManifestation",
              value: function duplicateManifestation(man) {
                var constr = this.duplicateConstruction(man);
                this.edit.manifestConstruction(constr);
              }
            }, {
              key: "duplicateConstruction",
              value: function duplicateConstruction(man) {
                if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0)) {
                  var vector = man.getLocation();
                  return this.getVertex(vector);
                } else if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0)) {
                  var strut = man;
                  var p1 = this.getVertex(strut.getLocation());
                  var p2 = this.getVertex(strut.getEnd());
                  return new com.vzome.core.construction.SegmentJoiningPoints(p1, p2);
                } else if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0)) {
                  var vs = new java.util.ArrayList();

                  for (var index630 = man.iterator(); index630.hasNext();) {
                    var v = index630.next();
                    {
                      vs.add(this.getVertex(v));
                    }
                  }

                  return new com.vzome.core.construction.PolygonFromVertices(vs.toArray([]));
                }

                return null;
              }
            }, {
              key: "getVertex",
              value: function getVertex(vertexVector) {
                var result = this.vertexData.get(vertexVector);

                if (result == null) {
                  var key = vertexVector;
                  if (this.offset != null) vertexVector = vertexVector.plus(this.offset);
                  result = new com.vzome.core.construction.FreePoint(vertexVector);
                  this.vertexData.put(key, result);
                }

                return result;
              }
            }]);

            return Duplicator;
          }();

          editor.Duplicator = Duplicator;
          Duplicator["__class"] = "com.vzome.core.editor.Duplicator";
        })(core.editor || (core.editor = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (editor) {
          var SelectionSummary =
          /*#__PURE__*/
          function () {
            function SelectionSummary(selection) {
              _classCallCheck(this, SelectionSummary);

              this.balls = 0;
              this.struts = 0;
              this.panels = 0;
              this.listeners = new java.util.ArrayList();
              if (this.selection === undefined) this.selection = null;
              this.selection = selection;
            }

            _createClass(SelectionSummary, [{
              key: "notifyListeners",
              value: function notifyListeners() {
                for (var index631 = this.listeners.iterator(); index631.hasNext();) {
                  var listener = index631.next();
                  {
                    listener.selectionChanged(this.selection.size(), this.balls, this.struts, this.panels);
                  }
                }
              }
              /**
              *
              * @param {*} m
              */

            }, {
              key: "manifestationAdded",
              value: function manifestationAdded(m) {
                if (m != null && (m["__interfaces"] != null && m["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || m.constructor != null && m.constructor["__interfaces"] != null && m.constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0)) ++this.balls;else if (m != null && (m["__interfaces"] != null && m["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || m.constructor != null && m.constructor["__interfaces"] != null && m.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0)) ++this.struts;else if (m != null && (m["__interfaces"] != null && m["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0 || m.constructor != null && m.constructor["__interfaces"] != null && m.constructor["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0)) ++this.panels;
              }
              /**
              *
              * @param {*} m
              */

            }, {
              key: "manifestationRemoved",
              value: function manifestationRemoved(m) {
                if (m != null && (m["__interfaces"] != null && m["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || m.constructor != null && m.constructor["__interfaces"] != null && m.constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0)) --this.balls;else if (m != null && (m["__interfaces"] != null && m["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || m.constructor != null && m.constructor["__interfaces"] != null && m.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0)) --this.struts;else if (m != null && (m["__interfaces"] != null && m["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0 || m.constructor != null && m.constructor["__interfaces"] != null && m.constructor["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0)) --this.panels;
              }
              /**
              *
              * @param {*} m
              * @param {com.vzome.core.construction.Color} color
              */

            }, {
              key: "manifestationColored",
              value: function manifestationColored(m, color) {}
            }, {
              key: "addListener",
              value: function addListener(listener) {
                this.listeners.add(listener);
              }
            }]);

            return SelectionSummary;
          }();

          editor.SelectionSummary = SelectionSummary;
          SelectionSummary["__class"] = "com.vzome.core.editor.SelectionSummary";
          SelectionSummary["__interfaces"] = ["com.vzome.core.model.ManifestationChanges"];
        })(core.editor || (core.editor = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (editor) {
          (function (api) {
            var UndoableEdit =
            /*#__PURE__*/
            function () {
              function UndoableEdit() {
                _classCallCheck(this, UndoableEdit);

                this.__hasBreakpoint = false;
                this.lineNumber = -1;
              }

              _createClass(UndoableEdit, [{
                key: "hasBreakpoint",
                value: function hasBreakpoint() {
                  return this.__hasBreakpoint;
                }
              }, {
                key: "setBreakpoint",
                value: function setBreakpoint(value) {
                  this.__hasBreakpoint = value;
                }
              }, {
                key: "getLineNumber",
                value: function getLineNumber() {
                  return this.lineNumber;
                }
              }, {
                key: "setLineNumber",
                value: function setLineNumber(lineNumber) {
                  this.lineNumber = lineNumber;
                }
              }]);

              return UndoableEdit;
            }();

            api.UndoableEdit = UndoableEdit;
            UndoableEdit["__class"] = "com.vzome.core.editor.api.UndoableEdit";
          })(editor.api || (editor.api = {}));
        })(core.editor || (core.editor = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (editor) {
          (function (api) {
            var ManifestConstructions =
            /*#__PURE__*/
            function (_java$util$ArrayList4) {
              _inherits(ManifestConstructions, _java$util$ArrayList4);

              var _super32 = _createSuper(ManifestConstructions);

              function ManifestConstructions(edit) {
                var _this21;

                _classCallCheck(this, ManifestConstructions);

                _this21 = _super32.call(this);
                if (_this21.edit === undefined) _this21.edit = null;
                _this21.edit = edit;
                return _this21;
              }

              _createClass(ManifestConstructions, [{
                key: "constructionAdded$com_vzome_core_construction_Construction",
                value: function constructionAdded$com_vzome_core_construction_Construction(c) {
                  this.edit.manifestConstruction(c);
                  this.edit.redo();
                }
              }, {
                key: "constructionAdded$com_vzome_core_construction_Construction$com_vzome_core_construction_Color",
                value: function constructionAdded$com_vzome_core_construction_Construction$com_vzome_core_construction_Color(c, color) {
                  var manifestation = this.edit.manifestConstruction(c);
                  if (color != null) this.edit.colorManifestation(manifestation, color);
                  this.edit.select$com_vzome_core_model_Manifestation(manifestation);
                  this.edit.redo();
                }
                /**
                *
                * @param {com.vzome.core.construction.Construction} c
                * @param {com.vzome.core.construction.Color} color
                */

              }, {
                key: "constructionAdded",
                value: function constructionAdded(c, color) {
                  if ((c != null && c instanceof com.vzome.core.construction.Construction || c === null) && (color != null && color instanceof com.vzome.core.construction.Color || color === null)) {
                    return this.constructionAdded$com_vzome_core_construction_Construction$com_vzome_core_construction_Color(c, color);
                  } else if ((c != null && c instanceof com.vzome.core.construction.Construction || c === null) && color === undefined) {
                    return this.constructionAdded$com_vzome_core_construction_Construction(c);
                  } else throw new Error('invalid overload');
                }
              }]);

              return ManifestConstructions;
            }(java.util.ArrayList);

            api.ManifestConstructions = ManifestConstructions;
            ManifestConstructions["__class"] = "com.vzome.core.editor.api.ManifestConstructions";
            ManifestConstructions["__interfaces"] = ["java.util.RandomAccess", "com.vzome.core.model.ColoredMeshJson.Events", "com.vzome.core.model.SimpleMeshJson.Events", "java.util.List", "java.lang.Cloneable", "com.vzome.core.construction.ConstructionChanges", "java.util.Collection", "java.lang.Iterable", "java.io.Serializable"];
          })(editor.api || (editor.api = {}));
        })(core.editor || (core.editor = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (editor) {
          (function (api) {
            (function (Selection) {
              function biggestGroup(m) {
                var parent = m.getContainer();
                var group = parent;

                while (parent != null) {
                  {
                    parent = group.getContainer();
                    if (parent == null) break;
                    group = parent;
                  }
                }

                return group;
              }

              Selection.biggestGroup = biggestGroup;
            })(api.Selection || (api.Selection = {}));
          })(editor.api || (editor.api = {}));
        })(core.editor || (core.editor = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (editor) {
          (function (api) {
            (function (ActionEnum) {
              ActionEnum[ActionEnum["IGNORE"] = 0] = "IGNORE";
              ActionEnum[ActionEnum["SELECT"] = 1] = "SELECT";
              ActionEnum[ActionEnum["DESELECT"] = 2] = "DESELECT";
            })(api.ActionEnum || (api.ActionEnum = {}));
          })(editor.api || (editor.api = {}));
        })(core.editor || (core.editor = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (editor) {
          var AbstractToolFactory =
          /*#__PURE__*/
          function () {
            function AbstractToolFactory(tools, symmetry, id, label, tooltip) {
              _classCallCheck(this, AbstractToolFactory);

              this.enabled = false;
              if (this.pcs === undefined) this.pcs = null;
              if (this.tools === undefined) this.tools = null;
              if (this.label === undefined) this.label = null;
              if (this.tooltip === undefined) this.tooltip = null;
              if (this.id === undefined) this.id = null;
              if (this.symmetry === undefined) this.symmetry = null;
              this.tools = tools;
              this.symmetry = symmetry;
              this.id = id;
              this.label = label;
              this.tooltip = tooltip;
              this.pcs = new java.beans.PropertyChangeSupport(this);
            }
            /**
            *
            * @param {number} total
            * @param {number} balls
            * @param {number} struts
            * @param {number} panels
            */


            _createClass(AbstractToolFactory, [{
              key: "selectionChanged",
              value: function selectionChanged(total, balls, struts, panels) {
                var wasEnabled = this.enabled;
                if (this.countsAreValid(total, balls, struts, panels)) this.enabled = this.bindParameters(this.getSelection());else this.enabled = false;
                if (wasEnabled !== this.enabled) this.pcs.firePropertyChange("enabled", wasEnabled, this.enabled);
              }
            }, {
              key: "getSymmetry",
              value: function getSymmetry() {
                return this.symmetry;
              }
            }, {
              key: "getId",
              value: function getId() {
                return this.id;
              }
            }, {
              key: "getLabel",
              value: function getLabel() {
                return this.label;
              }
            }, {
              key: "getToolTip",
              value: function getToolTip() {
                return this.tooltip;
              }
            }, {
              key: "getToolsModel",
              value: function getToolsModel() {
                return this.tools;
              }
            }, {
              key: "getEditorModel",
              value: function getEditorModel() {
                return this.tools.getEditorModel();
              }
            }, {
              key: "getSelection",
              value: function getSelection() {
                return this.getEditorModel().getSelection();
              }
            }, {
              key: "getModel",
              value: function getModel() {
                return this.getEditorModel().getRealizedModel();
              }
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "isEnabled",
              value: function isEnabled() {
                return this.enabled;
              }
            }, {
              key: "addListener",
              value: function addListener(listener) {
                this.pcs.addPropertyChangeListener(listener);
              }
              /**
              *
              * @return {com.vzome.core.editor.Tool}
              */

            }, {
              key: "createTool",
              value: function createTool() {
                var index = this.tools.reserveId();
                var tool = this.createToolInternal(AbstractToolFactory.NEW_PREFIX + index);
                tool.setCategory(this.getId());
                tool.setLabel(this.getId() + " " + index);
                if (tool != null && tool instanceof com.vzome.core.editor.api.UndoableEdit) this.tools.getContext().performAndRecord(tool);else this.tools.put(tool.getId(), tool);
                return tool;
              }
            }, {
              key: "createPredefinedTool",
              value: function createPredefinedTool(label) {
                var tool = this.createToolInternal(this.getId() + ".builtin/" + label);
                tool.setLabel(label);
                tool.setCategory(this.getId());
                tool.setPredefined(true);
                tool.checkSelection(true);
                this.tools.put(tool.getId(), tool);
                return tool;
              }
            }, {
              key: "deserializeTool",
              value: function deserializeTool(id) {
                var tool = this.createToolInternal(id);

                if (
                /* startsWith */
                function (str, searchString) {
                  var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                  return str.substr(position, searchString.length) === searchString;
                }(id, AbstractToolFactory.NEW_PREFIX)) {
                  var num = javaemul.internal.IntegerHelper.parseInt(id.substring(AbstractToolFactory.NEW_PREFIX.length));
                  this.tools.setMaxId(num);
                }

                this.tools.setConfiguration(tool);
                var nextDot = id.indexOf(".");

                if (nextDot > 0) {
                  tool.setCategory(id.substring(0, nextDot));
                } else {
                  tool.setCategory(this.getId());
                }

                return tool;
              }
            }]);

            return AbstractToolFactory;
          }();

          AbstractToolFactory.NEW_PREFIX = "tool-";
          editor.AbstractToolFactory = AbstractToolFactory;
          AbstractToolFactory["__class"] = "com.vzome.core.editor.AbstractToolFactory";
          AbstractToolFactory["__interfaces"] = ["com.vzome.core.editor.SelectionSummary.Listener", "com.vzome.api.Tool.Factory"];
        })(core.editor || (core.editor = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (editor_2) {
          var SymmetrySystem =
          /*#__PURE__*/
          function () {
            function SymmetrySystem(symmXml, symmetryPerspective, context, colors, allowNonstandard) {
              _classCallCheck(this, SymmetrySystem);

              if (this.symmetry === undefined) this.symmetry = null;
              if (this.orbits === undefined) this.orbits = null;
              this.orbitColors = new java.util.HashMap();
              if (this.shapes === undefined) this.shapes = null;
              this.vectorToAxis = new java.util.HashMap();
              this.noKnownDirections = false;
              if (this.symmetryPerspective === undefined) this.symmetryPerspective = null;
              this.toolFactoryLists = new java.util.HashMap();
              this.toolLists = new java.util.HashMap();
              if (this.context === undefined) this.context = null;
              if (this.editor === undefined) this.editor = null;
              this.symmetryPerspective = symmetryPerspective;
              this.context = context;
              this.symmetry = symmetryPerspective.getSymmetry();
              var styleName = symmetryPerspective.getDefaultGeometry().getName();
              this.orbits = new com.vzome.core.math.symmetry.OrbitSet(this.symmetry);

              if (symmXml == null) {
                for (var index632 = this.symmetry.getOrbitSet().iterator(); index632.hasNext();) {
                  var orbit = index632.next();
                  {
                    if (symmetryPerspective.orbitIsStandard(orbit) || allowNonstandard) this.orbits.add(orbit);
                    var color = colors.getColor(com.vzome.core.render.Colors.DIRECTION_$LI$() + orbit.getName());
                    this.orbitColors.put(orbit.getName(), color);
                  }
                }
              } else {
                styleName = symmXml.getAttribute("renderingStyle");
                var nodes = symmXml.getChildNodes();

                for (var i = 0; i < nodes.getLength(); i++) {
                  {
                    var node = nodes.item(i);

                    if (node != null && (node["__interfaces"] != null && node["__interfaces"].indexOf("org.w3c.dom.Element") >= 0 || node.constructor != null && node.constructor["__interfaces"] != null && node.constructor["__interfaces"].indexOf("org.w3c.dom.Element") >= 0)) {
                      var dirElem = node;
                      var name = dirElem.getAttribute("name");
                      var _orbit = null;
                      var nums = dirElem.getAttribute("prototype");

                      if (nums != null && !(nums.length === 0)) {
                        var prototype = this.symmetry.getField().parseVector(nums);

                        try {
                          _orbit = this.symmetry.createNewZoneOrbit(name, 0, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, prototype);
                        } catch (e) {
                          console.error("Integer overflow happened while creating orbit: " + name);
                          continue;
                        }

                        _orbit.setAutomatic(true);

                        try {
                          var autoNum = javaemul.internal.IntegerHelper.parseInt(name);
                          if (autoNum >= SymmetrySystem.NEXT_NEW_AXIS) SymmetrySystem.NEXT_NEW_AXIS = ++autoNum;else if (autoNum < SymmetrySystem.NEXT_NEW_AXIS) name = "" + SymmetrySystem.NEXT_NEW_AXIS++;
                        } catch (e) {
                          console.error(e.message);
                        }
                      } else {
                        _orbit = this.symmetry.getDirection(name);
                        if (_orbit == null) continue;
                      }

                      this.orbits.add(_orbit);
                      var str = dirElem.getAttribute("color");

                      if (str != null && !(str.length === 0)) {
                        var _color3 = com.vzome.core.construction.Color.parseColor(str);

                        this.orbitColors.put(_orbit.getName(), _color3);
                      }
                    }
                  }
                }

                for (var index633 = this.symmetry.getOrbitSet().iterator(); index633.hasNext();) {
                  var _orbit2 = index633.next();

                  {
                    if (this.orbits.contains(_orbit2)) continue;
                    if (_orbit2.isStandard() || allowNonstandard) this.orbits.add(_orbit2);

                    var _color4 = colors.getColor(com.vzome.core.render.Colors.DIRECTION_$LI$() + _orbit2.getName());

                    this.orbitColors.put(_orbit2.getName(), _color4);
                  }
                }
              }

              this.setStyle(styleName);
            }

            _createClass(SymmetrySystem, [{
              key: "setEditorModel",
              value: function setEditorModel(editor) {
                this.editor = editor;
              }
            }, {
              key: "createToolFactories",
              value: function createToolFactories(tools) {
                {
                  var array635 =
                  /* Enum.values */
                  function () {
                    var result = [];

                    for (var val in com.vzome.api.Tool.Kind) {
                      if (!isNaN(val)) {
                        result.push(parseInt(val, 10));
                      }
                    }

                    return result;
                  }();

                  for (var index634 = 0; index634 < array635.length; index634++) {
                    var kind = array635[index634];
                    {
                      var list = this.symmetryPerspective.createToolFactories(kind, tools);
                      this.toolFactoryLists.put(kind, list);
                      var toolList = this.symmetryPerspective.predefineTools(kind, tools);
                      this.toolLists.put(kind, toolList);
                    }
                  }
                }
              }
            }, {
              key: "getName",
              value: function getName() {
                return this.symmetry.getName();
              }
              /**
              *
              * @param {com.vzome.core.algebra.AlgebraicVector} vector
              * @return {com.vzome.core.math.symmetry.Axis}
              */

            }, {
              key: "getAxis",
              value: function getAxis(vector) {
                if (vector.isOrigin()) {
                  return null;
                }

                var line = this.vectorToAxis.get(vector.toString());
                if (line != null) return line;

                if (!this.noKnownDirections) {
                  line = this.symmetry['getAxis$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_math_symmetry_OrbitSet'](vector, this.orbits);

                  if (line != null) {
                    this.vectorToAxis.put(vector.toString(), line);
                    return line;
                  }
                }

                var dir = this.createAnonymousOrbit(vector);
                line = dir.getAxis$com_vzome_core_algebra_AlgebraicVector(vector);
                this.vectorToAxis.put(vector.toString(), line);
                return line;
              }
            }, {
              key: "createAnonymousOrbit",
              value: function createAnonymousOrbit(vector) {
                var symm = this.orbits.getSymmetry();
                var field = symm.getField();
                var longer = field['createPower$int'](1);
                var shorter = field['createPower$int'](-1);
                var rv = vector.toRealVector();
                var longVector = vector;
                var shortVector = vector;
                var longLen = 2.0;
                var shortLen = 2.0;
                var len = rv.length();

                if (len > 2.0) {
                  longLen = len;
                  longVector = vector;

                  while (longLen > 2.0) {
                    {
                      shortVector = longVector.scale(shorter);
                      shortLen = shortVector.toRealVector().length();
                      if (shortLen <= 2.0) break;
                      longLen = shortLen;
                      longVector = shortVector;
                    }
                  }
                } else {
                  shortLen = len;
                  shortVector = vector;

                  while (shortLen <= 2.0) {
                    {
                      longVector = shortVector.scale(longer);
                      longLen = longVector.toRealVector().length();
                      if (longLen > 2.0) break;
                      shortLen = longLen;
                      shortVector = longVector;
                    }
                  }
                }

                if (2.0 / shortLen > longLen) vector = longVector;else vector = shortVector;
                var colorName = "" + SymmetrySystem.NEXT_NEW_AXIS++;
                var orbit = symm.createNewZoneOrbit(colorName, 0, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, vector);
                orbit.setAutomatic(true);
                this.orbits.add(orbit);
                this.orbitColors.put(orbit.getName(), com.vzome.core.construction.Color.WHITE_$LI$());
                return orbit;
              }
            }, {
              key: "getVectorColor",
              value: function getVectorColor(vector) {
                if (vector.isOrigin()) {
                  return com.vzome.core.construction.Color.WHITE_$LI$();
                }

                var line = this.vectorToAxis.get(vector.toString());

                if (line == null) {
                  line = this.symmetry['getAxis$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_math_symmetry_OrbitSet'](vector, this.orbits);
                }

                return line == null ? com.vzome.core.construction.Color.WHITE_$LI$() : this.getColor(line.getDirection());
              }
              /**
              *
              * @param {com.vzome.core.math.symmetry.Direction} orbit
              * @return {com.vzome.core.construction.Color}
              */

            }, {
              key: "getColor",
              value: function getColor(orbit) {
                if (orbit == null) return com.vzome.core.construction.Color.WHITE_$LI$();
                var shapeColor = this.shapes.getColor(orbit);
                if (shapeColor == null) shapeColor = this.orbitColors.get(orbit.getName());
                if (shapeColor == null) return com.vzome.core.construction.Color.WHITE_$LI$();
                return shapeColor;
              }
              /**
              *
              * @return {*}
              */

            }, {
              key: "getSymmetry",
              value: function getSymmetry() {
                return this.symmetry;
              }
              /**
              *
              * @return {com.vzome.core.math.symmetry.OrbitSet}
              */

            }, {
              key: "getOrbits",
              value: function getOrbits() {
                return this.orbits;
              }
            }, {
              key: "disableKnownDirection",
              value: function disableKnownDirection() {
                this.noKnownDirections = true;
              }
            }, {
              key: "getRenderingStyle",
              value: function getRenderingStyle() {
                return this.shapes;
              }
            }, {
              key: "getXml",
              value: function getXml(doc) {
                var result = doc.createElement("SymmetrySystem");
                com.vzome.xml.DomUtils.addAttribute(result, "name", this.getSymmetry().getName());
                com.vzome.xml.DomUtils.addAttribute(result, "renderingStyle", this.shapes.getName());

                for (var index636 = this.orbits.iterator(); index636.hasNext();) {
                  var dir = index636.next();
                  {
                    var dirElem = doc.createElement("Direction");
                    if (dir.isAutomatic()) com.vzome.xml.DomUtils.addAttribute(dirElem, "prototype", dir.getPrototype().getVectorExpression$int(com.vzome.core.algebra.AlgebraicField.ZOMIC_FORMAT));
                    com.vzome.xml.DomUtils.addAttribute(dirElem, "name", dir.getName());
                    {
                      var color = this.getColor(dir);
                      if (color != null) com.vzome.xml.DomUtils.addAttribute(dirElem, "color", color.toString());
                    }
                    result.appendChild(dirElem);
                  }
                }

                return result;
              }
            }, {
              key: "getStyle$java_lang_String",
              value: function getStyle$java_lang_String(styleName) {
                var found = this.symmetryPerspective.getGeometries().stream().filter(function (e) {
                  return (
                    /* equals */
                    function (o1, o2) {
                      if (o1 && o1.equals) {
                        return o1.equals(o2);
                      } else {
                        return o1 === o2;
                      }
                    }(styleName, e.getName()) ||
                    /* equals */
                    function (o1, o2) {
                      if (o1 && o1.equals) {
                        return o1.equals(o2);
                      } else {
                        return o1 === o2;
                      }
                    }(styleName, e.getAlias()) ||
                    /* equals */
                    function (o1, o2) {
                      if (o1 && o1.equals) {
                        return o1.equals(o2);
                      } else {
                        return o1 === o2;
                      }
                    }(styleName, e.getPackage())
                  );
                }).findFirst();
                if (found.isPresent()) return found.get();else return null;
              }
            }, {
              key: "getStyle",
              value: function getStyle(styleName) {
                if (typeof styleName === 'string' || styleName === null) {
                  return this.getStyle$java_lang_String(styleName);
                } else if (styleName === undefined) {
                  return this.getStyle$();
                } else throw new Error('invalid overload');
              }
            }, {
              key: "setStyle",
              value: function setStyle(styleName) {
                var result = this.getStyle$java_lang_String(styleName);
                if (result != null) this.shapes = result;else {
                  SymmetrySystem.logger_$LI$().warning("UNKNOWN STYLE NAME: " + styleName);
                  this.shapes = this.symmetryPerspective.getDefaultGeometry();
                }
              }
            }, {
              key: "getStyleNames",
              value: function getStyleNames() {
                return this.symmetryPerspective.getGeometries().stream().map(function (e) {
                  return e.getName();
                }).toArray(function (arg0) {
                  return new Array(arg0);
                });
              }
            }, {
              key: "getStyle$",
              value: function getStyle$() {
                return this.shapes;
              }
              /**
              *
              * @return {*}
              */

            }, {
              key: "getShapes",
              value: function getShapes() {
                return this.shapes;
              }
            }, {
              key: "getShape$com_vzome_core_algebra_AlgebraicVector",
              value: function getShape$com_vzome_core_algebra_AlgebraicVector(offset) {
                return this.getShape$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_editor_api_Shapes(offset, this.shapes);
              }
            }, {
              key: "getShape$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_editor_api_Shapes",
              value: function getShape$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_editor_api_Shapes(offset, shapes) {
                if (offset == null) return shapes.getConnectorShape();else {
                  if (offset.isOrigin()) return null;
                  var axis = this.getAxis(offset);
                  if (axis == null) return null;
                  var orbit = axis.getDirection();
                  var len = axis.getLength(offset);
                  return shapes.getStrutShape(orbit, len);
                }
              }
            }, {
              key: "getShape",
              value: function getShape(offset, shapes) {
                if ((offset != null && offset instanceof com.vzome.core.algebra.AlgebraicVector || offset === null) && (shapes != null && (shapes["__interfaces"] != null && shapes["__interfaces"].indexOf("com.vzome.core.editor.api.Shapes") >= 0 || shapes.constructor != null && shapes.constructor["__interfaces"] != null && shapes.constructor["__interfaces"].indexOf("com.vzome.core.editor.api.Shapes") >= 0) || shapes === null)) {
                  return this.getShape$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_editor_api_Shapes(offset, shapes);
                } else if ((offset != null && offset instanceof com.vzome.core.algebra.AlgebraicVector || offset === null) && shapes === undefined) {
                  return this.getShape$com_vzome_core_algebra_AlgebraicVector(offset);
                } else throw new Error('invalid overload');
              }
            }, {
              key: "getToolFactories",
              value: function getToolFactories(kind) {
                return this.toolFactoryLists.get(kind);
              }
            }, {
              key: "getPredefinedTools",
              value: function getPredefinedTools(kind) {
                return this.toolLists.get(kind);
              }
            }, {
              key: "doAction",
              value: function doAction(action) {
                var command = this.symmetryPerspective.getLegacyCommand(action);

                if (command != null) {
                  var edit = new com.vzome.core.editor.CommandEdit(command, this.editor);
                  this.context.performAndRecord(edit);
                  return true;
                }

                return false;
              }
            }, {
              key: "getModelResourcePath",
              value: function getModelResourcePath() {
                return this.symmetryPerspective.getModelResourcePath();
              }
            }, {
              key: "orbitIsStandard",
              value: function orbitIsStandard(orbit) {
                return this.symmetryPerspective.orbitIsStandard(orbit);
              }
            }, {
              key: "orbitIsBuildDefault",
              value: function orbitIsBuildDefault(orbit) {
                return this.symmetryPerspective.orbitIsBuildDefault(orbit);
              }
            }, {
              key: "getOrbitUnitLength",
              value: function getOrbitUnitLength(orbit) {
                return this.symmetryPerspective.getOrbitUnitLength(orbit);
              }
            }], [{
              key: "logger_$LI$",
              value: function logger_$LI$() {
                if (SymmetrySystem.logger == null) SymmetrySystem.logger = java.util.logging.Logger.getLogger("com.vzome.core.editor");
                return SymmetrySystem.logger;
              }
            }]);

            return SymmetrySystem;
          }();

          SymmetrySystem.NEXT_NEW_AXIS = 0;
          editor_2.SymmetrySystem = SymmetrySystem;
          SymmetrySystem["__class"] = "com.vzome.core.editor.SymmetrySystem";
          SymmetrySystem["__interfaces"] = ["com.vzome.core.editor.api.OrbitSource"];
        })(core.editor || (core.editor = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (algebra) {
          var Vector3dHomogeneous =
          /*#__PURE__*/
          function () {
            function Vector3dHomogeneous(e1, e2, e3, e0, field) {
              var _this22 = this;

              _classCallCheck(this, Vector3dHomogeneous);

              if ((e1 != null && (e1["__interfaces"] != null && e1["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0 || e1.constructor != null && e1.constructor["__interfaces"] != null && e1.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0) || e1 === null) && (e2 != null && (e2["__interfaces"] != null && e2["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0 || e2.constructor != null && e2.constructor["__interfaces"] != null && e2.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0) || e2 === null) && (e3 != null && (e3["__interfaces"] != null && e3["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0 || e3.constructor != null && e3.constructor["__interfaces"] != null && e3.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0) || e3 === null) && (e0 != null && (e0["__interfaces"] != null && e0["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0 || e0.constructor != null && e0.constructor["__interfaces"] != null && e0.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0) || e0 === null) && (field != null && (field["__interfaces"] != null && field["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicField") >= 0 || field.constructor != null && field.constructor["__interfaces"] != null && field.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicField") >= 0) || field === null)) {
                if (this.e1 === undefined) this.e1 = null;
                if (this.e2 === undefined) this.e2 = null;
                if (this.e3 === undefined) this.e3 = null;
                if (this.e0 === undefined) this.e0 = null;
                if (this.field === undefined) this.field = null;
                if (this.e1 === undefined) this.e1 = null;
                if (this.e2 === undefined) this.e2 = null;
                if (this.e3 === undefined) this.e3 = null;
                if (this.e0 === undefined) this.e0 = null;
                if (this.field === undefined) this.field = null;

                (function () {
                  _this22.e1 = e1;
                  _this22.e2 = e2;
                  _this22.e3 = e3;
                  _this22.e0 = e0;
                  _this22.field = field;
                })();
              } else if ((e1 != null && (e1["__interfaces"] != null && e1["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0 || e1.constructor != null && e1.constructor["__interfaces"] != null && e1.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0) || e1 === null) && (e2 != null && (e2["__interfaces"] != null && e2["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0 || e2.constructor != null && e2.constructor["__interfaces"] != null && e2.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0) || e2 === null) && (e3 != null && (e3["__interfaces"] != null && e3["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0 || e3.constructor != null && e3.constructor["__interfaces"] != null && e3.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0) || e3 === null) && (e0 != null && (e0["__interfaces"] != null && e0["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicField") >= 0 || e0.constructor != null && e0.constructor["__interfaces"] != null && e0.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicField") >= 0) || e0 === null) && field === undefined) {
                var _args17 = arguments;
                var _field2 = _args17[3];
                {
                  var _args18 = arguments;
                  var _e2 = _args18[0];
                  var _e3 = _args18[0];

                  var _e4 = _args18[4]['createPower$int'](0);

                  if (this.e1 === undefined) this.e1 = null;
                  if (this.e2 === undefined) this.e2 = null;
                  if (this.e3 === undefined) this.e3 = null;
                  if (this.e0 === undefined) this.e0 = null;
                  if (this.field === undefined) this.field = null;
                  if (this.e1 === undefined) this.e1 = null;
                  if (this.e2 === undefined) this.e2 = null;
                  if (this.e3 === undefined) this.e3 = null;
                  if (this.e0 === undefined) this.e0 = null;
                  if (this.field === undefined) this.field = null;

                  (function () {
                    _this22.e1 = e1;
                    _this22.e2 = _e2;
                    _this22.e3 = _e3;
                    _this22.e0 = _e4;
                    _this22.field = _field2;
                  })();
                }
              } else if ((e1 != null && e1 instanceof com.vzome.core.algebra.AlgebraicVector || e1 === null) && (e2 != null && (e2["__interfaces"] != null && e2["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicField") >= 0 || e2.constructor != null && e2.constructor["__interfaces"] != null && e2.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicField") >= 0) || e2 === null) && e3 === undefined && e0 === undefined && field === undefined) {
                var _args19 = arguments;
                var v = _args19[0];
                var _field3 = _args19[1];
                {
                  var _e5 = v.getComponent(0);

                  v.getComponent(1);
                  v.getComponent(2);
                  {
                    var _args21 = arguments;
                    var _e8 = _args21[0];
                    var _e9 = _args21[0];

                    var _e10 = _args21[4]['createPower$int'](0);

                    if (this.e1 === undefined) this.e1 = null;
                    if (this.e2 === undefined) this.e2 = null;
                    if (this.e3 === undefined) this.e3 = null;
                    if (this.e0 === undefined) this.e0 = null;
                    if (this.field === undefined) this.field = null;
                    if (this.e1 === undefined) this.e1 = null;
                    if (this.e2 === undefined) this.e2 = null;
                    if (this.e3 === undefined) this.e3 = null;
                    if (this.e0 === undefined) this.e0 = null;
                    if (this.field === undefined) this.field = null;

                    (function () {
                      _this22.e1 = _e5;
                      _this22.e2 = _e8;
                      _this22.e3 = _e9;
                      _this22.e0 = _e10;
                      _this22.field = _field3;
                    })();
                  }
                }
              } else throw new Error('invalid overload');
            }

            _createClass(Vector3dHomogeneous, [{
              key: "outer",
              value: function outer(that) {
                var e12 = this.e1['times$com_vzome_core_algebra_AlgebraicNumber'](that.e2)['minus$com_vzome_core_algebra_AlgebraicNumber'](this.e2['times$com_vzome_core_algebra_AlgebraicNumber'](that.e1));
                var e23 = this.e2['times$com_vzome_core_algebra_AlgebraicNumber'](that.e3)['minus$com_vzome_core_algebra_AlgebraicNumber'](this.e3['times$com_vzome_core_algebra_AlgebraicNumber'](that.e2));
                var e31 = this.e3['times$com_vzome_core_algebra_AlgebraicNumber'](that.e1)['minus$com_vzome_core_algebra_AlgebraicNumber'](this.e1['times$com_vzome_core_algebra_AlgebraicNumber'](that.e3));
                var e10 = this.e1['times$com_vzome_core_algebra_AlgebraicNumber'](that.e0)['minus$com_vzome_core_algebra_AlgebraicNumber'](this.e0['times$com_vzome_core_algebra_AlgebraicNumber'](that.e1));
                var e20 = this.e2['times$com_vzome_core_algebra_AlgebraicNumber'](that.e0)['minus$com_vzome_core_algebra_AlgebraicNumber'](this.e0['times$com_vzome_core_algebra_AlgebraicNumber'](that.e2));
                var e30 = this.e3['times$com_vzome_core_algebra_AlgebraicNumber'](that.e0)['minus$com_vzome_core_algebra_AlgebraicNumber'](this.e0['times$com_vzome_core_algebra_AlgebraicNumber'](that.e3));
                return new com.vzome.core.algebra.Bivector3dHomogeneous(e12, e23, e31, e10, e20, e30, this.field);
              }
            }, {
              key: "getVector",
              value: function getVector() {
                return new com.vzome.core.algebra.AlgebraicVector(this.e1['dividedBy$com_vzome_core_algebra_AlgebraicNumber'](this.e0), this.e2['dividedBy$com_vzome_core_algebra_AlgebraicNumber'](this.e0), this.e3['dividedBy$com_vzome_core_algebra_AlgebraicNumber'](this.e0));
              }
            }, {
              key: "dot",
              value: function dot(v) {
                var e1 = this.e3['times$com_vzome_core_algebra_AlgebraicNumber'](v.e31)['minus$com_vzome_core_algebra_AlgebraicNumber'](this.e2['times$com_vzome_core_algebra_AlgebraicNumber'](v.e12))['minus$com_vzome_core_algebra_AlgebraicNumber'](this.e0['times$com_vzome_core_algebra_AlgebraicNumber'](v.e10));
                var e2 = this.e1['times$com_vzome_core_algebra_AlgebraicNumber'](v.e12)['minus$com_vzome_core_algebra_AlgebraicNumber'](this.e3['times$com_vzome_core_algebra_AlgebraicNumber'](v.e23))['minus$com_vzome_core_algebra_AlgebraicNumber'](this.e0['times$com_vzome_core_algebra_AlgebraicNumber'](v.e20));
                var e3 = this.e2['times$com_vzome_core_algebra_AlgebraicNumber'](v.e23)['minus$com_vzome_core_algebra_AlgebraicNumber'](this.e1['times$com_vzome_core_algebra_AlgebraicNumber'](v.e31))['minus$com_vzome_core_algebra_AlgebraicNumber'](this.e0['times$com_vzome_core_algebra_AlgebraicNumber'](v.e30));
                var e0 = this.e1['times$com_vzome_core_algebra_AlgebraicNumber'](v.e10)['plus$com_vzome_core_algebra_AlgebraicNumber'](this.e2['times$com_vzome_core_algebra_AlgebraicNumber'](v.e20))['plus$com_vzome_core_algebra_AlgebraicNumber'](this.e3['times$com_vzome_core_algebra_AlgebraicNumber'](v.e30));
                return new Vector3dHomogeneous(e1, e2, e3, e0, this.field);
              }
            }, {
              key: "exists",
              value: function exists() {
                return !this.e0.isZero();
              }
            }]);

            return Vector3dHomogeneous;
          }();

          algebra.Vector3dHomogeneous = Vector3dHomogeneous;
          Vector3dHomogeneous["__class"] = "com.vzome.core.algebra.Vector3dHomogeneous";
        })(core.algebra || (core.algebra = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (algebra) {
          var Bivector3dHomogeneous =
          /*#__PURE__*/
          function () {
            function Bivector3dHomogeneous(e12, e23, e31, e10, e20, e30, field) {
              _classCallCheck(this, Bivector3dHomogeneous);

              if (this.e12 === undefined) this.e12 = null;
              if (this.e23 === undefined) this.e23 = null;
              if (this.e31 === undefined) this.e31 = null;
              if (this.e10 === undefined) this.e10 = null;
              if (this.e20 === undefined) this.e20 = null;
              if (this.e30 === undefined) this.e30 = null;
              if (this.field === undefined) this.field = null;
              this.e12 = e12;
              this.e23 = e23;
              this.e31 = e31;
              this.e10 = e10;
              this.e20 = e20;
              this.e30 = e30;
              this.field = field;
            }

            _createClass(Bivector3dHomogeneous, [{
              key: "outer",
              value: function outer(that) {
                var e123 = this.e12['times$com_vzome_core_algebra_AlgebraicNumber'](that.e3)['plus$com_vzome_core_algebra_AlgebraicNumber'](this.e23['times$com_vzome_core_algebra_AlgebraicNumber'](that.e1))['plus$com_vzome_core_algebra_AlgebraicNumber'](this.e31['times$com_vzome_core_algebra_AlgebraicNumber'](that.e2));
                var e310 = this.e10['times$com_vzome_core_algebra_AlgebraicNumber'](that.e3)['plus$com_vzome_core_algebra_AlgebraicNumber'](this.e31['times$com_vzome_core_algebra_AlgebraicNumber'](that.e0))['minus$com_vzome_core_algebra_AlgebraicNumber'](this.e30['times$com_vzome_core_algebra_AlgebraicNumber'](that.e1));
                var e320 = this.e20['times$com_vzome_core_algebra_AlgebraicNumber'](that.e3)['minus$com_vzome_core_algebra_AlgebraicNumber'](this.e30['times$com_vzome_core_algebra_AlgebraicNumber'](that.e2))['minus$com_vzome_core_algebra_AlgebraicNumber'](this.e23['times$com_vzome_core_algebra_AlgebraicNumber'](that.e0));
                var e120 = this.e12['times$com_vzome_core_algebra_AlgebraicNumber'](that.e0)['plus$com_vzome_core_algebra_AlgebraicNumber'](this.e20['times$com_vzome_core_algebra_AlgebraicNumber'](that.e1))['minus$com_vzome_core_algebra_AlgebraicNumber'](this.e10['times$com_vzome_core_algebra_AlgebraicNumber'](that.e2));
                return new com.vzome.core.algebra.Trivector3dHomogeneous(e123, e310, e320, e120, this.field);
              }
            }]);

            return Bivector3dHomogeneous;
          }();

          algebra.Bivector3dHomogeneous = Bivector3dHomogeneous;
          Bivector3dHomogeneous["__class"] = "com.vzome.core.algebra.Bivector3dHomogeneous";
        })(core.algebra || (core.algebra = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (algebra) {
          var AlgebraicMatrix =
          /*#__PURE__*/
          function () {
            function AlgebraicMatrix(x, y, z, w) {
              var _this23 = this;

              _classCallCheck(this, AlgebraicMatrix);

              if ((x != null && x instanceof com.vzome.core.algebra.AlgebraicVector || x === null) && (y != null && y instanceof com.vzome.core.algebra.AlgebraicVector || y === null) && (z != null && z instanceof com.vzome.core.algebra.AlgebraicVector || z === null) && (w != null && w instanceof com.vzome.core.algebra.AlgebraicVector || w === null)) {
                {
                  var columns = [x, y, z, w];
                  if (this.matrix === undefined) this.matrix = null;
                  if (this.matrix === undefined) this.matrix = null;

                  (function () {
                    var rows = columns[0].dimension();
                    var cols = columns.length;

                    _this23.matrix = function (dims) {
                      var allocate = function allocate(dims) {
                        if (dims.length == 0) {
                          return null;
                        } else {
                          var array = [];

                          for (var i = 0; i < dims[0]; i++) {
                            array.push(allocate(dims.slice(1)));
                          }

                          return array;
                        }
                      };

                      return allocate(dims);
                    }([rows, cols]);

                    for (var i = 0; i < rows; i++) {
                      {
                        for (var j = 0; j < cols; j++) {
                          {
                            _this23.matrix[i][j] = columns[j].getComponent(i);
                          }
                        }
                      }
                    }
                  })();
                }
              } else if ((x != null && x instanceof com.vzome.core.algebra.AlgebraicVector || x === null) && (y != null && y instanceof com.vzome.core.algebra.AlgebraicVector || y === null) && (z != null && z instanceof com.vzome.core.algebra.AlgebraicVector || z === null) && w === undefined) {
                {
                  var _columns = [x, y, z];
                  if (this.matrix === undefined) this.matrix = null;
                  if (this.matrix === undefined) this.matrix = null;

                  (function () {
                    var rows = _columns[0].dimension();

                    var cols = _columns.length;

                    _this23.matrix = function (dims) {
                      var allocate = function allocate(dims) {
                        if (dims.length == 0) {
                          return null;
                        } else {
                          var array = [];

                          for (var i = 0; i < dims[0]; i++) {
                            array.push(allocate(dims.slice(1)));
                          }

                          return array;
                        }
                      };

                      return allocate(dims);
                    }([rows, cols]);

                    for (var i = 0; i < rows; i++) {
                      {
                        for (var j = 0; j < cols; j++) {
                          {
                            _this23.matrix[i][j] = _columns[j].getComponent(i);
                          }
                        }
                      }
                    }
                  })();
                }
              } else if ((x != null && (x["__interfaces"] != null && x["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicField") >= 0 || x.constructor != null && x.constructor["__interfaces"] != null && x.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicField") >= 0) || x === null) && (typeof y === 'number' || y === null) && (typeof z === 'number' || z === null) && w === undefined) {
                var _args25 = arguments;
                var field = _args25[0];
                var rows = _args25[1];
                var cols = _args25[2];
                if (this.matrix === undefined) this.matrix = null;
                if (this.matrix === undefined) this.matrix = null;

                (function () {
                  _this23.matrix = function (dims) {
                    var allocate = function allocate(dims) {
                      if (dims.length == 0) {
                        return null;
                      } else {
                        var array = [];

                        for (var i = 0; i < dims[0]; i++) {
                          array.push(allocate(dims.slice(1)));
                        }

                        return array;
                      }
                    };

                    return allocate(dims);
                  }([rows, cols]);

                  for (var i = 0; i < rows; i++) {
                    {
                      for (var j = 0; j < cols; j++) {
                        {
                          _this23.matrix[i][j] = field.zero();
                        }
                      }
                    }
                  }
                })();
              } else if ((x != null && x instanceof com.vzome.core.algebra.AlgebraicVector || x === null) && (y != null && y instanceof com.vzome.core.algebra.AlgebraicVector || y === null) && z === undefined && w === undefined) {
                {
                  var _columns2 = [x, y];
                  if (this.matrix === undefined) this.matrix = null;
                  if (this.matrix === undefined) this.matrix = null;

                  (function () {
                    var rows = _columns2[0].dimension();

                    var cols = _columns2.length;

                    _this23.matrix = function (dims) {
                      var allocate = function allocate(dims) {
                        if (dims.length == 0) {
                          return null;
                        } else {
                          var array = [];

                          for (var i = 0; i < dims[0]; i++) {
                            array.push(allocate(dims.slice(1)));
                          }

                          return array;
                        }
                      };

                      return allocate(dims);
                    }([rows, cols]);

                    for (var i = 0; i < rows; i++) {
                      {
                        for (var j = 0; j < cols; j++) {
                          {
                            _this23.matrix[i][j] = _columns2[j].getComponent(i);
                          }
                        }
                      }
                    }
                  })();
                }
              } else if ((x != null && (x["__interfaces"] != null && x["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicField") >= 0 || x.constructor != null && x.constructor["__interfaces"] != null && x.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicField") >= 0) || x === null) && (typeof y === 'number' || y === null) && z === undefined && w === undefined) {
                var _args28 = arguments;
                var _field4 = _args28[0];
                var dim = _args28[1];
                if (this.matrix === undefined) this.matrix = null;
                if (this.matrix === undefined) this.matrix = null;

                (function () {
                  _this23.matrix = function (dims) {
                    var allocate = function allocate(dims) {
                      if (dims.length == 0) {
                        return null;
                      } else {
                        var array = [];

                        for (var i = 0; i < dims[0]; i++) {
                          array.push(allocate(dims.slice(1)));
                        }

                        return array;
                      }
                    };

                    return allocate(dims);
                  }([dim, dim]);

                  for (var i = 0; i < dim; i++) {
                    {
                      for (var j = 0; j < dim; j++) {
                        {
                          if (i === j) _this23.matrix[i][j] = _field4.one();else _this23.matrix[i][j] = _field4.zero();
                        }
                      }
                    }
                  }
                })();
              } else if ((x != null && x instanceof Array && (x.length == 0 || x[0] == null || x[0] != null && x[0] instanceof com.vzome.core.algebra.AlgebraicVector) || x === null) && y === undefined && z === undefined && w === undefined) {
                var _args29 = arguments;
                var _columns3 = _args29[0];
                if (this.matrix === undefined) this.matrix = null;
                if (this.matrix === undefined) this.matrix = null;

                (function () {
                  var rows = _columns3[0].dimension();

                  var cols = _columns3.length;

                  _this23.matrix = function (dims) {
                    var allocate = function allocate(dims) {
                      if (dims.length == 0) {
                        return null;
                      } else {
                        var array = [];

                        for (var i = 0; i < dims[0]; i++) {
                          array.push(allocate(dims.slice(1)));
                        }

                        return array;
                      }
                    };

                    return allocate(dims);
                  }([rows, cols]);

                  for (var i = 0; i < rows; i++) {
                    {
                      for (var j = 0; j < cols; j++) {
                        {
                          _this23.matrix[i][j] = _columns3[j].getComponent(i);
                        }
                      }
                    }
                  }
                })();
              } else throw new Error('invalid overload');
            }
            /**
            *
            * @return {number}
            */


            _createClass(AlgebraicMatrix, [{
              key: "hashCode",
              value: function hashCode() {
                var prime = 31;
                var result = 1;

                for (var index637 = 0; index637 < this.matrix.length; index637++) {
                  var m = this.matrix[index637];
                  {
                    result = prime * result + java.util.Arrays.hashCode(m);
                  }
                }

                return result;
              }
              /**
              *
              * @param {*} obj
              * @return {boolean}
              */

            }, {
              key: "equals",
              value: function equals(obj) {
                if (this === obj) return true;
                if (obj == null) return false;
                if (this.constructor !== obj.constructor) return false;
                var other = obj;
                return java.util.Arrays.deepEquals(this.matrix, other.matrix);
              }
            }, {
              key: "getMatrix",
              value: function getMatrix() {
                return this.matrix;
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "toString",
              value: function toString() {
                var buf = new java.lang.StringBuilder();

                for (var index638 = 0; index638 < this.matrix.length; index638++) {
                  var m = this.matrix[index638];
                  {
                    buf.append(java.util.Arrays.toString(m));
                    buf.append(", ");
                  }
                }

                return "[ " + buf.toString() + " ]";
              }
            }, {
              key: "negate",
              value: function negate() {
                var field = this.matrix[0][0].getField();
                var result = new AlgebraicMatrix(field, this.matrix.length);

                for (var i = 0; i < this.matrix.length; i++) {
                  {
                    for (var j = 0; j < this.matrix[i].length; j++) {
                      {
                        result.matrix[i][j] = this.matrix[i][j].negate();
                      }
                    }
                  }
                }

                return result;
              }
            }, {
              key: "inverse",
              value: function inverse() {
                if (!this.isSquare()) {
                  throw new java.lang.IllegalArgumentException("matrix is not square");
                }

                var field = this.matrix[0][0].getField();
                var result = new AlgebraicMatrix(field, this.matrix.length);
                var rank = com.vzome.core.algebra.Fields.gaussJordanReduction$com_vzome_core_algebra_Fields_Element_A_A$com_vzome_core_algebra_Fields_Element_A_A(this.matrix, result.matrix);

                if (rank !== this.matrix.length) {
                  var message = "AlgebraicMatrix inverse expects matrix rank to be " + this.matrix.length + ", but it is " + rank + ".";
                  console.error(message);
                }

                return result;
              }
            }, {
              key: "transpose",
              value: function transpose() {
                var field = this.matrix[0][0].getField();
                var result = new AlgebraicMatrix(field, this.matrix[0].length, this.matrix.length);

                for (var i = 0; i < result.matrix.length; i++) {
                  {
                    for (var j = 0; j < this.matrix.length; j++) {
                      {
                        result.matrix[i][j] = this.matrix[j][i];
                      }
                    }
                  }
                }

                return result;
              }
            }, {
              key: "times",
              value: function times(that) {
                var field = this.matrix[0][0].getField();
                var result = new AlgebraicMatrix(field, this.matrix.length, that.matrix[0].length);
                com.vzome.core.algebra.Fields.matrixMultiplication(this.matrix, that.matrix, result.matrix);
                return result;
              }
            }, {
              key: "timesRow",
              value: function timesRow(rowVector) {
                var colLength = rowVector.dimension();
                if (this.matrix.length !== colLength) throw new java.lang.IllegalArgumentException("vector length incorrect for this matrix: " + rowVector);
                var rowLength = this.matrix[0].length;

                var resultComponents = function (s) {
                  var a = [];

                  while (s-- > 0) {
                    a.push(null);
                  }

                  return a;
                }(rowLength);

                var field = this.matrix[0][0].getField();

                for (var j = 0; j < rowLength; j++) {
                  {
                    resultComponents[j] = field.zero();

                    for (var i = 0; i < colLength; i++) {
                      {
                        var product = rowVector.getComponent(i)['times$com_vzome_core_algebra_AlgebraicNumber'](this.matrix[i][j]);
                        resultComponents[j] = resultComponents[j]['plus$com_vzome_core_algebra_AlgebraicNumber'](product);
                      }
                    }
                  }
                }

                return new com.vzome.core.algebra.AlgebraicVector(resultComponents);
              }
            }, {
              key: "timesColumn",
              value: function timesColumn(columnVector) {
                var rowLength = columnVector.dimension();
                if (this.matrix[0].length !== rowLength) throw new java.lang.IllegalArgumentException("vector length incorrect for this matrix: " + columnVector);
                var colLength = this.matrix.length;

                var resultComponents = function (s) {
                  var a = [];

                  while (s-- > 0) {
                    a.push(null);
                  }

                  return a;
                }(colLength);

                var field = this.matrix[0][0].getField();

                for (var i = 0; i < colLength; i++) {
                  {
                    resultComponents[i] = field.zero();

                    for (var j = 0; j < rowLength; j++) {
                      {
                        var product = columnVector.getComponent(j)['times$com_vzome_core_algebra_AlgebraicNumber'](this.matrix[i][j]);
                        resultComponents[i] = resultComponents[i]['plus$com_vzome_core_algebra_AlgebraicNumber'](product);
                      }
                    }
                  }
                }

                return new com.vzome.core.algebra.AlgebraicVector(resultComponents);
              }
            }, {
              key: "timesScalar",
              value: function timesScalar(scalar) {
                var result = new AlgebraicMatrix(scalar.getField(), this.matrix.length);

                for (var i = 0; i < this.matrix.length; i++) {
                  {
                    for (var j = 0; j < this.matrix[i].length; j++) {
                      {
                        result.matrix[i][j] = this.matrix[i][j]['times$com_vzome_core_algebra_AlgebraicNumber'](scalar);
                      }
                    }
                  }
                }

                return result;
              }
            }, {
              key: "isSquare",
              value: function isSquare() {
                return this.matrix.length === this.matrix[0].length;
              }
            }, {
              key: "trace",
              value: function trace() {
                if (!this.isSquare()) {
                  throw new java.lang.IllegalArgumentException("matrix is not square");
                }

                var trace = this.matrix[0][0].getField().zero();

                for (var i = 0; i < this.matrix.length; i++) {
                  {
                    trace = trace['plus$com_vzome_core_algebra_AlgebraicNumber'](this.matrix[i][i]);
                  }
                }

                return trace;
              }
            }, {
              key: "determinant",
              value: function determinant() {
                return AlgebraicMatrix.laplaceDeterminant(this.matrix);
              }
            }, {
              key: "setElement",
              value: function setElement(i, j, value) {
                this.matrix[i][j] = value;
                return this;
              }
            }, {
              key: "getElement",
              value: function getElement(i, j) {
                return this.matrix[i][j];
              }
            }], [{
              key: "laplaceDeterminant",
              value: function laplaceDeterminant(matrix) {
                if (matrix.length !== matrix[0].length) {
                  throw new java.lang.IllegalArgumentException("matrix is not square");
                }

                var determinant = null;

                switch (matrix.length) {
                  case 3:
                    determinant = matrix[0][0]['times$com_vzome_core_algebra_AlgebraicNumber'](matrix[1][1])['times$com_vzome_core_algebra_AlgebraicNumber'](matrix[2][2])['plus$com_vzome_core_algebra_AlgebraicNumber'](matrix[0][1]['times$com_vzome_core_algebra_AlgebraicNumber'](matrix[1][2])['times$com_vzome_core_algebra_AlgebraicNumber'](matrix[2][0]))['plus$com_vzome_core_algebra_AlgebraicNumber'](matrix[0][2]['times$com_vzome_core_algebra_AlgebraicNumber'](matrix[1][0])['times$com_vzome_core_algebra_AlgebraicNumber'](matrix[2][1]))['minus$com_vzome_core_algebra_AlgebraicNumber'](matrix[0][2]['times$com_vzome_core_algebra_AlgebraicNumber'](matrix[1][1])['times$com_vzome_core_algebra_AlgebraicNumber'](matrix[2][0]))['minus$com_vzome_core_algebra_AlgebraicNumber'](matrix[0][0]['times$com_vzome_core_algebra_AlgebraicNumber'](matrix[1][2])['times$com_vzome_core_algebra_AlgebraicNumber'](matrix[2][1]))['minus$com_vzome_core_algebra_AlgebraicNumber'](matrix[0][1]['times$com_vzome_core_algebra_AlgebraicNumber'](matrix[1][0])['times$com_vzome_core_algebra_AlgebraicNumber'](matrix[2][2]));
                    break;

                  case 2:
                    determinant = matrix[0][0]['times$com_vzome_core_algebra_AlgebraicNumber'](matrix[1][1])['minus$com_vzome_core_algebra_AlgebraicNumber'](matrix[0][1]['times$com_vzome_core_algebra_AlgebraicNumber'](matrix[1][0]));
                    break;

                  case 1:
                    determinant = matrix[0][0];
                    break;

                  default:
                    determinant = matrix[0][0].getField().zero();
                    var auxLength = matrix.length - 1;
                    var sign = matrix[0][0].getField().one();

                    for (var i = 0; i < matrix.length; i++) {
                      {
                        if (!matrix[0][i].isZero()) {
                          var aux = function (dims) {
                            var allocate = function allocate(dims) {
                              if (dims.length == 0) {
                                return null;
                              } else {
                                var array = [];

                                for (var _i28 = 0; _i28 < dims[0]; _i28++) {
                                  array.push(allocate(dims.slice(1)));
                                }

                                return array;
                              }
                            };

                            return allocate(dims);
                          }([auxLength, auxLength]);

                          var iAux = 0;
                          var jAux = 0;

                          for (var row = 1; row < matrix.length; row++) {
                            {
                              for (var col = 0; col < matrix.length; col++) {
                                {
                                  if (col !== i) {
                                    aux[iAux][jAux] = matrix[row][col];
                                    jAux++;
                                  }
                                }
                              }

                              iAux++;
                              jAux = 0;
                            }
                          }

                          determinant = determinant['plus$com_vzome_core_algebra_AlgebraicNumber'](sign['times$com_vzome_core_algebra_AlgebraicNumber'](matrix[0][i])['times$com_vzome_core_algebra_AlgebraicNumber'](AlgebraicMatrix.laplaceDeterminant(aux)));
                        }

                        sign = sign.negate();
                      }
                    }

                }

                return determinant;
              }
            }]);

            return AlgebraicMatrix;
          }();

          algebra.AlgebraicMatrix = AlgebraicMatrix;
          AlgebraicMatrix["__class"] = "com.vzome.core.algebra.AlgebraicMatrix";
        })(core.algebra || (core.algebra = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (algebra) {
          /**
          * A collection of static helper methods for the AlgebraicVector class
          * @class
          */
          var AlgebraicVectors =
          /*#__PURE__*/
          function () {
            function AlgebraicVectors() {
              _classCallCheck(this, AlgebraicVectors);
            }

            _createClass(AlgebraicVectors, null, [{
              key: "getNormal$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector",
              value: function getNormal$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector(v1, v2) {
                return v1.cross(v2);
              }
            }, {
              key: "getNormal$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector",
              value: function getNormal$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector(v0, v1, v2) {
                return AlgebraicVectors.getNormal$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector(v1.minus(v0), v2.minus(v0));
              }
              /**
              *
              * @param {com.vzome.core.algebra.AlgebraicVector} v0
              * @param {com.vzome.core.algebra.AlgebraicVector} v1
              * @param {com.vzome.core.algebra.AlgebraicVector} v2
              * @return {com.vzome.core.algebra.AlgebraicVector} normal to vectors v1 and v2,
              * with both v1 and v2 positioned at v0
              * using the righthand rule.
              */

            }, {
              key: "getNormal",
              value: function getNormal(v0, v1, v2) {
                if ((v0 != null && v0 instanceof com.vzome.core.algebra.AlgebraicVector || v0 === null) && (v1 != null && v1 instanceof com.vzome.core.algebra.AlgebraicVector || v1 === null) && (v2 != null && v2 instanceof com.vzome.core.algebra.AlgebraicVector || v2 === null)) {
                  return com.vzome.core.algebra.AlgebraicVectors.getNormal$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector(v0, v1, v2);
                } else if ((v0 != null && v0 instanceof com.vzome.core.algebra.AlgebraicVector || v0 === null) && (v1 != null && v1 instanceof com.vzome.core.algebra.AlgebraicVector || v1 === null) && v2 === undefined) {
                  return com.vzome.core.algebra.AlgebraicVectors.getNormal$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector(v0, v1);
                } else if ((v0 != null && (v0["__interfaces"] != null && v0["__interfaces"].indexOf("java.util.Collection") >= 0 || v0.constructor != null && v0.constructor["__interfaces"] != null && v0.constructor["__interfaces"].indexOf("java.util.Collection") >= 0) || v0 === null) && v1 === undefined && v2 === undefined) {
                  return com.vzome.core.algebra.AlgebraicVectors.getNormal$java_util_Collection(v0);
                } else throw new Error('invalid overload');
              }
              /**
              *
              * @param {com.vzome.core.algebra.AlgebraicVector} v1
              * @param {com.vzome.core.algebra.AlgebraicVector} v2
              * @return {boolean} true if vectors v1 and v2 are parallel, otherwise false.
              * Considered as position vectors, this is the same as testing if they are collinear with the origin.
              */

            }, {
              key: "areParallel",
              value: function areParallel(v1, v2) {
                return AlgebraicVectors.getNormal$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector(v1, v2).isOrigin();
              }
            }, {
              key: "getNormal$java_util_Collection",
              value: function getNormal$java_util_Collection(vectors) {
                if (vectors.size() < 3) {
                  throw new java.lang.IllegalArgumentException("Three vertices are required to calculate a normal. Found " + vectors.size());
                }

                var v0 = null;
                var v1 = null;
                var normal = null;

                for (var index639 = vectors.iterator(); index639.hasNext();) {
                  var vector = index639.next();
                  {
                    if (v0 == null) {
                      v0 = vector;
                    } else if (v1 == null) {
                      if (vector !== v0) {
                        v1 = vector;
                      }
                    } else {
                      normal = AlgebraicVectors.getNormal$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector(v0, v1, vector);

                      if (!normal.isOrigin()) {
                        return normal;
                      }
                    }
                  }
                }

                return normal;
              }
              /**
              *
              * @param {com.vzome.core.algebra.AlgebraicVector} vector
              * @return {number} index of the vector component having the greatest absolute value.
              * If more than one component has the same absolute value,
              * the greatest index will be returned.
              */

            }, {
              key: "getMaxComponentIndex",
              value: function getMaxComponentIndex(vector) {
                var maxIndex = 0;
                var maxSq = vector.getField().zero();

                for (var i = 0; i < vector.dimension(); i++) {
                  {
                    var n = vector.getComponent(i);
                    var sq = n['times$com_vzome_core_algebra_AlgebraicNumber'](n);

                    if (!sq.lessThan(maxSq)) {
                      maxIndex = i;
                      maxSq = sq;
                    }
                  }
                }

                return maxIndex;
              }
            }, {
              key: "areCoplanar",
              value: function areCoplanar(vectors) {
                if (vectors.size() < 4) {
                  return true;
                }

                var normal = AlgebraicVectors.getNormal$java_util_Collection(vectors);

                if (normal.isOrigin() || normal.dimension() < 3) {
                  return true;
                }

                return AlgebraicVectors.areOrthogonalTo(normal, vectors);
              }
            }, {
              key: "areOrthogonalTo",
              value: function areOrthogonalTo(normal, vectors) {
                if (normal.isOrigin()) {
                  throw new java.lang.IllegalArgumentException("Normal vector cannot be the origin");
                }

                var v0 = null;

                for (var index640 = vectors.iterator(); index640.hasNext();) {
                  var vector = index640.next();
                  {
                    if (v0 == null) {
                      v0 = vector;
                    } else if (!vector.minus(v0).dot(normal).isZero()) {
                      return false;
                    }
                  }
                }

                return true;
              }
            }, {
              key: "areCollinear$java_util_Collection",
              value: function areCollinear$java_util_Collection(vectors) {
                return vectors.size() < 3 ? true : AlgebraicVectors.getNormal$java_util_Collection(vectors).isOrigin();
              }
            }, {
              key: "areCollinear$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector",
              value: function areCollinear$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector(v0, v1, v2) {
                return AlgebraicVectors.getNormal$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector(v0, v1, v2).isOrigin();
              }
              /**
              *
              * @param {com.vzome.core.algebra.AlgebraicVector} v0
              * @param {com.vzome.core.algebra.AlgebraicVector} v1
              * @param {com.vzome.core.algebra.AlgebraicVector} v2
              * @return {boolean} true if position vectors v0, v1 and v2 are collinear, otherwise false.
              */

            }, {
              key: "areCollinear",
              value: function areCollinear(v0, v1, v2) {
                if ((v0 != null && v0 instanceof com.vzome.core.algebra.AlgebraicVector || v0 === null) && (v1 != null && v1 instanceof com.vzome.core.algebra.AlgebraicVector || v1 === null) && (v2 != null && v2 instanceof com.vzome.core.algebra.AlgebraicVector || v2 === null)) {
                  return com.vzome.core.algebra.AlgebraicVectors.areCollinear$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector(v0, v1, v2);
                } else if ((v0 != null && (v0["__interfaces"] != null && v0["__interfaces"].indexOf("java.util.Collection") >= 0 || v0.constructor != null && v0.constructor["__interfaces"] != null && v0.constructor["__interfaces"].indexOf("java.util.Collection") >= 0) || v0 === null) && v1 === undefined && v2 === undefined) {
                  return com.vzome.core.algebra.AlgebraicVectors.areCollinear$java_util_Collection(v0);
                } else throw new Error('invalid overload');
              }
            }, {
              key: "getLinePlaneIntersection",
              value: function getLinePlaneIntersection(lineStart, lineDirection, planeCenter, planeNormal) {
                var denom = planeNormal.dot(lineDirection);
                if (denom.isZero()) return null;
                var p1p3 = planeCenter.minus(lineStart);
                var numerator = planeNormal.dot(p1p3);
                var u = numerator['dividedBy$com_vzome_core_algebra_AlgebraicNumber'](denom);
                return lineStart.plus(lineDirection.scale(u));
              }
            }, {
              key: "calculateCentroid",
              value: function calculateCentroid(vectors) {
                return AlgebraicVectors.getCentroid(vectors.toArray(function (s) {
                  var a = [];

                  while (s-- > 0) {
                    a.push(null);
                  }

                  return a;
                }(vectors.size())));
              }
            }, {
              key: "getCentroid",
              value: function getCentroid(vectors) {
                var field = vectors[0].getField();
                var sum = new com.vzome.core.algebra.AlgebraicVector(field, vectors[0].dimension());

                for (var index641 = 0; index641 < vectors.length; index641++) {
                  var vector = vectors[index641];
                  {
                    sum = sum.plus(vector);
                  }
                }

                return sum.scale(field['createRational$long$long'](1, vectors.length));
              }
            }, {
              key: "getMagnitudeSquared",
              value: function getMagnitudeSquared(v) {
                return v.dot(v);
              }
              /**
              * @param {com.vzome.core.algebra.AlgebraicVector} vector
              * @return {com.vzome.core.algebra.AlgebraicVector} the greater of {@code vector} and its inverse.
              * The comparison is based on a canonical (not mathematical) comparison as implemented in {@code AlgebraicVector.compareTo()}.
              * There is no reasonable mathematical sense of ordering vectors,
              * but this provides a way to map a vector and its inverse to a common vector for such purposes as sorting and color mapping.
              */

            }, {
              key: "getCanonicalOrientation",
              value: function getCanonicalOrientation(vector) {
                var negate = vector.negate();
                return vector.compareTo(negate) > 0 ? vector : negate;
              }
              /**
              * getMostDistantFromOrigin() is is used by a few ColorMapper classes, but I think it can eventually be useful elsewhere as well, for example, a zoom-to-fit command or in deriving a convex hull. I've made it a static method of the AlgebraicVector class to encourage such reuse.
              *
              * @param {*} vectors A collection of vectors to be evaluated.
              * @return {java.util.TreeSet} A canonically sorted subset (maybe all) of the {@code vectors} collection. All of the returned vectors will be the same distance from the origin. That distance will be the maximum distance from the origin of any of the vectors in the original collection. If the original collection contains only the origin then so will the result.
              */

            }, {
              key: "getMostDistantFromOrigin",
              value: function getMostDistantFromOrigin(vectors) {
                var mostDistant = new java.util.TreeSet();
                var maxDistanceSquared = 0.0;

                for (var index642 = vectors.iterator(); index642.hasNext();) {
                  var vector = index642.next();
                  {
                    var magnitudeSquared = AlgebraicVectors.getMagnitudeSquared(vector).evaluate();

                    if (magnitudeSquared >= maxDistanceSquared) {
                      if (magnitudeSquared > maxDistanceSquared) {
                        mostDistant.clear();
                      }

                      maxDistanceSquared = magnitudeSquared;
                      mostDistant.add(vector);
                    }
                  }
                }

                return mostDistant;
              }
            }]);

            return AlgebraicVectors;
          }();

          algebra.AlgebraicVectors = AlgebraicVectors;
          AlgebraicVectors["__class"] = "com.vzome.core.algebra.AlgebraicVectors";
        })(core.algebra || (core.algebra = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (algebra) {
          /**
          * @author vorth
          * @param {*} n1
          * @param {*} n2
          * @param {*} n3
          * @param {*} n4
          * @param {*} n5
          * @class
          */
          var AlgebraicVector =
          /*#__PURE__*/
          function () {
            function AlgebraicVector(n1, n2, n3, n4, n5) {
              var _this24 = this;

              _classCallCheck(this, AlgebraicVector);

              if ((n1 != null && (n1["__interfaces"] != null && n1["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0 || n1.constructor != null && n1.constructor["__interfaces"] != null && n1.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0) || n1 === null) && (n2 != null && (n2["__interfaces"] != null && n2["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0 || n2.constructor != null && n2.constructor["__interfaces"] != null && n2.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0) || n2 === null) && (n3 != null && (n3["__interfaces"] != null && n3["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0 || n3.constructor != null && n3.constructor["__interfaces"] != null && n3.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0) || n3 === null) && (n4 != null && (n4["__interfaces"] != null && n4["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0 || n4.constructor != null && n4.constructor["__interfaces"] != null && n4.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0) || n4 === null) && (n5 != null && (n5["__interfaces"] != null && n5["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0 || n5.constructor != null && n5.constructor["__interfaces"] != null && n5.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0) || n5 === null)) {
                {
                  var field = n1.getField();
                  var dims = 5;
                  if (this.coordinates === undefined) this.coordinates = null;
                  if (this.field === undefined) this.field = null;
                  if (this.coordinates === undefined) this.coordinates = null;
                  if (this.field === undefined) this.field = null;

                  (function () {
                    _this24.coordinates = function (s) {
                      var a = [];

                      while (s-- > 0) {
                        a.push(null);
                      }

                      return a;
                    }(dims);

                    for (var i = 0; i < dims; i++) {
                      {
                        _this24.coordinates[i] = field.zero();
                      }
                    }

                    _this24.field = field;
                  })();
                }

                (function () {
                  _this24.coordinates[0] = n1;
                  _this24.coordinates[1] = n2;
                  _this24.coordinates[2] = n3;
                  _this24.coordinates[3] = n4;
                  _this24.coordinates[4] = n5;
                })();
              } else if ((n1 != null && (n1["__interfaces"] != null && n1["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0 || n1.constructor != null && n1.constructor["__interfaces"] != null && n1.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0) || n1 === null) && (n2 != null && (n2["__interfaces"] != null && n2["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0 || n2.constructor != null && n2.constructor["__interfaces"] != null && n2.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0) || n2 === null) && (n3 != null && (n3["__interfaces"] != null && n3["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0 || n3.constructor != null && n3.constructor["__interfaces"] != null && n3.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0) || n3 === null) && (n4 != null && (n4["__interfaces"] != null && n4["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0 || n4.constructor != null && n4.constructor["__interfaces"] != null && n4.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0) || n4 === null) && n5 === undefined) {
                {
                  var _field5 = n1.getField();

                  var _dims = 4;
                  if (this.coordinates === undefined) this.coordinates = null;
                  if (this.field === undefined) this.field = null;
                  if (this.coordinates === undefined) this.coordinates = null;
                  if (this.field === undefined) this.field = null;

                  (function () {
                    _this24.coordinates = function (s) {
                      var a = [];

                      while (s-- > 0) {
                        a.push(null);
                      }

                      return a;
                    }(_dims);

                    for (var i = 0; i < _dims; i++) {
                      {
                        _this24.coordinates[i] = _field5.zero();
                      }
                    }

                    _this24.field = _field5;
                  })();
                }

                (function () {
                  _this24.coordinates[0] = n1;
                  _this24.coordinates[1] = n2;
                  _this24.coordinates[2] = n3;
                  _this24.coordinates[3] = n4;
                })();
              } else if ((n1 != null && (n1["__interfaces"] != null && n1["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0 || n1.constructor != null && n1.constructor["__interfaces"] != null && n1.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0) || n1 === null) && (n2 != null && (n2["__interfaces"] != null && n2["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0 || n2.constructor != null && n2.constructor["__interfaces"] != null && n2.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0) || n2 === null) && (n3 != null && (n3["__interfaces"] != null && n3["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0 || n3.constructor != null && n3.constructor["__interfaces"] != null && n3.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0) || n3 === null) && n4 === undefined && n5 === undefined) {
                {
                  var _field6 = n1.getField();

                  var _dims2 = 3;
                  if (this.coordinates === undefined) this.coordinates = null;
                  if (this.field === undefined) this.field = null;
                  if (this.coordinates === undefined) this.coordinates = null;
                  if (this.field === undefined) this.field = null;

                  (function () {
                    _this24.coordinates = function (s) {
                      var a = [];

                      while (s-- > 0) {
                        a.push(null);
                      }

                      return a;
                    }(_dims2);

                    for (var i = 0; i < _dims2; i++) {
                      {
                        _this24.coordinates[i] = _field6.zero();
                      }
                    }

                    _this24.field = _field6;
                  })();
                }

                (function () {
                  _this24.coordinates[0] = n1;
                  _this24.coordinates[1] = n2;
                  _this24.coordinates[2] = n3;
                })();
              } else if ((n1 != null && (n1["__interfaces"] != null && n1["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0 || n1.constructor != null && n1.constructor["__interfaces"] != null && n1.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0) || n1 === null) && (n2 != null && (n2["__interfaces"] != null && n2["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0 || n2.constructor != null && n2.constructor["__interfaces"] != null && n2.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0) || n2 === null) && n3 === undefined && n4 === undefined && n5 === undefined) {
                {
                  var _field7 = n1.getField();

                  var _dims3 = 2;
                  if (this.coordinates === undefined) this.coordinates = null;
                  if (this.field === undefined) this.field = null;
                  if (this.coordinates === undefined) this.coordinates = null;
                  if (this.field === undefined) this.field = null;

                  (function () {
                    _this24.coordinates = function (s) {
                      var a = [];

                      while (s-- > 0) {
                        a.push(null);
                      }

                      return a;
                    }(_dims3);

                    for (var i = 0; i < _dims3; i++) {
                      {
                        _this24.coordinates[i] = _field7.zero();
                      }
                    }

                    _this24.field = _field7;
                  })();
                }

                (function () {
                  _this24.coordinates[0] = n1;
                  _this24.coordinates[1] = n2;
                })();
              } else if ((n1 != null && (n1["__interfaces"] != null && n1["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicField") >= 0 || n1.constructor != null && n1.constructor["__interfaces"] != null && n1.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicField") >= 0) || n1 === null) && (typeof n2 === 'number' || n2 === null) && n3 === undefined && n4 === undefined && n5 === undefined) {
                var _args37 = arguments;
                var _field8 = _args37[0];
                var _dims4 = _args37[1];
                if (this.coordinates === undefined) this.coordinates = null;
                if (this.field === undefined) this.field = null;
                if (this.coordinates === undefined) this.coordinates = null;
                if (this.field === undefined) this.field = null;

                (function () {
                  _this24.coordinates = function (s) {
                    var a = [];

                    while (s-- > 0) {
                      a.push(null);
                    }

                    return a;
                  }(_dims4);

                  for (var i = 0; i < _dims4; i++) {
                    {
                      _this24.coordinates[i] = _field8.zero();
                    }
                  }

                  _this24.field = _field8;
                })();
              } else if ((n1 != null && n1 instanceof Array && (n1.length == 0 || n1[0] == null || n1[0] != null && (n1[0]["__interfaces"] != null && n1[0]["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0 || n1[0].constructor != null && n1[0].constructor["__interfaces"] != null && n1[0].constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0)) || n1 === null) && n2 === undefined && n3 === undefined && n4 === undefined && n5 === undefined) {
                var _args38 = arguments;
                var n = _args38[0];
                if (this.coordinates === undefined) this.coordinates = null;
                if (this.field === undefined) this.field = null;
                if (this.coordinates === undefined) this.coordinates = null;
                if (this.field === undefined) this.field = null;

                (function () {
                  _this24.coordinates = function (s) {
                    var a = [];

                    while (s-- > 0) {
                      a.push(null);
                    }

                    return a;
                  }(n.length);

                  java.lang.System.arraycopy(n, 0, _this24.coordinates, 0, n.length);
                  _this24.field = n[0].getField();
                })();
              } else if ((n1 != null && (n1["__interfaces"] != null && n1["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0 || n1.constructor != null && n1.constructor["__interfaces"] != null && n1.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0) || n1 === null) && n2 === undefined && n3 === undefined && n4 === undefined && n5 === undefined) {
                {
                  var _field9 = n1.getField();

                  var _dims5 = 1;
                  if (this.coordinates === undefined) this.coordinates = null;
                  if (this.field === undefined) this.field = null;
                  if (this.coordinates === undefined) this.coordinates = null;
                  if (this.field === undefined) this.field = null;

                  (function () {
                    _this24.coordinates = function (s) {
                      var a = [];

                      while (s-- > 0) {
                        a.push(null);
                      }

                      return a;
                    }(_dims5);

                    for (var i = 0; i < _dims5; i++) {
                      {
                        _this24.coordinates[i] = _field9.zero();
                      }
                    }

                    _this24.field = _field9;
                  })();
                }

                (function () {
                  _this24.coordinates[0] = n1;
                })();
              } else throw new Error('invalid overload');
            }
            /**
            *
            * @return {number}
            */


            _createClass(AlgebraicVector, [{
              key: "hashCode",
              value: function hashCode() {
                var prime = 31;
                var result = 1;
                result = prime * result + java.util.Arrays.hashCode(this.coordinates);
                return result;
              }
              /**
              *
              * @param {*} obj
              * @return {boolean}
              */

            }, {
              key: "equals",
              value: function equals(obj) {
                if (this === obj) return true;
                if (obj == null) return false;
                if (this.constructor !== obj.constructor) return false;
                var other = obj;

                if (!function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(this.field, other.field)) {
                  var reason = "Invalid comparison of " +
                  /* getSimpleName */
                  function (c) {
                    return c["__class"] ? c["__class"].substring(c["__class"].lastIndexOf('.') + 1) : c["name"].substring(c["name"].lastIndexOf('.') + 1);
                  }(this.constructor) + "swith different fields: " + this.field.getName() + " and " + other.field.getName();

                  throw new java.lang.IllegalStateException(reason);
                }

                return java.util.Arrays.equals(this.coordinates, other.coordinates);
              }
              /**
              *
              * @param {com.vzome.core.algebra.AlgebraicVector} other
              * @return {number}
              */

            }, {
              key: "compareTo",
              value: function compareTo(other) {
                if (this === other) {
                  return 0;
                }

                if (other.equals(this)) {
                  return 0;
                }

                var comparison = this.coordinates.length - other.coordinates.length;

                if (comparison !== 0) {
                  return comparison;
                }

                for (var i = 0; i < this.coordinates.length; i++) {
                  {
                    var n1 = this.coordinates[i];
                    var n2 = other.coordinates[i];
                    comparison = n1.compareTo(n2);

                    if (comparison !== 0) {
                      return comparison;
                    }
                  }
                }

                return comparison;
              }
            }, {
              key: "toRealVector",
              value: function toRealVector() {
                return new com.vzome.core.math.RealVector(this.coordinates[0].evaluate(), this.coordinates[1].evaluate(), this.coordinates[2].evaluate());
              }
              /**
              * @return {string} A String with no extended characters so it's suitable for writing
              * to an 8 bit stream such as System.out or an ASCII text log file in Windows.
              * Contrast this with {@link toString()} which contains extended characters (e.g. φ (phi))
              */

            }, {
              key: "toASCIIString",
              value: function toASCIIString() {
                return this.getVectorExpression$int(com.vzome.core.algebra.AlgebraicField.EXPRESSION_FORMAT);
              }
              /**
              * @return {string} A String representation that can be persisted to XML and parsed by XmlSaveFormat.parseRationalVector().
              */

            }, {
              key: "toParsableString",
              value: function toParsableString() {
                return this.getVectorExpression$int(com.vzome.core.algebra.AlgebraicField.ZOMIC_FORMAT);
              }
            }, {
              key: "toString",
              value: function toString() {
                var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : com.vzome.core.algebra.AlgebraicField.DEFAULT_FORMAT;
                return this.getVectorExpression$int(format);
              }
            }, {
              key: "getComponent",
              value: function getComponent(i) {
                return this.coordinates[i];
              }
            }, {
              key: "getComponents",
              value: function getComponents() {
                return this.coordinates;
              }
            }, {
              key: "setComponent",
              value: function setComponent(component, coord) {
                this.coordinates[component] = coord;
                return this;
              }
            }, {
              key: "negate",
              value: function negate() {
                var result = function (s) {
                  var a = [];

                  while (s-- > 0) {
                    a.push(null);
                  }

                  return a;
                }(this.coordinates.length);

                for (var i = 0; i < result.length; i++) {
                  {
                    result[i] = this.coordinates[i].negate();
                  }
                }

                return new AlgebraicVector(result);
              }
            }, {
              key: "scale",
              value: function scale(_scale) {
                var result = function (s) {
                  var a = [];

                  while (s-- > 0) {
                    a.push(null);
                  }

                  return a;
                }(this.coordinates.length);

                for (var i = 0; i < result.length; i++) {
                  {
                    result[i] = this.coordinates[i]['times$com_vzome_core_algebra_AlgebraicNumber'](_scale);
                  }
                }

                return new AlgebraicVector(result);
              }
            }, {
              key: "isOrigin",
              value: function isOrigin() {
                for (var index643 = 0; index643 < this.coordinates.length; index643++) {
                  var coordinate = this.coordinates[index643];
                  {
                    if (!coordinate.isZero()) {
                      return false;
                    }
                  }
                }

                return true;
              }
            }, {
              key: "plus",
              value: function plus(that) {
                var result = function (s) {
                  var a = [];

                  while (s-- > 0) {
                    a.push(null);
                  }

                  return a;
                }(this.coordinates.length);

                for (var i = 0; i < result.length; i++) {
                  {
                    result[i] = this.coordinates[i]['plus$com_vzome_core_algebra_AlgebraicNumber'](that.coordinates[i]);
                  }
                }

                return new AlgebraicVector(result);
              }
            }, {
              key: "minus",
              value: function minus(that) {
                var result = function (s) {
                  var a = [];

                  while (s-- > 0) {
                    a.push(null);
                  }

                  return a;
                }(this.coordinates.length);

                for (var i = 0; i < result.length; i++) {
                  {
                    result[i] = this.coordinates[i]['minus$com_vzome_core_algebra_AlgebraicNumber'](that.coordinates[i]);
                  }
                }

                return new AlgebraicVector(result);
              }
            }, {
              key: "dimension",
              value: function dimension() {
                return this.coordinates.length;
              }
            }, {
              key: "cross",
              value: function cross(that) {
                var result = function (s) {
                  var a = [];

                  while (s-- > 0) {
                    a.push(null);
                  }

                  return a;
                }(this.coordinates.length);

                for (var i = 0; i < result.length; i++) {
                  {
                    var j = (i + 1) % 3;
                    var k = (i + 2) % 3;
                    result[i] = this.coordinates[j]['times$com_vzome_core_algebra_AlgebraicNumber'](that.coordinates[k])['minus$com_vzome_core_algebra_AlgebraicNumber'](this.coordinates[k]['times$com_vzome_core_algebra_AlgebraicNumber'](that.coordinates[j]));
                  }
                }

                return new AlgebraicVector(result);
              }
            }, {
              key: "inflateTo4d$",
              value: function inflateTo4d$() {
                return this.inflateTo4d$boolean(true);
              }
            }, {
              key: "inflateTo4d$boolean",
              value: function inflateTo4d$boolean(wFirst) {
                if (this.coordinates.length === 4) {
                  if (wFirst) return this;else return new AlgebraicVector([this.coordinates[1], this.coordinates[2], this.coordinates[3], this.coordinates[0]]);
                }

                if (wFirst) return new AlgebraicVector([this.field.zero(), this.coordinates[0], this.coordinates[1], this.coordinates[2]]);else return new AlgebraicVector([this.coordinates[0], this.coordinates[1], this.coordinates[2], this.field.zero()]);
              }
            }, {
              key: "inflateTo4d",
              value: function inflateTo4d(wFirst) {
                if (typeof wFirst === 'boolean' || wFirst === null) {
                  return this.inflateTo4d$boolean(wFirst);
                } else if (wFirst === undefined) {
                  return this.inflateTo4d$();
                } else throw new Error('invalid overload');
              }
            }, {
              key: "projectTo3d",
              value: function projectTo3d(wFirst) {
                if (this.dimension() === 3) return this;
                if (wFirst) return new AlgebraicVector([this.coordinates[1], this.coordinates[2], this.coordinates[3]]);else return new AlgebraicVector([this.coordinates[0], this.coordinates[1], this.coordinates[2]]);
              }
            }, {
              key: "getVectorExpression$java_lang_StringBuffer$int",
              value: function getVectorExpression$java_lang_StringBuffer$int(buf, format) {
                if (format === com.vzome.core.algebra.AlgebraicField.DEFAULT_FORMAT) buf.append("(");

                for (var i = 0; i < this.coordinates.length; i++) {
                  {
                    if (i > 0) if (format === com.vzome.core.algebra.AlgebraicField.VEF_FORMAT || format === com.vzome.core.algebra.AlgebraicField.ZOMIC_FORMAT) buf.append(" ");else buf.append(", ");
                    this.coordinates[i].getNumberExpression(buf, format);
                  }
                }

                if (format === com.vzome.core.algebra.AlgebraicField.DEFAULT_FORMAT) buf.append(")");
              }
              /**
              *
              * @param {java.lang.StringBuffer} buf a StringBuffer to which the formatted vector will be appended.
              * @param {number} format may be any of the following:
              * {@code AlgebraicField.DEFAULT_FORMAT = 0; // 4 + 3φ}
              * {@code AlgebraicField.EXPRESSION_FORMAT = 1; // 4 +3*phi}
              * {@code AlgebraicField.ZOMIC_FORMAT = 2; // 4 3}
              * {@code AlgebraicField.VEF_FORMAT = 3; // (3,4)}
              */

            }, {
              key: "getVectorExpression",
              value: function getVectorExpression(buf, format) {
                if ((buf != null && buf instanceof java.lang.StringBuffer || buf === null) && (typeof format === 'number' || format === null)) {
                  return this.getVectorExpression$java_lang_StringBuffer$int(buf, format);
                } else if ((typeof buf === 'number' || buf === null) && format === undefined) {
                  return this.getVectorExpression$int(buf);
                } else throw new Error('invalid overload');
              }
            }, {
              key: "getVectorExpression$int",
              value: function getVectorExpression$int(format) {
                var buf = new java.lang.StringBuffer();
                this.getVectorExpression$java_lang_StringBuffer$int(buf, format);
                return buf.toString();
              }
            }, {
              key: "dot",
              value: function dot(that) {
                var result = this.field.zero();

                for (var i = 0; i < that.dimension(); i++) {
                  {
                    result = result['plus$com_vzome_core_algebra_AlgebraicNumber'](this.coordinates[i]['times$com_vzome_core_algebra_AlgebraicNumber'](that.coordinates[i]));
                  }
                }

                return result;
              }
            }, {
              key: "getLength",
              value: function getLength(unit) {
                for (var i = 0; i < this.coordinates.length; i++) {
                  {
                    if (this.coordinates[i].isZero()) continue;
                    return this.coordinates[i]['dividedBy$com_vzome_core_algebra_AlgebraicNumber'](unit.coordinates[i]);
                  }
                }

                throw new java.lang.IllegalStateException("vector is the origin!");
              }
            }, {
              key: "getField",
              value: function getField() {
                return this.field;
              }
            }]);

            return AlgebraicVector;
          }();

          AlgebraicVector.X = 0;
          AlgebraicVector.Y = 1;
          AlgebraicVector.Z = 2;
          AlgebraicVector.W4 = 0;
          AlgebraicVector.X4 = 1;
          AlgebraicVector.Y4 = 2;
          AlgebraicVector.Z4 = 3;
          algebra.AlgebraicVector = AlgebraicVector;
          AlgebraicVector["__class"] = "com.vzome.core.algebra.AlgebraicVector";
          AlgebraicVector["__interfaces"] = ["java.lang.Comparable"];
        })(core.algebra || (core.algebra = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (algebra) {
          var VefVectorExporter =
          /*#__PURE__*/
          function () {
            function VefVectorExporter(writer, field, scale, withOffset) {
              var _this25 = this;

              _classCallCheck(this, VefVectorExporter);

              if ((writer != null && writer instanceof java.io.Writer || writer === null) && (field != null && (field["__interfaces"] != null && field["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicField") >= 0 || field.constructor != null && field.constructor["__interfaces"] != null && field.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicField") >= 0) || field === null) && (scale != null && (scale["__interfaces"] != null && scale["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0 || scale.constructor != null && scale.constructor["__interfaces"] != null && scale.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0) || scale === null) && (typeof withOffset === 'boolean' || withOffset === null)) {
                if (this.output === undefined) this.output = null;
                if (this.field === undefined) this.field = null;
                if (this.strutEnds === undefined) this.strutEnds = null;
                if (this.panelVertices === undefined) this.panelVertices = null;
                if (this.scale === undefined) this.scale = null;
                if (this.includeOffset === undefined) this.includeOffset = false;
                this.sortedVertexList = null;
                this.vertices = new java.util.TreeSet();
                this.ballLocations = new java.util.TreeSet();
                this.exportedOffset = null;
                this.strTip = "tip";
                this.strMiddle = "middle";
                if (this.output === undefined) this.output = null;
                if (this.field === undefined) this.field = null;
                this.sortedVertexList = null;
                this.vertices = new java.util.TreeSet();
                this.ballLocations = new java.util.TreeSet();
                if (this.strutEnds === undefined) this.strutEnds = null;
                if (this.panelVertices === undefined) this.panelVertices = null;
                if (this.scale === undefined) this.scale = null;
                if (this.includeOffset === undefined) this.includeOffset = false;
                this.exportedOffset = null;
                this.strTip = "tip";
                this.strMiddle = "middle";

                (function () {
                  _this25.includeOffset = withOffset;
                  _this25.scale = scale;
                  _this25.output = new java.io.PrintWriter(writer);
                  _this25.field = field;
                  var arrayComparator = new com.vzome.core.generic.ArrayComparator();
                  _this25.strutEnds = new java.util.TreeSet(arrayComparator.getContentFirstArrayComparator());
                  _this25.panelVertices = new java.util.TreeSet(arrayComparator.getLengthFirstArrayComparator());
                })();
              } else if ((writer != null && writer instanceof java.io.Writer || writer === null) && (field != null && (field["__interfaces"] != null && field["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicField") >= 0 || field.constructor != null && field.constructor["__interfaces"] != null && field.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicField") >= 0) || field === null) && scale === undefined && withOffset === undefined) {
                {
                  var _scale2 = null;
                  var _withOffset = false;
                  if (this.output === undefined) this.output = null;
                  if (this.field === undefined) this.field = null;
                  if (this.strutEnds === undefined) this.strutEnds = null;
                  if (this.panelVertices === undefined) this.panelVertices = null;
                  if (this.scale === undefined) this.scale = null;
                  if (this.includeOffset === undefined) this.includeOffset = false;
                  this.sortedVertexList = null;
                  this.vertices = new java.util.TreeSet();
                  this.ballLocations = new java.util.TreeSet();
                  this.exportedOffset = null;
                  this.strTip = "tip";
                  this.strMiddle = "middle";
                  if (this.output === undefined) this.output = null;
                  if (this.field === undefined) this.field = null;
                  this.sortedVertexList = null;
                  this.vertices = new java.util.TreeSet();
                  this.ballLocations = new java.util.TreeSet();
                  if (this.strutEnds === undefined) this.strutEnds = null;
                  if (this.panelVertices === undefined) this.panelVertices = null;
                  if (this.scale === undefined) this.scale = null;
                  if (this.includeOffset === undefined) this.includeOffset = false;
                  this.exportedOffset = null;
                  this.strTip = "tip";
                  this.strMiddle = "middle";

                  (function () {
                    _this25.includeOffset = _withOffset;
                    _this25.scale = _scale2;
                    _this25.output = new java.io.PrintWriter(writer);
                    _this25.field = field;
                    var arrayComparator = new com.vzome.core.generic.ArrayComparator();
                    _this25.strutEnds = new java.util.TreeSet(arrayComparator.getContentFirstArrayComparator());
                    _this25.panelVertices = new java.util.TreeSet(arrayComparator.getLengthFirstArrayComparator());
                  })();
                }
              } else throw new Error('invalid overload');
            }

            _createClass(VefVectorExporter, [{
              key: "exportPoint",
              value: function exportPoint(pt) {
                this.vertices.add(pt);
                this.ballLocations.add(pt);

                if (this.includeOffset) {
                  this.exportedOffset = pt;
                }
              }
            }, {
              key: "exportSegment",
              value: function exportSegment(start, end) {
                var ends = [start, end];
                this.vertices.add(ends[0]);
                this.vertices.add(ends[1]);
                this.strutEnds.add(ends);
              }
            }, {
              key: "exportPolygon",
              value: function exportPolygon(corners) {
                this.vertices.addAll(corners);

                var cornerArray = function (s) {
                  var a = [];

                  while (s-- > 0) {
                    a.push(null);
                  }

                  return a;
                }(corners.size());

                corners.toArray(cornerArray);
                this.panelVertices.add(cornerArray);
              }
              /**
              * @param {java.lang.StringBuffer} buffer = Don't assume that buffer starts out empty. Results will be appended.
              * @param {com.vzome.core.algebra.AlgebraicVector} vector = Value to be converted to a zero-padded 4D String which will be
              * prefixed and/or padded with field specific zeroes
              * depending on the number of dimensions in vector as follows:
              * 1D : 0 X 0 0
              * 2D : 0 X Y 0
              * 3D : 0 X Y Z
              * 4D : W X Y Z
              * @param {*} scale
              */

            }, {
              key: "finishExport",
              value: function finishExport() {
                this.sortedVertexList = new java.util.ArrayList(this.vertices);
                this.vertices = null;
                var version = this.exportedOffset == null ? com.vzome.core.math.VefParser.VERSION_EXPLICIT_BALLS : com.vzome.core.math.VefParser.VERSION_EXPLICIT_OFFSET;
                this.output.println$java_lang_Object("vZome VEF " + version + " field " + this.field.getName());

                if (this.exportedOffset != null) {
                  var buf = new java.lang.StringBuffer();
                  buf.append("\noffset ");
                  VefVectorExporter.appendVector(buf, this.exportedOffset.negate(), null);
                  buf.append("\n");
                  this.output.println$java_lang_Object(buf.toString());
                }

                this.output.println$java_lang_Object("\n" + this.sortedVertexList.size());
                {
                  var _buf = new java.lang.StringBuffer();

                  for (var index645 = this.sortedVertexList.iterator(); index645.hasNext();) {
                    var vector = index645.next();
                    {
                      VefVectorExporter.appendVector(_buf, vector, this.scale);

                      _buf.append("\n");
                    }
                  }

                  _buf.append("\n");

                  this.output.println$java_lang_Object(_buf.toString());
                }
                this.output.println$java_lang_Object("\n" + this.strutEnds.size());

                for (var index646 = this.strutEnds.iterator(); index646.hasNext();) {
                  var ends = index646.next();
                  {
                    this.output.print(this.sortedVertexList.indexOf(ends[0]) + " ");
                    this.output.println$java_lang_Object(this.sortedVertexList.indexOf(ends[1]));
                  }
                }

                this.output.println$java_lang_Object("\n");
                this.output.println$java_lang_Object("\n" + this.panelVertices.size());

                for (var index647 = this.panelVertices.iterator(); index647.hasNext();) {
                  var corners = index647.next();
                  {
                    this.output.print(corners.length + "  ");

                    for (var index648 = 0; index648 < corners.length; index648++) {
                      var corner = corners[index648];
                      {
                        this.output.print(this.sortedVertexList.indexOf(corner) + " ");
                      }
                    }

                    this.output.println$();
                  }
                }

                this.output.println$java_lang_Object("\n");
                this.output.println$java_lang_Object("\n" + this.ballLocations.size());
                var i = 0;

                for (var index649 = this.ballLocations.iterator(); index649.hasNext();) {
                  var ball = index649.next();
                  {
                    this.output.print(this.sortedVertexList.indexOf(ball) + " ");

                    if (++i % 10 === 0) {
                      this.output.println$();
                    }
                  }
                }

                this.output.println$java_lang_Object("\n");
                this.output.flush();
              }
            }], [{
              key: "appendVector",
              value: function appendVector(buffer, vector, scale) {
                var zeroString = vector.getField().zero().toString(com.vzome.core.algebra.AlgebraicField.VEF_FORMAT);
                var dims = vector.dimension();

                if (dims < 4) {
                  buffer.append(zeroString);
                  buffer.append(" ");
                }

                if (scale != null) vector = vector.scale(scale);
                vector.getVectorExpression$java_lang_StringBuffer$int(buffer, com.vzome.core.algebra.AlgebraicField.VEF_FORMAT);

                for (var d = dims + 1; d < 4; d++) {
                  {
                    buffer.append(" ");
                    buffer.append(zeroString);
                  }
                }
              }
            }, {
              key: "exportPolyhedron",
              value: function exportPolyhedron(polyhedron) {
                var out = new java.io.StringWriter();
                var exporter = new VefVectorExporter(out, polyhedron.getField());
                var vertexList = polyhedron.getVertexList();

                for (var index644 = polyhedron.getFaceSet().iterator(); index644.hasNext();) {
                  var face = index644.next();
                  {
                    var vertices = new java.util.ArrayList(face.size());

                    for (var i = 0; i < face.size(); i++) {
                      {
                        var vertexIndex = face.getVertex(i);
                        vertices.add(vertexList.get(vertexIndex));
                      }
                    }

                    exporter.exportPolygon(vertices);
                  }
                }

                exporter.finishExport();
                return out.toString();
              }
            }]);

            return VefVectorExporter;
          }();

          algebra.VefVectorExporter = VefVectorExporter;
          VefVectorExporter["__class"] = "com.vzome.core.algebra.VefVectorExporter";
        })(core.algebra || (core.algebra = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (algebra) {
          var Fields =
          /*#__PURE__*/
          function () {
            function Fields() {
              _classCallCheck(this, Fields);
            }

            _createClass(Fields, null, [{
              key: "rows",
              value: function rows(matrix) {
                return matrix.length;
              }
            }, {
              key: "columns",
              value: function columns(matrix) {
                return matrix[0].length;
              }
            }, {
              key: "matrixMultiplication",
              value: function matrixMultiplication(left, right, product) {
                if (Fields.rows(right) !== Fields.columns(left)) throw new java.lang.IllegalArgumentException("matrices cannot be multiplied");
                if (Fields.rows(product) !== Fields.rows(left)) throw new java.lang.IllegalArgumentException("product matrix has wrong number of rows");
                if (Fields.columns(right) !== Fields.columns(product)) throw new java.lang.IllegalArgumentException("product matrix has wrong number of columns");

                for (var i = 0; i < Fields.rows(product); i++) {
                  {
                    for (var j = 0; j < Fields.columns(product); j++) {
                      {
                        var sum = null;

                        for (var j2 = 0; j2 < Fields.columns(left); j2++) {
                          {
                            var prod = left[i][j2].times(right[j2][j]);
                            if (sum == null) sum = prod;else sum = sum.plus(prod);
                          }
                        }

                        product[i][j] = sum;
                      }
                    }
                  }
                }
              }
            }, {
              key: "gaussJordanReduction$com_vzome_core_algebra_Fields_Element_A_A",
              value: function gaussJordanReduction$com_vzome_core_algebra_Fields_Element_A_A(matrix) {
                return Fields.gaussJordanReduction$com_vzome_core_algebra_Fields_Element_A_A$com_vzome_core_algebra_Fields_Element_A_A(matrix, matrix);
              }
            }, {
              key: "gaussJordanReduction$com_vzome_core_algebra_Fields_Element_A_A$com_vzome_core_algebra_Fields_Element_A_A",
              value: function gaussJordanReduction$com_vzome_core_algebra_Fields_Element_A_A$com_vzome_core_algebra_Fields_Element_A_A(immutableMatrix, adjoined) {
                var nRows = Fields.rows(immutableMatrix);
                var matrix = Fields.copyOf(immutableMatrix);
                var rank = 0;

                for (var col = 0; col < Fields.columns(matrix); col++) {
                  {
                    var pivotRow = -1;

                    for (var row = rank; row < nRows; row++) {
                      {
                        var element = matrix[row][col];

                        if (!element.isZero()) {
                          pivotRow = row;
                          break;
                        }
                      }
                    }

                    if (pivotRow >= 0) {
                      if (pivotRow !== rank) {
                        Fields.swap(matrix, rank, pivotRow);
                        Fields.swap(adjoined, rank, pivotRow);
                        pivotRow = rank;
                      }

                      var scalar = matrix[pivotRow][col];

                      if (!scalar.isOne()) {
                        scalar = scalar.reciprocal();
                        Fields.scale(matrix[pivotRow], scalar);
                        Fields.scale(adjoined[pivotRow], scalar);
                      }

                      for (var _row = 0; _row < nRows; _row++) {
                        {
                          if (_row !== pivotRow) {
                            scalar = matrix[_row][col];

                            if (!scalar.isZero()) {
                              scalar = scalar.negate();
                              Fields.pivot(matrix, _row, scalar, pivotRow);
                              Fields.pivot(adjoined, _row, scalar, pivotRow);
                            }
                          }
                        }
                      }

                      rank++;
                    }
                  }
                }

                return rank;
              }
            }, {
              key: "gaussJordanReduction",
              value: function gaussJordanReduction(immutableMatrix, adjoined) {
                if ((immutableMatrix != null && immutableMatrix instanceof Array && (immutableMatrix.length == 0 || immutableMatrix[0] == null || immutableMatrix[0] instanceof Array) || immutableMatrix === null) && (adjoined != null && adjoined instanceof Array && (adjoined.length == 0 || adjoined[0] == null || adjoined[0] instanceof Array) || adjoined === null)) {
                  return com.vzome.core.algebra.Fields.gaussJordanReduction$com_vzome_core_algebra_Fields_Element_A_A$com_vzome_core_algebra_Fields_Element_A_A(immutableMatrix, adjoined);
                } else if ((immutableMatrix != null && immutableMatrix instanceof Array && (immutableMatrix.length == 0 || immutableMatrix[0] == null || immutableMatrix[0] instanceof Array) || immutableMatrix === null) && adjoined === undefined) {
                  return com.vzome.core.algebra.Fields.gaussJordanReduction$com_vzome_core_algebra_Fields_Element_A_A(immutableMatrix);
                } else throw new Error('invalid overload');
              }
            }, {
              key: "copyOf",
              value: function copyOf(matrix) {
                var nRows = Fields.rows(matrix);
                var nCols = Fields.columns(matrix);

                var copy = function (s) {
                  var a = [];

                  while (s-- > 0) {
                    a.push(null);
                  }

                  return a;
                }(nRows);

                for (var i = 0; i < nRows; i++) {
                  {
                    copy[i] = java.util.Arrays.copyOf(matrix[i], nCols);
                  }
                }

                return copy;
              }
              /**
              *
              * @param {Array} array of elements to be swapped
              * @param {number} r index of the first element to be swapped
              * @param {number} s index of the second element to be swapped
              * <br/>
              * Note that since Java implements a multi-dimensional array as an array of arrays,
              * the {@code array} parameter can be an {@code Object[][]} in which case
              * entire rows are swapped rather than an element at a time.
              * Besides being more efficient at run time, this also means
              * that rows of multi-dimensional arrays do not necessarily have to be the same length.
              * @private
              */

            }, {
              key: "swap",
              value: function swap(array, r, s) {
                var temp = array[r];
                array[r] = array[s];
                array[s] = temp;
              }
            }, {
              key: "scale",
              value: function scale(array, scalar) {
                for (var col = 0; col < array.length; col++) {
                  {
                    array[col] = scalar.times(array[col]);
                  }
                }
              }
            }, {
              key: "pivot",
              value: function pivot(matrix, row, scalar, rank) {
                for (var col = 0; col < Fields.columns(matrix); col++) {
                  {
                    matrix[row][col] = matrix[row][col].plus(matrix[rank][col].times(scalar));
                  }
                }
              }
            }]);

            return Fields;
          }();

          algebra.Fields = Fields;
          Fields["__class"] = "com.vzome.core.algebra.Fields";
        })(core.algebra || (core.algebra = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (algebra) {
          (function (AlgebraicField) {
            AlgebraicField.DEFAULT_FORMAT = 0;
            AlgebraicField.EXPRESSION_FORMAT = 1;
            AlgebraicField.ZOMIC_FORMAT = 2;
            AlgebraicField.VEF_FORMAT = 3;
          })(algebra.AlgebraicField || (algebra.AlgebraicField = {}));
        })(core.algebra || (core.algebra = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (algebra) {
          var Bivector3d =
          /*#__PURE__*/
          function () {
            function Bivector3d(a, b, c) {
              _classCallCheck(this, Bivector3d);

              if (this.a === undefined) this.a = null;
              if (this.b === undefined) this.b = null;
              if (this.c === undefined) this.c = null;
              this.a = a;
              this.b = b;
              this.c = c;
            }
            /**
            *
            * @return {number}
            */


            _createClass(Bivector3d, [{
              key: "hashCode",
              value: function hashCode() {
                var prime = 31;
                var result = 1;
                result = prime * result + (this.a == null ? 0 :
                /* hashCode */
                function (o) {
                  if (o.hashCode) {
                    return o.hashCode();
                  } else {
                    return o.toString().split('').reduce(function (prevHash, currVal) {
                      return (prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0;
                    }, 0);
                  }
                }(this.a));
                result = prime * result + (this.b == null ? 0 :
                /* hashCode */
                function (o) {
                  if (o.hashCode) {
                    return o.hashCode();
                  } else {
                    return o.toString().split('').reduce(function (prevHash, currVal) {
                      return (prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0;
                    }, 0);
                  }
                }(this.b));
                result = prime * result + (this.c == null ? 0 :
                /* hashCode */
                function (o) {
                  if (o.hashCode) {
                    return o.hashCode();
                  } else {
                    return o.toString().split('').reduce(function (prevHash, currVal) {
                      return (prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0;
                    }, 0);
                  }
                }(this.c));
                return result;
              }
              /**
              *
              * @param {*} obj
              * @return {boolean}
              */

            }, {
              key: "equals",
              value: function equals(obj) {
                if (this === obj) {
                  return true;
                }

                if (obj == null) {
                  return false;
                }

                if (this.constructor !== obj.constructor) {
                  return false;
                }

                var other = obj;

                if (this.a == null) {
                  if (other.a != null) {
                    return false;
                  }
                } else if (!function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(this.a, other.a)) {
                  return false;
                }

                if (this.b == null) {
                  if (other.b != null) {
                    return false;
                  }
                } else if (!function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(this.b, other.b)) {
                  return false;
                }

                if (this.c == null) {
                  if (other.c != null) {
                    return false;
                  }
                } else if (!function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(this.c, other.c)) {
                  return false;
                }

                return true;
              }
              /**
              * The pseudoscalar is implied in the result.
              * @param {com.vzome.core.algebra.Vector3d} v
              * @return
              * @return {*}
              */

            }, {
              key: "outer",
              value: function outer(v) {
                var a = this.a['times$com_vzome_core_algebra_AlgebraicNumber'](v.c);
                var b = this.b['times$com_vzome_core_algebra_AlgebraicNumber'](v.a);
                var c = this.c['times$com_vzome_core_algebra_AlgebraicNumber'](v.b);
                return a['plus$com_vzome_core_algebra_AlgebraicNumber'](b)['plus$com_vzome_core_algebra_AlgebraicNumber'](c);
              }
            }]);

            return Bivector3d;
          }();

          algebra.Bivector3d = Bivector3d;
          Bivector3d["__class"] = "com.vzome.core.algebra.Bivector3d";
        })(core.algebra || (core.algebra = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (algebra) {
          var Trivector3dHomogeneous =
          /*#__PURE__*/
          function () {
            function Trivector3dHomogeneous(e123, e310, e320, e120, field) {
              _classCallCheck(this, Trivector3dHomogeneous);

              if (this.e123 === undefined) this.e123 = null;
              if (this.e310 === undefined) this.e310 = null;
              if (this.e320 === undefined) this.e320 = null;
              if (this.e120 === undefined) this.e120 = null;
              if (this.field === undefined) this.field = null;
              this.e123 = e123;
              this.e310 = e310;
              this.e320 = e320;
              this.e120 = e120;
              this.field = field;
            }

            _createClass(Trivector3dHomogeneous, [{
              key: "dual",
              value: function dual() {
                return new com.vzome.core.algebra.Vector3dHomogeneous(this.e320.negate(), this.e310, this.e120, this.e123.negate(), this.field);
              }
            }]);

            return Trivector3dHomogeneous;
          }();

          algebra.Trivector3dHomogeneous = Trivector3dHomogeneous;
          Trivector3dHomogeneous["__class"] = "com.vzome.core.algebra.Trivector3dHomogeneous";
        })(core.algebra || (core.algebra = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (algebra) {
          (function (AlgebraicNumber) {
            var Views = function Views() {
              _classCallCheck(this, Views);
            };

            AlgebraicNumber.Views = Views;
            Views["__class"] = "com.vzome.core.algebra.AlgebraicNumber.Views";
          })(algebra.AlgebraicNumber || (algebra.AlgebraicNumber = {}));
        })(core.algebra || (core.algebra = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (algebra) {
          var Vector3d =
          /*#__PURE__*/
          function () {
            function Vector3d(a, b, c) {
              var _this26 = this;

              _classCallCheck(this, Vector3d);

              if ((a != null && (a["__interfaces"] != null && a["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0 || a.constructor != null && a.constructor["__interfaces"] != null && a.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0) || a === null) && (b != null && (b["__interfaces"] != null && b["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0 || b.constructor != null && b.constructor["__interfaces"] != null && b.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0) || b === null) && (c != null && (c["__interfaces"] != null && c["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0 || c.constructor != null && c.constructor["__interfaces"] != null && c.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0) || c === null)) {
                if (this.a === undefined) this.a = null;
                if (this.b === undefined) this.b = null;
                if (this.c === undefined) this.c = null;
                if (this.a === undefined) this.a = null;
                if (this.b === undefined) this.b = null;
                if (this.c === undefined) this.c = null;

                (function () {
                  _this26.a = a;
                  _this26.b = b;
                  _this26.c = c;
                })();
              } else if ((a != null && a instanceof com.vzome.core.algebra.AlgebraicVector || a === null) && b === undefined && c === undefined) {
                var _args43 = arguments;
                var v = _args43[0];
                if (this.a === undefined) this.a = null;
                if (this.b === undefined) this.b = null;
                if (this.c === undefined) this.c = null;
                if (this.a === undefined) this.a = null;
                if (this.b === undefined) this.b = null;
                if (this.c === undefined) this.c = null;

                (function () {
                  _this26.a = v.getComponent(0);
                  _this26.b = v.getComponent(1);
                  _this26.c = v.getComponent(2);
                })();
              } else throw new Error('invalid overload');
            }

            _createClass(Vector3d, [{
              key: "outer",
              value: function outer(that) {
                var a = this.a['times$com_vzome_core_algebra_AlgebraicNumber'](that.b)['minus$com_vzome_core_algebra_AlgebraicNumber'](this.b['times$com_vzome_core_algebra_AlgebraicNumber'](that.a));
                var b = this.b['times$com_vzome_core_algebra_AlgebraicNumber'](that.c)['minus$com_vzome_core_algebra_AlgebraicNumber'](this.c['times$com_vzome_core_algebra_AlgebraicNumber'](that.b));
                var c = this.c['times$com_vzome_core_algebra_AlgebraicNumber'](that.a)['minus$com_vzome_core_algebra_AlgebraicNumber'](this.a['times$com_vzome_core_algebra_AlgebraicNumber'](that.c));
                return new com.vzome.core.algebra.Bivector3d(a, b, c);
              }
            }]);

            return Vector3d;
          }();

          algebra.Vector3d = Vector3d;
          Vector3d["__class"] = "com.vzome.core.algebra.Vector3d";
        })(core.algebra || (core.algebra = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (algebra) {
          var Quaternion =
          /*#__PURE__*/
          function () {
            function Quaternion(field, vector) {
              _classCallCheck(this, Quaternion);

              if (this.representation === undefined) this.representation = null;
              if (this.transpose === undefined) this.transpose = null;
              if (this.field === undefined) this.field = null;
              if (this.vector === undefined) this.vector = null;
              this.field = field;
              this.vector = vector;
              var w_offset = 0;
              var factor = field['createRational$long'](0);

              if (vector.dimension() > 3) {
                factor = vector.getComponent(0);
                w_offset = 1;
              }

              this.representation = field.identityMatrix(4).timesScalar(factor);
              factor = vector.getComponent(0 + w_offset);
              this.representation.setElement(1, 0, factor);
              this.representation.setElement(3, 2, factor);
              factor = factor.negate();
              this.representation.setElement(0, 1, factor);
              this.representation.setElement(2, 3, factor);
              factor = vector.getComponent(1 + w_offset);
              this.representation.setElement(1, 3, factor);
              this.representation.setElement(2, 0, factor);
              factor = factor.negate();
              this.representation.setElement(3, 1, factor);
              this.representation.setElement(0, 2, factor);
              factor = vector.getComponent(2 + w_offset);
              this.representation.setElement(3, 0, factor);
              this.representation.setElement(2, 1, factor);
              factor = factor.negate();
              this.representation.setElement(1, 2, factor);
              this.representation.setElement(0, 3, factor);
              if (w_offset === 1) factor = vector.getComponent(0);else factor = field['createRational$long'](0);
              this.transpose = field.identityMatrix(4).timesScalar(factor);
              factor = vector.getComponent(0 + w_offset);
              this.transpose.setElement(0, 1, factor);
              this.transpose.setElement(2, 3, factor);
              factor = factor.negate();
              this.transpose.setElement(1, 0, factor);
              this.transpose.setElement(3, 2, factor);
              factor = vector.getComponent(1 + w_offset);
              this.transpose.setElement(3, 1, factor);
              this.transpose.setElement(0, 2, factor);
              factor = factor.negate();
              this.transpose.setElement(1, 3, factor);
              this.transpose.setElement(2, 0, factor);
              factor = vector.getComponent(2 + w_offset);
              this.transpose.setElement(1, 2, factor);
              this.transpose.setElement(0, 3, factor);
              factor = factor.negate();
              this.transpose.setElement(3, 0, factor);
              this.transpose.setElement(2, 1, factor);
            }
            /**
            *
            * @return {string}
            */


            _createClass(Quaternion, [{
              key: "toString",
              value: function toString() {
                return "Quaternion: " + this.vector.toString();
              }
            }, {
              key: "getVector",
              value: function getVector() {
                return this.vector;
              }
              /*private*/

            }, {
              key: "conjugate",
              value: function conjugate(q) {
                var result = this.field.origin(4);
                result.setComponent(3, q.getComponent(3).negate());
                result.setComponent(1, q.getComponent(1).negate());
                result.setComponent(2, q.getComponent(2).negate());
                result.setComponent(0, q.getComponent(0));
                return result;
              }
            }, {
              key: "reflect",
              value: function reflect(v) {
                var reflection = this.rightMultiply(this.conjugate(v));
                reflection = this.leftMultiply(reflection);
                return reflection.negate();
              }
              /**
              * Compute the product this * q.
              * @param {com.vzome.core.algebra.AlgebraicVector} q
              * @return {com.vzome.core.algebra.AlgebraicVector}
              */

            }, {
              key: "rightMultiply",
              value: function rightMultiply(q) {
                return this.representation.timesColumn(q);
              }
              /**
              * Compute the product q*this.
              * This is computed using the identities:
              *
              * conjugate( q*this ) == conjugate( this ) * conjugate( q )
              *
              * q * this == conjugate( conjugate( this ) * conjugate( q ) )
              *
              * @param {com.vzome.core.algebra.AlgebraicVector} q
              * @return
              * @return {com.vzome.core.algebra.AlgebraicVector}
              */

            }, {
              key: "leftMultiply",
              value: function leftMultiply(q) {
                var result = this.conjugate(q);
                result = this.transpose.timesColumn(result);
                return this.conjugate(result);
              }
            }]);

            return Quaternion;
          }();

          algebra.Quaternion = Quaternion;
          Quaternion["__class"] = "com.vzome.core.algebra.Quaternion";
        })(core.algebra || (core.algebra = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (xml) {
        var DomUtils =
        /*#__PURE__*/
        function () {
          function DomUtils() {
            _classCallCheck(this, DomUtils);
          }

          _createClass(DomUtils, null, [{
            key: "addAttribute",
            value: function addAttribute(elem, name, value) {
              elem.setAttribute(name, value);
            }
          }, {
            key: "getFirstChildElement$org_w3c_dom_Element$java_lang_String",
            value: function getFirstChildElement$org_w3c_dom_Element$java_lang_String(elem, name) {
              var elems = elem.getElementsByTagName(name);
              return elems.item(0);
            }
          }, {
            key: "getFirstChildElement",
            value: function getFirstChildElement(elem, name) {
              if ((elem != null && (elem["__interfaces"] != null && elem["__interfaces"].indexOf("org.w3c.dom.Element") >= 0 || elem.constructor != null && elem.constructor["__interfaces"] != null && elem.constructor["__interfaces"].indexOf("org.w3c.dom.Element") >= 0) || elem === null) && (typeof name === 'string' || name === null)) {
                return com.vzome.xml.DomUtils.getFirstChildElement$org_w3c_dom_Element$java_lang_String(elem, name);
              } else if ((elem != null && (elem["__interfaces"] != null && elem["__interfaces"].indexOf("org.w3c.dom.Element") >= 0 || elem.constructor != null && elem.constructor["__interfaces"] != null && elem.constructor["__interfaces"].indexOf("org.w3c.dom.Element") >= 0) || elem === null) && name === undefined) {
                return com.vzome.xml.DomUtils.getFirstChildElement$org_w3c_dom_Element(elem);
              } else throw new Error('invalid overload');
            }
          }, {
            key: "preserveSpace",
            value: function preserveSpace(contentElem) {
              contentElem.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
            }
          }, {
            key: "getFirstChildElement$org_w3c_dom_Element",
            value: function getFirstChildElement$org_w3c_dom_Element(parent) {
              var children = parent.getChildNodes();
              if (children.getLength() === 0) return null;

              for (var k = 0; k < children.getLength(); k++) {
                {
                  var kid = children.item(k);

                  if (kid != null && (kid["__interfaces"] != null && kid["__interfaces"].indexOf("org.w3c.dom.Element") >= 0 || kid.constructor != null && kid.constructor["__interfaces"] != null && kid.constructor["__interfaces"].indexOf("org.w3c.dom.Element") >= 0)) {
                    return kid;
                  }
                }
              }

              return null;
            }
          }, {
            key: "getChild",
            value: function getChild(parent, i) {
              var children = parent.getChildNodes();
              if (children.getLength() === 0) return null;
              var count = 0;

              for (var k = 0; k < children.getLength(); k++) {
                {
                  var kid = children.item(k);

                  if (kid != null && (kid["__interfaces"] != null && kid["__interfaces"].indexOf("org.w3c.dom.Element") >= 0 || kid.constructor != null && kid.constructor["__interfaces"] != null && kid.constructor["__interfaces"].indexOf("org.w3c.dom.Element") >= 0)) {
                    if (count === i) return kid;else ++count;
                  }
                }
              }

              return null;
            }
          }]);

          return DomUtils;
        }();

        xml.DomUtils = DomUtils;
        DomUtils["__class"] = "com.vzome.xml.DomUtils";
      })(vzome.xml || (vzome.xml = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (xml) {
        var ResourceLoader =
        /*#__PURE__*/
        function () {
          function ResourceLoader() {
            _classCallCheck(this, ResourceLoader);
          }

          _createClass(ResourceLoader, null, [{
            key: "INJECTED_RESOURCES_$LI$",
            value: function INJECTED_RESOURCES_$LI$() {
              if (ResourceLoader.INJECTED_RESOURCES == null) ResourceLoader.INJECTED_RESOURCES = new java.util.HashMap();
              return ResourceLoader.INJECTED_RESOURCES;
            }
          }, {
            key: "injectResource",
            value: function injectResource(path, content) {
              ResourceLoader.INJECTED_RESOURCES_$LI$().put(path, content);
            }
          }, {
            key: "hasInjectedResource",
            value: function hasInjectedResource(path) {
              return ResourceLoader.INJECTED_RESOURCES_$LI$().containsKey(path);
            }
          }, {
            key: "getInjectedResource",
            value: function getInjectedResource(path) {
              return ResourceLoader.INJECTED_RESOURCES_$LI$().get(path);
            }
          }, {
            key: "loadStringResource",
            value: function loadStringResource(path) {
              if (ResourceLoader.hasInjectedResource(path)) return ResourceLoader.getInjectedResource(path);
              var input = ResourceLoader.getClassLoader().getResourceAsStream(path);
              if (input == null) return null;
              var out = new java.io.ByteArrayOutputStream();

              var buf = function (s) {
                var a = [];

                while (s-- > 0) {
                  a.push(0);
                }

                return a;
              }(1024);

              var num;

              while ((num = input.read(buf, 0, 1024)) > 0) {
                out.write(buf, 0, num);
              }

              input.close();
              return new String(out.toByteArray());
            }
          }]);

          return ResourceLoader;
        }();

        xml.ResourceLoader = ResourceLoader;
        ResourceLoader["__class"] = "com.vzome.xml.ResourceLoader";
      })(vzome.xml || (vzome.xml = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (api) {
        (function (Tool) {
          (function (Kind) {
            Kind[Kind["SYMMETRY"] = 0] = "SYMMETRY";
            Kind[Kind["TRANSFORM"] = 1] = "TRANSFORM";
            Kind[Kind["LINEAR_MAP"] = 2] = "LINEAR_MAP";
          })(Tool.Kind || (Tool.Kind = {}));
        })(api.Tool || (api.Tool = {}));
      })(vzome.api || (vzome.api = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (java) {
    (function (util) {
      var UUID =
      /*#__PURE__*/
      function () {
        function UUID() {
          _classCallCheck(this, UUID);

          if (this.value === undefined) this.value = null;
          this.value =
          /* toString */
          '' + Math.random();
        }

        _createClass(UUID, [{
          key: "toString",
          value: function toString() {
            return this.value;
          }
        }], [{
          key: "randomUUID",
          value: function randomUUID() {
            return new UUID();
          }
        }]);

        return UUID;
      }();

      util.UUID = UUID;
      UUID["__class"] = "java.util.UUID";
    })(java.util || (java.util = {}));
  })(java);

  (function (java) {
    (function (util) {
      var StringTokenizer =
      /*#__PURE__*/
      function () {
        function StringTokenizer(str, seps) {
          var _this27 = this;

          _classCallCheck(this, StringTokenizer);

          if ((typeof str === 'string' || str === null) && (typeof seps === 'string' || seps === null)) {
            if (this.tokens === undefined) this.tokens = null;
            if (this.count === undefined) this.count = 0;
            if (this.tokens === undefined) this.tokens = null;
            if (this.count === undefined) this.count = 0;

            (function () {
              var pattern = seps == null ? "\\s+" : "[" + seps + "]+";
              var regExp = new RegExp(pattern);

              var strs = _this27.splitRegExp(str, regExp);

              var last = strs.length - 1;
              if (strs[last] === "") strs = java.util.Arrays.copyOf(strs, last);
              _this27.count = strs.length;
              _this27.tokens = java.util.Arrays.asList(strs).iterator();
            })();
          } else if ((typeof str === 'string' || str === null) && seps === undefined) {
            {
              var _seps = null;
              if (this.tokens === undefined) this.tokens = null;
              if (this.count === undefined) this.count = 0;
              if (this.tokens === undefined) this.tokens = null;
              if (this.count === undefined) this.count = 0;

              (function () {
                var pattern = _seps == null ? "\\s+" : "[" + _seps + "]+";
                var regExp = new RegExp(pattern);

                var strs = _this27.splitRegExp(str, regExp);

                var last = strs.length - 1;
                if (strs[last] === "") strs = java.util.Arrays.copyOf(strs, last);
                _this27.count = strs.length;
                _this27.tokens = java.util.Arrays.asList(strs).iterator();
              })();
            }
          } else throw new Error('invalid overload');
        }
        /*private*/


        _createClass(StringTokenizer, [{
          key: "splitRegExp",
          value: function splitRegExp(str, regExp) {
            return str.split(regExp);
          }
        }, {
          key: "hasMoreTokens",
          value: function hasMoreTokens() {
            return this.tokens.hasNext();
          }
        }, {
          key: "nextToken",
          value: function nextToken() {
            return this.tokens.next();
          }
        }, {
          key: "countTokens",
          value: function countTokens() {
            return this.count;
          }
        }]);

        return StringTokenizer;
      }();

      util.StringTokenizer = StringTokenizer;
      StringTokenizer["__class"] = "java.util.StringTokenizer";
    })(java.util || (java.util = {}));
  })(java);

  (function (java) {
    (function (util) {
      var Properties =
      /*#__PURE__*/
      function () {
        function Properties() {
          _classCallCheck(this, Properties);
        }

        _createClass(Properties, [{
          key: "getProperty",
          value: function getProperty(key) {
            return "";
          }
        }, {
          key: "load",
          value: function load(inStream) {}
        }, {
          key: "isEmpty",
          value: function isEmpty() {
            return true;
          }
        }]);

        return Properties;
      }();

      util.Properties = Properties;
      Properties["__class"] = "java.util.Properties";
    })(java.util || (java.util = {}));
  })(java);

  (function (java) {
    (function (io) {
      var File =
      /*#__PURE__*/
      function () {
        function File(parent, name) {
          _classCallCheck(this, File);
        }

        _createClass(File, [{
          key: "exists",
          value: function exists() {
            return false;
          }
        }]);

        return File;
      }();

      io.File = File;
      File["__class"] = "java.io.File";
    })(java.io || (java.io = {}));
  })(java);

  (function (java) {
    (function (io) {
      var StringWriter =
      /*#__PURE__*/
      function (_java$io$Writer) {
        _inherits(StringWriter, _java$io$Writer);

        var _super33 = _createSuper(StringWriter);

        _createClass(StringWriter, [{
          key: "toString",
          value: function toString() {
            return null;
          }
        }, {
          key: "flush",
          value: function flush() {}
        }, {
          key: "close",
          value: function close() {}
        }, {
          key: "write",
          value: function write(cbuf, off, len) {}
        }]);

        function StringWriter() {
          _classCallCheck(this, StringWriter);

          return _super33.call(this);
        }

        return StringWriter;
      }(java.io.Writer);

      io.StringWriter = StringWriter;
      StringWriter["__class"] = "java.io.StringWriter";
      StringWriter["__interfaces"] = ["java.lang.Appendable", "java.io.Closeable", "java.lang.AutoCloseable", "java.io.Flushable"];
    })(java.io || (java.io = {}));
  })(java);

  (function (java) {
    (function (io) {
      var PrintWriter =
      /*#__PURE__*/
      function (_java$io$Writer2) {
        _inherits(PrintWriter, _java$io$Writer2);

        var _super34 = _createSuper(PrintWriter);

        function PrintWriter(w) {
          _classCallCheck(this, PrintWriter);

          return _super34.call(this);
        }

        _createClass(PrintWriter, [{
          key: "flush",
          value: function flush() {}
        }, {
          key: "close",
          value: function close() {}
        }, {
          key: "write",
          value: function write(cbuf, off, len) {}
        }, {
          key: "println$",
          value: function println$() {}
        }, {
          key: "print",
          value: function print(x) {}
        }, {
          key: "println$java_lang_Object",
          value: function println$java_lang_Object(x) {}
        }, {
          key: "println",
          value: function println(x) {
            if (x != null || x === null) {
              return this.println$java_lang_Object(x);
            } else if (x === undefined) {
              return this.println$();
            } else throw new Error('invalid overload');
          }
        }]);

        return PrintWriter;
      }(java.io.Writer);

      io.PrintWriter = PrintWriter;
      PrintWriter["__class"] = "java.io.PrintWriter";
      PrintWriter["__interfaces"] = ["java.lang.Appendable", "java.io.Closeable", "java.lang.AutoCloseable", "java.io.Flushable"];
    })(java.io || (java.io = {}));
  })(java);

  (function (java) {
    (function (beans) {
      var PropertyChangeSupport =
      /*#__PURE__*/
      function () {
        function PropertyChangeSupport(a1) {
          _classCallCheck(this, PropertyChangeSupport);
        }

        _createClass(PropertyChangeSupport, [{
          key: "firePropertyChange",
          value: function firePropertyChange(a1, a2, a3) {}
        }, {
          key: "addPropertyChangeListener",
          value: function addPropertyChangeListener(a1) {}
        }, {
          key: "removePropertyChangeListener",
          value: function removePropertyChangeListener(a1) {}
        }]);

        return PropertyChangeSupport;
      }();

      beans.PropertyChangeSupport = PropertyChangeSupport;
      PropertyChangeSupport["__class"] = "java.beans.PropertyChangeSupport";
    })(java.beans || (java.beans = {}));
  })(java);

  (function (java) {
    (function (nio) {
      var FloatBuffer =
      /*#__PURE__*/
      function () {
        function FloatBuffer() {
          _classCallCheck(this, FloatBuffer);
        }

        _createClass(FloatBuffer, [{
          key: "put",
          value: function put(offset, x) {}
        }]);

        return FloatBuffer;
      }();

      nio.FloatBuffer = FloatBuffer;
      FloatBuffer["__class"] = "java.nio.FloatBuffer";
    })(java.nio || (java.nio = {}));
  })(java);

  (function (java) {
    (function (text) {
      var NumberFormat =
      /*#__PURE__*/
      function () {
        function NumberFormat() {
          _classCallCheck(this, NumberFormat);
        }

        _createClass(NumberFormat, [{
          key: "setMaximumFractionDigits",
          value: function setMaximumFractionDigits(i) {}
        }, {
          key: "setMinimumFractionDigits",
          value: function setMinimumFractionDigits(i) {}
        }, {
          key: "format",
          value: function format(x) {
            return (
              /* toString */
              '' + x
            );
          }
        }], [{
          key: "getNumberInstance",
          value: function getNumberInstance(us) {
            return new NumberFormat();
          }
        }]);

        return NumberFormat;
      }();

      text.NumberFormat = NumberFormat;
      NumberFormat["__class"] = "java.text.NumberFormat";
    })(java.text || (java.text = {}));
  })(java);

  (function (com) {
    (function (vzome) {
      (function (jsweet) {
        var JsSelection =
        /*#__PURE__*/
        function () {
          function JsSelection(field, adapter) {
            _classCallCheck(this, JsSelection);

            if (this.adapter === undefined) this.adapter = null;
            if (this.field === undefined) this.field = null;
            this.field = field;
            this.adapter = adapter;
          }

          _createClass(JsSelection, [{
            key: "setAdapter",
            value: function setAdapter(adapter) {
              this.adapter = adapter;
            }
            /**
            *
            * @return {*}
            */

          }, {
            key: "iterator",
            value: function iterator() {
              if (this.adapter == null) return java.util.Collections.emptyIterator();
              var f = this.adapter["selectedIterator"];
              var jSiterator = f.apply(this.adapter);
              return new JsSelection.JsSelection$0(this, jSiterator);
            }
            /**
            *
            */

          }, {
            key: "clear",
            value: function clear() {
              this.adapter["clearSelection"].apply(this.adapter);
            }
            /**
            *
            * @param {*} man
            * @return {boolean}
            */

          }, {
            key: "manifestationSelected",
            value: function manifestationSelected(man) {
              var vectors = man.getVectors();
              return this.adapter["manifestationSelected"].apply(this.adapter, [vectors]);
            }
            /**
            *
            * @param {*} man
            */

          }, {
            key: "select",
            value: function select(man) {
              var vectors = man.getVectors();
              this.adapter["select"].apply(this.adapter, [vectors]);
            }
            /**
            *
            * @param {*} man
            */

          }, {
            key: "unselect",
            value: function unselect(man) {
              var vectors = man.getVectors();
              this.adapter["unselect"].apply(this.adapter, [vectors]);
            }
            /**
            *
            * @return {number}
            */

          }, {
            key: "size",
            value: function size() {
              return this.adapter["selectionSize"].apply(this.adapter) | 0;
            }
            /**
            *
            */

          }, {
            key: "gatherGroup",
            value: function gatherGroup() {
              this.adapter["createGroup"].apply(this.adapter);
            }
            /**
            *
            */

          }, {
            key: "scatterGroup",
            value: function scatterGroup() {
              this.adapter["disbandGroup"].apply(this.adapter);
            }
            /**
            *
            */

          }, {
            key: "gatherGroup211",
            value: function gatherGroup211() {
              this.adapter["createLegacyGroup"].apply(this.adapter);
            }
            /**
            *
            */

          }, {
            key: "scatterGroup211",
            value: function scatterGroup211() {
              this.adapter["disbandLegacyGroup"].apply(this.adapter);
            }
            /**
            *
            * @param {*} man
            */

          }, {
            key: "selectWithGrouping",
            value: function selectWithGrouping(man) {
              if (man == null) return;
              var vectors = man.getVectors();
              this.adapter["selectWithGrouping"].apply(this.adapter, [vectors]);
            }
            /**
            *
            * @param {*} man
            */

          }, {
            key: "unselectWithGrouping",
            value: function unselectWithGrouping(man) {
              if (man == null) return;
              var vectors = man.getVectors();
              this.adapter["unselectWithGrouping"].apply(this.adapter, [vectors]);
            }
            /**
            *
            * @return {boolean}
            */

          }, {
            key: "isSelectionAGroup",
            value: function isSelectionAGroup() {
              return this.adapter["selectionIsGroup"].apply(this.adapter);
            }
            /**
            *
            * @param {*} bookmarkedSelection
            */

          }, {
            key: "copy",
            value: function copy(bookmarkedSelection) {
              throw new java.lang.RuntimeException("unimplemented");
            }
          }]);

          return JsSelection;
        }();

        jsweet.JsSelection = JsSelection;
        JsSelection["__class"] = "com.vzome.jsweet.JsSelection";
        JsSelection["__interfaces"] = ["com.vzome.core.editor.api.Selection", "java.lang.Iterable"];

        (function (JsSelection) {
          var JsSelection$0 =
          /*#__PURE__*/
          function () {
            function JsSelection$0(__parent, jSiterator) {
              _classCallCheck(this, JsSelection$0);

              this.jSiterator = jSiterator;
              this.__parent = __parent;
              this.peek = this.jSiterator.next();
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(JsSelection$0, [{
              key: "hasNext",
              value: function hasNext() {
                return !this.peek.done;
              }
              /**
              *
              * @return {*}
              */

            }, {
              key: "next",
              value: function next() {
                var result = com.vzome.jsweet.JsManifestation.manifest(this.peek.value, this.__parent.field, this.__parent.adapter);
                this.peek = this.jSiterator.next();
                return result;
              }
            }]);

            return JsSelection$0;
          }();

          JsSelection.JsSelection$0 = JsSelection$0;
          JsSelection$0["__interfaces"] = ["java.util.Iterator"];
        })(JsSelection = jsweet.JsSelection || (jsweet.JsSelection = {}));
      })(vzome.jsweet || (vzome.jsweet = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (jsweet) {
        var JsEditContext =
        /*#__PURE__*/
        function () {
          function JsEditContext() {
            _classCallCheck(this, JsEditContext);
          }
          /**
          *
          * @param {*} xml
          * @return {com.vzome.core.editor.api.UndoableEdit}
          */


          _createClass(JsEditContext, [{
            key: "createEdit",
            value: function createEdit(xml) {
              throw new java.lang.RuntimeException("unimplemented");
            }
            /**
            *
            * @param {com.vzome.core.editor.api.UndoableEdit} edit
            */

          }, {
            key: "performAndRecord",
            value: function performAndRecord(edit) {
              throw new java.lang.RuntimeException("unimplemented");
            }
            /**
            *
            * @param {string} cmdName
            * @return {*}
            */

          }, {
            key: "createLegacyCommand",
            value: function createLegacyCommand(cmdName) {
              throw new java.lang.RuntimeException("unimplemented");
            }
          }]);

          return JsEditContext;
        }();

        jsweet.JsEditContext = JsEditContext;
        JsEditContext["__class"] = "com.vzome.jsweet.JsEditContext";
        JsEditContext["__interfaces"] = ["com.vzome.core.editor.api.UndoableEdit.Context"];
      })(vzome.jsweet || (vzome.jsweet = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (jsweet) {
        var JsRealizedModel =
        /*#__PURE__*/
        function () {
          function JsRealizedModel(field, adapter) {
            _classCallCheck(this, JsRealizedModel);

            if (this.field === undefined) this.field = null;
            if (this.adapter === undefined) this.adapter = null;
            this.field = field;
            this.adapter = adapter;
          }

          _createClass(JsRealizedModel, [{
            key: "setAdapter",
            value: function setAdapter(adapter) {
              this.adapter = adapter;
            }
            /**
            *
            * @return {*}
            */

          }, {
            key: "iterator",
            value: function iterator() {
              var f = this.adapter["allIterator"];
              var jSiterator = f.apply(this.adapter);
              return new JsRealizedModel.JsRealizedModel$0(this, jSiterator);
            }
            /**
            *
            * @return {*}
            */

          }, {
            key: "getField",
            value: function getField() {
              return this.field;
            }
            /**
            *
            * @param {com.vzome.core.construction.Construction} c
            * @return {*}
            */

          }, {
            key: "findConstruction",
            value: function findConstruction(c) {
              if (c == null) return null;
              var vectors = com.vzome.jsweet.JsManifestation.canonicalizeConstruction(c);
              if (vectors == null) return null;
              vectors = this.adapter["findOrCreateManifestation"].apply(this.adapter, [vectors]);
              if (vectors == null) return null;
              return com.vzome.jsweet.JsManifestation.manifest(vectors, this.field, this.adapter);
            }
            /**
            *
            * @param {*} man
            */

          }, {
            key: "remove",
            value: function remove(man) {
              var vectors = man.getVectors();
              this.adapter["delete"].apply(this.adapter, [vectors]);
            }
            /**
            *
            * @param {com.vzome.core.construction.Construction} c
            * @return {*}
            */

          }, {
            key: "getManifestation",
            value: function getManifestation(c) {
              return this.findConstruction(c);
            }
            /**
            *
            * @param {*} man
            */

          }, {
            key: "show",
            value: function show(man) {
              var vectors = man.getVectors();
              this.adapter["showManifestation"].apply(this.adapter, [vectors]);
            }
            /**
            *
            * @param {*} man
            */

          }, {
            key: "hide",
            value: function hide(man) {
              var vectors = man.getVectors();
              this.adapter["hideManifestation"].apply(this.adapter, [vectors]);
            }
            /**
            *
            * @param {*} man
            * @param {com.vzome.core.construction.Color} color
            */

          }, {
            key: "setColor",
            value: function setColor(man, color) {
              man.setColor(color);
            }
            /**
            *
            * @param {*} man
            */

          }, {
            key: "add",
            value: function add(man) {
              var vectors = man.getVectors();
              this.adapter["showManifestation"].apply(this.adapter, [vectors]);
            }
            /**
            *
            * @param {*} m
            * @return {*}
            */

          }, {
            key: "findPerEditManifestation",
            value: function findPerEditManifestation(m) {
              return null;
            }
            /**
            *
            * @param {*} m
            */

          }, {
            key: "addPerEditManifestation",
            value: function addPerEditManifestation(m) {}
            /**
            *
            */

          }, {
            key: "clearPerEditManifestations",
            value: function clearPerEditManifestations() {}
            /**
            *
            * @param {com.vzome.core.construction.Construction} c
            * @return {*}
            */

          }, {
            key: "removeConstruction",
            value: function removeConstruction(c) {
              throw new java.lang.RuntimeException("unimplemented");
            }
            /**
            *
            * @return {number}
            */

          }, {
            key: "size",
            value: function size() {
              throw new java.lang.RuntimeException("unimplemented");
            }
          }]);

          return JsRealizedModel;
        }();

        jsweet.JsRealizedModel = JsRealizedModel;
        JsRealizedModel["__class"] = "com.vzome.jsweet.JsRealizedModel";
        JsRealizedModel["__interfaces"] = ["com.vzome.core.model.RealizedModel", "java.lang.Iterable"];

        (function (JsRealizedModel) {
          var JsRealizedModel$0 =
          /*#__PURE__*/
          function () {
            function JsRealizedModel$0(__parent, jSiterator) {
              _classCallCheck(this, JsRealizedModel$0);

              this.jSiterator = jSiterator;
              this.__parent = __parent;
              this.peek = this.jSiterator.next();
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(JsRealizedModel$0, [{
              key: "hasNext",
              value: function hasNext() {
                return !this.peek.done;
              }
              /**
              *
              * @return {*}
              */

            }, {
              key: "next",
              value: function next() {
                var result = com.vzome.jsweet.JsManifestation.manifest(this.peek.value, this.__parent.field, this.__parent.adapter);
                this.peek = this.jSiterator.next();
                return result;
              }
            }]);

            return JsRealizedModel$0;
          }();

          JsRealizedModel.JsRealizedModel$0 = JsRealizedModel$0;
          JsRealizedModel$0["__interfaces"] = ["java.util.Iterator"];
        })(JsRealizedModel = jsweet.JsRealizedModel || (jsweet.JsRealizedModel = {}));
      })(vzome.jsweet || (vzome.jsweet = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (jsweet) {
        var JsAlgebraicField =
        /*#__PURE__*/
        function () {
          function JsAlgebraicField(delegate) {
            _classCallCheck(this, JsAlgebraicField);

            if (this.delegate === undefined) this.delegate = null;
            if (this.positivePowers === undefined) this.positivePowers = null;
            if (this.negativePowers === undefined) this.negativePowers = null;
            this.delegate = delegate;
            var order = delegate["order"];

            this.positivePowers = function (s) {
              var a = [];

              while (s-- > 0) {
                a.push(null);
              }

              return a;
            }(order - 1);

            this.negativePowers = function (s) {
              var a = [];

              while (s-- > 0) {
                a.push(null);
              }

              return a;
            }(order - 1);
          }
          /**
          *
          * @return {string}
          */


          _createClass(JsAlgebraicField, [{
            key: "getName",
            value: function getName() {
              return this.delegate["name"];
            }
            /**
            *
            * @return {number}
            */

          }, {
            key: "getOrder",
            value: function getOrder() {
              return this.delegate["order"];
            }
            /**
            *
            * @return {number}
            */

          }, {
            key: "getNumIrrationals",
            value: function getNumIrrationals() {
              return this.getOrder() - 1;
            }
          }, {
            key: "add",
            value: function add(v1, v2) {
              var f = this.delegate["plus"];
              return f(v1, v2);
            }
          }, {
            key: "subtract",
            value: function subtract(v1, v2) {
              var f = this.delegate["minus"];
              return f(v1, v2);
            }
          }, {
            key: "multiply",
            value: function multiply(v1, v2) {
              var f = this.delegate["times"];
              return f(v1, v2);
            }
          }, {
            key: "evaluateNumber",
            value: function evaluateNumber(factors) {
              var f = this.delegate["embed"];
              return f(factors);
            }
          }, {
            key: "reciprocal",
            value: function reciprocal(factors) {
              var f = this.delegate["reciprocal"];
              return f(factors);
            }
          }, {
            key: "negate",
            value: function negate(factors) {
              var f = this.delegate["negate"];
              return f(factors);
            }
            /**
            *
            * @param {Array} trailingDivisorForm
            * @return {*}
            */

          }, {
            key: "createAlgebraicNumberFromTD",
            value: function createAlgebraicNumberFromTD(trailingDivisorForm) {
              return new com.vzome.jsweet.JsAlgebraicNumber(this, trailingDivisorForm);
            }
          }, {
            key: "createAlgebraicNumberFromPairs",
            value: function createAlgebraicNumberFromPairs(pairs) {
              var f = this.delegate["createRationalFromPairs"];
              var frac = f(pairs);
              return new com.vzome.jsweet.JsAlgebraicNumber(this, frac);
            }
          }, {
            key: "createRational$long$long",
            value: function createRational$long$long(numerator, denominator) {
              var f = this.delegate["createRational"];
              var frac = f(numerator, denominator);
              return new com.vzome.jsweet.JsAlgebraicNumber(this, frac);
            }
            /**
            *
            * @param {number} numerator
            * @param {number} denominator
            * @return {*}
            */

          }, {
            key: "createRational",
            value: function createRational(numerator, denominator) {
              if ((typeof numerator === 'number' || numerator === null) && (typeof denominator === 'number' || denominator === null)) {
                return this.createRational$long$long(numerator, denominator);
              } else if ((typeof numerator === 'number' || numerator === null) && denominator === undefined) {
                return this.createRational$long(numerator);
              } else throw new Error('invalid overload');
            }
            /**
            *
            * @return {*}
            */

          }, {
            key: "zero",
            value: function zero() {
              return new com.vzome.jsweet.JsAlgebraicNumber(this, this.delegate["zero"]);
            }
            /**
            *
            * @return {*}
            */

          }, {
            key: "one",
            value: function one() {
              return new com.vzome.jsweet.JsAlgebraicNumber(this, this.delegate["one"]);
            }
            /**
            *
            * @param {Array} nums
            * @return {com.vzome.core.algebra.AlgebraicVector}
            */

          }, {
            key: "createVector",
            value: function createVector(nums) {
              var x = this.createAlgebraicNumberFromPairs(nums[0]);
              var y = this.createAlgebraicNumberFromPairs(nums[1]);
              var z = this.createAlgebraicNumberFromPairs(nums[2]);
              return new com.vzome.core.algebra.AlgebraicVector(x, y, z);
            }
            /**
            *
            * @param {Array} nums
            * @return {com.vzome.core.algebra.AlgebraicVector}
            */

          }, {
            key: "createVectorFromTDs",
            value: function createVectorFromTDs(nums) {
              var x = this.createAlgebraicNumberFromTD(nums[0]);
              var y = this.createAlgebraicNumberFromTD(nums[1]);
              var z = this.createAlgebraicNumberFromTD(nums[2]);
              return new com.vzome.core.algebra.AlgebraicVector(x, y, z);
            }
            /**
            *
            * @param {number} dims
            * @return {com.vzome.core.algebra.AlgebraicVector}
            */

          }, {
            key: "origin",
            value: function origin(dims) {
              var zero = this.zero();

              switch (dims) {
                case 1:
                  return new com.vzome.core.algebra.AlgebraicVector(zero);

                case 2:
                  return new com.vzome.core.algebra.AlgebraicVector(zero, zero);

                case 3:
                  return new com.vzome.core.algebra.AlgebraicVector(zero, zero, zero);

                case 4:
                  return new com.vzome.core.algebra.AlgebraicVector(zero, zero, zero, zero);

                case 5:
                  return new com.vzome.core.algebra.AlgebraicVector(zero, zero, zero, zero, zero);

                default:
                  return null;
              }
            }
            /**
            *
            * @return {boolean}
            */

          }, {
            key: "scale4dRoots",
            value: function scale4dRoots() {
              return false;
            }
            /**
            *
            * @return {boolean}
            */

          }, {
            key: "doubleFrameVectors",
            value: function doubleFrameVectors() {
              return false;
            }
            /**
            *
            * @param {number} dims
            * @param {number} axis
            * @return {com.vzome.core.algebra.AlgebraicVector}
            */

          }, {
            key: "basisVector",
            value: function basisVector(dims, axis) {
              var result = this.origin(dims);
              return result.setComponent(axis, this.one());
            }
          }, {
            key: "createRational$long",
            value: function createRational$long(wholeNumber) {
              return this.createRational$long$long(wholeNumber, 1);
            }
          }, {
            key: "createPower$int",
            value: function createPower$int(power) {
              return this.createPower$int$int(power, 1);
            }
          }, {
            key: "createPower$int$int",
            value: function createPower$int$int(power, irr) {
              var one = this.one();
              if (power === 0 || irr === 0) return one;
              irr -= 1;

              if (power > 0) {
                if (this.positivePowers[irr] == null) this.positivePowers[irr] = new java.util.ArrayList(8);

                if (power >= this.positivePowers[irr].size()) {
                  if (this.positivePowers[irr].isEmpty()) {
                    this.positivePowers[irr].add(one);
                    this.positivePowers[irr].add(this.getUnitTerm(irr + 1));
                  }

                  var size = this.positivePowers[irr].size();
                  var irrat = this.positivePowers[irr].get(1);
                  var last = this.positivePowers[irr].get(size - 1);

                  for (var i = size; i <= power; i++) {
                    {
                      var next = last['times$com_vzome_core_algebra_AlgebraicNumber'](irrat);
                      this.positivePowers[irr].add(next);
                      last = next;
                    }
                  }
                }

                return this.positivePowers[irr].get(power);
              } else {
                power = -power;
                if (this.negativePowers[irr] == null) this.negativePowers[irr] = new java.util.ArrayList(8);

                if (power >= this.negativePowers[irr].size()) {
                  if (this.negativePowers[irr].isEmpty()) {
                    this.negativePowers[irr].add(one);
                    this.negativePowers[irr].add(this.getUnitTerm(irr + 1).reciprocal());
                  }

                  var _size = this.negativePowers[irr].size();

                  var _irrat = this.negativePowers[irr].get(1);

                  var _last = this.negativePowers[irr].get(_size - 1);

                  for (var _i29 = _size; _i29 <= power; _i29++) {
                    {
                      var _next = _last['times$com_vzome_core_algebra_AlgebraicNumber'](_irrat);

                      this.negativePowers[irr].add(_next);
                      _last = _next;
                    }
                  }
                }

                return this.negativePowers[irr].get(power);
              }
            }
            /**
            *
            * @param {number} power
            * @param {number} irr
            * @return {*}
            */

          }, {
            key: "createPower",
            value: function createPower(power, irr) {
              if ((typeof power === 'number' || power === null) && (typeof irr === 'number' || irr === null)) {
                return this.createPower$int$int(power, irr);
              } else if ((typeof power === 'number' || power === null) && irr === undefined) {
                return this.createPower$int(power);
              } else throw new Error('invalid overload');
            }
            /**
            * @param {number} n specifies the ordinal of the term in the AlgebraicNumber which will be set to one.
            * When {@code n == 0}, the result is the same as {@code createRational(1)}.
            * When {@code n == 1}, the result is the same as {@code createPower(1)}.
            * When {@code n < 0}, the result will be {@code zero()}.
            * When {@code n >= getOrder()}, an IndexOutOfBoundsException will be thrown.
            * @return {*} an AlgebraicNumber with the factor specified by {@code n} set to one.
            */

          }, {
            key: "getUnitTerm",
            value: function getUnitTerm(n) {
              if (n < 0) {
                return this.zero();
              }

              var factors = this.zero().toTrailingDivisor();
              factors[n] = 1;
              return this.createAlgebraicNumber$int_A(factors);
            }
          }, {
            key: "createAlgebraicNumber$int_A",
            value: function createAlgebraicNumber$int_A(terms) {
              return this.createAlgebraicNumber$int_A$int(terms, 1);
            }
          }, {
            key: "createAlgebraicNumber$int_A$int",
            value: function createAlgebraicNumber$int_A$int(numerators, denominator) {
              var factors = function (s) {
                var a = [];

                while (s-- > 0) {
                  a.push(0);
                }

                return a;
              }(numerators.length + 1);

              java.lang.System.arraycopy(numerators, 0, factors, 0, numerators.length);
              factors[numerators.length] = denominator;
              return new com.vzome.jsweet.JsAlgebraicNumber(this, factors);
            }
            /**
            *
            * @return {*}
            */

          }, {
            key: "getGoldenRatio",
            value: function getGoldenRatio() {
              var value = this.delegate["goldenRatio"];
              if (value == null) return null;
              return new com.vzome.jsweet.JsAlgebraicNumber(this, value);
            }
            /**
            *
            * @param {number} dims
            * @return {com.vzome.core.algebra.AlgebraicMatrix}
            */

          }, {
            key: "identityMatrix",
            value: function identityMatrix(dims) {
              var columns = function (s) {
                var a = [];

                while (s-- > 0) {
                  a.push(null);
                }

                return a;
              }(dims);

              for (var i = 0; i < columns.length; i++) {
                {
                  columns[i] = this.basisVector(dims, i);
                }
              }

              return new com.vzome.core.algebra.AlgebraicMatrix(columns);
            }
            /**
            * Modeled after AbstractAlgebraicField, with a switch from BigRationals to int[]s.
            * @param {string} string
            * @param {boolean} isRational
            * @return {*}
            */

          }, {
            key: "parseVefNumber",
            value: function parseVefNumber(string, isRational) {
              var pairs = function (s) {
                var a = [];

                while (s-- > 0) {
                  a.push(0);
                }

                return a;
              }(this.getOrder() + 1);

              if (!isRational &&
              /* startsWith */
              function (str, searchString) {
                var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                return str.substr(position, searchString.length) === searchString;
              }(string, "(") &&
              /* endsWith */
              function (str, searchString) {
                var pos = str.length - searchString.length;
                var lastIndex = str.indexOf(searchString, pos);
                return lastIndex !== -1 && lastIndex === pos;
              }(string, ")")) {
                var tokens = new java.util.StringTokenizer(string.substring(1, string.length - 1), ",");
                var numStack = new java.util.Stack();
                var denomStack = new java.util.Stack();

                while (tokens.hasMoreTokens()) {
                  {
                    if (numStack.size() >= this.getOrder()) {
                      throw new java.lang.RuntimeException("VEF format error: \"" + string + "\" has too many factors for " + this.getName() + " field");
                    }

                    var parts = tokens.nextToken().split("/");
                    numStack.push(javaemul.internal.IntegerHelper.parseInt(parts[0]));
                    denomStack.push(parts.length > 1 ? javaemul.internal.IntegerHelper.parseInt(parts[1]) : 1);
                  }
                }

                var i = 0;

                while (!numStack.empty()) {
                  {
                    pairs[i++] = numStack.pop();
                    pairs[i++] = denomStack.pop();
                  }
                }
              } else {
                var _parts = string.split("/");

                pairs[0] = javaemul.internal.IntegerHelper.parseInt(_parts[0]);
                pairs[1] = _parts.length > 1 ? javaemul.internal.IntegerHelper.parseInt(_parts[1]) : 1;
              }

              return this.createAlgebraicNumberFromPairs(pairs);
            }
            /**
            * Drop one coordinate from the 4D vector. If wFirst (the usual), then drop
            * the first coordinate, taking the "imaginary part" of the vector. If
            * !wFirst (for old VEF import, etc.), drop the last coordinate.
            *
            * @param {com.vzome.core.algebra.AlgebraicVector} source
            * @param {boolean} wFirst
            * @return
            * @return {com.vzome.core.algebra.AlgebraicVector}
            */

          }, {
            key: "projectTo3d",
            value: function projectTo3d(source, wFirst) {
              if (source.dimension() === 3) return source;else {
                var result = this.origin(3);

                for (var i = 0; i < 3; i++) {
                  result.setComponent(i, source.getComponent(wFirst ? i + 1 : i));
                }

                return result;
              }
            }
          }, {
            key: "createAlgebraicNumber$int$int$int$int",
            value: function createAlgebraicNumber$int$int$int$int(ones, irrat, denominator, scalePower) {
              var result = this.createAlgebraicNumberFromTD([ones, irrat, denominator]);

              if (scalePower !== 0) {
                var multiplier = this.createPower$int(scalePower);
                return result['times$com_vzome_core_algebra_AlgebraicNumber'](multiplier);
              } else return result;
            }
            /**
            *
            * @param {number} ones
            * @param {number} irrat
            * @param {number} denominator
            * @param {number} scalePower
            * @return {*}
            */

          }, {
            key: "createAlgebraicNumber",
            value: function createAlgebraicNumber(ones, irrat, denominator, scalePower) {
              if ((typeof ones === 'number' || ones === null) && (typeof irrat === 'number' || irrat === null) && (typeof denominator === 'number' || denominator === null) && (typeof scalePower === 'number' || scalePower === null)) {
                return this.createAlgebraicNumber$int$int$int$int(ones, irrat, denominator, scalePower);
              } else if ((ones != null && ones instanceof Array && (ones.length == 0 || ones[0] == null || typeof ones[0] === 'number') || ones === null) && (typeof irrat === 'number' || irrat === null) && denominator === undefined && scalePower === undefined) {
                return this.createAlgebraicNumber$int_A$int(ones, irrat);
              } else if ((ones != null && ones instanceof Array && (ones.length == 0 || ones[0] == null || typeof ones[0] === 'number') || ones === null) && irrat === undefined && denominator === undefined && scalePower === undefined) {
                return this.createAlgebraicNumber$int_A(ones);
              } else throw new Error('invalid overload');
            }
            /**
            *
            * @param {string} nums
            * @return {com.vzome.core.algebra.AlgebraicVector}
            */

          }, {
            key: "parseVector",
            value: function parseVector(nums) {
              var tokens = new java.util.StringTokenizer(nums, " ");
              var numToks = tokens.countTokens();
              if (numToks % this.getOrder() !== 0) throw new java.lang.IllegalStateException("Field order (" + this.getOrder() + ") does not divide token count: " + numToks + ", for \'" + nums + "\'");
              var dims = numToks / this.getOrder() | 0;

              var coords = function (s) {
                var a = [];

                while (s-- > 0) {
                  a.push(null);
                }

                return a;
              }(dims);

              for (var i = 0; i < dims; i++) {
                {
                  coords[i] = this.parseNumber$java_util_StringTokenizer(tokens);
                }
              }

              return new com.vzome.core.algebra.AlgebraicVector(coords);
            }
          }, {
            key: "parseNumber$java_lang_String",
            value: function parseNumber$java_lang_String(nums) {
              var tokens = new java.util.StringTokenizer(nums, " ");
              return this.parseNumber$java_util_StringTokenizer(tokens);
            }
            /**
            *
            * @param {string} nums
            * @return {*}
            */

          }, {
            key: "parseNumber",
            value: function parseNumber(nums) {
              if (typeof nums === 'string' || nums === null) {
                return this.parseNumber$java_lang_String(nums);
              } else if (nums != null && nums instanceof java.util.StringTokenizer || nums === null) {
                return this.parseNumber$java_util_StringTokenizer(nums);
              } else throw new Error('invalid overload');
            }
            /*private*/

          }, {
            key: "parseNumber$java_util_StringTokenizer",
            value: function parseNumber$java_util_StringTokenizer(tokens) {
              var order = this.getOrder();

              var pairs = function (s) {
                var a = [];

                while (s-- > 0) {
                  a.push(0);
                }

                return a;
              }(order * 2);

              for (var i = 0; i < order; i++) {
                {
                  var digit = tokens.nextToken();
                  var parts = digit.split("/");
                  pairs[i * 2] = javaemul.internal.IntegerHelper.parseInt(parts[0]);
                  if (parts.length > 1) pairs[i * 2 + 1] = javaemul.internal.IntegerHelper.parseInt(parts[1]);else pairs[i * 2 + 1] = 1;
                }
              }

              return this.createAlgebraicNumberFromPairs(pairs);
            }
            /**
            *
            * @param {string} string
            * @return {*}
            */

          }, {
            key: "parseLegacyNumber",
            value: function parseLegacyNumber(string) {
              var div = 1;

              if (
              /* startsWith */
              function (str, searchString) {
                var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                return str.substr(position, searchString.length) === searchString;
              }(string, "(")) {
                var closeParen = string.indexOf(')');
                div = javaemul.internal.IntegerHelper.parseInt(string.substring(closeParen + 2));
                string = string.substring(1, closeParen);
              }

              var phis = 0;
              var phiIndex = string.indexOf("phi");

              if (phiIndex >= 0) {
                var part = string.substring(0, phiIndex);
                if (part.length === 0) phis = 1;else if (
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(part, "-")) phis = -1;else phis = javaemul.internal.IntegerHelper.parseInt(part);
                string = string.substring(phiIndex + 3);
              }

              var ones;
              if (string.length === 0) ones = 0;else {
                if (
                /* startsWith */
                function (str, searchString) {
                  var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                  return str.substr(position, searchString.length) === searchString;
                }(string, "+")) string = string.substring(1);
                ones = javaemul.internal.IntegerHelper.parseInt(string);
              }
              return this.createAlgebraicNumber$int$int$int$int(ones, phis, div, 0);
            }
            /**
            *
            * @param {Array} nums
            * @return {com.vzome.core.algebra.AlgebraicVector}
            */

          }, {
            key: "createIntegerVectorFromTDs",
            value: function createIntegerVectorFromTDs(nums) {
              var dims = nums.length;
              var result = this.origin(dims);

              for (var dim = 0; dim < dims; dim++) {
                {
                  result.setComponent(dim, this.createAlgebraicNumberFromTD(nums[dim]));
                }
              }

              return result;
            }
          }, {
            key: "scaleBy",
            value: function scaleBy(factors, whichIrrational) {
              throw new java.lang.RuntimeException("unimplemented");
            }
            /**
            *
            * @param {java.lang.StringBuffer} instances
            * @param {number} w
            */

          }, {
            key: "defineMultiplier",
            value: function defineMultiplier(instances, w) {
              throw new java.lang.RuntimeException("unimplemented");
            }
          }, {
            key: "getIrrational$int$int",
            value: function getIrrational$int$int(i, format) {
              throw new java.lang.RuntimeException("unimplemented");
            }
            /**
            *
            * @param {number} i
            * @param {number} format
            * @return {string}
            */

          }, {
            key: "getIrrational",
            value: function getIrrational(i, format) {
              if ((typeof i === 'number' || i === null) && (typeof format === 'number' || format === null)) {
                return this.getIrrational$int$int(i, format);
              } else if ((typeof i === 'number' || i === null) && format === undefined) {
                return this.getIrrational$int(i);
              } else throw new Error('invalid overload');
            }
          }, {
            key: "getIrrational$int",
            value: function getIrrational$int(which) {
              throw new java.lang.RuntimeException("unimplemented");
            }
            /**
            *
            * @param {com.vzome.core.math.RealVector} target
            * @return {com.vzome.core.algebra.AlgebraicVector}
            */

          }, {
            key: "nearestAlgebraicVector",
            value: function nearestAlgebraicVector(target) {
              throw new java.lang.RuntimeException("unimplemented");
            }
            /**
            *
            * @return {*}
            */

          }, {
            key: "getAffineScalar",
            value: function getAffineScalar() {
              throw new java.lang.RuntimeException("unimplemented");
            }
            /**
            *
            * @param {Array} nums
            * @return {com.vzome.core.algebra.AlgebraicVector}
            */

          }, {
            key: "createIntegerVector",
            value: function createIntegerVector(nums) {
              throw new java.lang.RuntimeException("unimplemented");
            }
            /**
            *
            * @param {Array} data
            * @return {com.vzome.core.algebra.AlgebraicMatrix}
            */

          }, {
            key: "createMatrix",
            value: function createMatrix(data) {
              throw new java.lang.RuntimeException("unimplemented");
            }
            /**
            *
            * @return {number}
            */

          }, {
            key: "getNumMultipliers",
            value: function getNumMultipliers() {
              throw new java.lang.RuntimeException("unimplemented");
            }
          }]);

          return JsAlgebraicField;
        }();

        jsweet.JsAlgebraicField = JsAlgebraicField;
        JsAlgebraicField["__class"] = "com.vzome.jsweet.JsAlgebraicField";
        JsAlgebraicField["__interfaces"] = ["com.vzome.core.algebra.AlgebraicField"];
      })(vzome.jsweet || (vzome.jsweet = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (jsweet) {
        var JsManifestation =
        /*#__PURE__*/
        function () {
          function JsManifestation(field, adapter, vectors) {
            _classCallCheck(this, JsManifestation);

            if (this.vectors === undefined) this.vectors = null;
            if (this.field === undefined) this.field = null;
            if (this.adapter === undefined) this.adapter = null;
            this.field = field;
            this.adapter = adapter;
            this.vectors = vectors;
          }

          _createClass(JsManifestation, [{
            key: "getVectors",
            value: function getVectors() {
              return this.vectors;
            }
            /**
            *
            * @return {com.vzome.core.construction.Color}
            */

          }, {
            key: "getColor",
            value: function getColor() {
              var colorful = this.adapter["manifestationHasColor"].apply(this.adapter, [this.vectors]);
              if (!colorful) return null;
              var rgb = this.adapter["manifestationColor"].apply(this.adapter, [this.vectors]) | 0;
              return new com.vzome.core.construction.Color(rgb);
            }
            /**
            *
            * @param {com.vzome.core.construction.Color} color
            */

          }, {
            key: "setColor",
            value: function setColor(color) {
              if (color != null) this.adapter["setManifestationColor"].apply(this.adapter, [this.vectors, color.getRGB()]);
            }
            /**
            *
            * @return {boolean}
            */

          }, {
            key: "isRendered",
            value: function isRendered() {
              return this.adapter["manifestationRendered"].apply(this.adapter, [this.vectors]);
            }
            /**
            *
            * @param {com.vzome.core.construction.Construction} mConstruction
            */

          }, {
            key: "addConstruction",
            value: function addConstruction(mConstruction) {}
            /**
            *
            * @param {com.vzome.core.construction.Construction} mConstruction
            */

          }, {
            key: "removeConstruction",
            value: function removeConstruction(mConstruction) {}
            /**
            *
            * @return {boolean}
            */

          }, {
            key: "isUnnecessary",
            value: function isUnnecessary() {
              return true;
            }
            /**
            *
            * @return {com.vzome.core.construction.Construction}
            */

          }, {
            key: "getFirstConstruction",
            value: function getFirstConstruction() {
              return this.toConstruction();
            }
          }, {
            key: "setHidden",

            /**
            *
            * @param {boolean} b
            */
            value: function setHidden(b) {}
            /**
            *
            * @return {boolean}
            */

          }, {
            key: "isHidden",
            value: function isHidden() {
              return this.adapter["manifestationHidden"].apply(this.adapter, [this.vectors]);
            }
            /**
            *
            * @param {com.vzome.core.model.Group} container
            */

          }, {
            key: "setContainer",
            value: function setContainer(container) {
              throw new java.lang.RuntimeException("unimplemented");
            }
            /**
            *
            * @return {com.vzome.core.model.Group}
            */

          }, {
            key: "getContainer",
            value: function getContainer() {
              var members = this.adapter["getLargestGroup"].apply(this.adapter, [this.vectors]);
              if (members == null) return null;
              var group = new com.vzome.core.model.Group();

              for (var i = 0; i < members.length; i++) {
                {
                  group.add(JsManifestation.manifest(members[i], this.field, this.adapter));
                }
              }

              return group;
            }
            /**
            *
            * @return {*}
            */

          }, {
            key: "getConstructions",
            value: function getConstructions() {
              throw new java.lang.RuntimeException("unimplemented");
            }
            /**
            *
            * @param {*} doc
            * @return {*}
            */

          }, {
            key: "getXml",
            value: function getXml(doc) {
              throw new java.lang.RuntimeException("unimplemented");
            }
            /**
            *
            * @return {com.vzome.core.algebra.AlgebraicVector}
            */

          }, {
            key: "getCentroid",
            value: function getCentroid() {
              throw new java.lang.RuntimeException("unimplemented");
            }
          }], [{
            key: "canonicalizeNumbers",
            value: function canonicalizeNumbers() {
              for (var _len = arguments.length, ns = new Array(_len), _key = 0; _key < _len; _key++) {
                ns[_key] = arguments[_key];
              }

              return java.util.Arrays.stream(ns).map(function (n) {
                return n.toTrailingDivisor();
              }).toArray();
            }
            /**
            * Note: this does NOT order the vectors canonically in the outermost array
            * @param {Array} vs
            * @return
            * @return {Array}
            */

          }, {
            key: "canonicalizeVectors",
            value: function canonicalizeVectors() {
              var _this28 = this;

              for (var _len2 = arguments.length, vs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                vs[_key2] = arguments[_key2];
              }

              return java.util.Arrays.stream(vs).map(function (v) {
                return JsManifestation.canonicalizeNumbers.apply(_this28, v.getComponents());
              }).toArray();
            }
          }, {
            key: "canonicalizeConstruction",
            value: function canonicalizeConstruction(c) {
              if (c != null && c instanceof com.vzome.core.construction.Point) {
                var p = c;
                return JsManifestation.canonicalizeVectors(p.getLocation());
              } else if (c != null && c instanceof com.vzome.core.construction.Segment) {
                var s = c;
                return JsManifestation.canonicalizeVectors(s.getStart(), s.getEnd());
              } else if (c != null && c instanceof com.vzome.core.construction.Polygon) {
                return JsManifestation.canonicalizeVectors.apply(this, c.getVertices());
              }

              return null;
            }
          }, {
            key: "manifest",
            value: function manifest(vectors, field, adapter) {
              switch (vectors.length) {
                case 1:
                  return new com.vzome.jsweet.JsBall(field, adapter, vectors);

                case 2:
                  return new com.vzome.jsweet.JsStrut(field, adapter, vectors);

                default:
                  return new com.vzome.jsweet.JsPanel(field, adapter, vectors);
              }
            }
          }]);

          return JsManifestation;
        }();

        jsweet.JsManifestation = JsManifestation;
        JsManifestation["__class"] = "com.vzome.jsweet.JsManifestation";
        JsManifestation["__interfaces"] = ["com.vzome.core.model.GroupElement", "com.vzome.core.model.Manifestation"];
      })(vzome.jsweet || (vzome.jsweet = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (jsweet) {
        var JsAlgebraicNumber =
        /*#__PURE__*/
        function () {
          function JsAlgebraicNumber(field, factors) {
            _classCallCheck(this, JsAlgebraicNumber);

            if (this.field === undefined) this.field = null;
            if (this.factors === undefined) this.factors = null;
            this.field = field;
            this.factors = factors.slice();
          }
          /**
          *
          * @return {*}
          */


          _createClass(JsAlgebraicNumber, [{
            key: "getField",
            value: function getField() {
              return this.field;
            }
            /**
            *
            * @return {number}
            */

          }, {
            key: "evaluate",
            value: function evaluate() {
              return this.field.evaluateNumber(this.factors);
            }
            /**
            *
            * @return {Array}
            */

          }, {
            key: "toTrailingDivisor",
            value: function toTrailingDivisor() {
              return this.factors.slice();
            }
          }, {
            key: "plus$int",
            value: function plus$int(n) {
              return n === 0 ? this : this.plus$com_vzome_core_algebra_AlgebraicNumber(this.field.createRational$long(n));
            }
          }, {
            key: "plus$int$int",
            value: function plus$int$int(num, den) {
              return this.plus$com_vzome_core_algebra_AlgebraicNumber(this.field.createRational$long$long(num, den));
            }
            /**
            *
            * @param {number} num is the numerator of the rational value to be added
            * @param {number} den is the denominator of the rational value to be added
            * @return {*} this + (num / den)
            */

          }, {
            key: "plus",
            value: function plus(num, den) {
              if ((typeof num === 'number' || num === null) && (typeof den === 'number' || den === null)) {
                return this.plus$int$int(num, den);
              } else if ((num != null && (num["__interfaces"] != null && num["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0 || num.constructor != null && num.constructor["__interfaces"] != null && num.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0) || num === null) && den === undefined) {
                return this.plus$com_vzome_core_algebra_AlgebraicNumber(num);
              } else if ((typeof num === 'number' || num === null) && den === undefined) {
                return this.plus$int(num);
              } else throw new Error('invalid overload');
            }
          }, {
            key: "plus$com_vzome_core_algebra_AlgebraicNumber",
            value: function plus$com_vzome_core_algebra_AlgebraicNumber(that) {
              var factors = this.field.add(this.factors, that.factors);
              return new JsAlgebraicNumber(this.field, factors);
            }
          }, {
            key: "minus$int",
            value: function minus$int(n) {
              return n === 0 ? this : this.minus$com_vzome_core_algebra_AlgebraicNumber(this.field.createRational$long(n));
            }
          }, {
            key: "minus$int$int",
            value: function minus$int$int(num, den) {
              return this.minus$com_vzome_core_algebra_AlgebraicNumber(this.field.createRational$long$long(num, den));
            }
            /**
            *
            * @param {number} num
            * @param {number} den
            * @return {*}
            */

          }, {
            key: "minus",
            value: function minus(num, den) {
              if ((typeof num === 'number' || num === null) && (typeof den === 'number' || den === null)) {
                return this.minus$int$int(num, den);
              } else if ((num != null && (num["__interfaces"] != null && num["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0 || num.constructor != null && num.constructor["__interfaces"] != null && num.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0) || num === null) && den === undefined) {
                return this.minus$com_vzome_core_algebra_AlgebraicNumber(num);
              } else if ((typeof num === 'number' || num === null) && den === undefined) {
                return this.minus$int(num);
              } else throw new Error('invalid overload');
            }
          }, {
            key: "minus$com_vzome_core_algebra_AlgebraicNumber",
            value: function minus$com_vzome_core_algebra_AlgebraicNumber(that) {
              var factors = this.field.subtract(this.factors, that.factors);
              return new JsAlgebraicNumber(this.field, factors);
            }
          }, {
            key: "times$com_vzome_core_algebra_AlgebraicNumber",
            value: function times$com_vzome_core_algebra_AlgebraicNumber(that) {
              var factors = this.field.multiply(this.factors, that.factors);
              return new JsAlgebraicNumber(this.field, factors);
            }
          }, {
            key: "dividedBy$int",
            value: function dividedBy$int(divisor) {
              return divisor === 1 ? this : this.times$com_vzome_core_algebra_AlgebraicNumber(this.field.createRational$long$long(1, divisor));
            }
          }, {
            key: "dividedBy$int$int",
            value: function dividedBy$int$int(num, den) {
              return this.times$com_vzome_core_algebra_AlgebraicNumber(this.field.createRational$long$long(den, num));
            }
            /**
            *
            * @param {number} num
            * @param {number} den
            * @return {*}
            */

          }, {
            key: "dividedBy",
            value: function dividedBy(num, den) {
              if ((typeof num === 'number' || num === null) && (typeof den === 'number' || den === null)) {
                return this.dividedBy$int$int(num, den);
              } else if ((num != null && (num["__interfaces"] != null && num["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0 || num.constructor != null && num.constructor["__interfaces"] != null && num.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0) || num === null) && den === undefined) {
                return this.dividedBy$com_vzome_core_algebra_AlgebraicNumber(num);
              } else if ((typeof num === 'number' || num === null) && den === undefined) {
                return this.dividedBy$int(num);
              } else throw new Error('invalid overload');
            }
          }, {
            key: "dividedBy$com_vzome_core_algebra_AlgebraicNumber",
            value: function dividedBy$com_vzome_core_algebra_AlgebraicNumber(that) {
              var recip = this.field.reciprocal(that.factors);
              var factors = this.field.multiply(this.factors, recip);
              return new JsAlgebraicNumber(this.field, factors);
            }
          }, {
            key: "equals",
            value: function equals(that) {
              return java.util.Arrays.equals(this.factors, that.factors);
            }
            /**
            *
            * @return {*}
            */

          }, {
            key: "negate",
            value: function negate() {
              var factors = this.field.negate(this.factors);
              return new JsAlgebraicNumber(this.field, factors);
            }
            /**
            *
            * @return {boolean}
            */

          }, {
            key: "isZero",
            value: function isZero() {
              for (var i = 0; i < this.factors.length - 1; i++) {
                {
                  if (this.factors[i] !== 0) return false;
                }
              }

              return true;
            }
            /**
            *
            * @return {boolean}
            */

          }, {
            key: "isOne",
            value: function isOne() {
              if (this.factors[0] !== 1) return false;
              if (this.factors[this.factors.length - 1] !== 1) return false;

              for (var i = 1; i < this.factors.length - 1; i++) {
                {
                  if (this.factors[i] !== 0) return false;
                }
              }

              return true;
            }
            /**
            *
            * @return {*}
            */

          }, {
            key: "reciprocal",
            value: function reciprocal() {
              return new JsAlgebraicNumber(this.field, this.field.reciprocal(this.factors));
            }
            /**
            * @param {java.lang.StringBuffer} buf
            * @param {number} format must be one of the following values.
            * The result is formatted as follows:
            * <br>
            * {@code DEFAULT_FORMAT    // 4 + 3φ}<br>
            * {@code EXPRESSION_FORMAT // 4 +3*phi}<br>
            * {@code ZOMIC_FORMAT      // 4 3}<br>
            * {@code VEF_FORMAT        // (3,4)}<br>
            */

          }, {
            key: "getNumberExpression",
            value: function getNumberExpression(buf, format) {
              buf.append(this.toString(format));
            }
            /**
            * @param {number} format must be one of the following values.
            * The result is formatted as follows:
            * <br>
            * {@code DEFAULT_FORMAT    // 4 + 3φ}<br>
            * {@code EXPRESSION_FORMAT // 4 +3*phi}<br>
            * {@code ZOMIC_FORMAT      // 4 3}<br>
            * {@code VEF_FORMAT        // (3,4)}
            * @return {string}
            */

          }, {
            key: "toString",
            value: function toString(format) {
              return java.util.Arrays.toString(this.factors);
            }
            /**
            *
            * @param {*} other
            * @return {number}
            */

          }, {
            key: "compareTo",
            value: function compareTo(other) {
              if (this === other) {
                return 0;
              }

              if (
              /* equals */
              function (o1, o2) {
                if (o1 && o1.equals) {
                  return o1.equals(o2);
                } else {
                  return o1 === o2;
                }
              }(other, this)) {
                return 0;
              }

              var d1 = this.evaluate();
              var d2 = other.evaluate();
              return (
                /* compareTo */
                function (o1, o2) {
                  if (o1 && o1.compareTo) {
                    return o1.compareTo(o2);
                  } else {
                    return o1 < o2 ? -1 : o2 < o1 ? 1 : 0;
                  }
                }(d1, d2)
              );
            }
            /**
            *
            * @param {*} other
            * @return {boolean}
            */

          }, {
            key: "greaterThan",
            value: function greaterThan(other) {
              return this.compareTo(other) > 0;
            }
            /**
            *
            * @param {*} other
            * @return {boolean}
            */

          }, {
            key: "lessThan",
            value: function lessThan(other) {
              return this.compareTo(other) < 0;
            }
            /**
            *
            * @param {*} other
            * @return {boolean}
            */

          }, {
            key: "greaterThanOrEqualTo",
            value: function greaterThanOrEqualTo(other) {
              return this.compareTo(other) >= 0;
            }
            /**
            *
            * @param {*} other
            * @return {boolean}
            */

          }, {
            key: "lessThanOrEqualTo",
            value: function lessThanOrEqualTo(other) {
              return this.compareTo(other) <= 0;
            }
            /**
            *
            * @return {number}
            */

          }, {
            key: "signum",
            value: function signum() {
              return (
                /* intValue */
                javaemul.internal.DoubleHelper.valueOf(
                /* signum */
                function (f) {
                  if (f > 0) {
                    return 1;
                  } else if (f < 0) {
                    return -1;
                  } else {
                    return 0;
                  }
                }(this.evaluate())) | 0
              );
            }
          }, {
            key: "times$int",
            value: function times$int(n) {
              throw new java.lang.RuntimeException("unimplemented");
            }
          }, {
            key: "times$int$int",
            value: function times$int$int(num, den) {
              throw new java.lang.RuntimeException("unimplemented");
            }
            /**
            *
            * @param {number} num
            * @param {number} den
            * @return {*}
            */

          }, {
            key: "times",
            value: function times(num, den) {
              if ((typeof num === 'number' || num === null) && (typeof den === 'number' || den === null)) {
                return this.times$int$int(num, den);
              } else if ((num != null && (num["__interfaces"] != null && num["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0 || num.constructor != null && num.constructor["__interfaces"] != null && num.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0) || num === null) && den === undefined) {
                return this.times$com_vzome_core_algebra_AlgebraicNumber(num);
              } else if ((typeof num === 'number' || num === null) && den === undefined) {
                return this.times$int(num);
              } else throw new Error('invalid overload');
            }
            /**
            *
            * @return {boolean}
            */

          }, {
            key: "isRational",
            value: function isRational() {
              throw new java.lang.RuntimeException("unimplemented");
            }
          }]);

          return JsAlgebraicNumber;
        }();

        jsweet.JsAlgebraicNumber = JsAlgebraicNumber;
        JsAlgebraicNumber["__class"] = "com.vzome.jsweet.JsAlgebraicNumber";
        JsAlgebraicNumber["__interfaces"] = ["com.vzome.core.algebra.Fields.Element", "com.vzome.core.algebra.AlgebraicNumber", "java.lang.Comparable"];
      })(vzome.jsweet || (vzome.jsweet = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (jsweet) {
        var JsEditorModel =
        /*#__PURE__*/
        function () {
          function JsEditorModel(realizedModel, selection, kind, symmetries, symmetrySystems) {
            _classCallCheck(this, JsEditorModel);

            if (this.realizedModel === undefined) this.realizedModel = null;
            if (this.selection === undefined) this.selection = null;
            if (this.kind === undefined) this.kind = null;
            if (this.symmetrySegment === undefined) this.symmetrySegment = null;
            if (this.symmetryCenter === undefined) this.symmetryCenter = null;
            if (this.symmetries === undefined) this.symmetries = null;
            if (this.symmetrySystems === undefined) this.symmetrySystems = null;
            this.realizedModel = realizedModel;
            this.selection = selection;
            this.kind = kind;
            this.symmetries = symmetries;
            this.symmetrySystems = symmetrySystems;
            this.symmetryCenter = new com.vzome.core.construction.FreePoint(realizedModel.getField().origin(3));
          }

          _createClass(JsEditorModel, [{
            key: "setAdapter",
            value: function setAdapter(adapter) {
              this.realizedModel.setAdapter(adapter);
              this.selection.setAdapter(adapter);
            }
            /**
            *
            * @return {*}
            */

          }, {
            key: "getRealizedModel",
            value: function getRealizedModel() {
              return this.realizedModel;
            }
            /**
            *
            * @return {*}
            */

          }, {
            key: "getSelection",
            value: function getSelection() {
              return this.selection;
            }
            /**
            *
            * @return {*}
            */

          }, {
            key: "get4dSymmetries",
            value: function get4dSymmetries() {
              return this.kind;
            }
            /**
            *
            * @return {com.vzome.core.construction.Segment}
            */

          }, {
            key: "getSymmetrySegment",
            value: function getSymmetrySegment() {
              return this.symmetrySegment;
            }
            /**
            *
            * @return {com.vzome.core.construction.Point}
            */

          }, {
            key: "getCenterPoint",
            value: function getCenterPoint() {
              return this.symmetryCenter;
            }
            /**
            *
            * @param {com.vzome.core.construction.Construction} cons
            * @return {boolean}
            */

          }, {
            key: "hasFailedConstruction",
            value: function hasFailedConstruction(cons) {
              return false;
            }
          }, {
            key: "getSymmetrySystem$",
            value: function getSymmetrySystem$() {
              return this.symmetries;
            }
          }, {
            key: "getSymmetrySystem$java_lang_String",
            value: function getSymmetrySystem$java_lang_String(name) {
              return this.symmetrySystems[name];
            }
            /**
            *
            * @param {string} name
            * @return {*}
            */

          }, {
            key: "getSymmetrySystem",
            value: function getSymmetrySystem(name) {
              if (typeof name === 'string' || name === null) {
                return this.getSymmetrySystem$java_lang_String(name);
              } else if (name === undefined) {
                return this.getSymmetrySystem$();
              } else throw new Error('invalid overload');
            }
            /**
            *
            * @param {com.vzome.core.construction.Construction} cons
            */

          }, {
            key: "addFailedConstruction",
            value: function addFailedConstruction(cons) {}
            /**
            *
            * @param {com.vzome.core.construction.Construction} point
            */

          }, {
            key: "setCenterPoint",
            value: function setCenterPoint(point) {
              this.symmetryCenter = point;
            }
            /**
            *
            * @param {com.vzome.core.construction.Segment} segment
            */

          }, {
            key: "setSymmetrySegment",
            value: function setSymmetrySegment(segment) {
              this.symmetrySegment = segment;
            }
            /**
            *
            * @param {java.lang.Class} kind
            * @return {com.vzome.core.construction.Construction}
            */

          }, {
            key: "getSelectedConstruction",
            value: function getSelectedConstruction(kind) {
              throw new java.lang.RuntimeException("unimplemented");
            }
          }]);

          return JsEditorModel;
        }();

        jsweet.JsEditorModel = JsEditorModel;
        JsEditorModel["__class"] = "com.vzome.jsweet.JsEditorModel";
        JsEditorModel["__interfaces"] = ["com.vzome.core.editor.api.EditorModel", "com.vzome.core.editor.api.LegacyEditorModel", "com.vzome.core.editor.api.ImplicitSymmetryParameters", "com.vzome.core.editor.api.SymmetryAware"];
      })(vzome.jsweet || (vzome.jsweet = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (jsweet) {
        var JsAdapter =
        /*#__PURE__*/
        function () {
          function JsAdapter() {
            _classCallCheck(this, JsAdapter);
          }

          _createClass(JsAdapter, null, [{
            key: "mapVectorToJava",
            value: function mapVectorToJava(vector, field) {
              var ans = java.util.stream.Stream.of(vector).map(function (ints) {
                return new com.vzome.jsweet.JsAlgebraicNumber(field, ints);
              }).toArray();
              return new com.vzome.core.algebra.AlgebraicVector(ans);
            }
          }, {
            key: "mapVectorToJavascript",
            value: function mapVectorToJavascript(vector) {
              return java.util.stream.Stream.of(vector.getComponents()).map(function (an) {
                return an.toTrailingDivisor();
              }).toArray();
            }
          }, {
            key: "getZoneGrid",
            value: function getZoneGrid(orbits, planeNormal) {
              var gridPoints = new java.util.ArrayList();
              var field = orbits.getSymmetry().getField();
              var normal = JsAdapter.mapVectorToJava(planeNormal, field);
              var planeOrbits = new com.vzome.core.math.symmetry.PlaneOrbitSet(orbits.getOrbits(), normal);

              for (var iterator = planeOrbits.zones(); iterator.hasNext();) {
                {
                  var zone = iterator.next();
                  var orbit = zone.getDirection();
                  if (!orbit.isStandard()) continue;
                  var scale = orbit.getUnitLength();

                  for (var i = 0; i < 5; i++) {
                    {
                      scale = scale['times$com_vzome_core_algebra_AlgebraicNumber'](field.createPower$int(1));
                      var gridPoint = zone.normal().scale(scale);
                      gridPoints.add(JsAdapter.mapVectorToJavascript(gridPoint));
                    }
                  }
                }
              }

              return gridPoints.stream().toArray(function (size) {
                return function (s) {
                  var a = [];

                  while (s-- > 0) {
                    a.push(null);
                  }

                  return a;
                }(size);
              });
            }
          }]);

          return JsAdapter;
        }();

        jsweet.JsAdapter = JsAdapter;
        JsAdapter["__class"] = "com.vzome.jsweet.JsAdapter";
      })(vzome.jsweet || (vzome.jsweet = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (kinds) {
          var OctahedralSymmetryPerspective =
          /*#__PURE__*/
          function (_com$vzome$core$kinds) {
            _inherits(OctahedralSymmetryPerspective, _com$vzome$core$kinds);

            var _super35 = _createSuper(OctahedralSymmetryPerspective);

            function OctahedralSymmetryPerspective(field) {
              var _this29;

              _classCallCheck(this, OctahedralSymmetryPerspective);

              _this29 = _super35.call(this, new com.vzome.core.math.symmetry.OctahedralSymmetry(field));

              _this29.setDefaultGeometry(new com.vzome.core.viewing.OctahedralShapes("octahedral", "octahedra", _this29.symmetry));

              return _this29;
            }
            /**
            *
            * @return {com.vzome.core.math.symmetry.OctahedralSymmetry}
            */


            _createClass(OctahedralSymmetryPerspective, [{
              key: "getSymmetry",
              value: function getSymmetry() {
                return this.symmetry;
              }
              /**
              *
              * @param {com.vzome.api.Tool.Kind} kind
              * @param {com.vzome.core.editor.ToolsModel} tools
              * @return {*}
              */

            }, {
              key: "createToolFactories",
              value: function createToolFactories(kind, tools) {
                var result = new java.util.ArrayList();

                switch (kind) {
                  case com.vzome.api.Tool.Kind.SYMMETRY:
                    result.add(new com.vzome.core.tools.OctahedralToolFactory(tools, this.symmetry));
                    result.add(new com.vzome.core.tools.TetrahedralToolFactory(tools, this.symmetry));
                    result.add(new com.vzome.core.tools.InversionTool.Factory(tools));
                    result.add(new com.vzome.core.tools.MirrorTool.Factory(tools));
                    result.add(new com.vzome.core.tools.AxialSymmetryToolFactory(tools, this.symmetry));
                    break;

                  case com.vzome.api.Tool.Kind.TRANSFORM:
                    result.add(new com.vzome.core.tools.ScalingTool.__com_vzome_core_tools_ScalingTool_Factory(tools, this.symmetry));
                    result.add(new com.vzome.core.tools.RotationTool.__com_vzome_core_tools_RotationTool_Factory(tools, this.symmetry));
                    result.add(new com.vzome.core.tools.TranslationTool.Factory(tools));
                    result.add(new com.vzome.core.tools.ProjectionTool.Factory(tools));
                    break;

                  case com.vzome.api.Tool.Kind.LINEAR_MAP:
                    result.add(new com.vzome.core.tools.LinearMapTool.Factory(tools, this.symmetry, false));
                    break;
                }

                return result;
              }
              /**
              *
              * @param {com.vzome.api.Tool.Kind} kind
              * @param {com.vzome.core.editor.ToolsModel} tools
              * @return {*}
              */

            }, {
              key: "predefineTools",
              value: function predefineTools(kind, tools) {
                var result = new java.util.ArrayList();

                switch (kind) {
                  case com.vzome.api.Tool.Kind.SYMMETRY:
                    result.add(new com.vzome.core.tools.OctahedralToolFactory(tools, this.symmetry).createPredefinedTool("octahedral around origin"));
                    result.add(new com.vzome.core.tools.TetrahedralToolFactory(tools, this.symmetry).createPredefinedTool("tetrahedral around origin"));
                    result.add(new com.vzome.core.tools.InversionTool.Factory(tools).createPredefinedTool("reflection through origin"));
                    result.add(new com.vzome.core.tools.MirrorTool.Factory(tools).createPredefinedTool("reflection through XY plane"));
                    result.add(new com.vzome.core.tools.AxialSymmetryToolFactory(tools, this.symmetry).createPredefinedTool("symmetry around green through origin"));
                    break;

                  case com.vzome.api.Tool.Kind.TRANSFORM:
                    result.add(new com.vzome.core.tools.ScalingTool.__com_vzome_core_tools_ScalingTool_Factory(tools, this.symmetry).createPredefinedTool("scale down"));
                    result.add(new com.vzome.core.tools.ScalingTool.__com_vzome_core_tools_ScalingTool_Factory(tools, this.symmetry).createPredefinedTool("scale up"));
                    result.add(new com.vzome.core.tools.RotationTool.__com_vzome_core_tools_RotationTool_Factory(tools, this.symmetry).createPredefinedTool("rotate around green through origin"));
                    result.add(new com.vzome.core.tools.TranslationTool.Factory(tools).createPredefinedTool("b1 move along +X"));
                    break;
                }

                return result;
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getModelResourcePath",
              value: function getModelResourcePath() {
                return "org/vorthmann/zome/app/octahedral-vef.vZome";
              }
            }]);

            return OctahedralSymmetryPerspective;
          }(com.vzome.core.kinds.AbstractSymmetryPerspective);

          kinds.OctahedralSymmetryPerspective = OctahedralSymmetryPerspective;
          OctahedralSymmetryPerspective["__class"] = "com.vzome.core.kinds.OctahedralSymmetryPerspective";
          OctahedralSymmetryPerspective["__interfaces"] = ["com.vzome.core.editor.FieldApplication.SymmetryPerspective"];
        })(core.kinds || (core.kinds = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (kinds) {
          var IcosahedralSymmetryPerspective =
          /*#__PURE__*/
          function (_com$vzome$core$kinds2) {
            _inherits(IcosahedralSymmetryPerspective, _com$vzome$core$kinds2);

            var _super36 = _createSuper(IcosahedralSymmetryPerspective);

            function IcosahedralSymmetryPerspective(field) {
              var _this30;

              _classCallCheck(this, IcosahedralSymmetryPerspective);

              if (field != null && (field["__interfaces"] != null && field["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicField") >= 0 || field.constructor != null && field.constructor["__interfaces"] != null && field.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicField") >= 0) || field === null) {
                {
                  var symm = new com.vzome.core.math.symmetry.IcosahedralSymmetry(field);
                  _this30 = _super36.call(this, symm);
                  if (_this30.qSymmH4 === undefined) _this30.qSymmH4 = null;
                  if (_this30.qSymmH4_ROT === undefined) _this30.qSymmH4_ROT = null;
                  if (_this30.qSymmT2 === undefined) _this30.qSymmT2 = null;
                  if (_this30.cmdIcosasymm === undefined) _this30.cmdIcosasymm = null;
                  if (_this30.cmdTetrasymm === undefined) _this30.cmdTetrasymm = null;
                  if (_this30.cmdAxialsymm === undefined) _this30.cmdAxialsymm = null;
                  if (_this30.cmdH4symmetry === undefined) _this30.cmdH4symmetry = null;
                  if (_this30.cmdH4rotations === undefined) _this30.cmdH4rotations = null;
                  if (_this30.cmdIxTsymmetry === undefined) _this30.cmdIxTsymmetry = null;
                  if (_this30.cmdTxTsymmetry === undefined) _this30.cmdTxTsymmetry = null;
                  if (_this30.cmdVanOss600cell === undefined) _this30.cmdVanOss600cell = null;
                  if (_this30.qSymmH4 === undefined) _this30.qSymmH4 = null;
                  if (_this30.qSymmH4_ROT === undefined) _this30.qSymmH4_ROT = null;
                  if (_this30.qSymmT2 === undefined) _this30.qSymmT2 = null;
                  if (_this30.cmdIcosasymm === undefined) _this30.cmdIcosasymm = null;
                  if (_this30.cmdTetrasymm === undefined) _this30.cmdTetrasymm = null;
                  if (_this30.cmdAxialsymm === undefined) _this30.cmdAxialsymm = null;
                  if (_this30.cmdH4symmetry === undefined) _this30.cmdH4symmetry = null;
                  if (_this30.cmdH4rotations === undefined) _this30.cmdH4rotations = null;
                  if (_this30.cmdIxTsymmetry === undefined) _this30.cmdIxTsymmetry = null;
                  if (_this30.cmdTxTsymmetry === undefined) _this30.cmdTxTsymmetry = null;
                  if (_this30.cmdVanOss600cell === undefined) _this30.cmdVanOss600cell = null;

                  (function () {
                    var icosadefaultShapes = new com.vzome.core.viewing.ExportedVEFShapes(null, "default", "solid connectors", _this30.symmetry);
                    var lifelikeShapes = new com.vzome.core.viewing.ExportedVEFShapes(null, "lifelike", "lifelike", _this30.symmetry, icosadefaultShapes);
                    var tinyShapes = new com.vzome.core.viewing.ExportedVEFShapes(null, "tiny", "tiny connectors", _this30.symmetry);
                    var tinyDodecs = new com.vzome.core.viewing.ExportedVEFShapes(null, "dodecs", "small dodecahedra", "tiny dodecahedra", _this30.symmetry, tinyShapes);
                    var bigZome = new com.vzome.core.viewing.ExportedVEFShapes(null, "bigzome", "Big Zome", _this30.symmetry, tinyShapes);
                    var noTwist = new com.vzome.core.viewing.ExportedVEFShapes(null, "noTwist", "no-twist 121 zone", _this30.symmetry, true);
                    var vienne2 = new com.vzome.core.viewing.ExportedVEFShapes(null, "vienne2", "Vienne", _this30.symmetry, icosadefaultShapes);
                    var vienne3 = new com.vzome.core.viewing.ExportedVEFShapes(null, "vienne3", "Vienne lifelike", _this30.symmetry, vienne2);
                    var vienne = new com.vzome.core.viewing.ExportedVEFShapes(null, "vienne", "Vienne 121 zone", _this30.symmetry, true);

                    _this30.addShapes(icosadefaultShapes);

                    _this30.addShapes(lifelikeShapes);

                    _this30.addShapes(tinyShapes);

                    _this30.addShapes(tinyDodecs);

                    _this30.addShapes(bigZome);

                    _this30.addShapes(noTwist);

                    _this30.addShapes(vienne2);

                    _this30.addShapes(vienne3);

                    _this30.addShapes(vienne);

                    _this30.setDefaultGeometry(icosadefaultShapes);

                    var field = _this30.symmetry.getField();

                    _this30.qSymmH4 = new com.vzome.core.math.symmetry.QuaternionicSymmetry("H_4", "com/vzome/core/math/symmetry/H4roots.vef", field);
                    _this30.qSymmH4_ROT = new com.vzome.core.math.symmetry.QuaternionicSymmetry("H4_ROT", "com/vzome/core/math/symmetry/H4roots-rotationalSubgroup.vef", field);
                    _this30.qSymmT2 = new com.vzome.core.math.symmetry.QuaternionicSymmetry("2T", "com/vzome/core/math/symmetry/binaryTetrahedralGroup.vef", field);
                    _this30.cmdIcosasymm = new com.vzome.core.commands.CommandSymmetry(_this30.symmetry);
                    _this30.cmdTetrasymm = new com.vzome.core.commands.CommandTetrahedralSymmetry(_this30.symmetry);
                    _this30.cmdAxialsymm = new com.vzome.core.commands.CommandAxialSymmetry(_this30.symmetry);
                    _this30.cmdH4symmetry = new com.vzome.core.commands.CommandQuaternionSymmetry(_this30.qSymmH4, _this30.qSymmH4);
                    _this30.cmdH4rotations = new com.vzome.core.commands.CommandQuaternionSymmetry(_this30.qSymmH4_ROT, _this30.qSymmH4_ROT);
                    _this30.cmdIxTsymmetry = new com.vzome.core.commands.CommandQuaternionSymmetry(_this30.qSymmH4, _this30.qSymmT2);
                    _this30.cmdTxTsymmetry = new com.vzome.core.commands.CommandQuaternionSymmetry(_this30.qSymmT2, _this30.qSymmT2);
                    _this30.cmdVanOss600cell = new com.vzome.core.commands.CommandVanOss600Cell();
                  })();
                }
              } else if (field != null && field instanceof com.vzome.core.math.symmetry.IcosahedralSymmetry || field === null) {
                var _args47 = arguments;
                var _symm = _args47[0];
                _this30 = _super36.call(this, _symm);
                if (_this30.qSymmH4 === undefined) _this30.qSymmH4 = null;
                if (_this30.qSymmH4_ROT === undefined) _this30.qSymmH4_ROT = null;
                if (_this30.qSymmT2 === undefined) _this30.qSymmT2 = null;
                if (_this30.cmdIcosasymm === undefined) _this30.cmdIcosasymm = null;
                if (_this30.cmdTetrasymm === undefined) _this30.cmdTetrasymm = null;
                if (_this30.cmdAxialsymm === undefined) _this30.cmdAxialsymm = null;
                if (_this30.cmdH4symmetry === undefined) _this30.cmdH4symmetry = null;
                if (_this30.cmdH4rotations === undefined) _this30.cmdH4rotations = null;
                if (_this30.cmdIxTsymmetry === undefined) _this30.cmdIxTsymmetry = null;
                if (_this30.cmdTxTsymmetry === undefined) _this30.cmdTxTsymmetry = null;
                if (_this30.cmdVanOss600cell === undefined) _this30.cmdVanOss600cell = null;
                if (_this30.qSymmH4 === undefined) _this30.qSymmH4 = null;
                if (_this30.qSymmH4_ROT === undefined) _this30.qSymmH4_ROT = null;
                if (_this30.qSymmT2 === undefined) _this30.qSymmT2 = null;
                if (_this30.cmdIcosasymm === undefined) _this30.cmdIcosasymm = null;
                if (_this30.cmdTetrasymm === undefined) _this30.cmdTetrasymm = null;
                if (_this30.cmdAxialsymm === undefined) _this30.cmdAxialsymm = null;
                if (_this30.cmdH4symmetry === undefined) _this30.cmdH4symmetry = null;
                if (_this30.cmdH4rotations === undefined) _this30.cmdH4rotations = null;
                if (_this30.cmdIxTsymmetry === undefined) _this30.cmdIxTsymmetry = null;
                if (_this30.cmdTxTsymmetry === undefined) _this30.cmdTxTsymmetry = null;
                if (_this30.cmdVanOss600cell === undefined) _this30.cmdVanOss600cell = null;

                (function () {
                  var icosadefaultShapes = new com.vzome.core.viewing.ExportedVEFShapes(null, "default", "solid connectors", _this30.symmetry);
                  var lifelikeShapes = new com.vzome.core.viewing.ExportedVEFShapes(null, "lifelike", "lifelike", _this30.symmetry, icosadefaultShapes);
                  var tinyShapes = new com.vzome.core.viewing.ExportedVEFShapes(null, "tiny", "tiny connectors", _this30.symmetry);
                  var tinyDodecs = new com.vzome.core.viewing.ExportedVEFShapes(null, "dodecs", "small dodecahedra", "tiny dodecahedra", _this30.symmetry, tinyShapes);
                  var bigZome = new com.vzome.core.viewing.ExportedVEFShapes(null, "bigzome", "Big Zome", _this30.symmetry, tinyShapes);
                  var noTwist = new com.vzome.core.viewing.ExportedVEFShapes(null, "noTwist", "no-twist 121 zone", _this30.symmetry, true);
                  var vienne2 = new com.vzome.core.viewing.ExportedVEFShapes(null, "vienne2", "Vienne", _this30.symmetry, icosadefaultShapes);
                  var vienne3 = new com.vzome.core.viewing.ExportedVEFShapes(null, "vienne3", "Vienne lifelike", _this30.symmetry, vienne2);
                  var vienne = new com.vzome.core.viewing.ExportedVEFShapes(null, "vienne", "Vienne 121 zone", _this30.symmetry, true);

                  _this30.addShapes(icosadefaultShapes);

                  _this30.addShapes(lifelikeShapes);

                  _this30.addShapes(tinyShapes);

                  _this30.addShapes(tinyDodecs);

                  _this30.addShapes(bigZome);

                  _this30.addShapes(noTwist);

                  _this30.addShapes(vienne2);

                  _this30.addShapes(vienne3);

                  _this30.addShapes(vienne);

                  _this30.setDefaultGeometry(icosadefaultShapes);

                  var field = _this30.symmetry.getField();

                  _this30.qSymmH4 = new com.vzome.core.math.symmetry.QuaternionicSymmetry("H_4", "com/vzome/core/math/symmetry/H4roots.vef", field);
                  _this30.qSymmH4_ROT = new com.vzome.core.math.symmetry.QuaternionicSymmetry("H4_ROT", "com/vzome/core/math/symmetry/H4roots-rotationalSubgroup.vef", field);
                  _this30.qSymmT2 = new com.vzome.core.math.symmetry.QuaternionicSymmetry("2T", "com/vzome/core/math/symmetry/binaryTetrahedralGroup.vef", field);
                  _this30.cmdIcosasymm = new com.vzome.core.commands.CommandSymmetry(_this30.symmetry);
                  _this30.cmdTetrasymm = new com.vzome.core.commands.CommandTetrahedralSymmetry(_this30.symmetry);
                  _this30.cmdAxialsymm = new com.vzome.core.commands.CommandAxialSymmetry(_this30.symmetry);
                  _this30.cmdH4symmetry = new com.vzome.core.commands.CommandQuaternionSymmetry(_this30.qSymmH4, _this30.qSymmH4);
                  _this30.cmdH4rotations = new com.vzome.core.commands.CommandQuaternionSymmetry(_this30.qSymmH4_ROT, _this30.qSymmH4_ROT);
                  _this30.cmdIxTsymmetry = new com.vzome.core.commands.CommandQuaternionSymmetry(_this30.qSymmH4, _this30.qSymmT2);
                  _this30.cmdTxTsymmetry = new com.vzome.core.commands.CommandQuaternionSymmetry(_this30.qSymmT2, _this30.qSymmT2);
                  _this30.cmdVanOss600cell = new com.vzome.core.commands.CommandVanOss600Cell();
                })();
              } else throw new Error('invalid overload');

              return _possibleConstructorReturn(_this30);
            }
            /**
            *
            * @return {com.vzome.core.math.symmetry.IcosahedralSymmetry}
            */


            _createClass(IcosahedralSymmetryPerspective, [{
              key: "getSymmetry",
              value: function getSymmetry() {
                return this.symmetry;
              }
              /**
              *
              * @param {com.vzome.api.Tool.Kind} kind
              * @param {com.vzome.core.editor.ToolsModel} tools
              * @return {*}
              */

            }, {
              key: "createToolFactories",
              value: function createToolFactories(kind, tools) {
                var result = new java.util.ArrayList();
                var icosaSymm = this.getSymmetry();

                switch (kind) {
                  case com.vzome.api.Tool.Kind.SYMMETRY:
                    result.add(new com.vzome.core.tools.IcosahedralToolFactory(tools, icosaSymm));
                    result.add(new com.vzome.core.tools.TetrahedralToolFactory(tools, icosaSymm));
                    result.add(new com.vzome.core.tools.InversionTool.Factory(tools));
                    result.add(new com.vzome.core.tools.MirrorTool.Factory(tools));
                    result.add(new com.vzome.core.tools.AxialSymmetryToolFactory(tools, icosaSymm));
                    break;

                  case com.vzome.api.Tool.Kind.TRANSFORM:
                    result.add(new com.vzome.core.tools.ScalingTool.__com_vzome_core_tools_ScalingTool_Factory(tools, icosaSymm));
                    result.add(new com.vzome.core.tools.RotationTool.__com_vzome_core_tools_RotationTool_Factory(tools, icosaSymm));
                    result.add(new com.vzome.core.tools.TranslationTool.Factory(tools));
                    result.add(new com.vzome.core.tools.ProjectionTool.Factory(tools));
                    break;

                  case com.vzome.api.Tool.Kind.LINEAR_MAP:
                    result.add(new com.vzome.core.tools.AxialStretchTool.Factory(tools, icosaSymm, true, true, true));
                    result.add(new com.vzome.core.tools.AxialStretchTool.Factory(tools, icosaSymm, true, false, true));
                    result.add(new com.vzome.core.tools.AxialStretchTool.Factory(tools, icosaSymm, true, true, false));
                    result.add(new com.vzome.core.tools.AxialStretchTool.Factory(tools, icosaSymm, true, false, false));
                    result.add(new com.vzome.core.tools.AxialStretchTool.Factory(tools, icosaSymm, false, true, false));
                    result.add(new com.vzome.core.tools.AxialStretchTool.Factory(tools, icosaSymm, false, false, false));
                    result.add(new com.vzome.core.tools.LinearMapTool.Factory(tools, icosaSymm, false));
                    break;
                }

                return result;
              }
              /**
              *
              * @param {com.vzome.api.Tool.Kind} kind
              * @param {com.vzome.core.editor.ToolsModel} tools
              * @return {*}
              */

            }, {
              key: "predefineTools",
              value: function predefineTools(kind, tools) {
                var result = new java.util.ArrayList();
                var icosaSymm = this.getSymmetry();

                switch (kind) {
                  case com.vzome.api.Tool.Kind.SYMMETRY:
                    result.add(new com.vzome.core.tools.IcosahedralToolFactory(tools, icosaSymm).createPredefinedTool("icosahedral around origin"));
                    result.add(new com.vzome.core.tools.TetrahedralToolFactory(tools, icosaSymm).createPredefinedTool("tetrahedral around origin"));
                    result.add(new com.vzome.core.tools.InversionTool.Factory(tools).createPredefinedTool("reflection through origin"));
                    result.add(new com.vzome.core.tools.MirrorTool.Factory(tools).createPredefinedTool("reflection through XY plane"));
                    result.add(new com.vzome.core.tools.AxialSymmetryToolFactory(tools, icosaSymm).createPredefinedTool("symmetry around red through origin"));
                    break;

                  case com.vzome.api.Tool.Kind.TRANSFORM:
                    result.add(new com.vzome.core.tools.ScalingTool.__com_vzome_core_tools_ScalingTool_Factory(tools, icosaSymm).createPredefinedTool("scale down"));
                    result.add(new com.vzome.core.tools.ScalingTool.__com_vzome_core_tools_ScalingTool_Factory(tools, icosaSymm).createPredefinedTool("scale up"));
                    result.add(new com.vzome.core.tools.RotationTool.__com_vzome_core_tools_RotationTool_Factory(tools, icosaSymm).createPredefinedTool("rotate around red through origin"));
                    result.add(new com.vzome.core.tools.TranslationTool.Factory(tools).createPredefinedTool("b1 move along +X"));
                    break;
                }

                return result;
              }
              /**
              *
              * @param {string} action
              * @return {*}
              */

            }, {
              key: "getLegacyCommand",
              value: function getLegacyCommand(action) {
                switch (action) {
                  case "icosasymm":
                    return this.cmdIcosasymm;

                  case "tetrasymm":
                    return this.cmdTetrasymm;

                  case "axialsymm":
                    return this.cmdAxialsymm;

                  case "h4symmetry":
                    return this.cmdH4symmetry;

                  case "h4rotations":
                    return this.cmdH4rotations;

                  case "IxTsymmetry":
                    return this.cmdIxTsymmetry;

                  case "TxTsymmetry":
                    return this.cmdTxTsymmetry;

                  case "vanOss600cell":
                    return this.cmdVanOss600cell;

                  default:
                    return _get(_getPrototypeOf(IcosahedralSymmetryPerspective.prototype), "getLegacyCommand", this).call(this, action);
                }
              }
            }, {
              key: "getQuaternionSymmetry",
              value: function getQuaternionSymmetry(name) {
                switch (name) {
                  case "H_4":
                    return this.qSymmH4;

                  case "H4_ROT":
                    return this.qSymmH4_ROT;

                  case "2T":
                    return this.qSymmT2;

                  default:
                    return null;
                }
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getModelResourcePath",
              value: function getModelResourcePath() {
                return "org/vorthmann/zome/app/icosahedral-vef.vZome";
              }
            }]);

            return IcosahedralSymmetryPerspective;
          }(com.vzome.core.kinds.AbstractSymmetryPerspective);

          kinds.IcosahedralSymmetryPerspective = IcosahedralSymmetryPerspective;
          IcosahedralSymmetryPerspective["__class"] = "com.vzome.core.kinds.IcosahedralSymmetryPerspective";
          IcosahedralSymmetryPerspective["__interfaces"] = ["com.vzome.core.editor.FieldApplication.SymmetryPerspective"];
        })(core.kinds || (core.kinds = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (kinds) {
          /**
          * Everything here is stateless, or at worst, a cache (like Shapes).
          * An instance of this can be shared by many DocumentModels.
          * This is why it does not have tool factories, though it does
          * dictate what tool factories will be present.
          *
          * @author vorth
          * @param {*} field
          * @class
          * @extends com.vzome.core.kinds.DefaultFieldApplication
          */
          var GoldenFieldApplication =
          /*#__PURE__*/
          function (_com$vzome$core$kinds3) {
            _inherits(GoldenFieldApplication, _com$vzome$core$kinds3);

            var _super37 = _createSuper(GoldenFieldApplication);

            function GoldenFieldApplication(field) {
              var _thisSuper, _this31;

              _classCallCheck(this, GoldenFieldApplication);

              _this31 = _super37.call(this, field);
              if (_this31.icosahedralPerspective === undefined) _this31.icosahedralPerspective = null;
              _this31.h4Builder = null;
              _this31.cmdTauDivide = new com.vzome.core.commands.CommandTauDivision();
              _this31.icosahedralPerspective = new com.vzome.core.kinds.IcosahedralSymmetryPerspective(_this31.getField());

              var octahedralPerspective = _get((_thisSuper = _assertThisInitialized(_this31), _getPrototypeOf(GoldenFieldApplication.prototype)), "getDefaultSymmetryPerspective", _thisSuper).call(_thisSuper);

              var symm = octahedralPerspective.getSymmetry();
              symm.createZoneOrbit$java_lang_String$int$int$int_A_A$boolean$boolean$com_vzome_core_algebra_AlgebraicNumber("yellow", 0, 4, [[0, 1, 1, 1], [0, 1, 1, 1], [0, 1, 1, 1]], true, false, _this31.getField()['createPower$int'](-1));
              symm.createZoneOrbit$java_lang_String$int$int$int_A_A$boolean$boolean$com_vzome_core_algebra_AlgebraicNumber("green", 1, 8, [[1, 1, 0, 1], [1, 1, 0, 1], [0, 1, 0, 1]], true, true, _this31.getField()['createRational$long'](2));
              symm.createZoneOrbit$java_lang_String$int$int$int_A_A("lavender", 0, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, [[2, 1, -1, 1], [0, 1, 1, 1], [2, 1, -1, 1]]);
              symm.createZoneOrbit$java_lang_String$int$int$int_A_A("olive", 0, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, [[0, 1, 1, 1], [0, 1, 1, 1], [2, 1, -1, 1]]);
              symm.createZoneOrbit$java_lang_String$int$int$int_A_A("maroon", 0, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, [[-1, 1, 1, 1], [3, 1, -1, 1], [1, 1, -1, 1]]);
              symm.createZoneOrbit$java_lang_String$int$int$int_A_A("brown", 0, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, [[-1, 1, 1, 1], [-1, 1, 1, 1], [-2, 1, 2, 1]]);
              symm.createZoneOrbit$java_lang_String$int$int$int_A_A("red", 0, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, [[0, 1, 1, 1], [1, 1, 0, 1], [0, 1, 0, 1]]);
              symm.createZoneOrbit$java_lang_String$int$int$int_A_A$boolean$boolean$com_vzome_core_algebra_AlgebraicNumber("purple", 0, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, [[1, 1, 1, 1], [0, 1, 0, 1], [-1, 1, 0, 1]], false, false, _this31.getField()['createPower$int'](-1));
              symm.createZoneOrbit$java_lang_String$int$int$int_A_A$boolean$boolean$com_vzome_core_algebra_AlgebraicNumber("black", 0, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, [[1, 2, 0, 1], [0, 1, 1, 2], [-1, 2, 1, 2]], false, false, _this31.getField()['createRational$long'](2));
              symm.createZoneOrbit$java_lang_String$int$int$int_A_A("turquoise", 0, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, [[1, 1, 2, 1], [3, 1, 4, 1], [3, 1, 4, 1]]);
              var defaultShapes = new com.vzome.core.viewing.ExportedVEFShapes(null, "octahedral", "trapezoids", symm, null);
              octahedralPerspective.setDefaultGeometry(defaultShapes);
              octahedralPerspective.addShapes(new com.vzome.core.viewing.ExportedVEFShapes(null, "octahedralFast", "small octahedra", symm, null));
              octahedralPerspective.addShapes(new com.vzome.core.viewing.ExportedVEFShapes(null, "octahedralRealistic", "vZome logo", symm, defaultShapes));
              return _this31;
            }
            /**
            *
            * @return {*}
            */


            _createClass(GoldenFieldApplication, [{
              key: "getSymmetryPerspectives",
              value: function getSymmetryPerspectives() {
                return java.util.Arrays.asList(this.icosahedralPerspective, _get(_getPrototypeOf(GoldenFieldApplication.prototype), "getDefaultSymmetryPerspective", this).call(this));
              }
              /**
              *
              * @return {*}
              */

            }, {
              key: "getDefaultSymmetryPerspective",
              value: function getDefaultSymmetryPerspective() {
                return this.icosahedralPerspective;
              }
              /**
              *
              * @param {string} symmName
              * @return {*}
              */

            }, {
              key: "getSymmetryPerspective",
              value: function getSymmetryPerspective(symmName) {
                switch (symmName) {
                  case "icosahedral":
                    return this.icosahedralPerspective;

                  default:
                    return _get(_getPrototypeOf(GoldenFieldApplication.prototype), "getSymmetryPerspective", this).call(this, symmName);
                }
              }
              /**
              *
              * @param {string} name
              * @return {com.vzome.core.math.symmetry.QuaternionicSymmetry}
              */

            }, {
              key: "getQuaternionSymmetry",
              value: function getQuaternionSymmetry(name) {
                return this.icosahedralPerspective.getQuaternionSymmetry(name);
              }
              /**
              *
              * @param {*} toolFactories
              * @param {com.vzome.core.editor.ToolsModel} tools
              */

            }, {
              key: "registerToolFactories",
              value: function registerToolFactories(toolFactories, tools) {
                _get(_getPrototypeOf(GoldenFieldApplication.prototype), "registerToolFactories", this).call(this, toolFactories, tools);

                var symm = this.icosahedralPerspective.getSymmetry();
                toolFactories.put("AxialStretchTool", new com.vzome.core.tools.AxialStretchTool.Factory(tools, symm, false, false, false));
                toolFactories.put("SymmetryTool", new com.vzome.core.tools.IcosahedralToolFactory(tools, symm));
              }
              /**
              *
              * @param {string} groupName
              * @param {number} index
              * @param {number} edgesToRender
              * @param {Array} edgeScales
              * @param {*} listener
              */

            }, {
              key: "constructPolytope",
              value: function constructPolytope(groupName, index, edgesToRender, edgeScales, listener) {
                switch (groupName) {
                  case "H4":
                    if (this.h4Builder == null) {
                      var qsymm = new com.vzome.core.math.symmetry.QuaternionicSymmetry("H_4", "com/vzome/core/math/symmetry/H4roots.vef", this.getField());
                      this.h4Builder = new com.vzome.core.commands.CommandUniformH4Polytope(this.getField(), qsymm, 0);
                    }

                    this.h4Builder.generate(index, edgesToRender, edgeScales, listener);
                    break;

                  default:
                    _get(_getPrototypeOf(GoldenFieldApplication.prototype), "constructPolytope", this).call(this, groupName, index, edgesToRender, edgeScales, listener);

                    break;
                }
              }
              /**
              *
              * @param {string} action
              * @return {*}
              */

            }, {
              key: "getLegacyCommand",
              value: function getLegacyCommand(action) {
                switch (action) {
                  case "tauDivide":
                    return this.cmdTauDivide;

                  default:
                    return _get(_getPrototypeOf(GoldenFieldApplication.prototype), "getLegacyCommand", this).call(this, action);
                }
              }
            }]);

            return GoldenFieldApplication;
          }(com.vzome.core.kinds.DefaultFieldApplication);

          kinds.GoldenFieldApplication = GoldenFieldApplication;
          GoldenFieldApplication["__class"] = "com.vzome.core.kinds.GoldenFieldApplication";
          GoldenFieldApplication["__interfaces"] = ["com.vzome.core.math.symmetry.Symmetries4D", "com.vzome.core.editor.FieldApplication"];
        })(core.kinds || (core.kinds = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (viewing) {
          var OctahedralShapes =
          /*#__PURE__*/
          function (_com$vzome$core$viewi) {
            _inherits(OctahedralShapes, _com$vzome$core$viewi);

            var _super38 = _createSuper(OctahedralShapes);

            function OctahedralShapes(pkgName, name, symm) {
              _classCallCheck(this, OctahedralShapes);

              return _super38.call(this, pkgName, name, null, symm);
            }
            /**
            *
            * @param {string} pkgName
            * @return {com.vzome.core.math.Polyhedron}
            */


            _createClass(OctahedralShapes, [{
              key: "buildConnectorShape",
              value: function buildConnectorShape(pkgName) {
                var field = this.mSymmetry.getField();
                var cube = new com.vzome.core.math.Polyhedron(field);
                var scale = field['createPower$int'](-2);
                scale = field['createRational$long'](2)['times$com_vzome_core_algebra_AlgebraicNumber'](scale);
                var x = field.basisVector(3, com.vzome.core.algebra.AlgebraicVector.X);
                var y = field.basisVector(3, com.vzome.core.algebra.AlgebraicVector.Y);
                var z = field.basisVector(3, com.vzome.core.algebra.AlgebraicVector.Z);
                cube.addVertex(x.scale(scale));
                cube.addVertex(x.negate().scale(scale));
                cube.addVertex(y.scale(scale));
                cube.addVertex(y.negate().scale(scale));
                cube.addVertex(z.scale(scale));
                cube.addVertex(z.negate().scale(scale));
                var face = cube.newFace();
                face.add(0);
                face.add(2);
                face.add(4);
                cube.addFace(face);
                face = cube.newFace();
                face.add(0);
                face.add(5);
                face.add(2);
                cube.addFace(face);
                face = cube.newFace();
                face.add(0);
                face.add(3);
                face.add(5);
                cube.addFace(face);
                face = cube.newFace();
                face.add(0);
                face.add(4);
                face.add(3);
                cube.addFace(face);
                face = cube.newFace();
                face.add(1);
                face.add(4);
                face.add(2);
                cube.addFace(face);
                face = cube.newFace();
                face.add(1);
                face.add(2);
                face.add(5);
                cube.addFace(face);
                face = cube.newFace();
                face.add(1);
                face.add(5);
                face.add(3);
                cube.addFace(face);
                face = cube.newFace();
                face.add(1);
                face.add(3);
                face.add(4);
                cube.addFace(face);
                return cube;
              }
            }]);

            return OctahedralShapes;
          }(com.vzome.core.viewing.AbstractShapes);

          viewing.OctahedralShapes = OctahedralShapes;
          OctahedralShapes["__class"] = "com.vzome.core.viewing.OctahedralShapes";
          OctahedralShapes["__interfaces"] = ["com.vzome.core.editor.api.Shapes"];
        })(core.viewing || (core.viewing = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (math) {
          (function (symmetry) {
            /**
            * @author Scott Vorthmann
            * @param {*} field
            * @class
            * @extends com.vzome.core.math.symmetry.AbstractSymmetry
            */
            var IcosahedralSymmetry =
            /*#__PURE__*/
            function (_com$vzome$core$math$) {
              _inherits(IcosahedralSymmetry, _com$vzome$core$math$);

              var _super39 = _createSuper(IcosahedralSymmetry);

              function IcosahedralSymmetry(field) {
                var _this32;

                _classCallCheck(this, IcosahedralSymmetry);

                _this32 = _super39.call(this, 60, field, "blue");

                _this32.INCIDENCES = function (dims) {
                  var allocate = function allocate(dims) {
                    if (dims.length == 0) {
                      return 0;
                    } else {
                      var array = [];

                      for (var i = 0; i < dims[0]; i++) {
                        array.push(allocate(dims.slice(1)));
                      }

                      return array;
                    }
                  };

                  return allocate(dims);
                }([60, 3]);

                _this32.IDENTITY = new com.vzome.core.math.symmetry.Permutation(_assertThisInitialized(_this32), null);
                if (_this32.preferredAxis === undefined) _this32.preferredAxis = null;
                _this32.tetrahedralSubgroup = [null, null, null, null, null];

                _this32.blueTetrahedral = function (s) {
                  var a = [];

                  while (s-- > 0) {
                    a.push(0);
                  }

                  return a;
                }(60);

                _this32.greenTetrahedral = function (s) {
                  var a = [];

                  while (s-- > 0) {
                    a.push(0);
                  }

                  return a;
                }(60);

                _this32.yellowTetrahedral = function (s) {
                  var a = [];

                  while (s-- > 0) {
                    a.push(0);
                  }

                  return a;
                }(60);

                for (var i = 0; i < _this32.INCIDENCES.length; i++) {
                  {
                    _this32.INCIDENCES[i][0] = _this32.getPermutation(i).mapIndex(30);
                    _this32.INCIDENCES[i][1] = _this32.getPermutation(i).mapIndex(45);
                    _this32.INCIDENCES[i][2] = _this32.getPermutation(i).mapIndex(42);
                  }
                }

                _this32.tetrahedralSubgroup[0] = _this32.closure([1, 15]);
                _this32.tetrahedralSubgroup[1] = _this32.closure([11, 20]);
                _this32.tetrahedralSubgroup[2] = _this32.closure([27, 58]);
                _this32.tetrahedralSubgroup[3] = _this32.closure([17, 4]);
                _this32.tetrahedralSubgroup[4] = _this32.closure([55, 14]);

                var blueOrbit = _this32.getDirection("blue");

                var yellowOrbit = _this32.getDirection("yellow");

                for (var _i30 = 0; _i30 < 60; _i30++) {
                  {
                    var blueZone = blueOrbit.getAxis$int$int(com.vzome.core.math.symmetry.Symmetry.PLUS, _i30);
                    var yellowZone = yellowOrbit.getAxis$int$int(com.vzome.core.math.symmetry.Symmetry.PLUS, _i30);

                    for (var j = 0; j < _this32.tetrahedralSubgroup.length; j++) {
                      {
                        for (var k = 0; k < _this32.tetrahedralSubgroup[j].length; k++) {
                          {
                            if (_this32.tetrahedralSubgroup[j][k] === blueZone.getRotation()) _this32.blueTetrahedral[_i30] = j;
                            if (_this32.tetrahedralSubgroup[j][k] === yellowZone.getRotation()) _this32.yellowTetrahedral[_i30] = j;
                          }
                        }
                      }
                    }
                  }
                }

                var greenSeeds = [6, 9, 12, 0, 3];

                for (var _j2 = 0; _j2 < _this32.tetrahedralSubgroup.length; _j2++) {
                  {
                    var seedAxis = greenSeeds[_j2];

                    for (var _k3 = 0; _k3 < _this32.tetrahedralSubgroup[_j2].length; _k3++) {
                      {
                        var mappedAxis = _this32.mOrientations[_this32.tetrahedralSubgroup[_j2][_k3]].mapIndex(seedAxis);

                        _this32.greenTetrahedral[mappedAxis] = _j2;
                      }
                    }
                  }
                }

                return _this32;
              }
              /**
              *
              * @param {number} orientation
              * @return {Array}
              */


              _createClass(IcosahedralSymmetry, [{
                key: "getIncidentOrientations",
                value: function getIncidentOrientations(orientation) {
                  return this.INCIDENCES[orientation];
                }
                /**
                * Create a collection of blue-axis normals from a prototype,
                * by applying known rotations.
                * @param {com.vzome.core.math.symmetry.Direction} dir
                * @param {number} prototype
                * @param {number} rotated
                * @param {com.vzome.core.algebra.AlgebraicVector} xyz
                * @private
                */

                /*private*/

              }, {
                key: "createBlueAxes",
                value: function createBlueAxes(dir, prototype, rotated, xyz) {
                  var orientation = 0;
                  var reflect = [false, false, false];

                  for (var i = 0; i < 3; i++) {
                    {
                      for (var k = 0; k < 2; k++) {
                        {
                          for (var l = 0; l < 2; l++) {
                            {
                              var _unit2 = this.mOrientations[orientation].mapIndex(prototype);

                              if (dir.getAxis$int$int(com.vzome.core.math.symmetry.Symmetry.PLUS, _unit2) == null) {
                                var rot = this.mOrientations[orientation].mapIndex(rotated);
                                var rotation = this.getMapping(_unit2, rot);
                                var norm = this.mField.origin(3);

                                for (var m = 0; m < 3; m++) {
                                  {
                                    var offset = (m + 3 - i) % 3;

                                    if (reflect[m]) {
                                      norm.setComponent(m, xyz.getComponent(offset).negate());
                                    } else {
                                      norm.setComponent(m, xyz.getComponent(offset));
                                    }
                                  }
                                }

                                dir.createAxis$int$int$com_vzome_core_algebra_AlgebraicVector(_unit2, rotation, norm);
                                dir.createAxis$int$int$com_vzome_core_algebra_AlgebraicVector(rot, rotation, norm);
                              }

                              orientation = this.mOrientations[45].mapIndex(orientation);
                              reflect[0] = !reflect[0];
                              reflect[2] = !reflect[2];
                            }
                          }

                          orientation = this.mOrientations[15].mapIndex(orientation);
                          reflect[1] = !reflect[1];
                          reflect[2] = !reflect[2];
                        }
                      }

                      orientation = this.mOrientations[1].mapIndex(orientation);
                    }
                  }
                }
                /**
                *
                * @return {string}
                */

              }, {
                key: "getName",
                value: function getName() {
                  return "icosahedral";
                }
                /**
                *
                * @return {Array}
                */

              }, {
                key: "getOrbitTriangle",
                value: function getOrbitTriangle() {
                  var twice = this.mField['createRational$long'](2);
                  var blueVertex = this.getDirection("blue").getPrototype().scale(twice);
                  var redVertex = this.getDirection("red").getPrototype();
                  var phiInv = this.mField.getGoldenRatio().reciprocal();
                  var yellowVertex = this.getDirection("yellow").getPrototype().scale(phiInv);
                  return [blueVertex, redVertex, yellowVertex];
                }
                /**
                *
                * @param {com.vzome.core.math.symmetry.Symmetry.SpecialOrbit} which
                * @return {com.vzome.core.math.symmetry.Direction}
                */

              }, {
                key: "getSpecialOrbit",
                value: function getSpecialOrbit(which) {
                  switch (which) {
                    case com.vzome.core.math.symmetry.Symmetry.SpecialOrbit.BLUE:
                      return this.getDirection("blue");

                    case com.vzome.core.math.symmetry.Symmetry.SpecialOrbit.RED:
                      return this.getDirection("red");

                    case com.vzome.core.math.symmetry.Symmetry.SpecialOrbit.YELLOW:
                      return this.getDirection("yellow");

                    default:
                      return this.getDirection("black");
                  }
                }
                /**
                *
                * @param {string} frameColor
                */

              }, {
                key: "createFrameOrbit",
                value: function createFrameOrbit(frameColor) {
                  var xAxis = this.mField.basisVector(3, com.vzome.core.algebra.AlgebraicVector.X);
                  var dir = this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector$boolean$boolean$com_vzome_core_algebra_AlgebraicNumber(frameColor, 0, 15, xAxis, true, true, this.mField['createRational$long'](2));
                  dir.setScaleNames(["b0", "b1", "b2", "b3"]);
                  this.createBlueAxes(dir, 0, 15, xAxis);
                  this.createBlueAxes(dir, 9, 13, this.mField.createVector([[1, 2, 0, 1], [0, 1, 1, 2], [-1, 2, 1, 2]]));
                  this.createBlueAxes(dir, 6, 49, this.mField.createVector([[1, 2, 0, 1], [0, 1, 1, 2], [1, 2, -1, 2]]));

                  for (var p = 0; p < this.mOrientations.length; p++) {
                    {
                      var x = this.mOrientations[p].mapIndex(0);
                      var y = this.mOrientations[p].mapIndex(1);
                      var z = this.mOrientations[p].mapIndex(2);
                      this.mMatrices[p] = new com.vzome.core.algebra.AlgebraicMatrix(dir.getAxis$int$int(com.vzome.core.math.symmetry.Symmetry.PLUS, x).normal(), dir.getAxis$int$int(com.vzome.core.math.symmetry.Symmetry.PLUS, y).normal(), dir.getAxis$int$int(com.vzome.core.math.symmetry.Symmetry.PLUS, z).normal());
                      var axis = dir.getAxis$int$int(com.vzome.core.math.symmetry.Symmetry.PLUS, p);
                      var norm = this.mMatrices[p].timesColumn(xAxis);
                      if (!norm.equals(axis.normal())) throw new java.lang.IllegalStateException("matrix wrong: " + p);
                    }
                  }
                }
                /**
                *
                * @return {com.vzome.core.math.symmetry.Axis}
                */

              }, {
                key: "getPreferredAxis",
                value: function getPreferredAxis() {
                  return this.preferredAxis;
                }
                /**
                * @see com.vzome.core.math.symmetry.AbstractSymmetry#createOtherOrbits()
                *
                * @see com.vzome.core.algebra.AlgebraicField#createVector()
                *
                * @see com.vzome.core.math.symmetry.AbstractSymmetry#createZoneOrbit(String, int, int, AlgebraicVector, boolean, boolean, AlgebraicNumber)
                */

              }, {
                key: "createOtherOrbits",
                value: function createOtherOrbits() {
                  var dir;
                  dir = this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector$boolean("red", 0, 3, this.mField.createVector([[0, 1, 1, 1], [1, 1, 0, 1], [0, 1, 0, 1]]), true);
                  dir.setScaleNames(["r0", "r1", "r2", "r3"]);
                  this.preferredAxis = dir.getAxis$int$int(com.vzome.core.math.symmetry.Symmetry.PLUS, 1);
                  dir = this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector$boolean$boolean$com_vzome_core_algebra_AlgebraicNumber("yellow", 0, 27, this.mField.createVector([[1, 1, 1, 1], [0, 1, 0, 1], [-1, 1, 0, 1]]), true, false, this.mField['createPower$int'](-1));
                  dir.setScaleNames(["y0", "y1", "y2", "y3"]);
                  dir = this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector$boolean$boolean$com_vzome_core_algebra_AlgebraicNumber("green", 6, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, this.mField.createVector([[1, 1, 0, 1], [1, 1, 0, 1], [0, 1, 0, 1]]), true, true, this.mField['createRational$long'](2));
                  dir.setScaleNames(["g0", "g1", "g2", "g3"]);
                  this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector("orange", 6, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, this.mField.createVector([[1, 1, 0, 1], [0, 1, 1, 1], [0, 1, 0, 1]]));
                  this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector$boolean$boolean$com_vzome_core_algebra_AlgebraicNumber("purple", 0, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, this.mField.createVector([[1, 1, 1, 1], [1, 1, 0, 1], [0, 1, 0, 1]]), false, false, this.mField['createPower$int'](-1));
                  this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector("black", 3, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, this.mField.createVector([[0, 1, 1, 1], [1, 1, 0, 1], [1, 1, -1, 1]]));
                  this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector("lavender", 0, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, this.mField.createVector([[2, 1, -1, 1], [0, 1, 1, 1], [2, 1, -1, 1]])).withCorrection();
                  this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector("olive", 0, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, this.mField.createVector([[0, 1, 1, 1], [0, 1, 1, 1], [2, 1, -1, 1]])).withCorrection();
                  this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector("maroon", 0, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, this.mField.createVector([[-1, 1, 1, 1], [3, 1, -1, 1], [1, 1, -1, 1]])).withCorrection();
                  this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector("rose", 0, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, this.mField.createVector([[2, 1, -1, 1], [-1, 1, 2, 1], [0, 1, 0, 1]])).withCorrection();
                  this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector$boolean$boolean$com_vzome_core_algebra_AlgebraicNumber("navy", 0, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, this.mField.createVector([[-1, 1, 2, 1], [1, 1, 1, 1], [0, 1, 0, 1]]), false, false, this.mField['createPower$int'](-1)).withCorrection();
                  this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector("turquoise", 0, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, this.mField.createVector([[2, 1, 0, 1], [2, 1, -1, 1], [-3, 1, 2, 1]])).withCorrection();
                  this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector("coral", 0, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, this.mField.createVector([[-3, 1, 3, 1], [0, 1, 0, 1], [1, 1, 0, 1]])).withCorrection();
                  this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector("sulfur", 0, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, this.mField.createVector([[-3, 1, 3, 1], [2, 1, -1, 1], [0, 1, 0, 1]])).withCorrection();
                  this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector("sand", 0, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, this.mField.createVector([[-2, 1, 2, 1], [-2, 1, 2, 1], [2, 1, 0, 1]])).withCorrection();
                  this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector("apple", 0, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, this.mField.createVector([[5, 1, -3, 1], [1, 1, 0, 1], [0, 1, 1, 1]])).withCorrection();
                  this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector("cinnamon", 0, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, this.mField.createVector([[5, 1, -3, 1], [2, 1, -1, 1], [2, 1, 0, 1]])).withCorrection();
                  this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector("spruce", 0, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, this.mField.createVector([[-3, 1, 2, 1], [-3, 1, 2, 1], [5, 1, -2, 1]])).withCorrection();
                  this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector("brown", 0, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, this.mField.createVector([[-1, 1, 1, 1], [-1, 1, 1, 1], [-2, 1, 2, 1]])).withCorrection();
                }
                /**
                *
                */

              }, {
                key: "createInitialPermutations",
                value: function createInitialPermutations() {
                  var ORDER = 60;
                  this.mOrientations[0] = this.IDENTITY;

                  var map = function (s) {
                    var a = [];

                    while (s-- > 0) {
                      a.push(0);
                    }

                    return a;
                  }(ORDER);

                  for (var i = 0; i < 15; i++) {
                    {
                      map[i] = i + 15;
                      map[i + 15] = i;
                      map[i + 30] = i + 45;
                      map[i + 45] = i + 30;
                    }
                  }

                  this.mOrientations[15] = new com.vzome.core.math.symmetry.Permutation(this, map);

                  map = function (s) {
                    var a = [];

                    while (s-- > 0) {
                      a.push(0);
                    }

                    return a;
                  }(ORDER);

                  var starts = [[0, 1, 2], [15, 46, 32], [16, 47, 30], [17, 45, 31]];

                  for (var index650 = 0; index650 < starts.length; index650++) {
                    var start = starts[index650];
                    {
                      for (var j = 0; j < start.length; j++) {
                        {
                          for (var k = 0; k < 5; k++) {
                            {
                              map[start[j] + k * 3] = start[(j + 1) % 3] + k * 3;
                            }
                          }
                        }
                      }
                    }
                  }

                  this.mOrientations[1] = new com.vzome.core.math.symmetry.Permutation(this, map);

                  map = function (s) {
                    var a = [];

                    while (s-- > 0) {
                      a.push(0);
                    }

                    return a;
                  }(ORDER);

                  var cycles = [[0, 3, 6, 9, 12], [30, 42, 39, 36, 33], [2, 21, 29, 55, 4], [5, 24, 17, 58, 7], [8, 27, 20, 46, 10], [11, 15, 23, 49, 13], [1, 14, 18, 26, 52], [16, 50, 57, 38, 40], [19, 53, 45, 41, 43], [22, 56, 48, 44, 31], [25, 59, 51, 32, 34], [28, 47, 54, 35, 37]];

                  for (var index651 = 0; index651 < cycles.length; index651++) {
                    var cycle = cycles[index651];
                    {
                      for (var _j3 = 0; _j3 < cycle.length; _j3++) {
                        {
                          map[cycle[_j3]] = cycle[(_j3 + 1) % 5];
                        }
                      }
                    }
                  }

                  this.mOrientations[3] = new com.vzome.core.math.symmetry.Permutation(this, map);
                }
              }, {
                key: "subgroup$java_lang_String",
                value: function subgroup$java_lang_String(name) {
                  if (
                  /* equals */
                  function (o1, o2) {
                    if (o1 && o1.equals) {
                      return o1.equals(o2);
                    } else {
                      return o1 === o2;
                    }
                  }(com.vzome.core.math.symmetry.Symmetry.TETRAHEDRAL, name)) return this.tetrahedralSubgroup[0];
                  return null;
                }
                /**
                *
                * @param {string} color
                * @return {com.vzome.core.math.symmetry.Direction}
                */

              }, {
                key: "getDirection",
                value: function getDirection(color) {
                  if (
                  /* equals */
                  function (o1, o2) {
                    if (o1 && o1.equals) {
                      return o1.equals(o2);
                    } else {
                      return o1 === o2;
                    }
                  }("spring", color)) color = "apple";
                  if (
                  /* equals */
                  function (o1, o2) {
                    if (o1 && o1.equals) {
                      return o1.equals(o2);
                    } else {
                      return o1 === o2;
                    }
                  }("tan", color)) color = "sand";
                  return _get(_getPrototypeOf(IcosahedralSymmetry.prototype), "getDirection", this).call(this, color);
                }
              }, {
                key: "subgroup$java_lang_String$com_vzome_core_math_symmetry_Axis",
                value: function subgroup$java_lang_String$com_vzome_core_math_symmetry_Axis(name, zone) {
                  return this.subgroup$java_lang_String$com_vzome_core_math_symmetry_Axis$boolean(name, zone, true);
                }
              }, {
                key: "subgroup$java_lang_String$com_vzome_core_math_symmetry_Axis$boolean",
                value: function subgroup$java_lang_String$com_vzome_core_math_symmetry_Axis$boolean(name, zone, allowYellow) {
                  var orientation = zone.getOrientation();
                  var orbit = zone.getDirection();
                  var orbitName = orbit.getName();

                  if (
                  /* equals */
                  function (o1, o2) {
                    if (o1 && o1.equals) {
                      return o1.equals(o2);
                    } else {
                      return o1 === o2;
                    }
                  }(orbitName, "blue")) {
                    var subgroup = this.blueTetrahedral[orientation];
                    return this.tetrahedralSubgroup[subgroup];
                  } else if (
                  /* equals */
                  function (o1, o2) {
                    if (o1 && o1.equals) {
                      return o1.equals(o2);
                    } else {
                      return o1 === o2;
                    }
                  }(orbitName, "green")) {
                    var _subgroup = this.greenTetrahedral[orientation];
                    return this.tetrahedralSubgroup[_subgroup];
                  } else if (allowYellow &&
                  /* equals */
                  function (o1, o2) {
                    if (o1 && o1.equals) {
                      return o1.equals(o2);
                    } else {
                      return o1 === o2;
                    }
                  }(orbitName, "yellow")) {
                    var _subgroup2 = this.yellowTetrahedral[orientation];
                    return this.tetrahedralSubgroup[_subgroup2];
                  }

                  return null;
                }
              }, {
                key: "subgroup",
                value: function subgroup(name, zone, allowYellow) {
                  if ((typeof name === 'string' || name === null) && (zone != null && zone instanceof com.vzome.core.math.symmetry.Axis || zone === null) && (typeof allowYellow === 'boolean' || allowYellow === null)) {
                    return this.subgroup$java_lang_String$com_vzome_core_math_symmetry_Axis$boolean(name, zone, allowYellow);
                  } else if ((typeof name === 'string' || name === null) && (zone != null && zone instanceof com.vzome.core.math.symmetry.Axis || zone === null) && allowYellow === undefined) {
                    return this.subgroup$java_lang_String$com_vzome_core_math_symmetry_Axis(name, zone);
                  } else if ((typeof name === 'string' || name === null) && zone === undefined && allowYellow === undefined) {
                    return this.subgroup$java_lang_String(name);
                  } else throw new Error('invalid overload');
                }
              }, {
                key: "blueTetrahedralFromGreen",
                value: function blueTetrahedralFromGreen(greenIndex) {
                  var subgroup = this.greenTetrahedral[greenIndex];

                  for (var i = 0; i < this.blueTetrahedral.length; i++) {
                    {
                      if (this.blueTetrahedral[i] === subgroup) return i;
                    }
                  }

                  return 0;
                }
              }]);

              return IcosahedralSymmetry;
            }(com.vzome.core.math.symmetry.AbstractSymmetry);

            symmetry.IcosahedralSymmetry = IcosahedralSymmetry;
            IcosahedralSymmetry["__class"] = "com.vzome.core.math.symmetry.IcosahedralSymmetry";
            IcosahedralSymmetry["__interfaces"] = ["com.vzome.core.math.symmetry.Symmetry", "java.lang.Iterable", "com.vzome.core.math.symmetry.Embedding"];
          })(math.symmetry || (math.symmetry = {}));
        })(core.math || (core.math = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (math) {
          (function (symmetry) {
            /**
            * @author Scott Vorthmann
            *
            * @param {*} field
            * @class
            * @extends com.vzome.core.math.symmetry.AbstractSymmetry
            */
            var OctahedralSymmetry =
            /*#__PURE__*/
            function (_com$vzome$core$math$2) {
              _inherits(OctahedralSymmetry, _com$vzome$core$math$2);

              var _super40 = _createSuper(OctahedralSymmetry);

              function OctahedralSymmetry(field, frameColor) {
                var _this33;

                _classCallCheck(this, OctahedralSymmetry);

                if ((field != null && (field["__interfaces"] != null && field["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicField") >= 0 || field.constructor != null && field.constructor["__interfaces"] != null && field.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicField") >= 0) || field === null) && (typeof frameColor === 'string' || frameColor === null)) {
                  _this33 = _super40.call(this, OctahedralSymmetry.ORDER, field, frameColor);
                  if (_this33.frameColor === undefined) _this33.frameColor = null;
                  if (_this33.tetrahedralSubgroup === undefined) _this33.tetrahedralSubgroup = null;
                  _this33.IDENTITY = new com.vzome.core.math.symmetry.Permutation(_assertThisInitialized(_this33), null);
                  if (_this33.frameColor === undefined) _this33.frameColor = null;
                  if (_this33.tetrahedralSubgroup === undefined) _this33.tetrahedralSubgroup = null;

                  (function () {
                    _this33.frameColor = frameColor;
                    _this33.tetrahedralSubgroup = _this33.closure([0, 2, 4]);
                  })();
                } else if ((field != null && (field["__interfaces"] != null && field["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicField") >= 0 || field.constructor != null && field.constructor["__interfaces"] != null && field.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicField") >= 0) || field === null) && frameColor === undefined) {
                  {
                    var _frameColor = "blue";
                    _this33 = _super40.call(this, OctahedralSymmetry.ORDER, field, _frameColor);
                    if (_this33.frameColor === undefined) _this33.frameColor = null;
                    if (_this33.tetrahedralSubgroup === undefined) _this33.tetrahedralSubgroup = null;
                    _this33.IDENTITY = new com.vzome.core.math.symmetry.Permutation(_assertThisInitialized(_this33), null);
                    if (_this33.frameColor === undefined) _this33.frameColor = null;
                    if (_this33.tetrahedralSubgroup === undefined) _this33.tetrahedralSubgroup = null;

                    (function () {
                      _this33.frameColor = _frameColor;
                      _this33.tetrahedralSubgroup = _this33.closure([0, 2, 4]);
                    })();
                  }
                } else throw new Error('invalid overload');

                return _possibleConstructorReturn(_this33);
              }
              /**
              *
              * @param {com.vzome.core.math.symmetry.Symmetry.SpecialOrbit} which
              * @return {com.vzome.core.math.symmetry.Direction}
              */


              _createClass(OctahedralSymmetry, [{
                key: "getSpecialOrbit",
                value: function getSpecialOrbit(which) {
                  switch (which) {
                    case com.vzome.core.math.symmetry.Symmetry.SpecialOrbit.BLUE:
                      return this.getDirection(this.frameColor);

                    case com.vzome.core.math.symmetry.Symmetry.SpecialOrbit.RED:
                      return this.getDirection("green");

                    case com.vzome.core.math.symmetry.Symmetry.SpecialOrbit.YELLOW:
                      return this.getDirection("yellow");

                    default:
                      return null;
                  }
                }
                /**
                *
                * @return {boolean}
                */

              }, {
                key: "reverseOrbitTriangle",
                value: function reverseOrbitTriangle() {
                  return true;
                }
                /**
                *
                * @return {Array}
                */

              }, {
                key: "getOrbitTriangle",
                value: function getOrbitTriangle() {
                  var greenVertex = this.getDirection("green").getPrototype();
                  var blueVertex = this.getDirection("blue").getPrototype();
                  var yellowVertex = this.getDirection("yellow").getPrototype();
                  return [greenVertex, blueVertex, yellowVertex];
                }
                /**
                *
                */

              }, {
                key: "createInitialPermutations",
                value: function createInitialPermutations() {
                  this.mOrientations[0] = this.IDENTITY;

                  var map = function (s) {
                    var a = [];

                    while (s-- > 0) {
                      a.push(0);
                    }

                    return a;
                  }(OctahedralSymmetry.ORDER);

                  for (var i = 0; i < 6; i++) {
                    for (var j = 0; j < 4; j++) {
                      map[i * 4 + j] = i * 4 + (j + 1) % 4;
                    }
                  }

                  this.mOrientations[1] = new com.vzome.core.math.symmetry.Permutation(this, map);

                  map = function (s) {
                    var a = [];

                    while (s-- > 0) {
                      a.push(0);
                    }

                    return a;
                  }(OctahedralSymmetry.ORDER);

                  var cycles = [[0, 4, 8], [1, 11, 17], [2, 16, 22], [3, 21, 5], [6, 20, 14], [7, 13, 9], [10, 12, 18], [19, 15, 23]];

                  for (var index652 = 0; index652 < cycles.length; index652++) {
                    var cycle = cycles[index652];
                    {
                      for (var _j4 = 0; _j4 < cycle.length; _j4++) {
                        {
                          map[cycle[_j4]] = cycle[(_j4 + 1) % 3];
                        }
                      }
                    }
                  }

                  this.mOrientations[4] = new com.vzome.core.math.symmetry.Permutation(this, map);

                  map = function (s) {
                    var a = [];

                    while (s-- > 0) {
                      a.push(0);
                    }

                    return a;
                  }(OctahedralSymmetry.ORDER);

                  cycles = [[0, 5], [1, 8], [4, 9], [15, 20], [12, 19], [16, 23], [2, 17], [13, 10], [21, 6], [22, 3], [7, 14], [11, 18]];

                  for (var index653 = 0; index653 < cycles.length; index653++) {
                    var _cycle = cycles[index653];
                    {
                      for (var _j5 = 0; _j5 < _cycle.length; _j5++) {
                        {
                          map[_cycle[_j5]] = _cycle[(_j5 + 1) % 2];
                        }
                      }
                    }
                  }

                  this.mOrientations[5] = new com.vzome.core.math.symmetry.Permutation(this, map);
                }
                /**
                *
                */

              }, {
                key: "createOtherOrbits",
                value: function createOtherOrbits() {
                  var xAxis = this.mField.basisVector(3, com.vzome.core.algebra.AlgebraicVector.X);
                  var yAxis = this.mField.basisVector(3, com.vzome.core.algebra.AlgebraicVector.Y);
                  var zAxis = this.mField.basisVector(3, com.vzome.core.algebra.AlgebraicVector.Z);
                  var green = xAxis.plus(yAxis);
                  this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector$boolean("green", 1, 8, green, true);
                  var yellow = green.plus(zAxis);
                  this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector$boolean("yellow", 0, 4, yellow, true);
                }
                /**
                *
                * @param {string} frameColor
                */

              }, {
                key: "createFrameOrbit",
                value: function createFrameOrbit(frameColor) {
                  var xAxis = this.mField.basisVector(3, com.vzome.core.algebra.AlgebraicVector.X);
                  var yAxis = this.mField.basisVector(3, com.vzome.core.algebra.AlgebraicVector.Y);
                  var zAxis = this.mField.basisVector(3, com.vzome.core.algebra.AlgebraicVector.Z);
                  var dir;
                  if (this.mField.doubleFrameVectors()) dir = this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector$boolean$boolean$com_vzome_core_algebra_AlgebraicNumber(frameColor, 0, 1, xAxis, true, true, this.mField['createRational$long'](2));else dir = this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector$boolean(frameColor, 0, 1, xAxis, true);
                  this.createBasisAxes(dir, xAxis, 0);
                  this.createBasisAxes(dir, xAxis.negate(), 12);
                  this.createBasisAxes(dir, yAxis, 5);
                  this.createBasisAxes(dir, yAxis.negate(), 7);
                  this.createBasisAxes(dir, zAxis, 4);
                  this.createBasisAxes(dir, zAxis.negate(), 6);

                  for (var p = 0; p < OctahedralSymmetry.ORDER; p++) {
                    {
                      var x = this.mOrientations[p].mapIndex(0);
                      var y = this.mOrientations[p].mapIndex(8);
                      var z = this.mOrientations[p].mapIndex(4);
                      this.mMatrices[p] = new com.vzome.core.algebra.AlgebraicMatrix(dir.getAxis$int$int(com.vzome.core.math.symmetry.Symmetry.PLUS, x).normal(), dir.getAxis$int$int(com.vzome.core.math.symmetry.Symmetry.PLUS, y).normal(), dir.getAxis$int$int(com.vzome.core.math.symmetry.Symmetry.PLUS, z).normal());
                      var axis = dir.getAxis$int$int(com.vzome.core.math.symmetry.Symmetry.PLUS, p);
                      var norm = this.mMatrices[p].timesColumn(xAxis);
                      if (!norm.equals(axis.normal())) throw new java.lang.IllegalStateException("matrix wrong: " + p);
                    }
                  }
                }
                /*private*/

              }, {
                key: "createBasisAxes",
                value: function createBasisAxes(dir, norm, orientation) {
                  for (var i = 0; i < 4; i++) {
                    {
                      var prototype = this.mOrientations[orientation].mapIndex(i);
                      var rotatedPrototype = this.mOrientations[orientation].mapIndex((i + 1) % 4);
                      var rotation = this.getMapping(prototype, rotatedPrototype);
                      dir.createAxis$int$int$com_vzome_core_algebra_AlgebraicVector(prototype, rotation, norm);
                    }
                  }
                }
                /**
                *
                * @return {string}
                */

              }, {
                key: "getName",
                value: function getName() {
                  return "octahedral";
                }
                /**
                *
                * @param {string} name
                * @return {Array}
                */

              }, {
                key: "subgroup",
                value: function subgroup(name) {
                  if (
                  /* equals */
                  function (o1, o2) {
                    if (o1 && o1.equals) {
                      return o1.equals(o2);
                    } else {
                      return o1 === o2;
                    }
                  }(com.vzome.core.math.symmetry.Symmetry.TETRAHEDRAL, name)) return this.tetrahedralSubgroup;
                  return null;
                }
              }]);

              return OctahedralSymmetry;
            }(com.vzome.core.math.symmetry.AbstractSymmetry);

            OctahedralSymmetry.ORDER = 24;
            symmetry.OctahedralSymmetry = OctahedralSymmetry;
            OctahedralSymmetry["__class"] = "com.vzome.core.math.symmetry.OctahedralSymmetry";
            OctahedralSymmetry["__interfaces"] = ["com.vzome.core.math.symmetry.Symmetry", "java.lang.Iterable", "com.vzome.core.math.symmetry.Embedding"];
          })(math.symmetry || (math.symmetry = {}));
        })(core.math || (core.math = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (math) {
          (function (symmetry) {
            /**
            * @author Scott Vorthmann
            * @param {*} field
            * @class
            * @extends com.vzome.core.math.symmetry.AbstractSymmetry
            */
            var DodecagonalSymmetry =
            /*#__PURE__*/
            function (_com$vzome$core$math$3) {
              _inherits(DodecagonalSymmetry, _com$vzome$core$math$3);

              var _super41 = _createSuper(DodecagonalSymmetry);

              function DodecagonalSymmetry(field) {
                var _this34;

                _classCallCheck(this, DodecagonalSymmetry);

                _this34 = _super41.call(this, DodecagonalSymmetry.ORDER, field, "blue");
                _this34.IDENTITY = new com.vzome.core.math.symmetry.Permutation(_assertThisInitialized(_this34), null);
                return _this34;
              }
              /**
              *
              */


              _createClass(DodecagonalSymmetry, [{
                key: "createInitialPermutations",
                value: function createInitialPermutations() {
                  this.mOrientations[0] = this.IDENTITY;

                  var map = function (s) {
                    var a = [];

                    while (s-- > 0) {
                      a.push(0);
                    }

                    return a;
                  }(DodecagonalSymmetry.ORDER);

                  for (var i = 0; i < DodecagonalSymmetry.ORDER; i++) {
                    map[i] = (i + 1) % DodecagonalSymmetry.ORDER;
                  }

                  this.mOrientations[1] = new com.vzome.core.math.symmetry.Permutation(this, map);
                }
                /**
                *
                * @param {string} frameColor
                */

              }, {
                key: "createFrameOrbit",
                value: function createFrameOrbit(frameColor) {
                  var xAxis = this.mField.createVector([[1, 1, 0, 1], [0, 1, 0, 1], [0, 1, 0, 1]]);
                  var dir = this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector$boolean(frameColor, 0, 15, xAxis, true);
                  dir.createAxis$int$int$com_vzome_core_algebra_AlgebraicVector(0, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, xAxis);
                  dir.createAxis$int$int$int_A_A(1, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, [[0, 1, 1, 2], [1, 2, 0, 1], [0, 1, 0, 1]]);
                  dir.createAxis$int$int$int_A_A(2, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, [[1, 2, 0, 1], [0, 1, 1, 2], [0, 1, 0, 1]]);
                  dir.createAxis$int$int$int_A_A(3, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, [[0, 1, 0, 1], [1, 1, 0, 1], [0, 1, 0, 1]]);
                  dir.createAxis$int$int$int_A_A(4, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, [[-1, 2, 0, 1], [0, 1, 1, 2], [0, 1, 0, 1]]);
                  dir.createAxis$int$int$int_A_A(5, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, [[0, 1, -1, 2], [1, 2, 0, 1], [0, 1, 0, 1]]);
                  dir.createAxis$int$int$int_A_A(6, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, [[-1, 1, 0, 1], [0, 1, 0, 1], [0, 1, 0, 1]]);
                  dir.createAxis$int$int$int_A_A(7, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, [[0, 1, -1, 2], [-1, 2, 0, 1], [0, 1, 0, 1]]);
                  dir.createAxis$int$int$int_A_A(8, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, [[-1, 2, 0, 1], [0, 1, -1, 2], [0, 1, 0, 1]]);
                  dir.createAxis$int$int$int_A_A(9, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, [[0, 1, 0, 1], [-1, 1, 0, 1], [0, 1, 0, 1]]);
                  dir.createAxis$int$int$int_A_A(10, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, [[1, 2, 0, 1], [0, 1, -1, 2], [0, 1, 0, 1]]);
                  dir.createAxis$int$int$int_A_A(11, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, [[0, 1, 1, 2], [-1, 2, 0, 1], [0, 1, 0, 1]]);
                  var zAxis = this.mField.createVector([[0, 1, 0, 1], [0, 1, 0, 1], [1, 1, 0, 1]]);

                  for (var p = 0; p < DodecagonalSymmetry.ORDER; p++) {
                    {
                      var x = this.mOrientations[p].mapIndex(0);
                      var y = this.mOrientations[p].mapIndex(3);
                      this.mMatrices[p] = new com.vzome.core.algebra.AlgebraicMatrix(dir.getAxis$int$int(com.vzome.core.math.symmetry.Symmetry.PLUS, x).normal(), dir.getAxis$int$int(com.vzome.core.math.symmetry.Symmetry.PLUS, y).normal(), zAxis);
                      var axis = dir.getAxis$int$int(com.vzome.core.math.symmetry.Symmetry.PLUS, p);
                      var norm = this.mMatrices[p].timesColumn(xAxis);
                      if (!norm.equals(axis.normal())) throw new java.lang.IllegalStateException("matrix wrong: " + p);
                    }
                  }
                }
                /**
                *
                */

              }, {
                key: "createOtherOrbits",
                value: function createOtherOrbits() {
                  this.createZoneOrbit$java_lang_String$int$int$int_A_A$boolean("green", 0, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, [[1, 1, 1, 2], [1, 2, 0, 1], [0, 1, 0, 1]], true);
                  this.createZoneOrbit$java_lang_String$int$int$int_A_A$boolean("red", 0, 1, [[0, 1, 0, 1], [0, 1, 0, 1], [1, 1, 0, 1]], true);
                }
                /**
                *
                * @param {com.vzome.core.math.symmetry.Symmetry.SpecialOrbit} which
                * @return {com.vzome.core.math.symmetry.Direction}
                */

              }, {
                key: "getSpecialOrbit",
                value: function getSpecialOrbit(which) {
                  switch (which) {
                    case com.vzome.core.math.symmetry.Symmetry.SpecialOrbit.BLUE:
                      return this.getDirection("blue");

                    case com.vzome.core.math.symmetry.Symmetry.SpecialOrbit.RED:
                      return this.getDirection("red");

                    case com.vzome.core.math.symmetry.Symmetry.SpecialOrbit.YELLOW:
                      return this.getDirection("green");

                    default:
                      return null;
                  }
                }
                /**
                *
                * @return {com.vzome.core.math.symmetry.Axis}
                */

              }, {
                key: "getPreferredAxis",
                value: function getPreferredAxis() {
                  return this.getDirection("red").getAxis$int$int(0, 0);
                }
                /**
                *
                * @return {string}
                */

              }, {
                key: "getName",
                value: function getName() {
                  return "dodecagonal";
                }
                /**
                *
                * @param {string} name
                * @return {Array}
                */

              }, {
                key: "subgroup",
                value: function subgroup(name) {
                  return null;
                }
              }]);

              return DodecagonalSymmetry;
            }(com.vzome.core.math.symmetry.AbstractSymmetry);

            DodecagonalSymmetry.ORDER = 12;
            symmetry.DodecagonalSymmetry = DodecagonalSymmetry;
            DodecagonalSymmetry["__class"] = "com.vzome.core.math.symmetry.DodecagonalSymmetry";
            DodecagonalSymmetry["__interfaces"] = ["com.vzome.core.math.symmetry.Symmetry", "java.lang.Iterable", "com.vzome.core.math.symmetry.Embedding"];
          })(math.symmetry || (math.symmetry = {}));
        })(core.math || (core.math = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (math) {
          (function (symmetry) {
            var PlaneOrbitSet =
            /*#__PURE__*/
            function (_com$vzome$core$math$4) {
              _inherits(PlaneOrbitSet, _com$vzome$core$math$4);

              var _super42 = _createSuper(PlaneOrbitSet);

              function PlaneOrbitSet(delegate, normal) {
                var _this35;

                _classCallCheck(this, PlaneOrbitSet);

                _this35 = _super42.call(this, delegate.getSymmetry());
                if (_this35.delegate === undefined) _this35.delegate = null;
                if (_this35.normal === undefined) _this35.normal = null;
                _this35.__zones = new java.util.HashSet();
                _this35.delegate = delegate;
                _this35.normal = normal;

                for (var index654 = delegate.iterator(); index654.hasNext();) {
                  var dir = index654.next();
                  {
                    for (var index655 = dir.iterator(); index655.hasNext();) {
                      var axis = index655.next();
                      {
                        if (axis.normal().dot(_this35.normal).isZero()) _this35.__zones.add(axis);
                      }
                    }
                  }
                }

                return _this35;
              }

              _createClass(PlaneOrbitSet, [{
                key: "zones",
                value: function zones() {
                  return this.__zones.iterator();
                }
                /**
                *
                * @param {com.vzome.core.math.RealVector} vector
                * @return {com.vzome.core.math.symmetry.Axis}
                */

              }, {
                key: "getAxis",
                value: function getAxis(vector) {
                  if (com.vzome.core.math.RealVector.ORIGIN_$LI$().equals(vector)) {
                    return null;
                  }

                  var maxCosine = -1.0;
                  var closest = null;

                  for (var index656 = this.__zones.iterator(); index656.hasNext();) {
                    var axis = index656.next();
                    {
                      var axisV = axis.normal().toRealVector();
                      var cosine = vector.dot(axisV) / (vector.length() * axisV.length());

                      if (cosine > maxCosine) {
                        maxCosine = cosine;
                        closest = axis;
                      }
                    }
                  }

                  return closest;
                }
                /**
                *
                * @param {string} name
                * @return {com.vzome.core.math.symmetry.Direction}
                */

              }, {
                key: "getDirection",
                value: function getDirection(name) {
                  return this.delegate.getDirection(name);
                }
              }]);

              return PlaneOrbitSet;
            }(com.vzome.core.math.symmetry.OrbitSet);

            symmetry.PlaneOrbitSet = PlaneOrbitSet;
            PlaneOrbitSet["__class"] = "com.vzome.core.math.symmetry.PlaneOrbitSet";
            PlaneOrbitSet["__interfaces"] = ["java.lang.Cloneable", "java.util.SortedSet", "java.util.Collection", "java.util.Set", "java.util.NavigableSet", "java.lang.Iterable", "java.io.Serializable"];
          })(math.symmetry || (math.symmetry = {}));
        })(core.math || (core.math = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (math) {
          (function (symmetry) {
            var F4Group =
            /*#__PURE__*/
            function (_com$vzome$core$math$5) {
              _inherits(F4Group, _com$vzome$core$math$5);

              var _super43 = _createSuper(F4Group);

              function F4Group(field) {
                var _this36;

                _classCallCheck(this, F4Group);

                _this36 = _super43.call(this, field);
                _this36.ROOTS = [null, null, null, null];
                _this36.WEIGHTS = [null, null, null, null];
                if (_this36.A === undefined) _this36.A = null;
                var one = field['createRational$long'](1);
                var two = field['createRational$long'](2);
                var three = field['createRational$long'](3);
                var four = field['createRational$long'](4);
                var neg_one = field['createRational$long'](-1);
                var neg_two = field['createRational$long'](-2);
                _this36.ROOTS[0] = field.basisVector(4, com.vzome.core.algebra.AlgebraicVector.X4);

                _this36.ROOTS[0].setComponent(com.vzome.core.algebra.AlgebraicVector.X4, two);

                _this36.ROOTS[0].setComponent(com.vzome.core.algebra.AlgebraicVector.Y4, neg_two);

                _this36.ROOTS[1] = field.basisVector(4, com.vzome.core.algebra.AlgebraicVector.Y4);

                _this36.ROOTS[1].setComponent(com.vzome.core.algebra.AlgebraicVector.Y4, two);

                _this36.ROOTS[1].setComponent(com.vzome.core.algebra.AlgebraicVector.Z4, neg_two);

                _this36.ROOTS[2] = field.basisVector(4, com.vzome.core.algebra.AlgebraicVector.Z4);

                _this36.ROOTS[2].setComponent(com.vzome.core.algebra.AlgebraicVector.Z4, two);

                _this36.ROOTS[3] = field.basisVector(4, com.vzome.core.algebra.AlgebraicVector.W4);

                _this36.ROOTS[3].setComponent(com.vzome.core.algebra.AlgebraicVector.X4, neg_one);

                _this36.ROOTS[3].setComponent(com.vzome.core.algebra.AlgebraicVector.Y4, neg_one);

                _this36.ROOTS[3].setComponent(com.vzome.core.algebra.AlgebraicVector.Z4, neg_one);

                _this36.WEIGHTS[0] = field.basisVector(4, com.vzome.core.algebra.AlgebraicVector.X4);

                _this36.WEIGHTS[0].setComponent(com.vzome.core.algebra.AlgebraicVector.X4, two);

                _this36.WEIGHTS[0].setComponent(com.vzome.core.algebra.AlgebraicVector.W4, two);

                _this36.WEIGHTS[1] = field.basisVector(4, com.vzome.core.algebra.AlgebraicVector.Y4);

                _this36.WEIGHTS[1].setComponent(com.vzome.core.algebra.AlgebraicVector.X4, two);

                _this36.WEIGHTS[1].setComponent(com.vzome.core.algebra.AlgebraicVector.Y4, two);

                _this36.WEIGHTS[1].setComponent(com.vzome.core.algebra.AlgebraicVector.W4, four);

                _this36.WEIGHTS[2] = field.basisVector(4, com.vzome.core.algebra.AlgebraicVector.X4);

                _this36.WEIGHTS[2].setComponent(com.vzome.core.algebra.AlgebraicVector.Y4, one);

                _this36.WEIGHTS[2].setComponent(com.vzome.core.algebra.AlgebraicVector.Z4, one);

                _this36.WEIGHTS[2].setComponent(com.vzome.core.algebra.AlgebraicVector.W4, three);

                _this36.WEIGHTS[3] = field.basisVector(4, com.vzome.core.algebra.AlgebraicVector.W4);

                _this36.WEIGHTS[3].setComponent(com.vzome.core.algebra.AlgebraicVector.W4, two);

                if (field.scale4dRoots()) {
                  var scale = field['createPower$int'](1);
                  _this36.ROOTS[2] = _this36.ROOTS[2].scale(scale);
                  _this36.WEIGHTS[2] = _this36.WEIGHTS[2].scale(scale);
                }

                var half = field['createRational$long$long'](1, 2);
                var neg_half = field['createRational$long$long'](-1, 2);
                var col1 = field.basisVector(4, com.vzome.core.algebra.AlgebraicVector.X4);
                col1.setComponent(com.vzome.core.algebra.AlgebraicVector.X4, half);
                col1.setComponent(com.vzome.core.algebra.AlgebraicVector.Y4, half);
                col1.setComponent(com.vzome.core.algebra.AlgebraicVector.Z4, half);
                col1.setComponent(com.vzome.core.algebra.AlgebraicVector.W4, neg_half);
                var col2 = field.basisVector(4, com.vzome.core.algebra.AlgebraicVector.X4);
                col2.setComponent(com.vzome.core.algebra.AlgebraicVector.X4, half);
                col2.setComponent(com.vzome.core.algebra.AlgebraicVector.Y4, half);
                col2.setComponent(com.vzome.core.algebra.AlgebraicVector.Z4, neg_half);
                col2.setComponent(com.vzome.core.algebra.AlgebraicVector.W4, half);
                var col3 = field.basisVector(4, com.vzome.core.algebra.AlgebraicVector.X4);
                col3.setComponent(com.vzome.core.algebra.AlgebraicVector.X4, half);
                col3.setComponent(com.vzome.core.algebra.AlgebraicVector.Y4, neg_half);
                col3.setComponent(com.vzome.core.algebra.AlgebraicVector.Z4, half);
                col3.setComponent(com.vzome.core.algebra.AlgebraicVector.W4, half);
                var col4 = field.basisVector(4, com.vzome.core.algebra.AlgebraicVector.X4);
                col4.setComponent(com.vzome.core.algebra.AlgebraicVector.X4, half);
                col4.setComponent(com.vzome.core.algebra.AlgebraicVector.Y4, neg_half);
                col4.setComponent(com.vzome.core.algebra.AlgebraicVector.Z4, neg_half);
                col4.setComponent(com.vzome.core.algebra.AlgebraicVector.W4, neg_half);
                _this36.A = new com.vzome.core.algebra.AlgebraicMatrix(col1, col2, col3, col4);
                return _this36;
              }
              /**
              *
              * @return {number}
              */


              _createClass(F4Group, [{
                key: "getOrder",
                value: function getOrder() {
                  return 3 * _get(_getPrototypeOf(F4Group.prototype), "getOrder", this).call(this);
                }
                /**
                *
                * @param {com.vzome.core.algebra.AlgebraicVector} model
                * @param {number} element
                * @return {com.vzome.core.algebra.AlgebraicVector}
                */

              }, {
                key: "groupAction",
                value: function groupAction(model, element) {
                  var b4Order = _get(_getPrototypeOf(F4Group.prototype), "getOrder", this).call(this);

                  var aPower = element / b4Order | 0;
                  var b4Element = element % b4Order;

                  switch (aPower) {
                    case 0:
                      return _get(_getPrototypeOf(F4Group.prototype), "groupAction", this).call(this, model, b4Element);

                    case 1:
                      return _get(_getPrototypeOf(F4Group.prototype), "groupAction", this).call(this, this.A.timesColumn(model), b4Element);

                    case 2:
                      return _get(_getPrototypeOf(F4Group.prototype), "groupAction", this).call(this, this.A.timesColumn(this.A.timesColumn(model)), b4Element);
                  }

                  return null;
                }
                /**
                *
                * @param {number} i
                * @return {com.vzome.core.algebra.AlgebraicVector}
                */

              }, {
                key: "getWeight",
                value: function getWeight(i) {
                  return this.WEIGHTS[i];
                }
                /**
                *
                * @param {number} i
                * @return {com.vzome.core.algebra.AlgebraicVector}
                */

              }, {
                key: "getSimpleRoot",
                value: function getSimpleRoot(i) {
                  return this.ROOTS[i];
                }
              }]);

              return F4Group;
            }(com.vzome.core.math.symmetry.B4Group);

            symmetry.F4Group = F4Group;
            F4Group["__class"] = "com.vzome.core.math.symmetry.F4Group";
            F4Group["__interfaces"] = ["com.vzome.core.math.symmetry.CoxeterGroup"];
          })(math.symmetry || (math.symmetry = {}));
        })(core.math || (core.math = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (viewing) {
          /**
          * @author vorth
          * @param {java.io.File} prefsFolder
          * @param {string} pkgName
          * @param {string} name
          * @param {string} alias
          * @param {*} symm
          * @param {com.vzome.core.viewing.AbstractShapes} fallback
          * @class
          * @extends com.vzome.core.viewing.AbstractShapes
          */
          var ExportedVEFShapes =
          /*#__PURE__*/
          function (_com$vzome$core$viewi2) {
            _inherits(ExportedVEFShapes, _com$vzome$core$viewi2);

            var _super44 = _createSuper(ExportedVEFShapes);

            function ExportedVEFShapes(prefsFolder, pkgName, name, alias, symm, fallback) {
              var _this37;

              _classCallCheck(this, ExportedVEFShapes);

              if ((prefsFolder != null && prefsFolder instanceof java.io.File || prefsFolder === null) && (typeof pkgName === 'string' || pkgName === null) && (typeof name === 'string' || name === null) && (typeof alias === 'string' || alias === null) && (symm != null && (symm["__interfaces"] != null && symm["__interfaces"].indexOf("com.vzome.core.math.symmetry.Symmetry") >= 0 || symm.constructor != null && symm.constructor["__interfaces"] != null && symm.constructor["__interfaces"].indexOf("com.vzome.core.math.symmetry.Symmetry") >= 0) || symm === null) && (fallback != null && fallback instanceof com.vzome.core.viewing.AbstractShapes || fallback === null)) {
                _this37 = _super44.call(this, pkgName, name, alias, symm);
                if (_this37.prefsFolder === undefined) _this37.prefsFolder = null;
                if (_this37.fallback === undefined) _this37.fallback = null;
                _this37.colors = new java.util.Properties();
                if (_this37.prefsFolder === undefined) _this37.prefsFolder = null;
                if (_this37.fallback === undefined) _this37.fallback = null;

                (function () {
                  _this37.prefsFolder = prefsFolder;
                  _this37.fallback = fallback;
                  var colorProps = ExportedVEFShapes.MODEL_PREFIX + pkgName + "/colors.properties";

                  try {
                    var cl = _this37.constructor.getClassLoader();

                    var inputStream = cl.getResourceAsStream(colorProps);
                    if (inputStream != null) _this37.colors.load(inputStream);
                  } catch (ioe) {
                    if (ExportedVEFShapes.logger_$LI$().isLoggable(java.util.logging.Level.FINE)) ExportedVEFShapes.logger_$LI$().fine("problem with shape color properties: " + colorProps);
                  }
                })();
              } else if ((prefsFolder != null && prefsFolder instanceof java.io.File || prefsFolder === null) && (typeof pkgName === 'string' || pkgName === null) && (typeof name === 'string' || name === null) && (typeof alias === 'string' || alias === null) && (symm != null && (symm["__interfaces"] != null && symm["__interfaces"].indexOf("com.vzome.core.math.symmetry.Symmetry") >= 0 || symm.constructor != null && symm.constructor["__interfaces"] != null && symm.constructor["__interfaces"].indexOf("com.vzome.core.math.symmetry.Symmetry") >= 0) || symm === null) && fallback === undefined) {
                {
                  var _args51 = arguments;

                  var _fallback = new com.vzome.core.viewing.OctahedralShapes(_args51[1], _args51[2], _args51[4]);

                  _this37 = _super44.call(this, pkgName, name, alias, symm);
                  if (_this37.prefsFolder === undefined) _this37.prefsFolder = null;
                  if (_this37.fallback === undefined) _this37.fallback = null;
                  _this37.colors = new java.util.Properties();
                  if (_this37.prefsFolder === undefined) _this37.prefsFolder = null;
                  if (_this37.fallback === undefined) _this37.fallback = null;

                  (function () {
                    _this37.prefsFolder = prefsFolder;
                    _this37.fallback = _fallback;
                    var colorProps = ExportedVEFShapes.MODEL_PREFIX + pkgName + "/colors.properties";

                    try {
                      var cl = _this37.constructor.getClassLoader();

                      var inputStream = cl.getResourceAsStream(colorProps);
                      if (inputStream != null) _this37.colors.load(inputStream);
                    } catch (ioe) {
                      if (ExportedVEFShapes.logger_$LI$().isLoggable(java.util.logging.Level.FINE)) ExportedVEFShapes.logger_$LI$().fine("problem with shape color properties: " + colorProps);
                    }
                  })();
                }
              } else if ((prefsFolder != null && prefsFolder instanceof java.io.File || prefsFolder === null) && (typeof pkgName === 'string' || pkgName === null) && (typeof name === 'string' || name === null) && (alias != null && (alias["__interfaces"] != null && alias["__interfaces"].indexOf("com.vzome.core.math.symmetry.Symmetry") >= 0 || alias.constructor != null && alias.constructor["__interfaces"] != null && alias.constructor["__interfaces"].indexOf("com.vzome.core.math.symmetry.Symmetry") >= 0) || alias === null) && (symm != null && symm instanceof com.vzome.core.viewing.AbstractShapes || symm === null) && fallback === undefined) {
                var _args52 = arguments;
                var _symm2 = _args52[3];
                var _fallback2 = _args52[4];
                {
                  var _alias = null;
                  _this37 = _super44.call(this, pkgName, name, _alias, _symm2);
                  if (_this37.prefsFolder === undefined) _this37.prefsFolder = null;
                  if (_this37.fallback === undefined) _this37.fallback = null;
                  _this37.colors = new java.util.Properties();
                  if (_this37.prefsFolder === undefined) _this37.prefsFolder = null;
                  if (_this37.fallback === undefined) _this37.fallback = null;

                  (function () {
                    _this37.prefsFolder = prefsFolder;
                    _this37.fallback = _fallback2;
                    var colorProps = ExportedVEFShapes.MODEL_PREFIX + pkgName + "/colors.properties";

                    try {
                      var cl = _this37.constructor.getClassLoader();

                      var inputStream = cl.getResourceAsStream(colorProps);
                      if (inputStream != null) _this37.colors.load(inputStream);
                    } catch (ioe) {
                      if (ExportedVEFShapes.logger_$LI$().isLoggable(java.util.logging.Level.FINE)) ExportedVEFShapes.logger_$LI$().fine("problem with shape color properties: " + colorProps);
                    }
                  })();
                }
              } else if ((prefsFolder != null && prefsFolder instanceof java.io.File || prefsFolder === null) && (typeof pkgName === 'string' || pkgName === null) && (typeof name === 'string' || name === null) && (alias != null && (alias["__interfaces"] != null && alias["__interfaces"].indexOf("com.vzome.core.math.symmetry.Symmetry") >= 0 || alias.constructor != null && alias.constructor["__interfaces"] != null && alias.constructor["__interfaces"].indexOf("com.vzome.core.math.symmetry.Symmetry") >= 0) || alias === null) && (typeof symm === 'boolean' || symm === null) && fallback === undefined) {
                var _args54 = arguments;
                var _symm3 = _args54[3];
                _args54[4];
                {
                  var _args55 = arguments;
                  var _alias2 = null;

                  var _fallback3 = new com.vzome.core.viewing.OctahedralShapes(_args55[1], _args55[2], _args55[4]);

                  _this37 = _super44.call(this, pkgName, name, _alias2, _symm3);
                  if (_this37.prefsFolder === undefined) _this37.prefsFolder = null;
                  if (_this37.fallback === undefined) _this37.fallback = null;
                  _this37.colors = new java.util.Properties();
                  if (_this37.prefsFolder === undefined) _this37.prefsFolder = null;
                  if (_this37.fallback === undefined) _this37.fallback = null;

                  (function () {
                    _this37.prefsFolder = prefsFolder;
                    _this37.fallback = _fallback3;
                    var colorProps = ExportedVEFShapes.MODEL_PREFIX + pkgName + "/colors.properties";

                    try {
                      var cl = _this37.constructor.getClassLoader();

                      var inputStream = cl.getResourceAsStream(colorProps);
                      if (inputStream != null) _this37.colors.load(inputStream);
                    } catch (ioe) {
                      if (ExportedVEFShapes.logger_$LI$().isLoggable(java.util.logging.Level.FINE)) ExportedVEFShapes.logger_$LI$().fine("problem with shape color properties: " + colorProps);
                    }
                  })();
                }
              } else if ((prefsFolder != null && prefsFolder instanceof java.io.File || prefsFolder === null) && (typeof pkgName === 'string' || pkgName === null) && (typeof name === 'string' || name === null) && (alias != null && (alias["__interfaces"] != null && alias["__interfaces"].indexOf("com.vzome.core.math.symmetry.Symmetry") >= 0 || alias.constructor != null && alias.constructor["__interfaces"] != null && alias.constructor["__interfaces"].indexOf("com.vzome.core.math.symmetry.Symmetry") >= 0) || alias === null) && symm === undefined && fallback === undefined) {
                var _args56 = arguments;
                var _symm4 = _args56[3];
                {
                  var _alias3 = null;
                  {
                    var _args58 = arguments;

                    var _fallback4 = new com.vzome.core.viewing.OctahedralShapes(_args58[1], _args58[2], _args58[4]);

                    _this37 = _super44.call(this, pkgName, name, _alias3, _symm4);
                    if (_this37.prefsFolder === undefined) _this37.prefsFolder = null;
                    if (_this37.fallback === undefined) _this37.fallback = null;
                    _this37.colors = new java.util.Properties();
                    if (_this37.prefsFolder === undefined) _this37.prefsFolder = null;
                    if (_this37.fallback === undefined) _this37.fallback = null;

                    (function () {
                      _this37.prefsFolder = prefsFolder;
                      _this37.fallback = _fallback4;
                      var colorProps = ExportedVEFShapes.MODEL_PREFIX + pkgName + "/colors.properties";

                      try {
                        var cl = _this37.constructor.getClassLoader();

                        var inputStream = cl.getResourceAsStream(colorProps);
                        if (inputStream != null) _this37.colors.load(inputStream);
                      } catch (ioe) {
                        if (ExportedVEFShapes.logger_$LI$().isLoggable(java.util.logging.Level.FINE)) ExportedVEFShapes.logger_$LI$().fine("problem with shape color properties: " + colorProps);
                      }
                    })();
                  }
                }
              } else throw new Error('invalid overload');

              return _possibleConstructorReturn(_this37);
            }

            _createClass(ExportedVEFShapes, [{
              key: "buildConnectorShape",

              /**
              *
              * @param {string} pkgName
              * @return {com.vzome.core.math.Polyhedron}
              */
              value: function buildConnectorShape(pkgName) {
                var vefData = this.loadVefData(ExportedVEFShapes.NODE_MODEL);

                if (vefData != null) {
                  var parser = new ExportedVEFShapes.VefToShape(this);
                  parser.parseVEF(vefData, this.mSymmetry.getField());
                  return parser.getConnectorPolyhedron();
                }

                if (this.fallback != null) return this.fallback.buildConnectorShape(pkgName);else throw new java.lang.IllegalStateException("missing connector shape: " + pkgName);
              }
              /**
              *
              * @param {com.vzome.core.math.symmetry.Direction} dir
              * @return {*}
              */

            }, {
              key: "createStrutGeometry",
              value: function createStrutGeometry(dir) {
                var vefData = this.loadVefData(dir.getName());

                if (vefData != null) {
                  var parser = new ExportedVEFShapes.VefToShape(this);
                  parser.parseVEF(vefData, this.mSymmetry.getField());
                  return parser.getStrutGeometry(dir.getAxis$int$int(com.vzome.core.math.symmetry.Symmetry.PLUS, 0).normal());
                } else if (this.fallback != null) return this.fallback.createStrutGeometry(dir);else return _get(_getPrototypeOf(ExportedVEFShapes.prototype), "createStrutGeometry", this).call(this, dir);
              }
            }, {
              key: "loadVefData",
              value: function loadVefData(name) {
                if (ExportedVEFShapes.INJECTED_$LI$().containsKey(this.mPkgName + "-" + name)) return ExportedVEFShapes.INJECTED_$LI$().get(this.mPkgName + "-" + name);
                var script = this.mPkgName + "/" + name + ".vef";
                if (com.vzome.xml.ResourceLoader.hasInjectedResource(ExportedVEFShapes.MODEL_PREFIX + script)) return com.vzome.xml.ResourceLoader.getInjectedResource(ExportedVEFShapes.MODEL_PREFIX + script);
                var shapeFile = new java.io.File(this.prefsFolder, "Shapes/" + script);
                var stream = null;

                try {
                  if (shapeFile.exists()) stream = new java.io.FileInputStream(shapeFile);else {
                    script = ExportedVEFShapes.MODEL_PREFIX + script;
                    stream = this.constructor.getClassLoader().getResourceAsStream(script);
                    if (stream == null) return null;
                  }
                  var out = new java.io.ByteArrayOutputStream();

                  var buf = function (s) {
                    var a = [];

                    while (s-- > 0) {
                      a.push(0);
                    }

                    return a;
                  }(1024);

                  var num;

                  while ((num = stream.read(buf, 0, 1024)) > 0) {
                    out.write(buf, 0, num);
                  }

                  ;
                  return new String(out.toByteArray());
                } catch (e) {
                  ExportedVEFShapes.logger_$LI$().fine("Failure loading VEF data from " + shapeFile);
                } finally {
                  if (stream != null) try {
                    stream.close();
                  } catch (e) {
                    console.error(e.message, e);
                  }
                }

                return null;
              }
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "hasColors",
              value: function hasColors() {
                return !this.colors.isEmpty();
              }
              /**
              *
              * @param {com.vzome.core.math.symmetry.Direction} dir
              * @return {com.vzome.core.construction.Color}
              */

            }, {
              key: "getColor",
              value: function getColor(dir) {
                if (this.colors.isEmpty()) return null;
                var dirName = dir == null ? ExportedVEFShapes.NODE_MODEL : dir.getName();
                var colorString = this.colors.getProperty(dirName);
                if (colorString == null) return null;
                return com.vzome.core.render.Colors.parseColor(colorString);
              }
            }], [{
              key: "INJECTED_$LI$",
              value: function INJECTED_$LI$() {
                if (ExportedVEFShapes.INJECTED == null) ExportedVEFShapes.INJECTED = new java.util.HashMap();
                return ExportedVEFShapes.INJECTED;
              }
            }, {
              key: "logger_$LI$",
              value: function logger_$LI$() {
                if (ExportedVEFShapes.logger == null) ExportedVEFShapes.logger = java.util.logging.Logger.getLogger("com.vzome.core.viewing.shapes");
                return ExportedVEFShapes.logger;
              }
            }, {
              key: "injectShapeVEF",
              value: function injectShapeVEF(key, vef) {
                key =
                /* replace */
                key.split("--").join("/");
                ExportedVEFShapes.INJECTED_$LI$().put(key, vef);
              }
            }]);

            return ExportedVEFShapes;
          }(com.vzome.core.viewing.AbstractShapes);

          ExportedVEFShapes.MODEL_PREFIX = "com/vzome/core/parts/";
          ExportedVEFShapes.NODE_MODEL = "connector";
          viewing.ExportedVEFShapes = ExportedVEFShapes;
          ExportedVEFShapes["__class"] = "com.vzome.core.viewing.ExportedVEFShapes";
          ExportedVEFShapes["__interfaces"] = ["com.vzome.core.editor.api.Shapes"];

          (function (ExportedVEFShapes) {
            var VefToShape =
            /*#__PURE__*/
            function (_com$vzome$core$math$6) {
              _inherits(VefToShape, _com$vzome$core$math$6);

              var _super45 = _createSuper(VefToShape);

              function VefToShape(__parent) {
                var _this38;

                _classCallCheck(this, VefToShape);

                _this38 = _super45.call(this);
                _this38.__parent = __parent;
                _this38.tipVertexIndices = new java.util.HashSet();
                _this38.midpointVertexIndices = new java.util.HashSet();
                if (_this38.tipVertex === undefined) _this38.tipVertex = null;
                _this38.vertices = new java.util.ArrayList();
                _this38.faces = new java.util.ArrayList();
                return _this38;
              }

              _createClass(VefToShape, [{
                key: "getStrutGeometry",
                value: function getStrutGeometry(prototype) {
                  var tipAxis = this.__parent.mSymmetry['getAxis$com_vzome_core_algebra_AlgebraicVector'](this.tipVertex);

                  var midpoint = this.tipVertex.scale(this.__parent.mSymmetry.getField()['createRational$long$long'](1, 2));

                  var orientation = this.__parent.mSymmetry.inverse(tipAxis.getOrientation());

                  var adjustment = this.__parent.mSymmetry.getMatrix(orientation);

                  var newVertices = new java.util.ArrayList();

                  for (var i = 0; i < this.vertices.size(); i++) {
                    {
                      var originalVertex = this.vertices.get(i);
                      if (this.tipVertexIndices.contains(i)) originalVertex = originalVertex.minus(this.tipVertex);else if (this.midpointVertexIndices.contains(i)) originalVertex = originalVertex.minus(midpoint);
                      var adjustedVertex = adjustment.timesColumn(originalVertex);
                      newVertices.add(adjustedVertex);
                    }
                  }

                  return new com.vzome.core.viewing.ExportedVEFStrutGeometry(newVertices, this.faces, prototype, this.tipVertexIndices, this.midpointVertexIndices, this.__parent.mSymmetry.getField());
                }
              }, {
                key: "getConnectorPolyhedron",
                value: function getConnectorPolyhedron() {
                  var result = new com.vzome.core.math.Polyhedron(this.__parent.mSymmetry.getField());

                  for (var index657 = this.vertices.iterator(); index657.hasNext();) {
                    var vertex = index657.next();
                    {
                      result.addVertex(vertex);
                    }
                  }

                  for (var index658 = this.faces.iterator(); index658.hasNext();) {
                    var prototypeFace = index658.next();
                    {
                      var face = result.newFace();
                      face.addAll(prototypeFace);
                      result.addFace(face);
                    }
                  }

                  return result;
                }
                /**
                *
                * @param {number} index
                * @param {Array} verts
                */

              }, {
                key: "addFace",
                value: function addFace(index, verts) {
                  var face = new java.util.ArrayList();

                  for (var i = 0; i < verts.length; i++) {
                    {
                      var j = verts[i];
                      face.add(j);
                    }
                  }

                  this.faces.add(face);
                }
                /**
                *
                * @param {number} index
                * @param {com.vzome.core.algebra.AlgebraicVector} location
                */

              }, {
                key: "addVertex",
                value: function addVertex(index, location) {
                  var vertex = this.__parent.mSymmetry.getField().projectTo3d(location, this.wFirst());

                  this.vertices.add(vertex);
                }
                /**
                *
                * @param {number} index
                * @param {number} vertex
                */

              }, {
                key: "addBall",
                value: function addBall(index, vertex) {
                  this.tipVertexIndices.add(vertex);
                }
                /**
                *
                * @param {java.util.StringTokenizer} tokens
                */

              }, {
                key: "endFile",
                value: function endFile(tokens) {
                  if (!tokens.hasMoreTokens()) return;
                  var token = tokens.nextToken();
                  if (!function (o1, o2) {
                    if (o1 && o1.equals) {
                      return o1.equals(o2);
                    } else {
                      return o1 === o2;
                    }
                  }("tip", token)) throw new java.lang.IllegalStateException("VEF format error: token after face list (\"" + token + "\" should be \"tip\"");

                  try {
                    token = tokens.nextToken();
                  } catch (e1) {
                    throw new java.lang.IllegalStateException("VEF format error: no tokens after \"tip\"");
                  }

                  var tipIndex;

                  try {
                    tipIndex = javaemul.internal.IntegerHelper.parseInt(token);
                  } catch (e) {
                    throw new java.lang.RuntimeException("VEF format error: strut tip vertex index (\"" + token + "\") must be an integer", e);
                  }

                  this.tipVertex = this.vertices.get(tipIndex);
                  if (!tokens.hasMoreTokens()) return;
                  token = tokens.nextToken();
                  if (!function (o1, o2) {
                    if (o1 && o1.equals) {
                      return o1.equals(o2);
                    } else {
                      return o1 === o2;
                    }
                  }("middle", token)) throw new java.lang.IllegalStateException("VEF format error: token after tip vertex (\"" + token + "\" should be \"middle\"");

                  while (tokens.hasMoreTokens()) {
                    {
                      token = tokens.nextToken();
                      var vertexIndex = void 0;

                      try {
                        vertexIndex = javaemul.internal.IntegerHelper.parseInt(token);
                      } catch (e) {
                        throw new java.lang.RuntimeException("VEF format error: middle vertex index (\"" + token + "\") must be an integer", e);
                      }

                      this.midpointVertexIndices.add(vertexIndex);
                    }
                  }
                }
                /**
                *
                * @param {number} numVertices
                */

              }, {
                key: "startBalls",
                value: function startBalls(numVertices) {}
                /**
                *
                * @param {number} numEdges
                */

              }, {
                key: "startEdges",
                value: function startEdges(numEdges) {}
                /**
                *
                * @param {number} index
                * @param {number} v1
                * @param {number} v2
                */

              }, {
                key: "addEdge",
                value: function addEdge(index, v1, v2) {}
                /**
                *
                * @param {number} numFaces
                */

              }, {
                key: "startFaces",
                value: function startFaces(numFaces) {}
                /**
                *
                * @param {number} numVertices
                */

              }, {
                key: "startVertices",
                value: function startVertices(numVertices) {}
              }]);

              return VefToShape;
            }(com.vzome.core.math.VefParser);

            ExportedVEFShapes.VefToShape = VefToShape;
            VefToShape["__class"] = "com.vzome.core.viewing.ExportedVEFShapes.VefToShape";
          })(ExportedVEFShapes = viewing.ExportedVEFShapes || (viewing.ExportedVEFShapes = {}));
        })(core.viewing || (core.viewing = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (math) {
          (function (symmetry) {
            /**
            * @author Scott Vorthmann
            * @param {string} name
            * @param {string} rootsResource
            * @param {*} field
            * @class
            */
            var QuaternionicSymmetry =
            /*#__PURE__*/
            function () {
              function QuaternionicSymmetry(name, rootsResource, field) {
                _classCallCheck(this, QuaternionicSymmetry);

                if (this.mRoots === undefined) this.mRoots = null;
                if (this.mName === undefined) this.mName = null;
                this.mName = name;

                try {
                  var vefData = com.vzome.xml.ResourceLoader.loadStringResource(rootsResource);
                  var parser = new QuaternionicSymmetry.RootParser(field);
                  parser.parseVEF(vefData, field);
                  this.mRoots = parser.getQuaternions();
                } catch (exc) {
                  console.error(exc.message, exc);
                }
              }

              _createClass(QuaternionicSymmetry, [{
                key: "getRoots",
                value: function getRoots() {
                  return this.mRoots;
                }
              }, {
                key: "getName",
                value: function getName() {
                  return this.mName;
                }
              }]);

              return QuaternionicSymmetry;
            }();

            symmetry.QuaternionicSymmetry = QuaternionicSymmetry;
            QuaternionicSymmetry["__class"] = "com.vzome.core.math.symmetry.QuaternionicSymmetry";

            (function (QuaternionicSymmetry) {
              var RootParser =
              /*#__PURE__*/
              function (_com$vzome$core$math$7) {
                _inherits(RootParser, _com$vzome$core$math$7);

                var _super46 = _createSuper(RootParser);

                function RootParser(field) {
                  var _this39;

                  _classCallCheck(this, RootParser);

                  _this39 = _super46.call(this);
                  if (_this39.mRoots === undefined) _this39.mRoots = null;
                  if (_this39.__com_vzome_core_math_symmetry_QuaternionicSymmetry_RootParser_field === undefined) _this39.__com_vzome_core_math_symmetry_QuaternionicSymmetry_RootParser_field = null;
                  if (_this39.HALF === undefined) _this39.HALF = null;
                  _this39.__com_vzome_core_math_symmetry_QuaternionicSymmetry_RootParser_field = field;
                  _this39.HALF = field['createRational$long$long'](1, 2);
                  return _this39;
                }
                /**
                *
                * @param {number} numVertices
                */


                _createClass(RootParser, [{
                  key: "startVertices",
                  value: function startVertices(numVertices) {
                    this.mRoots = function (s) {
                      var a = [];

                      while (s-- > 0) {
                        a.push(null);
                      }

                      return a;
                    }(numVertices);
                  }
                }, {
                  key: "getQuaternions",
                  value: function getQuaternions() {
                    return this.mRoots;
                  }
                  /**
                  *
                  * @param {number} index
                  * @param {com.vzome.core.algebra.AlgebraicVector} location
                  */

                }, {
                  key: "addVertex",
                  value: function addVertex(index, location) {
                    this.mRoots[index] = new com.vzome.core.algebra.Quaternion(this.__com_vzome_core_math_symmetry_QuaternionicSymmetry_RootParser_field, location.scale(this.HALF));
                  }
                  /**
                  *
                  * @param {number} numEdges
                  */

                }, {
                  key: "startEdges",
                  value: function startEdges(numEdges) {}
                  /**
                  *
                  * @param {number} index
                  * @param {number} v1
                  * @param {number} v2
                  */

                }, {
                  key: "addEdge",
                  value: function addEdge(index, v1, v2) {}
                  /**
                  *
                  * @param {number} numFaces
                  */

                }, {
                  key: "startFaces",
                  value: function startFaces(numFaces) {}
                  /**
                  *
                  * @param {number} index
                  * @param {Array} verts
                  */

                }, {
                  key: "addFace",
                  value: function addFace(index, verts) {}
                  /**
                  *
                  * @param {number} index
                  * @param {number} vertex
                  */

                }, {
                  key: "addBall",
                  value: function addBall(index, vertex) {}
                  /**
                  *
                  * @param {number} numVertices
                  */

                }, {
                  key: "startBalls",
                  value: function startBalls(numVertices) {}
                  /**
                  *
                  * @param {java.util.StringTokenizer} tokens
                  */

                }, {
                  key: "endFile",
                  value: function endFile(tokens) {}
                }]);

                return RootParser;
              }(com.vzome.core.math.VefParser);

              QuaternionicSymmetry.RootParser = RootParser;
              RootParser["__class"] = "com.vzome.core.math.symmetry.QuaternionicSymmetry.RootParser";
            })(QuaternionicSymmetry = symmetry.QuaternionicSymmetry || (symmetry.QuaternionicSymmetry = {}));
          })(math.symmetry || (math.symmetry = {}));
        })(core.math || (core.math = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (math) {
          var VefToPolyhedron =
          /*#__PURE__*/
          function (_com$vzome$core$math$8) {
            _inherits(VefToPolyhedron, _com$vzome$core$math$8);

            var _super47 = _createSuper(VefToPolyhedron);

            function VefToPolyhedron(polyhedron) {
              var _this40;

              _classCallCheck(this, VefToPolyhedron);

              _this40 = _super47.call(this);
              if (_this40.polyhedron === undefined) _this40.polyhedron = null;
              _this40.polyhedron = polyhedron;
              return _this40;
            }

            _createClass(VefToPolyhedron, [{
              key: "addVertex",

              /**
              *
              * @param {number} index
              * @param {com.vzome.core.algebra.AlgebraicVector} location
              */
              value: function addVertex(index, location) {
                this.polyhedron.addVertex(this.getField().projectTo3d(location, true));
              }
              /**
              *
              * @param {number} index
              * @param {Array} verts
              */

            }, {
              key: "addFace",
              value: function addFace(index, verts) {
                var face = this.polyhedron.newFace();

                for (var index659 = 0; index659 < verts.length; index659++) {
                  var i = verts[index659];
                  face.add(i);
                }

                this.polyhedron.addFace(face);
              }
              /**
              *
              * @param {number} numVertices
              */

            }, {
              key: "startVertices",
              value: function startVertices(numVertices) {}
              /**
              *
              * @param {number} numFaces
              */

            }, {
              key: "startFaces",
              value: function startFaces(numFaces) {}
              /**
              *
              * @param {number} numEdges
              */

            }, {
              key: "startEdges",
              value: function startEdges(numEdges) {}
              /**
              *
              * @param {number} index
              * @param {number} v1
              * @param {number} v2
              */

            }, {
              key: "addEdge",
              value: function addEdge(index, v1, v2) {}
              /**
              *
              * @param {number} numVertices
              */

            }, {
              key: "startBalls",
              value: function startBalls(numVertices) {}
              /**
              *
              * @param {number} index
              * @param {number} vertex
              */

            }, {
              key: "addBall",
              value: function addBall(index, vertex) {}
            }], [{
              key: "importPolyhedron",
              value: function importPolyhedron(field, vef) {
                var result = new com.vzome.core.math.Polyhedron(field);
                var parser = new VefToPolyhedron(result);
                parser.parseVEF(vef, field);
                return result;
              }
            }]);

            return VefToPolyhedron;
          }(com.vzome.core.math.VefParser);

          math.VefToPolyhedron = VefToPolyhedron;
          VefToPolyhedron["__class"] = "com.vzome.core.math.VefToPolyhedron";
        })(core.math || (core.math = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          var VefToModel =
          /*#__PURE__*/
          function (_com$vzome$core$math$9) {
            _inherits(VefToModel, _com$vzome$core$math$9);

            var _super48 = _createSuper(VefToModel);

            function VefToModel(projection, effects, scale, offset) {
              var _this41;

              _classCallCheck(this, VefToModel);

              _this41 = _super48.call(this);
              if (_this41.offset === undefined) _this41.offset = null;
              if (_this41.scale === undefined) _this41.scale = null;
              if (_this41.__com_vzome_core_construction_VefToModel_field === undefined) _this41.__com_vzome_core_construction_VefToModel_field = null;
              if (_this41.mProjection === undefined) _this41.mProjection = null;
              if (_this41.mVertices === undefined) _this41.mVertices = null;
              if (_this41.mEffects === undefined) _this41.mEffects = null;
              _this41.noBallsSection = true;
              _this41.mEffects = effects;
              _this41.__com_vzome_core_construction_VefToModel_field = scale.getField();
              _this41.scale = scale;
              _this41.offset = offset;
              _this41.mProjection = projection == null ? new com.vzome.core.math.Projection.Default(_this41.__com_vzome_core_construction_VefToModel_field) : projection;

              if (projection != null && VefToModel.logger_$LI$().isLoggable(java.util.logging.Level.FINEST)) {
                VefToModel.logger_$LI$().finest("projection = " + projection.getProjectionName());
              }

              return _this41;
            }

            _createClass(VefToModel, [{
              key: "startVertices",

              /**
              *
              * @param {number} numVertices
              */
              value: function startVertices(numVertices) {
                this.mVertices = function (s) {
                  var a = [];

                  while (s-- > 0) {
                    a.push(null);
                  }

                  return a;
                }(numVertices);
              }
              /**
              *
              * @param {number} index
              * @param {com.vzome.core.algebra.AlgebraicVector} location
              */

            }, {
              key: "addVertex",
              value: function addVertex(index, location) {
                VefToModel.logger_$LI$().finest("addVertex location = " + location.getVectorExpression$int(com.vzome.core.algebra.AlgebraicField.VEF_FORMAT));

                if (this.scale != null) {
                  location = location.scale(this.scale);
                  VefToModel.logger_$LI$().finest("scaled = " + location.getVectorExpression$int(com.vzome.core.algebra.AlgebraicField.VEF_FORMAT));
                }

                location = this.mProjection.projectImage(location, this.wFirst());
                VefToModel.logger_$LI$().finest("projected = " + location.getVectorExpression$int(com.vzome.core.algebra.AlgebraicField.VEF_FORMAT));

                if (this.offset != null) {
                  location = location.plus(this.offset);
                  VefToModel.logger_$LI$().finest("translated = " + location.getVectorExpression$int(com.vzome.core.algebra.AlgebraicField.VEF_FORMAT));
                }

                this.mVertices[index] = new com.vzome.core.construction.FreePoint(location);
                this.mVertices[index].setIndex(index);
              }
              /**
              *
              * @param {number} numEdges
              */

            }, {
              key: "startEdges",
              value: function startEdges(numEdges) {}
              /**
              *
              * @param {number} index
              * @param {number} v1
              * @param {number} v2
              */

            }, {
              key: "addEdge",
              value: function addEdge(index, v1, v2) {
                var p1 = this.mVertices[v1];
                var p2 = this.mVertices[v2];
                if (p1 == null || p2 == null) return;
                var seg = new com.vzome.core.construction.SegmentJoiningPoints(p1, p2);
                seg.setIndex(index);
                this.mEffects.constructionAdded(seg);
              }
              /**
              *
              * @param {number} numFaces
              */

            }, {
              key: "startFaces",
              value: function startFaces(numFaces) {}
              /**
              *
              * @param {number} index
              * @param {Array} verts
              */

            }, {
              key: "addFace",
              value: function addFace(index, verts) {
                var points = function (s) {
                  var a = [];

                  while (s-- > 0) {
                    a.push(null);
                  }

                  return a;
                }(verts.length);

                for (var i = 0; i < verts.length; i++) {
                  points[i] = this.mVertices[verts[i]];
                }

                var panel = new com.vzome.core.construction.PolygonFromVertices(points);
                panel.setIndex(index);
                this.mEffects.constructionAdded(panel);
              }
              /**
              *
              * @param {number} index
              * @param {number} vertex
              */

            }, {
              key: "addBall",
              value: function addBall(index, vertex) {
                this.mEffects.constructionAdded(this.mVertices[vertex]);
              }
              /**
              *
              * @param {number} numVertices
              */

            }, {
              key: "startBalls",
              value: function startBalls(numVertices) {
                this.noBallsSection = false;
              }
              /**
              *
              * @param {java.util.StringTokenizer} tokens
              */

            }, {
              key: "endFile",
              value: function endFile(tokens) {
                if (this.noBallsSection) {
                  for (var index660 = 0; index660 < this.mVertices.length; index660++) {
                    var vertex = this.mVertices[index660];
                    {
                      this.mEffects.constructionAdded(vertex);
                    }
                  }
                }
              }
            }], [{
              key: "logger_$LI$",
              value: function logger_$LI$() {
                if (VefToModel.logger == null) VefToModel.logger = java.util.logging.Logger.getLogger("com.vzome.core.construction.VefToModel");
                return VefToModel.logger;
              }
            }]);

            return VefToModel;
          }(com.vzome.core.math.VefParser);

          construction.VefToModel = VefToModel;
          VefToModel["__class"] = "com.vzome.core.construction.VefToModel";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          var Polygon =
          /*#__PURE__*/
          function (_com$vzome$core$const) {
            _inherits(Polygon, _com$vzome$core$const);

            var _super49 = _createSuper(Polygon);

            function Polygon(field) {
              var _this42;

              _classCallCheck(this, Polygon);

              _this42 = _super49.call(this, field);
              if (_this42.mVertices === undefined) _this42.mVertices = null;
              return _this42;
            }
            /**
            *
            * @return {string}
            */


            _createClass(Polygon, [{
              key: "toString",
              value: function toString() {
                return "polygon " + java.util.Arrays.toString(this.mVertices);
              }
            }, {
              key: "setStateVariable",
              value: function setStateVariable(vertices, impossible) {
                if (impossible) {
                  if (this.isImpossible()) return false;
                  this.setImpossible(true);
                  return true;
                }

                this.mVertices = vertices;
                this.setImpossible(false);
                return true;
              }
            }, {
              key: "getXml$org_w3c_dom_Document",
              value: function getXml$org_w3c_dom_Document(doc) {
                var result = doc.createElement("polygon");
                this.getXml$org_w3c_dom_Element$java_lang_String(result, "vertex");
                return result;
              }
            }, {
              key: "getXml$org_w3c_dom_Element$java_lang_String",
              value: function getXml$org_w3c_dom_Element$java_lang_String(result, vertexChildName) {
                for (var index661 = 0; index661 < this.mVertices.length; index661++) {
                  var vertex = this.mVertices[index661];
                  {
                    var child = result.getOwnerDocument().createElement(vertexChildName);
                    com.vzome.xml.DomUtils.addAttribute(child, "at", vertex.getVectorExpression$int(com.vzome.core.algebra.AlgebraicField.ZOMIC_FORMAT));
                    result.appendChild(child);
                  }
                }
              }
            }, {
              key: "getXml",
              value: function getXml(result, vertexChildName) {
                if ((result != null && (result["__interfaces"] != null && result["__interfaces"].indexOf("org.w3c.dom.Element") >= 0 || result.constructor != null && result.constructor["__interfaces"] != null && result.constructor["__interfaces"].indexOf("org.w3c.dom.Element") >= 0) || result === null) && (typeof vertexChildName === 'string' || vertexChildName === null)) {
                  return this.getXml$org_w3c_dom_Element$java_lang_String(result, vertexChildName);
                } else if ((result != null && (result["__interfaces"] != null && result["__interfaces"].indexOf("org.w3c.dom.Document") >= 0 || result.constructor != null && result.constructor["__interfaces"] != null && result.constructor["__interfaces"].indexOf("org.w3c.dom.Document") >= 0) || result === null) && vertexChildName === undefined) {
                  return this.getXml$org_w3c_dom_Document(result);
                } else throw new Error('invalid overload');
              }
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "is3d",
              value: function is3d() {
                for (var index662 = 0; index662 < this.mVertices.length; index662++) {
                  var algebraicVector = this.mVertices[index662];
                  {
                    if (algebraicVector.dimension() !== 3) return false;
                  }
                }

                return true;
              }
            }, {
              key: "getVertexCount",
              value: function getVertexCount() {
                return this.mVertices.length;
              }
            }, {
              key: "getVertex",
              value: function getVertex(i) {
                return this.mVertices[i];
              }
            }, {
              key: "getNormal",
              value: function getNormal() {
                return com.vzome.core.algebra.AlgebraicVectors.getNormal$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector(this.mVertices[0], this.mVertices[1], this.mVertices[2]);
              }
            }, {
              key: "getCentroid",
              value: function getCentroid() {
                return com.vzome.core.algebra.AlgebraicVectors.getCentroid(this.mVertices);
              }
            }, {
              key: "getVertices",
              value: function getVertices() {
                return java.util.Arrays.copyOf(this.mVertices, this.mVertices.length);
              }
            }]);

            return Polygon;
          }(com.vzome.core.construction.Construction);

          construction.Polygon = Polygon;
          Polygon["__class"] = "com.vzome.core.construction.Polygon";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          /**
          * @author Scott Vorthmann
          * @extends com.vzome.core.construction.Construction
          * @class
          */
          var Transformation =
          /*#__PURE__*/
          function (_com$vzome$core$const2) {
            _inherits(Transformation, _com$vzome$core$const2);

            var _super50 = _createSuper(Transformation);

            function Transformation(field) {
              var _this43;

              _classCallCheck(this, Transformation);

              _this43 = _super50.call(this, field);
              if (_this43.mTransform === undefined) _this43.mTransform = null;
              if (_this43.mOffset === undefined) _this43.mOffset = null;
              return _this43;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(Transformation, [{
              key: "is3d",
              value: function is3d() {
                return true;
              }
              /**
              *
              * @param {*} that
              * @return {boolean}
              */

            }, {
              key: "equals",
              value: function equals(that) {
                if (this === that) {
                  return true;
                }

                if (that == null) {
                  return false;
                }

                if (!(that != null && that instanceof com.vzome.core.construction.Transformation)) {
                  return false;
                }

                var other = that;

                if (this.mOffset == null) {
                  if (other.mOffset != null) {
                    return false;
                  }
                } else if (!this.mOffset.equals(other.mOffset)) {
                  return false;
                }

                if (this.mTransform == null) {
                  if (other.mTransform != null) {
                    return false;
                  }
                } else if (!this.mTransform.equals(other.mTransform)) {
                  return false;
                }

                return true;
              }
            }, {
              key: "setStateVariables",
              value: function setStateVariables(transform, offset, impossible) {
                if (impossible) {
                  if (this.isImpossible()) return false;
                  this.setImpossible(true);
                  return true;
                }

                if (transform != null && transform.equals(this.mTransform) && offset.equals(this.mOffset) && !this.isImpossible()) return false;
                this.mTransform = transform;
                this.mOffset = offset;
                this.setImpossible(false);
                return true;
              }
            }, {
              key: "transform$com_vzome_core_algebra_AlgebraicVector",
              value: function transform$com_vzome_core_algebra_AlgebraicVector(arg) {
                arg = arg.minus(this.mOffset);
                arg = this.mTransform.timesColumn(arg);
                arg = arg.plus(this.mOffset);
                return arg;
              }
            }, {
              key: "transform",
              value: function transform(arg) {
                if (arg != null && arg instanceof com.vzome.core.algebra.AlgebraicVector || arg === null) {
                  return this.transform$com_vzome_core_algebra_AlgebraicVector(arg);
                } else if (arg != null && arg instanceof com.vzome.core.construction.Construction || arg === null) {
                  return this.transform$com_vzome_core_construction_Construction(arg);
                } else throw new Error('invalid overload');
              }
            }, {
              key: "transform$com_vzome_core_construction_Construction",
              value: function transform$com_vzome_core_construction_Construction(c) {
                if (c != null && c instanceof com.vzome.core.construction.Point) {
                  return new com.vzome.core.construction.TransformedPoint(this, c);
                } else if (c != null && c instanceof com.vzome.core.construction.Segment) {
                  return new com.vzome.core.construction.TransformedSegment(this, c);
                } else if (c != null && c instanceof com.vzome.core.construction.Polygon) {
                  return new com.vzome.core.construction.TransformedPolygon(this, c);
                } else {
                  return null;
                }
              }
              /**
              *
              * @param {*} doc
              * @return {*}
              */

            }, {
              key: "getXml",
              value: function getXml(doc) {
                var result = doc.createElement("transformation");
                return result;
              }
            }]);

            return Transformation;
          }(com.vzome.core.construction.Construction);

          construction.Transformation = Transformation;
          Transformation["__class"] = "com.vzome.core.construction.Transformation";

          (function (Transformation) {
            var Identity =
            /*#__PURE__*/
            function (_com$vzome$core$const3) {
              _inherits(Identity, _com$vzome$core$const3);

              var _super51 = _createSuper(Identity);

              _createClass(Identity, [{
                key: "transform$int_A",
                value: function transform$int_A(arg) {
                  return arg;
                }
              }, {
                key: "transform",
                value: function transform(arg) {
                  if (arg != null && arg instanceof Array && (arg.length == 0 || arg[0] == null || typeof arg[0] === 'number') || arg === null) {
                    return this.transform$int_A(arg);
                  } else if (arg != null && arg instanceof com.vzome.core.algebra.AlgebraicVector || arg === null) {
                    _get(_getPrototypeOf(Identity.prototype), "transform", this).call(this, arg);
                  } else if (arg != null && arg instanceof com.vzome.core.construction.Construction || arg === null) {
                    return this.transform$com_vzome_core_construction_Construction(arg);
                  } else throw new Error('invalid overload');
                }
              }]);

              function Identity(field) {
                _classCallCheck(this, Identity);

                return _super51.call(this, field);
              }

              _createClass(Identity, [{
                key: "attach",
                value: function attach() {}
              }, {
                key: "detach",
                value: function detach() {}
                /**
                *
                * @return {boolean}
                */

              }, {
                key: "mapParamsToState",
                value: function mapParamsToState() {
                  return true;
                }
              }]);

              return Identity;
            }(com.vzome.core.construction.Transformation);

            Transformation.Identity = Identity;
            Identity["__class"] = "com.vzome.core.construction.Transformation.Identity";
          })(Transformation = construction.Transformation || (construction.Transformation = {}));
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          /**
          * @author Scott Vorthmann
          * @extends com.vzome.core.construction.Construction
          * @class
          */
          var Segment =
          /*#__PURE__*/
          function (_com$vzome$core$const4) {
            _inherits(Segment, _com$vzome$core$const4);

            var _super52 = _createSuper(Segment);

            function Segment(field) {
              var _this44;

              _classCallCheck(this, Segment);

              _this44 = _super52.call(this, field);
              if (_this44.mStart === undefined) _this44.mStart = null;
              if (_this44.mOffset === undefined) _this44.mOffset = null;
              if (_this44.mEnd === undefined) _this44.mEnd = null;
              return _this44;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(Segment, [{
              key: "is3d",
              value: function is3d() {
                return this.mStart.dimension() === 3 && this.mOffset.dimension() === 3;
              }
            }, {
              key: "setStateVariables",
              value: function setStateVariables(start, offset, impossible) {
                if (impossible) {
                  if (this.isImpossible()) return false;
                  this.setImpossible(true);
                  return true;
                }

                if (offset.equals(this.mOffset) && !this.isImpossible() && start.equals(this.mStart)) return false;
                this.mOffset = offset;
                this.mStart = start;
                this.mEnd = null;
                this.setImpossible(false);
                return true;
              }
            }, {
              key: "getStart",
              value: function getStart() {
                return this.mStart;
              }
            }, {
              key: "getEnd",
              value: function getEnd() {
                if (this.mEnd == null) this.mEnd = this.mStart.plus(this.mOffset);
                return this.mEnd;
              }
            }, {
              key: "getOffset",
              value: function getOffset() {
                return this.mOffset;
              }
            }, {
              key: "getCentroid",
              value: function getCentroid() {
                return com.vzome.core.algebra.AlgebraicVectors.getCentroid([this.mStart, this.mEnd]);
              }
              /**
              *
              * @param {*} doc
              * @return {*}
              */

            }, {
              key: "getXml",
              value: function getXml(doc) {
                var result = doc.createElement("segment");
                result.setAttribute("start", this.mStart.getVectorExpression$int(com.vzome.core.algebra.AlgebraicField.ZOMIC_FORMAT));
                result.setAttribute("end", this.getEnd().getVectorExpression$int(com.vzome.core.algebra.AlgebraicField.ZOMIC_FORMAT));
                return result;
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "toString",
              value: function toString() {
                return "segment from " + this.mStart + " to " + this.getEnd();
              }
            }]);

            return Segment;
          }(com.vzome.core.construction.Construction);

          construction.Segment = Segment;
          Segment["__class"] = "com.vzome.core.construction.Segment";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          /**
          * @author Scott Vorthmann
          * @extends com.vzome.core.construction.Construction
          * @class
          */
          var Point =
          /*#__PURE__*/
          function (_com$vzome$core$const5) {
            _inherits(Point, _com$vzome$core$const5);

            var _super53 = _createSuper(Point);

            function Point(field) {
              var _this45;

              _classCallCheck(this, Point);

              _this45 = _super53.call(this, field);
              if (_this45.mLocation === undefined) _this45.mLocation = null;
              return _this45;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(Point, [{
              key: "is3d",
              value: function is3d() {
                return this.mLocation.dimension() === 3;
              }
            }, {
              key: "setStateVariable",
              value: function setStateVariable(loc, impossible) {
                if (impossible) {
                  if (this.isImpossible()) return false;
                  this.setImpossible(true);
                  return true;
                }

                if (loc.equals(this.mLocation) && !this.isImpossible()) return false;
                this.mLocation = loc;
                this.setImpossible(false);
                return true;
              }
            }, {
              key: "getLocation",
              value: function getLocation() {
                return this.mLocation;
              }
              /**
              *
              * @param {*} doc
              * @return {*}
              */

            }, {
              key: "getXml",
              value: function getXml(doc) {
                var result = doc.createElement("point");
                result.setAttribute("at", this.getLocation().getVectorExpression$int(com.vzome.core.algebra.AlgebraicField.ZOMIC_FORMAT));
                return result;
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "toString",
              value: function toString() {
                return "point at " + this.mLocation;
              }
            }]);

            return Point;
          }(com.vzome.core.construction.Construction);

          construction.Point = Point;
          Point["__class"] = "com.vzome.core.construction.Point";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          var Marker =
          /*#__PURE__*/
          function (_com$vzome$core$const6) {
            _inherits(Marker, _com$vzome$core$const6);

            var _super54 = _createSuper(Marker);

            function Marker(target) {
              var _this46;

              _classCallCheck(this, Marker);

              _this46 = _super54.call(this, target.field);
              if (_this46.mTarget === undefined) _this46.mTarget = null;
              _this46.mTarget = target;
              return _this46;
            }

            _createClass(Marker, [{
              key: "getTarget",
              value: function getTarget() {
                return this.mTarget;
              }
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "mapParamsToState",
              value: function mapParamsToState() {
                return false;
              }
              /**
              *
              * @param {*} doc
              * @return {*}
              */

            }, {
              key: "getXml",
              value: function getXml(doc) {
                var result = doc.createElement("marker");
                return result;
              }
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "is3d",
              value: function is3d() {
                return this.mTarget.is3d();
              }
            }]);

            return Marker;
          }(com.vzome.core.construction.Construction);

          construction.Marker = Marker;
          Marker["__class"] = "com.vzome.core.construction.Marker";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          /**
          * @author Scott Vorthmann
          * @extends com.vzome.core.construction.Construction
          * @class
          */
          var Plane =
          /*#__PURE__*/
          function (_com$vzome$core$const7) {
            _inherits(Plane, _com$vzome$core$const7);

            var _super55 = _createSuper(Plane);

            function Plane(field) {
              var _this47;

              _classCallCheck(this, Plane);

              _this47 = _super55.call(this, field);
              if (_this47.mBase === undefined) _this47.mBase = null;
              if (_this47.mNormal === undefined) _this47.mNormal = null;
              return _this47;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(Plane, [{
              key: "is3d",
              value: function is3d() {
                return true;
              }
            }, {
              key: "setStateVariables",
              value: function setStateVariables(base, normal, impossible) {
                if (impossible) {
                  if (this.isImpossible()) return false;
                  this.setImpossible(true);
                  return true;
                }

                if (normal.equals(this.mNormal) && !this.isImpossible() && base.equals(this.mBase)) return false;
                normal = normal.projectTo3d(true);
                this.mNormal = normal;
                this.mBase = base.projectTo3d(true);
                this.setImpossible(false);
                return true;
              }
            }, {
              key: "getBase",
              value: function getBase() {
                return this.mBase;
              }
            }, {
              key: "getNormal",
              value: function getNormal() {
                return this.mNormal;
              }
              /**
              *
              * @param {*} doc
              * @return {*}
              */

            }, {
              key: "getXml",
              value: function getXml(doc) {
                var result = doc.createElement("plane");
                return result;
              }
            }, {
              key: "getHomogeneous",
              value: function getHomogeneous() {
                return null;
              }
            }]);

            return Plane;
          }(com.vzome.core.construction.Construction);

          construction.Plane = Plane;
          Plane["__class"] = "com.vzome.core.construction.Plane";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          /**
          * @author Scott Vorthmann
          * @extends com.vzome.core.construction.Construction
          * @class
          */
          var Line =
          /*#__PURE__*/
          function (_com$vzome$core$const8) {
            _inherits(Line, _com$vzome$core$const8);

            var _super56 = _createSuper(Line);

            function Line(field) {
              var _this48;

              _classCallCheck(this, Line);

              _this48 = _super56.call(this, field);
              if (_this48.mDirection === undefined) _this48.mDirection = null;
              if (_this48.mStart === undefined) _this48.mStart = null;
              return _this48;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(Line, [{
              key: "is3d",
              value: function is3d() {
                return true;
              }
              /**
              *
              * @param {com.vzome.core.algebra.AlgebraicVector} start
              * @param {com.vzome.core.algebra.AlgebraicVector} norm need not be normalized yet
              * @return
              * @param {boolean} impossible
              * @return {boolean}
              */

            }, {
              key: "setStateVariables",
              value: function setStateVariables(start, norm, impossible) {
                if (impossible) {
                  if (this.isImpossible()) return false;
                  this.setImpossible(true);
                  return true;
                }

                if (norm.equals(this.mDirection) && start.equals(this.mStart) && !this.isImpossible()) return false;
                this.mDirection = norm;
                this.mStart = start;
                this.setImpossible(false);
                return true;
              }
            }, {
              key: "getStart",
              value: function getStart() {
                return this.mStart;
              }
              /**
              * @return {com.vzome.core.algebra.AlgebraicVector} a "unit" vector... always normalized
              */

            }, {
              key: "getDirection",
              value: function getDirection() {
                return this.mDirection;
              }
              /**
              *
              * @param {*} doc
              * @return {*}
              */

            }, {
              key: "getXml",
              value: function getXml(doc) {
                var result = doc.createElement("line");
                return result;
              }
            }, {
              key: "getHomogeneous",
              value: function getHomogeneous() {
                var v1 = new com.vzome.core.algebra.Vector3dHomogeneous(this.mStart, this.getField());
                var v2 = new com.vzome.core.algebra.Vector3dHomogeneous(this.mStart.plus(this.mDirection), this.getField());
                return v1.outer(v2);
              }
            }]);

            return Line;
          }(com.vzome.core.construction.Construction);

          construction.Line = Line;
          Line["__class"] = "com.vzome.core.construction.Line";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (generic) {
          /**
          * @author David Hall
          * @param {java.lang.Class} subClass
          * @param {*} preTest
          * @param {*} iterable
          * @param {*} postTest
          * @class
          * @extends com.vzome.core.generic.FilteredIterator
          */
          var SubClassIterator =
          /*#__PURE__*/
          function (_com$vzome$core$gener) {
            _inherits(SubClassIterator, _com$vzome$core$gener);

            var _super57 = _createSuper(SubClassIterator);

            function SubClassIterator(subClass, preTest, iterable, postTest) {
              var _this49;

              _classCallCheck(this, SubClassIterator);

              _this49 = _super57.call(this, preTest, iterable, postTest);
              if (_this49.subClass === undefined) _this49.subClass = null;
              _this49.subClass = subClass;
              return _this49;
            }
            /**
            *
            * @param {*} element
            * @return {boolean}
            */


            _createClass(SubClassIterator, [{
              key: "preFilter",
              value: function preFilter(element) {
                return element != null && this.subClass.isAssignableFrom(element.constructor) ? _get(_getPrototypeOf(SubClassIterator.prototype), "preFilter", this).call(this, element) : false;
              }
              /**
              *
              * @param {*} element
              * @return {com.vzome.core.generic.SubClassIterator.T}
              */

            }, {
              key: "apply",
              value: function apply(element) {
                return this.subClass.cast(element);
              }
            }]);

            return SubClassIterator;
          }(com.vzome.core.generic.FilteredIterator);

          generic.SubClassIterator = SubClassIterator;
          SubClassIterator["__class"] = "com.vzome.core.generic.SubClassIterator";
          SubClassIterator["__interfaces"] = ["java.util.Iterator", "java.lang.Iterable"];
        })(core.generic || (core.generic = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (editor) {
          (function (api) {
            /**
            * @author David Hall
            * @class
            */
            var Manifestations =
            /*#__PURE__*/
            function () {
              function Manifestations() {
                _classCallCheck(this, Manifestations);
              }

              _createClass(Manifestations, null, [{
                key: "visibleManifestations$java_lang_Iterable",
                value: function visibleManifestations$java_lang_Iterable(manifestations) {
                  return new Manifestations.ManifestationIterator(function (man) {
                    return Manifestations.Filters.isVisible(man);
                  }, manifestations, null);
                }
              }, {
                key: "visibleManifestations$java_util_function_Predicate$java_lang_Iterable",
                value: function visibleManifestations$java_util_function_Predicate$java_lang_Iterable(preTest, manifestations) {
                  return new Manifestations.ManifestationIterator(preTest, manifestations, function (man) {
                    return Manifestations.Filters.isVisible(man);
                  });
                }
              }, {
                key: "visibleManifestations",
                value: function visibleManifestations(preTest, manifestations) {
                  if ((typeof preTest === 'function' && preTest.length == 1 || preTest === null) && (manifestations != null && (manifestations["__interfaces"] != null && manifestations["__interfaces"].indexOf("java.lang.Iterable") >= 0 || manifestations.constructor != null && manifestations.constructor["__interfaces"] != null && manifestations.constructor["__interfaces"].indexOf("java.lang.Iterable") >= 0) || manifestations === null)) {
                    return com.vzome.core.editor.api.Manifestations.visibleManifestations$java_util_function_Predicate$java_lang_Iterable(preTest, manifestations);
                  } else if ((preTest != null && (preTest["__interfaces"] != null && preTest["__interfaces"].indexOf("java.lang.Iterable") >= 0 || preTest.constructor != null && preTest.constructor["__interfaces"] != null && preTest.constructor["__interfaces"].indexOf("java.lang.Iterable") >= 0) || preTest === null) && (typeof manifestations === 'function' && manifestations.length == 1 || manifestations === null)) {
                    return com.vzome.core.editor.api.Manifestations.visibleManifestations$java_lang_Iterable$java_util_function_Predicate(preTest, manifestations);
                  } else if ((preTest != null && (preTest["__interfaces"] != null && preTest["__interfaces"].indexOf("java.lang.Iterable") >= 0 || preTest.constructor != null && preTest.constructor["__interfaces"] != null && preTest.constructor["__interfaces"].indexOf("java.lang.Iterable") >= 0) || preTest === null) && manifestations === undefined) {
                    return com.vzome.core.editor.api.Manifestations.visibleManifestations$java_lang_Iterable(preTest);
                  } else throw new Error('invalid overload');
                }
              }, {
                key: "visibleManifestations$java_lang_Iterable$java_util_function_Predicate",
                value: function visibleManifestations$java_lang_Iterable$java_util_function_Predicate(manifestations, postTest) {
                  return new Manifestations.ManifestationIterator(function (man) {
                    return Manifestations.Filters.isVisible(man);
                  }, manifestations, postTest);
                }
              }, {
                key: "getConnectors$java_lang_Iterable",
                value: function getConnectors$java_lang_Iterable(manifestations) {
                  return new Manifestations.ConnectorIterator(null, manifestations, null);
                }
              }, {
                key: "getConnectors$java_lang_Iterable$java_util_function_Predicate",
                value: function getConnectors$java_lang_Iterable$java_util_function_Predicate(manifestations, postFilter) {
                  return new Manifestations.ConnectorIterator(null, manifestations, postFilter);
                }
              }, {
                key: "getConnectors$java_util_function_Predicate$java_lang_Iterable$java_util_function_Predicate",
                value: function getConnectors$java_util_function_Predicate$java_lang_Iterable$java_util_function_Predicate(preFilter, manifestations, postFilter) {
                  return new Manifestations.ConnectorIterator(preFilter, manifestations, postFilter);
                }
              }, {
                key: "getConnectors",
                value: function getConnectors(preFilter, manifestations, postFilter) {
                  if ((typeof preFilter === 'function' && preFilter.length == 1 || preFilter === null) && (manifestations != null && (manifestations["__interfaces"] != null && manifestations["__interfaces"].indexOf("java.lang.Iterable") >= 0 || manifestations.constructor != null && manifestations.constructor["__interfaces"] != null && manifestations.constructor["__interfaces"].indexOf("java.lang.Iterable") >= 0) || manifestations === null) && (typeof postFilter === 'function' && postFilter.length == 1 || postFilter === null)) {
                    return com.vzome.core.editor.api.Manifestations.getConnectors$java_util_function_Predicate$java_lang_Iterable$java_util_function_Predicate(preFilter, manifestations, postFilter);
                  } else if ((preFilter != null && (preFilter["__interfaces"] != null && preFilter["__interfaces"].indexOf("java.lang.Iterable") >= 0 || preFilter.constructor != null && preFilter.constructor["__interfaces"] != null && preFilter.constructor["__interfaces"].indexOf("java.lang.Iterable") >= 0) || preFilter === null) && (typeof manifestations === 'function' && manifestations.length == 1 || manifestations === null) && postFilter === undefined) {
                    return com.vzome.core.editor.api.Manifestations.getConnectors$java_lang_Iterable$java_util_function_Predicate(preFilter, manifestations);
                  } else if ((preFilter != null && (preFilter["__interfaces"] != null && preFilter["__interfaces"].indexOf("java.lang.Iterable") >= 0 || preFilter.constructor != null && preFilter.constructor["__interfaces"] != null && preFilter.constructor["__interfaces"].indexOf("java.lang.Iterable") >= 0) || preFilter === null) && manifestations === undefined && postFilter === undefined) {
                    return com.vzome.core.editor.api.Manifestations.getConnectors$java_lang_Iterable(preFilter);
                  } else throw new Error('invalid overload');
                }
              }, {
                key: "getVisibleConnectors",
                value: function getVisibleConnectors(manifestations) {
                  var postFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  return new Manifestations.ConnectorIterator(function (man) {
                    return Manifestations.Filters.isVisible(man);
                  }, manifestations, postFilter);
                }
              }, {
                key: "getHiddenConnectors",
                value: function getHiddenConnectors(manifestations) {
                  var postFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  return new Manifestations.ConnectorIterator(function (man) {
                    return Manifestations.Filters.isHidden(man);
                  }, manifestations, postFilter);
                }
              }, {
                key: "getStruts$java_lang_Iterable",
                value: function getStruts$java_lang_Iterable(manifestations) {
                  return new Manifestations.StrutIterator(null, manifestations, null);
                }
              }, {
                key: "getStruts$java_lang_Iterable$java_util_function_Predicate",
                value: function getStruts$java_lang_Iterable$java_util_function_Predicate(manifestations, postFilter) {
                  return new Manifestations.StrutIterator(null, manifestations, postFilter);
                }
              }, {
                key: "getStruts$java_util_function_Predicate$java_lang_Iterable$java_util_function_Predicate",
                value: function getStruts$java_util_function_Predicate$java_lang_Iterable$java_util_function_Predicate(preFilter, manifestations, postFilter) {
                  return new Manifestations.StrutIterator(preFilter, manifestations, postFilter);
                }
              }, {
                key: "getStruts",
                value: function getStruts(preFilter, manifestations, postFilter) {
                  if ((typeof preFilter === 'function' && preFilter.length == 1 || preFilter === null) && (manifestations != null && (manifestations["__interfaces"] != null && manifestations["__interfaces"].indexOf("java.lang.Iterable") >= 0 || manifestations.constructor != null && manifestations.constructor["__interfaces"] != null && manifestations.constructor["__interfaces"].indexOf("java.lang.Iterable") >= 0) || manifestations === null) && (typeof postFilter === 'function' && postFilter.length == 1 || postFilter === null)) {
                    return com.vzome.core.editor.api.Manifestations.getStruts$java_util_function_Predicate$java_lang_Iterable$java_util_function_Predicate(preFilter, manifestations, postFilter);
                  } else if ((preFilter != null && (preFilter["__interfaces"] != null && preFilter["__interfaces"].indexOf("java.lang.Iterable") >= 0 || preFilter.constructor != null && preFilter.constructor["__interfaces"] != null && preFilter.constructor["__interfaces"].indexOf("java.lang.Iterable") >= 0) || preFilter === null) && (typeof manifestations === 'function' && manifestations.length == 1 || manifestations === null) && postFilter === undefined) {
                    return com.vzome.core.editor.api.Manifestations.getStruts$java_lang_Iterable$java_util_function_Predicate(preFilter, manifestations);
                  } else if ((preFilter != null && (preFilter["__interfaces"] != null && preFilter["__interfaces"].indexOf("java.lang.Iterable") >= 0 || preFilter.constructor != null && preFilter.constructor["__interfaces"] != null && preFilter.constructor["__interfaces"].indexOf("java.lang.Iterable") >= 0) || preFilter === null) && manifestations === undefined && postFilter === undefined) {
                    return com.vzome.core.editor.api.Manifestations.getStruts$java_lang_Iterable(preFilter);
                  } else throw new Error('invalid overload');
                }
              }, {
                key: "getVisibleStruts",
                value: function getVisibleStruts(manifestations) {
                  var postFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  return new Manifestations.StrutIterator(function (man) {
                    return Manifestations.Filters.isVisible(man);
                  }, manifestations, postFilter);
                }
              }, {
                key: "getHiddenStruts",
                value: function getHiddenStruts(manifestations) {
                  var postFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  return new Manifestations.StrutIterator(function (man) {
                    return Manifestations.Filters.isHidden(man);
                  }, manifestations, postFilter);
                }
              }, {
                key: "getPanels$java_lang_Iterable",
                value: function getPanels$java_lang_Iterable(manifestations) {
                  return new Manifestations.PanelIterator(null, manifestations, null);
                }
              }, {
                key: "getPanels$java_lang_Iterable$java_util_function_Predicate",
                value: function getPanels$java_lang_Iterable$java_util_function_Predicate(manifestations, postFilter) {
                  return new Manifestations.PanelIterator(null, manifestations, postFilter);
                }
              }, {
                key: "getPanels$java_util_function_Predicate$java_lang_Iterable$java_util_function_Predicate",
                value: function getPanels$java_util_function_Predicate$java_lang_Iterable$java_util_function_Predicate(preFilter, manifestations, postFilter) {
                  return new Manifestations.PanelIterator(preFilter, manifestations, postFilter);
                }
              }, {
                key: "getPanels",
                value: function getPanels(preFilter, manifestations, postFilter) {
                  if ((typeof preFilter === 'function' && preFilter.length == 1 || preFilter === null) && (manifestations != null && (manifestations["__interfaces"] != null && manifestations["__interfaces"].indexOf("java.lang.Iterable") >= 0 || manifestations.constructor != null && manifestations.constructor["__interfaces"] != null && manifestations.constructor["__interfaces"].indexOf("java.lang.Iterable") >= 0) || manifestations === null) && (typeof postFilter === 'function' && postFilter.length == 1 || postFilter === null)) {
                    return com.vzome.core.editor.api.Manifestations.getPanels$java_util_function_Predicate$java_lang_Iterable$java_util_function_Predicate(preFilter, manifestations, postFilter);
                  } else if ((preFilter != null && (preFilter["__interfaces"] != null && preFilter["__interfaces"].indexOf("java.lang.Iterable") >= 0 || preFilter.constructor != null && preFilter.constructor["__interfaces"] != null && preFilter.constructor["__interfaces"].indexOf("java.lang.Iterable") >= 0) || preFilter === null) && (typeof manifestations === 'function' && manifestations.length == 1 || manifestations === null) && postFilter === undefined) {
                    return com.vzome.core.editor.api.Manifestations.getPanels$java_lang_Iterable$java_util_function_Predicate(preFilter, manifestations);
                  } else if ((preFilter != null && (preFilter["__interfaces"] != null && preFilter["__interfaces"].indexOf("java.lang.Iterable") >= 0 || preFilter.constructor != null && preFilter.constructor["__interfaces"] != null && preFilter.constructor["__interfaces"].indexOf("java.lang.Iterable") >= 0) || preFilter === null) && manifestations === undefined && postFilter === undefined) {
                    return com.vzome.core.editor.api.Manifestations.getPanels$java_lang_Iterable(preFilter);
                  } else throw new Error('invalid overload');
                }
              }, {
                key: "getVisiblePanels",
                value: function getVisiblePanels(manifestations) {
                  var postFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  return new Manifestations.PanelIterator(function (man) {
                    return Manifestations.Filters.isVisible(man);
                  }, manifestations, postFilter);
                }
              }, {
                key: "getHiddenPanels",
                value: function getHiddenPanels(manifestations) {
                  var postFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  return new Manifestations.PanelIterator(function (man) {
                    return Manifestations.Filters.isHidden(man);
                  }, manifestations, postFilter);
                }
              }]);

              return Manifestations;
            }();

            api.Manifestations = Manifestations;
            Manifestations["__class"] = "com.vzome.core.editor.api.Manifestations";

            (function (Manifestations) {
              var ManifestationIterator =
              /*#__PURE__*/
              function (_com$vzome$core$gener2) {
                _inherits(ManifestationIterator, _com$vzome$core$gener2);

                var _super58 = _createSuper(ManifestationIterator);

                function ManifestationIterator(preTest, manifestations, postTest) {
                  _classCallCheck(this, ManifestationIterator);

                  return _super58.call(this, preTest, manifestations, postTest);
                }

                _createClass(ManifestationIterator, [{
                  key: "apply$com_vzome_core_model_Manifestation",
                  value: function apply$com_vzome_core_model_Manifestation(element) {
                    return element;
                  }
                  /**
                  *
                  * @param {*} element
                  * @return {*}
                  */

                }, {
                  key: "apply",
                  value: function apply(element) {
                    if (element != null && (element["__interfaces"] != null && element["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0 || element.constructor != null && element.constructor["__interfaces"] != null && element.constructor["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0) || element === null) {
                      return this.apply$com_vzome_core_model_Manifestation(element);
                    } else if (element != null || element === null) {
                      throw new Error('cannot invoke abstract overloaded method... check your argument(s) type(s)');
                    } else throw new Error('invalid overload');
                  }
                }]);

                return ManifestationIterator;
              }(com.vzome.core.generic.FilteredIterator);

              Manifestations.ManifestationIterator = ManifestationIterator;
              ManifestationIterator["__class"] = "com.vzome.core.editor.api.Manifestations.ManifestationIterator";
              ManifestationIterator["__interfaces"] = ["java.util.Iterator", "java.lang.Iterable"];

              var ConnectorIterator =
              /*#__PURE__*/
              function (_com$vzome$core$gener3) {
                _inherits(ConnectorIterator, _com$vzome$core$gener3);

                var _super59 = _createSuper(ConnectorIterator);

                _createClass(ConnectorIterator, [{
                  key: "preFilter$com_vzome_core_model_Manifestation",
                  value: function preFilter$com_vzome_core_model_Manifestation(element) {
                    return element != null && element != null && (element["__interfaces"] != null && element["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || element.constructor != null && element.constructor["__interfaces"] != null && element.constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0) ? _get(_getPrototypeOf(ConnectorIterator.prototype), "preFilter", this).call(this, element) : false;
                  }
                  /**
                  *
                  * @param {*} element
                  * @return {boolean}
                  */

                }, {
                  key: "preFilter",
                  value: function preFilter(element) {
                    if (element != null && (element["__interfaces"] != null && element["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0 || element.constructor != null && element.constructor["__interfaces"] != null && element.constructor["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0) || element === null) {
                      return this.preFilter$com_vzome_core_model_Manifestation(element);
                    } else if (element != null || element === null) {
                      _get(_getPrototypeOf(ConnectorIterator.prototype), "preFilter", this).call(this, element);
                    } else throw new Error('invalid overload');
                  }
                }, {
                  key: "apply$com_vzome_core_model_Manifestation",
                  value: function apply$com_vzome_core_model_Manifestation(element) {
                    return element;
                  }
                  /**
                  *
                  * @param {*} element
                  * @return {*}
                  */

                }, {
                  key: "apply",
                  value: function apply(element) {
                    if (element != null && (element["__interfaces"] != null && element["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0 || element.constructor != null && element.constructor["__interfaces"] != null && element.constructor["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0) || element === null) {
                      return this.apply$com_vzome_core_model_Manifestation(element);
                    } else if (element != null || element === null) {
                      throw new Error('cannot invoke abstract overloaded method... check your argument(s) type(s)');
                    } else throw new Error('invalid overload');
                  }
                }]);

                function ConnectorIterator(preFilter, manifestations, postFilter) {
                  _classCallCheck(this, ConnectorIterator);

                  return _super59.call(this, preFilter, manifestations, postFilter);
                }

                return ConnectorIterator;
              }(com.vzome.core.generic.FilteredIterator);

              Manifestations.ConnectorIterator = ConnectorIterator;
              ConnectorIterator["__class"] = "com.vzome.core.editor.api.Manifestations.ConnectorIterator";
              ConnectorIterator["__interfaces"] = ["java.util.Iterator", "java.lang.Iterable"];

              var StrutIterator =
              /*#__PURE__*/
              function (_com$vzome$core$gener4) {
                _inherits(StrutIterator, _com$vzome$core$gener4);

                var _super60 = _createSuper(StrutIterator);

                _createClass(StrutIterator, [{
                  key: "preFilter$com_vzome_core_model_Manifestation",
                  value: function preFilter$com_vzome_core_model_Manifestation(element) {
                    return element != null && element != null && (element["__interfaces"] != null && element["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || element.constructor != null && element.constructor["__interfaces"] != null && element.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0) ? _get(_getPrototypeOf(StrutIterator.prototype), "preFilter", this).call(this, element) : false;
                  }
                  /**
                  *
                  * @param {*} element
                  * @return {boolean}
                  */

                }, {
                  key: "preFilter",
                  value: function preFilter(element) {
                    if (element != null && (element["__interfaces"] != null && element["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0 || element.constructor != null && element.constructor["__interfaces"] != null && element.constructor["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0) || element === null) {
                      return this.preFilter$com_vzome_core_model_Manifestation(element);
                    } else if (element != null || element === null) {
                      _get(_getPrototypeOf(StrutIterator.prototype), "preFilter", this).call(this, element);
                    } else throw new Error('invalid overload');
                  }
                }, {
                  key: "apply$com_vzome_core_model_Manifestation",
                  value: function apply$com_vzome_core_model_Manifestation(element) {
                    return element;
                  }
                  /**
                  *
                  * @param {*} element
                  * @return {*}
                  */

                }, {
                  key: "apply",
                  value: function apply(element) {
                    if (element != null && (element["__interfaces"] != null && element["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0 || element.constructor != null && element.constructor["__interfaces"] != null && element.constructor["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0) || element === null) {
                      return this.apply$com_vzome_core_model_Manifestation(element);
                    } else if (element != null || element === null) {
                      throw new Error('cannot invoke abstract overloaded method... check your argument(s) type(s)');
                    } else throw new Error('invalid overload');
                  }
                }]);

                function StrutIterator(preFilter, manifestations, postFilter) {
                  _classCallCheck(this, StrutIterator);

                  return _super60.call(this, preFilter, manifestations, postFilter);
                }

                return StrutIterator;
              }(com.vzome.core.generic.FilteredIterator);

              Manifestations.StrutIterator = StrutIterator;
              StrutIterator["__class"] = "com.vzome.core.editor.api.Manifestations.StrutIterator";
              StrutIterator["__interfaces"] = ["java.util.Iterator", "java.lang.Iterable"];

              var PanelIterator =
              /*#__PURE__*/
              function (_com$vzome$core$gener5) {
                _inherits(PanelIterator, _com$vzome$core$gener5);

                var _super61 = _createSuper(PanelIterator);

                _createClass(PanelIterator, [{
                  key: "preFilter$com_vzome_core_model_Manifestation",
                  value: function preFilter$com_vzome_core_model_Manifestation(element) {
                    return element != null && element != null && (element["__interfaces"] != null && element["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0 || element.constructor != null && element.constructor["__interfaces"] != null && element.constructor["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0) ? _get(_getPrototypeOf(PanelIterator.prototype), "preFilter", this).call(this, element) : false;
                  }
                  /**
                  *
                  * @param {*} element
                  * @return {boolean}
                  */

                }, {
                  key: "preFilter",
                  value: function preFilter(element) {
                    if (element != null && (element["__interfaces"] != null && element["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0 || element.constructor != null && element.constructor["__interfaces"] != null && element.constructor["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0) || element === null) {
                      return this.preFilter$com_vzome_core_model_Manifestation(element);
                    } else if (element != null || element === null) {
                      _get(_getPrototypeOf(PanelIterator.prototype), "preFilter", this).call(this, element);
                    } else throw new Error('invalid overload');
                  }
                }, {
                  key: "apply$com_vzome_core_model_Manifestation",
                  value: function apply$com_vzome_core_model_Manifestation(element) {
                    return element;
                  }
                  /**
                  *
                  * @param {*} element
                  * @return {*}
                  */

                }, {
                  key: "apply",
                  value: function apply(element) {
                    if (element != null && (element["__interfaces"] != null && element["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0 || element.constructor != null && element.constructor["__interfaces"] != null && element.constructor["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0) || element === null) {
                      return this.apply$com_vzome_core_model_Manifestation(element);
                    } else if (element != null || element === null) {
                      throw new Error('cannot invoke abstract overloaded method... check your argument(s) type(s)');
                    } else throw new Error('invalid overload');
                  }
                }]);

                function PanelIterator(preFilter, manifestations, postFilter) {
                  _classCallCheck(this, PanelIterator);

                  return _super61.call(this, preFilter, manifestations, postFilter);
                }

                return PanelIterator;
              }(com.vzome.core.generic.FilteredIterator);

              Manifestations.PanelIterator = PanelIterator;
              PanelIterator["__class"] = "com.vzome.core.editor.api.Manifestations.PanelIterator";
              PanelIterator["__interfaces"] = ["java.util.Iterator", "java.lang.Iterable"];

              var Filters =
              /*#__PURE__*/
              function () {
                function Filters() {
                  _classCallCheck(this, Filters);
                }

                _createClass(Filters, null, [{
                  key: "isRendered",
                  value: function isRendered(man) {
                    return man.isRendered();
                  }
                }, {
                  key: "isVisible",
                  value: function isVisible(man) {
                    return !man.isHidden();
                  }
                }, {
                  key: "isHidden",
                  value: function isHidden(man) {
                    return man.isHidden();
                  }
                }, {
                  key: "is",
                  value: function is(man) {
                    return true;
                  }
                }]);

                return Filters;
              }();

              Manifestations.Filters = Filters;
              Filters["__class"] = "com.vzome.core.editor.api.Manifestations.Filters";
            })(Manifestations = api.Manifestations || (api.Manifestations = {}));
          })(editor.api || (editor.api = {}));
        })(core.editor || (core.editor = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (commands) {
          var XmlSymmetryFormat =
          /*#__PURE__*/
          function (_com$vzome$core$comma) {
            _inherits(XmlSymmetryFormat, _com$vzome$core$comma);

            var _super62 = _createSuper(XmlSymmetryFormat);

            function XmlSymmetryFormat(version, capabilities) {
              var _this50;

              _classCallCheck(this, XmlSymmetryFormat);

              _this50 = _super62.call(this, version, capabilities);
              if (_this50.symmetries === undefined) _this50.symmetries = null;
              return _this50;
            }

            _createClass(XmlSymmetryFormat, [{
              key: "initialize$com_vzome_core_algebra_AlgebraicField$com_vzome_core_math_symmetry_OrbitSet_Field$int$java_lang_String$java_util_Properties",
              value: function initialize$com_vzome_core_algebra_AlgebraicField$com_vzome_core_math_symmetry_OrbitSet_Field$int$java_lang_String$java_util_Properties(field, symms, scale, writerVersion, props) {
                _get(_getPrototypeOf(XmlSymmetryFormat.prototype), "initialize", this).call(this, field, scale, writerVersion, props);

                this.symmetries = symms;
              }
            }, {
              key: "initialize",
              value: function initialize(field, symms, scale, writerVersion, props) {
                if ((field != null && (field["__interfaces"] != null && field["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicField") >= 0 || field.constructor != null && field.constructor["__interfaces"] != null && field.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicField") >= 0) || field === null) && (symms != null && (symms["__interfaces"] != null && symms["__interfaces"].indexOf("com.vzome.core.math.symmetry.OrbitSet.Field") >= 0 || symms.constructor != null && symms.constructor["__interfaces"] != null && symms.constructor["__interfaces"].indexOf("com.vzome.core.math.symmetry.OrbitSet.Field") >= 0) || symms === null) && (typeof scale === 'number' || scale === null) && (typeof writerVersion === 'string' || writerVersion === null) && (props != null && props instanceof java.util.Properties || props === null)) {
                  return this.initialize$com_vzome_core_algebra_AlgebraicField$com_vzome_core_math_symmetry_OrbitSet_Field$int$java_lang_String$java_util_Properties(field, symms, scale, writerVersion, props);
                } else if ((field != null && (field["__interfaces"] != null && field["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicField") >= 0 || field.constructor != null && field.constructor["__interfaces"] != null && field.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicField") >= 0) || field === null) && (typeof symms === 'number' || symms === null) && (typeof scale === 'string' || scale === null) && (writerVersion != null && writerVersion instanceof java.util.Properties || writerVersion === null) && props === undefined) {
                  _get(_getPrototypeOf(XmlSymmetryFormat.prototype), "initialize", this).call(this, field, symms, scale, writerVersion);
                } else throw new Error('invalid overload');
              }
            }, {
              key: "parseAlgebraicObject",
              value: function parseAlgebraicObject(valName, val) {
                if (
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(valName, "Symmetry")) {
                  var name = val.getAttribute("name");
                  return this.parseSymmetry(name);
                } else if (
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(valName, "QuaternionicSymmetry")) {
                  var _name = val.getAttribute("name");

                  return this.getQuaternionicSymmetry(_name);
                } else if (
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(valName, "Axis")) return this.parseAxis(val, "symm", "dir", "index", "sense");else {
                  return _get(_getPrototypeOf(XmlSymmetryFormat.prototype), "parseAlgebraicObject", this).call(this, valName, val);
                }
              }
            }, {
              key: "getQuaternionicSymmetry",
              value: function getQuaternionicSymmetry(name) {
                return this.symmetries.getQuaternionSet(name);
              }
            }, {
              key: "parseSymmetry",
              value: function parseSymmetry(sname) {
                var group = this.symmetries.getGroup(sname);
                var symm = group.getSymmetry();

                if (symm == null) {
                  XmlSymmetryFormat.__com_vzome_core_commands_XmlSymmetryFormat_logger_$LI$().severe("UNSUPPORTED symmetry: " + sname);

                  throw new java.lang.IllegalStateException("no symmetry with name=" + sname);
                } else return symm;
              }
            }, {
              key: "parseAxis",
              value: function parseAxis(xml, symmAttr, dirAttr, indexAttr, senseAttr) {
                var sname = xml.getAttribute(symmAttr);
                if (sname == null ||
                /* isEmpty */
                sname.length === 0) sname = "icosahedral";
                var group = this.symmetries.getGroup(sname);
                var aname = xml.getAttribute(dirAttr);
                if (aname == null ||
                /* isEmpty */
                aname.length === 0) aname = "blue";else if (
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(aname, "tan")) aname = "sand";else if (
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(aname, "spring")) aname = "apple";
                var iname = xml.getAttribute(indexAttr);
                var index = javaemul.internal.IntegerHelper.parseInt(iname);
                var sense = com.vzome.core.math.symmetry.Symmetry.PLUS;

                if (
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }("minus", xml.getAttribute(senseAttr))) {
                  sense = com.vzome.core.math.symmetry.Symmetry.MINUS;
                }

                var outbound = true;
                var outs = xml.getAttribute("outbound");
                if (outs != null &&
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(outs, "false")) outbound = false;
                var dir = group.getDirection(aname);

                if (dir == null) {
                  var msg = "Unsupported direction \'" + aname + "\' in " + sname + " symmetry";

                  XmlSymmetryFormat.__com_vzome_core_commands_XmlSymmetryFormat_logger_$LI$().severe(msg);

                  throw new java.lang.IllegalStateException(msg);
                }

                return dir.getAxis$int$int$boolean(sense, index, outbound);
              }
            }], [{
              key: "__static_initialize",
              value: function __static_initialize() {
                if (!XmlSymmetryFormat.__static_initialized) {
                  XmlSymmetryFormat.__static_initialized = true;

                  XmlSymmetryFormat.__static_initializer_0();
                }
              }
            }, {
              key: "__com_vzome_core_commands_XmlSymmetryFormat_logger_$LI$",
              value: function __com_vzome_core_commands_XmlSymmetryFormat_logger_$LI$() {
                XmlSymmetryFormat.__static_initialize();

                if (XmlSymmetryFormat.__com_vzome_core_commands_XmlSymmetryFormat_logger == null) XmlSymmetryFormat.__com_vzome_core_commands_XmlSymmetryFormat_logger = java.util.logging.Logger.getLogger("com.vzome.core.commands.XmlSaveFormat");
                return XmlSymmetryFormat.__com_vzome_core_commands_XmlSymmetryFormat_logger;
              }
            }, {
              key: "__static_initializer_0",
              value: function __static_initializer_0() {
                new XmlSymmetryFormat("http://tns.vorthmann.org/vZome/2.0/", [com.vzome.core.commands.XmlSaveFormat.PROJECT_4D, com.vzome.core.commands.XmlSaveFormat.SELECTION_NOT_SAVED]);
                new XmlSymmetryFormat("http://tns.vorthmann.org/vZome/2.0.1/", [com.vzome.core.commands.XmlSaveFormat.PROJECT_4D, com.vzome.core.commands.XmlSaveFormat.SELECTION_NOT_SAVED]);
                new XmlSymmetryFormat("http://tns.vorthmann.org/vZome/2.0.2/", [com.vzome.core.commands.XmlSaveFormat.SELECTION_NOT_SAVED]);
                new XmlSymmetryFormat("http://tns.vorthmann.org/vZome/2.0.3/", [com.vzome.core.commands.XmlSaveFormat.SELECTION_NOT_SAVED]);
                new XmlSymmetryFormat("http://tns.vorthmann.org/vZome/2.1.0/", [com.vzome.core.commands.XmlSaveFormat.SELECTION_NOT_SAVED, com.vzome.core.commands.XmlSaveFormat.FORMAT_2_1_0]);
                new XmlSymmetryFormat("http://tns.vorthmann.org/vZome/3.0.0/", [com.vzome.core.commands.XmlSaveFormat.GROUPING_IN_SELECTION]);
                new XmlSymmetryFormat("http://tns.vorthmann.org/vZome/4.0.0/", [com.vzome.core.commands.XmlSaveFormat.RATIONAL_VECTORS, com.vzome.core.commands.XmlSaveFormat.GROUPING_IN_SELECTION]);
                new XmlSymmetryFormat("http://tns.vorthmann.org/vZome/5.0.0/", [com.vzome.core.commands.XmlSaveFormat.RATIONAL_VECTORS, com.vzome.core.commands.XmlSaveFormat.COMPACTED_COMMAND_EDITS]);
                new XmlSymmetryFormat(com.vzome.core.commands.XmlSaveFormat.CURRENT_FORMAT, [com.vzome.core.commands.XmlSaveFormat.RATIONAL_VECTORS, com.vzome.core.commands.XmlSaveFormat.COMPACTED_COMMAND_EDITS, com.vzome.core.commands.XmlSaveFormat.MULTIPLE_DESIGNS]);
              }
            }, {
              key: "getFormat",
              value: function getFormat(namespace) {
                return com.vzome.core.commands.XmlSaveFormat.FORMATS_$LI$().get(namespace);
              }
            }, {
              key: "serializeAxis",
              value: function serializeAxis(xml, symmAttr, dirAttr, indexAttr, senseAttr, axis) {
                var str = axis.getDirection().getSymmetry().getName();
                if (!function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }("icosahedral", str)) com.vzome.xml.DomUtils.addAttribute(xml, symmAttr, str);
                str = axis.getDirection().getName();
                if (!function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }("blue", str)) com.vzome.xml.DomUtils.addAttribute(xml, dirAttr, str);
                com.vzome.xml.DomUtils.addAttribute(xml, indexAttr,
                /* toString */
                '' + axis.getOrientation());
                if (axis.getSense() !== com.vzome.core.math.symmetry.Symmetry.PLUS) com.vzome.xml.DomUtils.addAttribute(xml, "sense", "minus");
                if (!axis.isOutbound()) com.vzome.xml.DomUtils.addAttribute(xml, "outbound", "false");
              }
            }]);

            return XmlSymmetryFormat;
          }(com.vzome.core.commands.XmlSaveFormat);

          XmlSymmetryFormat.__static_initialized = false;
          commands.XmlSymmetryFormat = XmlSymmetryFormat;
          XmlSymmetryFormat["__class"] = "com.vzome.core.commands.XmlSymmetryFormat";
        })(core.commands || (core.commands = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (commands) {
          /**
          * @author Scott Vorthmann
          * @class
          * @extends com.vzome.core.commands.AbstractCommand
          */
          var CommandFreePoint =
          /*#__PURE__*/
          function (_com$vzome$core$comma2) {
            _inherits(CommandFreePoint, _com$vzome$core$comma2);

            var _super63 = _createSuper(CommandFreePoint);

            function CommandFreePoint() {
              _classCallCheck(this, CommandFreePoint);

              return _super63.call(this);
            }

            _createClass(CommandFreePoint, [{
              key: "getParameterSignature",

              /**
              *
              * @return {Array}
              */
              value: function getParameterSignature() {
                return CommandFreePoint.PARAMS_$LI$();
              }
              /**
              *
              * @return {Array}
              */

            }, {
              key: "getAttributeSignature",
              value: function getAttributeSignature() {
                return null;
              }
              /**
              *
              * @param {com.vzome.core.construction.ConstructionList} parameters
              * @param {com.vzome.core.commands.AttributeMap} attributes
              * @param {*} effects
              * @return {com.vzome.core.construction.ConstructionList}
              */

            }, {
              key: "apply",
              value: function apply(parameters, attributes, effects) {
                var result = new com.vzome.core.construction.ConstructionList();
                var loc = attributes.get("where");
                var pt2 = new com.vzome.core.construction.FreePoint(loc);
                effects.constructionAdded(pt2);
                result.addConstruction(pt2);
                return result;
              }
            }], [{
              key: "PARAMS_$LI$",
              value: function PARAMS_$LI$() {
                if (CommandFreePoint.PARAMS == null) CommandFreePoint.PARAMS = [];
                return CommandFreePoint.PARAMS;
              }
            }]);

            return CommandFreePoint;
          }(com.vzome.core.commands.AbstractCommand);

          commands.CommandFreePoint = CommandFreePoint;
          CommandFreePoint["__class"] = "com.vzome.core.commands.CommandFreePoint";
          CommandFreePoint["__interfaces"] = ["com.vzome.core.commands.Command"];
        })(core.commands || (core.commands = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (commands) {
          /**
          * @author Scott Vorthmann
          * @class
          * @extends com.vzome.core.commands.AbstractCommand
          */
          var CommandHide =
          /*#__PURE__*/
          function (_com$vzome$core$comma3) {
            _inherits(CommandHide, _com$vzome$core$comma3);

            var _super64 = _createSuper(CommandHide);

            function CommandHide() {
              _classCallCheck(this, CommandHide);

              return _super64.call(this);
            }

            _createClass(CommandHide, [{
              key: "getParameterSignature",

              /**
              *
              * @return {Array}
              */
              value: function getParameterSignature() {
                return CommandHide.PARAM_SIGNATURE_$LI$();
              }
              /**
              *
              * @return {Array}
              */

            }, {
              key: "getAttributeSignature",
              value: function getAttributeSignature() {
                return CommandHide.ATTR_SIGNATURE_$LI$();
              }
              /**
              *
              * @param {com.vzome.core.construction.ConstructionList} parameters
              * @param {com.vzome.core.commands.AttributeMap} attributes
              * @param {*} effects
              * @return {com.vzome.core.construction.ConstructionList}
              */

            }, {
              key: "apply",
              value: function apply(parameters, attributes, effects) {
                throw new commands.Command.Failure("CommandHide apply attempted");
              }
            }], [{
              key: "PARAM_SIGNATURE_$LI$",
              value: function PARAM_SIGNATURE_$LI$() {
                if (CommandHide.PARAM_SIGNATURE == null) CommandHide.PARAM_SIGNATURE = [[com.vzome.core.commands.Command.GENERIC_PARAM_NAME, com.vzome.core.construction.Construction]];
                return CommandHide.PARAM_SIGNATURE;
              }
            }, {
              key: "ATTR_SIGNATURE_$LI$",
              value: function ATTR_SIGNATURE_$LI$() {
                if (CommandHide.ATTR_SIGNATURE == null) CommandHide.ATTR_SIGNATURE = [];
                return CommandHide.ATTR_SIGNATURE;
              }
            }]);

            return CommandHide;
          }(com.vzome.core.commands.AbstractCommand);

          commands.CommandHide = CommandHide;
          CommandHide["__class"] = "com.vzome.core.commands.CommandHide";
          CommandHide["__interfaces"] = ["com.vzome.core.commands.Command"];
        })(core.commands || (core.commands = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (commands) {
          var CommandSetColor =
          /*#__PURE__*/
          function (_com$vzome$core$comma4) {
            _inherits(CommandSetColor, _com$vzome$core$comma4);

            var _super65 = _createSuper(CommandSetColor);

            function CommandSetColor() {
              _classCallCheck(this, CommandSetColor);

              return _super65.call(this);
            }

            _createClass(CommandSetColor, [{
              key: "getParameterSignature",

              /**
              *
              * @return {Array}
              */
              value: function getParameterSignature() {
                return CommandSetColor.PARAM_SIGNATURE_$LI$();
              }
              /**
              *
              * @return {Array}
              */

            }, {
              key: "getAttributeSignature",
              value: function getAttributeSignature() {
                return null;
              }
              /**
              *
              * @param {com.vzome.core.construction.ConstructionList} parameters
              * @param {com.vzome.core.commands.AttributeMap} attributes
              * @param {*} effects
              * @return {com.vzome.core.construction.ConstructionList}
              */

            }, {
              key: "apply",
              value: function apply(parameters, attributes, effects) {
                return parameters;
              }
            }], [{
              key: "PARAM_SIGNATURE_$LI$",
              value: function PARAM_SIGNATURE_$LI$() {
                if (CommandSetColor.PARAM_SIGNATURE == null) CommandSetColor.PARAM_SIGNATURE = [];
                return CommandSetColor.PARAM_SIGNATURE;
              }
            }]);

            return CommandSetColor;
          }(com.vzome.core.commands.AbstractCommand);

          CommandSetColor.MANIFESTATION_ATTR = "manifestation.context";
          CommandSetColor.COLOR_ATTR = "color";
          commands.CommandSetColor = CommandSetColor;
          CommandSetColor["__class"] = "com.vzome.core.commands.CommandSetColor";
          CommandSetColor["__interfaces"] = ["com.vzome.core.commands.Command"];
        })(core.commands || (core.commands = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          var GroupSelection =
          /*#__PURE__*/
          function (_com$vzome$core$edito) {
            _inherits(GroupSelection, _com$vzome$core$edito);

            var _super66 = _createSuper(GroupSelection);

            function GroupSelection(editor) {
              var _this51;

              _classCallCheck(this, GroupSelection);

              _this51 = _super66.call(this);
              if (_this51.mSelection === undefined) _this51.mSelection = null;
              _this51.mGrouping = false;
              _this51.recursiveGroups = true;
              _this51.unnecessary = false;
              _this51.mSelection = editor.getSelection();
              return _this51;
            }
            /**
            *
            * @param {*} props
            */


            _createClass(GroupSelection, [{
              key: "configure",
              value: function configure(props) {
                var mode = props.get("mode");

                this.mGrouping = mode == null ||
                /* isEmpty */
                mode.length === 0 ||
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(mode, "group");

                this.unnecessary = this.mGrouping === this.mSelection.isSelectionAGroup();
              }
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "isNoOp",
              value: function isNoOp() {
                return this.unnecessary;
              }
              /**
              *
              * @param {*} doc
              * @return {*}
              */

            }, {
              key: "getXml",
              value: function getXml(doc) {
                var elem = doc.createElement("GroupSelection");
                if (!this.mGrouping) com.vzome.xml.DomUtils.addAttribute(elem, "grouping", "false");
                return elem;
              }
              /**
              *
              * @param {*} doc
              * @return {*}
              */

            }, {
              key: "getDetailXml",
              value: function getDetailXml(doc) {
                return this.getXml(doc);
              }
              /**
              *
              * @param {*} xml
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              * @param {*} context
              */

            }, {
              key: "loadAndPerform",
              value: function loadAndPerform(xml, format, context) {
                var grouping = xml.getAttribute("grouping");

                this.mGrouping = grouping == null ||
                /* isEmpty */
                grouping.length === 0 ||
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(grouping, "true");

                this.recursiveGroups = format.groupingRecursive();
                context.performAndRecord(this);
              }
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "isDestructive",
              value: function isDestructive() {
                return true;
              }
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "isVisible",
              value: function isVisible() {
                return true;
              }
              /**
              *
              */

            }, {
              key: "redo",
              value: function redo() {
                if (this.mGrouping) {
                  if (this.recursiveGroups) this.mSelection.gatherGroup();else this.mSelection.gatherGroup211();
                } else if (this.recursiveGroups) this.mSelection.scatterGroup();else this.mSelection.scatterGroup211();
              }
              /**
              *
              */

            }, {
              key: "undo",
              value: function undo() {
                if (!this.mGrouping) {
                  if (this.recursiveGroups) this.mSelection.gatherGroup();else this.mSelection.gatherGroup211();
                } else if (this.recursiveGroups) this.mSelection.scatterGroup();else this.mSelection.scatterGroup211();
              }
              /**
              *
              */

            }, {
              key: "perform",
              value: function perform() {
                if (this.unnecessary) return;
                this.redo();
              }
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "isSticky",
              value: function isSticky() {
                return false;
              }
            }]);

            return GroupSelection;
          }(com.vzome.core.editor.api.UndoableEdit);

          edits.GroupSelection = GroupSelection;
          GroupSelection["__class"] = "com.vzome.core.edits.GroupSelection";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          /**
          * Used by CommandEdit.
          * @param {*} editor
          * @param m
          * @param {com.vzome.core.construction.Point} newCenter
          * @class
          * @extends com.vzome.core.editor.api.UndoableEdit
          */
          var SymmetryCenterChange =
          /*#__PURE__*/
          function (_com$vzome$core$edito2) {
            _inherits(SymmetryCenterChange, _com$vzome$core$edito2);

            var _super67 = _createSuper(SymmetryCenterChange);

            function SymmetryCenterChange(editor, newCenter) {
              var _this52;

              _classCallCheck(this, SymmetryCenterChange);

              if ((editor != null && (editor["__interfaces"] != null && editor["__interfaces"].indexOf("com.vzome.core.editor.api.ImplicitSymmetryParameters") >= 0 || editor.constructor != null && editor.constructor["__interfaces"] != null && editor.constructor["__interfaces"].indexOf("com.vzome.core.editor.api.ImplicitSymmetryParameters") >= 0) || editor === null) && (newCenter != null && newCenter instanceof com.vzome.core.construction.Point || newCenter === null)) {
                _this52 = _super67.call(this);
                if (_this52.mOldCenter === undefined) _this52.mOldCenter = null;
                if (_this52.mNewCenter === undefined) _this52.mNewCenter = null;
                if (_this52.editor === undefined) _this52.editor = null;
                if (_this52.mOldCenter === undefined) _this52.mOldCenter = null;
                if (_this52.mNewCenter === undefined) _this52.mNewCenter = null;
                if (_this52.editor === undefined) _this52.editor = null;

                (function () {
                  _this52.mOldCenter = editor.getCenterPoint();
                  _this52.mNewCenter = newCenter;
                  _this52.editor = editor;
                })();
              } else if ((editor != null && (editor["__interfaces"] != null && editor["__interfaces"].indexOf("com.vzome.core.editor.api.ImplicitSymmetryParameters") >= 0 || editor.constructor != null && editor.constructor["__interfaces"] != null && editor.constructor["__interfaces"].indexOf("com.vzome.core.editor.api.ImplicitSymmetryParameters") >= 0) || editor === null) && newCenter === undefined) {
                {
                  var _newCenter = null;
                  _this52 = _super67.call(this);
                  if (_this52.mOldCenter === undefined) _this52.mOldCenter = null;
                  if (_this52.mNewCenter === undefined) _this52.mNewCenter = null;
                  if (_this52.editor === undefined) _this52.editor = null;
                  if (_this52.mOldCenter === undefined) _this52.mOldCenter = null;
                  if (_this52.mNewCenter === undefined) _this52.mNewCenter = null;
                  if (_this52.editor === undefined) _this52.editor = null;

                  (function () {
                    _this52.mOldCenter = editor.getCenterPoint();
                    _this52.mNewCenter = _newCenter;
                    _this52.editor = editor;
                  })();
                }
              } else throw new Error('invalid overload');

              return _possibleConstructorReturn(_this52);
            }

            _createClass(SymmetryCenterChange, [{
              key: "configure",
              value: function configure(props) {
                var man = props.get("picked");
                if (man != null) this.mNewCenter = man.getFirstConstruction();
              }
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "isNoOp",
              value: function isNoOp() {
                return this.mNewCenter == null || this.mNewCenter.getLocation().equals(this.mOldCenter.getLocation());
              }
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "isVisible",
              value: function isVisible() {
                return false;
              }
              /**
              *
              */

            }, {
              key: "redo",
              value: function redo() {
                if (this.isNoOp()) return;
                this.editor.setCenterPoint(this.mNewCenter);
              }
              /**
              *
              */

            }, {
              key: "undo",
              value: function undo() {
                if (this.isNoOp()) return;
                this.editor.setCenterPoint(this.mOldCenter);
              }
              /**
              *
              * @param {*} doc
              * @return {*}
              */

            }, {
              key: "getXml",
              value: function getXml(doc) {
                var result = doc.createElement("SymmetryCenterChange");
                com.vzome.core.commands.XmlSaveFormat.serializePoint(result, "new", this.mNewCenter);
                return result;
              }
              /**
              *
              * @param {*} doc
              * @return {*}
              */

            }, {
              key: "getDetailXml",
              value: function getDetailXml(doc) {
                return this.getXml(doc);
              }
              /**
              *
              * @param {*} xml
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              * @param {*} context
              */

            }, {
              key: "loadAndPerform",
              value: function loadAndPerform(xml, format, context) {
                if (format.rationalVectors()) {
                  this.mNewCenter = format.parsePoint$org_w3c_dom_Element$java_lang_String(xml, "new");
                } else {
                  var attrs = format.loadCommandAttributes$org_w3c_dom_Element(xml);
                  var center = attrs.get("new");
                  this.mNewCenter = new com.vzome.core.construction.FreePoint(center.getLocation().projectTo3d(true));
                }

                context.performAndRecord(this);
              }
              /**
              *
              */

            }, {
              key: "perform",
              value: function perform() {
                if (this.mNewCenter == null) {
                  this.mNewCenter = this.editor.getSelectedConstruction(com.vzome.core.construction.Point);
                  if (this.mNewCenter == null) throw new com.vzome.core.commands.Command.Failure("Selection is not a single ball.");
                }

                this.redo();
              }
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "isDestructive",
              value: function isDestructive() {
                return true;
              }
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "isSticky",
              value: function isSticky() {
                return false;
              }
            }]);

            return SymmetryCenterChange;
          }(com.vzome.core.editor.api.UndoableEdit);

          edits.SymmetryCenterChange = SymmetryCenterChange;
          SymmetryCenterChange["__class"] = "com.vzome.core.edits.SymmetryCenterChange";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          /**
          * Used by CommandEdit.
          * @param {*} editor
          * @param m
          * @param {com.vzome.core.construction.Segment} newAxis
          * @class
          * @extends com.vzome.core.editor.api.UndoableEdit
          */
          var SymmetryAxisChange =
          /*#__PURE__*/
          function (_com$vzome$core$edito3) {
            _inherits(SymmetryAxisChange, _com$vzome$core$edito3);

            var _super68 = _createSuper(SymmetryAxisChange);

            function SymmetryAxisChange(editor, newAxis) {
              var _this53;

              _classCallCheck(this, SymmetryAxisChange);

              if ((editor != null && (editor["__interfaces"] != null && editor["__interfaces"].indexOf("com.vzome.core.editor.api.ImplicitSymmetryParameters") >= 0 || editor.constructor != null && editor.constructor["__interfaces"] != null && editor.constructor["__interfaces"].indexOf("com.vzome.core.editor.api.ImplicitSymmetryParameters") >= 0) || editor === null) && (newAxis != null && newAxis instanceof com.vzome.core.construction.Segment || newAxis === null)) {
                _this53 = _super68.call(this);
                if (_this53.mOldAxis === undefined) _this53.mOldAxis = null;
                if (_this53.mNewAxis === undefined) _this53.mNewAxis = null;
                if (_this53.mEditor === undefined) _this53.mEditor = null;
                if (_this53.mOldAxis === undefined) _this53.mOldAxis = null;
                if (_this53.mNewAxis === undefined) _this53.mNewAxis = null;
                if (_this53.mEditor === undefined) _this53.mEditor = null;

                (function () {
                  _this53.mOldAxis = editor.getSymmetrySegment();
                  _this53.mNewAxis = newAxis;
                  _this53.mEditor = editor;
                })();
              } else if ((editor != null && (editor["__interfaces"] != null && editor["__interfaces"].indexOf("com.vzome.core.editor.api.ImplicitSymmetryParameters") >= 0 || editor.constructor != null && editor.constructor["__interfaces"] != null && editor.constructor["__interfaces"].indexOf("com.vzome.core.editor.api.ImplicitSymmetryParameters") >= 0) || editor === null) && newAxis === undefined) {
                {
                  var _newAxis = null;
                  _this53 = _super68.call(this);
                  if (_this53.mOldAxis === undefined) _this53.mOldAxis = null;
                  if (_this53.mNewAxis === undefined) _this53.mNewAxis = null;
                  if (_this53.mEditor === undefined) _this53.mEditor = null;
                  if (_this53.mOldAxis === undefined) _this53.mOldAxis = null;
                  if (_this53.mNewAxis === undefined) _this53.mNewAxis = null;
                  if (_this53.mEditor === undefined) _this53.mEditor = null;

                  (function () {
                    _this53.mOldAxis = editor.getSymmetrySegment();
                    _this53.mNewAxis = _newAxis;
                    _this53.mEditor = editor;
                  })();
                }
              } else throw new Error('invalid overload');

              return _possibleConstructorReturn(_this53);
            }

            _createClass(SymmetryAxisChange, [{
              key: "configure",
              value: function configure(props) {
                var man = props.get("picked");
                if (man != null) this.mNewAxis = man.getFirstConstruction();
              }
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "isVisible",
              value: function isVisible() {
                return false;
              }
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "isNoOp",
              value: function isNoOp() {
                return this.mNewAxis == null || this.mOldAxis != null && this.mNewAxis.getStart().equals(this.mOldAxis.getStart()) && this.mNewAxis.getEnd().equals(this.mOldAxis.getEnd());
              }
              /**
              *
              */

            }, {
              key: "redo",
              value: function redo() {
                if (this.isNoOp()) return;
                this.mEditor.setSymmetrySegment(this.mNewAxis);
              }
              /**
              *
              */

            }, {
              key: "undo",
              value: function undo() {
                if (this.isNoOp()) return;
                this.mEditor.setSymmetrySegment(this.mOldAxis);
              }
              /**
              *
              * @param {*} doc
              * @return {*}
              */

            }, {
              key: "getXml",
              value: function getXml(doc) {
                var result = doc.createElement("SymmetryAxisChange");
                com.vzome.core.commands.XmlSaveFormat.serializeSegment(result, "start", "end", this.mNewAxis);
                return result;
              }
              /**
              *
              * @param {*} doc
              * @return {*}
              */

            }, {
              key: "getDetailXml",
              value: function getDetailXml(doc) {
                return this.getXml(doc);
              }
              /**
              *
              * @param {*} xml
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              * @param {*} context
              */

            }, {
              key: "loadAndPerform",
              value: function loadAndPerform(xml, format, context) {
                if (format.rationalVectors()) {
                  this.mNewAxis = format.parseSegment$org_w3c_dom_Element$java_lang_String$java_lang_String(xml, "start", "end");
                } else {
                  var attrs = format.loadCommandAttributes$org_w3c_dom_Element(xml);
                  this.mNewAxis = attrs.get("new");
                }

                context.performAndRecord(this);
              }
              /**
              *
              */

            }, {
              key: "perform",
              value: function perform() {
                if (this.mNewAxis == null) {
                  this.mNewAxis = this.mEditor.getSelectedConstruction(com.vzome.core.construction.Segment);
                  if (this.mNewAxis == null) throw new com.vzome.core.commands.Command.Failure("Selection is not a single strut.");
                }

                this.redo();
              }
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "isDestructive",
              value: function isDestructive() {
                return true;
              }
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "isSticky",
              value: function isSticky() {
                return false;
              }
            }]);

            return SymmetryAxisChange;
          }(com.vzome.core.editor.api.UndoableEdit);

          edits.SymmetryAxisChange = SymmetryAxisChange;
          SymmetryAxisChange["__class"] = "com.vzome.core.edits.SymmetryAxisChange";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (editor_3) {
          /**
          * Just a marker in the history.
          * @author Scott Vorthmann
          * @param {*} editor
          * @class
          * @extends com.vzome.core.editor.api.UndoableEdit
          */
          var EndBlock =
          /*#__PURE__*/
          function (_com$vzome$core$edito4) {
            _inherits(EndBlock, _com$vzome$core$edito4);

            var _super69 = _createSuper(EndBlock);

            function EndBlock(editor) {
              _classCallCheck(this, EndBlock);

              return _super69.call(this);
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(EndBlock, [{
              key: "isNoOp",
              value: function isNoOp() {
                return false;
              }
              /**
              *
              * @param {*} doc
              * @return {*}
              */

            }, {
              key: "getXml",
              value: function getXml(doc) {
                return doc.createElement("EndBlock");
              }
              /**
              *
              * @param {*} doc
              * @return {*}
              */

            }, {
              key: "getDetailXml",
              value: function getDetailXml(doc) {
                return this.getXml(doc);
              }
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "isVisible",
              value: function isVisible() {
                return false;
              }
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "isDestructive",
              value: function isDestructive() {
                return false;
              }
              /**
              *
              */

            }, {
              key: "redo",
              value: function redo() {}
              /**
              *
              * @param {*} xml
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              * @param {*} context
              */

            }, {
              key: "loadAndPerform",
              value: function loadAndPerform(xml, format, context) {
                context.performAndRecord(this);
              }
              /**
              *
              */

            }, {
              key: "undo",
              value: function undo() {}
              /**
              *
              * @param {*} props
              */

            }, {
              key: "configure",
              value: function configure(props) {}
              /**
              *
              */

            }, {
              key: "perform",
              value: function perform() {}
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "isSticky",
              value: function isSticky() {
                return false;
              }
            }]);

            return EndBlock;
          }(com.vzome.core.editor.api.UndoableEdit);

          editor_3.EndBlock = EndBlock;
          EndBlock["__class"] = "com.vzome.core.editor.EndBlock";
        })(core.editor || (core.editor = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (editor_4) {
          /**
          * Just a marker in the history.
          * @author Scott Vorthmann
          * @param {*} editor
          * @class
          * @extends com.vzome.core.editor.api.UndoableEdit
          */
          var BeginBlock =
          /*#__PURE__*/
          function (_com$vzome$core$edito5) {
            _inherits(BeginBlock, _com$vzome$core$edito5);

            var _super70 = _createSuper(BeginBlock);

            function BeginBlock(editor) {
              _classCallCheck(this, BeginBlock);

              return _super70.call(this);
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(BeginBlock, [{
              key: "isNoOp",
              value: function isNoOp() {
                return false;
              }
              /**
              *
              * @param {*} doc
              * @return {*}
              */

            }, {
              key: "getXml",
              value: function getXml(doc) {
                return doc.createElement("BeginBlock");
              }
              /**
              *
              * @param {*} doc
              * @return {*}
              */

            }, {
              key: "getDetailXml",
              value: function getDetailXml(doc) {
                return this.getXml(doc);
              }
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "isVisible",
              value: function isVisible() {
                return false;
              }
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "isDestructive",
              value: function isDestructive() {
                return false;
              }
              /**
              *
              */

            }, {
              key: "redo",
              value: function redo() {}
              /**
              *
              * @param {*} xml
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              * @param {*} context
              */

            }, {
              key: "loadAndPerform",
              value: function loadAndPerform(xml, format, context) {
                context.performAndRecord(this);
              }
              /**
              *
              */

            }, {
              key: "undo",
              value: function undo() {}
              /**
              *
              */

            }, {
              key: "perform",
              value: function perform() {}
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "isSticky",
              value: function isSticky() {
                return false;
              }
              /**
              *
              * @param {*} props
              */

            }, {
              key: "configure",
              value: function configure(props) {}
            }]);

            return BeginBlock;
          }(com.vzome.core.editor.api.UndoableEdit);

          editor_4.BeginBlock = BeginBlock;
          BeginBlock["__class"] = "com.vzome.core.editor.BeginBlock";
        })(core.editor || (core.editor = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (editor) {
          (function (api) {
            var SideEffects =
            /*#__PURE__*/
            function (_com$vzome$core$edito6) {
              _inherits(SideEffects, _com$vzome$core$edito6);

              var _super71 = _createSuper(SideEffects);

              function SideEffects() {
                var _this54;

                _classCallCheck(this, SideEffects);

                _this54 = _super71.call(this);
                _this54.mItems = new java.util.ArrayList();
                _this54.redone = 0;
                return _this54;
              }
              /**
              *
              * @param {*} doc
              * @return {*}
              */


              _createClass(SideEffects, [{
                key: "getDetailXml",
                value: function getDetailXml(doc) {
                  var result = this.getXml(doc);
                  var effects = doc.createElement("effects");

                  for (var index663 = this.mItems.iterator(); index663.hasNext();) {
                    var se = index663.next();
                    {
                      if (se != null) {
                        var effect = se.getXml(doc);

                        if (effect != null) {
                          effects.appendChild(effect);
                        }
                      }
                    }
                  }

                  result.appendChild(effects);
                  return result;
                }
                /**
                *
                * @return {boolean}
                */

              }, {
                key: "isSticky",
                value: function isSticky() {
                  return false;
                }
              }, {
                key: "isVisible",

                /**
                *
                * @return {boolean}
                */
                value: function isVisible() {
                  return true;
                }
                /**
                *
                * @return {boolean}
                */

              }, {
                key: "isDestructive",
                value: function isDestructive() {
                  return true;
                }
              }, {
                key: "plan",
                value: function plan(se) {
                  this.mItems.add(se);
                }
                /**
                *
                */

              }, {
                key: "perform",
                value: function perform() {
                  this.redo();
                }
              }, {
                key: "fail",
                value: function fail(message) {
                  this.undo();
                  throw new com.vzome.core.commands.Command.Failure(message);
                }
                /**
                *
                * @param {*} props
                */

              }, {
                key: "configure",
                value: function configure(props) {}
                /**
                *
                * @return {boolean}
                */

              }, {
                key: "isNoOp",
                value: function isNoOp() {
                  return this.mItems.size() === 0;
                }
                /**
                *
                */

              }, {
                key: "redo",
                value: function redo() {
                  for (var i = this.redone; i < this.mItems.size(); i++) {
                    {
                      var se = this.mItems.get(i);
                      if (se != null) se.redo();
                    }
                  }

                  this.redone = this.mItems.size();
                }
                /**
                *
                */

              }, {
                key: "undo",
                value: function undo() {
                  for (var i = this.mItems.size(); i > 0; i--) {
                    {
                      var se = this.mItems.get(i - 1);
                      if (se != null) se.undo();
                    }
                  }

                  this.redone = 0;
                }
              }, {
                key: "getEffects",
                value: function getEffects() {
                  return this.mItems.iterator();
                }
              }], [{
                key: "BUG_ACCOMMODATION_LOGGER_$LI$",
                value: function BUG_ACCOMMODATION_LOGGER_$LI$() {
                  if (SideEffects.BUG_ACCOMMODATION_LOGGER == null) SideEffects.BUG_ACCOMMODATION_LOGGER = java.util.logging.Logger.getLogger("com.vzome.core.bug.accommodations");
                  return SideEffects.BUG_ACCOMMODATION_LOGGER;
                }
              }, {
                key: "logBugAccommodation",
                value: function logBugAccommodation(accommodation) {
                  if (SideEffects.BUG_ACCOMMODATION_LOGGER_$LI$().isLoggable(java.util.logging.Level.WARNING)) SideEffects.BUG_ACCOMMODATION_LOGGER_$LI$().warning("ACCOMMODATION: " + accommodation);
                }
              }]);

              return SideEffects;
            }(com.vzome.core.editor.api.UndoableEdit);

            api.SideEffects = SideEffects;
            SideEffects["__class"] = "com.vzome.core.editor.api.SideEffects";
          })(editor.api || (editor.api = {}));
        })(core.editor || (core.editor = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (tools_1) {
          var OctahedralToolFactory =
          /*#__PURE__*/
          function (_com$vzome$core$edito7) {
            _inherits(OctahedralToolFactory, _com$vzome$core$edito7);

            var _super72 = _createSuper(OctahedralToolFactory);

            function OctahedralToolFactory(tools, symmetry) {
              var id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : OctahedralToolFactory.ID;
              var label = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : OctahedralToolFactory.LABEL;
              var tooltip = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : OctahedralToolFactory.TOOLTIP2;

              _classCallCheck(this, OctahedralToolFactory);

              return _super72.call(this, tools, symmetry, id, label, tooltip);
            }
            /**
            *
            * @param {number} total
            * @param {number} balls
            * @param {number} struts
            * @param {number} panels
            * @return {boolean}
            */


            _createClass(OctahedralToolFactory, [{
              key: "countsAreValid",
              value: function countsAreValid(total, balls, struts, panels) {
                return total === 1 && balls === 1 || total === 2 && balls === 1 && struts === 1;
              }
              /**
              *
              * @param {string} id
              * @return {com.vzome.core.editor.Tool}
              */

            }, {
              key: "createToolInternal",
              value: function createToolInternal(id) {
                return new com.vzome.core.tools.SymmetryTool(id, this.getSymmetry(), this.getToolsModel());
              }
              /**
              *
              * @param {*} selection
              * @return {boolean}
              */

            }, {
              key: "bindParameters",
              value: function bindParameters(selection) {
                var symmetry = this.getSymmetry();
                var total = this.getSelection().size();

                if (symmetry != null && symmetry instanceof com.vzome.core.math.symmetry.IcosahedralSymmetry) {
                  if (total !== 2) return false;

                  for (var index664 = selection.iterator(); index664.hasNext();) {
                    var man = index664.next();

                    if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0)) {
                      var zone = symmetry['getAxis$com_vzome_core_algebra_AlgebraicVector'](man.getOffset());
                      if (zone == null) return false;

                      switch (zone.getDirection().getName()) {
                        case "blue":
                        case "green":
                          return true;

                        default:
                          return false;
                      }
                    }
                  }

                  return false;
                } else {
                  return total === 1;
                }
              }
            }]);

            return OctahedralToolFactory;
          }(com.vzome.core.editor.AbstractToolFactory);

          OctahedralToolFactory.ID = "octahedral";
          OctahedralToolFactory.LABEL = "Create an octahedral symmetry tool";
          OctahedralToolFactory.TOOLTIP1 = "<p>Each tool produces up to 23 copies of the input<br>selection, using the rotation symmetries of a<br>cube or octahedron.  To create a tool, select a<br>ball that defines the center of symmetry, and<br>a single blue or green strut, defining one of<br>five possible orientations for the symmetry.<br><br>Combine with a point reflection tool to achieve<br>all 48 symmetries of the octahedron, including<br>reflections.<br></p>";
          OctahedralToolFactory.TOOLTIP2 = "<p>Each tool produces up to 23 copies of the input<br>selection, using the rotation symmetries of a<br>cube or octahedron.  To create a tool, select a<br>ball that defines the center of symmetry.<br><br>Combine with a point reflection tool to achieve<br>all 48 symmetries of the octahedron, including<br>reflections.<br></p>";
          tools_1.OctahedralToolFactory = OctahedralToolFactory;
          OctahedralToolFactory["__class"] = "com.vzome.core.tools.OctahedralToolFactory";
          OctahedralToolFactory["__interfaces"] = ["com.vzome.core.editor.SelectionSummary.Listener", "com.vzome.api.Tool.Factory"];
        })(core.tools || (core.tools = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (tools_2) {
          var IcosahedralToolFactory =
          /*#__PURE__*/
          function (_com$vzome$core$edito8) {
            _inherits(IcosahedralToolFactory, _com$vzome$core$edito8);

            var _super73 = _createSuper(IcosahedralToolFactory);

            function IcosahedralToolFactory(tools, symmetry) {
              _classCallCheck(this, IcosahedralToolFactory);

              return _super73.call(this, tools, symmetry, IcosahedralToolFactory.ID, IcosahedralToolFactory.LABEL, IcosahedralToolFactory.TOOLTIP);
            }
            /**
            *
            * @param {number} total
            * @param {number} balls
            * @param {number} struts
            * @param {number} panels
            * @return {boolean}
            */


            _createClass(IcosahedralToolFactory, [{
              key: "countsAreValid",
              value: function countsAreValid(total, balls, struts, panels) {
                return total === 1 && balls === 1;
              }
              /**
              *
              * @param {string} id
              * @return {com.vzome.core.editor.Tool}
              */

            }, {
              key: "createToolInternal",
              value: function createToolInternal(id) {
                return new com.vzome.core.tools.SymmetryTool(id, this.getSymmetry(), this.getToolsModel());
              }
              /**
              *
              * @param {*} selection
              * @return {boolean}
              */

            }, {
              key: "bindParameters",
              value: function bindParameters(selection) {
                return selection.size() === 1 && selection.iterator().next() != null && (selection.iterator().next()["__interfaces"] != null && selection.iterator().next()["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || selection.iterator().next().constructor != null && selection.iterator().next().constructor["__interfaces"] != null && selection.iterator().next().constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0);
              }
            }]);

            return IcosahedralToolFactory;
          }(com.vzome.core.editor.AbstractToolFactory);

          IcosahedralToolFactory.ID = "icosahedral";
          IcosahedralToolFactory.LABEL = "Create an icosahedral symmetry tool";
          IcosahedralToolFactory.TOOLTIP = "<p>Each tool produces up to 59 copies of the input<br>selection, using the rotation symmetries of an<br>icosahedron.  To create a tool, select a single<br>ball that defines the center of symmetry.<br><br>Combine with a point reflection tool to achieve<br>all 120 symmetries of the icosahedron, including<br>reflections.<br></p>";
          tools_2.IcosahedralToolFactory = IcosahedralToolFactory;
          IcosahedralToolFactory["__class"] = "com.vzome.core.tools.IcosahedralToolFactory";
          IcosahedralToolFactory["__interfaces"] = ["com.vzome.core.editor.SelectionSummary.Listener", "com.vzome.api.Tool.Factory"];
        })(core.tools || (core.tools = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (commands) {
          /**
          * @author Scott Vorthmann
          * @class
          * @extends com.vzome.core.commands.AbstractCommand
          */
          var CommandLoad =
          /*#__PURE__*/
          function (_com$vzome$core$comma5) {
            _inherits(CommandLoad, _com$vzome$core$comma5);

            var _super74 = _createSuper(CommandLoad);

            function CommandLoad() {
              _classCallCheck(this, CommandLoad);

              return _super74.call(this);
            }

            _createClass(CommandLoad, [{
              key: "getParameterSignature",

              /**
              *
              * @return {Array}
              */
              value: function getParameterSignature() {
                return CommandLoad.PARAM_SIGNATURE_$LI$();
              }
              /**
              *
              * @return {Array}
              */

            }, {
              key: "getAttributeSignature",
              value: function getAttributeSignature() {
                return CommandLoad.ATTR_SIGNATURE_$LI$();
              }
              /**
              *
              * @param {com.vzome.core.construction.ConstructionList} parameters
              * @param {com.vzome.core.commands.AttributeMap} attributes
              * @param {*} effects
              * @return {com.vzome.core.construction.ConstructionList}
              */

            }, {
              key: "apply",
              value: function apply(parameters, attributes, effects) {
                var result = new com.vzome.core.construction.ConstructionList();
                return result;
              }
            }], [{
              key: "PARAM_SIGNATURE_$LI$",
              value: function PARAM_SIGNATURE_$LI$() {
                if (CommandLoad.PARAM_SIGNATURE == null) CommandLoad.PARAM_SIGNATURE = [];
                return CommandLoad.PARAM_SIGNATURE;
              }
            }, {
              key: "ATTR_SIGNATURE_$LI$",
              value: function ATTR_SIGNATURE_$LI$() {
                if (CommandLoad.ATTR_SIGNATURE == null) CommandLoad.ATTR_SIGNATURE = [[CommandLoad.XML_ATTR, "org.w3c.dom.Element"]];
                return CommandLoad.ATTR_SIGNATURE;
              }
            }]);

            return CommandLoad;
          }(com.vzome.core.commands.AbstractCommand);

          CommandLoad.XML_ATTR = "xml";
          commands.CommandLoad = CommandLoad;
          CommandLoad["__class"] = "com.vzome.core.commands.CommandLoad";
          CommandLoad["__interfaces"] = ["com.vzome.core.commands.Command"];
        })(core.commands || (core.commands = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (math) {
          /**
          * Construct a new vector from its coordinate values.
          * @param {number} x
          * @param {number} y
          * @param {number} z
          * @class
          */
          var RealVector =
          /*#__PURE__*/
          function () {
            function RealVector(x, y, z) {
              var _this55 = this;

              _classCallCheck(this, RealVector);

              if ((typeof x === 'number' || x === null) && (typeof y === 'number' || y === null) && (typeof z === 'number' || z === null)) {
                if (this.x === undefined) this.x = 0;
                if (this.y === undefined) this.y = 0;
                if (this.z === undefined) this.z = 0;
                if (this.x === undefined) this.x = 0;
                if (this.y === undefined) this.y = 0;
                if (this.z === undefined) this.z = 0;

                (function () {
                  _this55.x = Math.fround(x);
                  _this55.y = Math.fround(y);
                  _this55.z = Math.fround(z);
                })();
              } else if (x === undefined && y === undefined && z === undefined) {
                {
                  var _x = 0.0;
                  var _y = 0.0;
                  var _z = 0.0;
                  if (this.x === undefined) this.x = 0;
                  if (this.y === undefined) this.y = 0;
                  if (this.z === undefined) this.z = 0;
                  if (this.x === undefined) this.x = 0;
                  if (this.y === undefined) this.y = 0;
                  if (this.z === undefined) this.z = 0;

                  (function () {
                    _this55.x = Math.fround(_x);
                    _this55.y = Math.fround(_y);
                    _this55.z = Math.fround(_z);
                  })();
                }
              } else throw new Error('invalid overload');
            }

            _createClass(RealVector, [{
              key: "toXmlAttributes",

              /**
              * Return a string representing this vector as XML attribute values.
              * @return {string}
              */
              value: function toXmlAttributes() {
                return "x=\"" + RealVector.FORMAT_$LI$().format(this.x) + "\" y=\"" + RealVector.FORMAT_$LI$().format(this.y) + "\" z=\"" + RealVector.FORMAT_$LI$().format(this.z) + "\"";
              }
            }, {
              key: "toString$java_text_NumberFormat",
              value: function toString$java_text_NumberFormat(format) {
                return format.format(this.x) + "," + format.format(this.y) + "," + format.format(this.z);
              }
              /**
              * Return a string representing this vector in the form "x,y,z".
              * @param {java.text.NumberFormat} format
              * @return {string}
              */

            }, {
              key: "toString",
              value: function toString(format) {
                if (format != null && format instanceof java.text.NumberFormat || format === null) {
                  return this.toString$java_text_NumberFormat(format);
                } else if (format === undefined) {
                  return this.toString$();
                } else throw new Error('invalid overload');
              }
            }, {
              key: "toString$",
              value: function toString$() {
                return RealVector.FORMAT_$LI$().format(this.x) + "," + RealVector.FORMAT_$LI$().format(this.y) + "," + RealVector.FORMAT_$LI$().format(this.z);
              }
              /**
              * Return a string representing this vector in the form "x y z".
              * @return {string}
              */

            }, {
              key: "spacedString",
              value: function spacedString() {
                var result = RealVector.FORMAT_$LI$().format(this.x) + " " + RealVector.FORMAT_$LI$().format(this.y) + " " + RealVector.FORMAT_$LI$().format(this.z);
                return result;
              }
              /**
              * Return the sum of this vector plus the vector "other",
              * as a new Vector3D.
              * @param {com.vzome.core.math.RealVector} other
              * @return {com.vzome.core.math.RealVector}
              */

            }, {
              key: "plus",
              value: function plus(other) {
                return new RealVector(Math.fround(this.x + other.x), Math.fround(this.y + other.y), Math.fround(this.z + other.z));
              }
              /**
              * Return the difference of this vector minus the vector "other",
              * as a new Vector3D.
              * @param {com.vzome.core.math.RealVector} other
              * @return {com.vzome.core.math.RealVector}
              */

            }, {
              key: "minus",
              value: function minus(other) {
                return new RealVector(Math.fround(this.x - other.x), Math.fround(this.y - other.y), Math.fround(this.z - other.z));
              }
              /**
              * Return a new vector equal to this vector scaled by the given factor.
              * @param {number} factor
              * @return {com.vzome.core.math.RealVector}
              */

            }, {
              key: "scale",
              value: function scale(factor) {
                return new RealVector(this.x * factor, this.y * factor, this.z * factor);
              }
              /**
              * Return the scalar (dot) product with the other vector
              * @param {com.vzome.core.math.RealVector} other
              * @return {number}
              */

            }, {
              key: "dot",
              value: function dot(other) {
                return Math.fround(Math.fround(Math.fround(this.x * other.x) + Math.fround(this.y * other.y)) + Math.fround(this.z * other.z));
              }
            }, {
              key: "cross",
              value: function cross(that) {
                return new RealVector(Math.fround(Math.fround(this.y * that.z) - Math.fround(this.z * that.y)), Math.fround(Math.fround(this.z * that.x) - Math.fround(this.x * that.z)), Math.fround(Math.fround(this.x * that.y) - Math.fround(this.y * that.x)));
              }
              /**
              * Return the length of this vector.
              * @return {number}
              */

            }, {
              key: "length",
              value: function length() {
                return Math.sqrt(this.dot(this));
              }
            }, {
              key: "normalize",
              value: function normalize() {
                return this.scale(1.0 / this.length());
              }
            }, {
              key: "write",
              value: function write(buf, offset) {
                buf.put(offset, this.x);
                buf.put(offset + 1, this.y);
                buf.put(offset + 2, this.z);
              }
              /**
              *
              * @param {*} other
              * @return {boolean}
              */

            }, {
              key: "equals",
              value: function equals(other) {
                if (other == null) {
                  return false;
                }

                if (other === this) {
                  return true;
                }

                if (!(other != null && other instanceof com.vzome.core.math.RealVector)) return false;
                var v = other;
                return this.x === v.x && this.y === v.y && this.z === v.z;
              }
              /**
              *
              * @return {number}
              */

            }, {
              key: "hashCode",
              value: function hashCode() {
                var hash = 3;
                hash = 41 * hash + (javaemul.internal.DoubleHelper.doubleToLongBits(this.x) ^ javaemul.internal.DoubleHelper.doubleToLongBits(this.x) >>> 32 | 0);
                hash = 41 * hash + (javaemul.internal.DoubleHelper.doubleToLongBits(this.y) ^ javaemul.internal.DoubleHelper.doubleToLongBits(this.y) >>> 32 | 0);
                hash = 41 * hash + (javaemul.internal.DoubleHelper.doubleToLongBits(this.z) ^ javaemul.internal.DoubleHelper.doubleToLongBits(this.z) >>> 32 | 0);
                return hash;
              }
            }, {
              key: "addTo",
              value: function addTo(addend, sum) {
                sum[0] = Math.fround(addend[0] + this.x);
                sum[1] = Math.fround(addend[1] + this.y);
                sum[2] = Math.fround(addend[2] + this.z);
              }
            }, {
              key: "toArray",
              value: function toArray(output) {
                output[0] = this.x;
                output[1] = this.y;
                output[2] = this.z;
              }
            }], [{
              key: "__static_initialize",
              value: function __static_initialize() {
                if (!RealVector.__static_initialized) {
                  RealVector.__static_initialized = true;

                  RealVector.__static_initializer_0();
                }
              }
            }, {
              key: "ORIGIN_$LI$",
              value: function ORIGIN_$LI$() {
                RealVector.__static_initialize();

                if (RealVector.ORIGIN == null) RealVector.ORIGIN = new RealVector(0.0, 0.0, 0.0);
                return RealVector.ORIGIN;
              }
            }, {
              key: "FORMAT_$LI$",
              value: function FORMAT_$LI$() {
                RealVector.__static_initialize();

                if (RealVector.FORMAT == null) RealVector.FORMAT = java.text.NumberFormat.getNumberInstance(java.util.Locale.US);
                return RealVector.FORMAT;
              }
            }, {
              key: "DIRECTION_0_$LI$",
              value: function DIRECTION_0_$LI$() {
                RealVector.__static_initialize();

                if (RealVector.DIRECTION_0 == null) RealVector.DIRECTION_0 = new RealVector(10.0, 0.1, -0.1);
                return RealVector.DIRECTION_0;
              }
            }, {
              key: "__static_initializer_0",
              value: function __static_initializer_0() {
                RealVector.FORMAT_$LI$().setMaximumFractionDigits(5);
                RealVector.FORMAT_$LI$().setMinimumFractionDigits(1);
              }
            }]);

            return RealVector;
          }();

          RealVector.__static_initialized = false;
          math.RealVector = RealVector;
          RealVector["__class"] = "com.vzome.core.math.RealVector";
        })(core.math || (core.math = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (jsweet) {
        var JsPanel =
        /*#__PURE__*/
        function (_com$vzome$jsweet$JsM) {
          _inherits(JsPanel, _com$vzome$jsweet$JsM);

          var _super75 = _createSuper(JsPanel);

          function JsPanel(field, adapter, coords) {
            _classCallCheck(this, JsPanel);

            return _super75.call(this, field, adapter, coords);
          }
          /**
          *
          * @return {com.vzome.core.construction.Construction}
          */


          _createClass(JsPanel, [{
            key: "toConstruction",
            value: function toConstruction() {
              var projected = new java.util.ArrayList();

              for (var i = 0; i < this.vectors.length; i++) {
                {
                  var pt = this.field.createVectorFromTDs(this.vectors[i]);
                  projected.add(new com.vzome.core.construction.FreePoint(this.field.projectTo3d(pt, true)));
                }
              }

              return new com.vzome.core.construction.PolygonFromVertices(projected);
            }
            /**
            *
            * @return {com.vzome.core.algebra.AlgebraicVector}
            */

          }, {
            key: "getLocation",
            value: function getLocation() {
              return null;
            }
          }, {
            key: "getNormal$",
            value: function getNormal$() {
              return this.getZoneVector();
            }
            /**
            *
            * @return {com.vzome.core.algebra.AlgebraicVector}
            */

          }, {
            key: "getZoneVector",
            value: function getZoneVector() {
              var v0 = this.field.createVectorFromTDs(this.vectors[0]);
              var v1 = this.field.createVectorFromTDs(this.vectors[1]);
              var v2 = this.field.createVectorFromTDs(this.vectors[2]);
              return com.vzome.core.algebra.AlgebraicVectors.getNormal$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector(v0, v1, v2);
            }
            /**
            *
            * @return {*}
            */

          }, {
            key: "iterator",
            value: function iterator() {
              return new JsPanel.JsPanel$0(this);
            }
            /**
            *
            * @param {com.vzome.core.algebra.AlgebraicVector} vector
            */

          }, {
            key: "setZoneVector",
            value: function setZoneVector(vector) {}
            /**
            *
            * @return {com.vzome.core.algebra.AlgebraicVector}
            */

          }, {
            key: "getFirstVertex",
            value: function getFirstVertex() {
              return this.field.createVectorFromTDs(this.vectors[0]);
            }
            /**
            *
            * @return {*}
            */

          }, {
            key: "getVertices",
            value: function getVertices() {
              throw new java.lang.RuntimeException("unimplemented");
            }
            /**
            *
            * @return {number}
            */

          }, {
            key: "getVertexCount",
            value: function getVertexCount() {
              throw new java.lang.RuntimeException("unimplemented");
            }
          }, {
            key: "getNormal$com_vzome_core_math_symmetry_Embedding",
            value: function getNormal$com_vzome_core_math_symmetry_Embedding(embedding) {
              throw new java.lang.RuntimeException("unimplemented");
            }
            /**
            *
            * @param {*} embedding
            * @return {com.vzome.core.math.RealVector}
            */

          }, {
            key: "getNormal",
            value: function getNormal(embedding) {
              if (embedding != null && (embedding["__interfaces"] != null && embedding["__interfaces"].indexOf("com.vzome.core.math.symmetry.Embedding") >= 0 || embedding.constructor != null && embedding.constructor["__interfaces"] != null && embedding.constructor["__interfaces"].indexOf("com.vzome.core.math.symmetry.Embedding") >= 0) || embedding === null) {
                return this.getNormal$com_vzome_core_math_symmetry_Embedding(embedding);
              } else if (embedding === undefined) {
                return this.getNormal$();
              } else throw new Error('invalid overload');
            }
          }]);

          return JsPanel;
        }(com.vzome.jsweet.JsManifestation);

        jsweet.JsPanel = JsPanel;
        JsPanel["__class"] = "com.vzome.jsweet.JsPanel";
        JsPanel["__interfaces"] = ["com.vzome.core.model.GroupElement", "com.vzome.core.model.Panel", "com.vzome.core.model.Manifestation", "java.lang.Iterable"];

        (function (JsPanel) {
          var JsPanel$0 =
          /*#__PURE__*/
          function () {
            function JsPanel$0(__parent) {
              _classCallCheck(this, JsPanel$0);

              this.__parent = __parent;
              this.i = 0;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(JsPanel$0, [{
              key: "hasNext",
              value: function hasNext() {
                return this.i < this.__parent.vectors.length;
              }
              /**
              *
              * @return {com.vzome.core.algebra.AlgebraicVector}
              */

            }, {
              key: "next",
              value: function next() {
                return this.__parent.field.createVectorFromTDs(this.__parent.vectors[this.i++]);
              }
            }]);

            return JsPanel$0;
          }();

          JsPanel.JsPanel$0 = JsPanel$0;
          JsPanel$0["__interfaces"] = ["java.util.Iterator"];
        })(JsPanel = jsweet.JsPanel || (jsweet.JsPanel = {}));
      })(vzome.jsweet || (vzome.jsweet = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (jsweet) {
        var JsBall =
        /*#__PURE__*/
        function (_com$vzome$jsweet$JsM2) {
          _inherits(JsBall, _com$vzome$jsweet$JsM2);

          var _super76 = _createSuper(JsBall);

          function JsBall(field, adapter, coords) {
            _classCallCheck(this, JsBall);

            return _super76.call(this, field, adapter, coords);
          }
          /**
          *
          * @return {com.vzome.core.algebra.AlgebraicVector}
          */


          _createClass(JsBall, [{
            key: "getLocation",
            value: function getLocation() {
              return this.field.createVectorFromTDs(this.vectors[0]);
            }
            /**
            *
            * @return {com.vzome.core.construction.Construction}
            */

          }, {
            key: "toConstruction",
            value: function toConstruction() {
              return new com.vzome.core.construction.FreePoint(this.getLocation());
            }
            /**
            *
            * @param {*} other
            * @return {number}
            */

          }, {
            key: "compareTo",
            value: function compareTo(other) {
              throw new java.lang.RuntimeException("unimplemented");
            }
          }]);

          return JsBall;
        }(com.vzome.jsweet.JsManifestation);

        jsweet.JsBall = JsBall;
        JsBall["__class"] = "com.vzome.jsweet.JsBall";
        JsBall["__interfaces"] = ["com.vzome.core.model.GroupElement", "com.vzome.core.model.Connector", "java.lang.Comparable", "com.vzome.core.model.Manifestation"];
      })(vzome.jsweet || (vzome.jsweet = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (jsweet) {
        var JsStrut =
        /*#__PURE__*/
        function (_com$vzome$jsweet$JsM3) {
          _inherits(JsStrut, _com$vzome$jsweet$JsM3);

          var _super77 = _createSuper(JsStrut);

          function JsStrut(field, adapter, coords) {
            _classCallCheck(this, JsStrut);

            return _super77.call(this, field, adapter, coords);
          }
          /**
          *
          * @return {com.vzome.core.algebra.AlgebraicVector}
          */


          _createClass(JsStrut, [{
            key: "getLocation",
            value: function getLocation() {
              return this.field.createVectorFromTDs(this.vectors[0]);
            }
            /**
            *
            * @return {com.vzome.core.construction.Construction}
            */

          }, {
            key: "toConstruction",
            value: function toConstruction() {
              return new com.vzome.core.construction.SegmentJoiningPoints(new com.vzome.core.construction.FreePoint(this.getLocation()), new com.vzome.core.construction.FreePoint(this.getEnd()));
            }
            /**
            *
            * @return {com.vzome.core.algebra.AlgebraicVector}
            */

          }, {
            key: "getEnd",
            value: function getEnd() {
              return this.field.createVectorFromTDs(this.vectors[1]);
            }
            /**
            *
            * @return {com.vzome.core.algebra.AlgebraicVector}
            */

          }, {
            key: "getOffset",
            value: function getOffset() {
              var start = this.getLocation();
              var end = this.getEnd();
              return end.minus(start);
            }
            /**
            *
            * @param {com.vzome.core.algebra.AlgebraicVector} vector
            */

          }, {
            key: "setZoneVector",
            value: function setZoneVector(vector) {}
            /**
            *
            * @return {com.vzome.core.algebra.AlgebraicVector}
            */

          }, {
            key: "getZoneVector",
            value: function getZoneVector() {
              return this.getOffset();
            }
            /**
            *
            * @param {*} other
            * @return {number}
            */

          }, {
            key: "compareTo",
            value: function compareTo(other) {
              throw new java.lang.RuntimeException("unimplemented");
            }
            /**
            *
            * @return {com.vzome.core.algebra.AlgebraicVector}
            */

          }, {
            key: "getCanonicalLesserEnd",
            value: function getCanonicalLesserEnd() {
              throw new java.lang.RuntimeException("unimplemented");
            }
            /**
            *
            * @return {com.vzome.core.algebra.AlgebraicVector}
            */

          }, {
            key: "getCanonicalGreaterEnd",
            value: function getCanonicalGreaterEnd() {
              throw new java.lang.RuntimeException("unimplemented");
            }
          }]);

          return JsStrut;
        }(com.vzome.jsweet.JsManifestation);

        jsweet.JsStrut = JsStrut;
        JsStrut["__class"] = "com.vzome.jsweet.JsStrut";
        JsStrut["__interfaces"] = ["com.vzome.core.model.GroupElement", "com.vzome.core.model.Strut", "java.lang.Comparable", "com.vzome.core.model.Manifestation"];
      })(vzome.jsweet || (vzome.jsweet = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (kinds) {
          /**
          * Everything here is stateless, or at worst, a cache (like Shapes).
          * An instance of this can be shared by many DocumentModels.
          * This is why it does not have tool factories, though it does
          * dictate what tool factories will be present.
          *
          * @author Scott Vorthmann
          * @param {*} field
          * @class
          * @extends com.vzome.core.kinds.DefaultFieldApplication
          */
          var RootTwoFieldApplication =
          /*#__PURE__*/
          function (_com$vzome$core$kinds4) {
            _inherits(RootTwoFieldApplication, _com$vzome$core$kinds4);

            var _super78 = _createSuper(RootTwoFieldApplication);

            function RootTwoFieldApplication(field) {
              var _thisSuper2, _this56;

              _classCallCheck(this, RootTwoFieldApplication);

              _this56 = _super78.call(this, field);
              _this56.synestructicsSymmetry = new RootTwoFieldApplication.RootTwoFieldApplication$0(_assertThisInitialized(_this56), _this56.getField(), "orange");
              _this56.synestructicsPerspective = new RootTwoFieldApplication.RootTwoFieldApplication$1(_assertThisInitialized(_this56), _this56.synestructicsSymmetry);

              var octahedralPerspective = _get((_thisSuper2 = _assertThisInitialized(_this56), _getPrototypeOf(RootTwoFieldApplication.prototype)), "getDefaultSymmetryPerspective", _thisSuper2).call(_thisSuper2);

              var symmetry = octahedralPerspective.getSymmetry();
              symmetry.createZoneOrbit$java_lang_String$int$int$int_A_A$boolean("yellow", 0, 4, [[1, 1, 0, 1], [1, 1, 0, 1], [1, 1, 0, 1]], true);
              symmetry.createZoneOrbit$java_lang_String$int$int$int_A_A$boolean("green", 1, 8, [[0, 1, 1, 2], [0, 1, 1, 2], [0, 1, 0, 1]], true);
              symmetry.createZoneOrbit$java_lang_String$int$int$int_A_A$boolean("brown", 0, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, [[1, 1, 0, 1], [1, 1, 0, 1], [2, 1, 0, 1]], true);
              var defaultShapes = new com.vzome.core.viewing.ExportedVEFShapes(null, "rootTwoSmall", "small octahedra", "small connectors", symmetry);
              octahedralPerspective.setDefaultGeometry(defaultShapes);
              octahedralPerspective.addShapes(defaultShapes);
              octahedralPerspective.addShapes(new com.vzome.core.viewing.ExportedVEFShapes(null, "rootTwo", "Tesseractix", symmetry, defaultShapes));
              octahedralPerspective.addShapes(new com.vzome.core.viewing.ExportedVEFShapes(null, "rootTwoBig", "ornate", symmetry, defaultShapes));
              return _this56;
            }
            /**
            *
            * @return {*}
            */


            _createClass(RootTwoFieldApplication, [{
              key: "getSymmetryPerspectives",
              value: function getSymmetryPerspectives() {
                return java.util.Arrays.asList(_get(_getPrototypeOf(RootTwoFieldApplication.prototype), "getDefaultSymmetryPerspective", this).call(this), this.synestructicsPerspective);
              }
              /**
              *
              * @param {string} symmName
              * @return {*}
              */

            }, {
              key: "getSymmetryPerspective",
              value: function getSymmetryPerspective(symmName) {
                switch (symmName) {
                  case "synestructics":
                    return this.synestructicsPerspective;

                  default:
                    return _get(_getPrototypeOf(RootTwoFieldApplication.prototype), "getSymmetryPerspective", this).call(this, symmName);
                }
              }
            }]);

            return RootTwoFieldApplication;
          }(com.vzome.core.kinds.DefaultFieldApplication);

          kinds.RootTwoFieldApplication = RootTwoFieldApplication;
          RootTwoFieldApplication["__class"] = "com.vzome.core.kinds.RootTwoFieldApplication";
          RootTwoFieldApplication["__interfaces"] = ["com.vzome.core.math.symmetry.Symmetries4D", "com.vzome.core.editor.FieldApplication"];

          (function (RootTwoFieldApplication) {
            var RootTwoFieldApplication$0 =
            /*#__PURE__*/
            function (_com$vzome$core$math$10) {
              _inherits(RootTwoFieldApplication$0, _com$vzome$core$math$10);

              var _super79 = _createSuper(RootTwoFieldApplication$0);

              function RootTwoFieldApplication$0(__parent, __arg0, __arg1) {
                var _this57;

                _classCallCheck(this, RootTwoFieldApplication$0);

                _this57 = _super79.call(this, __arg0, __arg1);
                _this57.__parent = __parent;
                return _this57;
              }
              /**
              *
              * @return {string}
              */


              _createClass(RootTwoFieldApplication$0, [{
                key: "getName",
                value: function getName() {
                  return "synestructics";
                }
                /**
                *
                * @param {com.vzome.core.math.symmetry.Symmetry.SpecialOrbit} which
                * @return {com.vzome.core.math.symmetry.Direction}
                */

              }, {
                key: "getSpecialOrbit",
                value: function getSpecialOrbit(which) {
                  switch (which) {
                    case com.vzome.core.math.symmetry.Symmetry.SpecialOrbit.BLUE:
                      return this.getDirection(this.frameColor);

                    case com.vzome.core.math.symmetry.Symmetry.SpecialOrbit.RED:
                      return this.getDirection("magenta");

                    case com.vzome.core.math.symmetry.Symmetry.SpecialOrbit.YELLOW:
                      return this.getDirection("yellow");

                    default:
                      return null;
                  }
                }
                /**
                *
                * @return {Array}
                */

              }, {
                key: "getOrbitTriangle",
                value: function getOrbitTriangle() {
                  var magentaVertex = this.getDirection("magenta").getPrototype();
                  var orangeVertex = this.getDirection(this.frameColor).getPrototype();
                  var yellowVertex = this.getDirection("yellow").getPrototype();
                  return [magentaVertex, orangeVertex, yellowVertex];
                }
                /**
                *
                */

              }, {
                key: "createOtherOrbits",
                value: function createOtherOrbits() {
                  var v = new com.vzome.core.algebra.AlgebraicVector(this.mField.one(), this.mField.one(), this.mField.one());
                  this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector$boolean("yellow", 0, 4, v, true);
                  var sqrt2 = this.mField['createPower$int'](1);
                  var half = this.mField['createRational$long$long'](1, 2);
                  v = new com.vzome.core.algebra.AlgebraicVector(sqrt2, sqrt2, this.mField.zero()).scale(half);
                  this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector$boolean("magenta", 1, 8, v, true);
                  v = new com.vzome.core.algebra.AlgebraicVector(this.mField.one(), this.mField.one(), this.mField.one()['plus$com_vzome_core_algebra_AlgebraicNumber'](this.mField.one()));
                  this.createZoneOrbit$java_lang_String$int$int$com_vzome_core_algebra_AlgebraicVector$boolean("brown", 0, com.vzome.core.math.symmetry.Symmetry.NO_ROTATION, v, true);
                }
              }]);

              return RootTwoFieldApplication$0;
            }(com.vzome.core.math.symmetry.OctahedralSymmetry);

            RootTwoFieldApplication.RootTwoFieldApplication$0 = RootTwoFieldApplication$0;
            RootTwoFieldApplication$0["__interfaces"] = ["com.vzome.core.math.symmetry.Symmetry", "java.lang.Iterable", "com.vzome.core.math.symmetry.Embedding"];

            var RootTwoFieldApplication$1 =
            /*#__PURE__*/
            function (_com$vzome$core$kinds5) {
              _inherits(RootTwoFieldApplication$1, _com$vzome$core$kinds5);

              var _super80 = _createSuper(RootTwoFieldApplication$1);

              function RootTwoFieldApplication$1(__parent, __arg0) {
                var _this58;

                _classCallCheck(this, RootTwoFieldApplication$1);

                _this58 = _super80.call(this, __arg0);
                _this58.__parent = __parent;

                (function () {
                  var defaultShapes = new com.vzome.core.viewing.ExportedVEFShapes(null, "rootTwoSmall", "small octahedra", _this58.symmetry, null);
                  var synestructicsShapes = new com.vzome.core.viewing.ExportedVEFShapes(null, "rootTwo", "Synestructics", _this58.symmetry, defaultShapes);
                  var ornateShapes = new com.vzome.core.viewing.ExportedVEFShapes(null, "rootTwoBig", "ornate", _this58.symmetry, defaultShapes);

                  _this58.setDefaultGeometry(defaultShapes);

                  _this58.addShapes(synestructicsShapes);

                  _this58.addShapes(ornateShapes);
                })();

                return _this58;
              }
              /**
              *
              * @param {com.vzome.api.Tool.Kind} kind
              * @param {com.vzome.core.editor.ToolsModel} tools
              * @return {*}
              */


              _createClass(RootTwoFieldApplication$1, [{
                key: "createToolFactories",
                value: function createToolFactories(kind, tools) {
                  var result = new java.util.ArrayList();

                  switch (kind) {
                    case com.vzome.api.Tool.Kind.SYMMETRY:
                      result.add(new com.vzome.core.tools.OctahedralToolFactory(tools, this.symmetry));
                      result.add(new com.vzome.core.tools.TetrahedralToolFactory(tools, this.symmetry));
                      result.add(new com.vzome.core.tools.InversionTool.Factory(tools));
                      result.add(new com.vzome.core.tools.MirrorTool.Factory(tools));
                      result.add(new com.vzome.core.tools.AxialSymmetryToolFactory(tools, this.symmetry));
                      break;

                    case com.vzome.api.Tool.Kind.TRANSFORM:
                      result.add(new com.vzome.core.tools.ScalingTool.__com_vzome_core_tools_ScalingTool_Factory(tools, this.symmetry));
                      result.add(new com.vzome.core.tools.RotationTool.__com_vzome_core_tools_RotationTool_Factory(tools, this.symmetry));
                      result.add(new com.vzome.core.tools.TranslationTool.Factory(tools));
                      result.add(new com.vzome.core.tools.ProjectionTool.Factory(tools));
                      break;

                    case com.vzome.api.Tool.Kind.LINEAR_MAP:
                      result.add(new com.vzome.core.tools.LinearMapTool.Factory(tools, this.symmetry, false));
                      break;
                  }

                  return result;
                }
                /**
                *
                * @param {com.vzome.api.Tool.Kind} kind
                * @param {com.vzome.core.editor.ToolsModel} tools
                * @return {*}
                */

              }, {
                key: "predefineTools",
                value: function predefineTools(kind, tools) {
                  var result = new java.util.ArrayList();

                  switch (kind) {
                    case com.vzome.api.Tool.Kind.SYMMETRY:
                      result.add(new com.vzome.core.tools.OctahedralToolFactory(tools, this.symmetry).createPredefinedTool("octahedral around origin"));
                      result.add(new com.vzome.core.tools.TetrahedralToolFactory(tools, this.symmetry).createPredefinedTool("tetrahedral around origin"));
                      result.add(new com.vzome.core.tools.InversionTool.Factory(tools).createPredefinedTool("reflection through origin"));
                      result.add(new com.vzome.core.tools.MirrorTool.Factory(tools).createPredefinedTool("reflection through XY plane"));
                      result.add(new com.vzome.core.tools.AxialSymmetryToolFactory(tools, this.symmetry).createPredefinedTool("symmetry around green through origin"));
                      break;

                    case com.vzome.api.Tool.Kind.TRANSFORM:
                      result.add(new com.vzome.core.tools.ScalingTool.__com_vzome_core_tools_ScalingTool_Factory(tools, this.symmetry).createPredefinedTool("scale down"));
                      result.add(new com.vzome.core.tools.ScalingTool.__com_vzome_core_tools_ScalingTool_Factory(tools, this.symmetry).createPredefinedTool("scale up"));
                      result.add(new com.vzome.core.tools.RotationTool.__com_vzome_core_tools_RotationTool_Factory(tools, this.symmetry).createPredefinedTool("rotate around green through origin"));
                      result.add(new com.vzome.core.tools.TranslationTool.Factory(tools).createPredefinedTool("b1 move along +X"));
                      break;
                  }

                  return result;
                }
                /**
                *
                * @return {string}
                */

              }, {
                key: "getModelResourcePath",
                value: function getModelResourcePath() {
                  return "org/vorthmann/zome/app/octahedral-vef.vZome";
                }
              }]);

              return RootTwoFieldApplication$1;
            }(com.vzome.core.kinds.AbstractSymmetryPerspective);

            RootTwoFieldApplication.RootTwoFieldApplication$1 = RootTwoFieldApplication$1;
            RootTwoFieldApplication$1["__interfaces"] = ["com.vzome.core.editor.FieldApplication.SymmetryPerspective"];
          })(RootTwoFieldApplication = kinds.RootTwoFieldApplication || (kinds.RootTwoFieldApplication = {}));
        })(core.kinds || (core.kinds = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (commands) {
          /**
          * @author Scott Vorthmann
          * @param {*} projection
          * @class
          * @extends com.vzome.core.commands.AbstractCommand
          */
          var CommandImportVEFData =
          /*#__PURE__*/
          function (_com$vzome$core$comma6) {
            _inherits(CommandImportVEFData, _com$vzome$core$comma6);

            var _super81 = _createSuper(CommandImportVEFData);

            function CommandImportVEFData(projection) {
              var _this59;

              _classCallCheck(this, CommandImportVEFData);

              if (projection != null && (projection["__interfaces"] != null && projection["__interfaces"].indexOf("com.vzome.core.math.Projection") >= 0 || projection.constructor != null && projection.constructor["__interfaces"] != null && projection.constructor["__interfaces"].indexOf("com.vzome.core.math.Projection") >= 0) || projection === null) {
                _this59 = _super81.call(this);
                if (_this59.mProjection === undefined) _this59.mProjection = null;
                _this59.quaternionVector = null;
                if (_this59.mProjection === undefined) _this59.mProjection = null;

                (function () {
                  _this59.mProjection = projection;
                })();
              } else if (projection === undefined) {
                {
                  var _projection = null;
                  _this59 = _super81.call(this);
                  if (_this59.mProjection === undefined) _this59.mProjection = null;
                  _this59.quaternionVector = null;
                  if (_this59.mProjection === undefined) _this59.mProjection = null;

                  (function () {
                    _this59.mProjection = _projection;
                  })();
                }
              } else throw new Error('invalid overload');

              return _possibleConstructorReturn(_this59);
            }

            _createClass(CommandImportVEFData, [{
              key: "getParameterSignature",

              /**
              *
              * @return {Array}
              */
              value: function getParameterSignature() {
                return CommandImportVEFData.PARAM_SIGNATURE_$LI$();
              }
              /**
              *
              * @return {Array}
              */

            }, {
              key: "getAttributeSignature",
              value: function getAttributeSignature() {
                return CommandImportVEFData.ATTR_SIGNATURE_$LI$();
              }
              /**
              *
              * @param {string} attrName
              * @return {boolean}
              */

            }, {
              key: "attributeIs3D",
              value: function attributeIs3D(attrName) {
                return !function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }("symmetry.axis.segment", attrName);
              }
              /**
              * Only called when migrating a 2.0 model file.
              * @param {com.vzome.core.algebra.AlgebraicVector} offset
              */

            }, {
              key: "setQuaternion",
              value: function setQuaternion(offset) {
                this.quaternionVector = offset;
              }
              /**
              *
              * @param {*} xml
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              * @return {com.vzome.core.commands.AttributeMap}
              */

            }, {
              key: "setXml",
              value: function setXml(xml, format) {
                var attrs = _get(_getPrototypeOf(CommandImportVEFData.prototype), "setXml", this).call(this, xml, format);

                this.quaternionVector = format.parseRationalVector(xml, "quaternion");
                return attrs;
              }
              /**
              *
              * @param {*} result
              * @param {com.vzome.core.commands.AttributeMap} attributes
              */

            }, {
              key: "getXml",
              value: function getXml(result, attributes) {
                if (this.quaternionVector != null) com.vzome.xml.DomUtils.addAttribute(result, "quaternion", this.quaternionVector.toParsableString());

                _get(_getPrototypeOf(CommandImportVEFData.prototype), "getXml", this).call(this, result, attributes);
              }
              /**
              *
              * @param {com.vzome.core.commands.AttributeMap} attributes
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              */

            }, {
              key: "setFixedAttributes",
              value: function setFixedAttributes(attributes, format) {
                if (!attributes.containsKey(CommandImportVEFData.FIELD_ATTR_NAME)) attributes.put(CommandImportVEFData.FIELD_ATTR_NAME, format.getField());

                _get(_getPrototypeOf(CommandImportVEFData.prototype), "setFixedAttributes", this).call(this, attributes, format);
              }
              /**
              *
              * @param {com.vzome.core.construction.ConstructionList} parameters
              * @param {com.vzome.core.commands.AttributeMap} attributes
              * @param {*} effects
              * @return {com.vzome.core.construction.ConstructionList}
              */

            }, {
              key: "apply",
              value: function apply(parameters, attributes, effects) {
                var result = new com.vzome.core.construction.ConstructionList();
                var field = attributes.get(CommandImportVEFData.FIELD_ATTR_NAME);
                if (field == null) field = attributes.get(com.vzome.core.commands.Command.FIELD_ATTR_NAME);
                var symmAxis = attributes.get(com.vzome.core.commands.CommandTransform.SYMMETRY_AXIS_ATTR_NAME);
                var vefData = attributes.get(CommandImportVEFData.VEF_STRING_ATTR_NAME);
                var noInversion = attributes.get(CommandImportVEFData.NO_INVERSION_ATTR_NAME);
                var projection = this.mProjection;

                if (projection == null) {
                  var quaternion = this.quaternionVector;
                  if (quaternion == null) quaternion = symmAxis == null ? null : symmAxis.getOffset();
                  if (quaternion != null) quaternion = quaternion.scale(field['createPower$int'](-5));
                  projection = quaternion == null ? null : new com.vzome.core.math.QuaternionProjection(field, null, quaternion);
                }

                if (noInversion != null && noInversion) new CommandImportVEFData.VefToModelNoInversion(this, projection, field, effects).parseVEF(vefData, field);else new com.vzome.core.construction.VefToModel(projection, effects, field['createPower$int'](5), null).parseVEF(vefData, field);
                return result;
              }
            }], [{
              key: "PARAM_SIGNATURE_$LI$",
              value: function PARAM_SIGNATURE_$LI$() {
                if (CommandImportVEFData.PARAM_SIGNATURE == null) CommandImportVEFData.PARAM_SIGNATURE = [[com.vzome.core.commands.Command.GENERIC_PARAM_NAME, com.vzome.core.construction.Construction]];
                return CommandImportVEFData.PARAM_SIGNATURE;
              }
            }, {
              key: "ATTR_SIGNATURE_$LI$",
              value: function ATTR_SIGNATURE_$LI$() {
                if (CommandImportVEFData.ATTR_SIGNATURE == null) CommandImportVEFData.ATTR_SIGNATURE = [[CommandImportVEFData.VEF_STRING_ATTR_NAME, String], [com.vzome.core.commands.Command.FIELD_ATTR_NAME, java.io.InputStream], [CommandImportVEFData.NO_INVERSION_ATTR_NAME, java.io.InputStream]];
                return CommandImportVEFData.ATTR_SIGNATURE;
              }
            }, {
              key: "logger_$LI$",
              value: function logger_$LI$() {
                if (CommandImportVEFData.logger == null) CommandImportVEFData.logger = java.util.logging.Logger.getLogger("com.vzome.core.commands.importVEF");
                return CommandImportVEFData.logger;
              }
            }]);

            return CommandImportVEFData;
          }(com.vzome.core.commands.AbstractCommand);

          CommandImportVEFData.X = 0;
          CommandImportVEFData.Y = 1;
          CommandImportVEFData.Z = 2;
          CommandImportVEFData.W = 3;
          CommandImportVEFData.VEF_STRING_ATTR_NAME = "org.vorthmann.zome.commands.CommandImportVEFData.vef.string";
          CommandImportVEFData.FIELD_ATTR_NAME = "org.vorthmann.zome.commands.CommandImportVEFData.field";
          CommandImportVEFData.NO_INVERSION_ATTR_NAME = "org.vorthmann.zome.commands.CommandImportVEFData.no.inversion";
          commands.CommandImportVEFData = CommandImportVEFData;
          CommandImportVEFData["__class"] = "com.vzome.core.commands.CommandImportVEFData";
          CommandImportVEFData["__interfaces"] = ["com.vzome.core.commands.Command"];

          (function (CommandImportVEFData) {
            var VefToModelNoInversion =
            /*#__PURE__*/
            function (_com$vzome$core$const9) {
              _inherits(VefToModelNoInversion, _com$vzome$core$const9);

              var _super82 = _createSuper(VefToModelNoInversion);

              function VefToModelNoInversion(__parent, projection, field, effects) {
                var _this60;

                _classCallCheck(this, VefToModelNoInversion);

                _this60 = _super82.call(this, projection, effects, field['createPower$int'](5), null);
                _this60.__parent = __parent;
                if (_this60.mProjected === undefined) _this60.mProjected = null;
                _this60.mUsedPoints = new java.util.HashSet();
                return _this60;
              }
              /**
              *
              * @param {number} index
              * @param {com.vzome.core.algebra.AlgebraicVector} location
              */


              _createClass(VefToModelNoInversion, [{
                key: "addVertex",
                value: function addVertex(index, location) {
                  if (this.scale != null) {
                    location = location.scale(this.scale);
                  }

                  if (this.mProjection != null) location = this.mProjection.projectImage(location, this.wFirst());
                  this.mVertices[index] = new com.vzome.core.construction.FreePoint(location);
                }
                /**
                *
                * @param {number} numEdges
                */

              }, {
                key: "startEdges",
                value: function startEdges(numEdges) {
                  this.mProjected = function (dims) {
                    var allocate = function allocate(dims) {
                      if (dims.length == 0) {
                        return null;
                      } else {
                        var array = [];

                        for (var i = 0; i < dims[0]; i++) {
                          array.push(allocate(dims.slice(1)));
                        }

                        return array;
                      }
                    };

                    return allocate(dims);
                  }([numEdges, 2]);
                }
                /**
                *
                * @param {number} index
                * @param {number} v1
                * @param {number} v2
                */

              }, {
                key: "addEdge",
                value: function addEdge(index, v1, v2) {
                  var p1 = this.mVertices[v1];
                  var p2 = this.mVertices[v2];
                  if (p1 == null || p2 == null) return;
                  var seg = new com.vzome.core.construction.SegmentJoiningPoints(p1, p2);
                  var pr1 = p1.getLocation().projectTo3d(this.wFirst()).negate();
                  var pr2 = p2.getLocation().projectTo3d(this.wFirst()).negate();

                  for (var i = 0; i < index; i++) {
                    {
                      if (pr1.equals(this.mProjected[i][0]) && pr2.equals(this.mProjected[i][1])) return;
                      if (pr2.equals(this.mProjected[i][0]) && pr1.equals(this.mProjected[i][1])) return;
                    }
                  }

                  this.mProjected[index][0] = pr1.negate();
                  this.mProjected[index][1] = pr2.negate();
                  this.mEffects.constructionAdded(seg);
                  this.mUsedPoints.add(p1);
                  this.mUsedPoints.add(p2);
                }
                /**
                *
                */

              }, {
                key: "endEdges",
                value: function endEdges() {
                  for (var index665 = this.mUsedPoints.iterator(); index665.hasNext();) {
                    var point = index665.next();
                    {
                      this.mEffects.constructionAdded(point);
                    }
                  }
                }
              }]);

              return VefToModelNoInversion;
            }(com.vzome.core.construction.VefToModel);

            CommandImportVEFData.VefToModelNoInversion = VefToModelNoInversion;
            VefToModelNoInversion["__class"] = "com.vzome.core.commands.CommandImportVEFData.VefToModelNoInversion";
          })(CommandImportVEFData = commands.CommandImportVEFData || (commands.CommandImportVEFData = {}));
        })(core.commands || (core.commands = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          var PolygonFromVertices =
          /*#__PURE__*/
          function (_com$vzome$core$const10) {
            _inherits(PolygonFromVertices, _com$vzome$core$const10);

            var _super83 = _createSuper(PolygonFromVertices);

            function PolygonFromVertices(points) {
              var _this61;

              _classCallCheck(this, PolygonFromVertices);

              if (points != null && (points["__interfaces"] != null && points["__interfaces"].indexOf("java.util.List") >= 0 || points.constructor != null && points.constructor["__interfaces"] != null && points.constructor["__interfaces"].indexOf("java.util.List") >= 0) || points === null) {
                {
                  var vertices = points.toArray(function (s) {
                    var a = [];

                    while (s-- > 0) {
                      a.push(null);
                    }

                    return a;
                  }(points.size()));
                  _this61 = _super83.call(this, vertices.length === 0 ? null : vertices[0].field);
                  if (_this61.__com_vzome_core_construction_PolygonFromVertices_mVertices === undefined) _this61.__com_vzome_core_construction_PolygonFromVertices_mVertices = null;
                  if (_this61.__com_vzome_core_construction_PolygonFromVertices_mVertices === undefined) _this61.__com_vzome_core_construction_PolygonFromVertices_mVertices = null;

                  (function () {
                    _this61.__com_vzome_core_construction_PolygonFromVertices_mVertices = vertices;

                    _this61.mapParamsToState();
                  })();
                }
              } else if (points != null && points instanceof Array && (points.length == 0 || points[0] == null || points[0] != null && points[0] instanceof com.vzome.core.construction.Point) || points === null) {
                var _args68 = arguments;
                var _vertices = _args68[0];
                _this61 = _super83.call(this, _vertices.length === 0 ? null : _vertices[0].field);
                if (_this61.__com_vzome_core_construction_PolygonFromVertices_mVertices === undefined) _this61.__com_vzome_core_construction_PolygonFromVertices_mVertices = null;
                if (_this61.__com_vzome_core_construction_PolygonFromVertices_mVertices === undefined) _this61.__com_vzome_core_construction_PolygonFromVertices_mVertices = null;

                (function () {
                  _this61.__com_vzome_core_construction_PolygonFromVertices_mVertices = _vertices;

                  _this61.mapParamsToState();
                })();
              } else throw new Error('invalid overload');

              return _possibleConstructorReturn(_this61);
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(PolygonFromVertices, [{
              key: "mapParamsToState",
              value: function mapParamsToState() {
                var locs = function (s) {
                  var a = [];

                  while (s-- > 0) {
                    a.push(null);
                  }

                  return a;
                }(this.__com_vzome_core_construction_PolygonFromVertices_mVertices.length);

                for (var i = 0; i < this.__com_vzome_core_construction_PolygonFromVertices_mVertices.length; i++) {
                  locs[i] = this.__com_vzome_core_construction_PolygonFromVertices_mVertices[i].getLocation();
                }

                return this.setStateVariable(locs, false);
              }
            }]);

            return PolygonFromVertices;
          }(com.vzome.core.construction.Polygon);

          construction.PolygonFromVertices = PolygonFromVertices;
          PolygonFromVertices["__class"] = "com.vzome.core.construction.PolygonFromVertices";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          /**
          * @author Scott Vorthmann
          * @param {com.vzome.core.construction.Transformation} transform
          * @param {com.vzome.core.construction.Polygon} prototype
          * @class
          * @extends com.vzome.core.construction.Polygon
          */
          var TransformedPolygon =
          /*#__PURE__*/
          function (_com$vzome$core$const11) {
            _inherits(TransformedPolygon, _com$vzome$core$const11);

            var _super84 = _createSuper(TransformedPolygon);

            function TransformedPolygon(transform, prototype) {
              var _this62;

              _classCallCheck(this, TransformedPolygon);

              _this62 = _super84.call(this, prototype.field);
              if (_this62.mTransform === undefined) _this62.mTransform = null;
              if (_this62.mPrototype === undefined) _this62.mPrototype = null;
              _this62.mTransform = transform;
              _this62.mPrototype = prototype;

              _this62.mapParamsToState();

              return _this62;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(TransformedPolygon, [{
              key: "mapParamsToState",
              value: function mapParamsToState() {
                var vertices = function (s) {
                  var a = [];

                  while (s-- > 0) {
                    a.push(null);
                  }

                  return a;
                }(this.mPrototype.getVertexCount());

                for (var i = 0; i < vertices.length; i++) {
                  {
                    vertices[i] = this.mTransform.transform$com_vzome_core_algebra_AlgebraicVector(this.mPrototype.getVertex(i));
                  }
                }

                return this.setStateVariable(vertices, false);
              }
            }]);

            return TransformedPolygon;
          }(com.vzome.core.construction.Polygon);

          construction.TransformedPolygon = TransformedPolygon;
          TransformedPolygon["__class"] = "com.vzome.core.construction.TransformedPolygon";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          /**
          * @author Scott Vorthmann
          * @param {com.vzome.core.algebra.Quaternion} leftQuaternion
          * @param {com.vzome.core.algebra.Quaternion} rightQuaternion
          * @param {com.vzome.core.construction.Polygon} prototype
          * @class
          * @extends com.vzome.core.construction.Polygon
          */
          var PolygonRotated4D =
          /*#__PURE__*/
          function (_com$vzome$core$const12) {
            _inherits(PolygonRotated4D, _com$vzome$core$const12);

            var _super85 = _createSuper(PolygonRotated4D);

            function PolygonRotated4D(leftQuaternion, rightQuaternion, prototype) {
              var _this63;

              _classCallCheck(this, PolygonRotated4D);

              _this63 = _super85.call(this, prototype.field);
              if (_this63.mLeftQuaternion === undefined) _this63.mLeftQuaternion = null;
              if (_this63.mRightQuaternion === undefined) _this63.mRightQuaternion = null;
              if (_this63.mPrototype === undefined) _this63.mPrototype = null;
              _this63.mLeftQuaternion = leftQuaternion;
              _this63.mRightQuaternion = rightQuaternion;
              _this63.mPrototype = prototype;

              _this63.mapParamsToState();

              return _this63;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(PolygonRotated4D, [{
              key: "mapParamsToState",
              value: function mapParamsToState() {
                if (this.mPrototype.isImpossible()) return this.setStateVariable(null, true);

                var vertices = function (s) {
                  var a = [];

                  while (s-- > 0) {
                    a.push(null);
                  }

                  return a;
                }(this.mPrototype.getVertexCount());

                for (var i = 0; i < vertices.length; i++) {
                  {
                    var loc = this.mRightQuaternion.leftMultiply(this.mPrototype.getVertex(i));
                    loc = this.mLeftQuaternion.rightMultiply(loc);
                    vertices[i] = loc;
                  }
                }

                return this.setStateVariable(vertices, false);
              }
            }]);

            return PolygonRotated4D;
          }(com.vzome.core.construction.Polygon);

          construction.PolygonRotated4D = PolygonRotated4D;
          PolygonRotated4D["__class"] = "com.vzome.core.construction.PolygonRotated4D";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          var MatrixTransformation =
          /*#__PURE__*/
          function (_com$vzome$core$const13) {
            _inherits(MatrixTransformation, _com$vzome$core$const13);

            var _super86 = _createSuper(MatrixTransformation);

            function MatrixTransformation(matrix, center) {
              var _this64;

              _classCallCheck(this, MatrixTransformation);

              _this64 = _super86.call(this, center.getField());

              _this64.setStateVariables(matrix, center, false);

              return _this64;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(MatrixTransformation, [{
              key: "mapParamsToState",
              value: function mapParamsToState() {
                return true;
              }
            }]);

            return MatrixTransformation;
          }(com.vzome.core.construction.Transformation);

          construction.MatrixTransformation = MatrixTransformation;
          MatrixTransformation["__class"] = "com.vzome.core.construction.MatrixTransformation";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          /**
          * @param prototype
          * @param {com.vzome.core.construction.Plane} projectionPlane
          * @param {com.vzome.core.construction.Line} projectionLine
          * @class
          * @extends com.vzome.core.construction.Transformation
          * @author Scott Vorthmann
          */
          var PlaneProjection =
          /*#__PURE__*/
          function (_com$vzome$core$const14) {
            _inherits(PlaneProjection, _com$vzome$core$const14);

            var _super87 = _createSuper(PlaneProjection);

            function PlaneProjection(projectionPlane, projectionLine) {
              var _this65;

              _classCallCheck(this, PlaneProjection);

              _this65 = _super87.call(this, projectionPlane.field);
              if (_this65.projectionPlane === undefined) _this65.projectionPlane = null;
              if (_this65.projectionVector === undefined) _this65.projectionVector = null;
              _this65.projectionPlane = projectionPlane;
              if (projectionLine == null) _this65.projectionVector = projectionPlane.getNormal();else _this65.projectionVector = projectionLine.getDirection();

              _this65.mapParamsToState();

              return _this65;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(PlaneProjection, [{
              key: "mapParamsToState",
              value: function mapParamsToState() {
                if (this.projectionPlane.isImpossible()) this.setStateVariables(null, null, true);
                var loc = this.projectionPlane.getBase();
                return this.setStateVariables(null, loc, false);
              }
            }, {
              key: "transform$com_vzome_core_algebra_AlgebraicVector",
              value: function transform$com_vzome_core_algebra_AlgebraicVector(arg) {
                var line = new com.vzome.core.construction.LineFromPointAndVector(arg, this.projectionVector);
                var point = new com.vzome.core.construction.LinePlaneIntersectionPoint(this.projectionPlane, line);
                return point.getLocation();
              }
              /**
              *
              * @param {com.vzome.core.algebra.AlgebraicVector} arg
              * @return {com.vzome.core.algebra.AlgebraicVector}
              */

            }, {
              key: "transform",
              value: function transform(arg) {
                if (arg != null && arg instanceof com.vzome.core.algebra.AlgebraicVector || arg === null) {
                  return this.transform$com_vzome_core_algebra_AlgebraicVector(arg);
                } else if (arg != null && arg instanceof com.vzome.core.construction.Construction || arg === null) {
                  return this.transform$com_vzome_core_construction_Construction(arg);
                } else throw new Error('invalid overload');
              }
            }, {
              key: "transform$com_vzome_core_construction_Construction",
              value: function transform$com_vzome_core_construction_Construction(c) {
                if (c != null && c instanceof com.vzome.core.construction.Segment) {
                  if (com.vzome.core.algebra.AlgebraicVectors.areParallel(this.projectionVector, c.getOffset())) {
                    return new com.vzome.core.construction.LinePlaneIntersectionPoint(this.projectionPlane, new com.vzome.core.construction.LineExtensionOfSegment(c));
                  }
                } else if (c != null && c instanceof com.vzome.core.construction.Polygon) {
                  var p = c;
                  var points = new java.util.ArrayList(1 + p.getVertexCount());
                  points.add(p.getVertex(0).plus(this.projectionVector));

                  for (var i = 0; i < p.getVertexCount(); i++) {
                    {
                      points.add(p.getVertex(i));
                    }
                  }

                  if (com.vzome.core.algebra.AlgebraicVectors.areCoplanar(points)) {
                    p = _get(_getPrototypeOf(PlaneProjection.prototype), "transform$com_vzome_core_construction_Construction", this).call(this, p);
                    var min = p.getVertex(0);
                    var max = min;

                    for (var _i31 = 1; _i31 < p.getVertexCount(); _i31++) {
                      {
                        var v = p.getVertex(_i31);

                        if (v.compareTo(min) === -1) {
                          min = v;
                        }

                        if (v.compareTo(max) === 1) {
                          max = v;
                        }
                      }
                    }

                    var p1 = new com.vzome.core.construction.FreePoint(min);
                    var p2 = new com.vzome.core.construction.FreePoint(max);
                    return new com.vzome.core.construction.SegmentJoiningPoints(p1, p2);
                  }
                }

                return _get(_getPrototypeOf(PlaneProjection.prototype), "transform$com_vzome_core_construction_Construction", this).call(this, c);
              }
            }]);

            return PlaneProjection;
          }(com.vzome.core.construction.Transformation);

          construction.PlaneProjection = PlaneProjection;
          PlaneProjection["__class"] = "com.vzome.core.construction.PlaneProjection";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          var Scaling =
          /*#__PURE__*/
          function (_com$vzome$core$const15) {
            _inherits(Scaling, _com$vzome$core$const15);

            var _super88 = _createSuper(Scaling);

            function Scaling(s1, s2, center, symmetry) {
              var _this66;

              _classCallCheck(this, Scaling);

              _this66 = _super88.call(this, s1.field);
              if (_this66.s1 === undefined) _this66.s1 = null;
              if (_this66.s2 === undefined) _this66.s2 = null;
              if (_this66.center === undefined) _this66.center = null;
              if (_this66.symmetry === undefined) _this66.symmetry = null;
              _this66.mOffset = _this66.field.projectTo3d(center.getLocation(), true);
              _this66.s1 = s1;
              _this66.s2 = s2;
              _this66.center = center;
              _this66.symmetry = symmetry;

              _this66.mapParamsToState();

              return _this66;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(Scaling, [{
              key: "mapParamsToState",
              value: function mapParamsToState() {
                var zone1 = this.symmetry['getAxis$com_vzome_core_algebra_AlgebraicVector'](this.s1.getOffset());
                var zone2 = this.symmetry['getAxis$com_vzome_core_algebra_AlgebraicVector'](this.s2.getOffset());
                var orbit = zone1.getDirection();
                if (orbit !== zone2.getDirection()) return this.setStateVariables(null, null, true);
                var len1 = zone1.getLength(this.s1.getOffset());
                var len2 = zone2.getLength(this.s2.getOffset());
                var scale = len2['dividedBy$com_vzome_core_algebra_AlgebraicNumber'](len1);
                var transform = new com.vzome.core.algebra.AlgebraicMatrix(this.field.basisVector(3, com.vzome.core.algebra.AlgebraicVector.X).scale(scale), this.field.basisVector(3, com.vzome.core.algebra.AlgebraicVector.Y).scale(scale), this.field.basisVector(3, com.vzome.core.algebra.AlgebraicVector.Z).scale(scale));
                return this.setStateVariables(transform, this.center.getLocation(), false);
              }
            }]);

            return Scaling;
          }(com.vzome.core.construction.Transformation);

          construction.Scaling = Scaling;
          Scaling["__class"] = "com.vzome.core.construction.Scaling";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          /**
          * @param prototype
          * @param {*} symm
          * @param {number} orientation
          * @param {com.vzome.core.construction.Point} center
          * @class
          * @extends com.vzome.core.construction.Transformation
          * @author Scott Vorthmann
          */
          var SymmetryTransformation =
          /*#__PURE__*/
          function (_com$vzome$core$const16) {
            _inherits(SymmetryTransformation, _com$vzome$core$const16);

            var _super89 = _createSuper(SymmetryTransformation);

            function SymmetryTransformation(symm, orientation, center) {
              var _this67;

              _classCallCheck(this, SymmetryTransformation);

              _this67 = _super89.call(this, center.field);
              if (_this67.mCenter === undefined) _this67.mCenter = null;
              if (_this67.mSymmetry === undefined) _this67.mSymmetry = null;
              if (_this67.mOrientation === undefined) _this67.mOrientation = 0;
              _this67.mSymmetry = symm;
              _this67.mOrientation = orientation;
              _this67.mCenter = center;

              _this67.mapParamsToState();

              return _this67;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(SymmetryTransformation, [{
              key: "mapParamsToState",
              value: function mapParamsToState() {
                if (this.mCenter.isImpossible()) return this.setStateVariables(null, null, true);
                var loc = this.mCenter.getLocation().projectTo3d(true);
                var matrix = this.mSymmetry.getMatrix(this.mOrientation);
                return this.setStateVariables(matrix, loc, false);
              }
            }]);

            return SymmetryTransformation;
          }(com.vzome.core.construction.Transformation);

          construction.SymmetryTransformation = SymmetryTransformation;
          SymmetryTransformation["__class"] = "com.vzome.core.construction.SymmetryTransformation";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          var PointToPointTranslation =
          /*#__PURE__*/
          function (_com$vzome$core$const17) {
            _inherits(PointToPointTranslation, _com$vzome$core$const17);

            var _super90 = _createSuper(PointToPointTranslation);

            function PointToPointTranslation(p1, p2) {
              var _this68;

              _classCallCheck(this, PointToPointTranslation);

              _this68 = _super90.call(this, p1.field);
              _this68.mOffset = _this68.field.projectTo3d(p2.getLocation().minus(p1.getLocation()), true);
              return _this68;
            }

            _createClass(PointToPointTranslation, [{
              key: "transform$com_vzome_core_algebra_AlgebraicVector",
              value: function transform$com_vzome_core_algebra_AlgebraicVector(arg) {
                return arg.plus(this.mOffset);
              }
              /**
              *
              * @param {com.vzome.core.algebra.AlgebraicVector} arg
              * @return {com.vzome.core.algebra.AlgebraicVector}
              */

            }, {
              key: "transform",
              value: function transform(arg) {
                if (arg != null && arg instanceof com.vzome.core.algebra.AlgebraicVector || arg === null) {
                  return this.transform$com_vzome_core_algebra_AlgebraicVector(arg);
                } else if (arg != null && arg instanceof com.vzome.core.construction.Construction || arg === null) {
                  return this.transform$com_vzome_core_construction_Construction(arg);
                } else throw new Error('invalid overload');
              }
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "mapParamsToState",
              value: function mapParamsToState() {
                return this.setStateVariables(null, null, false);
              }
            }]);

            return PointToPointTranslation;
          }(com.vzome.core.construction.Transformation);

          construction.PointToPointTranslation = PointToPointTranslation;
          PointToPointTranslation["__class"] = "com.vzome.core.construction.PointToPointTranslation";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          /**
          * This assumes that the starting basis is the usual X,Y,Z basis
          * @param {boolean} originalScaling
          * @param prototype
          * @param {com.vzome.core.construction.Segment} newX
          * @param {com.vzome.core.construction.Segment} newY
          * @param {com.vzome.core.construction.Segment} newZ
          * @param {com.vzome.core.construction.Point} kernel
          * @class
          * @extends com.vzome.core.construction.Transformation
          * @author Scott Vorthmann
          */
          var ChangeOfBasis =
          /*#__PURE__*/
          function (_com$vzome$core$const18) {
            _inherits(ChangeOfBasis, _com$vzome$core$const18);

            var _super91 = _createSuper(ChangeOfBasis);

            function ChangeOfBasis(newX, newY, newZ, kernel, originalScaling) {
              var _this69;

              _classCallCheck(this, ChangeOfBasis);

              if ((newX != null && newX instanceof com.vzome.core.construction.Segment || newX === null) && (newY != null && newY instanceof com.vzome.core.construction.Segment || newY === null) && (newZ != null && newZ instanceof com.vzome.core.construction.Segment || newZ === null) && (kernel != null && kernel instanceof com.vzome.core.construction.Point || kernel === null) && (typeof originalScaling === 'boolean' || originalScaling === null)) {
                _this69 = _super91.call(this, newX.field);
                if (_this69.mOld === undefined) _this69.mOld = null;
                if (_this69.mNew === undefined) _this69.mNew = null;
                if (_this69.mKernel === undefined) _this69.mKernel = null;
                if (_this69.scale === undefined) _this69.scale = null;
                if (_this69.mOld === undefined) _this69.mOld = null;
                if (_this69.mNew === undefined) _this69.mNew = null;
                if (_this69.mKernel === undefined) _this69.mKernel = null;
                if (_this69.scale === undefined) _this69.scale = null;

                (function () {
                  _this69.mNew = [newX, newY, newZ];
                  _this69.mOld = null;
                  _this69.mKernel = kernel;
                  if (originalScaling) _this69.scale = _this69.field['createPower$int'](-5);else _this69.scale = _this69.field['createRational$long$long'](1, 2)['times$com_vzome_core_algebra_AlgebraicNumber'](_this69.field['createPower$int'](-3));

                  _this69.mapParamsToState();
                })();
              } else if ((newX != null && newX instanceof Array && (newX.length == 0 || newX[0] == null || newX[0] != null && newX[0] instanceof com.vzome.core.construction.Segment) || newX === null) && (newY != null && newY instanceof Array && (newY.length == 0 || newY[0] == null || newY[0] != null && newY[0] instanceof com.vzome.core.construction.Segment) || newY === null) && (newZ != null && newZ instanceof com.vzome.core.construction.Point || newZ === null) && kernel === undefined && originalScaling === undefined) {
                var _args69 = arguments;
                var oldBasis = _args69[0];
                var newBasis = _args69[1];
                var _kernel = _args69[2];
                _this69 = _super91.call(this, oldBasis[0].field);
                if (_this69.mOld === undefined) _this69.mOld = null;
                if (_this69.mNew === undefined) _this69.mNew = null;
                if (_this69.mKernel === undefined) _this69.mKernel = null;
                if (_this69.scale === undefined) _this69.scale = null;
                if (_this69.mOld === undefined) _this69.mOld = null;
                if (_this69.mNew === undefined) _this69.mNew = null;
                if (_this69.mKernel === undefined) _this69.mKernel = null;
                if (_this69.scale === undefined) _this69.scale = null;

                (function () {
                  _this69.mOld = oldBasis;
                  _this69.mNew = newBasis;
                  _this69.mKernel = _kernel;
                  _this69.scale = _this69.field['createRational$long'](2)['times$com_vzome_core_algebra_AlgebraicNumber'](_this69.field['createPower$int'](-7));

                  _this69.mapParamsToState();
                })();
              } else throw new Error('invalid overload');

              return _possibleConstructorReturn(_this69);
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(ChangeOfBasis, [{
              key: "mapParamsToState",
              value: function mapParamsToState() {
                var loc = this.mKernel.getLocation();

                if (this.mOld != null) {
                  var oldCommon = ChangeOfBasis.findCommonVertex(this.mOld);
                  var offsets = [null, null, null];

                  for (var i = 0; i < offsets.length; i++) {
                    {
                      offsets[i] = this.mOld[i].getOffset().scale(this.scale);
                      if (oldCommon.equals(this.mOld[i].getEnd())) offsets[i] = offsets[i].negate();
                    }
                  }

                  var oldMatrix = new com.vzome.core.algebra.AlgebraicMatrix(offsets);
                  var newCommon = ChangeOfBasis.findCommonVertex(this.mNew);

                  for (var _i32 = 0; _i32 < offsets.length; _i32++) {
                    {
                      offsets[_i32] = this.mNew[_i32].getOffset().scale(this.scale);
                      if (newCommon.equals(this.mNew[_i32].getEnd())) offsets[_i32] = offsets[_i32].negate();
                    }
                  }

                  var newMatrix = new com.vzome.core.algebra.AlgebraicMatrix(offsets);
                  var transform = newMatrix.times(oldMatrix.inverse());
                  return this.setStateVariables(transform, loc, false);
                } else {
                  var _transform = new com.vzome.core.algebra.AlgebraicMatrix(this.mNew[0].getOffset().scale(this.scale), this.mNew[1].getOffset().scale(this.scale), this.mNew[2].getOffset().scale(this.scale));

                  return this.setStateVariables(_transform, loc, false);
                }
              }
              /*private*/

            }], [{
              key: "findCommonVertex",
              value: function findCommonVertex(basis) {
                var common = basis[0].getStart();
                if (common.equals(basis[1].getStart()) || common.equals(basis[1].getEnd())) return common;else {
                  common = basis[0].getEnd();
                  if (common.equals(basis[1].getStart()) || common.equals(basis[1].getEnd())) return common;else return null;
                }
              }
            }]);

            return ChangeOfBasis;
          }(com.vzome.core.construction.Transformation);

          construction.ChangeOfBasis = ChangeOfBasis;
          ChangeOfBasis["__class"] = "com.vzome.core.construction.ChangeOfBasis";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          var Translation =
          /*#__PURE__*/
          function (_com$vzome$core$const19) {
            _inherits(Translation, _com$vzome$core$const19);

            var _super92 = _createSuper(Translation);

            function Translation(offset) {
              var _this70;

              _classCallCheck(this, Translation);

              _this70 = _super92.call(this, offset.getField());
              if (_this70.mOffset === undefined) _this70.mOffset = null;
              _this70.mOffset = offset;
              return _this70;
            }

            _createClass(Translation, [{
              key: "transform$com_vzome_core_algebra_AlgebraicVector",
              value: function transform$com_vzome_core_algebra_AlgebraicVector(arg) {
                arg = arg.plus(this.mOffset);
                return arg;
              }
              /**
              *
              * @param {com.vzome.core.algebra.AlgebraicVector} arg
              * @return {com.vzome.core.algebra.AlgebraicVector}
              */

            }, {
              key: "transform",
              value: function transform(arg) {
                if (arg != null && arg instanceof com.vzome.core.algebra.AlgebraicVector || arg === null) {
                  return this.transform$com_vzome_core_algebra_AlgebraicVector(arg);
                } else if (arg != null && arg instanceof com.vzome.core.construction.Construction || arg === null) {
                  return this.transform$com_vzome_core_construction_Construction(arg);
                } else throw new Error('invalid overload');
              }
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "mapParamsToState",
              value: function mapParamsToState() {
                return this.setStateVariables(null, null, false);
              }
            }]);

            return Translation;
          }(com.vzome.core.construction.Transformation);

          construction.Translation = Translation;
          Translation["__class"] = "com.vzome.core.construction.Translation";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          /**
          * @param prototype
          * @param {com.vzome.core.construction.Plane} mirror
          * @class
          * @extends com.vzome.core.construction.Transformation
          * @author Scott Vorthmann
          */
          var PlaneReflection =
          /*#__PURE__*/
          function (_com$vzome$core$const20) {
            _inherits(PlaneReflection, _com$vzome$core$const20);

            var _super93 = _createSuper(PlaneReflection);

            function PlaneReflection(mirror) {
              var _this71;

              _classCallCheck(this, PlaneReflection);

              _this71 = _super93.call(this, mirror.field);
              if (_this71.mMirror === undefined) _this71.mMirror = null;
              if (_this71.mNormal === undefined) _this71.mNormal = null;
              if (_this71.mBase === undefined) _this71.mBase = null;
              if (_this71.mNormDotReciprocal === undefined) _this71.mNormDotReciprocal = null;
              _this71.mMirror = mirror;
              _this71.mNormal = mirror.getNormal();
              _this71.mBase = mirror.getBase();
              _this71.mNormDotReciprocal = _this71.mNormal.dot(_this71.mNormal).reciprocal();

              _this71.mapParamsToState();

              return _this71;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(PlaneReflection, [{
              key: "mapParamsToState",
              value: function mapParamsToState() {
                if (this.mMirror.isImpossible()) this.setStateVariables(null, null, true);
                var loc = this.mMirror.getBase();
                return this.setStateVariables(null, loc, false);
              }
            }, {
              key: "transform$com_vzome_core_algebra_AlgebraicVector",
              value: function transform$com_vzome_core_algebra_AlgebraicVector(arg) {
                arg = arg.minus(this.mBase);
                var xy = arg.dot(this.mNormal);
                xy = xy['times$com_vzome_core_algebra_AlgebraicNumber'](this.field['createRational$long'](2));
                arg = arg.minus(this.mNormal.scale(xy['times$com_vzome_core_algebra_AlgebraicNumber'](this.mNormDotReciprocal)));
                return arg.plus(this.mBase);
              }
              /**
              *
              * @param {com.vzome.core.algebra.AlgebraicVector} arg
              * @return {com.vzome.core.algebra.AlgebraicVector}
              */

            }, {
              key: "transform",
              value: function transform(arg) {
                if (arg != null && arg instanceof com.vzome.core.algebra.AlgebraicVector || arg === null) {
                  return this.transform$com_vzome_core_algebra_AlgebraicVector(arg);
                } else if (arg != null && arg instanceof com.vzome.core.construction.Construction || arg === null) {
                  return this.transform$com_vzome_core_construction_Construction(arg);
                } else throw new Error('invalid overload');
              }
            }]);

            return PlaneReflection;
          }(com.vzome.core.construction.Transformation);

          construction.PlaneReflection = PlaneReflection;
          PlaneReflection["__class"] = "com.vzome.core.construction.PlaneReflection";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          var MoveAndRotate =
          /*#__PURE__*/
          function (_com$vzome$core$const21) {
            _inherits(MoveAndRotate, _com$vzome$core$const21);

            var _super94 = _createSuper(MoveAndRotate);

            function MoveAndRotate(rotation, start, end) {
              var _this72;

              _classCallCheck(this, MoveAndRotate);

              _this72 = _super94.call(this, start.getField());
              if (_this72.rotation === undefined) _this72.rotation = null;
              if (_this72.translation === undefined) _this72.translation = null;
              _this72.rotation = new com.vzome.core.construction.MatrixTransformation(rotation, start);
              _this72.translation = new com.vzome.core.construction.Translation(end.minus(start));
              return _this72;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(MoveAndRotate, [{
              key: "mapParamsToState",
              value: function mapParamsToState() {
                return this.rotation.mapParamsToState() && this.translation.mapParamsToState();
              }
            }, {
              key: "transform$com_vzome_core_algebra_AlgebraicVector",
              value: function transform$com_vzome_core_algebra_AlgebraicVector(arg) {
                return this.translation.transform$com_vzome_core_algebra_AlgebraicVector(this.rotation.transform$com_vzome_core_algebra_AlgebraicVector(arg));
              }
              /**
              *
              * @param {com.vzome.core.algebra.AlgebraicVector} arg
              * @return {com.vzome.core.algebra.AlgebraicVector}
              */

            }, {
              key: "transform",
              value: function transform(arg) {
                if (arg != null && arg instanceof com.vzome.core.algebra.AlgebraicVector || arg === null) {
                  return this.transform$com_vzome_core_algebra_AlgebraicVector(arg);
                } else if (arg != null && arg instanceof com.vzome.core.construction.Construction || arg === null) {
                  return this.transform$com_vzome_core_construction_Construction(arg);
                } else throw new Error('invalid overload');
              }
            }]);

            return MoveAndRotate;
          }(com.vzome.core.construction.Transformation);

          construction.MoveAndRotate = MoveAndRotate;
          MoveAndRotate["__class"] = "com.vzome.core.construction.MoveAndRotate";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          /**
          * @param prototype
          * @param {com.vzome.core.construction.Point} center
          * @class
          * @extends com.vzome.core.construction.Transformation
          * @author Scott Vorthmann
          */
          var PointReflection =
          /*#__PURE__*/
          function (_com$vzome$core$const22) {
            _inherits(PointReflection, _com$vzome$core$const22);

            var _super95 = _createSuper(PointReflection);

            function PointReflection(center) {
              var _this73;

              _classCallCheck(this, PointReflection);

              _this73 = _super95.call(this, center.field);
              if (_this73.mCenter === undefined) _this73.mCenter = null;
              _this73.mCenter = center;

              _this73.mapParamsToState();

              return _this73;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(PointReflection, [{
              key: "mapParamsToState",
              value: function mapParamsToState() {
                if (this.mCenter.isImpossible()) this.setStateVariables(null, null, true);
                var loc = this.mCenter.getLocation().projectTo3d(true);
                return this.setStateVariables(null, loc, false);
              }
            }, {
              key: "transform$com_vzome_core_algebra_AlgebraicVector",
              value: function transform$com_vzome_core_algebra_AlgebraicVector(arg) {
                arg = arg.minus(this.mOffset);
                arg = this.mOffset.minus(arg);
                return arg;
              }
              /**
              *
              * @param {com.vzome.core.algebra.AlgebraicVector} arg
              * @return {com.vzome.core.algebra.AlgebraicVector}
              */

            }, {
              key: "transform",
              value: function transform(arg) {
                if (arg != null && arg instanceof com.vzome.core.algebra.AlgebraicVector || arg === null) {
                  return this.transform$com_vzome_core_algebra_AlgebraicVector(arg);
                } else if (arg != null && arg instanceof com.vzome.core.construction.Construction || arg === null) {
                  return this.transform$com_vzome_core_construction_Construction(arg);
                } else throw new Error('invalid overload');
              }
            }]);

            return PointReflection;
          }(com.vzome.core.construction.Transformation);

          construction.PointReflection = PointReflection;
          PointReflection["__class"] = "com.vzome.core.construction.PointReflection";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          /**
          * @author Scott Vorthmann
          * @param {com.vzome.core.construction.Line} l3
          * @param {*} len
          * @class
          * @extends com.vzome.core.construction.Segment
          */
          var SegmentOnLine =
          /*#__PURE__*/
          function (_com$vzome$core$const23) {
            _inherits(SegmentOnLine, _com$vzome$core$const23);

            var _super96 = _createSuper(SegmentOnLine);

            function SegmentOnLine(l3, len) {
              var _this74;

              _classCallCheck(this, SegmentOnLine);

              _this74 = _super96.call(this, l3.field);
              if (_this74.mLine === undefined) _this74.mLine = null;
              if (_this74.mLength === undefined) _this74.mLength = null;
              _this74.mLine = l3;
              _this74.mLength = len;

              _this74.mapParamsToState();

              return _this74;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(SegmentOnLine, [{
              key: "mapParamsToState",
              value: function mapParamsToState() {
                if (this.mLine.isImpossible()) return this.setStateVariables(null, null, true);
                var offset = this.getOffset().scale(this.mLength);
                return this.setStateVariables(this.mLine.getStart(), offset, false);
              }
            }]);

            return SegmentOnLine;
          }(com.vzome.core.construction.Segment);

          construction.SegmentOnLine = SegmentOnLine;
          SegmentOnLine["__class"] = "com.vzome.core.construction.SegmentOnLine";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          /**
          * @author Scott Vorthmann
          * @param {com.vzome.core.construction.Transformation} transform
          * @param {com.vzome.core.construction.Segment} prototype
          * @class
          * @extends com.vzome.core.construction.Segment
          */
          var TransformedSegment =
          /*#__PURE__*/
          function (_com$vzome$core$const24) {
            _inherits(TransformedSegment, _com$vzome$core$const24);

            var _super97 = _createSuper(TransformedSegment);

            function TransformedSegment(transform, prototype) {
              var _this75;

              _classCallCheck(this, TransformedSegment);

              _this75 = _super97.call(this, prototype.field);
              if (_this75.mTransform === undefined) _this75.mTransform = null;
              if (_this75.mPrototype === undefined) _this75.mPrototype = null;
              _this75.mTransform = transform;
              _this75.mPrototype = prototype;

              _this75.mapParamsToState();

              return _this75;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(TransformedSegment, [{
              key: "mapParamsToState",
              value: function mapParamsToState() {
                if (this.mTransform.isImpossible() || this.mPrototype.isImpossible()) return this.setStateVariables(null, null, true);
                var loc = this.mTransform.transform$com_vzome_core_algebra_AlgebraicVector(this.mPrototype.getStart().projectTo3d(true));
                var end = this.mTransform.transform$com_vzome_core_algebra_AlgebraicVector(this.mPrototype.getEnd().projectTo3d(true));
                return this.setStateVariables(loc, end.minus(loc), false);
              }
            }]);

            return TransformedSegment;
          }(com.vzome.core.construction.Segment);

          construction.TransformedSegment = TransformedSegment;
          TransformedSegment["__class"] = "com.vzome.core.construction.TransformedSegment";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          /**
          * @author Scott Vorthmann
          * @param {com.vzome.core.construction.Point} p1
          * @param {com.vzome.core.construction.Point} p2
          * @class
          * @extends com.vzome.core.construction.Segment
          */
          var SegmentJoiningPoints =
          /*#__PURE__*/
          function (_com$vzome$core$const25) {
            _inherits(SegmentJoiningPoints, _com$vzome$core$const25);

            var _super98 = _createSuper(SegmentJoiningPoints);

            function SegmentJoiningPoints(p1, p2) {
              var _this76;

              _classCallCheck(this, SegmentJoiningPoints);

              _this76 = _super98.call(this, p1.field);
              if (_this76.__com_vzome_core_construction_SegmentJoiningPoints_mStart === undefined) _this76.__com_vzome_core_construction_SegmentJoiningPoints_mStart = null;
              if (_this76.__com_vzome_core_construction_SegmentJoiningPoints_mEnd === undefined) _this76.__com_vzome_core_construction_SegmentJoiningPoints_mEnd = null;
              _this76.__com_vzome_core_construction_SegmentJoiningPoints_mStart = p1;
              _this76.__com_vzome_core_construction_SegmentJoiningPoints_mEnd = p2;

              _this76.mapParamsToState();

              return _this76;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(SegmentJoiningPoints, [{
              key: "mapParamsToState",
              value: function mapParamsToState() {
                if (this.__com_vzome_core_construction_SegmentJoiningPoints_mStart.isImpossible() || this.__com_vzome_core_construction_SegmentJoiningPoints_mEnd.isImpossible()) return this.setStateVariables(null, null, true);

                var startV = this.__com_vzome_core_construction_SegmentJoiningPoints_mStart.getLocation();

                var endV = this.__com_vzome_core_construction_SegmentJoiningPoints_mEnd.getLocation();

                if (startV.dimension() === 3 || endV.dimension() === 3) {
                  startV = startV.projectTo3d(true);
                  endV = endV.projectTo3d(true);
                }

                var offset = endV.minus(startV);
                return this.setStateVariables(startV, offset, false);
              }
            }]);

            return SegmentJoiningPoints;
          }(com.vzome.core.construction.Segment);

          construction.SegmentJoiningPoints = SegmentJoiningPoints;
          SegmentJoiningPoints["__class"] = "com.vzome.core.construction.SegmentJoiningPoints";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          /**
          * @author Scott Vorthmann
          * @param {com.vzome.core.construction.Segment} s1
          * @param {com.vzome.core.construction.Segment} s2
          * @class
          * @extends com.vzome.core.construction.Segment
          */
          var SegmentCrossProduct =
          /*#__PURE__*/
          function (_com$vzome$core$const26) {
            _inherits(SegmentCrossProduct, _com$vzome$core$const26);

            var _super99 = _createSuper(SegmentCrossProduct);

            function SegmentCrossProduct(s1, s2) {
              var _this77;

              _classCallCheck(this, SegmentCrossProduct);

              _this77 = _super99.call(this, s1.field);
              if (_this77.seg1 === undefined) _this77.seg1 = null;
              if (_this77.seg2 === undefined) _this77.seg2 = null;
              _this77.seg1 = s1;
              _this77.seg2 = s2;

              _this77.mapParamsToState();

              return _this77;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(SegmentCrossProduct, [{
              key: "mapParamsToState",
              value: function mapParamsToState() {
                if (this.seg1.isImpossible() || this.seg2.isImpossible()) {
                  return this.setStateVariables(null, null, true);
                }

                var v2 = com.vzome.core.algebra.AlgebraicVectors.getNormal$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector(this.seg1.getOffset(), this.seg2.getOffset()).scale(this.field['createPower$int'](-4)).scale(this.field['createRational$long$long'](1, 2));
                return this.setStateVariables(this.seg1.getEnd(), v2, false);
              }
            }]);

            return SegmentCrossProduct;
          }(com.vzome.core.construction.Segment);

          construction.SegmentCrossProduct = SegmentCrossProduct;
          SegmentCrossProduct["__class"] = "com.vzome.core.construction.SegmentCrossProduct";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          /**
          * @author Scott Vorthmann
          * @param {com.vzome.core.algebra.Quaternion} leftQuaternion
          * @param {com.vzome.core.algebra.Quaternion} rightQuaternion
          * @param {com.vzome.core.construction.Segment} prototype
          * @class
          * @extends com.vzome.core.construction.Segment
          */
          var SegmentRotated4D =
          /*#__PURE__*/
          function (_com$vzome$core$const27) {
            _inherits(SegmentRotated4D, _com$vzome$core$const27);

            var _super100 = _createSuper(SegmentRotated4D);

            function SegmentRotated4D(leftQuaternion, rightQuaternion, prototype) {
              var _this78;

              _classCallCheck(this, SegmentRotated4D);

              _this78 = _super100.call(this, prototype.field);
              if (_this78.mLeftQuaternion === undefined) _this78.mLeftQuaternion = null;
              if (_this78.mRightQuaternion === undefined) _this78.mRightQuaternion = null;
              if (_this78.mPrototype === undefined) _this78.mPrototype = null;
              _this78.mLeftQuaternion = leftQuaternion;
              _this78.mRightQuaternion = rightQuaternion;
              _this78.mPrototype = prototype;

              _this78.mapParamsToState();

              return _this78;
            }

            _createClass(SegmentRotated4D, [{
              key: "mapParamsToState",

              /**
              *
              * @return {boolean}
              */
              value: function mapParamsToState() {
                if (this.mPrototype.isImpossible()) return this.setStateVariables(null, null, true);
                var loc = this.mPrototype.getStart();
                loc = loc.inflateTo4d$boolean(true);
                loc = this.mRightQuaternion.leftMultiply(loc);
                loc = this.mLeftQuaternion.rightMultiply(loc);
                var end = this.mPrototype.getEnd();
                end = end.inflateTo4d$boolean(true);
                end = this.mRightQuaternion.leftMultiply(end);
                end = this.mLeftQuaternion.rightMultiply(end);

                if (SegmentRotated4D.logger_$LI$().isLoggable(java.util.logging.Level.FINER)) {
                  SegmentRotated4D.logger_$LI$().finer("------------------- SegmentRotated4D");
                  SegmentRotated4D.logger_$LI$().finer("left:    " + this.mLeftQuaternion.toString());
                  SegmentRotated4D.logger_$LI$().finer("right:   " + this.mRightQuaternion.toString());
                  SegmentRotated4D.logger_$LI$().finer("start: " + this.mPrototype.getStart().getVectorExpression$int(com.vzome.core.algebra.AlgebraicField.EXPRESSION_FORMAT));
                  SegmentRotated4D.logger_$LI$().finer("end:   " + this.mPrototype.getEnd().getVectorExpression$int(com.vzome.core.algebra.AlgebraicField.EXPRESSION_FORMAT));
                  SegmentRotated4D.logger_$LI$().finer("new start: " + loc.getVectorExpression$int(com.vzome.core.algebra.AlgebraicField.EXPRESSION_FORMAT));
                  SegmentRotated4D.logger_$LI$().finer("new end:   " + end.getVectorExpression$int(com.vzome.core.algebra.AlgebraicField.EXPRESSION_FORMAT));
                }

                return this.setStateVariables(loc, end.minus(loc), false);
              }
            }], [{
              key: "logger_$LI$",
              value: function logger_$LI$() {
                if (SegmentRotated4D.logger == null) SegmentRotated4D.logger = java.util.logging.Logger.getLogger("com.vzome.core.4d");
                return SegmentRotated4D.logger;
              }
            }]);

            return SegmentRotated4D;
          }(com.vzome.core.construction.Segment);

          construction.SegmentRotated4D = SegmentRotated4D;
          SegmentRotated4D["__class"] = "com.vzome.core.construction.SegmentRotated4D";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          var PolygonPolygonProjectionToSegment =
          /*#__PURE__*/
          function (_com$vzome$core$const28) {
            _inherits(PolygonPolygonProjectionToSegment, _com$vzome$core$const28);

            var _super101 = _createSuper(PolygonPolygonProjectionToSegment);

            function PolygonPolygonProjectionToSegment(polygon0, polygon1) {
              var _this79;

              _classCallCheck(this, PolygonPolygonProjectionToSegment);

              _this79 = _super101.call(this, polygon0.getField());
              _this79.polygons = [null, null];
              _this79.polygons[0] = polygon0;
              _this79.polygons[1] = polygon1;

              _this79.mapParamsToState();

              return _this79;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(PolygonPolygonProjectionToSegment, [{
              key: "mapParamsToState",
              value: function mapParamsToState() {
                if (this.polygons[0].isImpossible() || this.polygons[1].isImpossible()) {
                  return this.setStateVariables(null, null, true);
                }

                if (com.vzome.core.algebra.AlgebraicVectors.areParallel(this.polygons[0].getNormal(), this.polygons[1].getNormal())) {
                  return this.setStateVariables(null, null, true);
                }

                var intersections = new java.util.HashSet(2);

                for (var poly = 0; poly < 2; poly++) {
                  {
                    var edgePolygon = this.polygons[poly];
                    var planePolygon = this.polygons[(poly + 1) % 2];
                    var centroid = planePolygon.getCentroid();
                    var normal = planePolygon.getNormal();
                    var nVertices = edgePolygon.getVertexCount();

                    for (var i = 0; i < nVertices; i++) {
                      {
                        var lineStart = edgePolygon.getVertex(i);
                        var lineDirection = lineStart.minus(edgePolygon.getVertex((i + 1) % nVertices));

                        if (!lineDirection.isOrigin()) {
                          var intersection = com.vzome.core.algebra.AlgebraicVectors.getLinePlaneIntersection(lineStart, lineDirection, centroid, normal);

                          if (intersection != null) {
                            intersections.add(intersection);

                            if (intersections.size() === 2) {
                              break;
                            }
                          }
                        }
                      }
                    }

                    if (intersections.size() === 2) {
                      break;
                    }
                  }
                }

                if (intersections.size() !== 2) {
                  for (var _poly = 0; _poly < 2; _poly++) {
                    {
                      var _edgePolygon = this.polygons[_poly];
                      var _planePolygon = this.polygons[(_poly + 1) % 2];

                      var _centroid = _planePolygon.getCentroid();

                      var _normal = _planePolygon.getNormal();

                      var _lineStart = _edgePolygon.getCentroid();

                      for (var _i33 = 0; _i33 < _edgePolygon.getVertexCount(); _i33++) {
                        {
                          var _lineDirection = _lineStart.minus(_edgePolygon.getVertex(_i33));

                          if (!_lineDirection.isOrigin()) {
                            var _intersection = com.vzome.core.algebra.AlgebraicVectors.getLinePlaneIntersection(_lineStart, _lineDirection, _centroid, _normal);

                            if (_intersection != null) {
                              intersections.add(_intersection);

                              if (intersections.size() === 2) {
                                break;
                              }
                            }
                          }
                        }
                      }

                      if (intersections.size() === 2) {
                        break;
                      }
                    }
                  }
                }

                if (intersections.size() !== 2) {
                  return this.setStateVariables(null, null, true);
                }

                var v0 = null;
                var v1 = null;

                for (var index666 = intersections.iterator(); index666.hasNext();) {
                  var v = index666.next();
                  {
                    if (v0 == null) {
                      v0 = v;
                    } else {
                      v1 = v;
                    }
                  }
                }

                var intersectionLine = new com.vzome.core.construction.LineExtensionOfSegment(new com.vzome.core.construction.SegmentJoiningPoints(new com.vzome.core.construction.FreePoint(v0), new com.vzome.core.construction.FreePoint(v1)));
                var projections = new java.util.TreeSet();

                for (var _poly2 = 0; _poly2 < 2; _poly2++) {
                  {
                    var polygon = this.polygons[_poly2];
                    var v2 = v0.plus(polygon.getNormal());
                    var vProjection = com.vzome.core.algebra.AlgebraicVectors.getNormal$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector(v0, v1, v2);

                    for (var _i34 = 0; _i34 < polygon.getVertexCount(); _i34++) {
                      {
                        var vertex = polygon.getVertex(_i34);

                        if (com.vzome.core.algebra.AlgebraicVectors.areCollinear$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector(v0, v1, vertex)) {
                          projections.add(vertex);
                        } else {
                          var projectionLine = new com.vzome.core.construction.LineFromPointAndVector(vertex, vProjection);
                          var projection = new com.vzome.core.construction.LineLineIntersectionPoint(intersectionLine, projectionLine);
                          projections.add(projection.getLocation());
                        }
                      }
                    }
                  }
                }

                var start = null;
                var offset = null;
                var n = 0;

                for (var index667 = projections.iterator(); index667.hasNext();) {
                  var _v2 = index667.next();

                  {
                    if (n === 0) {
                      start = _v2;
                    } else if (n === projections.size() - 1) {
                      offset = _v2.minus(start);
                    }

                    n++;
                  }
                }

                return this.setStateVariables(start, offset, start == null || offset == null);
              }
            }]);

            return PolygonPolygonProjectionToSegment;
          }(com.vzome.core.construction.Segment);

          construction.PolygonPolygonProjectionToSegment = PolygonPolygonProjectionToSegment;
          PolygonPolygonProjectionToSegment["__class"] = "com.vzome.core.construction.PolygonPolygonProjectionToSegment";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          /**
          * @param step
          * @param {com.vzome.core.construction.Point} start
          * @param {com.vzome.core.math.symmetry.Axis} axis
          * @param {*} length
          * @class
          * @extends com.vzome.core.construction.Segment
          * @author Scott Vorthmann
          */
          var AnchoredSegment =
          /*#__PURE__*/
          function (_com$vzome$core$const29) {
            _inherits(AnchoredSegment, _com$vzome$core$const29);

            var _super102 = _createSuper(AnchoredSegment);

            function AnchoredSegment(axis, length, start) {
              var _this80;

              _classCallCheck(this, AnchoredSegment);

              _this80 = _super102.call(this, start.field);
              if (_this80.mAnchor === undefined) _this80.mAnchor = null;
              if (_this80.mAxis === undefined) _this80.mAxis = null;
              if (_this80.mLength === undefined) _this80.mLength = null;
              _this80.mAnchor = start;
              _this80.mAxis = axis;
              _this80.mLength = length;

              _this80.mapParamsToState();

              return _this80;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(AnchoredSegment, [{
              key: "mapParamsToState",
              value: function mapParamsToState() {
                if (this.mAnchor.isImpossible() || this.mLength.isZero()) return this.setStateVariables(null, null, true);
                var gv = this.mAnchor.getLocation().projectTo3d(true);
                var offset = this.mAxis.normal().scale(this.mLength);
                return this.setStateVariables(gv, offset, false);
              }
            }, {
              key: "getAxis",
              value: function getAxis() {
                return this.mAxis;
              }
            }, {
              key: "getLength",
              value: function getLength() {
                return this.mLength;
              }
            }, {
              key: "getUnitVector",
              value: function getUnitVector() {
                return this.mAxis.normal();
              }
            }]);

            return AnchoredSegment;
          }(com.vzome.core.construction.Segment);

          construction.AnchoredSegment = AnchoredSegment;
          AnchoredSegment["__class"] = "com.vzome.core.construction.AnchoredSegment";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (commands) {
          /**
          * @author Scott Vorthmann
          * @class
          * @extends com.vzome.core.commands.AbstractCommand
          */
          var CommandLinePlaneIntersect =
          /*#__PURE__*/
          function (_com$vzome$core$comma7) {
            _inherits(CommandLinePlaneIntersect, _com$vzome$core$comma7);

            var _super103 = _createSuper(CommandLinePlaneIntersect);

            function CommandLinePlaneIntersect() {
              _classCallCheck(this, CommandLinePlaneIntersect);

              return _super103.call(this);
            }

            _createClass(CommandLinePlaneIntersect, [{
              key: "getParameterSignature",

              /**
              *
              * @return {Array}
              */
              value: function getParameterSignature() {
                return CommandLinePlaneIntersect.PARAM_SIGNATURE_$LI$();
              }
              /**
              *
              * @return {Array}
              */

            }, {
              key: "getAttributeSignature",
              value: function getAttributeSignature() {
                return CommandLinePlaneIntersect.ATTR_SIGNATURE_$LI$();
              }
              /**
              *
              * @param {com.vzome.core.construction.ConstructionList} parameters
              * @param {com.vzome.core.commands.AttributeMap} attrs
              * @param {*} effects
              * @return {com.vzome.core.construction.ConstructionList}
              */

            }, {
              key: "apply",
              value: function apply(parameters, attrs, effects) {
                var result = new com.vzome.core.construction.ConstructionList();
                if (parameters == null || parameters.size() !== 2) throw new commands.Command.Failure("Intersection requires a panel and a strut.");

                try {
                  var panel;
                  var segment;
                  var first = parameters.get(0);

                  if (first != null && first instanceof com.vzome.core.construction.Polygon) {
                    panel = first;
                    segment = parameters.get(1);
                  } else {
                    segment = first;
                    panel = parameters.get(1);
                  }

                  var plane = new com.vzome.core.construction.PlaneExtensionOfPolygon(panel);
                  var line = new com.vzome.core.construction.LineExtensionOfSegment(segment);
                  var point = new com.vzome.core.construction.LinePlaneIntersectionPoint(plane, line);
                  result.addConstruction(point);
                  effects.constructionAdded(point);
                } catch (e) {
                  throw new commands.Command.Failure("Intersection requires a panel and a strut.");
                }

                return result;
              }
            }], [{
              key: "PARAM_SIGNATURE_$LI$",
              value: function PARAM_SIGNATURE_$LI$() {
                if (CommandLinePlaneIntersect.PARAM_SIGNATURE == null) CommandLinePlaneIntersect.PARAM_SIGNATURE = [["panel", com.vzome.core.construction.Polygon], ["segment", com.vzome.core.construction.Segment]];
                return CommandLinePlaneIntersect.PARAM_SIGNATURE;
              }
            }, {
              key: "ATTR_SIGNATURE_$LI$",
              value: function ATTR_SIGNATURE_$LI$() {
                if (CommandLinePlaneIntersect.ATTR_SIGNATURE == null) CommandLinePlaneIntersect.ATTR_SIGNATURE = [];
                return CommandLinePlaneIntersect.ATTR_SIGNATURE;
              }
            }]);

            return CommandLinePlaneIntersect;
          }(com.vzome.core.commands.AbstractCommand);

          commands.CommandLinePlaneIntersect = CommandLinePlaneIntersect;
          CommandLinePlaneIntersect["__class"] = "com.vzome.core.commands.CommandLinePlaneIntersect";
          CommandLinePlaneIntersect["__interfaces"] = ["com.vzome.core.commands.Command"];
        })(core.commands || (core.commands = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (commands) {
          var CommandObliquePentagon =
          /*#__PURE__*/
          function (_com$vzome$core$comma8) {
            _inherits(CommandObliquePentagon, _com$vzome$core$comma8);

            var _super104 = _createSuper(CommandObliquePentagon);

            function CommandObliquePentagon() {
              _classCallCheck(this, CommandObliquePentagon);

              return _super104.call(this);
            }

            _createClass(CommandObliquePentagon, [{
              key: "getParameterSignature",

              /**
              *
              * @return {Array}
              */
              value: function getParameterSignature() {
                return CommandObliquePentagon.PARAM_SIGNATURE_$LI$();
              }
              /**
              *
              * @return {Array}
              */

            }, {
              key: "getAttributeSignature",
              value: function getAttributeSignature() {
                return CommandObliquePentagon.ATTR_SIGNATURE_$LI$();
              }
              /**
              *
              * @param {com.vzome.core.construction.ConstructionList} parameters
              * @param {com.vzome.core.commands.AttributeMap} attributes
              * @param {*} effects
              * @return {com.vzome.core.construction.ConstructionList}
              */

            }, {
              key: "apply",
              value: function apply(parameters, attributes, effects) {
                throw new commands.Command.Failure("Oblique pentagon should never be called.");
              }
            }], [{
              key: "PARAM_SIGNATURE_$LI$",
              value: function PARAM_SIGNATURE_$LI$() {
                if (CommandObliquePentagon.PARAM_SIGNATURE == null) CommandObliquePentagon.PARAM_SIGNATURE = [["segment1", com.vzome.core.construction.Segment], ["segment2", com.vzome.core.construction.Segment]];
                return CommandObliquePentagon.PARAM_SIGNATURE;
              }
            }, {
              key: "ATTR_SIGNATURE_$LI$",
              value: function ATTR_SIGNATURE_$LI$() {
                if (CommandObliquePentagon.ATTR_SIGNATURE == null) CommandObliquePentagon.ATTR_SIGNATURE = [];
                return CommandObliquePentagon.ATTR_SIGNATURE;
              }
            }]);

            return CommandObliquePentagon;
          }(com.vzome.core.commands.AbstractCommand);

          commands.CommandObliquePentagon = CommandObliquePentagon;
          CommandObliquePentagon["__class"] = "com.vzome.core.commands.CommandObliquePentagon";
          CommandObliquePentagon["__interfaces"] = ["com.vzome.core.commands.Command"];
        })(core.commands || (core.commands = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (commands) {
          /**
          * @author Scott Vorthmann
          * @class
          * @extends com.vzome.core.commands.AbstractCommand
          */
          var CommandMidpoint =
          /*#__PURE__*/
          function (_com$vzome$core$comma9) {
            _inherits(CommandMidpoint, _com$vzome$core$comma9);

            var _super105 = _createSuper(CommandMidpoint);

            function CommandMidpoint() {
              _classCallCheck(this, CommandMidpoint);

              return _super105.call(this);
            }

            _createClass(CommandMidpoint, [{
              key: "getParameterSignature",

              /**
              *
              * @return {Array}
              */
              value: function getParameterSignature() {
                return CommandMidpoint.PARAM_SIGNATURE_$LI$();
              }
              /**
              *
              * @return {Array}
              */

            }, {
              key: "getAttributeSignature",
              value: function getAttributeSignature() {
                return CommandMidpoint.ATTR_SIGNATURE_$LI$();
              }
              /**
              *
              * @param {com.vzome.core.construction.ConstructionList} parameters
              * @param {com.vzome.core.commands.AttributeMap} attrs
              * @param {*} effects
              * @return {com.vzome.core.construction.ConstructionList}
              */

            }, {
              key: "apply",
              value: function apply(parameters, attrs, effects) {
                var result = new com.vzome.core.construction.ConstructionList();
                if (parameters == null || parameters.size() !== 1) throw new commands.Command.Failure("Midpoint can only apply to a single strut.");

                try {
                  var segment = parameters.get(0);
                  var midpoint = new com.vzome.core.construction.SegmentMidpoint(segment);
                  result.addConstruction(midpoint);
                  effects.constructionAdded(midpoint);
                } catch (e) {
                  throw new commands.Command.Failure("Midpoint can only apply to a strut.");
                }

                return result;
              }
            }], [{
              key: "PARAM_SIGNATURE_$LI$",
              value: function PARAM_SIGNATURE_$LI$() {
                if (CommandMidpoint.PARAM_SIGNATURE == null) CommandMidpoint.PARAM_SIGNATURE = [["segment", com.vzome.core.construction.Segment]];
                return CommandMidpoint.PARAM_SIGNATURE;
              }
            }, {
              key: "ATTR_SIGNATURE_$LI$",
              value: function ATTR_SIGNATURE_$LI$() {
                if (CommandMidpoint.ATTR_SIGNATURE == null) CommandMidpoint.ATTR_SIGNATURE = [];
                return CommandMidpoint.ATTR_SIGNATURE;
              }
            }]);

            return CommandMidpoint;
          }(com.vzome.core.commands.AbstractCommand);

          commands.CommandMidpoint = CommandMidpoint;
          CommandMidpoint["__class"] = "com.vzome.core.commands.CommandMidpoint";
          CommandMidpoint["__interfaces"] = ["com.vzome.core.commands.Command"];
        })(core.commands || (core.commands = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          /**
          * @author Scott Vorthmann
          * @param {com.vzome.core.algebra.Quaternion} leftQuaternion
          * @param {com.vzome.core.algebra.Quaternion} rightQuaternion
          * @param {com.vzome.core.construction.Point} prototype
          * @class
          * @extends com.vzome.core.construction.Point
          */
          var PointRotated4D =
          /*#__PURE__*/
          function (_com$vzome$core$const30) {
            _inherits(PointRotated4D, _com$vzome$core$const30);

            var _super106 = _createSuper(PointRotated4D);

            function PointRotated4D(leftQuaternion, rightQuaternion, prototype) {
              var _this81;

              _classCallCheck(this, PointRotated4D);

              _this81 = _super106.call(this, prototype.field);
              if (_this81.mLeftQuaternion === undefined) _this81.mLeftQuaternion = null;
              if (_this81.mRightQuaternion === undefined) _this81.mRightQuaternion = null;
              if (_this81.mPrototype === undefined) _this81.mPrototype = null;
              _this81.mLeftQuaternion = leftQuaternion;
              _this81.mRightQuaternion = rightQuaternion;
              _this81.mPrototype = prototype;

              _this81.mapParamsToState();

              return _this81;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(PointRotated4D, [{
              key: "mapParamsToState",
              value: function mapParamsToState() {
                if (this.mPrototype.isImpossible()) return this.setStateVariable(null, true);
                var field = this.mPrototype.getField();
                var loc = field.origin(4);
                var loc3d = this.mPrototype.getLocation();
                loc = loc3d.inflateTo4d$boolean(true);
                loc = this.mRightQuaternion.leftMultiply(loc);
                loc = this.mLeftQuaternion.rightMultiply(loc);
                return this.setStateVariable(loc, false);
              }
            }]);

            return PointRotated4D;
          }(com.vzome.core.construction.Point);

          construction.PointRotated4D = PointRotated4D;
          PointRotated4D["__class"] = "com.vzome.core.construction.PointRotated4D";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          var LineLineIntersectionPoint =
          /*#__PURE__*/
          function (_com$vzome$core$const31) {
            _inherits(LineLineIntersectionPoint, _com$vzome$core$const31);

            var _super107 = _createSuper(LineLineIntersectionPoint);

            function LineLineIntersectionPoint(line1, line2) {
              var _this82;

              _classCallCheck(this, LineLineIntersectionPoint);

              _this82 = _super107.call(this, line1.field);
              if (_this82.line1 === undefined) _this82.line1 = null;
              if (_this82.line2 === undefined) _this82.line2 = null;
              _this82.line1 = line1;
              _this82.line2 = line2;

              _this82.mapParamsToState();

              return _this82;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(LineLineIntersectionPoint, [{
              key: "mapParamsToState",
              value: function mapParamsToState() {
                var p1 = this.line1.getStart();
                var p21 = this.line1.getDirection();
                var p3 = this.line2.getStart();
                var p43 = this.line2.getDirection();
                if (p1.equals(p3)) return this.setStateVariable(p1, false);
                var p2 = p1.plus(p21);
                if (p2.equals(p3)) return this.setStateVariable(p2, false);
                var p4 = p3.plus(p43);
                if (p1.equals(p4)) return this.setStateVariable(p1, false);
                if (p2.equals(p4)) return this.setStateVariable(p2, false);
                var p13 = p1.minus(p3);
                var d1343 = p13.dot(p43);
                var d4321 = p43.dot(p21);
                var d1321 = p13.dot(p21);
                var d4343 = p43.dot(p43);
                var d2121 = p21.dot(p21);
                var denom = d2121['times$com_vzome_core_algebra_AlgebraicNumber'](d4343)['minus$com_vzome_core_algebra_AlgebraicNumber'](d4321['times$com_vzome_core_algebra_AlgebraicNumber'](d4321));
                if (denom.isZero()) return this.setStateVariable(null, true);
                var numer = d1343['times$com_vzome_core_algebra_AlgebraicNumber'](d4321)['minus$com_vzome_core_algebra_AlgebraicNumber'](d1321['times$com_vzome_core_algebra_AlgebraicNumber'](d4343));
                var mua = numer['dividedBy$com_vzome_core_algebra_AlgebraicNumber'](denom);
                var mub = d1343['plus$com_vzome_core_algebra_AlgebraicNumber'](d4321['times$com_vzome_core_algebra_AlgebraicNumber'](mua))['dividedBy$com_vzome_core_algebra_AlgebraicNumber'](d4343);
                var pa = p1.plus(p21.scale(mua));
                var pb = p3.plus(p43.scale(mub));
                if (!pa.equals(pb)) return this.setStateVariable(null, true);
                return this.setStateVariable(pb, false);
              }
            }]);

            return LineLineIntersectionPoint;
          }(com.vzome.core.construction.Point);

          construction.LineLineIntersectionPoint = LineLineIntersectionPoint;
          LineLineIntersectionPoint["__class"] = "com.vzome.core.construction.LineLineIntersectionPoint";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          /**
          * @author Scott Vorthmann
          * @param {com.vzome.core.construction.Transformation} transform
          * @param {com.vzome.core.construction.Point} prototype
          * @class
          * @extends com.vzome.core.construction.Point
          */
          var TransformedPoint =
          /*#__PURE__*/
          function (_com$vzome$core$const32) {
            _inherits(TransformedPoint, _com$vzome$core$const32);

            var _super108 = _createSuper(TransformedPoint);

            function TransformedPoint(transform, prototype) {
              var _this83;

              _classCallCheck(this, TransformedPoint);

              _this83 = _super108.call(this, prototype.field);
              if (_this83.mTransform === undefined) _this83.mTransform = null;
              if (_this83.mPrototype === undefined) _this83.mPrototype = null;
              _this83.mTransform = transform;
              _this83.mPrototype = prototype;

              _this83.mapParamsToState();

              return _this83;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(TransformedPoint, [{
              key: "mapParamsToState",
              value: function mapParamsToState() {
                if (this.mTransform.isImpossible() || this.mPrototype.isImpossible()) return this.setStateVariable(null, true);
                var loc = this.mTransform.transform$com_vzome_core_algebra_AlgebraicVector(this.mPrototype.getLocation());
                return this.setStateVariable(loc, false);
              }
            }]);

            return TransformedPoint;
          }(com.vzome.core.construction.Point);

          construction.TransformedPoint = TransformedPoint;
          TransformedPoint["__class"] = "com.vzome.core.construction.TransformedPoint";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          /**
          * @param loc
          * @param {com.vzome.core.construction.Segment} seg
          * @class
          * @extends com.vzome.core.construction.Point
          * @author Scott Vorthmann
          */
          var SegmentMidpoint =
          /*#__PURE__*/
          function (_com$vzome$core$const33) {
            _inherits(SegmentMidpoint, _com$vzome$core$const33);

            var _super109 = _createSuper(SegmentMidpoint);

            function SegmentMidpoint(seg) {
              var _this84;

              _classCallCheck(this, SegmentMidpoint);

              _this84 = _super109.call(this, seg.field);
              if (_this84.mSegment === undefined) _this84.mSegment = null;
              _this84.mSegment = seg;

              _this84.mapParamsToState();

              return _this84;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(SegmentMidpoint, [{
              key: "mapParamsToState",
              value: function mapParamsToState() {
                if (this.mSegment.isImpossible()) return this.setStateVariable(null, true);
                var half = this.field['createRational$long$long'](1, 2);
                var loc = this.mSegment.getStart();
                loc = loc.plus(this.mSegment.getOffset().scale(half));
                return this.setStateVariable(loc, false);
              }
            }]);

            return SegmentMidpoint;
          }(com.vzome.core.construction.Point);

          construction.SegmentMidpoint = SegmentMidpoint;
          SegmentMidpoint["__class"] = "com.vzome.core.construction.SegmentMidpoint";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          /**
          * @param {com.vzome.core.algebra.AlgebraicVector} loc
          * @class
          * @extends com.vzome.core.construction.Point
          * @author Scott Vorthmann
          */
          var FreePoint =
          /*#__PURE__*/
          function (_com$vzome$core$const34) {
            _inherits(FreePoint, _com$vzome$core$const34);

            var _super110 = _createSuper(FreePoint);

            function FreePoint(loc) {
              var _this85;

              _classCallCheck(this, FreePoint);

              _this85 = _super110.call(this, loc.getField());

              _this85.setStateVariable(loc, false);

              return _this85;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(FreePoint, [{
              key: "mapParamsToState",
              value: function mapParamsToState() {
                return true;
              }
            }]);

            return FreePoint;
          }(com.vzome.core.construction.Point);

          construction.FreePoint = FreePoint;
          FreePoint["__class"] = "com.vzome.core.construction.FreePoint";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          /**
          * @author Scott Vorthmann
          * @param {com.vzome.core.construction.Polygon} polygon
          * @param {number} index
          * @class
          * @extends com.vzome.core.construction.Point
          */
          var PolygonVertex =
          /*#__PURE__*/
          function (_com$vzome$core$const35) {
            _inherits(PolygonVertex, _com$vzome$core$const35);

            var _super111 = _createSuper(PolygonVertex);

            function PolygonVertex(polygon, index) {
              var _this86;

              _classCallCheck(this, PolygonVertex);

              _this86 = _super111.call(this, polygon.field);
              if (_this86.polygon === undefined) _this86.polygon = null;
              if (_this86.index === undefined) _this86.index = 0;
              _this86.polygon = polygon;
              _this86.index = index;

              _this86.mapParamsToState();

              return _this86;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(PolygonVertex, [{
              key: "mapParamsToState",
              value: function mapParamsToState() {
                if (this.polygon.isImpossible()) {
                  return this.setStateVariable(null, true);
                }

                var loc = this.polygon.getVertex(this.index);
                return this.setStateVariable(loc, false);
              }
            }]);

            return PolygonVertex;
          }(com.vzome.core.construction.Point);

          construction.PolygonVertex = PolygonVertex;
          PolygonVertex["__class"] = "com.vzome.core.construction.PolygonVertex";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          /**
          * @param loc
          * @param {com.vzome.core.construction.Segment} seg
          * @class
          * @extends com.vzome.core.construction.Point
          * @author Scott Vorthmann
          */
          var SegmentTauDivision =
          /*#__PURE__*/
          function (_com$vzome$core$const36) {
            _inherits(SegmentTauDivision, _com$vzome$core$const36);

            var _super112 = _createSuper(SegmentTauDivision);

            function SegmentTauDivision(seg) {
              var _this87;

              _classCallCheck(this, SegmentTauDivision);

              _this87 = _super112.call(this, seg.field);
              if (_this87.mSegment === undefined) _this87.mSegment = null;
              if (_this87.shrink === undefined) _this87.shrink = null;
              _this87.mSegment = seg;
              _this87.shrink = _this87.field['createPower$int'](-1);

              _this87.mapParamsToState();

              return _this87;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(SegmentTauDivision, [{
              key: "mapParamsToState",
              value: function mapParamsToState() {
                if (this.mSegment.isImpossible()) return this.setStateVariable(null, true);
                var loc = this.mSegment.getStart();
                var off = this.mSegment.getOffset().scale(this.shrink);
                loc = loc.plus(off);
                return this.setStateVariable(loc, false);
              }
            }]);

            return SegmentTauDivision;
          }(com.vzome.core.construction.Point);

          construction.SegmentTauDivision = SegmentTauDivision;
          SegmentTauDivision["__class"] = "com.vzome.core.construction.SegmentTauDivision";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          var LinePlaneIntersectionPoint =
          /*#__PURE__*/
          function (_com$vzome$core$const37) {
            _inherits(LinePlaneIntersectionPoint, _com$vzome$core$const37);

            var _super113 = _createSuper(LinePlaneIntersectionPoint);

            function LinePlaneIntersectionPoint(plane, line) {
              var _this88;

              _classCallCheck(this, LinePlaneIntersectionPoint);

              _this88 = _super113.call(this, line.field);
              if (_this88.mPlane === undefined) _this88.mPlane = null;
              if (_this88.mLine === undefined) _this88.mLine = null;
              _this88.mPlane = plane;
              _this88.mLine = line;

              _this88.mapParamsToState();

              return _this88;
            }
            /**
            * From Vince, GA4CG, p. 196.
            *
            * @author Scott Vorthmann
            * @return {boolean}
            */


            _createClass(LinePlaneIntersectionPoint, [{
              key: "mapParamsToState_usingGA",
              value: function mapParamsToState_usingGA() {
                if (this.mPlane.isImpossible() || this.mLine.isImpossible()) return this.setStateVariable(null, true);
                var plane = this.mPlane.getHomogeneous();
                var line = this.mLine.getHomogeneous();
                var intersection = plane.dual().dot(line);
                if (!intersection.exists()) return this.setStateVariable(null, true);
                return this.setStateVariable(intersection.getVector(), false);
              }
              /**
              * from http://astronomy.swin.edu.au/~pbourke/geometry/planeline/:
              *
              *
              * The equation of a plane (points P are on the plane with normal N and point P3 on the plane) can be written as
              *
              * N dot (P - P3) = 0
              *
              * The equation of the line (points P on the line passing through points P1 and P2) can be written as
              *
              * P = P1 + u (P2 - P1)
              *
              * The intersection of these two occurs when
              *
              * N dot (P1 + u (P2 - P1)) = N dot P3
              *
              * Solving for u gives
              *
              * u = ( N dot (P3-P1) ) / ( N dot (P2-P1) )
              *
              * If the denominator is zero, the line is parallel to the plane.
              *
              * @author Scott Vorthmann
              * @return {boolean}
              */

            }, {
              key: "mapParamsToState",
              value: function mapParamsToState() {
                if (this.mPlane.isImpossible() || this.mLine.isImpossible()) return this.setStateVariable(null, true);
                var p1 = this.mLine.getStart();
                var p1p2 = this.mLine.getDirection();
                var n = this.mPlane.getNormal();
                var p3 = this.mPlane.getBase();
                var p = com.vzome.core.algebra.AlgebraicVectors.getLinePlaneIntersection(p1, p1p2, p3, n);
                if (p == null) return this.setStateVariable(null, true);else return this.setStateVariable(p, false);
              }
            }]);

            return LinePlaneIntersectionPoint;
          }(com.vzome.core.construction.Point);

          construction.LinePlaneIntersectionPoint = LinePlaneIntersectionPoint;
          LinePlaneIntersectionPoint["__class"] = "com.vzome.core.construction.LinePlaneIntersectionPoint";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          /**
          * @author Scott Vorthmann
          * @param {Array} points
          * @class
          * @extends com.vzome.core.construction.Point
          */
          var CentroidPoint =
          /*#__PURE__*/
          function (_com$vzome$core$const38) {
            _inherits(CentroidPoint, _com$vzome$core$const38);

            var _super114 = _createSuper(CentroidPoint);

            function CentroidPoint(points) {
              var _this89;

              _classCallCheck(this, CentroidPoint);

              _this89 = _super114.call(this, points[0].field);
              if (_this89.mPoints === undefined) _this89.mPoints = null;
              _this89.mPoints = points;

              _this89.mapParamsToState();

              return _this89;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(CentroidPoint, [{
              key: "mapParamsToState",
              value: function mapParamsToState() {
                var centroid = this.mPoints[0].getLocation();
                var num = 1;

                for (var i = 1; i < this.mPoints.length; i++) {
                  {
                    centroid = centroid.plus(this.mPoints[i].getLocation());
                    num++;
                  }
                }

                centroid = centroid.scale(this.field['createRational$long$long'](1, num));
                return this.setStateVariable(centroid, false);
              }
            }]);

            return CentroidPoint;
          }(com.vzome.core.construction.Point);

          construction.CentroidPoint = CentroidPoint;
          CentroidPoint["__class"] = "com.vzome.core.construction.CentroidPoint";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          /**
          * @author Scott Vorthmann
          * @param {com.vzome.core.construction.Segment} seg
          * @param {boolean} start
          * @class
          * @extends com.vzome.core.construction.Point
          */
          var SegmentEndPoint =
          /*#__PURE__*/
          function (_com$vzome$core$const39) {
            _inherits(SegmentEndPoint, _com$vzome$core$const39);

            var _super115 = _createSuper(SegmentEndPoint);

            function SegmentEndPoint(seg, start) {
              var _this90;

              _classCallCheck(this, SegmentEndPoint);

              if ((seg != null && seg instanceof com.vzome.core.construction.Segment || seg === null) && (typeof start === 'boolean' || start === null)) {
                _this90 = _super115.call(this, seg.field);
                if (_this90.mSegment === undefined) _this90.mSegment = null;
                _this90.start = false;
                if (_this90.mSegment === undefined) _this90.mSegment = null;

                (function () {
                  _this90.mSegment = seg;
                  _this90.start = start;

                  _this90.mapParamsToState();
                })();
              } else if ((seg != null && seg instanceof com.vzome.core.construction.Segment || seg === null) && start === undefined) {
                {
                  var _start = false;
                  _this90 = _super115.call(this, seg.field);
                  if (_this90.mSegment === undefined) _this90.mSegment = null;
                  _this90.start = false;
                  if (_this90.mSegment === undefined) _this90.mSegment = null;

                  (function () {
                    _this90.mSegment = seg;
                    _this90.start = _start;

                    _this90.mapParamsToState();
                  })();
                }
              } else throw new Error('invalid overload');

              return _possibleConstructorReturn(_this90);
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(SegmentEndPoint, [{
              key: "mapParamsToState",
              value: function mapParamsToState() {
                if (this.mSegment.isImpossible()) return this.setStateVariable(null, true);
                var loc = this.start ? this.mSegment.getStart() : this.mSegment.getEnd();
                return this.setStateVariable(loc, false);
              }
            }]);

            return SegmentEndPoint;
          }(com.vzome.core.construction.Point);

          construction.SegmentEndPoint = SegmentEndPoint;
          SegmentEndPoint["__class"] = "com.vzome.core.construction.SegmentEndPoint";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (commands) {
          /**
          * @author Scott Vorthmann
          * @class
          * @extends com.vzome.core.commands.AbstractCommand
          */
          var CommandJoinPoints =
          /*#__PURE__*/
          function (_com$vzome$core$comma10) {
            _inherits(CommandJoinPoints, _com$vzome$core$comma10);

            var _super116 = _createSuper(CommandJoinPoints);

            function CommandJoinPoints() {
              _classCallCheck(this, CommandJoinPoints);

              return _super116.call(this);
            }

            _createClass(CommandJoinPoints, [{
              key: "getParameterSignature",

              /**
              *
              * @return {Array}
              */
              value: function getParameterSignature() {
                return CommandJoinPoints.PARAM_SIGNATURE_$LI$();
              }
              /**
              *
              * @return {Array}
              */

            }, {
              key: "getAttributeSignature",
              value: function getAttributeSignature() {
                return CommandJoinPoints.ATTR_SIGNATURE_$LI$();
              }
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "ordersSelection",
              value: function ordersSelection() {
                return true;
              }
              /**
              *
              * @param {com.vzome.core.construction.ConstructionList} parameters
              * @param {com.vzome.core.commands.AttributeMap} attrs
              * @param {*} effects
              * @return {com.vzome.core.construction.ConstructionList}
              */

            }, {
              key: "apply",
              value: function apply(parameters, attrs, effects) {
                var result = new com.vzome.core.construction.ConstructionList();
                if (parameters == null || parameters.size() !== 2) throw new commands.Command.Failure("parameters must be two points");

                try {
                  var pt1 = parameters.get(0);
                  var pt2 = parameters.get(1);
                  var segment = new com.vzome.core.construction.SegmentJoiningPoints(pt1, pt2);
                  result.addConstruction(segment);
                  effects.constructionAdded(segment);
                } catch (e) {
                  throw new commands.Command.Failure("parameters must be two points");
                }

                return result;
              }
            }], [{
              key: "PARAM_SIGNATURE_$LI$",
              value: function PARAM_SIGNATURE_$LI$() {
                if (CommandJoinPoints.PARAM_SIGNATURE == null) CommandJoinPoints.PARAM_SIGNATURE = [["start", com.vzome.core.construction.Point], ["end", com.vzome.core.construction.Point]];
                return CommandJoinPoints.PARAM_SIGNATURE;
              }
            }, {
              key: "ATTR_SIGNATURE_$LI$",
              value: function ATTR_SIGNATURE_$LI$() {
                if (CommandJoinPoints.ATTR_SIGNATURE == null) CommandJoinPoints.ATTR_SIGNATURE = [];
                return CommandJoinPoints.ATTR_SIGNATURE;
              }
            }]);

            return CommandJoinPoints;
          }(com.vzome.core.commands.AbstractCommand);

          commands.CommandJoinPoints = CommandJoinPoints;
          CommandJoinPoints["__class"] = "com.vzome.core.commands.CommandJoinPoints";
          CommandJoinPoints["__interfaces"] = ["com.vzome.core.commands.Command"];
        })(core.commands || (core.commands = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (commands) {
          /**
          * @author Scott Vorthmann
          * @class
          * @extends com.vzome.core.commands.AbstractCommand
          */
          var CommandTransform =
          /*#__PURE__*/
          function (_com$vzome$core$comma11) {
            _inherits(CommandTransform, _com$vzome$core$comma11);

            var _super117 = _createSuper(CommandTransform);

            function CommandTransform() {
              _classCallCheck(this, CommandTransform);

              return _super117.call(this);
            }
            /**
            *
            * @param {com.vzome.core.commands.AttributeMap} attributes
            * @param {com.vzome.core.commands.XmlSaveFormat} format
            */


            _createClass(CommandTransform, [{
              key: "setFixedAttributes",
              value: function setFixedAttributes(attributes, format) {
                if (format.getScale() !== 0) attributes.put(CommandTransform.SCALE_ATTR_NAME, format.getScale());

                _get(_getPrototypeOf(CommandTransform.prototype), "setFixedAttributes", this).call(this, attributes, format);
              }
              /**
              *
              * @param {com.vzome.core.construction.ConstructionList} parameters
              * @param {com.vzome.core.commands.AttributeMap} attributes
              * @param {*} effects
              * @return {com.vzome.core.construction.ConstructionList}
              */

            }, {
              key: "apply",
              value: function apply(parameters, attributes, effects) {
                return null;
              }
            }, {
              key: "getParameterSignature",

              /**
              *
              * @return {Array}
              */
              value: function getParameterSignature() {
                return CommandTransform.PARAM_SIGNATURE_$LI$();
              }
              /**
              *
              * @return {Array}
              */

            }, {
              key: "getAttributeSignature",
              value: function getAttributeSignature() {
                return CommandTransform.AXIS_ATTR_SIGNATURE_$LI$();
              }
            }, {
              key: "transform",
              value: function transform(params, _transform2, effects) {
                var output = new com.vzome.core.construction.ConstructionList();
                effects.constructionAdded(_transform2);

                for (var index668 = 0; index668 < params.length; index668++) {
                  var param = params[index668];
                  {
                    var result = _transform2.transform$com_vzome_core_construction_Construction(param);

                    if (result == null) continue;
                    effects.constructionAdded(result);
                    output.addConstruction(result);
                  }
                }

                return output;
              }
            }], [{
              key: "PARAM_SIGNATURE_$LI$",
              value: function PARAM_SIGNATURE_$LI$() {
                if (CommandTransform.PARAM_SIGNATURE == null) CommandTransform.PARAM_SIGNATURE = [[com.vzome.core.commands.Command.GENERIC_PARAM_NAME, com.vzome.core.construction.Construction]];
                return CommandTransform.PARAM_SIGNATURE;
              }
            }, {
              key: "ATTR_SIGNATURE_$LI$",
              value: function ATTR_SIGNATURE_$LI$() {
                if (CommandTransform.ATTR_SIGNATURE == null) CommandTransform.ATTR_SIGNATURE = [[CommandTransform.SYMMETRY_CENTER_ATTR_NAME, com.vzome.core.construction.Point]];
                return CommandTransform.ATTR_SIGNATURE;
              }
            }, {
              key: "AXIS_ATTR_SIGNATURE_$LI$",
              value: function AXIS_ATTR_SIGNATURE_$LI$() {
                if (CommandTransform.AXIS_ATTR_SIGNATURE == null) CommandTransform.AXIS_ATTR_SIGNATURE = [[CommandTransform.SYMMETRY_CENTER_ATTR_NAME, com.vzome.core.construction.Point], [CommandTransform.SYMMETRY_AXIS_ATTR_NAME, com.vzome.core.construction.Segment]];
                return CommandTransform.AXIS_ATTR_SIGNATURE;
              }
            }, {
              key: "GROUP_ATTR_SIGNATURE_$LI$",
              value: function GROUP_ATTR_SIGNATURE_$LI$() {
                if (CommandTransform.GROUP_ATTR_SIGNATURE == null) CommandTransform.GROUP_ATTR_SIGNATURE = [[CommandTransform.SYMMETRY_CENTER_ATTR_NAME, com.vzome.core.construction.Point], [CommandTransform.SYMMETRY_GROUP_ATTR_NAME, "com.vzome.core.math.symmetry.Symmetry"]];
                return CommandTransform.GROUP_ATTR_SIGNATURE;
              }
            }]);

            return CommandTransform;
          }(com.vzome.core.commands.AbstractCommand);

          CommandTransform.SYMMETRY_GROUP_ATTR_NAME = "symmetry.group";
          CommandTransform.SYMMETRY_CENTER_ATTR_NAME = "symmetry.center";
          CommandTransform.SYMMETRY_AXIS_ATTR_NAME = "symmetry.axis.segment";
          CommandTransform.SCALE_ATTR_NAME = "scale.factor";
          commands.CommandTransform = CommandTransform;
          CommandTransform["__class"] = "com.vzome.core.commands.CommandTransform";
          CommandTransform["__interfaces"] = ["com.vzome.core.commands.Command"];
        })(core.commands || (core.commands = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (commands) {
          /**
          * @author Scott Vorthmann
          * @class
          * @extends com.vzome.core.commands.AbstractCommand
          */
          var CommandBuildAnchoredSegment =
          /*#__PURE__*/
          function (_com$vzome$core$comma12) {
            _inherits(CommandBuildAnchoredSegment, _com$vzome$core$comma12);

            var _super118 = _createSuper(CommandBuildAnchoredSegment);

            function CommandBuildAnchoredSegment() {
              _classCallCheck(this, CommandBuildAnchoredSegment);

              return _super118.call(this);
            }
            /**
            *
            * @param {*} xml
            * @param {com.vzome.core.commands.AttributeMap} attributes
            */


            _createClass(CommandBuildAnchoredSegment, [{
              key: "getXml",
              value: function getXml(xml, attributes) {
                com.vzome.core.commands.XmlSymmetryFormat.serializeAxis(xml, "symm", "dir", "index", "sense", attributes.get("axis"));
                com.vzome.core.commands.XmlSaveFormat.serializeNumber(xml, "len", attributes.get("length"));
              }
              /**
              *
              * @param {*} xml
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              * @return {com.vzome.core.commands.AttributeMap}
              */

            }, {
              key: "setXml",
              value: function setXml(xml, format) {
                var attrs = _get(_getPrototypeOf(CommandBuildAnchoredSegment.prototype), "setXml", this).call(this, xml, format);

                if (format.commandEditsCompacted()) {
                  attrs.put("axis", format.parseAxis(xml, "symm", "dir", "index", "sense"));
                  attrs.put("length", format.parseNumber(xml, "len"));
                }

                return attrs;
              }
            }, {
              key: "getParameterSignature",

              /**
              *
              * @return {Array}
              */
              value: function getParameterSignature() {
                return CommandBuildAnchoredSegment.PARAM_SIGNATURE_$LI$();
              }
              /**
              *
              * @return {Array}
              */

            }, {
              key: "getAttributeSignature",
              value: function getAttributeSignature() {
                return null;
              }
              /**
              *
              * @param {com.vzome.core.construction.ConstructionList} parameters
              * @param {com.vzome.core.commands.AttributeMap} attrs
              * @param {*} effects
              * @return {com.vzome.core.construction.ConstructionList}
              */

            }, {
              key: "apply",
              value: function apply(parameters, attrs, effects) {
                var result = new com.vzome.core.construction.ConstructionList();
                if (parameters == null || parameters.size() !== 1) throw new commands.Command.Failure("start parameter must be a single point");
                var c = parameters.get(0);
                if (!(c != null && c instanceof com.vzome.core.construction.Point)) throw new commands.Command.Failure("start parameter must be a single point");
                var pt1 = c;
                var axis = attrs.get(CommandBuildAnchoredSegment.AXIS_ATTR);
                var len = attrs.get(CommandBuildAnchoredSegment.LENGTH_ATTR);
                var segment = new com.vzome.core.construction.AnchoredSegment(axis, len, pt1);
                effects.constructionAdded(segment);
                result.addConstruction(segment);
                var pt2 = new com.vzome.core.construction.SegmentEndPoint(segment);
                effects.constructionAdded(pt2);
                result.addConstruction(pt2);
                return result;
              }
            }], [{
              key: "PARAM_SIGNATURE_$LI$",
              value: function PARAM_SIGNATURE_$LI$() {
                if (CommandBuildAnchoredSegment.PARAM_SIGNATURE == null) CommandBuildAnchoredSegment.PARAM_SIGNATURE = [["start", com.vzome.core.construction.Point]];
                return CommandBuildAnchoredSegment.PARAM_SIGNATURE;
              }
            }]);

            return CommandBuildAnchoredSegment;
          }(com.vzome.core.commands.AbstractCommand);

          CommandBuildAnchoredSegment.AXIS_ATTR = "axis";
          CommandBuildAnchoredSegment.LENGTH_ATTR = "length";
          commands.CommandBuildAnchoredSegment = CommandBuildAnchoredSegment;
          CommandBuildAnchoredSegment["__class"] = "com.vzome.core.commands.CommandBuildAnchoredSegment";
          CommandBuildAnchoredSegment["__interfaces"] = ["com.vzome.core.commands.Command"];
        })(core.commands || (core.commands = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (commands) {
          /**
          * @author Scott Vorthmann
          * @class
          * @extends com.vzome.core.commands.AbstractCommand
          */
          var CommandTauDivision =
          /*#__PURE__*/
          function (_com$vzome$core$comma13) {
            _inherits(CommandTauDivision, _com$vzome$core$comma13);

            var _super119 = _createSuper(CommandTauDivision);

            function CommandTauDivision() {
              _classCallCheck(this, CommandTauDivision);

              return _super119.call(this);
            }

            _createClass(CommandTauDivision, [{
              key: "getParameterSignature",

              /**
              *
              * @return {Array}
              */
              value: function getParameterSignature() {
                return CommandTauDivision.PARAM_SIGNATURE_$LI$();
              }
              /**
              *
              * @return {Array}
              */

            }, {
              key: "getAttributeSignature",
              value: function getAttributeSignature() {
                return CommandTauDivision.ATTR_SIGNATURE_$LI$();
              }
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "ordersSelection",
              value: function ordersSelection() {
                return true;
              }
              /**
              *
              * @param {com.vzome.core.construction.ConstructionList} parameters
              * @param {com.vzome.core.commands.AttributeMap} attrs
              * @param {*} effects
              * @return {com.vzome.core.construction.ConstructionList}
              */

            }, {
              key: "apply",
              value: function apply(parameters, attrs, effects) {
                var result = new com.vzome.core.construction.ConstructionList();
                if (parameters == null || parameters.size() !== 2) throw new commands.Command.Failure("Tau division applies to two balls.");

                try {
                  var start = parameters.get(0);
                  var end = parameters.get(1);
                  var join = new com.vzome.core.construction.SegmentJoiningPoints(start, end);
                  var midpoint = new com.vzome.core.construction.SegmentTauDivision(join);
                  result.addConstruction(midpoint);
                  effects.constructionAdded(midpoint);
                } catch (e) {
                  throw new commands.Command.Failure("Tau division applies to two balls.");
                }

                return result;
              }
            }], [{
              key: "PARAM_SIGNATURE_$LI$",
              value: function PARAM_SIGNATURE_$LI$() {
                if (CommandTauDivision.PARAM_SIGNATURE == null) CommandTauDivision.PARAM_SIGNATURE = [["start", com.vzome.core.construction.Point], ["end", com.vzome.core.construction.Point]];
                return CommandTauDivision.PARAM_SIGNATURE;
              }
            }, {
              key: "ATTR_SIGNATURE_$LI$",
              value: function ATTR_SIGNATURE_$LI$() {
                if (CommandTauDivision.ATTR_SIGNATURE == null) CommandTauDivision.ATTR_SIGNATURE = [];
                return CommandTauDivision.ATTR_SIGNATURE;
              }
            }]);

            return CommandTauDivision;
          }(com.vzome.core.commands.AbstractCommand);

          commands.CommandTauDivision = CommandTauDivision;
          CommandTauDivision["__class"] = "com.vzome.core.commands.CommandTauDivision";
          CommandTauDivision["__interfaces"] = ["com.vzome.core.commands.Command"];
        })(core.commands || (core.commands = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (commands) {
          var CommandPolygon =
          /*#__PURE__*/
          function (_com$vzome$core$comma14) {
            _inherits(CommandPolygon, _com$vzome$core$comma14);

            var _super120 = _createSuper(CommandPolygon);

            function CommandPolygon() {
              _classCallCheck(this, CommandPolygon);

              return _super120.call(this);
            }

            _createClass(CommandPolygon, [{
              key: "getParameterSignature",

              /**
              *
              * @return {Array}
              */
              value: function getParameterSignature() {
                return CommandPolygon.PARAM_SIGNATURE_$LI$();
              }
              /**
              *
              * @return {Array}
              */

            }, {
              key: "getAttributeSignature",
              value: function getAttributeSignature() {
                return CommandPolygon.ATTR_SIGNATURE_$LI$();
              }
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "ordersSelection",
              value: function ordersSelection() {
                return true;
              }
              /**
              *
              * @param {com.vzome.core.construction.ConstructionList} parameters
              * @param {com.vzome.core.commands.AttributeMap} attrs
              * @param {*} effects
              * @return {com.vzome.core.construction.ConstructionList}
              */

            }, {
              key: "apply",
              value: function apply(parameters, attrs, effects) {
                var points = new java.util.ArrayList();
                {
                  var array670 = parameters.getConstructions();

                  for (var index669 = 0; index669 < array670.length; index669++) {
                    var param = array670[index669];
                    {
                      if (param != null && param instanceof com.vzome.core.construction.Point) {
                        points.add(param);
                      }
                    }
                  }
                }
                var errorMsg = null;

                if (points.size() < 3) {
                  errorMsg = "A polygon requires at least three vertices.";
                } else if (points.get(0).is3d() && points.get(1).is3d() && points.get(1).is3d()) {
                  var normal = com.vzome.core.algebra.AlgebraicVectors.getNormal$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector(points.get(0).getLocation(), points.get(1).getLocation(), points.get(2).getLocation());

                  if (normal.isOrigin()) {
                    errorMsg = "First 3 points cannot be collinear.";
                  } else {
                    var base = null;

                    for (var index671 = points.iterator(); index671.hasNext();) {
                      var point = index671.next();
                      {
                        if (base == null) {
                          base = point.getLocation();
                        } else {
                          if (!point.getLocation().minus(base).dot(normal).isZero()) {
                            errorMsg = "Points are not coplanar.";
                            break;
                          }
                        }
                      }
                    }
                  }
                }

                if (errorMsg != null && attrs.get(com.vzome.core.commands.Command.LOADING_FROM_FILE) == null) {
                  throw new commands.Command.Failure(errorMsg);
                }

                var poly = new com.vzome.core.construction.PolygonFromVertices(points);

                if (errorMsg != null) {
                  poly.setFailed();
                } else {
                  effects.constructionAdded(poly);
                }

                var result = new com.vzome.core.construction.ConstructionList();
                result.addConstruction(poly);
                return result;
              }
            }], [{
              key: "PARAM_SIGNATURE_$LI$",
              value: function PARAM_SIGNATURE_$LI$() {
                if (CommandPolygon.PARAM_SIGNATURE == null) CommandPolygon.PARAM_SIGNATURE = [[com.vzome.core.commands.Command.GENERIC_PARAM_NAME, com.vzome.core.construction.Point]];
                return CommandPolygon.PARAM_SIGNATURE;
              }
            }, {
              key: "ATTR_SIGNATURE_$LI$",
              value: function ATTR_SIGNATURE_$LI$() {
                if (CommandPolygon.ATTR_SIGNATURE == null) CommandPolygon.ATTR_SIGNATURE = [];
                return CommandPolygon.ATTR_SIGNATURE;
              }
            }]);

            return CommandPolygon;
          }(com.vzome.core.commands.AbstractCommand);

          commands.CommandPolygon = CommandPolygon;
          CommandPolygon["__class"] = "com.vzome.core.commands.CommandPolygon";
          CommandPolygon["__interfaces"] = ["com.vzome.core.commands.Command"];
        })(core.commands || (core.commands = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (commands) {
          /**
          * @author Scott Vorthmann
          * @class
          * @extends com.vzome.core.commands.AbstractCommand
          */
          var CommandCentroid =
          /*#__PURE__*/
          function (_com$vzome$core$comma15) {
            _inherits(CommandCentroid, _com$vzome$core$comma15);

            var _super121 = _createSuper(CommandCentroid);

            function CommandCentroid() {
              _classCallCheck(this, CommandCentroid);

              return _super121.call(this);
            }

            _createClass(CommandCentroid, [{
              key: "getParameterSignature",

              /**
              *
              * @return {Array}
              */
              value: function getParameterSignature() {
                return CommandCentroid.PARAM_SIGNATURE_$LI$();
              }
              /**
              *
              * @return {Array}
              */

            }, {
              key: "getAttributeSignature",
              value: function getAttributeSignature() {
                return CommandCentroid.ATTR_SIGNATURE_$LI$();
              }
              /**
              *
              * @param {com.vzome.core.construction.ConstructionList} parameters
              * @param {com.vzome.core.commands.AttributeMap} attrs
              * @param {*} effects
              * @return {com.vzome.core.construction.ConstructionList}
              */

            }, {
              key: "apply",
              value: function apply(parameters, attrs, effects) {
                var result = new com.vzome.core.construction.ConstructionList();
                if (parameters == null || parameters.size() === 0) throw new commands.Command.Failure("Select two or more balls to compute their centroid.");
                var params = parameters.getConstructions();
                var verticesList = new java.util.ArrayList();

                for (var index672 = 0; index672 < params.length; index672++) {
                  var param = params[index672];
                  {
                    if (param != null && param instanceof com.vzome.core.construction.Point) {
                      verticesList.add(param);
                    }
                  }
                }

                if (verticesList.isEmpty()) throw new commands.Command.Failure("Select two or more balls to compute their centroid.");
                var points = [];
                var centroid = new com.vzome.core.construction.CentroidPoint(verticesList.toArray(points));
                effects.constructionAdded(centroid);
                result.addConstruction(centroid);
                return result;
              }
            }], [{
              key: "PARAM_SIGNATURE_$LI$",
              value: function PARAM_SIGNATURE_$LI$() {
                if (CommandCentroid.PARAM_SIGNATURE == null) CommandCentroid.PARAM_SIGNATURE = [[com.vzome.core.commands.Command.GENERIC_PARAM_NAME, com.vzome.core.construction.Point]];
                return CommandCentroid.PARAM_SIGNATURE;
              }
            }, {
              key: "ATTR_SIGNATURE_$LI$",
              value: function ATTR_SIGNATURE_$LI$() {
                if (CommandCentroid.ATTR_SIGNATURE == null) CommandCentroid.ATTR_SIGNATURE = [];
                return CommandCentroid.ATTR_SIGNATURE;
              }
            }]);

            return CommandCentroid;
          }(com.vzome.core.commands.AbstractCommand);

          commands.CommandCentroid = CommandCentroid;
          CommandCentroid["__class"] = "com.vzome.core.commands.CommandCentroid";
          CommandCentroid["__interfaces"] = ["com.vzome.core.commands.Command"];
        })(core.commands || (core.commands = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          /**
          * @author Scott Vorthmann
          * @param {com.vzome.core.construction.Point} intersection
          * @param {com.vzome.core.construction.Segment} normal
          * @class
          * @extends com.vzome.core.construction.Plane
          */
          var PlaneFromNormalSegment =
          /*#__PURE__*/
          function (_com$vzome$core$const40) {
            _inherits(PlaneFromNormalSegment, _com$vzome$core$const40);

            var _super122 = _createSuper(PlaneFromNormalSegment);

            function PlaneFromNormalSegment(intersection, normal) {
              var _this91;

              _classCallCheck(this, PlaneFromNormalSegment);

              _this91 = _super122.call(this, intersection.field);
              if (_this91.__com_vzome_core_construction_PlaneFromNormalSegment_mNormal === undefined) _this91.__com_vzome_core_construction_PlaneFromNormalSegment_mNormal = null;
              if (_this91.mIntersection === undefined) _this91.mIntersection = null;
              _this91.__com_vzome_core_construction_PlaneFromNormalSegment_mNormal = normal;
              _this91.mIntersection = intersection;

              _this91.mapParamsToState();

              return _this91;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(PlaneFromNormalSegment, [{
              key: "mapParamsToState",
              value: function mapParamsToState() {
                if (this.__com_vzome_core_construction_PlaneFromNormalSegment_mNormal.isImpossible() || this.mIntersection.isImpossible()) return this.setStateVariables(null, null, true);
                return this.setStateVariables(this.mIntersection.getLocation(), this.__com_vzome_core_construction_PlaneFromNormalSegment_mNormal.getOffset(), false);
              }
            }]);

            return PlaneFromNormalSegment;
          }(com.vzome.core.construction.Plane);

          construction.PlaneFromNormalSegment = PlaneFromNormalSegment;
          PlaneFromNormalSegment["__class"] = "com.vzome.core.construction.PlaneFromNormalSegment";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          /**
          * @author Scott Vorthmann
          * @param {com.vzome.core.construction.Polygon} polygon
          * @class
          * @extends com.vzome.core.construction.Plane
          */
          var PlaneExtensionOfPolygon =
          /*#__PURE__*/
          function (_com$vzome$core$const41) {
            _inherits(PlaneExtensionOfPolygon, _com$vzome$core$const41);

            var _super123 = _createSuper(PlaneExtensionOfPolygon);

            function PlaneExtensionOfPolygon(polygon) {
              var _this92;

              _classCallCheck(this, PlaneExtensionOfPolygon);

              _this92 = _super123.call(this, polygon.field);
              if (_this92.mPolygon === undefined) _this92.mPolygon = null;
              _this92.mPolygon = polygon;

              _this92.mapParamsToState();

              return _this92;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(PlaneExtensionOfPolygon, [{
              key: "mapParamsToState",
              value: function mapParamsToState() {
                if (this.mPolygon.isImpossible()) {
                  return this.setStateVariables(null, null, true);
                }

                return this.setStateVariables(this.mPolygon.getVertex(0), this.mPolygon.getNormal(), false);
              }
              /**
              *
              * @return {com.vzome.core.algebra.Trivector3dHomogeneous}
              */

            }, {
              key: "getHomogeneous",
              value: function getHomogeneous() {
                var v1 = new com.vzome.core.algebra.Vector3dHomogeneous(this.mPolygon.getVertex(0), this.getField());
                var v2 = new com.vzome.core.algebra.Vector3dHomogeneous(this.mPolygon.getVertex(1), this.getField());
                var v3 = new com.vzome.core.algebra.Vector3dHomogeneous(this.mPolygon.getVertex(2), this.getField());
                return v1.outer(v2).outer(v3);
              }
            }]);

            return PlaneExtensionOfPolygon;
          }(com.vzome.core.construction.Plane);

          construction.PlaneExtensionOfPolygon = PlaneExtensionOfPolygon;
          PlaneExtensionOfPolygon["__class"] = "com.vzome.core.construction.PlaneExtensionOfPolygon";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          /**
          * @author Scott Vorthmann
          * @param {com.vzome.core.algebra.AlgebraicVector} point
          * @param {com.vzome.core.algebra.AlgebraicVector} normal
          * @class
          * @extends com.vzome.core.construction.Plane
          */
          var PlaneFromPointAndNormal =
          /*#__PURE__*/
          function (_com$vzome$core$const42) {
            _inherits(PlaneFromPointAndNormal, _com$vzome$core$const42);

            var _super124 = _createSuper(PlaneFromPointAndNormal);

            function PlaneFromPointAndNormal(point, normal) {
              var _this93;

              _classCallCheck(this, PlaneFromPointAndNormal);

              _this93 = _super124.call(this, point.getField());
              if (_this93.normal === undefined) _this93.normal = null;
              if (_this93.point === undefined) _this93.point = null;
              _this93.point = point;
              _this93.normal = normal;

              _this93.mapParamsToState();

              return _this93;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(PlaneFromPointAndNormal, [{
              key: "mapParamsToState",
              value: function mapParamsToState() {
                if (this.normal.isOrigin()) return this.setStateVariables(null, null, true);
                return this.setStateVariables(this.point, this.normal, false);
              }
            }]);

            return PlaneFromPointAndNormal;
          }(com.vzome.core.construction.Plane);

          construction.PlaneFromPointAndNormal = PlaneFromPointAndNormal;
          PlaneFromPointAndNormal["__class"] = "com.vzome.core.construction.PlaneFromPointAndNormal";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          /**
          * @param step
          * @param start
          * @param end
          * @param {com.vzome.core.construction.Line} l1
          * @param {com.vzome.core.construction.Line} l2
          * @param {com.vzome.core.construction.Point} p
          * @class
          * @extends com.vzome.core.construction.Line
          * @author Scott Vorthmann
          */
          var PerpendicularLine =
          /*#__PURE__*/
          function (_com$vzome$core$const43) {
            _inherits(PerpendicularLine, _com$vzome$core$const43);

            var _super125 = _createSuper(PerpendicularLine);

            function PerpendicularLine(l1, l2, p) {
              var _this94;

              _classCallCheck(this, PerpendicularLine);

              _this94 = _super125.call(this, l1.field);
              if (_this94.mLine1 === undefined) _this94.mLine1 = null;
              if (_this94.mLine2 === undefined) _this94.mLine2 = null;
              if (_this94.mPoint === undefined) _this94.mPoint = null;
              _this94.mLine1 = l1;
              _this94.mLine2 = l2;
              _this94.mPoint = p;

              _this94.mapParamsToState();

              return _this94;
            }
            /**
            * returns true if something changed.
            * @return
            * @return {boolean}
            */


            _createClass(PerpendicularLine, [{
              key: "mapParamsToState",
              value: function mapParamsToState() {
                if (this.mLine1.isImpossible() || this.mLine2.isImpossible() || this.mPoint.isImpossible()) {
                  return this.setStateVariables(null, null, true);
                }

                var normal = com.vzome.core.algebra.AlgebraicVectors.getNormal$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector(this.mLine1.getDirection(), this.mLine2.getDirection());
                return this.setStateVariables(this.mPoint.getLocation(), normal, normal.isOrigin());
              }
            }]);

            return PerpendicularLine;
          }(com.vzome.core.construction.Line);

          construction.PerpendicularLine = PerpendicularLine;
          PerpendicularLine["__class"] = "com.vzome.core.construction.PerpendicularLine";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          /**
          * @author Scott Vorthmann
          * @param {com.vzome.core.construction.Segment} seg
          * @class
          * @extends com.vzome.core.construction.Line
          */
          var LineExtensionOfSegment =
          /*#__PURE__*/
          function (_com$vzome$core$const44) {
            _inherits(LineExtensionOfSegment, _com$vzome$core$const44);

            var _super126 = _createSuper(LineExtensionOfSegment);

            function LineExtensionOfSegment(seg) {
              var _this95;

              _classCallCheck(this, LineExtensionOfSegment);

              _this95 = _super126.call(this, seg.field);
              if (_this95.mSegment === undefined) _this95.mSegment = null;
              _this95.mSegment = seg;

              _this95.mapParamsToState();

              return _this95;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(LineExtensionOfSegment, [{
              key: "mapParamsToState",
              value: function mapParamsToState() {
                if (this.mSegment.isImpossible()) return this.setStateVariables(null, null, true);
                return this.setStateVariables(this.mSegment.getStart(), this.mSegment.getOffset(), false);
              }
              /**
              *
              * @return {com.vzome.core.algebra.Bivector3dHomogeneous}
              */

            }, {
              key: "getHomogeneous",
              value: function getHomogeneous() {
                var v1 = new com.vzome.core.algebra.Vector3dHomogeneous(this.mSegment.getStart(), this.getField());
                var v2 = new com.vzome.core.algebra.Vector3dHomogeneous(this.mSegment.getEnd(), this.getField());
                return v1.outer(v2);
              }
            }]);

            return LineExtensionOfSegment;
          }(com.vzome.core.construction.Line);

          construction.LineExtensionOfSegment = LineExtensionOfSegment;
          LineExtensionOfSegment["__class"] = "com.vzome.core.construction.LineExtensionOfSegment";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (construction) {
          /**
          * @author Scott Vorthmann
          * @param {com.vzome.core.algebra.AlgebraicVector} point
          * @param {com.vzome.core.algebra.AlgebraicVector} direction
          * @class
          * @extends com.vzome.core.construction.Line
          */
          var LineFromPointAndVector =
          /*#__PURE__*/
          function (_com$vzome$core$const45) {
            _inherits(LineFromPointAndVector, _com$vzome$core$const45);

            var _super127 = _createSuper(LineFromPointAndVector);

            function LineFromPointAndVector(point, direction) {
              var _this96;

              _classCallCheck(this, LineFromPointAndVector);

              _this96 = _super127.call(this, point.getField());
              if (_this96.point === undefined) _this96.point = null;
              if (_this96.direction === undefined) _this96.direction = null;
              _this96.point = point;
              _this96.direction = direction;

              _this96.mapParamsToState();

              return _this96;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(LineFromPointAndVector, [{
              key: "mapParamsToState",
              value: function mapParamsToState() {
                if (this.direction.isOrigin()) return this.setStateVariables(null, null, true);
                return this.setStateVariables(this.point, this.direction, false);
              }
            }]);

            return LineFromPointAndVector;
          }(com.vzome.core.construction.Line);

          construction.LineFromPointAndVector = LineFromPointAndVector;
          LineFromPointAndVector["__class"] = "com.vzome.core.construction.LineFromPointAndVector";
        })(core.construction || (core.construction = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (editor) {
          (function (api) {
            var ChangeSelection =
            /*#__PURE__*/
            function (_com$vzome$core$edito9) {
              _inherits(ChangeSelection, _com$vzome$core$edito9);

              var _super128 = _createSuper(ChangeSelection);

              function ChangeSelection(selection) {
                var _this97;

                _classCallCheck(this, ChangeSelection);

                _this97 = _super128.call(this);
                if (_this97.mSelection === undefined) _this97.mSelection = null;
                if (_this97.groupingDoneInSelection === undefined) _this97.groupingDoneInSelection = false;
                _this97.orderedSelection = false;
                _this97.selectionEffects = null;
                _this97.mSelection = selection;
                _this97.groupingDoneInSelection = false;
                return _this97;
              }

              _createClass(ChangeSelection, [{
                key: "setOrderedSelection",
                value: function setOrderedSelection(orderedSelection) {
                  this.orderedSelection = orderedSelection;
                }
                /**
                *
                */

              }, {
                key: "undo",
                value: function undo() {
                  if (this.orderedSelection) {
                    var stack = new java.util.ArrayDeque();
                    this.selectionEffects = stack;

                    _get(_getPrototypeOf(ChangeSelection.prototype), "undo", this).call(this);

                    this.mSelection.clear();
                    this.selectionEffects = null;

                    while (!stack.isEmpty()) {
                      {
                        var se = stack.pop();
                        se.undo();
                      }
                    }
                  } else _get(_getPrototypeOf(ChangeSelection.prototype), "undo", this).call(this);
                }
              }, {
                key: "getXmlAttributes",
                value: function getXmlAttributes(element) {}
              }, {
                key: "setXmlAttributes",
                value: function setXmlAttributes(xml, format) {}
                /**
                *
                * @param {*} doc
                * @return {*}
                */

              }, {
                key: "getXml",
                value: function getXml(doc) {
                  var result = doc.createElement(this.getXmlElementName());
                  if (this.groupingDoneInSelection) com.vzome.xml.DomUtils.addAttribute(result, "grouping", "2.1.1");
                  this.getXmlAttributes(result);
                  return result;
                }
              }, {
                key: "adjustSelection",
                value: function adjustSelection(man, action) {
                  switch (action) {
                    case com.vzome.core.editor.api.ActionEnum.SELECT:
                      this.select$com_vzome_core_model_Manifestation(man);
                      break;

                    case com.vzome.core.editor.api.ActionEnum.DESELECT:
                      this.unselect$com_vzome_core_model_Manifestation(man);
                      break;

                    case com.vzome.core.editor.api.ActionEnum.IGNORE:
                      break;

                    default:
                      ChangeSelection.logger_$LI$().warning("unexpected action: " + com.vzome.core.editor.api.ActionEnum["_$wrappers"][action].toString());
                      break;
                  }
                }
                /**
                * Any subclass can override to alter loading, or migrate (insert other edits), etc.
                * ALWAYS DO SOME INSERT, or all trace of the command will disappear!
                * @param {*} xml
                * @param {com.vzome.core.commands.XmlSaveFormat} format
                * @param {*} context
                */

              }, {
                key: "loadAndPerform",
                value: function loadAndPerform(xml, format, context) {
                  var grouping = xml.getAttribute("grouping");
                  if (this.groupingAware() && (format.groupingDoneInSelection() ||
                  /* equals */
                  function (o1, o2) {
                    if (o1 && o1.equals) {
                      return o1.equals(o2);
                    } else {
                      return o1 === o2;
                    }
                  }("2.1.1", grouping))) this.groupingDoneInSelection = true;
                  this.setXmlAttributes(xml, format);
                  context.performAndRecord(this);
                }
              }, {
                key: "groupingAware",
                value: function groupingAware() {
                  return false;
                }
              }, {
                key: "unselect$com_vzome_core_model_Manifestation",
                value: function unselect$com_vzome_core_model_Manifestation(man) {
                  this.unselect$com_vzome_core_model_Manifestation$boolean(man, false);
                }
              }, {
                key: "unselect$com_vzome_core_model_Manifestation$boolean",
                value: function unselect$com_vzome_core_model_Manifestation$boolean(man, ignoreGroups) {
                  if (this.groupingDoneInSelection) {
                    this.plan(new ChangeSelection.SelectManifestation(this, man, false));
                    return;
                  }

                  if (man == null) {
                    api.SideEffects.logBugAccommodation("null manifestation");
                    return;
                  }

                  if (!this.mSelection.manifestationSelected(man)) return;
                  var group = ignoreGroups ? null : com.vzome.core.editor.api.Selection.biggestGroup(man);
                  if (group == null) this.plan(new ChangeSelection.SelectManifestation(this, man, false));else this.unselectGroup(group);
                }
              }, {
                key: "unselect",
                value: function unselect(man, ignoreGroups) {
                  if ((man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0) || man === null) && (typeof ignoreGroups === 'boolean' || ignoreGroups === null)) {
                    return this.unselect$com_vzome_core_model_Manifestation$boolean(man, ignoreGroups);
                  } else if ((man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0) || man === null) && ignoreGroups === undefined) {
                    return this.unselect$com_vzome_core_model_Manifestation(man);
                  } else throw new Error('invalid overload');
                }
              }, {
                key: "select$com_vzome_core_model_Manifestation",
                value: function select$com_vzome_core_model_Manifestation(man) {
                  this.select$com_vzome_core_model_Manifestation$boolean(man, false);
                }
              }, {
                key: "recordSelected",
                value: function recordSelected(man) {
                  if (!this.mSelection.manifestationSelected(man)) return;
                  this.plan(new ChangeSelection.RecordSelectedManifestation(this, man));
                }
              }, {
                key: "select$com_vzome_core_model_Manifestation$boolean",
                value: function select$com_vzome_core_model_Manifestation$boolean(man, ignoreGroups) {
                  if (this.groupingDoneInSelection) {
                    this.plan(new ChangeSelection.SelectManifestation(this, man, true));
                    return;
                  }

                  if (man == null) {
                    api.SideEffects.logBugAccommodation("null manifestation");
                    return;
                  }

                  if (this.mSelection.manifestationSelected(man)) return;
                  var group = ignoreGroups ? null : com.vzome.core.editor.api.Selection.biggestGroup(man);
                  if (group == null) this.plan(new ChangeSelection.SelectManifestation(this, man, true));else this.selectGroup(group);
                }
              }, {
                key: "select",
                value: function select(man, ignoreGroups) {
                  if ((man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0) || man === null) && (typeof ignoreGroups === 'boolean' || ignoreGroups === null)) {
                    return this.select$com_vzome_core_model_Manifestation$boolean(man, ignoreGroups);
                  } else if ((man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0) || man === null) && ignoreGroups === undefined) {
                    return this.select$com_vzome_core_model_Manifestation(man);
                  } else throw new Error('invalid overload');
                }
              }, {
                key: "selectGroup",
                value: function selectGroup(group) {
                  for (var index673 = group.iterator(); index673.hasNext();) {
                    var next = index673.next();
                    {
                      if (next != null && next instanceof com.vzome.core.model.Group) this.selectGroup(next);else this.plan(new ChangeSelection.SelectManifestation(this, next, true));
                    }
                  }
                }
              }, {
                key: "unselectGroup",
                value: function unselectGroup(group) {
                  for (var index674 = group.iterator(); index674.hasNext();) {
                    var next = index674.next();
                    {
                      if (next != null && next instanceof com.vzome.core.model.Group) this.unselectGroup(next);else this.plan(new ChangeSelection.SelectManifestation(this, next, false));
                    }
                  }
                }
              }, {
                key: "getSelectedConnectors",
                value: function getSelectedConnectors() {
                  return com.vzome.core.editor.api.Manifestations.getConnectors$java_lang_Iterable(this.mSelection);
                }
              }, {
                key: "getSelectedStruts",
                value: function getSelectedStruts() {
                  return com.vzome.core.editor.api.Manifestations.getStruts$java_lang_Iterable(this.mSelection);
                }
              }, {
                key: "getSelectedPanels",
                value: function getSelectedPanels() {
                  return com.vzome.core.editor.api.Manifestations.getPanels$java_lang_Iterable(this.mSelection);
                }
              }, {
                key: "getLastSelectedManifestation",
                value: function getLastSelectedManifestation() {
                  var last = null;

                  for (var index675 = this.mSelection.iterator(); index675.hasNext();) {
                    var man = index675.next();
                    {
                      last = man;
                    }
                  }

                  return last;
                }
              }, {
                key: "getLastSelectedConnector",
                value: function getLastSelectedConnector() {
                  var last = null;

                  for (var index676 = this.getSelectedConnectors().iterator(); index676.hasNext();) {
                    var connector = index676.next();
                    {
                      last = connector;
                    }
                  }

                  return last;
                }
              }, {
                key: "getLastSelectedStrut",
                value: function getLastSelectedStrut() {
                  var last = null;

                  for (var index677 = this.getSelectedStruts().iterator(); index677.hasNext();) {
                    var strut = index677.next();
                    {
                      last = strut;
                    }
                  }

                  return last;
                }
              }, {
                key: "getLastSelectedPanel",
                value: function getLastSelectedPanel() {
                  var last = null;

                  for (var index678 = this.getSelectedPanels().iterator(); index678.hasNext();) {
                    var panel = index678.next();
                    {
                      last = panel;
                    }
                  }

                  return last;
                }
              }, {
                key: "unselectAll",
                value: function unselectAll() {
                  var anySelected = false;

                  for (var index679 = this.mSelection.iterator(); index679.hasNext();) {
                    var man = index679.next();
                    {
                      anySelected = true;
                      this.unselect$com_vzome_core_model_Manifestation(man);
                    }
                  }

                  if (anySelected) {
                    this.redo();
                  }

                  return anySelected;
                }
              }, {
                key: "unselectConnectors",
                value: function unselectConnectors() {
                  var anySelected = false;

                  for (var index680 = this.getSelectedConnectors().iterator(); index680.hasNext();) {
                    var connector = index680.next();
                    {
                      anySelected = true;
                      this.unselect$com_vzome_core_model_Manifestation(connector);
                    }
                  }

                  if (anySelected) {
                    this.redo();
                  }

                  return anySelected;
                }
              }, {
                key: "unselectStruts",
                value: function unselectStruts() {
                  var anySelected = false;

                  for (var index681 = this.getSelectedStruts().iterator(); index681.hasNext();) {
                    var strut = index681.next();
                    {
                      anySelected = true;
                      this.unselect$com_vzome_core_model_Manifestation(strut);
                    }
                  }

                  if (anySelected) {
                    this.redo();
                  }

                  return anySelected;
                }
              }, {
                key: "unselectPanels",
                value: function unselectPanels() {
                  var anySelected = false;

                  for (var index682 = this.getSelectedPanels().iterator(); index682.hasNext();) {
                    var panel = index682.next();
                    {
                      anySelected = true;
                      this.unselect$com_vzome_core_model_Manifestation(panel);
                    }
                  }

                  if (anySelected) {
                    this.redo();
                  }

                  return anySelected;
                }
              }], [{
                key: "logger_$LI$",
                value: function logger_$LI$() {
                  if (ChangeSelection.logger == null) ChangeSelection.logger = java.util.logging.Logger.getLogger("com.vzome.core.editor.ChangeSelection");
                  return ChangeSelection.logger;
                }
              }]);

              return ChangeSelection;
            }(com.vzome.core.editor.api.SideEffects);

            api.ChangeSelection = ChangeSelection;
            ChangeSelection["__class"] = "com.vzome.core.editor.api.ChangeSelection";

            (function (ChangeSelection) {
              var SelectManifestation =
              /*#__PURE__*/
              function () {
                function SelectManifestation(__parent, man, value) {
                  _classCallCheck(this, SelectManifestation);

                  this.__parent = __parent;
                  if (this.mMan === undefined) this.mMan = null;
                  if (this.mOn === undefined) this.mOn = false;
                  this.mMan = man;
                  this.mOn = value;
                  com.vzome.core.editor.api.ChangeSelection.logger_$LI$().finest("constructing SelectManifestation");
                }
                /**
                *
                */


                _createClass(SelectManifestation, [{
                  key: "redo",
                  value: function redo() {
                    if (this.__parent.groupingDoneInSelection) {
                      if (this.mOn) this.__parent.mSelection.selectWithGrouping(this.mMan);else this.__parent.mSelection.unselectWithGrouping(this.mMan);
                    } else if (this.mOn) this.__parent.mSelection.select(this.mMan);else this.__parent.mSelection.unselect(this.mMan);
                  }
                  /**
                  *
                  */

                }, {
                  key: "undo",
                  value: function undo() {
                    if (this.__parent.groupingDoneInSelection) {
                      if (this.mOn) this.__parent.mSelection.unselectWithGrouping(this.mMan);else this.__parent.mSelection.selectWithGrouping(this.mMan);
                    } else if (this.mOn) this.__parent.mSelection.unselect(this.mMan);else if (this.__parent.selectionEffects != null) {
                      this.__parent.selectionEffects.push(this);
                    } else this.__parent.mSelection.select(this.mMan);
                  }
                  /**
                  *
                  * @param {*} doc
                  * @return {*}
                  */

                }, {
                  key: "getXml",
                  value: function getXml(doc) {
                    var result = this.mOn ? doc.createElement("select") : doc.createElement("deselect");

                    if (this.mMan != null) {
                      var man = this.mMan.getXml(doc);
                      result.appendChild(man);
                    }

                    return result;
                  }
                }]);

                return SelectManifestation;
              }();

              ChangeSelection.SelectManifestation = SelectManifestation;
              SelectManifestation["__class"] = "com.vzome.core.editor.api.ChangeSelection.SelectManifestation";
              SelectManifestation["__interfaces"] = ["com.vzome.core.editor.api.SideEffects.SideEffect"];

              var RecordSelectedManifestation =
              /*#__PURE__*/
              function () {
                function RecordSelectedManifestation(__parent, man) {
                  _classCallCheck(this, RecordSelectedManifestation);

                  this.__parent = __parent;
                  if (this.mMan === undefined) this.mMan = null;
                  this.mMan = man;
                  com.vzome.core.editor.api.ChangeSelection.logger_$LI$().finest("constructing RecordSelectedManifestation");
                }
                /**
                *
                */


                _createClass(RecordSelectedManifestation, [{
                  key: "redo",
                  value: function redo() {
                    com.vzome.core.editor.api.ChangeSelection.logger_$LI$().finest("redoing RecordSelectedManifestation");
                  }
                  /**
                  *
                  */

                }, {
                  key: "undo",
                  value: function undo() {
                    com.vzome.core.editor.api.ChangeSelection.logger_$LI$().finest("undoing RecordSelectedManifestation");
                    if (this.__parent.selectionEffects == null) this.__parent.mSelection.select(this.mMan);else this.__parent.selectionEffects.push(this);
                  }
                  /**
                  *
                  * @param {*} doc
                  * @return {*}
                  */

                }, {
                  key: "getXml",
                  value: function getXml(doc) {
                    return doc.createElement("recordSelected");
                  }
                }]);

                return RecordSelectedManifestation;
              }();

              ChangeSelection.RecordSelectedManifestation = RecordSelectedManifestation;
              RecordSelectedManifestation["__class"] = "com.vzome.core.editor.api.ChangeSelection.RecordSelectedManifestation";
              RecordSelectedManifestation["__interfaces"] = ["com.vzome.core.editor.api.SideEffects.SideEffect"];
            })(ChangeSelection = api.ChangeSelection || (api.ChangeSelection = {}));
          })(editor.api || (editor.api = {}));
        })(core.editor || (core.editor = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (tools_3) {
          var TetrahedralToolFactory =
          /*#__PURE__*/
          function (_com$vzome$core$tools) {
            _inherits(TetrahedralToolFactory, _com$vzome$core$tools);

            var _super129 = _createSuper(TetrahedralToolFactory);

            function TetrahedralToolFactory(tools, symmetry) {
              _classCallCheck(this, TetrahedralToolFactory);

              return _super129.call(this, tools, symmetry, TetrahedralToolFactory.__com_vzome_core_tools_TetrahedralToolFactory_ID, TetrahedralToolFactory.__com_vzome_core_tools_TetrahedralToolFactory_LABEL, "icosahedral" === symmetry.getName() ? TetrahedralToolFactory.__com_vzome_core_tools_TetrahedralToolFactory_TOOLTIP1 : TetrahedralToolFactory.__com_vzome_core_tools_TetrahedralToolFactory_TOOLTIP2);
            }
            /**
            *
            * @param {string} id
            * @return {com.vzome.core.editor.Tool}
            */


            _createClass(TetrahedralToolFactory, [{
              key: "createToolInternal",
              value: function createToolInternal(id) {
                if (!function (str, searchString) {
                  var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                  return str.substr(position, searchString.length) === searchString;
                }(id, "tetrahedral")) id = "tetrahedral." + id;
                return new com.vzome.core.tools.SymmetryTool(id, this.getSymmetry(), this.getToolsModel());
              }
            }]);

            return TetrahedralToolFactory;
          }(com.vzome.core.tools.OctahedralToolFactory);

          TetrahedralToolFactory.__com_vzome_core_tools_TetrahedralToolFactory_ID = "tetrahedral";
          TetrahedralToolFactory.__com_vzome_core_tools_TetrahedralToolFactory_LABEL = "Create a tetrahedral symmetry tool";
          TetrahedralToolFactory.__com_vzome_core_tools_TetrahedralToolFactory_TOOLTIP1 = "<p>Each tool produces up to 11 copies of the input<br>selection, using the rotation symmetries of a<br>tetrahedron.  To create a tool, select a ball<br>that defines the center of symmetry, and a single<br>blue or green strut, defining one of five<br>possible orientations for the symmetry.<br><br>Combine with a point reflection tool to achieve<br>all 24 symmetries of the tetrahedron, including<br>reflections.<br></p>";
          TetrahedralToolFactory.__com_vzome_core_tools_TetrahedralToolFactory_TOOLTIP2 = "<p>Each tool produces up to 11 copies of the input<br>selection, using the rotation symmetries of a<br>tetrahedron.  To create a tool, select a ball<br>that defines the center of symmetry.<br><br>Combine with a point reflection tool to achieve<br>all 24 symmetries of the tetrahedron, including<br>reflections.<br></p>";
          tools_3.TetrahedralToolFactory = TetrahedralToolFactory;
          TetrahedralToolFactory["__class"] = "com.vzome.core.tools.TetrahedralToolFactory";
          TetrahedralToolFactory["__interfaces"] = ["com.vzome.core.editor.SelectionSummary.Listener", "com.vzome.api.Tool.Factory"];
        })(core.tools || (core.tools = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (commands) {
          var CommandVanOss600Cell =
          /*#__PURE__*/
          function (_com$vzome$core$comma16) {
            _inherits(CommandVanOss600Cell, _com$vzome$core$comma16);

            var _super130 = _createSuper(CommandVanOss600Cell);

            _createClass(CommandVanOss600Cell, [{
              key: "apply",

              /**
              *
              * @param {com.vzome.core.construction.ConstructionList} parameters
              * @param {com.vzome.core.commands.AttributeMap} attributes
              * @param {*} effects
              * @return {com.vzome.core.construction.ConstructionList}
              */
              value: function apply(parameters, attributes, effects) {
                try {
                  var input = this.constructor.getClassLoader().getResourceAsStream("com/vzome/core/commands/600cell.vef");
                  var out = new java.io.ByteArrayOutputStream();

                  var buf = function (s) {
                    var a = [];

                    while (s-- > 0) {
                      a.push(0);
                    }

                    return a;
                  }(1024);

                  var num;

                  while ((num = input.read(buf, 0, 1024)) > 0) {
                    out.write(buf, 0, num);
                  }

                  ;
                  var vefData = new String(out.toByteArray());
                  var result = new com.vzome.core.construction.ConstructionList();
                  var field = attributes.get(com.vzome.core.commands.CommandImportVEFData.FIELD_ATTR_NAME);
                  if (field == null) field = attributes.get(com.vzome.core.commands.Command.FIELD_ATTR_NAME);
                  new CommandVanOss600Cell.VefToModel(this, null, effects).parseVEF(vefData, field);
                  return result;
                } catch (exc) {
                  throw new com.vzome.core.commands.Command.Failure(exc);
                }
              }
            }]);

            function CommandVanOss600Cell() {
              _classCallCheck(this, CommandVanOss600Cell);

              return _super130.call(this);
            }

            return CommandVanOss600Cell;
          }(com.vzome.core.commands.CommandImportVEFData);

          commands.CommandVanOss600Cell = CommandVanOss600Cell;
          CommandVanOss600Cell["__class"] = "com.vzome.core.commands.CommandVanOss600Cell";
          CommandVanOss600Cell["__interfaces"] = ["com.vzome.core.commands.Command"];

          (function (CommandVanOss600Cell) {
            var VefToModel =
            /*#__PURE__*/
            function (_com$vzome$core$math$11) {
              _inherits(VefToModel, _com$vzome$core$math$11);

              var _super131 = _createSuper(VefToModel);

              function VefToModel(__parent, quaternion, effects) {
                var _this98;

                _classCallCheck(this, VefToModel);

                _this98 = _super131.call(this);
                _this98.__parent = __parent;
                if (_this98.mQuaternion === undefined) _this98.mQuaternion = null;
                if (_this98.mProjection === undefined) _this98.mProjection = null;
                if (_this98.mVertices === undefined) _this98.mVertices = null;
                if (_this98.mEffects === undefined) _this98.mEffects = null;
                if (_this98.mLocations === undefined) _this98.mLocations = null;
                _this98.mQuaternion = null;
                _this98.mEffects = effects;
                return _this98;
              }
              /**
              *
              * @param {number} numVertices
              */


              _createClass(VefToModel, [{
                key: "startVertices",
                value: function startVertices(numVertices) {
                  this.mVertices = function (s) {
                    var a = [];

                    while (s-- > 0) {
                      a.push(null);
                    }

                    return a;
                  }(numVertices);

                  this.mLocations = function (s) {
                    var a = [];

                    while (s-- > 0) {
                      a.push(null);
                    }

                    return a;
                  }(numVertices);

                  this.mProjection = null;
                }
                /**
                *
                * @param {number} index
                * @param {com.vzome.core.algebra.AlgebraicVector} location
                */

              }, {
                key: "addVertex",
                value: function addVertex(index, location) {
                  this.mLocations[index] = location;
                }
                /**
                *
                */

              }, {
                key: "endVertices",
                value: function endVertices() {
                  var field = this.getField();
                  var half = field['createRational$long$long'](1, 2);
                  var quarter = field['createRational$long$long'](1, 4);
                  var centroid = this.mLocations[0].plus(this.mLocations[48]).plus(this.mLocations[50]).plus(this.mLocations[64]).scale(quarter);
                  var edgeCenter = this.mLocations[0].plus(this.mLocations[48]).scale(half);
                  var vertex = this.mLocations[50];
                  var edgeToVertex = vertex.minus(edgeCenter);
                  var edgeToCenter = centroid.minus(edgeCenter);
                  var symmCenter1 = edgeCenter.plus(edgeToCenter.scale(field['createAlgebraicNumber$int$int$int$int'](0, 3, 5, 0)));
                  var symmCenter2 = edgeCenter.plus(edgeToVertex.scale(field['createAlgebraicNumber$int$int$int$int'](0, 2, 5, 0)));
                  var direction = symmCenter2.minus(symmCenter1);
                  var target = symmCenter1.plus(direction.scale(field['createAlgebraicNumber$int$int$int$int'](0, 1, 1, 0)));
                  this.mProjection = new com.vzome.core.math.QuaternionProjection(field, null, target);
                  var power5 = field['createPower$int'](5);

                  for (var i = 0; i < this.mLocations.length; i++) {
                    {
                      var location = this.mLocations[i].scale(power5);
                      location = this.mProjection.projectImage(location, this.wFirst());
                      this.mVertices[i] = new com.vzome.core.construction.FreePoint(location);
                      this.mEffects.constructionAdded(this.mVertices[i]);
                    }
                  }
                }
                /**
                *
                * @param {number} index
                * @param {number} v1
                * @param {number} v2
                */

              }, {
                key: "addEdge",
                value: function addEdge(index, v1, v2) {
                  var p1 = this.mVertices[v1];
                  var p2 = this.mVertices[v2];

                  if (p1 == null || p2 == null) {
                    console.info("skipping " + v1 + " " + v2);
                    return;
                  }

                  var seg = new com.vzome.core.construction.SegmentJoiningPoints(p1, p2);
                  this.mEffects.constructionAdded(seg);
                }
                /**
                *
                * @param {number} numEdges
                */

              }, {
                key: "startEdges",
                value: function startEdges(numEdges) {}
                /**
                *
                * @param {number} numFaces
                */

              }, {
                key: "startFaces",
                value: function startFaces(numFaces) {}
                /**
                *
                * @param {number} index
                * @param {Array} verts
                */

              }, {
                key: "addFace",
                value: function addFace(index, verts) {}
                /**
                *
                * @param {number} index
                * @param {number} vertex
                */

              }, {
                key: "addBall",
                value: function addBall(index, vertex) {}
                /**
                *
                * @param {number} numVertices
                */

              }, {
                key: "startBalls",
                value: function startBalls(numVertices) {}
              }]);

              return VefToModel;
            }(com.vzome.core.math.VefParser);

            CommandVanOss600Cell.VefToModel = VefToModel;
            VefToModel["__class"] = "com.vzome.core.commands.CommandVanOss600Cell.VefToModel";
          })(CommandVanOss600Cell = commands.CommandVanOss600Cell || (commands.CommandVanOss600Cell = {}));
        })(core.commands || (core.commands = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (commands) {
          /**
          * @author Scott Vorthmann
          * @param {*} field
          * @param {com.vzome.core.math.symmetry.QuaternionicSymmetry} qsymm
          * @param {number} index
          * @class
          * @extends com.vzome.core.commands.CommandTransform
          */
          var CommandUniformH4Polytope =
          /*#__PURE__*/
          function (_com$vzome$core$comma17) {
            _inherits(CommandUniformH4Polytope, _com$vzome$core$comma17);

            var _super132 = _createSuper(CommandUniformH4Polytope);

            function CommandUniformH4Polytope(field, qsymm, index) {
              var _this99;

              _classCallCheck(this, CommandUniformH4Polytope);

              if ((field != null && (field["__interfaces"] != null && field["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicField") >= 0 || field.constructor != null && field.constructor["__interfaces"] != null && field.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicField") >= 0) || field === null) && (qsymm != null && qsymm instanceof com.vzome.core.math.symmetry.QuaternionicSymmetry || qsymm === null) && (typeof index === 'number' || index === null)) {
                _this99 = _super132.call(this);
                if (_this99.mRoots === undefined) _this99.mRoots = null;
                if (_this99.field === undefined) _this99.field = null;
                if (_this99.symm === undefined) _this99.symm = null;
                _this99.h4Symms = new java.util.HashMap();
                _this99.mPolytopeIndex = -1;
                _this99.quaternionVector = null;
                if (_this99.mRoots === undefined) _this99.mRoots = null;
                if (_this99.field === undefined) _this99.field = null;
                if (_this99.symm === undefined) _this99.symm = null;

                (function () {
                  _this99.mPolytopeIndex = index;
                  _this99.field = field;
                  _this99.symm = new CommandUniformH4Polytope.H4Symmetry(field);
                  _this99.mRoots = qsymm.getRoots();
                })();
              } else if (field === undefined && qsymm === undefined && index === undefined) {
                _this99 = _super132.call(this);
                if (_this99.mRoots === undefined) _this99.mRoots = null;
                if (_this99.field === undefined) _this99.field = null;
                if (_this99.symm === undefined) _this99.symm = null;
                _this99.h4Symms = new java.util.HashMap();
                _this99.mPolytopeIndex = -1;
                _this99.quaternionVector = null;
                if (_this99.mRoots === undefined) _this99.mRoots = null;
                if (_this99.field === undefined) _this99.field = null;
                if (_this99.symm === undefined) _this99.symm = null;
              } else throw new Error('invalid overload');

              return _possibleConstructorReturn(_this99);
            }
            /**
            *
            * @param {com.vzome.core.commands.AttributeMap} attributes
            * @param {com.vzome.core.commands.XmlSaveFormat} format
            */


            _createClass(CommandUniformH4Polytope, [{
              key: "setFixedAttributes",
              value: function setFixedAttributes(attributes, format) {
                _get(_getPrototypeOf(CommandUniformH4Polytope.prototype), "setFixedAttributes", this).call(this, attributes, format);

                this.field = format.getField();
                this.symm = this.h4Symms.get(this.field);

                if (this.symm == null) {
                  this.symm = new CommandUniformH4Polytope.H4Symmetry(this.field);
                  this.h4Symms.put(this.field, this.symm);
                }

                this.mRoots = format.getQuaternionicSymmetry("H_4").getRoots();
              }
            }, {
              key: "setQuaternion",

              /**
              * Only called when migrating a 2.0 model file.
              * @param {com.vzome.core.algebra.AlgebraicVector} offset
              */
              value: function setQuaternion(offset) {
                this.quaternionVector = offset;
              }
              /**
              *
              * @param {*} xml
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              * @return {com.vzome.core.commands.AttributeMap}
              */

            }, {
              key: "setXml",
              value: function setXml(xml, format) {
                var attrs = _get(_getPrototypeOf(CommandUniformH4Polytope.prototype), "setXml", this).call(this, xml, format);

                this.quaternionVector = format.parseRationalVector(xml, "quaternion");
                return attrs;
              }
              /**
              *
              * @param {*} result
              * @param {com.vzome.core.commands.AttributeMap} attributes
              */

            }, {
              key: "getXml",
              value: function getXml(result, attributes) {
                if (this.quaternionVector != null) com.vzome.xml.DomUtils.addAttribute(result, "quaternion", this.quaternionVector.toParsableString());

                _get(_getPrototypeOf(CommandUniformH4Polytope.prototype), "getXml", this).call(this, result, attributes);
              }
              /**
              *
              * @return {Array}
              */

            }, {
              key: "getAttributeSignature",
              value: function getAttributeSignature() {
                return com.vzome.core.commands.CommandTransform.GROUP_ATTR_SIGNATURE_$LI$();
              }
              /**
              *
              * @param {string} attrName
              * @return {boolean}
              */

            }, {
              key: "attributeIs3D",
              value: function attributeIs3D(attrName) {
                if (
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }("symmetry.axis.segment", attrName)) return false;else return true;
              }
              /**
              *
              * @param {com.vzome.core.construction.ConstructionList} parameters
              * @param {com.vzome.core.commands.AttributeMap} attributes
              * @param {*} effects
              * @return {com.vzome.core.construction.ConstructionList}
              */

            }, {
              key: "apply",
              value: function apply(parameters, attributes, effects) {
                var SCALE_DOWN_5 = this.field['createPower$int'](-5);
                var proj = new com.vzome.core.math.Projection.Default(this.field);
                var leftQuat = null;
                var rightQuat = null;

                if (parameters.size() === 0) {
                  rightQuat = this.quaternionVector;
                  var symmAxis = attributes.get(com.vzome.core.commands.CommandTransform.SYMMETRY_AXIS_ATTR_NAME);
                  if (rightQuat == null) rightQuat = symmAxis == null ? null : symmAxis.getOffset();
                  if (rightQuat != null) rightQuat = rightQuat.scale(SCALE_DOWN_5);
                } else {
                  var numSegs = 0;

                  for (var index683 = parameters.iterator(); index683.hasNext();) {
                    var cons = index683.next();
                    {
                      if (cons != null && cons instanceof com.vzome.core.construction.Segment) {
                        var seg = cons;
                        if (++numSegs === 1) rightQuat = seg.getOffset().scale(SCALE_DOWN_5);else if (numSegs === 2) leftQuat = seg.getOffset().scale(SCALE_DOWN_5);else throw new com.vzome.core.commands.Command.Failure("Too many struts to specify quaternion multiplication.");
                      }
                    }
                  }
                }

                if (rightQuat != null) proj = new com.vzome.core.math.QuaternionProjection(this.field, leftQuat, rightQuat);

                if (this.mPolytopeIndex < 0) {
                  var indexObj = attributes.get(CommandUniformH4Polytope.POLYTOPE_INDEX_ATTR_NAME);
                  this.mPolytopeIndex = indexObj;
                } else attributes.put(CommandUniformH4Polytope.POLYTOPE_INDEX_ATTR_NAME, this.mPolytopeIndex);

                this.generate(this.mPolytopeIndex, this.mPolytopeIndex, null, new CommandUniformH4Polytope.ConstructionChangesAdapter(effects, proj, this.field['createPower$int'](5)));
                return new com.vzome.core.construction.ConstructionList();
              }
            }, {
              key: "generate",
              value: function generate(index, renderEdges, edgeScales, listener) {
                var reflections = [null, null, null, null];
                var prototype = this.symm.getPrototype(index);

                if (edgeScales != null) {
                  prototype = this.field.origin(4);

                  for (var b = 0; b < 4; b++) {
                    {
                      var mask = 1 << b;
                      var test = index & mask;

                      if (test !== 0) {
                        var contribution = this.symm.getCoRoot(b).scale(edgeScales[b]);
                        prototype = prototype.plus(contribution);
                      }
                    }
                  }
                }

                for (var mirror = 0; mirror < 4; mirror++) {
                  if ((renderEdges & 1 << mirror) !== 0) reflections[mirror] = this.symm.reflect(mirror, prototype);
                }

                for (var index684 = 0; index684 < this.mRoots.length; index684++) {
                  var outerRoot = this.mRoots[index684];
                  {
                    for (var index685 = 0; index685 < this.mRoots.length; index685++) {
                      var innerRoot = this.mRoots[index685];
                      {
                        var vertex = outerRoot.rightMultiply(prototype);
                        vertex = innerRoot.leftMultiply(vertex);
                        var p1 = listener.addVertex(vertex);

                        for (var _mirror = 0; _mirror < 4; _mirror++) {
                          {
                            if (reflections[_mirror] != null) {
                              var other = outerRoot.rightMultiply(reflections[_mirror]);
                              other = innerRoot.leftMultiply(other);

                              if (!other.equals(vertex)) {
                                var p2 = listener.addVertex(other);
                                listener.addEdge(p1, p2);
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }], [{
              key: "logger_$LI$",
              value: function logger_$LI$() {
                if (CommandUniformH4Polytope.logger == null) CommandUniformH4Polytope.logger = java.util.logging.Logger.getLogger("com.vzome.core.commands.h4polytope");
                return CommandUniformH4Polytope.logger;
              }
            }]);

            return CommandUniformH4Polytope;
          }(com.vzome.core.commands.CommandTransform);

          CommandUniformH4Polytope.POLYTOPE_INDEX_ATTR_NAME = "polytope.index";
          commands.CommandUniformH4Polytope = CommandUniformH4Polytope;
          CommandUniformH4Polytope["__class"] = "com.vzome.core.commands.CommandUniformH4Polytope";
          CommandUniformH4Polytope["__interfaces"] = ["com.vzome.core.commands.Command"];

          (function (CommandUniformH4Polytope) {
            var H4Symmetry =
            /*#__PURE__*/
            function () {
              function H4Symmetry(field) {
                _classCallCheck(this, H4Symmetry);

                this.mPrototypes = function (s) {
                  var a = [];

                  while (s-- > 0) {
                    a.push(null);
                  }

                  return a;
                }(15);

                this.mMirrors = [null, null, null, null];
                this.coRoots = [null, null, null, null];
                var ONE = field['createRational$long'](1);
                var NEG_ONE = field['createRational$long'](-1);
                var TWO = field['createRational$long'](2);
                var A = field['createAlgebraicNumber$int$int$int$int'](1, -1, 1, 0);
                var B = field['createAlgebraicNumber$int$int$int$int'](0, 1, 1, 0);
                var temp = field.origin(4);
                temp.setComponent(1, A['dividedBy$com_vzome_core_algebra_AlgebraicNumber'](TWO));
                temp.setComponent(2, ONE['dividedBy$com_vzome_core_algebra_AlgebraicNumber'](TWO));
                temp.setComponent(3, B['dividedBy$com_vzome_core_algebra_AlgebraicNumber'](TWO));
                this.mMirrors[3] = new com.vzome.core.algebra.Quaternion(field, temp);
                temp = field.origin(4);
                temp.setComponent(3, NEG_ONE);
                this.mMirrors[2] = new com.vzome.core.algebra.Quaternion(field, temp);
                temp = field.origin(4);
                temp.setComponent(1, ONE['dividedBy$com_vzome_core_algebra_AlgebraicNumber'](TWO));
                temp.setComponent(2, NEG_ONE['dividedBy$com_vzome_core_algebra_AlgebraicNumber'](TWO));
                temp.setComponent(3, ONE['dividedBy$com_vzome_core_algebra_AlgebraicNumber'](TWO));
                temp.setComponent(0, NEG_ONE['dividedBy$com_vzome_core_algebra_AlgebraicNumber'](TWO));
                this.mMirrors[1] = new com.vzome.core.algebra.Quaternion(field, temp);
                temp = field.origin(4);
                temp.setComponent(0, ONE);
                this.mMirrors[0] = new com.vzome.core.algebra.Quaternion(field, temp);
                var B2 = field['createAlgebraicNumber$int$int$int$int'](0, 2, 1, 0);
                this.coRoots[3] = field.origin(4);
                this.coRoots[3].setComponent(1, B2);
                this.coRoots[3].setComponent(2, B2);
                this.coRoots[2] = field.origin(4);
                this.coRoots[2].setComponent(1, B2['plus$com_vzome_core_algebra_AlgebraicNumber'](ONE));
                this.coRoots[2].setComponent(2, B['plus$com_vzome_core_algebra_AlgebraicNumber'](TWO));
                this.coRoots[2].setComponent(3, A);
                this.coRoots[1] = field.origin(4);
                this.coRoots[1].setComponent(1, B2);
                this.coRoots[1].setComponent(2, TWO);
                this.coRoots[0] = field.origin(4);
                this.coRoots[0].setComponent(1, B);
                this.coRoots[0].setComponent(2, ONE);
                this.coRoots[0].setComponent(0, A.negate());
                if (com.vzome.core.commands.CommandUniformH4Polytope.logger_$LI$().isLoggable(java.util.logging.Level.FINE)) for (var i = 0; i < 4; i++) {
                  {
                    var buf = new java.lang.StringBuffer();
                    this.coRoots[i].getVectorExpression$java_lang_StringBuffer$int(buf, com.vzome.core.algebra.AlgebraicField.DEFAULT_FORMAT);
                    com.vzome.core.commands.CommandUniformH4Polytope.logger_$LI$().fine(buf.toString());
                  }
                }
                var origin = field.origin(4);

                for (var index = 1; index <= 15; index++) {
                  {
                    var vertex = origin;

                    for (var b = 0; b < 4; b++) {
                      {
                        var mask = 1 << b;
                        var test = index & mask;

                        if (test !== 0) {
                          vertex = vertex.plus(this.coRoots[b]);
                        }
                      }
                    }

                    this.mPrototypes[index - 1] = vertex;
                  }
                }
              }

              _createClass(H4Symmetry, [{
                key: "getPrototype",
                value: function getPrototype(index) {
                  return this.mPrototypes[index - 1];
                }
              }, {
                key: "reflect",
                value: function reflect(mirror, prototype) {
                  return this.mMirrors[mirror].reflect(prototype);
                }
              }, {
                key: "getCoRoot",
                value: function getCoRoot(i) {
                  return this.coRoots[i];
                }
              }]);

              return H4Symmetry;
            }();

            CommandUniformH4Polytope.H4Symmetry = H4Symmetry;
            H4Symmetry["__class"] = "com.vzome.core.commands.CommandUniformH4Polytope.H4Symmetry";

            var ConstructionChangesAdapter =
            /*#__PURE__*/
            function () {
              function ConstructionChangesAdapter(effects, proj, scale) {
                _classCallCheck(this, ConstructionChangesAdapter);

                this.vertices = new java.util.HashMap();
                if (this.effects === undefined) this.effects = null;
                if (this.proj === undefined) this.proj = null;
                if (this.scale === undefined) this.scale = null;
                this.edges = new java.util.HashSet();
                this.effects = effects;
                this.proj = proj;
                this.scale = scale;
              }
              /**
              *
              * @param {*} v1
              * @param {*} v2
              * @return {*}
              */


              _createClass(ConstructionChangesAdapter, [{
                key: "addEdge",
                value: function addEdge(v1, v2) {
                  var p1 = v1;
                  var p2 = v2;
                  var edge = new CommandUniformH4Polytope.Edge(p1.getIndex(), p2.getIndex());
                  if (this.edges.contains(edge)) return null;
                  this.edges.add(edge);
                  this.effects.constructionAdded(new com.vzome.core.construction.SegmentJoiningPoints(p1, p2));
                  return edge;
                }
                /**
                *
                * @param {Array} vertices
                * @return {*}
                */

              }, {
                key: "addFace",
                value: function addFace(vertices) {
                  return null;
                }
                /**
                *
                * @param {com.vzome.core.algebra.AlgebraicVector} vertex
                * @return {*}
                */

              }, {
                key: "addVertex",
                value: function addVertex(vertex) {
                  var p = this.vertices.get(vertex);

                  if (p == null) {
                    var projected = vertex;
                    com.vzome.core.commands.CommandUniformH4Polytope.logger_$LI$().finer("before   : ");
                    this.printGoldenVector(projected);
                    if (this.proj != null) projected = this.proj.projectImage(projected, true);
                    com.vzome.core.commands.CommandUniformH4Polytope.logger_$LI$().finer("projected: ");
                    this.printGoldenVector(projected);
                    projected = projected.scale(this.scale);
                    com.vzome.core.commands.CommandUniformH4Polytope.logger_$LI$().finer("scaled   : ");
                    this.printGoldenVector(projected);
                    p = new com.vzome.core.construction.FreePoint(projected);
                    p.setIndex(this.vertices.size());
                    this.effects.constructionAdded(p);
                    this.vertices.put(vertex, p);
                  }

                  return p;
                }
              }, {
                key: "printGoldenVector",
                value: function printGoldenVector(gv) {
                  if (com.vzome.core.commands.CommandUniformH4Polytope.logger_$LI$().isLoggable(java.util.logging.Level.FINER)) {
                    var buf = new java.lang.StringBuffer();
                    gv.getVectorExpression$java_lang_StringBuffer$int(buf, com.vzome.core.algebra.AlgebraicField.DEFAULT_FORMAT);
                    com.vzome.core.commands.CommandUniformH4Polytope.logger_$LI$().finer(buf.toString());
                  }
                }
              }]);

              return ConstructionChangesAdapter;
            }();

            CommandUniformH4Polytope.ConstructionChangesAdapter = ConstructionChangesAdapter;
            ConstructionChangesAdapter["__class"] = "com.vzome.core.commands.CommandUniformH4Polytope.ConstructionChangesAdapter";
            ConstructionChangesAdapter["__interfaces"] = ["com.vzome.core.math.symmetry.WythoffConstruction.Listener"];

            var Edge =
            /*#__PURE__*/
            function () {
              function Edge(p1, p2) {
                _classCallCheck(this, Edge);

                if (this.p1 === undefined) this.p1 = 0;
                if (this.p2 === undefined) this.p2 = 0;
                this.p1 = p1;
                this.p2 = p2;
              }
              /**
              *
              * @param {*} obj
              * @return {boolean}
              */


              _createClass(Edge, [{
                key: "equals",
                value: function equals(obj) {
                  if (
                  /* equals */
                  function (o1, o2) {
                    if (o1 && o1.equals) {
                      return o1.equals(o2);
                    } else {
                      return o1 === o2;
                    }
                  }(this, obj)) return true;
                  if (!(obj != null && obj instanceof com.vzome.core.commands.CommandUniformH4Polytope.Edge)) return false;
                  var that = obj;
                  if (this.p1 === that.p1 && this.p2 === that.p2) return true;
                  if (this.p1 === that.p2 && this.p2 === that.p1) return true;
                  return false;
                }
                /**
                *
                * @return {number}
                */

              }, {
                key: "hashCode",
                value: function hashCode() {
                  return this.p1 ^ this.p2;
                }
              }]);

              return Edge;
            }();

            CommandUniformH4Polytope.Edge = Edge;
            Edge["__class"] = "com.vzome.core.commands.CommandUniformH4Polytope.Edge";
          })(CommandUniformH4Polytope = commands.CommandUniformH4Polytope || (commands.CommandUniformH4Polytope = {}));
        })(core.commands || (core.commands = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (commands) {
          /**
          * @author Scott Vorthmann
          * @param {*} symmetry
          * @class
          * @extends com.vzome.core.commands.CommandTransform
          */
          var CommandSymmetry =
          /*#__PURE__*/
          function (_com$vzome$core$comma18) {
            _inherits(CommandSymmetry, _com$vzome$core$comma18);

            var _super133 = _createSuper(CommandSymmetry);

            function CommandSymmetry(symmetry) {
              var _this100;

              _classCallCheck(this, CommandSymmetry);

              if (symmetry != null && (symmetry["__interfaces"] != null && symmetry["__interfaces"].indexOf("com.vzome.core.math.symmetry.Symmetry") >= 0 || symmetry.constructor != null && symmetry.constructor["__interfaces"] != null && symmetry.constructor["__interfaces"].indexOf("com.vzome.core.math.symmetry.Symmetry") >= 0) || symmetry === null) {
                _this100 = _super133.call(this);
                if (_this100.mSymmetry === undefined) _this100.mSymmetry = null;
                if (_this100.mSymmetry === undefined) _this100.mSymmetry = null;

                (function () {
                  _this100.mSymmetry = symmetry;
                })();
              } else if (symmetry === undefined) {
                {
                  var _symmetry = null;
                  _this100 = _super133.call(this);
                  if (_this100.mSymmetry === undefined) _this100.mSymmetry = null;
                  if (_this100.mSymmetry === undefined) _this100.mSymmetry = null;

                  (function () {
                    _this100.mSymmetry = _symmetry;
                  })();
                }
              } else throw new Error('invalid overload');

              return _possibleConstructorReturn(_this100);
            }
            /**
            *
            * @return {Array}
            */


            _createClass(CommandSymmetry, [{
              key: "getAttributeSignature",
              value: function getAttributeSignature() {
                return com.vzome.core.commands.CommandTransform.GROUP_ATTR_SIGNATURE_$LI$();
              }
            }, {
              key: "setSymmetry",
              value: function setSymmetry(attributes) {
                if (this.mSymmetry == null) this.mSymmetry = attributes.get(com.vzome.core.commands.CommandTransform.SYMMETRY_GROUP_ATTR_NAME);else if (!attributes.containsKey(com.vzome.core.commands.CommandTransform.SYMMETRY_GROUP_ATTR_NAME)) attributes.put(com.vzome.core.commands.CommandTransform.SYMMETRY_GROUP_ATTR_NAME, this.mSymmetry);
                if (this.mSymmetry == null) throw new java.lang.IllegalStateException("null symmetry no longer supported");
                var center = attributes.get(com.vzome.core.commands.CommandTransform.SYMMETRY_CENTER_ATTR_NAME);
                return center;
              }
              /**
              *
              * @param {com.vzome.core.commands.AttributeMap} attributes
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              */

            }, {
              key: "setFixedAttributes",
              value: function setFixedAttributes(attributes, format) {
                if (!attributes.containsKey(com.vzome.core.commands.CommandTransform.SYMMETRY_GROUP_ATTR_NAME)) {
                  var icosahedralSymmetry = format.parseSymmetry("icosahedral");
                  attributes.put(com.vzome.core.commands.CommandTransform.SYMMETRY_GROUP_ATTR_NAME, icosahedralSymmetry);
                }

                _get(_getPrototypeOf(CommandSymmetry.prototype), "setFixedAttributes", this).call(this, attributes, format);
              }
              /**
              *
              * @param {com.vzome.core.construction.ConstructionList} parameters
              * @param {com.vzome.core.commands.AttributeMap} attributes
              * @param {*} effects
              * @return {com.vzome.core.construction.ConstructionList}
              */

            }, {
              key: "apply",
              value: function apply(parameters, attributes, effects) {
                var center = this.setSymmetry(attributes);
                var params = parameters.getConstructions();
                var output = new com.vzome.core.construction.ConstructionList();

                for (var index686 = 0; index686 < params.length; index686++) {
                  var param = params[index686];
                  {
                    output.addConstruction(param);
                  }
                }

                for (var i = 1; i < this.mSymmetry.getChiralOrder(); i++) {
                  {
                    var transform = new com.vzome.core.construction.SymmetryTransformation(this.mSymmetry, i, center);
                    output.addAll(this.transform(params, transform, effects));
                  }
                }

                return output;
              }
            }]);

            return CommandSymmetry;
          }(com.vzome.core.commands.CommandTransform);

          commands.CommandSymmetry = CommandSymmetry;
          CommandSymmetry["__class"] = "com.vzome.core.commands.CommandSymmetry";
          CommandSymmetry["__interfaces"] = ["com.vzome.core.commands.Command"];
        })(core.commands || (core.commands = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (commands) {
          /**
          * @author Scott Vorthmann
          * @param {com.vzome.core.math.symmetry.QuaternionicSymmetry} left
          * @param {com.vzome.core.math.symmetry.QuaternionicSymmetry} right
          * @class
          * @extends com.vzome.core.commands.CommandTransform
          */
          var CommandQuaternionSymmetry =
          /*#__PURE__*/
          function (_com$vzome$core$comma19) {
            _inherits(CommandQuaternionSymmetry, _com$vzome$core$comma19);

            var _super134 = _createSuper(CommandQuaternionSymmetry);

            function CommandQuaternionSymmetry(left, right) {
              var _this101;

              _classCallCheck(this, CommandQuaternionSymmetry);

              if ((left != null && left instanceof com.vzome.core.math.symmetry.QuaternionicSymmetry || left === null) && (right != null && right instanceof com.vzome.core.math.symmetry.QuaternionicSymmetry || right === null)) {
                _this101 = _super134.call(this);
                if (_this101.mLeft === undefined) _this101.mLeft = null;
                if (_this101.mRight === undefined) _this101.mRight = null;
                if (_this101.mLeft === undefined) _this101.mLeft = null;
                if (_this101.mRight === undefined) _this101.mRight = null;

                (function () {
                  _this101.mLeft = left;
                  _this101.mRight = right;
                })();
              } else if (left === undefined && right === undefined) {
                _this101 = _super134.call(this);
                if (_this101.mLeft === undefined) _this101.mLeft = null;
                if (_this101.mRight === undefined) _this101.mRight = null;
                if (_this101.mLeft === undefined) _this101.mLeft = null;
                if (_this101.mRight === undefined) _this101.mRight = null;
              } else throw new Error('invalid overload');

              return _possibleConstructorReturn(_this101);
            }
            /**
            *
            * @param {com.vzome.core.commands.AttributeMap} attributes
            * @param {com.vzome.core.commands.XmlSaveFormat} format
            */


            _createClass(CommandQuaternionSymmetry, [{
              key: "setFixedAttributes",
              value: function setFixedAttributes(attributes, format) {
                _get(_getPrototypeOf(CommandQuaternionSymmetry.prototype), "setFixedAttributes", this).call(this, attributes, format);

                if (!attributes.containsKey(CommandQuaternionSymmetry.LEFT_SYMMETRY_GROUP_ATTR_NAME_$LI$())) {
                  this.mLeft = format.getQuaternionicSymmetry("H_4");
                  attributes.put(CommandQuaternionSymmetry.LEFT_SYMMETRY_GROUP_ATTR_NAME_$LI$(), this.mLeft);
                }

                if (!attributes.containsKey(CommandQuaternionSymmetry.RIGHT_SYMMETRY_GROUP_ATTR_NAME)) {
                  this.mRight = format.getQuaternionicSymmetry("H_4");
                  attributes.put(CommandQuaternionSymmetry.RIGHT_SYMMETRY_GROUP_ATTR_NAME, this.mRight);
                }
              }
            }, {
              key: "getAttributeSignature",

              /**
              *
              * @return {Array}
              */
              value: function getAttributeSignature() {
                return com.vzome.core.commands.CommandTransform.GROUP_ATTR_SIGNATURE_$LI$();
              }
              /**
              *
              * @param {com.vzome.core.construction.ConstructionList} parameters
              * @param {com.vzome.core.commands.AttributeMap} attributes
              * @param {*} effects
              * @return {com.vzome.core.construction.ConstructionList}
              */

            }, {
              key: "apply",
              value: function apply(parameters, attributes, effects) {
                if (this.mLeft == null) this.mLeft = attributes.get(CommandQuaternionSymmetry.LEFT_SYMMETRY_GROUP_ATTR_NAME_$LI$());else if (!attributes.containsKey(CommandQuaternionSymmetry.LEFT_SYMMETRY_GROUP_ATTR_NAME_$LI$())) attributes.put(CommandQuaternionSymmetry.LEFT_SYMMETRY_GROUP_ATTR_NAME_$LI$(), this.mLeft);
                if (this.mRight == null) this.mRight = attributes.get(CommandQuaternionSymmetry.RIGHT_SYMMETRY_GROUP_ATTR_NAME);else if (!attributes.containsKey(CommandQuaternionSymmetry.RIGHT_SYMMETRY_GROUP_ATTR_NAME)) attributes.put(CommandQuaternionSymmetry.RIGHT_SYMMETRY_GROUP_ATTR_NAME, this.mRight);
                var leftRoots = this.mLeft.getRoots();
                var rightRoots = this.mRight.getRoots();
                var params = parameters.getConstructions();
                var output = new com.vzome.core.construction.ConstructionList();

                for (var index687 = 0; index687 < params.length; index687++) {
                  var param = params[index687];
                  {
                    output.addConstruction(param);
                  }
                }

                for (var index688 = 0; index688 < leftRoots.length; index688++) {
                  var leftRoot = leftRoots[index688];
                  {
                    for (var index689 = 0; index689 < rightRoots.length; index689++) {
                      var rightRoot = rightRoots[index689];
                      {
                        for (var index690 = 0; index690 < params.length; index690++) {
                          var _param = params[index690];
                          {
                            var result = null;

                            if (_param != null && _param instanceof com.vzome.core.construction.Point) {
                              result = new com.vzome.core.construction.PointRotated4D(leftRoot, rightRoot, _param);
                            } else if (_param != null && _param instanceof com.vzome.core.construction.Segment) {
                              result = new com.vzome.core.construction.SegmentRotated4D(leftRoot, rightRoot, _param);
                            } else if (_param != null && _param instanceof com.vzome.core.construction.Polygon) {
                              result = new com.vzome.core.construction.PolygonRotated4D(leftRoot, rightRoot, _param);
                            } else ;

                            if (result == null) continue;
                            effects.constructionAdded(result);
                            output.addConstruction(result);
                          }
                        }
                      }
                    }
                  }
                }

                return output;
              }
            }], [{
              key: "LEFT_SYMMETRY_GROUP_ATTR_NAME_$LI$",
              value: function LEFT_SYMMETRY_GROUP_ATTR_NAME_$LI$() {
                if (CommandQuaternionSymmetry.LEFT_SYMMETRY_GROUP_ATTR_NAME == null) CommandQuaternionSymmetry.LEFT_SYMMETRY_GROUP_ATTR_NAME = com.vzome.core.commands.CommandTransform.SYMMETRY_GROUP_ATTR_NAME;
                return CommandQuaternionSymmetry.LEFT_SYMMETRY_GROUP_ATTR_NAME;
              }
            }]);

            return CommandQuaternionSymmetry;
          }(com.vzome.core.commands.CommandTransform);

          CommandQuaternionSymmetry.RIGHT_SYMMETRY_GROUP_ATTR_NAME = "right.symmetry.group";
          commands.CommandQuaternionSymmetry = CommandQuaternionSymmetry;
          CommandQuaternionSymmetry["__class"] = "com.vzome.core.commands.CommandQuaternionSymmetry";
          CommandQuaternionSymmetry["__interfaces"] = ["com.vzome.core.commands.Command"];
        })(core.commands || (core.commands = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (commands) {
          /**
          * @author Scott Vorthmann
          * @class
          * @extends com.vzome.core.commands.CommandTransform
          */
          var CommandTranslate =
          /*#__PURE__*/
          function (_com$vzome$core$comma20) {
            _inherits(CommandTranslate, _com$vzome$core$comma20);

            var _super135 = _createSuper(CommandTranslate);

            _createClass(CommandTranslate, [{
              key: "apply",

              /**
              *
              * @param {com.vzome.core.construction.ConstructionList} parameters
              * @param {com.vzome.core.commands.AttributeMap} attributes
              * @param {*} effects
              * @return {com.vzome.core.construction.ConstructionList}
              */
              value: function apply(parameters, attributes, effects) {
                var norm = attributes.get(com.vzome.core.commands.CommandTransform.SYMMETRY_AXIS_ATTR_NAME);

                if (norm == null) {
                  throw new com.vzome.core.commands.Command.Failure("no symmetry axis provided");
                }

                var params = parameters.getConstructions();
                var field = norm.getField();
                var offset = field.projectTo3d(norm.getOffset(), true);
                var transform = new com.vzome.core.construction.Translation(offset);
                return this.transform(params, transform, effects);
              }
            }]);

            function CommandTranslate() {
              _classCallCheck(this, CommandTranslate);

              return _super135.call(this);
            }

            return CommandTranslate;
          }(com.vzome.core.commands.CommandTransform);

          commands.CommandTranslate = CommandTranslate;
          CommandTranslate["__class"] = "com.vzome.core.commands.CommandTranslate";
          CommandTranslate["__interfaces"] = ["com.vzome.core.commands.Command"];
        })(core.commands || (core.commands = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (commands) {
          /**
          * @author Scott Vorthmann
          * @class
          * @extends com.vzome.core.commands.CommandTransform
          */
          var CommandCentralSymmetry =
          /*#__PURE__*/
          function (_com$vzome$core$comma21) {
            _inherits(CommandCentralSymmetry, _com$vzome$core$comma21);

            var _super136 = _createSuper(CommandCentralSymmetry);

            _createClass(CommandCentralSymmetry, [{
              key: "getAttributeSignature",

              /**
              *
              * @return {Array}
              */
              value: function getAttributeSignature() {
                return com.vzome.core.commands.CommandTransform.ATTR_SIGNATURE_$LI$();
              }
              /**
              *
              * @param {com.vzome.core.construction.ConstructionList} parameters
              * @param {com.vzome.core.commands.AttributeMap} attributes
              * @param {*} effects
              * @return {com.vzome.core.construction.ConstructionList}
              */

            }, {
              key: "apply",
              value: function apply(parameters, attributes, effects) {
                var output = new com.vzome.core.construction.ConstructionList();
                var center = attributes.get(com.vzome.core.commands.CommandTransform.SYMMETRY_CENTER_ATTR_NAME);
                var params = parameters.getConstructions();

                for (var index691 = 0; index691 < params.length; index691++) {
                  var param = params[index691];
                  {
                    output.addConstruction(param);
                  }
                }

                var transform = new com.vzome.core.construction.PointReflection(center);
                effects.constructionAdded(transform);
                return this.transform(params, transform, effects);
              }
            }]);

            function CommandCentralSymmetry() {
              _classCallCheck(this, CommandCentralSymmetry);

              return _super136.call(this);
            }

            return CommandCentralSymmetry;
          }(com.vzome.core.commands.CommandTransform);

          commands.CommandCentralSymmetry = CommandCentralSymmetry;
          CommandCentralSymmetry["__class"] = "com.vzome.core.commands.CommandCentralSymmetry";
          CommandCentralSymmetry["__interfaces"] = ["com.vzome.core.commands.Command"];
        })(core.commands || (core.commands = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (commands) {
          /**
          * @author Scott Vorthmann
          * @class
          * @extends com.vzome.core.commands.CommandTransform
          */
          var CommandMirrorSymmetry =
          /*#__PURE__*/
          function (_com$vzome$core$comma22) {
            _inherits(CommandMirrorSymmetry, _com$vzome$core$comma22);

            var _super137 = _createSuper(CommandMirrorSymmetry);

            _createClass(CommandMirrorSymmetry, [{
              key: "apply",

              /**
              *
              * @param {com.vzome.core.construction.ConstructionList} parameters
              * @param {com.vzome.core.commands.AttributeMap} attributes
              * @param {*} effects
              * @return {com.vzome.core.construction.ConstructionList}
              */
              value: function apply(parameters, attributes, effects) {
                var center = attributes.get(com.vzome.core.commands.CommandTransform.SYMMETRY_CENTER_ATTR_NAME);
                var norm = attributes.get(com.vzome.core.commands.CommandTransform.SYMMETRY_AXIS_ATTR_NAME);

                if (norm == null) {
                  throw new com.vzome.core.commands.Command.Failure("no symmetry axis provided");
                }

                var params = parameters.getConstructions();
                var mirror = new com.vzome.core.construction.PlaneFromNormalSegment(center, norm);
                effects.constructionAdded(mirror);
                var transform = new com.vzome.core.construction.PlaneReflection(mirror);
                return this.transform(params, transform, effects);
              }
            }]);

            function CommandMirrorSymmetry() {
              _classCallCheck(this, CommandMirrorSymmetry);

              return _super137.call(this);
            }

            return CommandMirrorSymmetry;
          }(com.vzome.core.commands.CommandTransform);

          commands.CommandMirrorSymmetry = CommandMirrorSymmetry;
          CommandMirrorSymmetry["__class"] = "com.vzome.core.commands.CommandMirrorSymmetry";
          CommandMirrorSymmetry["__interfaces"] = ["com.vzome.core.commands.Command"];
        })(core.commands || (core.commands = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          var ValidateSelection =
          /*#__PURE__*/
          function (_com$vzome$core$edito10) {
            _inherits(ValidateSelection, _com$vzome$core$edito10);

            var _super138 = _createSuper(ValidateSelection);

            _createClass(ValidateSelection, [{
              key: "perform",

              /**
              *
              */
              value: function perform() {
                if (this.mSelection.size() === 0) throw new com.vzome.core.commands.Command.Failure("selection is empty");
              }
            }]);

            function ValidateSelection(editor) {
              _classCallCheck(this, ValidateSelection);

              return _super138.call(this, editor.getSelection());
            }
            /**
            *
            * @return {string}
            */


            _createClass(ValidateSelection, [{
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "ValidateSelection";
              }
            }]);

            return ValidateSelection;
          }(com.vzome.core.editor.api.ChangeSelection);

          edits.ValidateSelection = ValidateSelection;
          ValidateSelection["__class"] = "com.vzome.core.edits.ValidateSelection";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          var InvertSelection =
          /*#__PURE__*/
          function (_com$vzome$core$edito11) {
            _inherits(InvertSelection, _com$vzome$core$edito11);

            var _super139 = _createSuper(InvertSelection);

            function InvertSelection(editor) {
              var _this102;

              _classCallCheck(this, InvertSelection);

              _this102 = _super139.call(this, editor.getSelection());
              if (_this102.mManifestations === undefined) _this102.mManifestations = null;
              _this102.mManifestations = editor.getRealizedModel();
              return _this102;
            }
            /**
            *
            */


            _createClass(InvertSelection, [{
              key: "perform",
              value: function perform() {
                for (var index692 = this.mManifestations.iterator(); index692.hasNext();) {
                  var m = index692.next();
                  {
                    if (m.isRendered()) {
                      if (this.mSelection.manifestationSelected(m)) this.unselect$com_vzome_core_model_Manifestation(m);else this.select$com_vzome_core_model_Manifestation(m);
                    }
                  }
                }

                this.redo();
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "InvertSelection";
              }
            }]);

            return InvertSelection;
          }(com.vzome.core.editor.api.ChangeSelection);

          edits.InvertSelection = InvertSelection;
          InvertSelection["__class"] = "com.vzome.core.edits.InvertSelection";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          /**
          * Used by CommandEdit.
          * @param {*} editor
          * @param {*} m
          * @class
          * @extends com.vzome.core.editor.api.ChangeSelection
          */
          var SelectManifestation =
          /*#__PURE__*/
          function (_com$vzome$core$edito12) {
            _inherits(SelectManifestation, _com$vzome$core$edito12);

            var _super140 = _createSuper(SelectManifestation);

            function SelectManifestation(editor, m) {
              var _this103;

              _classCallCheck(this, SelectManifestation);

              if ((editor != null && (editor["__interfaces"] != null && editor["__interfaces"].indexOf("com.vzome.core.editor.api.EditorModel") >= 0 || editor.constructor != null && editor.constructor["__interfaces"] != null && editor.constructor["__interfaces"].indexOf("com.vzome.core.editor.api.EditorModel") >= 0) || editor === null) && (m != null && (m["__interfaces"] != null && m["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0 || m.constructor != null && m.constructor["__interfaces"] != null && m.constructor["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0) || m === null)) {
                {
                  _this103 = _super140.call(this, editor.getSelection());
                  if (_this103.mManifestation === undefined) _this103.mManifestation = null;
                  if (_this103.construction === undefined) _this103.construction = null;
                  if (_this103.mRealized === undefined) _this103.mRealized = null;
                  if (_this103.mReplace === undefined) _this103.mReplace = false;
                  if (_this103.mManifestation === undefined) _this103.mManifestation = null;
                  if (_this103.construction === undefined) _this103.construction = null;
                  if (_this103.mRealized === undefined) _this103.mRealized = null;
                  if (_this103.mReplace === undefined) _this103.mReplace = false;

                  (function () {
                    _this103.mRealized = editor.getRealizedModel();
                  })();
                }

                (function () {
                  _this103.mManifestation = m;

                  if (_this103.mManifestation != null) {
                    _this103.construction = _this103.mManifestation.toConstruction();
                  }
                })();
              } else if ((editor != null && (editor["__interfaces"] != null && editor["__interfaces"].indexOf("com.vzome.core.editor.api.EditorModel") >= 0 || editor.constructor != null && editor.constructor["__interfaces"] != null && editor.constructor["__interfaces"].indexOf("com.vzome.core.editor.api.EditorModel") >= 0) || editor === null) && m === undefined) {
                _this103 = _super140.call(this, editor.getSelection());
                if (_this103.mManifestation === undefined) _this103.mManifestation = null;
                if (_this103.construction === undefined) _this103.construction = null;
                if (_this103.mRealized === undefined) _this103.mRealized = null;
                if (_this103.mReplace === undefined) _this103.mReplace = false;
                if (_this103.mManifestation === undefined) _this103.mManifestation = null;
                if (_this103.construction === undefined) _this103.construction = null;
                if (_this103.mRealized === undefined) _this103.mRealized = null;
                if (_this103.mReplace === undefined) _this103.mReplace = false;

                (function () {
                  _this103.mRealized = editor.getRealizedModel();
                })();
              } else throw new Error('invalid overload');

              return _possibleConstructorReturn(_this103);
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(SelectManifestation, [{
              key: "groupingAware",
              value: function groupingAware() {
                return true;
              }
            }, {
              key: "configure",
              value: function configure(props) {
                var mode = props.get("mode");

                this.mReplace =
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }("replace", mode);

                this.mManifestation = props.get("picked");

                if (this.mManifestation != null) {
                  this.construction = this.mManifestation.toConstruction();
                }
              }
              /**
              *
              */

            }, {
              key: "perform",
              value: function perform() {
                if (this.mReplace) {
                  for (var index693 = this.mSelection.iterator(); index693.hasNext();) {
                    var man = index693.next();
                    {
                      this.unselect$com_vzome_core_model_Manifestation$boolean(man, true);
                    }
                  }

                  this.select$com_vzome_core_model_Manifestation(this.mManifestation);
                } else if (this.mSelection.manifestationSelected(this.mManifestation)) this.unselect$com_vzome_core_model_Manifestation(this.mManifestation);else this.select$com_vzome_core_model_Manifestation(this.mManifestation);

                this.redo();
              }
              /**
              *
              * @param {*} result
              */

            }, {
              key: "getXmlAttributes",
              value: function getXmlAttributes(result) {
                if (this.construction != null && this.construction instanceof com.vzome.core.construction.Point) com.vzome.core.commands.XmlSaveFormat.serializePoint(result, "point", this.construction);else if (this.construction != null && this.construction instanceof com.vzome.core.construction.Segment) com.vzome.core.commands.XmlSaveFormat.serializeSegment(result, "startSegment", "endSegment", this.construction);else if (this.construction != null && this.construction instanceof com.vzome.core.construction.Polygon) com.vzome.core.commands.XmlSaveFormat.serializePolygon(result, "polygonVertex", this.construction);
                if (this.mReplace) com.vzome.xml.DomUtils.addAttribute(result, "replace", "true");
              }
              /**
              *
              * @param {*} xml
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              */

            }, {
              key: "setXmlAttributes",
              value: function setXmlAttributes(xml, format) {
                if (format.rationalVectors()) {
                  this.construction = format.parsePoint$org_w3c_dom_Element$java_lang_String(xml, "point");
                  if (this.construction == null) this.construction = format.parseSegment$org_w3c_dom_Element$java_lang_String$java_lang_String(xml, "startSegment", "endSegment");

                  if (this.construction == null) {
                    var kid = com.vzome.xml.DomUtils.getFirstChildElement$org_w3c_dom_Element$java_lang_String(xml, "polygon");
                    if (kid != null) this.construction = format.parsePolygon$org_w3c_dom_Element$java_lang_String(kid, "vertex");else this.construction = format.parsePolygon$org_w3c_dom_Element$java_lang_String(xml, "polygonVertex");
                  }
                } else {
                  var attrs = format.loadCommandAttributes$org_w3c_dom_Element(xml);
                  this.construction = attrs.get("manifestation");
                  var replaceVal = attrs.get("replace");
                  if (replaceVal != null && replaceVal) this.mReplace = true;
                }

                this.mManifestation = this.mRealized.getManifestation(this.construction);

                if (this.mManifestation == null && format.rationalVectors() && this.construction != null && this.construction instanceof com.vzome.core.construction.Polygon) {
                  this.construction = format.parsePolygonReversed(xml, "polygonVertex");
                  this.mManifestation = this.mRealized.getManifestation(this.construction);
                  if (this.mManifestation != null) SideEffects.logBugAccommodation("reverse-oriented polygon");
                }
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "SelectManifestation";
              }
            }]);

            return SelectManifestation;
          }(com.vzome.core.editor.api.ChangeSelection);

          edits.SelectManifestation = SelectManifestation;
          SelectManifestation["__class"] = "com.vzome.core.edits.SelectManifestation";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          /**
          * This constructor is only used during deserialization, so it prepares for setXmlAttributes().
          * @param {*} editor
          * @class
          * @extends com.vzome.core.editor.api.ChangeSelection
          * @author David Hall
          */
          var AdjustSelectionByOrbitLength =
          /*#__PURE__*/
          function (_com$vzome$core$edito13) {
            _inherits(AdjustSelectionByOrbitLength, _com$vzome$core$edito13);

            var _super141 = _createSuper(AdjustSelectionByOrbitLength);

            function AdjustSelectionByOrbitLength(editor) {
              var _this104;

              _classCallCheck(this, AdjustSelectionByOrbitLength);

              _this104 = _super141.call(this, editor.getSelection());
              if (_this104.orbit === undefined) _this104.orbit = null;
              if (_this104.length === undefined) _this104.length = null;
              if (_this104.symmetry === undefined) _this104.symmetry = null;
              _this104.strutAction = com.vzome.core.editor.api.ActionEnum.IGNORE;
              _this104.panelAction = com.vzome.core.editor.api.ActionEnum.IGNORE;
              if (_this104.editor === undefined) _this104.editor = null;
              _this104.symmetry = editor['getSymmetrySystem$']();
              _this104.editor = editor;
              return _this104;
            }
            /**
            *
            * @param {*} props
            */


            _createClass(AdjustSelectionByOrbitLength, [{
              key: "configure",
              value: function configure(props) {
                var mode = props.get("mode");
                var strut = props.get("picked");
                this.orbit = props.get("orbit");
                this.length = props.get("length");
                if (mode != null) switch (mode) {
                  case "selectSimilarStruts":
                    this.strutAction = com.vzome.core.editor.api.ActionEnum.SELECT;
                    break;

                  case "selectSimilarPanels":
                    this.panelAction = com.vzome.core.editor.api.ActionEnum.SELECT;
                    break;

                  case "deselectSimilarStruts":
                    this.strutAction = com.vzome.core.editor.api.ActionEnum.DESELECT;
                    break;

                  case "deselectSimilarPanels":
                    this.panelAction = com.vzome.core.editor.api.ActionEnum.DESELECT;
                    break;
                }

                if (strut != null) {
                  var offset = strut.getOffset();
                  var zone = this.symmetry.getAxis(offset);
                  this.orbit = zone.getOrbit();
                  this.length = zone.getLength(offset);
                }
              }
              /**
              *
              */

            }, {
              key: "perform",
              value: function perform() {
                var whichManifestationSet = this.strutAction === com.vzome.core.editor.api.ActionEnum.SELECT || this.panelAction === com.vzome.core.editor.api.ActionEnum.SELECT ? this.editor.getRealizedModel() : this.mSelection;

                for (var index694 = whichManifestationSet.iterator(); index694.hasNext();) {
                  var man = index694.next();
                  {
                    if (man.isRendered()) {
                      if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0)) {
                        var offset = man.getOffset();
                        var zone = this.symmetry.getAxis(offset);

                        if (zone.getOrbit() === this.orbit) {
                          if (this.length == null ||
                          /* equals */
                          function (o1, o2) {
                            if (o1 && o1.equals) {
                              return o1.equals(o2);
                            } else {
                              return o1 === o2;
                            }
                          }(this.length, zone.getLength(offset))) {
                            this.adjustSelection(man, this.strutAction);
                          }
                        }
                      } else if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0)) {
                        var _zone = this.symmetry.getAxis(man['getNormal$']());

                        if (_zone.getOrbit() === this.orbit) {
                          this.adjustSelection(man, this.panelAction);
                        }
                      }
                    }
                  }
                }

                this.redo();
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "AdjustSelectionByOrbitLength";
              }
              /**
              *
              * @param {*} element
              */

            }, {
              key: "getXmlAttributes",
              value: function getXmlAttributes(element) {
                if (this.symmetry != null) {
                  com.vzome.xml.DomUtils.addAttribute(element, "symmetry", this.symmetry.getName());
                }

                if (this.orbit != null) {
                  com.vzome.xml.DomUtils.addAttribute(element, "orbit", this.orbit.getName());
                }

                if (this.length != null) {
                  com.vzome.core.commands.XmlSaveFormat.serializeNumber(element, "length", this.length);
                }

                element.setAttribute("struts", com.vzome.core.editor.api.ActionEnum["_$wrappers"][this.strutAction].toString());
                element.setAttribute("panels", com.vzome.core.editor.api.ActionEnum["_$wrappers"][this.panelAction].toString());
              }
              /**
              *
              * @param {*} xml
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              */

            }, {
              key: "setXmlAttributes",
              value: function setXmlAttributes(xml, format) {
                this.symmetry = this.editor['getSymmetrySystem$java_lang_String'](xml.getAttribute("symmetry"));
                this.length = format.parseNumber(xml, "length");
                this.orbit = this.symmetry.getOrbits().getDirection(xml.getAttribute("orbit"));

                if (
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(xml.getLocalName(), "SelectSimilarSize")) {
                  this.strutAction = com.vzome.core.editor.api.ActionEnum.SELECT;
                  this.panelAction = com.vzome.core.editor.api.ActionEnum.IGNORE;
                } else {
                  this.strutAction =
                  /* Enum.valueOf */
                  com.vzome.core.editor.api.ActionEnum[xml.getAttribute("struts")];
                  this.panelAction =
                  /* Enum.valueOf */
                  com.vzome.core.editor.api.ActionEnum[xml.getAttribute("panels")];
                }
              }
            }]);

            return AdjustSelectionByOrbitLength;
          }(com.vzome.core.editor.api.ChangeSelection);

          edits.AdjustSelectionByOrbitLength = AdjustSelectionByOrbitLength;
          AdjustSelectionByOrbitLength["__class"] = "com.vzome.core.edits.AdjustSelectionByOrbitLength";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          /**
          * @author David Hall
          * This class is designed to be a generalized replacement for the legacy DeselectByClass
          * It allows balls, struts and/or panels to be selected, deselected or ignored by class
          * It can be used in place of DeselectByClass including the ability to parse the legacy XML.
          * DeselectByClass has been renamed as AdjustSelectionByClass and modified with the additional functionality.
          * @param {*} editor
          * @class
          * @extends com.vzome.core.editor.api.ChangeSelection
          */
          var AdjustSelectionByClass =
          /*#__PURE__*/
          function (_com$vzome$core$edito14) {
            _inherits(AdjustSelectionByClass, _com$vzome$core$edito14);

            var _super142 = _createSuper(AdjustSelectionByClass);

            function AdjustSelectionByClass(editor) {
              var _this105;

              _classCallCheck(this, AdjustSelectionByClass);

              _this105 = _super142.call(this, editor.getSelection());
              _this105.ballAction = com.vzome.core.editor.api.ActionEnum.IGNORE;
              _this105.strutAction = com.vzome.core.editor.api.ActionEnum.IGNORE;
              _this105.panelAction = com.vzome.core.editor.api.ActionEnum.IGNORE;
              if (_this105.editor === undefined) _this105.editor = null;
              _this105.editor = editor;
              return _this105;
            }
            /**
            *
            * @param {*} props
            */


            _createClass(AdjustSelectionByClass, [{
              key: "configure",
              value: function configure(props) {
                var mode = props.get("mode");
                if (mode != null) switch (mode) {
                  case "selectBalls":
                    this.ballAction = com.vzome.core.editor.api.ActionEnum.SELECT;
                    break;

                  case "selectStruts":
                    this.strutAction = com.vzome.core.editor.api.ActionEnum.SELECT;
                    break;

                  case "selectPanels":
                    this.panelAction = com.vzome.core.editor.api.ActionEnum.SELECT;
                    break;

                  case "deselectBalls":
                  case "unselectBalls":
                    this.ballAction = com.vzome.core.editor.api.ActionEnum.DESELECT;
                    break;

                  case "deselectStruts":
                    this.strutAction = com.vzome.core.editor.api.ActionEnum.DESELECT;
                    break;

                  case "deselectPanels":
                    this.panelAction = com.vzome.core.editor.api.ActionEnum.DESELECT;
                    break;

                  case "unselectStruts":
                  case "unselectStrutsAndPanels":
                    this.strutAction = com.vzome.core.editor.api.ActionEnum.DESELECT;
                    this.panelAction = com.vzome.core.editor.api.ActionEnum.DESELECT;
                    break;
                }
              }
              /**
              *
              */

            }, {
              key: "perform",
              value: function perform() {
                var whichManifestationSet = this.ballAction === com.vzome.core.editor.api.ActionEnum.SELECT || this.strutAction === com.vzome.core.editor.api.ActionEnum.SELECT || this.panelAction === com.vzome.core.editor.api.ActionEnum.SELECT ? this.editor.getRealizedModel() : this.mSelection;

                for (var index695 = whichManifestationSet.iterator(); index695.hasNext();) {
                  var man = index695.next();
                  {
                    if (man.isRendered()) {
                      if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0)) {
                        this.adjustSelection(man, this.ballAction);
                      } else if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0)) {
                        this.adjustSelection(man, this.strutAction);
                      } else if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0)) {
                        this.adjustSelection(man, this.panelAction);
                      }
                    }
                  }
                }

                this.redo();
              }
              /**
              *
              * @param {*} element
              */

            }, {
              key: "getXmlAttributes",
              value: function getXmlAttributes(element) {
                element.setAttribute("balls", com.vzome.core.editor.api.ActionEnum["_$wrappers"][this.ballAction].toString());
                element.setAttribute("struts", com.vzome.core.editor.api.ActionEnum["_$wrappers"][this.strutAction].toString());
                element.setAttribute("panels", com.vzome.core.editor.api.ActionEnum["_$wrappers"][this.panelAction].toString());
              }
              /**
              *
              * @param {*} xml
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              */

            }, {
              key: "setXmlAttributes",
              value: function setXmlAttributes(xml, format) {
                if (
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(xml.getLocalName(), "DeselectByClass")) {
                  if (
                  /* equals */
                  function (o1, o2) {
                    if (o1 && o1.equals) {
                      return o1.equals(o2);
                    } else {
                      return o1 === o2;
                    }
                  }(xml.getAttribute("class"), "balls")) {
                    this.ballAction = com.vzome.core.editor.api.ActionEnum.DESELECT;
                    this.strutAction = com.vzome.core.editor.api.ActionEnum.IGNORE;
                    this.panelAction = com.vzome.core.editor.api.ActionEnum.IGNORE;
                  } else {
                    this.ballAction = com.vzome.core.editor.api.ActionEnum.IGNORE;
                    this.strutAction = com.vzome.core.editor.api.ActionEnum.DESELECT;
                    this.panelAction = com.vzome.core.editor.api.ActionEnum.DESELECT;
                  }
                } else {
                  this.ballAction =
                  /* Enum.valueOf */
                  com.vzome.core.editor.api.ActionEnum[xml.getAttribute("balls")];
                  this.strutAction =
                  /* Enum.valueOf */
                  com.vzome.core.editor.api.ActionEnum[xml.getAttribute("struts")];
                  this.panelAction =
                  /* Enum.valueOf */
                  com.vzome.core.editor.api.ActionEnum[xml.getAttribute("panels")];
                }
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "AdjustSelectionByClass";
              }
            }]);

            return AdjustSelectionByClass;
          }(com.vzome.core.editor.api.ChangeSelection);

          edits.AdjustSelectionByClass = AdjustSelectionByClass;
          AdjustSelectionByClass["__class"] = "com.vzome.core.edits.AdjustSelectionByClass";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          var SelectAll =
          /*#__PURE__*/
          function (_com$vzome$core$edito15) {
            _inherits(SelectAll, _com$vzome$core$edito15);

            var _super143 = _createSuper(SelectAll);

            function SelectAll(editor) {
              var _this106;

              _classCallCheck(this, SelectAll);

              _this106 = _super143.call(this, editor.getSelection());
              if (_this106.realizedModel === undefined) _this106.realizedModel = null;
              _this106.realizedModel = editor.getRealizedModel();
              return _this106;
            }
            /**
            *
            */


            _createClass(SelectAll, [{
              key: "perform",
              value: function perform() {
                for (var index696 = this.realizedModel.iterator(); index696.hasNext();) {
                  var m = index696.next();
                  {
                    if (m.isRendered()) {
                      if (!this.mSelection.manifestationSelected(m)) this.select$com_vzome_core_model_Manifestation$boolean(m, true);
                    }
                  }
                }

                _get(_getPrototypeOf(SelectAll.prototype), "perform", this).call(this);
              }
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "groupingAware",
              value: function groupingAware() {
                return true;
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "SelectAll";
              }
            }]);

            return SelectAll;
          }(com.vzome.core.editor.api.ChangeSelection);

          edits.SelectAll = SelectAll;
          SelectAll["__class"] = "com.vzome.core.edits.SelectAll";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          var SelectNeighbors =
          /*#__PURE__*/
          function (_com$vzome$core$edito16) {
            _inherits(SelectNeighbors, _com$vzome$core$edito16);

            var _super144 = _createSuper(SelectNeighbors);

            function SelectNeighbors(editor) {
              var _this107;

              _classCallCheck(this, SelectNeighbors);

              _this107 = _super144.call(this, editor.getSelection());
              if (_this107.editor === undefined) _this107.editor = null;
              _this107.withPanels = false;
              _this107.editor = editor;
              return _this107;
            }

            _createClass(SelectNeighbors, [{
              key: "perform",
              value: function perform() {
                var model = this.editor.getRealizedModel();
                var panels = new java.util.HashSet();
                var struts = new java.util.HashSet();
                var balls = new java.util.HashSet();

                for (var index697 = this.mSelection.iterator(); index697.hasNext();) {
                  var man = index697.next();
                  {
                    if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0)) struts.add(man);else if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0)) balls.add(man);else if (this.withPanels && man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0)) panels.add(man);
                  }
                }

                for (var index698 = balls.iterator(); index698.hasNext();) {
                  var ball = index698.next();
                  {
                    var loc = ball.getLocation();

                    for (var index699 = model.iterator(); index699.hasNext();) {
                      var _man3 = index699.next();

                      {
                        if (!_man3.isRendered()) continue;

                        if (_man3 != null && (_man3["__interfaces"] != null && _man3["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || _man3.constructor != null && _man3.constructor["__interfaces"] != null && _man3.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0) && !struts.contains(_man3)) {
                          var strut = _man3;
                          if (loc.equals(strut.getLocation()) || loc.equals(strut.getEnd())) this.select$com_vzome_core_model_Manifestation(strut);
                        } else if (this.withPanels && _man3 != null && (_man3["__interfaces"] != null && _man3["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0 || _man3.constructor != null && _man3.constructor["__interfaces"] != null && _man3.constructor["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0) && !panels.contains(_man3)) {
                          var panel = _man3;

                          for (var index700 = panel.iterator(); index700.hasNext();) {
                            var vertex = index700.next();
                            {
                              if (loc.equals(vertex)) {
                                this.select$com_vzome_core_model_Manifestation(panel);
                                break;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }

                for (var index701 = struts.iterator(); index701.hasNext();) {
                  var _strut = index701.next();

                  {
                    var _loc2 = _strut.getLocation();

                    var end = _strut.getEnd();

                    for (var index702 = model.iterator(); index702.hasNext();) {
                      var _man4 = index702.next();

                      {
                        if (!_man4.isRendered()) continue;

                        if (_man4 != null && (_man4["__interfaces"] != null && _man4["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || _man4.constructor != null && _man4.constructor["__interfaces"] != null && _man4.constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0) && !balls.contains(_man4)) {
                          var bloc = _man4.getLocation();

                          if (bloc.equals(_loc2) || bloc.equals(end)) this.select$com_vzome_core_model_Manifestation(_man4);
                        }
                      }
                    }
                  }
                }

                if (this.withPanels) {
                  for (var index703 = panels.iterator(); index703.hasNext();) {
                    var _panel = index703.next();

                    {
                      for (var index704 = _panel.iterator(); index704.hasNext();) {
                        var _loc3 = index704.next();

                        {
                          for (var index705 = model.iterator(); index705.hasNext();) {
                            var _man5 = index705.next();

                            {
                              if (_man5.isRendered()) {
                                if (_man5 != null && (_man5["__interfaces"] != null && _man5["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || _man5.constructor != null && _man5.constructor["__interfaces"] != null && _man5.constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0) && !balls.contains(_man5)) {
                                  var _bloc = _man5.getLocation();

                                  if (_bloc.equals(_loc3)) {
                                    this.select$com_vzome_core_model_Manifestation(_man5);
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }

                _get(_getPrototypeOf(SelectNeighbors.prototype), "perform", this).call(this);
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "SelectNeighbors";
              }
            }]);

            return SelectNeighbors;
          }(com.vzome.core.editor.api.ChangeSelection);

          edits.SelectNeighbors = SelectNeighbors;
          SelectNeighbors["__class"] = "com.vzome.core.edits.SelectNeighbors";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          var DeselectAll =
          /*#__PURE__*/
          function (_com$vzome$core$edito17) {
            _inherits(DeselectAll, _com$vzome$core$edito17);

            var _super145 = _createSuper(DeselectAll);

            _createClass(DeselectAll, [{
              key: "perform",

              /**
              *
              */
              value: function perform() {
                for (var index706 = this.mSelection.iterator(); index706.hasNext();) {
                  var man = index706.next();
                  {
                    this.unselect$com_vzome_core_model_Manifestation$boolean(man, true);
                  }
                }

                _get(_getPrototypeOf(DeselectAll.prototype), "perform", this).call(this);
              }
            }]);

            function DeselectAll(editor) {
              _classCallCheck(this, DeselectAll);

              return _super145.call(this, editor.getSelection());
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(DeselectAll, [{
              key: "groupingAware",
              value: function groupingAware() {
                return true;
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "DeselectAll";
              }
            }]);

            return DeselectAll;
          }(com.vzome.core.editor.api.ChangeSelection);

          edits.DeselectAll = DeselectAll;
          DeselectAll["__class"] = "com.vzome.core.edits.DeselectAll";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (editor) {
          (function (api) {
            var ChangeManifestations =
            /*#__PURE__*/
            function (_com$vzome$core$edito18) {
              _inherits(ChangeManifestations, _com$vzome$core$edito18);

              var _super146 = _createSuper(ChangeManifestations);

              function ChangeManifestations(editorModel) {
                var _this108;

                _classCallCheck(this, ChangeManifestations);

                _this108 = _super146.call(this, editorModel.getSelection());
                if (_this108.mManifestations === undefined) _this108.mManifestations = null;
                _this108.mManifestations = editorModel.getRealizedModel();

                _this108.mManifestations.clearPerEditManifestations();

                return _this108;
              }
              /**
              *
              */


              _createClass(ChangeManifestations, [{
                key: "redo",
                value: function redo() {
                  this.mManifestations.clearPerEditManifestations();

                  _get(_getPrototypeOf(ChangeManifestations.prototype), "redo", this).call(this);
                }
                /**
                *
                */

              }, {
                key: "undo",
                value: function undo() {
                  this.mManifestations.clearPerEditManifestations();

                  _get(_getPrototypeOf(ChangeManifestations.prototype), "undo", this).call(this);
                }
              }, {
                key: "getManifestation",
                value: function getManifestation(c) {
                  return this.mManifestations.getManifestation(c);
                }
              }, {
                key: "manifestConstruction",
                value: function manifestConstruction(c) {
                  var m = this.mManifestations.findConstruction(c);
                  if (m == null) return null;
                  var made = this.mManifestations.findPerEditManifestation(m);
                  if (made != null) return made;

                  if (m.isUnnecessary()) {
                    this.mManifestations.addPerEditManifestation(m);
                    this.plan(new ChangeManifestations.ManifestConstruction(this, c, m, true));
                  } else {
                    if (!m.isRendered()) this.plan(new ChangeManifestations.RenderManifestation(this, m, true));
                  }

                  return m;
                }
              }, {
                key: "unmanifestConstruction",
                value: function unmanifestConstruction(c) {
                  var m = this.mManifestations.removeConstruction(c);
                  if (m == null) return null;
                  this.plan(new ChangeManifestations.ManifestConstruction(this, c, m, false));
                  return m;
                }
              }, {
                key: "deleteManifestation",
                value: function deleteManifestation(man) {
                  this.plan(new ChangeManifestations.DeleteManifestation(this, man));
                }
              }, {
                key: "showManifestation",
                value: function showManifestation(m) {
                  this.plan(new ChangeManifestations.RenderManifestation(this, m, true));
                }
              }, {
                key: "hideManifestation",
                value: function hideManifestation(m) {
                  this.plan(new ChangeManifestations.RenderManifestation(this, m, false));
                }
              }, {
                key: "colorManifestation",
                value: function colorManifestation(m, color) {
                  this.plan(new ChangeManifestations.ColorManifestation(this, m, color));
                }
              }, {
                key: "hideConnectors",
                value: function hideConnectors() {
                  for (var index707 = com.vzome.core.editor.api.Manifestations.getVisibleConnectors(this.mManifestations).iterator(); index707.hasNext();) {
                    var connector = index707.next();
                    this.hideManifestation(connector);
                  }
                }
              }, {
                key: "showConnectors",
                value: function showConnectors() {
                  for (var index708 = com.vzome.core.editor.api.Manifestations.getHiddenConnectors(this.mManifestations).iterator(); index708.hasNext();) {
                    var connector = index708.next();
                    this.showManifestation(connector);
                  }
                }
              }, {
                key: "hideStruts",
                value: function hideStruts() {
                  for (var index709 = com.vzome.core.editor.api.Manifestations.getVisibleStruts(this.mManifestations).iterator(); index709.hasNext();) {
                    var strut = index709.next();
                    this.hideManifestation(strut);
                  }
                }
              }, {
                key: "showStruts",
                value: function showStruts() {
                  for (var index710 = com.vzome.core.editor.api.Manifestations.getHiddenStruts(this.mManifestations).iterator(); index710.hasNext();) {
                    var strut = index710.next();
                    this.showManifestation(strut);
                  }
                }
              }, {
                key: "hidePanels",
                value: function hidePanels() {
                  for (var index711 = com.vzome.core.editor.api.Manifestations.getVisiblePanels(this.mManifestations).iterator(); index711.hasNext();) {
                    var panel = index711.next();
                    this.hideManifestation(panel);
                  }
                }
              }, {
                key: "showPanels",
                value: function showPanels() {
                  for (var index712 = com.vzome.core.editor.api.Manifestations.getHiddenPanels(this.mManifestations).iterator(); index712.hasNext();) {
                    var panel = index712.next();
                    this.showManifestation(panel);
                  }
                }
              }, {
                key: "showsManifestation",
                value: function showsManifestation(man) {
                  for (var iterator = this.getEffects(); iterator.hasNext();) {
                    {
                      var effect = iterator.next();

                      if (effect != null && effect instanceof com.vzome.core.editor.api.ChangeManifestations.ManifestConstruction) {
                        var show = effect;
                        if (show.showsManifestation(man)) return true;
                      } else if (effect != null && effect instanceof com.vzome.core.editor.api.ChangeManifestations.RenderManifestation) {
                        var _show = effect;
                        if (_show.showsManifestation(man)) return true;
                      }
                    }
                  }

                  return false;
                }
              }, {
                key: "getRenderedSelection",
                value: function getRenderedSelection() {
                  return com.vzome.core.editor.api.Manifestations.visibleManifestations$java_lang_Iterable$java_util_function_Predicate(this.mSelection, function (man) {
                    return com.vzome.core.editor.api.Manifestations.Filters.isRendered(man);
                  });
                }
              }, {
                key: "getConnectors",
                value: function getConnectors() {
                  return com.vzome.core.editor.api.Manifestations.getConnectors$java_lang_Iterable(this.mManifestations);
                }
              }, {
                key: "getStruts",
                value: function getStruts() {
                  return com.vzome.core.editor.api.Manifestations.getStruts$java_lang_Iterable(this.mManifestations);
                }
              }, {
                key: "getPanels",
                value: function getPanels() {
                  return com.vzome.core.editor.api.Manifestations.getPanels$java_lang_Iterable(this.mManifestations);
                }
              }, {
                key: "getVisibleConnectors$",
                value: function getVisibleConnectors$() {
                  return com.vzome.core.editor.api.Manifestations.getVisibleConnectors(this.mManifestations);
                }
              }, {
                key: "getVisibleStruts$",
                value: function getVisibleStruts$() {
                  return com.vzome.core.editor.api.Manifestations.getVisibleStruts(this.mManifestations);
                }
              }, {
                key: "getVisiblePanels$",
                value: function getVisiblePanels$() {
                  return com.vzome.core.editor.api.Manifestations.getVisiblePanels(this.mManifestations);
                }
              }, {
                key: "getVisibleConnectors$java_util_function_Predicate",
                value: function getVisibleConnectors$java_util_function_Predicate(postFilter) {
                  return com.vzome.core.editor.api.Manifestations.getVisibleConnectors(this.mManifestations, postFilter);
                }
              }, {
                key: "getVisibleConnectors",
                value: function getVisibleConnectors(postFilter) {
                  if (typeof postFilter === 'function' && postFilter.length == 1 || postFilter === null) {
                    return this.getVisibleConnectors$java_util_function_Predicate(postFilter);
                  } else if (postFilter === undefined) {
                    return this.getVisibleConnectors$();
                  } else throw new Error('invalid overload');
                }
              }, {
                key: "getVisibleStruts$java_util_function_Predicate",
                value: function getVisibleStruts$java_util_function_Predicate(postFilter) {
                  return com.vzome.core.editor.api.Manifestations.getVisibleStruts(this.mManifestations, postFilter);
                }
              }, {
                key: "getVisibleStruts",
                value: function getVisibleStruts(postFilter) {
                  if (typeof postFilter === 'function' && postFilter.length == 1 || postFilter === null) {
                    return this.getVisibleStruts$java_util_function_Predicate(postFilter);
                  } else if (postFilter === undefined) {
                    return this.getVisibleStruts$();
                  } else throw new Error('invalid overload');
                }
              }, {
                key: "getVisiblePanels$java_util_function_Predicate",
                value: function getVisiblePanels$java_util_function_Predicate(postFilter) {
                  return com.vzome.core.editor.api.Manifestations.getVisiblePanels(this.mManifestations, postFilter);
                }
              }, {
                key: "getVisiblePanels",
                value: function getVisiblePanels(postFilter) {
                  if (typeof postFilter === 'function' && postFilter.length == 1 || postFilter === null) {
                    return this.getVisiblePanels$java_util_function_Predicate(postFilter);
                  } else if (postFilter === undefined) {
                    return this.getVisiblePanels$();
                  } else throw new Error('invalid overload');
                }
              }]);

              return ChangeManifestations;
            }(com.vzome.core.editor.api.ChangeSelection);

            api.ChangeManifestations = ChangeManifestations;
            ChangeManifestations["__class"] = "com.vzome.core.editor.api.ChangeManifestations";

            (function (ChangeManifestations) {
              var ManifestConstruction =
              /*#__PURE__*/
              function () {
                function ManifestConstruction(__parent, construction, manifestation, showing) {
                  _classCallCheck(this, ManifestConstruction);

                  this.__parent = __parent;
                  if (this.mManifestation === undefined) this.mManifestation = null;
                  if (this.mConstruction === undefined) this.mConstruction = null;
                  if (this.mShowing === undefined) this.mShowing = false;
                  this.mConstruction = construction;
                  this.mManifestation = manifestation;
                  this.mShowing = showing;
                }
                /**
                *
                */


                _createClass(ManifestConstruction, [{
                  key: "redo",
                  value: function redo() {
                    if (this.mShowing) {
                      if (this.mManifestation.isUnnecessary()) this.__parent.mManifestations.add(this.mManifestation);

                      this.__parent.mManifestations.show(this.mManifestation);

                      this.mManifestation.addConstruction(this.mConstruction);
                    } else {
                      this.mManifestation.removeConstruction(this.mConstruction);

                      if (this.mManifestation.isUnnecessary()) {
                        this.__parent.mManifestations.hide(this.mManifestation);

                        this.__parent.mManifestations.remove(this.mManifestation);
                      }
                    }
                  }
                  /**
                  *
                  */

                }, {
                  key: "undo",
                  value: function undo() {
                    if (this.mShowing) {
                      this.mManifestation.removeConstruction(this.mConstruction);

                      if (this.mManifestation.isUnnecessary()) {
                        this.__parent.mManifestations.hide(this.mManifestation);

                        this.__parent.mManifestations.remove(this.mManifestation);
                      }
                    } else {
                      if (this.mManifestation.isUnnecessary()) this.__parent.mManifestations.add(this.mManifestation);

                      this.__parent.mManifestations.show(this.mManifestation);

                      this.mManifestation.addConstruction(this.mConstruction);
                    }
                  }
                  /**
                  *
                  * @param {*} doc
                  * @return {*}
                  */

                }, {
                  key: "getXml",
                  value: function getXml(doc) {
                    var result = this.mShowing ? doc.createElement("mshow") : doc.createElement("mhide");
                    var man = this.mConstruction.getXml(doc);
                    result.appendChild(man);
                    return result;
                  }
                }, {
                  key: "showsManifestation",
                  value: function showsManifestation(man) {
                    return this.mShowing &&
                    /* equals */
                    function (o1, o2) {
                      if (o1 && o1.equals) {
                        return o1.equals(o2);
                      } else {
                        return o1 === o2;
                      }
                    }(this.mManifestation, man);
                  }
                }]);

                return ManifestConstruction;
              }();

              ChangeManifestations.ManifestConstruction = ManifestConstruction;
              ManifestConstruction["__class"] = "com.vzome.core.editor.api.ChangeManifestations.ManifestConstruction";
              ManifestConstruction["__interfaces"] = ["com.vzome.core.editor.api.SideEffects.SideEffect"];

              var RenderManifestation =
              /*#__PURE__*/
              function () {
                function RenderManifestation(__parent, manifestation, showing) {
                  _classCallCheck(this, RenderManifestation);

                  this.__parent = __parent;
                  if (this.mManifestation === undefined) this.mManifestation = null;
                  if (this.mShowing === undefined) this.mShowing = false;
                  this.mManifestation = manifestation;
                  this.mShowing = showing;
                }
                /**
                *
                */


                _createClass(RenderManifestation, [{
                  key: "redo",
                  value: function redo() {
                    this.mManifestation.setHidden(!this.mShowing);
                    if (this.mShowing) this.__parent.mManifestations.show(this.mManifestation);else this.__parent.mManifestations.hide(this.mManifestation);
                  }
                  /**
                  *
                  */

                }, {
                  key: "undo",
                  value: function undo() {
                    this.mManifestation.setHidden(this.mShowing);
                    if (this.mShowing) this.__parent.mManifestations.hide(this.mManifestation);else this.__parent.mManifestations.show(this.mManifestation);
                  }
                  /**
                  *
                  * @param {*} doc
                  * @return {*}
                  */

                }, {
                  key: "getXml",
                  value: function getXml(doc) {
                    var result = this.mShowing ? doc.createElement("show") : doc.createElement("hide");
                    var man = this.mManifestation.getXml(doc);
                    result.appendChild(man);
                    return result;
                  }
                }, {
                  key: "showsManifestation",
                  value: function showsManifestation(man) {
                    return this.mShowing &&
                    /* equals */
                    function (o1, o2) {
                      if (o1 && o1.equals) {
                        return o1.equals(o2);
                      } else {
                        return o1 === o2;
                      }
                    }(this.mManifestation, man);
                  }
                }]);

                return RenderManifestation;
              }();

              ChangeManifestations.RenderManifestation = RenderManifestation;
              RenderManifestation["__class"] = "com.vzome.core.editor.api.ChangeManifestations.RenderManifestation";
              RenderManifestation["__interfaces"] = ["com.vzome.core.editor.api.SideEffects.SideEffect"];

              var DeleteManifestation =
              /*#__PURE__*/
              function () {
                function DeleteManifestation(__parent, manifestation) {
                  _classCallCheck(this, DeleteManifestation);

                  this.__parent = __parent;
                  if (this.mManifestation === undefined) this.mManifestation = null;
                  this.mManifestation = manifestation;
                }
                /**
                *
                */


                _createClass(DeleteManifestation, [{
                  key: "redo",
                  value: function redo() {
                    this.mManifestation.setHidden(true);

                    this.__parent.mManifestations.hide(this.mManifestation);

                    this.__parent.mManifestations.remove(this.mManifestation);
                  }
                  /**
                  *
                  */

                }, {
                  key: "undo",
                  value: function undo() {
                    this.__parent.mManifestations.add(this.mManifestation);

                    this.__parent.mManifestations.show(this.mManifestation);

                    this.mManifestation.setHidden(false);
                  }
                  /**
                  *
                  * @param {*} doc
                  * @return {*}
                  */

                }, {
                  key: "getXml",
                  value: function getXml(doc) {
                    var result = doc.createElement("delete");
                    var man = this.mManifestation.getXml(doc);
                    result.appendChild(man);
                    return result;
                  }
                }]);

                return DeleteManifestation;
              }();

              ChangeManifestations.DeleteManifestation = DeleteManifestation;
              DeleteManifestation["__class"] = "com.vzome.core.editor.api.ChangeManifestations.DeleteManifestation";
              DeleteManifestation["__interfaces"] = ["com.vzome.core.editor.api.SideEffects.SideEffect"];

              var ColorManifestation =
              /*#__PURE__*/
              function () {
                function ColorManifestation(__parent, manifestation, color) {
                  _classCallCheck(this, ColorManifestation);

                  this.__parent = __parent;
                  if (this.mManifestation === undefined) this.mManifestation = null;
                  if (this.oldColor === undefined) this.oldColor = null;
                  if (this.newColor === undefined) this.newColor = null;
                  this.mManifestation = manifestation;
                  this.newColor = color;
                  this.oldColor = manifestation.getColor();
                }
                /**
                *
                */


                _createClass(ColorManifestation, [{
                  key: "redo",
                  value: function redo() {
                    this.__parent.mManifestations.setColor(this.mManifestation, this.newColor);
                  }
                  /**
                  *
                  */

                }, {
                  key: "undo",
                  value: function undo() {
                    this.__parent.mManifestations.setColor(this.mManifestation, this.oldColor);
                  }
                  /**
                  *
                  * @param {*} doc
                  * @return {*}
                  */

                }, {
                  key: "getXml",
                  value: function getXml(doc) {
                    var result = doc.createElement("color");
                    com.vzome.xml.DomUtils.addAttribute(result, "rgb", this.newColor.toString());
                    var man = this.mManifestation.getXml(doc);
                    result.appendChild(man);
                    return result;
                  }
                }]);

                return ColorManifestation;
              }();

              ChangeManifestations.ColorManifestation = ColorManifestation;
              ColorManifestation["__class"] = "com.vzome.core.editor.api.ChangeManifestations.ColorManifestation";
              ColorManifestation["__interfaces"] = ["com.vzome.core.editor.api.SideEffects.SideEffect"];
            })(ChangeManifestations = api.ChangeManifestations || (api.ChangeManifestations = {}));
          })(editor.api || (editor.api = {}));
        })(core.editor || (core.editor = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (commands) {
          /**
          * @author Scott Vorthmann
          * @param {*} symmetry
          * @class
          * @extends com.vzome.core.commands.CommandSymmetry
          */
          var CommandTetrahedralSymmetry =
          /*#__PURE__*/
          function (_com$vzome$core$comma23) {
            _inherits(CommandTetrahedralSymmetry, _com$vzome$core$comma23);

            var _super147 = _createSuper(CommandTetrahedralSymmetry);

            function CommandTetrahedralSymmetry() {
              var symmetry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

              _classCallCheck(this, CommandTetrahedralSymmetry);

              return _super147.call(this, symmetry);
            }

            _createClass(CommandTetrahedralSymmetry, [{
              key: "getAttributeSignature",

              /**
              *
              * @return {Array}
              */
              value: function getAttributeSignature() {
                return CommandTetrahedralSymmetry.ATTR_SIGNATURE_$LI$();
              }
              /**
              *
              * @param {com.vzome.core.construction.ConstructionList} parameters
              * @param {com.vzome.core.commands.AttributeMap} attributes
              * @param {*} effects
              * @return {com.vzome.core.construction.ConstructionList}
              */

            }, {
              key: "apply",
              value: function apply(parameters, attributes, effects) {
                var center = this.setSymmetry(attributes);
                var closure = this.mSymmetry.subgroup(com.vzome.core.math.symmetry.Symmetry.TETRAHEDRAL);
                var params = parameters.getConstructions();
                var output = new com.vzome.core.construction.ConstructionList();

                for (var index713 = 0; index713 < params.length; index713++) {
                  var param = params[index713];
                  {
                    output.addConstruction(param);
                  }
                }

                for (var i = 1; i < closure.length; i++) {
                  {
                    var transform = new com.vzome.core.construction.SymmetryTransformation(this.mSymmetry, closure[i], center);
                    output.addAll(this.transform(params, transform, effects));
                  }
                }

                return output;
              }
            }], [{
              key: "ATTR_SIGNATURE_$LI$",
              value: function ATTR_SIGNATURE_$LI$() {
                if (CommandTetrahedralSymmetry.ATTR_SIGNATURE == null) CommandTetrahedralSymmetry.ATTR_SIGNATURE = [[com.vzome.core.commands.CommandTransform.SYMMETRY_CENTER_ATTR_NAME, com.vzome.core.construction.Point], [com.vzome.core.commands.CommandTransform.SYMMETRY_GROUP_ATTR_NAME, "com.vzome.core.math.symmetry.Symmetry"], [CommandTetrahedralSymmetry.SUBGROUP_ATTR_NAME, [].constructor]];
                return CommandTetrahedralSymmetry.ATTR_SIGNATURE;
              }
            }]);

            return CommandTetrahedralSymmetry;
          }(com.vzome.core.commands.CommandSymmetry);

          CommandTetrahedralSymmetry.SUBGROUP_ATTR_NAME = "symmetry.permutations";
          commands.CommandTetrahedralSymmetry = CommandTetrahedralSymmetry;
          CommandTetrahedralSymmetry["__class"] = "com.vzome.core.commands.CommandTetrahedralSymmetry";
          CommandTetrahedralSymmetry["__interfaces"] = ["com.vzome.core.commands.Command"];
        })(core.commands || (core.commands = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (commands) {
          /**
          * @author Scott Vorthmann
          * @class
          * @extends com.vzome.core.commands.CommandSymmetry
          */
          var CommandRotate =
          /*#__PURE__*/
          function (_com$vzome$core$comma24) {
            _inherits(CommandRotate, _com$vzome$core$comma24);

            var _super148 = _createSuper(CommandRotate);

            _createClass(CommandRotate, [{
              key: "apply",

              /**
              *
              * @param {com.vzome.core.construction.ConstructionList} parameters
              * @param {com.vzome.core.commands.AttributeMap} attributes
              * @param {*} effects
              * @return {com.vzome.core.construction.ConstructionList}
              */
              value: function apply(parameters, attributes, effects) {
                var center = this.setSymmetry(attributes);
                var norm = attributes.get(com.vzome.core.commands.CommandTransform.SYMMETRY_AXIS_ATTR_NAME);

                if (norm == null) {
                  throw new com.vzome.core.commands.Command.Failure("no symmetry axis provided");
                }

                var params = parameters.getConstructions();
                var output = new com.vzome.core.construction.ConstructionList();
                var vector = norm.getOffset();
                vector = norm.getField().projectTo3d(vector, true);
                var axis = this.mSymmetry['getAxis$com_vzome_core_algebra_AlgebraicVector'](vector);
                var rotation = axis.getRotation();
                var transform = new com.vzome.core.construction.SymmetryTransformation(this.mSymmetry, rotation, center);
                effects.constructionAdded(transform);
                output.addAll(this.transform(params, transform, effects));
                return output;
              }
            }]);

            function CommandRotate() {
              _classCallCheck(this, CommandRotate);

              return _super148.call(this);
            }

            return CommandRotate;
          }(com.vzome.core.commands.CommandSymmetry);

          commands.CommandRotate = CommandRotate;
          CommandRotate["__class"] = "com.vzome.core.commands.CommandRotate";
          CommandRotate["__interfaces"] = ["com.vzome.core.commands.Command"];
        })(core.commands || (core.commands = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (commands) {
          /**
          * @author Scott Vorthmann
          * @param {*} symmetry
          * @class
          * @extends com.vzome.core.commands.CommandSymmetry
          */
          var CommandAxialSymmetry =
          /*#__PURE__*/
          function (_com$vzome$core$comma25) {
            _inherits(CommandAxialSymmetry, _com$vzome$core$comma25);

            var _super149 = _createSuper(CommandAxialSymmetry);

            function CommandAxialSymmetry() {
              var symmetry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

              _classCallCheck(this, CommandAxialSymmetry);

              return _super149.call(this, symmetry);
            }
            /**
            *
            * @param {com.vzome.core.construction.ConstructionList} parameters
            * @param {com.vzome.core.commands.AttributeMap} attributes
            * @param {*} effects
            * @return {com.vzome.core.construction.ConstructionList}
            */


            _createClass(CommandAxialSymmetry, [{
              key: "apply",
              value: function apply(parameters, attributes, effects) {
                this.setSymmetry(attributes);
                var norm = attributes.get(com.vzome.core.commands.CommandTransform.SYMMETRY_AXIS_ATTR_NAME);

                if (norm == null) {
                  throw new com.vzome.core.commands.Command.Failure("no symmetry axis provided");
                }

                var output = new com.vzome.core.construction.ConstructionList();
                var vector = norm.getOffset();
                vector = norm.getField().projectTo3d(vector, true);
                var axis = this.mSymmetry['getAxis$com_vzome_core_algebra_AlgebraicVector'](vector);
                var rotation = axis.getRotationPermutation();

                if (rotation == null) {
                  throw new com.vzome.core.commands.Command.Failure("symmetry axis does not support axial symmetry");
                }

                var order = rotation.getOrder();
                var rotate = new com.vzome.core.commands.CommandRotate();

                for (var i = 1; i < order; i++) {
                  {
                    for (var index714 = parameters.iterator(); index714.hasNext();) {
                      var param = index714.next();
                      {
                        output.addConstruction(param);
                      }
                    }

                    parameters = rotate.apply(parameters, attributes, effects);
                  }
                }

                for (var index715 = parameters.iterator(); index715.hasNext();) {
                  var _param2 = index715.next();

                  {
                    output.addConstruction(_param2);
                  }
                }

                return output;
              }
            }]);

            return CommandAxialSymmetry;
          }(com.vzome.core.commands.CommandSymmetry);

          commands.CommandAxialSymmetry = CommandAxialSymmetry;
          CommandAxialSymmetry["__class"] = "com.vzome.core.commands.CommandAxialSymmetry";
          CommandAxialSymmetry["__interfaces"] = ["com.vzome.core.commands.Command"];
        })(core.commands || (core.commands = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          /**
          * @author David Hall
          * @param {*} editor
          * @class
          * @extends com.vzome.core.editor.api.ChangeManifestations
          */
          var PanelPanelIntersection =
          /*#__PURE__*/
          function (_com$vzome$core$edito19) {
            _inherits(PanelPanelIntersection, _com$vzome$core$edito19);

            var _super150 = _createSuper(PanelPanelIntersection);

            function PanelPanelIntersection(editor) {
              _classCallCheck(this, PanelPanelIntersection);

              return _super150.call(this, editor);
            }
            /**
            *
            */


            _createClass(PanelPanelIntersection, [{
              key: "perform",
              value: function perform() {
                var panel0 = null;
                var panel1 = null;
                var nPanels = 0;

                for (var index716 = this.mSelection.iterator(); index716.hasNext();) {
                  var man = index716.next();
                  {
                    this.unselect$com_vzome_core_model_Manifestation(man);

                    if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0)) {
                      switch (nPanels++) {
                        case 0:
                          panel0 = man;
                          break;

                        case 1:
                          panel1 = man;
                          break;
                      }
                    }
                  }
                }

                if (nPanels !== 2) {
                  var msg;

                  switch (nPanels) {
                    case 0:
                      msg = "No panels are selected.";
                      break;

                    case 1:
                      msg = "One panel is selected.";
                      break;

                    default:
                      msg = nPanels + " panels are selected.";
                      break;
                  }

                  this.fail(msg + " Two are required.");
                }

                if (com.vzome.core.algebra.AlgebraicVectors.areParallel(panel0['getNormal$'](), panel1['getNormal$']())) {
                  var vertices = new java.util.ArrayList();
                  {
                    var array718 = [panel0, panel1];

                    for (var index717 = 0; index717 < array718.length; index717++) {
                      var panel = array718[index717];
                      {
                        for (var index719 = panel.iterator(); index719.hasNext();) {
                          var v = index719.next();
                          {
                            vertices.add(v);
                          }
                        }
                      }
                    }
                  }
                  this.fail("Panels are " + (com.vzome.core.algebra.AlgebraicVectors.areCoplanar(vertices) ? "coplanar" : "parallel") + ".");
                }

                this.redo();
                var segment = new com.vzome.core.construction.PolygonPolygonProjectionToSegment(PanelPanelIntersection.polygonFromPanel(panel0), PanelPanelIntersection.polygonFromPanel(panel1));
                var start = new com.vzome.core.construction.FreePoint(segment.getStart());
                var end = new com.vzome.core.construction.FreePoint(segment.getEnd());
                this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(segment));
                this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(start));
                this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(end));
                this.redo();
              }
              /*private*/

            }, {
              key: "getXmlElementName",

              /**
              *
              * @return {string}
              */
              value: function getXmlElementName() {
                return (
                  /* getSimpleName */
                  function (c) {
                    return c["__class"] ? c["__class"].substring(c["__class"].lastIndexOf('.') + 1) : c["name"].substring(c["name"].lastIndexOf('.') + 1);
                  }(this.constructor)
                );
              }
            }], [{
              key: "polygonFromPanel",
              value: function polygonFromPanel(panel) {
                var vertices = new java.util.ArrayList(panel.getVertexCount());

                for (var index720 = panel.iterator(); index720.hasNext();) {
                  var vector = index720.next();
                  {
                    vertices.add(new com.vzome.core.construction.FreePoint(vector));
                  }
                }

                return new com.vzome.core.construction.PolygonFromVertices(vertices);
              }
            }]);

            return PanelPanelIntersection;
          }(com.vzome.core.editor.api.ChangeManifestations);

          edits.PanelPanelIntersection = PanelPanelIntersection;
          PanelPanelIntersection["__class"] = "com.vzome.core.edits.PanelPanelIntersection";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          var JoinPoints =
          /*#__PURE__*/
          function (_com$vzome$core$edito20) {
            _inherits(JoinPoints, _com$vzome$core$edito20);

            var _super151 = _createSuper(JoinPoints);

            function JoinPoints(editor) {
              var _this109;

              _classCallCheck(this, JoinPoints);

              _this109 = _super151.call(this, editor);
              _this109.joinMode = JoinPoints.JoinModeEnum.CLOSED_LOOP;
              return _this109;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(JoinPoints, [{
              key: "groupingAware",
              value: function groupingAware() {
                return true;
              }
              /**
              *
              * @param {*} props
              */

            }, {
              key: "configure",
              value: function configure(props) {
                var mode = props.get("mode");
                if (mode != null) this.joinMode =
                /* Enum.valueOf */
                JoinPoints.JoinModeEnum[mode];
              }
              /**
              *
              * @param {*} element
              */

            }, {
              key: "getXmlAttributes",
              value: function getXmlAttributes(element) {
                if (this.joinMode === JoinPoints.JoinModeEnum.CLOSED_LOOP) ;else {
                  element.setAttribute(JoinPoints.ATTRNAME_CLOSEDLOOP, "false");
                  if (this.joinMode !== JoinPoints.JoinModeEnum.CHAIN_BALLS) element.setAttribute(JoinPoints.ATTRNAME_JOINMODE,
                  /* Enum.name */
                  com.vzome.core.edits.JoinPoints.JoinModeEnum[this.joinMode]);
                }
              }
              /**
              *
              * @param {*} xml
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              */

            }, {
              key: "setXmlAttributes",
              value: function setXmlAttributes(xml, format) {
                var attr = xml.getAttribute(JoinPoints.ATTRNAME_JOINMODE);

                if (attr != null && !(attr.length === 0)) {
                  this.joinMode =
                  /* Enum.valueOf */
                  JoinPoints.JoinModeEnum[attr];
                } else {
                  attr = xml.getAttribute(JoinPoints.ATTRNAME_CLOSEDLOOP);

                  if (attr != null && !(attr.length === 0)) {
                    this.joinMode = javaemul.internal.BooleanHelper.parseBoolean(attr) ? JoinPoints.JoinModeEnum.CLOSED_LOOP : JoinPoints.JoinModeEnum.CHAIN_BALLS;
                  } else {
                    this.joinMode = JoinPoints.JoinModeEnum.CLOSED_LOOP;
                  }
                }
              }
              /**
              *
              */

            }, {
              key: "perform",
              value: function perform() {
                var inputs = new java.util.ArrayList();
                if (this.joinMode !== JoinPoints.JoinModeEnum.ALL_POSSIBLE) this.setOrderedSelection(true);

                for (var index721 = this.mSelection.iterator(); index721.hasNext();) {
                  var man = index721.next();
                  {
                    if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0)) {
                      inputs.add(man.getFirstConstruction());
                    }

                    this.unselect$com_vzome_core_model_Manifestation(man);
                  }
                }

                this.redo();
                var last = inputs.size() - 1;

                if (last > 0) {
                  var points = inputs.toArray([]);

                  switch (this.joinMode) {
                    case com.vzome.core.edits.JoinPoints.JoinModeEnum.CHAIN_BALLS:
                      for (var i = 0; i < last; i++) {
                        {
                          this.addSegment(points, i, i + 1);
                        }
                      }

                      break;

                    case com.vzome.core.edits.JoinPoints.JoinModeEnum.CLOSED_LOOP:
                      for (var _i35 = 0; _i35 < last; _i35++) {
                        {
                          this.addSegment(points, _i35, _i35 + 1);
                        }
                      }

                      if (last > 1) {
                        this.addSegment(points, last, 0);
                      }

                      break;

                    case com.vzome.core.edits.JoinPoints.JoinModeEnum.ALL_TO_FIRST:
                      for (var _i36 = 1; _i36 <= last; _i36++) {
                        {
                          this.addSegment(points, 0, _i36);
                        }
                      }

                      break;

                    case com.vzome.core.edits.JoinPoints.JoinModeEnum.ALL_TO_LAST:
                      for (var _i37 = 0; _i37 < last; _i37++) {
                        {
                          this.addSegment(points, _i37, last);
                        }
                      }

                      break;

                    case com.vzome.core.edits.JoinPoints.JoinModeEnum.ALL_POSSIBLE:
                      for (var start = 0; start < last; start++) {
                        {
                          for (var end = start + 1; end <= last; end++) {
                            {
                              this.addSegment(points, start, end);
                            }
                          }
                        }
                      }

                      break;

                    default:
                      throw new com.vzome.core.commands.Command.Failure("Unsupported JoinModeEnum: " + com.vzome.core.edits.JoinPoints.JoinModeEnum["_$wrappers"][this.joinMode].toString());
                  }

                  this.redo();
                }
              }
            }, {
              key: "addSegment",
              value: function addSegment(points, start, end) {
                if (start !== end && !points[start].getLocation().equals(points[end].getLocation())) {
                  var segment = new com.vzome.core.construction.SegmentJoiningPoints(points[start], points[end]);
                  this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(segment));
                }
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "JoinPoints";
              }
            }]);

            return JoinPoints;
          }(com.vzome.core.editor.api.ChangeManifestations);

          JoinPoints.ATTRNAME_CLOSEDLOOP = "closedLoop";
          JoinPoints.ATTRNAME_JOINMODE = "joinMode";
          edits.JoinPoints = JoinPoints;
          JoinPoints["__class"] = "com.vzome.core.edits.JoinPoints";

          (function (JoinPoints) {
            (function (JoinModeEnum) {
              JoinModeEnum[JoinModeEnum["CHAIN_BALLS"] = 0] = "CHAIN_BALLS";
              JoinModeEnum[JoinModeEnum["CLOSED_LOOP"] = 1] = "CLOSED_LOOP";
              JoinModeEnum[JoinModeEnum["ALL_TO_FIRST"] = 2] = "ALL_TO_FIRST";
              JoinModeEnum[JoinModeEnum["ALL_TO_LAST"] = 3] = "ALL_TO_LAST";
              JoinModeEnum[JoinModeEnum["ALL_POSSIBLE"] = 4] = "ALL_POSSIBLE";
            })(JoinPoints.JoinModeEnum || (JoinPoints.JoinModeEnum = {}));
          })(JoinPoints = edits.JoinPoints || (edits.JoinPoints = {}));
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          var ShowNormals =
          /*#__PURE__*/
          function (_com$vzome$core$edito21) {
            _inherits(ShowNormals, _com$vzome$core$edito21);

            var _super152 = _createSuper(ShowNormals);

            function ShowNormals(editor) {
              _classCallCheck(this, ShowNormals);

              return _super152.call(this, editor);
            }
            /**
            *
            */


            _createClass(ShowNormals, [{
              key: "perform",
              value: function perform() {
                var SCALE_DOWN = this.mManifestations.getField()['createAlgebraicNumber$int$int$int$int'](1, 0, 2, -3);
                this.unselectConnectors();
                this.unselectStruts();

                for (var index722 = com.vzome.core.editor.api.Manifestations.getPanels$java_lang_Iterable(this.mSelection).iterator(); index722.hasNext();) {
                  var panel = index722.next();
                  {
                    this.unselect$com_vzome_core_model_Manifestation(panel);
                    var centroid = panel.getCentroid();
                    var tip = centroid.plus(panel['getNormal$']().scale(SCALE_DOWN));
                    var p1 = new com.vzome.core.construction.FreePoint(centroid);
                    var p2 = new com.vzome.core.construction.FreePoint(tip);
                    var s = new com.vzome.core.construction.SegmentJoiningPoints(p1, p2);
                    this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(p1));
                    this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(p2));
                    this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(s));
                  }
                }

                this.redo();
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return ShowNormals.NAME;
              }
            }]);

            return ShowNormals;
          }(com.vzome.core.editor.api.ChangeManifestations);

          ShowNormals.NAME = "ShowNormals";
          edits.ShowNormals = ShowNormals;
          ShowNormals["__class"] = "com.vzome.core.edits.ShowNormals";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          var ShowPoint =
          /*#__PURE__*/
          function (_com$vzome$core$edito22) {
            _inherits(ShowPoint, _com$vzome$core$edito22);

            var _super153 = _createSuper(ShowPoint);

            function ShowPoint(editor) {
              var _this110;

              _classCallCheck(this, ShowPoint);

              _this110 = _super153.call(this, editor);
              if (_this110.point === undefined) _this110.point = null;
              if (_this110.parameters === undefined) _this110.parameters = null;
              _this110.parameters = editor;
              return _this110;
            }
            /**
            *
            * @param {*} props
            */


            _createClass(ShowPoint, [{
              key: "configure",
              value: function configure(props) {
                switch (props.get("mode")) {
                  case "origin":
                    var _origin = this.mManifestations.getField().origin(3);

                    this.point = new com.vzome.core.construction.FreePoint(_origin);
                    break;

                  case "symmCenter":
                    this.point = this.parameters.getCenterPoint();
                    break;
                }
              }
              /**
              *
              */

            }, {
              key: "perform",
              value: function perform() {
                this.manifestConstruction(this.point);
                this.redo();
              }
              /**
              *
              * @param {*} xml
              */

            }, {
              key: "getXmlAttributes",
              value: function getXmlAttributes(xml) {
                com.vzome.core.commands.XmlSaveFormat.serializePoint(xml, "point", this.point);
              }
              /**
              *
              * @param {*} xml
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              */

            }, {
              key: "setXmlAttributes",
              value: function setXmlAttributes(xml, format) {
                if (format.commandEditsCompacted()) this.point = format.parsePoint$org_w3c_dom_Element$java_lang_String(xml, "point");else {
                  var attrs = format.loadCommandAttributes$org_w3c_dom_Element(xml);
                  this.point = attrs.get("point");
                }
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "ShowPoint";
              }
            }]);

            return ShowPoint;
          }(com.vzome.core.editor.api.ChangeManifestations);

          edits.ShowPoint = ShowPoint;
          ShowPoint["__class"] = "com.vzome.core.edits.ShowPoint";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          /**
          * This is only used when opening legacy files.  The UI and controllers now use the generic Polytope4d.
          * @author Scott Vorthmann
          * @param {*} editorModel
          * @param {com.vzome.core.construction.Segment} symmAxis
          * @param {number} index
          * @class
          * @extends com.vzome.core.editor.api.ChangeManifestations
          */
          var B4Polytope =
          /*#__PURE__*/
          function (_com$vzome$core$edito23) {
            _inherits(B4Polytope, _com$vzome$core$edito23);

            var _super154 = _createSuper(B4Polytope);

            function B4Polytope(editorModel, symmAxis, index) {
              var _this111;

              _classCallCheck(this, B4Polytope);

              if ((editorModel != null && (editorModel["__interfaces"] != null && editorModel["__interfaces"].indexOf("com.vzome.core.editor.api.EditorModel") >= 0 || editorModel.constructor != null && editorModel.constructor["__interfaces"] != null && editorModel.constructor["__interfaces"].indexOf("com.vzome.core.editor.api.EditorModel") >= 0) || editorModel === null) && (symmAxis != null && symmAxis instanceof com.vzome.core.construction.Segment || symmAxis === null) && (typeof index === 'number' || index === null)) {
                _this111 = _super154.call(this, editorModel);
                if (_this111.index === undefined) _this111.index = 0;
                if (_this111.proj === undefined) _this111.proj = null;
                if (_this111.symmAxis === undefined) _this111.symmAxis = null;
                if (_this111.field === undefined) _this111.field = null;
                if (_this111.index === undefined) _this111.index = 0;
                if (_this111.proj === undefined) _this111.proj = null;
                if (_this111.symmAxis === undefined) _this111.symmAxis = null;
                if (_this111.field === undefined) _this111.field = null;

                (function () {
                  _this111.field = _this111.mManifestations.getField();
                  _this111.index = index;
                  _this111.symmAxis = symmAxis;
                })();
              } else if ((editorModel != null && (editorModel["__interfaces"] != null && editorModel["__interfaces"].indexOf("com.vzome.core.editor.api.EditorModel") >= 0 || editorModel.constructor != null && editorModel.constructor["__interfaces"] != null && editorModel.constructor["__interfaces"].indexOf("com.vzome.core.editor.api.EditorModel") >= 0) || editorModel === null) && symmAxis === undefined && index === undefined) {
                {
                  var _symmAxis = null;
                  var _index = 0;
                  _this111 = _super154.call(this, editorModel);
                  if (_this111.index === undefined) _this111.index = 0;
                  if (_this111.proj === undefined) _this111.proj = null;
                  if (_this111.symmAxis === undefined) _this111.symmAxis = null;
                  if (_this111.field === undefined) _this111.field = null;
                  if (_this111.index === undefined) _this111.index = 0;
                  if (_this111.proj === undefined) _this111.proj = null;
                  if (_this111.symmAxis === undefined) _this111.symmAxis = null;
                  if (_this111.field === undefined) _this111.field = null;

                  (function () {
                    _this111.field = _this111.mManifestations.getField();
                    _this111.index = _index;
                    _this111.symmAxis = _symmAxis;
                  })();
                }
              } else throw new Error('invalid overload');

              return _possibleConstructorReturn(_this111);
            }
            /**
            *
            * @return {string}
            */


            _createClass(B4Polytope, [{
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "B4Polytope";
              }
              /**
              *
              * @param {*} result
              */

            }, {
              key: "getXmlAttributes",
              value: function getXmlAttributes(result) {
                com.vzome.xml.DomUtils.addAttribute(result, "dynkin",
                /* toString */
                '' + this.index);
                if (this.symmAxis != null) com.vzome.core.commands.XmlSaveFormat.serializeSegment(result, "start", "end", this.symmAxis);
              }
              /**
              *
              * @param {*} xml
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              */

            }, {
              key: "setXmlAttributes",
              value: function setXmlAttributes(xml, format) {
                var binary = xml.getAttribute("dynkin");
                this.index = javaemul.internal.IntegerHelper.parseInt(binary, 2);
                if (format.commandEditsCompacted()) this.symmAxis = format.parseSegment$org_w3c_dom_Element$java_lang_String$java_lang_String(xml, "start", "end");else {
                  var attrs = format.loadCommandAttributes$org_w3c_dom_Element(xml);
                  this.symmAxis = attrs.get("rotation");
                }
              }
              /**
              *
              */

            }, {
              key: "perform",
              value: function perform() {
                if (this.symmAxis == null) this.proj = new com.vzome.core.math.Projection.Default(this.field);else {
                  var scale = this.field['createPower$int'](-5);
                  this.proj = new com.vzome.core.math.QuaternionProjection(this.field, null, this.symmAxis.getOffset().scale(scale));
                }
                var edgeScales = [null, null, null, null];

                for (var i = 0; i < edgeScales.length; i++) {
                  {
                    edgeScales[i] = this.field['createPower$int'](0);
                  }
                }

                var group = new com.vzome.core.math.symmetry.B4Group(this.field);
                com.vzome.core.math.symmetry.WythoffConstruction.constructPolytope(group, this.index, this.index, edgeScales, group, new B4Polytope.WythoffListener(this, this.field));
                this.redo();
              }
            }]);

            return B4Polytope;
          }(com.vzome.core.editor.api.ChangeManifestations);

          edits.B4Polytope = B4Polytope;
          B4Polytope["__class"] = "com.vzome.core.edits.B4Polytope";

          (function (B4Polytope) {
            var WythoffListener =
            /*#__PURE__*/
            function () {
              function WythoffListener(__parent, field) {
                _classCallCheck(this, WythoffListener);

                this.__parent = __parent;
                this.numVertices = 0;
                if (this.scale === undefined) this.scale = null;
                this.scale = field['createPower$int'](5);
              }
              /**
              *
              * @param {*} p1
              * @param {*} p2
              * @return {*}
              */


              _createClass(WythoffListener, [{
                key: "addEdge",
                value: function addEdge(p1, p2) {
                  var edge = new com.vzome.core.construction.SegmentJoiningPoints(p1, p2);

                  this.__parent.manifestConstruction(edge);

                  return edge;
                }
                /**
                *
                * @param {Array} vertices
                * @return {*}
                */

              }, {
                key: "addFace",
                value: function addFace(vertices) {
                  return null;
                }
                /**
                *
                * @param {com.vzome.core.algebra.AlgebraicVector} vertex
                * @return {*}
                */

              }, {
                key: "addVertex",
                value: function addVertex(vertex) {
                  var projected = vertex;
                  if (this.__parent.proj != null) projected = this.__parent.proj.projectImage(vertex, true);
                  var p = new com.vzome.core.construction.FreePoint(projected.scale(this.scale));
                  p.setIndex(this.numVertices++);

                  this.__parent.manifestConstruction(p);

                  return p;
                }
              }]);

              return WythoffListener;
            }();

            B4Polytope.WythoffListener = WythoffListener;
            WythoffListener["__class"] = "com.vzome.core.edits.B4Polytope.WythoffListener";
            WythoffListener["__interfaces"] = ["com.vzome.core.math.symmetry.WythoffConstruction.Listener"];
          })(B4Polytope = edits.B4Polytope || (edits.B4Polytope = {}));
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          var CrossProduct =
          /*#__PURE__*/
          function (_com$vzome$core$edito24) {
            _inherits(CrossProduct, _com$vzome$core$edito24);

            var _super155 = _createSuper(CrossProduct);

            _createClass(CrossProduct, [{
              key: "perform",

              /**
              *
              */
              value: function perform() {
                var p1 = null;
                var p2 = null;
                var s1 = null;
                var success = false;
                this.setOrderedSelection(true);

                for (var index723 = this.mSelection.iterator(); index723.hasNext();) {
                  var man = index723.next();
                  {
                    if (success) {
                      this.recordSelected(man);
                    } else {
                      this.unselect$com_vzome_core_model_Manifestation(man);

                      if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0)) {
                        var nextPoint = man.getFirstConstruction();

                        if (p1 == null) {
                          p1 = nextPoint;
                        } else if (s1 == null) {
                          p2 = nextPoint;
                          s1 = new com.vzome.core.construction.SegmentJoiningPoints(p1, nextPoint);
                        } else if (!success) {
                          var segment = new com.vzome.core.construction.SegmentJoiningPoints(p2, nextPoint);
                          segment = new com.vzome.core.construction.SegmentCrossProduct(s1, segment);
                          this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(segment));
                          var endpt = new com.vzome.core.construction.SegmentEndPoint(segment);
                          this.manifestConstruction(endpt);
                          success = true;
                        } else this.recordSelected(man);
                      }
                    }
                  }
                }

                if (!success) throw new com.vzome.core.commands.Command.Failure("cross-product requires three selected vertices");
                this.redo();
              }
            }]);

            function CrossProduct(editorModel) {
              _classCallCheck(this, CrossProduct);

              return _super155.call(this, editorModel);
            }
            /**
            *
            * @return {string}
            */


            _createClass(CrossProduct, [{
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "CrossProduct";
              }
            }]);

            return CrossProduct;
          }(com.vzome.core.editor.api.ChangeManifestations);

          edits.CrossProduct = CrossProduct;
          CrossProduct["__class"] = "com.vzome.core.edits.CrossProduct";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          var ShowHidden =
          /*#__PURE__*/
          function (_com$vzome$core$edito25) {
            _inherits(ShowHidden, _com$vzome$core$edito25);

            var _super156 = _createSuper(ShowHidden);

            function ShowHidden(editor) {
              _classCallCheck(this, ShowHidden);

              return _super156.call(this, editor);
            }
            /**
            *
            */


            _createClass(ShowHidden, [{
              key: "perform",
              value: function perform() {
                for (var index724 = this.mManifestations.iterator(); index724.hasNext();) {
                  var m = index724.next();
                  {
                    if (m.isHidden()) {
                      this.showManifestation(m);
                      this.select$com_vzome_core_model_Manifestation(m);
                    } else if (this.mSelection.manifestationSelected(m)) this.unselect$com_vzome_core_model_Manifestation(m);
                  }
                }

                this.redo();
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "ShowHidden";
              }
            }]);

            return ShowHidden;
          }(com.vzome.core.editor.api.ChangeManifestations);

          edits.ShowHidden = ShowHidden;
          ShowHidden["__class"] = "com.vzome.core.edits.ShowHidden";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          var PolarZonohedron =
          /*#__PURE__*/
          function (_com$vzome$core$edito26) {
            _inherits(PolarZonohedron, _com$vzome$core$edito26);

            var _super157 = _createSuper(PolarZonohedron);

            function PolarZonohedron(editor) {
              var _this112;

              _classCallCheck(this, PolarZonohedron);

              _this112 = _super157.call(this, editor);
              if (_this112.symmetry === undefined) _this112.symmetry = null;
              if (_this112.editor === undefined) _this112.editor = null;
              _this112.editor = editor;
              _this112.symmetry = editor['getSymmetrySystem$']();
              return _this112;
            }
            /**
            *
            * @return {string}
            */


            _createClass(PolarZonohedron, [{
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "PolarZonohedron";
              }
              /**
              *
              * @param {*} element
              */

            }, {
              key: "getXmlAttributes",
              value: function getXmlAttributes(element) {
                if (this.symmetry != null) {
                  com.vzome.xml.DomUtils.addAttribute(element, "symmetry", this.symmetry.getName());
                }
              }
              /**
              *
              * @param {*} xml
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              */

            }, {
              key: "setXmlAttributes",
              value: function setXmlAttributes(xml, format) {
                this.symmetry = this.editor['getSymmetrySystem$java_lang_String'](xml.getAttribute("symmetry"));
              }
              /**
              *
              */

            }, {
              key: "perform",
              value: function perform() {
                var errorMsg = new java.lang.StringBuilder();
                errorMsg.append("The Polar Zonohedron command requires either of the following selections:\n\n1) Two non-collinear struts with a common end point.\n   The first strut must have more than 2-fold rotational symmetry.\n   The second strut will be rotated around the first.\n\n2) Any three or more struts having a common end point.\n");
                var struts = new java.util.ArrayList();

                for (var index725 = this.mSelection.iterator(); index725.hasNext();) {
                  var man = index725.next();
                  {
                    if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0)) {
                      struts.add(man);
                    }

                    this.unselect$com_vzome_core_model_Manifestation(man);
                  }
                }

                if (struts.size() < 2) {
                  errorMsg.append(struts.size() === 1 ? "\nonly one strut is selected." : "\nno struts are selected.");
                  this.fail(errorMsg.toString());
                }

                var common = struts.size() === 2 ? this.useRotationalSymmetry(struts, errorMsg) : this.useRadialSelection(struts);

                if (common == null) {
                  this.fail(errorMsg.append("\nselected struts do not have a common end point").toString());
                }

                var L1 = 0;
                var L2 = 1;
                var layers = struts.size();
                var offsets = new java.util.ArrayList(layers);
                var vertices = [null, null];

                vertices[L1] = function (s) {
                  var a = [];

                  while (s-- > 0) {
                    a.push(null);
                  }

                  return a;
                }(layers);

                for (var i = 0; i < layers; i++) {
                  {
                    var strut = struts.get(i);
                    var start = strut.getLocation();
                    var end = strut.getEnd();
                    var offset = strut.getOffset();

                    if (start.equals(common)) {
                      vertices[L1][i] = end;
                      offsets.add(offset);
                    } else {
                      vertices[L1][i] = start;
                      offsets.add(offset.negate());
                    }
                  }
                }

                for (var layer = 1; layer < layers; layer++) {
                  {
                    vertices[L2] = function (s) {
                      var a = [];

                      while (s-- > 0) {
                        a.push(null);
                      }

                      return a;
                    }(layers);

                    for (var _i38 = 0; _i38 < layers; _i38++) {
                      {
                        var off = (_i38 + layer) % layers;

                        var _offset = offsets.get(off);

                        var v1 = vertices[L1][_i38];
                        var v2 = v1.plus(_offset);
                        var v3 = vertices[L1][(_i38 + 1) % layers];
                        var v0 = v3.minus(_offset);
                        vertices[L2][_i38] = v2;
                        var p0 = new com.vzome.core.construction.FreePoint(v0);
                        var p1 = new com.vzome.core.construction.FreePoint(v1);
                        var p2 = new com.vzome.core.construction.FreePoint(v2);
                        var p3 = new com.vzome.core.construction.FreePoint(v3);
                        this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(p0));
                        this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(p1));
                        this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(p2));
                        this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(p3));
                        this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(new com.vzome.core.construction.SegmentJoiningPoints(p1, p2)));
                        this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(new com.vzome.core.construction.SegmentJoiningPoints(p2, p3)));
                        this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(new com.vzome.core.construction.PolygonFromVertices([p0, p1, p2, p3])));
                      }
                    }

                    vertices[L1] = vertices[L2];
                  }
                }

                this.redo();
              }
            }, {
              key: "useRotationalSymmetry",

              /*private*/
              value: function useRotationalSymmetry(struts, errorMsg) {
                var axisStrut = struts.get(0);
                var axisSegment = axisStrut.getFirstConstruction();
                var v1 = axisSegment.getOffset();
                v1 = axisSegment.getField().projectTo3d(v1, true);
                var axis1 = this.symmetry.getAxis(v1);

                if (axis1 == null) {
                  this.fail(errorMsg.append("\nfirst selected strut is not an axis of rotational symmetry").toString());
                }

                var perm = axis1.getRotationPermutation();

                if (perm == null) {
                  this.fail(errorMsg.append("\nfirst selected strut is not an axis of rotation").toString());
                }

                var rotation = perm.mapIndex(0);
                var order = perm.getOrder();

                if (order <= 2) {
                  this.fail(errorMsg.append("\nfirst selected strut has " + order + "-fold symmetry").toString());
                }

                var spokeStrut = struts.get(1);
                var spokeSegment = spokeStrut.getFirstConstruction();
                var v2 = spokeSegment.getOffset();

                if (v1.equals(v2) || v1.equals(v2.negate())) {
                  this.fail(errorMsg.append("\nselected struts are collinear").toString());
                }

                var common = PolarZonohedron.getCommonEndpoint(axisStrut, spokeStrut);

                if (common == null) {
                  this.fail(errorMsg.append("\nselected struts do not have a common end point").toString());
                }

                var s1 = axisSegment.getStart();
                var e1 = axisSegment.getEnd();
                var center = new com.vzome.core.construction.SegmentEndPoint(axisSegment, common.equals(e1));
                var s2 = spokeSegment.getStart();
                var e2 = spokeSegment.getEnd();

                if (common.equals(s1)) {
                  if (common.equals(e2)) {
                    v2 = v2.negate();
                    e2 = s2;
                    s2 = common;
                  }
                } else {
                  v1 = v1.negate();
                  e1 = s1;
                  s1 = common;

                  if (common.equals(e2)) {
                    v2 = v2.negate();
                    e2 = s2;
                    s2 = common;
                  }
                }

                this.redo();
                struts.remove(axisStrut);
                this.select$com_vzome_core_model_Manifestation(spokeStrut);
                var p0 = new com.vzome.core.construction.FreePoint(s2);
                var p1 = new com.vzome.core.construction.FreePoint(e2);
                this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(p0));
                this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(p1));

                for (var i = 0; i < order - 1; i++) {
                  {
                    var transform = new com.vzome.core.construction.SymmetryTransformation(this.symmetry.getSymmetry(), rotation, center);
                    rotation = perm.mapIndex(rotation);
                    var ball = this.manifestConstruction(new com.vzome.core.construction.TransformedPoint(transform, p1));
                    var strut = this.manifestConstruction(new com.vzome.core.construction.TransformedSegment(transform, spokeSegment));
                    struts.add(strut);
                    this.select$com_vzome_core_model_Manifestation(ball);
                    this.select$com_vzome_core_model_Manifestation(strut);
                  }
                }

                this.redo();
                return common;
              }
              /*private*/

            }, {
              key: "useRadialSelection",
              value: function useRadialSelection(struts) {
                var first = struts.get(0);
                var common = PolarZonohedron.getCommonEndpoint(first, struts.get(1));

                if (common == null) {
                  return null;
                }

                for (var i = 1; i < struts.size(); i++) {
                  {
                    if (!common.equals(PolarZonohedron.getCommonEndpoint(first, struts.get(i)))) {
                      return null;
                    }
                  }
                }

                this.redo();
                this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(new com.vzome.core.construction.FreePoint(common)));

                for (var index726 = struts.iterator(); index726.hasNext();) {
                  var strut = index726.next();
                  {
                    this.select$com_vzome_core_model_Manifestation(strut);
                    var start = strut.getLocation();

                    if (common.equals(start)) {
                      this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(new com.vzome.core.construction.FreePoint(strut.getEnd())));
                    } else {
                      this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(new com.vzome.core.construction.FreePoint(start)));
                    }
                  }
                }

                this.redo();
                return common;
              }
            }], [{
              key: "getCommonEndpoint",
              value: function getCommonEndpoint(strut1, strut2) {
                if (
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(strut1, strut2)) {
                  throw new java.lang.IllegalArgumentException("Identical struts have both end points in common.");
                }

                var start1 = strut1.getLocation();
                var end1 = strut1.getEnd();
                var start2 = strut2.getLocation();
                var end2 = strut2.getEnd();
                if (start1.equals(start2) || start1.equals(end2)) return start1;
                if (end1.equals(start2) || end1.equals(end2)) return end1;
                return null;
              }
            }]);

            return PolarZonohedron;
          }(com.vzome.core.editor.api.ChangeManifestations);

          edits.PolarZonohedron = PolarZonohedron;
          PolarZonohedron["__class"] = "com.vzome.core.edits.PolarZonohedron";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          var TransformSelection =
          /*#__PURE__*/
          function (_com$vzome$core$edito27) {
            _inherits(TransformSelection, _com$vzome$core$edito27);

            var _super158 = _createSuper(TransformSelection);

            function TransformSelection(editor, transform) {
              var _this113;

              _classCallCheck(this, TransformSelection);

              _this113 = _super158.call(this, editor);
              if (_this113.transform === undefined) _this113.transform = null;
              _this113.transform = transform;
              return _this113;
            }
            /**
            *
            */


            _createClass(TransformSelection, [{
              key: "perform",
              value: function perform() {
                var inputs = new java.util.ArrayList();

                for (var index727 = this.mSelection.iterator(); index727.hasNext();) {
                  var man = index727.next();
                  {
                    this.unselect$com_vzome_core_model_Manifestation(man);
                    inputs.add(man);
                  }
                }

                this.redo();

                for (var index728 = inputs.iterator(); index728.hasNext();) {
                  var m = index728.next();
                  {
                    if (!m.isRendered()) continue;
                    var c = m.getFirstConstruction();
                    var result = this.transform.transform$com_vzome_core_construction_Construction(c);
                    this.select$com_vzome_core_model_Manifestation$boolean(this.manifestConstruction(result), true);
                  }
                }

                this.redo();
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "TransformSelection";
              }
            }]);

            return TransformSelection;
          }(com.vzome.core.editor.api.ChangeManifestations);

          edits.TransformSelection = TransformSelection;
          TransformSelection["__class"] = "com.vzome.core.edits.TransformSelection";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          var Polytope4d =
          /*#__PURE__*/
          function (_com$vzome$core$edito28) {
            _inherits(Polytope4d, _com$vzome$core$edito28);

            var _super159 = _createSuper(Polytope4d);

            function Polytope4d(editor, symmetries, quaternion, index, groupName, edgesToRender, edgeScales, renderGroupName) {
              var _this114;

              _classCallCheck(this, Polytope4d);

              if ((editor != null && (editor["__interfaces"] != null && editor["__interfaces"].indexOf("com.vzome.core.editor.api.EditorModel") >= 0 || editor.constructor != null && editor.constructor["__interfaces"] != null && editor.constructor["__interfaces"].indexOf("com.vzome.core.editor.api.EditorModel") >= 0) || editor === null) && (symmetries != null && (symmetries["__interfaces"] != null && symmetries["__interfaces"].indexOf("com.vzome.core.math.symmetry.Symmetries4D") >= 0 || symmetries.constructor != null && symmetries.constructor["__interfaces"] != null && symmetries.constructor["__interfaces"].indexOf("com.vzome.core.math.symmetry.Symmetries4D") >= 0) || symmetries === null) && (quaternion != null && quaternion instanceof com.vzome.core.algebra.AlgebraicVector || quaternion === null) && (typeof index === 'number' || index === null) && (typeof groupName === 'string' || groupName === null) && (typeof edgesToRender === 'number' || edgesToRender === null) && (edgeScales != null && edgeScales instanceof Array && (edgeScales.length == 0 || edgeScales[0] == null || edgeScales[0] != null && (edgeScales[0]["__interfaces"] != null && edgeScales[0]["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0 || edgeScales[0].constructor != null && edgeScales[0].constructor["__interfaces"] != null && edgeScales[0].constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0)) || edgeScales === null) && (typeof renderGroupName === 'string' || renderGroupName === null)) {
                _this114 = _super159.call(this, editor);
                if (_this114.index === undefined) _this114.index = 0;
                if (_this114.field === undefined) _this114.field = null;
                if (_this114.proj === undefined) _this114.proj = null;
                if (_this114.quaternion === undefined) _this114.quaternion = null;
                if (_this114.groupName === undefined) _this114.groupName = null;
                if (_this114.renderGroupName === undefined) _this114.renderGroupName = null;
                if (_this114.symmetries === undefined) _this114.symmetries = null;
                _this114.edgesToRender = 15;
                _this114.edgeScales = [null, null, null, null];
                if (_this114.index === undefined) _this114.index = 0;
                if (_this114.field === undefined) _this114.field = null;
                if (_this114.proj === undefined) _this114.proj = null;
                if (_this114.quaternion === undefined) _this114.quaternion = null;
                if (_this114.groupName === undefined) _this114.groupName = null;
                if (_this114.renderGroupName === undefined) _this114.renderGroupName = null;
                if (_this114.symmetries === undefined) _this114.symmetries = null;

                (function () {
                  _this114.symmetries = symmetries;
                  _this114.field = editor.getRealizedModel().getField();
                  _this114.index = index;
                  _this114.quaternion = quaternion;
                  _this114.groupName = groupName;
                  _this114.renderGroupName = renderGroupName;
                  _this114.edgesToRender = edgesToRender;
                  if (edgeScales != null) _this114.edgeScales = edgeScales;else for (var i = 0; i < _this114.edgeScales.length; i++) {
                    {
                      _this114.edgeScales[i] = _this114.field['createPower$int'](0);
                    }
                  }
                })();
              } else if ((editor != null && (editor["__interfaces"] != null && editor["__interfaces"].indexOf("com.vzome.core.editor.api.EditorModel") >= 0 || editor.constructor != null && editor.constructor["__interfaces"] != null && editor.constructor["__interfaces"].indexOf("com.vzome.core.editor.api.EditorModel") >= 0) || editor === null) && (symmetries != null && (symmetries["__interfaces"] != null && symmetries["__interfaces"].indexOf("com.vzome.core.math.symmetry.Symmetries4D") >= 0 || symmetries.constructor != null && symmetries.constructor["__interfaces"] != null && symmetries.constructor["__interfaces"].indexOf("com.vzome.core.math.symmetry.Symmetries4D") >= 0) || symmetries === null) && (quaternion != null && quaternion instanceof com.vzome.core.construction.Segment || quaternion === null) && (typeof index === 'number' || index === null) && (typeof groupName === 'string' || groupName === null) && edgesToRender === undefined && edgeScales === undefined && renderGroupName === undefined) {
                var _args80 = arguments;
                var symmAxis = _args80[2];
                {
                  var _args81 = arguments;

                  var _quaternion = symmAxis == null ? null : symmAxis.getOffset().inflateTo4d$();

                  var _edgesToRender = _args81[3];
                  var _edgeScales = null;
                  var _renderGroupName = _args81[4];
                  _this114 = _super159.call(this, editor);
                  if (_this114.index === undefined) _this114.index = 0;
                  if (_this114.field === undefined) _this114.field = null;
                  if (_this114.proj === undefined) _this114.proj = null;
                  if (_this114.quaternion === undefined) _this114.quaternion = null;
                  if (_this114.groupName === undefined) _this114.groupName = null;
                  if (_this114.renderGroupName === undefined) _this114.renderGroupName = null;
                  if (_this114.symmetries === undefined) _this114.symmetries = null;
                  _this114.edgesToRender = 15;
                  _this114.edgeScales = [null, null, null, null];
                  if (_this114.index === undefined) _this114.index = 0;
                  if (_this114.field === undefined) _this114.field = null;
                  if (_this114.proj === undefined) _this114.proj = null;
                  if (_this114.quaternion === undefined) _this114.quaternion = null;
                  if (_this114.groupName === undefined) _this114.groupName = null;
                  if (_this114.renderGroupName === undefined) _this114.renderGroupName = null;
                  if (_this114.symmetries === undefined) _this114.symmetries = null;

                  (function () {
                    _this114.symmetries = symmetries;
                    _this114.field = editor.getRealizedModel().getField();
                    _this114.index = index;
                    _this114.quaternion = _quaternion;
                    _this114.groupName = groupName;
                    _this114.renderGroupName = _renderGroupName;
                    _this114.edgesToRender = _edgesToRender;
                    if (_edgeScales != null) _this114.edgeScales = _edgeScales;else for (var i = 0; i < _this114.edgeScales.length; i++) {
                      {
                        _this114.edgeScales[i] = _this114.field['createPower$int'](0);
                      }
                    }
                  })();
                }
              } else if ((editor != null && (editor["__interfaces"] != null && editor["__interfaces"].indexOf("com.vzome.core.editor.api.EditorModel") >= 0 || editor.constructor != null && editor.constructor["__interfaces"] != null && editor.constructor["__interfaces"].indexOf("com.vzome.core.editor.api.EditorModel") >= 0) || editor === null) && symmetries === undefined && quaternion === undefined && index === undefined && groupName === undefined && edgesToRender === undefined && edgeScales === undefined && renderGroupName === undefined) {
                {
                  var _args83 = arguments;

                  var _symmetries = _args83[0].get4dSymmetries();

                  var _symmAxis2 = null;
                  var _index2 = 0;
                  var _groupName = null;
                  {
                    var _args84 = arguments;

                    var _quaternion2 = _symmAxis2 == null ? null : _symmAxis2.getOffset().inflateTo4d$();

                    var _edgesToRender2 = _args84[3];
                    var _edgeScales2 = null;
                    var _renderGroupName2 = _args84[4];
                    _this114 = _super159.call(this, editor);
                    if (_this114.index === undefined) _this114.index = 0;
                    if (_this114.field === undefined) _this114.field = null;
                    if (_this114.proj === undefined) _this114.proj = null;
                    if (_this114.quaternion === undefined) _this114.quaternion = null;
                    if (_this114.groupName === undefined) _this114.groupName = null;
                    if (_this114.renderGroupName === undefined) _this114.renderGroupName = null;
                    if (_this114.symmetries === undefined) _this114.symmetries = null;
                    _this114.edgesToRender = 15;
                    _this114.edgeScales = [null, null, null, null];
                    if (_this114.index === undefined) _this114.index = 0;
                    if (_this114.field === undefined) _this114.field = null;
                    if (_this114.proj === undefined) _this114.proj = null;
                    if (_this114.quaternion === undefined) _this114.quaternion = null;
                    if (_this114.groupName === undefined) _this114.groupName = null;
                    if (_this114.renderGroupName === undefined) _this114.renderGroupName = null;
                    if (_this114.symmetries === undefined) _this114.symmetries = null;

                    (function () {
                      _this114.symmetries = _symmetries;
                      _this114.field = editor.getRealizedModel().getField();
                      _this114.index = _index2;
                      _this114.quaternion = _quaternion2;
                      _this114.groupName = _groupName;
                      _this114.renderGroupName = _renderGroupName2;
                      _this114.edgesToRender = _edgesToRender2;
                      if (_edgeScales2 != null) _this114.edgeScales = _edgeScales2;else for (var i = 0; i < _this114.edgeScales.length; i++) {
                        {
                          _this114.edgeScales[i] = _this114.field['createPower$int'](0);
                        }
                      }
                    })();
                  }
                }
              } else throw new Error('invalid overload');

              return _possibleConstructorReturn(_this114);
            }
            /**
            *
            * @param {*} params
            */


            _createClass(Polytope4d, [{
              key: "configure",
              value: function configure(params) {
                this.groupName = params.get("groupName");
                this.renderGroupName = params.get("renderGroupName");
                this.index = params.get("index") | 0;
                this.edgesToRender = params.get("edgesToRender") | 0;
                this.edgeScales = params.get("edgeScales");
                this.quaternion = params.get("quaternion");
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "Polytope4d";
              }
              /**
              *
              * @param {*} xml
              */

            }, {
              key: "getXmlAttributes",
              value: function getXmlAttributes(xml) {
                if (this.quaternion != null) com.vzome.xml.DomUtils.addAttribute(xml, "quaternion", this.quaternion.toParsableString());
                com.vzome.xml.DomUtils.addAttribute(xml, "group", this.groupName);
                com.vzome.xml.DomUtils.addAttribute(xml, "wythoff",
                /* toString */
                '' + this.index);
                if (this.edgesToRender !== 15) com.vzome.xml.DomUtils.addAttribute(xml, "renderEdges",
                /* toString */
                '' + this.edgesToRender);
                if (!function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(this.renderGroupName, this.groupName)) com.vzome.xml.DomUtils.addAttribute(xml, "renderGroup", this.renderGroupName);
              }
              /**
              *
              * @param {*} xml
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              */

            }, {
              key: "setXmlAttributes",
              value: function setXmlAttributes(xml, format) {
                var binary = xml.getAttribute("wythoff");
                this.index = javaemul.internal.IntegerHelper.parseInt(binary, 2);
                var renderString = xml.getAttribute("renderEdges");
                this.edgesToRender = renderString == null ||
                /* isEmpty */
                renderString.length === 0 ? this.index : javaemul.internal.IntegerHelper.parseInt(renderString, 2);
                this.groupName = xml.getAttribute("group");
                var rgString = xml.getAttribute("renderGroup");
                this.renderGroupName = rgString == null ||
                /* isEmpty */
                rgString.length === 0 ? this.groupName : rgString;
                var quatString = xml.getAttribute("quaternion");

                if (quatString != null && !function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }("", quatString)) {
                  if (
                  /* contains */
                  quatString.indexOf("+") != -1) {
                    quatString =
                    /* replace */
                    quatString.split(',').join(' ');
                    quatString =
                    /* replace */
                    quatString.split('(').join(' ');
                    quatString =
                    /* replace */
                    quatString.split(')').join(' ');
                    quatString =
                    /* replace */
                    quatString.split('+').join(' ');
                    var irrat = this.field['getIrrational$int'](0).charAt(0);
                    quatString =
                    /* replace */
                    quatString.split(irrat).join(' ');
                    quatString = quatString + " 0 0 0";
                  }

                  this.quaternion = this.field.parseVector(quatString);
                } else {
                  var segment = null;
                  if (format.commandEditsCompacted()) segment = format.parseSegment$org_w3c_dom_Element$java_lang_String$java_lang_String(xml, "start", "end");else {
                    var attrs = format.loadCommandAttributes$org_w3c_dom_Element(xml);
                    segment = attrs.get("rotation");
                  }
                  if (segment != null) this.quaternion = segment.getOffset().inflateTo4d$();
                }
              }
              /**
              *
              */

            }, {
              key: "perform",
              value: function perform() {
                if (this.quaternion == null) this.proj = new com.vzome.core.math.Projection.Default(this.field);else this.proj = new com.vzome.core.math.QuaternionProjection(this.field, null, this.quaternion.scale(this.field['createPower$int'](-5)));
                this.symmetries.constructPolytope(this.groupName, this.index, this.edgesToRender, this.edgeScales, new Polytope4d.WythoffListener(this));
                this.redo();
              }
            }], [{
              key: "getSupportedGroups",
              value: function getSupportedGroups() {
                return ["A4", "B4/C4", "D4", "F4", "H4"];
              }
            }]);

            return Polytope4d;
          }(com.vzome.core.editor.api.ChangeManifestations);

          edits.Polytope4d = Polytope4d;
          Polytope4d["__class"] = "com.vzome.core.edits.Polytope4d";

          (function (Polytope4d) {
            var WythoffListener =
            /*#__PURE__*/
            function () {
              function WythoffListener(__parent) {
                _classCallCheck(this, WythoffListener);

                this.__parent = __parent;
                this.numVertices = 0;
                this.vertices = new java.util.HashMap();
              }
              /**
              *
              * @param {*} p1
              * @param {*} p2
              * @return {*}
              */


              _createClass(WythoffListener, [{
                key: "addEdge",
                value: function addEdge(p1, p2) {
                  var edge = new com.vzome.core.construction.SegmentJoiningPoints(p1, p2);

                  this.__parent.manifestConstruction(edge);

                  return edge;
                }
                /**
                *
                * @param {Array} vertices
                * @return {*}
                */

              }, {
                key: "addFace",
                value: function addFace(vertices) {
                  return null;
                }
                /**
                *
                * @param {com.vzome.core.algebra.AlgebraicVector} vertex
                * @return {*}
                */

              }, {
                key: "addVertex",
                value: function addVertex(vertex) {
                  var p = this.vertices.get(vertex.toString());

                  if (p == null) {
                    var projected = vertex;
                    if (this.__parent.proj != null) projected = this.__parent.proj.projectImage(vertex, true);
                    projected = projected.scale(this.__parent.field['createPower$int'](5));
                    p = new com.vzome.core.construction.FreePoint(projected);
                    p.setIndex(this.numVertices++);

                    this.__parent.manifestConstruction(p);

                    this.vertices.put(vertex.toString(), p);
                  }

                  return p;
                }
              }]);

              return WythoffListener;
            }();

            Polytope4d.WythoffListener = WythoffListener;
            WythoffListener["__class"] = "com.vzome.core.edits.Polytope4d.WythoffListener";
            WythoffListener["__interfaces"] = ["com.vzome.core.math.symmetry.WythoffConstruction.Listener"];
          })(Polytope4d = edits.Polytope4d || (edits.Polytope4d = {}));
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          var ShowVertices =
          /*#__PURE__*/
          function (_com$vzome$core$edito29) {
            _inherits(ShowVertices, _com$vzome$core$edito29);

            var _super160 = _createSuper(ShowVertices);

            function ShowVertices(editor) {
              _classCallCheck(this, ShowVertices);

              return _super160.call(this, editor);
            }
            /**
            *
            */


            _createClass(ShowVertices, [{
              key: "perform",
              value: function perform() {
                for (var index729 = this.mSelection.iterator(); index729.hasNext();) {
                  var man = index729.next();
                  {
                    this.unselect$com_vzome_core_model_Manifestation(man);

                    if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0)) {
                      var s = man.getFirstConstruction();
                      var start = new com.vzome.core.construction.SegmentEndPoint(s, true);
                      this.manifestConstruction(start);
                      var end = new com.vzome.core.construction.SegmentEndPoint(s, false);
                      this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(end));
                    } else if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0)) {
                      var polygon = man.getFirstConstruction();

                      for (var i = 0; i < polygon.getVertexCount(); i++) {
                        {
                          var v = new com.vzome.core.construction.PolygonVertex(polygon, i);
                          this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(v));
                        }
                      }
                    }
                  }
                }

                this.redo();
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return ShowVertices.NAME;
              }
            }]);

            return ShowVertices;
          }(com.vzome.core.editor.api.ChangeManifestations);

          ShowVertices.NAME = "ShowVertices";
          edits.ShowVertices = ShowVertices;
          ShowVertices["__class"] = "com.vzome.core.edits.ShowVertices";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          var JoinSkewLines =
          /*#__PURE__*/
          function (_com$vzome$core$edito30) {
            _inherits(JoinSkewLines, _com$vzome$core$edito30);

            var _super161 = _createSuper(JoinSkewLines);

            function JoinSkewLines(editor) {
              _classCallCheck(this, JoinSkewLines);

              return _super161.call(this, editor);
            }
            /**
            *
            */


            _createClass(JoinSkewLines, [{
              key: "perform",
              value: function perform() {
                var errorMsg = new java.lang.StringBuilder();
                errorMsg.append("This command requires two non-parallel struts.\n");
                var s0 = null;
                var s1 = null;
                var qty = 0;

                for (var index730 = this.mSelection.iterator(); index730.hasNext();) {
                  var man = index730.next();
                  {
                    if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0)) {
                      switch (qty) {
                        case 0:
                          s0 = man;
                          break;

                        case 1:
                          s1 = man;
                          break;

                        default:
                          errorMsg.append("\ntoo many struts are selected.");
                          this.fail(errorMsg.toString());
                      }

                      qty++;
                    }

                    this.unselect$com_vzome_core_model_Manifestation(man);
                  }
                }

                if (qty < 2) {
                  errorMsg.append(qty === 1 ? "\nonly one strut is selected." : "\nno struts are selected.");
                  this.fail(errorMsg.toString());
                }

                var u = s0.getOffset();
                var v = s1.getOffset();
                var p0 = s0.getLocation();
                var q0 = s1.getLocation();
                var uuA = u.dot(u);
                var uvB = u.dot(v);
                var vvC = v.dot(v);
                var denD = uuA['times$com_vzome_core_algebra_AlgebraicNumber'](vvC)['minus$com_vzome_core_algebra_AlgebraicNumber'](uvB['times$com_vzome_core_algebra_AlgebraicNumber'](uvB));

                if (denD.isZero()) {
                  errorMsg.append("\nstruts are parallel.");
                  this.fail(errorMsg.toString());
                }

                this.redo();
                var w = p0.minus(q0);
                var uwD = u.dot(w);
                var vwE = v.dot(w);
                var sc = uvB['times$com_vzome_core_algebra_AlgebraicNumber'](vwE)['minus$com_vzome_core_algebra_AlgebraicNumber'](vvC['times$com_vzome_core_algebra_AlgebraicNumber'](uwD))['dividedBy$com_vzome_core_algebra_AlgebraicNumber'](denD);
                var tc = uuA['times$com_vzome_core_algebra_AlgebraicNumber'](vwE)['minus$com_vzome_core_algebra_AlgebraicNumber'](uvB['times$com_vzome_core_algebra_AlgebraicNumber'](uwD))['dividedBy$com_vzome_core_algebra_AlgebraicNumber'](denD);
                var w0 = p0.plus(u.scale(sc));
                var pw0 = new com.vzome.core.construction.FreePoint(w0);
                this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(pw0));
                var w1 = q0.plus(v.scale(tc));

                if (!w1.equals(w0)) {
                  var pw1 = new com.vzome.core.construction.FreePoint(w1);
                  this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(pw1));
                  this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(new com.vzome.core.construction.SegmentJoiningPoints(pw0, pw1)));
                }

                this.redo();
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return JoinSkewLines.NAME;
              }
            }]);

            return JoinSkewLines;
          }(com.vzome.core.editor.api.ChangeManifestations);

          JoinSkewLines.NAME = "JoinSkewLines";
          edits.JoinSkewLines = JoinSkewLines;
          JoinSkewLines["__class"] = "com.vzome.core.edits.JoinSkewLines";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          var NewCentroid =
          /*#__PURE__*/
          function (_com$vzome$core$edito31) {
            _inherits(NewCentroid, _com$vzome$core$edito31);

            var _super162 = _createSuper(NewCentroid);

            _createClass(NewCentroid, [{
              key: "perform",

              /**
              *
              */
              value: function perform() {
                var verticesList = new java.util.ArrayList();

                for (var index731 = this.mSelection.iterator(); index731.hasNext();) {
                  var man = index731.next();
                  {
                    this.unselect$com_vzome_core_model_Manifestation(man);
                    var construction = man.toConstruction();

                    if (construction != null && construction instanceof com.vzome.core.construction.Point) {
                      var nextPoint = construction;
                      verticesList.add(nextPoint);
                    }
                  }
                }

                if (verticesList.size() < 2) throw new com.vzome.core.commands.Command.Failure("Select at least two balls to compute the centroid.");
                var points = [];
                var centroid = new com.vzome.core.construction.CentroidPoint(verticesList.toArray(points));
                this.manifestConstruction(centroid);
                this.redo();
              }
            }]);

            function NewCentroid(editorModel) {
              _classCallCheck(this, NewCentroid);

              return _super162.call(this, editorModel);
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(NewCentroid, [{
              key: "groupingAware",
              value: function groupingAware() {
                return true;
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "NewCentroid";
              }
            }]);

            return NewCentroid;
          }(com.vzome.core.editor.api.ChangeManifestations);

          edits.NewCentroid = NewCentroid;
          NewCentroid["__class"] = "com.vzome.core.edits.NewCentroid";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          var LinePlaneIntersect =
          /*#__PURE__*/
          function (_com$vzome$core$edito32) {
            _inherits(LinePlaneIntersect, _com$vzome$core$edito32);

            var _super163 = _createSuper(LinePlaneIntersect);

            function LinePlaneIntersect(editor) {
              _classCallCheck(this, LinePlaneIntersect);

              return _super163.call(this, editor);
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(LinePlaneIntersect, [{
              key: "groupingAware",
              value: function groupingAware() {
                return true;
              }
              /**
              *
              */

            }, {
              key: "perform",
              value: function perform() {
                var panel = null;
                var strut = null;
                var p0 = null;
                var p1 = null;
                var p2 = null;

                for (var index732 = this.mSelection.iterator(); index732.hasNext();) {
                  var man = index732.next();
                  {
                    this.unselect$com_vzome_core_model_Manifestation(man);

                    if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0) && p2 == null) {
                      var nextPoint = man.getFirstConstruction();
                      if (p0 == null) p0 = nextPoint;else if (p1 == null) p1 = nextPoint;else if (p2 == null) p2 = nextPoint;
                    } else if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0) && strut == null) {
                      strut = man;
                    } else if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0) && panel == null) {
                      panel = man;
                    }
                  }
                }

                var point = null;
                var plane = null;
                var line = new com.vzome.core.construction.LineFromPointAndVector(strut.getLocation(), strut.getZoneVector());

                if (p2 != null && panel == null) {
                  var points = [p0, p1, p2];
                  var polygon = new com.vzome.core.construction.PolygonFromVertices(points);
                  plane = new com.vzome.core.construction.PlaneExtensionOfPolygon(polygon);
                } else if (strut != null && panel != null) {
                  plane = new com.vzome.core.construction.PlaneFromPointAndNormal(panel.getFirstVertex(), panel.getZoneVector());
                }

                if (plane != null && !plane.isImpossible()) {
                  point = new com.vzome.core.construction.LinePlaneIntersectionPoint(plane, line);
                  if (!point.isImpossible()) this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(point));
                }

                this.redo();
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "LinePlaneIntersect";
              }
            }]);

            return LinePlaneIntersect;
          }(com.vzome.core.editor.api.ChangeManifestations);

          edits.LinePlaneIntersect = LinePlaneIntersect;
          LinePlaneIntersect["__class"] = "com.vzome.core.edits.LinePlaneIntersect";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          var SelectByBoundary =
          /*#__PURE__*/
          function (_com$vzome$core$edito33) {
            _inherits(SelectByBoundary, _com$vzome$core$edito33);

            var _super164 = _createSuper(SelectByBoundary);

            function SelectByBoundary(editor) {
              _classCallCheck(this, SelectByBoundary);

              return _super164.call(this, editor);
            }
            /**
            *
            * @param {string} message
            */


            _createClass(SelectByBoundary, [{
              key: "fail",
              value: function fail(message) {
                var errorMsg = new java.lang.StringBuilder();
                var usage = this.usage();

                if (usage != null) {
                  errorMsg.append(usage);
                }

                if (message != null) {
                  if (errorMsg.length() > 0) {
                    errorMsg.append("\n");
                  }

                  errorMsg.append(message);
                }

                _get(_getPrototypeOf(SelectByBoundary.prototype), "fail", this).call(this, errorMsg.toString());
              }
              /**
              *
              */

            }, {
              key: "perform",
              value: function perform() {
                var errMsg = this.setBoundary();

                if (errMsg != null) {
                  this.fail(errMsg);
                }

                this.unselectAll();
                this.selectBoundedManifestations();
                this.redo();
              }
            }, {
              key: "selectBoundedManifestations",
              value: function selectBoundedManifestations() {
                for (var index733 = this.getConnectors().iterator(); index733.hasNext();) {
                  var connector = index733.next();
                  {
                    if (this.boundaryContains$com_vzome_core_model_Connector(connector)) {
                      this.select$com_vzome_core_model_Manifestation(connector);
                    }
                  }
                }

                for (var index734 = this.getStruts().iterator(); index734.hasNext();) {
                  var strut = index734.next();
                  {
                    if (this.boundaryContains$com_vzome_core_model_Strut(strut)) {
                      this.select$com_vzome_core_model_Manifestation(strut);
                    }
                  }
                }

                for (var index735 = this.getPanels().iterator(); index735.hasNext();) {
                  var panel = index735.next();
                  {
                    if (this.boundaryContains$com_vzome_core_model_Panel(panel)) {
                      this.select$com_vzome_core_model_Manifestation(panel);
                    }
                  }
                }
              }
            }, {
              key: "boundaryContains$com_vzome_core_model_Connector",
              value: function boundaryContains$com_vzome_core_model_Connector(connector) {
                return this.boundaryContains$com_vzome_core_algebra_AlgebraicVector(connector.getLocation());
              }
            }, {
              key: "boundaryContains",
              value: function boundaryContains(connector) {
                if (connector != null && (connector["__interfaces"] != null && connector["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || connector.constructor != null && connector.constructor["__interfaces"] != null && connector.constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0) || connector === null) {
                  return this.boundaryContains$com_vzome_core_model_Connector(connector);
                } else if (connector != null && (connector["__interfaces"] != null && connector["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || connector.constructor != null && connector.constructor["__interfaces"] != null && connector.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0) || connector === null) {
                  return this.boundaryContains$com_vzome_core_model_Strut(connector);
                } else if (connector != null && (connector["__interfaces"] != null && connector["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0 || connector.constructor != null && connector.constructor["__interfaces"] != null && connector.constructor["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0) || connector === null) {
                  return this.boundaryContains$com_vzome_core_model_Panel(connector);
                } else if (connector != null && connector instanceof com.vzome.core.algebra.AlgebraicVector || connector === null) {
                  return this.boundaryContains$com_vzome_core_algebra_AlgebraicVector(connector);
                } else throw new Error('invalid overload');
              }
              /*private*/

            }, {
              key: "boundaryContains$com_vzome_core_model_Strut",
              value: function boundaryContains$com_vzome_core_model_Strut(strut) {
                return this.boundaryContains$com_vzome_core_algebra_AlgebraicVector(strut.getLocation()) && this.boundaryContains$com_vzome_core_algebra_AlgebraicVector(strut.getEnd());
              }
              /*private*/

            }, {
              key: "boundaryContains$com_vzome_core_model_Panel",
              value: function boundaryContains$com_vzome_core_model_Panel(panel) {
                for (var index736 = panel.iterator(); index736.hasNext();) {
                  var vertex = index736.next();
                  {
                    if (!this.boundaryContains$com_vzome_core_algebra_AlgebraicVector(vertex)) {
                      return false;
                    }
                  }
                }

                return true;
              }
            }, {
              key: "boundaryContains$com_vzome_core_algebra_AlgebraicVector",
              value: function boundaryContains$com_vzome_core_algebra_AlgebraicVector(v) {
                throw new Error('cannot invoke abstract overloaded method... check your argument(s) type(s)');
              }
            }]);

            return SelectByBoundary;
          }(com.vzome.core.editor.api.ChangeManifestations);

          edits.SelectByBoundary = SelectByBoundary;
          SelectByBoundary["__class"] = "com.vzome.core.edits.SelectByBoundary";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          /**
          * called from the main menu and when opening a file
          * @param symmetry
          * @param selection
          * @param model
          * @param {*} editor
          * @class
          * @extends com.vzome.core.editor.api.ChangeManifestations
          * @author David Hall
          */
          var SelectParallelStruts =
          /*#__PURE__*/
          function (_com$vzome$core$edito34) {
            _inherits(SelectParallelStruts, _com$vzome$core$edito34);

            var _super165 = _createSuper(SelectParallelStruts);

            function SelectParallelStruts(editor) {
              var _this115;

              _classCallCheck(this, SelectParallelStruts);

              _this115 = _super165.call(this, editor);
              if (_this115.symmetry === undefined) _this115.symmetry = null;
              if (_this115.orbit === undefined) _this115.orbit = null;
              if (_this115.axis === undefined) _this115.axis = null;
              if (_this115.editor === undefined) _this115.editor = null;
              _this115.editor = editor;
              _this115.symmetry = editor['getSymmetrySystem$']();
              return _this115;
            }
            /**
            *
            * @param {*} props
            */


            _createClass(SelectParallelStruts, [{
              key: "configure",
              value: function configure(props) {
                var strut = props.get("picked");

                if (strut != null) {
                  this.axis = this.symmetry.getAxis(strut.getOffset());
                  this.orbit = this.axis.getOrbit();
                }
              }
              /**
              *
              */

            }, {
              key: "perform",
              value: function perform() {
                if (this.orbit == null || this.axis == null) {
                  var lastStrut = this.getLastSelectedStrut();

                  if (lastStrut != null) {
                    var offset = lastStrut.getOffset();
                    this.orbit = this.symmetry.getAxis(offset).getOrbit();
                    this.axis = this.orbit.getAxis$com_vzome_core_algebra_AlgebraicVector(offset);
                  }
                }

                if (this.orbit == null || this.axis == null) {
                  throw new com.vzome.core.commands.Command.Failure("select a reference strut.");
                }

                this.unselectAll();
                var opposite = (this.axis.getSense() + 1) % 2;
                var oppositeAxis = this.orbit.getAxis$int$int(opposite, this.axis.getOrientation());

                for (var index737 = this.getStruts().iterator(); index737.hasNext();) {
                  var strut = index737.next();
                  {
                    var strutAxis = this.symmetry.getAxis(strut.getOffset());

                    if (strutAxis != null && strutAxis.getOrbit().equals(this.orbit)) {
                      if (strutAxis.equals(this.axis) || strutAxis.equals(oppositeAxis)) {
                        this.select$com_vzome_core_model_Manifestation(strut);
                      }
                    }
                  }
                }

                _get(_getPrototypeOf(SelectParallelStruts.prototype), "perform", this).call(this);
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "SelectParallelStruts";
              }
              /**
              *
              * @param {*} element
              */

            }, {
              key: "getXmlAttributes",
              value: function getXmlAttributes(element) {
                if (this.symmetry != null) com.vzome.xml.DomUtils.addAttribute(element, "symmetry", this.symmetry.getName());
                if (this.orbit != null) com.vzome.xml.DomUtils.addAttribute(element, "orbit", this.orbit.getName());
                if (this.axis != null) com.vzome.core.commands.XmlSymmetryFormat.serializeAxis(element, "symm", "dir", "index", "sense", this.axis);
              }
              /**
              *
              * @param {*} xml
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              */

            }, {
              key: "setXmlAttributes",
              value: function setXmlAttributes(xml, format) {
                this.symmetry = this.editor['getSymmetrySystem$java_lang_String'](xml.getAttribute("symmetry"));
                this.orbit = this.symmetry.getOrbits().getDirection(xml.getAttribute("orbit"));
                this.axis = format.parseAxis(xml, "symm", "dir", "index", "sense");
              }
            }]);

            return SelectParallelStruts;
          }(com.vzome.core.editor.api.ChangeManifestations);

          edits.SelectParallelStruts = SelectParallelStruts;
          SelectParallelStruts["__class"] = "com.vzome.core.edits.SelectParallelStruts";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          var ConvexHull =
          /*#__PURE__*/
          function (_com$vzome$core$edito35) {
            _inherits(ConvexHull, _com$vzome$core$edito35);

            var _super166 = _createSuper(ConvexHull);

            function ConvexHull(editorModel) {
              _classCallCheck(this, ConvexHull);

              return _super166.call(this, editorModel);
            }

            _createClass(ConvexHull, [{
              key: "getSelectedVertexSet",
              value: function getSelectedVertexSet(unselectAll) {
                var vertexSet = new java.util.HashSet();

                for (var index738 = this.mSelection.iterator(); index738.hasNext();) {
                  var man = index738.next();
                  {
                    if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0)) {
                      vertexSet.add(man.getLocation());
                    } else if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0)) {
                      vertexSet.add(man.getLocation());
                      vertexSet.add(man.getEnd());
                    } else if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0)) {
                      for (var index739 = man.iterator(); index739.hasNext();) {
                        var vertex = index739.next();
                        {
                          vertexSet.add(vertex);
                        }
                      }
                    }

                    if (unselectAll) {
                      this.unselect$com_vzome_core_model_Manifestation(man);
                    }
                  }
                }

                return vertexSet;
              }
            }]);

            return ConvexHull;
          }(com.vzome.core.editor.api.ChangeManifestations);

          edits.ConvexHull = ConvexHull;
          ConvexHull["__class"] = "com.vzome.core.edits.ConvexHull";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          var AffinePentagon =
          /*#__PURE__*/
          function (_com$vzome$core$edito36) {
            _inherits(AffinePentagon, _com$vzome$core$edito36);

            var _super167 = _createSuper(AffinePentagon);

            _createClass(AffinePentagon, [{
              key: "perform",

              /**
              *
              */
              value: function perform() {
                var errorMsg = "Affine pentagon command requires two selected struts with a common vertex.";
                var strut1 = null;
                var strut2 = null;

                for (var index740 = this.mSelection.iterator(); index740.hasNext();) {
                  var man = index740.next();
                  {
                    this.unselect$com_vzome_core_model_Manifestation(man);

                    if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0)) {
                      if (strut1 == null) {
                        strut1 = man;
                      } else if (strut2 == null) {
                        strut2 = man;
                      }
                    }
                  }
                }

                this.redo();

                if (strut1 == null || strut2 == null) {
                  this.fail(errorMsg);
                }

                var field = strut1.getLocation().getField();
                var s1 = strut1.getFirstConstruction();
                var s2 = strut2.getFirstConstruction();
                this.manifestConstruction(new com.vzome.core.construction.SegmentEndPoint(s1, true));
                this.manifestConstruction(new com.vzome.core.construction.SegmentEndPoint(s1, false));
                this.manifestConstruction(new com.vzome.core.construction.SegmentEndPoint(s2, true));
                this.manifestConstruction(new com.vzome.core.construction.SegmentEndPoint(s2, false));
                this.redo();
                var offset1 = s1.getOffset();
                var offset2 = s2.getOffset();
                var v1 = null;
                var v2 = null;
                {
                  var s1s = s1.getStart();
                  var s1e = s1.getEnd();
                  var s2s = s2.getStart();
                  var s2e = s2.getEnd();

                  if (s1s.equals(s2s)) {
                    v1 = s1e;
                    v2 = s2e;
                  } else if (s1e.equals(s2s)) {
                    v1 = s1s;
                    v2 = s2e;
                    offset1 = offset1.negate();
                  } else if (s1e.equals(s2e)) {
                    v1 = s1s;
                    v2 = s2s;
                    offset2 = offset2.negate();
                    offset1 = offset1.negate();
                  } else if (s1s.equals(s2e)) {
                    v1 = s1e;
                    v2 = s2s;
                    offset2 = offset2.negate();
                  } else {
                    this.fail(errorMsg);
                  }
                }
                var p1 = null;
                var p2 = null;

                for (var index741 = this.mManifestations.iterator(); index741.hasNext();) {
                  var m = index741.next();
                  {
                    if (m != null && (m["__interfaces"] != null && m["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || m.constructor != null && m.constructor["__interfaces"] != null && m.constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0)) {
                      var loc = m.getLocation();
                      if (loc.equals(v1)) p1 = m.getFirstConstruction();else if (loc.equals(v2)) p2 = m.getFirstConstruction();
                    }
                  }
                }

                var phi = field['createPower$int'](1);
                var transform = new com.vzome.core.construction.Translation(offset1.scale(phi));
                var p3 = new com.vzome.core.construction.TransformedPoint(transform, p2);
                this.manifestConstruction(p3);
                transform = new com.vzome.core.construction.Translation(offset2.scale(phi));
                var p4 = new com.vzome.core.construction.TransformedPoint(transform, p1);
                this.manifestConstruction(p4);
                var segment = new com.vzome.core.construction.SegmentJoiningPoints(p1, p3);
                this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(segment));
                segment = new com.vzome.core.construction.SegmentJoiningPoints(p2, p4);
                this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(segment));
                segment = new com.vzome.core.construction.SegmentJoiningPoints(p3, p4);
                this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(segment));
                this.redo();
              }
            }]);

            function AffinePentagon(editorModel) {
              _classCallCheck(this, AffinePentagon);

              return _super167.call(this, editorModel);
            }
            /**
            *
            * @return {string}
            */


            _createClass(AffinePentagon, [{
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "AffinePentagon";
              }
            }]);

            return AffinePentagon;
          }(com.vzome.core.editor.api.ChangeManifestations);

          edits.AffinePentagon = AffinePentagon;
          AffinePentagon["__class"] = "com.vzome.core.edits.AffinePentagon";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          var StrutCreation =
          /*#__PURE__*/
          function (_com$vzome$core$edito37) {
            _inherits(StrutCreation, _com$vzome$core$edito37);

            var _super168 = _createSuper(StrutCreation);

            function StrutCreation(anchor, axis, len, editor) {
              var _this116;

              _classCallCheck(this, StrutCreation);

              if ((anchor != null && anchor instanceof com.vzome.core.construction.Point || anchor === null) && (axis != null && axis instanceof com.vzome.core.math.symmetry.Axis || axis === null) && (len != null && (len["__interfaces"] != null && len["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0 || len.constructor != null && len.constructor["__interfaces"] != null && len.constructor["__interfaces"].indexOf("com.vzome.core.algebra.AlgebraicNumber") >= 0) || len === null) && (editor != null && (editor["__interfaces"] != null && editor["__interfaces"].indexOf("com.vzome.core.editor.api.EditorModel") >= 0 || editor.constructor != null && editor.constructor["__interfaces"] != null && editor.constructor["__interfaces"].indexOf("com.vzome.core.editor.api.EditorModel") >= 0) || editor === null)) {
                _this116 = _super168.call(this, editor);
                if (_this116.mAnchor === undefined) _this116.mAnchor = null;
                if (_this116.mAxis === undefined) _this116.mAxis = null;
                if (_this116.mLength === undefined) _this116.mLength = null;
                if (_this116.mAnchor === undefined) _this116.mAnchor = null;
                if (_this116.mAxis === undefined) _this116.mAxis = null;
                if (_this116.mLength === undefined) _this116.mLength = null;

                (function () {
                  _this116.mAnchor = anchor;
                  _this116.mAxis = axis;
                  _this116.mLength = len;
                })();
              } else if ((anchor != null && (anchor["__interfaces"] != null && anchor["__interfaces"].indexOf("com.vzome.core.editor.api.EditorModel") >= 0 || anchor.constructor != null && anchor.constructor["__interfaces"] != null && anchor.constructor["__interfaces"].indexOf("com.vzome.core.editor.api.EditorModel") >= 0) || anchor === null) && axis === undefined && len === undefined && editor === undefined) {
                var _args85 = arguments;
                var _editor = _args85[0];
                {
                  var _anchor = null;
                  var _axis = null;
                  var _len3 = null;
                  _this116 = _super168.call(this, _editor);
                  if (_this116.mAnchor === undefined) _this116.mAnchor = null;
                  if (_this116.mAxis === undefined) _this116.mAxis = null;
                  if (_this116.mLength === undefined) _this116.mLength = null;
                  if (_this116.mAnchor === undefined) _this116.mAnchor = null;
                  if (_this116.mAxis === undefined) _this116.mAxis = null;
                  if (_this116.mLength === undefined) _this116.mLength = null;

                  (function () {
                    _this116.mAnchor = _anchor;
                    _this116.mAxis = _axis;
                    _this116.mLength = _len3;
                  })();
                }
              } else throw new Error('invalid overload');

              return _possibleConstructorReturn(_this116);
            }
            /**
            *
            * @param {*} params
            */


            _createClass(StrutCreation, [{
              key: "configure",
              value: function configure(params) {
                this.mAnchor = params.get("anchor");
                this.mAxis = params.get("zone");
                this.mLength = params.get("length");
              }
              /**
              *
              */

            }, {
              key: "perform",
              value: function perform() {
                var segment = new com.vzome.core.construction.AnchoredSegment(this.mAxis, this.mLength, this.mAnchor);
                this.manifestConstruction(segment);
                var point = new com.vzome.core.construction.SegmentEndPoint(segment);
                this.manifestConstruction(point);
                this.redo();
              }
              /**
              *
              * @param {*} xml
              */

            }, {
              key: "getXmlAttributes",
              value: function getXmlAttributes(xml) {
                com.vzome.core.commands.XmlSaveFormat.serializePoint(xml, "anchor", this.mAnchor);
                com.vzome.core.commands.XmlSymmetryFormat.serializeAxis(xml, "symm", "dir", "index", "sense", this.mAxis);
                com.vzome.core.commands.XmlSaveFormat.serializeNumber(xml, "len", this.mLength);
              }
              /**
              *
              * @param {*} xml
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              */

            }, {
              key: "setXmlAttributes",
              value: function setXmlAttributes(xml, format) {
                if (format.rationalVectors()) {
                  this.mAnchor = format.parsePoint$org_w3c_dom_Element$java_lang_String(xml, "anchor");
                  this.mAxis = format.parseAxis(xml, "symm", "dir", "index", "sense");
                  this.mLength = format.parseNumber(xml, "len");
                } else {
                  var attrs = format.loadCommandAttributes$org_w3c_dom_Element$boolean(xml, true);
                  this.mAnchor = attrs.get("anchor");
                  this.mAxis = attrs.get("axis");
                  this.mLength = attrs.get("len");
                }
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "StrutCreation";
              }
            }]);

            return StrutCreation;
          }(com.vzome.core.editor.api.ChangeManifestations);

          edits.StrutCreation = StrutCreation;
          StrutCreation["__class"] = "com.vzome.core.edits.StrutCreation";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          var StrutIntersection =
          /*#__PURE__*/
          function (_com$vzome$core$edito38) {
            _inherits(StrutIntersection, _com$vzome$core$edito38);

            var _super169 = _createSuper(StrutIntersection);

            function StrutIntersection(editor) {
              _classCallCheck(this, StrutIntersection);

              return _super169.call(this, editor);
            }
            /**
            *
            */


            _createClass(StrutIntersection, [{
              key: "perform",
              value: function perform() {
                var s1 = null;
                var s2 = null;

                for (var index742 = this.mSelection.iterator(); index742.hasNext();) {
                  var man = index742.next();
                  {
                    this.unselect$com_vzome_core_model_Manifestation(man);
                    if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0)) if (s1 == null) s1 = man;else if (s2 == null) s2 = man;else throw new com.vzome.core.commands.Command.Failure("only two struts are allowed");
                  }
                }

                if (s1 == null || s2 == null) throw new com.vzome.core.commands.Command.Failure("two struts are required");
                var l1 = new com.vzome.core.construction.LineFromPointAndVector(s1.getLocation(), s1.getZoneVector());
                var l2 = new com.vzome.core.construction.LineFromPointAndVector(s2.getLocation(), s2.getZoneVector());
                var point = new com.vzome.core.construction.LineLineIntersectionPoint(l1, l2);
                if (point.isImpossible()) throw new com.vzome.core.commands.Command.Failure("lines are parallel or non-intersecting");
                var ball = this.manifestConstruction(point);
                this.select$com_vzome_core_model_Manifestation(ball);
                this.redo();
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "StrutIntersection";
              }
            }]);

            return StrutIntersection;
          }(com.vzome.core.editor.api.ChangeManifestations);

          edits.StrutIntersection = StrutIntersection;
          StrutIntersection["__class"] = "com.vzome.core.edits.StrutIntersection";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          /**
          * Work in progress, to help someone create correctly oriented surfaces for vZome part export,
          * or for StL 3D printing export.
          *
          * @author Scott Vorthmann
          * @param {*} singlePanel
          * @param {*} editor
          * @class
          * @extends com.vzome.core.editor.api.ChangeManifestations
          */
          var ReversePanel =
          /*#__PURE__*/
          function (_com$vzome$core$edito39) {
            _inherits(ReversePanel, _com$vzome$core$edito39);

            var _super170 = _createSuper(ReversePanel);

            function ReversePanel(singlePanel, editor) {
              var _this117;

              _classCallCheck(this, ReversePanel);

              _this117 = _super170.call(this, editor);
              if (_this117.panel === undefined) _this117.panel = null;
              if (singlePanel != null) _this117.panel = singlePanel;else _this117.panel = null;
              return _this117;
            }
            /**
            *
            */


            _createClass(ReversePanel, [{
              key: "perform",
              value: function perform() {
                if (this.panel != null) {
                  if (this.mSelection.manifestationSelected(this.panel)) this.unselect$com_vzome_core_model_Manifestation(this.panel);
                  var polygon = this.panel.getFirstConstruction();
                  this.unmanifestConstruction(polygon);
                }

                this.redo();
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "ReversePanel";
              }
            }]);

            return ReversePanel;
          }(com.vzome.core.editor.api.ChangeManifestations);

          edits.ReversePanel = ReversePanel;
          ReversePanel["__class"] = "com.vzome.core.edits.ReversePanel";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          /**
          * @author David Hall
          * @param {*} editor
          * @class
          * @extends com.vzome.core.editor.api.ChangeManifestations
          */
          var MapToColor =
          /*#__PURE__*/
          function (_com$vzome$core$edito40) {
            _inherits(MapToColor, _com$vzome$core$edito40);

            var _super171 = _createSuper(MapToColor);

            function MapToColor(editor) {
              var _this118;

              _classCallCheck(this, MapToColor);

              _this118 = _super171.call(this, editor);
              if (_this118.colorMapper === undefined) _this118.colorMapper = null;
              if (_this118.editor === undefined) _this118.editor = null;
              _this118.editor = editor;
              return _this118;
            }
            /**
            *
            * @param {*} props
            */


            _createClass(MapToColor, [{
              key: "configure",
              value: function configure(props) {
                var colorMapperName = props.get("mode");
                var symmetry = this.editor['getSymmetrySystem$']();
                if (colorMapperName != null) this.colorMapper = com.vzome.core.edits.ManifestationColorMappers.getColorMapper$java_lang_String$com_vzome_core_editor_api_OrbitSource(colorMapperName, symmetry);
              }
              /**
              * Either configure() or setXmlAttributes() is always called before perform()
              */

            }, {
              key: "perform",
              value: function perform() {
                if (this.colorMapper.requiresOrderedSelection()) {
                  this.setOrderedSelection(true);
                }

                this.colorMapper.initialize(this.getRenderedSelection());

                for (var index743 = this.getRenderedSelection().iterator(); index743.hasNext();) {
                  var man = index743.next();
                  {
                    this.plan(new MapToColor.ColorMapManifestation(this, man, this.colorMapper.apply$com_vzome_core_model_Manifestation(man)));
                    this.unselect$com_vzome_core_model_Manifestation$boolean(man, true);
                  }
                }

                this.redo();
              }
              /**
              *
              * @param {*} result
              */

            }, {
              key: "getXmlAttributes",
              value: function getXmlAttributes(result) {
                result.setAttribute(MapToColor.COLORMAPPER_ATTR_NAME, this.colorMapper.getName());
                this.colorMapper.getXmlAttributes(result);
              }
              /**
              *
              * @param {*} xml
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              */

            }, {
              key: "setXmlAttributes",
              value: function setXmlAttributes(xml, format) {
                var symmetry = this.editor['getSymmetrySystem$java_lang_String'](xml.getAttribute("symmetry"));
                var colorMapperName = xml.getAttribute(MapToColor.COLORMAPPER_ATTR_NAME);
                this.colorMapper = com.vzome.core.edits.ManifestationColorMappers.getColorMapper$java_lang_String$com_vzome_core_editor_api_OrbitSource(colorMapperName, symmetry);
                this.colorMapper.setXmlAttributes(xml);
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "MapToColor";
              }
            }]);

            return MapToColor;
          }(com.vzome.core.editor.api.ChangeManifestations);

          MapToColor.COLORMAPPER_ATTR_NAME = "colorMapper";
          edits.MapToColor = MapToColor;
          MapToColor["__class"] = "com.vzome.core.edits.MapToColor";

          (function (MapToColor) {
            var ColorMapManifestation =
            /*#__PURE__*/
            function () {
              function ColorMapManifestation(__parent, manifestation, color) {
                _classCallCheck(this, ColorMapManifestation);

                this.__parent = __parent;
                if (this.mManifestation === undefined) this.mManifestation = null;
                if (this.oldColor === undefined) this.oldColor = null;
                if (this.newColor === undefined) this.newColor = null;
                this.mManifestation = manifestation;
                this.newColor = color;
                this.oldColor = manifestation.getColor();
              }
              /**
              *
              */


              _createClass(ColorMapManifestation, [{
                key: "redo",
                value: function redo() {
                  this.__parent.mManifestations.setColor(this.mManifestation, this.newColor);
                }
                /**
                *
                */

              }, {
                key: "undo",
                value: function undo() {
                  this.__parent.mManifestations.setColor(this.mManifestation, this.oldColor);
                }
                /**
                *
                * @param {*} doc
                * @return {*}
                */

              }, {
                key: "getXml",
                value: function getXml(doc) {
                  var result = doc.createElement("color");
                  com.vzome.xml.DomUtils.addAttribute(result, "rgb", this.newColor.toString());
                  var man = this.mManifestation.getXml(doc);
                  result.appendChild(man);
                  return result;
                }
              }]);

              return ColorMapManifestation;
            }();

            MapToColor.ColorMapManifestation = ColorMapManifestation;
            ColorMapManifestation["__class"] = "com.vzome.core.edits.MapToColor.ColorMapManifestation";
            ColorMapManifestation["__interfaces"] = ["com.vzome.core.editor.api.SideEffects.SideEffect"];
          })(MapToColor = edits.MapToColor || (edits.MapToColor = {}));
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          var ColorManifestations =
          /*#__PURE__*/
          function (_com$vzome$core$edito41) {
            _inherits(ColorManifestations, _com$vzome$core$edito41);

            var _super172 = _createSuper(ColorManifestations);

            function ColorManifestations(editorModel) {
              var _this119;

              _classCallCheck(this, ColorManifestations);

              _this119 = _super172.call(this, editorModel);
              if (_this119.color === undefined) _this119.color = null;
              return _this119;
            }
            /**
            *
            * @param {*} props
            */


            _createClass(ColorManifestations, [{
              key: "configure",
              value: function configure(props) {
                var mode = props.get("mode");
                if (mode != null) this.initialize(new com.vzome.core.construction.Color(mode));
              }
              /*private*/

            }, {
              key: "initialize",
              value: function initialize(color) {
                this.color = color;

                for (var index744 = this.mSelection.iterator(); index744.hasNext();) {
                  var m = index744.next();
                  {
                    if (m.isRendered()) this.colorManifestation(m, color);
                    this.unselect$com_vzome_core_model_Manifestation$boolean(m, true);
                  }
                }
              }
              /**
              *
              * @param {*} result
              */

            }, {
              key: "getXmlAttributes",
              value: function getXmlAttributes(result) {
                result.setAttribute("red", "" + this.color.getRed());
                result.setAttribute("green", "" + this.color.getGreen());
                result.setAttribute("blue", "" + this.color.getBlue());
                var alpha = this.color.getAlpha();
                if (alpha < 255) result.setAttribute("alpha", "" + alpha);
              }
              /**
              *
              * @param {*} xml
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              */

            }, {
              key: "setXmlAttributes",
              value: function setXmlAttributes(xml, format) {
                if (format.loadToRender()) {
                  var red = xml.getAttribute("red");
                  var green = xml.getAttribute("green");
                  var blue = xml.getAttribute("blue");
                  var alphaStr = xml.getAttribute("alpha");
                  var alpha = alphaStr == null ||
                  /* isEmpty */
                  alphaStr.length === 0 ? 255 : javaemul.internal.IntegerHelper.parseInt(alphaStr);
                  this.initialize(new com.vzome.core.construction.Color(javaemul.internal.IntegerHelper.parseInt(red), javaemul.internal.IntegerHelper.parseInt(green), javaemul.internal.IntegerHelper.parseInt(blue), alpha));
                } else this.initialize(null);
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "setItemColor";
              }
            }]);

            return ColorManifestations;
          }(com.vzome.core.editor.api.ChangeManifestations);

          edits.ColorManifestations = ColorManifestations;
          ColorManifestations["__class"] = "com.vzome.core.edits.ColorManifestations";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          var ImportMesh =
          /*#__PURE__*/
          function (_com$vzome$core$edito42) {
            _inherits(ImportMesh, _com$vzome$core$edito42);

            var _super173 = _createSuper(ImportMesh);

            function ImportMesh(editor) {
              var _this120;

              _classCallCheck(this, ImportMesh);

              _this120 = _super173.call(this, editor);
              if (_this120.meshData === undefined) _this120.meshData = null;
              if (_this120.scale === undefined) _this120.scale = null;
              if (_this120.projection === undefined) _this120.projection = null;
              if (_this120.editor === undefined) _this120.editor = null;
              _this120.editor = editor;
              return _this120;
            }
            /**
            *
            * @param {*} params
            */


            _createClass(ImportMesh, [{
              key: "configure",
              value: function configure(params) {
                var field = this.mManifestations.getField();
                this.meshData = params.get("vef");
                this.projection = params.get("projection");
                this.scale = params.get("scale");

                if (this.scale == null) {
                  this.scale = field.one();
                }

                var mode = params.getOrDefault("mode", "");

                switch (mode) {
                  case "":
                    break;

                  case "clipboard":
                    if (this.meshData != null && !function (str, searchString) {
                      var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                      return str.substr(position, searchString.length) === searchString;
                    }(this.meshData, "vZome VEF") && !function (str, searchString) {
                      var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                      return str.substr(position, searchString.length) === searchString;
                    }(this.meshData, "{")) this.meshData = null;
                    break;

                  case "Quaternion":
                    break;

                  default:
                    this.setProjection(mode, field);
                    break;
                }
              }
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "isNoOp",
              value: function isNoOp() {
                return this.meshData == null;
              }
              /**
              *
              * @param {*} element
              */

            }, {
              key: "getXmlAttributes",
              value: function getXmlAttributes(element) {
                if (this.scale != null) com.vzome.xml.DomUtils.addAttribute(element, "scale", this.scale.toString(com.vzome.core.algebra.AlgebraicField.ZOMIC_FORMAT));

                if (this.projection != null) {
                  var name = this.projection.getProjectionName();

                  if (!function (o1, o2) {
                    if (o1 && o1.equals) {
                      return o1.equals(o2);
                    } else {
                      return o1 === o2;
                    }
                  }("", name)) {
                    com.vzome.xml.DomUtils.addAttribute(element, "projection", this.projection.getProjectionName());
                    this.projection.getXmlAttributes(element);
                  }
                }

                var textNode = element.getOwnerDocument().createTextNode(com.vzome.core.commands.XmlSaveFormat.escapeNewlines(this.meshData));
                element.appendChild(textNode);
              }
              /**
              *
              * @param {*} xml
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              */

            }, {
              key: "setXmlAttributes",
              value: function setXmlAttributes(xml, format) {
                var field = format.getField();
                this.scale = format.parseRationalNumber(xml, "scale");

                if (this.scale == null) {
                  this.scale = field.one();
                }

                this.meshData = xml.getTextContent();
                var projectionName = xml.getAttribute("projection");

                if (
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }("", projectionName)) {
                  var quaternion = format.parseRationalVector(xml, "quaternion");
                  this.projection = quaternion == null ? null : new com.vzome.core.math.QuaternionProjection(field, null, quaternion);
                } else {
                  this.setProjection(projectionName, field);
                }

                if (this.projection != null) {
                  this.projection.setXmlAttributes(xml);
                }
              }
            }, {
              key: "setProjection",
              value: function setProjection(projectionName, field) {
                switch (projectionName) {
                  case "Quaternion":
                    this.projection = new com.vzome.core.math.QuaternionProjection(field, null, null);
                    break;

                  case "SixCube":
                    this.projection = new com.vzome.core.math.SixCubeProjection(field);
                    break;

                  case "Tetrahedral":
                    this.projection = new com.vzome.core.math.TetrahedralProjection(field);
                    break;

                  case "Perspective":
                    this.projection = new com.vzome.core.math.PerspectiveProjection(field, null);
                    break;
                }
              }
              /**
              *
              */

            }, {
              key: "perform",
              value: function perform() {
                if (this.meshData == null) return;
                var offset = null;
                var pointFound = false;

                for (var index745 = this.mSelection.iterator(); index745.hasNext();) {
                  var man = index745.next();
                  {
                    if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0)) {
                      var nextPoint = man.getFirstConstruction();

                      if (!pointFound) {
                        pointFound = true;
                        offset = nextPoint.getLocation();
                      } else {
                        offset = null;
                        break;
                      }
                    }

                    if (this.deselectInputs()) this.unselect$com_vzome_core_model_Manifestation(man);
                  }
                }

                var field = this.mManifestations.getField();
                var events = new com.vzome.core.editor.api.ManifestConstructions(this);
                var registry = new ImportMesh.ImportMesh$0(this, field);
                if (this.projection == null) this.projection = new com.vzome.core.math.Projection.Default(field);

                try {
                  this.parseMeshData(offset, events, registry);
                } catch (e) {
                  throw new com.vzome.core.commands.Command.Failure("The selected file has incorrect content for this import.\n" + e.message);
                }

                this.redo();
              }
            }, {
              key: "deselectInputs",
              value: function deselectInputs() {
                return true;
              }
            }]);

            return ImportMesh;
          }(com.vzome.core.editor.api.ChangeManifestations);

          edits.ImportMesh = ImportMesh;
          ImportMesh["__class"] = "com.vzome.core.edits.ImportMesh";

          (function (ImportMesh) {
            var ImportMesh$0 =
            /*#__PURE__*/
            function () {
              function ImportMesh$0(__parent, field) {
                _classCallCheck(this, ImportMesh$0);

                this.field = field;
                this.__parent = __parent;
              }
              /**
              *
              * @param {string} name
              * @return {*}
              */


              _createClass(ImportMesh$0, [{
                key: "getField",
                value: function getField(name) {
                  if (
                  /* equals */
                  function (o1, o2) {
                    if (o1 && o1.equals) {
                      return o1.equals(o2);
                    } else {
                      return o1 === o2;
                    }
                  }(this.field.getName(), name)) return this.field;else return null;
                }
              }]);

              return ImportMesh$0;
            }();

            ImportMesh.ImportMesh$0 = ImportMesh$0;
            ImportMesh$0["__interfaces"] = ["com.vzome.core.algebra.AlgebraicField.Registry"];
          })(ImportMesh = edits.ImportMesh || (edits.ImportMesh = {}));
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          var Delete =
          /*#__PURE__*/
          function (_com$vzome$core$edito43) {
            _inherits(Delete, _com$vzome$core$edito43);

            var _super174 = _createSuper(Delete);

            _createClass(Delete, [{
              key: "perform",

              /**
              *
              */
              value: function perform() {
                var inputs = new java.util.ArrayList();

                for (var index746 = this.mSelection.iterator(); index746.hasNext();) {
                  var man = index746.next();
                  {
                    inputs.add(man);
                    this.unselect$com_vzome_core_model_Manifestation(man);
                  }
                }

                this.redo();

                for (var index747 = inputs.iterator(); index747.hasNext();) {
                  var _man6 = index747.next();

                  {
                    this.deleteManifestation(_man6);
                  }
                }

                _get(_getPrototypeOf(Delete.prototype), "perform", this).call(this);
              }
            }]);

            function Delete(editorModel) {
              _classCallCheck(this, Delete);

              return _super174.call(this, editorModel);
            }
            /**
            *
            * @return {string}
            */


            _createClass(Delete, [{
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "Delete";
              }
            }]);

            return Delete;
          }(com.vzome.core.editor.api.ChangeManifestations);

          edits.Delete = Delete;
          Delete["__class"] = "com.vzome.core.edits.Delete";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          var AffineTransformAll =
          /*#__PURE__*/
          function (_com$vzome$core$edito44) {
            _inherits(AffineTransformAll, _com$vzome$core$edito44);

            var _super175 = _createSuper(AffineTransformAll);

            function AffineTransformAll(editorModel) {
              var _this121;

              _classCallCheck(this, AffineTransformAll);

              _this121 = _super175.call(this, editorModel);
              if (_this121.center === undefined) _this121.center = null;
              _this121.center = editorModel.getCenterPoint();
              return _this121;
            }
            /**
            *
            */


            _createClass(AffineTransformAll, [{
              key: "perform",
              value: function perform() {
                var s1 = null;
                var s2 = null;
                var s3 = null;

                for (var index748 = this.mSelection.iterator(); index748.hasNext();) {
                  var man = index748.next();
                  {
                    this.unselect$com_vzome_core_model_Manifestation(man);

                    if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0)) {
                      if (s1 == null) s1 = man.getFirstConstruction();else if (s2 == null) s2 = man.getFirstConstruction();else if (s3 == null) s3 = man.getFirstConstruction();
                    }
                  }
                }

                if (s3 == null || s2 == null || s1 == null) throw new com.vzome.core.commands.Command.Failure("three struts required");
                this.redo();
                var transform = new com.vzome.core.construction.ChangeOfBasis(s1, s2, s3, this.center, true);

                for (var index749 = this.mManifestations.iterator(); index749.hasNext();) {
                  var m = index749.next();
                  {
                    if (!m.isRendered()) continue;
                    var c = m.getFirstConstruction();
                    var result = transform.transform$com_vzome_core_construction_Construction(c);
                    this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(result));
                  }
                }

                this.redo();
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "AffineTransformAll";
              }
            }]);

            return AffineTransformAll;
          }(com.vzome.core.editor.api.ChangeManifestations);

          edits.AffineTransformAll = AffineTransformAll;
          AffineTransformAll["__class"] = "com.vzome.core.edits.AffineTransformAll";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          var Parallelepiped =
          /*#__PURE__*/
          function (_com$vzome$core$edito45) {
            _inherits(Parallelepiped, _com$vzome$core$edito45);

            var _super176 = _createSuper(Parallelepiped);

            function Parallelepiped(editor) {
              _classCallCheck(this, Parallelepiped);

              return _super176.call(this, editor);
            }
            /**
            *
            * @return {string}
            */


            _createClass(Parallelepiped, [{
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "Parallelepiped";
              }
              /**
              *
              */

            }, {
              key: "perform",
              value: function perform() {
                var errorMsg = "Parallelepiped command requires three selected struts with a common vertex.";
                var strut1 = null;
                var strut2 = null;
                var strut3 = null;

                for (var index750 = this.mSelection.iterator(); index750.hasNext();) {
                  var man = index750.next();
                  {
                    this.unselect$com_vzome_core_model_Manifestation(man);

                    if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0)) {
                      if (strut1 == null) {
                        strut1 = "com.vzome.core.model.Strut".cast(man);
                      } else if (strut2 == null) {
                        strut2 = "com.vzome.core.model.Strut".cast(man);
                      } else if (strut3 == null) {
                        strut3 = "com.vzome.core.model.Strut".cast(man);
                      } else this.fail(errorMsg);
                    } else this.fail(errorMsg);
                  }
                }

                if (strut1 == null || strut2 == null || strut3 == null) {
                  this.fail(errorMsg);
                }

                var s1 = com.vzome.core.construction.Segment.cast(strut1.getFirstConstruction());
                var s2 = com.vzome.core.construction.Segment.cast(strut2.getFirstConstruction());
                var s3 = com.vzome.core.construction.Segment.cast(strut3.getFirstConstruction());
                var offset1 = s1.getOffset();
                var offset2 = s2.getOffset();
                var offset3 = s3.getOffset();
                var v0 = null;
                var v1 = null;
                var v2 = null;
                var v3 = null;
                {
                  var s1s = s1.getStart();
                  var s1e = s1.getEnd();
                  var s2s = s2.getStart();
                  var s2e = s2.getEnd();

                  if (s1s.equals(s2s)) {
                    v1 = s1e;
                    v2 = s2e;
                    v0 = s2s;
                  } else if (s1e.equals(s2s)) {
                    v1 = s1s;
                    v2 = s2e;
                    v0 = s2s;
                    offset1 = offset1.negate();
                  } else if (s1e.equals(s2e)) {
                    v1 = s1s;
                    v2 = s2s;
                    v0 = s2e;
                    offset2 = offset2.negate();
                    offset1 = offset1.negate();
                  } else if (s1s.equals(s2e)) {
                    v1 = s1e;
                    v2 = s2s;
                    v0 = s2e;
                    offset2 = offset2.negate();
                  } else {
                    this.fail(errorMsg);
                  }

                  var s3s = s3.getStart();
                  var s3e = s3.getEnd();

                  if (s3s.equals(v0)) {
                    v3 = s3e;
                  } else if (s3e.equals(v0)) {
                    v3 = s3s;
                    offset3 = offset3.negate();
                  } else {
                    this.fail(errorMsg);
                  }
                }
                this.redo();
                var p0 = new com.vzome.core.construction.FreePoint(v0);
                var p1 = new com.vzome.core.construction.FreePoint(v1);
                var p2 = new com.vzome.core.construction.FreePoint(v2);
                var p3 = new com.vzome.core.construction.FreePoint(v3);
                this.manifestConstruction(p0);
                this.manifestConstruction(p1);
                this.manifestConstruction(p2);
                this.manifestConstruction(p3);
                this.redo();
                var v4 = v2.plus(offset3);
                var p4 = new com.vzome.core.construction.FreePoint(v4);
                this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(p4));
                this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(new com.vzome.core.construction.SegmentJoiningPoints(p2, p4)));
                this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(new com.vzome.core.construction.SegmentJoiningPoints(p3, p4)));
                var v5 = v3.plus(offset1);
                var p5 = new com.vzome.core.construction.FreePoint(v5);
                this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(p5));
                this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(new com.vzome.core.construction.SegmentJoiningPoints(p1, p5)));
                this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(new com.vzome.core.construction.SegmentJoiningPoints(p3, p5)));
                var v6 = v1.plus(offset2);
                var p6 = new com.vzome.core.construction.FreePoint(v6);
                this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(p6));
                this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(new com.vzome.core.construction.SegmentJoiningPoints(p1, p6)));
                this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(new com.vzome.core.construction.SegmentJoiningPoints(p2, p6)));
                var v7 = v4.plus(offset1);
                var p7 = new com.vzome.core.construction.FreePoint(v7);
                this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(p7));
                this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(new com.vzome.core.construction.SegmentJoiningPoints(p4, p7)));
                this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(new com.vzome.core.construction.SegmentJoiningPoints(p5, p7)));
                this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(new com.vzome.core.construction.SegmentJoiningPoints(p6, p7)));
                this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(new com.vzome.core.construction.PolygonFromVertices([p0, p3, p4, p2])));
                this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(new com.vzome.core.construction.PolygonFromVertices([p0, p1, p5, p3])));
                this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(new com.vzome.core.construction.PolygonFromVertices([p0, p2, p6, p1])));
                this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(new com.vzome.core.construction.PolygonFromVertices([p7, p4, p3, p5])));
                this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(new com.vzome.core.construction.PolygonFromVertices([p7, p6, p2, p4])));
                this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(new com.vzome.core.construction.PolygonFromVertices([p7, p5, p1, p6])));
                this.redo();
              }
            }]);

            return Parallelepiped;
          }(com.vzome.core.editor.api.ChangeManifestations);

          edits.Parallelepiped = Parallelepiped;
          Parallelepiped["__class"] = "com.vzome.core.edits.Parallelepiped";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          /**
          * @author David Hall
          * @param {*} editor
          * @class
          * @extends com.vzome.core.editor.api.ChangeManifestations
          */
          var SelectAutomaticStruts =
          /*#__PURE__*/
          function (_com$vzome$core$edito46) {
            _inherits(SelectAutomaticStruts, _com$vzome$core$edito46);

            var _super177 = _createSuper(SelectAutomaticStruts);

            function SelectAutomaticStruts(editor) {
              var _this122;

              _classCallCheck(this, SelectAutomaticStruts);

              _this122 = _super177.call(this, editor);
              if (_this122.symmetry === undefined) _this122.symmetry = null;
              if (_this122.editor === undefined) _this122.editor = null;
              _this122.editor = editor;
              _this122.symmetry = editor['getSymmetrySystem$']();
              return _this122;
            }
            /**
            *
            */


            _createClass(SelectAutomaticStruts, [{
              key: "perform",
              value: function perform() {
                var _this123 = this;

                this.unselectAll();

                for (var index751 = this.getVisibleStruts$java_util_function_Predicate(function (strut) {
                  return _this123.isAutomaticStrut(strut);
                }).iterator(); index751.hasNext();) {
                  var strut = index751.next();
                  {
                    this.select$com_vzome_core_model_Manifestation(strut);
                  }
                }

                _get(_getPrototypeOf(SelectAutomaticStruts.prototype), "perform", this).call(this);
              }
              /*private*/

            }, {
              key: "isAutomaticStrut",
              value: function isAutomaticStrut(strut) {
                return this.symmetry.getAxis(strut.getOffset()).getOrbit().isAutomatic();
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "SelectAutomaticStruts";
              }
              /**
              *
              * @param {*} element
              */

            }, {
              key: "getXmlAttributes",
              value: function getXmlAttributes(element) {
                if (this.symmetry != null) {
                  com.vzome.xml.DomUtils.addAttribute(element, "symmetry", this.symmetry.getName());
                }
              }
              /**
              *
              * @param {*} xml
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              */

            }, {
              key: "setXmlAttributes",
              value: function setXmlAttributes(xml, format) {
                this.symmetry = this.editor['getSymmetrySystem$java_lang_String'](xml.getAttribute("symmetry"));
              }
            }]);

            return SelectAutomaticStruts;
          }(com.vzome.core.editor.api.ChangeManifestations);

          edits.SelectAutomaticStruts = SelectAutomaticStruts;
          SelectAutomaticStruts["__class"] = "com.vzome.core.edits.SelectAutomaticStruts";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          /**
          * @author David Hall
          * @param {*} editor
          * @class
          * @extends com.vzome.core.editor.api.ChangeManifestations
          */
          var SelectCollinear =
          /*#__PURE__*/
          function (_com$vzome$core$edito47) {
            _inherits(SelectCollinear, _com$vzome$core$edito47);

            var _super178 = _createSuper(SelectCollinear);

            function SelectCollinear(editor) {
              var _this124;

              _classCallCheck(this, SelectCollinear);

              _this124 = _super178.call(this, editor);
              _this124.vector1 = null;
              _this124.vector2 = null;
              return _this124;
            }
            /**
            *
            * @param {*} props
            */


            _createClass(SelectCollinear, [{
              key: "configure",
              value: function configure(props) {
                var strut = props.get("picked");

                if (strut != null) {
                  this.vector1 = strut.getLocation();
                  this.vector2 = strut.getEnd();
                }
              }
              /**
              *
              */

            }, {
              key: "perform",
              value: function perform() {
                var _this125 = this;

                if (this.vector1 == null || this.vector2 == null) {
                  var lastStrut = this.getLastSelectedStrut();

                  if (lastStrut != null) {
                    this.vector1 = lastStrut.getLocation();
                    this.vector2 = lastStrut.getEnd();
                  } else {
                    for (var index752 = this.getSelectedConnectors().iterator(); index752.hasNext();) {
                      var ball = index752.next();
                      {
                        this.vector1 = this.vector2;
                        this.vector2 = ball.getLocation();
                      }
                    }
                  }
                }

                if (this.vector1 == null || this.vector2 == null) {
                  throw new com.vzome.core.commands.Command.Failure("select a strut or two balls as a reference.");
                }

                this.unselectAll();
                var balls = new java.util.TreeSet();

                for (var index753 = this.getVisibleConnectors$java_util_function_Predicate(function (ball) {
                  return _this125.isCollinearWith(ball);
                }).iterator(); index753.hasNext();) {
                  var _ball = index753.next();

                  {
                    balls.add(_ball);
                  }
                }

                var struts = new java.util.TreeSet();

                for (var index754 = this.getVisibleStruts$().iterator(); index754.hasNext();) {
                  var strut = index754.next();
                  {
                    if (this.isCollinearWith$com_vzome_core_model_Strut(strut)) {
                      struts.add(strut);
                    }
                  }
                }

                for (var index755 = struts.iterator(); index755.hasNext();) {
                  var _strut2 = index755.next();

                  {
                    this.select$com_vzome_core_model_Manifestation(_strut2);
                  }
                }

                for (var index756 = balls.iterator(); index756.hasNext();) {
                  var _ball2 = index756.next();

                  {
                    this.select$com_vzome_core_model_Manifestation(_ball2);
                  }
                }

                var level = java.util.logging.Level.FINER;

                if (com.vzome.core.editor.api.ChangeSelection.logger_$LI$().isLoggable(level)) {
                  var sb = new java.lang.StringBuilder("Selected:\n");
                  var indent = "  ";

                  for (var index757 = struts.iterator(); index757.hasNext();) {
                    var _strut3 = index757.next();

                    {
                      sb.append(indent).append(_strut3.toString()).append("\n");
                    }
                  }

                  for (var index758 = balls.iterator(); index758.hasNext();) {
                    var _ball3 = index758.next();

                    {
                      sb.append(indent).append(_ball3.toString()).append("\n");
                    }
                  }

                  com.vzome.core.editor.api.ChangeSelection.logger_$LI$().log(level, sb.toString());
                }

                _get(_getPrototypeOf(SelectCollinear.prototype), "perform", this).call(this);
              }
            }, {
              key: "isCollinearWith$com_vzome_core_model_Connector",
              value: function isCollinearWith$com_vzome_core_model_Connector(ball) {
                return this.isCollinear(ball.getLocation());
              }
            }, {
              key: "isCollinearWith",
              value: function isCollinearWith(ball) {
                if (ball != null && (ball["__interfaces"] != null && ball["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || ball.constructor != null && ball.constructor["__interfaces"] != null && ball.constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0) || ball === null) {
                  return this.isCollinearWith$com_vzome_core_model_Connector(ball);
                } else if (ball != null && (ball["__interfaces"] != null && ball["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || ball.constructor != null && ball.constructor["__interfaces"] != null && ball.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0) || ball === null) {
                  return this.isCollinearWith$com_vzome_core_model_Strut(ball);
                } else throw new Error('invalid overload');
              }
              /*private*/

            }, {
              key: "isCollinearWith$com_vzome_core_model_Strut",
              value: function isCollinearWith$com_vzome_core_model_Strut(strut) {
                return this.isCollinear(strut.getLocation()) && this.isCollinear(strut.getEnd());
              }
              /*private*/

            }, {
              key: "isCollinear",
              value: function isCollinear(vec) {
                return com.vzome.core.algebra.AlgebraicVectors.areCollinear$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector$com_vzome_core_algebra_AlgebraicVector(vec, this.vector1, this.vector2);
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "SelectCollinear";
              }
              /**
              *
              * @param {*} element
              */

            }, {
              key: "getXmlAttributes",
              value: function getXmlAttributes(element) {
                com.vzome.xml.DomUtils.addAttribute(element, "vector1", this.vector1.toParsableString());
                com.vzome.xml.DomUtils.addAttribute(element, "vector2", this.vector2.toParsableString());
              }
              /**
              *
              * @param {*} xml
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              */

            }, {
              key: "setXmlAttributes",
              value: function setXmlAttributes(xml, format) {
                this.vector1 = format.parseRationalVector(xml, "vector1");
                this.vector2 = format.parseRationalVector(xml, "vector2");
              }
            }]);

            return SelectCollinear;
          }(com.vzome.core.editor.api.ChangeManifestations);

          edits.SelectCollinear = SelectCollinear;
          SelectCollinear["__class"] = "com.vzome.core.edits.SelectCollinear";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (editor_5) {
          /**
          * Just a mechanism to incorporate the legacy edit mechanism into the new undo/redo.
          *
          * @author Scott Vorthmann 2006
          * @param {com.vzome.core.commands.AbstractCommand} cmd
          * @param {*} editor
          * @class
          * @extends com.vzome.core.editor.api.ChangeManifestations
          */
          var CommandEdit =
          /*#__PURE__*/
          function (_com$vzome$core$edito48) {
            _inherits(CommandEdit, _com$vzome$core$edito48);

            var _super179 = _createSuper(CommandEdit);

            function CommandEdit(cmd, editor) {
              var _this126;

              _classCallCheck(this, CommandEdit);

              _this126 = _super179.call(this, editor);
              if (_this126.mEditorModel === undefined) _this126.mEditorModel = null;
              if (_this126.mCommand === undefined) _this126.mCommand = null;
              if (_this126.mAttrs === undefined) _this126.mAttrs = null;
              _this126.mEditorModel = editor;
              _this126.mCommand = cmd;
              return _this126;
            }

            _createClass(CommandEdit, [{
              key: "groupingAware",

              /**
              *
              * @return {boolean}
              */
              value: function groupingAware() {
                return true;
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                var cmdName = function (c) {
                  return c["__class"] ? c["__class"] : c["name"];
                }(this.mCommand.constructor);

                var lastDot = cmdName.lastIndexOf('.');
                return cmdName.substring(lastDot + 1 + "Command".length);
              }
              /**
              *
              * @param {*} result
              */

            }, {
              key: "getXmlAttributes",
              value: function getXmlAttributes(result) {
                this.mCommand.getXml(result, this.mAttrs);
              }
              /**
              *
              * @param {*} xml
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              */

            }, {
              key: "setXmlAttributes",
              value: function setXmlAttributes(xml, format) {
                this.mAttrs = this.mCommand.setXml(xml, format);
                this.mAttrs.put(com.vzome.core.commands.Command.LOADING_FROM_FILE, javaemul.internal.BooleanHelper.TRUE);
              }
              /**
              *
              */

            }, {
              key: "perform",
              value: function perform() {
                var isHide = this.mCommand != null && this.mCommand instanceof com.vzome.core.commands.CommandHide;

                if (CommandEdit.logger_$LI$().isLoggable(java.util.logging.Level.FINER)) {
                  CommandEdit.logger_$LI$().finer("------------------- CommandEdit");
                }

                if (this.mCommand.ordersSelection()) this.setOrderedSelection(true);
                var constrsBefore = new com.vzome.core.construction.ConstructionList();

                for (var index759 = this.mSelection.iterator(); index759.hasNext();) {
                  var man = index759.next();
                  {
                    if (CommandEdit.logger_$LI$().isLoggable(java.util.logging.Level.FINER)) {
                      CommandEdit.logger_$LI$().finer("----------- manifestation: " + man.toString());

                      for (var iterator = man.getConstructions(); iterator.hasNext();) {
                        {
                          var c = iterator.next();
                          CommandEdit.logger_$LI$().finer("   " + c.toString());
                        }
                      }
                    }

                    this.unselect$com_vzome_core_model_Manifestation(man);
                    if (isHide) this.hideManifestation(man);else {
                      var construction = man.getFirstConstruction();
                      constrsBefore.add(construction);
                    }
                  }
                }

                this.redo();
                if (isHide) return;
                if (this.mAttrs == null) this.mAttrs = new com.vzome.core.commands.AttributeMap();
                var symmAxis = this.mEditorModel.getSymmetrySegment();
                if (symmAxis != null) this.mAttrs.put(com.vzome.core.commands.CommandTransform.SYMMETRY_AXIS_ATTR_NAME, symmAxis);
                this.mAttrs.put(com.vzome.core.commands.CommandTransform.SYMMETRY_CENTER_ATTR_NAME, this.mEditorModel.getCenterPoint());
                this.mAttrs.put(com.vzome.core.commands.Command.FIELD_ATTR_NAME, this.mManifestations.getField());
                var news = new CommandEdit.NewConstructions();
                var selectionAfter = null;
                var signature = this.mCommand.getParameterSignature();
                var actualsLen = constrsBefore.size();

                if (signature.length === actualsLen || signature.length === 1 &&
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(signature[0][0], com.vzome.core.commands.Command.GENERIC_PARAM_NAME)) {
                  try {
                    selectionAfter = this.mCommand.apply(constrsBefore, this.mAttrs, news);
                  } catch (f) {
                    this.undo();
                    throw f;
                  }
                } else if (signature.length > actualsLen) {
                  this.fail("Too few objects in the selection.");
                } else if (signature.length === 1) {
                  var partial;
                  selectionAfter = new com.vzome.core.construction.ConstructionList();

                  for (var i = 0; i < actualsLen; i++) {
                    {
                      var param = constrsBefore.get(i);
                      var formalClass = signature[0][1];

                      if (formalClass === com.vzome.core.construction.Point && param != null && param instanceof com.vzome.core.construction.Point || formalClass === com.vzome.core.construction.Segment && param != null && param instanceof com.vzome.core.construction.Segment) {
                        var single = new com.vzome.core.construction.ConstructionList();
                        single.addConstruction(param);
                        partial = this.mCommand.apply(single, this.mAttrs, news);
                        selectionAfter.addAll(partial);
                      } else selectionAfter.add(param);
                    }
                  }
                } else this.fail("Too many objects in the selection.");

                for (var index760 = news.iterator(); index760.hasNext();) {
                  var _c = index760.next();

                  {
                    this.manifestConstruction(_c);
                  }
                }

                for (var index761 = selectionAfter.iterator(); index761.hasNext();) {
                  var cons = index761.next();
                  {
                    if (cons.failed()) {
                      CommandEdit.logBugAccommodation("failed construction");
                      this.mEditorModel.addFailedConstruction(cons);
                      continue;
                    }

                    var _man7 = this.manifestConstruction(cons);

                    if (_man7 != null) this.select$com_vzome_core_model_Manifestation(_man7);
                  }
                }

                this.redo();
              }
              /**
              *
              * @param {*} xml
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              * @param {*} context
              */

            }, {
              key: "loadAndPerform",
              value: function loadAndPerform(xml, format, context) {
                var cmdName = null;
                if (format.selectionsNotSaved()) cmdName = xml.getLocalName();else if (format.commandEditsCompacted()) cmdName = "Command" + xml.getLocalName();else cmdName = xml.getAttribute("command");
                if (
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(cmdName, "CommandIcosahedralSymmetry")) cmdName = "CommandSymmetry";
                this.mCommand = context.createLegacyCommand(cmdName);

                if (format.selectionsNotSaved()) {
                  var selectedBefore = new java.util.LinkedHashSet();
                  context.performAndRecord(new com.vzome.core.editor.BeginBlock(null));
                  this.mAttrs = new com.vzome.core.commands.AttributeMap();
                  var nodes = xml.getChildNodes();

                  for (var j = 0; j < nodes.getLength(); j++) {
                    {
                      var kid2 = nodes.item(j);

                      if (kid2 != null && (kid2["__interfaces"] != null && kid2["__interfaces"].indexOf("org.w3c.dom.Element") >= 0 || kid2.constructor != null && kid2.constructor["__interfaces"] != null && kid2.constructor["__interfaces"].indexOf("org.w3c.dom.Element") >= 0)) {
                        var attrOrParam = kid2;
                        var apName = attrOrParam.getLocalName();

                        if (
                        /* equals */
                        function (o1, o2) {
                          if (o1 && o1.equals) {
                            return o1.equals(o2);
                          } else {
                            return o1 === o2;
                          }
                        }(apName, "attr")) {
                          var attrName = attrOrParam.getAttribute("name");
                          if (
                          /* endsWith */
                          function (str, searchString) {
                            var pos = str.length - searchString.length;
                            var lastIndex = str.indexOf(searchString, pos);
                            return lastIndex !== -1 && lastIndex === pos;
                          }(attrName, ".symmetry.center")) attrName = com.vzome.core.commands.CommandTransform.SYMMETRY_CENTER_ATTR_NAME;else if (
                          /* equals */
                          function (o1, o2) {
                            if (o1 && o1.equals) {
                              return o1.equals(o2);
                            } else {
                              return o1 === o2;
                            }
                          }(attrName, "reflection.mirror.normal.segment")) attrName = com.vzome.core.commands.CommandTransform.SYMMETRY_AXIS_ATTR_NAME;
                          var val = com.vzome.xml.DomUtils.getFirstChildElement$org_w3c_dom_Element(attrOrParam);
                          var valName = val.getLocalName();
                          if (
                          /* equals */
                          function (o1, o2) {
                            if (o1 && o1.equals) {
                              return o1.equals(o2);
                            } else {
                              return o1 === o2;
                            }
                          }(valName, "FreePoint")) valName = "point";
                          var value = format.parseAlgebraicObject(valName, val);
                          if (value === com.vzome.core.commands.XmlSaveFormat.NOT_AN_ATTRIBUTE_$LI$()) value = format.parseConstruction$java_lang_String$org_w3c_dom_Element(valName, val);

                          if (
                          /* equals */
                          function (o1, o2) {
                            if (o1 && o1.equals) {
                              return o1.equals(o2);
                            } else {
                              return o1 === o2;
                            }
                          }(attrName, com.vzome.core.commands.CommandTransform.SYMMETRY_CENTER_ATTR_NAME)) {
                            var c = new com.vzome.core.construction.FreePoint(value.getLocation().projectTo3d(true));
                            context.performAndRecord(new com.vzome.core.edits.SymmetryCenterChange(this.mEditorModel, c));
                          } else if (
                          /* equals */
                          function (o1, o2) {
                            if (o1 && o1.equals) {
                              return o1.equals(o2);
                            } else {
                              return o1 === o2;
                            }
                          }(attrName, com.vzome.core.commands.CommandTransform.SYMMETRY_AXIS_ATTR_NAME)) {
                            context.performAndRecord(new com.vzome.core.edits.SymmetryAxisChange(this.mEditorModel, value));

                            if (!this.mCommand.attributeIs3D(attrName)) {
                              var vector = value.getOffset();
                              this.mCommand.setQuaternion(vector);
                            }
                          } else this.mAttrs.put(attrName, value);
                        } else {
                          var _c2 = format.parseConstruction$java_lang_String$org_w3c_dom_Element(apName, attrOrParam);

                          if (_c2 != null) {
                            if (this.mEditorModel.hasFailedConstruction(_c2)) {
                              CommandEdit.logBugAccommodation("skip selecting a failed construction");
                              continue;
                            }

                            var m = this.getManifestation(_c2);

                            if (m == null || m.isUnnecessary()) {
                              CommandEdit.loadAndPerformLgger_$LI$().severe("CommandEdit parameter: " + attrOrParam.toString());
                              throw new com.vzome.core.commands.Command.Failure("no manifestation to be selected.");
                            }

                            if (!selectedBefore.contains(m)) selectedBefore.add(m);
                          }
                        }
                      }
                    }
                  }

                  if (selectedBefore.size() > (this.mManifestations.size() / 2 | 0)) {
                    var toUnselect = new java.util.ArrayList();

                    for (var index762 = this.mManifestations.iterator(); index762.hasNext();) {
                      var _m = index762.next();

                      {
                        if (!selectedBefore.contains(_m)) toUnselect.add(_m);
                      }
                    }

                    var edit = new com.vzome.core.edits.SelectAll(this.mEditorModel);
                    context.performAndRecord(edit);

                    for (var index763 = toUnselect.iterator(); index763.hasNext();) {
                      var _m2 = index763.next();

                      {
                        edit = new com.vzome.core.edits.SelectManifestation(this.mEditorModel, _m2);
                        context.performAndRecord(edit);
                      }
                    }
                  } else {
                    var _edit = new com.vzome.core.edits.DeselectAll(this.mEditorModel);

                    context.performAndRecord(_edit);

                    for (var index764 = selectedBefore.iterator(); index764.hasNext();) {
                      var _m3 = index764.next();

                      {
                        _edit = new com.vzome.core.edits.SelectManifestation(this.mEditorModel, _m3);
                        context.performAndRecord(_edit);
                      }
                    }
                  }

                  context.performAndRecord(new com.vzome.core.editor.EndBlock(null));
                  this.redo();

                  if (this.mCommand != null && this.mCommand instanceof com.vzome.core.commands.CommandObliquePentagon) {
                    var _edit2 = new com.vzome.core.edits.AffinePentagon(this.mEditorModel);

                    context.performAndRecord(_edit2);
                    return;
                  }

                  this.mCommand.setFixedAttributes(this.mAttrs, format);
                  this.mAttrs.put(com.vzome.core.commands.Command.LOADING_FROM_FILE, javaemul.internal.BooleanHelper.TRUE);
                  context.performAndRecord(this);
                } else _get(_getPrototypeOf(CommandEdit.prototype), "loadAndPerform", this).call(this, xml, format, context);
              }
            }], [{
              key: "logger_$LI$",
              value: function logger_$LI$() {
                if (CommandEdit.logger == null) CommandEdit.logger = java.util.logging.Logger.getLogger("com.vzome.core.editor.CommandEdit");
                return CommandEdit.logger;
              }
            }, {
              key: "loadAndPerformLgger_$LI$",
              value: function loadAndPerformLgger_$LI$() {
                if (CommandEdit.loadAndPerformLgger == null) CommandEdit.loadAndPerformLgger = java.util.logging.Logger.getLogger("com.vzome.core.editor.CommandEdit.loadAndPerform");
                return CommandEdit.loadAndPerformLgger;
              }
            }]);

            return CommandEdit;
          }(com.vzome.core.editor.api.ChangeManifestations);

          editor_5.CommandEdit = CommandEdit;
          CommandEdit["__class"] = "com.vzome.core.editor.CommandEdit";

          (function (CommandEdit) {
            var NewConstructions =
            /*#__PURE__*/
            function (_java$util$ArrayList5) {
              _inherits(NewConstructions, _java$util$ArrayList5);

              var _super180 = _createSuper(NewConstructions);

              _createClass(NewConstructions, [{
                key: "constructionAdded",

                /**
                *
                * @param {com.vzome.core.construction.Construction} c
                */
                value: function constructionAdded(c) {
                  this.add(c);
                }
              }]);

              function NewConstructions() {
                _classCallCheck(this, NewConstructions);

                return _super180.call(this);
              }

              return NewConstructions;
            }(java.util.ArrayList);

            CommandEdit.NewConstructions = NewConstructions;
            NewConstructions["__class"] = "com.vzome.core.editor.CommandEdit.NewConstructions";
            NewConstructions["__interfaces"] = ["java.util.RandomAccess", "java.util.List", "java.lang.Cloneable", "com.vzome.core.construction.ConstructionChanges", "java.util.Collection", "java.lang.Iterable", "java.io.Serializable"];
          })(CommandEdit = editor_5.CommandEdit || (editor_5.CommandEdit = {}));
        })(core.editor || (core.editor = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (editor) {
          var Tool =
          /*#__PURE__*/
          function (_com$vzome$core$edito49) {
            _inherits(Tool, _com$vzome$core$edito49);

            var _super181 = _createSuper(Tool);

            function Tool(id, tools) {
              var _this127;

              _classCallCheck(this, Tool);

              _this127 = _super181.call(this, tools.getEditorModel());
              if (_this127.id === undefined) _this127.id = null;
              if (_this127.tools === undefined) _this127.tools = null;
              _this127.parameters = new java.util.ArrayList();
              if (_this127.category === undefined) _this127.category = null;
              if (_this127.predefined === undefined) _this127.predefined = false;
              if (_this127.hidden === undefined) _this127.hidden = false;
              if (_this127.label === undefined) _this127.label = null;
              if (_this127.selectInputs === undefined) _this127.selectInputs = false;
              if (_this127.deleteInputs === undefined) _this127.deleteInputs = false;
              _this127.pcs = new java.beans.PropertyChangeSupport(_assertThisInitialized(_this127));
              _this127.tools = tools;
              _this127.id = id;
              _this127.selectInputs = true;
              _this127.deleteInputs = false;
              return _this127;
            }

            _createClass(Tool, [{
              key: "isSelectInputs",
              value: function isSelectInputs() {
                return this.selectInputs;
              }
            }, {
              key: "isDeleteInputs",
              value: function isDeleteInputs() {
                return this.deleteInputs;
              }
            }, {
              key: "setInputBehaviors",
              value: function setInputBehaviors(selectInputs, deleteInputs) {
                this.selectInputs = selectInputs;
                this.deleteInputs = deleteInputs;
              }
            }, {
              key: "addPropertyChangeListener",
              value: function addPropertyChangeListener(listener) {
                this.pcs.addPropertyChangeListener(listener);
              }
            }, {
              key: "setCategory",
              value: function setCategory(category) {
                this.category = category;
              }
            }, {
              key: "addParameter",
              value: function addParameter(c) {
                this.parameters.add(c);
              }
            }, {
              key: "getParameters",
              value: function getParameters() {
                return this.parameters;
              }
            }, {
              key: "setPredefined",
              value: function setPredefined(value) {
                this.predefined = value;
              }
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "isNoOp",
              value: function isNoOp() {
                return false;
              }
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "isSticky",
              value: function isSticky() {
                return true;
              }
              /**
              *
              */

            }, {
              key: "redo",
              value: function redo() {}
              /**
              *
              */

            }, {
              key: "undo",
              value: function undo() {}
              /**
              *
              */

            }, {
              key: "perform",
              value: function perform() {
                var error = this.checkSelection(true);
                if (error != null) throw new com.vzome.core.commands.Command.Failure(error);
                this.tools.put(this.getId(), this);
              }
              /**
              *
              * @param {*} element
              */

            }, {
              key: "getXmlAttributes",
              value: function getXmlAttributes(element) {
                element.setAttribute("name", this.id);
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getId",
              value: function getId() {
                return this.id;
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getCategory",
              value: function getCategory() {
                return this.category;
              }
              /**
              *
              * @param {boolean} selectInputs
              * @param {boolean} deleteInputs
              * @param {boolean} createOutputs
              * @param {boolean} selectOutputs
              */

            }, {
              key: "apply",
              value: function apply(selectInputs, deleteInputs, createOutputs, selectOutputs) {
                this.tools.applyTool(this, selectInputs, deleteInputs, createOutputs, selectOutputs);
              }
              /**
              *
              */

            }, {
              key: "selectParameters",
              value: function selectParameters() {
                this.tools.selectToolParameters(this);
              }
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "isPredefined",
              value: function isPredefined() {
                return this.predefined;
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getLabel",
              value: function getLabel() {
                return this.label;
              }
              /**
              *
              * @param {string} label
              */

            }, {
              key: "setLabel",
              value: function setLabel(label) {
                this.label = label;
              }
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "isHidden",
              value: function isHidden() {
                return this.hidden;
              }
              /**
              *
              * @param {boolean} hidden
              */

            }, {
              key: "setHidden",
              value: function setHidden(hidden) {
                this.hidden = hidden;
                this.tools.hideTool(this);
              }
            }]);

            return Tool;
          }(com.vzome.core.editor.api.ChangeManifestations);

          editor.Tool = Tool;
          Tool["__class"] = "com.vzome.core.editor.Tool";
          Tool["__interfaces"] = ["com.vzome.api.Tool"];
        })(core.editor || (core.editor = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (editor) {
          var ApplyTool =
          /*#__PURE__*/
          function (_com$vzome$core$edito50) {
            _inherits(ApplyTool, _com$vzome$core$edito50);

            var _super182 = _createSuper(ApplyTool);

            function ApplyTool(tools, tool, selectInputs, deleteInputs, createOutputs, selectOutputs, redundantOutputs) {
              var _this128;

              _classCallCheck(this, ApplyTool);

              _this128 = _super182.call(this, tools.getEditorModel());
              if (_this128.tool === undefined) _this128.tool = null;
              if (_this128.selectInputs === undefined) _this128.selectInputs = false;
              if (_this128.deselectOutputs === undefined) _this128.deselectOutputs = false;
              if (_this128.justSelect === undefined) _this128.justSelect = false;
              if (_this128.hideInputs === undefined) _this128.hideInputs = false;
              if (_this128.deleteInputs === undefined) _this128.deleteInputs = false;
              if (_this128.redundantOutputs === undefined) _this128.redundantOutputs = false;
              if (_this128.tools === undefined) _this128.tools = null;
              _this128.tools = tools;
              _this128.tool = tool;
              _this128.selectInputs = selectInputs;
              _this128.deleteInputs = deleteInputs;
              _this128.hideInputs = false;
              _this128.deselectOutputs = !selectOutputs;
              _this128.justSelect = !createOutputs;
              _this128.redundantOutputs = redundantOutputs;
              return _this128;
            }
            /**
            *
            */


            _createClass(ApplyTool, [{
              key: "perform",
              value: function perform() {
                var inputs = new java.util.ArrayList();

                for (var index765 = this.mSelection.iterator(); index765.hasNext();) {
                  var man = index765.next();
                  {
                    if (this.deleteInputs && this.tool.needsInput()) {
                      _get(_getPrototypeOf(ApplyTool.prototype), "unselect$com_vzome_core_model_Manifestation$boolean", this).call(this, man, true);

                      _get(_getPrototypeOf(ApplyTool.prototype), "deleteManifestation", this).call(this, man);
                    } else if (this.hideInputs && this.tool.needsInput()) {
                      _get(_getPrototypeOf(ApplyTool.prototype), "unselect$com_vzome_core_model_Manifestation$boolean", this).call(this, man, true);

                      _get(_getPrototypeOf(ApplyTool.prototype), "hideManifestation", this).call(this, man);
                    } else if (!this.selectInputs) _get(_getPrototypeOf(ApplyTool.prototype), "unselect$com_vzome_core_model_Manifestation$boolean", this).call(this, man, true);

                    if (this.tool.needsInput()) inputs.add(man);
                  }
                }

                this.redo();
                this.tool.prepare(this);

                if (this.tool.needsInput()) {
                  for (var index766 = inputs.iterator(); index766.hasNext();) {
                    var _man8 = index766.next();

                    {
                      var c = _man8.toConstruction();

                      c.setColor(_man8.getColor());
                      this.tool.performEdit(c, this);
                    }
                  }
                } else {
                  for (var index767 = this.mManifestations.iterator(); index767.hasNext();) {
                    var _man9 = index767.next();

                    {
                      this.tool.performSelect(_man9, this);
                    }
                  }
                }

                this.tool.complete(this);
                this.redo();

                _get(_getPrototypeOf(ApplyTool.prototype), "perform", this).call(this);
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                if (this.redundantOutputs) return "ApplyTool";else return "ToolApplied";
              }
              /**
              *
              * @param {*} element
              */

            }, {
              key: "getXmlAttributes",
              value: function getXmlAttributes(element) {
                element.setAttribute("name", this.tool.getId());
                if (this.selectInputs) element.setAttribute("selectInputs", "true");
                if (this.deselectOutputs) element.setAttribute("deselectOutputs", "true");
                if (this.justSelect) element.setAttribute("justSelect", "true");
                if (this.hideInputs) element.setAttribute("hideInputs", "true");
                if (this.deleteInputs) element.setAttribute("deleteInputs", "true");
              }
              /**
              *
              * @param {*} element
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              */

            }, {
              key: "setXmlAttributes",
              value: function setXmlAttributes(element, format) {
                var toolName = element.getAttribute("name");
                this.tool = this.tools.get(toolName);
                this.selectInputs = this.isAttributeTrue(element, "selectInputs");
                this.deselectOutputs = this.isAttributeTrue(element, "deselectOutputs");
                this.justSelect = this.isAttributeTrue(element, "justSelect");
                this.hideInputs = this.isAttributeTrue(element, "hideInputs");
                this.deleteInputs = this.isAttributeTrue(element, "deleteInputs");
              }
              /*private*/

            }, {
              key: "isAttributeTrue",
              value: function isAttributeTrue(element, name) {
                var value = element.getAttribute(name);
                return value != null &&
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(value, "true");
              }
              /**
              *
              * @param {com.vzome.core.construction.Construction} c
              * @return {*}
              */

            }, {
              key: "manifestConstruction",
              value: function manifestConstruction(c) {
                var m = this.getManifestation(c);
                var preExistsNotHidden = m != null && m.isRendered();

                if (this.justSelect) {
                  if (preExistsNotHidden) _get(_getPrototypeOf(ApplyTool.prototype), "select$com_vzome_core_model_Manifestation$boolean", this).call(this, m, false);
                } else if (this.redundantOutputs || !preExistsNotHidden) {
                  m = _get(_getPrototypeOf(ApplyTool.prototype), "manifestConstruction", this).call(this, c);
                  if (!this.deselectOutputs) _get(_getPrototypeOf(ApplyTool.prototype), "select$com_vzome_core_model_Manifestation$boolean", this).call(this, m, true);
                }

                return m;
              }
            }, {
              key: "select",
              value: function select(man, ignoreGroups) {
                if ((man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0) || man === null) && (typeof ignoreGroups === 'boolean' || ignoreGroups === null)) {
                  _get(_getPrototypeOf(ApplyTool.prototype), "select", this).call(this, man, ignoreGroups);
                } else if ((man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0) || man === null) && ignoreGroups === undefined) {
                  return this.select$com_vzome_core_model_Manifestation(man);
                } else throw new Error('invalid overload');
              }
            }, {
              key: "select$com_vzome_core_model_Manifestation",
              value: function select$com_vzome_core_model_Manifestation(m) {
                if (this.tool.needsInput()) throw new java.lang.UnsupportedOperationException("select is not supported within Tool.performEdit");
                if (!m.isRendered()) _get(_getPrototypeOf(ApplyTool.prototype), "showManifestation", this).call(this, m);

                _get(_getPrototypeOf(ApplyTool.prototype), "select$com_vzome_core_model_Manifestation$boolean", this).call(this, m, true);
              }
            }, {
              key: "unselect",
              value: function unselect(man, ignoreGroups) {
                if ((man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0) || man === null) && (typeof ignoreGroups === 'boolean' || ignoreGroups === null)) {
                  _get(_getPrototypeOf(ApplyTool.prototype), "unselect", this).call(this, man, ignoreGroups);
                } else if ((man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0) || man === null) && ignoreGroups === undefined) {
                  return this.unselect$com_vzome_core_model_Manifestation(man);
                } else throw new Error('invalid overload');
              }
            }, {
              key: "unselect$com_vzome_core_model_Manifestation",
              value: function unselect$com_vzome_core_model_Manifestation(man) {
                throw new java.lang.UnsupportedOperationException("unselect is not supported within Tool.performEdit");
              }
              /**
              *
              * @param {*} m
              */

            }, {
              key: "showManifestation",
              value: function showManifestation(m) {
                throw new java.lang.UnsupportedOperationException("showManifestation is not supported within Tool.performEdit");
              }
              /**
              *
              * @param {*} m
              */

            }, {
              key: "hideManifestation",
              value: function hideManifestation(m) {
                throw new java.lang.UnsupportedOperationException("hideManifestation is not supported within Tool.performEdit");
              }
            }]);

            return ApplyTool;
          }(com.vzome.core.editor.api.ChangeManifestations);

          editor.ApplyTool = ApplyTool;
          ApplyTool["__class"] = "com.vzome.core.editor.ApplyTool";
        })(core.editor || (core.editor = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (editor) {
          var SelectToolParameters =
          /*#__PURE__*/
          function (_com$vzome$core$edito51) {
            _inherits(SelectToolParameters, _com$vzome$core$edito51);

            var _super183 = _createSuper(SelectToolParameters);

            function SelectToolParameters(tools, tool) {
              var _this129;

              _classCallCheck(this, SelectToolParameters);

              _this129 = _super183.call(this, tools.getEditorModel());
              if (_this129.tool === undefined) _this129.tool = null;
              if (_this129.tools === undefined) _this129.tools = null;
              _this129.tools = tools;
              _this129.tool = tool;
              return _this129;
            }
            /**
            *
            */


            _createClass(SelectToolParameters, [{
              key: "perform",
              value: function perform() {
                for (var index768 = this.mSelection.iterator(); index768.hasNext();) {
                  var man = index768.next();

                  _get(_getPrototypeOf(SelectToolParameters.prototype), "unselect$com_vzome_core_model_Manifestation$boolean", this).call(this, man, true);
                }

                this.redo();

                for (var index769 = this.tool.getParameters().iterator(); index769.hasNext();) {
                  var con = index769.next();
                  {
                    var _man10 = this.manifestConstruction(con);

                    this.select$com_vzome_core_model_Manifestation(_man10);
                  }
                }

                this.redo();
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "SelectToolParameters";
              }
              /**
              *
              * @param {*} element
              */

            }, {
              key: "getXmlAttributes",
              value: function getXmlAttributes(element) {
                element.setAttribute("name", this.tool.getId());
              }
              /**
              *
              * @param {*} element
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              */

            }, {
              key: "setXmlAttributes",
              value: function setXmlAttributes(element, format) {
                var toolName = element.getAttribute("name");
                this.tool = this.tools.get(toolName);
              }
            }]);

            return SelectToolParameters;
          }(com.vzome.core.editor.api.ChangeManifestations);

          editor.SelectToolParameters = SelectToolParameters;
          SelectToolParameters["__class"] = "com.vzome.core.editor.SelectToolParameters";
        })(core.editor || (core.editor = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          var SelectByDiameter =
          /*#__PURE__*/
          function (_com$vzome$core$edits) {
            _inherits(SelectByDiameter, _com$vzome$core$edits);

            var _super184 = _createSuper(SelectByDiameter);

            function SelectByDiameter(editor) {
              var _this130;

              _classCallCheck(this, SelectByDiameter);

              _this130 = _super184.call(this, editor);
              if (_this130.center === undefined) _this130.center = null;
              if (_this130.maxRadiusSquared === undefined) _this130.maxRadiusSquared = null;
              return _this130;
            }
            /**
            *
            * @return {string}
            */


            _createClass(SelectByDiameter, [{
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return SelectByDiameter.NAME;
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "usage",
              value: function usage() {
                return "This command requires two connectors which define the\ndiameter of a sphere centered at their midpoint.\n\nAll parts that are completely within the sphere will be selected.\n";
              }
            }, {
              key: "adjustBoundary",
              value: function adjustBoundary(vectors) {
                switch (vectors.size()) {
                  case 1:
                    return null;

                  case 2:
                    this.center = com.vzome.core.algebra.AlgebraicVectors.calculateCentroid(vectors);
                    var v1 = vectors.get(0).minus(this.center);
                    this.maxRadiusSquared = v1.dot(v1);
                    return null;
                }

                return "Too many connectors are selected.";
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "setBoundary",
              value: function setBoundary() {
                this.center = null;
                this.maxRadiusSquared = null;
                var vectors = new java.util.ArrayList();

                for (var index770 = this.mSelection.iterator(); index770.hasNext();) {
                  var man = index770.next();
                  {
                    if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0)) {
                      vectors.add(man.getLocation());
                      var errMsg = this.adjustBoundary(vectors);

                      if (errMsg != null) {
                        return errMsg;
                      }
                    }
                  }
                }

                if (vectors.isEmpty()) {
                  return "No connectors are selected.";
                }

                if (this.center == null || this.maxRadiusSquared == null) {
                  var n = vectors.size();
                  return n === 1 ? "Only one connector is selected." : "Only " + n + " connectors are selected.";
                }

                return null;
              }
            }, {
              key: "boundaryContains$com_vzome_core_algebra_AlgebraicVector",
              value: function boundaryContains$com_vzome_core_algebra_AlgebraicVector(v) {
                v = v.minus(this.center);
                var vSq = v.dot(v);
                return vSq.compareTo(this.maxRadiusSquared) <= 0;
              }
              /**
              *
              * @param {com.vzome.core.algebra.AlgebraicVector} v
              * @return {boolean}
              */

            }, {
              key: "boundaryContains",
              value: function boundaryContains(v) {
                if (v != null && v instanceof com.vzome.core.algebra.AlgebraicVector || v === null) {
                  return this.boundaryContains$com_vzome_core_algebra_AlgebraicVector(v);
                } else if (v != null && (v["__interfaces"] != null && v["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || v.constructor != null && v.constructor["__interfaces"] != null && v.constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0) || v === null) {
                  _get(_getPrototypeOf(SelectByDiameter.prototype), "boundaryContains", this).call(this, v);
                } else if (v != null && (v["__interfaces"] != null && v["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || v.constructor != null && v.constructor["__interfaces"] != null && v.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0) || v === null) {
                  return this.boundaryContains$com_vzome_core_model_Strut(v);
                } else if (v != null && (v["__interfaces"] != null && v["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0 || v.constructor != null && v.constructor["__interfaces"] != null && v.constructor["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0) || v === null) {
                  return this.boundaryContains$com_vzome_core_model_Panel(v);
                } else throw new Error('invalid overload');
              }
            }]);

            return SelectByDiameter;
          }(com.vzome.core.edits.SelectByBoundary);

          SelectByDiameter.NAME = "SelectByDiameter";
          edits.SelectByDiameter = SelectByDiameter;
          SelectByDiameter["__class"] = "com.vzome.core.edits.SelectByDiameter";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          var SelectByPlane =
          /*#__PURE__*/
          function (_com$vzome$core$edits2) {
            _inherits(SelectByPlane, _com$vzome$core$edits2);

            var _super185 = _createSuper(SelectByPlane);

            function SelectByPlane(editor) {
              var _this131;

              _classCallCheck(this, SelectByPlane);

              _this131 = _super185.call(this, editor);
              if (_this131.plane === undefined) _this131.plane = null;
              if (_this131.anchor === undefined) _this131.anchor = null;
              if (_this131.desiredOrientation === undefined) _this131.desiredOrientation = 0;
              return _this131;
            }
            /**
            *
            * @return {string}
            */


            _createClass(SelectByPlane, [{
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return SelectByPlane.NAME;
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "usage",
              value: function usage() {
                return "This command requires four selected connectors.\n\nThe first three connectors must not be collinear,\nso that they define a plane.\nThe fourth connector must lie outside of that plane,\nand defines which half space you wish to select.\n\nAll parts that are completely within that half-space will be selected.\n";
              }
              /**
              *
              */

            }, {
              key: "perform",
              value: function perform() {
                this.setOrderedSelection(true);

                _get(_getPrototypeOf(SelectByPlane.prototype), "perform", this).call(this);
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "setBoundary",
              value: function setBoundary() {
                var p1 = null;
                var p2 = null;
                var p3 = null;
                var p4 = null;

                for (var index771 = this.mSelection.iterator(); index771.hasNext();) {
                  var man = index771.next();
                  {
                    if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0)) {
                      if (p1 == null) {
                        p1 = man.getLocation();
                        continue;
                      }

                      if (p2 == null) {
                        p2 = man.getLocation();
                        continue;
                      }

                      if (p3 == null) {
                        p3 = man.getLocation();
                        continue;
                      }

                      if (p4 == null) {
                        p4 = man.getLocation();
                        continue;
                      } else {
                        return "You have selected more than four connectors.";
                      }
                    }
                  }
                }

                if (p4 == null) return "You have selected fewer than four connectors.";
                var v1 = new com.vzome.core.algebra.Vector3d(p2.minus(p1));
                var v2 = new com.vzome.core.algebra.Vector3d(p3.minus(p1));
                this.plane = v1.outer(v2);
                this.anchor = p1;
                this.desiredOrientation = this.orient(p4);

                if (this.desiredOrientation === 0) {
                  return "Your last selected connector lies in the plane of the other three.";
                }

                return null;
              }
              /*private*/

            }, {
              key: "orient",
              value: function orient(point) {
                var diff = point.minus(this.anchor);
                var v = new com.vzome.core.algebra.Vector3d(diff);
                var volume = this.plane.outer(v);
                if (volume.isZero()) return 0;else {
                  var volD = volume.evaluate();
                  return volD > 0.0 ? 1 : -1;
                }
              }
            }, {
              key: "boundaryContains$com_vzome_core_algebra_AlgebraicVector",
              value: function boundaryContains$com_vzome_core_algebra_AlgebraicVector(v) {
                var orientation = this.orient(v);
                return orientation === 0 || orientation === this.desiredOrientation;
              }
              /**
              *
              * @param {com.vzome.core.algebra.AlgebraicVector} v
              * @return {boolean}
              */

            }, {
              key: "boundaryContains",
              value: function boundaryContains(v) {
                if (v != null && v instanceof com.vzome.core.algebra.AlgebraicVector || v === null) {
                  return this.boundaryContains$com_vzome_core_algebra_AlgebraicVector(v);
                } else if (v != null && (v["__interfaces"] != null && v["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || v.constructor != null && v.constructor["__interfaces"] != null && v.constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0) || v === null) {
                  _get(_getPrototypeOf(SelectByPlane.prototype), "boundaryContains", this).call(this, v);
                } else if (v != null && (v["__interfaces"] != null && v["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || v.constructor != null && v.constructor["__interfaces"] != null && v.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0) || v === null) {
                  return this.boundaryContains$com_vzome_core_model_Strut(v);
                } else if (v != null && (v["__interfaces"] != null && v["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0 || v.constructor != null && v.constructor["__interfaces"] != null && v.constructor["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0) || v === null) {
                  return this.boundaryContains$com_vzome_core_model_Panel(v);
                } else throw new Error('invalid overload');
              }
            }]);

            return SelectByPlane;
          }(com.vzome.core.edits.SelectByBoundary);

          SelectByPlane.NAME = "SelectByPlane";
          edits.SelectByPlane = SelectByPlane;
          SelectByPlane["__class"] = "com.vzome.core.edits.SelectByPlane";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          var ConvexHull3d =
          /*#__PURE__*/
          function (_com$vzome$core$edits3) {
            _inherits(ConvexHull3d, _com$vzome$core$edits3);

            var _super186 = _createSuper(ConvexHull3d);

            function ConvexHull3d(editorModel) {
              var _this132;

              _classCallCheck(this, ConvexHull3d);

              _this132 = _super186.call(this, editorModel);
              _this132.mode = null;
              _this132.generateStruts = true;
              _this132.generatePanels = true;
              return _this132;
            }
            /**
            *
            * @return {string}
            */


            _createClass(ConvexHull3d, [{
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return ConvexHull3d.NAME;
              }
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "isNoOp",
              value: function isNoOp() {
                return this.generateStruts || this.generatePanels ? _get(_getPrototypeOf(ConvexHull3d.prototype), "isNoOp", this).call(this) : true;
              }
              /**
              *
              * @param {*} props
              */

            }, {
              key: "configure",
              value: function configure(props) {
                this.setMode(props.get("mode"));
              }
              /*private*/

            }, {
              key: "setMode",
              value: function setMode(newMode) {
                this.mode = "";
                this.generateStruts = true;
                this.generatePanels = true;
                if (newMode != null) switch (newMode) {
                  case "":
                    this.mode = newMode;
                    this.generateStruts = true;
                    this.generatePanels = true;
                    break;

                  case "noPanels":
                    this.mode = newMode;
                    this.generateStruts = true;
                    this.generatePanels = false;
                    break;

                  case "onlyPanels":
                    this.mode = newMode;
                    this.generateStruts = false;
                    this.generatePanels = true;
                    break;

                  default:
                    if (com.vzome.core.editor.api.ChangeSelection.logger_$LI$().isLoggable(java.util.logging.Level.WARNING)) {
                      com.vzome.core.editor.api.ChangeSelection.logger_$LI$().warning(ConvexHull3d.NAME + ": Ignoring unknown mode: \"" + newMode + "\".");
                    }

                    break;
                }
              }
              /**
              *
              */

            }, {
              key: "perform",
              value: function perform() {
                var hull3d = new com.vzome.core.math.convexhull.QuickHull3D();
                hull3d.build$java_util_Collection(this.getSelectedVertexSet(true));
                this.redo();
                var vertices = hull3d.getVertices$();
                var pointMap = new java.util.HashMap(vertices.length);

                for (var index772 = 0; index772 < vertices.length; index772++) {
                  var vertex = vertices[index772];
                  {
                    var point = new com.vzome.core.construction.FreePoint(vertex);
                    pointMap.put(vertex, point);
                    this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(point));
                  }
                }

                var faces = hull3d.getFaces$();

                for (var index773 = 0; index773 < faces.length; index773++) {
                  var face = faces[index773];
                  {
                    var points = function (s) {
                      var a = [];

                      while (s-- > 0) {
                        a.push(null);
                      }

                      return a;
                    }(face.length);

                    var startIndex = face[face.length - 1];
                    var start = pointMap.get(vertices[startIndex]);

                    for (var i = 0; i < face.length; i++) {
                      {
                        var endIndex = startIndex;
                        startIndex = face[i];
                        var end = points[i] = pointMap.get(vertices[startIndex]);

                        if (this.generateStruts && startIndex < endIndex) {
                          this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(new com.vzome.core.construction.SegmentJoiningPoints(start, end)));
                        }

                        start = end;
                      }
                    }

                    if (this.generatePanels) {
                      this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(new com.vzome.core.construction.PolygonFromVertices(points)));
                    }
                  }
                }

                this.redo();
              }
              /**
              *
              * @param {*} element
              */

            }, {
              key: "getXmlAttributes",
              value: function getXmlAttributes(element) {
                if (this.mode != null) {
                  element.setAttribute("mode", this.mode);
                }
              }
              /**
              *
              * @param {*} xml
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              */

            }, {
              key: "setXmlAttributes",
              value: function setXmlAttributes(xml, format) {
                this.setMode(xml.getAttribute("mode"));
              }
            }]);

            return ConvexHull3d;
          }(com.vzome.core.edits.ConvexHull);

          ConvexHull3d.NAME = "ConvexHull3d";
          edits.ConvexHull3d = ConvexHull3d;
          ConvexHull3d["__class"] = "com.vzome.core.edits.ConvexHull3d";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          var ConvexHull2d =
          /*#__PURE__*/
          function (_com$vzome$core$edits4) {
            _inherits(ConvexHull2d, _com$vzome$core$edits4);

            var _super187 = _createSuper(ConvexHull2d);

            function ConvexHull2d(editorModel) {
              _classCallCheck(this, ConvexHull2d);

              return _super187.call(this, editorModel);
            }
            /**
            *
            * @return {string}
            */


            _createClass(ConvexHull2d, [{
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return ConvexHull2d.NAME;
              }
              /**
              *
              */

            }, {
              key: "perform",
              value: function perform() {
                var hull2d = com.vzome.core.math.convexhull.GrahamScan2D.buildHull(this.getSelectedVertexSet(true));
                this.redo();

                var vertices = function (s) {
                  var a = [];

                  while (s-- > 0) {
                    a.push(null);
                  }

                  return a;
                }(hull2d.length);

                var p = 0;
                var pointMap = new java.util.HashMap(hull2d.length);

                for (var index774 = 0; index774 < hull2d.length; index774++) {
                  var vertex = hull2d[index774];
                  {
                    var point = new com.vzome.core.construction.FreePoint(vertex);
                    pointMap.put(vertex, point);
                    vertices[p++] = point;
                    this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(point));
                  }
                }

                this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(new com.vzome.core.construction.PolygonFromVertices(vertices)));
                var start = pointMap.get(hull2d[0]);

                for (var i = 1; i < hull2d.length; i++) {
                  {
                    var _end = pointMap.get(hull2d[i]);

                    this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(new com.vzome.core.construction.SegmentJoiningPoints(start, _end)));
                    start = _end;
                  }
                }

                var end = pointMap.get(hull2d[0]);
                this.select$com_vzome_core_model_Manifestation(this.manifestConstruction(new com.vzome.core.construction.SegmentJoiningPoints(start, end)));
                this.redo();
              }
            }]);

            return ConvexHull2d;
          }(com.vzome.core.edits.ConvexHull);

          ConvexHull2d.NAME = "ConvexHull2d";
          edits.ConvexHull2d = ConvexHull2d;
          ConvexHull2d["__class"] = "com.vzome.core.edits.ConvexHull2d";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          var StrutMove =
          /*#__PURE__*/
          function (_com$vzome$core$edits5) {
            _inherits(StrutMove, _com$vzome$core$edits5);

            var _super188 = _createSuper(StrutMove);

            function StrutMove(editor) {
              var _this133;

              _classCallCheck(this, StrutMove);

              _this133 = _super188.call(this, editor);
              if (_this133.oldStrut === undefined) _this133.oldStrut = null;
              return _this133;
            }
            /**
            *
            * @param {*} params
            */


            _createClass(StrutMove, [{
              key: "configure",
              value: function configure(params) {
                _get(_getPrototypeOf(StrutMove.prototype), "configure", this).call(this, params);

                this.oldStrut = params.get("oldStrut");
              }
              /**
              *
              */

            }, {
              key: "perform",
              value: function perform() {
                this.deleteManifestation(this.oldStrut);
                this.manifestConstruction(this.mAnchor);

                _get(_getPrototypeOf(StrutMove.prototype), "redo", this).call(this);

                _get(_getPrototypeOf(StrutMove.prototype), "perform", this).call(this);
              }
              /**
              *
              * @param {*} xml
              */

            }, {
              key: "getXmlAttributes",
              value: function getXmlAttributes(xml) {
                com.vzome.core.commands.XmlSaveFormat.serializeSegment(xml, "startSegment", "endSegment", this.oldStrut.getFirstConstruction());

                _get(_getPrototypeOf(StrutMove.prototype), "getXmlAttributes", this).call(this, xml);
              }
              /**
              *
              * @param {*} xml
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              */

            }, {
              key: "setXmlAttributes",
              value: function setXmlAttributes(xml, format) {
                var construction = format.parseSegment$org_w3c_dom_Element$java_lang_String$java_lang_String(xml, "startSegment", "endSegment");
                if (construction != null) this.oldStrut = this.getManifestation(construction);

                _get(_getPrototypeOf(StrutMove.prototype), "setXmlAttributes", this).call(this, xml, format);
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "StrutMove";
              }
            }]);

            return StrutMove;
          }(com.vzome.core.edits.StrutCreation);

          edits.StrutMove = StrutMove;
          StrutMove["__class"] = "com.vzome.core.edits.StrutMove";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          var ImportSimpleMeshJson =
          /*#__PURE__*/
          function (_com$vzome$core$edits6) {
            _inherits(ImportSimpleMeshJson, _com$vzome$core$edits6);

            var _super189 = _createSuper(ImportSimpleMeshJson);

            function ImportSimpleMeshJson(editor) {
              _classCallCheck(this, ImportSimpleMeshJson);

              return _super189.call(this, editor);
            }
            /**
            *
            * @param {com.vzome.core.algebra.AlgebraicVector} offset
            * @param {com.vzome.core.editor.api.ManifestConstructions} events
            * @param {*} registry
            */


            _createClass(ImportSimpleMeshJson, [{
              key: "parseMeshData",
              value: function parseMeshData(offset, events, registry) {
                com.vzome.core.model.SimpleMeshJson.parse(this.meshData, offset, this.projection, events, registry);
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "ImportSimpleMeshJson";
              }
            }]);

            return ImportSimpleMeshJson;
          }(com.vzome.core.edits.ImportMesh);

          edits.ImportSimpleMeshJson = ImportSimpleMeshJson;
          ImportSimpleMeshJson["__class"] = "com.vzome.core.edits.ImportSimpleMeshJson";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          var ImportColoredMeshJson =
          /*#__PURE__*/
          function (_com$vzome$core$edits7) {
            _inherits(ImportColoredMeshJson, _com$vzome$core$edits7);

            var _super190 = _createSuper(ImportColoredMeshJson);

            function ImportColoredMeshJson(editor) {
              _classCallCheck(this, ImportColoredMeshJson);

              return _super190.call(this, editor);
            }
            /**
            *
            * @param {com.vzome.core.algebra.AlgebraicVector} offset
            * @param {com.vzome.core.editor.api.ManifestConstructions} events
            * @param {*} registry
            */


            _createClass(ImportColoredMeshJson, [{
              key: "parseMeshData",
              value: function parseMeshData(offset, events, registry) {
                com.vzome.core.model.ColoredMeshJson.parse(this.meshData, offset, this.projection, events, registry);
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "ImportColoredMeshJson";
              }
            }]);

            return ImportColoredMeshJson;
          }(com.vzome.core.edits.ImportMesh);

          edits.ImportColoredMeshJson = ImportColoredMeshJson;
          ImportColoredMeshJson["__class"] = "com.vzome.core.edits.ImportColoredMeshJson";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          var LoadVEF =
          /*#__PURE__*/
          function (_com$vzome$core$edits8) {
            _inherits(LoadVEF, _com$vzome$core$edits8);

            var _super191 = _createSuper(LoadVEF);

            function LoadVEF(editor) {
              _classCallCheck(this, LoadVEF);

              return _super191.call(this, editor);
            }

            _createClass(LoadVEF, [{
              key: "deselectInputs",
              value: function deselectInputs() {
                return false;
              }
              /**
              *
              * @param {com.vzome.core.algebra.AlgebraicVector} offset
              * @param {com.vzome.core.editor.api.ManifestConstructions} events
              * @param {*} registry
              */

            }, {
              key: "parseMeshData",
              value: function parseMeshData(offset, events, registry) {
                var v2m = new com.vzome.core.construction.VefToModel(this.projection, events, this.scale, offset);
                v2m.parseVEF(this.meshData, this.mManifestations.getField());
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "LoadVEF";
              }
            }]);

            return LoadVEF;
          }(com.vzome.core.edits.ImportMesh);

          edits.LoadVEF = LoadVEF;
          LoadVEF["__class"] = "com.vzome.core.edits.LoadVEF";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (tools_4) {
          var TransformationTool =
          /*#__PURE__*/
          function (_com$vzome$core$edito52) {
            _inherits(TransformationTool, _com$vzome$core$edito52);

            var _super192 = _createSuper(TransformationTool);

            function TransformationTool(id, tools) {
              var _this134;

              _classCallCheck(this, TransformationTool);

              _this134 = _super192.call(this, id, tools);
              if (_this134.transforms === undefined) _this134.transforms = null;
              if (_this134.originPoint === undefined) _this134.originPoint = null;
              _this134.originPoint = tools.getOriginPoint();
              return _this134;
            }
            /**
            *
            * @param {com.vzome.core.editor.api.ChangeManifestations} applyTool
            */


            _createClass(TransformationTool, [{
              key: "prepare",
              value: function prepare(applyTool) {}
              /**
              *
              * @param {com.vzome.core.editor.api.ChangeManifestations} applyTool
              */

            }, {
              key: "complete",
              value: function complete(applyTool) {}
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "needsInput",
              value: function needsInput() {
                return true;
              }
              /**
              *
              * @param {*} that
              * @return {boolean}
              */

            }, {
              key: "equals",
              value: function equals(that) {
                if (this === that) {
                  return true;
                }

                if (that == null) {
                  return false;
                }

                if (!function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(that.constructor, this.constructor)) {
                  return false;
                }

                var other = that;

                if (this.originPoint == null) {
                  if (other.originPoint != null) {
                    return false;
                  }
                } else if (!function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(this.originPoint, other.originPoint)) {
                  return false;
                }

                if (!java.util.Arrays.equals(this.transforms, other.transforms)) {
                  return false;
                }

                return true;
              }
              /**
              *
              * @param {com.vzome.core.construction.Construction} c
              * @param {com.vzome.core.editor.api.ChangeManifestations} applyTool
              */

            }, {
              key: "performEdit",
              value: function performEdit(c, applyTool) {
                for (var index775 = 0; index775 < this.transforms.length; index775++) {
                  var transform = this.transforms[index775];
                  {
                    var result = transform.transform$com_vzome_core_construction_Construction(c);
                    if (result == null) continue;
                    var color = c.getColor();
                    result.setColor(color);
                    var m = applyTool.manifestConstruction(result);
                    if (m != null) if (color != null) applyTool.colorManifestation(m, c.getColor());
                  }
                }

                applyTool.redo();
              }
              /**
              *
              * @param {*} man
              * @param {com.vzome.core.editor.api.ChangeManifestations} applyTool
              */

            }, {
              key: "performSelect",
              value: function performSelect(man, applyTool) {}
            }, {
              key: "unselect$com_vzome_core_model_Manifestation$boolean",
              value: function unselect$com_vzome_core_model_Manifestation$boolean(man, ignoreGroups) {
                var c = man.getFirstConstruction();
                this.addParameter(c);

                _get(_getPrototypeOf(TransformationTool.prototype), "unselect$com_vzome_core_model_Manifestation$boolean", this).call(this, man, ignoreGroups);
              }
              /**
              *
              * @param {*} man
              * @param {boolean} ignoreGroups
              */

            }, {
              key: "unselect",
              value: function unselect(man, ignoreGroups) {
                if ((man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0) || man === null) && (typeof ignoreGroups === 'boolean' || ignoreGroups === null)) {
                  return this.unselect$com_vzome_core_model_Manifestation$boolean(man, ignoreGroups);
                } else if ((man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Manifestation") >= 0) || man === null) && ignoreGroups === undefined) {
                  return this.unselect$com_vzome_core_model_Manifestation(man);
                } else throw new Error('invalid overload');
              }
            }, {
              key: "isAutomatic",
              value: function isAutomatic() {
                return (
                  /* contains */
                  this.getId().indexOf(".auto/") != -1
                );
              }
            }]);

            return TransformationTool;
          }(com.vzome.core.editor.Tool);

          tools_4.TransformationTool = TransformationTool;
          TransformationTool["__class"] = "com.vzome.core.tools.TransformationTool";
          TransformationTool["__interfaces"] = ["com.vzome.api.Tool"];
        })(core.tools || (core.tools = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (tools_5) {
          var PlaneSelectionTool =
          /*#__PURE__*/
          function (_com$vzome$core$edito53) {
            _inherits(PlaneSelectionTool, _com$vzome$core$edito53);

            var _super193 = _createSuper(PlaneSelectionTool);

            function PlaneSelectionTool(id, tools) {
              var _this135;

              _classCallCheck(this, PlaneSelectionTool);

              _this135 = _super193.call(this, id, tools);
              if (_this135.plane === undefined) _this135.plane = null;
              if (_this135.anchor === undefined) _this135.anchor = null;
              _this135.halfSpace = true;
              _this135.boundaryOpen = false;
              _this135.above = true;
              _this135.includeBalls = true;
              _this135.includeStruts = true;
              _this135.includePanels = true;
              _this135.includePartials = false;
              return _this135;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(PlaneSelectionTool, [{
              key: "isSticky",
              value: function isSticky() {
                return true;
              }
              /**
              *
              */

            }, {
              key: "perform",
              value: function perform() {
                var p1 = null;
                var p2 = null;
                var p3 = null;

                for (var index776 = this.mSelection.iterator(); index776.hasNext();) {
                  var man = index776.next();
                  {
                    this.unselect$com_vzome_core_model_Manifestation(man);

                    if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0)) {
                      if (p1 == null) {
                        p1 = man.getLocation();
                        continue;
                      }

                      if (p2 == null) {
                        p2 = man.getLocation();
                        continue;
                      }

                      if (p3 == null) {
                        p3 = man.getLocation();
                        continue;
                      } else {
                        throw new com.vzome.core.commands.Command.Failure("half-space selection tool requires exactly three balls");
                      }
                    }
                  }
                }

                if (p3 == null) throw new com.vzome.core.commands.Command.Failure("half-space selection tool requires exactly three balls");
                var v1 = new com.vzome.core.algebra.Vector3d(p2.minus(p1));
                var v2 = new com.vzome.core.algebra.Vector3d(p3.minus(p1));
                this.plane = v1.outer(v2);
                this.anchor = p1;

                _get(_getPrototypeOf(PlaneSelectionTool.prototype), "perform", this).call(this);
              }
              /**
              *
              * @param {com.vzome.core.editor.api.ChangeManifestations} applyTool
              */

            }, {
              key: "prepare",
              value: function prepare(applyTool) {}
              /**
              *
              * @param {com.vzome.core.editor.api.ChangeManifestations} applyTool
              */

            }, {
              key: "complete",
              value: function complete(applyTool) {}
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "needsInput",
              value: function needsInput() {
                return false;
              }
              /**
              *
              * @param {com.vzome.core.construction.Construction} c
              * @param {com.vzome.core.editor.api.ChangeManifestations} applyTool
              */

            }, {
              key: "performEdit",
              value: function performEdit(c, applyTool) {}
              /**
              *
              * @param {*} man
              * @param {com.vzome.core.editor.api.ChangeManifestations} applyTool
              */

            }, {
              key: "performSelect",
              value: function performSelect(man, applyTool) {
                if (man.isHidden()) return;
                if (!man.isRendered()) return;
                if (this.includePanels && man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0)) return;

                if (this.includeBalls && man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0)) {
                  var c = man;
                  var orientation = this.orient(c.getLocation());
                  if (!this.boundaryOpen && orientation === 0) applyTool.select$com_vzome_core_model_Manifestation(man);else if (this.halfSpace && this.above && orientation > 0) applyTool.select$com_vzome_core_model_Manifestation(man);else if (this.halfSpace && !this.above && orientation < 0) applyTool.select$com_vzome_core_model_Manifestation(man);
                } else if (this.includeStruts && man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0)) {
                  var o1 = this.orient(man.getLocation());
                  var o2 = this.orient(man.getEnd());

                  if (this.includePartials) {
                    if (!this.boundaryOpen && (o1 === 0 || o2 === 0)) applyTool.select$com_vzome_core_model_Manifestation(man);else if (this.halfSpace) {
                      if (this.above && (o1 > 0 || o2 > 0)) applyTool.select$com_vzome_core_model_Manifestation(man);else if (!this.above && (o1 < 0 || o2 < 0)) applyTool.select$com_vzome_core_model_Manifestation(man);
                    }
                  } else {
                    if (!this.halfSpace && o1 === 0 && o2 === 0) applyTool.select$com_vzome_core_model_Manifestation(man);else if (this.halfSpace) {
                      if (this.boundaryOpen) {
                        if (this.above && o1 > 0 && o2 > 0) applyTool.select$com_vzome_core_model_Manifestation(man);else if (!this.above && o1 < 0 && o2 < 0) applyTool.select$com_vzome_core_model_Manifestation(man);
                      } else {
                        if (this.above && o1 >= 0 && o2 >= 0) applyTool.select$com_vzome_core_model_Manifestation(man);else if (!this.above && o1 <= 0 && o2 <= 0) applyTool.select$com_vzome_core_model_Manifestation(man);
                      }
                    }
                  }
                }

                applyTool.redo();
              }
            }, {
              key: "orient",
              value: function orient(point) {
                var diff = point.minus(this.anchor);
                var v = new com.vzome.core.algebra.Vector3d(diff);
                var volume = this.plane.outer(v);
                if (volume.isZero()) return 0;else {
                  var volD = volume.evaluate();
                  return volD > 0.0 ? 1 : -1;
                }
              }
              /**
              *
              */

            }, {
              key: "redo",
              value: function redo() {}
              /**
              *
              */

            }, {
              key: "undo",
              value: function undo() {}
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "PlaneSelectionTool";
              }
              /**
              *
              * @param {*} element
              */

            }, {
              key: "getXmlAttributes",
              value: function getXmlAttributes(element) {
                element.setAttribute("name", this.getId());
              }
              /**
              *
              * @param {*} element
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              */

            }, {
              key: "setXmlAttributes",
              value: function setXmlAttributes(element, format) {
                _get(_getPrototypeOf(PlaneSelectionTool.prototype), "setXmlAttributes", this).call(this, element, format);

                this.includeBalls = !function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }("false", element.getAttribute("balls"));
                this.includeStruts = !function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }("false", element.getAttribute("struts"));

                this.includePanels =
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }("true", element.getAttribute("panels"));

                this.includePartials =
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }("any", element.getAttribute("vertices"));

                this.boundaryOpen =
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }("true", element.getAttribute("open"));

                var halfSpace = element.getAttribute("halfSpace");

                if (
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }("above", halfSpace)) {
                  this.halfSpace = true;
                  this.above = true;
                } else if (
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }("below", halfSpace)) {
                  this.halfSpace = true;
                  this.above = false;
                } else {
                  this.halfSpace = false;
                  this.boundaryOpen = false;
                }
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getCategory",
              value: function getCategory() {
                return "plane";
              }
            }, {
              key: "getDefaultName",
              value: function getDefaultName() {
                return "plane";
              }
              /**
              *
              * @param {boolean} prepareTool
              * @return {string}
              */

            }, {
              key: "checkSelection",
              value: function checkSelection(prepareTool) {
                return null;
              }
            }]);

            return PlaneSelectionTool;
          }(com.vzome.core.editor.Tool);

          tools_5.PlaneSelectionTool = PlaneSelectionTool;
          PlaneSelectionTool["__class"] = "com.vzome.core.tools.PlaneSelectionTool";
          PlaneSelectionTool["__interfaces"] = ["com.vzome.api.Tool"];

          (function (PlaneSelectionTool) {
            var Factory =
            /*#__PURE__*/
            function (_com$vzome$core$edito54) {
              _inherits(Factory, _com$vzome$core$edito54);

              var _super194 = _createSuper(Factory);

              function Factory(tools) {
                _classCallCheck(this, Factory);

                return _super194.call(this, tools, null, "plane", "", "");
              }
              /**
              *
              * @param {number} total
              * @param {number} balls
              * @param {number} struts
              * @param {number} panels
              * @return {boolean}
              */


              _createClass(Factory, [{
                key: "countsAreValid",
                value: function countsAreValid(total, balls, struts, panels) {
                  return total === 3 && balls === 3;
                }
                /**
                *
                * @param {string} id
                * @return {com.vzome.core.editor.Tool}
                */

              }, {
                key: "createToolInternal",
                value: function createToolInternal(id) {
                  return new com.vzome.core.tools.PlaneSelectionTool(id, this.getToolsModel());
                }
                /**
                *
                * @param {*} selection
                * @return {boolean}
                */

              }, {
                key: "bindParameters",
                value: function bindParameters(selection) {
                  return true;
                }
              }]);

              return Factory;
            }(com.vzome.core.editor.AbstractToolFactory);

            PlaneSelectionTool.Factory = Factory;
            Factory["__class"] = "com.vzome.core.tools.PlaneSelectionTool.Factory";
            Factory["__interfaces"] = ["com.vzome.core.editor.SelectionSummary.Listener", "com.vzome.api.Tool.Factory"];
          })(PlaneSelectionTool = tools_5.PlaneSelectionTool || (tools_5.PlaneSelectionTool = {}));
        })(core.tools || (core.tools = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (tools_6) {
          var BookmarkTool =
          /*#__PURE__*/
          function (_com$vzome$core$edito55) {
            _inherits(BookmarkTool, _com$vzome$core$edito55);

            var _super195 = _createSuper(BookmarkTool);

            function BookmarkTool(id, tools) {
              var _this136;

              _classCallCheck(this, BookmarkTool);

              _this136 = _super195.call(this, id, tools);
              _this136.bookmarkedConstructions = new java.util.ArrayList();
              return _this136;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(BookmarkTool, [{
              key: "isSticky",
              value: function isSticky() {
                return true;
              }
              /**
              *
              */

            }, {
              key: "perform",
              value: function perform() {
                var duper = new com.vzome.core.editor.Duplicator(null, null);
                if (this.mSelection.size() === 0) this.bookmarkedConstructions.add(new com.vzome.core.construction.FreePoint(this.mManifestations.getField().origin(3)));else for (var index777 = this.mSelection.iterator(); index777.hasNext();) {
                  var man = index777.next();
                  {
                    var result = duper.duplicateConstruction(man);
                    this.bookmarkedConstructions.add(result);
                    this.addParameter(result);
                  }
                }

                _get(_getPrototypeOf(BookmarkTool.prototype), "perform", this).call(this);
              }
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "needsInput",
              value: function needsInput() {
                return false;
              }
              /**
              *
              * @param {com.vzome.core.editor.api.ChangeManifestations} edit
              */

            }, {
              key: "prepare",
              value: function prepare(edit) {
                if (this.bookmarkedConstructions.isEmpty()) {
                  edit.manifestConstruction(new com.vzome.core.construction.FreePoint(this.mManifestations.getField().origin(3)));
                } else for (var index778 = this.bookmarkedConstructions.iterator(); index778.hasNext();) {
                  var con = index778.next();
                  {
                    edit.manifestConstruction(con);
                  }
                }

                edit.redo();
              }
              /**
              *
              * @param {com.vzome.core.editor.api.ChangeManifestations} applyTool
              */

            }, {
              key: "complete",
              value: function complete(applyTool) {}
              /**
              *
              * @param {com.vzome.core.construction.Construction} c
              * @param {com.vzome.core.editor.api.ChangeManifestations} applyTool
              */

            }, {
              key: "performEdit",
              value: function performEdit(c, applyTool) {}
              /**
              *
              * @param {*} man
              * @param {com.vzome.core.editor.api.ChangeManifestations} applyTool
              */

            }, {
              key: "performSelect",
              value: function performSelect(man, applyTool) {}
              /**
              *
              */

            }, {
              key: "redo",
              value: function redo() {}
              /**
              *
              */

            }, {
              key: "undo",
              value: function undo() {}
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "BookmarkTool";
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getCategory",
              value: function getCategory() {
                return BookmarkTool.ID;
              }
              /**
              *
              * @param {boolean} prepareTool
              * @return {string}
              */

            }, {
              key: "checkSelection",
              value: function checkSelection(prepareTool) {
                return null;
              }
            }]);

            return BookmarkTool;
          }(com.vzome.core.editor.Tool);

          BookmarkTool.ID = "bookmark";
          BookmarkTool.LABEL = "Create a selection bookmark";
          BookmarkTool.TOOLTIP = "<p>A selection bookmark lets you re-create<br>any selection at a later time.</p>";
          tools_6.BookmarkTool = BookmarkTool;
          BookmarkTool["__class"] = "com.vzome.core.tools.BookmarkTool";
          BookmarkTool["__interfaces"] = ["com.vzome.api.Tool"];

          (function (BookmarkTool) {
            var Factory =
            /*#__PURE__*/
            function (_com$vzome$core$edito56) {
              _inherits(Factory, _com$vzome$core$edito56);

              var _super196 = _createSuper(Factory);

              function Factory(tools) {
                _classCallCheck(this, Factory);

                return _super196.call(this, tools, null, com.vzome.core.tools.BookmarkTool.ID, com.vzome.core.tools.BookmarkTool.LABEL, com.vzome.core.tools.BookmarkTool.TOOLTIP);
              }
              /**
              *
              * @param {number} total
              * @param {number} balls
              * @param {number} struts
              * @param {number} panels
              * @return {boolean}
              */


              _createClass(Factory, [{
                key: "countsAreValid",
                value: function countsAreValid(total, balls, struts, panels) {
                  return total > 0;
                }
                /**
                *
                * @param {string} id
                * @return {com.vzome.core.editor.Tool}
                */

              }, {
                key: "createToolInternal",
                value: function createToolInternal(id) {
                  return new com.vzome.core.tools.BookmarkTool(id, this.getToolsModel());
                }
                /**
                *
                * @param {*} selection
                * @return {boolean}
                */

              }, {
                key: "bindParameters",
                value: function bindParameters(selection) {
                  return true;
                }
              }]);

              return Factory;
            }(com.vzome.core.editor.AbstractToolFactory);

            BookmarkTool.Factory = Factory;
            Factory["__class"] = "com.vzome.core.tools.BookmarkTool.Factory";
            Factory["__interfaces"] = ["com.vzome.core.editor.SelectionSummary.Listener", "com.vzome.api.Tool.Factory"];
          })(BookmarkTool = tools_6.BookmarkTool || (tools_6.BookmarkTool = {}));
        })(core.tools || (core.tools = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (tools_7) {
          var ModuleTool =
          /*#__PURE__*/
          function (_com$vzome$core$edito57) {
            _inherits(ModuleTool, _com$vzome$core$edito57);

            var _super197 = _createSuper(ModuleTool);

            function ModuleTool(id, tools) {
              var _this137;

              _classCallCheck(this, ModuleTool);

              _this137 = _super197.call(this, id, tools);
              if (_this137.name === undefined) _this137.name = null;
              _this137.bookmarkedSelection = new java.util.ArrayList();

              _this137.mSelection.copy(_this137.bookmarkedSelection);

              return _this137;
            }
            /**
            *
            * @return {boolean}
            */


            _createClass(ModuleTool, [{
              key: "isSticky",
              value: function isSticky() {
                return true;
              }
              /**
              *
              * @param {com.vzome.core.editor.api.ChangeManifestations} applyTool
              */

            }, {
              key: "prepare",
              value: function prepare(applyTool) {}
              /**
              *
              * @param {com.vzome.core.editor.api.ChangeManifestations} applyTool
              */

            }, {
              key: "complete",
              value: function complete(applyTool) {}
              /**
              *
              * @return {boolean}
              */

            }, {
              key: "needsInput",
              value: function needsInput() {
                return true;
              }
              /**
              *
              * @param {com.vzome.core.construction.Construction} c
              * @param {com.vzome.core.editor.api.ChangeManifestations} applyTool
              */

            }, {
              key: "performEdit",
              value: function performEdit(c, applyTool) {
                if (!(c != null && c instanceof com.vzome.core.construction.Point)) return;
                var p = c;
                var loc = p.getLocation();
                var duper = new com.vzome.core.editor.Duplicator(applyTool, loc);

                for (var index779 = this.bookmarkedSelection.iterator(); index779.hasNext();) {
                  var man = index779.next();
                  {
                    duper.duplicateManifestation(man);
                  }
                }

                applyTool.redo();
              }
              /**
              *
              * @param {*} man
              * @param {com.vzome.core.editor.api.ChangeManifestations} applyTool
              */

            }, {
              key: "performSelect",
              value: function performSelect(man, applyTool) {}
              /**
              *
              */

            }, {
              key: "redo",
              value: function redo() {}
              /**
              *
              */

            }, {
              key: "undo",
              value: function undo() {}
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "ModuleTool";
              }
              /**
              *
              * @param {*} element
              */

            }, {
              key: "getXmlAttributes",
              value: function getXmlAttributes(element) {
                element.setAttribute("name", this.name);
              }
              /**
              *
              * @param {*} element
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              */

            }, {
              key: "setXmlAttributes",
              value: function setXmlAttributes(element, format) {
                this.name = element.getAttribute("name");
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getCategory",
              value: function getCategory() {
                return ModuleTool.ID;
              }
              /**
              *
              * @param {boolean} prepareTool
              * @return {string}
              */

            }, {
              key: "checkSelection",
              value: function checkSelection(prepareTool) {
                return null;
              }
            }]);

            return ModuleTool;
          }(com.vzome.core.editor.Tool);

          ModuleTool.ID = "module";
          ModuleTool.LABEL = "Create a module tool";
          ModuleTool.TOOLTIP = "<p>Each tool duplicates the original module.<br></p>";
          tools_7.ModuleTool = ModuleTool;
          ModuleTool["__class"] = "com.vzome.core.tools.ModuleTool";
          ModuleTool["__interfaces"] = ["com.vzome.api.Tool"];

          (function (ModuleTool) {
            var Factory =
            /*#__PURE__*/
            function (_com$vzome$core$edito58) {
              _inherits(Factory, _com$vzome$core$edito58);

              var _super198 = _createSuper(Factory);

              function Factory(tools) {
                _classCallCheck(this, Factory);

                return _super198.call(this, tools, null, com.vzome.core.tools.ModuleTool.ID, com.vzome.core.tools.ModuleTool.LABEL, com.vzome.core.tools.ModuleTool.TOOLTIP);
              }
              /**
              *
              * @param {number} total
              * @param {number} balls
              * @param {number} struts
              * @param {number} panels
              * @return {boolean}
              */


              _createClass(Factory, [{
                key: "countsAreValid",
                value: function countsAreValid(total, balls, struts, panels) {
                  return total > 0;
                }
                /**
                *
                * @param {string} id
                * @return {com.vzome.core.editor.Tool}
                */

              }, {
                key: "createToolInternal",
                value: function createToolInternal(id) {
                  return new com.vzome.core.tools.ModuleTool(id, this.getToolsModel());
                }
                /**
                *
                * @param {*} selection
                * @return {boolean}
                */

              }, {
                key: "bindParameters",
                value: function bindParameters(selection) {
                  return true;
                }
              }]);

              return Factory;
            }(com.vzome.core.editor.AbstractToolFactory);

            ModuleTool.Factory = Factory;
            Factory["__class"] = "com.vzome.core.tools.ModuleTool.Factory";
            Factory["__interfaces"] = ["com.vzome.core.editor.SelectionSummary.Listener", "com.vzome.api.Tool.Factory"];
          })(ModuleTool = tools_7.ModuleTool || (tools_7.ModuleTool = {}));
        })(core.tools || (core.tools = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (edits) {
          var SelectByRadius =
          /*#__PURE__*/
          function (_com$vzome$core$edits9) {
            _inherits(SelectByRadius, _com$vzome$core$edits9);

            var _super199 = _createSuper(SelectByRadius);

            function SelectByRadius(editor) {
              var _this138;

              _classCallCheck(this, SelectByRadius);

              _this138 = _super199.call(this, editor);
              if (_this138.minRadiusSquared === undefined) _this138.minRadiusSquared = null;
              return _this138;
            }
            /**
            *
            * @return {string}
            */


            _createClass(SelectByRadius, [{
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return SelectByRadius.NAME;
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "usage",
              value: function usage() {
                return "This command requires either two or three selected connectors.\n\nThe first connector marks the center of a sphere.\nThe second connector defines its radius.\nAn optional third connector defines the radius of\n a second sphere with the same center.\n\nAll parts that are completely within the larger sphere will be selected.\n\nIf a second sphere is defined then any parts\n     within the smaller sphere, even partially, will be excluded.\n";
              }
              /**
              *
              */

            }, {
              key: "perform",
              value: function perform() {
                this.setOrderedSelection(true);

                _get(_getPrototypeOf(SelectByRadius.prototype), "perform", this).call(this);
              }
              /**
              *
              * @param {*} vectors
              * @return {string}
              */

            }, {
              key: "adjustBoundary",
              value: function adjustBoundary(vectors) {
                var v = vectors.get(vectors.size() - 1);

                switch (vectors.size()) {
                  case 1:
                    this.center = v;
                    this.maxRadiusSquared = null;
                    this.minRadiusSquared = null;
                    return null;

                  case 2:
                    var v2 = v.minus(this.center);
                    this.maxRadiusSquared = v2.dot(v2);
                    return null;

                  case 3:
                    var v3 = v.minus(this.center);
                    this.minRadiusSquared = v3.dot(v3);

                    if (this.maxRadiusSquared.compareTo(this.minRadiusSquared) < 0) {
                      var temp = this.maxRadiusSquared;
                      this.maxRadiusSquared = this.minRadiusSquared;
                      this.minRadiusSquared = temp;
                    }

                    return null;
                }

                return _get(_getPrototypeOf(SelectByRadius.prototype), "adjustBoundary", this).call(this, vectors);
              }
            }, {
              key: "boundaryContains$com_vzome_core_algebra_AlgebraicVector",
              value: function boundaryContains$com_vzome_core_algebra_AlgebraicVector(v) {
                if (_get(_getPrototypeOf(SelectByRadius.prototype), "boundaryContains$com_vzome_core_algebra_AlgebraicVector", this).call(this, v)) {
                  if (this.minRadiusSquared != null) {
                    var v1 = v.minus(this.center);
                    return v1.dot(v1).compareTo(this.minRadiusSquared) >= 0;
                  }

                  return true;
                }

                return false;
              }
              /**
              *
              * @param {com.vzome.core.algebra.AlgebraicVector} v
              * @return {boolean}
              */

            }, {
              key: "boundaryContains",
              value: function boundaryContains(v) {
                if (v != null && v instanceof com.vzome.core.algebra.AlgebraicVector || v === null) {
                  return this.boundaryContains$com_vzome_core_algebra_AlgebraicVector(v);
                } else if (v != null && (v["__interfaces"] != null && v["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || v.constructor != null && v.constructor["__interfaces"] != null && v.constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0) || v === null) {
                  _get(_getPrototypeOf(SelectByRadius.prototype), "boundaryContains", this).call(this, v);
                } else if (v != null && (v["__interfaces"] != null && v["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || v.constructor != null && v.constructor["__interfaces"] != null && v.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0) || v === null) {
                  return this.boundaryContains$com_vzome_core_model_Strut(v);
                } else if (v != null && (v["__interfaces"] != null && v["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0 || v.constructor != null && v.constructor["__interfaces"] != null && v.constructor["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0) || v === null) {
                  return this.boundaryContains$com_vzome_core_model_Panel(v);
                } else throw new Error('invalid overload');
              }
            }]);

            return SelectByRadius;
          }(com.vzome.core.edits.SelectByDiameter);

          SelectByRadius.NAME = "SelectByRadius";
          edits.SelectByRadius = SelectByRadius;
          SelectByRadius["__class"] = "com.vzome.core.edits.SelectByRadius";
        })(core.edits || (core.edits = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (tools_8) {
          var InversionTool =
          /*#__PURE__*/
          function (_com$vzome$core$tools2) {
            _inherits(InversionTool, _com$vzome$core$tools2);

            var _super200 = _createSuper(InversionTool);

            function InversionTool(toolName, tools) {
              _classCallCheck(this, InversionTool);

              return _super200.call(this, toolName, tools);
            }
            /**
            *
            * @param {boolean} prepareTool
            * @return {string}
            */


            _createClass(InversionTool, [{
              key: "checkSelection",
              value: function checkSelection(prepareTool) {
                var center = null;
                if (!this.isAutomatic()) for (var index780 = this.mSelection.iterator(); index780.hasNext();) {
                  var man = index780.next();
                  {
                    if (prepareTool) this.unselect$com_vzome_core_model_Manifestation(man);

                    if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0)) {
                      if (center != null) return "more than one center selected";
                      center = man.getFirstConstruction();
                    } else if (!prepareTool) return "panel or strut selected";
                  }
                }

                if (center == null) {
                  if (prepareTool) {
                    center = this.originPoint;
                    this.addParameter(center);
                  } else return "No symmetry center selected";
                }

                if (prepareTool) {
                  this.transforms = [null];
                  this.transforms[0] = new com.vzome.core.construction.PointReflection(center);
                }

                return null;
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "InversionTool";
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getCategory",
              value: function getCategory() {
                return InversionTool.ID;
              }
            }]);

            return InversionTool;
          }(com.vzome.core.tools.TransformationTool);

          InversionTool.ID = "point reflection";
          InversionTool.LABEL = "Create a point reflection tool";
          InversionTool.TOOLTIP = "<p>Each tool duplicates the selection by reflecting<br>each point through the defined center.  To create a<br>tool, select a single ball that defines that center.<br></p>";
          tools_8.InversionTool = InversionTool;
          InversionTool["__class"] = "com.vzome.core.tools.InversionTool";
          InversionTool["__interfaces"] = ["com.vzome.api.Tool"];

          (function (InversionTool) {
            var Factory =
            /*#__PURE__*/
            function (_com$vzome$core$edito59) {
              _inherits(Factory, _com$vzome$core$edito59);

              var _super201 = _createSuper(Factory);

              function Factory(tools) {
                var _this139;

                _classCallCheck(this, Factory);

                _this139 = _super201.call(this, tools, null, com.vzome.core.tools.InversionTool.ID, com.vzome.core.tools.InversionTool.LABEL, com.vzome.core.tools.InversionTool.TOOLTIP);
                if (_this139.center === undefined) _this139.center = null;
                return _this139;
              }
              /**
              *
              * @param {number} total
              * @param {number} balls
              * @param {number} struts
              * @param {number} panels
              * @return {boolean}
              */


              _createClass(Factory, [{
                key: "countsAreValid",
                value: function countsAreValid(total, balls, struts, panels) {
                  return total === 1 && balls === 1;
                }
                /**
                *
                * @param {string} id
                * @return {com.vzome.core.editor.Tool}
                */

              }, {
                key: "createToolInternal",
                value: function createToolInternal(id) {
                  return new com.vzome.core.tools.InversionTool(id, this.getToolsModel());
                }
                /**
                *
                * @param {*} selection
                * @return {boolean}
                */

              }, {
                key: "bindParameters",
                value: function bindParameters(selection) {
                  for (var index781 = selection.iterator(); index781.hasNext();) {
                    var man = index781.next();
                    this.center = man;
                  }

                  return true;
                }
              }]);

              return Factory;
            }(com.vzome.core.editor.AbstractToolFactory);

            InversionTool.Factory = Factory;
            Factory["__class"] = "com.vzome.core.tools.InversionTool.Factory";
            Factory["__interfaces"] = ["com.vzome.core.editor.SelectionSummary.Listener", "com.vzome.api.Tool.Factory"];
          })(InversionTool = tools_8.InversionTool || (tools_8.InversionTool = {}));
        })(core.tools || (core.tools = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (tools_9) {
          var AxialStretchTool =
          /*#__PURE__*/
          function (_com$vzome$core$tools3) {
            _inherits(AxialStretchTool, _com$vzome$core$tools3);

            var _super202 = _createSuper(AxialStretchTool);

            function AxialStretchTool(id, symmetry, tools, stretch, red, first, category) {
              var _this140;

              _classCallCheck(this, AxialStretchTool);

              _this140 = _super202.call(this, id, tools);
              if (_this140.symmetry === undefined) _this140.symmetry = null;
              if (_this140.stretch === undefined) _this140.stretch = false;
              if (_this140.red === undefined) _this140.red = false;
              if (_this140.first === undefined) _this140.first = false;
              if (_this140.__com_vzome_core_tools_AxialStretchTool_category === undefined) _this140.__com_vzome_core_tools_AxialStretchTool_category = null;
              _this140.symmetry = symmetry;
              _this140.stretch = stretch;
              _this140.red = red;
              _this140.first = first;
              _this140.__com_vzome_core_tools_AxialStretchTool_category = category;

              _this140.setInputBehaviors(false, true);

              return _this140;
            }
            /**
            *
            * @param {boolean} prepareTool
            * @return {string}
            */


            _createClass(AxialStretchTool, [{
              key: "checkSelection",
              value: function checkSelection(prepareTool) {
                var center = null;
                var axis = null;

                for (var index782 = this.mSelection.iterator(); index782.hasNext();) {
                  var man = index782.next();
                  {
                    if (prepareTool) this.unselect$com_vzome_core_model_Manifestation(man);

                    if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0)) {
                      if (center != null) return "Only one ball may be selected";
                      center = man.getFirstConstruction();
                    } else if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0)) {
                      if (axis != null) return "Only one strut may be selected";
                      axis = man.getFirstConstruction();
                    } else if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0)) {
                      return "Panels are not supported.";
                    }
                  }
                }

                if (center == null) return "Exactly one ball must be selected.";
                if (axis == null) return "Exactly one strut must be selected.";
                var zone = this.symmetry.getAxis$com_vzome_core_algebra_AlgebraicVector(axis.getOffset());
                if (zone == null) return "Selected alignment strut is not an appropriate axis.";
                var o0;
                var o1;
                var o2;
                var n0;
                var n1;
                var n2;

                switch (zone.getDirection().getName()) {
                  case "yellow":
                    {
                      if (this.red) return "A red axis strut must be selected.";

                      var _blueOrbit = this.symmetry.getDirection("blue");

                      var blueScale = _blueOrbit.getUnitLength();

                      o0 = _blueOrbit.getAxis$int$int(com.vzome.core.math.symmetry.Symmetry.PLUS, 2).normal().scale(blueScale);
                      o1 = _blueOrbit.getAxis$int$int(com.vzome.core.math.symmetry.Symmetry.PLUS, 54).normal().scale(blueScale);
                      o2 = _blueOrbit.getAxis$int$int(com.vzome.core.math.symmetry.Symmetry.PLUS, 36).normal().scale(blueScale);
                      var redOrbit = this.symmetry.getDirection("red");
                      var redScale = redOrbit.getUnitLength();
                      n0 = redOrbit.getAxis$int$int(com.vzome.core.math.symmetry.Symmetry.PLUS, 2).normal().scale(redScale);
                      n1 = redOrbit.getAxis$int$int(com.vzome.core.math.symmetry.Symmetry.PLUS, 46).normal().scale(redScale);
                      n2 = redOrbit.getAxis$int$int(com.vzome.core.math.symmetry.Symmetry.PLUS, 16).normal().scale(redScale);
                      break;
                    }

                  case "red":
                    {
                      if (!this.red) return "A yellow axis strut must be selected.";

                      var _blueOrbit2 = this.symmetry.getDirection("blue");

                      var _blueScale = _blueOrbit2.getUnitLength();

                      var _redOrbit = this.symmetry.getDirection("red");

                      var _redScale = _redOrbit.getUnitLength();

                      if (this.first) {
                        o0 = _blueOrbit2.getAxis$int$int(com.vzome.core.math.symmetry.Symmetry.PLUS, 56).normal().scale(_blueScale);
                        o1 = _blueOrbit2.getAxis$int$int(com.vzome.core.math.symmetry.Symmetry.PLUS, 38).normal().scale(_blueScale);
                        o2 = _blueOrbit2.getAxis$int$int(com.vzome.core.math.symmetry.Symmetry.PLUS, 40).normal().scale(_blueScale);
                        n0 = _redOrbit.getAxis$int$int(com.vzome.core.math.symmetry.Symmetry.PLUS, 46).normal().scale(_redScale);
                        n1 = _redOrbit.getAxis$int$int(com.vzome.core.math.symmetry.Symmetry.PLUS, 1).normal().scale(_redScale);
                        n2 = _redOrbit.getAxis$int$int(com.vzome.core.math.symmetry.Symmetry.PLUS, 2).normal().scale(_redScale);
                      } else {
                        o0 = _blueOrbit2.getAxis$int$int(com.vzome.core.math.symmetry.Symmetry.PLUS, 37).normal().scale(_blueScale);
                        o1 = _blueOrbit2.getAxis$int$int(com.vzome.core.math.symmetry.Symmetry.PLUS, 25).normal().scale(_blueScale);
                        o2 = _blueOrbit2.getAxis$int$int(com.vzome.core.math.symmetry.Symmetry.PLUS, 45).normal().scale(_blueScale);
                        n0 = _blueOrbit2.getAxis$int$int(com.vzome.core.math.symmetry.Symmetry.PLUS, 37).normal().scale(_blueScale);
                        n1 = _blueOrbit2.getAxis$int$int(com.vzome.core.math.symmetry.Symmetry.PLUS, 25).normal().scale(_blueScale);
                        _redScale = _redScale['times$com_vzome_core_algebra_AlgebraicNumber'](this.symmetry.getField()['createPower$int'](-1));
                        n2 = _redOrbit.getAxis$int$int(com.vzome.core.math.symmetry.Symmetry.PLUS, 45).normal().scale(_redScale);
                      }

                      break;
                    }

                  default:
                    return "Selected alignment strut is not an appropriate axis.";
                }

                if (prepareTool) {
                  var orientation = this.symmetry.getMatrix(zone.getOrientation());
                  var inverse = orientation.inverse();
                  var oldBasis = new com.vzome.core.algebra.AlgebraicMatrix(o0, o1, o2);
                  var newBasis = new com.vzome.core.algebra.AlgebraicMatrix(n0, n1, n2);

                  if (this.stretch) {
                    var temp = oldBasis;
                    oldBasis = newBasis;
                    newBasis = temp;
                  }

                  var matrix = orientation.times(newBasis.times(oldBasis.inverse()).times(inverse));
                  this.transforms = [null];
                  this.transforms[0] = new com.vzome.core.construction.MatrixTransformation(matrix, center.getLocation());
                }

                return null;
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "AxialStretchTool";
              }
              /**
              *
              * @param {*} element
              */

            }, {
              key: "getXmlAttributes",
              value: function getXmlAttributes(element) {
                _get(_getPrototypeOf(AxialStretchTool.prototype), "getXmlAttributes", this).call(this, element);

                if (this.stretch) element.setAttribute("stretch", "true");
                element.setAttribute("orbit", this.red ? "red" : "yellow");
                if (!this.first) element.setAttribute("first", "false");
              }
              /**
              *
              * @param {*} element
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              */

            }, {
              key: "setXmlAttributes",
              value: function setXmlAttributes(element, format) {
                var value = element.getAttribute("stretch");

                this.stretch = value != null &&
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(value, "true");

                value = element.getAttribute("orbit");

                this.red =
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(value, "red");

                value = element.getAttribute("first");
                this.first = value == null || !function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(value, "false");
                this.symmetry = format.parseSymmetry("icosahedral");

                _get(_getPrototypeOf(AxialStretchTool.prototype), "setXmlAttributes", this).call(this, element, format);
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getCategory",
              value: function getCategory() {
                return this.__com_vzome_core_tools_AxialStretchTool_category;
              }
            }]);

            return AxialStretchTool;
          }(com.vzome.core.tools.TransformationTool);

          AxialStretchTool.TOOLTIP_REDSQUASH1 = "<p>Each tool applies a \"squash\" transformation to the<br>selected objects, compressing along a red axis.  To create<br>a tool, select a ball as the center of the mapping, and a<br>red strut as the direction of the compression.  The ball and<br>strut need not be collinear.<br><br>The mapping comes from the usual Zome projection of the<br>120-cell.  It is the mapping that transforms the central,<br>blue dodecahedron into the compressed form in the next<br>layer outward.<br><br>By default, the input selection will be removed, and replaced<br>with the squashed equivalent.  If you want to keep the inputs,<br>you can right-click after creating the tool, to configure it.<br></p>";
          AxialStretchTool.TOOLTIP_REDSTRETCH1 = "<p>Each tool applies a \"stretch\" transformation to the<br>selected objects, stretching along a red axis.  To create<br>a tool, select a ball as the center of the mapping, and a<br>red strut as the direction of the stretch.  The ball and<br>strut need not be collinear.<br><br>The mapping comes from the usual Zome projection of the<br>120-cell.  It is the inverse of the mapping that transforms<br>the central, blue dodecahedron into the compressed form in<br>the next layer outward.<br><br>By default, the input selection will be removed, and replaced<br>with the stretched equivalent.  If you want to keep the inputs,<br>you can right-click after creating the tool, to configure it.<br></p>";
          AxialStretchTool.TOOLTIP_YELLOWSQUASH = "<p>Each tool applies a \"squash\" transformation to the<br>selected objects, compressing along a yellow axis.  To create<br>a tool, select a ball as the center of the mapping, and a<br>yellow strut as the direction of the compression.  The ball and<br>strut need not be collinear.<br><br>The mapping comes from the usual Zome projection of the<br>120-cell.  It is the mapping that transforms the central,<br>blue dodecahedron into the compressed form along a yellow axis.<br><br>By default, the input selection will be removed, and replaced<br>with the squashed equivalent.  If you want to keep the inputs,<br>you can right-click after creating the tool, to configure it.<br></p>";
          AxialStretchTool.TOOLTIP_YELLOWSTRETCH = "<p>Each tool applies a \"stretch\" transformation to the<br>selected objects, stretching along a yellow axis.  To create<br>a tool, select a ball as the center of the mapping, and a<br>yellow strut as the direction of the stretch.  The ball and<br>strut need not be collinear.<br><br>The mapping comes from the usual Zome projection of the<br>120-cell.  It is the inverse of the mapping that transforms<br>the central, blue dodecahedron into the compressed form along<br>a yellow axis.<br><br>By default, the input selection will be removed, and replaced<br>with the stretched equivalent.  If you want to keep the inputs,<br>you can right-click after creating the tool, to configure it.<br></p>";
          AxialStretchTool.TOOLTIP_REDSQUASH2 = "<p>Each tool applies a \"squash\" transformation to the<br>selected objects, compressing along a red axis.  To create<br>a tool, select a ball as the center of the mapping, and a<br>red strut as the direction of the compression.  The ball and<br>strut need not be collinear.<br><br>The mapping comes from the usual Zome projection of the<br>120-cell.  It is the mapping that transforms the central,<br>blue dodecahedron into the compressed form in the second<br>layer outward along a red axis.<br><br>By default, the input selection will be removed, and replaced<br>with the squashed equivalent.  If you want to keep the inputs,<br>you can right-click after creating the tool, to configure it.<br></p>";
          AxialStretchTool.TOOLTIP_REDSTRETCH2 = "<p>Each tool applies a \"stretch\" transformation to the<br>selected objects, stretching along a red axis.  To create<br>a tool, select a ball as the center of the mapping, and a<br>red strut as the direction of the stretch.  The ball and<br>strut need not be collinear.<br><br>The mapping comes from the usual Zome projection of the<br>120-cell.  It is the inverse of the mapping that transforms<br>the central, blue dodecahedron into the compressed form in<br>the second layer outward along a red axis.<br><br>By default, the input selection will be removed, and replaced<br>with the stretched equivalent.  If you want to keep the inputs,<br>you can right-click after creating the tool, to configure it.<br></p>";
          tools_9.AxialStretchTool = AxialStretchTool;
          AxialStretchTool["__class"] = "com.vzome.core.tools.AxialStretchTool";
          AxialStretchTool["__interfaces"] = ["com.vzome.api.Tool"];

          (function (AxialStretchTool) {
            var Factory =
            /*#__PURE__*/
            function (_com$vzome$core$edito60) {
              _inherits(Factory, _com$vzome$core$edito60);

              var _super203 = _createSuper(Factory);

              function Factory(tools, symmetry, red, stretch, first) {
                var _this141;

                _classCallCheck(this, Factory);

                _this141 = _super203.call(this, tools, symmetry, Factory.getCategory(red, stretch, first), Factory.getLabel(red, stretch, first), Factory.getToolTip(red, stretch, first));
                if (_this141.red === undefined) _this141.red = false;
                if (_this141.stretch === undefined) _this141.stretch = false;
                if (_this141.first === undefined) _this141.first = false;
                _this141.red = red;
                _this141.stretch = stretch;
                _this141.first = first;
                return _this141;
              }

              _createClass(Factory, [{
                key: "countsAreValid",

                /**
                *
                * @param {number} total
                * @param {number} balls
                * @param {number} struts
                * @param {number} panels
                * @return {boolean}
                */
                value: function countsAreValid(total, balls, struts, panels) {
                  return total === 2 && balls === 1 && struts === 1;
                }
                /**
                *
                * @param {string} id
                * @return {com.vzome.core.editor.Tool}
                */

              }, {
                key: "createToolInternal",
                value: function createToolInternal(id) {
                  var category = Factory.getCategory(this.red, this.stretch, this.first);
                  return new com.vzome.core.tools.AxialStretchTool(id, this.getSymmetry(), this.getToolsModel(), this.stretch, this.red, this.first, category);
                }
                /**
                *
                * @param {*} selection
                * @return {boolean}
                */

              }, {
                key: "bindParameters",
                value: function bindParameters(selection) {
                  var symmetry = this.getSymmetry();

                  for (var index783 = selection.iterator(); index783.hasNext();) {
                    var man = index783.next();

                    if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0)) {
                      var axisStrut = man;
                      var vector = axisStrut.getOffset();
                      vector = symmetry.getField().projectTo3d(vector, true);
                      var axis = symmetry.getAxis$com_vzome_core_algebra_AlgebraicVector(vector);
                      if (axis == null) return false;
                      var orbitName = axis.getDirection().getName();
                      if (this.red) return (
                        /* equals */
                        function (o1, o2) {
                          if (o1 && o1.equals) {
                            return o1.equals(o2);
                          } else {
                            return o1 === o2;
                          }
                        }(orbitName, "red")
                      );else return (
                        /* equals */
                        function (o1, o2) {
                          if (o1 && o1.equals) {
                            return o1.equals(o2);
                          } else {
                            return o1 === o2;
                          }
                        }(orbitName, "yellow")
                      );
                    }
                  }

                  return true;
                }
              }], [{
                key: "getCategory",
                value: function getCategory(red, stretch, first) {
                  if (red) {
                    if (first) return stretch ? "redstretch1" : "redsquash1";else return stretch ? "redstretch2" : "redsquash2";
                  } else return stretch ? "yellowstretch" : "yellowsquash";
                }
              }, {
                key: "getLabel",
                value: function getLabel(red, stretch, first) {
                  var label;

                  if (red) {
                    if (first) label = stretch ? "weak red stretch" : "weak red squash";else label = stretch ? "strong red stretch" : "strong red squash";
                  } else label = stretch ? "yellow stretch" : "yellow squash";

                  return "Create a " + label + " tool";
                }
              }, {
                key: "getToolTip",
                value: function getToolTip(red, stretch, first) {
                  if (red) {
                    if (first) return stretch ? com.vzome.core.tools.AxialStretchTool.TOOLTIP_REDSTRETCH1 : com.vzome.core.tools.AxialStretchTool.TOOLTIP_REDSQUASH1;else return stretch ? com.vzome.core.tools.AxialStretchTool.TOOLTIP_REDSTRETCH2 : com.vzome.core.tools.AxialStretchTool.TOOLTIP_REDSQUASH2;
                  } else return stretch ? com.vzome.core.tools.AxialStretchTool.TOOLTIP_YELLOWSTRETCH : com.vzome.core.tools.AxialStretchTool.TOOLTIP_YELLOWSQUASH;
                }
              }]);

              return Factory;
            }(com.vzome.core.editor.AbstractToolFactory);

            AxialStretchTool.Factory = Factory;
            Factory["__class"] = "com.vzome.core.tools.AxialStretchTool.Factory";
            Factory["__interfaces"] = ["com.vzome.core.editor.SelectionSummary.Listener", "com.vzome.api.Tool.Factory"];
          })(AxialStretchTool = tools_9.AxialStretchTool || (tools_9.AxialStretchTool = {}));
        })(core.tools || (core.tools = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (tools_10) {
          var SymmetryTool =
          /*#__PURE__*/
          function (_com$vzome$core$tools4) {
            _inherits(SymmetryTool, _com$vzome$core$tools4);

            var _super204 = _createSuper(SymmetryTool);

            function SymmetryTool(id, symmetry, tools) {
              var _this142;

              _classCallCheck(this, SymmetryTool);

              _this142 = _super204.call(this, id, tools);
              if (_this142.symmetry === undefined) _this142.symmetry = null;
              _this142.symmetry = symmetry;
              return _this142;
            }
            /**
            *
            * @return {number}
            */


            _createClass(SymmetryTool, [{
              key: "hashCode",
              value: function hashCode() {
                var prime = 31;
                var result = 1;
                result = prime * result + (this.symmetry == null ? 0 :
                /* hashCode */
                function (o) {
                  if (o.hashCode) {
                    return o.hashCode();
                  } else {
                    return o.toString().split('').reduce(function (prevHash, currVal) {
                      return (prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0;
                    }, 0);
                  }
                }(this.symmetry));
                return result;
              }
              /**
              *
              * @param {*} that
              * @return {boolean}
              */

            }, {
              key: "equals",
              value: function equals(that) {
                if (this === that) {
                  return true;
                }

                if (!_get(_getPrototypeOf(SymmetryTool.prototype), "equals", this).call(this, that)) {
                  return false;
                }

                if (this.constructor !== that.constructor) {
                  return false;
                }

                var other = that;

                if (this.symmetry == null) {
                  if (other.symmetry != null) {
                    return false;
                  }
                } else if (!function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(this.symmetry, other.symmetry)) {
                  return false;
                }

                return true;
              }
              /**
              *
              * @param {boolean} prepareTool
              * @return {string}
              */

            }, {
              key: "checkSelection",
              value: function checkSelection(prepareTool) {
                var center = null;
                var axis = null;
                var correct = true;
                var hasPanels = false;
                if (!this.isAutomatic()) for (var index784 = this.mSelection.iterator(); index784.hasNext();) {
                  var man = index784.next();
                  {
                    if (prepareTool) this.unselect$com_vzome_core_model_Manifestation(man);

                    if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0)) {
                      if (center != null) return "No unique symmetry center selected";
                      center = man.getFirstConstruction();
                    } else if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0)) {
                      if (axis != null) correct = false;else axis = man;
                    } else if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0)) {
                      hasPanels = true;
                    }
                  }
                }

                if (center == null) {
                  if (prepareTool) {
                    center = this.originPoint;
                    this.addParameter(center);
                  } else return "No symmetry center selected";
                }

                if (hasPanels) {
                  if (!prepareTool) return "panels are selected";
                }

                var closure = this.symmetry.subgroup(com.vzome.core.math.symmetry.Symmetry.TETRAHEDRAL);

                switch (this.symmetry.getName()) {
                  case "icosahedral":
                    if (!prepareTool && axis != null &&
                    /* equals */
                    function (o1, o2) {
                      if (o1 && o1.equals) {
                        return o1.equals(o2);
                      } else {
                        return o1 === o2;
                      }
                    }(this.getCategory(), "icosahedral")) return "No struts needed for icosahedral symmetry.";

                    switch (this.getCategory()) {
                      case "tetrahedral":
                        if (!correct) return "no unique alignment strut selected.";

                        if (axis == null) {
                          if (!prepareTool) return "no aligment strut selected.";
                        } else {
                          var icosa = this.symmetry;
                          var zone = icosa.getAxis$com_vzome_core_algebra_AlgebraicVector(axis.getOffset());
                          if (zone == null) return "selected alignment strut is not a tetrahedral axis.";
                          var allowYellow = prepareTool;
                          closure = icosa.subgroup$java_lang_String$com_vzome_core_math_symmetry_Axis$boolean(com.vzome.core.math.symmetry.Symmetry.TETRAHEDRAL, zone, allowYellow);
                          if (closure == null) return "selected alignment strut is not a tetrahedral axis.";
                        }

                        if (prepareTool) {
                          var _order2 = closure.length;

                          this.transforms = function (s) {
                            var a = [];

                            while (s-- > 0) {
                              a.push(null);
                            }

                            return a;
                          }(_order2 - 1);

                          for (var i = 0; i < _order2 - 1; i++) {
                            this.transforms[i] = new com.vzome.core.construction.SymmetryTransformation(this.symmetry, closure[i + 1], center);
                          }
                        }

                        break;

                      case "octahedral":
                        var orientation = null;
                        if (!correct) return "no unique alignment strut selected.";

                        if (axis == null) {
                          if (!prepareTool) return "no aligment strut selected.";
                        } else {
                          var _icosa = this.symmetry;

                          var _zone2 = _icosa.getAxis$com_vzome_core_algebra_AlgebraicVector(axis.getOffset());

                          if (_zone2 == null) return "selected alignment strut is not an octahedral axis.";
                          var blueIndex = 0;

                          switch (_zone2.getDirection().getName()) {
                            case "green":
                              blueIndex = _icosa.blueTetrahedralFromGreen(_zone2.getOrientation());
                              break;

                            case "blue":
                              blueIndex = _zone2.getOrientation();
                              break;

                            default:
                              return "selected alignment strut is not an octahedral axis.";
                          }

                          orientation = this.symmetry.getMatrix(blueIndex);
                        }

                        if (prepareTool) {
                          var inverse = orientation.inverse();
                          var octa = this.symmetry != null && this.symmetry instanceof com.vzome.core.math.symmetry.OctahedralSymmetry ? this.symmetry : new com.vzome.core.math.symmetry.OctahedralSymmetry(this.symmetry.getField());

                          var _order3 = octa.getChiralOrder();

                          this.transforms = function (s) {
                            var a = [];

                            while (s-- > 0) {
                              a.push(null);
                            }

                            return a;
                          }(_order3 - 1);

                          for (var _i39 = 0; _i39 < _order3 - 1; _i39++) {
                            {
                              var matrix = octa.getMatrix(_i39 + 1);
                              matrix = orientation.times(matrix.times(inverse));
                              this.transforms[_i39] = new com.vzome.core.construction.MatrixTransformation(matrix, center.getLocation());
                            }
                          }
                        }

                        break;

                      default:
                        if (prepareTool) this.prepareFullSymmetry(center);
                        break;
                    }

                    break;

                  case "octahedral":
                    if (prepareTool) {
                      if (
                      /* equals */
                      function (o1, o2) {
                        if (o1 && o1.equals) {
                          return o1.equals(o2);
                        } else {
                          return o1 === o2;
                        }
                      }(this.getCategory(), "tetrahedral")) {
                        var _order4 = closure.length;

                        this.transforms = function (s) {
                          var a = [];

                          while (s-- > 0) {
                            a.push(null);
                          }

                          return a;
                        }(_order4 - 1);

                        for (var _i40 = 0; _i40 < _order4 - 1; _i40++) {
                          this.transforms[_i40] = new com.vzome.core.construction.SymmetryTransformation(this.symmetry, closure[_i40 + 1], center);
                        }
                      } else {
                        this.prepareFullSymmetry(center);
                      }
                    } else {
                      if (axis != null) return "No struts needed for symmetry";
                    }

                    break;

                  default:
                    if (prepareTool) this.prepareFullSymmetry(center);
                    break;
                }

                return null;
              }
            }, {
              key: "prepareFullSymmetry",
              value: function prepareFullSymmetry(center) {
                var order = this.symmetry.getChiralOrder();

                this.transforms = function (s) {
                  var a = [];

                  while (s-- > 0) {
                    a.push(null);
                  }

                  return a;
                }(order - 1);

                for (var i = 0; i < order - 1; i++) {
                  this.transforms[i] = new com.vzome.core.construction.SymmetryTransformation(this.symmetry, i + 1, center);
                }
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "SymmetryTool";
              }
              /**
              *
              * @param {*} element
              */

            }, {
              key: "getXmlAttributes",
              value: function getXmlAttributes(element) {
                element.setAttribute("symmetry", this.symmetry.getName());

                _get(_getPrototypeOf(SymmetryTool.prototype), "getXmlAttributes", this).call(this, element);
              }
              /**
              *
              * @param {*} element
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              */

            }, {
              key: "setXmlAttributes",
              value: function setXmlAttributes(element, format) {
                var symmName = element.getAttribute("symmetry");
                this.symmetry = format.parseSymmetry(symmName);

                _get(_getPrototypeOf(SymmetryTool.prototype), "setXmlAttributes", this).call(this, element, format);
              }
            }]);

            return SymmetryTool;
          }(com.vzome.core.tools.TransformationTool);

          SymmetryTool.ID = "symmetry";
          SymmetryTool.LABEL = "Create a general symmetry tool";
          SymmetryTool.TOOLTIP = "<p>General symmetry tool.<br></p>";
          tools_10.SymmetryTool = SymmetryTool;
          SymmetryTool["__class"] = "com.vzome.core.tools.SymmetryTool";
          SymmetryTool["__interfaces"] = ["com.vzome.api.Tool"];

          (function (SymmetryTool) {
            var Factory =
            /*#__PURE__*/
            function (_com$vzome$core$edito61) {
              _inherits(Factory, _com$vzome$core$edito61);

              var _super205 = _createSuper(Factory);

              function Factory(tools, symmetry) {
                _classCallCheck(this, Factory);

                return _super205.call(this, tools, symmetry, com.vzome.core.tools.SymmetryTool.ID, com.vzome.core.tools.SymmetryTool.LABEL, com.vzome.core.tools.SymmetryTool.TOOLTIP);
              }
              /**
              *
              * @param {number} total
              * @param {number} balls
              * @param {number} struts
              * @param {number} panels
              * @return {boolean}
              */


              _createClass(Factory, [{
                key: "countsAreValid",
                value: function countsAreValid(total, balls, struts, panels) {
                  return total === 1 && balls === 1;
                }
                /**
                *
                * @param {string} id
                * @return {com.vzome.core.editor.Tool}
                */

              }, {
                key: "createToolInternal",
                value: function createToolInternal(id) {
                  return new com.vzome.core.tools.SymmetryTool(id, this.getSymmetry(), this.getToolsModel());
                }
                /**
                *
                * @param {*} selection
                * @return {boolean}
                */

              }, {
                key: "bindParameters",
                value: function bindParameters(selection) {
                  return selection.size() === 1 && selection.iterator().next() != null && (selection.iterator().next()["__interfaces"] != null && selection.iterator().next()["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || selection.iterator().next().constructor != null && selection.iterator().next().constructor["__interfaces"] != null && selection.iterator().next().constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0);
                }
              }]);

              return Factory;
            }(com.vzome.core.editor.AbstractToolFactory);

            SymmetryTool.Factory = Factory;
            Factory["__class"] = "com.vzome.core.tools.SymmetryTool.Factory";
            Factory["__interfaces"] = ["com.vzome.core.editor.SelectionSummary.Listener", "com.vzome.api.Tool.Factory"];
          })(SymmetryTool = tools_10.SymmetryTool || (tools_10.SymmetryTool = {}));
        })(core.tools || (core.tools = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (tools_11) {
          var LinearMapTool =
          /*#__PURE__*/
          function (_com$vzome$core$tools5) {
            _inherits(LinearMapTool, _com$vzome$core$tools5);

            var _super206 = _createSuper(LinearMapTool);

            function LinearMapTool(name, tools, originalScaling) {
              var _this143;

              _classCallCheck(this, LinearMapTool);

              _this143 = _super206.call(this, name, tools);
              if (_this143.originalScaling === undefined) _this143.originalScaling = false;
              _this143.originalScaling = originalScaling;

              _this143.setInputBehaviors(false, true);

              return _this143;
            }

            _createClass(LinearMapTool, [{
              key: "checkSelection",
              value: function checkSelection(prepareTool) {
                var oldBasis = [null, null, null];
                var newBasis = [null, null, null];
                var index = 0;
                var correct = true;
                var center = null;

                for (var index785 = this.mSelection.iterator(); index785.hasNext();) {
                  var man = index785.next();
                  {
                    if (prepareTool) this.unselect$com_vzome_core_model_Manifestation(man);

                    if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0)) {
                      if (center != null) {
                        correct = false;
                        break;
                      }

                      center = man.getFirstConstruction();
                    } else if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0)) {
                      if (index >= 6) {
                        correct = false;
                        break;
                      }

                      if ((index / 3 | 0) === 0) {
                        oldBasis[index % 3] = man.getFirstConstruction();
                      } else {
                        newBasis[index % 3] = man.getFirstConstruction();
                      }

                      ++index;
                    }
                  }
                }

                correct = correct && (index === 3 || index === 6);
                if (!correct) return "linear map tool requires three adjacent, non-parallel struts (or two sets of three) and a single (optional) center ball";

                if (prepareTool) {
                  if (center == null) center = this.originPoint;
                  this.transforms = [null];
                  if (index === 6) this.transforms[0] = new com.vzome.core.construction.ChangeOfBasis(oldBasis, newBasis, center);else this.transforms[0] = new com.vzome.core.construction.ChangeOfBasis(oldBasis[0], oldBasis[1], oldBasis[2], center, this.originalScaling);
                }

                return null;
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "LinearTransformTool";
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getCategory",
              value: function getCategory() {
                return LinearMapTool.CATEGORY;
              }
            }]);

            return LinearMapTool;
          }(com.vzome.core.tools.TransformationTool);

          LinearMapTool.CATEGORY = "linear map";
          LinearMapTool.LABEL = "Create a linear map tool";
          LinearMapTool.TOOLTIP = "<p><b>For experts and Linear Algebra students...</b><br><br>Each tool applies a linear transformation to the selected<br>objects, possibly rotating, stretching, and compressing.  To<br>create a tool, select a ball as the center of the mapping,<br>three struts (in order) to define the input basis, and three<br>more struts to define the output basis.<br><br>You can omit the input basis if it would consist of three<br>identical blue struts at right angles; the three struts you<br>select will be interpreted as the output basis.<br><br>By default, the input selection will be removed, and replaced<br>with the transformed equivalent.  If you want to keep the inputs,<br>you can right-click after creating the tool, to configure it.<br></p>";
          tools_11.LinearMapTool = LinearMapTool;
          LinearMapTool["__class"] = "com.vzome.core.tools.LinearMapTool";
          LinearMapTool["__interfaces"] = ["com.vzome.api.Tool"];

          (function (LinearMapTool) {
            var Factory =
            /*#__PURE__*/
            function (_com$vzome$core$edito62) {
              _inherits(Factory, _com$vzome$core$edito62);

              var _super207 = _createSuper(Factory);

              function Factory(tools, symmetry, originalScaling) {
                var _this144;

                _classCallCheck(this, Factory);

                _this144 = _super207.call(this, tools, symmetry, com.vzome.core.tools.LinearMapTool.CATEGORY, com.vzome.core.tools.LinearMapTool.LABEL, com.vzome.core.tools.LinearMapTool.TOOLTIP);
                if (_this144.originalScaling === undefined) _this144.originalScaling = false;
                _this144.originalScaling = originalScaling;
                return _this144;
              }
              /**
              *
              * @param {number} total
              * @param {number} balls
              * @param {number} struts
              * @param {number} panels
              * @return {boolean}
              */


              _createClass(Factory, [{
                key: "countsAreValid",
                value: function countsAreValid(total, balls, struts, panels) {
                  return total === 7 && balls === 1 && struts === 6 || total === 4 && balls === 1 && struts === 3;
                }
                /**
                *
                * @param {string} id
                * @return {com.vzome.core.editor.Tool}
                */

              }, {
                key: "createToolInternal",
                value: function createToolInternal(id) {
                  return new com.vzome.core.tools.LinearMapTool(id, this.getToolsModel(), this.originalScaling);
                }
                /**
                *
                * @param {*} selection
                * @return {boolean}
                */

              }, {
                key: "bindParameters",
                value: function bindParameters(selection) {
                  return true;
                }
              }]);

              return Factory;
            }(com.vzome.core.editor.AbstractToolFactory);

            LinearMapTool.Factory = Factory;
            Factory["__class"] = "com.vzome.core.tools.LinearMapTool.Factory";
            Factory["__interfaces"] = ["com.vzome.core.editor.SelectionSummary.Listener", "com.vzome.api.Tool.Factory"];
          })(LinearMapTool = tools_11.LinearMapTool || (tools_11.LinearMapTool = {}));
        })(core.tools || (core.tools = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (tools_12) {
          var ProjectionTool =
          /*#__PURE__*/
          function (_com$vzome$core$tools6) {
            _inherits(ProjectionTool, _com$vzome$core$tools6);

            var _super208 = _createSuper(ProjectionTool);

            function ProjectionTool(id, tools) {
              var _this145;

              _classCallCheck(this, ProjectionTool);

              _this145 = _super208.call(this, id, tools);

              _this145.setInputBehaviors(false, true);

              return _this145;
            }
            /**
            *
            */


            _createClass(ProjectionTool, [{
              key: "perform",
              value: function perform() {
                var plane = null;
                var line = null;

                for (var index786 = this.mSelection.iterator(); index786.hasNext();) {
                  var man = index786.next();
                  {
                    this.unselect$com_vzome_core_model_Manifestation(man);

                    if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0)) {
                      if (plane == null) {
                        var panel = man;
                        var polygon = panel.toConstruction();
                        plane = new com.vzome.core.construction.PlaneExtensionOfPolygon(polygon);
                        continue;
                      } else {
                        throw new com.vzome.core.commands.Command.Failure("Projection tool requires a single selected panel");
                      }
                    }

                    if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0)) {
                      if (line == null) {
                        var strut = man;
                        var segment = strut.toConstruction();
                        line = new com.vzome.core.construction.LineExtensionOfSegment(segment);
                        continue;
                      } else {
                        throw new com.vzome.core.commands.Command.Failure("Projection tool allows only a single selected strut");
                      }
                    }
                  }
                }

                if (plane == null) throw new com.vzome.core.commands.Command.Failure("Projection tool requires a selected panel");
                this.transforms = [null];
                this.transforms[0] = new com.vzome.core.construction.PlaneProjection(plane, line);

                if (line != null) {
                  var test = this.transforms[0].transform$com_vzome_core_algebra_AlgebraicVector(line.getDirection());
                  if (test == null) throw new com.vzome.core.commands.Command.Failure("Selected strut and plane must not be parallel");
                }

                _get(_getPrototypeOf(ProjectionTool.prototype), "perform", this).call(this);
              }
              /**
              *
              * @param {boolean} prepareTool
              * @return {string}
              */

            }, {
              key: "checkSelection",
              value: function checkSelection(prepareTool) {
                return null;
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "ProjectionTool";
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getCategory",
              value: function getCategory() {
                return ProjectionTool.ID;
              }
            }]);

            return ProjectionTool;
          }(com.vzome.core.tools.TransformationTool);

          ProjectionTool.ID = "projection";
          ProjectionTool.LABEL = "Create a plane projection tool";
          ProjectionTool.TOOLTIP = "<p>Created tools project selected objects to a 2D plane.  To create a<br>tool, define the projection plane by selecting a single plane.<br>Optionally, select a strut to define a line of projection;<br>the default line is orthogonal to the projection plane.<br></p>";
          tools_12.ProjectionTool = ProjectionTool;
          ProjectionTool["__class"] = "com.vzome.core.tools.ProjectionTool";
          ProjectionTool["__interfaces"] = ["com.vzome.api.Tool"];

          (function (ProjectionTool) {
            var Factory =
            /*#__PURE__*/
            function (_com$vzome$core$edito63) {
              _inherits(Factory, _com$vzome$core$edito63);

              var _super209 = _createSuper(Factory);

              function Factory(tools) {
                _classCallCheck(this, Factory);

                return _super209.call(this, tools, null, com.vzome.core.tools.ProjectionTool.ID, com.vzome.core.tools.ProjectionTool.LABEL, com.vzome.core.tools.ProjectionTool.TOOLTIP);
              }
              /**
              *
              * @param {number} total
              * @param {number} balls
              * @param {number} struts
              * @param {number} panels
              * @return {boolean}
              */


              _createClass(Factory, [{
                key: "countsAreValid",
                value: function countsAreValid(total, balls, struts, panels) {
                  return total === 2 && panels === 1 && struts === 1 || total === 1 && panels === 1;
                }
                /**
                *
                * @param {string} id
                * @return {com.vzome.core.editor.Tool}
                */

              }, {
                key: "createToolInternal",
                value: function createToolInternal(id) {
                  return new com.vzome.core.tools.ProjectionTool(id, this.getToolsModel());
                }
                /**
                *
                * @param {*} selection
                * @return {boolean}
                */

              }, {
                key: "bindParameters",
                value: function bindParameters(selection) {
                  return true;
                }
              }]);

              return Factory;
            }(com.vzome.core.editor.AbstractToolFactory);

            ProjectionTool.Factory = Factory;
            Factory["__class"] = "com.vzome.core.tools.ProjectionTool.Factory";
            Factory["__interfaces"] = ["com.vzome.core.editor.SelectionSummary.Listener", "com.vzome.api.Tool.Factory"];
          })(ProjectionTool = tools_12.ProjectionTool || (tools_12.ProjectionTool = {}));
        })(core.tools || (core.tools = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (tools_13) {
          var MirrorTool =
          /*#__PURE__*/
          function (_com$vzome$core$tools7) {
            _inherits(MirrorTool, _com$vzome$core$tools7);

            var _super210 = _createSuper(MirrorTool);

            function MirrorTool(id, tools) {
              var _this146;

              _classCallCheck(this, MirrorTool);

              _this146 = _super210.call(this, id, tools);
              if (_this146.symmSys === undefined) _this146.symmSys = null;
              _this146.symmSys = tools.getEditorModel()['getSymmetrySystem$']();
              return _this146;
            }
            /**
            *
            * @param {boolean} prepareTool
            * @return {string}
            */


            _createClass(MirrorTool, [{
              key: "checkSelection",
              value: function checkSelection(prepareTool) {
                var center = null;
                var axis = null;
                var mirrorPanel = null;

                if (
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(this.getId(), "mirror.builtin/reflection through XY plane")) {
                  center = this.originPoint;
                  this.addParameter(center);
                  var field = this.originPoint.getField();
                  var zAxis = field.basisVector(3, com.vzome.core.algebra.AlgebraicVector.Z).scale(field['createPower$int'](com.vzome.core.math.symmetry.Direction.USER_SCALE));
                  var p2 = new com.vzome.core.construction.FreePoint(zAxis);
                  axis = new com.vzome.core.construction.SegmentJoiningPoints(center, p2);
                  this.addParameter(axis);
                } else if (
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }(this.getId(), "mirror.builtin/reflection through red plane")) {
                  center = this.originPoint;
                  this.addParameter(center);
                  var redAxis = this.symmSys.getSymmetry().getSpecialOrbit(com.vzome.core.math.symmetry.Symmetry.SpecialOrbit.RED).getAxis$int$int(com.vzome.core.math.symmetry.Symmetry.PLUS, 0).normal();

                  var _p4 = new com.vzome.core.construction.FreePoint(redAxis);

                  axis = new com.vzome.core.construction.SegmentJoiningPoints(center, _p4);
                  this.addParameter(axis);
                } else if (this.isAutomatic()) {
                  center = this.originPoint;

                  var _field10 = this.originPoint.getField();

                  var xAxis = _field10.basisVector(3, com.vzome.core.algebra.AlgebraicVector.X);

                  var _p5 = new com.vzome.core.construction.FreePoint(xAxis);

                  axis = new com.vzome.core.construction.SegmentJoiningPoints(center, _p5);
                } else for (var index787 = this.mSelection.iterator(); index787.hasNext();) {
                  var man = index787.next();
                  {
                    if (prepareTool) this.unselect$com_vzome_core_model_Manifestation(man);

                    if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0)) {
                      if (center != null) {
                        if (prepareTool) break;else return "Only one center ball may be selected";
                      }

                      center = man.getFirstConstruction();
                    } else if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0)) {
                      if (axis != null) {
                        if (prepareTool) break;else return "Only one mirror axis strut may be selected";
                      }

                      axis = man.getFirstConstruction();
                    } else if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0)) {
                      if (mirrorPanel != null) {
                        if (prepareTool) break;else return "Only one mirror panel may be selected";
                      }

                      mirrorPanel = man.getFirstConstruction();
                    }
                  }
                }

                if (center == null) {
                  if (prepareTool) center = this.originPoint;else if (mirrorPanel == null) return "No symmetry center selected";
                }

                var mirrorPlane = null;

                if (axis != null && center != null && mirrorPanel == null) {
                  if (prepareTool) mirrorPlane = new com.vzome.core.construction.PlaneFromNormalSegment(center, axis);
                } else if (axis == null && mirrorPanel != null) {
                  if (prepareTool) mirrorPlane = new com.vzome.core.construction.PlaneExtensionOfPolygon(mirrorPanel);else if (center != null) return "mirror tool requires a single panel,\nor a single strut and a single center ball";
                } else {
                  var msg = "mirror tool requires a single panel,\nor a single strut and a single center ball";

                  if (prepareTool) {
                    throw new java.lang.IllegalStateException("Failed to prepare tool: " + msg);
                  } else {
                    return msg;
                  }
                }

                if (prepareTool) {
                  this.transforms = [null];
                  this.transforms[0] = new com.vzome.core.construction.PlaneReflection(mirrorPlane);
                }

                return null;
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "MirrorTool";
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getCategory",
              value: function getCategory() {
                return MirrorTool.ID;
              }
            }]);

            return MirrorTool;
          }(com.vzome.core.tools.TransformationTool);

          MirrorTool.ID = "mirror";
          MirrorTool.LABEL = "Create a mirror reflection tool";
          MirrorTool.TOOLTIP = "<p>Each tool duplicates the selection by reflecting<br>each object in a mirror plane.  To create a<br>tool, define the mirror plane by selecting a single<br>panel, or by selecting a strut orthogonal to the<br>plane and a ball lying in the plane.<br></p>";
          tools_13.MirrorTool = MirrorTool;
          MirrorTool["__class"] = "com.vzome.core.tools.MirrorTool";
          MirrorTool["__interfaces"] = ["com.vzome.api.Tool"];

          (function (MirrorTool) {
            var Factory =
            /*#__PURE__*/
            function (_com$vzome$core$edito64) {
              _inherits(Factory, _com$vzome$core$edito64);

              var _super211 = _createSuper(Factory);

              function Factory(tools) {
                _classCallCheck(this, Factory);

                return _super211.call(this, tools, null, com.vzome.core.tools.MirrorTool.ID, com.vzome.core.tools.MirrorTool.LABEL, com.vzome.core.tools.MirrorTool.TOOLTIP);
              }
              /**
              *
              * @param {number} total
              * @param {number} balls
              * @param {number} struts
              * @param {number} panels
              * @return {boolean}
              */


              _createClass(Factory, [{
                key: "countsAreValid",
                value: function countsAreValid(total, balls, struts, panels) {
                  return total === 2 && balls === 1 && struts === 1 || total === 1 && panels === 1;
                }
                /**
                *
                * @param {string} id
                * @return {com.vzome.core.editor.Tool}
                */

              }, {
                key: "createToolInternal",
                value: function createToolInternal(id) {
                  return new com.vzome.core.tools.MirrorTool(id, this.getToolsModel());
                }
                /**
                *
                * @param {*} selection
                * @return {boolean}
                */

              }, {
                key: "bindParameters",
                value: function bindParameters(selection) {
                  return true;
                }
              }]);

              return Factory;
            }(com.vzome.core.editor.AbstractToolFactory);

            MirrorTool.Factory = Factory;
            Factory["__class"] = "com.vzome.core.tools.MirrorTool.Factory";
            Factory["__interfaces"] = ["com.vzome.core.editor.SelectionSummary.Listener", "com.vzome.api.Tool.Factory"];
          })(MirrorTool = tools_13.MirrorTool || (tools_13.MirrorTool = {}));
        })(core.tools || (core.tools = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (tools_14) {
          var TranslationTool =
          /*#__PURE__*/
          function (_com$vzome$core$tools8) {
            _inherits(TranslationTool, _com$vzome$core$tools8);

            var _super212 = _createSuper(TranslationTool);

            function TranslationTool(id, tools) {
              var _this147;

              _classCallCheck(this, TranslationTool);

              _this147 = _super212.call(this, id, tools);

              _this147.setInputBehaviors(false, true);

              return _this147;
            }
            /**
            *
            * @param {boolean} prepareTool
            * @return {string}
            */


            _createClass(TranslationTool, [{
              key: "checkSelection",
              value: function checkSelection(prepareTool) {
                var p1 = null;
                var p2 = null;
                var correct = true;
                if (!this.isAutomatic()) for (var index788 = this.mSelection.iterator(); index788.hasNext();) {
                  var man = index788.next();
                  {
                    if (prepareTool) this.unselect$com_vzome_core_model_Manifestation(man);

                    if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0)) {
                      if (p2 != null) {
                        correct = false;
                        break;
                      }

                      if (p1 == null) p1 = man.getFirstConstruction();else p2 = man.getFirstConstruction();
                    } else if (!prepareTool) {
                      return "Only balls can be selected for this tool.";
                    }
                  }
                }

                if (p1 == null) {
                  if (this.isAutomatic() || this.isPredefined()) {
                    p1 = this.originPoint;
                    this.addParameter(p1);
                    var field = this.originPoint.getField();
                    var xAxis = field.basisVector(3, com.vzome.core.algebra.AlgebraicVector.X);
                    var scale = field['createPower$int'](3);
                    scale = scale['times$com_vzome_core_algebra_AlgebraicNumber'](field['createRational$long'](2));
                    xAxis = xAxis.scale(scale);
                    p2 = new com.vzome.core.construction.FreePoint(xAxis);
                    this.addParameter(p2);
                  } else {
                    correct = false;
                  }
                } else if (p2 == null) if (prepareTool) {
                  p2 = p1;
                  p1 = this.originPoint;
                } else correct = false;

                if (!correct) return "translation tool requires start and end points, or just an end point";

                if (prepareTool) {
                  this.transforms = [null];
                  this.transforms[0] = new com.vzome.core.construction.PointToPointTranslation(p1, p2);
                }

                return null;
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "TranslationTool";
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getCategory",
              value: function getCategory() {
                return TranslationTool.ID;
              }
            }]);

            return TranslationTool;
          }(com.vzome.core.tools.TransformationTool);

          TranslationTool.ID = "translation";
          TranslationTool.LABEL = "Create a translation tool";
          TranslationTool.TOOLTIP = "<p>Each tool moves the selected objects to a new location.<br>To create a tool, select two balls that are separated by<br>your desired translation offset.  Order of selection<br>matters: the first ball selected is the \"from\" location,<br>and the second is the \"to\" location.<br><br>By default, the input selection will be moved to the new<br>location.  If you want to copy rather than move, you can<br>right-click after creating the tool, to configure it.<br></p>";
          tools_14.TranslationTool = TranslationTool;
          TranslationTool["__class"] = "com.vzome.core.tools.TranslationTool";
          TranslationTool["__interfaces"] = ["com.vzome.api.Tool"];

          (function (TranslationTool) {
            var Factory =
            /*#__PURE__*/
            function (_com$vzome$core$edito65) {
              _inherits(Factory, _com$vzome$core$edito65);

              var _super213 = _createSuper(Factory);

              function Factory(tools) {
                _classCallCheck(this, Factory);

                return _super213.call(this, tools, null, com.vzome.core.tools.TranslationTool.ID, com.vzome.core.tools.TranslationTool.LABEL, com.vzome.core.tools.TranslationTool.TOOLTIP);
              }
              /**
              *
              * @param {number} total
              * @param {number} balls
              * @param {number} struts
              * @param {number} panels
              * @return {boolean}
              */


              _createClass(Factory, [{
                key: "countsAreValid",
                value: function countsAreValid(total, balls, struts, panels) {
                  return total === 2 && balls === 2;
                }
                /**
                *
                * @param {string} id
                * @return {com.vzome.core.editor.Tool}
                */

              }, {
                key: "createToolInternal",
                value: function createToolInternal(id) {
                  return new com.vzome.core.tools.TranslationTool(id, this.getToolsModel());
                }
                /**
                *
                * @param {*} selection
                * @return {boolean}
                */

              }, {
                key: "bindParameters",
                value: function bindParameters(selection) {
                  return true;
                }
              }]);

              return Factory;
            }(com.vzome.core.editor.AbstractToolFactory);

            TranslationTool.Factory = Factory;
            Factory["__class"] = "com.vzome.core.tools.TranslationTool.Factory";
            Factory["__interfaces"] = ["com.vzome.core.editor.SelectionSummary.Listener", "com.vzome.api.Tool.Factory"];
          })(TranslationTool = tools_14.TranslationTool || (tools_14.TranslationTool = {}));
        })(core.tools || (core.tools = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (tools_15) {
          var RotationTool =
          /*#__PURE__*/
          function (_com$vzome$core$tools9) {
            _inherits(RotationTool, _com$vzome$core$tools9);

            var _super214 = _createSuper(RotationTool);

            function RotationTool(id, symmetry, tools, full) {
              var _this148;

              _classCallCheck(this, RotationTool);

              if ((typeof id === 'string' || id === null) && (symmetry != null && (symmetry["__interfaces"] != null && symmetry["__interfaces"].indexOf("com.vzome.core.math.symmetry.Symmetry") >= 0 || symmetry.constructor != null && symmetry.constructor["__interfaces"] != null && symmetry.constructor["__interfaces"].indexOf("com.vzome.core.math.symmetry.Symmetry") >= 0) || symmetry === null) && (tools != null && tools instanceof com.vzome.core.editor.ToolsModel || tools === null) && (typeof full === 'boolean' || full === null)) {
                _this148 = _super214.call(this, id, symmetry, tools);
                if (_this148.fullRotation === undefined) _this148.fullRotation = false;
                if (_this148.corrected === undefined) _this148.corrected = false;
                if (_this148.fullRotation === undefined) _this148.fullRotation = false;
                if (_this148.corrected === undefined) _this148.corrected = false;

                (function () {
                  _this148.fullRotation = full;
                  _this148.corrected = true;
                  if (full) _this148.setInputBehaviors(true, false);else _this148.setInputBehaviors(false, true);
                })();
              } else if ((typeof id === 'string' || id === null) && (symmetry != null && (symmetry["__interfaces"] != null && symmetry["__interfaces"].indexOf("com.vzome.core.math.symmetry.Symmetry") >= 0 || symmetry.constructor != null && symmetry.constructor["__interfaces"] != null && symmetry.constructor["__interfaces"].indexOf("com.vzome.core.math.symmetry.Symmetry") >= 0) || symmetry === null) && (tools != null && tools instanceof com.vzome.core.editor.ToolsModel || tools === null) && full === undefined) {
                var _args87 = arguments;
                var editor = _args87[2];
                {
                  var _tools = editor;
                  var _full = false;
                  _this148 = _super214.call(this, id, symmetry, _tools);
                  if (_this148.fullRotation === undefined) _this148.fullRotation = false;
                  if (_this148.corrected === undefined) _this148.corrected = false;
                  if (_this148.fullRotation === undefined) _this148.fullRotation = false;
                  if (_this148.corrected === undefined) _this148.corrected = false;

                  (function () {
                    _this148.fullRotation = _full;
                    _this148.corrected = true;
                    if (_full) _this148.setInputBehaviors(true, false);else _this148.setInputBehaviors(false, true);
                  })();
                }

                (function () {
                  _this148.corrected = false;
                })();
              } else throw new Error('invalid overload');

              return _possibleConstructorReturn(_this148);
            }
            /**
            *
            * @return {string}
            */


            _createClass(RotationTool, [{
              key: "getCategory",
              value: function getCategory() {
                if (this.fullRotation) return "axial symmetry";else return RotationTool.__com_vzome_core_tools_RotationTool_ID;
              }
              /**
              *
              * @param {boolean} prepareTool
              * @return {string}
              */

            }, {
              key: "checkSelection",
              value: function checkSelection(prepareTool) {
                var center = null;
                var axisStrut = null;
                var correct = true;

                for (var index789 = this.mSelection.iterator(); index789.hasNext();) {
                  var man = index789.next();
                  {
                    if (prepareTool) this.unselect$com_vzome_core_model_Manifestation(man);

                    if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0)) {
                      if (center != null) {
                        correct = false;
                        break;
                      }

                      center = man.getFirstConstruction();
                    } else if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0)) {
                      if (axisStrut != null) {
                        correct = false;
                        break;
                      }

                      axisStrut = man.getFirstConstruction();
                    }
                  }
                }

                if (axisStrut == null) {
                  var preferredAxis = this.symmetry.getPreferredAxis();

                  if (preferredAxis != null) {
                    var field = this.symmetry.getField();
                    center = this.originPoint;
                    this.addParameter(center);
                    axisStrut = new com.vzome.core.construction.AnchoredSegment(preferredAxis, field.one(), center);
                    this.addParameter(axisStrut);
                  } else if (this.isPredefined()) {
                    center = this.originPoint;
                    this.addParameter(center);
                    var redOrbit = this.symmetry.getSpecialOrbit(com.vzome.core.math.symmetry.Symmetry.SpecialOrbit.RED);

                    var _field11 = this.symmetry.getField();

                    var redScale = redOrbit.getUnitLength()['times$com_vzome_core_algebra_AlgebraicNumber'](_field11['createPower$int'](com.vzome.core.math.symmetry.Direction.USER_SCALE));
                    axisStrut = new com.vzome.core.construction.AnchoredSegment(redOrbit.getAxis$int$int(com.vzome.core.math.symmetry.Symmetry.PLUS, 1), redScale, center);
                    this.addParameter(axisStrut);
                  } else if (this.isAutomatic()) {
                    center = this.originPoint;
                    this.addParameter(center);

                    var _field12 = this.symmetry.getField();

                    var zAxis = _field12.basisVector(3, com.vzome.core.algebra.AlgebraicVector.Z);

                    var len = _field12['createPower$int'](2);

                    axisStrut = new com.vzome.core.construction.AnchoredSegment(this.symmetry['getAxis$com_vzome_core_algebra_AlgebraicVector'](zAxis), len, center);
                    this.addParameter(axisStrut);
                  } else correct = false;
                } else if (center == null) center = new com.vzome.core.construction.SegmentEndPoint(axisStrut);

                if (!correct) return "rotation tool requires a single axis strut,\nand optionally a separate center point";
                var vector = axisStrut.getOffset();
                vector = axisStrut.getField().projectTo3d(vector, true);
                var axis = this.symmetry['getAxis$com_vzome_core_algebra_AlgebraicVector'](vector);
                if (axis == null) return "selected strut is not an axis of rotation";
                var perm = axis.getRotationPermutation();
                if (perm == null) return "selected strut is not an axis of rotation";
                var rotation = this.corrected ? perm.mapIndex(0) : axis.getRotation();

                if (prepareTool) {
                  if (this.fullRotation) {
                    var _order5 = perm.getOrder();

                    this.transforms = function (s) {
                      var a = [];

                      while (s-- > 0) {
                        a.push(null);
                      }

                      return a;
                    }(_order5 - 1);

                    for (var i = 0; i < this.transforms.length; i++) {
                      {
                        this.transforms[i] = new com.vzome.core.construction.SymmetryTransformation(this.symmetry, rotation, center);
                        rotation = perm.mapIndex(rotation);
                      }
                    }
                  } else {
                    this.transforms = [null];
                    this.transforms[0] = new com.vzome.core.construction.SymmetryTransformation(this.symmetry, rotation, center);
                  }
                }

                return null;
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "RotationTool";
              }
              /**
              *
              * @param {*} element
              */

            }, {
              key: "getXmlAttributes",
              value: function getXmlAttributes(element) {
                if (this.fullRotation) element.setAttribute("full", "true");
                if (this.corrected) element.setAttribute("corrected", "true");

                _get(_getPrototypeOf(RotationTool.prototype), "getXmlAttributes", this).call(this, element);
              }
              /**
              *
              * @param {*} element
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              */

            }, {
              key: "setXmlAttributes",
              value: function setXmlAttributes(element, format) {
                var value = element.getAttribute("full");

                this.fullRotation = value != null &&
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }("true", value);

                value = element.getAttribute("corrected");

                this.corrected = value != null &&
                /* equals */
                function (o1, o2) {
                  if (o1 && o1.equals) {
                    return o1.equals(o2);
                  } else {
                    return o1 === o2;
                  }
                }("true", value);

                _get(_getPrototypeOf(RotationTool.prototype), "setXmlAttributes", this).call(this, element, format);
              }
            }]);

            return RotationTool;
          }(com.vzome.core.tools.SymmetryTool);

          RotationTool.__com_vzome_core_tools_RotationTool_ID = "rotation";
          RotationTool.__com_vzome_core_tools_RotationTool_LABEL = "Create a rotation tool";
          RotationTool.__com_vzome_core_tools_RotationTool_TOOLTIP = "<p>Each tool rotates the selected objects around an axis<br>of symmetry.  To create a tool, select a strut that<br>defines that axis.  You can also define the direction<br>and center independently, by selecting a ball for the<br>center and a strut for the axis.  Note: not all struts<br>correspond to rotational symmetries!<br><br>The direction of rotation depends on the strut<br>orientation, which is hard to discover, but easy to<br>control, by dragging out a new strut.<br><br>By default, the input selection will be moved to the new,<br>rotated orientation.  After creating a tool, you can<br>right-click to configure the tool to create a copy, instead.<br></p>";
          tools_15.RotationTool = RotationTool;
          RotationTool["__class"] = "com.vzome.core.tools.RotationTool";
          RotationTool["__interfaces"] = ["com.vzome.api.Tool"];

          (function (RotationTool) {
            var __com_vzome_core_tools_RotationTool_Factory =
            /*#__PURE__*/
            function (_com$vzome$core$edito66) {
              _inherits(__com_vzome_core_tools_RotationTool_Factory, _com$vzome$core$edito66);

              var _super215 = _createSuper(__com_vzome_core_tools_RotationTool_Factory);

              function __com_vzome_core_tools_RotationTool_Factory(tools, symmetry) {
                var _this149;

                var id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : com.vzome.core.tools.RotationTool.__com_vzome_core_tools_RotationTool_ID;
                var label = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : com.vzome.core.tools.RotationTool.__com_vzome_core_tools_RotationTool_LABEL;
                var tooltip = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : com.vzome.core.tools.RotationTool.__com_vzome_core_tools_RotationTool_TOOLTIP;

                _classCallCheck(this, __com_vzome_core_tools_RotationTool_Factory);

                _this149 = _super215.call(this, tools, symmetry, id, label, tooltip);
                if (_this149.noStrut === undefined) _this149.noStrut = false;
                return _this149;
              }
              /**
              *
              * @param {number} total
              * @param {number} balls
              * @param {number} struts
              * @param {number} panels
              * @return {boolean}
              */


              _createClass(__com_vzome_core_tools_RotationTool_Factory, [{
                key: "countsAreValid",
                value: function countsAreValid(total, balls, struts, panels) {
                  if (total === 1 && balls === 1) {
                    this.noStrut = true;
                    return true;
                  } else if (total === 1 && struts === 1 || total === 2 && balls === 1 && struts === 1) {
                    this.noStrut = false;
                    return true;
                  }

                  return false;
                }
                /**
                *
                * @param {string} id
                * @return {com.vzome.core.editor.Tool}
                */

              }, {
                key: "createToolInternal",
                value: function createToolInternal(id) {
                  return new com.vzome.core.tools.RotationTool(id, this.getSymmetry(), this.getToolsModel(), false);
                }
                /**
                *
                * @param {*} selection
                * @return {boolean}
                */

              }, {
                key: "bindParameters",
                value: function bindParameters(selection) {
                  var symmetry = this.getSymmetry();

                  for (var index790 = selection.iterator(); index790.hasNext();) {
                    var man = index790.next();

                    if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0)) {
                      var axisStrut = man;
                      var vector = axisStrut.getOffset();
                      vector = symmetry.getField().projectTo3d(vector, true);
                      var axis = symmetry['getAxis$com_vzome_core_algebra_AlgebraicVector'](vector);
                      if (axis == null) return false;
                      var perm = axis.getRotationPermutation();
                      if (perm == null) return false;
                    } else if (this.noStrut) {
                      var _axis2 = symmetry.getPreferredAxis();

                      if (_axis2 == null) return false;
                    }
                  }

                  return true;
                }
              }]);

              return __com_vzome_core_tools_RotationTool_Factory;
            }(com.vzome.core.editor.AbstractToolFactory);

            RotationTool.__com_vzome_core_tools_RotationTool_Factory = __com_vzome_core_tools_RotationTool_Factory;
            __com_vzome_core_tools_RotationTool_Factory["__class"] = "com.vzome.core.tools.RotationTool.Factory";
            __com_vzome_core_tools_RotationTool_Factory["__interfaces"] = ["com.vzome.core.editor.SelectionSummary.Listener", "com.vzome.api.Tool.Factory"];
          })(RotationTool = tools_15.RotationTool || (tools_15.RotationTool = {}));
        })(core.tools || (core.tools = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (tools_16) {
          var ScalingTool =
          /*#__PURE__*/
          function (_com$vzome$core$tools10) {
            _inherits(ScalingTool, _com$vzome$core$tools10);

            var _super216 = _createSuper(ScalingTool);

            function ScalingTool(id, symmetry, tools) {
              var _this150;

              _classCallCheck(this, ScalingTool);

              _this150 = _super216.call(this, id, symmetry, tools);
              if (_this150.scaleFactor === undefined) _this150.scaleFactor = null;
              _this150.scaleFactor = null;

              _this150.setInputBehaviors(false, true);

              return _this150;
            }
            /**
            *
            * @return {string}
            */


            _createClass(ScalingTool, [{
              key: "getCategory",
              value: function getCategory() {
                return ScalingTool.__com_vzome_core_tools_ScalingTool_ID;
              }
            }, {
              key: "setScaleFactor",
              value: function setScaleFactor(scaleFactor) {
                this.scaleFactor = scaleFactor;
              }
              /**
              *
              * @param {boolean} prepareTool
              * @return {string}
              */

            }, {
              key: "checkSelection",
              value: function checkSelection(prepareTool) {
                if (this.scaleFactor != null) {
                  var field = this.scaleFactor.getField();
                  this.transforms = [null];
                  var column1 = field.basisVector(3, com.vzome.core.algebra.AlgebraicVector.X).scale(this.scaleFactor);
                  var column2 = field.basisVector(3, com.vzome.core.algebra.AlgebraicVector.Y).scale(this.scaleFactor);
                  var column3 = field.basisVector(3, com.vzome.core.algebra.AlgebraicVector.Z).scale(this.scaleFactor);
                  var p1 = new com.vzome.core.construction.FreePoint(field.basisVector(3, com.vzome.core.algebra.AlgebraicVector.X).scale(field['createPower$int'](4)));
                  var p2 = new com.vzome.core.construction.FreePoint(column2.scale(field['createPower$int'](4)));
                  this.addParameter(this.originPoint);
                  this.addParameter(new com.vzome.core.construction.SegmentJoiningPoints(this.originPoint, p1));
                  this.addParameter(new com.vzome.core.construction.SegmentJoiningPoints(this.originPoint, p2));
                  var transform = new com.vzome.core.algebra.AlgebraicMatrix(column1, column2, column3);
                  this.transforms[0] = new com.vzome.core.construction.MatrixTransformation(transform, this.originPoint.getLocation());
                  return null;
                }

                var s1 = null;
                var s2 = null;
                var center = null;
                var correct = true;
                var hasPanels = false;

                for (var index791 = this.mSelection.iterator(); index791.hasNext();) {
                  var man = index791.next();
                  {
                    if (prepareTool) this.unselect$com_vzome_core_model_Manifestation(man);

                    if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Connector") >= 0)) {
                      if (center != null) {
                        correct = false;
                        break;
                      }

                      center = man.getFirstConstruction();
                    } else if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0)) {
                      if (s2 != null) {
                        correct = false;
                        break;
                      }

                      if (s1 == null) s1 = man.getFirstConstruction();else s2 = man.getFirstConstruction();
                    } else if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Panel") >= 0)) hasPanels = true;
                  }
                }

                if (center == null) {
                  if (prepareTool) center = this.originPoint;else return "No symmetry center selected";
                }

                correct = correct && s2 != null;
                if (!prepareTool && hasPanels) correct = false;
                if (!correct) return "scaling tool requires before and after struts, and a single center";
                var zone1 = this.symmetry['getAxis$com_vzome_core_algebra_AlgebraicVector'](s1.getOffset());
                var zone2 = this.symmetry['getAxis$com_vzome_core_algebra_AlgebraicVector'](s2.getOffset());
                if (zone1 == null || zone2 == null) return "struts cannot be automatic";
                var orbit = zone1.getDirection();
                if (orbit !== zone2.getDirection()) return "before and after struts must be from the same orbit";

                if (prepareTool) {
                  this.transforms = [null];
                  this.transforms[0] = new com.vzome.core.construction.Scaling(s1, s2, center, this.symmetry);
                }

                return null;
              }
              /**
              *
              * @return {string}
              */

            }, {
              key: "getXmlElementName",
              value: function getXmlElementName() {
                return "ScalingTool";
              }
              /**
              *
              * @param {*} element
              * @param {com.vzome.core.commands.XmlSaveFormat} format
              */

            }, {
              key: "setXmlAttributes",
              value: function setXmlAttributes(element, format) {
                var symmName = element.getAttribute("symmetry");

                if (symmName == null ||
                /* isEmpty */
                symmName.length === 0) {
                  element.setAttribute("symmetry", "icosahedral");
                  SideEffects.logBugAccommodation("scaling tool serialized with no symmetry; assuming icosahedral");
                }

                _get(_getPrototypeOf(ScalingTool.prototype), "setXmlAttributes", this).call(this, element, format);
              }
            }]);

            return ScalingTool;
          }(com.vzome.core.tools.SymmetryTool);

          ScalingTool.__com_vzome_core_tools_ScalingTool_ID = "scaling";
          ScalingTool.__com_vzome_core_tools_ScalingTool_LABEL = "Create a scaling tool";
          ScalingTool.__com_vzome_core_tools_ScalingTool_TOOLTIP = "<p>Each tool enlarges or shrinks the selected objects,<br>relative to a central point.  To create a tool,<br>select a ball representing the central point, and<br>two struts from the same orbit (color) with different<br>sizes.<br><br>The selection order matters.  First select a strut<br>that you want to enlarge or shrink, then select a<br>strut that has the desired target size.<br></p>";
          tools_16.ScalingTool = ScalingTool;
          ScalingTool["__class"] = "com.vzome.core.tools.ScalingTool";
          ScalingTool["__interfaces"] = ["com.vzome.api.Tool"];

          (function (ScalingTool) {
            var __com_vzome_core_tools_ScalingTool_Factory =
            /*#__PURE__*/
            function (_com$vzome$core$edito67) {
              _inherits(__com_vzome_core_tools_ScalingTool_Factory, _com$vzome$core$edito67);

              var _super217 = _createSuper(__com_vzome_core_tools_ScalingTool_Factory);

              function __com_vzome_core_tools_ScalingTool_Factory(tools, symmetry) {
                _classCallCheck(this, __com_vzome_core_tools_ScalingTool_Factory);

                return _super217.call(this, tools, symmetry, com.vzome.core.tools.ScalingTool.__com_vzome_core_tools_ScalingTool_ID, com.vzome.core.tools.ScalingTool.__com_vzome_core_tools_ScalingTool_LABEL, com.vzome.core.tools.ScalingTool.__com_vzome_core_tools_ScalingTool_TOOLTIP);
              }
              /**
              *
              * @param {number} total
              * @param {number} balls
              * @param {number} struts
              * @param {number} panels
              * @return {boolean}
              */


              _createClass(__com_vzome_core_tools_ScalingTool_Factory, [{
                key: "countsAreValid",
                value: function countsAreValid(total, balls, struts, panels) {
                  return total === 3 && balls === 1 && struts === 2;
                }
                /**
                *
                * @param {string} id
                * @return {com.vzome.core.editor.Tool}
                */

              }, {
                key: "createToolInternal",
                value: function createToolInternal(id) {
                  var tool = new com.vzome.core.tools.ScalingTool(id, this.getSymmetry(), this.getToolsModel());
                  var scalePower = 0;

                  switch (id) {
                    case "scaling.builtin/scale up":
                      scalePower = 1;
                      break;

                    case "scaling.builtin/scale down":
                      scalePower = -1;
                      break;

                    default:
                      return tool;
                  }

                  var field = this.getToolsModel().getEditorModel().getRealizedModel().getField();
                  tool.setScaleFactor(field['createPower$int'](scalePower));
                  return tool;
                }
                /**
                *
                * @param {*} selection
                * @return {boolean}
                */

              }, {
                key: "bindParameters",
                value: function bindParameters(selection) {
                  var symmetry = this.getSymmetry();
                  var offset1 = null;
                  var offset2 = null;

                  for (var index792 = selection.iterator(); index792.hasNext();) {
                    var man = index792.next();

                    if (man != null && (man["__interfaces"] != null && man["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0 || man.constructor != null && man.constructor["__interfaces"] != null && man.constructor["__interfaces"].indexOf("com.vzome.core.model.Strut") >= 0)) {
                      var strut = man;
                      if (offset1 == null) offset1 = strut.getOffset();else offset2 = strut.getOffset();
                    }
                  }

                  var zone1 = symmetry['getAxis$com_vzome_core_algebra_AlgebraicVector'](offset1);
                  var zone2 = symmetry['getAxis$com_vzome_core_algebra_AlgebraicVector'](offset2);
                  if (zone1 == null || zone2 == null) return false;
                  var orbit1 = zone1.getDirection();
                  var orbit2 = zone2.getDirection();
                  if (orbit1 !== orbit2) return false;
                  if (orbit1.isAutomatic()) return false;
                  var l1 = zone1.getLength(offset1);
                  var l2 = zone2.getLength(offset2);
                  if (
                  /* equals */
                  function (o1, o2) {
                    if (o1 && o1.equals) {
                      return o1.equals(o2);
                    } else {
                      return o1 === o2;
                    }
                  }(l1, l2)) return false;
                  return true;
                }
              }]);

              return __com_vzome_core_tools_ScalingTool_Factory;
            }(com.vzome.core.editor.AbstractToolFactory);

            ScalingTool.__com_vzome_core_tools_ScalingTool_Factory = __com_vzome_core_tools_ScalingTool_Factory;
            __com_vzome_core_tools_ScalingTool_Factory["__class"] = "com.vzome.core.tools.ScalingTool.Factory";
            __com_vzome_core_tools_ScalingTool_Factory["__interfaces"] = ["com.vzome.core.editor.SelectionSummary.Listener", "com.vzome.api.Tool.Factory"];
          })(ScalingTool = tools_16.ScalingTool || (tools_16.ScalingTool = {}));
        })(core.tools || (core.tools = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  (function (com) {
    (function (vzome) {
      (function (core) {
        (function (tools_17) {
          var AxialSymmetryToolFactory =
          /*#__PURE__*/
          function (_com$vzome$core$tools11) {
            _inherits(AxialSymmetryToolFactory, _com$vzome$core$tools11);

            var _super218 = _createSuper(AxialSymmetryToolFactory);

            function AxialSymmetryToolFactory(tools, symmetry) {
              _classCallCheck(this, AxialSymmetryToolFactory);

              return _super218.call(this, tools, symmetry, AxialSymmetryToolFactory.ID, AxialSymmetryToolFactory.LABEL, AxialSymmetryToolFactory.TOOLTIP);
            }
            /**
            *
            * @param {string} id
            * @return {com.vzome.core.editor.Tool}
            */


            _createClass(AxialSymmetryToolFactory, [{
              key: "createToolInternal",
              value: function createToolInternal(id) {
                return new com.vzome.core.tools.RotationTool(id, this.getSymmetry(), this.getToolsModel(), true);
              }
            }]);

            return AxialSymmetryToolFactory;
          }(com.vzome.core.tools.RotationTool.__com_vzome_core_tools_RotationTool_Factory);

          AxialSymmetryToolFactory.ID = "axial symmetry";
          AxialSymmetryToolFactory.LABEL = "Create a rotational symmetry tool";
          AxialSymmetryToolFactory.TOOLTIP = "<p>Each tool creates enough copies of the selected objects to<br>create rotational symmetry around an axis.  To create a tool,<br>select a strut that defines that axis,  You can also define<br>the direction and center independently, by selecting a ball<br>for the center and a strut for the axis.  Note: not all struts<br>correspond to rotational symmetries!<br><br>Combine with a point reflection or mirror reflection tool to<br>achieve more symmetries.<br></p>";
          tools_17.AxialSymmetryToolFactory = AxialSymmetryToolFactory;
          AxialSymmetryToolFactory["__class"] = "com.vzome.core.tools.AxialSymmetryToolFactory";
          AxialSymmetryToolFactory["__interfaces"] = ["com.vzome.core.editor.SelectionSummary.Listener", "com.vzome.api.Tool.Factory"];
        })(core.tools || (core.tools = {}));
      })(vzome.core || (vzome.core = {}));
    })(com.vzome || (com.vzome = {}));
  })(com || (com = {}));

  com.vzome.core.editor.CommandEdit.loadAndPerformLgger_$LI$();
  com.vzome.core.editor.CommandEdit.logger_$LI$();
  com.vzome.core.commands.CommandTetrahedralSymmetry.ATTR_SIGNATURE_$LI$();
  com.vzome.core.commands.CommandQuaternionSymmetry.LEFT_SYMMETRY_GROUP_ATTR_NAME_$LI$();
  com.vzome.core.commands.CommandUniformH4Polytope.logger_$LI$();
  com.vzome.core.editor.api.ChangeSelection.logger_$LI$();
  com.vzome.core.commands.CommandCentroid.ATTR_SIGNATURE_$LI$();
  com.vzome.core.commands.CommandCentroid.PARAM_SIGNATURE_$LI$();
  com.vzome.core.commands.CommandPolygon.ATTR_SIGNATURE_$LI$();
  com.vzome.core.commands.CommandPolygon.PARAM_SIGNATURE_$LI$();
  com.vzome.core.commands.CommandTauDivision.ATTR_SIGNATURE_$LI$();
  com.vzome.core.commands.CommandTauDivision.PARAM_SIGNATURE_$LI$();
  com.vzome.core.commands.CommandBuildAnchoredSegment.PARAM_SIGNATURE_$LI$();
  com.vzome.core.commands.CommandTransform.GROUP_ATTR_SIGNATURE_$LI$();
  com.vzome.core.commands.CommandTransform.AXIS_ATTR_SIGNATURE_$LI$();
  com.vzome.core.commands.CommandTransform.ATTR_SIGNATURE_$LI$();
  com.vzome.core.commands.CommandTransform.PARAM_SIGNATURE_$LI$();
  com.vzome.core.commands.CommandJoinPoints.ATTR_SIGNATURE_$LI$();
  com.vzome.core.commands.CommandJoinPoints.PARAM_SIGNATURE_$LI$();
  com.vzome.core.commands.CommandMidpoint.ATTR_SIGNATURE_$LI$();
  com.vzome.core.commands.CommandMidpoint.PARAM_SIGNATURE_$LI$();
  com.vzome.core.commands.CommandObliquePentagon.ATTR_SIGNATURE_$LI$();
  com.vzome.core.commands.CommandObliquePentagon.PARAM_SIGNATURE_$LI$();
  com.vzome.core.commands.CommandLinePlaneIntersect.ATTR_SIGNATURE_$LI$();
  com.vzome.core.commands.CommandLinePlaneIntersect.PARAM_SIGNATURE_$LI$();
  com.vzome.core.construction.SegmentRotated4D.logger_$LI$();
  com.vzome.core.commands.CommandImportVEFData.logger_$LI$();
  com.vzome.core.commands.CommandImportVEFData.ATTR_SIGNATURE_$LI$();
  com.vzome.core.commands.CommandImportVEFData.PARAM_SIGNATURE_$LI$();
  com.vzome.core.math.RealVector.DIRECTION_0_$LI$();
  com.vzome.core.math.RealVector.FORMAT_$LI$();
  com.vzome.core.math.RealVector.ORIGIN_$LI$();

  com.vzome.core.math.RealVector.__static_initialize();

  com.vzome.core.commands.CommandLoad.ATTR_SIGNATURE_$LI$();
  com.vzome.core.commands.CommandLoad.PARAM_SIGNATURE_$LI$();
  com.vzome.core.editor.api.SideEffects.BUG_ACCOMMODATION_LOGGER_$LI$();
  com.vzome.core.commands.CommandSetColor.PARAM_SIGNATURE_$LI$();
  com.vzome.core.commands.CommandHide.ATTR_SIGNATURE_$LI$();
  com.vzome.core.commands.CommandHide.PARAM_SIGNATURE_$LI$();
  com.vzome.core.commands.CommandFreePoint.PARAMS_$LI$();

  com.vzome.core.commands.XmlSymmetryFormat.__com_vzome_core_commands_XmlSymmetryFormat_logger_$LI$();

  com.vzome.core.commands.XmlSymmetryFormat.__static_initialize();

  com.vzome.core.construction.VefToModel.logger_$LI$();
  com.vzome.core.viewing.ExportedVEFShapes.logger_$LI$();
  com.vzome.core.viewing.ExportedVEFShapes.INJECTED_$LI$();
  com.vzome.xml.ResourceLoader.INJECTED_RESOURCES_$LI$();
  com.vzome.core.editor.SymmetrySystem.logger_$LI$();
  com.vzome.core.edits.ManifestationColorMappers.colorMappers_$LI$();

  com.vzome.core.edits.ManifestationColorMappers.__static_initialize();

  com.vzome.core.commands.Command.Failure.logger_$LI$();
  com.vzome.core.commands.XmlSaveFormat.NOT_AN_ATTRIBUTE_$LI$();
  com.vzome.core.commands.XmlSaveFormat.logger_$LI$();
  com.vzome.core.commands.XmlSaveFormat.FORMATS_$LI$();
  com.vzome.core.construction.Color.GREY_TRANSPARENT_$LI$();
  com.vzome.core.construction.Color.WHITE_$LI$();
  com.vzome.core.construction.Color.BLACK_$LI$();
  com.vzome.core.math.symmetry.B4Group.B4_PERMS_$LI$();
  com.vzome.core.math.symmetry.Direction.logger_$LI$();
  com.vzome.core.math.symmetry.DirectionNaming.SIGN_$LI$();
  com.vzome.core.math.symmetry.D4Group.D4_PERMS_$LI$();
  com.vzome.core.math.symmetry.A4Group.S5_PERMS_$LI$();
  com.vzome.core.math.Polyhedron.logger_$LI$();
  com.vzome.core.viewing.ExportedVEFStrutGeometry.LOGGER_$LI$();
  com.vzome.core.render.RenderedManifestation.logger_$LI$();
  com.vzome.core.render.Colors.NO_VECTOR_$LI$();
  com.vzome.core.render.Colors.PLANE_$LI$();
  com.vzome.core.render.Colors.DIRECTION_$LI$();
  com.vzome.core.render.Colors.CONNECTOR_$LI$();
  com.vzome.core.render.Colors.HIGHLIGHT_MAC_$LI$();
  com.vzome.core.render.Colors.HIGHLIGHT_$LI$();
  com.vzome.core.render.Colors.PANEL_$LI$();
  com.vzome.core.render.Colors.BACKGROUND_$LI$();

  var _fields,
      _this = undefined;

  var fields = (_fields = {}, _defineProperty(_fields, goldenField.name, goldenField), _defineProperty(_fields, field.name, field), _fields); // Copied from core/src/main/resources/com/vzome/core/editor/defaultPrefs.properties

  var defaults = {
    "color.red": "175,0,0",
    "color.yellow": "240,160,0",
    "color.blue": "0,118,149",
    "color.green": "0,141,54",
    "color.orange": "220,76,0",
    "color.purple": "108,0,198",
    "color.black": "30,30,30",
    "color.white": "225,225,225",
    "color.olive": "100,113,0",
    "color.lavender": "175,135,255",
    "color.maroon": "117,0,50",
    "color.rose": "255,51,143",
    "color.navy": "0,0,153",
    "color.brown": "107,53,26",
    "color.apple": "116,195,0",
    "color.sand": "154,117,74",
    "color.turquoise": "18,205,148",
    "color.coral": "255,126,106",
    "color.sulfur": "230,245,62",
    "color.cinnamon": "136,37,0",
    "color.spruce": "18,73,48",
    "color.magenta": "255,41,183",
    "color.snubPentagon": "187,57,48",
    "color.snubTriangle": "87,188,48",
    "color.snubDiagonal": "228,225,199",
    "color.snubFaceNormal": "216,216,208",
    "color.snubVertex": "204,204,0",
    "color.slate": "108, 126, 142",
    "color.mauve": "137, 104, 112",
    "color.ivory": "228,225,199",
    "color.panels": "225,225,225",
    "color.background": "175,200,220",
    "color.highlight": "195,195,195",
    "color.highlight.mac ": "153,255,0",
    "color.light.directional.1": "235, 235, 228",
    "color.light.directional.2": "228, 228, 235",
    "color.light.directional.3": "30, 30, 30",
    "color.light.ambient": "41, 41, 41",
    // direction values are given as "x,y,z", a vector of real numbers.
    // The X axis points to the right of your screen, the Y axis points to
    // the top of the screen, and the Z axis points out of the screen toward you.
    "direction.light.1": "1.0,-1.0,-1.0",
    "direction.light.2": "-1.0,0.0,0.0",
    "direction.light.3": "0.0,0.0,-1.0"
  }; // Initialization

  var makeQuaternions = function makeQuaternions(matrices) {
    return matrices.map(function (am) {
      var m = [[], [], []];

      for (var i = 0; i < 3; i++) {
        for (var j = 0; j < 3; j++) {
          var an = am.getElement(i, j);
          m[i][j] = an.evaluate();
        }
      }

      return matrix2quat(m);
    });
  }; // Due to Mike Day, Insomniac Games
  //   https://d3cw3dd2w32x2b.cloudfront.net/wp-content/uploads/2015/01/matrix-to-quat.pdf


  var matrix2quat = function matrix2quat(m) {
    var _m = _slicedToArray(m, 3),
        _m$ = _slicedToArray(_m[0], 3),
        m00 = _m$[0],
        m10 = _m$[1],
        m20 = _m$[2],
        _m$2 = _slicedToArray(_m[1], 3),
        m01 = _m$2[0],
        m11 = _m$2[1],
        m21 = _m$2[2],
        _m$3 = _slicedToArray(_m[2], 3),
        m02 = _m$3[0],
        m12 = _m$3[1],
        m22 = _m$3[2];

    var t;
    var q;

    if (m22 < 0) {
      if (m00 > m11) {
        t = 1 + m00 - m11 - m22;
        q = [t, m01 + m10, m20 + m02, m12 - m21];
      } else {
        t = 1 - m00 + m11 - m22;
        q = [m01 + m10, t, m12 + m21, m20 - m02];
      }
    } else {
      if (m00 < -m11) {
        t = 1 - m00 - m11 + m22;
        q = [m20 + m02, m12 + m21, t, m01 - m10];
      } else {
        t = 1 + m00 + m11 + m22;
        q = [m12 - m21, m20 - m02, m01 - m10, t];
      }
    }

    return q.map(function (x) {
      return x * 0.5 / Math.sqrt(t);
    });
  };

  var init =
  /*#__PURE__*/
  function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3() {
      var vzomePkg, util, ImportColoredMeshJson, ImportSimpleMeshJson, xmlToEditClass, editFactory, injectResource, properties, colors, gfield, r2field, fieldApps, editContext, documentFactory, commands, _i2, _Object$keys, name, symmPer, orbitSource, shaper, shaperName, blue, gridPoints, parser;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              vzomePkg = com.vzome;
              util = java.util;

              ImportColoredMeshJson =
              /*#__PURE__*/
              function (_vzomePkg$core$edits$) {
                _inherits(ImportColoredMeshJson, _vzomePkg$core$edits$);

                var _super = _createSuper(ImportColoredMeshJson);

                function ImportColoredMeshJson() {
                  _classCallCheck(this, ImportColoredMeshJson);

                  return _super.apply(this, arguments);
                }

                _createClass(ImportColoredMeshJson, [{
                  key: "parseMeshData",
                  value: function parseMeshData(offset, events, registry) {
                    var _this2 = this; // TODO: handle projection and scale


                    var coloredMesh = JSON.parse(this.meshData);
                    var field = registry.getField(coloredMesh.field);
                    var vertices = coloredMesh.vertices.map(function (nums) {
                      var vertex = field.createIntegerVectorFromTDs(nums);
                      if (vertex.dimension() > 3) vertex = _this2.projection.projectImage(vertex, false);
                      if (offset != null) vertex = offset.plus(vertex);
                      return vertex;
                    }); // TODO: handle legacy format; see ColoredMeshJson.java

                    coloredMesh.balls.forEach(function (ball) {
                      var vertex = vertices[ball.vertex];
                      var color = ball.color && vzomePkg.core.construction.Color.parseWebColor(ball.color);
                      events.constructionAdded(new vzomePkg.core.construction.FreePoint(vertex), color);
                    });
                    coloredMesh.struts.forEach(function (strut) {
                      var point1 = new vzomePkg.core.construction.FreePoint(vertices[strut.vertices[0]]);
                      var point2 = new vzomePkg.core.construction.FreePoint(vertices[strut.vertices[1]]);
                      var color = strut.color && vzomePkg.core.construction.Color.parseWebColor(strut.color);
                      events.constructionAdded(new vzomePkg.core.construction.SegmentJoiningPoints(point1, point2), color);
                    });
                    coloredMesh.panels.forEach(function (panel) {
                      var points = [];
                      panel.vertices.forEach(function (i) {
                        points.push(new vzomePkg.core.construction.FreePoint(vertices[i]));
                      });
                      var color = panel.color && vzomePkg.core.construction.Color.parseWebColor(panel.color);
                      events.constructionAdded(new vzomePkg.core.construction.PolygonFromVertices(points), color);
                    }); // TODO: handle panels
                  }
                }]);

                return ImportColoredMeshJson;
              }(vzomePkg.core.edits.ImportMesh);

              ImportSimpleMeshJson =
              /*#__PURE__*/
              function (_vzomePkg$core$edits$2) {
                _inherits(ImportSimpleMeshJson, _vzomePkg$core$edits$2);

                var _super2 = _createSuper(ImportSimpleMeshJson);

                function ImportSimpleMeshJson() {
                  _classCallCheck(this, ImportSimpleMeshJson);

                  return _super2.apply(this, arguments);
                }

                _createClass(ImportSimpleMeshJson, [{
                  key: "parseMeshData",
                  value: function parseMeshData(offset, events, registry) {
                    var _this3 = this; // TODO: handle projection and scale


                    var simpleMesh = JSON.parse(this.meshData);
                    var field = registry.getField(simpleMesh.field || 'golden');
                    var vertices = simpleMesh.vertices.map(function (nums) {
                      var vertex = field.createIntegerVectorFromTDs(nums);
                      if (vertex.dimension() > 3) vertex = _this3.projection.projectImage(vertex, false);
                      if (offset != null) vertex = offset.plus(vertex);
                      return vertex;
                    });
                    simpleMesh.edges.forEach(function (strut) {
                      var point1 = new vzomePkg.core.construction.FreePoint(vertices[strut[0]]);
                      var point2 = new vzomePkg.core.construction.FreePoint(vertices[strut[1]]);
                      events.constructionAdded(point1);
                      events.constructionAdded(point2);
                      events.constructionAdded(new vzomePkg.core.construction.SegmentJoiningPoints(point1, point2));
                    });
                    simpleMesh.faces.forEach(function (panel) {
                      var points = [];
                      panel.forEach(function (i) {
                        points.push(new vzomePkg.core.construction.FreePoint(vertices[i]));
                      });
                      events.constructionAdded(new vzomePkg.core.construction.PolygonFromVertices(points));
                    });
                  }
                }]);

                return ImportSimpleMeshJson;
              }(vzomePkg.core.edits.ImportMesh);

              xmlToEditClass = function xmlToEditClass(editName) {
                if (editName === 'CommandEdit') {
                  // The constructor pattern is wrong
                  return undefined;
                }

                var legacyNames = {
                  setItemColor: "ColorManifestations",
                  BnPolyope: "B4Polytope",
                  DeselectByClass: "AdjustSelectionByClass",
                  realizeMetaParts: "RealizeMetaParts",
                  SelectSimilarSize: "AdjustSelectionByOrbitLength",
                  zomic: "RunZomicScript",
                  py: "RunPythonScript",
                  apiProxy: "ApiEdit"
                };
                editName = legacyNames[editName] || editName;
                return vzomePkg.core.edits[editName] || vzomePkg.core.editor[editName];
              };

              editFactory = function editFactory(editor, toolFactories, toolsModel) {
                return function (xmlElement) {
                  editor.setAdapter(null); // This should trigger NPEs in any edits that have side-effects in their constructor

                  var editName = xmlElement.getLocalName();
                  if (editName === "Snapshot") return null;
                  if (editName === "ImportColoredMeshJson") return new ImportColoredMeshJson(editor);
                  if (editName === "ImportSimpleMeshJson") return new ImportSimpleMeshJson(editor);

                  if (toolsModel) {
                    var toolEdit = toolsModel.createEdit(editName);
                    if (toolEdit) return toolEdit;
                  }

                  var toolId = xmlElement.getAttribute("name");

                  if (toolId) {
                    var factory = toolFactories.get(editName);

                    if (factory) {
                      var edit = factory.deserializeTool(toolId);
                      if (edit) return edit;
                    }
                  }

                  var editClass = xmlToEditClass(editName);
                  if (editClass) return new editClass(editor);else return new vzomePkg.core.editor.CommandEdit(null, editor);
                };
              };

              injectResource =
              /*#__PURE__*/
              function () {
                var _ref2 = _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee(path, url) {
                  var response, text;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return fetch(url);

                        case 2:
                          response = _context.sent;

                          if (response.ok) {
                            _context.next = 6;
                            break;
                          }

                          console.log("No resource for ".concat(path));
                          return _context.abrupt("return");

                        case 6:
                          _context.next = 8;
                          return response.text();

                        case 8:
                          text = _context.sent;

                          if (!(text[0] === "<")) {
                            _context.next = 11;
                            break;
                          }

                          return _context.abrupt("return");

                        case 11:
                          vzomePkg.xml.ResourceLoader.injectResource(path, text);
                          console.log("injected resource ".concat(path));

                        case 13:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function injectResource(_x, _x2) {
                  return _ref2.apply(this, arguments);
                };
              }(); // Initialize the field application


              _context3.next = 9;
              return Promise.all(Object.entries(resources).map(function (_ref3) {
                var _ref4 = _slicedToArray(_ref3, 2),
                    key = _ref4[0],
                    value = _ref4[1];

                return injectResource("com/vzome/core/math/symmetry/".concat(key, ".vef"), value);
              }));

            case 9:
              properties = new JsProperties(defaults);
              colors = new vzomePkg.core.render.Colors(properties);
              gfield = new vzomePkg.jsweet.JsAlgebraicField(goldenField);
              r2field = new vzomePkg.jsweet.JsAlgebraicField(field);
              fieldApps = {
                golden: new vzomePkg.core.kinds.GoldenFieldApplication(gfield),
                rootTwo: new vzomePkg.core.kinds.RootTwoFieldApplication(r2field)
              }; // This object implements the UndoableEdit.Context interface

              editContext = {
                // Since we are not creating Branch edits, this should never be used
                createEdit: function createEdit() {
                  throw new Error("createEdit should never be called");
                },
                createLegacyCommand: function createLegacyCommand(name) {
                  var constructor = vzomePkg.core.commands[name];
                  if (constructor) return new constructor();else throw new Error("".concat(name, " command is not available yet"));
                },
                // We will do our own edit recording, so this is just perform
                performAndRecord: function performAndRecord(edit) {
                  return edit.perform();
                }
              };

              documentFactory = function documentFactory(fieldName, namespace, xml) {
                // This reproduces the DocumentModel constructor pretty faithfully
                var fieldApp = fieldApps[fieldName];
                if (!fieldApp) throw new Error("Field \"".concat(fieldName, "\" is not supported yet."));
                var field = fieldApp.getField();
                var originPoint = new vzomePkg.core.construction.FreePoint(field.origin(3));
                var systemXml = xml && xml.getChildElement("SymmetrySystem");
                var symmName = systemXml && systemXml.getAttribute("name");
                var symmPer = symmName && fieldApp.getSymmetryPerspective(symmName) || fieldApp.getDefaultSymmetryPerspective();
                var toolsModel = new vzomePkg.core.editor.ToolsModel(editContext, originPoint); // Initialize the default SymmetrySystems from the FieldApplication

                var symmetrySystems = {};
                var symmPerspectives = fieldApp.getSymmetryPerspectives().iterator();

                while (symmPerspectives.hasNext()) {
                  var perspective = symmPerspectives.next();
                  var osm = new vzomePkg.core.editor.SymmetrySystem(null, perspective, editContext, colors, true);
                  symmetrySystems[osm.getName()] = osm;
                } // Now overwrite some or all of those default SymmetrySystems with those stored in the file.
                //   This is important mostly for the automatic orbits, but can also carry color overrides.


                var orbitSource = new vzomePkg.core.editor.SymmetrySystem(systemXml, symmPer, editContext, colors, true);
                symmetrySystems[symmPer.getName()] = orbitSource;

                if (xml) {
                  var symms = xml.getChildElement("OtherSymmetries");

                  if (symms) {
                    var nodes = symms.getElementsByTagName("SymmetrySystem");

                    for (var i = 0; i < nodes.getLength(); i++) {
                      var symmElem = nodes.item(i);

                      var _symmName = symmElem.getAttribute("name");

                      var symmPerspective = fieldApp.getSymmetryPerspective(_symmName);
                      var otherSymmetrySystem = new vzomePkg.core.editor.SymmetrySystem(symmElem, symmPerspective, _this, colors, true);
                      symmetrySystems[_symmName] = otherSymmetrySystem;
                    }
                  }
                } // This has no analogue in Java DocumentModel


                orbitSource.quaternions = makeQuaternions(orbitSource.getSymmetry().getMatrices());
                var orbitSetField = {
                  __interfaces: ["com.vzome.core.math.symmetry.OrbitSet.Field"],
                  getGroup: function getGroup(name) {
                    return symmetrySystems[name].getOrbits();
                  },
                  getQuaternionSet: function getQuaternionSet(name) {
                    return fieldApp.getQuaternionSymmetry(name);
                  }
                };
                var realizedModel = new vzomePkg.jsweet.JsRealizedModel(field);
                var selection = new vzomePkg.jsweet.JsSelection(field);
                var editor = new vzomePkg.jsweet.JsEditorModel(realizedModel, selection, fieldApp, orbitSource, symmetrySystems);
                toolsModel.setEditorModel(editor);
                var format = namespace && vzomePkg.core.commands.XmlSymmetryFormat.getFormat(namespace);
                format && format.initialize(field, orbitSetField, 0, "vZome Online", new util.Properties());
                var toolFactories = new util.HashMap();

                for (var _i = 0, _Object$values = Object.values(symmetrySystems); _i < _Object$values.length; _i++) {
                  var symmetrySystem = _Object$values[_i];
                  symmetrySystem.createToolFactories(toolsModel); // needed to register built-in tools
                }

                fieldApp.registerToolFactories(toolFactories, toolsModel);
                var bookmarkFactory = new vzomePkg.core.tools.BookmarkTool.Factory(toolsModel);
                bookmarkFactory.createPredefinedTool("ball at origin");
                var toolsXml = xml && xml.getChildElement("Tools");
                toolsXml && toolsModel.loadFromXml(toolsXml);
                var shaper = shaperFactory(vzomePkg, orbitSource);
                shaper.shapesName = orbitSource.getShapes().getName();

                var parseAndPerformEdit = function parseAndPerformEdit(xmlElement, adapter) {
                  var wrappedElement = new JavaDomElement(xmlElement); // Note that we do not do editor.setAdapter( adapter ) yet.  This means that we cannot
                  //  deal with edits that have side-effects in their constructors!

                  var edit = editFactory(editor, toolFactories, toolsModel)(wrappedElement);
                  if (!edit) // Null edit only happens for expected cases (e.g. "Shapshot"); others become CommandEdit.
                    return false; //  Not indicating failure, just indicating nothing to record in history

                  editor.setAdapter(adapter);
                  edit.loadAndPerform(wrappedElement, format, editContext);
                  return true;
                };

                var configureAndPerformEdit = function configureAndPerformEdit(className, config, adapter) {
                  var edit = editFactory(editor, toolFactories, toolsModel)(new JavaDomElement({
                    localName: className
                  }));
                  if (!edit) return;
                  editor.setAdapter(adapter);
                  edit.configure(new JsProperties(config));
                  edit.perform();
                };

                return {
                  shaper: shaper,
                  parseAndPerformEdit: parseAndPerformEdit,
                  configureAndPerformEdit: configureAndPerformEdit
                };
              }; // Discover all the legacy edit classes and register as commands


              commands = {};

              for (_i2 = 0, _Object$keys = Object.keys(vzomePkg.core.edits); _i2 < _Object$keys.length; _i2++) {
                name = _Object$keys[_i2];
                commands[name] = legacyCommandFactory(documentFactory, name);
              } // store.dispatch( commandsDefined( commands ) )
              // Prepare the orbitSource for resolveShapes


              symmPer = fieldApps.golden.getDefaultSymmetryPerspective();
              orbitSource = new vzomePkg.core.editor.SymmetrySystem(null, symmPer, editContext, colors, true);
              orbitSource.quaternions = makeQuaternions(orbitSource.getSymmetry().getMatrices());
              shaper = shaperFactory(vzomePkg, orbitSource);
              shaperName = orbitSource.getShapes().getName();
              blue = [[0, 0, 1], [0, 0, 1], [1, 0, 1]];
              gridPoints = vzomePkg.jsweet.JsAdapter.getZoneGrid(orbitSource, blue); // store.dispatch( planes.doSetWorkingPlaneGrid( gridPoints ) )

              parser = createParser(documentFactory);
              _context3.next = 31;
              return Promise.all(Object.entries(shapes$a).map(
              /*#__PURE__*/
              function () {
                var _ref6 = _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee2(_ref5) {
                  var _ref7, family, shapes;

                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _ref7 = _slicedToArray(_ref5, 2), family = _ref7[0], shapes = _ref7[1];
                          _context2.next = 3;
                          return Promise.all(Object.entries(shapes).map(function (_ref8) {
                            var _ref9 = _slicedToArray(_ref8, 2),
                                key = _ref9[0],
                                value = _ref9[1];

                            return injectResource("com/vzome/core/parts/".concat(family, "/").concat(key, ".vef"), value);
                          }));

                        case 3:
                          return _context2.abrupt("return", _context2.sent);

                        case 4:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function (_x3) {
                  return _ref6.apply(this, arguments);
                };
              }()));

            case 31:
              return _context3.abrupt("return", {
                parser: parser,
                shaper: shaper,
                shaperName: shaperName,
                commands: commands,
                gridPoints: gridPoints
              });

            case 32:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function init() {
      return _ref.apply(this, arguments);
    };
  }();

  var coreState = init();

  var embedShape = function embedShape(shape) {
    var vertices = shape.getVertexList().toArray().map(function (av) {
      var _av$toRealVector = av.toRealVector(),
          x = _av$toRealVector.x,
          y = _av$toRealVector.y,
          z = _av$toRealVector.z;

      return {
        x: x,
        y: y,
        z: z
      };
    });
    var faces = shape.getTriangleFaces().toArray();
    var id = shape.getGuid().toString();
    return {
      id: id,
      vertices: vertices,
      faces: faces
    };
  };

  var shaperFactory = function shaperFactory(vzomePkg, orbitSource) {
    return function (shapes) {
      return function (instance) {
        var id = instance.id,
            vectors = instance.vectors;
        var jsAF = orbitSource.getSymmetry().getField();
        var shown = new Map();
        shown.set(id, instance);
        var adapter = new Adapter(shown, new Map(), new Map());
        var man = vzomePkg.jsweet.JsManifestation.manifest(vectors, jsAF, adapter);
        var rm = new vzomePkg.core.render.RenderedManifestation(man, orbitSource);
        rm.resetAttributes(false, true); // may be a zero-length strut, no shape

        if (!rm.getShape()) return undefined; // is the shape new?

        var shapeId = rm.getShapeId().toString();

        if (!shapes[shapeId]) {
          shapes[shapeId] = embedShape(rm.getShape());
        } // get shape, orientation, color, and position from rm


        var positionAV = rm.getLocationAV() || jsAF.origin(3);

        var _orbitSource$getSymme = orbitSource.getSymmetry().embedInR3(positionAV),
            x = _orbitSource$getSymme.x,
            y = _orbitSource$getSymme.y,
            z = _orbitSource$getSymme.z;

        var quatIndex = rm.getStrutZone();
        var rotation = quatIndex && quatIndex >= 0 && orbitSource.quaternions[quatIndex] || [0, 0, 0, 1];
        var finalColor = rm.getColor().getRGB();
        return {
          id: id,
          position: [x, y, z],
          rotation: rotation,
          color: finalColor,
          shapeId: shapeId
        };
      };
    };
  };

  var legacyCommandFactory = function legacyCommandFactory(createEditor, className) {
    return function (config) {
      var field = undefined; // TODO designs.selectField( getState() )
      // TODO const symmetry = designs.selectCurrentSymmetry( getState() )
      // TODO const shapes = designs.selectCurrentShapes( getState() )

      var _ref10 = {},
          shown = _ref10.shown,
          hidden = _ref10.hidden,
          selected = _ref10.selected; // TODO designs.selectMesh( getState() )

      shown = new Map(shown);
      hidden = new Map(hidden);
      selected = new Map(selected);
      var adapter = new Adapter(shown, selected, hidden); // side-effects will appear in shown, hidden, and selected maps

      createEditor(field.name).configureAndPerformEdit(className, config, adapter); // TODO
      // dispatch( { type: WORK_STARTED } )
      // dispatch( meshChanged( shown, selected, hidden ) )
      // dispatch( { type: WORK_FINISHED } )
    };
  };

  var assignIds = function assignIds(element) {
    var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ':';
    element.id = id;
    var child = element.firstElementChild;
    var i = 0;

    while (child) {
      assignIds(child, "".concat(id).concat(i++, ":"));
      child = child.nextElementSibling;
    }

    return element;
  };

  var Step = {
    IN: 0,
    OVER: 1,
    OUT: 2,
    DONE: 3
  };

  var interpret = function interpret(action, parseAndPerform, adapter, editElement) {
    var stack = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    var recordSnapshot = arguments.length > 5 ? arguments[5] : undefined;

    var step = function step() {
      if (!editElement) return Step.DONE;

      if (editElement.nodeName === "Branch") {
        var branchAdapter = adapter.clone();
        stack.push({
          branch: editElement,
          adapter: adapter
        });
        recordSnapshot && recordSnapshot(branchAdapter, editElement.firstElementChild, stack);
        editElement = editElement.firstElementChild; // this assumes there are no empty branches

        adapter = branchAdapter;
        return Step.IN;
      } else {
        adapter = adapter.clone(); // each command builds on the last

        parseAndPerform(editElement, adapter);

        if (editElement.nextElementSibling) {
          recordSnapshot && recordSnapshot(adapter, editElement.nextElementSibling);
          editElement = editElement.nextElementSibling;
          return Step.OVER;
        } else {
          var top;

          do {
            top = stack.pop();
          } while (top && !top.branch.nextElementSibling);

          if (top) {
            adapter = top.adapter.clone(); // overwrite and discard the prior value

            editElement = top.branch.nextElementSibling;
            recordSnapshot && recordSnapshot(adapter, editElement, stack);
            return Step.OUT;
          } else {
            // at the end of the editHistory
            recordSnapshot && recordSnapshot(adapter, null);
            return Step.DONE;
          }
        }
      }
    };

    var conTinue = function conTinue() {
      var stepped;

      do {
        stepped = stepOut();
      } while (stepped !== Step.DONE);
    };

    var stepOver = function stepOver() {
      var stepped = step();

      switch (stepped) {
        case Step.IN:
          stepOut();
          return Step.OVER;

        default:
          return stepped;
      }
    };

    var stepOut = function stepOut() {
      var stepped;

      do {
        stepped = stepOver();
      } while (stepped !== Step.OUT && stepped !== Step.DONE);

      return stepped;
    };

    switch (action) {
      case Step.IN:
        step();
        break;

      case Step.OVER:
        stepOver();
        break;

      case Step.OUT:
        stepOut();
        break;

      case Step.DONE:
      default:
        conTinue();
        break;
    }
  };

  var parseViewXml = function parseViewXml(viewingElement) {
    var parseVector = function parseVector(element, name) {
      var child = element.getChildElement(name);
      var x = parseFloat(child.getAttribute("x"));
      var y = parseFloat(child.getAttribute("y"));
      var z = parseFloat(child.getAttribute("z"));
      return [x, y, z];
    };

    var viewModel = viewingElement.getChildElement("ViewModel");
    var distance = parseFloat(viewModel.getAttribute("distance"));
    var near = parseFloat(viewModel.getAttribute("near"));
    var far = parseFloat(viewModel.getAttribute("far"));
    var lookAt = parseVector(viewModel, "LookAtPoint");
    var up = parseVector(viewModel, "UpDirection");
    var lookDirection = parseVector(viewModel, "LookDirection");
    var position = lookAt.map(function (e, i) {
      return e - distance * lookDirection[i];
    });
    return {
      position: position,
      lookAt: lookAt,
      up: up,
      near: near,
      far: far
    };
  };

  var createParser = function createParser(createDocument) {
    return function (xmlText) {
      try {
        var domDoc = new DOMParser().parseFromString(xmlText, "application/xml");
        var vZomeRoot = new JavaDomElement(domDoc.firstElementChild);
        var namespace = vZomeRoot.getAttribute("xmlns:vzome");
        var fieldName = vZomeRoot.getAttribute("field");

        var _createDocument = createDocument(fieldName, namespace, vZomeRoot),
            shaper = _createDocument.shaper,
            parseAndPerformEdit = _createDocument.parseAndPerformEdit;

        var field = fields[fieldName];
        var viewing = vZomeRoot.getChildElement("Viewing");
        var camera = viewing && parseViewXml(viewing);
        var edits = assignIds(vZomeRoot.getChildElement("EditHistory").nativeElement); // TODO: use editNumber

        var targetEdit = ":".concat(edits.getAttribute("editNumber"), ":");
        return {
          edits: edits,
          camera: camera,
          field: field,
          parseAndPerformEdit: parseAndPerformEdit,
          targetEdit: targetEdit,
          shaper: shaper
        };
      } catch (error) {
        console.log("%%%%%%%%%%%%%%%%%%% legacyjava.js parser failed: ".concat(error));
        return null;
      }
    };
  };

  var legacyjava =
  /*#__PURE__*/
  Object.freeze({
    __proto__: null,
    init: init,
    coreState: coreState,
    legacyCommandFactory: legacyCommandFactory,
    Step: Step,
    interpret: interpret,
    parseViewXml: parseViewXml,
    createParser: createParser
  });
  var aspectRatio$1 = window.innerWidth / window.innerHeight; // TODO: this is totally static!

  var convertFOV$1 = function convertFOV(fovX) {
    return fovX / aspectRatio$1 * 180 / Math.PI;
  }; // converting radians to degrees


  var originShown = function originShown(field) {
    var originBall = createInstance([field.origin(3)]);
    return new Map().set(originBall.id, originBall);
  };

  var fetchModel = function fetchModel(path) {
    // TODO: I should really deploy my own copy of this proxy on Heroku
    var fetchWithCORS = function fetchWithCORS(url) {
      return fetch(url).catch(function (_) {
        return fetch('https://cors-anywhere.herokuapp.com/' + url);
      });
    };

    return fetchWithCORS(path).then(function (response) {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      return response.text();
    }).catch(function (error) {
      console.error('There has been a problem with your fetch operation:', error);
      return null;
    });
  }; // from https://www.bitdegree.org/learn/javascript-download


  var download = function download(url, xml) {
    var name = url.split('\\').pop().split('/').pop();
    var blob = new Blob([xml], {
      type: 'application/xml'
    });
    var element = document.createElement('a');
    var blobURI = URL.createObjectURL(blob);
    element.setAttribute('href', blobURI);
    element.setAttribute('download', "".concat(name));
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  var UrlViewer = function UrlViewer(props) {
    var url = props.url,
        lighting = props.lighting;

    var _useState = React.useState(props.camera),
        _useState2 = _slicedToArray(_useState, 2),
        camera = _useState2[0],
        setCamera = _useState2[1];

    var _useState3 = React.useState(null),
        _useState4 = _slicedToArray(_useState3, 2),
        mesh = _useState4[0],
        setMesh = _useState4[1];

    var _useState5 = React.useState(null),
        _useState6 = _slicedToArray(_useState5, 2),
        resolver = _useState6[0],
        setResolver = _useState6[1];

    var _useState7 = React.useState(null),
        _useState8 = _slicedToArray(_useState7, 2),
        xml = _useState8[0],
        setXml = _useState8[1];

    React.useEffect(function () {
      function parseUrl() {
        return _parseUrl.apply(this, arguments);
      }

      function _parseUrl() {
        _parseUrl = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee() {
          var _yield$vZome$coreStat, parser, text, _ref, edits, camera, field, parseAndPerformEdit, shaper, meshAdapter, record;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return coreState;

                case 2:
                  _yield$vZome$coreStat = _context.sent;
                  parser = _yield$vZome$coreStat.parser;
                  _context.next = 6;
                  return fetchModel(url);

                case 6:
                  text = _context.sent;

                  if (text) {
                    _context.next = 9;
                    break;
                  }

                  return _context.abrupt("return");

                case 9:
                  setXml(text);
                  _ref = parser(text) || {}, edits = _ref.edits, camera = _ref.camera, field = _ref.field, parseAndPerformEdit = _ref.parseAndPerformEdit, _ref.targetEdit, shaper = _ref.shaper;

                  if (edits) {
                    _context.next = 13;
                    break;
                  }

                  return _context.abrupt("return");

                case 13:
                  setCamera(_objectSpread2(_objectSpread2({}, camera), {}, {
                    fov: convertFOV$1(0.75)
                  }));
                  setResolver({
                    shaper: shaper
                  });
                  meshAdapter = new Adapter(originShown(field), new Map(), new Map());

                  record = function record(adapter) {
                    meshAdapter = adapter;
                  }; // yup, overwrite every time


                  interpret(Step.DONE, parseAndPerformEdit, meshAdapter, edits.firstElementChild, [], record);
                  setMesh(meshAdapter);

                case 19:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
        return _parseUrl.apply(this, arguments);
      }

      parseUrl();
    }, [url]);
    return (
      /*#__PURE__*/
      React__default['default'].createElement("div", {
        style: {
          display: 'flex',
          height: '100%'
        }
      },
      /*#__PURE__*/
      React__default['default'].createElement(DesignCanvas, {
        lighting: lighting,
        camera: camera
      }, mesh &&
      /*#__PURE__*/
      React__default['default'].createElement(MeshGeometry, {
        shown: mesh.shown,
        selected: mesh.selected,
        resolver: resolver.shaper
      })), xml &&
      /*#__PURE__*/
      React__default['default'].createElement(Fab__default['default'], {
        color: "primary",
        size: "small",
        "aria-label": "download",
        style: {
          position: 'absolute'
        },
        onClick: function onClick() {
          return download(url, xml);
        }
      },
      /*#__PURE__*/
      React__default['default'].createElement(GetAppRoundedIcon__default['default'], {
        fontSize: "small"
      })))
    );
  };

  exports.Adapter = Adapter;
  exports.BuildPlane = BuildPlane;
  exports.DesignCanvas = DesignCanvas;
  exports.MeshGeometry = MeshGeometry;
  exports.ShapedGeometry = ShapedGeometry;
  exports.UrlViewer = UrlViewer;
  exports.createInstance = createInstance;
  exports.goldenField = goldenField;
  exports.root2Field = field;
  exports.vZomeJava = legacyjava;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});